export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** A date-time string at UTC, such as 2019-12-03T09:54:33Z, compliant with the date-time format. */
  DateTime: { input: any; output: any; }
  /** The `JSON` scalar type represents JSON values as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSON: { input: any; output: any; }
  /** The `JSONObject` scalar type represents JSON objects as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSONObject: { input: any; output: any; }
};

export type AiValidationResult = {
  __typename?: 'AIValidationResult';
  /** Any concerns identified */
  concerns?: Maybe<Array<Scalars['String']['output']>>;
  /** Confidence score from 0-100 */
  confidence: Scalars['Int']['output'];
  /** Brief summary of document content */
  contentSummary?: Maybe<Scalars['String']['output']>;
  /** The type detected by AI */
  detectedType: Scalars['String']['output'];
  /** Error message if status is ERROR */
  errorMessage?: Maybe<Scalars['String']['output']>;
  /** Human-readable feedback */
  feedback: Scalars['String']['output'];
  /** Key indicators that led to classification */
  keyIndicators?: Maybe<Array<Scalars['String']['output']>>;
  /** Whether document matches the selected type */
  matchesSelectedType: Scalars['Boolean']['output'];
  /** Current validation status */
  status: ValidationStatus;
  /** ISO timestamp of when validation completed */
  validatedAt?: Maybe<Scalars['String']['output']>;
};

/** Active user presence information */
export type ActiveUser = {
  __typename?: 'ActiveUser';
  /** Name of the current activity the user is working on */
  currentActivity: Scalars['String']['output'];
  /** User first name */
  firstName: Scalars['String']['output'];
  /** Whether user is currently active (active within last 30 seconds) */
  isActive: Scalars['Boolean']['output'];
  /** User last name */
  lastName: Scalars['String']['output'];
  /** Timestamp of last activity (ISO string) */
  lastSeen: Scalars['String']['output'];
  /** Additional metadata about user activity */
  metadata?: Maybe<Scalars['String']['output']>;
  /** URL to user profile image */
  profileImage?: Maybe<Scalars['String']['output']>;
  /** User ID */
  userId: Scalars['ID']['output'];
};

export type ActivityAnalyticsInput = {
  /** Filter to a specific activity name (e.g., "ideate", "scope") */
  activityName?: InputMaybe<Scalars['String']['input']>;
  /** When true: Sum all ADKs per Student first, then calculate stats across Student totals. Use for "How much total time does the average student spend?" When false (default): Calculate stats on individual ADK records. */
  aggregateByStudent?: InputMaybe<Scalars['Boolean']['input']>;
  /** Bypass cache and fetch fresh data */
  bypassCache?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by completion level: all (default), completedOnly, or fullProgramOnly */
  completionFilter?: InputMaybe<CompletionFilterMode>;
  /** Grouping dimension: "activity" (default), "program", or "programSchema" */
  groupBy?: InputMaybe<Scalars['String']['input']>;
  /** Whether to normalize/cap outliers at the specified percentile */
  normalizeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
  /** Percentile threshold for outlier exclusion (e.g., 0.95 to exclude top 5%) */
  outlierPercentile?: InputMaybe<Scalars['Float']['input']>;
  /** Filter to a specific program by ID */
  programId?: InputMaybe<Scalars['String']['input']>;
  /** Filter to a specific program template/schema by ID */
  programSchemaId?: InputMaybe<Scalars['String']['input']>;
};

export type ActivityAnalyticsOutput = {
  __typename?: 'ActivityAnalyticsOutput';
  /** If true, stats are calculated per-student (sum all ADKs per student, then avg/median across students). If false (default), stats are calculated per-ADK record. */
  aggregateByStudent?: Maybe<Scalars['Boolean']['output']>;
  /** The completion filter applied: all, completedOnly, or fullProgramOnly */
  completionFilter?: Maybe<Scalars['String']['output']>;
  /** Human-readable description of the filter applied */
  filterDescription?: Maybe<Scalars['String']['output']>;
  /** Whether this data came from cache */
  fromCache: Scalars['Boolean']['output'];
  /** When this data was generated */
  generatedAt: Scalars['DateTime']['output'];
  /** The grouping dimension used */
  groupBy: Scalars['String']['output'];
  /** Statistics for each group */
  stats: Array<ActivityStats>;
  /** Total number of records analyzed */
  totalRecords: Scalars['Int']['output'];
};

export type ActivityDurationAnalyticsOutput = {
  __typename?: 'ActivityDurationAnalyticsOutput';
  /** Duration summaries per activity */
  activities: Array<ActivityDurationSummary>;
  /** Whether this data came from cache */
  fromCache: Scalars['Boolean']['output'];
  /** Program ID queried */
  programId: Scalars['String']['output'];
};

export type ActivityDurationSummary = {
  __typename?: 'ActivityDurationSummary';
  /** Activity name */
  activityName: Scalars['String']['output'];
  /** Average completion time in minutes */
  avgMinutes: Scalars['Float']['output'];
  /** Median completion time in minutes */
  medianMinutes: Scalars['Float']['output'];
  /** Number of completions used for the calculation */
  sampleSize: Scalars['Int']['output'];
};

export type ActivityOtpResponse = {
  __typename?: 'ActivityOtpResponse';
  /** The identifier that was verified (email or phone) */
  identifier?: Maybe<Scalars['String']['output']>;
  /** Human-readable message */
  message?: Maybe<Scalars['String']['output']>;
  /** Number of remaining attempts before lockout */
  remainingAttempts?: Maybe<Scalars['Float']['output']>;
  /** Whether the OTP was sent (for send operations) */
  sent?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the operation was successful */
  success: Scalars['Boolean']['output'];
  /** Whether the OTP was verified (for verify operations) */
  verified?: Maybe<Scalars['Boolean']['output']>;
  /** Timestamp when verification occurred (ISO 8601) */
  verifiedAt?: Maybe<Scalars['String']['output']>;
};

export type ActivityRollbackEventCountAggregate = {
  __typename?: 'ActivityRollbackEventCountAggregate';
  _all: Scalars['Int']['output'];
  activityName: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  fieldPath: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  initiatedBy: Scalars['Int']['output'];
  initiatedByUserId: Scalars['Int']['output'];
  programId: Scalars['Int']['output'];
  programTeamId: Scalars['Int']['output'];
  reason: Scalars['Int']['output'];
  removedValue: Scalars['Int']['output'];
  restoredValue: Scalars['Int']['output'];
  rolledBackAt: Scalars['Int']['output'];
  studentId: Scalars['Int']['output'];
  updatedAt: Scalars['Int']['output'];
  writeLogId: Scalars['Int']['output'];
};

export type ActivityRollbackEventMaxAggregate = {
  __typename?: 'ActivityRollbackEventMaxAggregate';
  activityName?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  fieldPath?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  initiatedBy?: Maybe<Scalars['String']['output']>;
  initiatedByUserId?: Maybe<Scalars['String']['output']>;
  programId?: Maybe<Scalars['String']['output']>;
  programTeamId?: Maybe<Scalars['String']['output']>;
  reason?: Maybe<Scalars['String']['output']>;
  rolledBackAt?: Maybe<Scalars['DateTime']['output']>;
  studentId?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  writeLogId?: Maybe<Scalars['String']['output']>;
};

export type ActivityRollbackEventMinAggregate = {
  __typename?: 'ActivityRollbackEventMinAggregate';
  activityName?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  fieldPath?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  initiatedBy?: Maybe<Scalars['String']['output']>;
  initiatedByUserId?: Maybe<Scalars['String']['output']>;
  programId?: Maybe<Scalars['String']['output']>;
  programTeamId?: Maybe<Scalars['String']['output']>;
  reason?: Maybe<Scalars['String']['output']>;
  rolledBackAt?: Maybe<Scalars['DateTime']['output']>;
  studentId?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  writeLogId?: Maybe<Scalars['String']['output']>;
};

export type ActivitySchema = {
  __typename?: 'ActivitySchema';
  JSONSchema?: Maybe<Scalars['JSON']['output']>;
  activityImage?: Maybe<Scalars['String']['output']>;
  buildScope?: Maybe<ActivitySchemaBuildScope>;
  builderType?: Maybe<Scalars['String']['output']>;
  category?: Maybe<Scalars['String']['output']>;
  completed?: Maybe<Scalars['Boolean']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  description: Scalars['String']['output'];
  discordEntityType?: Maybe<Scalars['String']['output']>;
  employerWebsite?: Maybe<Scalars['String']['output']>;
  fields?: Maybe<Array<ActivitySchemaFields>>;
  icon: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  instruction?: Maybe<ActivitySchemaInstruction>;
  interviewReqeust?: Maybe<Scalars['String']['output']>;
  introVideo?: Maybe<Scalars['String']['output']>;
  isPreview?: Maybe<Scalars['Boolean']['output']>;
  isSkippable?: Maybe<Scalars['Boolean']['output']>;
  isTeamAdk?: Maybe<Scalars['Boolean']['output']>;
  isVideoask?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  optional?: Maybe<Scalars['Boolean']['output']>;
  permissions?: Maybe<Array<ActivitySchemaPermissions>>;
  position?: Maybe<Scalars['Int']['output']>;
  presetFields?: Maybe<Array<ActivitySchemaPresetFields>>;
  preview?: Maybe<Scalars['Boolean']['output']>;
  projectScope?: Maybe<Scalars['String']['output']>;
  required?: Maybe<Scalars['Boolean']['output']>;
  setupRequired: Scalars['Boolean']['output'];
  sourceActivitySchemaId?: Maybe<Scalars['String']['output']>;
  status: Scalars['Boolean']['output'];
  statusType?: Maybe<Scalars['String']['output']>;
  styling?: Maybe<ActivitySchemaStyling>;
  timeToSolveProblem?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
  usageCount?: Maybe<Scalars['Int']['output']>;
};

export type ActivitySchemaAvgAggregate = {
  __typename?: 'ActivitySchemaAvgAggregate';
  position?: Maybe<Scalars['Float']['output']>;
  timeToSolveProblem?: Maybe<Scalars['Float']['output']>;
  usageCount?: Maybe<Scalars['Float']['output']>;
};

export type ActivitySchemaBuildScope = {
  __typename?: 'ActivitySchemaBuildScope';
  objectives?: Maybe<Array<ActivitySchemaBuildScopeObjectives>>;
  projects?: Maybe<Array<ActivitySchemaBuildScopeProjects>>;
};

export type ActivitySchemaBuildScopeCreateInput = {
  objectives?: InputMaybe<Array<ActivitySchemaBuildScopeObjectivesCreateInput>>;
  projects?: InputMaybe<Array<ActivitySchemaBuildScopeProjectsCreateInput>>;
};

export type ActivitySchemaBuildScopeNullableCompositeFilter = {
  equals?: InputMaybe<ActivitySchemaBuildScopeObjectEqualityInput>;
  is?: InputMaybe<ActivitySchemaBuildScopeWhereInput>;
  isNot?: InputMaybe<ActivitySchemaBuildScopeWhereInput>;
  isSet?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ActivitySchemaBuildScopeNullableCreateEnvelopeInput = {
  set?: InputMaybe<ActivitySchemaBuildScopeCreateInput>;
};

export type ActivitySchemaBuildScopeNullableUpdateEnvelopeInput = {
  set?: InputMaybe<ActivitySchemaBuildScopeCreateInput>;
  unset?: InputMaybe<Scalars['Boolean']['input']>;
  upsert?: InputMaybe<ActivitySchemaBuildScopeUpsertInput>;
};

export type ActivitySchemaBuildScopeObjectEqualityInput = {
  objectives?: InputMaybe<Array<ActivitySchemaBuildScopeObjectivesObjectEqualityInput>>;
  projects?: InputMaybe<Array<ActivitySchemaBuildScopeProjectsObjectEqualityInput>>;
};

export type ActivitySchemaBuildScopeObjectives = {
  __typename?: 'ActivitySchemaBuildScopeObjectives';
  action?: Maybe<Scalars['String']['output']>;
  icon?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  position?: Maybe<Scalars['Int']['output']>;
  roles?: Maybe<Array<Scalars['String']['output']>>;
  /** Could not determine type: the field only had null or empty values in the sample set. */
  rules?: Maybe<Scalars['JSON']['output']>;
  styling?: Maybe<ActivitySchemaBuildScopeObjectivesStyling>;
  target?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
};

export type ActivitySchemaBuildScopeObjectivesCreateInput = {
  action?: InputMaybe<Scalars['String']['input']>;
  icon?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  position?: InputMaybe<Scalars['Int']['input']>;
  roles?: InputMaybe<ActivitySchemaBuildScopeObjectivesCreaterolesInput>;
  rules?: InputMaybe<Scalars['JSON']['input']>;
  styling?: InputMaybe<ActivitySchemaBuildScopeObjectivesStylingCreateInput>;
  target?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  type: Scalars['String']['input'];
};

export type ActivitySchemaBuildScopeObjectivesCreaterolesInput = {
  set: Array<Scalars['String']['input']>;
};

export type ActivitySchemaBuildScopeObjectivesObjectEqualityInput = {
  action?: InputMaybe<Scalars['String']['input']>;
  icon?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  position?: InputMaybe<Scalars['Int']['input']>;
  roles?: InputMaybe<Array<Scalars['String']['input']>>;
  rules?: InputMaybe<Scalars['JSON']['input']>;
  styling?: InputMaybe<ActivitySchemaBuildScopeObjectivesStylingObjectEqualityInput>;
  target?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  type: Scalars['String']['input'];
};

export type ActivitySchemaBuildScopeObjectivesOrderByCompositeAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type ActivitySchemaBuildScopeObjectivesStyling = {
  __typename?: 'ActivitySchemaBuildScopeObjectivesStyling';
  depressed?: Maybe<Scalars['Boolean']['output']>;
  hint?: Maybe<Scalars['String']['output']>;
  icon?: Maybe<Scalars['String']['output']>;
  label: Scalars['String']['output'];
  leftIcon?: Maybe<Scalars['String']['output']>;
  outlined: Scalars['Boolean']['output'];
  placeholder?: Maybe<Scalars['String']['output']>;
  rightIcon?: Maybe<Scalars['String']['output']>;
  rounded: Scalars['Boolean']['output'];
  small?: Maybe<Scalars['Boolean']['output']>;
};

export type ActivitySchemaBuildScopeObjectivesStylingCreateInput = {
  depressed?: InputMaybe<Scalars['Boolean']['input']>;
  hint?: InputMaybe<Scalars['String']['input']>;
  icon?: InputMaybe<Scalars['String']['input']>;
  label: Scalars['String']['input'];
  leftIcon?: InputMaybe<Scalars['String']['input']>;
  outlined: Scalars['Boolean']['input'];
  placeholder?: InputMaybe<Scalars['String']['input']>;
  rightIcon?: InputMaybe<Scalars['String']['input']>;
  rounded: Scalars['Boolean']['input'];
  small?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ActivitySchemaBuildScopeObjectivesStylingObjectEqualityInput = {
  depressed?: InputMaybe<Scalars['Boolean']['input']>;
  hint?: InputMaybe<Scalars['String']['input']>;
  icon?: InputMaybe<Scalars['String']['input']>;
  label: Scalars['String']['input'];
  leftIcon?: InputMaybe<Scalars['String']['input']>;
  outlined: Scalars['Boolean']['input'];
  placeholder?: InputMaybe<Scalars['String']['input']>;
  rightIcon?: InputMaybe<Scalars['String']['input']>;
  rounded: Scalars['Boolean']['input'];
  small?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ActivitySchemaBuildScopeOrderByInput = {
  objectives?: InputMaybe<ActivitySchemaBuildScopeObjectivesOrderByCompositeAggregateInput>;
  projects?: InputMaybe<ActivitySchemaBuildScopeProjectsOrderByCompositeAggregateInput>;
};

export type ActivitySchemaBuildScopeProjects = {
  __typename?: 'ActivitySchemaBuildScopeProjects';
  action?: Maybe<Scalars['String']['output']>;
  icon?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  position?: Maybe<Scalars['Int']['output']>;
  roles?: Maybe<Array<Scalars['String']['output']>>;
  styling?: Maybe<ActivitySchemaBuildScopeProjectsStyling>;
  target?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
};

export type ActivitySchemaBuildScopeProjectsCreateInput = {
  action?: InputMaybe<Scalars['String']['input']>;
  icon?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  position?: InputMaybe<Scalars['Int']['input']>;
  roles?: InputMaybe<ActivitySchemaBuildScopeProjectsCreaterolesInput>;
  styling?: InputMaybe<ActivitySchemaBuildScopeProjectsStylingCreateInput>;
  target?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  type: Scalars['String']['input'];
};

export type ActivitySchemaBuildScopeProjectsCreaterolesInput = {
  set: Array<Scalars['String']['input']>;
};

export type ActivitySchemaBuildScopeProjectsObjectEqualityInput = {
  action?: InputMaybe<Scalars['String']['input']>;
  icon?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  position?: InputMaybe<Scalars['Int']['input']>;
  roles?: InputMaybe<Array<Scalars['String']['input']>>;
  styling?: InputMaybe<ActivitySchemaBuildScopeProjectsStylingObjectEqualityInput>;
  target?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  type: Scalars['String']['input'];
};

export type ActivitySchemaBuildScopeProjectsOrderByCompositeAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type ActivitySchemaBuildScopeProjectsStyling = {
  __typename?: 'ActivitySchemaBuildScopeProjectsStyling';
  color: Scalars['String']['output'];
  depressed: Scalars['Boolean']['output'];
  label: Scalars['String']['output'];
  leftIcon: Scalars['String']['output'];
  rounded: Scalars['Boolean']['output'];
};

export type ActivitySchemaBuildScopeProjectsStylingCreateInput = {
  color: Scalars['String']['input'];
  depressed: Scalars['Boolean']['input'];
  label: Scalars['String']['input'];
  leftIcon: Scalars['String']['input'];
  rounded: Scalars['Boolean']['input'];
};

export type ActivitySchemaBuildScopeProjectsStylingObjectEqualityInput = {
  color: Scalars['String']['input'];
  depressed: Scalars['Boolean']['input'];
  label: Scalars['String']['input'];
  leftIcon: Scalars['String']['input'];
  rounded: Scalars['Boolean']['input'];
};

export type ActivitySchemaBuildScopeUpdateInput = {
  objectives?: InputMaybe<Array<ActivitySchemaBuildScopeObjectivesCreateInput>>;
  projects?: InputMaybe<Array<ActivitySchemaBuildScopeProjectsCreateInput>>;
};

export type ActivitySchemaBuildScopeUpsertInput = {
  set: ActivitySchemaBuildScopeCreateInput;
  update: ActivitySchemaBuildScopeUpdateInput;
};

export type ActivitySchemaBuildScopeWhereInput = {
  AND?: InputMaybe<Array<ActivitySchemaBuildScopeWhereInput>>;
  NOT?: InputMaybe<Array<ActivitySchemaBuildScopeWhereInput>>;
  OR?: InputMaybe<Array<ActivitySchemaBuildScopeWhereInput>>;
  objectives?: InputMaybe<Array<ActivitySchemaBuildScopeObjectivesObjectEqualityInput>>;
  projects?: InputMaybe<Array<ActivitySchemaBuildScopeProjectsObjectEqualityInput>>;
};

export type ActivitySchemaCountAggregate = {
  __typename?: 'ActivitySchemaCountAggregate';
  JSONSchema: Scalars['Int']['output'];
  _all: Scalars['Int']['output'];
  activityImage: Scalars['Int']['output'];
  builderType: Scalars['Int']['output'];
  category: Scalars['Int']['output'];
  completed: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  createdBy: Scalars['Int']['output'];
  description: Scalars['Int']['output'];
  discordEntityType: Scalars['Int']['output'];
  employerWebsite: Scalars['Int']['output'];
  icon: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  interviewReqeust: Scalars['Int']['output'];
  introVideo: Scalars['Int']['output'];
  isPreview: Scalars['Int']['output'];
  isSkippable: Scalars['Int']['output'];
  isTeamAdk: Scalars['Int']['output'];
  isVideoask: Scalars['Int']['output'];
  name: Scalars['Int']['output'];
  optional: Scalars['Int']['output'];
  position: Scalars['Int']['output'];
  preview: Scalars['Int']['output'];
  projectScope: Scalars['Int']['output'];
  required: Scalars['Int']['output'];
  setupRequired: Scalars['Int']['output'];
  sourceActivitySchemaId: Scalars['Int']['output'];
  status: Scalars['Int']['output'];
  statusType: Scalars['Int']['output'];
  timeToSolveProblem: Scalars['Int']['output'];
  updatedAt: Scalars['Int']['output'];
  updatedBy: Scalars['Int']['output'];
  usageCount: Scalars['Int']['output'];
};

export type ActivitySchemaCreateInput = {
  JSONSchema?: InputMaybe<Scalars['JSON']['input']>;
  activityImage?: InputMaybe<Scalars['String']['input']>;
  buildScope?: InputMaybe<ActivitySchemaBuildScopeNullableCreateEnvelopeInput>;
  builderType?: InputMaybe<Scalars['String']['input']>;
  category?: InputMaybe<Scalars['String']['input']>;
  completed?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy?: InputMaybe<Scalars['String']['input']>;
  description: Scalars['String']['input'];
  discordEntityType?: InputMaybe<Scalars['String']['input']>;
  employerWebsite?: InputMaybe<Scalars['String']['input']>;
  fields?: InputMaybe<Array<ActivitySchemaFieldsCreateInput>>;
  icon: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  instruction?: InputMaybe<ActivitySchemaInstructionNullableCreateEnvelopeInput>;
  interviewReqeust?: InputMaybe<Scalars['String']['input']>;
  introVideo?: InputMaybe<Scalars['String']['input']>;
  isPreview?: InputMaybe<Scalars['Boolean']['input']>;
  isSkippable?: InputMaybe<Scalars['Boolean']['input']>;
  isTeamAdk?: InputMaybe<Scalars['Boolean']['input']>;
  isVideoask?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  optional?: InputMaybe<Scalars['Boolean']['input']>;
  permissions?: InputMaybe<Array<ActivitySchemaPermissionsCreateInput>>;
  position?: InputMaybe<Scalars['Int']['input']>;
  presetFields?: InputMaybe<Array<ActivitySchemaPresetFieldsCreateInput>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  projectScope?: InputMaybe<Scalars['String']['input']>;
  required?: InputMaybe<Scalars['Boolean']['input']>;
  setupRequired: Scalars['Boolean']['input'];
  sourceActivitySchemaId?: InputMaybe<Scalars['String']['input']>;
  status: Scalars['Boolean']['input'];
  statusType?: InputMaybe<Scalars['String']['input']>;
  styling?: InputMaybe<ActivitySchemaStylingNullableCreateEnvelopeInput>;
  timeToSolveProblem?: InputMaybe<Scalars['Int']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedBy?: InputMaybe<Scalars['String']['input']>;
  usageCount?: InputMaybe<Scalars['Int']['input']>;
};

export type ActivitySchemaFields = {
  __typename?: 'ActivitySchemaFields';
  action?: Maybe<Scalars['String']['output']>;
  adk?: Maybe<Scalars['String']['output']>;
  ages?: Maybe<Scalars['String']['output']>;
  align?: Maybe<Scalars['String']['output']>;
  blank?: Maybe<Scalars['Boolean']['output']>;
  builderType?: Maybe<Scalars['String']['output']>;
  color?: Maybe<Scalars['String']['output']>;
  /** ISO timestamp of last compilation */
  compiledAt?: Maybe<Scalars['DateTime']['output']>;
  /** Compilation metadata: { vue: "2.7.16", vuetify: "2.4.6" } */
  compiledWith?: Maybe<Scalars['JSON']['output']>;
  dark?: Maybe<Scalars['Boolean']['output']>;
  /** Multiple data types found: String: 18.5%, Boolean: 59.3%, Int: 22.2% out of 27 sampled entries */
  defaultValue?: Maybe<Scalars['JSON']['output']>;
  /** Multiple data types found: String: 25%, ActivitySchemaFieldsEvent: 75% out of 4 sampled entries */
  event?: Maybe<Scalars['JSON']['output']>;
  header?: Maybe<Scalars['String']['output']>;
  href?: Maybe<Scalars['String']['output']>;
  icon?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  /** Multiple data types found: Array(String): 71.4%, Array(Int): 28.6% out of 8 sampled entries */
  items?: Maybe<Scalars['JSON']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  max?: Maybe<Scalars['String']['output']>;
  maxDate?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  min?: Maybe<Scalars['String']['output']>;
  minDate?: Maybe<Scalars['String']['output']>;
  model?: Maybe<Scalars['String']['output']>;
  modelItems?: Maybe<Array<ActivitySchemaFieldsModelItems>>;
  multiple?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  noSetup?: Maybe<Scalars['Boolean']['output']>;
  outlined?: Maybe<Scalars['Boolean']['output']>;
  placeholder?: Maybe<Scalars['String']['output']>;
  position?: Maybe<Scalars['Int']['output']>;
  preset?: Maybe<ActivitySchemaFieldsPreset>;
  radioButtons?: Maybe<Array<ActivitySchemaFieldsRadioButtons>>;
  roles?: Maybe<Array<Scalars['String']['output']>>;
  rounded?: Maybe<Scalars['Boolean']['output']>;
  rules?: Maybe<Array<Scalars['String']['output']>>;
  searchInput?: Maybe<Scalars['String']['output']>;
  searchType?: Maybe<Scalars['String']['output']>;
  /** Semantic contract for tri-mode participation (UI, text chat, voice) */
  semantic?: Maybe<Scalars['JSON']['output']>;
  setup?: Maybe<ActivitySchemaFieldsSetup>;
  styling?: Maybe<ActivitySchemaFieldsStyling>;
  subTitle?: Maybe<Scalars['String']['output']>;
  target?: Maybe<Scalars['String']['output']>;
  tickSize?: Maybe<Scalars['Int']['output']>;
  ticks?: Maybe<Scalars['Boolean']['output']>;
  timelineItems?: Maybe<Array<ActivitySchemaFieldsTimelineItems>>;
  title?: Maybe<Scalars['String']['output']>;
  titleAfterChip?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  vChipContent?: Maybe<Scalars['String']['output']>;
  value?: Maybe<ActivitySchemaFieldsValue>;
  videoAskLabel?: Maybe<Scalars['String']['output']>;
  videoAskUrl?: Maybe<Scalars['String']['output']>;
  /** Raw .vue source code (generated widgets only) */
  widgetSource?: Maybe<Scalars['String']['output']>;
  /** CDN URL for compiled widget JS (generated widgets only) */
  widgetUrl?: Maybe<Scalars['String']['output']>;
  /** Widget version number for immutability tracking */
  widgetVersion?: Maybe<Scalars['Int']['output']>;
};

export type ActivitySchemaFieldsCreateInput = {
  action?: InputMaybe<Scalars['String']['input']>;
  adk?: InputMaybe<Scalars['String']['input']>;
  ages?: InputMaybe<Scalars['String']['input']>;
  align?: InputMaybe<Scalars['String']['input']>;
  blank?: InputMaybe<Scalars['Boolean']['input']>;
  builderType?: InputMaybe<Scalars['String']['input']>;
  color?: InputMaybe<Scalars['String']['input']>;
  compiledAt?: InputMaybe<Scalars['DateTime']['input']>;
  compiledWith?: InputMaybe<Scalars['JSON']['input']>;
  dark?: InputMaybe<Scalars['Boolean']['input']>;
  defaultValue?: InputMaybe<Scalars['JSON']['input']>;
  event?: InputMaybe<Scalars['JSON']['input']>;
  header?: InputMaybe<Scalars['String']['input']>;
  href?: InputMaybe<Scalars['String']['input']>;
  icon?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  items?: InputMaybe<Scalars['JSON']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  max?: InputMaybe<Scalars['String']['input']>;
  maxDate?: InputMaybe<Scalars['String']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  min?: InputMaybe<Scalars['String']['input']>;
  minDate?: InputMaybe<Scalars['String']['input']>;
  model?: InputMaybe<Scalars['String']['input']>;
  modelItems?: InputMaybe<Array<ActivitySchemaFieldsModelItemsCreateInput>>;
  multiple?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  noSetup?: InputMaybe<Scalars['Boolean']['input']>;
  outlined?: InputMaybe<Scalars['Boolean']['input']>;
  placeholder?: InputMaybe<Scalars['String']['input']>;
  position?: InputMaybe<Scalars['Int']['input']>;
  preset?: InputMaybe<ActivitySchemaFieldsPresetCreateInput>;
  radioButtons?: InputMaybe<Array<ActivitySchemaFieldsRadioButtonsCreateInput>>;
  roles?: InputMaybe<ActivitySchemaFieldsCreaterolesInput>;
  rounded?: InputMaybe<Scalars['Boolean']['input']>;
  rules?: InputMaybe<ActivitySchemaFieldsCreaterulesInput>;
  searchInput?: InputMaybe<Scalars['String']['input']>;
  searchType?: InputMaybe<Scalars['String']['input']>;
  semantic?: InputMaybe<Scalars['JSON']['input']>;
  setup?: InputMaybe<ActivitySchemaFieldsSetupCreateInput>;
  styling?: InputMaybe<ActivitySchemaFieldsStylingCreateInput>;
  subTitle?: InputMaybe<Scalars['String']['input']>;
  target?: InputMaybe<Scalars['String']['input']>;
  tickSize?: InputMaybe<Scalars['Int']['input']>;
  ticks?: InputMaybe<Scalars['Boolean']['input']>;
  timelineItems?: InputMaybe<Array<ActivitySchemaFieldsTimelineItemsCreateInput>>;
  title?: InputMaybe<Scalars['String']['input']>;
  titleAfterChip?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  vChipContent?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<ActivitySchemaFieldsValueCreateInput>;
  videoAskLabel?: InputMaybe<Scalars['String']['input']>;
  videoAskUrl?: InputMaybe<Scalars['String']['input']>;
  widgetSource?: InputMaybe<Scalars['String']['input']>;
  widgetUrl?: InputMaybe<Scalars['String']['input']>;
  widgetVersion?: InputMaybe<Scalars['Int']['input']>;
};

export type ActivitySchemaFieldsCreaterolesInput = {
  set: Array<Scalars['String']['input']>;
};

export type ActivitySchemaFieldsCreaterulesInput = {
  set: Array<Scalars['String']['input']>;
};

export type ActivitySchemaFieldsModelItems = {
  __typename?: 'ActivitySchemaFieldsModelItems';
  name: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type ActivitySchemaFieldsModelItemsCreateInput = {
  name: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export type ActivitySchemaFieldsModelItemsObjectEqualityInput = {
  name: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export type ActivitySchemaFieldsObjectEqualityInput = {
  action?: InputMaybe<Scalars['String']['input']>;
  adk?: InputMaybe<Scalars['String']['input']>;
  ages?: InputMaybe<Scalars['String']['input']>;
  align?: InputMaybe<Scalars['String']['input']>;
  blank?: InputMaybe<Scalars['Boolean']['input']>;
  builderType?: InputMaybe<Scalars['String']['input']>;
  color?: InputMaybe<Scalars['String']['input']>;
  compiledAt?: InputMaybe<Scalars['DateTime']['input']>;
  compiledWith?: InputMaybe<Scalars['JSON']['input']>;
  dark?: InputMaybe<Scalars['Boolean']['input']>;
  defaultValue?: InputMaybe<Scalars['JSON']['input']>;
  event?: InputMaybe<Scalars['JSON']['input']>;
  header?: InputMaybe<Scalars['String']['input']>;
  href?: InputMaybe<Scalars['String']['input']>;
  icon?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  items?: InputMaybe<Scalars['JSON']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  max?: InputMaybe<Scalars['String']['input']>;
  maxDate?: InputMaybe<Scalars['String']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  min?: InputMaybe<Scalars['String']['input']>;
  minDate?: InputMaybe<Scalars['String']['input']>;
  model?: InputMaybe<Scalars['String']['input']>;
  modelItems?: InputMaybe<Array<ActivitySchemaFieldsModelItemsObjectEqualityInput>>;
  multiple?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  noSetup?: InputMaybe<Scalars['Boolean']['input']>;
  outlined?: InputMaybe<Scalars['Boolean']['input']>;
  placeholder?: InputMaybe<Scalars['String']['input']>;
  position?: InputMaybe<Scalars['Int']['input']>;
  preset?: InputMaybe<ActivitySchemaFieldsPresetObjectEqualityInput>;
  radioButtons?: InputMaybe<Array<ActivitySchemaFieldsRadioButtonsObjectEqualityInput>>;
  roles?: InputMaybe<Array<Scalars['String']['input']>>;
  rounded?: InputMaybe<Scalars['Boolean']['input']>;
  rules?: InputMaybe<Array<Scalars['String']['input']>>;
  searchInput?: InputMaybe<Scalars['String']['input']>;
  searchType?: InputMaybe<Scalars['String']['input']>;
  semantic?: InputMaybe<Scalars['JSON']['input']>;
  setup?: InputMaybe<ActivitySchemaFieldsSetupObjectEqualityInput>;
  styling?: InputMaybe<ActivitySchemaFieldsStylingObjectEqualityInput>;
  subTitle?: InputMaybe<Scalars['String']['input']>;
  target?: InputMaybe<Scalars['String']['input']>;
  tickSize?: InputMaybe<Scalars['Int']['input']>;
  ticks?: InputMaybe<Scalars['Boolean']['input']>;
  timelineItems?: InputMaybe<Array<ActivitySchemaFieldsTimelineItemsObjectEqualityInput>>;
  title?: InputMaybe<Scalars['String']['input']>;
  titleAfterChip?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  vChipContent?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<ActivitySchemaFieldsValueObjectEqualityInput>;
  videoAskLabel?: InputMaybe<Scalars['String']['input']>;
  videoAskUrl?: InputMaybe<Scalars['String']['input']>;
  widgetSource?: InputMaybe<Scalars['String']['input']>;
  widgetUrl?: InputMaybe<Scalars['String']['input']>;
  widgetVersion?: InputMaybe<Scalars['Int']['input']>;
};

export type ActivitySchemaFieldsOrderByCompositeAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type ActivitySchemaFieldsPreset = {
  __typename?: 'ActivitySchemaFieldsPreset';
  acceptanceDeadline?: Maybe<Scalars['String']['output']>;
  apprentice?: Maybe<Scalars['Boolean']['output']>;
  compensation1?: Maybe<Scalars['Boolean']['output']>;
  compensation2?: Maybe<Scalars['Boolean']['output']>;
  compensation3?: Maybe<Scalars['Boolean']['output']>;
  compensation4?: Maybe<Scalars['Boolean']['output']>;
  compensation5?: Maybe<Scalars['Boolean']['output']>;
  compensation6?: Maybe<Scalars['Boolean']['output']>;
  continuation?: Maybe<Scalars['Int']['output']>;
  eir?: Maybe<Scalars['Boolean']['output']>;
  employerRecord?: Maybe<Scalars['Int']['output']>;
  extern?: Maybe<Scalars['Boolean']['output']>;
  externCredential?: Maybe<Scalars['Int']['output']>;
  fellow?: Maybe<Scalars['Boolean']['output']>;
  intern?: Maybe<Scalars['Boolean']['output']>;
  internshipEnd?: Maybe<Scalars['String']['output']>;
  internshipProject1?: Maybe<Scalars['Boolean']['output']>;
  internshipProject2?: Maybe<Scalars['Boolean']['output']>;
  internshipProject3?: Maybe<Scalars['Boolean']['output']>;
  internshipStart?: Maybe<Scalars['String']['output']>;
  licenseRequirement?: Maybe<Scalars['Int']['output']>;
  maxHours?: Maybe<Scalars['Int']['output']>;
  maximumBudget?: Maybe<Scalars['String']['output']>;
  minHours?: Maybe<Scalars['Int']['output']>;
  minimumBudget?: Maybe<Scalars['String']['output']>;
  preApprentice?: Maybe<Scalars['Boolean']['output']>;
  preInternship?: Maybe<Scalars['Boolean']['output']>;
};

export type ActivitySchemaFieldsPresetCreateInput = {
  acceptanceDeadline?: InputMaybe<Scalars['String']['input']>;
  apprentice?: InputMaybe<Scalars['Boolean']['input']>;
  compensation1?: InputMaybe<Scalars['Boolean']['input']>;
  compensation2?: InputMaybe<Scalars['Boolean']['input']>;
  compensation3?: InputMaybe<Scalars['Boolean']['input']>;
  compensation4?: InputMaybe<Scalars['Boolean']['input']>;
  compensation5?: InputMaybe<Scalars['Boolean']['input']>;
  compensation6?: InputMaybe<Scalars['Boolean']['input']>;
  continuation?: InputMaybe<Scalars['Int']['input']>;
  eir?: InputMaybe<Scalars['Boolean']['input']>;
  employerRecord?: InputMaybe<Scalars['Int']['input']>;
  extern?: InputMaybe<Scalars['Boolean']['input']>;
  externCredential?: InputMaybe<Scalars['Int']['input']>;
  fellow?: InputMaybe<Scalars['Boolean']['input']>;
  intern?: InputMaybe<Scalars['Boolean']['input']>;
  internshipEnd?: InputMaybe<Scalars['String']['input']>;
  internshipProject1?: InputMaybe<Scalars['Boolean']['input']>;
  internshipProject2?: InputMaybe<Scalars['Boolean']['input']>;
  internshipProject3?: InputMaybe<Scalars['Boolean']['input']>;
  internshipStart?: InputMaybe<Scalars['String']['input']>;
  licenseRequirement?: InputMaybe<Scalars['Int']['input']>;
  maxHours?: InputMaybe<Scalars['Int']['input']>;
  maximumBudget?: InputMaybe<Scalars['String']['input']>;
  minHours?: InputMaybe<Scalars['Int']['input']>;
  minimumBudget?: InputMaybe<Scalars['String']['input']>;
  preApprentice?: InputMaybe<Scalars['Boolean']['input']>;
  preInternship?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ActivitySchemaFieldsPresetObjectEqualityInput = {
  acceptanceDeadline?: InputMaybe<Scalars['String']['input']>;
  apprentice?: InputMaybe<Scalars['Boolean']['input']>;
  compensation1?: InputMaybe<Scalars['Boolean']['input']>;
  compensation2?: InputMaybe<Scalars['Boolean']['input']>;
  compensation3?: InputMaybe<Scalars['Boolean']['input']>;
  compensation4?: InputMaybe<Scalars['Boolean']['input']>;
  compensation5?: InputMaybe<Scalars['Boolean']['input']>;
  compensation6?: InputMaybe<Scalars['Boolean']['input']>;
  continuation?: InputMaybe<Scalars['Int']['input']>;
  eir?: InputMaybe<Scalars['Boolean']['input']>;
  employerRecord?: InputMaybe<Scalars['Int']['input']>;
  extern?: InputMaybe<Scalars['Boolean']['input']>;
  externCredential?: InputMaybe<Scalars['Int']['input']>;
  fellow?: InputMaybe<Scalars['Boolean']['input']>;
  intern?: InputMaybe<Scalars['Boolean']['input']>;
  internshipEnd?: InputMaybe<Scalars['String']['input']>;
  internshipProject1?: InputMaybe<Scalars['Boolean']['input']>;
  internshipProject2?: InputMaybe<Scalars['Boolean']['input']>;
  internshipProject3?: InputMaybe<Scalars['Boolean']['input']>;
  internshipStart?: InputMaybe<Scalars['String']['input']>;
  licenseRequirement?: InputMaybe<Scalars['Int']['input']>;
  maxHours?: InputMaybe<Scalars['Int']['input']>;
  maximumBudget?: InputMaybe<Scalars['String']['input']>;
  minHours?: InputMaybe<Scalars['Int']['input']>;
  minimumBudget?: InputMaybe<Scalars['String']['input']>;
  preApprentice?: InputMaybe<Scalars['Boolean']['input']>;
  preInternship?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ActivitySchemaFieldsRadioButtons = {
  __typename?: 'ActivitySchemaFieldsRadioButtons';
  action?: Maybe<Scalars['String']['output']>;
  clickable?: Maybe<Scalars['Boolean']['output']>;
  event?: Maybe<ActivitySchemaFieldsRadioButtonsEvent>;
  label: Scalars['String']['output'];
};

export type ActivitySchemaFieldsRadioButtonsCreateInput = {
  action?: InputMaybe<Scalars['String']['input']>;
  clickable?: InputMaybe<Scalars['Boolean']['input']>;
  event?: InputMaybe<ActivitySchemaFieldsRadioButtonsEventCreateInput>;
  label: Scalars['String']['input'];
};

export type ActivitySchemaFieldsRadioButtonsEvent = {
  __typename?: 'ActivitySchemaFieldsRadioButtonsEvent';
  body: Scalars['String']['output'];
  buttons?: Maybe<Array<ActivitySchemaFieldsRadioButtonsEventButtons>>;
  component: Scalars['String']['output'];
  title: Scalars['String']['output'];
  trigger: Scalars['String']['output'];
};

export type ActivitySchemaFieldsRadioButtonsEventButtons = {
  __typename?: 'ActivitySchemaFieldsRadioButtonsEventButtons';
  label: Scalars['String']['output'];
  model: Scalars['String']['output'];
  style: ActivitySchemaFieldsRadioButtonsEventButtonsStyle;
};

export type ActivitySchemaFieldsRadioButtonsEventButtonsCreateInput = {
  label: Scalars['String']['input'];
  model: Scalars['String']['input'];
  style: ActivitySchemaFieldsRadioButtonsEventButtonsStyleCreateInput;
};

export type ActivitySchemaFieldsRadioButtonsEventButtonsObjectEqualityInput = {
  label: Scalars['String']['input'];
  model: Scalars['String']['input'];
  style: ActivitySchemaFieldsRadioButtonsEventButtonsStyleObjectEqualityInput;
};

export type ActivitySchemaFieldsRadioButtonsEventButtonsStyle = {
  __typename?: 'ActivitySchemaFieldsRadioButtonsEventButtonsStyle';
  class: Scalars['String']['output'];
  color: Scalars['String']['output'];
  dark?: Maybe<Scalars['Boolean']['output']>;
  depressed?: Maybe<Scalars['Boolean']['output']>;
  outlined?: Maybe<Scalars['Boolean']['output']>;
  rounded: Scalars['Boolean']['output'];
  xLarge: Scalars['Boolean']['output'];
};

export type ActivitySchemaFieldsRadioButtonsEventButtonsStyleCreateInput = {
  class: Scalars['String']['input'];
  color: Scalars['String']['input'];
  dark?: InputMaybe<Scalars['Boolean']['input']>;
  depressed?: InputMaybe<Scalars['Boolean']['input']>;
  outlined?: InputMaybe<Scalars['Boolean']['input']>;
  rounded: Scalars['Boolean']['input'];
  xLarge: Scalars['Boolean']['input'];
};

export type ActivitySchemaFieldsRadioButtonsEventButtonsStyleObjectEqualityInput = {
  class: Scalars['String']['input'];
  color: Scalars['String']['input'];
  dark?: InputMaybe<Scalars['Boolean']['input']>;
  depressed?: InputMaybe<Scalars['Boolean']['input']>;
  outlined?: InputMaybe<Scalars['Boolean']['input']>;
  rounded: Scalars['Boolean']['input'];
  xLarge: Scalars['Boolean']['input'];
};

export type ActivitySchemaFieldsRadioButtonsEventCreateInput = {
  body: Scalars['String']['input'];
  buttons?: InputMaybe<Array<ActivitySchemaFieldsRadioButtonsEventButtonsCreateInput>>;
  component: Scalars['String']['input'];
  title: Scalars['String']['input'];
  trigger: Scalars['String']['input'];
};

export type ActivitySchemaFieldsRadioButtonsEventObjectEqualityInput = {
  body: Scalars['String']['input'];
  buttons?: InputMaybe<Array<ActivitySchemaFieldsRadioButtonsEventButtonsObjectEqualityInput>>;
  component: Scalars['String']['input'];
  title: Scalars['String']['input'];
  trigger: Scalars['String']['input'];
};

export type ActivitySchemaFieldsRadioButtonsObjectEqualityInput = {
  action?: InputMaybe<Scalars['String']['input']>;
  clickable?: InputMaybe<Scalars['Boolean']['input']>;
  event?: InputMaybe<ActivitySchemaFieldsRadioButtonsEventObjectEqualityInput>;
  label: Scalars['String']['input'];
};

export type ActivitySchemaFieldsSetup = {
  __typename?: 'ActivitySchemaFieldsSetup';
  action?: Maybe<ActivitySchemaFieldsSetupAction>;
  airtableFormLink?: Maybe<Scalars['String']['output']>;
  airtableLink?: Maybe<Scalars['String']['output']>;
  airtableResponseLink?: Maybe<Scalars['String']['output']>;
  airtableTableLink?: Maybe<Scalars['String']['output']>;
  arrivalLink?: Maybe<Scalars['String']['output']>;
  arrivalStatus?: Maybe<Scalars['String']['output']>;
  attendeeList?: Maybe<Scalars['String']['output']>;
  /** Could not determine type: the field only had null or empty values in the sample set. */
  boards?: Maybe<Scalars['JSON']['output']>;
  calendly_link?: Maybe<Scalars['String']['output']>;
  /** Could not determine type: the field only had null or empty values in the sample set. */
  channels?: Maybe<Scalars['JSON']['output']>;
  checkinLink?: Maybe<Scalars['String']['output']>;
  discordLink?: Maybe<Scalars['String']['output']>;
  docDesc?: Maybe<Scalars['String']['output']>;
  eventAgenda?: Maybe<Scalars['String']['output']>;
  eventDate?: Maybe<Scalars['String']['output']>;
  eventLocations?: Maybe<Scalars['String']['output']>;
  eventName?: Maybe<Scalars['String']['output']>;
  fileType?: Maybe<Array<Scalars['String']['output']>>;
  /** Could not determine type: the field only had null or empty values in the sample set. */
  formUrls?: Maybe<Scalars['JSON']['output']>;
  instagramEmbedLink?: Maybe<Scalars['String']['output']>;
  instructions?: Maybe<Scalars['String']['output']>;
  /** Could not determine type: the field only had null or empty values in the sample set. */
  keyResults?: Maybe<Scalars['JSON']['output']>;
  link?: Maybe<Scalars['String']['output']>;
  materialsToBring?: Maybe<Array<ActivitySchemaFieldsSetupMaterialsToBring>>;
  objective?: Maybe<Scalars['String']['output']>;
  providers?: Maybe<ActivitySchemaFieldsSetupProviders>;
  rsvpLink?: Maybe<Scalars['String']['output']>;
  sponsorHandle?: Maybe<Scalars['String']['output']>;
  sponsorOrganization?: Maybe<Scalars['String']['output']>;
  timeFrame?: Maybe<Array<ActivitySchemaFieldsSetupTimeFrame>>;
  timeZone?: Maybe<Scalars['String']['output']>;
  uploadLimit?: Maybe<ActivitySchemaFieldsSetupUploadLimit>;
  uploadLink?: Maybe<Scalars['String']['output']>;
  videoaskEmbed?: Maybe<Scalars['String']['output']>;
  videoaskLink?: Maybe<Scalars['String']['output']>;
  videoaskResponseLink?: Maybe<Scalars['String']['output']>;
  youtubeLink?: Maybe<Scalars['String']['output']>;
};

export type ActivitySchemaFieldsSetupAction = {
  __typename?: 'ActivitySchemaFieldsSetupAction';
  desc: Scalars['String']['output'];
  link: Scalars['String']['output'];
};

export type ActivitySchemaFieldsSetupActionCreateInput = {
  desc: Scalars['String']['input'];
  link: Scalars['String']['input'];
};

export type ActivitySchemaFieldsSetupActionObjectEqualityInput = {
  desc: Scalars['String']['input'];
  link: Scalars['String']['input'];
};

export type ActivitySchemaFieldsSetupCreateInput = {
  action?: InputMaybe<ActivitySchemaFieldsSetupActionCreateInput>;
  airtableFormLink?: InputMaybe<Scalars['String']['input']>;
  airtableLink?: InputMaybe<Scalars['String']['input']>;
  airtableResponseLink?: InputMaybe<Scalars['String']['input']>;
  airtableTableLink?: InputMaybe<Scalars['String']['input']>;
  arrivalLink?: InputMaybe<Scalars['String']['input']>;
  arrivalStatus?: InputMaybe<Scalars['String']['input']>;
  attendeeList?: InputMaybe<Scalars['String']['input']>;
  boards?: InputMaybe<Scalars['JSON']['input']>;
  calendly_link?: InputMaybe<Scalars['String']['input']>;
  channels?: InputMaybe<Scalars['JSON']['input']>;
  checkinLink?: InputMaybe<Scalars['String']['input']>;
  discordLink?: InputMaybe<Scalars['String']['input']>;
  docDesc?: InputMaybe<Scalars['String']['input']>;
  eventAgenda?: InputMaybe<Scalars['String']['input']>;
  eventDate?: InputMaybe<Scalars['String']['input']>;
  eventLocations?: InputMaybe<Scalars['String']['input']>;
  eventName?: InputMaybe<Scalars['String']['input']>;
  fileType?: InputMaybe<ActivitySchemaFieldsSetupCreatefileTypeInput>;
  formUrls?: InputMaybe<Scalars['JSON']['input']>;
  instagramEmbedLink?: InputMaybe<Scalars['String']['input']>;
  instructions?: InputMaybe<Scalars['String']['input']>;
  keyResults?: InputMaybe<Scalars['JSON']['input']>;
  link?: InputMaybe<Scalars['String']['input']>;
  materialsToBring?: InputMaybe<Array<ActivitySchemaFieldsSetupMaterialsToBringCreateInput>>;
  objective?: InputMaybe<Scalars['String']['input']>;
  providers?: InputMaybe<ActivitySchemaFieldsSetupProvidersCreateInput>;
  rsvpLink?: InputMaybe<Scalars['String']['input']>;
  sponsorHandle?: InputMaybe<Scalars['String']['input']>;
  sponsorOrganization?: InputMaybe<Scalars['String']['input']>;
  timeFrame?: InputMaybe<Array<ActivitySchemaFieldsSetupTimeFrameCreateInput>>;
  timeZone?: InputMaybe<Scalars['String']['input']>;
  uploadLimit?: InputMaybe<ActivitySchemaFieldsSetupUploadLimitCreateInput>;
  uploadLink?: InputMaybe<Scalars['String']['input']>;
  videoaskEmbed?: InputMaybe<Scalars['String']['input']>;
  videoaskLink?: InputMaybe<Scalars['String']['input']>;
  videoaskResponseLink?: InputMaybe<Scalars['String']['input']>;
  youtubeLink?: InputMaybe<Scalars['String']['input']>;
};

export type ActivitySchemaFieldsSetupCreatefileTypeInput = {
  set: Array<Scalars['String']['input']>;
};

export type ActivitySchemaFieldsSetupMaterialsToBring = {
  __typename?: 'ActivitySchemaFieldsSetupMaterialsToBring';
  item: Scalars['String']['output'];
  qty: Scalars['Int']['output'];
  required: Scalars['Boolean']['output'];
};

export type ActivitySchemaFieldsSetupMaterialsToBringCreateInput = {
  item: Scalars['String']['input'];
  qty: Scalars['Int']['input'];
  required: Scalars['Boolean']['input'];
};

export type ActivitySchemaFieldsSetupMaterialsToBringObjectEqualityInput = {
  item: Scalars['String']['input'];
  qty: Scalars['Int']['input'];
  required: Scalars['Boolean']['input'];
};

export type ActivitySchemaFieldsSetupObjectEqualityInput = {
  action?: InputMaybe<ActivitySchemaFieldsSetupActionObjectEqualityInput>;
  airtableFormLink?: InputMaybe<Scalars['String']['input']>;
  airtableLink?: InputMaybe<Scalars['String']['input']>;
  airtableResponseLink?: InputMaybe<Scalars['String']['input']>;
  airtableTableLink?: InputMaybe<Scalars['String']['input']>;
  arrivalLink?: InputMaybe<Scalars['String']['input']>;
  arrivalStatus?: InputMaybe<Scalars['String']['input']>;
  attendeeList?: InputMaybe<Scalars['String']['input']>;
  boards?: InputMaybe<Scalars['JSON']['input']>;
  calendly_link?: InputMaybe<Scalars['String']['input']>;
  channels?: InputMaybe<Scalars['JSON']['input']>;
  checkinLink?: InputMaybe<Scalars['String']['input']>;
  discordLink?: InputMaybe<Scalars['String']['input']>;
  docDesc?: InputMaybe<Scalars['String']['input']>;
  eventAgenda?: InputMaybe<Scalars['String']['input']>;
  eventDate?: InputMaybe<Scalars['String']['input']>;
  eventLocations?: InputMaybe<Scalars['String']['input']>;
  eventName?: InputMaybe<Scalars['String']['input']>;
  fileType?: InputMaybe<Array<Scalars['String']['input']>>;
  formUrls?: InputMaybe<Scalars['JSON']['input']>;
  instagramEmbedLink?: InputMaybe<Scalars['String']['input']>;
  instructions?: InputMaybe<Scalars['String']['input']>;
  keyResults?: InputMaybe<Scalars['JSON']['input']>;
  link?: InputMaybe<Scalars['String']['input']>;
  materialsToBring?: InputMaybe<Array<ActivitySchemaFieldsSetupMaterialsToBringObjectEqualityInput>>;
  objective?: InputMaybe<Scalars['String']['input']>;
  providers?: InputMaybe<ActivitySchemaFieldsSetupProvidersObjectEqualityInput>;
  rsvpLink?: InputMaybe<Scalars['String']['input']>;
  sponsorHandle?: InputMaybe<Scalars['String']['input']>;
  sponsorOrganization?: InputMaybe<Scalars['String']['input']>;
  timeFrame?: InputMaybe<Array<ActivitySchemaFieldsSetupTimeFrameObjectEqualityInput>>;
  timeZone?: InputMaybe<Scalars['String']['input']>;
  uploadLimit?: InputMaybe<ActivitySchemaFieldsSetupUploadLimitObjectEqualityInput>;
  uploadLink?: InputMaybe<Scalars['String']['input']>;
  videoaskEmbed?: InputMaybe<Scalars['String']['input']>;
  videoaskLink?: InputMaybe<Scalars['String']['input']>;
  videoaskResponseLink?: InputMaybe<Scalars['String']['input']>;
  youtubeLink?: InputMaybe<Scalars['String']['input']>;
};

export type ActivitySchemaFieldsSetupProviders = {
  __typename?: 'ActivitySchemaFieldsSetupProviders';
  apple: Scalars['Boolean']['output'];
  google: Scalars['Boolean']['output'];
  web: Scalars['Boolean']['output'];
};

export type ActivitySchemaFieldsSetupProvidersCreateInput = {
  apple: Scalars['Boolean']['input'];
  google: Scalars['Boolean']['input'];
  web: Scalars['Boolean']['input'];
};

export type ActivitySchemaFieldsSetupProvidersObjectEqualityInput = {
  apple: Scalars['Boolean']['input'];
  google: Scalars['Boolean']['input'];
  web: Scalars['Boolean']['input'];
};

export type ActivitySchemaFieldsSetupTimeFrame = {
  __typename?: 'ActivitySchemaFieldsSetupTimeFrame';
  end: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  isCondensed: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  notes: Scalars['String']['output'];
  start: Scalars['String']['output'];
  visibility: Scalars['String']['output'];
};

export type ActivitySchemaFieldsSetupTimeFrameCreateInput = {
  end: Scalars['String']['input'];
  id: Scalars['Int']['input'];
  isCondensed: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  notes: Scalars['String']['input'];
  start: Scalars['String']['input'];
  visibility: Scalars['String']['input'];
};

export type ActivitySchemaFieldsSetupTimeFrameObjectEqualityInput = {
  end: Scalars['String']['input'];
  id: Scalars['Int']['input'];
  isCondensed: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  notes: Scalars['String']['input'];
  start: Scalars['String']['input'];
  visibility: Scalars['String']['input'];
};

export type ActivitySchemaFieldsSetupUploadLimit = {
  __typename?: 'ActivitySchemaFieldsSetupUploadLimit';
  max: Scalars['Int']['output'];
  min: Scalars['Int']['output'];
};

export type ActivitySchemaFieldsSetupUploadLimitCreateInput = {
  max: Scalars['Int']['input'];
  min: Scalars['Int']['input'];
};

export type ActivitySchemaFieldsSetupUploadLimitObjectEqualityInput = {
  max: Scalars['Int']['input'];
  min: Scalars['Int']['input'];
};

export type ActivitySchemaFieldsStyling = {
  __typename?: 'ActivitySchemaFieldsStyling';
  appendIcon?: Maybe<Scalars['String']['output']>;
  chips?: Maybe<Scalars['Boolean']['output']>;
  class?: Maybe<Scalars['String']['output']>;
  color?: Maybe<Scalars['String']['output']>;
  /** Multiple data types found: String: 84.6%, Int: 15.4% out of 13 sampled entries */
  counter?: Maybe<Scalars['JSON']['output']>;
  dark?: Maybe<Scalars['Boolean']['output']>;
  dense?: Maybe<Scalars['Boolean']['output']>;
  denseIcon?: Maybe<Scalars['Boolean']['output']>;
  depressed?: Maybe<Scalars['Boolean']['output']>;
  flat?: Maybe<Scalars['Boolean']['output']>;
  hide_details?: Maybe<Scalars['Boolean']['output']>;
  hint?: Maybe<Scalars['String']['output']>;
  icon?: Maybe<Scalars['Boolean']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  leftIcon?: Maybe<Scalars['Boolean']['output']>;
  multiple?: Maybe<Scalars['Boolean']['output']>;
  outlined?: Maybe<Scalars['Boolean']['output']>;
  placeholder?: Maybe<Scalars['String']['output']>;
  prependIcon?: Maybe<Scalars['String']['output']>;
  rightIcon?: Maybe<Scalars['Boolean']['output']>;
  rounded?: Maybe<Scalars['Boolean']['output']>;
  small?: Maybe<Scalars['Boolean']['output']>;
  small_chips?: Maybe<Scalars['Boolean']['output']>;
  wrapperClass?: Maybe<Scalars['String']['output']>;
  xLarge?: Maybe<Scalars['Boolean']['output']>;
  xSmall?: Maybe<Scalars['Boolean']['output']>;
};

export type ActivitySchemaFieldsStylingCreateInput = {
  appendIcon?: InputMaybe<Scalars['String']['input']>;
  chips?: InputMaybe<Scalars['Boolean']['input']>;
  class?: InputMaybe<Scalars['String']['input']>;
  color?: InputMaybe<Scalars['String']['input']>;
  counter?: InputMaybe<Scalars['JSON']['input']>;
  dark?: InputMaybe<Scalars['Boolean']['input']>;
  dense?: InputMaybe<Scalars['Boolean']['input']>;
  denseIcon?: InputMaybe<Scalars['Boolean']['input']>;
  depressed?: InputMaybe<Scalars['Boolean']['input']>;
  flat?: InputMaybe<Scalars['Boolean']['input']>;
  hide_details?: InputMaybe<Scalars['Boolean']['input']>;
  hint?: InputMaybe<Scalars['String']['input']>;
  icon?: InputMaybe<Scalars['Boolean']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  leftIcon?: InputMaybe<Scalars['Boolean']['input']>;
  multiple?: InputMaybe<Scalars['Boolean']['input']>;
  outlined?: InputMaybe<Scalars['Boolean']['input']>;
  placeholder?: InputMaybe<Scalars['String']['input']>;
  prependIcon?: InputMaybe<Scalars['String']['input']>;
  rightIcon?: InputMaybe<Scalars['Boolean']['input']>;
  rounded?: InputMaybe<Scalars['Boolean']['input']>;
  small?: InputMaybe<Scalars['Boolean']['input']>;
  small_chips?: InputMaybe<Scalars['Boolean']['input']>;
  wrapperClass?: InputMaybe<Scalars['String']['input']>;
  xLarge?: InputMaybe<Scalars['Boolean']['input']>;
  xSmall?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ActivitySchemaFieldsStylingObjectEqualityInput = {
  appendIcon?: InputMaybe<Scalars['String']['input']>;
  chips?: InputMaybe<Scalars['Boolean']['input']>;
  class?: InputMaybe<Scalars['String']['input']>;
  color?: InputMaybe<Scalars['String']['input']>;
  counter?: InputMaybe<Scalars['JSON']['input']>;
  dark?: InputMaybe<Scalars['Boolean']['input']>;
  dense?: InputMaybe<Scalars['Boolean']['input']>;
  denseIcon?: InputMaybe<Scalars['Boolean']['input']>;
  depressed?: InputMaybe<Scalars['Boolean']['input']>;
  flat?: InputMaybe<Scalars['Boolean']['input']>;
  hide_details?: InputMaybe<Scalars['Boolean']['input']>;
  hint?: InputMaybe<Scalars['String']['input']>;
  icon?: InputMaybe<Scalars['Boolean']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  leftIcon?: InputMaybe<Scalars['Boolean']['input']>;
  multiple?: InputMaybe<Scalars['Boolean']['input']>;
  outlined?: InputMaybe<Scalars['Boolean']['input']>;
  placeholder?: InputMaybe<Scalars['String']['input']>;
  prependIcon?: InputMaybe<Scalars['String']['input']>;
  rightIcon?: InputMaybe<Scalars['Boolean']['input']>;
  rounded?: InputMaybe<Scalars['Boolean']['input']>;
  small?: InputMaybe<Scalars['Boolean']['input']>;
  small_chips?: InputMaybe<Scalars['Boolean']['input']>;
  wrapperClass?: InputMaybe<Scalars['String']['input']>;
  xLarge?: InputMaybe<Scalars['Boolean']['input']>;
  xSmall?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ActivitySchemaFieldsTimelineItems = {
  __typename?: 'ActivitySchemaFieldsTimelineItems';
  answer: Scalars['String']['output'];
  color: Scalars['String']['output'];
  question: Scalars['String']['output'];
};

export type ActivitySchemaFieldsTimelineItemsCreateInput = {
  answer: Scalars['String']['input'];
  color: Scalars['String']['input'];
  question: Scalars['String']['input'];
};

export type ActivitySchemaFieldsTimelineItemsObjectEqualityInput = {
  answer: Scalars['String']['input'];
  color: Scalars['String']['input'];
  question: Scalars['String']['input'];
};

export type ActivitySchemaFieldsValue = {
  __typename?: 'ActivitySchemaFieldsValue';
  dateCheckedIn?: Maybe<Scalars['String']['output']>;
  dateCheckedOut?: Maybe<Scalars['String']['output']>;
  deliverable?: Maybe<Array<Scalars['String']['output']>>;
  description?: Maybe<Scalars['String']['output']>;
  docLink?: Maybe<Scalars['String']['output']>;
  fileUpload?: Maybe<Array<ActivitySchemaFieldsValueFileUpload>>;
  isCheckedIn?: Maybe<Scalars['Boolean']['output']>;
  /** Could not determine type: the field only had null or empty values in the sample set. */
  keyResults?: Maybe<Scalars['JSON']['output']>;
  loaded?: Maybe<Array<Scalars['String']['output']>>;
  objective?: Maybe<Scalars['String']['output']>;
  /** Could not determine type: the field only had null or empty values in the sample set. */
  okrAck?: Maybe<Scalars['JSON']['output']>;
  outcome?: Maybe<Array<Scalars['String']['output']>>;
  studentLinkedinProfile?: Maybe<Scalars['String']['output']>;
  submission?: Maybe<ActivitySchemaFieldsValueSubmission>;
  textFields?: Maybe<Array<Scalars['String']['output']>>;
  url?: Maybe<Scalars['String']['output']>;
  /** Nested objects had no data in the sample dataset to introspect a nested type. */
  urlSubmitted?: Maybe<Scalars['JSON']['output']>;
};

export type ActivitySchemaFieldsValueCreateInput = {
  dateCheckedIn?: InputMaybe<Scalars['String']['input']>;
  dateCheckedOut?: InputMaybe<Scalars['String']['input']>;
  deliverable?: InputMaybe<ActivitySchemaFieldsValueCreatedeliverableInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  docLink?: InputMaybe<Scalars['String']['input']>;
  fileUpload?: InputMaybe<Array<ActivitySchemaFieldsValueFileUploadCreateInput>>;
  isCheckedIn?: InputMaybe<Scalars['Boolean']['input']>;
  keyResults?: InputMaybe<Scalars['JSON']['input']>;
  loaded?: InputMaybe<ActivitySchemaFieldsValueCreateloadedInput>;
  objective?: InputMaybe<Scalars['String']['input']>;
  okrAck?: InputMaybe<Scalars['JSON']['input']>;
  outcome?: InputMaybe<ActivitySchemaFieldsValueCreateoutcomeInput>;
  studentLinkedinProfile?: InputMaybe<Scalars['String']['input']>;
  submission?: InputMaybe<ActivitySchemaFieldsValueSubmissionCreateInput>;
  textFields?: InputMaybe<ActivitySchemaFieldsValueCreatetextFieldsInput>;
  url?: InputMaybe<Scalars['String']['input']>;
  urlSubmitted?: InputMaybe<Scalars['JSON']['input']>;
};

export type ActivitySchemaFieldsValueCreatedeliverableInput = {
  set: Array<Scalars['String']['input']>;
};

export type ActivitySchemaFieldsValueCreateloadedInput = {
  set: Array<Scalars['String']['input']>;
};

export type ActivitySchemaFieldsValueCreateoutcomeInput = {
  set: Array<Scalars['String']['input']>;
};

export type ActivitySchemaFieldsValueCreatetextFieldsInput = {
  set: Array<Scalars['String']['input']>;
};

export type ActivitySchemaFieldsValueFileUpload = {
  __typename?: 'ActivitySchemaFieldsValueFileUpload';
  description: Scalars['String']['output'];
  /** Could not determine type: the field only had null or empty values in the sample set. */
  file?: Maybe<Scalars['JSON']['output']>;
  fileName: Scalars['String']['output'];
  timestamp?: Maybe<Scalars['String']['output']>;
};

export type ActivitySchemaFieldsValueFileUploadCreateInput = {
  description: Scalars['String']['input'];
  file?: InputMaybe<Scalars['JSON']['input']>;
  fileName: Scalars['String']['input'];
  timestamp?: InputMaybe<Scalars['String']['input']>;
};

export type ActivitySchemaFieldsValueFileUploadObjectEqualityInput = {
  description: Scalars['String']['input'];
  file?: InputMaybe<Scalars['JSON']['input']>;
  fileName: Scalars['String']['input'];
  timestamp?: InputMaybe<Scalars['String']['input']>;
};

export type ActivitySchemaFieldsValueObjectEqualityInput = {
  dateCheckedIn?: InputMaybe<Scalars['String']['input']>;
  dateCheckedOut?: InputMaybe<Scalars['String']['input']>;
  deliverable?: InputMaybe<Array<Scalars['String']['input']>>;
  description?: InputMaybe<Scalars['String']['input']>;
  docLink?: InputMaybe<Scalars['String']['input']>;
  fileUpload?: InputMaybe<Array<ActivitySchemaFieldsValueFileUploadObjectEqualityInput>>;
  isCheckedIn?: InputMaybe<Scalars['Boolean']['input']>;
  keyResults?: InputMaybe<Scalars['JSON']['input']>;
  loaded?: InputMaybe<Array<Scalars['String']['input']>>;
  objective?: InputMaybe<Scalars['String']['input']>;
  okrAck?: InputMaybe<Scalars['JSON']['input']>;
  outcome?: InputMaybe<Array<Scalars['String']['input']>>;
  studentLinkedinProfile?: InputMaybe<Scalars['String']['input']>;
  submission?: InputMaybe<ActivitySchemaFieldsValueSubmissionObjectEqualityInput>;
  textFields?: InputMaybe<Array<Scalars['String']['input']>>;
  url?: InputMaybe<Scalars['String']['input']>;
  urlSubmitted?: InputMaybe<Scalars['JSON']['input']>;
};

export type ActivitySchemaFieldsValueSubmission = {
  __typename?: 'ActivitySchemaFieldsValueSubmission';
  apple: Scalars['String']['output'];
  google: Scalars['String']['output'];
  web: Scalars['String']['output'];
};

export type ActivitySchemaFieldsValueSubmissionCreateInput = {
  apple: Scalars['String']['input'];
  google: Scalars['String']['input'];
  web: Scalars['String']['input'];
};

export type ActivitySchemaFieldsValueSubmissionObjectEqualityInput = {
  apple: Scalars['String']['input'];
  google: Scalars['String']['input'];
  web: Scalars['String']['input'];
};

export type ActivitySchemaInstruction = {
  __typename?: 'ActivitySchemaInstruction';
  boilerInstructions?: Maybe<Array<Scalars['String']['output']>>;
  discordUrl?: Maybe<Scalars['String']['output']>;
  goal?: Maybe<Scalars['String']['output']>;
  youtubeUrl?: Maybe<Scalars['String']['output']>;
};

export type ActivitySchemaInstructionCreateInput = {
  boilerInstructions?: InputMaybe<ActivitySchemaInstructionCreateboilerInstructionsInput>;
  discordUrl?: InputMaybe<Scalars['String']['input']>;
  goal?: InputMaybe<Scalars['String']['input']>;
  youtubeUrl?: InputMaybe<Scalars['String']['input']>;
};

export type ActivitySchemaInstructionCreateboilerInstructionsInput = {
  set: Array<Scalars['String']['input']>;
};

export type ActivitySchemaInstructionNullableCompositeFilter = {
  equals?: InputMaybe<ActivitySchemaInstructionObjectEqualityInput>;
  is?: InputMaybe<ActivitySchemaInstructionWhereInput>;
  isNot?: InputMaybe<ActivitySchemaInstructionWhereInput>;
  isSet?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ActivitySchemaInstructionNullableCreateEnvelopeInput = {
  set?: InputMaybe<ActivitySchemaInstructionCreateInput>;
};

export type ActivitySchemaInstructionNullableUpdateEnvelopeInput = {
  set?: InputMaybe<ActivitySchemaInstructionCreateInput>;
  unset?: InputMaybe<Scalars['Boolean']['input']>;
  upsert?: InputMaybe<ActivitySchemaInstructionUpsertInput>;
};

export type ActivitySchemaInstructionObjectEqualityInput = {
  boilerInstructions?: InputMaybe<Array<Scalars['String']['input']>>;
  discordUrl?: InputMaybe<Scalars['String']['input']>;
  goal?: InputMaybe<Scalars['String']['input']>;
  youtubeUrl?: InputMaybe<Scalars['String']['input']>;
};

export type ActivitySchemaInstructionOrderByInput = {
  boilerInstructions?: InputMaybe<SortOrder>;
  discordUrl?: InputMaybe<SortOrder>;
  goal?: InputMaybe<SortOrder>;
  youtubeUrl?: InputMaybe<SortOrder>;
};

export type ActivitySchemaInstructionUpdateInput = {
  boilerInstructions?: InputMaybe<ActivitySchemaInstructionUpdateboilerInstructionsInput>;
  discordUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  goal?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  youtubeUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type ActivitySchemaInstructionUpdateboilerInstructionsInput = {
  push?: InputMaybe<Array<Scalars['String']['input']>>;
  set?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type ActivitySchemaInstructionUpsertInput = {
  set: ActivitySchemaInstructionCreateInput;
  update: ActivitySchemaInstructionUpdateInput;
};

export type ActivitySchemaInstructionWhereInput = {
  AND?: InputMaybe<Array<ActivitySchemaInstructionWhereInput>>;
  NOT?: InputMaybe<Array<ActivitySchemaInstructionWhereInput>>;
  OR?: InputMaybe<Array<ActivitySchemaInstructionWhereInput>>;
  boilerInstructions?: InputMaybe<StringNullableListFilter>;
  discordUrl?: InputMaybe<StringNullableFilter>;
  goal?: InputMaybe<StringNullableFilter>;
  youtubeUrl?: InputMaybe<StringNullableFilter>;
};

/** Filter input for ActivitySchema library queries */
export type ActivitySchemaLibraryFilterInput = {
  /** Filter by category (Pre, Do, Reflect, etc.) */
  category?: InputMaybe<Scalars['String']['input']>;
  /** Search by name (case-insensitive contains) */
  search?: InputMaybe<Scalars['String']['input']>;
  /** Number of items to skip for pagination */
  skip?: InputMaybe<Scalars['Int']['input']>;
  /** Filter by status type (draft, published, archived) */
  statusType?: InputMaybe<Scalars['String']['input']>;
  /** Number of items to take for pagination */
  take?: InputMaybe<Scalars['Int']['input']>;
};

/** Activity schema item for library display */
export type ActivitySchemaLibraryItem = {
  __typename?: 'ActivitySchemaLibraryItem';
  /** Category (Pre, Do, Reflect, etc.) */
  category?: Maybe<Scalars['String']['output']>;
  /** Creation timestamp */
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  /** User ID of the creator */
  createdBy?: Maybe<Scalars['String']['output']>;
  /** Email of the creator for display */
  createdByEmail?: Maybe<Scalars['String']['output']>;
  /** Description (may be truncated for display) */
  description: Scalars['String']['output'];
  /** Icon identifier for display */
  icon: Scalars['String']['output'];
  /** Unique identifier */
  id: Scalars['String']['output'];
  /** Name of the activity */
  name: Scalars['String']['output'];
  /** Status type (draft, published, archived) */
  statusType?: Maybe<Scalars['String']['output']>;
  /** Number of times this schema has been cloned/used */
  usageCount?: Maybe<Scalars['Int']['output']>;
};

export type ActivitySchemaLibraryResult = {
  __typename?: 'ActivitySchemaLibraryResult';
  hasMore: Scalars['Boolean']['output'];
  items: Array<ActivitySchemaLibraryItem>;
  totalCount: Scalars['Int']['output'];
};

export type ActivitySchemaMaxAggregate = {
  __typename?: 'ActivitySchemaMaxAggregate';
  activityImage?: Maybe<Scalars['String']['output']>;
  builderType?: Maybe<Scalars['String']['output']>;
  category?: Maybe<Scalars['String']['output']>;
  completed?: Maybe<Scalars['Boolean']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  discordEntityType?: Maybe<Scalars['String']['output']>;
  employerWebsite?: Maybe<Scalars['String']['output']>;
  icon?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  interviewReqeust?: Maybe<Scalars['String']['output']>;
  introVideo?: Maybe<Scalars['String']['output']>;
  isPreview?: Maybe<Scalars['Boolean']['output']>;
  isSkippable?: Maybe<Scalars['Boolean']['output']>;
  isTeamAdk?: Maybe<Scalars['Boolean']['output']>;
  isVideoask?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  optional?: Maybe<Scalars['Boolean']['output']>;
  position?: Maybe<Scalars['Int']['output']>;
  preview?: Maybe<Scalars['Boolean']['output']>;
  projectScope?: Maybe<Scalars['String']['output']>;
  required?: Maybe<Scalars['Boolean']['output']>;
  setupRequired?: Maybe<Scalars['Boolean']['output']>;
  sourceActivitySchemaId?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['Boolean']['output']>;
  statusType?: Maybe<Scalars['String']['output']>;
  timeToSolveProblem?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
  usageCount?: Maybe<Scalars['Int']['output']>;
};

export type ActivitySchemaMinAggregate = {
  __typename?: 'ActivitySchemaMinAggregate';
  activityImage?: Maybe<Scalars['String']['output']>;
  builderType?: Maybe<Scalars['String']['output']>;
  category?: Maybe<Scalars['String']['output']>;
  completed?: Maybe<Scalars['Boolean']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  discordEntityType?: Maybe<Scalars['String']['output']>;
  employerWebsite?: Maybe<Scalars['String']['output']>;
  icon?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  interviewReqeust?: Maybe<Scalars['String']['output']>;
  introVideo?: Maybe<Scalars['String']['output']>;
  isPreview?: Maybe<Scalars['Boolean']['output']>;
  isSkippable?: Maybe<Scalars['Boolean']['output']>;
  isTeamAdk?: Maybe<Scalars['Boolean']['output']>;
  isVideoask?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  optional?: Maybe<Scalars['Boolean']['output']>;
  position?: Maybe<Scalars['Int']['output']>;
  preview?: Maybe<Scalars['Boolean']['output']>;
  projectScope?: Maybe<Scalars['String']['output']>;
  required?: Maybe<Scalars['Boolean']['output']>;
  setupRequired?: Maybe<Scalars['Boolean']['output']>;
  sourceActivitySchemaId?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['Boolean']['output']>;
  statusType?: Maybe<Scalars['String']['output']>;
  timeToSolveProblem?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
  usageCount?: Maybe<Scalars['Int']['output']>;
};

export type ActivitySchemaOrderByWithRelationInput = {
  JSONSchema?: InputMaybe<SortOrder>;
  activityImage?: InputMaybe<SortOrder>;
  buildScope?: InputMaybe<ActivitySchemaBuildScopeOrderByInput>;
  builderType?: InputMaybe<SortOrder>;
  category?: InputMaybe<SortOrder>;
  completed?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  createdBy?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrder>;
  discordEntityType?: InputMaybe<SortOrder>;
  employerWebsite?: InputMaybe<SortOrder>;
  fields?: InputMaybe<ActivitySchemaFieldsOrderByCompositeAggregateInput>;
  icon?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  instruction?: InputMaybe<ActivitySchemaInstructionOrderByInput>;
  interviewReqeust?: InputMaybe<SortOrder>;
  introVideo?: InputMaybe<SortOrder>;
  isPreview?: InputMaybe<SortOrder>;
  isSkippable?: InputMaybe<SortOrder>;
  isTeamAdk?: InputMaybe<SortOrder>;
  isVideoask?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  optional?: InputMaybe<SortOrder>;
  permissions?: InputMaybe<ActivitySchemaPermissionsOrderByCompositeAggregateInput>;
  position?: InputMaybe<SortOrder>;
  presetFields?: InputMaybe<ActivitySchemaPresetFieldsOrderByCompositeAggregateInput>;
  preview?: InputMaybe<SortOrder>;
  projectScope?: InputMaybe<SortOrder>;
  required?: InputMaybe<SortOrder>;
  setupRequired?: InputMaybe<SortOrder>;
  sourceActivitySchemaId?: InputMaybe<SortOrder>;
  status?: InputMaybe<SortOrder>;
  statusType?: InputMaybe<SortOrder>;
  styling?: InputMaybe<ActivitySchemaStylingOrderByInput>;
  timeToSolveProblem?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
  updatedBy?: InputMaybe<SortOrder>;
  usageCount?: InputMaybe<SortOrder>;
};

export type ActivitySchemaPermissions = {
  __typename?: 'ActivitySchemaPermissions';
  permissions_matrix?: Maybe<Array<Scalars['String']['output']>>;
  role?: Maybe<Scalars['String']['output']>;
  roles?: Maybe<Scalars['String']['output']>;
};

export type ActivitySchemaPermissionsCreateInput = {
  permissions_matrix?: InputMaybe<ActivitySchemaPermissionsCreatepermissions_MatrixInput>;
  role?: InputMaybe<Scalars['String']['input']>;
  roles?: InputMaybe<Scalars['String']['input']>;
};

export type ActivitySchemaPermissionsCreatepermissions_MatrixInput = {
  set: Array<Scalars['String']['input']>;
};

export type ActivitySchemaPermissionsObjectEqualityInput = {
  permissions_matrix?: InputMaybe<Array<Scalars['String']['input']>>;
  role?: InputMaybe<Scalars['String']['input']>;
  roles?: InputMaybe<Scalars['String']['input']>;
};

export type ActivitySchemaPermissionsOrderByCompositeAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type ActivitySchemaPresetFields = {
  __typename?: 'ActivitySchemaPresetFields';
  action?: Maybe<Scalars['String']['output']>;
  /** Multiple data types found: String: 33.3%, Int: 66.7% out of 6 sampled entries */
  defaultValue?: Maybe<Scalars['JSON']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  /** Multiple data types found: Array(String): 33.3%, Array(Int): 66.7% out of 6 sampled entries */
  items?: Maybe<Scalars['JSON']['output']>;
  model?: Maybe<Scalars['String']['output']>;
  modelItems?: Maybe<Array<ActivitySchemaFieldsModelItems>>;
  name?: Maybe<Scalars['String']['output']>;
  noSetup?: Maybe<Scalars['Boolean']['output']>;
  position?: Maybe<Scalars['Int']['output']>;
  preset?: Maybe<ActivitySchemaPresetFieldsPreset>;
  roles?: Maybe<Array<Scalars['String']['output']>>;
  /** Could not determine type: the field only had null or empty values in the sample set. */
  rules?: Maybe<Scalars['JSON']['output']>;
  /** Nested objects had no data in the sample dataset to introspect a nested type. */
  setup?: Maybe<Scalars['JSON']['output']>;
  styling?: Maybe<ActivitySchemaPresetFieldsStyling>;
  target?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
  /** Nested objects had no data in the sample dataset to introspect a nested type. */
  value?: Maybe<Scalars['JSON']['output']>;
  videoAskLabel?: Maybe<Scalars['String']['output']>;
  videoAskUrl?: Maybe<Scalars['String']['output']>;
};

export type ActivitySchemaPresetFieldsCreateInput = {
  action?: InputMaybe<Scalars['String']['input']>;
  defaultValue?: InputMaybe<Scalars['JSON']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  items?: InputMaybe<Scalars['JSON']['input']>;
  model?: InputMaybe<Scalars['String']['input']>;
  modelItems?: InputMaybe<Array<ActivitySchemaFieldsModelItemsCreateInput>>;
  name?: InputMaybe<Scalars['String']['input']>;
  noSetup?: InputMaybe<Scalars['Boolean']['input']>;
  position?: InputMaybe<Scalars['Int']['input']>;
  preset?: InputMaybe<ActivitySchemaPresetFieldsPresetCreateInput>;
  roles?: InputMaybe<ActivitySchemaPresetFieldsCreaterolesInput>;
  rules?: InputMaybe<Scalars['JSON']['input']>;
  setup?: InputMaybe<Scalars['JSON']['input']>;
  styling?: InputMaybe<ActivitySchemaPresetFieldsStylingCreateInput>;
  target?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  type: Scalars['String']['input'];
  value?: InputMaybe<Scalars['JSON']['input']>;
  videoAskLabel?: InputMaybe<Scalars['String']['input']>;
  videoAskUrl?: InputMaybe<Scalars['String']['input']>;
};

export type ActivitySchemaPresetFieldsCreaterolesInput = {
  set: Array<Scalars['String']['input']>;
};

export type ActivitySchemaPresetFieldsObjectEqualityInput = {
  action?: InputMaybe<Scalars['String']['input']>;
  defaultValue?: InputMaybe<Scalars['JSON']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  items?: InputMaybe<Scalars['JSON']['input']>;
  model?: InputMaybe<Scalars['String']['input']>;
  modelItems?: InputMaybe<Array<ActivitySchemaFieldsModelItemsObjectEqualityInput>>;
  name?: InputMaybe<Scalars['String']['input']>;
  noSetup?: InputMaybe<Scalars['Boolean']['input']>;
  position?: InputMaybe<Scalars['Int']['input']>;
  preset?: InputMaybe<ActivitySchemaPresetFieldsPresetObjectEqualityInput>;
  roles?: InputMaybe<Array<Scalars['String']['input']>>;
  rules?: InputMaybe<Scalars['JSON']['input']>;
  setup?: InputMaybe<Scalars['JSON']['input']>;
  styling?: InputMaybe<ActivitySchemaPresetFieldsStylingObjectEqualityInput>;
  target?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  type: Scalars['String']['input'];
  value?: InputMaybe<Scalars['JSON']['input']>;
  videoAskLabel?: InputMaybe<Scalars['String']['input']>;
  videoAskUrl?: InputMaybe<Scalars['String']['input']>;
};

export type ActivitySchemaPresetFieldsOrderByCompositeAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type ActivitySchemaPresetFieldsPreset = {
  __typename?: 'ActivitySchemaPresetFieldsPreset';
  maxCharacters?: Maybe<Scalars['String']['output']>;
  maxQuestions?: Maybe<Scalars['Int']['output']>;
  maxTeamMembers?: Maybe<Scalars['Int']['output']>;
  minLogs?: Maybe<Scalars['Int']['output']>;
  minimumHoursNow?: Maybe<Scalars['String']['output']>;
  requireFiles?: Maybe<Scalars['Boolean']['output']>;
  requireSlides?: Maybe<Scalars['Boolean']['output']>;
  requireVideo?: Maybe<Scalars['Boolean']['output']>;
  videoMaxLength?: Maybe<Scalars['Int']['output']>;
};

export type ActivitySchemaPresetFieldsPresetCreateInput = {
  maxCharacters?: InputMaybe<Scalars['String']['input']>;
  maxQuestions?: InputMaybe<Scalars['Int']['input']>;
  maxTeamMembers?: InputMaybe<Scalars['Int']['input']>;
  minLogs?: InputMaybe<Scalars['Int']['input']>;
  minimumHoursNow?: InputMaybe<Scalars['String']['input']>;
  requireFiles?: InputMaybe<Scalars['Boolean']['input']>;
  requireSlides?: InputMaybe<Scalars['Boolean']['input']>;
  requireVideo?: InputMaybe<Scalars['Boolean']['input']>;
  videoMaxLength?: InputMaybe<Scalars['Int']['input']>;
};

export type ActivitySchemaPresetFieldsPresetObjectEqualityInput = {
  maxCharacters?: InputMaybe<Scalars['String']['input']>;
  maxQuestions?: InputMaybe<Scalars['Int']['input']>;
  maxTeamMembers?: InputMaybe<Scalars['Int']['input']>;
  minLogs?: InputMaybe<Scalars['Int']['input']>;
  minimumHoursNow?: InputMaybe<Scalars['String']['input']>;
  requireFiles?: InputMaybe<Scalars['Boolean']['input']>;
  requireSlides?: InputMaybe<Scalars['Boolean']['input']>;
  requireVideo?: InputMaybe<Scalars['Boolean']['input']>;
  videoMaxLength?: InputMaybe<Scalars['Int']['input']>;
};

export type ActivitySchemaPresetFieldsStyling = {
  __typename?: 'ActivitySchemaPresetFieldsStyling';
  class?: Maybe<Scalars['String']['output']>;
  depressed?: Maybe<Scalars['Boolean']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  outlined?: Maybe<Scalars['Boolean']['output']>;
  placeholder?: Maybe<Scalars['String']['output']>;
  prependIcon?: Maybe<Scalars['String']['output']>;
  rounded?: Maybe<Scalars['Boolean']['output']>;
  wrapperClass?: Maybe<Scalars['String']['output']>;
  xLarge?: Maybe<Scalars['Boolean']['output']>;
};

export type ActivitySchemaPresetFieldsStylingCreateInput = {
  class?: InputMaybe<Scalars['String']['input']>;
  depressed?: InputMaybe<Scalars['Boolean']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  outlined?: InputMaybe<Scalars['Boolean']['input']>;
  placeholder?: InputMaybe<Scalars['String']['input']>;
  prependIcon?: InputMaybe<Scalars['String']['input']>;
  rounded?: InputMaybe<Scalars['Boolean']['input']>;
  wrapperClass?: InputMaybe<Scalars['String']['input']>;
  xLarge?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ActivitySchemaPresetFieldsStylingObjectEqualityInput = {
  class?: InputMaybe<Scalars['String']['input']>;
  depressed?: InputMaybe<Scalars['Boolean']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  outlined?: InputMaybe<Scalars['Boolean']['input']>;
  placeholder?: InputMaybe<Scalars['String']['input']>;
  prependIcon?: InputMaybe<Scalars['String']['input']>;
  rounded?: InputMaybe<Scalars['Boolean']['input']>;
  wrapperClass?: InputMaybe<Scalars['String']['input']>;
  xLarge?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ActivitySchemaStyling = {
  __typename?: 'ActivitySchemaStyling';
  borderColor: Scalars['String']['output'];
};

export type ActivitySchemaStylingCreateInput = {
  borderColor: Scalars['String']['input'];
};

export type ActivitySchemaStylingNullableCompositeFilter = {
  equals?: InputMaybe<ActivitySchemaStylingObjectEqualityInput>;
  is?: InputMaybe<ActivitySchemaStylingWhereInput>;
  isNot?: InputMaybe<ActivitySchemaStylingWhereInput>;
  isSet?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ActivitySchemaStylingNullableCreateEnvelopeInput = {
  set?: InputMaybe<ActivitySchemaStylingCreateInput>;
};

export type ActivitySchemaStylingNullableUpdateEnvelopeInput = {
  set?: InputMaybe<ActivitySchemaStylingCreateInput>;
  unset?: InputMaybe<Scalars['Boolean']['input']>;
  upsert?: InputMaybe<ActivitySchemaStylingUpsertInput>;
};

export type ActivitySchemaStylingObjectEqualityInput = {
  borderColor: Scalars['String']['input'];
};

export type ActivitySchemaStylingOrderByInput = {
  borderColor?: InputMaybe<SortOrder>;
};

export type ActivitySchemaStylingUpdateInput = {
  borderColor?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type ActivitySchemaStylingUpsertInput = {
  set: ActivitySchemaStylingCreateInput;
  update: ActivitySchemaStylingUpdateInput;
};

export type ActivitySchemaStylingWhereInput = {
  AND?: InputMaybe<Array<ActivitySchemaStylingWhereInput>>;
  NOT?: InputMaybe<Array<ActivitySchemaStylingWhereInput>>;
  OR?: InputMaybe<Array<ActivitySchemaStylingWhereInput>>;
  borderColor?: InputMaybe<StringFilter>;
};

export type ActivitySchemaSumAggregate = {
  __typename?: 'ActivitySchemaSumAggregate';
  position?: Maybe<Scalars['Int']['output']>;
  timeToSolveProblem?: Maybe<Scalars['Int']['output']>;
  usageCount?: Maybe<Scalars['Int']['output']>;
};

export type ActivitySchemaUpdateInput = {
  JSONSchema?: InputMaybe<Scalars['JSON']['input']>;
  activityImage?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  buildScope?: InputMaybe<ActivitySchemaBuildScopeNullableUpdateEnvelopeInput>;
  builderType?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  category?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  completed?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  description?: InputMaybe<StringFieldUpdateOperationsInput>;
  discordEntityType?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  employerWebsite?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  fields?: InputMaybe<Array<ActivitySchemaFieldsCreateInput>>;
  icon?: InputMaybe<StringFieldUpdateOperationsInput>;
  instruction?: InputMaybe<ActivitySchemaInstructionNullableUpdateEnvelopeInput>;
  interviewReqeust?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  introVideo?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  isPreview?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isSkippable?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isTeamAdk?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isVideoask?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  optional?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  permissions?: InputMaybe<Array<ActivitySchemaPermissionsCreateInput>>;
  position?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  presetFields?: InputMaybe<Array<ActivitySchemaPresetFieldsCreateInput>>;
  preview?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  projectScope?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  required?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  setupRequired?: InputMaybe<BoolFieldUpdateOperationsInput>;
  sourceActivitySchemaId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  status?: InputMaybe<BoolFieldUpdateOperationsInput>;
  statusType?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  styling?: InputMaybe<ActivitySchemaStylingNullableUpdateEnvelopeInput>;
  timeToSolveProblem?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  updatedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  usageCount?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
};

export type ActivitySchemaWhereInput = {
  AND?: InputMaybe<Array<ActivitySchemaWhereInput>>;
  JSONSchema?: InputMaybe<JsonNullableFilter>;
  NOT?: InputMaybe<Array<ActivitySchemaWhereInput>>;
  OR?: InputMaybe<Array<ActivitySchemaWhereInput>>;
  activityImage?: InputMaybe<StringNullableFilter>;
  buildScope?: InputMaybe<ActivitySchemaBuildScopeNullableCompositeFilter>;
  builderType?: InputMaybe<StringNullableFilter>;
  category?: InputMaybe<StringNullableFilter>;
  completed?: InputMaybe<BoolNullableFilter>;
  createdAt?: InputMaybe<DateTimeNullableFilter>;
  createdBy?: InputMaybe<StringNullableFilter>;
  description?: InputMaybe<StringFilter>;
  discordEntityType?: InputMaybe<StringNullableFilter>;
  employerWebsite?: InputMaybe<StringNullableFilter>;
  fields?: InputMaybe<Array<ActivitySchemaFieldsObjectEqualityInput>>;
  icon?: InputMaybe<StringFilter>;
  id?: InputMaybe<StringFilter>;
  instruction?: InputMaybe<ActivitySchemaInstructionNullableCompositeFilter>;
  interviewReqeust?: InputMaybe<StringNullableFilter>;
  introVideo?: InputMaybe<StringNullableFilter>;
  isPreview?: InputMaybe<BoolNullableFilter>;
  isSkippable?: InputMaybe<BoolNullableFilter>;
  isTeamAdk?: InputMaybe<BoolNullableFilter>;
  isVideoask?: InputMaybe<BoolNullableFilter>;
  name?: InputMaybe<StringFilter>;
  optional?: InputMaybe<BoolNullableFilter>;
  permissions?: InputMaybe<Array<ActivitySchemaPermissionsObjectEqualityInput>>;
  position?: InputMaybe<IntNullableFilter>;
  presetFields?: InputMaybe<Array<ActivitySchemaPresetFieldsObjectEqualityInput>>;
  preview?: InputMaybe<BoolNullableFilter>;
  projectScope?: InputMaybe<StringNullableFilter>;
  required?: InputMaybe<BoolNullableFilter>;
  setupRequired?: InputMaybe<BoolFilter>;
  sourceActivitySchemaId?: InputMaybe<StringNullableFilter>;
  status?: InputMaybe<BoolFilter>;
  statusType?: InputMaybe<StringNullableFilter>;
  styling?: InputMaybe<ActivitySchemaStylingNullableCompositeFilter>;
  timeToSolveProblem?: InputMaybe<IntNullableFilter>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
  updatedBy?: InputMaybe<StringNullableFilter>;
  usageCount?: InputMaybe<IntNullableFilter>;
};

export type ActivitySchemaWhereUniqueInput = {
  AND?: InputMaybe<Array<ActivitySchemaWhereInput>>;
  JSONSchema?: InputMaybe<JsonNullableFilter>;
  NOT?: InputMaybe<Array<ActivitySchemaWhereInput>>;
  OR?: InputMaybe<Array<ActivitySchemaWhereInput>>;
  activityImage?: InputMaybe<StringNullableFilter>;
  buildScope?: InputMaybe<ActivitySchemaBuildScopeNullableCompositeFilter>;
  builderType?: InputMaybe<StringNullableFilter>;
  category?: InputMaybe<StringNullableFilter>;
  completed?: InputMaybe<BoolNullableFilter>;
  createdAt?: InputMaybe<DateTimeNullableFilter>;
  createdBy?: InputMaybe<StringNullableFilter>;
  description?: InputMaybe<StringFilter>;
  discordEntityType?: InputMaybe<StringNullableFilter>;
  employerWebsite?: InputMaybe<StringNullableFilter>;
  fields?: InputMaybe<Array<ActivitySchemaFieldsObjectEqualityInput>>;
  icon?: InputMaybe<StringFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  instruction?: InputMaybe<ActivitySchemaInstructionNullableCompositeFilter>;
  interviewReqeust?: InputMaybe<StringNullableFilter>;
  introVideo?: InputMaybe<StringNullableFilter>;
  isPreview?: InputMaybe<BoolNullableFilter>;
  isSkippable?: InputMaybe<BoolNullableFilter>;
  isTeamAdk?: InputMaybe<BoolNullableFilter>;
  isVideoask?: InputMaybe<BoolNullableFilter>;
  name?: InputMaybe<StringFilter>;
  optional?: InputMaybe<BoolNullableFilter>;
  permissions?: InputMaybe<Array<ActivitySchemaPermissionsObjectEqualityInput>>;
  position?: InputMaybe<IntNullableFilter>;
  presetFields?: InputMaybe<Array<ActivitySchemaPresetFieldsObjectEqualityInput>>;
  preview?: InputMaybe<BoolNullableFilter>;
  projectScope?: InputMaybe<StringNullableFilter>;
  required?: InputMaybe<BoolNullableFilter>;
  setupRequired?: InputMaybe<BoolFilter>;
  sourceActivitySchemaId?: InputMaybe<StringNullableFilter>;
  status?: InputMaybe<BoolFilter>;
  statusType?: InputMaybe<StringNullableFilter>;
  styling?: InputMaybe<ActivitySchemaStylingNullableCompositeFilter>;
  timeToSolveProblem?: InputMaybe<IntNullableFilter>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
  updatedBy?: InputMaybe<StringNullableFilter>;
  usageCount?: InputMaybe<IntNullableFilter>;
};

export type ActivityStats = {
  __typename?: 'ActivityStats';
  /** Average duration in days (from start to completion) */
  avgDurationDays?: Maybe<Scalars['Float']['output']>;
  /** Average time taken in seconds */
  avgTimeTaken: Scalars['Float']['output'];
  /** Number of records with valid duration data */
  durationCount: Scalars['Int']['output'];
  /** Program ID or Schema ID (for drill-down) */
  groupId?: Maybe<Scalars['String']['output']>;
  /** Activity name, program name, or schema name */
  groupKey: Scalars['String']['output'];
  /** Maximum duration in days */
  maxDurationDays?: Maybe<Scalars['Float']['output']>;
  /** Maximum time taken in seconds */
  maxTimeTaken: Scalars['Float']['output'];
  /** Median duration in days */
  medianDurationDays?: Maybe<Scalars['Float']['output']>;
  /** Median time taken in seconds */
  medianTimeTaken: Scalars['Float']['output'];
  /** Minimum duration in days */
  minDurationDays?: Maybe<Scalars['Float']['output']>;
  /** Minimum time taken in seconds */
  minTimeTaken: Scalars['Float']['output'];
  /** 25th percentile of time taken in seconds */
  p25TimeTaken: Scalars['Float']['output'];
  /** 75th percentile of time taken in seconds */
  p75TimeTaken: Scalars['Float']['output'];
  /** 95th percentile of time taken in seconds */
  p95TimeTaken: Scalars['Float']['output'];
  /** Number of completions in this group */
  sampleSize: Scalars['Int']['output'];
  /** Standard deviation of time taken */
  stdDevTimeTaken: Scalars['Float']['output'];
};

export type ActivityWriteLogAvgAggregate = {
  __typename?: 'ActivityWriteLogAvgAggregate';
  activityIndex?: Maybe<Scalars['Float']['output']>;
  aiConfidence?: Maybe<Scalars['Float']['output']>;
};

export type ActivityWriteLogCountAggregate = {
  __typename?: 'ActivityWriteLogCountAggregate';
  _all: Scalars['Int']['output'];
  activityIndex: Scalars['Int']['output'];
  activityName: Scalars['Int']['output'];
  aiConfidence: Scalars['Int']['output'];
  aiIntent: Scalars['Int']['output'];
  confidenceTier: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  draftSaved: Scalars['Int']['output'];
  fieldPath: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  inboundMessageId: Scalars['Int']['output'];
  newValue: Scalars['Int']['output'];
  outcomeCompletedActivity: Scalars['Int']['output'];
  outcomeEngagedAfter: Scalars['Int']['output'];
  outcomeMeasuredAt: Scalars['Int']['output'];
  outcomeParticipantReplied: Scalars['Int']['output'];
  outcomeTracked: Scalars['Int']['output'];
  previousValue: Scalars['Int']['output'];
  programId: Scalars['Int']['output'];
  programTeamId: Scalars['Int']['output'];
  source: Scalars['Int']['output'];
  studentId: Scalars['Int']['output'];
  targetType: Scalars['Int']['output'];
  threadId: Scalars['Int']['output'];
  updatedAt: Scalars['Int']['output'];
  writtenAt: Scalars['Int']['output'];
};

export type ActivityWriteLogMaxAggregate = {
  __typename?: 'ActivityWriteLogMaxAggregate';
  activityIndex?: Maybe<Scalars['Int']['output']>;
  activityName?: Maybe<Scalars['String']['output']>;
  aiConfidence?: Maybe<Scalars['Float']['output']>;
  aiIntent?: Maybe<Scalars['String']['output']>;
  confidenceTier?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  draftSaved?: Maybe<Scalars['Boolean']['output']>;
  fieldPath?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  inboundMessageId?: Maybe<Scalars['String']['output']>;
  outcomeCompletedActivity?: Maybe<Scalars['Boolean']['output']>;
  outcomeEngagedAfter?: Maybe<Scalars['Boolean']['output']>;
  outcomeMeasuredAt?: Maybe<Scalars['DateTime']['output']>;
  outcomeParticipantReplied?: Maybe<Scalars['Boolean']['output']>;
  outcomeTracked?: Maybe<Scalars['Boolean']['output']>;
  programId?: Maybe<Scalars['String']['output']>;
  programTeamId?: Maybe<Scalars['String']['output']>;
  source?: Maybe<Scalars['String']['output']>;
  studentId?: Maybe<Scalars['String']['output']>;
  targetType?: Maybe<Scalars['String']['output']>;
  threadId?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  writtenAt?: Maybe<Scalars['DateTime']['output']>;
};

export type ActivityWriteLogMinAggregate = {
  __typename?: 'ActivityWriteLogMinAggregate';
  activityIndex?: Maybe<Scalars['Int']['output']>;
  activityName?: Maybe<Scalars['String']['output']>;
  aiConfidence?: Maybe<Scalars['Float']['output']>;
  aiIntent?: Maybe<Scalars['String']['output']>;
  confidenceTier?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  draftSaved?: Maybe<Scalars['Boolean']['output']>;
  fieldPath?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  inboundMessageId?: Maybe<Scalars['String']['output']>;
  outcomeCompletedActivity?: Maybe<Scalars['Boolean']['output']>;
  outcomeEngagedAfter?: Maybe<Scalars['Boolean']['output']>;
  outcomeMeasuredAt?: Maybe<Scalars['DateTime']['output']>;
  outcomeParticipantReplied?: Maybe<Scalars['Boolean']['output']>;
  outcomeTracked?: Maybe<Scalars['Boolean']['output']>;
  programId?: Maybe<Scalars['String']['output']>;
  programTeamId?: Maybe<Scalars['String']['output']>;
  source?: Maybe<Scalars['String']['output']>;
  studentId?: Maybe<Scalars['String']['output']>;
  targetType?: Maybe<Scalars['String']['output']>;
  threadId?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  writtenAt?: Maybe<Scalars['DateTime']['output']>;
};

export type ActivityWriteLogSumAggregate = {
  __typename?: 'ActivityWriteLogSumAggregate';
  activityIndex?: Maybe<Scalars['Int']['output']>;
  aiConfidence?: Maybe<Scalars['Float']['output']>;
};

export type AddFamilyMemberInput = {
  bio?: InputMaybe<Scalars['String']['input']>;
  birthDate?: InputMaybe<Scalars['String']['input']>;
  deathDate?: InputMaybe<Scalars['String']['input']>;
  familyId: Scalars['ID']['input'];
  generationName?: InputMaybe<Scalars['String']['input']>;
  hometown?: InputMaybe<Scalars['String']['input']>;
  hometownPlaceId?: InputMaybe<Scalars['ID']['input']>;
  isAdopted?: InputMaybe<Scalars['Boolean']['input']>;
  isDeceased?: InputMaybe<Scalars['Boolean']['input']>;
  maternalPaternalLine?: InputMaybe<Scalars['String']['input']>;
  nameEn?: InputMaybe<Scalars['String']['input']>;
  nameZh?: InputMaybe<Scalars['String']['input']>;
  nickname?: InputMaybe<Scalars['String']['input']>;
};

export type AddIdentityToExistingAccountInput = {
  /** The new identity type (email or phone) */
  identityType: Scalars['String']['input'];
  /** The value of the identity (email address or phone number) */
  identityValue: Scalars['String']['input'];
  /** OTP code for verification if required */
  otpCode?: InputMaybe<Scalars['String']['input']>;
  /** The existing account ID to add the identity to */
  targetAccountId: Scalars['String']['input'];
};

export type AddOrganizationDomainAfterVerificationInput = {
  /** The domain to add (e.g., "example.com") */
  domain: Scalars['String']['input'];
  /** The Organization ID */
  organizationId: Scalars['String']['input'];
  /** The email address used to verify domain ownership */
  verifierEmail: Scalars['String']['input'];
};

export type AddPasswordToAccountInput = {
  /** Email address of the account to add password authentication */
  email: Scalars['String']['input'];
  /** New password to add to the account */
  password: Scalars['String']['input'];
};

export type AddPasswordToAccountResponse = {
  __typename?: 'AddPasswordToAccountResponse';
  /** Updated list of user identities after password addition */
  identities: Array<UserIdentity>;
  /** Success or error message */
  message: Scalars['String']['output'];
  /** Whether the password was successfully added */
  success: Scalars['Boolean']['output'];
};

/** Address information for Stripe Connect account */
export type AddressInput = {
  /** City */
  city: Scalars['String']['input'];
  /** Country code */
  country: Scalars['String']['input'];
  /** Street address line 1 */
  line1: Scalars['String']['input'];
  /** Street address line 2 */
  line2?: InputMaybe<Scalars['String']['input']>;
  /** Postal code / ZIP code */
  postalCode: Scalars['String']['input'];
  /** State / Province */
  state: Scalars['String']['input'];
};

export type AdminUpdateOrganizationLogoInput = {
  /** The new logo URL */
  logoUrl: Scalars['String']['input'];
  /** The Organization ID to update */
  organizationId: Scalars['String']['input'];
};

export type AirtableOrganization = {
  __typename?: 'AirtableOrganization';
  _id?: Maybe<Scalars['String']['output']>;
  domain: Scalars['String']['output'];
  domains: Array<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  members: Scalars['Int']['output'];
  organizationJoinLink: Scalars['String']['output'];
  participants: Scalars['Int']['output'];
  programs: Scalars['Int']['output'];
  title: Scalars['String']['output'];
  users: Scalars['Int']['output'];
};

export type AirtableProgram = {
  __typename?: 'AirtableProgram';
  domains: Scalars['String']['output'];
  id: Scalars['String']['output'];
  participants: Scalars['String']['output'];
  programDesc: Scalars['String']['output'];
  programName: Scalars['String']['output'];
};

export type AirtableSavedScope = {
  __typename?: 'AirtableSavedScope';
  deviceInfo?: Maybe<DeviceInfo>;
  email?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  roadmap?: Maybe<Roadmap>;
  savedAt: Scalars['String']['output'];
  savedInputs: Scalars['String']['output'];
  scopesList: Scalars['String']['output'];
  scopesPerEmployer: Scalars['Int']['output'];
  selectedScopes: Scalars['String']['output'];
  userId: Scalars['String']['output'];
};

export type AirtableSavedScopeInput = {
  deviceInfo?: InputMaybe<DeviceInfoInput>;
  email?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  roadmap?: InputMaybe<Scalars['String']['input']>;
  savedAt: Scalars['String']['input'];
  savedInputs: Scalars['String']['input'];
  scopesList: Scalars['String']['input'];
  scopesPerEmployer: Scalars['Int']['input'];
  selectedScopes: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};

export type ApiTokenCountAggregate = {
  __typename?: 'ApiTokenCountAggregate';
  _all: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  expiresAt: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  lastUsedAt: Scalars['Int']['output'];
  name: Scalars['Int']['output'];
  scopes: Scalars['Int']['output'];
  tokenHash: Scalars['Int']['output'];
  tokenLookup: Scalars['Int']['output'];
  userId: Scalars['Int']['output'];
};

export type ApiTokenMaxAggregate = {
  __typename?: 'ApiTokenMaxAggregate';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  expiresAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  lastUsedAt?: Maybe<Scalars['DateTime']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  tokenHash?: Maybe<Scalars['String']['output']>;
  tokenLookup?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
};

export type ApiTokenMinAggregate = {
  __typename?: 'ApiTokenMinAggregate';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  expiresAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  lastUsedAt?: Maybe<Scalars['DateTime']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  tokenHash?: Maybe<Scalars['String']['output']>;
  tokenLookup?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
};

export type AuditAuthMethodDetails = {
  __typename?: 'AuditAuthMethodDetails';
  availableMethods?: Maybe<Array<Scalars['String']['output']>>;
  email: Scalars['String']['output'];
  hasEmailOtp: Scalars['Boolean']['output'];
  hasPasswordAuth: Scalars['Boolean']['output'];
  hasPhoneOtp: Scalars['Boolean']['output'];
};

export type AuditLinkingDetails = {
  __typename?: 'AuditLinkingDetails';
  connectionType: Scalars['String']['output'];
  linkingMethod?: Maybe<Scalars['String']['output']>;
  primaryUserId: Scalars['String']['output'];
  provider: Scalars['String']['output'];
  secondaryUserId: Scalars['String']['output'];
};

export type AuditLogCountAggregate = {
  __typename?: 'AuditLogCountAggregate';
  _all: Scalars['Int']['output'];
  auth0UserId: Scalars['Int']['output'];
  errorMessage: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  ipAddress: Scalars['Int']['output'];
  operationType: Scalars['Int']['output'];
  success: Scalars['Int']['output'];
  timestamp: Scalars['Int']['output'];
  userAgent: Scalars['Int']['output'];
  userId: Scalars['Int']['output'];
};

export type AuditLogMaxAggregate = {
  __typename?: 'AuditLogMaxAggregate';
  auth0UserId?: Maybe<Scalars['String']['output']>;
  errorMessage?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  ipAddress?: Maybe<Scalars['String']['output']>;
  operationType?: Maybe<AuditOperationType>;
  success?: Maybe<Scalars['Boolean']['output']>;
  timestamp?: Maybe<Scalars['DateTime']['output']>;
  userAgent?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
};

export type AuditLogMinAggregate = {
  __typename?: 'AuditLogMinAggregate';
  auth0UserId?: Maybe<Scalars['String']['output']>;
  errorMessage?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  ipAddress?: Maybe<Scalars['String']['output']>;
  operationType?: Maybe<AuditOperationType>;
  success?: Maybe<Scalars['Boolean']['output']>;
  timestamp?: Maybe<Scalars['DateTime']['output']>;
  userAgent?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
};

export type AuditOperationData = {
  __typename?: 'AuditOperationData';
  authMethodDetails?: Maybe<AuditAuthMethodDetails>;
  linkingDetails?: Maybe<AuditLinkingDetails>;
  passwordDetails?: Maybe<AuditPasswordDetails>;
  syncDetails?: Maybe<AuditSyncDetails>;
  validationDetails?: Maybe<AuditValidationDetails>;
};

export enum AuditOperationType {
  AuthMethodCheck = 'AUTH_METHOD_CHECK',
  IdentityLink = 'IDENTITY_LINK',
  IdentitySync = 'IDENTITY_SYNC',
  IdentityUnlink = 'IDENTITY_UNLINK',
  IdentityValidation = 'IDENTITY_VALIDATION',
  PasswordAddition = 'PASSWORD_ADDITION'
}

export type AuditPasswordDetails = {
  __typename?: 'AuditPasswordDetails';
  accountExists: Scalars['Boolean']['output'];
  connectionType?: Maybe<Scalars['String']['output']>;
  email: Scalars['String']['output'];
  identityCreated: Scalars['Boolean']['output'];
};

export type AuditSyncDetails = {
  __typename?: 'AuditSyncDetails';
  auth0Source?: Maybe<Scalars['String']['output']>;
  identitiesAfter?: Maybe<Scalars['JSON']['output']>;
  identitiesBefore?: Maybe<Scalars['JSON']['output']>;
  identitiesCount: Scalars['Int']['output'];
  retryAttempts?: Maybe<Scalars['Int']['output']>;
};

export type AuditValidationDetails = {
  __typename?: 'AuditValidationDetails';
  duplicatesRemoved?: Maybe<Scalars['Int']['output']>;
  identitiesValidated: Scalars['Int']['output'];
  validationErrors?: Maybe<Array<Scalars['String']['output']>>;
};

export type Auth0CallbackInput = {
  /** Authorization code returned from Auth0 */
  authorizationCode: Scalars['String']['input'];
  /** Redirect URI used for the Auth0 authentication flow */
  redirectUri: Scalars['String']['input'];
  /** User intent for the authentication (e.g., signin, signup, link) */
  userIntent?: InputMaybe<Scalars['String']['input']>;
};

export type Auth0UsersCountAggregate = {
  __typename?: 'Auth0UsersCountAggregate';
  _all: Scalars['Int']['output'];
  created: Scalars['Int']['output'];
  email: Scalars['Int']['output'];
  firstName: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  lastName: Scalars['Int']['output'];
  phoneNumber: Scalars['Int']['output'];
  processed: Scalars['Int']['output'];
  userId: Scalars['Int']['output'];
};

export type Auth0UsersMaxAggregate = {
  __typename?: 'Auth0UsersMaxAggregate';
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  processed?: Maybe<Scalars['Boolean']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
};

export type Auth0UsersMinAggregate = {
  __typename?: 'Auth0UsersMinAggregate';
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  processed?: Maybe<Scalars['Boolean']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
};

export type AuthResponse = {
  __typename?: 'AuthResponse';
  /** JWT access token for API authentication */
  accessToken: Scalars['String']['output'];
  /** Access token expiry time in seconds */
  expiresIn?: Maybe<Scalars['Float']['output']>;
  /** OIDC ID token */
  idToken?: Maybe<Scalars['String']['output']>;
  /** Human-readable status message or error details */
  message?: Maybe<Scalars['String']['output']>;
  /** Indicates if OTP was sent (for OTP initiation flow) */
  otpSent?: Maybe<Scalars['Boolean']['output']>;
  /** Refresh token for obtaining new access tokens */
  refreshToken?: Maybe<Scalars['String']['output']>;
  /** Indicates if the authentication operation was successful */
  success?: Maybe<Scalars['Boolean']['output']>;
  /** Authenticated user information */
  user: AuthUserOutput;
};

export type AuthUserOutput = {
  __typename?: 'AuthUserOutput';
  /** User's email address */
  email?: Maybe<Scalars['String']['output']>;
  /** Whether the user's email has been verified */
  emailVerified?: Maybe<Scalars['Boolean']['output']>;
  /** User's first name */
  firstName?: Maybe<Scalars['String']['output']>;
  /** User's full name (concatenated first and last name) */
  fullName?: Maybe<Scalars['String']['output']>;
  /** Unique database identifier for the user */
  id: Scalars['ID']['output'];
  /** User's last name */
  lastName?: Maybe<Scalars['String']['output']>;
  /** User's phone number in E.164 format */
  phoneNumber?: Maybe<Scalars['String']['output']>;
  /** Whether the user's phone number has been verified */
  phoneVerified?: Maybe<Scalars['Boolean']['output']>;
  /** URL to user's profile image */
  profileImg?: Maybe<Scalars['String']['output']>;
  /** Auth0 user identifier (sub claim) */
  userId?: Maybe<Scalars['String']['output']>;
  /** Array of user roles/types (e.g., student, teacher, admin) */
  userTypes?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Overall verification status (email or phone verified) */
  verified?: Maybe<Scalars['Boolean']['output']>;
};

export type AuthUserProfile = {
  __typename?: 'AuthUserProfile';
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  fullName?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  profileImg?: Maybe<Scalars['String']['output']>;
};

export type AuthUserRecord = {
  __typename?: 'AuthUserRecord';
  badges?: Maybe<Array<Maybe<UserBadges>>>;
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  fullName?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  portfolioPublic?: Maybe<Scalars['Boolean']['output']>;
  profile?: Maybe<ProfileImage>;
  profileImg?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
};

export type AutoPilot = {
  __typename?: 'AutoPilot';
  channels: AutoPilotChannels;
  contextCapabilities?: Maybe<ContextCapabilities>;
  conversationSettings?: Maybe<ConversationSettings>;
  createdAt: Scalars['DateTime']['output'];
  deprecated?: Maybe<Scalars['Boolean']['output']>;
  deprecatedAt?: Maybe<Scalars['DateTime']['output']>;
  enabledBy: Scalars['String']['output'];
  enabledByRole: Scalars['String']['output'];
  escalationConfig?: Maybe<EscalationConfig>;
  id: Scalars['ID']['output'];
  onboardingConfig?: Maybe<OnboardingConfig>;
  participantOverrides?: Maybe<ParticipantOverrides>;
  programId?: Maybe<Scalars['String']['output']>;
  programName?: Maybe<Scalars['String']['output']>;
  scope: AutoPilotScope;
  settings: AutoPilotSettings;
  status: Scalars['String']['output'];
  triggerThresholds: AutoPilotTriggerThresholds;
  updatedAt: Scalars['DateTime']['output'];
  viewPreferences?: Maybe<AutoPilotViewPreferences>;
  writeBackConfig?: Maybe<WriteBackConfig>;
};

/** Individual channel configuration */
export type AutoPilotChannelConfig = {
  __typename?: 'AutoPilotChannelConfig';
  enabled: Scalars['Boolean']['output'];
  managerPreference: Scalars['Boolean']['output'];
};

/** Channel preferences for SMS and email */
export type AutoPilotChannels = {
  __typename?: 'AutoPilotChannels';
  email: AutoPilotChannelConfig;
  sms: AutoPilotChannelConfig;
};

export type AutoPilotCountAggregate = {
  __typename?: 'AutoPilotCountAggregate';
  _all: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  deprecated: Scalars['Int']['output'];
  deprecatedAt: Scalars['Int']['output'];
  enabledBy: Scalars['Int']['output'];
  enabledByRole: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  programId: Scalars['Int']['output'];
  programName: Scalars['Int']['output'];
  status: Scalars['Int']['output'];
  updatedAt: Scalars['Int']['output'];
};

/** Deadline nudge thresholds for time-based triggers */
export type AutoPilotDeadlineThresholds = {
  __typename?: 'AutoPilotDeadlineThresholds';
  enabled?: Maybe<Scalars['Boolean']['output']>;
  hoursBeforeDeadline?: Maybe<Array<Scalars['Int']['output']>>;
  nudgeOnOverdue?: Maybe<Scalars['Boolean']['output']>;
};

export type AutoPilotMaxAggregate = {
  __typename?: 'AutoPilotMaxAggregate';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  deprecated?: Maybe<Scalars['Boolean']['output']>;
  deprecatedAt?: Maybe<Scalars['DateTime']['output']>;
  enabledBy?: Maybe<Scalars['String']['output']>;
  enabledByRole?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  programId?: Maybe<Scalars['String']['output']>;
  programName?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type AutoPilotMinAggregate = {
  __typename?: 'AutoPilotMinAggregate';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  deprecated?: Maybe<Scalars['Boolean']['output']>;
  deprecatedAt?: Maybe<Scalars['DateTime']['output']>;
  enabledBy?: Maybe<Scalars['String']['output']>;
  enabledByRole?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  programId?: Maybe<Scalars['String']['output']>;
  programName?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

/** Auto-pilot scope definition */
export type AutoPilotScope = {
  __typename?: 'AutoPilotScope';
  customDateEnd?: Maybe<Scalars['String']['output']>;
  customDateStart?: Maybe<Scalars['String']['output']>;
  dateRange?: Maybe<Scalars['String']['output']>;
  programIds?: Maybe<Array<Scalars['String']['output']>>;
  schoolYear?: Maybe<Scalars['String']['output']>;
  studentIds?: Maybe<Array<Scalars['String']['output']>>;
  type: Scalars['String']['output'];
};

/** Operating mode settings */
export type AutoPilotSettings = {
  __typename?: 'AutoPilotSettings';
  mode: Scalars['String']['output'];
};

/** Trigger thresholds for when to send messages */
export type AutoPilotTriggerThresholds = {
  __typename?: 'AutoPilotTriggerThresholds';
  deadlineThresholds?: Maybe<AutoPilotDeadlineThresholds>;
  maxRiskScore?: Maybe<Scalars['Int']['output']>;
  minPotentialScore?: Maybe<Scalars['Int']['output']>;
  minRiskScore?: Maybe<Scalars['Int']['output']>;
  quadrants?: Maybe<Array<Scalars['String']['output']>>;
  recommendations?: Maybe<Array<Scalars['String']['output']>>;
};

/** View preferences for Monitor display */
export type AutoPilotViewPreferences = {
  __typename?: 'AutoPilotViewPreferences';
  groupBy: Scalars['String']['output'];
  showOnlineOnly: Scalars['Boolean']['output'];
  sortBy: Scalars['String']['output'];
};

/** Bank account information (lazy loaded from Stripe API) */
export type BankAccount = {
  __typename?: 'BankAccount';
  /** Account holder name */
  accountHolderName: Scalars['String']['output'];
  /** Account holder type (individual or company) */
  accountHolderType: Scalars['String']['output'];
  /** Bank name */
  bankName: Scalars['String']['output'];
  /** Country code */
  country: Scalars['String']['output'];
  /** Currency code */
  currency: Scalars['String']['output'];
  /** Whether this is the default payout account */
  defaultForCurrency: Scalars['Boolean']['output'];
  /** Fingerprint for duplicate detection */
  fingerprint?: Maybe<Scalars['String']['output']>;
  /** Stripe bank account ID */
  id: Scalars['String']['output'];
  /** Last 4 digits of account number */
  last4: Scalars['String']['output'];
  /** Last 4 digits of routing number */
  routingNumber: Scalars['String']['output'];
  /** Account status (new, validated, verified, errored) */
  status: Scalars['String']['output'];
};

/** Response from bank account verification via microdeposits */
export type BankAccountVerificationResponse = {
  __typename?: 'BankAccountVerificationResponse';
  /** Updated bank account details */
  bankAccount: BankAccount;
  /** Error message if verification failed */
  error?: Maybe<Scalars['String']['output']>;
  /** Bank account ID */
  id: Scalars['String']['output'];
  /** Verification status */
  status: Scalars['String']['output'];
  /** Whether verification was successful */
  verified: Scalars['Boolean']['output'];
};

/** Input for testing batch profile fetching */
export type BatchProfileTestInput = {
  /** Array of user IDs to fetch */
  userIds: Array<Scalars['ID']['input']>;
};

/** Result of batch profile fetch performance test */
export type BatchProfileTestResult = {
  __typename?: 'BatchProfileTestResult';
  /** Number of cache hits in this batch */
  cacheHits: Scalars['Float']['output'];
  /** Number of cache misses in this batch */
  cacheMisses: Scalars['Float']['output'];
  /** Number of profiles successfully fetched */
  profilesFetched: Scalars['Float']['output'];
  /** Response time in milliseconds */
  responseTime: Scalars['Float']['output'];
  /** Whether profiles were already cached */
  wasCached: Scalars['Boolean']['output'];
};

export type BehavioralAnalyticsAvgAggregate = {
  __typename?: 'BehavioralAnalyticsAvgAggregate';
  currentMomentum?: Maybe<Scalars['Float']['output']>;
  dataPointCount?: Maybe<Scalars['Float']['output']>;
  driftRiskScore?: Maybe<Scalars['Float']['output']>;
  repairAttempts?: Maybe<Scalars['Float']['output']>;
  thresholdMultiplier?: Maybe<Scalars['Float']['output']>;
  urgencyCalibration?: Maybe<Scalars['Float']['output']>;
};

export type BehavioralAnalyticsCountAggregate = {
  __typename?: 'BehavioralAnalyticsCountAggregate';
  _all: Scalars['Int']['output'];
  breakthroughs: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  currentMomentum: Scalars['Int']['output'];
  dataPointCount: Scalars['Int']['output'];
  dormantSince: Scalars['Int']['output'];
  driftRiskScore: Scalars['Int']['output'];
  email: Scalars['Int']['output'];
  engagementHeatmap: Scalars['Int']['output'];
  firstName: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  lastDriftAlert: Scalars['Int']['output'];
  lastName: Scalars['Int']['output'];
  lastOutreachAt: Scalars['Int']['output'];
  lastRepairAttemptAt: Scalars['Int']['output'];
  lastUpdated: Scalars['Int']['output'];
  momentumPattern: Scalars['Int']['output'];
  momentumType: Scalars['Int']['output'];
  nextRecommendedOutreach: Scalars['Int']['output'];
  optimalContactWindow: Scalars['Int']['output'];
  participantId: Scalars['Int']['output'];
  phoneNumber: Scalars['Int']['output'];
  programId: Scalars['Int']['output'];
  programName: Scalars['Int']['output'];
  relationshipMetrics: Scalars['Int']['output'];
  repairAttempts: Scalars['Int']['output'];
  repairMode: Scalars['Int']['output'];
  repairModeEnteredAt: Scalars['Int']['output'];
  repairModeReason: Scalars['Int']['output'];
  responseTimeTrend: Scalars['Int']['output'];
  rhythmType: Scalars['Int']['output'];
  sentimentTrend: Scalars['Int']['output'];
  studentId: Scalars['Int']['output'];
  thresholdAdjustmentHistory: Scalars['Int']['output'];
  thresholdMultiplier: Scalars['Int']['output'];
  urgencyCalibration: Scalars['Int']['output'];
};

export type BehavioralAnalyticsMaxAggregate = {
  __typename?: 'BehavioralAnalyticsMaxAggregate';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  currentMomentum?: Maybe<Scalars['Float']['output']>;
  dataPointCount?: Maybe<Scalars['Int']['output']>;
  dormantSince?: Maybe<Scalars['DateTime']['output']>;
  driftRiskScore?: Maybe<Scalars['Float']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  lastDriftAlert?: Maybe<Scalars['DateTime']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  lastOutreachAt?: Maybe<Scalars['DateTime']['output']>;
  lastRepairAttemptAt?: Maybe<Scalars['DateTime']['output']>;
  lastUpdated?: Maybe<Scalars['DateTime']['output']>;
  momentumType?: Maybe<Scalars['String']['output']>;
  participantId?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  programId?: Maybe<Scalars['String']['output']>;
  programName?: Maybe<Scalars['String']['output']>;
  repairAttempts?: Maybe<Scalars['Int']['output']>;
  repairMode?: Maybe<Scalars['Boolean']['output']>;
  repairModeEnteredAt?: Maybe<Scalars['DateTime']['output']>;
  repairModeReason?: Maybe<Scalars['String']['output']>;
  rhythmType?: Maybe<Scalars['String']['output']>;
  studentId?: Maybe<Scalars['String']['output']>;
  thresholdMultiplier?: Maybe<Scalars['Float']['output']>;
  urgencyCalibration?: Maybe<Scalars['Float']['output']>;
};

export type BehavioralAnalyticsMinAggregate = {
  __typename?: 'BehavioralAnalyticsMinAggregate';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  currentMomentum?: Maybe<Scalars['Float']['output']>;
  dataPointCount?: Maybe<Scalars['Int']['output']>;
  dormantSince?: Maybe<Scalars['DateTime']['output']>;
  driftRiskScore?: Maybe<Scalars['Float']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  lastDriftAlert?: Maybe<Scalars['DateTime']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  lastOutreachAt?: Maybe<Scalars['DateTime']['output']>;
  lastRepairAttemptAt?: Maybe<Scalars['DateTime']['output']>;
  lastUpdated?: Maybe<Scalars['DateTime']['output']>;
  momentumType?: Maybe<Scalars['String']['output']>;
  participantId?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  programId?: Maybe<Scalars['String']['output']>;
  programName?: Maybe<Scalars['String']['output']>;
  repairAttempts?: Maybe<Scalars['Int']['output']>;
  repairMode?: Maybe<Scalars['Boolean']['output']>;
  repairModeEnteredAt?: Maybe<Scalars['DateTime']['output']>;
  repairModeReason?: Maybe<Scalars['String']['output']>;
  rhythmType?: Maybe<Scalars['String']['output']>;
  studentId?: Maybe<Scalars['String']['output']>;
  thresholdMultiplier?: Maybe<Scalars['Float']['output']>;
  urgencyCalibration?: Maybe<Scalars['Float']['output']>;
};

export type BehavioralAnalyticsSumAggregate = {
  __typename?: 'BehavioralAnalyticsSumAggregate';
  currentMomentum?: Maybe<Scalars['Float']['output']>;
  dataPointCount?: Maybe<Scalars['Int']['output']>;
  driftRiskScore?: Maybe<Scalars['Float']['output']>;
  repairAttempts?: Maybe<Scalars['Int']['output']>;
  thresholdMultiplier?: Maybe<Scalars['Float']['output']>;
  urgencyCalibration?: Maybe<Scalars['Float']['output']>;
};

export type BoolFieldUpdateOperationsInput = {
  set?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BoolFilter = {
  equals?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<NestedBoolFilter>;
};

export type BoolNullableFilter = {
  equals?: InputMaybe<Scalars['Boolean']['input']>;
  isSet?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<NestedBoolNullableFilter>;
};

export type BulkSetupScopeCountAggregate = {
  __typename?: 'BulkSetupScopeCountAggregate';
  _all: Scalars['Int']['output'];
  bulkId: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  organizerId: Scalars['Int']['output'];
  scopes: Scalars['Int']['output'];
  website: Scalars['Int']['output'];
};

export type BulkSetupScopeMaxAggregate = {
  __typename?: 'BulkSetupScopeMaxAggregate';
  bulkId?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  organizerId?: Maybe<Scalars['String']['output']>;
  website?: Maybe<Scalars['String']['output']>;
};

export type BulkSetupScopeMinAggregate = {
  __typename?: 'BulkSetupScopeMinAggregate';
  bulkId?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  organizerId?: Maybe<Scalars['String']['output']>;
  website?: Maybe<Scalars['String']['output']>;
};

/** Cache performance metrics for monitoring */
export type CacheMetrics = {
  __typename?: 'CacheMetrics';
  /** Total number of cache hits */
  cacheHits: Scalars['Float']['output'];
  /** Total number of cache misses */
  cacheMisses: Scalars['Float']['output'];
  /** Cache hit rate percentage */
  hitRate: Scalars['String']['output'];
  /** Number of MongoDB fallback queries */
  mongodbFallbacks: Scalars['Float']['output'];
  /** Total requests processed */
  totalRequests: Scalars['Float']['output'];
};

export type CancelInvitationInput = {
  /** Email address of the invited stakeholder */
  invitee: Scalars['String']['input'];
  /** The Organization ID */
  organizationId: Scalars['String']['input'];
};

export type CancelInvitationResponse = {
  __typename?: 'CancelInvitationResponse';
  /** Status message */
  message: Scalars['String']['output'];
  /** Whether the operation was successful */
  success: Scalars['Boolean']['output'];
};

/** Input for canceling a subscription */
export type CancelSubscriptionInput = {
  /** MongoDB subscription ID to cancel */
  subscriptionId: Scalars['String']['input'];
};

export type CaptchaData = {
  __typename?: 'CaptchaData';
  /** Unique identifier for this captcha challenge */
  captchaId: Scalars['String']['output'];
  /** Base64 encoded image string or URL to the image */
  imageData: Scalars['String']['output'];
};

export type CashPayment = {
  __typename?: 'CashPayment';
  /** Payment amount in dollars */
  amount: Scalars['Float']['output'];
  /** Personal message from the sponsor with this payment */
  message?: Maybe<Scalars['String']['output']>;
  /** Date when this payment was made (ISO string) */
  paidAt: Scalars['String']['output'];
};

export type CashSponsorInfo = {
  __typename?: 'CashSponsorInfo';
  anonymous?: Maybe<Scalars['Boolean']['output']>;
  company?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
};

/** Summary data for completion celebration dialog */
export type CelebrationSummaryType = {
  __typename?: 'CelebrationSummaryType';
  /** When the program was completed */
  completedAt: Scalars['DateTime']['output'];
  /** Participant first name for personalization */
  participantFirstName: Scalars['String']['output'];
  /** Name of the AI mentor persona */
  personaName: Scalars['String']['output'];
  /** Photo URL of the persona */
  personaPhotoUrl?: Maybe<Scalars['String']['output']>;
  /** Name of the completed program */
  programName: Scalars['String']['output'];
};

export type ChangePasswordInput = {
  /** The user's current password (if required by policy, often for self-service change) */
  currentPassword?: InputMaybe<Scalars['String']['input']>;
  /** The new password for the user */
  newPassword: Scalars['String']['input'];
};

export type CheckAuthMethodsInput = {
  /** Email address to check available authentication methods for */
  email: Scalars['String']['input'];
};

export type CheckAuthMethodsResponse = {
  __typename?: 'CheckAuthMethodsResponse';
  /** List of available authentication methods (e.g., ["email-otp", "password"]) */
  availableMethods: Array<Scalars['String']['output']>;
  /** Whether the user has email OTP authentication enabled */
  hasEmailOtp: Scalars['Boolean']['output'];
  /** Whether the user has password authentication enabled */
  hasPasswordAuth: Scalars['Boolean']['output'];
  /** Whether the user has phone OTP authentication enabled */
  hasPhoneOtp: Scalars['Boolean']['output'];
  /** List of user identities from Auth0 */
  identities: Array<UserIdentity>;
};

export type CheckMergeEligibilityInput = {
  /** Current logged-in user ID (optional) */
  currentUserId?: InputMaybe<Scalars['String']['input']>;
  /** Email or phone number to check for merge eligibility */
  identifier: Scalars['String']['input'];
  /** Type of identifier: EMAIL or PHONE */
  type: Scalars['String']['input'];
};

export type CheckUserExistsInput = {
  /** Email or phone number to check */
  identifier: Scalars['String']['input'];
  /** Type of identifier: EMAIL or PHONE */
  type: Scalars['String']['input'];
};

export type CloneActivitySchemaResult = {
  __typename?: 'CloneActivitySchemaResult';
  data?: Maybe<ActivitySchema>;
  error?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type CloneReportTemplateInput = {
  name: Scalars['String']['input'];
  organizationId: Scalars['String']['input'];
  sourceTemplateId: Scalars['String']['input'];
};

export type CloneShiftSpendGoalInput = {
  id: Scalars['ID']['input'];
  originalInput?: InputMaybe<Scalars['String']['input']>;
  rateProfileSlug?: InputMaybe<Scalars['String']['input']>;
  targetDate?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CommsAudience = {
  __typename?: 'CommsAudience';
  contactCount?: Maybe<Scalars['Int']['output']>;
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  filters?: Maybe<Scalars['JSON']['output']>;
  id: Scalars['ID']['output'];
  lastUsedAt?: Maybe<Scalars['DateTime']['output']>;
  memberCount: Scalars['Int']['output'];
  memberIds: Array<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  type: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type CommsAudienceAvgAggregate = {
  __typename?: 'CommsAudienceAvgAggregate';
  contactCount?: Maybe<Scalars['Float']['output']>;
  memberCount?: Maybe<Scalars['Float']['output']>;
};

export type CommsAudienceContact = {
  __typename?: 'CommsAudienceContact';
  firstName?: Maybe<Scalars['String']['output']>;
  hasPhone: Scalars['Boolean']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  programNames: Array<Scalars['String']['output']>;
  smsOptedOut: Scalars['Boolean']['output'];
  userId: Scalars['String']['output'];
};

export type CommsAudienceCountAggregate = {
  __typename?: 'CommsAudienceCountAggregate';
  _all: Scalars['Int']['output'];
  contactCount: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  createdBy: Scalars['Int']['output'];
  description: Scalars['Int']['output'];
  filters: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  lastUsedAt: Scalars['Int']['output'];
  memberCount: Scalars['Int']['output'];
  memberIds: Scalars['Int']['output'];
  name: Scalars['Int']['output'];
  type: Scalars['Int']['output'];
  updatedAt: Scalars['Int']['output'];
};

export type CommsAudienceMaxAggregate = {
  __typename?: 'CommsAudienceMaxAggregate';
  contactCount?: Maybe<Scalars['Int']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  lastUsedAt?: Maybe<Scalars['DateTime']['output']>;
  memberCount?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type CommsAudienceMinAggregate = {
  __typename?: 'CommsAudienceMinAggregate';
  contactCount?: Maybe<Scalars['Int']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  lastUsedAt?: Maybe<Scalars['DateTime']['output']>;
  memberCount?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type CommsAudiencePreview = {
  __typename?: 'CommsAudiencePreview';
  contacts: Array<CommsAudienceContact>;
  optedOutCount: Scalars['Int']['output'];
  totalCount: Scalars['Int']['output'];
  withPhoneCount: Scalars['Int']['output'];
  withoutPhoneCount: Scalars['Int']['output'];
};

export type CommsAudienceSumAggregate = {
  __typename?: 'CommsAudienceSumAggregate';
  contactCount?: Maybe<Scalars['Int']['output']>;
  memberCount?: Maybe<Scalars['Int']['output']>;
};

export type CommsCampaign = {
  __typename?: 'CommsCampaign';
  audienceFilters?: Maybe<Scalars['JSON']['output']>;
  audienceId?: Maybe<Scalars['String']['output']>;
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['String']['output'];
  deliveredCount: Scalars['Int']['output'];
  failedCount: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  messageTemplate: Scalars['String']['output'];
  name: Scalars['String']['output'];
  noPhoneCount: Scalars['Int']['output'];
  optedOutCount: Scalars['Int']['output'];
  phoneLineId: Scalars['String']['output'];
  scheduledAt?: Maybe<Scalars['DateTime']['output']>;
  sentAt?: Maybe<Scalars['DateTime']['output']>;
  sentCount: Scalars['Int']['output'];
  status: Scalars['String']['output'];
  totalRecipients: Scalars['Int']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type CommsCampaignAvgAggregate = {
  __typename?: 'CommsCampaignAvgAggregate';
  deliveredCount?: Maybe<Scalars['Float']['output']>;
  failedCount?: Maybe<Scalars['Float']['output']>;
  noPhoneCount?: Maybe<Scalars['Float']['output']>;
  optedOutCount?: Maybe<Scalars['Float']['output']>;
  sentCount?: Maybe<Scalars['Float']['output']>;
  totalRecipients?: Maybe<Scalars['Float']['output']>;
};

export type CommsCampaignCountAggregate = {
  __typename?: 'CommsCampaignCountAggregate';
  _all: Scalars['Int']['output'];
  audienceFilters: Scalars['Int']['output'];
  audienceId: Scalars['Int']['output'];
  completedAt: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  createdBy: Scalars['Int']['output'];
  deliveredCount: Scalars['Int']['output'];
  failedCount: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  messageTemplate: Scalars['Int']['output'];
  name: Scalars['Int']['output'];
  noPhoneCount: Scalars['Int']['output'];
  optedOutCount: Scalars['Int']['output'];
  phoneLineId: Scalars['Int']['output'];
  scheduledAt: Scalars['Int']['output'];
  sentAt: Scalars['Int']['output'];
  sentCount: Scalars['Int']['output'];
  status: Scalars['Int']['output'];
  totalRecipients: Scalars['Int']['output'];
  updatedAt: Scalars['Int']['output'];
};

export type CommsCampaignMaxAggregate = {
  __typename?: 'CommsCampaignMaxAggregate';
  audienceId?: Maybe<Scalars['String']['output']>;
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  deliveredCount?: Maybe<Scalars['Int']['output']>;
  failedCount?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  messageTemplate?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  noPhoneCount?: Maybe<Scalars['Int']['output']>;
  optedOutCount?: Maybe<Scalars['Int']['output']>;
  phoneLineId?: Maybe<Scalars['String']['output']>;
  scheduledAt?: Maybe<Scalars['DateTime']['output']>;
  sentAt?: Maybe<Scalars['DateTime']['output']>;
  sentCount?: Maybe<Scalars['Int']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  totalRecipients?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type CommsCampaignMinAggregate = {
  __typename?: 'CommsCampaignMinAggregate';
  audienceId?: Maybe<Scalars['String']['output']>;
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  deliveredCount?: Maybe<Scalars['Int']['output']>;
  failedCount?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  messageTemplate?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  noPhoneCount?: Maybe<Scalars['Int']['output']>;
  optedOutCount?: Maybe<Scalars['Int']['output']>;
  phoneLineId?: Maybe<Scalars['String']['output']>;
  scheduledAt?: Maybe<Scalars['DateTime']['output']>;
  sentAt?: Maybe<Scalars['DateTime']['output']>;
  sentCount?: Maybe<Scalars['Int']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  totalRecipients?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type CommsCampaignRecipient = {
  __typename?: 'CommsCampaignRecipient';
  campaignId: Scalars['String']['output'];
  conversationId?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  deliveredAt?: Maybe<Scalars['DateTime']['output']>;
  externalId?: Maybe<Scalars['String']['output']>;
  failureReason?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  messageId?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  resolvedMessage?: Maybe<Scalars['String']['output']>;
  sentAt?: Maybe<Scalars['DateTime']['output']>;
  status: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  userId: Scalars['String']['output'];
  variables?: Maybe<Scalars['JSON']['output']>;
};

export type CommsCampaignRecipientCountAggregate = {
  __typename?: 'CommsCampaignRecipientCountAggregate';
  _all: Scalars['Int']['output'];
  campaignId: Scalars['Int']['output'];
  conversationId: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  deliveredAt: Scalars['Int']['output'];
  externalId: Scalars['Int']['output'];
  failureReason: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  messageId: Scalars['Int']['output'];
  phoneNumber: Scalars['Int']['output'];
  resolvedMessage: Scalars['Int']['output'];
  sentAt: Scalars['Int']['output'];
  status: Scalars['Int']['output'];
  updatedAt: Scalars['Int']['output'];
  userId: Scalars['Int']['output'];
  variables: Scalars['Int']['output'];
};

export type CommsCampaignRecipientMaxAggregate = {
  __typename?: 'CommsCampaignRecipientMaxAggregate';
  campaignId?: Maybe<Scalars['String']['output']>;
  conversationId?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  deliveredAt?: Maybe<Scalars['DateTime']['output']>;
  externalId?: Maybe<Scalars['String']['output']>;
  failureReason?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  messageId?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  resolvedMessage?: Maybe<Scalars['String']['output']>;
  sentAt?: Maybe<Scalars['DateTime']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
};

export type CommsCampaignRecipientMinAggregate = {
  __typename?: 'CommsCampaignRecipientMinAggregate';
  campaignId?: Maybe<Scalars['String']['output']>;
  conversationId?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  deliveredAt?: Maybe<Scalars['DateTime']['output']>;
  externalId?: Maybe<Scalars['String']['output']>;
  failureReason?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  messageId?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  resolvedMessage?: Maybe<Scalars['String']['output']>;
  sentAt?: Maybe<Scalars['DateTime']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
};

export type CommsCampaignSumAggregate = {
  __typename?: 'CommsCampaignSumAggregate';
  deliveredCount?: Maybe<Scalars['Int']['output']>;
  failedCount?: Maybe<Scalars['Int']['output']>;
  noPhoneCount?: Maybe<Scalars['Int']['output']>;
  optedOutCount?: Maybe<Scalars['Int']['output']>;
  sentCount?: Maybe<Scalars['Int']['output']>;
  totalRecipients?: Maybe<Scalars['Int']['output']>;
};

export type CommsCampaignWithRecipients = {
  __typename?: 'CommsCampaignWithRecipients';
  campaign: CommsCampaign;
  recipients: Array<CommsCampaignRecipient>;
};

export type CommsConversation = {
  __typename?: 'CommsConversation';
  contactName?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  externalPhone: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  lastMessageAt: Scalars['DateTime']['output'];
  lastMessagePreview?: Maybe<Scalars['String']['output']>;
  messageCount: Scalars['Int']['output'];
  phoneLineId: Scalars['String']['output'];
  status: Scalars['String']['output'];
  tags?: Maybe<Array<CommsConversationTag>>;
  unreadCount: Scalars['Int']['output'];
  updatedAt: Scalars['DateTime']['output'];
  userId?: Maybe<Scalars['String']['output']>;
};

export type CommsConversationAvgAggregate = {
  __typename?: 'CommsConversationAvgAggregate';
  messageCount?: Maybe<Scalars['Float']['output']>;
  unreadCount?: Maybe<Scalars['Float']['output']>;
};

export type CommsConversationCountAggregate = {
  __typename?: 'CommsConversationCountAggregate';
  _all: Scalars['Int']['output'];
  contactName: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  externalPhone: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  lastMessageAt: Scalars['Int']['output'];
  lastMessagePreview: Scalars['Int']['output'];
  messageCount: Scalars['Int']['output'];
  phoneLineId: Scalars['Int']['output'];
  status: Scalars['Int']['output'];
  unreadCount: Scalars['Int']['output'];
  updatedAt: Scalars['Int']['output'];
  userId: Scalars['Int']['output'];
};

export type CommsConversationMaxAggregate = {
  __typename?: 'CommsConversationMaxAggregate';
  contactName?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  externalPhone?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  lastMessageAt?: Maybe<Scalars['DateTime']['output']>;
  lastMessagePreview?: Maybe<Scalars['String']['output']>;
  messageCount?: Maybe<Scalars['Int']['output']>;
  phoneLineId?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  unreadCount?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
};

export type CommsConversationMinAggregate = {
  __typename?: 'CommsConversationMinAggregate';
  contactName?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  externalPhone?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  lastMessageAt?: Maybe<Scalars['DateTime']['output']>;
  lastMessagePreview?: Maybe<Scalars['String']['output']>;
  messageCount?: Maybe<Scalars['Int']['output']>;
  phoneLineId?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  unreadCount?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
};

export type CommsConversationSumAggregate = {
  __typename?: 'CommsConversationSumAggregate';
  messageCount?: Maybe<Scalars['Int']['output']>;
  unreadCount?: Maybe<Scalars['Int']['output']>;
};

export type CommsConversationTag = {
  __typename?: 'CommsConversationTag';
  appliedBy?: Maybe<Scalars['String']['output']>;
  conversationId: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  tagColor?: Maybe<Scalars['String']['output']>;
  tagId: Scalars['String']['output'];
  tagName?: Maybe<Scalars['String']['output']>;
};

export type CommsConversationTagCountAggregate = {
  __typename?: 'CommsConversationTagCountAggregate';
  _all: Scalars['Int']['output'];
  appliedBy: Scalars['Int']['output'];
  conversationId: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  tagId: Scalars['Int']['output'];
};

export type CommsConversationTagMaxAggregate = {
  __typename?: 'CommsConversationTagMaxAggregate';
  appliedBy?: Maybe<Scalars['String']['output']>;
  conversationId?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  tagId?: Maybe<Scalars['String']['output']>;
};

export type CommsConversationTagMinAggregate = {
  __typename?: 'CommsConversationTagMinAggregate';
  appliedBy?: Maybe<Scalars['String']['output']>;
  conversationId?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  tagId?: Maybe<Scalars['String']['output']>;
};

export type CommsConversationWithMessages = {
  __typename?: 'CommsConversationWithMessages';
  conversation: CommsConversation;
  messages: Array<CommsMessage>;
};

export type CommsDiscoveredCategory = {
  __typename?: 'CommsDiscoveredCategory';
  fields: Array<CommsDiscoveredField>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type CommsDiscoveredField = {
  __typename?: 'CommsDiscoveredField';
  chipFriendly: Scalars['Boolean']['output'];
  collection: Scalars['String']['output'];
  dataType: Scalars['String']['output'];
  displayName: Scalars['String']['output'];
  distinctCount: Scalars['Int']['output'];
  fieldPath: Scalars['String']['output'];
  operators: Array<Scalars['String']['output']>;
  topValues: Array<Scalars['JSON']['output']>;
};

export type CommsExpansionSuggestion = {
  __typename?: 'CommsExpansionSuggestion';
  audienceFilters: Scalars['JSON']['output'];
  description: Scalars['String']['output'];
  estimatedCount: Scalars['Int']['output'];
  label: Scalars['String']['output'];
};

export type CommsExpansionSuggestions = {
  __typename?: 'CommsExpansionSuggestions';
  suggestions: Array<CommsExpansionSuggestion>;
};

export type CommsExperiment = {
  __typename?: 'CommsExperiment';
  aiContext?: Maybe<Scalars['JSON']['output']>;
  autoScaleThreshold?: Maybe<Scalars['JSON']['output']>;
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['String']['output'];
  currentStage: Scalars['Int']['output'];
  description?: Maybe<Scalars['String']['output']>;
  goal?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  nextEvaluationAt?: Maybe<Scalars['DateTime']['output']>;
  opportunityCta?: Maybe<Scalars['String']['output']>;
  opportunityId?: Maybe<Scalars['String']['output']>;
  opportunityType: Scalars['String']['output'];
  overlapProtection: Scalars['Boolean']['output'];
  scaleBehavior: Scalars['String']['output'];
  scalingConfig?: Maybe<Scalars['JSON']['output']>;
  source: Scalars['String']['output'];
  status: Scalars['String']['output'];
  testStrategy: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  variantIds: Array<Scalars['String']['output']>;
  winnerDeclaredAt?: Maybe<Scalars['DateTime']['output']>;
  winnerVariantId?: Maybe<Scalars['String']['output']>;
};

export type CommsExperimentAnalysis = {
  __typename?: 'CommsExperimentAnalysis';
  daysSinceActivation: Scalars['Float']['output'];
  experiment: CommsExperiment;
  sufficientData: Scalars['Boolean']['output'];
  variants: Array<CommsExperimentVariant>;
  winnerVariant?: Maybe<CommsExperimentVariant>;
};

export type CommsExperimentAvgAggregate = {
  __typename?: 'CommsExperimentAvgAggregate';
  currentStage?: Maybe<Scalars['Float']['output']>;
};

export type CommsExperimentCountAggregate = {
  __typename?: 'CommsExperimentCountAggregate';
  _all: Scalars['Int']['output'];
  activatedAt: Scalars['Int']['output'];
  aiContext: Scalars['Int']['output'];
  autoScaleThreshold: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  createdBy: Scalars['Int']['output'];
  currentStage: Scalars['Int']['output'];
  description: Scalars['Int']['output'];
  goal: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['Int']['output'];
  nextEvaluationAt: Scalars['Int']['output'];
  opportunityCta: Scalars['Int']['output'];
  opportunityId: Scalars['Int']['output'];
  opportunityType: Scalars['Int']['output'];
  overlapProtection: Scalars['Int']['output'];
  scaleBehavior: Scalars['Int']['output'];
  scalingConfig: Scalars['Int']['output'];
  source: Scalars['Int']['output'];
  status: Scalars['Int']['output'];
  testStrategy: Scalars['Int']['output'];
  updatedAt: Scalars['Int']['output'];
  variantIds: Scalars['Int']['output'];
  winnerDeclaredAt: Scalars['Int']['output'];
  winnerVariantId: Scalars['Int']['output'];
};

export type CommsExperimentDailyStat = {
  __typename?: 'CommsExperimentDailyStat';
  date: Scalars['String']['output'];
  delivered: Scalars['Int']['output'];
  failed: Scalars['Int']['output'];
  replied: Scalars['Int']['output'];
  sent: Scalars['Int']['output'];
  variantId: Scalars['String']['output'];
};

export type CommsExperimentFeedbackAvgAggregate = {
  __typename?: 'CommsExperimentFeedbackAvgAggregate';
  pmfScore?: Maybe<Scalars['Float']['output']>;
  resultCount?: Maybe<Scalars['Float']['output']>;
};

export type CommsExperimentFeedbackCountAggregate = {
  __typename?: 'CommsExperimentFeedbackCountAggregate';
  _all: Scalars['Int']['output'];
  correctedFilter: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  experimentId: Scalars['Int']['output'];
  filter: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  pmfScore: Scalars['Int']['output'];
  resultCount: Scalars['Int']['output'];
  success: Scalars['Int']['output'];
  type: Scalars['Int']['output'];
};

export type CommsExperimentFeedbackMaxAggregate = {
  __typename?: 'CommsExperimentFeedbackMaxAggregate';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  experimentId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  pmfScore?: Maybe<Scalars['Float']['output']>;
  resultCount?: Maybe<Scalars['Int']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type CommsExperimentFeedbackMinAggregate = {
  __typename?: 'CommsExperimentFeedbackMinAggregate';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  experimentId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  pmfScore?: Maybe<Scalars['Float']['output']>;
  resultCount?: Maybe<Scalars['Int']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type CommsExperimentFeedbackSumAggregate = {
  __typename?: 'CommsExperimentFeedbackSumAggregate';
  pmfScore?: Maybe<Scalars['Float']['output']>;
  resultCount?: Maybe<Scalars['Int']['output']>;
};

export type CommsExperimentMaxAggregate = {
  __typename?: 'CommsExperimentMaxAggregate';
  activatedAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  currentStage?: Maybe<Scalars['Int']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  goal?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  nextEvaluationAt?: Maybe<Scalars['DateTime']['output']>;
  opportunityCta?: Maybe<Scalars['String']['output']>;
  opportunityId?: Maybe<Scalars['String']['output']>;
  opportunityType?: Maybe<Scalars['String']['output']>;
  overlapProtection?: Maybe<Scalars['Boolean']['output']>;
  scaleBehavior?: Maybe<Scalars['String']['output']>;
  source?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  testStrategy?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  winnerDeclaredAt?: Maybe<Scalars['DateTime']['output']>;
  winnerVariantId?: Maybe<Scalars['String']['output']>;
};

export type CommsExperimentMinAggregate = {
  __typename?: 'CommsExperimentMinAggregate';
  activatedAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  currentStage?: Maybe<Scalars['Int']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  goal?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  nextEvaluationAt?: Maybe<Scalars['DateTime']['output']>;
  opportunityCta?: Maybe<Scalars['String']['output']>;
  opportunityId?: Maybe<Scalars['String']['output']>;
  opportunityType?: Maybe<Scalars['String']['output']>;
  overlapProtection?: Maybe<Scalars['Boolean']['output']>;
  scaleBehavior?: Maybe<Scalars['String']['output']>;
  source?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  testStrategy?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  winnerDeclaredAt?: Maybe<Scalars['DateTime']['output']>;
  winnerVariantId?: Maybe<Scalars['String']['output']>;
};

export type CommsExperimentRecentReply = {
  __typename?: 'CommsExperimentRecentReply';
  repliedAt?: Maybe<Scalars['DateTime']['output']>;
  userId: Scalars['String']['output'];
  userName: Scalars['String']['output'];
  variantId: Scalars['String']['output'];
};

export type CommsExperimentSumAggregate = {
  __typename?: 'CommsExperimentSumAggregate';
  currentStage?: Maybe<Scalars['Int']['output']>;
};

export type CommsExperimentTimeline = {
  __typename?: 'CommsExperimentTimeline';
  dailyStats: Array<CommsExperimentDailyStat>;
  recentReplies: Array<CommsExperimentRecentReply>;
};

export type CommsExperimentVariant = {
  __typename?: 'CommsExperimentVariant';
  audienceDescription?: Maybe<Scalars['String']['output']>;
  audienceFilters?: Maybe<Scalars['JSON']['output']>;
  audienceLabel?: Maybe<Scalars['String']['output']>;
  conversionRate?: Maybe<Scalars['Float']['output']>;
  engagementRate?: Maybe<Scalars['Float']['output']>;
  id: Scalars['ID']['output'];
  isWinner: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  pmfScore?: Maybe<Scalars['Float']['output']>;
  status: Scalars['String']['output'];
  steps?: Maybe<Array<CommsExperimentVariantStep>>;
  totalDelivered: Scalars['Int']['output'];
  totalEnrolled: Scalars['Int']['output'];
  totalReplied: Scalars['Int']['output'];
  totalSent: Scalars['Int']['output'];
  variantId: Scalars['String']['output'];
};

export type CommsExperimentVariantStep = {
  __typename?: 'CommsExperimentVariantStep';
  channel: Scalars['String']['output'];
  condition: Scalars['String']['output'];
  delayDays?: Maybe<Scalars['Int']['output']>;
  delayHours?: Maybe<Scalars['Int']['output']>;
  deliveredCount: Scalars['Int']['output'];
  failedCount: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  messageTemplate: Scalars['String']['output'];
  repliedCount: Scalars['Int']['output'];
  sentCount: Scalars['Int']['output'];
  stepNumber: Scalars['Int']['output'];
  subject?: Maybe<Scalars['String']['output']>;
};

export type CommsMessage = {
  __typename?: 'CommsMessage';
  content: Scalars['String']['output'];
  conversationId: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  direction: Scalars['String']['output'];
  externalId?: Maybe<Scalars['String']['output']>;
  failureReason?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  mediaTypes: Array<Scalars['String']['output']>;
  mediaUrls: Array<Scalars['String']['output']>;
  sentBy?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type CommsMessageCountAggregate = {
  __typename?: 'CommsMessageCountAggregate';
  _all: Scalars['Int']['output'];
  content: Scalars['Int']['output'];
  conversationId: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  direction: Scalars['Int']['output'];
  externalId: Scalars['Int']['output'];
  failureReason: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  mediaTypes: Scalars['Int']['output'];
  mediaUrls: Scalars['Int']['output'];
  sentBy: Scalars['Int']['output'];
  status: Scalars['Int']['output'];
  updatedAt: Scalars['Int']['output'];
};

export type CommsMessageMaxAggregate = {
  __typename?: 'CommsMessageMaxAggregate';
  content?: Maybe<Scalars['String']['output']>;
  conversationId?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  direction?: Maybe<Scalars['String']['output']>;
  externalId?: Maybe<Scalars['String']['output']>;
  failureReason?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  sentBy?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type CommsMessageMinAggregate = {
  __typename?: 'CommsMessageMinAggregate';
  content?: Maybe<Scalars['String']['output']>;
  conversationId?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  direction?: Maybe<Scalars['String']['output']>;
  externalId?: Maybe<Scalars['String']['output']>;
  failureReason?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  sentBy?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type CommsOpportunity = {
  __typename?: 'CommsOpportunity';
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['String']['output'];
  cta?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  goal?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  linkedProgramId?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  successMetrics?: Maybe<Scalars['JSON']['output']>;
  type: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type CommsOpportunityCountAggregate = {
  __typename?: 'CommsOpportunityCountAggregate';
  _all: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  createdBy: Scalars['Int']['output'];
  cta: Scalars['Int']['output'];
  description: Scalars['Int']['output'];
  goal: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  linkedProgramId: Scalars['Int']['output'];
  name: Scalars['Int']['output'];
  successMetrics: Scalars['Int']['output'];
  type: Scalars['Int']['output'];
  updatedAt: Scalars['Int']['output'];
};

export type CommsOpportunityMaxAggregate = {
  __typename?: 'CommsOpportunityMaxAggregate';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  cta?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  goal?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  linkedProgramId?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type CommsOpportunityMinAggregate = {
  __typename?: 'CommsOpportunityMinAggregate';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  cta?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  goal?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  linkedProgramId?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type CommsPhoneLine = {
  __typename?: 'CommsPhoneLine';
  channelType?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  emailAddress?: Maybe<Scalars['String']['output']>;
  emailName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  inboundRouting?: Maybe<Scalars['String']['output']>;
  isActive: Scalars['Boolean']['output'];
  label: Scalars['String']['output'];
  phoneNumber: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type CommsPhoneLineCountAggregate = {
  __typename?: 'CommsPhoneLineCountAggregate';
  _all: Scalars['Int']['output'];
  channelType: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  emailAddress: Scalars['Int']['output'];
  emailName: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  inboundRouting: Scalars['Int']['output'];
  isActive: Scalars['Int']['output'];
  label: Scalars['Int']['output'];
  phoneNumber: Scalars['Int']['output'];
  updatedAt: Scalars['Int']['output'];
};

export type CommsPhoneLineMaxAggregate = {
  __typename?: 'CommsPhoneLineMaxAggregate';
  channelType?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  emailAddress?: Maybe<Scalars['String']['output']>;
  emailName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  inboundRouting?: Maybe<Scalars['String']['output']>;
  isActive?: Maybe<Scalars['Boolean']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type CommsPhoneLineMinAggregate = {
  __typename?: 'CommsPhoneLineMinAggregate';
  channelType?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  emailAddress?: Maybe<Scalars['String']['output']>;
  emailName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  inboundRouting?: Maybe<Scalars['String']['output']>;
  isActive?: Maybe<Scalars['Boolean']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type CommsPreActivationCheck = {
  __typename?: 'CommsPreActivationCheck';
  audienceCount: Scalars['Int']['output'];
  audienceLabel: Scalars['String']['output'];
  hasZeroContacts: Scalars['Boolean']['output'];
  variantId: Scalars['String']['output'];
  variantName: Scalars['String']['output'];
};

export type CommsRule = {
  __typename?: 'CommsRule';
  actions: Scalars['JSON']['output'];
  conditions: Scalars['JSON']['output'];
  createdAt: Scalars['DateTime']['output'];
  enabled: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  sortOrder: Scalars['Int']['output'];
  stopProcessing: Scalars['Boolean']['output'];
  triggers: Scalars['JSON']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type CommsRuleAvgAggregate = {
  __typename?: 'CommsRuleAvgAggregate';
  sortOrder?: Maybe<Scalars['Float']['output']>;
};

export type CommsRuleCountAggregate = {
  __typename?: 'CommsRuleCountAggregate';
  _all: Scalars['Int']['output'];
  actions: Scalars['Int']['output'];
  conditions: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  enabled: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['Int']['output'];
  sortOrder: Scalars['Int']['output'];
  stopProcessing: Scalars['Int']['output'];
  triggers: Scalars['Int']['output'];
  updatedAt: Scalars['Int']['output'];
};

export type CommsRuleMaxAggregate = {
  __typename?: 'CommsRuleMaxAggregate';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  enabled?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  sortOrder?: Maybe<Scalars['Int']['output']>;
  stopProcessing?: Maybe<Scalars['Boolean']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type CommsRuleMinAggregate = {
  __typename?: 'CommsRuleMinAggregate';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  enabled?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  sortOrder?: Maybe<Scalars['Int']['output']>;
  stopProcessing?: Maybe<Scalars['Boolean']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type CommsRuleSumAggregate = {
  __typename?: 'CommsRuleSumAggregate';
  sortOrder?: Maybe<Scalars['Int']['output']>;
};

export type CommsSequence = {
  __typename?: 'CommsSequence';
  activatedAt?: Maybe<Scalars['DateTime']['output']>;
  aiContext?: Maybe<Scalars['JSON']['output']>;
  audienceFilters?: Maybe<Scalars['JSON']['output']>;
  audienceType: Scalars['String']['output'];
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  conversionRate?: Maybe<Scalars['Float']['output']>;
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['String']['output'];
  dedupCrossSequence: Scalars['Boolean']['output'];
  description?: Maybe<Scalars['String']['output']>;
  engagementRate?: Maybe<Scalars['Float']['output']>;
  goal?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastRunAt?: Maybe<Scalars['DateTime']['output']>;
  name: Scalars['String']['output'];
  nextRunAt?: Maybe<Scalars['DateTime']['output']>;
  opportunityCta?: Maybe<Scalars['String']['output']>;
  opportunityId?: Maybe<Scalars['String']['output']>;
  opportunityType: Scalars['String']['output'];
  pauseOnReply: Scalars['Boolean']['output'];
  phoneLineId: Scalars['String']['output'];
  pmfScore?: Maybe<Scalars['Float']['output']>;
  recurrenceDay?: Maybe<Scalars['Int']['output']>;
  recurrenceEndCount?: Maybe<Scalars['Int']['output']>;
  recurrenceEndDate?: Maybe<Scalars['DateTime']['output']>;
  recurrenceEndType?: Maybe<Scalars['String']['output']>;
  recurrencePreset?: Maybe<Scalars['String']['output']>;
  recurrenceRunCount: Scalars['Int']['output'];
  recurrenceTime?: Maybe<Scalars['String']['output']>;
  sendWindowEnd: Scalars['Int']['output'];
  sendWindowStart: Scalars['Int']['output'];
  sendWindowTimezone: Scalars['String']['output'];
  source: Scalars['String']['output'];
  status: Scalars['String']['output'];
  successCriteria?: Maybe<Scalars['JSON']['output']>;
  totalEnrolled: Scalars['Int']['output'];
  type: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type CommsSequenceAvgAggregate = {
  __typename?: 'CommsSequenceAvgAggregate';
  conversionRate?: Maybe<Scalars['Float']['output']>;
  engagementRate?: Maybe<Scalars['Float']['output']>;
  pmfScore?: Maybe<Scalars['Float']['output']>;
  recurrenceDay?: Maybe<Scalars['Float']['output']>;
  recurrenceEndCount?: Maybe<Scalars['Float']['output']>;
  recurrenceRunCount?: Maybe<Scalars['Float']['output']>;
  sendWindowEnd?: Maybe<Scalars['Float']['output']>;
  sendWindowStart?: Maybe<Scalars['Float']['output']>;
  totalEnrolled?: Maybe<Scalars['Float']['output']>;
};

export type CommsSequenceCountAggregate = {
  __typename?: 'CommsSequenceCountAggregate';
  _all: Scalars['Int']['output'];
  activatedAt: Scalars['Int']['output'];
  aiContext: Scalars['Int']['output'];
  audienceFilters: Scalars['Int']['output'];
  audienceType: Scalars['Int']['output'];
  completedAt: Scalars['Int']['output'];
  conversionRate: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  createdBy: Scalars['Int']['output'];
  dedupCrossSequence: Scalars['Int']['output'];
  description: Scalars['Int']['output'];
  engagementRate: Scalars['Int']['output'];
  enrollmentTrigger: Scalars['Int']['output'];
  goal: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  lastRunAt: Scalars['Int']['output'];
  name: Scalars['Int']['output'];
  nextRunAt: Scalars['Int']['output'];
  opportunityCta: Scalars['Int']['output'];
  opportunityId: Scalars['Int']['output'];
  opportunityType: Scalars['Int']['output'];
  pauseOnReply: Scalars['Int']['output'];
  phoneLineId: Scalars['Int']['output'];
  pmfScore: Scalars['Int']['output'];
  recurrenceDay: Scalars['Int']['output'];
  recurrenceEndCount: Scalars['Int']['output'];
  recurrenceEndDate: Scalars['Int']['output'];
  recurrenceEndType: Scalars['Int']['output'];
  recurrencePreset: Scalars['Int']['output'];
  recurrenceRunCount: Scalars['Int']['output'];
  recurrenceTime: Scalars['Int']['output'];
  sendWindowEnd: Scalars['Int']['output'];
  sendWindowStart: Scalars['Int']['output'];
  sendWindowTimezone: Scalars['Int']['output'];
  source: Scalars['Int']['output'];
  status: Scalars['Int']['output'];
  successCriteria: Scalars['Int']['output'];
  totalEnrolled: Scalars['Int']['output'];
  type: Scalars['Int']['output'];
  updatedAt: Scalars['Int']['output'];
};

export type CommsSequenceEnrollment = {
  __typename?: 'CommsSequenceEnrollment';
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  conversionType?: Maybe<Scalars['String']['output']>;
  convertedAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  currentStep: Scalars['Int']['output'];
  enrolledAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  lastRepliedAt?: Maybe<Scalars['DateTime']['output']>;
  nextStepAt?: Maybe<Scalars['DateTime']['output']>;
  pausedAt?: Maybe<Scalars['DateTime']['output']>;
  repliedToStep?: Maybe<Scalars['Int']['output']>;
  sequenceId: Scalars['String']['output'];
  status: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  userId: Scalars['String']['output'];
};

export type CommsSequenceEnrollmentAvgAggregate = {
  __typename?: 'CommsSequenceEnrollmentAvgAggregate';
  currentStep?: Maybe<Scalars['Float']['output']>;
  repliedToStep?: Maybe<Scalars['Float']['output']>;
};

export type CommsSequenceEnrollmentCountAggregate = {
  __typename?: 'CommsSequenceEnrollmentCountAggregate';
  _all: Scalars['Int']['output'];
  completedAt: Scalars['Int']['output'];
  conversionType: Scalars['Int']['output'];
  convertedAt: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  currentStep: Scalars['Int']['output'];
  enrolledAt: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  lastRepliedAt: Scalars['Int']['output'];
  nextStepAt: Scalars['Int']['output'];
  pausedAt: Scalars['Int']['output'];
  repliedToStep: Scalars['Int']['output'];
  sequenceId: Scalars['Int']['output'];
  status: Scalars['Int']['output'];
  updatedAt: Scalars['Int']['output'];
  userId: Scalars['Int']['output'];
};

export type CommsSequenceEnrollmentMaxAggregate = {
  __typename?: 'CommsSequenceEnrollmentMaxAggregate';
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  conversionType?: Maybe<Scalars['String']['output']>;
  convertedAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  currentStep?: Maybe<Scalars['Int']['output']>;
  enrolledAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  lastRepliedAt?: Maybe<Scalars['DateTime']['output']>;
  nextStepAt?: Maybe<Scalars['DateTime']['output']>;
  pausedAt?: Maybe<Scalars['DateTime']['output']>;
  repliedToStep?: Maybe<Scalars['Int']['output']>;
  sequenceId?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
};

export type CommsSequenceEnrollmentMinAggregate = {
  __typename?: 'CommsSequenceEnrollmentMinAggregate';
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  conversionType?: Maybe<Scalars['String']['output']>;
  convertedAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  currentStep?: Maybe<Scalars['Int']['output']>;
  enrolledAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  lastRepliedAt?: Maybe<Scalars['DateTime']['output']>;
  nextStepAt?: Maybe<Scalars['DateTime']['output']>;
  pausedAt?: Maybe<Scalars['DateTime']['output']>;
  repliedToStep?: Maybe<Scalars['Int']['output']>;
  sequenceId?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
};

export type CommsSequenceEnrollmentSumAggregate = {
  __typename?: 'CommsSequenceEnrollmentSumAggregate';
  currentStep?: Maybe<Scalars['Int']['output']>;
  repliedToStep?: Maybe<Scalars['Int']['output']>;
};

export type CommsSequenceEnrollmentSummary = {
  __typename?: 'CommsSequenceEnrollmentSummary';
  active: Scalars['Int']['output'];
  completed: Scalars['Int']['output'];
  failed: Scalars['Int']['output'];
  optedOut: Scalars['Int']['output'];
  paused: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type CommsSequenceMaxAggregate = {
  __typename?: 'CommsSequenceMaxAggregate';
  activatedAt?: Maybe<Scalars['DateTime']['output']>;
  audienceType?: Maybe<Scalars['String']['output']>;
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  conversionRate?: Maybe<Scalars['Float']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  dedupCrossSequence?: Maybe<Scalars['Boolean']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  engagementRate?: Maybe<Scalars['Float']['output']>;
  goal?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  lastRunAt?: Maybe<Scalars['DateTime']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  nextRunAt?: Maybe<Scalars['DateTime']['output']>;
  opportunityCta?: Maybe<Scalars['String']['output']>;
  opportunityId?: Maybe<Scalars['String']['output']>;
  opportunityType?: Maybe<Scalars['String']['output']>;
  pauseOnReply?: Maybe<Scalars['Boolean']['output']>;
  phoneLineId?: Maybe<Scalars['String']['output']>;
  pmfScore?: Maybe<Scalars['Float']['output']>;
  recurrenceDay?: Maybe<Scalars['Int']['output']>;
  recurrenceEndCount?: Maybe<Scalars['Int']['output']>;
  recurrenceEndDate?: Maybe<Scalars['DateTime']['output']>;
  recurrenceEndType?: Maybe<Scalars['String']['output']>;
  recurrencePreset?: Maybe<Scalars['String']['output']>;
  recurrenceRunCount?: Maybe<Scalars['Int']['output']>;
  recurrenceTime?: Maybe<Scalars['String']['output']>;
  sendWindowEnd?: Maybe<Scalars['Int']['output']>;
  sendWindowStart?: Maybe<Scalars['Int']['output']>;
  sendWindowTimezone?: Maybe<Scalars['String']['output']>;
  source?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  totalEnrolled?: Maybe<Scalars['Int']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type CommsSequenceMinAggregate = {
  __typename?: 'CommsSequenceMinAggregate';
  activatedAt?: Maybe<Scalars['DateTime']['output']>;
  audienceType?: Maybe<Scalars['String']['output']>;
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  conversionRate?: Maybe<Scalars['Float']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  dedupCrossSequence?: Maybe<Scalars['Boolean']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  engagementRate?: Maybe<Scalars['Float']['output']>;
  goal?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  lastRunAt?: Maybe<Scalars['DateTime']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  nextRunAt?: Maybe<Scalars['DateTime']['output']>;
  opportunityCta?: Maybe<Scalars['String']['output']>;
  opportunityId?: Maybe<Scalars['String']['output']>;
  opportunityType?: Maybe<Scalars['String']['output']>;
  pauseOnReply?: Maybe<Scalars['Boolean']['output']>;
  phoneLineId?: Maybe<Scalars['String']['output']>;
  pmfScore?: Maybe<Scalars['Float']['output']>;
  recurrenceDay?: Maybe<Scalars['Int']['output']>;
  recurrenceEndCount?: Maybe<Scalars['Int']['output']>;
  recurrenceEndDate?: Maybe<Scalars['DateTime']['output']>;
  recurrenceEndType?: Maybe<Scalars['String']['output']>;
  recurrencePreset?: Maybe<Scalars['String']['output']>;
  recurrenceRunCount?: Maybe<Scalars['Int']['output']>;
  recurrenceTime?: Maybe<Scalars['String']['output']>;
  sendWindowEnd?: Maybe<Scalars['Int']['output']>;
  sendWindowStart?: Maybe<Scalars['Int']['output']>;
  sendWindowTimezone?: Maybe<Scalars['String']['output']>;
  source?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  totalEnrolled?: Maybe<Scalars['Int']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type CommsSequenceStep = {
  __typename?: 'CommsSequenceStep';
  channel: Scalars['String']['output'];
  condition: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  delayDays?: Maybe<Scalars['Int']['output']>;
  delayHours?: Maybe<Scalars['Int']['output']>;
  deliveredCount: Scalars['Int']['output'];
  failedCount: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  messageTemplate: Scalars['String']['output'];
  repliedCount: Scalars['Int']['output'];
  sentCount: Scalars['Int']['output'];
  sequenceId: Scalars['String']['output'];
  specificDate?: Maybe<Scalars['DateTime']['output']>;
  stepNumber: Scalars['Int']['output'];
  subject?: Maybe<Scalars['String']['output']>;
  timingType: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type CommsSequenceStepAvgAggregate = {
  __typename?: 'CommsSequenceStepAvgAggregate';
  delayDays?: Maybe<Scalars['Float']['output']>;
  delayHours?: Maybe<Scalars['Float']['output']>;
  deliveredCount?: Maybe<Scalars['Float']['output']>;
  failedCount?: Maybe<Scalars['Float']['output']>;
  repliedCount?: Maybe<Scalars['Float']['output']>;
  sentCount?: Maybe<Scalars['Float']['output']>;
  stepNumber?: Maybe<Scalars['Float']['output']>;
};

export type CommsSequenceStepCountAggregate = {
  __typename?: 'CommsSequenceStepCountAggregate';
  _all: Scalars['Int']['output'];
  channel: Scalars['Int']['output'];
  condition: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  delayDays: Scalars['Int']['output'];
  delayHours: Scalars['Int']['output'];
  deliveredCount: Scalars['Int']['output'];
  failedCount: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  messageTemplate: Scalars['Int']['output'];
  repliedCount: Scalars['Int']['output'];
  sentCount: Scalars['Int']['output'];
  sequenceId: Scalars['Int']['output'];
  specificDate: Scalars['Int']['output'];
  stepNumber: Scalars['Int']['output'];
  subject: Scalars['Int']['output'];
  timingType: Scalars['Int']['output'];
  updatedAt: Scalars['Int']['output'];
};

export type CommsSequenceStepMaxAggregate = {
  __typename?: 'CommsSequenceStepMaxAggregate';
  channel?: Maybe<Scalars['String']['output']>;
  condition?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  delayDays?: Maybe<Scalars['Int']['output']>;
  delayHours?: Maybe<Scalars['Int']['output']>;
  deliveredCount?: Maybe<Scalars['Int']['output']>;
  failedCount?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  messageTemplate?: Maybe<Scalars['String']['output']>;
  repliedCount?: Maybe<Scalars['Int']['output']>;
  sentCount?: Maybe<Scalars['Int']['output']>;
  sequenceId?: Maybe<Scalars['String']['output']>;
  specificDate?: Maybe<Scalars['DateTime']['output']>;
  stepNumber?: Maybe<Scalars['Int']['output']>;
  subject?: Maybe<Scalars['String']['output']>;
  timingType?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type CommsSequenceStepMinAggregate = {
  __typename?: 'CommsSequenceStepMinAggregate';
  channel?: Maybe<Scalars['String']['output']>;
  condition?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  delayDays?: Maybe<Scalars['Int']['output']>;
  delayHours?: Maybe<Scalars['Int']['output']>;
  deliveredCount?: Maybe<Scalars['Int']['output']>;
  failedCount?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  messageTemplate?: Maybe<Scalars['String']['output']>;
  repliedCount?: Maybe<Scalars['Int']['output']>;
  sentCount?: Maybe<Scalars['Int']['output']>;
  sequenceId?: Maybe<Scalars['String']['output']>;
  specificDate?: Maybe<Scalars['DateTime']['output']>;
  stepNumber?: Maybe<Scalars['Int']['output']>;
  subject?: Maybe<Scalars['String']['output']>;
  timingType?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type CommsSequenceStepSendCountAggregate = {
  __typename?: 'CommsSequenceStepSendCountAggregate';
  _all: Scalars['Int']['output'];
  channel: Scalars['Int']['output'];
  conversationId: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  deliveredAt: Scalars['Int']['output'];
  enrollmentId: Scalars['Int']['output'];
  externalId: Scalars['Int']['output'];
  failureReason: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  messageId: Scalars['Int']['output'];
  resolvedMessage: Scalars['Int']['output'];
  sentAt: Scalars['Int']['output'];
  sequenceId: Scalars['Int']['output'];
  status: Scalars['Int']['output'];
  stepId: Scalars['Int']['output'];
  updatedAt: Scalars['Int']['output'];
  userId: Scalars['Int']['output'];
};

export type CommsSequenceStepSendMaxAggregate = {
  __typename?: 'CommsSequenceStepSendMaxAggregate';
  channel?: Maybe<Scalars['String']['output']>;
  conversationId?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  deliveredAt?: Maybe<Scalars['DateTime']['output']>;
  enrollmentId?: Maybe<Scalars['String']['output']>;
  externalId?: Maybe<Scalars['String']['output']>;
  failureReason?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  messageId?: Maybe<Scalars['String']['output']>;
  resolvedMessage?: Maybe<Scalars['String']['output']>;
  sentAt?: Maybe<Scalars['DateTime']['output']>;
  sequenceId?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  stepId?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
};

export type CommsSequenceStepSendMinAggregate = {
  __typename?: 'CommsSequenceStepSendMinAggregate';
  channel?: Maybe<Scalars['String']['output']>;
  conversationId?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  deliveredAt?: Maybe<Scalars['DateTime']['output']>;
  enrollmentId?: Maybe<Scalars['String']['output']>;
  externalId?: Maybe<Scalars['String']['output']>;
  failureReason?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  messageId?: Maybe<Scalars['String']['output']>;
  resolvedMessage?: Maybe<Scalars['String']['output']>;
  sentAt?: Maybe<Scalars['DateTime']['output']>;
  sequenceId?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  stepId?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
};

export type CommsSequenceStepSumAggregate = {
  __typename?: 'CommsSequenceStepSumAggregate';
  delayDays?: Maybe<Scalars['Int']['output']>;
  delayHours?: Maybe<Scalars['Int']['output']>;
  deliveredCount?: Maybe<Scalars['Int']['output']>;
  failedCount?: Maybe<Scalars['Int']['output']>;
  repliedCount?: Maybe<Scalars['Int']['output']>;
  sentCount?: Maybe<Scalars['Int']['output']>;
  stepNumber?: Maybe<Scalars['Int']['output']>;
};

export type CommsSequenceSumAggregate = {
  __typename?: 'CommsSequenceSumAggregate';
  conversionRate?: Maybe<Scalars['Float']['output']>;
  engagementRate?: Maybe<Scalars['Float']['output']>;
  pmfScore?: Maybe<Scalars['Float']['output']>;
  recurrenceDay?: Maybe<Scalars['Int']['output']>;
  recurrenceEndCount?: Maybe<Scalars['Int']['output']>;
  recurrenceRunCount?: Maybe<Scalars['Int']['output']>;
  sendWindowEnd?: Maybe<Scalars['Int']['output']>;
  sendWindowStart?: Maybe<Scalars['Int']['output']>;
  totalEnrolled?: Maybe<Scalars['Int']['output']>;
};

export type CommsSequenceWithDetails = {
  __typename?: 'CommsSequenceWithDetails';
  enrollmentSummary: CommsSequenceEnrollmentSummary;
  sequence: CommsSequence;
  steps: Array<CommsSequenceStep>;
};

export type CommsTag = {
  __typename?: 'CommsTag';
  color: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  pinned: Scalars['Boolean']['output'];
  sortOrder: Scalars['Int']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type CommsTagAvgAggregate = {
  __typename?: 'CommsTagAvgAggregate';
  sortOrder?: Maybe<Scalars['Float']['output']>;
};

export type CommsTagCountAggregate = {
  __typename?: 'CommsTagCountAggregate';
  _all: Scalars['Int']['output'];
  color: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['Int']['output'];
  pinned: Scalars['Int']['output'];
  sortOrder: Scalars['Int']['output'];
  updatedAt: Scalars['Int']['output'];
};

export type CommsTagMaxAggregate = {
  __typename?: 'CommsTagMaxAggregate';
  color?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  pinned?: Maybe<Scalars['Boolean']['output']>;
  sortOrder?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type CommsTagMinAggregate = {
  __typename?: 'CommsTagMinAggregate';
  color?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  pinned?: Maybe<Scalars['Boolean']['output']>;
  sortOrder?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type CommsTagSumAggregate = {
  __typename?: 'CommsTagSumAggregate';
  sortOrder?: Maybe<Scalars['Int']['output']>;
};

export type CommsUnreadCount = {
  __typename?: 'CommsUnreadCount';
  count: Scalars['Int']['output'];
};

/** Input for completing AIPM onboarding */
export type CompleteOnboardingInput = {
  /** First goal collected from user (optional) */
  firstGoal?: InputMaybe<Scalars['String']['input']>;
  /** Preferred channel: sms or email (optional) */
  preferredChannel?: InputMaybe<Scalars['String']['input']>;
  /** Program ID to complete onboarding for */
  programId: Scalars['String']['input'];
};

/** Result of completing AIPM onboarding */
export type CompleteOnboardingResultType = {
  __typename?: 'CompleteOnboardingResultType';
  /** Whether onboarding was completed successfully */
  completed: Scalars['Boolean']['output'];
  /** OutreachLog ID of the 0th message sent */
  messageId?: Maybe<Scalars['String']['output']>;
};

/** Result of triggering completion celebration */
export type CompletionCelebrationResultType = {
  __typename?: 'CompletionCelebrationResultType';
  /** OutreachLog ID of the celebration message */
  celebrationMessageId?: Maybe<Scalars['String']['output']>;
  /** Summary data for celebration dialog display */
  celebrationSummary?: Maybe<CelebrationSummaryType>;
  /** Whether portfolio is ready for the participant */
  portfolioReady?: Maybe<Scalars['Boolean']['output']>;
  /** Reason if celebration was not triggered: not_complete, already_celebrated, no_user_settings */
  reason?: Maybe<Scalars['String']['output']>;
  /** Whether celebration was triggered */
  triggered: Scalars['Boolean']['output'];
};

/** Filter mode for activity completion analytics */
export enum CompletionFilterMode {
  /** All ADKs with timeTaken > 0, regardless of completion status */
  All = 'ALL',
  /** Only ADKs with timestamp completed values (excludes boolean true and null) */
  CompletedOnly = 'COMPLETED_ONLY',
  /** Only Students where ALL ADKs have valid completed timestamps */
  FullProgramOnly = 'FULL_PROGRAM_ONLY'
}

/** Stripe Connect account verification status */
export enum ConnectStatus {
  Pending = 'PENDING',
  Restricted = 'RESTRICTED',
  Unverified = 'UNVERIFIED',
  Verified = 'VERIFIED'
}

/** Verification error requiring resolution */
export type ConnectVerificationError = {
  __typename?: 'ConnectVerificationError';
  /** Error code from Stripe */
  code: Scalars['String']['output'];
  /** Human-readable error reason */
  reason: Scalars['String']['output'];
  /** The requirement that has the error */
  requirement: Scalars['String']['output'];
};

/** Stripe Connect account verification status and requirements */
export type ConnectVerificationStatusType = {
  __typename?: 'ConnectVerificationStatusType';
  /** Requirements currently due (need immediate action) */
  currentlyDue: Array<Scalars['String']['output']>;
  /** Reason why account is disabled (if applicable) */
  disabledReason?: Maybe<Scalars['String']['output']>;
  /** Verification errors that need resolution */
  errors: Array<ConnectVerificationError>;
  /** Requirements eventually due (will be required later) */
  eventuallyDue: Array<Scalars['String']['output']>;
  /** Requirements past due (overdue, may restrict account) */
  pastDue: Array<Scalars['String']['output']>;
  /** Requirements pending verification by Stripe */
  pendingVerification: Array<Scalars['String']['output']>;
  /** Overall verification status */
  status: ConnectStatus;
};

export type ConnectionContext = {
  __typename?: 'ConnectionContext';
  /** Total cash received from this sponsor in dollars */
  cashReceived?: Maybe<Scalars['Float']['output']>;
  /** Date when the connection was first established (ISO string) */
  firstConnectionDate?: Maybe<Scalars['String']['output']>;
  /** Whether the sponsor has a registered user account (false for unregistered cash sponsors) */
  isRegistered?: Maybe<Scalars['Boolean']['output']>;
  /** Organization ID for navigation/linking */
  organizationId?: Maybe<Scalars['String']['output']>;
  /** Organization name for display (e.g., "from Acme Corp") */
  organizationName?: Maybe<Scalars['String']['output']>;
  /** Days of proximity in program start dates (for participants) */
  proximityDays?: Maybe<Scalars['Int']['output']>;
  /** Type of relationship: cohort, teammate, organizer, sponsor */
  relationshipType?: Maybe<Scalars['String']['output']>;
  /** Number of programs shared with this person */
  sharedProgramCount?: Maybe<Scalars['Int']['output']>;
  /** Names of programs shared with this person */
  sharedProgramNames?: Maybe<Array<Scalars['String']['output']>>;
  /** Type of sponsorship (for sponsors): CHECKOUT, CREDENTIAL, CASH, MIXED */
  sponsorType?: Maybe<Scalars['String']['output']>;
  /** Total tokens received from this sponsor */
  tokensReceived?: Maybe<Scalars['Int']['output']>;
};

/** AI context capabilities - which knowledge sources are enabled */
export type ContextCapabilities = {
  __typename?: 'ContextCapabilities';
  activityContext: ContextToggle;
  longRangeContext?: Maybe<LongRangeContextConfig>;
  programContext: ContextToggle;
  resourceContext: ContextToggle;
};

/** Simple enabled/disabled toggle for context sources */
export type ContextToggle = {
  __typename?: 'ContextToggle';
  enabled: Scalars['Boolean']['output'];
};

export type ConversationPendingWriteAvgAggregate = {
  __typename?: 'ConversationPendingWriteAvgAggregate';
  activityIndex?: Maybe<Scalars['Float']['output']>;
  aiConfidence?: Maybe<Scalars['Float']['output']>;
};

export type ConversationPendingWriteCountAggregate = {
  __typename?: 'ConversationPendingWriteCountAggregate';
  _all: Scalars['Int']['output'];
  activityIndex: Scalars['Int']['output'];
  activityName: Scalars['Int']['output'];
  aiConfidence: Scalars['Int']['output'];
  approvedAt: Scalars['Int']['output'];
  approvedBy: Scalars['Int']['output'];
  canAutoCommit: Scalars['Int']['output'];
  collectedData: Scalars['Int']['output'];
  confidenceTier: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  isTeamActivity: Scalars['Int']['output'];
  programTeamId: Scalars['Int']['output'];
  rejectionReason: Scalars['Int']['output'];
  threadId: Scalars['Int']['output'];
  updatedAt: Scalars['Int']['output'];
  validationErrors: Scalars['Int']['output'];
  validationStatus: Scalars['Int']['output'];
  writeStatus: Scalars['Int']['output'];
  writtenAt: Scalars['Int']['output'];
};

export type ConversationPendingWriteMaxAggregate = {
  __typename?: 'ConversationPendingWriteMaxAggregate';
  activityIndex?: Maybe<Scalars['Int']['output']>;
  activityName?: Maybe<Scalars['String']['output']>;
  aiConfidence?: Maybe<Scalars['Float']['output']>;
  approvedAt?: Maybe<Scalars['DateTime']['output']>;
  approvedBy?: Maybe<Scalars['String']['output']>;
  canAutoCommit?: Maybe<Scalars['Boolean']['output']>;
  confidenceTier?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  isTeamActivity?: Maybe<Scalars['Boolean']['output']>;
  programTeamId?: Maybe<Scalars['String']['output']>;
  rejectionReason?: Maybe<Scalars['String']['output']>;
  threadId?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  validationStatus?: Maybe<Scalars['String']['output']>;
  writeStatus?: Maybe<Scalars['String']['output']>;
  writtenAt?: Maybe<Scalars['DateTime']['output']>;
};

export type ConversationPendingWriteMinAggregate = {
  __typename?: 'ConversationPendingWriteMinAggregate';
  activityIndex?: Maybe<Scalars['Int']['output']>;
  activityName?: Maybe<Scalars['String']['output']>;
  aiConfidence?: Maybe<Scalars['Float']['output']>;
  approvedAt?: Maybe<Scalars['DateTime']['output']>;
  approvedBy?: Maybe<Scalars['String']['output']>;
  canAutoCommit?: Maybe<Scalars['Boolean']['output']>;
  confidenceTier?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  isTeamActivity?: Maybe<Scalars['Boolean']['output']>;
  programTeamId?: Maybe<Scalars['String']['output']>;
  rejectionReason?: Maybe<Scalars['String']['output']>;
  threadId?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  validationStatus?: Maybe<Scalars['String']['output']>;
  writeStatus?: Maybe<Scalars['String']['output']>;
  writtenAt?: Maybe<Scalars['DateTime']['output']>;
};

export type ConversationPendingWriteSumAggregate = {
  __typename?: 'ConversationPendingWriteSumAggregate';
  activityIndex?: Maybe<Scalars['Int']['output']>;
  aiConfidence?: Maybe<Scalars['Float']['output']>;
};

/** Rate limiting configuration for conversation messages */
export type ConversationRateLimit = {
  __typename?: 'ConversationRateLimit';
  enabled: Scalars['Boolean']['output'];
  maxMessagesPerDay?: Maybe<Scalars['Int']['output']>;
  maxMessagesPerHour?: Maybe<Scalars['Int']['output']>;
};

/** Conversation settings for AIPM Conversation Engine (Path A) */
export type ConversationSettings = {
  __typename?: 'ConversationSettings';
  conversationHistoryDepth?: Maybe<Scalars['Int']['output']>;
  conversationRateLimit: ConversationRateLimit;
};

export type ConversationThreadAvgAggregate = {
  __typename?: 'ConversationThreadAvgAggregate';
  messageCount?: Maybe<Scalars['Float']['output']>;
};

export type ConversationThreadCountAggregate = {
  __typename?: 'ConversationThreadCountAggregate';
  _all: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  email: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  lastChannel: Scalars['Int']['output'];
  lastMessageAt: Scalars['Int']['output'];
  messageCount: Scalars['Int']['output'];
  participantId: Scalars['Int']['output'];
  personaId: Scalars['Int']['output'];
  phoneNumber: Scalars['Int']['output'];
  programId: Scalars['Int']['output'];
  status: Scalars['Int']['output'];
  studentId: Scalars['Int']['output'];
  updatedAt: Scalars['Int']['output'];
};

export type ConversationThreadMaxAggregate = {
  __typename?: 'ConversationThreadMaxAggregate';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  lastChannel?: Maybe<Scalars['String']['output']>;
  lastMessageAt?: Maybe<Scalars['DateTime']['output']>;
  messageCount?: Maybe<Scalars['Int']['output']>;
  participantId?: Maybe<Scalars['String']['output']>;
  personaId?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  programId?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  studentId?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type ConversationThreadMinAggregate = {
  __typename?: 'ConversationThreadMinAggregate';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  lastChannel?: Maybe<Scalars['String']['output']>;
  lastMessageAt?: Maybe<Scalars['DateTime']['output']>;
  messageCount?: Maybe<Scalars['Int']['output']>;
  participantId?: Maybe<Scalars['String']['output']>;
  personaId?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  programId?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  studentId?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type ConversationThreadSumAggregate = {
  __typename?: 'ConversationThreadSumAggregate';
  messageCount?: Maybe<Scalars['Int']['output']>;
};

/** Aggregated onboarding funnel stats for coordinators */
export type CoordinatorFunnelStatsType = {
  __typename?: 'CoordinatorFunnelStatsType';
  /** Count of participants completed */
  completeCount: Scalars['Float']['output'];
  /** Completion percentage (0-100) */
  completionRate: Scalars['Float']['output'];
  /** Count of participants in progress */
  inProgressCount: Scalars['Float']['output'];
  /** Count of participants not started */
  notStartedCount: Scalars['Float']['output'];
  /** Program ID */
  programId: Scalars['String']['output'];
  /** Total participant count */
  totalCount: Scalars['Float']['output'];
};

export type CoveredByInfo = {
  __typename?: 'CoveredByInfo';
  name: Scalars['String']['output'];
  role: Scalars['String']['output'];
};

/** Input type for creating a new ActivitySchema */
export type CreateActivitySchemaInput = {
  /** JSON Schema for validation */
  JSONSchema?: InputMaybe<Scalars['JSON']['input']>;
  /** Activity image URL */
  activityImage?: InputMaybe<Scalars['String']['input']>;
  /** Build scope configuration as JSON */
  buildScope?: InputMaybe<Scalars['JSON']['input']>;
  /** Builder type identifier */
  builderType?: InputMaybe<Scalars['String']['input']>;
  /** Category of the activity (Pre, Do, Reflect, etc.) */
  category?: InputMaybe<Scalars['String']['input']>;
  /** Whether this activity is completed */
  completed?: InputMaybe<Scalars['Boolean']['input']>;
  /** Description of the activity */
  description: Scalars['String']['input'];
  /** Discord entity type for integration */
  discordEntityType?: InputMaybe<Scalars['String']['input']>;
  /** Employer website URL */
  employerWebsite?: InputMaybe<Scalars['String']['input']>;
  /** Activity fields configuration as JSON */
  fields?: InputMaybe<Scalars['JSON']['input']>;
  /** Icon identifier (e.g., mdi-check) */
  icon: Scalars['String']['input'];
  /** Instruction configuration as JSON */
  instruction?: InputMaybe<Scalars['JSON']['input']>;
  /** Interview request text */
  interviewRequest?: InputMaybe<Scalars['String']['input']>;
  /** Intro video URL */
  introVideo?: InputMaybe<Scalars['String']['input']>;
  /** Whether this is a preview activity */
  isPreview?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether this activity can be skipped */
  isSkippable?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether this is a team-based activity */
  isTeamAdk?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether this uses VideoAsk integration */
  isVideoask?: InputMaybe<Scalars['Boolean']['input']>;
  /** Name of the activity */
  name: Scalars['String']['input'];
  /** Whether this activity is optional */
  optional?: InputMaybe<Scalars['Boolean']['input']>;
  /** Permissions configuration as JSON */
  permissions?: InputMaybe<Scalars['JSON']['input']>;
  /** Position/order of the activity */
  position?: InputMaybe<Scalars['Int']['input']>;
  /** Preset fields configuration as JSON */
  presetFields?: InputMaybe<Scalars['JSON']['input']>;
  /** Preview mode flag */
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  /** Project scope text */
  projectScope?: InputMaybe<Scalars['String']['input']>;
  /** Whether this activity is required */
  required?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether setup is required for this activity */
  setupRequired: Scalars['Boolean']['input'];
  /** Status of the activity (active/inactive) */
  status: Scalars['Boolean']['input'];
  /** Status type (draft, published, archived) */
  statusType?: InputMaybe<Scalars['String']['input']>;
  /** Styling configuration as JSON */
  styling?: InputMaybe<Scalars['JSON']['input']>;
  /** Estimated time to solve the problem in minutes */
  timeToSolveProblem?: InputMaybe<Scalars['Int']['input']>;
};

/** Input for creating bank account using Stripe token (recommended for security) */
export type CreateBankAccountTokenInput = {
  /** Stripe bank account token (btok_xxx) from Stripe.js */
  token: Scalars['String']['input'];
};

/** Input for creating a Stripe Checkout session */
export type CreateCheckoutSessionInput = {
  /** Payment amount in dollars */
  amount: Scalars['Float']['input'];
  /** Cancel URL if user cancels payment */
  cancelUrl?: InputMaybe<Scalars['String']['input']>;
  /** Whether this is a sponsorship payment (default: false) */
  isSponsor?: InputMaybe<Scalars['Boolean']['input']>;
  /** Program ID for the checkout session */
  programId: Scalars['String']['input'];
  /** Student ID (if different from authenticated user) */
  studentId?: InputMaybe<Scalars['String']['input']>;
  /** Success URL after payment completion */
  successUrl?: InputMaybe<Scalars['String']['input']>;
};

export type CreateEndorsementRequestInput = {
  adkIndex: Scalars['Float']['input'];
  criteria: Array<CriterionInput>;
  customEmailMessage?: InputMaybe<Scalars['String']['input']>;
  endorserEmail: Scalars['String']['input'];
  endorserInfo?: InputMaybe<Scalars['String']['input']>;
  endorserName: Scalars['String']['input'];
  endorserRelationship?: InputMaybe<Scalars['String']['input']>;
  expirationDays?: InputMaybe<Scalars['Float']['input']>;
  fieldIndex: Scalars['Float']['input'];
  programId: Scalars['String']['input'];
  studentId?: InputMaybe<Scalars['String']['input']>;
};

export type CreateEndorsementRequestResponse = {
  __typename?: 'CreateEndorsementRequestResponse';
  message?: Maybe<Scalars['String']['output']>;
  requestId?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
  token?: Maybe<Scalars['String']['output']>;
};

export type CreateFamilyFaceCropInput = {
  /** Bbox height as ratio of photo height (0..1) */
  bboxHRatio: Scalars['Float']['input'];
  /** Bbox width as ratio of photo width (0..1) */
  bboxWRatio: Scalars['Float']['input'];
  /** Bbox top-left X as ratio of photo width (0..1) */
  bboxXRatio: Scalars['Float']['input'];
  /** Bbox top-left Y as ratio of photo height (0..1) */
  bboxYRatio: Scalars['Float']['input'];
  photoId: Scalars['ID']['input'];
};

export type CreateFamilyInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};

export type CreateFamilyRelationshipInput = {
  familyId: Scalars['ID']['input'];
  fromMemberId: Scalars['ID']['input'];
  toMemberId: Scalars['ID']['input'];
  type: Scalars['String']['input'];
};

export type CreateFamilyViewInput = {
  downDepth?: InputMaybe<Scalars['Int']['input']>;
  familyId: Scalars['ID']['input'];
  includeSpouses?: InputMaybe<Scalars['Boolean']['input']>;
  rootMemberId: Scalars['ID']['input'];
  titleEn?: InputMaybe<Scalars['String']['input']>;
  titleZh?: InputMaybe<Scalars['String']['input']>;
  upDepth?: InputMaybe<Scalars['Int']['input']>;
};

/** Input for creating a Stripe invoice with product prices */
export type CreateInvoiceInput = {
  /** Whether to automatically finalize the invoice (default: true) */
  autoAdvance?: InputMaybe<Scalars['Boolean']['input']>;
  /** Stripe Customer ID */
  customerId: Scalars['String']['input'];
  /** Invoice description */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Line items for the invoice (using Stripe Price IDs) */
  lineItems: Array<InvoiceLineItemInput>;
};

/** Response from creating a Stripe invoice */
export type CreateInvoiceResponse = {
  __typename?: 'CreateInvoiceResponse';
  /** Currency code */
  currency: Scalars['String']['output'];
  /** Hosted invoice page URL */
  hostedInvoiceUrl?: Maybe<Scalars['String']['output']>;
  /** Stripe Invoice ID */
  invoiceId: Scalars['String']['output'];
  /** Invoice PDF URL */
  invoicePdf?: Maybe<Scalars['String']['output']>;
  /** Invoice status */
  status: Scalars['String']['output'];
  /** Total amount in cents */
  total: Scalars['Int']['output'];
};

export type CreateJournalInput = {
  activityName?: InputMaybe<Scalars['String']['input']>;
  activityPosition?: InputMaybe<Scalars['Int']['input']>;
  completionPercentage?: InputMaybe<Scalars['Float']['input']>;
  content: Scalars['String']['input'];
  email?: InputMaybe<Scalars['String']['input']>;
  emojis?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  programId: Scalars['String']['input'];
  programName?: InputMaybe<Scalars['String']['input']>;
  studentId: Scalars['String']['input'];
  title?: InputMaybe<Scalars['String']['input']>;
  totalActivities?: InputMaybe<Scalars['Int']['input']>;
  triggerType?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

/** Input for creating a platform donation subscription */
export type CreatePlatformDonationInput = {
  /** User ID who will own the subscription */
  userId: Scalars['String']['input'];
};

export type CreateReportShareInput = {
  /** When the share link expires */
  expiresIn?: InputMaybe<ShareExpiryOption>;
  /** Organization ID */
  organizationId: Scalars['String']['input'];
  /** Optional password for additional security */
  password?: InputMaybe<Scalars['String']['input']>;
  /** Report template ID to share */
  templateId: Scalars['String']['input'];
};

export type CreateReportTemplateInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  exportConfig?: InputMaybe<ReportExportConfigInput>;
  fields: Array<ReportFieldInput>;
  name: Scalars['String']['input'];
  organizationId: Scalars['String']['input'];
  programSchemaId: Scalars['String']['input'];
};

/** Input for creating a Stripe Connect account */
export type CreateStripeAccountInput = {
  /** Business type (individual or company) */
  businessType?: InputMaybe<Scalars['String']['input']>;
  /** Country code (US, CA, etc.) */
  country?: Scalars['String']['input'];
  /** Account holder email */
  email: Scalars['String']['input'];
};

/** Input for creating a student payment checkout session */
export type CreateStudentPaymentInput = {
  /** Amount in dollars (min: $0.50, max: $10,000). Student receives 100%. */
  amount: Scalars['Float']['input'];
  /** Cancel redirect URL if user cancels payment */
  cancelUrl?: InputMaybe<Scalars['String']['input']>;
  /** Payment description/memo */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Program ID the student worked on */
  programId: Scalars['String']['input'];
  /** Student ID to receive payment */
  studentId: Scalars['String']['input'];
  /** Success redirect URL after payment completion */
  successUrl?: InputMaybe<Scalars['String']['input']>;
};

/** Input for creating a wallet payment checkout session */
export type CreateWalletPaymentInput = {
  /** Amount in dollars (min: $0.50, max: $10,000) */
  amount: Scalars['Float']['input'];
  /** Cancel redirect URL if user cancels payment */
  cancelUrl?: InputMaybe<Scalars['String']['input']>;
  /** ADK activity name where checkout is happening (e.g., "start" or unsponsored activity name) */
  checkoutActivity?: InputMaybe<Scalars['String']['input']>;
  /** Payment description/memo */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Type of payment: sponsorship (0% fee - TO students) or student_payment (10% fee - TO organizers) */
  paymentType: WalletPaymentType;
  /** Program ID the payment is associated with */
  programId: Scalars['String']['input'];
  /** User ID who will receive the payment (wallet owner) */
  recipientId: Scalars['String']['input'];
  /** Success redirect URL after payment completion */
  successUrl?: InputMaybe<Scalars['String']['input']>;
};

/** Input for creating a wallet payment intent for embedded card forms */
export type CreateWalletPaymentIntentInput = {
  /** Amount in dollars (min: $0.50, max: $10,000) */
  amount: Scalars['Float']['input'];
  /** ADK activity name where checkout is happening (e.g., "start" or unsponsored activity name) */
  checkoutActivity?: InputMaybe<Scalars['String']['input']>;
  /** Payment description/memo */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Type of payment: sponsorship (0% fee - TO students) or student_payment (10% fee - TO organizers) */
  paymentType: WalletPaymentType;
  /** Program ID the payment is associated with */
  programId: Scalars['String']['input'];
  /** User ID who will receive the payment (wallet owner) */
  recipientId: Scalars['String']['input'];
};

export type CreatorEventCountAggregate = {
  __typename?: 'CreatorEventCountAggregate';
  _all: Scalars['Int']['output'];
  action: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  input: Scalars['Int']['output'];
  metadata: Scalars['Int']['output'];
  output: Scalars['Int']['output'];
  scope: Scalars['Int']['output'];
  threadId: Scalars['Int']['output'];
  userId: Scalars['Int']['output'];
};

export type CreatorEventMaxAggregate = {
  __typename?: 'CreatorEventMaxAggregate';
  action?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  scope?: Maybe<Scalars['String']['output']>;
  threadId?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
};

export type CreatorEventMinAggregate = {
  __typename?: 'CreatorEventMinAggregate';
  action?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  scope?: Maybe<Scalars['String']['output']>;
  threadId?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
};

/**
 * Embedded message within a CreatorThread
 * Note: id and createdAt are set in application code since @default is not supported on composite types
 */
export type CreatorMessage = {
  __typename?: 'CreatorMessage';
  content: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['String']['output'];
  metadata?: Maybe<Scalars['JSON']['output']>;
  role: Scalars['String']['output'];
};

export type CreatorMessageCreateInput = {
  content: Scalars['String']['input'];
  createdAt: Scalars['DateTime']['input'];
  id: Scalars['String']['input'];
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  role: Scalars['String']['input'];
};

export type CreatorMessageObjectEqualityInput = {
  content: Scalars['String']['input'];
  createdAt: Scalars['DateTime']['input'];
  id: Scalars['String']['input'];
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  role: Scalars['String']['input'];
};

export type CreatorMessageOutput = {
  __typename?: 'CreatorMessageOutput';
  content: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['String']['output'];
  metadata?: Maybe<Scalars['JSON']['output']>;
  role: Scalars['String']['output'];
};

/**
 * AI Creator thread for multi-turn chat conversations
 * Each thread tracks a user's creation session at a specific scope/entity
 */
export type CreatorThread = {
  __typename?: 'CreatorThread';
  createdAt: Scalars['DateTime']['output'];
  entityId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isArchived: Scalars['Boolean']['output'];
  messages?: Maybe<Array<CreatorMessage>>;
  scope: Scalars['String']['output'];
  title?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  user: User;
  userId: Scalars['String']['output'];
};

export type CreatorThreadCountAggregate = {
  __typename?: 'CreatorThreadCountAggregate';
  _all: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  entityId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  isArchived: Scalars['Int']['output'];
  scope: Scalars['Int']['output'];
  title: Scalars['Int']['output'];
  updatedAt: Scalars['Int']['output'];
  userId: Scalars['Int']['output'];
};

export type CreatorThreadCreateManyUserInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  entityId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isArchived?: InputMaybe<Scalars['Boolean']['input']>;
  messages?: InputMaybe<Array<CreatorMessageCreateInput>>;
  scope: Scalars['String']['input'];
  title?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CreatorThreadCreateManyUserInputEnvelope = {
  data: Array<CreatorThreadCreateManyUserInput>;
};

export type CreatorThreadCreateNestedManyWithoutUserInput = {
  connect?: InputMaybe<Array<CreatorThreadWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<CreatorThreadCreateOrConnectWithoutUserInput>>;
  create?: InputMaybe<Array<CreatorThreadCreateWithoutUserInput>>;
  createMany?: InputMaybe<CreatorThreadCreateManyUserInputEnvelope>;
};

export type CreatorThreadCreateOrConnectWithoutUserInput = {
  create: CreatorThreadCreateWithoutUserInput;
  where: CreatorThreadWhereUniqueInput;
};

export type CreatorThreadCreateWithoutUserInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  entityId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isArchived?: InputMaybe<Scalars['Boolean']['input']>;
  messages?: InputMaybe<Array<CreatorMessageCreateInput>>;
  scope: Scalars['String']['input'];
  title?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CreatorThreadListRelationFilter = {
  every?: InputMaybe<CreatorThreadWhereInput>;
  none?: InputMaybe<CreatorThreadWhereInput>;
  some?: InputMaybe<CreatorThreadWhereInput>;
};

export type CreatorThreadMaxAggregate = {
  __typename?: 'CreatorThreadMaxAggregate';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  entityId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  isArchived?: Maybe<Scalars['Boolean']['output']>;
  scope?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
};

export type CreatorThreadMinAggregate = {
  __typename?: 'CreatorThreadMinAggregate';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  entityId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  isArchived?: Maybe<Scalars['Boolean']['output']>;
  scope?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
};

export type CreatorThreadOutput = {
  __typename?: 'CreatorThreadOutput';
  createdAt: Scalars['DateTime']['output'];
  entityId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  messages: Array<CreatorMessageOutput>;
  scope: Scalars['String']['output'];
  title?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  userId: Scalars['String']['output'];
};

export type CreatorThreadScalarWhereInput = {
  AND?: InputMaybe<Array<CreatorThreadScalarWhereInput>>;
  NOT?: InputMaybe<Array<CreatorThreadScalarWhereInput>>;
  OR?: InputMaybe<Array<CreatorThreadScalarWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  entityId?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<StringFilter>;
  isArchived?: InputMaybe<BoolFilter>;
  scope?: InputMaybe<StringFilter>;
  title?: InputMaybe<StringNullableFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  userId?: InputMaybe<StringFilter>;
};

export type CreatorThreadUpdateManyMutationInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  entityId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  isArchived?: InputMaybe<BoolFieldUpdateOperationsInput>;
  messages?: InputMaybe<Array<CreatorMessageCreateInput>>;
  scope?: InputMaybe<StringFieldUpdateOperationsInput>;
  title?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type CreatorThreadUpdateManyWithWhereWithoutUserInput = {
  data: CreatorThreadUpdateManyMutationInput;
  where: CreatorThreadScalarWhereInput;
};

export type CreatorThreadUpdateManyWithoutUserNestedInput = {
  connect?: InputMaybe<Array<CreatorThreadWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<CreatorThreadCreateOrConnectWithoutUserInput>>;
  create?: InputMaybe<Array<CreatorThreadCreateWithoutUserInput>>;
  createMany?: InputMaybe<CreatorThreadCreateManyUserInputEnvelope>;
  delete?: InputMaybe<Array<CreatorThreadWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<CreatorThreadScalarWhereInput>>;
  disconnect?: InputMaybe<Array<CreatorThreadWhereUniqueInput>>;
  set?: InputMaybe<Array<CreatorThreadWhereUniqueInput>>;
  update?: InputMaybe<Array<CreatorThreadUpdateWithWhereUniqueWithoutUserInput>>;
  updateMany?: InputMaybe<Array<CreatorThreadUpdateManyWithWhereWithoutUserInput>>;
  upsert?: InputMaybe<Array<CreatorThreadUpsertWithWhereUniqueWithoutUserInput>>;
};

export type CreatorThreadUpdateWithWhereUniqueWithoutUserInput = {
  data: CreatorThreadUpdateWithoutUserInput;
  where: CreatorThreadWhereUniqueInput;
};

export type CreatorThreadUpdateWithoutUserInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  entityId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  isArchived?: InputMaybe<BoolFieldUpdateOperationsInput>;
  messages?: InputMaybe<Array<CreatorMessageCreateInput>>;
  scope?: InputMaybe<StringFieldUpdateOperationsInput>;
  title?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type CreatorThreadUpsertWithWhereUniqueWithoutUserInput = {
  create: CreatorThreadCreateWithoutUserInput;
  update: CreatorThreadUpdateWithoutUserInput;
  where: CreatorThreadWhereUniqueInput;
};

export type CreatorThreadWhereInput = {
  AND?: InputMaybe<Array<CreatorThreadWhereInput>>;
  NOT?: InputMaybe<Array<CreatorThreadWhereInput>>;
  OR?: InputMaybe<Array<CreatorThreadWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  entityId?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<StringFilter>;
  isArchived?: InputMaybe<BoolFilter>;
  messages?: InputMaybe<Array<CreatorMessageObjectEqualityInput>>;
  scope?: InputMaybe<StringFilter>;
  title?: InputMaybe<StringNullableFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  user?: InputMaybe<UserRelationFilter>;
  userId?: InputMaybe<StringFilter>;
};

export type CreatorThreadWhereUniqueInput = {
  AND?: InputMaybe<Array<CreatorThreadWhereInput>>;
  NOT?: InputMaybe<Array<CreatorThreadWhereInput>>;
  OR?: InputMaybe<Array<CreatorThreadWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  entityId?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  isArchived?: InputMaybe<BoolFilter>;
  messages?: InputMaybe<Array<CreatorMessageObjectEqualityInput>>;
  scope?: InputMaybe<StringFilter>;
  title?: InputMaybe<StringNullableFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  user?: InputMaybe<UserRelationFilter>;
  userId?: InputMaybe<StringFilter>;
};

export type CredentialTemplateCountAggregate = {
  __typename?: 'CredentialTemplateCountAggregate';
  _all: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  createdBy: Scalars['Int']['output'];
  description: Scalars['Int']['output'];
  domain: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  isValidated: Scalars['Int']['output'];
  name: Scalars['Int']['output'];
  organizationId: Scalars['Int']['output'];
  organizationLogo: Scalars['Int']['output'];
  organizationName: Scalars['Int']['output'];
  programId: Scalars['Int']['output'];
  status: Scalars['Int']['output'];
  type: Scalars['Int']['output'];
  validatedAt: Scalars['Int']['output'];
  validatedBy: Scalars['Int']['output'];
  validatorEmail: Scalars['Int']['output'];
};

export type CredentialTemplateMaxAggregate = {
  __typename?: 'CredentialTemplateMaxAggregate';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  domain?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  isValidated?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  organizationId?: Maybe<Scalars['String']['output']>;
  organizationLogo?: Maybe<Scalars['String']['output']>;
  organizationName?: Maybe<Scalars['String']['output']>;
  programId?: Maybe<Scalars['String']['output']>;
  status?: Maybe<CredentialTemplateStatus>;
  type?: Maybe<CredentialTemplateType>;
  validatedAt?: Maybe<Scalars['DateTime']['output']>;
  validatedBy?: Maybe<Scalars['String']['output']>;
  validatorEmail?: Maybe<Scalars['String']['output']>;
};

export type CredentialTemplateMinAggregate = {
  __typename?: 'CredentialTemplateMinAggregate';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  domain?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  isValidated?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  organizationId?: Maybe<Scalars['String']['output']>;
  organizationLogo?: Maybe<Scalars['String']['output']>;
  organizationName?: Maybe<Scalars['String']['output']>;
  programId?: Maybe<Scalars['String']['output']>;
  status?: Maybe<CredentialTemplateStatus>;
  type?: Maybe<CredentialTemplateType>;
  validatedAt?: Maybe<Scalars['DateTime']['output']>;
  validatedBy?: Maybe<Scalars['String']['output']>;
  validatorEmail?: Maybe<Scalars['String']['output']>;
};

/** Status enum for CredentialTemplate */
export enum CredentialTemplateStatus {
  Active = 'active',
  Archived = 'archived'
}

/** Type enum for CredentialTemplate */
export enum CredentialTemplateType {
  Credential = 'credential',
  Reward = 'reward'
}

export type Criterion = {
  __typename?: 'Criterion';
  id: Scalars['String']['output'];
  label: Scalars['String']['output'];
};

export type CriterionInput = {
  id: Scalars['String']['input'];
  label: Scalars['String']['input'];
};

export type CurrentUser = {
  __typename?: 'CurrentUser';
  dbUser?: Maybe<AuthUserRecord>;
  email?: Maybe<Scalars['String']['output']>;
  emailVerified?: Maybe<Scalars['Boolean']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  fullName?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  phoneVerified?: Maybe<Scalars['Boolean']['output']>;
  profile?: Maybe<ProfileImage>;
  profileImg?: Maybe<Scalars['String']['output']>;
  shareCode?: Maybe<Scalars['String']['output']>;
  stripeConnectId?: Maybe<Scalars['String']['output']>;
  stripeCurrentlyDue?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  stripeVerified?: Maybe<Scalars['String']['output']>;
  userId: Scalars['String']['output'];
  userTypes?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  username?: Maybe<Scalars['String']['output']>;
};

export type CustomerPortalSession = {
  __typename?: 'CustomerPortalSession';
  url: Scalars['String']['output'];
};

/** Date of birth for identity verification */
export type DateOfBirthInput = {
  /** Day (1-31) */
  day: Scalars['Float']['input'];
  /** Month (1-12) */
  month: Scalars['Float']['input'];
  /** Year (e.g., 1990) */
  year: Scalars['Float']['input'];
};

export type DateTimeFieldUpdateOperationsInput = {
  set?: InputMaybe<Scalars['DateTime']['input']>;
};

export type DateTimeFilter = {
  equals?: InputMaybe<Scalars['DateTime']['input']>;
  gt?: InputMaybe<Scalars['DateTime']['input']>;
  gte?: InputMaybe<Scalars['DateTime']['input']>;
  in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  lt?: InputMaybe<Scalars['DateTime']['input']>;
  lte?: InputMaybe<Scalars['DateTime']['input']>;
  not?: InputMaybe<NestedDateTimeFilter>;
  notIn?: InputMaybe<Array<Scalars['DateTime']['input']>>;
};

export type DateTimeNullableFilter = {
  equals?: InputMaybe<Scalars['DateTime']['input']>;
  gt?: InputMaybe<Scalars['DateTime']['input']>;
  gte?: InputMaybe<Scalars['DateTime']['input']>;
  in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  isSet?: InputMaybe<Scalars['Boolean']['input']>;
  lt?: InputMaybe<Scalars['DateTime']['input']>;
  lte?: InputMaybe<Scalars['DateTime']['input']>;
  not?: InputMaybe<NestedDateTimeNullableFilter>;
  notIn?: InputMaybe<Array<Scalars['DateTime']['input']>>;
};

/** Input for deleting a bank account */
export type DeleteBankAccountInput = {
  /** Bank account ID to delete */
  bankAccountId: Scalars['String']['input'];
};

export type DeleteVideoAskInput = {
  adkName: Scalars['String']['input'];
  keyName: Scalars['String']['input'];
  programId: Scalars['String']['input'];
  publicId?: InputMaybe<Scalars['String']['input']>;
  userType: Scalars['String']['input'];
};

export type DeviceInfo = {
  __typename?: 'DeviceInfo';
  browser: Scalars['String']['output'];
  firstSeen: Scalars['String']['output'];
  id: Scalars['String']['output'];
  language: Scalars['String']['output'];
  platform: Scalars['String']['output'];
  timeZone: Scalars['String']['output'];
};

export type DeviceInfoInput = {
  browser: Scalars['String']['input'];
  firstSeen: Scalars['String']['input'];
  id: Scalars['String']['input'];
  language: Scalars['String']['input'];
  platform: Scalars['String']['input'];
  timeZone: Scalars['String']['input'];
};

export type DiscordLinkTokenCountAggregate = {
  __typename?: 'DiscordLinkTokenCountAggregate';
  _all: Scalars['Int']['output'];
  context: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  expiresAt: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  token: Scalars['Int']['output'];
  used: Scalars['Int']['output'];
  usedAt: Scalars['Int']['output'];
};

export type DiscordLinkTokenMaxAggregate = {
  __typename?: 'DiscordLinkTokenMaxAggregate';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  expiresAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  token?: Maybe<Scalars['String']['output']>;
  used?: Maybe<Scalars['Boolean']['output']>;
  usedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type DiscordLinkTokenMinAggregate = {
  __typename?: 'DiscordLinkTokenMinAggregate';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  expiresAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  token?: Maybe<Scalars['String']['output']>;
  used?: Maybe<Scalars['Boolean']['output']>;
  usedAt?: Maybe<Scalars['DateTime']['output']>;
};

/** User discovered via domain matching */
export type DiscoveredDomainUser = {
  __typename?: 'DiscoveredDomainUser';
  /** Email domain (e.g., 'acme.com') */
  domain: Scalars['String']['output'];
  /** User's email address */
  email: Scalars['String']['output'];
  /** User's first name */
  firstName?: Maybe<Scalars['String']['output']>;
  /** User ID */
  id: Scalars['ID']['output'];
  /** Whether this user's domain is the org's primary domain */
  isPrimaryDomain: Scalars['Boolean']['output'];
  /** User's last name */
  lastName?: Maybe<Scalars['String']['output']>;
  /** Profile image URL */
  profileImg?: Maybe<Scalars['String']['output']>;
};

export type DiscoveredField = {
  __typename?: 'DiscoveredField';
  activityName?: Maybe<Scalars['String']['output']>;
  dataType: Scalars['String']['output'];
  displayName: Scalars['String']['output'];
  fieldIndex?: Maybe<Scalars['Int']['output']>;
  fieldName?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  isPrimary: Scalars['Boolean']['output'];
  isTeamField: Scalars['Boolean']['output'];
  path: Scalars['String']['output'];
  positionHint: Scalars['Int']['output'];
  source: Scalars['String']['output'];
  suggestedArrayHandling?: Maybe<Scalars['String']['output']>;
  widgetType?: Maybe<Scalars['String']['output']>;
};

export type DiscoveredFieldCategory = {
  __typename?: 'DiscoveredFieldCategory';
  activityName?: Maybe<Scalars['String']['output']>;
  categoryId: Scalars['String']['output'];
  categoryName: Scalars['String']['output'];
  fields: Array<DiscoveredField>;
  icon?: Maybe<Scalars['String']['output']>;
  isActivity: Scalars['Boolean']['output'];
  position: Scalars['Int']['output'];
};

/** Input for dismissing AIPM onboarding */
export type DismissOnboardingInput = {
  /** Program ID for which to dismiss onboarding */
  programId: Scalars['String']['input'];
};

/** Result of dismissing AIPM onboarding */
export type DismissalResultType = {
  __typename?: 'DismissalResultType';
  /** Whether dismissal was recorded */
  dismissed: Scalars['Boolean']['output'];
  /** When the dismissal expires (24-hour window) */
  expiresAt: Scalars['DateTime']['output'];
};

export type DocumentValidationStatusResponse = {
  __typename?: 'DocumentValidationStatusResponse';
  /** Error message if query failed */
  message?: Maybe<Scalars['String']['output']>;
  /** Whether the query was successful */
  ok: Scalars['Boolean']['output'];
  /** The validation result */
  result?: Maybe<AiValidationResult>;
};

export type DomainManagementResponse = {
  __typename?: 'DomainManagementResponse';
  /** Updated list of domains */
  domains?: Maybe<Array<Scalars['String']['output']>>;
  /** Status message */
  message: Scalars['String']['output'];
  /** Primary domain after operation */
  primaryDomain?: Maybe<Scalars['String']['output']>;
  /** Whether the operation was successful */
  success: Scalars['Boolean']['output'];
};

/** Domain user discovery response */
export type DomainUserDiscoveryOutput = {
  __typename?: 'DomainUserDiscoveryOutput';
  /** Total count of matching users (before limit applied) */
  totalCount: Scalars['Int']['output'];
  /** Discovered users matching org domains */
  users: Array<DiscoveredDomainUser>;
};

/** A unit-agnostic duration: { value: 2, unit: "hours" } */
export type Duration = {
  __typename?: 'Duration';
  /** minutes | hours | days | weeks | months */
  unit: Scalars['String']['output'];
  value: Scalars['Int']['output'];
};

/**
 * Ecosystem is the highest-level creation on PilotCity — a shared environment
 * where People, Places, and Programs converge around an Objective.
 * Hierarchy: Widget > Activity > Program > Initiative > Ecosystem
 */
export type Ecosystem = {
  __typename?: 'Ecosystem';
  blueprintKey?: Maybe<Scalars['String']['output']>;
  /** Sparse cell values — only filled intersections stored */
  cells?: Maybe<Array<EcosystemCell>>;
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['String']['output'];
  creatorName?: Maybe<Scalars['String']['output']>;
  /** company | school | city | individual | non_profit */
  creatorType?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  initiatives?: Maybe<Array<EcosystemInitiative>>;
  name: Scalars['String']['output'];
  objective?: Maybe<EcosystemObjective>;
  /** Row headers (ordered) */
  orgTypes?: Maybe<Array<Scalars['String']['output']>>;
  organizationId?: Maybe<Scalars['String']['output']>;
  /** Column headers with name + description (new format) */
  outcomeDetails?: Maybe<Array<EcosystemOutcomeDetail>>;
  /** Column headers (ordered) — legacy string format */
  outcomes?: Maybe<Array<Scalars['String']['output']>>;
  placeIds?: Maybe<Array<Scalars['String']['output']>>;
  shareToken?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  /** private | shared | public */
  visibility: Scalars['String']['output'];
};

/** A single cell in the Outcomes × OrgTypes matrix */
export type EcosystemCell = {
  __typename?: 'EcosystemCell';
  /** Program concept names/descriptions (one per line in UI) */
  concepts?: Maybe<Array<Scalars['String']['output']>>;
  /** Row key — matches an entry in orgTypes[] */
  orgType: Scalars['String']['output'];
  /** Column key — matches an entry in outcomes[] */
  outcome: Scalars['String']['output'];
  /** Linked ProgramDesign IDs (when AI-generated) */
  programDesignIds?: Maybe<Array<Scalars['String']['output']>>;
  /** Metadata tags/keywords for this cell */
  tags?: Maybe<Array<Scalars['String']['output']>>;
};

export type EcosystemCountAggregate = {
  __typename?: 'EcosystemCountAggregate';
  _all: Scalars['Int']['output'];
  blueprintKey: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  createdBy: Scalars['Int']['output'];
  creatorName: Scalars['Int']['output'];
  creatorType: Scalars['Int']['output'];
  description: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['Int']['output'];
  orgTypes: Scalars['Int']['output'];
  organizationId: Scalars['Int']['output'];
  outcomes: Scalars['Int']['output'];
  placeIds: Scalars['Int']['output'];
  shareToken: Scalars['Int']['output'];
  updatedAt: Scalars['Int']['output'];
  visibility: Scalars['Int']['output'];
};

/** A sequenced group of programs targeting specific outcomes */
export type EcosystemInitiative = {
  __typename?: 'EcosystemInitiative';
  duration?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  leadPartner?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  programIds?: Maybe<Array<Scalars['String']['output']>>;
  targetOutcomes?: Maybe<Array<Scalars['String']['output']>>;
};

export type EcosystemMaxAggregate = {
  __typename?: 'EcosystemMaxAggregate';
  blueprintKey?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  creatorName?: Maybe<Scalars['String']['output']>;
  creatorType?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  organizationId?: Maybe<Scalars['String']['output']>;
  shareToken?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  visibility?: Maybe<Scalars['String']['output']>;
};

export type EcosystemMinAggregate = {
  __typename?: 'EcosystemMinAggregate';
  blueprintKey?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  creatorName?: Maybe<Scalars['String']['output']>;
  creatorType?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  organizationId?: Maybe<Scalars['String']['output']>;
  shareToken?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  visibility?: Maybe<Scalars['String']['output']>;
};

/** The driving objective of the ecosystem */
export type EcosystemObjective = {
  __typename?: 'EcosystemObjective';
  /** economic_development | workforce | civic | education | innovation */
  category?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  label: Scalars['String']['output'];
  /** e.g. "3-5 years" */
  timeHorizon?: Maybe<Scalars['String']['output']>;
};

/** Column header with name and optional description */
export type EcosystemOutcomeDetail = {
  __typename?: 'EcosystemOutcomeDetail';
  /** Funnel description: "Foot Traffic → Repeat Visits → Familiarity → Tour → Lease" */
  description?: Maybe<Scalars['String']['output']>;
  /** Display name: "Events" */
  name: Scalars['String']['output'];
};

/**
 * A physical place that can be contributed to ecosystems.
 * Named EcosystemPlace to avoid collision with existing Place GraphQL type in location service.
 */
export type EcosystemPlace = {
  __typename?: 'EcosystemPlace';
  address?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  ownerOrganizationId?: Maybe<Scalars['String']['output']>;
  tags?: Maybe<Array<Scalars['String']['output']>>;
  /** building | campus | street | block | neighborhood | district | city | county | state | country */
  type?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type EcosystemPlaceCountAggregate = {
  __typename?: 'EcosystemPlaceCountAggregate';
  _all: Scalars['Int']['output'];
  address: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  description: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['Int']['output'];
  ownerOrganizationId: Scalars['Int']['output'];
  tags: Scalars['Int']['output'];
  type: Scalars['Int']['output'];
  updatedAt: Scalars['Int']['output'];
};

export type EcosystemPlaceMaxAggregate = {
  __typename?: 'EcosystemPlaceMaxAggregate';
  address?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  ownerOrganizationId?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type EcosystemPlaceMinAggregate = {
  __typename?: 'EcosystemPlaceMinAggregate';
  address?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  ownerOrganizationId?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type EcosystemViewLogCountAggregate = {
  __typename?: 'EcosystemViewLogCountAggregate';
  _all: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  ecosystemId: Scalars['Int']['output'];
  email: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  ip: Scalars['Int']['output'];
  name: Scalars['Int']['output'];
  userAgent: Scalars['Int']['output'];
  userId: Scalars['Int']['output'];
  viewerType: Scalars['Int']['output'];
};

export type EcosystemViewLogMaxAggregate = {
  __typename?: 'EcosystemViewLogMaxAggregate';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  ecosystemId?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  ip?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  userAgent?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
  viewerType?: Maybe<Scalars['String']['output']>;
};

export type EcosystemViewLogMinAggregate = {
  __typename?: 'EcosystemViewLogMinAggregate';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  ecosystemId?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  ip?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  userAgent?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
  viewerType?: Maybe<Scalars['String']['output']>;
};

/** Result of verifying email OTP code */
export type EmailVerificationResultType = {
  __typename?: 'EmailVerificationResultType';
  /** Error message if verification failed */
  error?: Maybe<Scalars['String']['output']>;
  /** Whether verification was successful */
  verified: Scalars['Boolean']['output'];
};

/** Result of sending email verification OTP */
export type EmailVerificationSendResultType = {
  __typename?: 'EmailVerificationSendResultType';
  /** Number of verification attempts remaining */
  attemptsRemaining: Scalars['Float']['output'];
  /** Whether OTP was sent successfully */
  sent: Scalars['Boolean']['output'];
};

export type Employer = {
  __typename?: 'Employer';
  employeeCount: Scalars['String']['output'];
  id: Scalars['String']['output'];
  industry: Scalars['String']['output'];
  jurisdiction: Scalars['String']['output'];
  moreNotes: Scalars['String']['output'];
  name: Scalars['String']['output'];
  pathways: Array<Scalars['String']['output']>;
  rank: Scalars['Int']['output'];
  schoolDistrict: Scalars['String']['output'];
  shortDescription: Scalars['String']['output'];
  website: Scalars['String']['output'];
};

export type EmployerConnection = {
  __typename?: 'EmployerConnection';
  hasMore: Scalars['Boolean']['output'];
  nextOffset?: Maybe<Scalars['String']['output']>;
  records: Array<Employer>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type EmployerPortfolio = {
  __typename?: 'EmployerPortfolio';
  airtable?: Maybe<Array<EmployerPortfolioAirtable>>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  employerName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  industry: Scalars['String']['output'];
  jobTitle: Scalars['String']['output'];
  last_modified_at?: Maybe<Scalars['DateTime']['output']>;
  last_synced_at?: Maybe<Scalars['DateTime']['output']>;
  organizerName?: Maybe<Scalars['String']['output']>;
  primaryProduct: Scalars['String']['output'];
  work: EmployerPortfolioWork;
};

export type EmployerPortfolioAirtable = {
  __typename?: 'EmployerPortfolioAirtable';
  airtable_id: Scalars['String']['output'];
  created_at: Scalars['DateTime']['output'];
  last_modified_at: Scalars['DateTime']['output'];
  spreadsheet: Scalars['String']['output'];
};

export type EmployerPortfolioCountAggregate = {
  __typename?: 'EmployerPortfolioCountAggregate';
  _all: Scalars['Int']['output'];
  deletedAt: Scalars['Int']['output'];
  employerName: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  industry: Scalars['Int']['output'];
  jobTitle: Scalars['Int']['output'];
  last_modified_at: Scalars['Int']['output'];
  last_synced_at: Scalars['Int']['output'];
  organizerName: Scalars['Int']['output'];
  primaryProduct: Scalars['Int']['output'];
};

export type EmployerPortfolioMaxAggregate = {
  __typename?: 'EmployerPortfolioMaxAggregate';
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  employerName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  industry?: Maybe<Scalars['String']['output']>;
  jobTitle?: Maybe<Scalars['String']['output']>;
  last_modified_at?: Maybe<Scalars['DateTime']['output']>;
  last_synced_at?: Maybe<Scalars['DateTime']['output']>;
  organizerName?: Maybe<Scalars['String']['output']>;
  primaryProduct?: Maybe<Scalars['String']['output']>;
};

export type EmployerPortfolioMinAggregate = {
  __typename?: 'EmployerPortfolioMinAggregate';
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  employerName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  industry?: Maybe<Scalars['String']['output']>;
  jobTitle?: Maybe<Scalars['String']['output']>;
  last_modified_at?: Maybe<Scalars['DateTime']['output']>;
  last_synced_at?: Maybe<Scalars['DateTime']['output']>;
  organizerName?: Maybe<Scalars['String']['output']>;
  primaryProduct?: Maybe<Scalars['String']['output']>;
};

export type EmployerPortfolioWork = {
  __typename?: 'EmployerPortfolioWork';
  city: Scalars['String']['output'];
  country?: Maybe<Scalars['String']['output']>;
  countryCode?: Maybe<Scalars['String']['output']>;
  county?: Maybe<Scalars['String']['output']>;
  formattedAddress?: Maybe<Scalars['String']['output']>;
  geocodeConfidence?: Maybe<Scalars['String']['output']>;
  geocodeSource?: Maybe<Scalars['String']['output']>;
  geocodedAt?: Maybe<Scalars['DateTime']['output']>;
  isPrivate?: Maybe<Scalars['Boolean']['output']>;
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  placeId?: Maybe<Scalars['String']['output']>;
  state: Scalars['String']['output'];
  stateCode?: Maybe<Scalars['String']['output']>;
  streetAddress: Scalars['String']['output'];
  typeName?: Maybe<Scalars['String']['output']>;
  zipcode: Scalars['String']['output'];
};

export type EndorsementDashboardItem = {
  __typename?: 'EndorsementDashboardItem';
  endorsementRequest: EndorsementRequest;
  studentContext: StudentContext;
};

export type EndorsementDashboardResponse = {
  __typename?: 'EndorsementDashboardResponse';
  completedEndorsements: Array<EndorsementDashboardItem>;
  endorserEmail?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  pendingEndorsements: Array<EndorsementDashboardItem>;
  success: Scalars['Boolean']['output'];
};

export type EndorsementRequest = {
  __typename?: 'EndorsementRequest';
  criteria: Array<Criterion>;
  emailResendCount: Scalars['Float']['output'];
  emailSentAt?: Maybe<Scalars['String']['output']>;
  endorsement?: Maybe<EndorsementResponse>;
  endorserEmail: Scalars['String']['output'];
  endorserInfo?: Maybe<Scalars['String']['output']>;
  endorserName: Scalars['String']['output'];
  endorserRelationship?: Maybe<Scalars['String']['output']>;
  expiresAt: Scalars['String']['output'];
  id: Scalars['String']['output'];
  requestedAt: Scalars['String']['output'];
  status: EndorsementStatus;
  token: Scalars['String']['output'];
};

export type EndorsementResponse = {
  __typename?: 'EndorsementResponse';
  completedAt: Scalars['String']['output'];
  criteriaResponses: Scalars['JSON']['output'];
  endorserPhone?: Maybe<Scalars['String']['output']>;
  observations: Scalars['String']['output'];
};

/** Status of an endorsement request */
export enum EndorsementStatus {
  Completed = 'COMPLETED',
  Expired = 'EXPIRED',
  Pending = 'PENDING'
}

export type EnumStudentWalletStatusFieldUpdateOperationsInput = {
  set?: InputMaybe<StudentWalletStatus>;
};

export type EnumStudentWalletStatusFilter = {
  equals?: InputMaybe<StudentWalletStatus>;
  in?: InputMaybe<Array<StudentWalletStatus>>;
  not?: InputMaybe<NestedEnumStudentWalletStatusFilter>;
  notIn?: InputMaybe<Array<StudentWalletStatus>>;
};

export type EnumTransactionStatusFieldUpdateOperationsInput = {
  set?: InputMaybe<TransactionStatus>;
};

export type EnumTransactionStatusFilter = {
  equals?: InputMaybe<TransactionStatus>;
  in?: InputMaybe<Array<TransactionStatus>>;
  not?: InputMaybe<NestedEnumTransactionStatusFilter>;
  notIn?: InputMaybe<Array<TransactionStatus>>;
};

export type EnumTransferStatusFieldUpdateOperationsInput = {
  set?: InputMaybe<TransferStatus>;
};

export type EnumTransferStatusFilter = {
  equals?: InputMaybe<TransferStatus>;
  in?: InputMaybe<Array<TransferStatus>>;
  not?: InputMaybe<NestedEnumTransferStatusFilter>;
  notIn?: InputMaybe<Array<TransferStatus>>;
};

export type EnumWalletPaymentTypeFieldUpdateOperationsInput = {
  set?: InputMaybe<WalletPaymentType>;
};

export type EnumWalletPaymentTypeFilter = {
  equals?: InputMaybe<WalletPaymentType>;
  in?: InputMaybe<Array<WalletPaymentType>>;
  not?: InputMaybe<NestedEnumWalletPaymentTypeFilter>;
  notIn?: InputMaybe<Array<WalletPaymentType>>;
};

export type EscalationBriefingCountAggregate = {
  __typename?: 'EscalationBriefingCountAggregate';
  _all: Scalars['Int']['output'];
  activityName: Scalars['Int']['output'];
  alternativeActions: Scalars['Int']['output'];
  attemptedWrites: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  escalationReason: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  learnedPreferences: Scalars['Int']['output'];
  participantId: Scalars['Int']['output'];
  programId: Scalars['Int']['output'];
  recentMessages: Scalars['Int']['output'];
  recommendedAction: Scalars['Int']['output'];
  resolvedAt: Scalars['Int']['output'];
  resolvedBy: Scalars['Int']['output'];
  talkingPoints: Scalars['Int']['output'];
  threadId: Scalars['Int']['output'];
  updatedAt: Scalars['Int']['output'];
  urgency: Scalars['Int']['output'];
};

export type EscalationBriefingMaxAggregate = {
  __typename?: 'EscalationBriefingMaxAggregate';
  activityName?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  escalationReason?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  participantId?: Maybe<Scalars['String']['output']>;
  programId?: Maybe<Scalars['String']['output']>;
  recommendedAction?: Maybe<Scalars['String']['output']>;
  resolvedAt?: Maybe<Scalars['DateTime']['output']>;
  resolvedBy?: Maybe<Scalars['String']['output']>;
  threadId?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  urgency?: Maybe<Scalars['String']['output']>;
};

export type EscalationBriefingMinAggregate = {
  __typename?: 'EscalationBriefingMinAggregate';
  activityName?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  escalationReason?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  participantId?: Maybe<Scalars['String']['output']>;
  programId?: Maybe<Scalars['String']['output']>;
  recommendedAction?: Maybe<Scalars['String']['output']>;
  resolvedAt?: Maybe<Scalars['DateTime']['output']>;
  resolvedBy?: Maybe<Scalars['String']['output']>;
  threadId?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  urgency?: Maybe<Scalars['String']['output']>;
};

/** Escalation configuration for identifying participants needing human intervention */
export type EscalationConfig = {
  __typename?: 'EscalationConfig';
  enabled: Scalars['Boolean']['output'];
  thresholds: EscalationThresholds;
  weights: EscalationWeights;
};

export type EscalationLogCountAggregate = {
  __typename?: 'EscalationLogCountAggregate';
  _all: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  escalationType: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  inboundMessageId: Scalars['Int']['output'];
  messageContent: Scalars['Int']['output'];
  notificationQueued: Scalars['Int']['output'];
  notificationSentAt: Scalars['Int']['output'];
  participantName: Scalars['Int']['output'];
  programId: Scalars['Int']['output'];
  reason: Scalars['Int']['output'];
  resolutionNotes: Scalars['Int']['output'];
  resolvedAt: Scalars['Int']['output'];
  resolvedBy: Scalars['Int']['output'];
  severity: Scalars['Int']['output'];
  status: Scalars['Int']['output'];
  studentId: Scalars['Int']['output'];
  triggeredAt: Scalars['Int']['output'];
  updatedAt: Scalars['Int']['output'];
};

export type EscalationLogMaxAggregate = {
  __typename?: 'EscalationLogMaxAggregate';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  escalationType?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  inboundMessageId?: Maybe<Scalars['String']['output']>;
  messageContent?: Maybe<Scalars['String']['output']>;
  notificationQueued?: Maybe<Scalars['Boolean']['output']>;
  notificationSentAt?: Maybe<Scalars['DateTime']['output']>;
  participantName?: Maybe<Scalars['String']['output']>;
  programId?: Maybe<Scalars['String']['output']>;
  reason?: Maybe<Scalars['String']['output']>;
  resolutionNotes?: Maybe<Scalars['String']['output']>;
  resolvedAt?: Maybe<Scalars['DateTime']['output']>;
  resolvedBy?: Maybe<Scalars['String']['output']>;
  severity?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  studentId?: Maybe<Scalars['String']['output']>;
  triggeredAt?: Maybe<Scalars['DateTime']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type EscalationLogMinAggregate = {
  __typename?: 'EscalationLogMinAggregate';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  escalationType?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  inboundMessageId?: Maybe<Scalars['String']['output']>;
  messageContent?: Maybe<Scalars['String']['output']>;
  notificationQueued?: Maybe<Scalars['Boolean']['output']>;
  notificationSentAt?: Maybe<Scalars['DateTime']['output']>;
  participantName?: Maybe<Scalars['String']['output']>;
  programId?: Maybe<Scalars['String']['output']>;
  reason?: Maybe<Scalars['String']['output']>;
  resolutionNotes?: Maybe<Scalars['String']['output']>;
  resolvedAt?: Maybe<Scalars['DateTime']['output']>;
  resolvedBy?: Maybe<Scalars['String']['output']>;
  severity?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  studentId?: Maybe<Scalars['String']['output']>;
  triggeredAt?: Maybe<Scalars['DateTime']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

/** Thresholds for escalation signals */
export type EscalationThresholds = {
  __typename?: 'EscalationThresholds';
  consecutiveNoResponse: Scalars['Int']['output'];
  inactivityDays: Scalars['Int']['output'];
  riskScoreIncreaseDelta: Scalars['Int']['output'];
};

/** Weights for escalation score calculation */
export type EscalationWeights = {
  __typename?: 'EscalationWeights';
  consecutiveNoResponse: Scalars['Float']['output'];
  inactivityDays: Scalars['Float']['output'];
  riskScoreIncrease: Scalars['Float']['output'];
};

export type Family = {
  __typename?: 'Family';
  connectionType: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  createdByUserId: Scalars['ID']['output'];
  description?: Maybe<Scalars['String']['output']>;
  hierarchyType: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type FamilyCountAggregate = {
  __typename?: 'FamilyCountAggregate';
  _all: Scalars['Int']['output'];
  connectionType: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  createdByUserId: Scalars['Int']['output'];
  description: Scalars['Int']['output'];
  hierarchyType: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['Int']['output'];
  updatedAt: Scalars['Int']['output'];
};

export type FamilyEditLogCountAggregate = {
  __typename?: 'FamilyEditLogCountAggregate';
  _all: Scalars['Int']['output'];
  action: Scalars['Int']['output'];
  changedFields: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  entityId: Scalars['Int']['output'];
  entityType: Scalars['Int']['output'];
  familyId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  userId: Scalars['Int']['output'];
};

export type FamilyEditLogMaxAggregate = {
  __typename?: 'FamilyEditLogMaxAggregate';
  action?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  entityId?: Maybe<Scalars['String']['output']>;
  entityType?: Maybe<Scalars['String']['output']>;
  familyId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
};

export type FamilyEditLogMinAggregate = {
  __typename?: 'FamilyEditLogMinAggregate';
  action?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  entityId?: Maybe<Scalars['String']['output']>;
  entityType?: Maybe<Scalars['String']['output']>;
  familyId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
};

export type FamilyFaceCrop = {
  __typename?: 'FamilyFaceCrop';
  bboxHRatio: Scalars['Float']['output'];
  bboxWRatio: Scalars['Float']['output'];
  bboxXRatio: Scalars['Float']['output'];
  bboxYRatio: Scalars['Float']['output'];
  createdAt: Scalars['DateTime']['output'];
  createdByUserId: Scalars['ID']['output'];
  familyId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  memberId?: Maybe<Scalars['ID']['output']>;
  photoId: Scalars['ID']['output'];
  s3Key: Scalars['String']['output'];
  s3PublicUrl: Scalars['String']['output'];
};

export type FamilyFaceCropAvgAggregate = {
  __typename?: 'FamilyFaceCropAvgAggregate';
  bboxHRatio?: Maybe<Scalars['Float']['output']>;
  bboxWRatio?: Maybe<Scalars['Float']['output']>;
  bboxXRatio?: Maybe<Scalars['Float']['output']>;
  bboxYRatio?: Maybe<Scalars['Float']['output']>;
};

export type FamilyFaceCropCountAggregate = {
  __typename?: 'FamilyFaceCropCountAggregate';
  _all: Scalars['Int']['output'];
  bboxHRatio: Scalars['Int']['output'];
  bboxWRatio: Scalars['Int']['output'];
  bboxXRatio: Scalars['Int']['output'];
  bboxYRatio: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  createdByUserId: Scalars['Int']['output'];
  familyId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  memberId: Scalars['Int']['output'];
  photoId: Scalars['Int']['output'];
  s3Key: Scalars['Int']['output'];
  s3PublicUrl: Scalars['Int']['output'];
};

export type FamilyFaceCropMaxAggregate = {
  __typename?: 'FamilyFaceCropMaxAggregate';
  bboxHRatio?: Maybe<Scalars['Float']['output']>;
  bboxWRatio?: Maybe<Scalars['Float']['output']>;
  bboxXRatio?: Maybe<Scalars['Float']['output']>;
  bboxYRatio?: Maybe<Scalars['Float']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdByUserId?: Maybe<Scalars['String']['output']>;
  familyId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  memberId?: Maybe<Scalars['String']['output']>;
  photoId?: Maybe<Scalars['String']['output']>;
  s3Key?: Maybe<Scalars['String']['output']>;
  s3PublicUrl?: Maybe<Scalars['String']['output']>;
};

export type FamilyFaceCropMinAggregate = {
  __typename?: 'FamilyFaceCropMinAggregate';
  bboxHRatio?: Maybe<Scalars['Float']['output']>;
  bboxWRatio?: Maybe<Scalars['Float']['output']>;
  bboxXRatio?: Maybe<Scalars['Float']['output']>;
  bboxYRatio?: Maybe<Scalars['Float']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdByUserId?: Maybe<Scalars['String']['output']>;
  familyId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  memberId?: Maybe<Scalars['String']['output']>;
  photoId?: Maybe<Scalars['String']['output']>;
  s3Key?: Maybe<Scalars['String']['output']>;
  s3PublicUrl?: Maybe<Scalars['String']['output']>;
};

export type FamilyFaceCropSumAggregate = {
  __typename?: 'FamilyFaceCropSumAggregate';
  bboxHRatio?: Maybe<Scalars['Float']['output']>;
  bboxWRatio?: Maybe<Scalars['Float']['output']>;
  bboxXRatio?: Maybe<Scalars['Float']['output']>;
  bboxYRatio?: Maybe<Scalars['Float']['output']>;
};

export type FamilyMaxAggregate = {
  __typename?: 'FamilyMaxAggregate';
  connectionType?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdByUserId?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  hierarchyType?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type FamilyMember = {
  __typename?: 'FamilyMember';
  avatarFaceCropId?: Maybe<Scalars['ID']['output']>;
  avatarUrl?: Maybe<Scalars['String']['output']>;
  bio?: Maybe<Scalars['String']['output']>;
  birthDate?: Maybe<Scalars['String']['output']>;
  birthYear?: Maybe<Scalars['Int']['output']>;
  colorTag?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  createdByUserId: Scalars['ID']['output'];
  deathDate?: Maybe<Scalars['String']['output']>;
  deathYear?: Maybe<Scalars['Int']['output']>;
  familyId: Scalars['ID']['output'];
  generationName?: Maybe<Scalars['String']['output']>;
  hometown?: Maybe<Scalars['String']['output']>;
  hometownPlaceId?: Maybe<Scalars['ID']['output']>;
  id: Scalars['ID']['output'];
  isAdopted: Scalars['Boolean']['output'];
  isDeceased: Scalars['Boolean']['output'];
  /** True when rendered as masked in public view (minor-privacy) */
  isMaskedOnPublicView?: Maybe<Scalars['Boolean']['output']>;
  linkedUserId?: Maybe<Scalars['ID']['output']>;
  maternalPaternalLine?: Maybe<Scalars['String']['output']>;
  nameEn?: Maybe<Scalars['String']['output']>;
  nameZh?: Maybe<Scalars['String']['output']>;
  nickname?: Maybe<Scalars['String']['output']>;
  publicDisplayOverride: Scalars['Boolean']['output'];
  siblingOrder?: Maybe<Scalars['Int']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type FamilyMemberAvgAggregate = {
  __typename?: 'FamilyMemberAvgAggregate';
  birthYear?: Maybe<Scalars['Float']['output']>;
  deathYear?: Maybe<Scalars['Float']['output']>;
  siblingOrder?: Maybe<Scalars['Float']['output']>;
};

export type FamilyMemberCountAggregate = {
  __typename?: 'FamilyMemberCountAggregate';
  _all: Scalars['Int']['output'];
  avatarFaceCropId: Scalars['Int']['output'];
  bio: Scalars['Int']['output'];
  birthDate: Scalars['Int']['output'];
  birthYear: Scalars['Int']['output'];
  colorTag: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  createdByUserId: Scalars['Int']['output'];
  deathDate: Scalars['Int']['output'];
  deathYear: Scalars['Int']['output'];
  familyId: Scalars['Int']['output'];
  generationName: Scalars['Int']['output'];
  hometown: Scalars['Int']['output'];
  hometownPlaceId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  isAdopted: Scalars['Int']['output'];
  isDeceased: Scalars['Int']['output'];
  linkedUserId: Scalars['Int']['output'];
  maternalPaternalLine: Scalars['Int']['output'];
  nameEn: Scalars['Int']['output'];
  nameZh: Scalars['Int']['output'];
  nickname: Scalars['Int']['output'];
  publicDisplayOverride: Scalars['Int']['output'];
  siblingOrder: Scalars['Int']['output'];
  updatedAt: Scalars['Int']['output'];
};

export type FamilyMemberMaxAggregate = {
  __typename?: 'FamilyMemberMaxAggregate';
  avatarFaceCropId?: Maybe<Scalars['String']['output']>;
  bio?: Maybe<Scalars['String']['output']>;
  birthDate?: Maybe<Scalars['String']['output']>;
  birthYear?: Maybe<Scalars['Int']['output']>;
  colorTag?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdByUserId?: Maybe<Scalars['String']['output']>;
  deathDate?: Maybe<Scalars['String']['output']>;
  deathYear?: Maybe<Scalars['Int']['output']>;
  familyId?: Maybe<Scalars['String']['output']>;
  generationName?: Maybe<Scalars['String']['output']>;
  hometown?: Maybe<Scalars['String']['output']>;
  hometownPlaceId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  isAdopted?: Maybe<Scalars['Boolean']['output']>;
  isDeceased?: Maybe<Scalars['Boolean']['output']>;
  linkedUserId?: Maybe<Scalars['String']['output']>;
  maternalPaternalLine?: Maybe<Scalars['String']['output']>;
  nameEn?: Maybe<Scalars['String']['output']>;
  nameZh?: Maybe<Scalars['String']['output']>;
  nickname?: Maybe<Scalars['String']['output']>;
  publicDisplayOverride?: Maybe<Scalars['Boolean']['output']>;
  siblingOrder?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type FamilyMemberMinAggregate = {
  __typename?: 'FamilyMemberMinAggregate';
  avatarFaceCropId?: Maybe<Scalars['String']['output']>;
  bio?: Maybe<Scalars['String']['output']>;
  birthDate?: Maybe<Scalars['String']['output']>;
  birthYear?: Maybe<Scalars['Int']['output']>;
  colorTag?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdByUserId?: Maybe<Scalars['String']['output']>;
  deathDate?: Maybe<Scalars['String']['output']>;
  deathYear?: Maybe<Scalars['Int']['output']>;
  familyId?: Maybe<Scalars['String']['output']>;
  generationName?: Maybe<Scalars['String']['output']>;
  hometown?: Maybe<Scalars['String']['output']>;
  hometownPlaceId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  isAdopted?: Maybe<Scalars['Boolean']['output']>;
  isDeceased?: Maybe<Scalars['Boolean']['output']>;
  linkedUserId?: Maybe<Scalars['String']['output']>;
  maternalPaternalLine?: Maybe<Scalars['String']['output']>;
  nameEn?: Maybe<Scalars['String']['output']>;
  nameZh?: Maybe<Scalars['String']['output']>;
  nickname?: Maybe<Scalars['String']['output']>;
  publicDisplayOverride?: Maybe<Scalars['Boolean']['output']>;
  siblingOrder?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type FamilyMemberSumAggregate = {
  __typename?: 'FamilyMemberSumAggregate';
  birthYear?: Maybe<Scalars['Int']['output']>;
  deathYear?: Maybe<Scalars['Int']['output']>;
  siblingOrder?: Maybe<Scalars['Int']['output']>;
};

export type FamilyMinAggregate = {
  __typename?: 'FamilyMinAggregate';
  connectionType?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdByUserId?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  hierarchyType?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type FamilyPhoto = {
  __typename?: 'FamilyPhoto';
  captionEn?: Maybe<Scalars['String']['output']>;
  captionZh?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  familyId: Scalars['ID']['output'];
  height?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  originalFilename?: Maybe<Scalars['String']['output']>;
  s3Key: Scalars['String']['output'];
  s3PublicUrl: Scalars['String']['output'];
  takenAtGuess?: Maybe<Scalars['String']['output']>;
  uploadedByUserId: Scalars['ID']['output'];
  width?: Maybe<Scalars['Int']['output']>;
};

export type FamilyPhotoAvgAggregate = {
  __typename?: 'FamilyPhotoAvgAggregate';
  height?: Maybe<Scalars['Float']['output']>;
  width?: Maybe<Scalars['Float']['output']>;
};

export type FamilyPhotoCountAggregate = {
  __typename?: 'FamilyPhotoCountAggregate';
  _all: Scalars['Int']['output'];
  captionEn: Scalars['Int']['output'];
  captionZh: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  familyId: Scalars['Int']['output'];
  height: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  originalFilename: Scalars['Int']['output'];
  s3Key: Scalars['Int']['output'];
  s3PublicUrl: Scalars['Int']['output'];
  takenAtGuess: Scalars['Int']['output'];
  uploadedByUserId: Scalars['Int']['output'];
  width: Scalars['Int']['output'];
};

export type FamilyPhotoMaxAggregate = {
  __typename?: 'FamilyPhotoMaxAggregate';
  captionEn?: Maybe<Scalars['String']['output']>;
  captionZh?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  familyId?: Maybe<Scalars['String']['output']>;
  height?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  originalFilename?: Maybe<Scalars['String']['output']>;
  s3Key?: Maybe<Scalars['String']['output']>;
  s3PublicUrl?: Maybe<Scalars['String']['output']>;
  takenAtGuess?: Maybe<Scalars['String']['output']>;
  uploadedByUserId?: Maybe<Scalars['String']['output']>;
  width?: Maybe<Scalars['Int']['output']>;
};

export type FamilyPhotoMinAggregate = {
  __typename?: 'FamilyPhotoMinAggregate';
  captionEn?: Maybe<Scalars['String']['output']>;
  captionZh?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  familyId?: Maybe<Scalars['String']['output']>;
  height?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  originalFilename?: Maybe<Scalars['String']['output']>;
  s3Key?: Maybe<Scalars['String']['output']>;
  s3PublicUrl?: Maybe<Scalars['String']['output']>;
  takenAtGuess?: Maybe<Scalars['String']['output']>;
  uploadedByUserId?: Maybe<Scalars['String']['output']>;
  width?: Maybe<Scalars['Int']['output']>;
};

export type FamilyPhotoSumAggregate = {
  __typename?: 'FamilyPhotoSumAggregate';
  height?: Maybe<Scalars['Int']['output']>;
  width?: Maybe<Scalars['Int']['output']>;
};

export type FamilyRelationship = {
  __typename?: 'FamilyRelationship';
  createdAt: Scalars['DateTime']['output'];
  createdByUserId: Scalars['ID']['output'];
  familyId: Scalars['ID']['output'];
  fromMemberId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  toMemberId: Scalars['ID']['output'];
  type: Scalars['String']['output'];
};

export type FamilyRelationshipCountAggregate = {
  __typename?: 'FamilyRelationshipCountAggregate';
  _all: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  createdByUserId: Scalars['Int']['output'];
  familyId: Scalars['Int']['output'];
  fromMemberId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  toMemberId: Scalars['Int']['output'];
  type: Scalars['Int']['output'];
};

export type FamilyRelationshipMaxAggregate = {
  __typename?: 'FamilyRelationshipMaxAggregate';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdByUserId?: Maybe<Scalars['String']['output']>;
  familyId?: Maybe<Scalars['String']['output']>;
  fromMemberId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  toMemberId?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type FamilyRelationshipMinAggregate = {
  __typename?: 'FamilyRelationshipMinAggregate';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdByUserId?: Maybe<Scalars['String']['output']>;
  familyId?: Maybe<Scalars['String']['output']>;
  fromMemberId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  toMemberId?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type FamilySubgraph = {
  __typename?: 'FamilySubgraph';
  faceCrops: Array<FamilyFaceCrop>;
  familyName: Scalars['String']['output'];
  members: Array<FamilyMember>;
  photos: Array<FamilyPhoto>;
  relationships: Array<FamilyRelationship>;
  view?: Maybe<FamilyView>;
  /** True if viewer is authenticated AND has edit permission (creator or linked). False on public share view. */
  viewerCanEdit: Scalars['Boolean']['output'];
};

export type FamilyView = {
  __typename?: 'FamilyView';
  createdAt: Scalars['DateTime']['output'];
  createdByUserId: Scalars['ID']['output'];
  downDepth: Scalars['Int']['output'];
  duplicatedFromViewId?: Maybe<Scalars['ID']['output']>;
  familyId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  includeSpouses: Scalars['Boolean']['output'];
  rootMemberId: Scalars['ID']['output'];
  shareToken: Scalars['String']['output'];
  titleEn?: Maybe<Scalars['String']['output']>;
  titleZh?: Maybe<Scalars['String']['output']>;
  upDepth: Scalars['Int']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type FamilyViewAvgAggregate = {
  __typename?: 'FamilyViewAvgAggregate';
  downDepth?: Maybe<Scalars['Float']['output']>;
  upDepth?: Maybe<Scalars['Float']['output']>;
};

export type FamilyViewCountAggregate = {
  __typename?: 'FamilyViewCountAggregate';
  _all: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  createdByUserId: Scalars['Int']['output'];
  downDepth: Scalars['Int']['output'];
  duplicatedFromViewId: Scalars['Int']['output'];
  familyId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  includeSpouses: Scalars['Int']['output'];
  rootMemberId: Scalars['Int']['output'];
  shareToken: Scalars['Int']['output'];
  titleEn: Scalars['Int']['output'];
  titleZh: Scalars['Int']['output'];
  upDepth: Scalars['Int']['output'];
  updatedAt: Scalars['Int']['output'];
};

export type FamilyViewMaxAggregate = {
  __typename?: 'FamilyViewMaxAggregate';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdByUserId?: Maybe<Scalars['String']['output']>;
  downDepth?: Maybe<Scalars['Int']['output']>;
  duplicatedFromViewId?: Maybe<Scalars['String']['output']>;
  familyId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  includeSpouses?: Maybe<Scalars['Boolean']['output']>;
  rootMemberId?: Maybe<Scalars['String']['output']>;
  shareToken?: Maybe<Scalars['String']['output']>;
  titleEn?: Maybe<Scalars['String']['output']>;
  titleZh?: Maybe<Scalars['String']['output']>;
  upDepth?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type FamilyViewMinAggregate = {
  __typename?: 'FamilyViewMinAggregate';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdByUserId?: Maybe<Scalars['String']['output']>;
  downDepth?: Maybe<Scalars['Int']['output']>;
  duplicatedFromViewId?: Maybe<Scalars['String']['output']>;
  familyId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  includeSpouses?: Maybe<Scalars['Boolean']['output']>;
  rootMemberId?: Maybe<Scalars['String']['output']>;
  shareToken?: Maybe<Scalars['String']['output']>;
  titleEn?: Maybe<Scalars['String']['output']>;
  titleZh?: Maybe<Scalars['String']['output']>;
  upDepth?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type FamilyViewSumAggregate = {
  __typename?: 'FamilyViewSumAggregate';
  downDepth?: Maybe<Scalars['Int']['output']>;
  upDepth?: Maybe<Scalars['Int']['output']>;
};

/** Individual fee component from Stripe */
export type FeeDetail = {
  __typename?: 'FeeDetail';
  /** Fee amount in dollars */
  amount: Scalars['Float']['output'];
  /** Currency code */
  currency: Scalars['String']['output'];
  /** Fee description */
  description?: Maybe<Scalars['String']['output']>;
  /** Fee type (stripe_fee, application_fee, etc.) */
  type: Scalars['String']['output'];
};

export type FetchEmployersInput = {
  includeTotal?: InputMaybe<Scalars['Boolean']['input']>;
  offset?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  searchQuery?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<SortInput>>;
};

export type FetchOrganizationsInput = {
  offset?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  searchField?: InputMaybe<Scalars['String']['input']>;
  searchQuery?: InputMaybe<Scalars['String']['input']>;
};

export type FieldValidationResult = {
  __typename?: 'FieldValidationResult';
  displayName: Scalars['String']['output'];
  fieldId: Scalars['String']['output'];
  nullRate: Scalars['Float']['output'];
  path: Scalars['String']['output'];
  sampleValues?: Maybe<Array<Scalars['String']['output']>>;
  source: Scalars['String']['output'];
  status: TemplateValidationStatus;
  warning?: Maybe<Scalars['String']['output']>;
};

export type FloatFieldUpdateOperationsInput = {
  decrement?: InputMaybe<Scalars['Float']['input']>;
  divide?: InputMaybe<Scalars['Float']['input']>;
  increment?: InputMaybe<Scalars['Float']['input']>;
  multiply?: InputMaybe<Scalars['Float']['input']>;
  set?: InputMaybe<Scalars['Float']['input']>;
};

export type FloatFilter = {
  equals?: InputMaybe<Scalars['Float']['input']>;
  gt?: InputMaybe<Scalars['Float']['input']>;
  gte?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<Scalars['Float']['input']>>;
  lt?: InputMaybe<Scalars['Float']['input']>;
  lte?: InputMaybe<Scalars['Float']['input']>;
  not?: InputMaybe<NestedFloatFilter>;
  notIn?: InputMaybe<Array<Scalars['Float']['input']>>;
};

export type FloatNullableFilter = {
  equals?: InputMaybe<Scalars['Float']['input']>;
  gt?: InputMaybe<Scalars['Float']['input']>;
  gte?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<Scalars['Float']['input']>>;
  isSet?: InputMaybe<Scalars['Boolean']['input']>;
  lt?: InputMaybe<Scalars['Float']['input']>;
  lte?: InputMaybe<Scalars['Float']['input']>;
  not?: InputMaybe<NestedFloatNullableFilter>;
  notIn?: InputMaybe<Array<Scalars['Float']['input']>>;
};

export type FloatNullableListFilter = {
  equals?: InputMaybe<Array<Scalars['Float']['input']>>;
  has?: InputMaybe<Scalars['Float']['input']>;
  hasEvery?: InputMaybe<Array<Scalars['Float']['input']>>;
  hasSome?: InputMaybe<Array<Scalars['Float']['input']>>;
  isEmpty?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ForgotPasswordInput = {
  /** Email address of the user requesting password reset */
  email: Scalars['String']['input'];
};

export type ForgotPasswordResponse = {
  __typename?: 'ForgotPasswordResponse';
  /** Response message */
  message?: Maybe<Scalars['String']['output']>;
  /** Whether the password reset request was successful */
  success: Scalars['Boolean']['output'];
};

export type GenerateRoadmapAiInput = {
  /** Participant toggle — when true (default), grounding evidence influences program ranking via a 6th criterion. When false, grounding is narrative-only. */
  applyGroundingRanking?: InputMaybe<Scalars['Boolean']['input']>;
  /** User customization inputs (strengths, passions, problems, careers, skills, etc.) */
  customizationInputs?: InputMaybe<Scalars['JSON']['input']>;
  /** Maximum tokens in response */
  maxTokens?: InputMaybe<Scalars['Int']['input']>;
  /** OpenAI model to use */
  model?: InputMaybe<Scalars['String']['input']>;
  /** Program context for roadmap generation */
  programContext?: InputMaybe<ProgramContextInput>;
  /** Program sequence for initiative design roadmaps */
  programSequence?: InputMaybe<Array<ProgramSequenceStepInput>>;
  /** Direct prompt to send to OpenAI (DEPRECATED - use customizationInputs instead for security) */
  prompt?: InputMaybe<Scalars['String']['input']>;
  /** Prompt type: "default" for 3-phase roadmap, "initiative-design" for sponsor-defined sequence */
  promptType?: InputMaybe<Scalars['String']['input']>;
  /** Per-surface controls for where workforce stats are required in the output. Each flag, when false, omits the "MUST cite a stat" directive for that surface — the AI is still allowed to reference numbers but no longer forced to. Reduces token bloat without removing grounding entirely. */
  saturationFlags?: InputMaybe<SaturationFlagsInput>;
  /** Sponsor share code — used to look up attached GroundingSources and ground the roadmap in real-world evidence. */
  shareCode?: InputMaybe<Scalars['String']['input']>;
  /** Temperature for generation (0-1) */
  temperature?: InputMaybe<Scalars['Float']['input']>;
  /** Participant toggle — when true (default) and the share link has GroundingSources attached, real evidence is injected into the prompt. When false, the LLM falls back to current ungrounded behavior. */
  useGrounding?: InputMaybe<Scalars['Boolean']['input']>;
  /** Program IDs visible on the share link in default mode (no programSequence). Used by grounding service to filter row shortlist to programs the participant will actually see. */
  visibleProgramIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type GenerateRoadmapAiOutput = {
  __typename?: 'GenerateRoadmapAIOutput';
  /** Raw content from OpenAI */
  content?: Maybe<Scalars['String']['output']>;
  /** Error message if failed */
  error?: Maybe<Scalars['String']['output']>;
  /** Whether response was served from cache */
  fromCache?: Maybe<Scalars['Boolean']['output']>;
  /** When the response was generated */
  generatedAt: Scalars['DateTime']['output'];
  /** Parsed JSON content if applicable */
  parsedContent?: Maybe<Scalars['JSON']['output']>;
  /** Whether the generation was successful */
  success: Scalars['Boolean']['output'];
  /** Number of tokens used */
  tokensUsed?: Maybe<Scalars['Int']['output']>;
};

/** Input for querying onboarding funnel stats */
export type GetFunnelStatsInput = {
  /** Program ID to get funnel stats for */
  programId: Scalars['String']['input'];
};

export type GetMonitorInput = {
  filter?: InputMaybe<Scalars['String']['input']>;
  limit: Scalars['Int']['input'];
  org_id?: InputMaybe<Scalars['String']['input']>;
  owner_id: Scalars['String']['input'];
  program_id?: InputMaybe<Scalars['String']['input']>;
  skip: Scalars['Int']['input'];
  /** Sort field (e.g. _id, adksCompletion, created) */
  sortBy?: InputMaybe<Scalars['String']['input']>;
  /** Sort direction: asc or desc */
  sortDir?: InputMaybe<Scalars['String']['input']>;
  /** Optional student ID for single-student detail loading */
  student_id?: InputMaybe<Scalars['String']['input']>;
};

/** Input for getMonitorProgramCounts — per-program participant counts */
export type GetMonitorProgramCountsInput = {
  filter?: InputMaybe<Scalars['String']['input']>;
  org_id?: InputMaybe<Scalars['String']['input']>;
  owner_id: Scalars['String']['input'];
  program_id?: InputMaybe<Scalars['String']['input']>;
};

export type GetMonitorRosterInput = {
  /** ISO date string (YYYY-MM-DD) — filter students created on or after this date */
  dateFrom?: InputMaybe<Scalars['String']['input']>;
  /** ISO date string (YYYY-MM-DD) — filter students created on or before this date */
  dateTo?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Scalars['String']['input']>;
  /** Known total count from a previous response — skips the count pipeline when provided */
  knownCount?: InputMaybe<Scalars['Int']['input']>;
  limit: Scalars['Int']['input'];
  /** When true, only return students who are currently online (active in presence system) */
  onlineOnly?: InputMaybe<Scalars['Boolean']['input']>;
  org_id?: InputMaybe<Scalars['String']['input']>;
  owner_id: Scalars['String']['input'];
  /** Filter to specific program IDs (overrides single program_id when provided) */
  programIds?: InputMaybe<Array<Scalars['String']['input']>>;
  program_id?: InputMaybe<Scalars['String']['input']>;
  /** Search text — matches name, school, team, program name (case-insensitive) */
  searchText?: InputMaybe<Scalars['String']['input']>;
  skip: Scalars['Int']['input'];
  /** Sort field (e.g. _id, adksCompletion, created) */
  sortBy?: InputMaybe<Scalars['String']['input']>;
  /** Sort direction: asc or desc */
  sortDir?: InputMaybe<Scalars['String']['input']>;
  /** Optional student ID for single-student detail loading */
  student_id?: InputMaybe<Scalars['String']['input']>;
};

/** Input for getMonitorScores — lightweight scores-only query for Quadrant view */
export type GetMonitorScoresInput = {
  filter?: InputMaybe<Scalars['String']['input']>;
  org_id?: InputMaybe<Scalars['String']['input']>;
  owner_id: Scalars['String']['input'];
  /** Filter to specific program IDs (overrides single program_id when provided) */
  programIds?: InputMaybe<Array<Scalars['String']['input']>>;
  program_id?: InputMaybe<Scalars['String']['input']>;
};

export type GetStudentInstancesInput = {
  participantId: Scalars['String']['input'];
  programId: Scalars['String']['input'];
};

export type GetVideoAskStatusInput = {
  adkName: Scalars['String']['input'];
  studentId: Scalars['String']['input'];
};

/** Basic greeting response with a message */
export type Greeting = {
  __typename?: 'Greeting';
  /** The greeting message text */
  message: Scalars['String']['output'];
};

/** Greeting response that includes the current time */
export type GreetingWithTime = {
  __typename?: 'GreetingWithTime';
  /** The greeting message text */
  message: Scalars['String']['output'];
  /** ISO timestamp of when the greeting was generated */
  time: Scalars['String']['output'];
};

/**
 * GroundingSource — external real-world evidence attached to sponsor links to
 * ground AI roadmap generation in measurable reality (versus LLM-hallucinated
 * labor-market claims). Workforce data is the v1 kind; future kinds (scholarships,
 * employer outcomes, college admissions, etc.) plug in via per-kind row models.
 * Pattern:
 * - Parent record (this model) holds provenance metadata that all kinds share.
 * - Per-kind row tables (e.g., WorkforceOccupationRow) hold kind-specific facts
 * so each kind gets proper indexes and type safety without a polymorphic blob.
 * Seed source for v1: "California Occupational Demand 2024–2029" published by
 * the CA Center of Excellence; underlying data licensed from Lightcast.
 */
export type GroundingSource = {
  __typename?: 'GroundingSource';
  _count: GroundingSourceCount;
  /** Whether downstream UI must show attribution */
  attributionRequired: Scalars['Boolean']['output'];
  /** Pre-formatted attribution string (e.g., "Data via CA COE; sourced from Lightcast") */
  attributionText: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  /** ISO-style jurisdiction code (e.g., "us-ca", "us-tx") — drives auto-attach later */
  jurisdiction: Scalars['String']['output'];
  /** Display label shown in UI (e.g., "California") */
  jurisdictionLabel: Scalars['String']['output'];
  /**
   * Discriminator — selects which row table holds this source's facts.
   * v1: "workforce". Future: "scholarships", "employer-outcomes", "college-admissions", ...
   */
  kind: Scalars['String']['output'];
  /** Human-readable name surfaced to sponsors and participants */
  name: Scalars['String']['output'];
  /** Forward projection window end year (e.g., 2029) — null for sources without projections */
  projectionEndYear?: Maybe<Scalars['Int']['output']>;
  /** Stable slug used by seed scripts and integration tests (e.g. "ca-coe-2024-2029") */
  slug: Scalars['String']['output'];
  /** Publishing organization (e.g., "CA Center of Excellence for Labor Market Research") */
  source: Scalars['String']['output'];
  /** URL where the dataset was retrieved (Looker Studio link, agency portal, etc.) */
  sourceUrl: Scalars['String']['output'];
  /**
   * Top-line summary stats — kind-specific JSON shape used by the prompt builder
   * for high-level grounding statements. For workforce: { totalJobs, totalAnnualOpenings,
   * medianHourlyEarnings, medianAnnualEarnings, occupationCount }.
   */
  summary?: Maybe<Scalars['JSON']['output']>;
  /** Taxonomy used by row link keys, where applicable (e.g., "SOC-2018" for workforce) */
  taxonomy?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  /** True data origin if `source` is a re-publisher (e.g., "Lightcast" for COE) */
  upstreamProvider?: Maybe<Scalars['String']['output']>;
  /** Vintage year of the data (e.g., "2024") */
  vintage: Scalars['String']['output'];
  /** Workforce-specific row relation (populated when kind='workforce') */
  workforceRows?: Maybe<Array<WorkforceOccupationRow>>;
};

export type GroundingSourceAvgAggregate = {
  __typename?: 'GroundingSourceAvgAggregate';
  projectionEndYear?: Maybe<Scalars['Float']['output']>;
};

export type GroundingSourceCount = {
  __typename?: 'GroundingSourceCount';
  workforceRows: Scalars['Int']['output'];
};

export type GroundingSourceCountAggregate = {
  __typename?: 'GroundingSourceCountAggregate';
  _all: Scalars['Int']['output'];
  attributionRequired: Scalars['Int']['output'];
  attributionText: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  jurisdiction: Scalars['Int']['output'];
  jurisdictionLabel: Scalars['Int']['output'];
  kind: Scalars['Int']['output'];
  name: Scalars['Int']['output'];
  projectionEndYear: Scalars['Int']['output'];
  slug: Scalars['Int']['output'];
  source: Scalars['Int']['output'];
  sourceUrl: Scalars['Int']['output'];
  summary: Scalars['Int']['output'];
  taxonomy: Scalars['Int']['output'];
  updatedAt: Scalars['Int']['output'];
  upstreamProvider: Scalars['Int']['output'];
  vintage: Scalars['Int']['output'];
};

export type GroundingSourceMaxAggregate = {
  __typename?: 'GroundingSourceMaxAggregate';
  attributionRequired?: Maybe<Scalars['Boolean']['output']>;
  attributionText?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  jurisdiction?: Maybe<Scalars['String']['output']>;
  jurisdictionLabel?: Maybe<Scalars['String']['output']>;
  kind?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  projectionEndYear?: Maybe<Scalars['Int']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  source?: Maybe<Scalars['String']['output']>;
  sourceUrl?: Maybe<Scalars['String']['output']>;
  taxonomy?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  upstreamProvider?: Maybe<Scalars['String']['output']>;
  vintage?: Maybe<Scalars['String']['output']>;
};

export type GroundingSourceMinAggregate = {
  __typename?: 'GroundingSourceMinAggregate';
  attributionRequired?: Maybe<Scalars['Boolean']['output']>;
  attributionText?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  jurisdiction?: Maybe<Scalars['String']['output']>;
  jurisdictionLabel?: Maybe<Scalars['String']['output']>;
  kind?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  projectionEndYear?: Maybe<Scalars['Int']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  source?: Maybe<Scalars['String']['output']>;
  sourceUrl?: Maybe<Scalars['String']['output']>;
  taxonomy?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  upstreamProvider?: Maybe<Scalars['String']['output']>;
  vintage?: Maybe<Scalars['String']['output']>;
};

export type GroundingSourceOutput = {
  __typename?: 'GroundingSourceOutput';
  attributionRequired: Scalars['Boolean']['output'];
  attributionText: Scalars['String']['output'];
  id: Scalars['String']['output'];
  jurisdiction: Scalars['String']['output'];
  jurisdictionLabel: Scalars['String']['output'];
  /** Discriminator: "workforce", future kinds... */
  kind: Scalars['String']['output'];
  name: Scalars['String']['output'];
  projectionEndYear?: Maybe<Scalars['Int']['output']>;
  slug: Scalars['String']['output'];
  source: Scalars['String']['output'];
  sourceUrl: Scalars['String']['output'];
  /** Kind-specific top-line summary stats */
  summary?: Maybe<Scalars['JSON']['output']>;
  taxonomy?: Maybe<Scalars['String']['output']>;
  upstreamProvider?: Maybe<Scalars['String']['output']>;
  vintage: Scalars['String']['output'];
};

export type GroundingSourceSumAggregate = {
  __typename?: 'GroundingSourceSumAggregate';
  projectionEndYear?: Maybe<Scalars['Int']['output']>;
};

/** Type of identity to migrate (PHONE or EMAIL) */
export enum IdentityType {
  Email = 'EMAIL',
  Phone = 'PHONE'
}

export type InboundMessageAvgAggregate = {
  __typename?: 'InboundMessageAvgAggregate';
  numMedia?: Maybe<Scalars['Float']['output']>;
};

export type InboundMessageCountAggregate = {
  __typename?: 'InboundMessageCountAggregate';
  _all: Scalars['Int']['output'];
  autoResponse: Scalars['Int']['output'];
  autoResponseSentAt: Scalars['Int']['output'];
  channel: Scalars['Int']['output'];
  content: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  externalId: Scalars['Int']['output'];
  fromAddress: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  inReplyToOutreachId: Scalars['Int']['output'];
  mediaTypes: Scalars['Int']['output'];
  mediaUrls: Scalars['Int']['output'];
  numMedia: Scalars['Int']['output'];
  processedAt: Scalars['Int']['output'];
  processedBy: Scalars['Int']['output'];
  programId: Scalars['Int']['output'];
  rawContent: Scalars['Int']['output'];
  receivedAt: Scalars['Int']['output'];
  status: Scalars['Int']['output'];
  studentId: Scalars['Int']['output'];
  subject: Scalars['Int']['output'];
  threadHeaders: Scalars['Int']['output'];
  threadId: Scalars['Int']['output'];
  updatedAt: Scalars['Int']['output'];
};

export type InboundMessageMaxAggregate = {
  __typename?: 'InboundMessageMaxAggregate';
  autoResponse?: Maybe<Scalars['String']['output']>;
  autoResponseSentAt?: Maybe<Scalars['DateTime']['output']>;
  channel?: Maybe<Scalars['String']['output']>;
  content?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  externalId?: Maybe<Scalars['String']['output']>;
  fromAddress?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  inReplyToOutreachId?: Maybe<Scalars['String']['output']>;
  numMedia?: Maybe<Scalars['Int']['output']>;
  processedAt?: Maybe<Scalars['DateTime']['output']>;
  processedBy?: Maybe<Scalars['String']['output']>;
  programId?: Maybe<Scalars['String']['output']>;
  rawContent?: Maybe<Scalars['String']['output']>;
  receivedAt?: Maybe<Scalars['DateTime']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  studentId?: Maybe<Scalars['String']['output']>;
  subject?: Maybe<Scalars['String']['output']>;
  threadId?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type InboundMessageMinAggregate = {
  __typename?: 'InboundMessageMinAggregate';
  autoResponse?: Maybe<Scalars['String']['output']>;
  autoResponseSentAt?: Maybe<Scalars['DateTime']['output']>;
  channel?: Maybe<Scalars['String']['output']>;
  content?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  externalId?: Maybe<Scalars['String']['output']>;
  fromAddress?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  inReplyToOutreachId?: Maybe<Scalars['String']['output']>;
  numMedia?: Maybe<Scalars['Int']['output']>;
  processedAt?: Maybe<Scalars['DateTime']['output']>;
  processedBy?: Maybe<Scalars['String']['output']>;
  programId?: Maybe<Scalars['String']['output']>;
  rawContent?: Maybe<Scalars['String']['output']>;
  receivedAt?: Maybe<Scalars['DateTime']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  studentId?: Maybe<Scalars['String']['output']>;
  subject?: Maybe<Scalars['String']['output']>;
  threadId?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type InboundMessageSumAggregate = {
  __typename?: 'InboundMessageSumAggregate';
  numMedia?: Maybe<Scalars['Int']['output']>;
};

export type IndustryCount = {
  __typename?: 'IndustryCount';
  /** Number of programs in this industry */
  count: Scalars['Int']['output'];
  /** The industry name */
  industry: Scalars['String']['output'];
};

/** Input for initializing AIPM onboarding */
export type InitializeOnboardingInput = {
  /** Entry point: checkout, retroactive, unsponsored, participant_initiated */
  entryPoint: Scalars['String']['input'];
  /** Program ID to initialize onboarding for */
  programId: Scalars['String']['input'];
};

/** Result of initializing AIPM onboarding */
export type InitializeOnboardingResultType = {
  __typename?: 'InitializeOnboardingResultType';
  /** Entry point type that triggered onboarding */
  entryPoint: Scalars['String']['output'];
  /** Session ID for tracking onboarding progress */
  sessionId: Scalars['String']['output'];
  /** User ID with updated aipmSettings */
  userId: Scalars['String']['output'];
};

export type IntFieldUpdateOperationsInput = {
  decrement?: InputMaybe<Scalars['Int']['input']>;
  divide?: InputMaybe<Scalars['Int']['input']>;
  increment?: InputMaybe<Scalars['Int']['input']>;
  multiply?: InputMaybe<Scalars['Int']['input']>;
  set?: InputMaybe<Scalars['Int']['input']>;
};

export type IntFilter = {
  equals?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  in?: InputMaybe<Array<Scalars['Int']['input']>>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  not?: InputMaybe<NestedIntFilter>;
  notIn?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type IntNullableFilter = {
  equals?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  in?: InputMaybe<Array<Scalars['Int']['input']>>;
  isSet?: InputMaybe<Scalars['Boolean']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  not?: InputMaybe<NestedIntNullableFilter>;
  notIn?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type IntNullableListFilter = {
  equals?: InputMaybe<Array<Scalars['Int']['input']>>;
  has?: InputMaybe<Scalars['Int']['input']>;
  hasEvery?: InputMaybe<Array<Scalars['Int']['input']>>;
  hasSome?: InputMaybe<Array<Scalars['Int']['input']>>;
  isEmpty?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Invitation = {
  __typename?: 'Invitation';
  Email?: Maybe<Scalars['String']['output']>;
  Message?: Maybe<Scalars['String']['output']>;
  Name: Scalars['String']['output'];
  Participant?: Maybe<Scalars['String']['output']>;
  Phone?: Maybe<Scalars['String']['output']>;
  Subject?: Maybe<Scalars['String']['output']>;
  Type: Scalars['String']['output'];
  confirmParticipantPhone?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  messageType?: Maybe<Scalars['String']['output']>;
  otherType?: Maybe<Scalars['String']['output']>;
  sendType?: Maybe<Scalars['String']['output']>;
};

export type InvitationInput = {
  Email?: InputMaybe<Scalars['String']['input']>;
  Message?: InputMaybe<Scalars['String']['input']>;
  Name: Scalars['String']['input'];
  Participant?: InputMaybe<Scalars['String']['input']>;
  Phone?: InputMaybe<Scalars['String']['input']>;
  Subject?: InputMaybe<Scalars['String']['input']>;
  Type: Scalars['String']['input'];
  confirmParticipantPhone?: InputMaybe<Scalars['String']['input']>;
  messageType?: InputMaybe<Scalars['String']['input']>;
  otherType?: InputMaybe<Scalars['String']['input']>;
  sendType?: InputMaybe<Scalars['String']['input']>;
};

export type Invitee = {
  __typename?: 'Invitee';
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

/** Stripe invoice with line items */
export type Invoice = {
  __typename?: 'Invoice';
  /** Invoice creation date */
  created: Scalars['DateTime']['output'];
  /** Currency code */
  currency: Scalars['String']['output'];
  /** Stripe Customer ID */
  customer: Scalars['String']['output'];
  /** Invoice description */
  description?: Maybe<Scalars['String']['output']>;
  /** Invoice due date */
  dueDate?: Maybe<Scalars['DateTime']['output']>;
  /** Hosted invoice page URL */
  hostedInvoiceUrl?: Maybe<Scalars['String']['output']>;
  /** Stripe Invoice ID */
  id: Scalars['String']['output'];
  /** Invoice PDF URL */
  invoicePdf?: Maybe<Scalars['String']['output']>;
  /** Invoice line items */
  lineItems: Array<InvoiceLineItem>;
  /** Invoice metadata */
  metadata?: Maybe<Scalars['JSON']['output']>;
  /** Invoice status (draft, open, paid, void, uncollectible) */
  status: Scalars['String']['output'];
  /** Total amount in cents */
  total: Scalars['Int']['output'];
};

/** Line item in a Stripe invoice */
export type InvoiceLineItem = {
  __typename?: 'InvoiceLineItem';
  /** Amount in cents */
  amount: Scalars['Int']['output'];
  /** Line item ID */
  id: Scalars['String']['output'];
  /** Stripe Price ID */
  priceId: Scalars['String']['output'];
  /** Stripe Product ID */
  productId: Scalars['String']['output'];
  /** Product name */
  productName: Scalars['String']['output'];
  /** Quantity */
  quantity: Scalars['Int']['output'];
};

/** Individual line item for an invoice using Stripe Price ID */
export type InvoiceLineItemInput = {
  /** Stripe Price ID */
  priceId: Scalars['String']['input'];
  /** Quantity */
  quantity?: Scalars['Int']['input'];
};

export type JournalOrderByInput = {
  createdAt?: InputMaybe<SortOrder>;
  programId?: InputMaybe<SortOrder>;
  studentId?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type JournalWhereInput = {
  id?: InputMaybe<Scalars['String']['input']>;
  programId?: InputMaybe<Scalars['String']['input']>;
  studentId?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Journal represents a student's journal entry for reflections and emotional tracking
 * Each journal entry is private to the student and tracks their thoughts throughout the program
 * DATA MODEL NOTES:
 * - Prisma model name: Journals (plural, matches MongoDB collection name)
 * - MongoDB collection: Journals (plural)
 * - No @@map directive needed when model name matches collection name
 */
export type Journals = {
  __typename?: 'Journals';
  /** Name of the activity this journal entry is associated with (e.g., 'ideate', 'research') */
  activityName?: Maybe<Scalars['String']['output']>;
  /** Position of this activity in the program sequence (1-based index) */
  activityPosition?: Maybe<Scalars['Int']['output']>;
  /** Program completion percentage at time of this entry (0-100) */
  completionPercentage?: Maybe<Scalars['Float']['output']>;
  /**
   * The main content of the journal entry (supports markdown formatting)
   * FULL-TEXT INDEXED: MongoDB text index enabled for keyword/phrase searches
   * See migration: packages/database/migrations/20251118000000-add-fulltext-search-remove-redundant-fields.js
   */
  content: Scalars['String']['output'];
  /** Timestamp when the journal entry was created */
  createdAt: Scalars['DateTime']['output'];
  /** User's email at time of journal entry creation */
  email?: Maybe<Scalars['String']['output']>;
  /**
   * Aggregated string of emojis representing the student's mood/emotions
   * Stored as a single string for easier analytics (e.g., "🎉😊🙂")
   */
  emojis: Scalars['String']['output'];
  /** User's first name at time of journal entry creation */
  firstName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /** User's last name at time of journal entry creation */
  lastName?: Maybe<Scalars['String']['output']>;
  /** User's phone number at time of journal entry creation */
  phoneNumber?: Maybe<Scalars['String']['output']>;
  /** Reference to the program this journal entry is associated with */
  programId: Scalars['String']['output'];
  /**
   * Program name for easier analytics (denormalized for performance)
   * NULLABLE: Optional field, may be null for entries created before this field was added
   */
  programName?: Maybe<Scalars['String']['output']>;
  /** Reference to the student who created this journal entry */
  studentId: Scalars['String']['output'];
  /**
   * Optional title for the journal entry
   * NULLABLE: User can create journal without title. If both title and activityName are null,
   * UI should display "Journal Entry - [createdAt]" as fallback identifier
   * FULL-TEXT INDEXED: MongoDB text index enabled for keyword/phrase searches (weighted higher than content)
   * See migration: packages/database/migrations/20251118000000-add-fulltext-search-remove-redundant-fields.js
   */
  title?: Maybe<Scalars['String']['output']>;
  /** Total number of activities in the program */
  totalActivities?: Maybe<Scalars['Int']['output']>;
  /**
   * Type of trigger that prompted this journal entry
   * Values: 'manual' | 'activity_started' | 'activity_completed'
   */
  triggerType?: Maybe<Scalars['String']['output']>;
  /** Timestamp when the journal entry was last updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User's MongoDB ObjectId (same as studentId for referential integrity) */
  userId?: Maybe<Scalars['String']['output']>;
};

export type JournalsAvgAggregate = {
  __typename?: 'JournalsAvgAggregate';
  activityPosition?: Maybe<Scalars['Float']['output']>;
  completionPercentage?: Maybe<Scalars['Float']['output']>;
  totalActivities?: Maybe<Scalars['Float']['output']>;
};

export type JournalsCountAggregate = {
  __typename?: 'JournalsCountAggregate';
  _all: Scalars['Int']['output'];
  activityName: Scalars['Int']['output'];
  activityPosition: Scalars['Int']['output'];
  completionPercentage: Scalars['Int']['output'];
  content: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  email: Scalars['Int']['output'];
  emojis: Scalars['Int']['output'];
  firstName: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  lastName: Scalars['Int']['output'];
  phoneNumber: Scalars['Int']['output'];
  programId: Scalars['Int']['output'];
  programName: Scalars['Int']['output'];
  studentId: Scalars['Int']['output'];
  title: Scalars['Int']['output'];
  totalActivities: Scalars['Int']['output'];
  triggerType: Scalars['Int']['output'];
  updatedAt: Scalars['Int']['output'];
  userId: Scalars['Int']['output'];
};

export type JournalsMaxAggregate = {
  __typename?: 'JournalsMaxAggregate';
  activityName?: Maybe<Scalars['String']['output']>;
  activityPosition?: Maybe<Scalars['Int']['output']>;
  completionPercentage?: Maybe<Scalars['Float']['output']>;
  content?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  emojis?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  programId?: Maybe<Scalars['String']['output']>;
  programName?: Maybe<Scalars['String']['output']>;
  studentId?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  totalActivities?: Maybe<Scalars['Int']['output']>;
  triggerType?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
};

export type JournalsMinAggregate = {
  __typename?: 'JournalsMinAggregate';
  activityName?: Maybe<Scalars['String']['output']>;
  activityPosition?: Maybe<Scalars['Int']['output']>;
  completionPercentage?: Maybe<Scalars['Float']['output']>;
  content?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  emojis?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  programId?: Maybe<Scalars['String']['output']>;
  programName?: Maybe<Scalars['String']['output']>;
  studentId?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  totalActivities?: Maybe<Scalars['Int']['output']>;
  triggerType?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
};

export type JournalsSumAggregate = {
  __typename?: 'JournalsSumAggregate';
  activityPosition?: Maybe<Scalars['Int']['output']>;
  completionPercentage?: Maybe<Scalars['Float']['output']>;
  totalActivities?: Maybe<Scalars['Int']['output']>;
};

export type JourneyEventCountAggregate = {
  __typename?: 'JourneyEventCountAggregate';
  _all: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  description: Scalars['Int']['output'];
  eventSubtype: Scalars['Int']['output'];
  eventType: Scalars['Int']['output'];
  icon: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  metadata: Scalars['Int']['output'];
  programId: Scalars['Int']['output'];
  sentiment: Scalars['Int']['output'];
  studentId: Scalars['Int']['output'];
  timestamp: Scalars['Int']['output'];
  title: Scalars['Int']['output'];
  updatedAt: Scalars['Int']['output'];
};

export type JourneyEventMaxAggregate = {
  __typename?: 'JourneyEventMaxAggregate';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  eventSubtype?: Maybe<Scalars['String']['output']>;
  eventType?: Maybe<Scalars['String']['output']>;
  icon?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  programId?: Maybe<Scalars['String']['output']>;
  sentiment?: Maybe<Scalars['String']['output']>;
  studentId?: Maybe<Scalars['String']['output']>;
  timestamp?: Maybe<Scalars['DateTime']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type JourneyEventMinAggregate = {
  __typename?: 'JourneyEventMinAggregate';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  eventSubtype?: Maybe<Scalars['String']['output']>;
  eventType?: Maybe<Scalars['String']['output']>;
  icon?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  programId?: Maybe<Scalars['String']['output']>;
  sentiment?: Maybe<Scalars['String']['output']>;
  studentId?: Maybe<Scalars['String']['output']>;
  timestamp?: Maybe<Scalars['DateTime']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type JourneySummaryCountAggregate = {
  __typename?: 'JourneySummaryCountAggregate';
  _all: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  currentState: Scalars['Int']['output'];
  dateString: Scalars['Int']['output'];
  generatedAt: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  programId: Scalars['Int']['output'];
  studentId: Scalars['Int']['output'];
  summary: Scalars['Int']['output'];
  updatedAt: Scalars['Int']['output'];
};

export type JourneySummaryMaxAggregate = {
  __typename?: 'JourneySummaryMaxAggregate';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  currentState?: Maybe<Scalars['String']['output']>;
  dateString?: Maybe<Scalars['String']['output']>;
  generatedAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  programId?: Maybe<Scalars['String']['output']>;
  studentId?: Maybe<Scalars['String']['output']>;
  summary?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type JourneySummaryMinAggregate = {
  __typename?: 'JourneySummaryMinAggregate';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  currentState?: Maybe<Scalars['String']['output']>;
  dateString?: Maybe<Scalars['String']['output']>;
  generatedAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  programId?: Maybe<Scalars['String']['output']>;
  studentId?: Maybe<Scalars['String']['output']>;
  summary?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type JsonFilter = {
  equals?: InputMaybe<Scalars['JSON']['input']>;
  not?: InputMaybe<Scalars['JSON']['input']>;
};

export type JsonNullableFilter = {
  equals?: InputMaybe<Scalars['JSON']['input']>;
  isSet?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<Scalars['JSON']['input']>;
};

export type L1CheckoutInit = {
  __typename?: 'L1CheckoutInit';
  clientSecret: Scalars['String']['output'];
  customerId: Scalars['String']['output'];
  subscriptionId: Scalars['String']['output'];
};

export type LandingPlacesInput = {
  /** Page size — default 24, max 100. */
  first?: InputMaybe<Scalars['Int']['input']>;
  /** Optional city-name substring filter (case-insensitive). */
  search?: InputMaybe<Scalars['String']['input']>;
  /** Offset — default 0. */
  skip?: InputMaybe<Scalars['Int']['input']>;
};

export type LangGraphAssistant = {
  __typename?: 'LangGraphAssistant';
  _count: LangGraphAssistantCount;
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  langGraphId: Scalars['String']['output'];
  metadata?: Maybe<Scalars['JSON']['output']>;
  name: Scalars['String']['output'];
  threads?: Maybe<Array<LangGraphThread>>;
  updatedAt: Scalars['DateTime']['output'];
  userAccess?: Maybe<Array<UserAssistantAccess>>;
};

export type LangGraphAssistantCount = {
  __typename?: 'LangGraphAssistantCount';
  threads: Scalars['Int']['output'];
  userAccess: Scalars['Int']['output'];
};

export type LangGraphAssistantCountAggregate = {
  __typename?: 'LangGraphAssistantCountAggregate';
  _all: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  description: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  isActive: Scalars['Int']['output'];
  langGraphId: Scalars['Int']['output'];
  metadata: Scalars['Int']['output'];
  name: Scalars['Int']['output'];
  updatedAt: Scalars['Int']['output'];
};

export type LangGraphAssistantCreateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  langGraphId: Scalars['String']['input'];
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  name: Scalars['String']['input'];
  threads?: InputMaybe<LangGraphThreadCreateNestedManyWithoutAssistantInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  userAccess?: InputMaybe<UserAssistantAccessCreateNestedManyWithoutAssistantInput>;
};

export type LangGraphAssistantCreateNestedOneWithoutThreadsInput = {
  connect?: InputMaybe<LangGraphAssistantWhereUniqueInput>;
  connectOrCreate?: InputMaybe<LangGraphAssistantCreateOrConnectWithoutThreadsInput>;
  create?: InputMaybe<LangGraphAssistantCreateWithoutThreadsInput>;
};

export type LangGraphAssistantCreateNestedOneWithoutUserAccessInput = {
  connect?: InputMaybe<LangGraphAssistantWhereUniqueInput>;
  connectOrCreate?: InputMaybe<LangGraphAssistantCreateOrConnectWithoutUserAccessInput>;
  create?: InputMaybe<LangGraphAssistantCreateWithoutUserAccessInput>;
};

export type LangGraphAssistantCreateOrConnectWithoutThreadsInput = {
  create: LangGraphAssistantCreateWithoutThreadsInput;
  where: LangGraphAssistantWhereUniqueInput;
};

export type LangGraphAssistantCreateOrConnectWithoutUserAccessInput = {
  create: LangGraphAssistantCreateWithoutUserAccessInput;
  where: LangGraphAssistantWhereUniqueInput;
};

export type LangGraphAssistantCreateWithoutThreadsInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  langGraphId: Scalars['String']['input'];
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  name: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  userAccess?: InputMaybe<UserAssistantAccessCreateNestedManyWithoutAssistantInput>;
};

export type LangGraphAssistantCreateWithoutUserAccessInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  langGraphId: Scalars['String']['input'];
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  name: Scalars['String']['input'];
  threads?: InputMaybe<LangGraphThreadCreateNestedManyWithoutAssistantInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type LangGraphAssistantMaxAggregate = {
  __typename?: 'LangGraphAssistantMaxAggregate';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  isActive?: Maybe<Scalars['Boolean']['output']>;
  langGraphId?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type LangGraphAssistantMinAggregate = {
  __typename?: 'LangGraphAssistantMinAggregate';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  isActive?: Maybe<Scalars['Boolean']['output']>;
  langGraphId?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type LangGraphAssistantRelationFilter = {
  is?: InputMaybe<LangGraphAssistantWhereInput>;
  isNot?: InputMaybe<LangGraphAssistantWhereInput>;
};

export type LangGraphAssistantUpdateInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  isActive?: InputMaybe<BoolFieldUpdateOperationsInput>;
  langGraphId?: InputMaybe<StringFieldUpdateOperationsInput>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  threads?: InputMaybe<LangGraphThreadUpdateManyWithoutAssistantNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  userAccess?: InputMaybe<UserAssistantAccessUpdateManyWithoutAssistantNestedInput>;
};

export type LangGraphAssistantUpdateOneRequiredWithoutThreadsNestedInput = {
  connect?: InputMaybe<LangGraphAssistantWhereUniqueInput>;
  connectOrCreate?: InputMaybe<LangGraphAssistantCreateOrConnectWithoutThreadsInput>;
  create?: InputMaybe<LangGraphAssistantCreateWithoutThreadsInput>;
  update?: InputMaybe<LangGraphAssistantUpdateToOneWithWhereWithoutThreadsInput>;
  upsert?: InputMaybe<LangGraphAssistantUpsertWithoutThreadsInput>;
};

export type LangGraphAssistantUpdateOneRequiredWithoutUserAccessNestedInput = {
  connect?: InputMaybe<LangGraphAssistantWhereUniqueInput>;
  connectOrCreate?: InputMaybe<LangGraphAssistantCreateOrConnectWithoutUserAccessInput>;
  create?: InputMaybe<LangGraphAssistantCreateWithoutUserAccessInput>;
  update?: InputMaybe<LangGraphAssistantUpdateToOneWithWhereWithoutUserAccessInput>;
  upsert?: InputMaybe<LangGraphAssistantUpsertWithoutUserAccessInput>;
};

export type LangGraphAssistantUpdateToOneWithWhereWithoutThreadsInput = {
  data: LangGraphAssistantUpdateWithoutThreadsInput;
  where?: InputMaybe<LangGraphAssistantWhereInput>;
};

export type LangGraphAssistantUpdateToOneWithWhereWithoutUserAccessInput = {
  data: LangGraphAssistantUpdateWithoutUserAccessInput;
  where?: InputMaybe<LangGraphAssistantWhereInput>;
};

export type LangGraphAssistantUpdateWithoutThreadsInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  isActive?: InputMaybe<BoolFieldUpdateOperationsInput>;
  langGraphId?: InputMaybe<StringFieldUpdateOperationsInput>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  userAccess?: InputMaybe<UserAssistantAccessUpdateManyWithoutAssistantNestedInput>;
};

export type LangGraphAssistantUpdateWithoutUserAccessInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  isActive?: InputMaybe<BoolFieldUpdateOperationsInput>;
  langGraphId?: InputMaybe<StringFieldUpdateOperationsInput>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  threads?: InputMaybe<LangGraphThreadUpdateManyWithoutAssistantNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type LangGraphAssistantUpsertWithoutThreadsInput = {
  create: LangGraphAssistantCreateWithoutThreadsInput;
  update: LangGraphAssistantUpdateWithoutThreadsInput;
  where?: InputMaybe<LangGraphAssistantWhereInput>;
};

export type LangGraphAssistantUpsertWithoutUserAccessInput = {
  create: LangGraphAssistantCreateWithoutUserAccessInput;
  update: LangGraphAssistantUpdateWithoutUserAccessInput;
  where?: InputMaybe<LangGraphAssistantWhereInput>;
};

export type LangGraphAssistantWhereInput = {
  AND?: InputMaybe<Array<LangGraphAssistantWhereInput>>;
  NOT?: InputMaybe<Array<LangGraphAssistantWhereInput>>;
  OR?: InputMaybe<Array<LangGraphAssistantWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  description?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<StringFilter>;
  isActive?: InputMaybe<BoolFilter>;
  langGraphId?: InputMaybe<StringFilter>;
  metadata?: InputMaybe<JsonNullableFilter>;
  name?: InputMaybe<StringFilter>;
  threads?: InputMaybe<LangGraphThreadListRelationFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  userAccess?: InputMaybe<UserAssistantAccessListRelationFilter>;
};

export type LangGraphAssistantWhereUniqueInput = {
  AND?: InputMaybe<Array<LangGraphAssistantWhereInput>>;
  NOT?: InputMaybe<Array<LangGraphAssistantWhereInput>>;
  OR?: InputMaybe<Array<LangGraphAssistantWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  description?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<BoolFilter>;
  langGraphId?: InputMaybe<Scalars['String']['input']>;
  metadata?: InputMaybe<JsonNullableFilter>;
  name?: InputMaybe<StringFilter>;
  threads?: InputMaybe<LangGraphThreadListRelationFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  userAccess?: InputMaybe<UserAssistantAccessListRelationFilter>;
};

export type LangGraphThread = {
  __typename?: 'LangGraphThread';
  assistant: LangGraphAssistant;
  assistantId: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  isArchived: Scalars['Boolean']['output'];
  langGraphId: Scalars['String']['output'];
  messages?: Maybe<Array<Message>>;
  metadata?: Maybe<Scalars['JSON']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  user: User;
  userId: Scalars['String']['output'];
};

export type LangGraphThreadCountAggregate = {
  __typename?: 'LangGraphThreadCountAggregate';
  _all: Scalars['Int']['output'];
  assistantId: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  isArchived: Scalars['Int']['output'];
  langGraphId: Scalars['Int']['output'];
  metadata: Scalars['Int']['output'];
  title: Scalars['Int']['output'];
  updatedAt: Scalars['Int']['output'];
  userId: Scalars['Int']['output'];
};

export type LangGraphThreadCreateManyAssistantInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isArchived?: InputMaybe<Scalars['Boolean']['input']>;
  langGraphId: Scalars['String']['input'];
  messages?: InputMaybe<Array<MessageCreateInput>>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  userId: Scalars['String']['input'];
};

export type LangGraphThreadCreateManyAssistantInputEnvelope = {
  data: Array<LangGraphThreadCreateManyAssistantInput>;
};

export type LangGraphThreadCreateManyUserInput = {
  assistantId: Scalars['String']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isArchived?: InputMaybe<Scalars['Boolean']['input']>;
  langGraphId: Scalars['String']['input'];
  messages?: InputMaybe<Array<MessageCreateInput>>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type LangGraphThreadCreateManyUserInputEnvelope = {
  data: Array<LangGraphThreadCreateManyUserInput>;
};

export type LangGraphThreadCreateNestedManyWithoutAssistantInput = {
  connect?: InputMaybe<Array<LangGraphThreadWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<LangGraphThreadCreateOrConnectWithoutAssistantInput>>;
  create?: InputMaybe<Array<LangGraphThreadCreateWithoutAssistantInput>>;
  createMany?: InputMaybe<LangGraphThreadCreateManyAssistantInputEnvelope>;
};

export type LangGraphThreadCreateNestedManyWithoutUserInput = {
  connect?: InputMaybe<Array<LangGraphThreadWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<LangGraphThreadCreateOrConnectWithoutUserInput>>;
  create?: InputMaybe<Array<LangGraphThreadCreateWithoutUserInput>>;
  createMany?: InputMaybe<LangGraphThreadCreateManyUserInputEnvelope>;
};

export type LangGraphThreadCreateOrConnectWithoutAssistantInput = {
  create: LangGraphThreadCreateWithoutAssistantInput;
  where: LangGraphThreadWhereUniqueInput;
};

export type LangGraphThreadCreateOrConnectWithoutUserInput = {
  create: LangGraphThreadCreateWithoutUserInput;
  where: LangGraphThreadWhereUniqueInput;
};

export type LangGraphThreadCreateWithoutAssistantInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isArchived?: InputMaybe<Scalars['Boolean']['input']>;
  langGraphId: Scalars['String']['input'];
  messages?: InputMaybe<Array<MessageCreateInput>>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  user: UserCreateNestedOneWithoutLangGraphThreadsInput;
};

export type LangGraphThreadCreateWithoutUserInput = {
  assistant: LangGraphAssistantCreateNestedOneWithoutThreadsInput;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isArchived?: InputMaybe<Scalars['Boolean']['input']>;
  langGraphId: Scalars['String']['input'];
  messages?: InputMaybe<Array<MessageCreateInput>>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type LangGraphThreadListRelationFilter = {
  every?: InputMaybe<LangGraphThreadWhereInput>;
  none?: InputMaybe<LangGraphThreadWhereInput>;
  some?: InputMaybe<LangGraphThreadWhereInput>;
};

export type LangGraphThreadMaxAggregate = {
  __typename?: 'LangGraphThreadMaxAggregate';
  assistantId?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  isArchived?: Maybe<Scalars['Boolean']['output']>;
  langGraphId?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
};

export type LangGraphThreadMinAggregate = {
  __typename?: 'LangGraphThreadMinAggregate';
  assistantId?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  isArchived?: Maybe<Scalars['Boolean']['output']>;
  langGraphId?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
};

export type LangGraphThreadScalarWhereInput = {
  AND?: InputMaybe<Array<LangGraphThreadScalarWhereInput>>;
  NOT?: InputMaybe<Array<LangGraphThreadScalarWhereInput>>;
  OR?: InputMaybe<Array<LangGraphThreadScalarWhereInput>>;
  assistantId?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<StringFilter>;
  isArchived?: InputMaybe<BoolFilter>;
  langGraphId?: InputMaybe<StringFilter>;
  metadata?: InputMaybe<JsonNullableFilter>;
  title?: InputMaybe<StringNullableFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  userId?: InputMaybe<StringFilter>;
};

export type LangGraphThreadUpdateManyMutationInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  isArchived?: InputMaybe<BoolFieldUpdateOperationsInput>;
  langGraphId?: InputMaybe<StringFieldUpdateOperationsInput>;
  messages?: InputMaybe<Array<MessageCreateInput>>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  title?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type LangGraphThreadUpdateManyWithWhereWithoutAssistantInput = {
  data: LangGraphThreadUpdateManyMutationInput;
  where: LangGraphThreadScalarWhereInput;
};

export type LangGraphThreadUpdateManyWithWhereWithoutUserInput = {
  data: LangGraphThreadUpdateManyMutationInput;
  where: LangGraphThreadScalarWhereInput;
};

export type LangGraphThreadUpdateManyWithoutAssistantNestedInput = {
  connect?: InputMaybe<Array<LangGraphThreadWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<LangGraphThreadCreateOrConnectWithoutAssistantInput>>;
  create?: InputMaybe<Array<LangGraphThreadCreateWithoutAssistantInput>>;
  createMany?: InputMaybe<LangGraphThreadCreateManyAssistantInputEnvelope>;
  delete?: InputMaybe<Array<LangGraphThreadWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<LangGraphThreadScalarWhereInput>>;
  disconnect?: InputMaybe<Array<LangGraphThreadWhereUniqueInput>>;
  set?: InputMaybe<Array<LangGraphThreadWhereUniqueInput>>;
  update?: InputMaybe<Array<LangGraphThreadUpdateWithWhereUniqueWithoutAssistantInput>>;
  updateMany?: InputMaybe<Array<LangGraphThreadUpdateManyWithWhereWithoutAssistantInput>>;
  upsert?: InputMaybe<Array<LangGraphThreadUpsertWithWhereUniqueWithoutAssistantInput>>;
};

export type LangGraphThreadUpdateManyWithoutUserNestedInput = {
  connect?: InputMaybe<Array<LangGraphThreadWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<LangGraphThreadCreateOrConnectWithoutUserInput>>;
  create?: InputMaybe<Array<LangGraphThreadCreateWithoutUserInput>>;
  createMany?: InputMaybe<LangGraphThreadCreateManyUserInputEnvelope>;
  delete?: InputMaybe<Array<LangGraphThreadWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<LangGraphThreadScalarWhereInput>>;
  disconnect?: InputMaybe<Array<LangGraphThreadWhereUniqueInput>>;
  set?: InputMaybe<Array<LangGraphThreadWhereUniqueInput>>;
  update?: InputMaybe<Array<LangGraphThreadUpdateWithWhereUniqueWithoutUserInput>>;
  updateMany?: InputMaybe<Array<LangGraphThreadUpdateManyWithWhereWithoutUserInput>>;
  upsert?: InputMaybe<Array<LangGraphThreadUpsertWithWhereUniqueWithoutUserInput>>;
};

export type LangGraphThreadUpdateWithWhereUniqueWithoutAssistantInput = {
  data: LangGraphThreadUpdateWithoutAssistantInput;
  where: LangGraphThreadWhereUniqueInput;
};

export type LangGraphThreadUpdateWithWhereUniqueWithoutUserInput = {
  data: LangGraphThreadUpdateWithoutUserInput;
  where: LangGraphThreadWhereUniqueInput;
};

export type LangGraphThreadUpdateWithoutAssistantInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  isArchived?: InputMaybe<BoolFieldUpdateOperationsInput>;
  langGraphId?: InputMaybe<StringFieldUpdateOperationsInput>;
  messages?: InputMaybe<Array<MessageCreateInput>>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  title?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  user?: InputMaybe<UserUpdateOneRequiredWithoutLangGraphThreadsNestedInput>;
};

export type LangGraphThreadUpdateWithoutUserInput = {
  assistant?: InputMaybe<LangGraphAssistantUpdateOneRequiredWithoutThreadsNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  isArchived?: InputMaybe<BoolFieldUpdateOperationsInput>;
  langGraphId?: InputMaybe<StringFieldUpdateOperationsInput>;
  messages?: InputMaybe<Array<MessageCreateInput>>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  title?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type LangGraphThreadUpsertWithWhereUniqueWithoutAssistantInput = {
  create: LangGraphThreadCreateWithoutAssistantInput;
  update: LangGraphThreadUpdateWithoutAssistantInput;
  where: LangGraphThreadWhereUniqueInput;
};

export type LangGraphThreadUpsertWithWhereUniqueWithoutUserInput = {
  create: LangGraphThreadCreateWithoutUserInput;
  update: LangGraphThreadUpdateWithoutUserInput;
  where: LangGraphThreadWhereUniqueInput;
};

export type LangGraphThreadWhereInput = {
  AND?: InputMaybe<Array<LangGraphThreadWhereInput>>;
  NOT?: InputMaybe<Array<LangGraphThreadWhereInput>>;
  OR?: InputMaybe<Array<LangGraphThreadWhereInput>>;
  assistant?: InputMaybe<LangGraphAssistantRelationFilter>;
  assistantId?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<StringFilter>;
  isArchived?: InputMaybe<BoolFilter>;
  langGraphId?: InputMaybe<StringFilter>;
  messages?: InputMaybe<Array<MessageObjectEqualityInput>>;
  metadata?: InputMaybe<JsonNullableFilter>;
  title?: InputMaybe<StringNullableFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  user?: InputMaybe<UserRelationFilter>;
  userId?: InputMaybe<StringFilter>;
};

export type LangGraphThreadWhereUniqueInput = {
  AND?: InputMaybe<Array<LangGraphThreadWhereInput>>;
  NOT?: InputMaybe<Array<LangGraphThreadWhereInput>>;
  OR?: InputMaybe<Array<LangGraphThreadWhereInput>>;
  assistant?: InputMaybe<LangGraphAssistantRelationFilter>;
  assistantId?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  isArchived?: InputMaybe<BoolFilter>;
  langGraphId?: InputMaybe<Scalars['String']['input']>;
  messages?: InputMaybe<Array<MessageObjectEqualityInput>>;
  metadata?: InputMaybe<JsonNullableFilter>;
  title?: InputMaybe<StringNullableFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  user?: InputMaybe<UserRelationFilter>;
  userId?: InputMaybe<StringFilter>;
};

export type LinkAccountResponse = {
  __typename?: 'LinkAccountResponse';
  /** Whether the conflicting accounts can be merged (only present when conflict is true) */
  canMerge?: Maybe<Scalars['Boolean']['output']>;
  /** Whether there is a conflict with existing account (false if no conflict) */
  conflict: Scalars['Boolean']['output'];
  /** ID of the conflicting user account (only present when conflict is true) */
  conflictUserId?: Maybe<Scalars['String']['output']>;
  /** ID of the merged account when accounts were automatically merged */
  mergedAccountId?: Maybe<Scalars['String']['output']>;
  /** Human-readable explanation of the linking result or error message if failed */
  message: Scalars['String']['output'];
  /** Whether OTP verification is required (false if not needed) */
  requiresVerification: Scalars['Boolean']['output'];
  /** Indicates if the account linking process completed successfully */
  success: Scalars['Boolean']['output'];
};

export type LinkEmailInput = {
  /** Email address to link to the account */
  email: Scalars['String']['input'];
  /** User explicitly consented to merge accounts if conflict exists */
  forceMerge?: InputMaybe<Scalars['Boolean']['input']>;
  /** 6-digit OTP code for email verification */
  otpCode?: InputMaybe<Scalars['String']['input']>;
  /** Password to set for this email identity */
  password?: InputMaybe<Scalars['String']['input']>;
  /** Skip OTP verification if password is already set */
  passwordSet?: InputMaybe<Scalars['Boolean']['input']>;
};

export type LinkPhoneInput = {
  /** User explicitly consented to merge accounts if conflict exists */
  forceMerge?: InputMaybe<Scalars['Boolean']['input']>;
  /** 6-digit OTP code for phone verification */
  otpCode?: InputMaybe<Scalars['String']['input']>;
  /** Phone number to link to the account (E.164 format) */
  phoneNumber: Scalars['String']['input'];
};

export type LogoutResponse = {
  __typename?: 'LogoutResponse';
  /** Indicates if the logout operation completed successfully */
  ok: Scalars['Boolean']['output'];
};

/** Long-range context configuration for cross-activity analysis */
export type LongRangeContextConfig = {
  __typename?: 'LongRangeContextConfig';
  enabled: Scalars['Boolean']['output'];
  maxRawContentChars?: Maybe<Scalars['Int']['output']>;
  spanThreshold?: Maybe<Scalars['Float']['output']>;
};

export type ManageOrganizationDomainInput = {
  /** The domain to manage (e.g., "example.com") */
  domain: Scalars['String']['input'];
  /** The Organization ID */
  organizationId: Scalars['String']['input'];
};

/** Result for markThreadAsRead mutation */
export type MarkReadResult = {
  __typename?: 'MarkReadResult';
  success: Scalars['Boolean']['output'];
  /** Number of messages marked as read */
  updatedCount: Scalars['Int']['output'];
};

export type MemberOrganizer = {
  __typename?: 'MemberOrganizer';
  /** First name of the member */
  firstName?: Maybe<Scalars['String']['output']>;
  /** Last name of the member */
  lastName?: Maybe<Scalars['String']['output']>;
  /** User ID of the member who is an organizer */
  userId: Scalars['String']['output'];
};

export type MergeEligibilityResponse = {
  __typename?: 'MergeEligibilityResponse';
  /** Whether the accounts are eligible to be merged */
  canMerge: Scalars['Boolean']['output'];
  /** Type of conflict: SAME_USER, DIFFERENT_USER, or NONE */
  conflictType: Scalars['String']['output'];
  /** ID of the existing account that owns this identity */
  conflictUserId?: Maybe<Scalars['String']['output']>;
  /** Whether the identity already exists in the system */
  exists: Scalars['Boolean']['output'];
  /** Whether the conflicting account has an email identity */
  hasEmail: Scalars['Boolean']['output'];
  /** Whether the conflicting account has a phone identity */
  hasPhone: Scalars['Boolean']['output'];
  /** User-friendly explanation of the merge eligibility status */
  message: Scalars['String']['output'];
};

export type Message = {
  __typename?: 'Message';
  content: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['String']['output'];
  langGraphId: Scalars['String']['output'];
  metadata?: Maybe<Scalars['JSON']['output']>;
  role: Scalars['String']['output'];
  runs?: Maybe<Array<Run>>;
};

export type MessageCreateInput = {
  content: Scalars['String']['input'];
  createdAt: Scalars['DateTime']['input'];
  id: Scalars['String']['input'];
  langGraphId: Scalars['String']['input'];
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  role: Scalars['String']['input'];
  runs?: InputMaybe<Array<RunCreateInput>>;
};

export type MessageObjectEqualityInput = {
  content: Scalars['String']['input'];
  createdAt: Scalars['DateTime']['input'];
  id: Scalars['String']['input'];
  langGraphId: Scalars['String']['input'];
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  role: Scalars['String']['input'];
  runs?: InputMaybe<Array<RunObjectEqualityInput>>;
};

export type MigrateIdentityInput = {
  /** ID of the account to remove identity from */
  fromUserId: Scalars['String']['input'];
  /** Phone number (E.164 format) or email address to migrate */
  identifier: Scalars['String']['input'];
  /** Type of identity to migrate */
  identityType: IdentityType;
  /** 6-digit OTP verification code */
  verificationCode: Scalars['String']['input'];
};

export type MigrateIdentityResponse = {
  __typename?: 'MigrateIdentityResponse';
  /** Human-readable explanation of the migration result or error details */
  message: Scalars['String']['output'];
  /** Indicates if the identity migration completed successfully */
  success: Scalars['Boolean']['output'];
};

export type MonitorCountAggregate = {
  __typename?: 'MonitorCountAggregate';
  _all: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  owner: Scalars['Int']['output'];
  participant_id: Scalars['Int']['output'];
  studentIds: Scalars['Int']['output'];
};

export type MonitorMaxAggregate = {
  __typename?: 'MonitorMaxAggregate';
  id?: Maybe<Scalars['String']['output']>;
  owner?: Maybe<Scalars['String']['output']>;
  participant_id?: Maybe<Scalars['String']['output']>;
};

export type MonitorMinAggregate = {
  __typename?: 'MonitorMinAggregate';
  id?: Maybe<Scalars['String']['output']>;
  owner?: Maybe<Scalars['String']['output']>;
  participant_id?: Maybe<Scalars['String']['output']>;
};

export type MonitorMonkey = {
  __typename?: 'MonitorMonkey';
  claimedAt?: Maybe<Scalars['Float']['output']>;
  shareCode?: Maybe<Scalars['String']['output']>;
  userID?: Maybe<Scalars['String']['output']>;
};

/** Per-program participant count */
export type MonitorProgramCount = {
  __typename?: 'MonitorProgramCount';
  count: Scalars['Int']['output'];
  programId: Scalars['String']['output'];
  programName?: Maybe<Scalars['String']['output']>;
};

/** Response for getMonitorProgramCounts — participant counts per program */
export type MonitorProgramCountsResponse = {
  __typename?: 'MonitorProgramCountsResponse';
  programs: Array<MonitorProgramCount>;
  totalCount: Scalars['Int']['output'];
};

export type MonitorProgramDocs = {
  __typename?: 'MonitorProgramDocs';
  _id: Scalars['String']['output'];
  organizers?: Maybe<Array<Maybe<Scalars['JSONObject']['output']>>>;
  programName?: Maybe<Scalars['String']['output']>;
};

export type MonitorResponse = {
  __typename?: 'MonitorResponse';
  monitoredStudents: Array<MonitoredStudent>;
  programDocs?: Maybe<Array<Maybe<MonitorProgramDocs>>>;
  studentsLength?: Maybe<Scalars['Int']['output']>;
};

/** Lightweight roster response for Monitor page initial load */
export type MonitorRosterResponse = {
  __typename?: 'MonitorRosterResponse';
  roster: Array<RosterStudent>;
  rosterLength?: Maybe<Scalars['Int']['output']>;
};

/** Minimal student record with scores only for Quadrant view */
export type MonitorScoreStudent = {
  __typename?: 'MonitorScoreStudent';
  _id: Scalars['String']['output'];
  name?: Maybe<Scalars['String']['output']>;
  /** Scoring data: riskScore, potentialScore, quadrant, scoredAt */
  scores?: Maybe<Scalars['JSONObject']['output']>;
};

/** Response for getMonitorScores — all scored students for Quadrant view */
export type MonitorScoresResponse = {
  __typename?: 'MonitorScoresResponse';
  students: Array<MonitorScoreStudent>;
  totalCount: Scalars['Int']['output'];
};

export type MonitoredStudent = {
  __typename?: 'MonitoredStudent';
  _id?: Maybe<Scalars['String']['output']>;
  adks?: Maybe<Array<Maybe<Scalars['JSONObject']['output']>>>;
  adksCompletion?: Maybe<Scalars['Float']['output']>;
  controllable?: Maybe<Scalars['Boolean']['output']>;
  defaultOffer?: Maybe<Scalars['JSONObject']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  grade?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  offerStatus?: Maybe<Scalars['Boolean']['output']>;
  participant_id?: Maybe<Scalars['String']['output']>;
  /** Profile image URLs object with small, medium, large */
  profile?: Maybe<Scalars['JSONObject']['output']>;
  program?: Maybe<Scalars['String']['output']>;
  program_id?: Maybe<Scalars['String']['output']>;
  /** School info object with name, district, etc. from StudentPortfolio */
  school?: Maybe<Scalars['JSONObject']['output']>;
  /** Scoring data: riskScore, potentialScore, quadrant, scoredAt */
  scores?: Maybe<Scalars['JSONObject']['output']>;
  studentStatus?: Maybe<Scalars['String']['output']>;
  teamName?: Maybe<Scalars['String']['output']>;
  timeSheetHrs?: Maybe<Scalars['String']['output']>;
  videoAskResponse?: Maybe<Scalars['String']['output']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  activateCommsExperiment: CommsExperiment;
  activateCommsSequence: CommsSequence;
  /** Add bank account to Stripe Connect account */
  addBankAccount: PaymentResponse;
  addCommsExperimentVariant: Scalars['JSON']['output'];
  /** Add a domain after email verification (admin/owner only) */
  addOrganizationDomainAfterVerification: DomainManagementResponse;
  /** Update an organization logo (admin only) */
  adminUpdateOrganizationLogo: Organization;
  advanceCommsExperimentStage: CommsExperiment;
  analyzeCommsExperiment: CommsExperimentAnalysis;
  /** Soft-archive a goal (sets status to "archived"). */
  archiveShiftSpendGoal: Scalars['Boolean']['output'];
  archiveThread: Scalars['Boolean']['output'];
  /** Add a new login method (email/phone) to an existing account. */
  authAddIdentityToExistingAccount: LinkAccountResponse;
  /** Add password authentication to an existing email OTP account. */
  authAddPasswordToAccount: AddPasswordToAccountResponse;
  /** Change the password for the current authenticated user. */
  authChangePassword: AuthResponse;
  /** Initiate a password reset flow for a user. */
  authForgotPassword: ForgotPasswordResponse;
  /** Link an email address to an SMS-only account. */
  authLinkEmail: LinkAccountResponse;
  /** Link a phone number to an email-only account. */
  authLinkPhone: LinkAccountResponse;
  /** Clear auth cookies and logout. */
  authLogout: LogoutResponse;
  /** Migrate an Auth0 identity from one account to another. */
  authMigrateIdentity: MigrateIdentityResponse;
  /** Process Auth0 authorization code callback. */
  authProcessCallback: AuthResponse;
  /** Refresh access and refresh tokens via cookies. */
  authRefresh: RefreshResponse;
  /** Resend a captcha for verification purposes. */
  authResendCaptcha: ResendCaptchaResponse;
  /** Resend an OTP code for verification. */
  authResendOtp: ResendOtpResponse;
  /** Sign in a user with various methods. */
  authSignIn: AuthResponse;
  /** Register a new user. */
  authSignUp: AuthResponse;
  /** Verify a JWT token and return user information. */
  authVerifyJwt: VerifyJwtResponse;
  /** Verify an OTP for sign-in or other actions. */
  authVerifyOtp: AuthResponse;
  cancelCommsCampaign: CommsCampaign;
  cancelMySubscription: Scalars['Boolean']['output'];
  /** Cancel a pending stakeholder invitation (admin/owner only) */
  cancelStakeholderInvitation: CancelInvitationResponse;
  /** Cancel an existing subscription */
  cancelSubscription: Subscription;
  /** Clears the link keys of the given kind for a program, forcing re-tagging on the next roadmap generation. Returns false on failure (logged server-side). */
  clearProgramGroundingTags: Scalars['Boolean']['output'];
  /** Clone an ActivitySchema for embedding in a Program. Preserves lineage via sourceActivitySchemaId. */
  cloneActivitySchemaToProgram: CloneActivitySchemaResult;
  /** Clone a report template for customization (member only) */
  cloneReportTemplate: OrgReportTemplate;
  /** Prepare a refined estimate by cloning a source goal. The new goal is NOT created here — the client should send the returned originalInput back through the /shiftspend/estimate SSE endpoint. */
  cloneShiftSpendGoal: ShiftSpendGoalOutput;
  commsDuplicateAudience: CommsAudience;
  /** Complete AIPM onboarding and trigger 0th message */
  completeAIPMOnboarding: CompleteOnboardingResultType;
  /** Confirm and process a program checkout after Stripe redirect. Idempotent with webhook. */
  confirmProgramCheckout: Scalars['Boolean']['output'];
  /** Confirm payment after embedded card form. Idempotent with webhook. */
  confirmWalletPaymentIntent: Scalars['Boolean']['output'];
  /** Create a new ActivitySchema in the library. */
  createActivitySchema: ActivitySchema;
  /** Create a new ActivitySchema using simplified JSON input (no envelope wrappers needed). */
  createActivitySchemaSimplified: ActivitySchema;
  createAssistant: LangGraphAssistant;
  createAutomationProgram: Program;
  createCommsAudience: CommsAudience;
  createCommsCampaign: CommsCampaign;
  /** Create an email channel for sending campaigns via email */
  createCommsEmailChannel: CommsPhoneLine;
  createCommsExperiment: CommsExperiment;
  createCommsOpportunity: CommsOpportunity;
  /** Create a new automation rule */
  createCommsRule: CommsRule;
  createCommsSequence: CommsSequence;
  /** Create a new tag */
  createCommsTag: CommsTag;
  /** Create Stripe Connect account for receiving payments */
  createConnectAccount: PaymentResponse;
  createCustomerPortalSession: CustomerPortalSession;
  /** Create a new Ecosystem */
  createEcosystem: Ecosystem;
  /** Create a new EcosystemPlace */
  createEcosystemPlace: EcosystemPlace;
  /** Create an endorsement request and send email to endorser */
  createEndorsementRequest: CreateEndorsementRequestResponse;
  /** Create Stripe invoice with line items */
  createInvoice: CreateInvoiceResponse;
  /** Create a new journal entry. The entry will be associated with the authenticated user. */
  createJournal: Journals;
  createL1Checkout: L1CheckoutInit;
  /** Create Stripe Checkout session for payment */
  createPaymentCheckout: PaymentResponse;
  /** Create recurring monthly platform donation subscription */
  createPlatformDonationSubscription: Subscription;
  createProgramByTemplateId: Program;
  /** Create a new ProgramDesign from AI interview data */
  createProgramDesign: ProgramDesign;
  /** Create a shareable link for a report template (org member only) */
  createReportShare: ReportShareTokenOutput;
  /** Create a new custom report template (member only) */
  createReportTemplate: OrgReportTemplate;
  createScaledCampaign: CommsSequence;
  /**
   * Create Stripe Checkout session to pay a student for project work
   * @deprecated Use createWalletPaymentCheckout mutation instead with payment_type=student_payment.
   */
  createStudentPaymentCheckout: StudentPaymentCheckoutResponse;
  /**
   * Withdraw funds from student wallet to bank account
   * @deprecated Use createUnifiedWithdrawal mutation instead. The unified withdrawal combines all payment types.
   */
  createStudentWithdrawal: StudentWalletWithdrawalResponse;
  createThread: LangGraphThread;
  /** Withdraw funds from unified wallet to bank account */
  createUnifiedWithdrawal: UnifiedWithdrawalResponse;
  /** Create Stripe checkout session for wallet payment */
  createWalletPaymentCheckout: WalletPaymentCheckoutResponse;
  /** Create Stripe PaymentIntent for embedded card form payment */
  createWalletPaymentIntent: WalletPaymentIntentResponse;
  /**
   * Withdraw funds from wallet to bank account
   * @deprecated Use createUnifiedWithdrawal mutation instead. The unified withdrawal combines all payment types.
   */
  createWithdrawal: PaymentResponse;
  /** Delete (archive) an ActivitySchema. Requires creator or superadmin permission. */
  deleteActivitySchema: Scalars['Boolean']['output'];
  deleteAssistant: Scalars['Boolean']['output'];
  deleteCommsAudience: Scalars['Boolean']['output'];
  deleteCommsExperiment: Scalars['Boolean']['output'];
  deleteCommsOpportunity: Scalars['Boolean']['output'];
  /** Delete an automation rule */
  deleteCommsRule: Scalars['Boolean']['output'];
  deleteCommsSequence: Scalars['Boolean']['output'];
  /** Delete a tag and all its associations */
  deleteCommsTag: Scalars['Boolean']['output'];
  /** Delete an Ecosystem (owner only) */
  deleteEcosystem: Scalars['Boolean']['output'];
  /** Delete a journal entry. User must own the entry. */
  deleteJournal: Journals;
  /** Delete a custom report template (member only) */
  deleteReportTemplate: Scalars['Boolean']['output'];
  /** Delete a roadmap by ID (authenticated users only for ownership check) */
  deleteRoadmap: Scalars['Boolean']['output'];
  /** Hard-delete a goal (owner-only). */
  deleteShiftSpendGoal: Scalars['Boolean']['output'];
  deleteVideoAskResponse: VideoAskOperationResult;
  /** Dismiss AIPM onboarding dialog for 24 hours */
  dismissAIPMOnboarding: DismissalResultType;
  /** Duplicate an Ecosystem (deep-forks linked ProgramDesigns; new copy is private and owned by current user) */
  duplicateEcosystem: Ecosystem;
  familyAddMember: FamilyMember;
  familyAssociateFaceToMember: FamilyFaceCrop;
  /** Claim yourself as a FamilyMember. Links current user to the member via linkedUserId. Rejects if already claimed. */
  familyClaimMember: FamilyMember;
  familyClearMemberAvatar: FamilyMember;
  familyCreate: Family;
  /** Extract a bbox from an existing FamilyPhoto into a 400x400 avatar. */
  familyCreateFaceCrop: FamilyFaceCrop;
  familyCreateRelationship: FamilyRelationship;
  familyCreateView: FamilyView;
  familyDelete: Scalars['Boolean']['output'];
  familyDeleteMember: Scalars['Boolean']['output'];
  familyDeletePhoto: Scalars['Boolean']['output'];
  familyDeleteRelationship: Scalars['Boolean']['output'];
  /** Deep-clone an entire family into a new entity owned by the caller. Used as user-level recovery. */
  familyDuplicate: Family;
  familySetMemberAvatar: FamilyMember;
  familyUnclaimMember: FamilyMember;
  familyUpdate: Family;
  familyUpdateMember: FamilyMember;
  familyUpdateView: FamilyView;
  /** Fork an existing ProgramDesign — creates a copy with new ownership */
  forkProgramDesign: ProgramDesign;
  /** Generate AI content for roadmap using OpenAI (10-30s response time). Supports caching for identical inputs. */
  generateRoadmapAI: GenerateRoadmapAiOutput;
  /** Generate a share token for public access (owner only) */
  generateShareToken: Ecosystem;
  /** Get Stripe Connect onboarding URL for account setup */
  getConnectAccountLink: PaymentResponse;
  /** Initialize AIPM onboarding session for current user */
  initializeAIPMOnboarding: InitializeOnboardingResultType;
  logContactSalesClicked: Scalars['Boolean']['output'];
  /** Log an AI Creator event (apply, reject, undo) */
  logCreatorEvent: Scalars['Boolean']['output'];
  /** Log a view of a shared ecosystem */
  logEcosystemView: Scalars['Boolean']['output'];
  logMeetingScheduled: Scalars['Boolean']['output'];
  /** Log that a user downloaded a shared report (public) */
  logReportDownload: Scalars['Boolean']['output'];
  /** Log a report export for audit trail (member only) */
  logReportExport: Scalars['Boolean']['output'];
  /** Mark a conversation as read (set unreadCount to 0) */
  markCommsConversationRead: Scalars['Boolean']['output'];
  /** Mark all unread inbound messages in a thread as acknowledged. User must be the participant (owner) of the thread. */
  markThreadAsRead: MarkReadResult;
  /** Migrate all anonymous roadmaps for an email to authenticated user account */
  migrateAnonymousRoadmaps: Array<SavedScopeOutput>;
  /** Migrate saved scopes from device ID to user ID */
  migrateDeviceSaves: Scalars['Boolean']['output'];
  /** Send an SMS OTP to a nurse for ShiftSpend login. */
  nurseRequestOtp: NurseOtpResponse;
  /** Verify SMS OTP, ensure User has nurse role, and create NursePortfolio if needed. */
  nurseVerifyOtp: NurseAuthResponse;
  pauseCommsExperiment: CommsExperiment;
  pauseCommsSequence: CommsSequence;
  reAttachVideoaskResponse: VideoAskOperationResult;
  refreshCommsSequenceAudience: Scalars['JSON']['output'];
  refreshVideoAskTranscription: VideoAskOperationResult;
  /** Refund a payment transaction */
  refundPayment: PaymentResponse;
  /** Remove bank account from Stripe Connect account */
  removeBankAccount: PaymentResponse;
  /** Remove a domain from an organization (admin/owner only) */
  removeOrganizationDomain: DomainManagementResponse;
  /** Remove a member from an organization (admin/owner only) */
  removeOrganizationMember: CancelInvitationResponse;
  /** Remove user's presence from a program (e.g., when leaving or logging out) */
  removePresence: Scalars['Boolean']['output'];
  removeProfileImage: UploadProfileImageResponse;
  /** Resend phone verification OTP to participant (coordinator only) */
  resendAIPMVerification: ResendVerificationResultType;
  /** Resend endorsement request email to endorser */
  resendEndorsementEmail: ResendEndorsementEmailResponse;
  resumeCommsExperiment: CommsExperiment;
  resumeCommsSequence: CommsSequence;
  resumeMySubscription: Scalars['Boolean']['output'];
  /** Revoke a report share link (org member only) */
  revokeReportShare: Scalars['Boolean']['output'];
  saveBulkSetupScopes: Scalars['JSONObject']['output'];
  /** Save an invitation to Airtable */
  saveInvitation: Invitation;
  /** Save a new roadmap with email (anonymous) or userId (authenticated) */
  saveRoadmap: SavedScopeOutput;
  /** Save a scope configuration to Airtable */
  saveScope: AirtableSavedScope;
  scaleCommsExperimentWinner: CommsExperimentAnalysis;
  /** Select an AI mentor persona for current user */
  selectAIPMPersona: SelectPersonaResultType;
  /** Send email verification OTP to current user */
  sendAIPMEmailVerification: EmailVerificationSendResultType;
  /** Send phone verification OTP to current user */
  sendAIPMPhoneVerification: PhoneVerificationSendResultType;
  /** Send a 6-digit OTP to an email address for activity-level verification (does NOT modify Auth0/User) */
  sendActivityEmailOtp: ActivityOtpResponse;
  /** Send a 6-digit OTP to a phone number for activity-level verification (does NOT modify Auth0/User) */
  sendActivityPhoneOtp: ActivityOtpResponse;
  sendCommsCampaign: CommsCampaign;
  /** Send a 6-digit verification code to join an organization */
  sendOrganizationVerificationCode: VerificationResponse;
  /** Send verification code to email for report access (public) */
  sendReportAccessCode: Scalars['Boolean']['output'];
  /** Set or clear the credential validator for a participant (PilotCity admins only) */
  setCredentialValidator: SetCredentialValidatorResponse;
  /** Set a bank account as default for currency payouts */
  setDefaultBankAccount: PaymentResponse;
  /** Set the default Student instance for a user+program */
  setDefaultInstance: Student;
  /** Set slug for current user (authenticated) */
  setMyProfileSlug: SetSlugOutput;
  /** Toggle public visibility for org portfolio (authenticated, admin only) */
  setOrgPortfolioPublic: Scalars['Boolean']['output'];
  /** Set slug for an organization (authenticated, admin only) */
  setOrgProfileSlug: SetSlugOutput;
  /** Set the primary domain for an organization (admin/owner only) */
  setOrganizationPrimaryDomain: DomainManagementResponse;
  /** Toggle public visibility for user portfolio (authenticated) */
  setPortfolioPublic: Scalars['Boolean']['output'];
  /** Skip onboarding for participant (coordinator only, if program allows) */
  skipAIPMOnboarding: SkipOnboardingResultType;
  /** Submit an endorsement (public - token validates the request) */
  submitEndorsement: SubmitEndorsementResponse;
  /** Submit an RSVP/Watch Party form */
  submitRSVP: RsvpRecord;
  /** Apply a tag to a conversation */
  tagCommsConversation: Scalars['Boolean']['output'];
  /** Test batch profile fetching performance (for cache demo) */
  testBatchProfiles: BatchProfileTestResult;
  /** Toggle AIPM check-in messages on/off */
  toggleAIPM: ToggleAipmResultType;
  /** Toggle a rule enabled/disabled */
  toggleCommsRule: CommsRule;
  /** Trigger completion celebration when participant reaches 100% */
  triggerCompletionCelebration: CompletionCelebrationResultType;
  /** Remove a tag from a conversation */
  untagCommsConversation: Scalars['Boolean']['output'];
  /** Update an existing ActivitySchema. Requires creator or superadmin permission. */
  updateActivitySchema: ActivitySchema;
  /** Update an existing ActivitySchema using simplified JSON input (no envelope wrappers needed). */
  updateActivitySchemaSimplified: ActivitySchema;
  updateAssistant: LangGraphAssistant;
  updateAutomationAdk: Program;
  /** Update bank account holder information or default status */
  updateBankAccount: PaymentResponse;
  updateCommsAudience: CommsAudience;
  updateCommsOpportunity: CommsOpportunity;
  /** Update a phone line label */
  updateCommsPhoneLine: CommsPhoneLine;
  /** Update an automation rule */
  updateCommsRule: CommsRule;
  updateCommsSequence: CommsSequence;
  updateCommsSequenceStep: CommsSequenceStep;
  /** Update a tag */
  updateCommsTag: CommsTag;
  /** Update Stripe Connect account information */
  updateConnectAccount: PaymentResponse;
  /** Update an existing Ecosystem (supports auth or shareToken) */
  updateEcosystem: Ecosystem;
  /** Update an EcosystemPlace */
  updateEcosystemPlace: EcosystemPlace;
  /** Update a journal entry. User must own the entry. */
  updateJournal: Journals;
  /** Update an organization logo (org members only) */
  updateOrganizationLogo: Organization;
  /** Update an organization name (org members only). Propagates to all denormalized copies. */
  updateOrganizationName: Organization;
  /** Update user portfolio data for a specific portfolio type (User, Teacher, Student, etc.). */
  updatePortfolio: UpdatePortfolioResponse;
  /** Update portfolio data for a specific user by ID (admin/organizer access only). */
  updatePortfolioById: UpdatePortfolioResponse;
  /** Update user's presence in a program (heartbeat). Call this periodically to indicate the user is active. */
  updatePresence: PresenceUpdateResult;
  /** Update an existing ProgramDesign */
  updateProgramDesign: ProgramDesign;
  /** Update the locations array (and optionally deliveryModality) on a program. Replaces the full array. */
  updateProgramLocations: Program;
  updateProgramTimeSettings: Scalars['JSONObject']['output'];
  /** Update an existing custom report template (member only) */
  updateReportTemplate: OrgReportTemplate;
  /** Update a sponsor link shareCode to a custom value */
  updateShareCode: SponsorLinkOutput;
  /** Update a student preference. User must own the student record. */
  updateStudentPreference: Student;
  updateThread: LangGraphThread;
  uploadADKSchema: Scalars['Boolean']['output'];
  /** Upload a document for an ADK field. Returns file URL and metadata. */
  uploadDocument: UploadDocumentResponse;
  /** Upload a base64 image as organization logo (org members only) */
  uploadOrganizationLogoImage: Organization;
  uploadProfileImage: UploadProfileImageResponse;
  /** Update the nurse portfolio (tax rate, employers, rate profiles, license info). */
  upsertNursePortfolio: NursePortfolioOutput;
  /** Initiate AI validation for an uploaded document. Returns a validationId for status polling. */
  validateDocument: ValidateDocumentResponse;
  /** Verify email OTP code for current user */
  verifyAIPMEmail: EmailVerificationResultType;
  /** Verify phone OTP code for current user */
  verifyAIPMPhone: PhoneVerificationResultType;
  /** Verify a 6-digit OTP for activity-level email verification (does NOT modify Auth0/User) */
  verifyActivityEmailOtp: ActivityOtpResponse;
  /** Verify a 6-digit OTP for activity-level phone verification (does NOT modify Auth0/User) */
  verifyActivityPhoneOtp: ActivityOtpResponse;
  /** Verify bank account via microdeposits or document upload */
  verifyBankAccount: BankAccountVerificationResponse;
  /** Verify a 6-digit code and join an organization */
  verifyOrganizationCode: VerificationResponse;
  /** Verify a 6-digit code and join an organization (authenticated) */
  verifyOrganizationCodeAuthenticated: VerificationResponse;
  /** Verify email code to access shared report (public) */
  verifyReportAccess: VerifyReportAccessOutput;
};


export type MutationActivateCommsExperimentArgs = {
  id: Scalars['String']['input'];
};


export type MutationActivateCommsSequenceArgs = {
  id: Scalars['String']['input'];
};


export type MutationAddBankAccountArgs = {
  input: CreateBankAccountTokenInput;
};


export type MutationAddCommsExperimentVariantArgs = {
  experimentId: Scalars['String']['input'];
  variant: Scalars['JSON']['input'];
};


export type MutationAddOrganizationDomainAfterVerificationArgs = {
  input: AddOrganizationDomainAfterVerificationInput;
};


export type MutationAdminUpdateOrganizationLogoArgs = {
  input: AdminUpdateOrganizationLogoInput;
};


export type MutationAdvanceCommsExperimentStageArgs = {
  id: Scalars['String']['input'];
};


export type MutationAnalyzeCommsExperimentArgs = {
  id: Scalars['String']['input'];
};


export type MutationArchiveShiftSpendGoalArgs = {
  id: Scalars['ID']['input'];
};


export type MutationArchiveThreadArgs = {
  id: Scalars['String']['input'];
};


export type MutationAuthAddIdentityToExistingAccountArgs = {
  input: AddIdentityToExistingAccountInput;
};


export type MutationAuthAddPasswordToAccountArgs = {
  input: AddPasswordToAccountInput;
};


export type MutationAuthChangePasswordArgs = {
  input: ChangePasswordInput;
};


export type MutationAuthForgotPasswordArgs = {
  input: ForgotPasswordInput;
};


export type MutationAuthLinkEmailArgs = {
  input: LinkEmailInput;
};


export type MutationAuthLinkPhoneArgs = {
  input: LinkPhoneInput;
};


export type MutationAuthMigrateIdentityArgs = {
  input: MigrateIdentityInput;
};


export type MutationAuthProcessCallbackArgs = {
  input: Auth0CallbackInput;
};


export type MutationAuthResendCaptchaArgs = {
  input: ResendCaptchaInput;
};


export type MutationAuthResendOtpArgs = {
  input: ResendOtpInput;
};


export type MutationAuthSignInArgs = {
  input: SignInInput;
};


export type MutationAuthSignUpArgs = {
  input: SignUpInput;
};


export type MutationAuthVerifyJwtArgs = {
  input: VerifyJwtInput;
};


export type MutationAuthVerifyOtpArgs = {
  input: VerifyOtpInput;
};


export type MutationCancelCommsCampaignArgs = {
  campaignId: Scalars['String']['input'];
};


export type MutationCancelStakeholderInvitationArgs = {
  input: CancelInvitationInput;
};


export type MutationCancelSubscriptionArgs = {
  input: CancelSubscriptionInput;
};


export type MutationClearProgramGroundingTagsArgs = {
  kind: Scalars['String']['input'];
  programId: Scalars['String']['input'];
};


export type MutationCloneActivitySchemaToProgramArgs = {
  activitySchemaId: Scalars['String']['input'];
  programId: Scalars['String']['input'];
};


export type MutationCloneReportTemplateArgs = {
  input: CloneReportTemplateInput;
};


export type MutationCloneShiftSpendGoalArgs = {
  input: CloneShiftSpendGoalInput;
};


export type MutationCommsDuplicateAudienceArgs = {
  id: Scalars['String']['input'];
};


export type MutationCompleteAipmOnboardingArgs = {
  input: CompleteOnboardingInput;
};


export type MutationConfirmProgramCheckoutArgs = {
  sessionId: Scalars['String']['input'];
};


export type MutationConfirmWalletPaymentIntentArgs = {
  paymentIntentId: Scalars['String']['input'];
};


export type MutationCreateActivitySchemaArgs = {
  data: ActivitySchemaCreateInput;
};


export type MutationCreateActivitySchemaSimplifiedArgs = {
  data: CreateActivitySchemaInput;
};


export type MutationCreateAssistantArgs = {
  data: LangGraphAssistantCreateInput;
};


export type MutationCreateAutomationProgramArgs = {
  data: Scalars['JSONObject']['input'];
};


export type MutationCreateCommsAudienceArgs = {
  contactCount?: InputMaybe<Scalars['Int']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<Scalars['JSON']['input']>;
  memberCount?: InputMaybe<Scalars['Int']['input']>;
  memberIds?: InputMaybe<Array<Scalars['String']['input']>>;
  name: Scalars['String']['input'];
  type: Scalars['String']['input'];
};


export type MutationCreateCommsCampaignArgs = {
  audienceId?: InputMaybe<Scalars['String']['input']>;
  excludeUserIds?: InputMaybe<Array<Scalars['String']['input']>>;
  filterState: Scalars['JSON']['input'];
  messageTemplate: Scalars['String']['input'];
  name: Scalars['String']['input'];
  phoneLineId: Scalars['String']['input'];
  scheduledAt?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCreateCommsEmailChannelArgs = {
  emailAddress: Scalars['String']['input'];
  emailName: Scalars['String']['input'];
  inboundRouting?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCreateCommsExperimentArgs = {
  aiContext?: InputMaybe<Scalars['JSON']['input']>;
  autoScaleThreshold?: InputMaybe<Scalars['JSON']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  goal?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  opportunityCta?: InputMaybe<Scalars['String']['input']>;
  opportunityId?: InputMaybe<Scalars['String']['input']>;
  opportunityType: Scalars['String']['input'];
  overlapProtection?: InputMaybe<Scalars['Boolean']['input']>;
  phoneLineId: Scalars['String']['input'];
  scaleBehavior?: InputMaybe<Scalars['String']['input']>;
  scalingConfig?: InputMaybe<Scalars['JSON']['input']>;
  source?: InputMaybe<Scalars['String']['input']>;
  testStrategy?: InputMaybe<Scalars['String']['input']>;
  variants: Scalars['JSON']['input'];
};


export type MutationCreateCommsOpportunityArgs = {
  cta?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  goal?: InputMaybe<Scalars['String']['input']>;
  linkedProgramId?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  successMetrics?: InputMaybe<Scalars['JSON']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCreateCommsRuleArgs = {
  actions: Scalars['JSON']['input'];
  conditions: Scalars['JSON']['input'];
  name: Scalars['String']['input'];
  sortOrder?: InputMaybe<Scalars['Int']['input']>;
  stopProcessing?: InputMaybe<Scalars['Boolean']['input']>;
  triggers: Scalars['JSON']['input'];
};


export type MutationCreateCommsSequenceArgs = {
  audienceFilters?: InputMaybe<Scalars['JSON']['input']>;
  goal?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  opportunityCta?: InputMaybe<Scalars['String']['input']>;
  opportunityId?: InputMaybe<Scalars['String']['input']>;
  opportunityType?: InputMaybe<Scalars['String']['input']>;
  phoneLineId: Scalars['String']['input'];
  settings?: InputMaybe<Scalars['JSON']['input']>;
  steps: Scalars['JSON']['input'];
  type: Scalars['String']['input'];
};


export type MutationCreateCommsTagArgs = {
  color?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  pinned?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationCreateConnectAccountArgs = {
  input: CreateStripeAccountInput;
};


export type MutationCreateCustomerPortalSessionArgs = {
  returnUrl: Scalars['String']['input'];
};


export type MutationCreateEcosystemArgs = {
  data: Scalars['JSON']['input'];
};


export type MutationCreateEcosystemPlaceArgs = {
  data: Scalars['JSON']['input'];
};


export type MutationCreateEndorsementRequestArgs = {
  input: CreateEndorsementRequestInput;
};


export type MutationCreateInvoiceArgs = {
  input: CreateInvoiceInput;
};


export type MutationCreateJournalArgs = {
  data: CreateJournalInput;
};


export type MutationCreatePaymentCheckoutArgs = {
  input: CreateCheckoutSessionInput;
};


export type MutationCreatePlatformDonationSubscriptionArgs = {
  input: CreatePlatformDonationInput;
};


export type MutationCreateProgramByTemplateIdArgs = {
  data: Scalars['JSONObject']['input'];
  templateId: Scalars['String']['input'];
};


export type MutationCreateProgramDesignArgs = {
  data: Scalars['JSON']['input'];
};


export type MutationCreateReportShareArgs = {
  input: CreateReportShareInput;
};


export type MutationCreateReportTemplateArgs = {
  input: CreateReportTemplateInput;
};


export type MutationCreateScaledCampaignArgs = {
  audienceFilters: Scalars['JSON']['input'];
  experimentId: Scalars['String']['input'];
  phoneLineId: Scalars['String']['input'];
};


export type MutationCreateStudentPaymentCheckoutArgs = {
  input: CreateStudentPaymentInput;
};


export type MutationCreateStudentWithdrawalArgs = {
  amount?: InputMaybe<Scalars['Float']['input']>;
};


export type MutationCreateThreadArgs = {
  assistantId: Scalars['String']['input'];
  metadata?: InputMaybe<Scalars['JSONObject']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCreateUnifiedWithdrawalArgs = {
  amount?: InputMaybe<Scalars['Float']['input']>;
};


export type MutationCreateWalletPaymentCheckoutArgs = {
  input: CreateWalletPaymentInput;
};


export type MutationCreateWalletPaymentIntentArgs = {
  input: CreateWalletPaymentIntentInput;
};


export type MutationCreateWithdrawalArgs = {
  input: WithdrawFundsInput;
};


export type MutationDeleteActivitySchemaArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteAssistantArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteCommsAudienceArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteCommsExperimentArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteCommsOpportunityArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteCommsRuleArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteCommsSequenceArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteCommsTagArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteEcosystemArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteJournalArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteReportTemplateArgs = {
  templateId: Scalars['String']['input'];
};


export type MutationDeleteRoadmapArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteShiftSpendGoalArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteVideoAskResponseArgs = {
  input: DeleteVideoAskInput;
};


export type MutationDismissAipmOnboardingArgs = {
  input: DismissOnboardingInput;
};


export type MutationDuplicateEcosystemArgs = {
  id: Scalars['String']['input'];
};


export type MutationFamilyAddMemberArgs = {
  input: AddFamilyMemberInput;
};


export type MutationFamilyAssociateFaceToMemberArgs = {
  faceCropId: Scalars['ID']['input'];
  memberId: Scalars['ID']['input'];
};


export type MutationFamilyClaimMemberArgs = {
  memberId: Scalars['ID']['input'];
};


export type MutationFamilyClearMemberAvatarArgs = {
  memberId: Scalars['ID']['input'];
};


export type MutationFamilyCreateArgs = {
  input: CreateFamilyInput;
};


export type MutationFamilyCreateFaceCropArgs = {
  input: CreateFamilyFaceCropInput;
};


export type MutationFamilyCreateRelationshipArgs = {
  input: CreateFamilyRelationshipInput;
};


export type MutationFamilyCreateViewArgs = {
  input: CreateFamilyViewInput;
};


export type MutationFamilyDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationFamilyDeleteMemberArgs = {
  id: Scalars['ID']['input'];
};


export type MutationFamilyDeletePhotoArgs = {
  id: Scalars['ID']['input'];
};


export type MutationFamilyDeleteRelationshipArgs = {
  id: Scalars['ID']['input'];
};


export type MutationFamilyDuplicateArgs = {
  familyId: Scalars['ID']['input'];
};


export type MutationFamilySetMemberAvatarArgs = {
  faceCropId: Scalars['ID']['input'];
  memberId: Scalars['ID']['input'];
};


export type MutationFamilyUnclaimMemberArgs = {
  memberId: Scalars['ID']['input'];
};


export type MutationFamilyUpdateArgs = {
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
};


export type MutationFamilyUpdateMemberArgs = {
  id: Scalars['ID']['input'];
  input: UpdateFamilyMemberInput;
};


export type MutationFamilyUpdateViewArgs = {
  id: Scalars['ID']['input'];
  input: UpdateFamilyViewInput;
};


export type MutationForkProgramDesignArgs = {
  id: Scalars['String']['input'];
};


export type MutationGenerateRoadmapAiArgs = {
  email?: InputMaybe<Scalars['String']['input']>;
  input: GenerateRoadmapAiInput;
};


export type MutationGenerateShareTokenArgs = {
  id: Scalars['String']['input'];
};


export type MutationGetConnectAccountLinkArgs = {
  refreshUrl: Scalars['String']['input'];
  returnUrl: Scalars['String']['input'];
};


export type MutationInitializeAipmOnboardingArgs = {
  input: InitializeOnboardingInput;
};


export type MutationLogContactSalesClickedArgs = {
  trigger: Scalars['String']['input'];
};


export type MutationLogCreatorEventArgs = {
  action: Scalars['String']['input'];
  data?: InputMaybe<Scalars['JSON']['input']>;
  scope: Scalars['String']['input'];
  threadId: Scalars['String']['input'];
};


export type MutationLogEcosystemViewArgs = {
  ecosystemId: Scalars['String']['input'];
  email: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
};


export type MutationLogMeetingScheduledArgs = {
  eventUri?: InputMaybe<Scalars['String']['input']>;
  inviteeUri?: InputMaybe<Scalars['String']['input']>;
  trigger: Scalars['String']['input'];
};


export type MutationLogReportDownloadArgs = {
  email: Scalars['String']['input'];
  exportType?: InputMaybe<Scalars['String']['input']>;
  rowCount?: InputMaybe<Scalars['Int']['input']>;
  token: Scalars['String']['input'];
};


export type MutationLogReportExportArgs = {
  exportType: Scalars['String']['input'];
  organizationId: Scalars['String']['input'];
  rowCount: Scalars['Int']['input'];
  templateId: Scalars['String']['input'];
};


export type MutationMarkCommsConversationReadArgs = {
  id: Scalars['String']['input'];
};


export type MutationMarkThreadAsReadArgs = {
  threadId: Scalars['String']['input'];
};


export type MutationMigrateAnonymousRoadmapsArgs = {
  email: Scalars['String']['input'];
};


export type MutationMigrateDeviceSavesArgs = {
  deviceId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};


export type MutationNurseRequestOtpArgs = {
  input: NurseRequestOtpInput;
};


export type MutationNurseVerifyOtpArgs = {
  input: NurseVerifyOtpInput;
};


export type MutationPauseCommsExperimentArgs = {
  id: Scalars['String']['input'];
};


export type MutationPauseCommsSequenceArgs = {
  id: Scalars['String']['input'];
};


export type MutationReAttachVideoaskResponseArgs = {
  input: ReattachVideoAskInput;
};


export type MutationRefreshCommsSequenceAudienceArgs = {
  id: Scalars['String']['input'];
};


export type MutationRefreshVideoAskTranscriptionArgs = {
  adkName: Scalars['String']['input'];
  programId: Scalars['String']['input'];
  studentId: Scalars['String']['input'];
};


export type MutationRefundPaymentArgs = {
  input: RefundPaymentInput;
};


export type MutationRemoveBankAccountArgs = {
  input: DeleteBankAccountInput;
};


export type MutationRemoveOrganizationDomainArgs = {
  input: ManageOrganizationDomainInput;
};


export type MutationRemoveOrganizationMemberArgs = {
  input: RemoveOrganizationMemberInput;
};


export type MutationRemovePresenceArgs = {
  programId: Scalars['ID']['input'];
};


export type MutationResendAipmVerificationArgs = {
  input: ResendVerificationInput;
};


export type MutationResendEndorsementEmailArgs = {
  input: ResendEndorsementEmailInput;
};


export type MutationResumeCommsExperimentArgs = {
  id: Scalars['String']['input'];
};


export type MutationResumeCommsSequenceArgs = {
  id: Scalars['String']['input'];
};


export type MutationRevokeReportShareArgs = {
  tokenId: Scalars['String']['input'];
};


export type MutationSaveBulkSetupScopesArgs = {
  bulkId: Scalars['String']['input'];
  scopes: Array<Scalars['String']['input']>;
  website: Scalars['String']['input'];
};


export type MutationSaveInvitationArgs = {
  input: InvitationInput;
};


export type MutationSaveRoadmapArgs = {
  input: SaveRoadmapInput;
};


export type MutationSaveScopeArgs = {
  input: AirtableSavedScopeInput;
};


export type MutationScaleCommsExperimentWinnerArgs = {
  id: Scalars['String']['input'];
};


export type MutationSelectAipmPersonaArgs = {
  input: SelectPersonaInput;
};


export type MutationSendAipmEmailVerificationArgs = {
  input: SendEmailVerificationInput;
};


export type MutationSendAipmPhoneVerificationArgs = {
  input: SendPhoneVerificationInput;
};


export type MutationSendActivityEmailOtpArgs = {
  input: SendActivityEmailOtpInput;
};


export type MutationSendActivityPhoneOtpArgs = {
  input: SendActivityPhoneOtpInput;
};


export type MutationSendCommsCampaignArgs = {
  campaignId: Scalars['String']['input'];
};


export type MutationSendOrganizationVerificationCodeArgs = {
  input: SendVerificationCodeInput;
};


export type MutationSendReportAccessCodeArgs = {
  email: Scalars['String']['input'];
  token: Scalars['String']['input'];
};


export type MutationSetCredentialValidatorArgs = {
  input: SetCredentialValidatorInput;
};


export type MutationSetDefaultBankAccountArgs = {
  bankAccountId: Scalars['String']['input'];
};


export type MutationSetDefaultInstanceArgs = {
  input: SetDefaultInstanceInput;
};


export type MutationSetMyProfileSlugArgs = {
  slug: Scalars['String']['input'];
};


export type MutationSetOrgPortfolioPublicArgs = {
  isPublic: Scalars['Boolean']['input'];
  orgId: Scalars['String']['input'];
};


export type MutationSetOrgProfileSlugArgs = {
  orgId: Scalars['String']['input'];
  slug: Scalars['String']['input'];
};


export type MutationSetOrganizationPrimaryDomainArgs = {
  input: ManageOrganizationDomainInput;
};


export type MutationSetPortfolioPublicArgs = {
  isPublic: Scalars['Boolean']['input'];
};


export type MutationSkipAipmOnboardingArgs = {
  input: SkipOnboardingInput;
};


export type MutationSubmitEndorsementArgs = {
  input: SubmitEndorsementInput;
};


export type MutationSubmitRsvpArgs = {
  input: RsvpInput;
};


export type MutationTagCommsConversationArgs = {
  conversationId: Scalars['String']['input'];
  tagId: Scalars['String']['input'];
};


export type MutationTestBatchProfilesArgs = {
  input: BatchProfileTestInput;
};


export type MutationToggleAipmArgs = {
  input: ToggleAipmInput;
};


export type MutationToggleCommsRuleArgs = {
  id: Scalars['String']['input'];
};


export type MutationTriggerCompletionCelebrationArgs = {
  input: TriggerCompletionCelebrationInput;
};


export type MutationUntagCommsConversationArgs = {
  conversationId: Scalars['String']['input'];
  tagId: Scalars['String']['input'];
};


export type MutationUpdateActivitySchemaArgs = {
  data: ActivitySchemaUpdateInput;
  id: Scalars['String']['input'];
};


export type MutationUpdateActivitySchemaSimplifiedArgs = {
  data: UpdateActivitySchemaInput;
  id: Scalars['String']['input'];
};


export type MutationUpdateAssistantArgs = {
  data: LangGraphAssistantUpdateInput;
  id: Scalars['String']['input'];
};


export type MutationUpdateAutomationAdkArgs = {
  adkId: Scalars['String']['input'];
  content: Scalars['JSONObject']['input'];
  programId: Scalars['String']['input'];
};


export type MutationUpdateBankAccountArgs = {
  input: UpdateBankAccountInput;
};


export type MutationUpdateCommsAudienceArgs = {
  contactCount?: InputMaybe<Scalars['Int']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<Scalars['JSON']['input']>;
  id: Scalars['String']['input'];
  memberCount?: InputMaybe<Scalars['Int']['input']>;
  memberIds?: InputMaybe<Array<Scalars['String']['input']>>;
  name?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateCommsOpportunityArgs = {
  cta?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  goal?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  linkedProgramId?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  successMetrics?: InputMaybe<Scalars['JSON']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateCommsPhoneLineArgs = {
  id: Scalars['String']['input'];
  label: Scalars['String']['input'];
};


export type MutationUpdateCommsRuleArgs = {
  actions?: InputMaybe<Scalars['JSON']['input']>;
  conditions?: InputMaybe<Scalars['JSON']['input']>;
  id: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<Scalars['Int']['input']>;
  stopProcessing?: InputMaybe<Scalars['Boolean']['input']>;
  triggers?: InputMaybe<Scalars['JSON']['input']>;
};


export type MutationUpdateCommsSequenceArgs = {
  data: Scalars['JSON']['input'];
  id: Scalars['String']['input'];
};


export type MutationUpdateCommsSequenceStepArgs = {
  data: Scalars['JSON']['input'];
  stepId: Scalars['String']['input'];
};


export type MutationUpdateCommsTagArgs = {
  color?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  pinned?: InputMaybe<Scalars['Boolean']['input']>;
  sortOrder?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationUpdateConnectAccountArgs = {
  input: UpdateStripeAccountInput;
};


export type MutationUpdateEcosystemArgs = {
  data: Scalars['JSON']['input'];
  id: Scalars['String']['input'];
  shareToken?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateEcosystemPlaceArgs = {
  data: Scalars['JSON']['input'];
  id: Scalars['String']['input'];
};


export type MutationUpdateJournalArgs = {
  data: UpdateJournalInput;
  id: Scalars['String']['input'];
};


export type MutationUpdateOrganizationLogoArgs = {
  input: UpdateOrganizationLogoInput;
};


export type MutationUpdateOrganizationNameArgs = {
  input: UpdateOrganizationNameInput;
};


export type MutationUpdatePortfolioArgs = {
  input: UpdatePortfolioInput;
};


export type MutationUpdatePortfolioByIdArgs = {
  input: UpdatePortfolioInput;
  userId: Scalars['String']['input'];
};


export type MutationUpdatePresenceArgs = {
  input: PresenceInput;
};


export type MutationUpdateProgramDesignArgs = {
  data: Scalars['JSON']['input'];
  id: Scalars['String']['input'];
};


export type MutationUpdateProgramLocationsArgs = {
  deliveryModality?: InputMaybe<Scalars['String']['input']>;
  locations: Array<ProgramLocationCreateInput>;
  programId: Scalars['String']['input'];
};


export type MutationUpdateProgramTimeSettingsArgs = {
  input: Scalars['JSONObject']['input'];
  programId: Scalars['String']['input'];
};


export type MutationUpdateReportTemplateArgs = {
  input: UpdateReportTemplateInput;
  templateId: Scalars['String']['input'];
};


export type MutationUpdateShareCodeArgs = {
  input: UpdateShareCodeInput;
};


export type MutationUpdateStudentPreferenceArgs = {
  data: UpdateStudentPreferenceInput;
  studentId: Scalars['String']['input'];
};


export type MutationUpdateThreadArgs = {
  id: Scalars['String']['input'];
  metadata?: InputMaybe<Scalars['JSONObject']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUploadAdkSchemaArgs = {
  name: Scalars['String']['input'];
  schema: Scalars['JSONObject']['input'];
};


export type MutationUploadDocumentArgs = {
  input: UploadDocumentInput;
};


export type MutationUploadOrganizationLogoImageArgs = {
  input: UploadOrganizationLogoImageInput;
};


export type MutationUploadProfileImageArgs = {
  input: UploadProfileImageInput;
};


export type MutationUpsertNursePortfolioArgs = {
  input: UpsertNursePortfolioInput;
};


export type MutationValidateDocumentArgs = {
  input: ValidateDocumentInput;
};


export type MutationVerifyAipmEmailArgs = {
  input: VerifyEmailInput;
};


export type MutationVerifyAipmPhoneArgs = {
  input: VerifyPhoneInput;
};


export type MutationVerifyActivityEmailOtpArgs = {
  input: VerifyActivityEmailOtpInput;
};


export type MutationVerifyActivityPhoneOtpArgs = {
  input: VerifyActivityPhoneOtpInput;
};


export type MutationVerifyBankAccountArgs = {
  input: VerifyBankAccountInput;
};


export type MutationVerifyOrganizationCodeArgs = {
  input: VerifyCodeInput;
};


export type MutationVerifyOrganizationCodeAuthenticatedArgs = {
  input: VerifyCodeInput;
};


export type MutationVerifyReportAccessArgs = {
  code: Scalars['String']['input'];
  email: Scalars['String']['input'];
  token: Scalars['String']['input'];
};

/** Paginated result for myThreads query */
export type MyInboxResult = {
  __typename?: 'MyInboxResult';
  threads: Array<MyInboxThread>;
  total: Scalars['Int']['output'];
};

/** Thread summary for inbox display */
export type MyInboxThread = {
  __typename?: 'MyInboxThread';
  /** Whether the thread has unread inbound messages */
  hasUnread: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  lastChannel?: Maybe<Scalars['String']['output']>;
  lastMessageAt: Scalars['DateTime']['output'];
  /** Preview of the last message (truncated to 100 chars) */
  lastMessagePreview?: Maybe<Scalars['String']['output']>;
  messageCount: Scalars['Int']['output'];
  programId: Scalars['String']['output'];
  programName: Scalars['String']['output'];
};

export type MyPeopleResponse = {
  __typename?: 'MyPeopleResponse';
  /** Program creators/organizers whose programs the user completed */
  creators: Array<Person>;
  /** Count of creators in current page */
  creatorsCount: Scalars['Int']['output'];
  /** Total creators before pagination */
  creatorsTotalCount: Scalars['Int']['output'];
  /** True when more creators exist beyond current page */
  hasMoreCreators: Scalars['Boolean']['output'];
  /** True when more participants exist beyond current page */
  hasMoreParticipants: Scalars['Boolean']['output'];
  /** True when more sponsors exist beyond current page */
  hasMoreSponsors: Scalars['Boolean']['output'];
  /** Fellow participants from shared programs (cohort and teammates) */
  participants: Array<Person>;
  /** Count of participants in current page */
  participantsCount: Scalars['Int']['output'];
  /** Total participants before pagination */
  participantsTotalCount: Scalars['Int']['output'];
  /** Sponsors who have supported the user through programs */
  sponsors: Array<Person>;
  /** Count of sponsors in current page */
  sponsorsCount: Scalars['Int']['output'];
  /** Total sponsors before pagination */
  sponsorsTotalCount: Scalars['Int']['output'];
  /** Grand total count across all categories (legacy compatibility) */
  totalCount: Scalars['Int']['output'];
};

export type MyPlacesResponse = {
  __typename?: 'MyPlacesResponse';
  /** Whether the viewer is the owner of these places */
  isOwner: Scalars['Boolean']['output'];
  /** Array of places from user portfolios */
  places: Array<Place>;
};

export type MyProgram = {
  __typename?: 'MyProgram';
  /** User role in relation to this program */
  _role: ProgramRole;
  /** Computed status based on user role and program state */
  _status: ProgramStatus;
  /** ADKs completion progress percentage (0-100) */
  adksCompletionProgress?: Maybe<Scalars['Float']['output']>;
  /** Whether the program is awaiting sponsorship */
  awaitingSponsorship?: Maybe<Scalars['Boolean']['output']>;
  /** Date when the program was created */
  dateCreated: Scalars['DateTime']['output'];
  /** Domain associated with the program */
  domain?: Maybe<Scalars['String']['output']>;
  /** Unique identifier of the program */
  id: Scalars['String']['output'];
  /** Industries covered by this program */
  industries?: Maybe<Array<Scalars['String']['output']>>;
  /** Date when the program was last saved */
  lastSaved?: Maybe<Scalars['DateTime']['output']>;
  /** ID of the sponsoring organization */
  organizationId?: Maybe<Scalars['String']['output']>;
  /** Name of the sponsoring organization */
  organizationName?: Maybe<Scalars['String']['output']>;
  /** Organizers of this program */
  organizers?: Maybe<Array<MyProgramOrganizer>>;
  /** Career pathways covered by this program */
  pathways?: Maybe<Array<Scalars['String']['output']>>;
  /** Description of the program */
  programDesc?: Maybe<Scalars['String']['output']>;
  /** Program image URL */
  programImage?: Maybe<Scalars['String']['output']>;
  /** Name of the program */
  programName?: Maybe<Scalars['String']['output']>;
  /** Whether the program is published */
  published?: Maybe<Scalars['Boolean']['output']>;
  /** Sharable URL for the program */
  sharable_url?: Maybe<Scalars['String']['output']>;
  /** ID of the template used */
  templateId?: Maybe<Scalars['String']['output']>;
  /** Name of the template used */
  templateName?: Maybe<Scalars['String']['output']>;
};

export type MyProgramOrganizer = {
  __typename?: 'MyProgramOrganizer';
  /** First name of the organizer */
  firstName?: Maybe<Scalars['String']['output']>;
  /** Last name of the organizer */
  lastName?: Maybe<Scalars['String']['output']>;
  /** Profile image URL */
  profileImg?: Maybe<Scalars['String']['output']>;
  /** Role of the organizer (e.g., owner, editor) */
  role?: Maybe<Scalars['String']['output']>;
  /** User ID of the organizer */
  userId: Scalars['String']['output'];
};

export type MyProgramsResponse = {
  __typename?: 'MyProgramsResponse';
  /** True when there are more programs beyond the current page */
  hasMore: Scalars['Boolean']['output'];
  /** Programs for the current page (organizer + participant) */
  programs: Array<MyProgram>;
  /** Total count of unique programs (organizer ∪ participant) before pagination */
  totalCount: Scalars['Int']['output'];
};

export type MySubscriptionStatus = {
  __typename?: 'MySubscriptionStatus';
  cancelAtPeriodEnd: Scalars['Boolean']['output'];
  createToday: UsageMeter;
  currentPeriodEnd?: Maybe<Scalars['String']['output']>;
  designThisHour: UsageMeter;
  enroll: UsageMeter;
  overageEnabled: Scalars['Boolean']['output'];
  overagePerParticipant: Scalars['Float']['output'];
  publish: UsageMeter;
  stripeSubscriptionId?: Maybe<Scalars['String']['output']>;
  tier: Scalars['String']['output'];
};

/** Thread metadata for message list */
export type MyThreadInfo = {
  __typename?: 'MyThreadInfo';
  id: Scalars['ID']['output'];
  lastMessageAt: Scalars['DateTime']['output'];
  messageCount: Scalars['Int']['output'];
  programId: Scalars['String']['output'];
  programName: Scalars['String']['output'];
  status: Scalars['String']['output'];
};

export type NestedBoolFilter = {
  equals?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<NestedBoolFilter>;
};

export type NestedBoolNullableFilter = {
  equals?: InputMaybe<Scalars['Boolean']['input']>;
  isSet?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<NestedBoolNullableFilter>;
};

export type NestedDateTimeFilter = {
  equals?: InputMaybe<Scalars['DateTime']['input']>;
  gt?: InputMaybe<Scalars['DateTime']['input']>;
  gte?: InputMaybe<Scalars['DateTime']['input']>;
  in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  lt?: InputMaybe<Scalars['DateTime']['input']>;
  lte?: InputMaybe<Scalars['DateTime']['input']>;
  not?: InputMaybe<NestedDateTimeFilter>;
  notIn?: InputMaybe<Array<Scalars['DateTime']['input']>>;
};

export type NestedDateTimeNullableFilter = {
  equals?: InputMaybe<Scalars['DateTime']['input']>;
  gt?: InputMaybe<Scalars['DateTime']['input']>;
  gte?: InputMaybe<Scalars['DateTime']['input']>;
  in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  isSet?: InputMaybe<Scalars['Boolean']['input']>;
  lt?: InputMaybe<Scalars['DateTime']['input']>;
  lte?: InputMaybe<Scalars['DateTime']['input']>;
  not?: InputMaybe<NestedDateTimeNullableFilter>;
  notIn?: InputMaybe<Array<Scalars['DateTime']['input']>>;
};

export type NestedEnumStudentWalletStatusFilter = {
  equals?: InputMaybe<StudentWalletStatus>;
  in?: InputMaybe<Array<StudentWalletStatus>>;
  not?: InputMaybe<NestedEnumStudentWalletStatusFilter>;
  notIn?: InputMaybe<Array<StudentWalletStatus>>;
};

export type NestedEnumTransactionStatusFilter = {
  equals?: InputMaybe<TransactionStatus>;
  in?: InputMaybe<Array<TransactionStatus>>;
  not?: InputMaybe<NestedEnumTransactionStatusFilter>;
  notIn?: InputMaybe<Array<TransactionStatus>>;
};

export type NestedEnumTransferStatusFilter = {
  equals?: InputMaybe<TransferStatus>;
  in?: InputMaybe<Array<TransferStatus>>;
  not?: InputMaybe<NestedEnumTransferStatusFilter>;
  notIn?: InputMaybe<Array<TransferStatus>>;
};

export type NestedEnumWalletPaymentTypeFilter = {
  equals?: InputMaybe<WalletPaymentType>;
  in?: InputMaybe<Array<WalletPaymentType>>;
  not?: InputMaybe<NestedEnumWalletPaymentTypeFilter>;
  notIn?: InputMaybe<Array<WalletPaymentType>>;
};

export type NestedFloatFilter = {
  equals?: InputMaybe<Scalars['Float']['input']>;
  gt?: InputMaybe<Scalars['Float']['input']>;
  gte?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<Scalars['Float']['input']>>;
  lt?: InputMaybe<Scalars['Float']['input']>;
  lte?: InputMaybe<Scalars['Float']['input']>;
  not?: InputMaybe<NestedFloatFilter>;
  notIn?: InputMaybe<Array<Scalars['Float']['input']>>;
};

export type NestedFloatNullableFilter = {
  equals?: InputMaybe<Scalars['Float']['input']>;
  gt?: InputMaybe<Scalars['Float']['input']>;
  gte?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<Scalars['Float']['input']>>;
  isSet?: InputMaybe<Scalars['Boolean']['input']>;
  lt?: InputMaybe<Scalars['Float']['input']>;
  lte?: InputMaybe<Scalars['Float']['input']>;
  not?: InputMaybe<NestedFloatNullableFilter>;
  notIn?: InputMaybe<Array<Scalars['Float']['input']>>;
};

export type NestedIntFilter = {
  equals?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  in?: InputMaybe<Array<Scalars['Int']['input']>>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  not?: InputMaybe<NestedIntFilter>;
  notIn?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type NestedIntNullableFilter = {
  equals?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  in?: InputMaybe<Array<Scalars['Int']['input']>>;
  isSet?: InputMaybe<Scalars['Boolean']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  not?: InputMaybe<NestedIntNullableFilter>;
  notIn?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type NestedStringFilter = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equals?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  not?: InputMaybe<NestedStringFilter>;
  notIn?: InputMaybe<Array<Scalars['String']['input']>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};

export type NestedStringNullableFilter = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equals?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  isSet?: InputMaybe<Scalars['Boolean']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  not?: InputMaybe<NestedStringNullableFilter>;
  notIn?: InputMaybe<Array<Scalars['String']['input']>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};

export type NullableBoolFieldUpdateOperationsInput = {
  set?: InputMaybe<Scalars['Boolean']['input']>;
  unset?: InputMaybe<Scalars['Boolean']['input']>;
};

export type NullableDateTimeFieldUpdateOperationsInput = {
  set?: InputMaybe<Scalars['DateTime']['input']>;
  unset?: InputMaybe<Scalars['Boolean']['input']>;
};

export type NullableFloatFieldUpdateOperationsInput = {
  decrement?: InputMaybe<Scalars['Float']['input']>;
  divide?: InputMaybe<Scalars['Float']['input']>;
  increment?: InputMaybe<Scalars['Float']['input']>;
  multiply?: InputMaybe<Scalars['Float']['input']>;
  set?: InputMaybe<Scalars['Float']['input']>;
  unset?: InputMaybe<Scalars['Boolean']['input']>;
};

export type NullableIntFieldUpdateOperationsInput = {
  decrement?: InputMaybe<Scalars['Int']['input']>;
  divide?: InputMaybe<Scalars['Int']['input']>;
  increment?: InputMaybe<Scalars['Int']['input']>;
  multiply?: InputMaybe<Scalars['Int']['input']>;
  set?: InputMaybe<Scalars['Int']['input']>;
  unset?: InputMaybe<Scalars['Boolean']['input']>;
};

export type NullableStringFieldUpdateOperationsInput = {
  set?: InputMaybe<Scalars['String']['input']>;
  unset?: InputMaybe<Scalars['Boolean']['input']>;
};

export type NurseAuthResponse = {
  __typename?: 'NurseAuthResponse';
  auth: AuthResponse;
  isNewNurse: Scalars['Boolean']['output'];
  nursePortfolioId: Scalars['ID']['output'];
};

export type NurseOtpResponse = {
  __typename?: 'NurseOtpResponse';
  message?: Maybe<Scalars['String']['output']>;
  otpSent: Scalars['Boolean']['output'];
};

export type NursePortfolio = {
  __typename?: 'NursePortfolio';
  createdAt: Scalars['DateTime']['output'];
  defaultRateProfileSlug?: Maybe<Scalars['String']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  effectiveTaxRate: Scalars['Float']['output'];
  employers?: Maybe<Array<NursePortfolioEmployer>>;
  id: Scalars['ID']['output'];
  licenseNumber?: Maybe<Scalars['String']['output']>;
  licenseState?: Maybe<Scalars['String']['output']>;
  rateProfiles?: Maybe<Array<NursePortfolioRateProfile>>;
  specialty?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  user: User;
  userId: Scalars['String']['output'];
};

export type NursePortfolioAvgAggregate = {
  __typename?: 'NursePortfolioAvgAggregate';
  effectiveTaxRate?: Maybe<Scalars['Float']['output']>;
};

export type NursePortfolioCountAggregate = {
  __typename?: 'NursePortfolioCountAggregate';
  _all: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  defaultRateProfileSlug: Scalars['Int']['output'];
  deletedAt: Scalars['Int']['output'];
  effectiveTaxRate: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  licenseNumber: Scalars['Int']['output'];
  licenseState: Scalars['Int']['output'];
  specialty: Scalars['Int']['output'];
  updatedAt: Scalars['Int']['output'];
  userId: Scalars['Int']['output'];
};

export type NursePortfolioCreateNestedOneWithoutUserInput = {
  connect?: InputMaybe<NursePortfolioWhereUniqueInput>;
  connectOrCreate?: InputMaybe<NursePortfolioCreateOrConnectWithoutUserInput>;
  create?: InputMaybe<NursePortfolioCreateWithoutUserInput>;
};

export type NursePortfolioCreateOrConnectWithoutUserInput = {
  create: NursePortfolioCreateWithoutUserInput;
  where: NursePortfolioWhereUniqueInput;
};

export type NursePortfolioCreateWithoutUserInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  defaultRateProfileSlug?: InputMaybe<Scalars['String']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  effectiveTaxRate?: InputMaybe<Scalars['Float']['input']>;
  employers?: InputMaybe<Array<NursePortfolioEmployerCreateInput>>;
  id?: InputMaybe<Scalars['String']['input']>;
  licenseNumber?: InputMaybe<Scalars['String']['input']>;
  licenseState?: InputMaybe<Scalars['String']['input']>;
  rateProfiles?: InputMaybe<Array<NursePortfolioRateProfileCreateInput>>;
  specialty?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type NursePortfolioEmployer = {
  __typename?: 'NursePortfolioEmployer';
  city?: Maybe<Scalars['String']['output']>;
  employmentType?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  state?: Maybe<Scalars['String']['output']>;
};

export type NursePortfolioEmployerCreateInput = {
  city?: InputMaybe<Scalars['String']['input']>;
  employmentType?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  state?: InputMaybe<Scalars['String']['input']>;
};

export type NursePortfolioEmployerInput = {
  city?: InputMaybe<Scalars['String']['input']>;
  employmentType?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  state?: InputMaybe<Scalars['String']['input']>;
};

export type NursePortfolioEmployerObjectEqualityInput = {
  city?: InputMaybe<Scalars['String']['input']>;
  employmentType?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  state?: InputMaybe<Scalars['String']['input']>;
};

export type NursePortfolioEmployerOutput = {
  __typename?: 'NursePortfolioEmployerOutput';
  city?: Maybe<Scalars['String']['output']>;
  employmentType?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  state?: Maybe<Scalars['String']['output']>;
};

export type NursePortfolioMaxAggregate = {
  __typename?: 'NursePortfolioMaxAggregate';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  defaultRateProfileSlug?: Maybe<Scalars['String']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  effectiveTaxRate?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  licenseNumber?: Maybe<Scalars['String']['output']>;
  licenseState?: Maybe<Scalars['String']['output']>;
  specialty?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
};

export type NursePortfolioMinAggregate = {
  __typename?: 'NursePortfolioMinAggregate';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  defaultRateProfileSlug?: Maybe<Scalars['String']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  effectiveTaxRate?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  licenseNumber?: Maybe<Scalars['String']['output']>;
  licenseState?: Maybe<Scalars['String']['output']>;
  specialty?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
};

export type NursePortfolioNullableRelationFilter = {
  is?: InputMaybe<NursePortfolioWhereInput>;
  isNot?: InputMaybe<NursePortfolioWhereInput>;
};

export type NursePortfolioOutput = {
  __typename?: 'NursePortfolioOutput';
  createdAt: Scalars['DateTime']['output'];
  defaultRateProfileSlug?: Maybe<Scalars['String']['output']>;
  effectiveTaxRate: Scalars['Float']['output'];
  employers: Array<NursePortfolioEmployerOutput>;
  id: Scalars['ID']['output'];
  licenseNumber?: Maybe<Scalars['String']['output']>;
  licenseState?: Maybe<Scalars['String']['output']>;
  rateProfiles: Array<NursePortfolioRateProfileOutput>;
  specialty?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  userId: Scalars['ID']['output'];
};

export type NursePortfolioRateProfile = {
  __typename?: 'NursePortfolioRateProfile';
  basePerHour: Scalars['Float']['output'];
  employerName?: Maybe<Scalars['String']['output']>;
  employmentType: Scalars['String']['output'];
  extraShiftBonusFormula: Scalars['String']['output'];
  extraShiftFlatBonus?: Maybe<Scalars['Float']['output']>;
  holidayMultiplier: Scalars['Float']['output'];
  isDefault: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  nightDifferentialPct: Scalars['Float']['output'];
  onCallMultiplier: Scalars['Float']['output'];
  shiftHours: Scalars['Float']['output'];
  slug: Scalars['String']['output'];
  weekendDifferentialPct: Scalars['Float']['output'];
};

export type NursePortfolioRateProfileCreateInput = {
  basePerHour: Scalars['Float']['input'];
  employerName?: InputMaybe<Scalars['String']['input']>;
  employmentType: Scalars['String']['input'];
  extraShiftBonusFormula?: InputMaybe<Scalars['String']['input']>;
  extraShiftFlatBonus?: InputMaybe<Scalars['Float']['input']>;
  holidayMultiplier?: InputMaybe<Scalars['Float']['input']>;
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  nightDifferentialPct?: InputMaybe<Scalars['Float']['input']>;
  onCallMultiplier?: InputMaybe<Scalars['Float']['input']>;
  shiftHours?: InputMaybe<Scalars['Float']['input']>;
  slug: Scalars['String']['input'];
  weekendDifferentialPct?: InputMaybe<Scalars['Float']['input']>;
};

export type NursePortfolioRateProfileInput = {
  basePerHour: Scalars['Float']['input'];
  employerName?: InputMaybe<Scalars['String']['input']>;
  employmentType?: InputMaybe<Scalars['String']['input']>;
  extraShiftBonusFormula?: InputMaybe<Scalars['String']['input']>;
  extraShiftFlatBonus?: InputMaybe<Scalars['Float']['input']>;
  holidayMultiplier?: InputMaybe<Scalars['Float']['input']>;
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  nightDifferentialPct?: InputMaybe<Scalars['Float']['input']>;
  onCallMultiplier?: InputMaybe<Scalars['Float']['input']>;
  shiftHours?: InputMaybe<Scalars['Float']['input']>;
  slug: Scalars['String']['input'];
  weekendDifferentialPct?: InputMaybe<Scalars['Float']['input']>;
};

export type NursePortfolioRateProfileObjectEqualityInput = {
  basePerHour: Scalars['Float']['input'];
  employerName?: InputMaybe<Scalars['String']['input']>;
  employmentType: Scalars['String']['input'];
  extraShiftBonusFormula: Scalars['String']['input'];
  extraShiftFlatBonus?: InputMaybe<Scalars['Float']['input']>;
  holidayMultiplier: Scalars['Float']['input'];
  isDefault: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  nightDifferentialPct: Scalars['Float']['input'];
  onCallMultiplier: Scalars['Float']['input'];
  shiftHours: Scalars['Float']['input'];
  slug: Scalars['String']['input'];
  weekendDifferentialPct: Scalars['Float']['input'];
};

export type NursePortfolioRateProfileOutput = {
  __typename?: 'NursePortfolioRateProfileOutput';
  basePerHour: Scalars['Float']['output'];
  employerName?: Maybe<Scalars['String']['output']>;
  employmentType: Scalars['String']['output'];
  extraShiftBonusFormula: Scalars['String']['output'];
  extraShiftFlatBonus?: Maybe<Scalars['Float']['output']>;
  holidayMultiplier: Scalars['Float']['output'];
  isDefault: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  nightDifferentialPct: Scalars['Float']['output'];
  onCallMultiplier: Scalars['Float']['output'];
  shiftHours: Scalars['Float']['output'];
  slug: Scalars['String']['output'];
  weekendDifferentialPct: Scalars['Float']['output'];
};

export type NursePortfolioSumAggregate = {
  __typename?: 'NursePortfolioSumAggregate';
  effectiveTaxRate?: Maybe<Scalars['Float']['output']>;
};

export type NursePortfolioUpdateOneWithoutUserNestedInput = {
  connect?: InputMaybe<NursePortfolioWhereUniqueInput>;
  connectOrCreate?: InputMaybe<NursePortfolioCreateOrConnectWithoutUserInput>;
  create?: InputMaybe<NursePortfolioCreateWithoutUserInput>;
  delete?: InputMaybe<NursePortfolioWhereInput>;
  disconnect?: InputMaybe<NursePortfolioWhereInput>;
  update?: InputMaybe<NursePortfolioUpdateToOneWithWhereWithoutUserInput>;
  upsert?: InputMaybe<NursePortfolioUpsertWithoutUserInput>;
};

export type NursePortfolioUpdateToOneWithWhereWithoutUserInput = {
  data: NursePortfolioUpdateWithoutUserInput;
  where?: InputMaybe<NursePortfolioWhereInput>;
};

export type NursePortfolioUpdateWithoutUserInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  defaultRateProfileSlug?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  effectiveTaxRate?: InputMaybe<FloatFieldUpdateOperationsInput>;
  employers?: InputMaybe<Array<NursePortfolioEmployerCreateInput>>;
  licenseNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  licenseState?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  rateProfiles?: InputMaybe<Array<NursePortfolioRateProfileCreateInput>>;
  specialty?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type NursePortfolioUpsertWithoutUserInput = {
  create: NursePortfolioCreateWithoutUserInput;
  update: NursePortfolioUpdateWithoutUserInput;
  where?: InputMaybe<NursePortfolioWhereInput>;
};

export type NursePortfolioWhereInput = {
  AND?: InputMaybe<Array<NursePortfolioWhereInput>>;
  NOT?: InputMaybe<Array<NursePortfolioWhereInput>>;
  OR?: InputMaybe<Array<NursePortfolioWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  defaultRateProfileSlug?: InputMaybe<StringNullableFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  effectiveTaxRate?: InputMaybe<FloatFilter>;
  employers?: InputMaybe<Array<NursePortfolioEmployerObjectEqualityInput>>;
  id?: InputMaybe<StringFilter>;
  licenseNumber?: InputMaybe<StringNullableFilter>;
  licenseState?: InputMaybe<StringNullableFilter>;
  rateProfiles?: InputMaybe<Array<NursePortfolioRateProfileObjectEqualityInput>>;
  specialty?: InputMaybe<StringNullableFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  user?: InputMaybe<UserRelationFilter>;
  userId?: InputMaybe<StringFilter>;
};

export type NursePortfolioWhereUniqueInput = {
  AND?: InputMaybe<Array<NursePortfolioWhereInput>>;
  NOT?: InputMaybe<Array<NursePortfolioWhereInput>>;
  OR?: InputMaybe<Array<NursePortfolioWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  defaultRateProfileSlug?: InputMaybe<StringNullableFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  effectiveTaxRate?: InputMaybe<FloatFilter>;
  employers?: InputMaybe<Array<NursePortfolioEmployerObjectEqualityInput>>;
  id?: InputMaybe<Scalars['String']['input']>;
  licenseNumber?: InputMaybe<StringNullableFilter>;
  licenseState?: InputMaybe<StringNullableFilter>;
  rateProfiles?: InputMaybe<Array<NursePortfolioRateProfileObjectEqualityInput>>;
  specialty?: InputMaybe<StringNullableFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  user?: InputMaybe<UserRelationFilter>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type NurseRequestOtpInput = {
  /** Phone number in E.164 format (e.g., +15551234567) */
  phoneNumber: Scalars['String']['input'];
};

export type NurseVerifyOtpInput = {
  /** 6-digit verification code received via SMS */
  otpCode: Scalars['String']['input'];
  /** Phone number used to request the OTP */
  phoneNumber: Scalars['String']['input'];
};

export type OAuthAuthorizationCodeCountAggregate = {
  __typename?: 'OAuthAuthorizationCodeCountAggregate';
  _all: Scalars['Int']['output'];
  clientId: Scalars['Int']['output'];
  code: Scalars['Int']['output'];
  codeChallenge: Scalars['Int']['output'];
  codeChallengeMethod: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  expiresAt: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  redirectUri: Scalars['Int']['output'];
  scope: Scalars['Int']['output'];
  userId: Scalars['Int']['output'];
};

export type OAuthAuthorizationCodeMaxAggregate = {
  __typename?: 'OAuthAuthorizationCodeMaxAggregate';
  clientId?: Maybe<Scalars['String']['output']>;
  code?: Maybe<Scalars['String']['output']>;
  codeChallenge?: Maybe<Scalars['String']['output']>;
  codeChallengeMethod?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  expiresAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  redirectUri?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
};

export type OAuthAuthorizationCodeMinAggregate = {
  __typename?: 'OAuthAuthorizationCodeMinAggregate';
  clientId?: Maybe<Scalars['String']['output']>;
  code?: Maybe<Scalars['String']['output']>;
  codeChallenge?: Maybe<Scalars['String']['output']>;
  codeChallengeMethod?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  expiresAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  redirectUri?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
};

export type OAuthClientCountAggregate = {
  __typename?: 'OAuthClientCountAggregate';
  _all: Scalars['Int']['output'];
  clientId: Scalars['Int']['output'];
  clientName: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  grantTypes: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  lastUsedAt: Scalars['Int']['output'];
  redirectUris: Scalars['Int']['output'];
  tokenEndpointAuthMethod: Scalars['Int']['output'];
};

export type OAuthClientMaxAggregate = {
  __typename?: 'OAuthClientMaxAggregate';
  clientId?: Maybe<Scalars['String']['output']>;
  clientName?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  lastUsedAt?: Maybe<Scalars['DateTime']['output']>;
  tokenEndpointAuthMethod?: Maybe<Scalars['String']['output']>;
};

export type OAuthClientMinAggregate = {
  __typename?: 'OAuthClientMinAggregate';
  clientId?: Maybe<Scalars['String']['output']>;
  clientName?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  lastUsedAt?: Maybe<Scalars['DateTime']['output']>;
  tokenEndpointAuthMethod?: Maybe<Scalars['String']['output']>;
};

export type OAuthTokenCountAggregate = {
  __typename?: 'OAuthTokenCountAggregate';
  _all: Scalars['Int']['output'];
  accessTokenHash: Scalars['Int']['output'];
  accessTokenPrefix: Scalars['Int']['output'];
  clientId: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  expiresAt: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  lastUsedAt: Scalars['Int']['output'];
  refreshTokenHash: Scalars['Int']['output'];
  refreshTokenPrefix: Scalars['Int']['output'];
  revokedAt: Scalars['Int']['output'];
  scope: Scalars['Int']['output'];
  userId: Scalars['Int']['output'];
};

export type OAuthTokenMaxAggregate = {
  __typename?: 'OAuthTokenMaxAggregate';
  accessTokenHash?: Maybe<Scalars['String']['output']>;
  accessTokenPrefix?: Maybe<Scalars['String']['output']>;
  clientId?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  expiresAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  lastUsedAt?: Maybe<Scalars['DateTime']['output']>;
  refreshTokenHash?: Maybe<Scalars['String']['output']>;
  refreshTokenPrefix?: Maybe<Scalars['String']['output']>;
  revokedAt?: Maybe<Scalars['DateTime']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
};

export type OAuthTokenMinAggregate = {
  __typename?: 'OAuthTokenMinAggregate';
  accessTokenHash?: Maybe<Scalars['String']['output']>;
  accessTokenPrefix?: Maybe<Scalars['String']['output']>;
  clientId?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  expiresAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  lastUsedAt?: Maybe<Scalars['DateTime']['output']>;
  refreshTokenHash?: Maybe<Scalars['String']['output']>;
  refreshTokenPrefix?: Maybe<Scalars['String']['output']>;
  revokedAt?: Maybe<Scalars['DateTime']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
};

/** Onboarding configuration for AIPM participant onboarding */
export type OnboardingConfig = {
  __typename?: 'OnboardingConfig';
  customWelcome?: Maybe<Scalars['String']['output']>;
  defaultPersonaId?: Maybe<Scalars['String']['output']>;
  defaultPersonaIds?: Maybe<Array<Scalars['String']['output']>>;
  enabled?: Maybe<Scalars['Boolean']['output']>;
  phoneRequired: Scalars['Boolean']['output'];
  required: Scalars['Boolean']['output'];
  retroactiveEnabled?: Maybe<Scalars['Boolean']['output']>;
  retroactiveEnabledAt?: Maybe<Scalars['DateTime']['output']>;
  welcomeMessageEnabled?: Maybe<Scalars['Boolean']['output']>;
};

/** Input for querying onboarding status */
export type OnboardingStatusInput = {
  /** Program ID to check onboarding status for */
  programId: Scalars['String']['input'];
};

/** Complete onboarding status with funnel state */
export type OnboardingStatusType = {
  __typename?: 'OnboardingStatusType';
  /** Timestamp when onboarding was completed */
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Current step in progress */
  currentStep?: Maybe<Scalars['String']['output']>;
  /** Current funnel state: not_started, in_progress, complete */
  funnelState: Scalars['String']['output'];
  /** Step-by-step completion status */
  steps: OnboardingStepsType;
};

/** Completion status of each onboarding step */
export type OnboardingStepsType = {
  __typename?: 'OnboardingStepsType';
  /** Channel preference set */
  channel: Scalars['Boolean']['output'];
  /** Confirmation step completed */
  confirmation: Scalars['Boolean']['output'];
  /** First goal collected */
  goal: Scalars['Boolean']['output'];
  /** Persona selection completed */
  persona: Scalars['Boolean']['output'];
  /** Phone verification completed */
  phone: Scalars['Boolean']['output'];
  /** Welcome step completed */
  welcome: Scalars['Boolean']['output'];
};

export type OrgReportTemplate = {
  __typename?: 'OrgReportTemplate';
  description?: Maybe<Scalars['String']['output']>;
  exportConfig?: Maybe<ReportExportOptions>;
  fields: Array<ReportFieldConfig>;
  hasParticipants: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  isSystemTemplate: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  organizationId?: Maybe<Scalars['String']['output']>;
  participantCount: Scalars['Int']['output'];
  programSchemaId?: Maybe<Scalars['String']['output']>;
  programSchemaName?: Maybe<Scalars['String']['output']>;
  version: Scalars['Int']['output'];
};

export type Organization = {
  __typename?: 'Organization';
  /**
   * Sponsor org HQ — renders as a distinct (square/badge) pin on the sponsor map alongside program pins.
   * Set via direct DB seed in v1; self-serve admin UI deferred to v2.
   */
  address?: Maybe<ProgramLocation>;
  airtable?: Maybe<Array<OrganizationAirtable>>;
  created: Scalars['DateTime']['output'];
  /** User ID of who created this organization (may be null for legacy orgs) */
  created_by?: Maybe<Scalars['String']['output']>;
  /** Audit trail of domain verifications - records who verified which domain and when */
  domainVerifications?: Maybe<Array<OrganizationDomainVerification>>;
  /** Array of verified email domains for this organization (e.g., ["acme.com", "acme.co.uk"]) */
  domains?: Maybe<Array<Scalars['String']['output']>>;
  id: Scalars['ID']['output'];
  invitationLink?: Maybe<Scalars['String']['output']>;
  isAutoSponsoring?: Maybe<Scalars['Boolean']['output']>;
  isShareCodeAdded?: Maybe<Scalars['Boolean']['output']>;
  last_modified_at?: Maybe<Scalars['DateTime']['output']>;
  /** When the organization was last synced (may be null for legacy orgs) */
  last_synced_at?: Maybe<Scalars['DateTime']['output']>;
  logo?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  portfolioPublic?: Maybe<Scalars['Boolean']['output']>;
  /** Primary domain for display purposes (e.g., "acme.com") */
  primaryDomain?: Maybe<Scalars['String']['output']>;
  searchKeys?: Maybe<Array<Scalars['String']['output']>>;
  slug?: Maybe<Scalars['String']['output']>;
  sponsorLinkSharable?: Maybe<Scalars['Boolean']['output']>;
  updated: Scalars['DateTime']['output'];
  users?: Maybe<Array<OrganizationUsers>>;
};

export type OrganizationAirtable = {
  __typename?: 'OrganizationAirtable';
  airtable_id: Scalars['String']['output'];
  created_at: Scalars['DateTime']['output'];
  last_modified_at: Scalars['DateTime']['output'];
  spreadsheet: Scalars['String']['output'];
};

/** Lightweight organization for domain-based discovery */
export type OrganizationByDomain = {
  __typename?: 'OrganizationByDomain';
  /** Verified email domains for this organization */
  domains?: Maybe<Array<Scalars['String']['output']>>;
  /** Organization ID */
  id: Scalars['ID']['output'];
  /** Organization logo URL */
  logo?: Maybe<Scalars['String']['output']>;
  /** Organization name */
  name: Scalars['String']['output'];
};

export type OrganizationCountAggregate = {
  __typename?: 'OrganizationCountAggregate';
  _all: Scalars['Int']['output'];
  created: Scalars['Int']['output'];
  created_by: Scalars['Int']['output'];
  domains: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  invitationLink: Scalars['Int']['output'];
  isAutoSponsoring: Scalars['Int']['output'];
  isShareCodeAdded: Scalars['Int']['output'];
  last_modified_at: Scalars['Int']['output'];
  last_synced_at: Scalars['Int']['output'];
  logo: Scalars['Int']['output'];
  name: Scalars['Int']['output'];
  portfolioPublic: Scalars['Int']['output'];
  primaryDomain: Scalars['Int']['output'];
  searchKeys: Scalars['Int']['output'];
  slug: Scalars['Int']['output'];
  sponsorLinkSharable: Scalars['Int']['output'];
  updated: Scalars['Int']['output'];
};

/**
 * Embedded type for tracking domain verification audit trail
 * Records who verified a domain for an organization and when
 */
export type OrganizationDomainVerification = {
  __typename?: 'OrganizationDomainVerification';
  /** The domain that was verified (e.g., "acme.com") */
  domain: Scalars['String']['output'];
  /** When the domain was verified */
  verifiedAt: Scalars['DateTime']['output'];
  /** User ID of the person who verified the domain */
  verifiedBy: Scalars['String']['output'];
  /** Email address used for verification */
  verifierEmail: Scalars['String']['output'];
};

export type OrganizationMaxAggregate = {
  __typename?: 'OrganizationMaxAggregate';
  created?: Maybe<Scalars['DateTime']['output']>;
  created_by?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  invitationLink?: Maybe<Scalars['String']['output']>;
  isAutoSponsoring?: Maybe<Scalars['Boolean']['output']>;
  isShareCodeAdded?: Maybe<Scalars['Boolean']['output']>;
  last_modified_at?: Maybe<Scalars['DateTime']['output']>;
  last_synced_at?: Maybe<Scalars['DateTime']['output']>;
  logo?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  portfolioPublic?: Maybe<Scalars['Boolean']['output']>;
  primaryDomain?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  sponsorLinkSharable?: Maybe<Scalars['Boolean']['output']>;
  updated?: Maybe<Scalars['DateTime']['output']>;
};

export type OrganizationMinAggregate = {
  __typename?: 'OrganizationMinAggregate';
  created?: Maybe<Scalars['DateTime']['output']>;
  created_by?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  invitationLink?: Maybe<Scalars['String']['output']>;
  isAutoSponsoring?: Maybe<Scalars['Boolean']['output']>;
  isShareCodeAdded?: Maybe<Scalars['Boolean']['output']>;
  last_modified_at?: Maybe<Scalars['DateTime']['output']>;
  last_synced_at?: Maybe<Scalars['DateTime']['output']>;
  logo?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  portfolioPublic?: Maybe<Scalars['Boolean']['output']>;
  primaryDomain?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  sponsorLinkSharable?: Maybe<Scalars['Boolean']['output']>;
  updated?: Maybe<Scalars['DateTime']['output']>;
};

export type OrganizationParticipant = {
  __typename?: 'OrganizationParticipant';
  cashPaymentCount?: Maybe<Scalars['Int']['output']>;
  cashReceived?: Maybe<Scalars['Float']['output']>;
  cashSponsorInfo?: Maybe<CashSponsorInfo>;
  createdAt?: Maybe<Scalars['String']['output']>;
  credentialCount?: Maybe<Scalars['Int']['output']>;
  credentialName?: Maybe<Scalars['String']['output']>;
  credentialType?: Maybe<Scalars['String']['output']>;
  credentials?: Maybe<Array<Scalars['String']['output']>>;
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  initials: Scalars['String']['output'];
  isValidated?: Maybe<Scalars['Boolean']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  lastSavedAt?: Maybe<Scalars['String']['output']>;
  organizationName?: Maybe<Scalars['String']['output']>;
  participantId: Scalars['String']['output'];
  pathways?: Maybe<Array<Scalars['String']['output']>>;
  percentageCompleted?: Maybe<Scalars['Float']['output']>;
  profileImg?: Maybe<Scalars['String']['output']>;
  programDesc?: Maybe<Scalars['String']['output']>;
  programId: Scalars['String']['output'];
  programLogo?: Maybe<Scalars['String']['output']>;
  programName?: Maybe<Scalars['String']['output']>;
  school?: Maybe<Scalars['String']['output']>;
  schoolDistrict?: Maybe<Scalars['String']['output']>;
  shareCode?: Maybe<Scalars['String']['output']>;
  sponsorAvatar?: Maybe<Scalars['String']['output']>;
  sponsorId?: Maybe<Scalars['String']['output']>;
  sponsorInitials?: Maybe<Scalars['String']['output']>;
  sponsorName?: Maybe<Scalars['String']['output']>;
  sponsoredAt?: Maybe<Scalars['String']['output']>;
  sponsorshipType: ParticipantSponsorshipType;
  startDate?: Maybe<Scalars['String']['output']>;
  status?: Maybe<ParticipantStatus>;
  templateName?: Maybe<Scalars['String']['output']>;
  tokensReceived?: Maybe<Scalars['Int']['output']>;
  validatedAt?: Maybe<Scalars['String']['output']>;
  validatedBy?: Maybe<Scalars['String']['output']>;
  validatorName?: Maybe<Scalars['String']['output']>;
  wblType?: Maybe<Scalars['String']['output']>;
};

export type OrganizationParticipantsOutput = {
  __typename?: 'OrganizationParticipantsOutput';
  hasMore: Scalars['Boolean']['output'];
  participants: Array<OrganizationParticipant>;
  summary: ParticipantSummary;
  totalCount: Scalars['Int']['output'];
};

export type OrganizationProgram = {
  __typename?: 'OrganizationProgram';
  /** Organization members who are organizers of this program (only populated for member-organized relationship) */
  _memberOrganizers?: Maybe<Array<MemberOrganizer>>;
  /** How this program relates to the queried organization (created, member-organized, or sponsored) */
  _relationship: ProgramRelationship;
  /** ADKs completion progress percentage (0-100) */
  adksCompletionProgress?: Maybe<Scalars['Float']['output']>;
  /** Whether the program is awaiting sponsorship */
  awaitingSponsorship?: Maybe<Scalars['Boolean']['output']>;
  /** Date when the program was created */
  dateCreated: Scalars['DateTime']['output'];
  /** Domain associated with the program */
  domain?: Maybe<Scalars['String']['output']>;
  /** Unique identifier of the program */
  id: Scalars['String']['output'];
  /** Industries covered by this program */
  industries?: Maybe<Array<Scalars['String']['output']>>;
  /** Date when the program was last saved */
  lastSaved?: Maybe<Scalars['DateTime']['output']>;
  /** ID of the sponsoring organization */
  organizationId?: Maybe<Scalars['String']['output']>;
  /** Name of the sponsoring organization */
  organizationName?: Maybe<Scalars['String']['output']>;
  /** Organizers of this program */
  organizers?: Maybe<Array<MyProgramOrganizer>>;
  /** Career pathways covered by this program */
  pathways?: Maybe<Array<Scalars['String']['output']>>;
  /** Description of the program */
  programDesc?: Maybe<Scalars['String']['output']>;
  /** Program image URL */
  programImage?: Maybe<Scalars['String']['output']>;
  /** Name of the program */
  programName?: Maybe<Scalars['String']['output']>;
  /** Whether the program is published */
  published?: Maybe<Scalars['Boolean']['output']>;
  /** Sharable URL for the program */
  sharable_url?: Maybe<Scalars['String']['output']>;
  /** ID of the template used */
  templateId?: Maybe<Scalars['String']['output']>;
  /** Name of the template used */
  templateName?: Maybe<Scalars['String']['output']>;
};

export type OrganizationProgramsResponse = {
  __typename?: 'OrganizationProgramsResponse';
  /** User IDs that were excluded from organizer matching because they exceed the service-account threshold */
  excludedServiceAccountIds: Array<Scalars['String']['output']>;
  /** Programs related to the organization */
  programs: Array<OrganizationProgram>;
  /** True total count of member-organized programs before truncation was applied */
  totalCount: Scalars['Int']['output'];
  /** True when the member-organized program list was capped to prevent OOM */
  truncated: Scalars['Boolean']['output'];
};

export type OrganizationTeamMember = {
  __typename?: 'OrganizationTeamMember';
  /** User's first name */
  firstName?: Maybe<Scalars['String']['output']>;
  /** Display initials for avatar fallback */
  initials: Scalars['String']['output'];
  /** User's last name */
  lastName?: Maybe<Scalars['String']['output']>;
  /** Profile image URL */
  profileImg?: Maybe<Scalars['String']['output']>;
  /** Team member's role (owner, admin, member) */
  role: Scalars['String']['output'];
  /** User slug for public portfolio link (only returned if portfolioPublic=true) */
  slug?: Maybe<Scalars['String']['output']>;
  /** User ID of the team member */
  userId: Scalars['String']['output'];
};

export type OrganizationTeamResponse = {
  __typename?: 'OrganizationTeamResponse';
  /** Whether the viewer is an owner/admin of this organization */
  isOwner: Scalars['Boolean']['output'];
  /** List of team members */
  members: Array<OrganizationTeamMember>;
};

export type OrganizationUsers = {
  __typename?: 'OrganizationUsers';
  autoSponsorCriteria?: Maybe<OrganizationUsersAutoSponsorCriteria>;
  autoSponsoringAllowed?: Maybe<Scalars['Boolean']['output']>;
  role: Scalars['String']['output'];
  shareCode?: Maybe<Scalars['String']['output']>;
  updated?: Maybe<Scalars['DateTime']['output']>;
  user_id: Scalars['String']['output'];
};

export type OrganizationUsersAutoSponsorCriteria = {
  __typename?: 'OrganizationUsersAutoSponsorCriteria';
  age?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  roles?: Maybe<Array<Scalars['String']['output']>>;
  schoolDistrict?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
};

export type OrganizerPortfolio = {
  __typename?: 'OrganizerPortfolio';
  /** Field referred in an index, but found no data to define the type. */
  district?: Maybe<Scalars['JSON']['output']>;
  id: Scalars['ID']['output'];
  industry: Scalars['String']['output'];
  jobTitle: Scalars['String']['output'];
  organizerName: Scalars['String']['output'];
  /** Field referred in an index, but found no data to define the type. */
  position?: Maybe<Scalars['JSON']['output']>;
  primaryProduct: Scalars['String']['output'];
  /** Field referred in an index, but found no data to define the type. */
  schoolDistrict?: Maybe<Scalars['JSON']['output']>;
  /** Field referred in an index, but found no data to define the type. */
  staffType?: Maybe<Scalars['JSON']['output']>;
  work: OrganizerPortfolioWork;
};

export type OrganizerPortfolioCountAggregate = {
  __typename?: 'OrganizerPortfolioCountAggregate';
  _all: Scalars['Int']['output'];
  district: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  industry: Scalars['Int']['output'];
  jobTitle: Scalars['Int']['output'];
  organizerName: Scalars['Int']['output'];
  position: Scalars['Int']['output'];
  primaryProduct: Scalars['Int']['output'];
  schoolDistrict: Scalars['Int']['output'];
  staffType: Scalars['Int']['output'];
};

export type OrganizerPortfolioMaxAggregate = {
  __typename?: 'OrganizerPortfolioMaxAggregate';
  id?: Maybe<Scalars['String']['output']>;
  industry?: Maybe<Scalars['String']['output']>;
  jobTitle?: Maybe<Scalars['String']['output']>;
  organizerName?: Maybe<Scalars['String']['output']>;
  primaryProduct?: Maybe<Scalars['String']['output']>;
};

export type OrganizerPortfolioMinAggregate = {
  __typename?: 'OrganizerPortfolioMinAggregate';
  id?: Maybe<Scalars['String']['output']>;
  industry?: Maybe<Scalars['String']['output']>;
  jobTitle?: Maybe<Scalars['String']['output']>;
  organizerName?: Maybe<Scalars['String']['output']>;
  primaryProduct?: Maybe<Scalars['String']['output']>;
};

export type OrganizerPortfolioWork = {
  __typename?: 'OrganizerPortfolioWork';
  city: Scalars['String']['output'];
  state: Scalars['String']['output'];
  streetAddress: Scalars['String']['output'];
  zipcode: Scalars['String']['output'];
};

/** Context for OTP resend request */
export enum OtpContext {
  SignIn = 'SIGN_IN',
  SignUp = 'SIGN_UP'
}

export type OtpEventsAvgAggregate = {
  __typename?: 'OtpEventsAvgAggregate';
  signin_otp_attempts?: Maybe<Scalars['Float']['output']>;
  signup_otp_attempts?: Maybe<Scalars['Float']['output']>;
};

export type OtpEventsCountAggregate = {
  __typename?: 'OtpEventsCountAggregate';
  _all: Scalars['Int']['output'];
  blocked_signin_until: Scalars['Int']['output'];
  blocked_signup_until: Scalars['Int']['output'];
  captchaCode: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  last_attempt_at: Scalars['Int']['output'];
  phone_number: Scalars['Int']['output'];
  signin_otp_attempts: Scalars['Int']['output'];
  signup_otp_attempts: Scalars['Int']['output'];
};

export type OtpEventsMaxAggregate = {
  __typename?: 'OtpEventsMaxAggregate';
  blocked_signin_until?: Maybe<Scalars['DateTime']['output']>;
  blocked_signup_until?: Maybe<Scalars['DateTime']['output']>;
  captchaCode?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  last_attempt_at?: Maybe<Scalars['DateTime']['output']>;
  phone_number?: Maybe<Scalars['String']['output']>;
  signin_otp_attempts?: Maybe<Scalars['Int']['output']>;
  signup_otp_attempts?: Maybe<Scalars['Int']['output']>;
};

export type OtpEventsMinAggregate = {
  __typename?: 'OtpEventsMinAggregate';
  blocked_signin_until?: Maybe<Scalars['DateTime']['output']>;
  blocked_signup_until?: Maybe<Scalars['DateTime']['output']>;
  captchaCode?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  last_attempt_at?: Maybe<Scalars['DateTime']['output']>;
  phone_number?: Maybe<Scalars['String']['output']>;
  signin_otp_attempts?: Maybe<Scalars['Int']['output']>;
  signup_otp_attempts?: Maybe<Scalars['Int']['output']>;
};

export type OtpEventsSumAggregate = {
  __typename?: 'OtpEventsSumAggregate';
  signin_otp_attempts?: Maybe<Scalars['Int']['output']>;
  signup_otp_attempts?: Maybe<Scalars['Int']['output']>;
};

/** The type of OTP verification being performed. */
export enum OtpVerificationType {
  Email = 'EMAIL',
  Phone = 'PHONE'
}

export type OutreachLog = {
  __typename?: 'OutreachLog';
  contextSnapshot?: Maybe<Scalars['JSON']['output']>;
  createdAt: Scalars['DateTime']['output'];
  deliveredAt?: Maybe<Scalars['DateTime']['output']>;
  editedContent?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  externalId?: Maybe<Scalars['String']['output']>;
  failureReason?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  messageChannel: Scalars['String']['output'];
  messageContent?: Maybe<Scalars['String']['output']>;
  messageGeneratedAt?: Maybe<Scalars['DateTime']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  potentialScore: Scalars['Int']['output'];
  programId: Scalars['String']['output'];
  programName?: Maybe<Scalars['String']['output']>;
  promptMetadata?: Maybe<Scalars['JSON']['output']>;
  quadrant: Scalars['String']['output'];
  recommendation: Scalars['String']['output'];
  responseReceived: Scalars['Boolean']['output'];
  reviewedAt?: Maybe<Scalars['DateTime']['output']>;
  reviewedBy?: Maybe<Scalars['String']['output']>;
  riskScore: Scalars['Int']['output'];
  scheduledSendAt?: Maybe<Scalars['DateTime']['output']>;
  scoreAtLastEngagement?: Maybe<Scalars['JSON']['output']>;
  senderInfo?: Maybe<Scalars['JSON']['output']>;
  sentAt?: Maybe<Scalars['DateTime']['output']>;
  sentBy?: Maybe<Scalars['String']['output']>;
  signals: Scalars['JSON']['output'];
  status: Scalars['String']['output'];
  studentId: Scalars['String']['output'];
  threadId?: Maybe<Scalars['String']['output']>;
  triggerMetadata?: Maybe<Scalars['JSON']['output']>;
  triggerType: Scalars['String']['output'];
  triggeredAt: Scalars['DateTime']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type OutreachLogAvgAggregate = {
  __typename?: 'OutreachLogAvgAggregate';
  potentialScore?: Maybe<Scalars['Float']['output']>;
  riskScore?: Maybe<Scalars['Float']['output']>;
};

export type OutreachLogCountAggregate = {
  __typename?: 'OutreachLogCountAggregate';
  _all: Scalars['Int']['output'];
  contextSnapshot: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  deliveredAt: Scalars['Int']['output'];
  editedContent: Scalars['Int']['output'];
  email: Scalars['Int']['output'];
  externalId: Scalars['Int']['output'];
  failureReason: Scalars['Int']['output'];
  firstName: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  lastName: Scalars['Int']['output'];
  messageChannel: Scalars['Int']['output'];
  messageContent: Scalars['Int']['output'];
  messageGeneratedAt: Scalars['Int']['output'];
  phoneNumber: Scalars['Int']['output'];
  potentialScore: Scalars['Int']['output'];
  programId: Scalars['Int']['output'];
  programName: Scalars['Int']['output'];
  promptMetadata: Scalars['Int']['output'];
  quadrant: Scalars['Int']['output'];
  recommendation: Scalars['Int']['output'];
  responseReceived: Scalars['Int']['output'];
  reviewedAt: Scalars['Int']['output'];
  reviewedBy: Scalars['Int']['output'];
  riskScore: Scalars['Int']['output'];
  scheduledSendAt: Scalars['Int']['output'];
  scoreAtLastEngagement: Scalars['Int']['output'];
  senderInfo: Scalars['Int']['output'];
  sentAt: Scalars['Int']['output'];
  sentBy: Scalars['Int']['output'];
  signals: Scalars['Int']['output'];
  status: Scalars['Int']['output'];
  studentId: Scalars['Int']['output'];
  threadId: Scalars['Int']['output'];
  triggerMetadata: Scalars['Int']['output'];
  triggerType: Scalars['Int']['output'];
  triggeredAt: Scalars['Int']['output'];
  updatedAt: Scalars['Int']['output'];
};

export type OutreachLogMaxAggregate = {
  __typename?: 'OutreachLogMaxAggregate';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  deliveredAt?: Maybe<Scalars['DateTime']['output']>;
  editedContent?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  externalId?: Maybe<Scalars['String']['output']>;
  failureReason?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  messageChannel?: Maybe<Scalars['String']['output']>;
  messageContent?: Maybe<Scalars['String']['output']>;
  messageGeneratedAt?: Maybe<Scalars['DateTime']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  potentialScore?: Maybe<Scalars['Int']['output']>;
  programId?: Maybe<Scalars['String']['output']>;
  programName?: Maybe<Scalars['String']['output']>;
  quadrant?: Maybe<Scalars['String']['output']>;
  recommendation?: Maybe<Scalars['String']['output']>;
  responseReceived?: Maybe<Scalars['Boolean']['output']>;
  reviewedAt?: Maybe<Scalars['DateTime']['output']>;
  reviewedBy?: Maybe<Scalars['String']['output']>;
  riskScore?: Maybe<Scalars['Int']['output']>;
  scheduledSendAt?: Maybe<Scalars['DateTime']['output']>;
  sentAt?: Maybe<Scalars['DateTime']['output']>;
  sentBy?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  studentId?: Maybe<Scalars['String']['output']>;
  threadId?: Maybe<Scalars['String']['output']>;
  triggerType?: Maybe<Scalars['String']['output']>;
  triggeredAt?: Maybe<Scalars['DateTime']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type OutreachLogMinAggregate = {
  __typename?: 'OutreachLogMinAggregate';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  deliveredAt?: Maybe<Scalars['DateTime']['output']>;
  editedContent?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  externalId?: Maybe<Scalars['String']['output']>;
  failureReason?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  messageChannel?: Maybe<Scalars['String']['output']>;
  messageContent?: Maybe<Scalars['String']['output']>;
  messageGeneratedAt?: Maybe<Scalars['DateTime']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  potentialScore?: Maybe<Scalars['Int']['output']>;
  programId?: Maybe<Scalars['String']['output']>;
  programName?: Maybe<Scalars['String']['output']>;
  quadrant?: Maybe<Scalars['String']['output']>;
  recommendation?: Maybe<Scalars['String']['output']>;
  responseReceived?: Maybe<Scalars['Boolean']['output']>;
  reviewedAt?: Maybe<Scalars['DateTime']['output']>;
  reviewedBy?: Maybe<Scalars['String']['output']>;
  riskScore?: Maybe<Scalars['Int']['output']>;
  scheduledSendAt?: Maybe<Scalars['DateTime']['output']>;
  sentAt?: Maybe<Scalars['DateTime']['output']>;
  sentBy?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  studentId?: Maybe<Scalars['String']['output']>;
  threadId?: Maybe<Scalars['String']['output']>;
  triggerType?: Maybe<Scalars['String']['output']>;
  triggeredAt?: Maybe<Scalars['DateTime']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type OutreachLogSumAggregate = {
  __typename?: 'OutreachLogSumAggregate';
  potentialScore?: Maybe<Scalars['Int']['output']>;
  riskScore?: Maybe<Scalars['Int']['output']>;
};

export type OutreachQuadrantStats = {
  __typename?: 'OutreachQuadrantStats';
  PASSIVE: Scalars['Int']['output'];
  STRUGGLING: Scalars['Int']['output'];
  THRIVING: Scalars['Int']['output'];
  URGENT: Scalars['Int']['output'];
};

export type OutreachStats = {
  __typename?: 'OutreachStats';
  byQuadrant: OutreachQuadrantStats;
  total: Scalars['Int']['output'];
};

export type PageInfo = {
  __typename?: 'PageInfo';
  /** Cursor pointing to the end of the page */
  endCursor?: Maybe<Scalars['String']['output']>;
  /** Whether there are more items after the current page */
  hasNextPage: Scalars['Boolean']['output'];
  /** Whether there are more items before the current page */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** Cursor pointing to the start of the page */
  startCursor?: Maybe<Scalars['String']['output']>;
};

export type PaginationInput = {
  /** Cursor to start pagination from */
  after?: InputMaybe<Scalars['String']['input']>;
  /** Cursor to end pagination at */
  before?: InputMaybe<Scalars['String']['input']>;
  /** Number of items to return (max 100) */
  first?: InputMaybe<Scalars['Float']['input']>;
  /** Number of items to return from the end (max 100) */
  last?: InputMaybe<Scalars['Float']['input']>;
  /** Offset-based pagination: number of items to skip */
  skip?: InputMaybe<Scalars['Float']['input']>;
  /** Offset-based pagination: number of items to take */
  take?: InputMaybe<Scalars['Float']['input']>;
};

export type ParentPortfolio = {
  __typename?: 'ParentPortfolio';
  airtable?: Maybe<Array<ParentPortfolioAirtable>>;
  currentEmployer?: Maybe<Scalars['String']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  email: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  last_modified_at?: Maybe<Scalars['DateTime']['output']>;
  last_synced_at?: Maybe<Scalars['DateTime']['output']>;
  linkedIn?: Maybe<Scalars['String']['output']>;
  parent: ParentPortfolioParent;
  positionTitle?: Maybe<Scalars['String']['output']>;
  reSkill?: Maybe<Scalars['String']['output']>;
};

export type ParentPortfolioAirtable = {
  __typename?: 'ParentPortfolioAirtable';
  airtable_id: Scalars['String']['output'];
  created_at: Scalars['DateTime']['output'];
  last_modified_at: Scalars['DateTime']['output'];
  spreadsheet: Scalars['String']['output'];
};

export type ParentPortfolioCountAggregate = {
  __typename?: 'ParentPortfolioCountAggregate';
  _all: Scalars['Int']['output'];
  currentEmployer: Scalars['Int']['output'];
  deletedAt: Scalars['Int']['output'];
  email: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  last_modified_at: Scalars['Int']['output'];
  last_synced_at: Scalars['Int']['output'];
  linkedIn: Scalars['Int']['output'];
  positionTitle: Scalars['Int']['output'];
  reSkill: Scalars['Int']['output'];
};

export type ParentPortfolioMaxAggregate = {
  __typename?: 'ParentPortfolioMaxAggregate';
  currentEmployer?: Maybe<Scalars['String']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  last_modified_at?: Maybe<Scalars['DateTime']['output']>;
  last_synced_at?: Maybe<Scalars['DateTime']['output']>;
  linkedIn?: Maybe<Scalars['String']['output']>;
  positionTitle?: Maybe<Scalars['String']['output']>;
  reSkill?: Maybe<Scalars['String']['output']>;
};

export type ParentPortfolioMinAggregate = {
  __typename?: 'ParentPortfolioMinAggregate';
  currentEmployer?: Maybe<Scalars['String']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  last_modified_at?: Maybe<Scalars['DateTime']['output']>;
  last_synced_at?: Maybe<Scalars['DateTime']['output']>;
  linkedIn?: Maybe<Scalars['String']['output']>;
  positionTitle?: Maybe<Scalars['String']['output']>;
  reSkill?: Maybe<Scalars['String']['output']>;
};

export type ParentPortfolioParent = {
  __typename?: 'ParentPortfolioParent';
  city: Scalars['String']['output'];
  country?: Maybe<Scalars['String']['output']>;
  countryCode?: Maybe<Scalars['String']['output']>;
  county?: Maybe<Scalars['String']['output']>;
  currentEmployer?: Maybe<Scalars['String']['output']>;
  formattedAddress?: Maybe<Scalars['String']['output']>;
  geocodeConfidence?: Maybe<Scalars['String']['output']>;
  geocodeSource?: Maybe<Scalars['String']['output']>;
  geocodedAt?: Maybe<Scalars['DateTime']['output']>;
  isPrivate?: Maybe<Scalars['Boolean']['output']>;
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  placeId?: Maybe<Scalars['String']['output']>;
  positionTitle?: Maybe<Scalars['String']['output']>;
  state: Scalars['String']['output'];
  stateCode?: Maybe<Scalars['String']['output']>;
  streetAddress: Scalars['String']['output'];
  typeName?: Maybe<Scalars['String']['output']>;
  zipcode: Scalars['String']['output'];
};

export type Participant = {
  __typename?: 'Participant';
  birthYear?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  domainOnly?: Maybe<Scalars['String']['output']>;
  ethnicity?: Maybe<Scalars['String']['output']>;
  fullName: Scalars['String']['output'];
  gender?: Maybe<Scalars['String']['output']>;
  grade?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  language?: Maybe<Scalars['String']['output']>;
  pathways?: Maybe<Scalars['String']['output']>;
  percentageCompleted?: Maybe<Scalars['String']['output']>;
  programDesc?: Maybe<Scalars['String']['output']>;
  programDomains: Scalars['String']['output'];
  programName: Scalars['String']['output'];
  school?: Maybe<Scalars['String']['output']>;
  schoolDistrict: Scalars['String']['output'];
  tderCount?: Maybe<Scalars['Float']['output']>;
  zipcode?: Maybe<Scalars['String']['output']>;
};

export type ParticipantDetails = {
  __typename?: 'ParticipantDetails';
  commentRecords: Array<RsvpRecord>;
  rsvpRecords: Array<RsvpRecord>;
};

export type ParticipantFiltersInput = {
  birthYear?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  domain?: InputMaybe<Scalars['String']['input']>;
  ethnicity?: InputMaybe<Array<Scalars['String']['input']>>;
  gender?: InputMaybe<Scalars['String']['input']>;
  grade?: InputMaybe<Scalars['String']['input']>;
  industries?: InputMaybe<Array<Scalars['String']['input']>>;
  language?: InputMaybe<Array<Scalars['String']['input']>>;
  organization?: InputMaybe<Scalars['String']['input']>;
  pathway?: InputMaybe<Scalars['String']['input']>;
  percentageCompleted?: InputMaybe<Scalars['String']['input']>;
  schoolDistrict?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  zipcode?: InputMaybe<Scalars['String']['input']>;
};

/** Per-participant override configuration for Training Mode */
export type ParticipantOverrides = {
  __typename?: 'ParticipantOverrides';
  autoEnabled?: Maybe<Array<Scalars['String']['output']>>;
  enabledAt?: Maybe<Scalars['JSON']['output']>;
  excluded?: Maybe<Array<Scalars['String']['output']>>;
  excludedAt?: Maybe<Scalars['JSON']['output']>;
};

export type ParticipantReportField = {
  __typename?: 'ParticipantReportField';
  activityName?: Maybe<Scalars['String']['output']>;
  dataType: Scalars['String']['output'];
  id: Scalars['String']['output'];
  isLink: Scalars['Boolean']['output'];
  label: Scalars['String']['output'];
  value?: Maybe<Scalars['JSON']['output']>;
};

export type ParticipantReportOutput = {
  __typename?: 'ParticipantReportOutput';
  fields?: Maybe<Array<ParticipantReportField>>;
  message?: Maybe<Scalars['String']['output']>;
  programName?: Maybe<Scalars['String']['output']>;
  studentName?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
  templateName?: Maybe<Scalars['String']['output']>;
};

/** How the organization sponsored this participant */
export enum ParticipantSponsorshipType {
  Cash = 'CASH',
  Checkout = 'CHECKOUT',
  Credential = 'CREDENTIAL',
  Mixed = 'MIXED'
}

/** Current status of the participant in their program */
export enum ParticipantStatus {
  Active = 'ACTIVE',
  Completed = 'COMPLETED',
  Dropped = 'DROPPED',
  Pending = 'PENDING'
}

export type ParticipantSummary = {
  __typename?: 'ParticipantSummary';
  activeCount: Scalars['Int']['output'];
  cashCount: Scalars['Int']['output'];
  checkoutCount: Scalars['Int']['output'];
  completedCount: Scalars['Int']['output'];
  credentialCount: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
  totalTokens: Scalars['Int']['output'];
  uniquePrograms: Scalars['Int']['output'];
};

export type PathwayCount = {
  __typename?: 'PathwayCount';
  /** Number of programs in this pathway */
  count: Scalars['Int']['output'];
  /** The pathway name */
  pathway: Scalars['String']['output'];
};

/** Generic response from payment operations */
export type PaymentResponse = {
  __typename?: 'PaymentResponse';
  /** Account ID (for Connect accounts) */
  accountId?: Maybe<Scalars['String']['output']>;
  /** Bank account ID (for bank operations) */
  bankAccountId?: Maybe<Scalars['String']['output']>;
  /** Human-readable message describing the result */
  message: Scalars['String']['output'];
  /** Session ID (for checkout sessions) */
  sessionId?: Maybe<Scalars['String']['output']>;
  /** Session URL (for checkout sessions) */
  sessionUrl?: Maybe<Scalars['String']['output']>;
  /** Whether the operation succeeded */
  success: Scalars['Boolean']['output'];
  /** Transfer ID (for withdrawals) */
  transferId?: Maybe<Scalars['String']['output']>;
};

/** Confidence level for transfer-to-payout correlation */
export enum PayoutConfidence {
  High = 'HIGH',
  Medium = 'MEDIUM'
}

/** Status of instructor withdrawal/payout */
export enum PayoutStatus {
  Canceled = 'canceled',
  Completed = 'completed',
  Failed = 'failed',
  InTransit = 'in_transit',
  Paid = 'paid',
  Pending = 'pending'
}

/** Real-time payout status from Stripe (fetched on-demand) */
export type PayoutStatusType = {
  __typename?: 'PayoutStatusType';
  /** Unix timestamp when funds will/did arrive at bank */
  arrivalDate?: Maybe<Scalars['Int']['output']>;
  /** Confidence level of transfer-to-payout correlation */
  confidence: PayoutConfidence;
  /** Failure message if payout failed */
  failureMessage?: Maybe<Scalars['String']['output']>;
  /** Payout status: pending, in_transit, paid, failed, canceled */
  status: Scalars['String']['output'];
};

export type PelLocatorCityCount = {
  __typename?: 'PelLocatorCityCount';
  avgLat?: Maybe<Scalars['Float']['output']>;
  avgLng?: Maybe<Scalars['Float']['output']>;
  city: Scalars['String']['output'];
  count: Scalars['Int']['output'];
  zip?: Maybe<Scalars['String']['output']>;
};

export type Person = {
  __typename?: 'Person';
  /** Category of this person: SPONSOR, CREATOR, or PARTICIPANT */
  category: PersonCategory;
  /** Contextual information about the connection */
  connectionContext?: Maybe<ConnectionContext>;
  /** First name of the person */
  firstName?: Maybe<Scalars['String']['output']>;
  /** Unique identifier of the person */
  id: Scalars['String']['output'];
  /** Initials for avatar fallback display */
  initials: Scalars['String']['output'];
  /** Last name of the person */
  lastName?: Maybe<Scalars['String']['output']>;
  /** URL to the profile image */
  profileImg?: Maybe<Scalars['String']['output']>;
  /** User slug for public portfolio link (only returned if portfolioPublic=true) */
  slug?: Maybe<Scalars['String']['output']>;
  /** User ID in the database (may differ from id for sponsors) */
  userId?: Maybe<Scalars['String']['output']>;
  /** User types/roles (Student, Employer, etc.) */
  userTypes?: Maybe<Array<Scalars['String']['output']>>;
};

/** The category of a person in My People: SPONSOR, CREATOR, or PARTICIPANT */
export enum PersonCategory {
  Creator = 'CREATOR',
  Participant = 'PARTICIPANT',
  Sponsor = 'SPONSOR'
}

/** Account representative information */
export type PersonInput = {
  /** Address */
  address?: InputMaybe<AddressInput>;
  /** Date of birth */
  dob?: InputMaybe<DateOfBirthInput>;
  /** Email address */
  email?: InputMaybe<Scalars['String']['input']>;
  /** First name */
  firstName: Scalars['String']['input'];
  /** Last name */
  lastName: Scalars['String']['input'];
  /** Phone number */
  phone?: InputMaybe<Scalars['String']['input']>;
};

export type PersonaCountAggregate = {
  __typename?: 'PersonaCountAggregate';
  _all: Scalars['Int']['output'];
  active: Scalars['Int']['output'];
  bio: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  createdBy: Scalars['Int']['output'];
  engagementStyle: Scalars['Int']['output'];
  greeting: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['Int']['output'];
  organizationId: Scalars['Int']['output'];
  photoUrl: Scalars['Int']['output'];
  scope: Scalars['Int']['output'];
  signatureStyle: Scalars['Int']['output'];
  tone: Scalars['Int']['output'];
  type: Scalars['Int']['output'];
  updatedAt: Scalars['Int']['output'];
  userId: Scalars['Int']['output'];
  verified: Scalars['Int']['output'];
  voiceConfig: Scalars['Int']['output'];
};

/** AI mentor persona for AIPM conversations */
export type PersonaGraphQlType = {
  __typename?: 'PersonaGraphQLType';
  /** Personalized greeting message */
  greeting?: Maybe<Scalars['String']['output']>;
  /** MongoDB ObjectId of the persona */
  id: Scalars['ID']['output'];
  /** Display name of the persona */
  name: Scalars['String']['output'];
  /** AWS S3 URL for persona avatar */
  photoUrl?: Maybe<Scalars['String']['output']>;
  /** Biography/profile of the persona */
  profile: Scalars['String']['output'];
  /** Persona scope: universal or private */
  scope?: Maybe<Scalars['String']['output']>;
  /** Message signature (e.g., "- Adriane") */
  signature: Scalars['String']['output'];
  /** Tone and communication style */
  tone: Scalars['String']['output'];
  /** Persona type classification */
  type?: Maybe<Scalars['String']['output']>;
  /** User ID for team member personas */
  userId?: Maybe<Scalars['String']['output']>;
};

export type PersonaMaxAggregate = {
  __typename?: 'PersonaMaxAggregate';
  active?: Maybe<Scalars['Boolean']['output']>;
  bio?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  engagementStyle?: Maybe<Scalars['String']['output']>;
  greeting?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  organizationId?: Maybe<Scalars['String']['output']>;
  photoUrl?: Maybe<Scalars['String']['output']>;
  scope?: Maybe<Scalars['String']['output']>;
  signatureStyle?: Maybe<Scalars['String']['output']>;
  tone?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
  verified?: Maybe<Scalars['Boolean']['output']>;
};

export type PersonaMinAggregate = {
  __typename?: 'PersonaMinAggregate';
  active?: Maybe<Scalars['Boolean']['output']>;
  bio?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  engagementStyle?: Maybe<Scalars['String']['output']>;
  greeting?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  organizationId?: Maybe<Scalars['String']['output']>;
  photoUrl?: Maybe<Scalars['String']['output']>;
  scope?: Maybe<Scalars['String']['output']>;
  signatureStyle?: Maybe<Scalars['String']['output']>;
  tone?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
  verified?: Maybe<Scalars['Boolean']['output']>;
};

/** Result of verifying phone OTP code */
export type PhoneVerificationResultType = {
  __typename?: 'PhoneVerificationResultType';
  /** Error message if verification failed */
  error?: Maybe<Scalars['String']['output']>;
  /** Whether verification was successful */
  verified: Scalars['Boolean']['output'];
};

/** Result of sending phone verification OTP */
export type PhoneVerificationSendResultType = {
  __typename?: 'PhoneVerificationSendResultType';
  /** Number of verification attempts remaining */
  attemptsRemaining: Scalars['Float']['output'];
  /** Whether OTP was sent successfully */
  sent: Scalars['Boolean']['output'];
};

export type Place = {
  __typename?: 'Place';
  /** City name */
  city?: Maybe<Scalars['String']['output']>;
  /** Country name */
  country?: Maybe<Scalars['String']['output']>;
  /** Full formatted address (owner view only for private places) */
  formattedAddress?: Maybe<Scalars['String']['output']>;
  /** Geocoding confidence level */
  geocodeConfidence?: Maybe<Scalars['String']['output']>;
  /** Whether this place is marked as private */
  isPrivate: Scalars['Boolean']['output'];
  /** Display label for the place */
  label: Scalars['String']['output'];
  /** Latitude coordinate */
  lat?: Maybe<Scalars['Float']['output']>;
  /** Longitude coordinate */
  lng?: Maybe<Scalars['Float']['output']>;
  /** Source portfolio type (student, teacher, employer, parent) */
  sourceType?: Maybe<Scalars['String']['output']>;
  /** State name */
  state?: Maybe<Scalars['String']['output']>;
  /** Type of place (home, school, workplace, city, county, state) */
  type: PlaceType;
};

export type PlaceProfile = {
  __typename?: 'PlaceProfile';
  /** City name in title-case (e.g. "San Leandro"). */
  city: Scalars['String']['output'];
  /** Editorial description from EcosystemPlace overlay (null when unauthored). */
  description?: Maybe<Scalars['String']['output']>;
  /** True when a matching EcosystemPlace record exists (i.e., the city has been authored/claimed). */
  hasEcosystemPlace: Scalars['Boolean']['output'];
  /** Approximate centroid latitude (averaged from contributing geo records). */
  lat?: Maybe<Scalars['Float']['output']>;
  /** Approximate centroid longitude. */
  lng?: Maybe<Scalars['Float']['output']>;
  /** Number of Organizations whose HQ address is in this city. */
  organizationCount: Scalars['Int']['output'];
  /** Owning Organization ObjectId from EcosystemPlace overlay (null when unauthored). */
  ownerOrganizationId?: Maybe<Scalars['String']['output']>;
  /** Number of public Portfolios (across all 6 collections) anchored at this city. */
  portfolioCount: Scalars['Int']['output'];
  /** Number of published Programs whose locations include this city. */
  programCount: Scalars['Int']['output'];
  /** Canonical slug: city-state lowercased (e.g. "san-leandro-ca"). */
  slug: Scalars['String']['output'];
  /** Two-letter state code uppercased (e.g. "CA"). */
  state: Scalars['String']['output'];
  /** Tags from EcosystemPlace overlay; empty array when unauthored. */
  tags: Array<Scalars['String']['output']>;
  /** Aggregate presence — programCount + portfolioCount + organizationCount. */
  totalPresence: Scalars['Int']['output'];
};

export type PlaceProfilesPage = {
  __typename?: 'PlaceProfilesPage';
  /** Whether more results exist beyond this page. */
  hasNextPage: Scalars['Boolean']['output'];
  /** Top cities ranked by totalPresence descending. */
  items: Array<PlaceProfile>;
  /** Total number of cities available (across all pages). */
  totalCount: Scalars['Int']['output'];
};

/** The type of place in the My Places hierarchy */
export enum PlaceType {
  City = 'CITY',
  County = 'COUNTY',
  Home = 'HOME',
  School = 'SCHOOL',
  State = 'STATE',
  Workplace = 'WORKPLACE'
}

export type Portfolio = {
  __typename?: 'Portfolio';
  completionStatus: PortfolioCompletionStatus;
  employer?: Maybe<EmployerPortfolio>;
  organizer?: Maybe<OrganizerPortfolio>;
  parent?: Maybe<ParentPortfolio>;
  school?: Maybe<SchoolPortfolio>;
  student?: Maybe<StudentPortfolio>;
  teacher?: Maybe<TeacherPortfolio>;
  user: PortfolioUser;
};

export type PortfolioCompletionStatus = {
  __typename?: 'PortfolioCompletionStatus';
  employerProfile: Scalars['Boolean']['output'];
  generalProfile: Scalars['Boolean']['output'];
  organizerProfile: Scalars['Boolean']['output'];
  overallComplete: Scalars['Boolean']['output'];
  parentProfile: Scalars['Boolean']['output'];
  percentComplete: Scalars['Float']['output'];
  schoolProfile: Scalars['Boolean']['output'];
  studentProfile: Scalars['Boolean']['output'];
  teacherProfile: Scalars['Boolean']['output'];
};

/** The type of portfolio data being updated */
export enum PortfolioUpdateType {
  Employer = 'EMPLOYER',
  Organizer = 'ORGANIZER',
  Parent = 'PARENT',
  School = 'SCHOOL',
  Student = 'STUDENT',
  Teacher = 'TEACHER',
  User = 'USER'
}

export type PortfolioUser = {
  __typename?: 'PortfolioUser';
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  profileImg?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
  userTypes?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

/** Input data for updating user presence */
export type PresenceInput = {
  /** 0-based index of the activity in program.adks array. Optional - omit for general online status without activity tracking. */
  activityIndex?: InputMaybe<Scalars['Int']['input']>;
  /** Optional metadata about user activity (page number, module, etc.) */
  metadata?: InputMaybe<Scalars['String']['input']>;
  /** ID of the program the user is active in */
  programId: Scalars['ID']['input'];
};

/** Performance timing breakdown for debugging */
export type PresencePerformanceMetrics = {
  __typename?: 'PresencePerformanceMetrics';
  /** Activity name resolution time in milliseconds */
  activityResolveMs: Scalars['Float']['output'];
  /** Context read time in milliseconds */
  contextReadMs: Scalars['Float']['output'];
  /** Pipeline execution time in milliseconds */
  pipelineExecMs: Scalars['Float']['output'];
  /** Whether program was fetched from cache (true) or MongoDB (false) */
  programCached: Scalars['Boolean']['output'];
  /** Program cache fetch time in milliseconds */
  programFetchMs: Scalars['Float']['output'];
  /** Total response time in milliseconds */
  totalMs: Scalars['Float']['output'];
};

/** Result of a presence update operation */
export type PresenceUpdateResult = {
  __typename?: 'PresenceUpdateResult';
  /** The updated active user data if successful */
  activeUser?: Maybe<ActiveUser>;
  /** Error message if update failed */
  error?: Maybe<Scalars['String']['output']>;
  /** Performance metrics for debugging (shows timing breakdown) */
  performanceMetrics?: Maybe<PresencePerformanceMetrics>;
  /** Whether the presence update was successful */
  success: Scalars['Boolean']['output'];
};

/** Stripe price for a product */
export type Price = {
  __typename?: 'Price';
  /** Three-letter ISO currency code (usd, eur, etc) */
  currency: Scalars['String']['output'];
  /** Stripe Price ID */
  id: Scalars['String']['output'];
  /** Recurring configuration if this is a subscription price */
  recurring?: Maybe<PriceRecurring>;
  /** Price in cents */
  unitAmount: Scalars['Int']['output'];
};

/** Recurring price configuration */
export type PriceRecurring = {
  __typename?: 'PriceRecurring';
  /** Billing interval (day, week, month, year) */
  interval: Scalars['String']['output'];
  /** Number of intervals between billings */
  intervalCount: Scalars['Int']['output'];
};

/** Stripe product with token metadata */
export type Product = {
  __typename?: 'Product';
  /** Whether the product is active and available for purchase */
  active: Scalars['Boolean']['output'];
  /** Default price for this product */
  defaultPrice?: Maybe<Price>;
  /** Product description */
  description?: Maybe<Scalars['String']['output']>;
  /** Stripe Product ID */
  id: Scalars['String']['output'];
  /** Product image URLs */
  images: Array<Scalars['String']['output']>;
  /** Product metadata including token count */
  metadata: ProductMetadata;
  /** Product name */
  name: Scalars['String']['output'];
  /** All prices for this product */
  prices: Array<Price>;
};

/** Product metadata including token count */
export type ProductMetadata = {
  __typename?: 'ProductMetadata';
  /** Number of tokens included in this product */
  tokens?: Maybe<Scalars['Int']['output']>;
};

export type ProfileImage = {
  __typename?: 'ProfileImage';
  large?: Maybe<Scalars['String']['output']>;
  medium?: Maybe<Scalars['String']['output']>;
  small?: Maybe<Scalars['String']['output']>;
};

/**
 * Program represents an instance created from a program template (ProgramSchema)
 * Programs inherit structure from templates but maintain their own state and customizations
 */
export type Program = {
  __typename?: 'Program';
  _count: ProgramCount;
  activityNotification?: Maybe<Scalars['Boolean']['output']>;
  /** Activities (ADKs) that students will complete - inherited from template but can be customized */
  adks?: Maybe<Array<ProgramAdks>>;
  /** Multiple data types found: Array(String): 15.7%, Array(Int): 84.3% out of 336 sampled entries */
  ageRange?: Maybe<Scalars['JSON']['output']>;
  airtable?: Maybe<Array<ProgramAirtable>>;
  airtable_link?: Maybe<Scalars['String']['output']>;
  categories?: Maybe<Array<ProgramCategories>>;
  checkoutQualification?: Maybe<ProgramCheckoutQualification>;
  colors?: Maybe<Scalars['String']['output']>;
  /**
   * Compilation pipeline status for Fast/MCP-created programs.
   * Defaults to "ready" so legacy programs (which never set this) read as ready.
   * "compiling" = widget compilation + intelligence extraction in progress;
   * "failed"    = compilation pipeline failed; see logs for reason;
   * "ready"    = all activities have fieldSchema + protocol populated, safe to publish/enroll.
   */
  compilationStatus?: Maybe<Scalars['String']['output']>;
  /** Multiple data types found: String: 22%, String (ObjectId): 78% out of 927 sampled entries */
  createdBy?: Maybe<Scalars['JSON']['output']>;
  /**
   * How the program was created — analytics-only, NEVER affects runtime behavior.
   * 'fast' = AI-creator with Fast mode pre-fills (~60s flow)
   * 'standard' = AI-creator full interview (current default)
   * 'pro' = AI-creator with all advanced settings exposed
   * 'agent' = MCP / API-driven creation (Claude Code, etc)
   * null = legacy programs created before this field existed
   * Hard rule: do NOT branch runtime logic on this field. Programs are programs.
   * @see /Users/dericklee/.claude/plans/delightful-chasing-tarjan.md
   */
  creationMode?: Maybe<Scalars['String']['output']>;
  credentials?: Maybe<Array<ProgramCredentials>>;
  /** Multiple data types found: String: 0.5%, DateTime (Date): 99.5% out of 1000 sampled entries */
  dateCreated: Scalars['DateTime']['output'];
  deadlineCompletion?: Maybe<Scalars['String']['output']>;
  /**
   * Program-level delivery mode: "online" | "in-person" | "hybrid".
   * Mirrors ProgramDesign.deliveryModality for programs not created via AI flow.
   * Drives visibility of the Locations settings section and map pin behavior.
   */
  deliveryModality?: Maybe<Scalars['String']['output']>;
  /** Domain extracted from resourceWeb for organization linkage (e.g., "acme.com") */
  domain?: Maybe<Scalars['String']['output']>;
  embedded_descriptor?: Maybe<Scalars['String']['output']>;
  embeddings?: Maybe<Array<Scalars['Float']['output']>>;
  file_draft?: Maybe<Scalars['Boolean']['output']>;
  flippedDescription?: Maybe<Scalars['String']['output']>;
  flippedPresentation?: Maybe<Scalars['String']['output']>;
  flippedRegistration?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  industries?: Maybe<Array<Scalars['String']['output']>>;
  isChennelCreated?: Maybe<Scalars['Boolean']['output']>;
  isLastModifiedAtExists?: Maybe<Scalars['Boolean']['output']>;
  isProgramSchemaAdded?: Maybe<Scalars['Boolean']['output']>;
  /** Whether this program is publicly accessible */
  isPublic?: Maybe<Scalars['Boolean']['output']>;
  isSaveAdkMoleculeAdded?: Maybe<Scalars['Boolean']['output']>;
  isShowTimer?: Maybe<Scalars['Boolean']['output']>;
  isUniqueFieldIdAdded?: Maybe<Scalars['Boolean']['output']>;
  isUniqueIdAdded?: Maybe<Scalars['Boolean']['output']>;
  isUnsponsoredProgram?: Maybe<Scalars['Boolean']['output']>;
  isUpdateOrg?: Maybe<Scalars['Boolean']['output']>;
  isUpdateParticipants?: Maybe<Scalars['Boolean']['output']>;
  keywords?: Maybe<Array<Scalars['String']['output']>>;
  lastSaved: Scalars['DateTime']['output'];
  /** Multiple data types found: String: 0.9%, DateTime (Date): 99.1% out of 999 sampled entries */
  last_synced_at?: Maybe<Scalars['JSON']['output']>;
  /** Multiple data types found: Boolean: 59.9%, DateTime (Date): 40.1% out of 669 sampled entries */
  licensed?: Maybe<Scalars['JSON']['output']>;
  /**
   * Physical sites where this program meets. Empty for online programs.
   * First entry is the primary pin on the sponsor map. Multi-pin rendering deferred.
   */
  locations?: Maybe<Array<ProgramLocation>>;
  metaData?: Maybe<ProgramMetaData>;
  /** Reference to the Organization that sponsors/owns this program */
  organizationId?: Maybe<Scalars['String']['output']>;
  /** Denormalized organization name for display (avoids joins) */
  organizationName?: Maybe<Scalars['String']['output']>;
  /** Organizations that manage this program */
  organizers?: Maybe<Array<ProgramOrganizers>>;
  /**
   * Multiple data types found: String: 50%, String (ObjectId): 50% out of 12 sampled entries
   * Reference to original program if this is a clone
   */
  originalProgramId?: Maybe<Scalars['JSON']['output']>;
  /**
   * Multiple data types found: Array(String (ObjectId)): 0.9%, Array(ProgramParticipants): 99.1% out of 528 sampled entries
   * Students participating in this program
   */
  participants?: Maybe<Scalars['JSON']['output']>;
  /** Career pathways this program covers */
  pathways?: Maybe<Array<Scalars['String']['output']>>;
  programDesc?: Maybe<Scalars['String']['output']>;
  /** Reference to the ProgramDesign blueprint this program was created from */
  programDesignId?: Maybe<Scalars['String']['output']>;
  programImage?: Maybe<Scalars['String']['output']>;
  programKeywords?: Maybe<Scalars['JSON']['output']>;
  programName?: Maybe<Scalars['String']['output']>;
  /** Price of the program (stored as string to handle various formats) */
  programPrice?: Maybe<Scalars['String']['output']>;
  program_schema?: Maybe<Array<ProgramProgramSchema>>;
  /** Reference to the source template (ProgramSchema) this program was created from (optional for standalone programs) */
  program_schema_id?: Maybe<Scalars['String']['output']>;
  public_url?: Maybe<Scalars['String']['output']>;
  /** Whether this program has been published and is available to students */
  published?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Timestamp of the FIRST publish event for this program AFTER the
   * monetization system launched. Null for grandfathered (pre-monetization)
   * publishes. Programs with non-null publishedAt count toward the plan's
   * publish cap; null ones are exempt.
   */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Multiple data types found: String: 38.1%, Array(String): 61.9% out of 335 sampled entries */
  requiredResidency?: Maybe<Scalars['JSON']['output']>;
  requiredSkills?: Maybe<Scalars['JSON']['output']>;
  requiredTech?: Maybe<Array<Scalars['String']['output']>>;
  resourceWeb?: Maybe<Scalars['String']['output']>;
  /** Multiple data types found: String: 98.6%, Array(String): 1.4% out of 73 sampled entries */
  reward?: Maybe<Scalars['JSON']['output']>;
  rewardPresets?: Maybe<Array<Scalars['String']['output']>>;
  /** Multiple data types found: String: 68.6%, Array(String): 28.4%, Array(ProgramRewards): 3% out of 300 sampled entries */
  rewards?: Maybe<Scalars['JSON']['output']>;
  selectedDistrict?: Maybe<Scalars['JSON']['output']>;
  sharable_url?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  /**
   * SOC (Standard Occupational Classification) codes this program prepares participants for.
   * Populated lazily by the workforce SocTaggerService on first roadmap generation that
   * uses a workforce grounding source. Stable across regenerations; sponsors can clear
   * individual codes via the SettingsDialog tag review surface to force re-tagging.
   */
  socCodes?: Maybe<Array<Scalars['String']['output']>>;
  start_activity_status?: Maybe<Scalars['String']['output']>;
  /** Payments made to students enrolled in this program */
  studentWalletTransactions?: Maybe<Array<StudentWalletTransaction>>;
  /** ID of the template this program was created from (maps to ProgramSchema._id) */
  templateId?: Maybe<Scalars['String']['output']>;
  /** Could not determine type: the field only had null or empty values in the sample set. */
  templateImage?: Maybe<Scalars['JSON']['output']>;
  templateName?: Maybe<Scalars['String']['output']>;
  /** Program-level time boundaries (start/end dates for the overall program) */
  timeConfig?: Maybe<ProgramTimeConfig>;
  timerType?: Maybe<Scalars['String']['output']>;
  tokens?: Maybe<Scalars['Int']['output']>;
  tokensRange?: Maybe<ProgramTokensRange>;
  unsponsoredAdk?: Maybe<Scalars['String']['output']>;
  videoAskShareId?: Maybe<Scalars['String']['output']>;
  visibility?: Maybe<Scalars['String']['output']>;
  /** Unified wallet transactions associated with this program */
  walletTransactions?: Maybe<Array<WalletTransaction>>;
};

export type ProgramAdks = {
  __typename?: 'ProgramAdks';
  aboutOrg?: Maybe<Scalars['String']['output']>;
  activityFieldSchema?: Maybe<Scalars['JSON']['output']>;
  activityImage?: Maybe<Scalars['String']['output']>;
  activitySettings?: Maybe<ProgramAdksActivitySettings>;
  agentBrief?: Maybe<Scalars['JSON']['output']>;
  agreementInstructions?: Maybe<Scalars['String']['output']>;
  agreementLink?: Maybe<Scalars['String']['output']>;
  airtableRecordId?: Maybe<Scalars['String']['output']>;
  buildScope?: Maybe<ProgramAdksBuildScope>;
  builderType?: Maybe<Scalars['String']['output']>;
  category?: Maybe<Scalars['String']['output']>;
  clockIn?: Maybe<Scalars['String']['output']>;
  clockOut?: Maybe<Scalars['String']['output']>;
  /** Multiple data types found: String: 53.3%, Boolean: 0%, DateTime (Date): 46.7% out of 3009 sampled entries */
  completed?: Maybe<Scalars['JSON']['output']>;
  connection?: Maybe<Scalars['String']['output']>;
  conversationProtocol?: Maybe<Scalars['JSON']['output']>;
  credentials?: Maybe<Scalars['JSON']['output']>;
  defaultActivity?: Maybe<ProgramAdksDefaultActivity>;
  deliverable?: Maybe<Scalars['JSON']['output']>;
  deliverableActivity?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  discordEmployerChannel?: Maybe<Scalars['String']['output']>;
  discordEntityType?: Maybe<Scalars['String']['output']>;
  employerWebsite?: Maybe<Scalars['String']['output']>;
  endEarlyActivity?: Maybe<Scalars['String']['output']>;
  /** Multiple data types found: ProgramAdksFields: 0%, Array(ProgramAdksFields): 100% out of 13028 sampled entries */
  fields?: Maybe<Scalars['JSON']['output']>;
  finalPresentationDate?: Maybe<Scalars['String']['output']>;
  formEmbedUrl?: Maybe<Scalars['String']['output']>;
  groupActivity?: Maybe<Scalars['String']['output']>;
  icon?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  instruction?: Maybe<ProgramAdksInstruction>;
  interviewChallenge?: Maybe<Scalars['String']['output']>;
  interviewOpportunity?: Maybe<Scalars['String']['output']>;
  interviewProblem?: Maybe<Scalars['String']['output']>;
  interviewReqeust?: Maybe<Scalars['String']['output']>;
  interviewRequest?: Maybe<Scalars['String']['output']>;
  interviewSolution?: Maybe<Scalars['String']['output']>;
  introVideo?: Maybe<Scalars['String']['output']>;
  isPreview?: Maybe<Scalars['Boolean']['output']>;
  isSaved?: Maybe<Scalars['Boolean']['output']>;
  isSkippable?: Maybe<Scalars['Boolean']['output']>;
  isTeamAdk?: Maybe<Scalars['Boolean']['output']>;
  isVideoask?: Maybe<Scalars['Boolean']['output']>;
  keyResults?: Maybe<Scalars['JSON']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  optional?: Maybe<Scalars['Boolean']['output']>;
  participationLevel?: Maybe<Scalars['String']['output']>;
  pathways?: Maybe<Scalars['JSON']['output']>;
  permissions?: Maybe<Array<ProgramAdksPermissions>>;
  position?: Maybe<Scalars['JSON']['output']>;
  presetFields?: Maybe<Array<ProgramAdksPresetFields>>;
  preview?: Maybe<Scalars['Boolean']['output']>;
  primaryObjective?: Maybe<Scalars['String']['output']>;
  programDesc?: Maybe<Scalars['String']['output']>;
  /** Fields written flat by legacy automate-setup Lambda (also exist nested in rfp/scope sub-types) */
  programName?: Maybe<Scalars['String']['output']>;
  projectReq?: Maybe<Scalars['JSON']['output']>;
  projectScope?: Maybe<Scalars['String']['output']>;
  required?: Maybe<Scalars['Boolean']['output']>;
  requiredActivity?: Maybe<Scalars['String']['output']>;
  requiredSkills?: Maybe<Scalars['JSON']['output']>;
  requiredTech?: Maybe<Scalars['JSON']['output']>;
  researchLinks?: Maybe<Scalars['String']['output']>;
  resourceDrive?: Maybe<Scalars['String']['output']>;
  resourceFacebook?: Maybe<Scalars['String']['output']>;
  resourceInsta?: Maybe<Scalars['String']['output']>;
  resourceLinkedIn?: Maybe<Scalars['String']['output']>;
  resourceTwitter?: Maybe<Scalars['String']['output']>;
  resourceWeb?: Maybe<Scalars['String']['output']>;
  resourceYouTube?: Maybe<Scalars['String']['output']>;
  rewards?: Maybe<Scalars['JSON']['output']>;
  rfp?: Maybe<ProgramAdksRfp>;
  scope?: Maybe<ProgramAdksScope>;
  setupRequired?: Maybe<Scalars['Boolean']['output']>;
  /** Multiple data types found: String: 1.1%, Boolean: 98.9% out of 13034 sampled entries */
  status?: Maybe<Scalars['JSON']['output']>;
  styling?: Maybe<ProgramAdksStyling>;
  tagId?: Maybe<Scalars['String']['output']>;
  weeklyConferenceLink?: Maybe<Scalars['String']['output']>;
  weeklyMeetingCadence?: Maybe<Scalars['String']['output']>;
  weeklyMeetingDay?: Maybe<Scalars['String']['output']>;
  weeklyMeetingTime?: Maybe<Scalars['String']['output']>;
};

export type ProgramAdksActivitySettings = {
  __typename?: 'ProgramAdksActivitySettings';
  /** Could not determine type: the field only had null or empty values in the sample set. */
  activityGroups?: Maybe<Scalars['JSON']['output']>;
  activityPlacement?: Maybe<Scalars['String']['output']>;
  activityRequired?: Maybe<Scalars['String']['output']>;
  /** Could not determine type: the field only had null or empty values in the sample set. */
  activityView?: Maybe<Scalars['JSON']['output']>;
  /** Could not determine type: the field only had null or empty values in the sample set. */
  allowToEndProgramEarly?: Maybe<Scalars['JSON']['output']>;
  instructions?: Maybe<Scalars['String']['output']>;
  isDeliverable?: Maybe<Scalars['String']['output']>;
  /** Could not determine type: the field only had null or empty values in the sample set. */
  makeActivityAccessible?: Maybe<Scalars['JSON']['output']>;
  /** Could not determine type: the field only had null or empty values in the sample set. */
  merits?: Maybe<Scalars['JSON']['output']>;
  mongoDbChart?: Maybe<Scalars['String']['output']>;
  outcomes?: Maybe<Scalars['String']['output']>;
  /** Could not determine type: the field only had null or empty values in the sample set. */
  participantAndTeamData?: Maybe<Scalars['JSON']['output']>;
  /** Could not determine type: the field only had null or empty values in the sample set. */
  postActivityReflection?: Maybe<Scalars['JSON']['output']>;
  /** Could not determine type: the field only had null or empty values in the sample set. */
  presetAndSetup?: Maybe<Scalars['JSON']['output']>;
  /** Could not determine type: the field only had null or empty values in the sample set. */
  programTemplates?: Maybe<Scalars['JSON']['output']>;
  reminder?: Maybe<Scalars['String']['output']>;
  requirements?: Maybe<Array<Scalars['String']['output']>>;
  /** Could not determine type: the field only had null or empty values in the sample set. */
  resourceTypes?: Maybe<Scalars['JSON']['output']>;
  timeInForCountDown?: Maybe<Scalars['String']['output']>;
  /** Time settings for this activity (due dates, time allowances, gates, expected duration) */
  timeSettings?: Maybe<ProgramAdksTimeSettings>;
  /** Could not determine type: the field only had null or empty values in the sample set. */
  typeOfCharts?: Maybe<Scalars['JSON']['output']>;
};

export type ProgramAdksActivitySettingsCreateInput = {
  activityGroups?: InputMaybe<Scalars['JSON']['input']>;
  activityPlacement?: InputMaybe<Scalars['String']['input']>;
  activityRequired?: InputMaybe<Scalars['String']['input']>;
  activityView?: InputMaybe<Scalars['JSON']['input']>;
  allowToEndProgramEarly?: InputMaybe<Scalars['JSON']['input']>;
  instructions?: InputMaybe<Scalars['String']['input']>;
  isDeliverable?: InputMaybe<Scalars['String']['input']>;
  makeActivityAccessible?: InputMaybe<Scalars['JSON']['input']>;
  merits?: InputMaybe<Scalars['JSON']['input']>;
  mongoDbChart?: InputMaybe<Scalars['String']['input']>;
  outcomes?: InputMaybe<Scalars['String']['input']>;
  participantAndTeamData?: InputMaybe<Scalars['JSON']['input']>;
  postActivityReflection?: InputMaybe<Scalars['JSON']['input']>;
  presetAndSetup?: InputMaybe<Scalars['JSON']['input']>;
  programTemplates?: InputMaybe<Scalars['JSON']['input']>;
  reminder?: InputMaybe<Scalars['String']['input']>;
  requirements?: InputMaybe<ProgramAdksActivitySettingsCreaterequirementsInput>;
  resourceTypes?: InputMaybe<Scalars['JSON']['input']>;
  timeInForCountDown?: InputMaybe<Scalars['String']['input']>;
  timeSettings?: InputMaybe<ProgramAdksTimeSettingsCreateInput>;
  typeOfCharts?: InputMaybe<Scalars['JSON']['input']>;
};

export type ProgramAdksActivitySettingsCreaterequirementsInput = {
  set: Array<Scalars['String']['input']>;
};

export type ProgramAdksActivitySettingsObjectEqualityInput = {
  activityGroups?: InputMaybe<Scalars['JSON']['input']>;
  activityPlacement?: InputMaybe<Scalars['String']['input']>;
  activityRequired?: InputMaybe<Scalars['String']['input']>;
  activityView?: InputMaybe<Scalars['JSON']['input']>;
  allowToEndProgramEarly?: InputMaybe<Scalars['JSON']['input']>;
  instructions?: InputMaybe<Scalars['String']['input']>;
  isDeliverable?: InputMaybe<Scalars['String']['input']>;
  makeActivityAccessible?: InputMaybe<Scalars['JSON']['input']>;
  merits?: InputMaybe<Scalars['JSON']['input']>;
  mongoDbChart?: InputMaybe<Scalars['String']['input']>;
  outcomes?: InputMaybe<Scalars['String']['input']>;
  participantAndTeamData?: InputMaybe<Scalars['JSON']['input']>;
  postActivityReflection?: InputMaybe<Scalars['JSON']['input']>;
  presetAndSetup?: InputMaybe<Scalars['JSON']['input']>;
  programTemplates?: InputMaybe<Scalars['JSON']['input']>;
  reminder?: InputMaybe<Scalars['String']['input']>;
  requirements?: InputMaybe<Array<Scalars['String']['input']>>;
  resourceTypes?: InputMaybe<Scalars['JSON']['input']>;
  timeInForCountDown?: InputMaybe<Scalars['String']['input']>;
  timeSettings?: InputMaybe<ProgramAdksTimeSettingsObjectEqualityInput>;
  typeOfCharts?: InputMaybe<Scalars['JSON']['input']>;
};

export type ProgramAdksBuildScope = {
  __typename?: 'ProgramAdksBuildScope';
  objectives?: Maybe<Array<ProgramAdksBuildScopeObjectives>>;
  projects?: Maybe<Array<ProgramAdksBuildScopeProjects>>;
};

export type ProgramAdksBuildScopeCreateInput = {
  objectives?: InputMaybe<Array<ProgramAdksBuildScopeObjectivesCreateInput>>;
  projects?: InputMaybe<Array<ProgramAdksBuildScopeProjectsCreateInput>>;
};

export type ProgramAdksBuildScopeObjectEqualityInput = {
  objectives?: InputMaybe<Array<ProgramAdksBuildScopeObjectivesObjectEqualityInput>>;
  projects?: InputMaybe<Array<ProgramAdksBuildScopeProjectsObjectEqualityInput>>;
};

export type ProgramAdksBuildScopeObjectives = {
  __typename?: 'ProgramAdksBuildScopeObjectives';
  action?: Maybe<Scalars['String']['output']>;
  icon?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  position: Scalars['Int']['output'];
  roles?: Maybe<Array<Scalars['String']['output']>>;
  /** Could not determine type: the field only had null or empty values in the sample set. */
  rules?: Maybe<Scalars['JSON']['output']>;
  styling?: Maybe<ProgramAdksBuildScopeObjectivesStyling>;
  target?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
};

export type ProgramAdksBuildScopeObjectivesCreateInput = {
  action?: InputMaybe<Scalars['String']['input']>;
  icon?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  position: Scalars['Int']['input'];
  roles?: InputMaybe<ProgramAdksBuildScopeObjectivesCreaterolesInput>;
  rules?: InputMaybe<Scalars['JSON']['input']>;
  styling?: InputMaybe<ProgramAdksBuildScopeObjectivesStylingCreateInput>;
  target?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  type: Scalars['String']['input'];
};

export type ProgramAdksBuildScopeObjectivesCreaterolesInput = {
  set: Array<Scalars['String']['input']>;
};

export type ProgramAdksBuildScopeObjectivesObjectEqualityInput = {
  action?: InputMaybe<Scalars['String']['input']>;
  icon?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  position: Scalars['Int']['input'];
  roles?: InputMaybe<Array<Scalars['String']['input']>>;
  rules?: InputMaybe<Scalars['JSON']['input']>;
  styling?: InputMaybe<ProgramAdksBuildScopeObjectivesStylingObjectEqualityInput>;
  target?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  type: Scalars['String']['input'];
};

export type ProgramAdksBuildScopeObjectivesStyling = {
  __typename?: 'ProgramAdksBuildScopeObjectivesStyling';
  depressed?: Maybe<Scalars['Boolean']['output']>;
  hint?: Maybe<Scalars['String']['output']>;
  icon?: Maybe<Scalars['String']['output']>;
  label: Scalars['String']['output'];
  leftIcon?: Maybe<Scalars['String']['output']>;
  outlined: Scalars['Boolean']['output'];
  placeholder?: Maybe<Scalars['String']['output']>;
  rightIcon?: Maybe<Scalars['String']['output']>;
  rounded: Scalars['Boolean']['output'];
  small?: Maybe<Scalars['Boolean']['output']>;
};

export type ProgramAdksBuildScopeObjectivesStylingCreateInput = {
  depressed?: InputMaybe<Scalars['Boolean']['input']>;
  hint?: InputMaybe<Scalars['String']['input']>;
  icon?: InputMaybe<Scalars['String']['input']>;
  label: Scalars['String']['input'];
  leftIcon?: InputMaybe<Scalars['String']['input']>;
  outlined: Scalars['Boolean']['input'];
  placeholder?: InputMaybe<Scalars['String']['input']>;
  rightIcon?: InputMaybe<Scalars['String']['input']>;
  rounded: Scalars['Boolean']['input'];
  small?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ProgramAdksBuildScopeObjectivesStylingObjectEqualityInput = {
  depressed?: InputMaybe<Scalars['Boolean']['input']>;
  hint?: InputMaybe<Scalars['String']['input']>;
  icon?: InputMaybe<Scalars['String']['input']>;
  label: Scalars['String']['input'];
  leftIcon?: InputMaybe<Scalars['String']['input']>;
  outlined: Scalars['Boolean']['input'];
  placeholder?: InputMaybe<Scalars['String']['input']>;
  rightIcon?: InputMaybe<Scalars['String']['input']>;
  rounded: Scalars['Boolean']['input'];
  small?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ProgramAdksBuildScopeProjects = {
  __typename?: 'ProgramAdksBuildScopeProjects';
  action?: Maybe<Scalars['String']['output']>;
  icon?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  position: Scalars['Int']['output'];
  roles?: Maybe<Array<Scalars['String']['output']>>;
  styling?: Maybe<ProgramAdksBuildScopeProjectsStyling>;
  target?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
};

export type ProgramAdksBuildScopeProjectsCreateInput = {
  action?: InputMaybe<Scalars['String']['input']>;
  icon?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  position: Scalars['Int']['input'];
  roles?: InputMaybe<ProgramAdksBuildScopeProjectsCreaterolesInput>;
  styling?: InputMaybe<ProgramAdksBuildScopeProjectsStylingCreateInput>;
  target?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  type: Scalars['String']['input'];
};

export type ProgramAdksBuildScopeProjectsCreaterolesInput = {
  set: Array<Scalars['String']['input']>;
};

export type ProgramAdksBuildScopeProjectsObjectEqualityInput = {
  action?: InputMaybe<Scalars['String']['input']>;
  icon?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  position: Scalars['Int']['input'];
  roles?: InputMaybe<Array<Scalars['String']['input']>>;
  styling?: InputMaybe<ProgramAdksBuildScopeProjectsStylingObjectEqualityInput>;
  target?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  type: Scalars['String']['input'];
};

export type ProgramAdksBuildScopeProjectsStyling = {
  __typename?: 'ProgramAdksBuildScopeProjectsStyling';
  color: Scalars['String']['output'];
  depressed: Scalars['Boolean']['output'];
  label: Scalars['String']['output'];
  leftIcon: Scalars['String']['output'];
  rounded: Scalars['Boolean']['output'];
};

export type ProgramAdksBuildScopeProjectsStylingCreateInput = {
  color: Scalars['String']['input'];
  depressed: Scalars['Boolean']['input'];
  label: Scalars['String']['input'];
  leftIcon: Scalars['String']['input'];
  rounded: Scalars['Boolean']['input'];
};

export type ProgramAdksBuildScopeProjectsStylingObjectEqualityInput = {
  color: Scalars['String']['input'];
  depressed: Scalars['Boolean']['input'];
  label: Scalars['String']['input'];
  leftIcon: Scalars['String']['input'];
  rounded: Scalars['Boolean']['input'];
};

export type ProgramAdksCreateInput = {
  aboutOrg?: InputMaybe<Scalars['String']['input']>;
  activityFieldSchema?: InputMaybe<Scalars['JSON']['input']>;
  activityImage?: InputMaybe<Scalars['String']['input']>;
  activitySettings?: InputMaybe<ProgramAdksActivitySettingsCreateInput>;
  agentBrief?: InputMaybe<Scalars['JSON']['input']>;
  agreementInstructions?: InputMaybe<Scalars['String']['input']>;
  agreementLink?: InputMaybe<Scalars['String']['input']>;
  airtableRecordId?: InputMaybe<Scalars['String']['input']>;
  buildScope?: InputMaybe<ProgramAdksBuildScopeCreateInput>;
  builderType?: InputMaybe<Scalars['String']['input']>;
  category?: InputMaybe<Scalars['String']['input']>;
  clockIn?: InputMaybe<Scalars['String']['input']>;
  clockOut?: InputMaybe<Scalars['String']['input']>;
  completed?: InputMaybe<Scalars['JSON']['input']>;
  connection?: InputMaybe<Scalars['String']['input']>;
  conversationProtocol?: InputMaybe<Scalars['JSON']['input']>;
  credentials?: InputMaybe<Scalars['JSON']['input']>;
  defaultActivity?: InputMaybe<ProgramAdksDefaultActivityCreateInput>;
  deliverable?: InputMaybe<Scalars['JSON']['input']>;
  deliverableActivity?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  discordEmployerChannel?: InputMaybe<Scalars['String']['input']>;
  discordEntityType?: InputMaybe<Scalars['String']['input']>;
  employerWebsite?: InputMaybe<Scalars['String']['input']>;
  endEarlyActivity?: InputMaybe<Scalars['String']['input']>;
  fields?: InputMaybe<Scalars['JSON']['input']>;
  finalPresentationDate?: InputMaybe<Scalars['String']['input']>;
  formEmbedUrl?: InputMaybe<Scalars['String']['input']>;
  groupActivity?: InputMaybe<Scalars['String']['input']>;
  icon?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  instruction?: InputMaybe<ProgramAdksInstructionCreateInput>;
  interviewChallenge?: InputMaybe<Scalars['String']['input']>;
  interviewOpportunity?: InputMaybe<Scalars['String']['input']>;
  interviewProblem?: InputMaybe<Scalars['String']['input']>;
  interviewReqeust?: InputMaybe<Scalars['String']['input']>;
  interviewRequest?: InputMaybe<Scalars['String']['input']>;
  interviewSolution?: InputMaybe<Scalars['String']['input']>;
  introVideo?: InputMaybe<Scalars['String']['input']>;
  isPreview?: InputMaybe<Scalars['Boolean']['input']>;
  isSaved?: InputMaybe<Scalars['Boolean']['input']>;
  isSkippable?: InputMaybe<Scalars['Boolean']['input']>;
  isTeamAdk?: InputMaybe<Scalars['Boolean']['input']>;
  isVideoask?: InputMaybe<Scalars['Boolean']['input']>;
  keyResults?: InputMaybe<Scalars['JSON']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  optional?: InputMaybe<Scalars['Boolean']['input']>;
  participationLevel?: InputMaybe<Scalars['String']['input']>;
  pathways?: InputMaybe<Scalars['JSON']['input']>;
  permissions?: InputMaybe<Array<ProgramAdksPermissionsCreateInput>>;
  position?: InputMaybe<Scalars['JSON']['input']>;
  presetFields?: InputMaybe<Array<ProgramAdksPresetFieldsCreateInput>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  primaryObjective?: InputMaybe<Scalars['String']['input']>;
  programDesc?: InputMaybe<Scalars['String']['input']>;
  programName?: InputMaybe<Scalars['String']['input']>;
  projectReq?: InputMaybe<Scalars['JSON']['input']>;
  projectScope?: InputMaybe<Scalars['String']['input']>;
  required?: InputMaybe<Scalars['Boolean']['input']>;
  requiredActivity?: InputMaybe<Scalars['String']['input']>;
  requiredSkills?: InputMaybe<Scalars['JSON']['input']>;
  requiredTech?: InputMaybe<Scalars['JSON']['input']>;
  researchLinks?: InputMaybe<Scalars['String']['input']>;
  resourceDrive?: InputMaybe<Scalars['String']['input']>;
  resourceFacebook?: InputMaybe<Scalars['String']['input']>;
  resourceInsta?: InputMaybe<Scalars['String']['input']>;
  resourceLinkedIn?: InputMaybe<Scalars['String']['input']>;
  resourceTwitter?: InputMaybe<Scalars['String']['input']>;
  resourceWeb?: InputMaybe<Scalars['String']['input']>;
  resourceYouTube?: InputMaybe<Scalars['String']['input']>;
  rewards?: InputMaybe<Scalars['JSON']['input']>;
  rfp?: InputMaybe<ProgramAdksRfpCreateInput>;
  scope?: InputMaybe<ProgramAdksScopeCreateInput>;
  setupRequired?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<Scalars['JSON']['input']>;
  styling?: InputMaybe<ProgramAdksStylingCreateInput>;
  tagId?: InputMaybe<Scalars['String']['input']>;
  weeklyConferenceLink?: InputMaybe<Scalars['String']['input']>;
  weeklyMeetingCadence?: InputMaybe<Scalars['String']['input']>;
  weeklyMeetingDay?: InputMaybe<Scalars['String']['input']>;
  weeklyMeetingTime?: InputMaybe<Scalars['String']['input']>;
};

export type ProgramAdksDefaultActivity = {
  __typename?: 'ProgramAdksDefaultActivity';
  deliverableActivity: Scalars['String']['output'];
  endEarlyActivity: Scalars['String']['output'];
  groupActivity: Scalars['String']['output'];
  required: Scalars['Boolean']['output'];
  requiredActivity: Scalars['String']['output'];
};

export type ProgramAdksDefaultActivityCreateInput = {
  deliverableActivity: Scalars['String']['input'];
  endEarlyActivity: Scalars['String']['input'];
  groupActivity: Scalars['String']['input'];
  required: Scalars['Boolean']['input'];
  requiredActivity: Scalars['String']['input'];
};

export type ProgramAdksDefaultActivityObjectEqualityInput = {
  deliverableActivity: Scalars['String']['input'];
  endEarlyActivity: Scalars['String']['input'];
  groupActivity: Scalars['String']['input'];
  required: Scalars['Boolean']['input'];
  requiredActivity: Scalars['String']['input'];
};

export type ProgramAdksInstruction = {
  __typename?: 'ProgramAdksInstruction';
  boilerInstructions?: Maybe<Array<Scalars['String']['output']>>;
  connection?: Maybe<Scalars['String']['output']>;
  discordUrl?: Maybe<Scalars['String']['output']>;
  goal?: Maybe<Scalars['String']['output']>;
  youtubeUrl?: Maybe<Scalars['String']['output']>;
};

export type ProgramAdksInstructionCreateInput = {
  boilerInstructions?: InputMaybe<ProgramAdksInstructionCreateboilerInstructionsInput>;
  connection?: InputMaybe<Scalars['String']['input']>;
  discordUrl?: InputMaybe<Scalars['String']['input']>;
  goal?: InputMaybe<Scalars['String']['input']>;
  youtubeUrl?: InputMaybe<Scalars['String']['input']>;
};

export type ProgramAdksInstructionCreateboilerInstructionsInput = {
  set: Array<Scalars['String']['input']>;
};

export type ProgramAdksInstructionObjectEqualityInput = {
  boilerInstructions?: InputMaybe<Array<Scalars['String']['input']>>;
  connection?: InputMaybe<Scalars['String']['input']>;
  discordUrl?: InputMaybe<Scalars['String']['input']>;
  goal?: InputMaybe<Scalars['String']['input']>;
  youtubeUrl?: InputMaybe<Scalars['String']['input']>;
};

export type ProgramAdksObjectEqualityInput = {
  aboutOrg?: InputMaybe<Scalars['String']['input']>;
  activityFieldSchema?: InputMaybe<Scalars['JSON']['input']>;
  activityImage?: InputMaybe<Scalars['String']['input']>;
  activitySettings?: InputMaybe<ProgramAdksActivitySettingsObjectEqualityInput>;
  agentBrief?: InputMaybe<Scalars['JSON']['input']>;
  agreementInstructions?: InputMaybe<Scalars['String']['input']>;
  agreementLink?: InputMaybe<Scalars['String']['input']>;
  airtableRecordId?: InputMaybe<Scalars['String']['input']>;
  buildScope?: InputMaybe<ProgramAdksBuildScopeObjectEqualityInput>;
  builderType?: InputMaybe<Scalars['String']['input']>;
  category?: InputMaybe<Scalars['String']['input']>;
  clockIn?: InputMaybe<Scalars['String']['input']>;
  clockOut?: InputMaybe<Scalars['String']['input']>;
  completed?: InputMaybe<Scalars['JSON']['input']>;
  connection?: InputMaybe<Scalars['String']['input']>;
  conversationProtocol?: InputMaybe<Scalars['JSON']['input']>;
  credentials?: InputMaybe<Scalars['JSON']['input']>;
  defaultActivity?: InputMaybe<ProgramAdksDefaultActivityObjectEqualityInput>;
  deliverable?: InputMaybe<Scalars['JSON']['input']>;
  deliverableActivity?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  discordEmployerChannel?: InputMaybe<Scalars['String']['input']>;
  discordEntityType?: InputMaybe<Scalars['String']['input']>;
  employerWebsite?: InputMaybe<Scalars['String']['input']>;
  endEarlyActivity?: InputMaybe<Scalars['String']['input']>;
  fields?: InputMaybe<Scalars['JSON']['input']>;
  finalPresentationDate?: InputMaybe<Scalars['String']['input']>;
  formEmbedUrl?: InputMaybe<Scalars['String']['input']>;
  groupActivity?: InputMaybe<Scalars['String']['input']>;
  icon?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  instruction?: InputMaybe<ProgramAdksInstructionObjectEqualityInput>;
  interviewChallenge?: InputMaybe<Scalars['String']['input']>;
  interviewOpportunity?: InputMaybe<Scalars['String']['input']>;
  interviewProblem?: InputMaybe<Scalars['String']['input']>;
  interviewReqeust?: InputMaybe<Scalars['String']['input']>;
  interviewRequest?: InputMaybe<Scalars['String']['input']>;
  interviewSolution?: InputMaybe<Scalars['String']['input']>;
  introVideo?: InputMaybe<Scalars['String']['input']>;
  isPreview?: InputMaybe<Scalars['Boolean']['input']>;
  isSaved?: InputMaybe<Scalars['Boolean']['input']>;
  isSkippable?: InputMaybe<Scalars['Boolean']['input']>;
  isTeamAdk?: InputMaybe<Scalars['Boolean']['input']>;
  isVideoask?: InputMaybe<Scalars['Boolean']['input']>;
  keyResults?: InputMaybe<Scalars['JSON']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  optional?: InputMaybe<Scalars['Boolean']['input']>;
  participationLevel?: InputMaybe<Scalars['String']['input']>;
  pathways?: InputMaybe<Scalars['JSON']['input']>;
  permissions?: InputMaybe<Array<ProgramAdksPermissionsObjectEqualityInput>>;
  position?: InputMaybe<Scalars['JSON']['input']>;
  presetFields?: InputMaybe<Array<ProgramAdksPresetFieldsObjectEqualityInput>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  primaryObjective?: InputMaybe<Scalars['String']['input']>;
  programDesc?: InputMaybe<Scalars['String']['input']>;
  programName?: InputMaybe<Scalars['String']['input']>;
  projectReq?: InputMaybe<Scalars['JSON']['input']>;
  projectScope?: InputMaybe<Scalars['String']['input']>;
  required?: InputMaybe<Scalars['Boolean']['input']>;
  requiredActivity?: InputMaybe<Scalars['String']['input']>;
  requiredSkills?: InputMaybe<Scalars['JSON']['input']>;
  requiredTech?: InputMaybe<Scalars['JSON']['input']>;
  researchLinks?: InputMaybe<Scalars['String']['input']>;
  resourceDrive?: InputMaybe<Scalars['String']['input']>;
  resourceFacebook?: InputMaybe<Scalars['String']['input']>;
  resourceInsta?: InputMaybe<Scalars['String']['input']>;
  resourceLinkedIn?: InputMaybe<Scalars['String']['input']>;
  resourceTwitter?: InputMaybe<Scalars['String']['input']>;
  resourceWeb?: InputMaybe<Scalars['String']['input']>;
  resourceYouTube?: InputMaybe<Scalars['String']['input']>;
  rewards?: InputMaybe<Scalars['JSON']['input']>;
  rfp?: InputMaybe<ProgramAdksRfpObjectEqualityInput>;
  scope?: InputMaybe<ProgramAdksScopeObjectEqualityInput>;
  setupRequired?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<Scalars['JSON']['input']>;
  styling?: InputMaybe<ProgramAdksStylingObjectEqualityInput>;
  tagId?: InputMaybe<Scalars['String']['input']>;
  weeklyConferenceLink?: InputMaybe<Scalars['String']['input']>;
  weeklyMeetingCadence?: InputMaybe<Scalars['String']['input']>;
  weeklyMeetingDay?: InputMaybe<Scalars['String']['input']>;
  weeklyMeetingTime?: InputMaybe<Scalars['String']['input']>;
};

export type ProgramAdksPermissions = {
  __typename?: 'ProgramAdksPermissions';
  permissions_matrix?: Maybe<Array<Scalars['String']['output']>>;
  role?: Maybe<Scalars['String']['output']>;
  roles?: Maybe<Scalars['String']['output']>;
};

export type ProgramAdksPermissionsCreateInput = {
  permissions_matrix?: InputMaybe<ProgramAdksPermissionsCreatepermissions_MatrixInput>;
  role?: InputMaybe<Scalars['String']['input']>;
  roles?: InputMaybe<Scalars['String']['input']>;
};

export type ProgramAdksPermissionsCreatepermissions_MatrixInput = {
  set: Array<Scalars['String']['input']>;
};

export type ProgramAdksPermissionsObjectEqualityInput = {
  permissions_matrix?: InputMaybe<Array<Scalars['String']['input']>>;
  role?: InputMaybe<Scalars['String']['input']>;
  roles?: InputMaybe<Scalars['String']['input']>;
};

export type ProgramAdksPresetFields = {
  __typename?: 'ProgramAdksPresetFields';
  action?: Maybe<Scalars['String']['output']>;
  active?: Maybe<Scalars['Boolean']['output']>;
  /** Multiple data types found: String: 26.7%, Int: 73.3% out of 3989 sampled entries */
  defaultValue?: Maybe<Scalars['JSON']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  /** Multiple data types found: Array(String): 26.7%, Array(Int): 73.3% out of 3989 sampled entries */
  items?: Maybe<Scalars['JSON']['output']>;
  model?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  noSetup?: Maybe<Scalars['Boolean']['output']>;
  position?: Maybe<Scalars['Int']['output']>;
  preset?: Maybe<ProgramAdksPresetFieldsPreset>;
  roles?: Maybe<Array<Scalars['String']['output']>>;
  /** Could not determine type: the field only had null or empty values in the sample set. */
  rules?: Maybe<Scalars['JSON']['output']>;
  setup?: Maybe<ProgramAdksPresetFieldsSetup>;
  styling?: Maybe<ProgramAdksPresetFieldsStyling>;
  target?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
  /** Nested objects had no data in the sample dataset to introspect a nested type. */
  value?: Maybe<Scalars['JSON']['output']>;
  videoAskLabel?: Maybe<Scalars['String']['output']>;
  videoAskUrl?: Maybe<Scalars['String']['output']>;
};

export type ProgramAdksPresetFieldsCreateInput = {
  action?: InputMaybe<Scalars['String']['input']>;
  active?: InputMaybe<Scalars['Boolean']['input']>;
  defaultValue?: InputMaybe<Scalars['JSON']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  items?: InputMaybe<Scalars['JSON']['input']>;
  model?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  noSetup?: InputMaybe<Scalars['Boolean']['input']>;
  position?: InputMaybe<Scalars['Int']['input']>;
  preset?: InputMaybe<ProgramAdksPresetFieldsPresetCreateInput>;
  roles?: InputMaybe<ProgramAdksPresetFieldsCreaterolesInput>;
  rules?: InputMaybe<Scalars['JSON']['input']>;
  setup?: InputMaybe<ProgramAdksPresetFieldsSetupCreateInput>;
  styling?: InputMaybe<ProgramAdksPresetFieldsStylingCreateInput>;
  target?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  type: Scalars['String']['input'];
  value?: InputMaybe<Scalars['JSON']['input']>;
  videoAskLabel?: InputMaybe<Scalars['String']['input']>;
  videoAskUrl?: InputMaybe<Scalars['String']['input']>;
};

export type ProgramAdksPresetFieldsCreaterolesInput = {
  set: Array<Scalars['String']['input']>;
};

export type ProgramAdksPresetFieldsObjectEqualityInput = {
  action?: InputMaybe<Scalars['String']['input']>;
  active?: InputMaybe<Scalars['Boolean']['input']>;
  defaultValue?: InputMaybe<Scalars['JSON']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  items?: InputMaybe<Scalars['JSON']['input']>;
  model?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  noSetup?: InputMaybe<Scalars['Boolean']['input']>;
  position?: InputMaybe<Scalars['Int']['input']>;
  preset?: InputMaybe<ProgramAdksPresetFieldsPresetObjectEqualityInput>;
  roles?: InputMaybe<Array<Scalars['String']['input']>>;
  rules?: InputMaybe<Scalars['JSON']['input']>;
  setup?: InputMaybe<ProgramAdksPresetFieldsSetupObjectEqualityInput>;
  styling?: InputMaybe<ProgramAdksPresetFieldsStylingObjectEqualityInput>;
  target?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  type: Scalars['String']['input'];
  value?: InputMaybe<Scalars['JSON']['input']>;
  videoAskLabel?: InputMaybe<Scalars['String']['input']>;
  videoAskUrl?: InputMaybe<Scalars['String']['input']>;
};

export type ProgramAdksPresetFieldsPreset = {
  __typename?: 'ProgramAdksPresetFieldsPreset';
  maxCharacters?: Maybe<Scalars['String']['output']>;
  maxQuestions?: Maybe<Scalars['Int']['output']>;
  maxTeamMembers?: Maybe<Scalars['Int']['output']>;
  minLogs?: Maybe<Scalars['Int']['output']>;
  minimumHoursNow?: Maybe<Scalars['String']['output']>;
  videoMaxLength?: Maybe<Scalars['Int']['output']>;
};

export type ProgramAdksPresetFieldsPresetCreateInput = {
  maxCharacters?: InputMaybe<Scalars['String']['input']>;
  maxQuestions?: InputMaybe<Scalars['Int']['input']>;
  maxTeamMembers?: InputMaybe<Scalars['Int']['input']>;
  minLogs?: InputMaybe<Scalars['Int']['input']>;
  minimumHoursNow?: InputMaybe<Scalars['String']['input']>;
  videoMaxLength?: InputMaybe<Scalars['Int']['input']>;
};

export type ProgramAdksPresetFieldsPresetObjectEqualityInput = {
  maxCharacters?: InputMaybe<Scalars['String']['input']>;
  maxQuestions?: InputMaybe<Scalars['Int']['input']>;
  maxTeamMembers?: InputMaybe<Scalars['Int']['input']>;
  minLogs?: InputMaybe<Scalars['Int']['input']>;
  minimumHoursNow?: InputMaybe<Scalars['String']['input']>;
  videoMaxLength?: InputMaybe<Scalars['Int']['input']>;
};

export type ProgramAdksPresetFieldsSetup = {
  __typename?: 'ProgramAdksPresetFieldsSetup';
  directoryPreferences?: Maybe<Array<ProgramAdksPresetFieldsSetupDirectoryPreferences>>;
  discordData?: Maybe<ProgramAdksPresetFieldsSetupDiscordData>;
  driveLink?: Maybe<Scalars['String']['output']>;
  endEarlyActivity?: Maybe<Scalars['String']['output']>;
  groupActivity?: Maybe<Scalars['String']['output']>;
  maxCharacters?: Maybe<Scalars['String']['output']>;
  maxQuestions?: Maybe<Scalars['Int']['output']>;
  maxTeamMembers?: Maybe<Scalars['Int']['output']>;
  minLogs?: Maybe<Scalars['Int']['output']>;
  minimumHoursNow?: Maybe<Scalars['String']['output']>;
  requiredActivity?: Maybe<Scalars['String']['output']>;
  settings?: Maybe<ProgramAdksPresetFieldsSetupSettings>;
  signInVideoAskResponse?: Maybe<ProgramAdksPresetFieldsSetupSignInVideoAskResponse>;
  videoMaxLength?: Maybe<Scalars['Int']['output']>;
  welcomeActivity?: Maybe<Scalars['String']['output']>;
};

export type ProgramAdksPresetFieldsSetupCreateInput = {
  directoryPreferences?: InputMaybe<Array<ProgramAdksPresetFieldsSetupDirectoryPreferencesCreateInput>>;
  discordData?: InputMaybe<ProgramAdksPresetFieldsSetupDiscordDataCreateInput>;
  driveLink?: InputMaybe<Scalars['String']['input']>;
  endEarlyActivity?: InputMaybe<Scalars['String']['input']>;
  groupActivity?: InputMaybe<Scalars['String']['input']>;
  maxCharacters?: InputMaybe<Scalars['String']['input']>;
  maxQuestions?: InputMaybe<Scalars['Int']['input']>;
  maxTeamMembers?: InputMaybe<Scalars['Int']['input']>;
  minLogs?: InputMaybe<Scalars['Int']['input']>;
  minimumHoursNow?: InputMaybe<Scalars['String']['input']>;
  requiredActivity?: InputMaybe<Scalars['String']['input']>;
  settings?: InputMaybe<ProgramAdksPresetFieldsSetupSettingsCreateInput>;
  signInVideoAskResponse?: InputMaybe<ProgramAdksPresetFieldsSetupSignInVideoAskResponseCreateInput>;
  videoMaxLength?: InputMaybe<Scalars['Int']['input']>;
  welcomeActivity?: InputMaybe<Scalars['String']['input']>;
};

export type ProgramAdksPresetFieldsSetupDirectoryPreferences = {
  __typename?: 'ProgramAdksPresetFieldsSetupDirectoryPreferences';
  contactMethod?: Maybe<Array<Scalars['String']['output']>>;
  contactMethods?: Maybe<Array<Scalars['String']['output']>>;
  contactPreferences?: Maybe<Array<Scalars['String']['output']>>;
  hideEmail: Scalars['Boolean']['output'];
  hidePhone: Scalars['Boolean']['output'];
  schedulingLink?: Maybe<Scalars['String']['output']>;
  userId: Scalars['String']['output'];
};

export type ProgramAdksPresetFieldsSetupDirectoryPreferencesCreateInput = {
  contactMethod?: InputMaybe<ProgramAdksPresetFieldsSetupDirectoryPreferencesCreatecontactMethodInput>;
  contactMethods?: InputMaybe<ProgramAdksPresetFieldsSetupDirectoryPreferencesCreatecontactMethodsInput>;
  contactPreferences?: InputMaybe<ProgramAdksPresetFieldsSetupDirectoryPreferencesCreatecontactPreferencesInput>;
  hideEmail: Scalars['Boolean']['input'];
  hidePhone: Scalars['Boolean']['input'];
  schedulingLink?: InputMaybe<Scalars['String']['input']>;
  userId: Scalars['String']['input'];
};

export type ProgramAdksPresetFieldsSetupDirectoryPreferencesCreatecontactMethodInput = {
  set: Array<Scalars['String']['input']>;
};

export type ProgramAdksPresetFieldsSetupDirectoryPreferencesCreatecontactMethodsInput = {
  set: Array<Scalars['String']['input']>;
};

export type ProgramAdksPresetFieldsSetupDirectoryPreferencesCreatecontactPreferencesInput = {
  set: Array<Scalars['String']['input']>;
};

export type ProgramAdksPresetFieldsSetupDirectoryPreferencesObjectEqualityInput = {
  contactMethod?: InputMaybe<Array<Scalars['String']['input']>>;
  contactMethods?: InputMaybe<Array<Scalars['String']['input']>>;
  contactPreferences?: InputMaybe<Array<Scalars['String']['input']>>;
  hideEmail: Scalars['Boolean']['input'];
  hidePhone: Scalars['Boolean']['input'];
  schedulingLink?: InputMaybe<Scalars['String']['input']>;
  userId: Scalars['String']['input'];
};

export type ProgramAdksPresetFieldsSetupDiscordData = {
  __typename?: 'ProgramAdksPresetFieldsSetupDiscordData';
  channel?: Maybe<ProgramAdksPresetFieldsSetupDiscordDataChannel>;
  createdBy: ProgramAdksPresetFieldsSetupDiscordDataCreatedBy;
  role: ProgramAdksPresetFieldsSetupDiscordDataRole;
};

export type ProgramAdksPresetFieldsSetupDiscordDataChannel = {
  __typename?: 'ProgramAdksPresetFieldsSetupDiscordDataChannel';
  flags: Scalars['Int']['output'];
  guild_id: Scalars['String']['output'];
  id: Scalars['String']['output'];
  /** Could not determine type: the field only had null or empty values in the sample set. */
  last_message_id?: Maybe<Scalars['JSON']['output']>;
  name: Scalars['String']['output'];
  nsfw: Scalars['Boolean']['output'];
  parent_id: Scalars['String']['output'];
  permission_overwrites?: Maybe<Array<ProgramAdksPresetFieldsSetupDiscordDataChannelPermissionOverwrites>>;
  position: Scalars['Int']['output'];
  rate_limit_per_user: Scalars['Int']['output'];
  /** Could not determine type: the field only had null or empty values in the sample set. */
  topic?: Maybe<Scalars['JSON']['output']>;
  type: Scalars['Int']['output'];
};

export type ProgramAdksPresetFieldsSetupDiscordDataChannelCreateInput = {
  flags: Scalars['Int']['input'];
  guild_id: Scalars['String']['input'];
  id: Scalars['String']['input'];
  last_message_id?: InputMaybe<Scalars['JSON']['input']>;
  name: Scalars['String']['input'];
  nsfw: Scalars['Boolean']['input'];
  parent_id: Scalars['String']['input'];
  permission_overwrites?: InputMaybe<Array<ProgramAdksPresetFieldsSetupDiscordDataChannelPermissionOverwritesCreateInput>>;
  position: Scalars['Int']['input'];
  rate_limit_per_user: Scalars['Int']['input'];
  topic?: InputMaybe<Scalars['JSON']['input']>;
  type: Scalars['Int']['input'];
};

export type ProgramAdksPresetFieldsSetupDiscordDataChannelObjectEqualityInput = {
  flags: Scalars['Int']['input'];
  guild_id: Scalars['String']['input'];
  id: Scalars['String']['input'];
  last_message_id?: InputMaybe<Scalars['JSON']['input']>;
  name: Scalars['String']['input'];
  nsfw: Scalars['Boolean']['input'];
  parent_id: Scalars['String']['input'];
  permission_overwrites?: InputMaybe<Array<ProgramAdksPresetFieldsSetupDiscordDataChannelPermissionOverwritesObjectEqualityInput>>;
  position: Scalars['Int']['input'];
  rate_limit_per_user: Scalars['Int']['input'];
  topic?: InputMaybe<Scalars['JSON']['input']>;
  type: Scalars['Int']['input'];
};

export type ProgramAdksPresetFieldsSetupDiscordDataChannelPermissionOverwrites = {
  __typename?: 'ProgramAdksPresetFieldsSetupDiscordDataChannelPermissionOverwrites';
  allow: Scalars['Int']['output'];
  allow_new: Scalars['String']['output'];
  deny: Scalars['Int']['output'];
  deny_new: Scalars['String']['output'];
  id: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type ProgramAdksPresetFieldsSetupDiscordDataChannelPermissionOverwritesCreateInput = {
  allow: Scalars['Int']['input'];
  allow_new: Scalars['String']['input'];
  deny: Scalars['Int']['input'];
  deny_new: Scalars['String']['input'];
  id: Scalars['String']['input'];
  type: Scalars['String']['input'];
};

export type ProgramAdksPresetFieldsSetupDiscordDataChannelPermissionOverwritesObjectEqualityInput = {
  allow: Scalars['Int']['input'];
  allow_new: Scalars['String']['input'];
  deny: Scalars['Int']['input'];
  deny_new: Scalars['String']['input'];
  id: Scalars['String']['input'];
  type: Scalars['String']['input'];
};

export type ProgramAdksPresetFieldsSetupDiscordDataCreateInput = {
  channel?: InputMaybe<ProgramAdksPresetFieldsSetupDiscordDataChannelCreateInput>;
  createdBy: ProgramAdksPresetFieldsSetupDiscordDataCreatedByCreateInput;
  role: ProgramAdksPresetFieldsSetupDiscordDataRoleCreateInput;
};

export type ProgramAdksPresetFieldsSetupDiscordDataCreatedBy = {
  __typename?: 'ProgramAdksPresetFieldsSetupDiscordDataCreatedBy';
  email: Scalars['String']['output'];
  userType: Scalars['String']['output'];
};

export type ProgramAdksPresetFieldsSetupDiscordDataCreatedByCreateInput = {
  email: Scalars['String']['input'];
  userType: Scalars['String']['input'];
};

export type ProgramAdksPresetFieldsSetupDiscordDataCreatedByObjectEqualityInput = {
  email: Scalars['String']['input'];
  userType: Scalars['String']['input'];
};

export type ProgramAdksPresetFieldsSetupDiscordDataObjectEqualityInput = {
  channel?: InputMaybe<ProgramAdksPresetFieldsSetupDiscordDataChannelObjectEqualityInput>;
  createdBy: ProgramAdksPresetFieldsSetupDiscordDataCreatedByObjectEqualityInput;
  role: ProgramAdksPresetFieldsSetupDiscordDataRoleObjectEqualityInput;
};

export type ProgramAdksPresetFieldsSetupDiscordDataRole = {
  __typename?: 'ProgramAdksPresetFieldsSetupDiscordDataRole';
  color?: Maybe<Scalars['Int']['output']>;
  /** Could not determine type: the field only had null or empty values in the sample set. */
  description?: Maybe<Scalars['JSON']['output']>;
  flags?: Maybe<Scalars['Int']['output']>;
  global?: Maybe<Scalars['Boolean']['output']>;
  hoist?: Maybe<Scalars['Boolean']['output']>;
  /** Could not determine type: the field only had null or empty values in the sample set. */
  icon?: Maybe<Scalars['JSON']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  managed?: Maybe<Scalars['Boolean']['output']>;
  mentionable?: Maybe<Scalars['Boolean']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  permissions?: Maybe<Scalars['Int']['output']>;
  permissions_new?: Maybe<Scalars['String']['output']>;
  position?: Maybe<Scalars['Int']['output']>;
  retry_after?: Maybe<Scalars['Float']['output']>;
  /** Could not determine type: the field only had null or empty values in the sample set. */
  unicode_emoji?: Maybe<Scalars['JSON']['output']>;
};

export type ProgramAdksPresetFieldsSetupDiscordDataRoleCreateInput = {
  color?: InputMaybe<Scalars['Int']['input']>;
  description?: InputMaybe<Scalars['JSON']['input']>;
  flags?: InputMaybe<Scalars['Int']['input']>;
  global?: InputMaybe<Scalars['Boolean']['input']>;
  hoist?: InputMaybe<Scalars['Boolean']['input']>;
  icon?: InputMaybe<Scalars['JSON']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  managed?: InputMaybe<Scalars['Boolean']['input']>;
  mentionable?: InputMaybe<Scalars['Boolean']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  permissions?: InputMaybe<Scalars['Int']['input']>;
  permissions_new?: InputMaybe<Scalars['String']['input']>;
  position?: InputMaybe<Scalars['Int']['input']>;
  retry_after?: InputMaybe<Scalars['Float']['input']>;
  unicode_emoji?: InputMaybe<Scalars['JSON']['input']>;
};

export type ProgramAdksPresetFieldsSetupDiscordDataRoleObjectEqualityInput = {
  color?: InputMaybe<Scalars['Int']['input']>;
  description?: InputMaybe<Scalars['JSON']['input']>;
  flags?: InputMaybe<Scalars['Int']['input']>;
  global?: InputMaybe<Scalars['Boolean']['input']>;
  hoist?: InputMaybe<Scalars['Boolean']['input']>;
  icon?: InputMaybe<Scalars['JSON']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  managed?: InputMaybe<Scalars['Boolean']['input']>;
  mentionable?: InputMaybe<Scalars['Boolean']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  permissions?: InputMaybe<Scalars['Int']['input']>;
  permissions_new?: InputMaybe<Scalars['String']['input']>;
  position?: InputMaybe<Scalars['Int']['input']>;
  retry_after?: InputMaybe<Scalars['Float']['input']>;
  unicode_emoji?: InputMaybe<Scalars['JSON']['input']>;
};

export type ProgramAdksPresetFieldsSetupObjectEqualityInput = {
  directoryPreferences?: InputMaybe<Array<ProgramAdksPresetFieldsSetupDirectoryPreferencesObjectEqualityInput>>;
  discordData?: InputMaybe<ProgramAdksPresetFieldsSetupDiscordDataObjectEqualityInput>;
  driveLink?: InputMaybe<Scalars['String']['input']>;
  endEarlyActivity?: InputMaybe<Scalars['String']['input']>;
  groupActivity?: InputMaybe<Scalars['String']['input']>;
  maxCharacters?: InputMaybe<Scalars['String']['input']>;
  maxQuestions?: InputMaybe<Scalars['Int']['input']>;
  maxTeamMembers?: InputMaybe<Scalars['Int']['input']>;
  minLogs?: InputMaybe<Scalars['Int']['input']>;
  minimumHoursNow?: InputMaybe<Scalars['String']['input']>;
  requiredActivity?: InputMaybe<Scalars['String']['input']>;
  settings?: InputMaybe<ProgramAdksPresetFieldsSetupSettingsObjectEqualityInput>;
  signInVideoAskResponse?: InputMaybe<ProgramAdksPresetFieldsSetupSignInVideoAskResponseObjectEqualityInput>;
  videoMaxLength?: InputMaybe<Scalars['Int']['input']>;
  welcomeActivity?: InputMaybe<Scalars['String']['input']>;
};

export type ProgramAdksPresetFieldsSetupSettings = {
  __typename?: 'ProgramAdksPresetFieldsSetupSettings';
  caseStudySettings: ProgramAdksPresetFieldsSetupSettingsCaseStudySettings;
  digitalResumeSettings: Scalars['Boolean']['output'];
  presentationSettings: ProgramAdksPresetFieldsSetupSettingsPresentationSettings;
  projectFAQSettings: Scalars['Boolean']['output'];
  projectImplementationSettings: ProgramAdksPresetFieldsSetupSettingsProjectImplementationSettings;
  projectPlanSettings: ProgramAdksPresetFieldsSetupSettingsProjectPlanSettings;
  projectTaskSettings: ProgramAdksPresetFieldsSetupSettingsProjectTaskSettings;
  teamSettings: ProgramAdksPresetFieldsSetupSettingsTeamSettings;
  userInterviewSettings: ProgramAdksPresetFieldsSetupSettingsUserInterviewSettings;
};

export type ProgramAdksPresetFieldsSetupSettingsCaseStudySettings = {
  __typename?: 'ProgramAdksPresetFieldsSetupSettingsCaseStudySettings';
  contentSetting?: Maybe<Scalars['String']['output']>;
  required: Scalars['Boolean']['output'];
};

export type ProgramAdksPresetFieldsSetupSettingsCaseStudySettingsCreateInput = {
  contentSetting?: InputMaybe<Scalars['String']['input']>;
  required: Scalars['Boolean']['input'];
};

export type ProgramAdksPresetFieldsSetupSettingsCaseStudySettingsObjectEqualityInput = {
  contentSetting?: InputMaybe<Scalars['String']['input']>;
  required: Scalars['Boolean']['input'];
};

export type ProgramAdksPresetFieldsSetupSettingsCreateInput = {
  caseStudySettings: ProgramAdksPresetFieldsSetupSettingsCaseStudySettingsCreateInput;
  digitalResumeSettings: Scalars['Boolean']['input'];
  presentationSettings: ProgramAdksPresetFieldsSetupSettingsPresentationSettingsCreateInput;
  projectFAQSettings: Scalars['Boolean']['input'];
  projectImplementationSettings: ProgramAdksPresetFieldsSetupSettingsProjectImplementationSettingsCreateInput;
  projectPlanSettings: ProgramAdksPresetFieldsSetupSettingsProjectPlanSettingsCreateInput;
  projectTaskSettings: ProgramAdksPresetFieldsSetupSettingsProjectTaskSettingsCreateInput;
  teamSettings: ProgramAdksPresetFieldsSetupSettingsTeamSettingsCreateInput;
  userInterviewSettings: ProgramAdksPresetFieldsSetupSettingsUserInterviewSettingsCreateInput;
};

export type ProgramAdksPresetFieldsSetupSettingsObjectEqualityInput = {
  caseStudySettings: ProgramAdksPresetFieldsSetupSettingsCaseStudySettingsObjectEqualityInput;
  digitalResumeSettings: Scalars['Boolean']['input'];
  presentationSettings: ProgramAdksPresetFieldsSetupSettingsPresentationSettingsObjectEqualityInput;
  projectFAQSettings: Scalars['Boolean']['input'];
  projectImplementationSettings: ProgramAdksPresetFieldsSetupSettingsProjectImplementationSettingsObjectEqualityInput;
  projectPlanSettings: ProgramAdksPresetFieldsSetupSettingsProjectPlanSettingsObjectEqualityInput;
  projectTaskSettings: ProgramAdksPresetFieldsSetupSettingsProjectTaskSettingsObjectEqualityInput;
  teamSettings: ProgramAdksPresetFieldsSetupSettingsTeamSettingsObjectEqualityInput;
  userInterviewSettings: ProgramAdksPresetFieldsSetupSettingsUserInterviewSettingsObjectEqualityInput;
};

export type ProgramAdksPresetFieldsSetupSettingsPresentationSettings = {
  __typename?: 'ProgramAdksPresetFieldsSetupSettingsPresentationSettings';
  maxMins?: Maybe<Scalars['String']['output']>;
  required: Scalars['Boolean']['output'];
};

export type ProgramAdksPresetFieldsSetupSettingsPresentationSettingsCreateInput = {
  maxMins?: InputMaybe<Scalars['String']['input']>;
  required: Scalars['Boolean']['input'];
};

export type ProgramAdksPresetFieldsSetupSettingsPresentationSettingsObjectEqualityInput = {
  maxMins?: InputMaybe<Scalars['String']['input']>;
  required: Scalars['Boolean']['input'];
};

export type ProgramAdksPresetFieldsSetupSettingsProjectImplementationSettings = {
  __typename?: 'ProgramAdksPresetFieldsSetupSettingsProjectImplementationSettings';
  pilots?: Maybe<Scalars['String']['output']>;
  required: Scalars['Boolean']['output'];
};

export type ProgramAdksPresetFieldsSetupSettingsProjectImplementationSettingsCreateInput = {
  pilots?: InputMaybe<Scalars['String']['input']>;
  required: Scalars['Boolean']['input'];
};

export type ProgramAdksPresetFieldsSetupSettingsProjectImplementationSettingsObjectEqualityInput = {
  pilots?: InputMaybe<Scalars['String']['input']>;
  required: Scalars['Boolean']['input'];
};

export type ProgramAdksPresetFieldsSetupSettingsProjectPlanSettings = {
  __typename?: 'ProgramAdksPresetFieldsSetupSettingsProjectPlanSettings';
  prePopulate?: Maybe<Scalars['String']['output']>;
  required: Scalars['Boolean']['output'];
};

export type ProgramAdksPresetFieldsSetupSettingsProjectPlanSettingsCreateInput = {
  prePopulate?: InputMaybe<Scalars['String']['input']>;
  required: Scalars['Boolean']['input'];
};

export type ProgramAdksPresetFieldsSetupSettingsProjectPlanSettingsObjectEqualityInput = {
  prePopulate?: InputMaybe<Scalars['String']['input']>;
  required: Scalars['Boolean']['input'];
};

export type ProgramAdksPresetFieldsSetupSettingsProjectTaskSettings = {
  __typename?: 'ProgramAdksPresetFieldsSetupSettingsProjectTaskSettings';
  required: Scalars['Boolean']['output'];
  taskSetting?: Maybe<Scalars['String']['output']>;
};

export type ProgramAdksPresetFieldsSetupSettingsProjectTaskSettingsCreateInput = {
  required: Scalars['Boolean']['input'];
  taskSetting?: InputMaybe<Scalars['String']['input']>;
};

export type ProgramAdksPresetFieldsSetupSettingsProjectTaskSettingsObjectEqualityInput = {
  required: Scalars['Boolean']['input'];
  taskSetting?: InputMaybe<Scalars['String']['input']>;
};

export type ProgramAdksPresetFieldsSetupSettingsTeamSettings = {
  __typename?: 'ProgramAdksPresetFieldsSetupSettingsTeamSettings';
  editViewSetting?: Maybe<Scalars['String']['output']>;
  required: Scalars['Boolean']['output'];
};

export type ProgramAdksPresetFieldsSetupSettingsTeamSettingsCreateInput = {
  editViewSetting?: InputMaybe<Scalars['String']['input']>;
  required: Scalars['Boolean']['input'];
};

export type ProgramAdksPresetFieldsSetupSettingsTeamSettingsObjectEqualityInput = {
  editViewSetting?: InputMaybe<Scalars['String']['input']>;
  required: Scalars['Boolean']['input'];
};

export type ProgramAdksPresetFieldsSetupSettingsUserInterviewSettings = {
  __typename?: 'ProgramAdksPresetFieldsSetupSettingsUserInterviewSettings';
  required: Scalars['Boolean']['output'];
  totalUsers?: Maybe<Scalars['String']['output']>;
};

export type ProgramAdksPresetFieldsSetupSettingsUserInterviewSettingsCreateInput = {
  required: Scalars['Boolean']['input'];
  totalUsers?: InputMaybe<Scalars['String']['input']>;
};

export type ProgramAdksPresetFieldsSetupSettingsUserInterviewSettingsObjectEqualityInput = {
  required: Scalars['Boolean']['input'];
  totalUsers?: InputMaybe<Scalars['String']['input']>;
};

export type ProgramAdksPresetFieldsSetupSignInVideoAskResponse = {
  __typename?: 'ProgramAdksPresetFieldsSetupSignInVideoAskResponse';
  contact: ProgramAdksPresetFieldsSetupSignInVideoAskResponseContact;
  event_id: Scalars['String']['output'];
  event_type: Scalars['String']['output'];
  form: ProgramAdksPresetFieldsSetupSignInVideoAskResponseForm;
  interaction_id: Scalars['String']['output'];
};

export type ProgramAdksPresetFieldsSetupSignInVideoAskResponseContact = {
  __typename?: 'ProgramAdksPresetFieldsSetupSignInVideoAskResponseContact';
  answers?: Maybe<Array<ProgramAdksPresetFieldsSetupSignInVideoAskResponseContactAnswers>>;
  are_answers_public: Scalars['Boolean']['output'];
  are_messages_public: Scalars['Boolean']['output'];
  contact_id: Scalars['String']['output'];
  email: Scalars['String']['output'];
  platform: Scalars['String']['output'];
  share_id: Scalars['String']['output'];
  share_url: Scalars['String']['output'];
  status: Scalars['String']['output'];
};

export type ProgramAdksPresetFieldsSetupSignInVideoAskResponseContactAnswers = {
  __typename?: 'ProgramAdksPresetFieldsSetupSignInVideoAskResponseContactAnswers';
  answer_id: Scalars['String']['output'];
  media_id: Scalars['String']['output'];
  media_url: Scalars['String']['output'];
  /** Could not determine type: the field only had null or empty values in the sample set. */
  poll_options?: Maybe<Scalars['JSON']['output']>;
  question_id: Scalars['String']['output'];
};

export type ProgramAdksPresetFieldsSetupSignInVideoAskResponseContactAnswersCreateInput = {
  answer_id: Scalars['String']['input'];
  media_id: Scalars['String']['input'];
  media_url: Scalars['String']['input'];
  poll_options?: InputMaybe<Scalars['JSON']['input']>;
  question_id: Scalars['String']['input'];
};

export type ProgramAdksPresetFieldsSetupSignInVideoAskResponseContactAnswersObjectEqualityInput = {
  answer_id: Scalars['String']['input'];
  media_id: Scalars['String']['input'];
  media_url: Scalars['String']['input'];
  poll_options?: InputMaybe<Scalars['JSON']['input']>;
  question_id: Scalars['String']['input'];
};

export type ProgramAdksPresetFieldsSetupSignInVideoAskResponseContactCreateInput = {
  answers?: InputMaybe<Array<ProgramAdksPresetFieldsSetupSignInVideoAskResponseContactAnswersCreateInput>>;
  are_answers_public: Scalars['Boolean']['input'];
  are_messages_public: Scalars['Boolean']['input'];
  contact_id: Scalars['String']['input'];
  email: Scalars['String']['input'];
  platform: Scalars['String']['input'];
  share_id: Scalars['String']['input'];
  share_url: Scalars['String']['input'];
  status: Scalars['String']['input'];
};

export type ProgramAdksPresetFieldsSetupSignInVideoAskResponseContactObjectEqualityInput = {
  answers?: InputMaybe<Array<ProgramAdksPresetFieldsSetupSignInVideoAskResponseContactAnswersObjectEqualityInput>>;
  are_answers_public: Scalars['Boolean']['input'];
  are_messages_public: Scalars['Boolean']['input'];
  contact_id: Scalars['String']['input'];
  email: Scalars['String']['input'];
  platform: Scalars['String']['input'];
  share_id: Scalars['String']['input'];
  share_url: Scalars['String']['input'];
  status: Scalars['String']['input'];
};

export type ProgramAdksPresetFieldsSetupSignInVideoAskResponseCreateInput = {
  contact: ProgramAdksPresetFieldsSetupSignInVideoAskResponseContactCreateInput;
  event_id: Scalars['String']['input'];
  event_type: Scalars['String']['input'];
  form: ProgramAdksPresetFieldsSetupSignInVideoAskResponseFormCreateInput;
  interaction_id: Scalars['String']['input'];
};

export type ProgramAdksPresetFieldsSetupSignInVideoAskResponseForm = {
  __typename?: 'ProgramAdksPresetFieldsSetupSignInVideoAskResponseForm';
  are_answers_public: Scalars['Boolean']['output'];
  are_messages_public: Scalars['Boolean']['output'];
  form_id: Scalars['String']['output'];
  hide_branding: Scalars['Boolean']['output'];
  idle_deadline_time_in_minutes: Scalars['Int']['output'];
  notifications: ProgramAdksPresetFieldsSetupSignInVideoAskResponseFormNotifications;
  questions?: Maybe<Array<ProgramAdksPresetFieldsSetupSignInVideoAskResponseFormQuestions>>;
  requires_consent: Scalars['Boolean']['output'];
  requires_contact_email: Scalars['Boolean']['output'];
  requires_contact_info: Scalars['Boolean']['output'];
  requires_contact_name: Scalars['Boolean']['output'];
  requires_contact_phone_number: Scalars['Boolean']['output'];
  respondents_count: Scalars['Int']['output'];
  responses_share_id: Scalars['String']['output'];
  responses_share_url: Scalars['String']['output'];
  share_id: Scalars['String']['output'];
  share_url: Scalars['String']['output'];
  show_consent: Scalars['Boolean']['output'];
  show_contact_email: Scalars['Boolean']['output'];
  show_contact_name: Scalars['Boolean']['output'];
  show_contact_phone_number: Scalars['Boolean']['output'];
  tag_share_id: Scalars['String']['output'];
  tag_share_url: Scalars['String']['output'];
};

export type ProgramAdksPresetFieldsSetupSignInVideoAskResponseFormCreateInput = {
  are_answers_public: Scalars['Boolean']['input'];
  are_messages_public: Scalars['Boolean']['input'];
  form_id: Scalars['String']['input'];
  hide_branding: Scalars['Boolean']['input'];
  idle_deadline_time_in_minutes: Scalars['Int']['input'];
  notifications: ProgramAdksPresetFieldsSetupSignInVideoAskResponseFormNotificationsCreateInput;
  questions?: InputMaybe<Array<ProgramAdksPresetFieldsSetupSignInVideoAskResponseFormQuestionsCreateInput>>;
  requires_consent: Scalars['Boolean']['input'];
  requires_contact_email: Scalars['Boolean']['input'];
  requires_contact_info: Scalars['Boolean']['input'];
  requires_contact_name: Scalars['Boolean']['input'];
  requires_contact_phone_number: Scalars['Boolean']['input'];
  respondents_count: Scalars['Int']['input'];
  responses_share_id: Scalars['String']['input'];
  responses_share_url: Scalars['String']['input'];
  share_id: Scalars['String']['input'];
  share_url: Scalars['String']['input'];
  show_consent: Scalars['Boolean']['input'];
  show_contact_email: Scalars['Boolean']['input'];
  show_contact_name: Scalars['Boolean']['input'];
  show_contact_phone_number: Scalars['Boolean']['input'];
  tag_share_id: Scalars['String']['input'];
  tag_share_url: Scalars['String']['input'];
};

export type ProgramAdksPresetFieldsSetupSignInVideoAskResponseFormNotifications = {
  __typename?: 'ProgramAdksPresetFieldsSetupSignInVideoAskResponseFormNotifications';
  send_contact_message_emails: Scalars['Boolean']['output'];
};

export type ProgramAdksPresetFieldsSetupSignInVideoAskResponseFormNotificationsCreateInput = {
  send_contact_message_emails: Scalars['Boolean']['input'];
};

export type ProgramAdksPresetFieldsSetupSignInVideoAskResponseFormNotificationsObjectEqualityInput = {
  send_contact_message_emails: Scalars['Boolean']['input'];
};

export type ProgramAdksPresetFieldsSetupSignInVideoAskResponseFormObjectEqualityInput = {
  are_answers_public: Scalars['Boolean']['input'];
  are_messages_public: Scalars['Boolean']['input'];
  form_id: Scalars['String']['input'];
  hide_branding: Scalars['Boolean']['input'];
  idle_deadline_time_in_minutes: Scalars['Int']['input'];
  notifications: ProgramAdksPresetFieldsSetupSignInVideoAskResponseFormNotificationsObjectEqualityInput;
  questions?: InputMaybe<Array<ProgramAdksPresetFieldsSetupSignInVideoAskResponseFormQuestionsObjectEqualityInput>>;
  requires_consent: Scalars['Boolean']['input'];
  requires_contact_email: Scalars['Boolean']['input'];
  requires_contact_info: Scalars['Boolean']['input'];
  requires_contact_name: Scalars['Boolean']['input'];
  requires_contact_phone_number: Scalars['Boolean']['input'];
  respondents_count: Scalars['Int']['input'];
  responses_share_id: Scalars['String']['input'];
  responses_share_url: Scalars['String']['input'];
  share_id: Scalars['String']['input'];
  share_url: Scalars['String']['input'];
  show_consent: Scalars['Boolean']['input'];
  show_contact_email: Scalars['Boolean']['input'];
  show_contact_name: Scalars['Boolean']['input'];
  show_contact_phone_number: Scalars['Boolean']['input'];
  tag_share_id: Scalars['String']['input'];
  tag_share_url: Scalars['String']['input'];
};

export type ProgramAdksPresetFieldsSetupSignInVideoAskResponseFormQuestions = {
  __typename?: 'ProgramAdksPresetFieldsSetupSignInVideoAskResponseFormQuestions';
  question_id: Scalars['String']['output'];
};

export type ProgramAdksPresetFieldsSetupSignInVideoAskResponseFormQuestionsCreateInput = {
  question_id: Scalars['String']['input'];
};

export type ProgramAdksPresetFieldsSetupSignInVideoAskResponseFormQuestionsObjectEqualityInput = {
  question_id: Scalars['String']['input'];
};

export type ProgramAdksPresetFieldsSetupSignInVideoAskResponseObjectEqualityInput = {
  contact: ProgramAdksPresetFieldsSetupSignInVideoAskResponseContactObjectEqualityInput;
  event_id: Scalars['String']['input'];
  event_type: Scalars['String']['input'];
  form: ProgramAdksPresetFieldsSetupSignInVideoAskResponseFormObjectEqualityInput;
  interaction_id: Scalars['String']['input'];
};

export type ProgramAdksPresetFieldsStyling = {
  __typename?: 'ProgramAdksPresetFieldsStyling';
  class?: Maybe<Scalars['String']['output']>;
  depressed?: Maybe<Scalars['Boolean']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  outlined?: Maybe<Scalars['Boolean']['output']>;
  placeholder?: Maybe<Scalars['String']['output']>;
  prependIcon?: Maybe<Scalars['String']['output']>;
  rounded?: Maybe<Scalars['Boolean']['output']>;
  wrapperClass?: Maybe<Scalars['String']['output']>;
  xLarge?: Maybe<Scalars['Boolean']['output']>;
};

export type ProgramAdksPresetFieldsStylingCreateInput = {
  class?: InputMaybe<Scalars['String']['input']>;
  depressed?: InputMaybe<Scalars['Boolean']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  outlined?: InputMaybe<Scalars['Boolean']['input']>;
  placeholder?: InputMaybe<Scalars['String']['input']>;
  prependIcon?: InputMaybe<Scalars['String']['input']>;
  rounded?: InputMaybe<Scalars['Boolean']['input']>;
  wrapperClass?: InputMaybe<Scalars['String']['input']>;
  xLarge?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ProgramAdksPresetFieldsStylingObjectEqualityInput = {
  class?: InputMaybe<Scalars['String']['input']>;
  depressed?: InputMaybe<Scalars['Boolean']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  outlined?: InputMaybe<Scalars['Boolean']['input']>;
  placeholder?: InputMaybe<Scalars['String']['input']>;
  prependIcon?: InputMaybe<Scalars['String']['input']>;
  rounded?: InputMaybe<Scalars['Boolean']['input']>;
  wrapperClass?: InputMaybe<Scalars['String']['input']>;
  xLarge?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ProgramAdksRfp = {
  __typename?: 'ProgramAdksRfp';
  aboutOrg: Scalars['String']['output'];
  deliverable?: Maybe<Array<Scalars['String']['output']>>;
  employerName: Scalars['String']['output'];
  employerWebsite: Scalars['String']['output'];
  interviewChallenge: Scalars['String']['output'];
  interviewOpportunity: Scalars['String']['output'];
  interviewProblem: Scalars['String']['output'];
  interviewReqeust: Scalars['String']['output'];
  interviewSolution: Scalars['String']['output'];
  introVideo: Scalars['String']['output'];
  outcome?: Maybe<Array<Scalars['String']['output']>>;
  projectReq: Scalars['String']['output'];
  projectScope: Scalars['String']['output'];
  required: Scalars['Boolean']['output'];
  resourceDrive: Scalars['String']['output'];
  resourceFacebook: Scalars['String']['output'];
  resourceInsta: Scalars['String']['output'];
  resourceLinkedIn: Scalars['String']['output'];
  resourceTwitter?: Maybe<Scalars['String']['output']>;
  resourceWeb: Scalars['String']['output'];
  resourceYouTube: Scalars['String']['output'];
};

export type ProgramAdksRfpCreateInput = {
  aboutOrg: Scalars['String']['input'];
  deliverable?: InputMaybe<ProgramAdksRfpCreatedeliverableInput>;
  employerName: Scalars['String']['input'];
  employerWebsite: Scalars['String']['input'];
  interviewChallenge: Scalars['String']['input'];
  interviewOpportunity: Scalars['String']['input'];
  interviewProblem: Scalars['String']['input'];
  interviewReqeust: Scalars['String']['input'];
  interviewSolution: Scalars['String']['input'];
  introVideo: Scalars['String']['input'];
  outcome?: InputMaybe<ProgramAdksRfpCreateoutcomeInput>;
  projectReq: Scalars['String']['input'];
  projectScope: Scalars['String']['input'];
  required: Scalars['Boolean']['input'];
  resourceDrive: Scalars['String']['input'];
  resourceFacebook: Scalars['String']['input'];
  resourceInsta: Scalars['String']['input'];
  resourceLinkedIn: Scalars['String']['input'];
  resourceTwitter?: InputMaybe<Scalars['String']['input']>;
  resourceWeb: Scalars['String']['input'];
  resourceYouTube: Scalars['String']['input'];
};

export type ProgramAdksRfpCreatedeliverableInput = {
  set: Array<Scalars['String']['input']>;
};

export type ProgramAdksRfpCreateoutcomeInput = {
  set: Array<Scalars['String']['input']>;
};

export type ProgramAdksRfpObjectEqualityInput = {
  aboutOrg: Scalars['String']['input'];
  deliverable?: InputMaybe<Array<Scalars['String']['input']>>;
  employerName: Scalars['String']['input'];
  employerWebsite: Scalars['String']['input'];
  interviewChallenge: Scalars['String']['input'];
  interviewOpportunity: Scalars['String']['input'];
  interviewProblem: Scalars['String']['input'];
  interviewReqeust: Scalars['String']['input'];
  interviewSolution: Scalars['String']['input'];
  introVideo: Scalars['String']['input'];
  outcome?: InputMaybe<Array<Scalars['String']['input']>>;
  projectReq: Scalars['String']['input'];
  projectScope: Scalars['String']['input'];
  required: Scalars['Boolean']['input'];
  resourceDrive: Scalars['String']['input'];
  resourceFacebook: Scalars['String']['input'];
  resourceInsta: Scalars['String']['input'];
  resourceLinkedIn: Scalars['String']['input'];
  resourceTwitter?: InputMaybe<Scalars['String']['input']>;
  resourceWeb: Scalars['String']['input'];
  resourceYouTube: Scalars['String']['input'];
};

export type ProgramAdksScope = {
  __typename?: 'ProgramAdksScope';
  aboutOrg: Scalars['String']['output'];
  deliverable?: Maybe<Array<Scalars['String']['output']>>;
  employerName: Scalars['String']['output'];
  employerWebsite: Scalars['String']['output'];
  interviewChallenge: Scalars['String']['output'];
  interviewOpportunity: Scalars['String']['output'];
  interviewProblem: Scalars['String']['output'];
  interviewReqeust: Scalars['String']['output'];
  interviewSolution: Scalars['String']['output'];
  introVideo: Scalars['String']['output'];
  outcome?: Maybe<Array<Scalars['String']['output']>>;
  projectReq: Scalars['String']['output'];
  projectScope: Scalars['String']['output'];
  required: Scalars['Boolean']['output'];
  resourceDrive: Scalars['String']['output'];
  resourceFacebook: Scalars['String']['output'];
  resourceInsta: Scalars['String']['output'];
  resourceLinkedIn: Scalars['String']['output'];
  resourceTwitter?: Maybe<Scalars['String']['output']>;
  resourceWeb: Scalars['String']['output'];
  resourceYouTube: Scalars['String']['output'];
};

export type ProgramAdksScopeCreateInput = {
  aboutOrg: Scalars['String']['input'];
  deliverable?: InputMaybe<ProgramAdksScopeCreatedeliverableInput>;
  employerName: Scalars['String']['input'];
  employerWebsite: Scalars['String']['input'];
  interviewChallenge: Scalars['String']['input'];
  interviewOpportunity: Scalars['String']['input'];
  interviewProblem: Scalars['String']['input'];
  interviewReqeust: Scalars['String']['input'];
  interviewSolution: Scalars['String']['input'];
  introVideo: Scalars['String']['input'];
  outcome?: InputMaybe<ProgramAdksScopeCreateoutcomeInput>;
  projectReq: Scalars['String']['input'];
  projectScope: Scalars['String']['input'];
  required: Scalars['Boolean']['input'];
  resourceDrive: Scalars['String']['input'];
  resourceFacebook: Scalars['String']['input'];
  resourceInsta: Scalars['String']['input'];
  resourceLinkedIn: Scalars['String']['input'];
  resourceTwitter?: InputMaybe<Scalars['String']['input']>;
  resourceWeb: Scalars['String']['input'];
  resourceYouTube: Scalars['String']['input'];
};

export type ProgramAdksScopeCreatedeliverableInput = {
  set: Array<Scalars['String']['input']>;
};

export type ProgramAdksScopeCreateoutcomeInput = {
  set: Array<Scalars['String']['input']>;
};

export type ProgramAdksScopeObjectEqualityInput = {
  aboutOrg: Scalars['String']['input'];
  deliverable?: InputMaybe<Array<Scalars['String']['input']>>;
  employerName: Scalars['String']['input'];
  employerWebsite: Scalars['String']['input'];
  interviewChallenge: Scalars['String']['input'];
  interviewOpportunity: Scalars['String']['input'];
  interviewProblem: Scalars['String']['input'];
  interviewReqeust: Scalars['String']['input'];
  interviewSolution: Scalars['String']['input'];
  introVideo: Scalars['String']['input'];
  outcome?: InputMaybe<Array<Scalars['String']['input']>>;
  projectReq: Scalars['String']['input'];
  projectScope: Scalars['String']['input'];
  required: Scalars['Boolean']['input'];
  resourceDrive: Scalars['String']['input'];
  resourceFacebook: Scalars['String']['input'];
  resourceInsta: Scalars['String']['input'];
  resourceLinkedIn: Scalars['String']['input'];
  resourceTwitter?: InputMaybe<Scalars['String']['input']>;
  resourceWeb: Scalars['String']['input'];
  resourceYouTube: Scalars['String']['input'];
};

export type ProgramAdksStyling = {
  __typename?: 'ProgramAdksStyling';
  borderColor: Scalars['String']['output'];
};

export type ProgramAdksStylingCreateInput = {
  borderColor: Scalars['String']['input'];
};

export type ProgramAdksStylingObjectEqualityInput = {
  borderColor: Scalars['String']['input'];
};

/** Time properties for a single activity — all optional, all default to OFF */
export type ProgramAdksTimeSettings = {
  __typename?: 'ProgramAdksTimeSettings';
  /** ISO date or JSON RelativeDate — blocks submissions after this date */
  closeDate?: Maybe<Scalars['String']['output']>;
  closeDateAnchor?: Maybe<Scalars['String']['output']>;
  /** ISO date string (anchor=fixed) or JSON-serialized RelativeDate (anchor=enrollment|activity-start) */
  dueDate?: Maybe<Scalars['String']['output']>;
  /** Discriminator: "enrollment" | "activity-start" | "fixed" */
  dueDateAnchor?: Maybe<Scalars['String']['output']>;
  /** Display-only estimated duration in minutes */
  expectedDuration?: Maybe<Scalars['Int']['output']>;
  /** ISO date or JSON RelativeDate — blocks access before this date */
  startDate?: Maybe<Scalars['String']['output']>;
  startDateAnchor?: Maybe<Scalars['String']['output']>;
  /** Duration limit in minutes once activity is started */
  timeAllowance?: Maybe<Scalars['Int']['output']>;
  /** "soft" = warning only, "hard" = auto-submit. Default: "soft" */
  timeAllowanceMode?: Maybe<Scalars['String']['output']>;
};

export type ProgramAdksTimeSettingsCreateInput = {
  closeDate?: InputMaybe<Scalars['String']['input']>;
  closeDateAnchor?: InputMaybe<Scalars['String']['input']>;
  dueDate?: InputMaybe<Scalars['String']['input']>;
  dueDateAnchor?: InputMaybe<Scalars['String']['input']>;
  expectedDuration?: InputMaybe<Scalars['Int']['input']>;
  startDate?: InputMaybe<Scalars['String']['input']>;
  startDateAnchor?: InputMaybe<Scalars['String']['input']>;
  timeAllowance?: InputMaybe<Scalars['Int']['input']>;
  timeAllowanceMode?: InputMaybe<Scalars['String']['input']>;
};

export type ProgramAdksTimeSettingsObjectEqualityInput = {
  closeDate?: InputMaybe<Scalars['String']['input']>;
  closeDateAnchor?: InputMaybe<Scalars['String']['input']>;
  dueDate?: InputMaybe<Scalars['String']['input']>;
  dueDateAnchor?: InputMaybe<Scalars['String']['input']>;
  expectedDuration?: InputMaybe<Scalars['Int']['input']>;
  startDate?: InputMaybe<Scalars['String']['input']>;
  startDateAnchor?: InputMaybe<Scalars['String']['input']>;
  timeAllowance?: InputMaybe<Scalars['Int']['input']>;
  timeAllowanceMode?: InputMaybe<Scalars['String']['input']>;
};

export type ProgramAggregations = {
  __typename?: 'ProgramAggregations';
  /** Program counts by industry */
  industries: Array<IndustryCount>;
  /** Program counts by pathway */
  pathways: Array<PathwayCount>;
  /** Program counts by template */
  templates: Array<TemplateCount>;
};

export type ProgramAirtable = {
  __typename?: 'ProgramAirtable';
  airtable_id: Scalars['String']['output'];
  /** Multiple data types found: String: 5.2%, DateTime (Date): 94.8% out of 1021 sampled entries */
  created_at: Scalars['JSON']['output'];
  /** Multiple data types found: String: 5.2%, DateTime (Date): 94.8% out of 1021 sampled entries */
  last_modified_at: Scalars['JSON']['output'];
  spreadsheet: Scalars['String']['output'];
};

export type ProgramAirtableCreateInput = {
  airtable_id: Scalars['String']['input'];
  created_at: Scalars['JSON']['input'];
  last_modified_at: Scalars['JSON']['input'];
  spreadsheet: Scalars['String']['input'];
};

export type ProgramAirtableObjectEqualityInput = {
  airtable_id: Scalars['String']['input'];
  created_at: Scalars['JSON']['input'];
  last_modified_at: Scalars['JSON']['input'];
  spreadsheet: Scalars['String']['input'];
};

export type ProgramAvgAggregate = {
  __typename?: 'ProgramAvgAggregate';
  embeddings?: Maybe<Scalars['Float']['output']>;
  tokens?: Maybe<Scalars['Float']['output']>;
};

export type ProgramCategories = {
  __typename?: 'ProgramCategories';
  icon?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
};

export type ProgramCategoriesCreateInput = {
  icon?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};

export type ProgramCategoriesObjectEqualityInput = {
  icon?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};

export type ProgramCheckoutQualification = {
  __typename?: 'ProgramCheckoutQualification';
  ageLimit?: Maybe<Array<Scalars['Int']['output']>>;
};

export type ProgramCheckoutQualificationCreateInput = {
  ageLimit?: InputMaybe<ProgramCheckoutQualificationCreateageLimitInput>;
};

export type ProgramCheckoutQualificationCreateageLimitInput = {
  set: Array<Scalars['Int']['input']>;
};

export type ProgramCheckoutQualificationNullableCompositeFilter = {
  equals?: InputMaybe<ProgramCheckoutQualificationObjectEqualityInput>;
  is?: InputMaybe<ProgramCheckoutQualificationWhereInput>;
  isNot?: InputMaybe<ProgramCheckoutQualificationWhereInput>;
  isSet?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ProgramCheckoutQualificationNullableCreateEnvelopeInput = {
  set?: InputMaybe<ProgramCheckoutQualificationCreateInput>;
};

export type ProgramCheckoutQualificationNullableUpdateEnvelopeInput = {
  set?: InputMaybe<ProgramCheckoutQualificationCreateInput>;
  unset?: InputMaybe<Scalars['Boolean']['input']>;
  upsert?: InputMaybe<ProgramCheckoutQualificationUpsertInput>;
};

export type ProgramCheckoutQualificationObjectEqualityInput = {
  ageLimit?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type ProgramCheckoutQualificationUpdateInput = {
  ageLimit?: InputMaybe<ProgramCheckoutQualificationUpdateageLimitInput>;
};

export type ProgramCheckoutQualificationUpdateageLimitInput = {
  push?: InputMaybe<Array<Scalars['Int']['input']>>;
  set?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type ProgramCheckoutQualificationUpsertInput = {
  set: ProgramCheckoutQualificationCreateInput;
  update: ProgramCheckoutQualificationUpdateInput;
};

export type ProgramCheckoutQualificationWhereInput = {
  AND?: InputMaybe<Array<ProgramCheckoutQualificationWhereInput>>;
  NOT?: InputMaybe<Array<ProgramCheckoutQualificationWhereInput>>;
  OR?: InputMaybe<Array<ProgramCheckoutQualificationWhereInput>>;
  ageLimit?: InputMaybe<IntNullableListFilter>;
};

export type ProgramConnection = {
  __typename?: 'ProgramConnection';
  /** Aggregated counts for faceted search */
  aggregations: ProgramAggregations;
  /** List of program edges */
  edges: Array<ProgramEdge>;
  pageInfo: PageInfo;
  /** Total number of programs matching the filter */
  totalCount: Scalars['Int']['output'];
};

export type ProgramContextInput = {
  /** Program industries */
  industries?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Program pathways */
  pathways?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Program description */
  programDesc?: InputMaybe<Scalars['String']['input']>;
  /** Program name */
  programName?: InputMaybe<Scalars['String']['input']>;
};

export type ProgramCount = {
  __typename?: 'ProgramCount';
  studentWalletTransactions: Scalars['Int']['output'];
  walletTransactions: Scalars['Int']['output'];
};

export type ProgramCountAggregate = {
  __typename?: 'ProgramCountAggregate';
  _all: Scalars['Int']['output'];
  activityNotification: Scalars['Int']['output'];
  ageRange: Scalars['Int']['output'];
  airtable_link: Scalars['Int']['output'];
  colors: Scalars['Int']['output'];
  compilationStatus: Scalars['Int']['output'];
  createdBy: Scalars['Int']['output'];
  creationMode: Scalars['Int']['output'];
  dateCreated: Scalars['Int']['output'];
  deadlineCompletion: Scalars['Int']['output'];
  deliveryModality: Scalars['Int']['output'];
  domain: Scalars['Int']['output'];
  embedded_descriptor: Scalars['Int']['output'];
  embeddings: Scalars['Int']['output'];
  file_draft: Scalars['Int']['output'];
  flippedDescription: Scalars['Int']['output'];
  flippedPresentation: Scalars['Int']['output'];
  flippedRegistration: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  industries: Scalars['Int']['output'];
  isChennelCreated: Scalars['Int']['output'];
  isLastModifiedAtExists: Scalars['Int']['output'];
  isProgramSchemaAdded: Scalars['Int']['output'];
  isPublic: Scalars['Int']['output'];
  isSaveAdkMoleculeAdded: Scalars['Int']['output'];
  isShowTimer: Scalars['Int']['output'];
  isUniqueFieldIdAdded: Scalars['Int']['output'];
  isUniqueIdAdded: Scalars['Int']['output'];
  isUnsponsoredProgram: Scalars['Int']['output'];
  isUpdateOrg: Scalars['Int']['output'];
  isUpdateParticipants: Scalars['Int']['output'];
  keywords: Scalars['Int']['output'];
  lastSaved: Scalars['Int']['output'];
  last_synced_at: Scalars['Int']['output'];
  licensed: Scalars['Int']['output'];
  organizationId: Scalars['Int']['output'];
  organizationName: Scalars['Int']['output'];
  originalProgramId: Scalars['Int']['output'];
  participants: Scalars['Int']['output'];
  pathways: Scalars['Int']['output'];
  programDesc: Scalars['Int']['output'];
  programDesignId: Scalars['Int']['output'];
  programImage: Scalars['Int']['output'];
  programKeywords: Scalars['Int']['output'];
  programName: Scalars['Int']['output'];
  programPrice: Scalars['Int']['output'];
  program_schema_id: Scalars['Int']['output'];
  public_url: Scalars['Int']['output'];
  published: Scalars['Int']['output'];
  publishedAt: Scalars['Int']['output'];
  requiredResidency: Scalars['Int']['output'];
  requiredSkills: Scalars['Int']['output'];
  requiredTech: Scalars['Int']['output'];
  resourceWeb: Scalars['Int']['output'];
  reward: Scalars['Int']['output'];
  rewardPresets: Scalars['Int']['output'];
  rewards: Scalars['Int']['output'];
  selectedDistrict: Scalars['Int']['output'];
  sharable_url: Scalars['Int']['output'];
  slug: Scalars['Int']['output'];
  socCodes: Scalars['Int']['output'];
  start_activity_status: Scalars['Int']['output'];
  templateId: Scalars['Int']['output'];
  templateImage: Scalars['Int']['output'];
  templateName: Scalars['Int']['output'];
  timerType: Scalars['Int']['output'];
  tokens: Scalars['Int']['output'];
  unsponsoredAdk: Scalars['Int']['output'];
  videoAskShareId: Scalars['Int']['output'];
  visibility: Scalars['Int']['output'];
};

export type ProgramCreateNestedOneWithoutStudentWalletTransactionsInput = {
  connect?: InputMaybe<ProgramWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ProgramCreateOrConnectWithoutStudentWalletTransactionsInput>;
  create?: InputMaybe<ProgramCreateWithoutStudentWalletTransactionsInput>;
};

export type ProgramCreateNestedOneWithoutWalletTransactionsInput = {
  connect?: InputMaybe<ProgramWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ProgramCreateOrConnectWithoutWalletTransactionsInput>;
  create?: InputMaybe<ProgramCreateWithoutWalletTransactionsInput>;
};

export type ProgramCreateOrConnectWithoutStudentWalletTransactionsInput = {
  create: ProgramCreateWithoutStudentWalletTransactionsInput;
  where: ProgramWhereUniqueInput;
};

export type ProgramCreateOrConnectWithoutWalletTransactionsInput = {
  create: ProgramCreateWithoutWalletTransactionsInput;
  where: ProgramWhereUniqueInput;
};

export type ProgramCreateWithoutStudentWalletTransactionsInput = {
  activityNotification?: InputMaybe<Scalars['Boolean']['input']>;
  adks?: InputMaybe<Array<ProgramAdksCreateInput>>;
  ageRange?: InputMaybe<Scalars['JSON']['input']>;
  airtable?: InputMaybe<Array<ProgramAirtableCreateInput>>;
  airtable_link?: InputMaybe<Scalars['String']['input']>;
  categories?: InputMaybe<Array<ProgramCategoriesCreateInput>>;
  checkoutQualification?: InputMaybe<ProgramCheckoutQualificationNullableCreateEnvelopeInput>;
  colors?: InputMaybe<Scalars['String']['input']>;
  compilationStatus?: InputMaybe<Scalars['String']['input']>;
  createdBy?: InputMaybe<Scalars['JSON']['input']>;
  creationMode?: InputMaybe<Scalars['String']['input']>;
  credentials?: InputMaybe<Array<ProgramCredentialsCreateInput>>;
  dateCreated?: InputMaybe<Scalars['DateTime']['input']>;
  deadlineCompletion?: InputMaybe<Scalars['String']['input']>;
  deliveryModality?: InputMaybe<Scalars['String']['input']>;
  domain?: InputMaybe<Scalars['String']['input']>;
  embedded_descriptor?: InputMaybe<Scalars['String']['input']>;
  embeddings?: InputMaybe<ProgramCreateembeddingsInput>;
  file_draft?: InputMaybe<Scalars['Boolean']['input']>;
  flippedDescription?: InputMaybe<Scalars['String']['input']>;
  flippedPresentation?: InputMaybe<Scalars['String']['input']>;
  flippedRegistration?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  industries?: InputMaybe<ProgramCreateindustriesInput>;
  isChennelCreated?: InputMaybe<Scalars['Boolean']['input']>;
  isLastModifiedAtExists?: InputMaybe<Scalars['Boolean']['input']>;
  isProgramSchemaAdded?: InputMaybe<Scalars['Boolean']['input']>;
  isPublic?: InputMaybe<Scalars['Boolean']['input']>;
  isSaveAdkMoleculeAdded?: InputMaybe<Scalars['Boolean']['input']>;
  isShowTimer?: InputMaybe<Scalars['Boolean']['input']>;
  isUniqueFieldIdAdded?: InputMaybe<Scalars['Boolean']['input']>;
  isUniqueIdAdded?: InputMaybe<Scalars['Boolean']['input']>;
  isUnsponsoredProgram?: InputMaybe<Scalars['Boolean']['input']>;
  isUpdateOrg?: InputMaybe<Scalars['Boolean']['input']>;
  isUpdateParticipants?: InputMaybe<Scalars['Boolean']['input']>;
  keywords?: InputMaybe<ProgramCreatekeywordsInput>;
  lastSaved?: InputMaybe<Scalars['DateTime']['input']>;
  last_synced_at?: InputMaybe<Scalars['JSON']['input']>;
  licensed?: InputMaybe<Scalars['JSON']['input']>;
  locations?: InputMaybe<Array<ProgramLocationCreateInput>>;
  metaData?: InputMaybe<ProgramMetaDataNullableCreateEnvelopeInput>;
  organizationId?: InputMaybe<Scalars['String']['input']>;
  organizationName?: InputMaybe<Scalars['String']['input']>;
  organizers?: InputMaybe<Array<ProgramOrganizersCreateInput>>;
  originalProgramId?: InputMaybe<Scalars['JSON']['input']>;
  participants?: InputMaybe<Scalars['JSON']['input']>;
  pathways?: InputMaybe<ProgramCreatepathwaysInput>;
  programDesc?: InputMaybe<Scalars['String']['input']>;
  programDesignId?: InputMaybe<Scalars['String']['input']>;
  programImage?: InputMaybe<Scalars['String']['input']>;
  programKeywords?: InputMaybe<Scalars['JSON']['input']>;
  programName?: InputMaybe<Scalars['String']['input']>;
  programPrice?: InputMaybe<Scalars['String']['input']>;
  program_schema?: InputMaybe<Array<ProgramProgramSchemaCreateInput>>;
  program_schema_id?: InputMaybe<Scalars['String']['input']>;
  public_url?: InputMaybe<Scalars['String']['input']>;
  published?: InputMaybe<Scalars['Boolean']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  requiredResidency?: InputMaybe<Scalars['JSON']['input']>;
  requiredSkills?: InputMaybe<Scalars['JSON']['input']>;
  requiredTech?: InputMaybe<ProgramCreaterequiredTechInput>;
  resourceWeb?: InputMaybe<Scalars['String']['input']>;
  reward?: InputMaybe<Scalars['JSON']['input']>;
  rewardPresets?: InputMaybe<ProgramCreaterewardPresetsInput>;
  rewards?: InputMaybe<Scalars['JSON']['input']>;
  selectedDistrict?: InputMaybe<Scalars['JSON']['input']>;
  sharable_url?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  socCodes?: InputMaybe<ProgramCreatesocCodesInput>;
  start_activity_status?: InputMaybe<Scalars['String']['input']>;
  templateId?: InputMaybe<Scalars['String']['input']>;
  templateImage?: InputMaybe<Scalars['JSON']['input']>;
  templateName?: InputMaybe<Scalars['String']['input']>;
  timeConfig?: InputMaybe<ProgramTimeConfigNullableCreateEnvelopeInput>;
  timerType?: InputMaybe<Scalars['String']['input']>;
  tokens?: InputMaybe<Scalars['Int']['input']>;
  tokensRange?: InputMaybe<ProgramTokensRangeNullableCreateEnvelopeInput>;
  unsponsoredAdk?: InputMaybe<Scalars['String']['input']>;
  videoAskShareId?: InputMaybe<Scalars['String']['input']>;
  visibility?: InputMaybe<Scalars['String']['input']>;
  walletTransactions?: InputMaybe<WalletTransactionCreateNestedManyWithoutProgramInput>;
};

export type ProgramCreateWithoutWalletTransactionsInput = {
  activityNotification?: InputMaybe<Scalars['Boolean']['input']>;
  adks?: InputMaybe<Array<ProgramAdksCreateInput>>;
  ageRange?: InputMaybe<Scalars['JSON']['input']>;
  airtable?: InputMaybe<Array<ProgramAirtableCreateInput>>;
  airtable_link?: InputMaybe<Scalars['String']['input']>;
  categories?: InputMaybe<Array<ProgramCategoriesCreateInput>>;
  checkoutQualification?: InputMaybe<ProgramCheckoutQualificationNullableCreateEnvelopeInput>;
  colors?: InputMaybe<Scalars['String']['input']>;
  compilationStatus?: InputMaybe<Scalars['String']['input']>;
  createdBy?: InputMaybe<Scalars['JSON']['input']>;
  creationMode?: InputMaybe<Scalars['String']['input']>;
  credentials?: InputMaybe<Array<ProgramCredentialsCreateInput>>;
  dateCreated?: InputMaybe<Scalars['DateTime']['input']>;
  deadlineCompletion?: InputMaybe<Scalars['String']['input']>;
  deliveryModality?: InputMaybe<Scalars['String']['input']>;
  domain?: InputMaybe<Scalars['String']['input']>;
  embedded_descriptor?: InputMaybe<Scalars['String']['input']>;
  embeddings?: InputMaybe<ProgramCreateembeddingsInput>;
  file_draft?: InputMaybe<Scalars['Boolean']['input']>;
  flippedDescription?: InputMaybe<Scalars['String']['input']>;
  flippedPresentation?: InputMaybe<Scalars['String']['input']>;
  flippedRegistration?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  industries?: InputMaybe<ProgramCreateindustriesInput>;
  isChennelCreated?: InputMaybe<Scalars['Boolean']['input']>;
  isLastModifiedAtExists?: InputMaybe<Scalars['Boolean']['input']>;
  isProgramSchemaAdded?: InputMaybe<Scalars['Boolean']['input']>;
  isPublic?: InputMaybe<Scalars['Boolean']['input']>;
  isSaveAdkMoleculeAdded?: InputMaybe<Scalars['Boolean']['input']>;
  isShowTimer?: InputMaybe<Scalars['Boolean']['input']>;
  isUniqueFieldIdAdded?: InputMaybe<Scalars['Boolean']['input']>;
  isUniqueIdAdded?: InputMaybe<Scalars['Boolean']['input']>;
  isUnsponsoredProgram?: InputMaybe<Scalars['Boolean']['input']>;
  isUpdateOrg?: InputMaybe<Scalars['Boolean']['input']>;
  isUpdateParticipants?: InputMaybe<Scalars['Boolean']['input']>;
  keywords?: InputMaybe<ProgramCreatekeywordsInput>;
  lastSaved?: InputMaybe<Scalars['DateTime']['input']>;
  last_synced_at?: InputMaybe<Scalars['JSON']['input']>;
  licensed?: InputMaybe<Scalars['JSON']['input']>;
  locations?: InputMaybe<Array<ProgramLocationCreateInput>>;
  metaData?: InputMaybe<ProgramMetaDataNullableCreateEnvelopeInput>;
  organizationId?: InputMaybe<Scalars['String']['input']>;
  organizationName?: InputMaybe<Scalars['String']['input']>;
  organizers?: InputMaybe<Array<ProgramOrganizersCreateInput>>;
  originalProgramId?: InputMaybe<Scalars['JSON']['input']>;
  participants?: InputMaybe<Scalars['JSON']['input']>;
  pathways?: InputMaybe<ProgramCreatepathwaysInput>;
  programDesc?: InputMaybe<Scalars['String']['input']>;
  programDesignId?: InputMaybe<Scalars['String']['input']>;
  programImage?: InputMaybe<Scalars['String']['input']>;
  programKeywords?: InputMaybe<Scalars['JSON']['input']>;
  programName?: InputMaybe<Scalars['String']['input']>;
  programPrice?: InputMaybe<Scalars['String']['input']>;
  program_schema?: InputMaybe<Array<ProgramProgramSchemaCreateInput>>;
  program_schema_id?: InputMaybe<Scalars['String']['input']>;
  public_url?: InputMaybe<Scalars['String']['input']>;
  published?: InputMaybe<Scalars['Boolean']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  requiredResidency?: InputMaybe<Scalars['JSON']['input']>;
  requiredSkills?: InputMaybe<Scalars['JSON']['input']>;
  requiredTech?: InputMaybe<ProgramCreaterequiredTechInput>;
  resourceWeb?: InputMaybe<Scalars['String']['input']>;
  reward?: InputMaybe<Scalars['JSON']['input']>;
  rewardPresets?: InputMaybe<ProgramCreaterewardPresetsInput>;
  rewards?: InputMaybe<Scalars['JSON']['input']>;
  selectedDistrict?: InputMaybe<Scalars['JSON']['input']>;
  sharable_url?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  socCodes?: InputMaybe<ProgramCreatesocCodesInput>;
  start_activity_status?: InputMaybe<Scalars['String']['input']>;
  studentWalletTransactions?: InputMaybe<StudentWalletTransactionCreateNestedManyWithoutProgramInput>;
  templateId?: InputMaybe<Scalars['String']['input']>;
  templateImage?: InputMaybe<Scalars['JSON']['input']>;
  templateName?: InputMaybe<Scalars['String']['input']>;
  timeConfig?: InputMaybe<ProgramTimeConfigNullableCreateEnvelopeInput>;
  timerType?: InputMaybe<Scalars['String']['input']>;
  tokens?: InputMaybe<Scalars['Int']['input']>;
  tokensRange?: InputMaybe<ProgramTokensRangeNullableCreateEnvelopeInput>;
  unsponsoredAdk?: InputMaybe<Scalars['String']['input']>;
  videoAskShareId?: InputMaybe<Scalars['String']['input']>;
  visibility?: InputMaybe<Scalars['String']['input']>;
};

export type ProgramCreateembeddingsInput = {
  set: Array<Scalars['Float']['input']>;
};

export type ProgramCreateindustriesInput = {
  set: Array<Scalars['String']['input']>;
};

export type ProgramCreatekeywordsInput = {
  set: Array<Scalars['String']['input']>;
};

export type ProgramCreatepathwaysInput = {
  set: Array<Scalars['String']['input']>;
};

export type ProgramCreaterequiredTechInput = {
  set: Array<Scalars['String']['input']>;
};

export type ProgramCreaterewardPresetsInput = {
  set: Array<Scalars['String']['input']>;
};

export type ProgramCreatesocCodesInput = {
  set: Array<Scalars['String']['input']>;
};

export type ProgramCredentials = {
  __typename?: 'ProgramCredentials';
  activities?: Maybe<Array<Scalars['String']['output']>>;
  credentials?: Maybe<Array<Scalars['String']['output']>>;
  id: Scalars['Int']['output'];
};

export type ProgramCredentialsCreateInput = {
  activities?: InputMaybe<ProgramCredentialsCreateactivitiesInput>;
  credentials?: InputMaybe<ProgramCredentialsCreatecredentialsInput>;
  id: Scalars['Int']['input'];
};

export type ProgramCredentialsCreateactivitiesInput = {
  set: Array<Scalars['String']['input']>;
};

export type ProgramCredentialsCreatecredentialsInput = {
  set: Array<Scalars['String']['input']>;
};

export type ProgramCredentialsObjectEqualityInput = {
  activities?: InputMaybe<Array<Scalars['String']['input']>>;
  credentials?: InputMaybe<Array<Scalars['String']['input']>>;
  id: Scalars['Int']['input'];
};

/**
 * ProgramDesign captures the strategic blueprint for a program, grounded in the Program Logic Model.
 * Created during AI interview, persisted as a shareable/forkable design document.
 */
export type ProgramDesign = {
  __typename?: 'ProgramDesign';
  activities?: Maybe<Array<ProgramDesignActivity>>;
  /** AI co-pilot configuration from AIPC interview */
  aiConfig?: Maybe<ProgramDesignAiConfig>;
  /** AI-inferred + creator-confirmed conditions that must be true for program to succeed */
  assumptions?: Maybe<Array<Scalars['String']['output']>>;
  cadence?: Maybe<Scalars['String']['output']>;
  /** Program constitution: guiding principles for all AI behavior */
  constitution?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['String']['output'];
  /** Interview thread that produced this design */
  createdFromThreadId?: Maybe<Scalars['String']['output']>;
  /** Program-level delivery mode: online | in-person | hybrid */
  deliveryModality?: Maybe<Scalars['String']['output']>;
  description: Scalars['String']['output'];
  /** The big-picture outcome vision — what participants BECOME */
  desiredTransformation?: Maybe<Scalars['String']['output']>;
  duration?: Maybe<Scalars['String']['output']>;
  endDate?: Maybe<Scalars['DateTime']['output']>;
  /** Overall evaluation methodology */
  evaluationPlan?: Maybe<ProgramDesignEvaluationPlan>;
  /** Conditions beyond program control that may affect outcomes */
  externalFactors?: Maybe<Array<Scalars['String']['output']>>;
  /** If forked from another design */
  forkedFromId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /** Long-term condition changes at program level (social, economic, civic) */
  impactOutcomes?: Maybe<Array<ProgramDesignImpactOutcome>>;
  /** Program-level resources needed (staff, materials, technology, content, spaces, partners) */
  inputs?: Maybe<Array<ProgramDesignInput>>;
  /**
   * Physical sites captured during AI interview when modality is in-person/hybrid.
   * Threaded into Program.locations on program creation.
   */
  locations?: Maybe<Array<ProgramLocation>>;
  mission?: Maybe<Scalars['String']['output']>;
  organizationId?: Maybe<Scalars['String']['output']>;
  /** Phase name for ecosystem timeline grouping (e.g., "Phase 1: Activate") */
  phase?: Maybe<Scalars['String']['output']>;
  /** Program-level synchronicity: synchronous | asynchronous | blended */
  primarySyncMode?: Maybe<Scalars['String']['output']>;
  /** Fidelity indicators — did we execute the plan as designed? */
  processIndicators?: Maybe<Array<ProgramDesignProcessIndicator>>;
  programArc?: Maybe<Scalars['String']['output']>;
  /** Program created from this design (one-to-one) */
  programId?: Maybe<Scalars['String']['output']>;
  programName: Scalars['String']['output'];
  programVibe?: Maybe<Scalars['String']['output']>;
  /** Structured resources detected during interview (URLs, platform handles, tools) */
  resources?: Maybe<Array<ProgramDesignResource>>;
  /** Structured schedule configuration for timeline rendering + program creation */
  schedule?: Maybe<ProgramDesignSchedule>;
  signatureMoment?: Maybe<Scalars['String']['output']>;
  /** The problem, need, or opportunity this program addresses */
  situation?: Maybe<Scalars['String']['output']>;
  startDate?: Maybe<Scalars['DateTime']['output']>;
  /** draft | approved | program-created */
  status: Scalars['String']['output'];
  /** Outcome indicators — what changed in participants? */
  successMetrics?: Maybe<Array<ProgramDesignSuccessMetric>>;
  targetParticipants?: Maybe<Scalars['String']['output']>;
  /** AI-generated narrative: "This program works because..." */
  theoryOfChange?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

/** Born-Intelligent Programs: AI co-pilot configuration from AIPC interview */
export type ProgramDesignAiConfig = {
  __typename?: 'ProgramDesignAIConfig';
  channels?: Maybe<Array<Scalars['String']['output']>>;
  deadlineBehavior?: Maybe<Scalars['String']['output']>;
  enabled: Scalars['Boolean']['output'];
  engagementStyle?: Maybe<Scalars['String']['output']>;
  /** Graduated dial ceiling: max participation level allowed */
  participationCeiling?: Maybe<Scalars['String']['output']>;
  personaId?: Maybe<Scalars['String']['output']>;
};

export type ProgramDesignActivity = {
  __typename?: 'ProgramDesignActivity';
  customDescription?: Maybe<Scalars['String']['output']>;
  deliverables?: Maybe<Array<Scalars['String']['output']>>;
  isSynchronous?: Maybe<Scalars['Boolean']['output']>;
  isTeamAdk?: Maybe<Scalars['Boolean']['output']>;
  /** online | in-person | hybrid */
  modality?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  outcomes?: Maybe<Array<ProgramDesignOutcome>>;
  /** WHY this activity exists — its role in achieving program outcomes */
  purpose: Scalars['String']['output'];
  requiredInputs?: Maybe<Array<ProgramDesignInput>>;
  /** "opening hook" | "skill-building core" | "culminating capstone" */
  roleInArc?: Maybe<Scalars['String']['output']>;
  standardWidget?: Maybe<Scalars['String']['output']>;
  /** custom | standard */
  widgetType?: Maybe<Scalars['String']['output']>;
};

export type ProgramDesignCountAggregate = {
  __typename?: 'ProgramDesignCountAggregate';
  _all: Scalars['Int']['output'];
  assumptions: Scalars['Int']['output'];
  cadence: Scalars['Int']['output'];
  constitution: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  createdBy: Scalars['Int']['output'];
  createdFromThreadId: Scalars['Int']['output'];
  deliveryModality: Scalars['Int']['output'];
  description: Scalars['Int']['output'];
  desiredTransformation: Scalars['Int']['output'];
  duration: Scalars['Int']['output'];
  endDate: Scalars['Int']['output'];
  externalFactors: Scalars['Int']['output'];
  forkedFromId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  mission: Scalars['Int']['output'];
  organizationId: Scalars['Int']['output'];
  phase: Scalars['Int']['output'];
  primarySyncMode: Scalars['Int']['output'];
  programArc: Scalars['Int']['output'];
  programId: Scalars['Int']['output'];
  programName: Scalars['Int']['output'];
  programVibe: Scalars['Int']['output'];
  signatureMoment: Scalars['Int']['output'];
  situation: Scalars['Int']['output'];
  startDate: Scalars['Int']['output'];
  status: Scalars['Int']['output'];
  targetParticipants: Scalars['Int']['output'];
  theoryOfChange: Scalars['Int']['output'];
  updatedAt: Scalars['Int']['output'];
};

export type ProgramDesignEvaluationPlan = {
  __typename?: 'ProgramDesignEvaluationPlan';
  /** e.g. ["After Activity 3", "Program completion", "30-day follow-up"] */
  dataCollectionPoints?: Maybe<Array<Scalars['String']['output']>>;
  /** e.g. "Mixed methods: rubric scores + participant reflection journals" */
  methodology?: Maybe<Scalars['String']['output']>;
  /** e.g. "Participants self-assess via post-activity Journal entries" */
  participantRole?: Maybe<Scalars['String']['output']>;
};

export type ProgramDesignImpactOutcome = {
  __typename?: 'ProgramDesignImpactOutcome';
  description?: Maybe<Scalars['String']['output']>;
  /** e.g. "Increased workforce readiness in community" */
  name: Scalars['String']['output'];
  /** Always "long-term" for impact outcomes */
  tier: Scalars['String']['output'];
};

export type ProgramDesignInput = {
  __typename?: 'ProgramDesignInput';
  /** What AI provided (if auto-filled) */
  autoFilledValue?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  /** Whether the AI auto-filled this input */
  isAutoFilled: Scalars['Boolean']['output'];
  /** e.g. "Guest speaker contact", "Video link", "Rubric document" */
  name: Scalars['String']['output'];
  /** How central this resource is: foundational | important | supplementary */
  significance?: Maybe<Scalars['String']['output']>;
  /** staff | material | technology | content | space | partner */
  type: Scalars['String']['output'];
};

export type ProgramDesignMaxAggregate = {
  __typename?: 'ProgramDesignMaxAggregate';
  cadence?: Maybe<Scalars['String']['output']>;
  constitution?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  createdFromThreadId?: Maybe<Scalars['String']['output']>;
  deliveryModality?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  desiredTransformation?: Maybe<Scalars['String']['output']>;
  duration?: Maybe<Scalars['String']['output']>;
  endDate?: Maybe<Scalars['DateTime']['output']>;
  forkedFromId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  mission?: Maybe<Scalars['String']['output']>;
  organizationId?: Maybe<Scalars['String']['output']>;
  phase?: Maybe<Scalars['String']['output']>;
  primarySyncMode?: Maybe<Scalars['String']['output']>;
  programArc?: Maybe<Scalars['String']['output']>;
  programId?: Maybe<Scalars['String']['output']>;
  programName?: Maybe<Scalars['String']['output']>;
  programVibe?: Maybe<Scalars['String']['output']>;
  signatureMoment?: Maybe<Scalars['String']['output']>;
  situation?: Maybe<Scalars['String']['output']>;
  startDate?: Maybe<Scalars['DateTime']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  targetParticipants?: Maybe<Scalars['String']['output']>;
  theoryOfChange?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type ProgramDesignMinAggregate = {
  __typename?: 'ProgramDesignMinAggregate';
  cadence?: Maybe<Scalars['String']['output']>;
  constitution?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  createdFromThreadId?: Maybe<Scalars['String']['output']>;
  deliveryModality?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  desiredTransformation?: Maybe<Scalars['String']['output']>;
  duration?: Maybe<Scalars['String']['output']>;
  endDate?: Maybe<Scalars['DateTime']['output']>;
  forkedFromId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  mission?: Maybe<Scalars['String']['output']>;
  organizationId?: Maybe<Scalars['String']['output']>;
  phase?: Maybe<Scalars['String']['output']>;
  primarySyncMode?: Maybe<Scalars['String']['output']>;
  programArc?: Maybe<Scalars['String']['output']>;
  programId?: Maybe<Scalars['String']['output']>;
  programName?: Maybe<Scalars['String']['output']>;
  programVibe?: Maybe<Scalars['String']['output']>;
  signatureMoment?: Maybe<Scalars['String']['output']>;
  situation?: Maybe<Scalars['String']['output']>;
  startDate?: Maybe<Scalars['DateTime']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  targetParticipants?: Maybe<Scalars['String']['output']>;
  theoryOfChange?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type ProgramDesignOutcome = {
  __typename?: 'ProgramDesignOutcome';
  description?: Maybe<Scalars['String']['output']>;
  /** e.g. "Career articulation skills" */
  name: Scalars['String']['output'];
  /** Causal reasoning: "Because practicing elevator pitches with peer feedback builds confidence" */
  rationale?: Maybe<Scalars['String']['output']>;
  /** Links to ProgramDesignSuccessMetric.metricId */
  successMetricId: Scalars['String']['output'];
  /** short-term | intermediate */
  tier: Scalars['String']['output'];
};

/**
 * Process indicators track implementation fidelity — did we do what we planned?
 * PLM best practice: if outcomes aren't met, process indicators diagnose WHY
 * (theory failure vs. implementation failure)
 */
export type ProgramDesignProcessIndicator = {
  __typename?: 'ProgramDesignProcessIndicator';
  description?: Maybe<Scalars['String']['output']>;
  /** e.g. "Activity completion rate", "Mentor session attendance" */
  name: Scalars['String']['output'];
  /** e.g. ">= 80% of participants complete all activities" */
  targetThreshold?: Maybe<Scalars['String']['output']>;
};

export type ProgramDesignResource = {
  __typename?: 'ProgramDesignResource';
  /** Creator's intent: "students watch and respond to this video" */
  intent?: Maybe<Scalars['String']['output']>;
  /** How central this resource is: foundational | important | supplementary */
  significance?: Maybe<Scalars['String']['output']>;
  /** Which activities should use this resource */
  targetActivities?: Maybe<Array<Scalars['String']['output']>>;
  /** The resource URL (normalized) */
  url: Scalars['String']['output'];
};

/**
 * Comprehensive scheduling configuration for a program design.
 * Replaces free-text "duration" with structured fields that drive
 * timeline rendering, display labels, and Program creation.
 */
export type ProgramDesignSchedule = {
  __typename?: 'ProgramDesignSchedule';
  /**
   * How often events occur
   * weekly | biweekly | monthly | quarterly | annual
   */
  cadence?: Maybe<Scalars['String']['output']>;
  /** For cohort-based: how long each cohort runs: { value: 12, unit: "weeks" } */
  cohortDuration?: Maybe<Duration>;
  /**
   * Deadline enforcement level
   * soft | hard
   */
  deadlineType?: Maybe<Scalars['String']['output']>;
  endDate?: Maybe<Scalars['DateTime']['output']>;
  /** How many times per cadence period (default 1). "3x/week" = weekly + 3 */
  frequencyPerCadence?: Maybe<Scalars['Int']['output']>;
  /**
   * How structured is the pacing?
   * self-paced | scheduled | cohort
   */
  pacingMode?: Maybe<Scalars['String']['output']>;
  /**
   * What kind of scheduling pattern?
   * one-time | recurring | cohort | ongoing
   */
  scheduleType?: Maybe<Scalars['String']['output']>;
  /** How long each occurrence lasts: { value: 2, unit: "hours" } */
  sessionDuration?: Maybe<Duration>;
  /** Calendar boundaries */
  startDate?: Maybe<Scalars['DateTime']['output']>;
  /** Alternative to endDate: program ends after N sessions */
  totalSessions?: Maybe<Scalars['Int']['output']>;
};

export type ProgramDesignSuccessMetric = {
  __typename?: 'ProgramDesignSuccessMetric';
  /** Which widget/activity provides the data */
  dataSource?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  /** e.g. "Scored 1-5 rubric evaluated by mentor" */
  measurementMethod?: Maybe<Scalars['String']['output']>;
  /** UUID for cross-referencing from activity outcomes */
  metricId: Scalars['String']['output'];
  /** e.g. "Career Articulation Proficiency" */
  name: Scalars['String']['output'];
  /** e.g. "Score >= 3 out of 5" */
  targetThreshold?: Maybe<Scalars['String']['output']>;
  /** short-term | intermediate | long-term */
  tier: Scalars['String']['output'];
  /** rubric | portfolio | quiz | demonstration | peer-feedback | self-assessment | journal */
  type: Scalars['String']['output'];
};

export type ProgramEdge = {
  __typename?: 'ProgramEdge';
  /** Cursor for this program edge */
  cursor: Scalars['String']['output'];
  node: Program;
};

export type ProgramFilterInput = {
  /** Filter by age range */
  ageRange?: InputMaybe<Scalars['JSON']['input']>;
  /** Filter by industries */
  industries?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Filter by public accessibility */
  isPublic?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by keywords */
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Filter by organizer user ID */
  organizerId?: InputMaybe<Scalars['String']['input']>;
  /** Filter by pathways */
  pathways?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Filter by published status */
  published?: InputMaybe<Scalars['Boolean']['input']>;
  /** Full-text search across program name, description, and keywords */
  search?: InputMaybe<Scalars['String']['input']>;
  /** Filter by sponsor template names - only return templates matching these names */
  sponsorTemplateNames?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Filter by template ID */
  templateId?: InputMaybe<Scalars['String']['input']>;
};

export type ProgramGroundingTag = {
  __typename?: 'ProgramGroundingTag';
  /** Human-readable label (e.g., "Marketing Managers") */
  displayLabel: Scalars['String']['output'];
  /** Source kind, e.g., "workforce" */
  kind: Scalars['String']['output'];
  /** Link key (e.g., SOC code "11-2021") */
  linkKey: Scalars['String']['output'];
};

/**
 * Embedded geocoded place used by Program.locations[], ProgramDesign.locations[], and Organization.address.
 * UI requires Google Places autocomplete for entry, so coords are populated in normal flow.
 * Coords are nullable to tolerate edge cases (legacy/manual edits); renderers skip pins missing coords.
 */
export type ProgramLocation = {
  __typename?: 'ProgramLocation';
  /** Parsed address components from the Google Places result (display + future region filtering) */
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  countryCode?: Maybe<Scalars['String']['output']>;
  /** Full geocoded address from Google Places — the only required field */
  formattedAddress: Scalars['String']['output'];
  /** "exact" | "city_level" | "state_level" | "failed" */
  geocodeConfidence?: Maybe<Scalars['String']['output']>;
  /** "user_input" only in v1 */
  geocodeSource?: Maybe<Scalars['String']['output']>;
  geocodedAt?: Maybe<Scalars['DateTime']['output']>;
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  /** Optional human-readable label (e.g., "Acme HQ Conference Room") */
  name?: Maybe<Scalars['String']['output']>;
  /** Google Places ID — lets us re-fetch the canonical place if needed */
  placeId?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  stateCode?: Maybe<Scalars['String']['output']>;
};

export type ProgramLocationCreateInput = {
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  countryCode?: InputMaybe<Scalars['String']['input']>;
  formattedAddress: Scalars['String']['input'];
  geocodeConfidence?: InputMaybe<Scalars['String']['input']>;
  geocodeSource?: InputMaybe<Scalars['String']['input']>;
  geocodedAt?: InputMaybe<Scalars['DateTime']['input']>;
  lat?: InputMaybe<Scalars['Float']['input']>;
  lng?: InputMaybe<Scalars['Float']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  placeId?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  stateCode?: InputMaybe<Scalars['String']['input']>;
};

export type ProgramLocationObjectEqualityInput = {
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  countryCode?: InputMaybe<Scalars['String']['input']>;
  formattedAddress: Scalars['String']['input'];
  geocodeConfidence?: InputMaybe<Scalars['String']['input']>;
  geocodeSource?: InputMaybe<Scalars['String']['input']>;
  geocodedAt?: InputMaybe<Scalars['DateTime']['input']>;
  lat?: InputMaybe<Scalars['Float']['input']>;
  lng?: InputMaybe<Scalars['Float']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  placeId?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  stateCode?: InputMaybe<Scalars['String']['input']>;
};

export type ProgramMaxAggregate = {
  __typename?: 'ProgramMaxAggregate';
  activityNotification?: Maybe<Scalars['Boolean']['output']>;
  airtable_link?: Maybe<Scalars['String']['output']>;
  colors?: Maybe<Scalars['String']['output']>;
  compilationStatus?: Maybe<Scalars['String']['output']>;
  creationMode?: Maybe<Scalars['String']['output']>;
  dateCreated?: Maybe<Scalars['DateTime']['output']>;
  deadlineCompletion?: Maybe<Scalars['String']['output']>;
  deliveryModality?: Maybe<Scalars['String']['output']>;
  domain?: Maybe<Scalars['String']['output']>;
  embedded_descriptor?: Maybe<Scalars['String']['output']>;
  file_draft?: Maybe<Scalars['Boolean']['output']>;
  flippedDescription?: Maybe<Scalars['String']['output']>;
  flippedPresentation?: Maybe<Scalars['String']['output']>;
  flippedRegistration?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  isChennelCreated?: Maybe<Scalars['Boolean']['output']>;
  isLastModifiedAtExists?: Maybe<Scalars['Boolean']['output']>;
  isProgramSchemaAdded?: Maybe<Scalars['Boolean']['output']>;
  isPublic?: Maybe<Scalars['Boolean']['output']>;
  isSaveAdkMoleculeAdded?: Maybe<Scalars['Boolean']['output']>;
  isShowTimer?: Maybe<Scalars['Boolean']['output']>;
  isUniqueFieldIdAdded?: Maybe<Scalars['Boolean']['output']>;
  isUniqueIdAdded?: Maybe<Scalars['Boolean']['output']>;
  isUnsponsoredProgram?: Maybe<Scalars['Boolean']['output']>;
  isUpdateOrg?: Maybe<Scalars['Boolean']['output']>;
  isUpdateParticipants?: Maybe<Scalars['Boolean']['output']>;
  lastSaved?: Maybe<Scalars['DateTime']['output']>;
  organizationId?: Maybe<Scalars['String']['output']>;
  organizationName?: Maybe<Scalars['String']['output']>;
  programDesc?: Maybe<Scalars['String']['output']>;
  programDesignId?: Maybe<Scalars['String']['output']>;
  programImage?: Maybe<Scalars['String']['output']>;
  programName?: Maybe<Scalars['String']['output']>;
  programPrice?: Maybe<Scalars['String']['output']>;
  program_schema_id?: Maybe<Scalars['String']['output']>;
  public_url?: Maybe<Scalars['String']['output']>;
  published?: Maybe<Scalars['Boolean']['output']>;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  resourceWeb?: Maybe<Scalars['String']['output']>;
  sharable_url?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  start_activity_status?: Maybe<Scalars['String']['output']>;
  templateId?: Maybe<Scalars['String']['output']>;
  templateName?: Maybe<Scalars['String']['output']>;
  timerType?: Maybe<Scalars['String']['output']>;
  tokens?: Maybe<Scalars['Int']['output']>;
  unsponsoredAdk?: Maybe<Scalars['String']['output']>;
  videoAskShareId?: Maybe<Scalars['String']['output']>;
  visibility?: Maybe<Scalars['String']['output']>;
};

export type ProgramMetaData = {
  __typename?: 'ProgramMetaData';
  keywords?: Maybe<Array<Scalars['String']['output']>>;
  linkedinDesc: Scalars['String']['output'];
  /** Could not determine type: the field only had null or empty values in the sample set. */
  linkedinImage?: Maybe<Scalars['JSON']['output']>;
  linkedinTitle: Scalars['String']['output'];
  linkedinUrl: Scalars['String']['output'];
  metaDesc: Scalars['String']['output'];
  ogDesc: Scalars['String']['output'];
  /** Could not determine type: the field only had null or empty values in the sample set. */
  ogImage?: Maybe<Scalars['JSON']['output']>;
  ogTitle: Scalars['String']['output'];
  ogUrl: Scalars['String']['output'];
  tags?: Maybe<Array<Scalars['String']['output']>>;
  twitterDesc: Scalars['String']['output'];
  /** Could not determine type: the field only had null or empty values in the sample set. */
  twitterImage?: Maybe<Scalars['JSON']['output']>;
  twitterTitle: Scalars['String']['output'];
  twitterUrl: Scalars['String']['output'];
};

export type ProgramMetaDataCreateInput = {
  keywords?: InputMaybe<ProgramMetaDataCreatekeywordsInput>;
  linkedinDesc: Scalars['String']['input'];
  linkedinImage?: InputMaybe<Scalars['JSON']['input']>;
  linkedinTitle: Scalars['String']['input'];
  linkedinUrl: Scalars['String']['input'];
  metaDesc: Scalars['String']['input'];
  ogDesc: Scalars['String']['input'];
  ogImage?: InputMaybe<Scalars['JSON']['input']>;
  ogTitle: Scalars['String']['input'];
  ogUrl: Scalars['String']['input'];
  tags?: InputMaybe<ProgramMetaDataCreatetagsInput>;
  twitterDesc: Scalars['String']['input'];
  twitterImage?: InputMaybe<Scalars['JSON']['input']>;
  twitterTitle: Scalars['String']['input'];
  twitterUrl: Scalars['String']['input'];
};

export type ProgramMetaDataCreatekeywordsInput = {
  set: Array<Scalars['String']['input']>;
};

export type ProgramMetaDataCreatetagsInput = {
  set: Array<Scalars['String']['input']>;
};

export type ProgramMetaDataNullableCompositeFilter = {
  equals?: InputMaybe<ProgramMetaDataObjectEqualityInput>;
  is?: InputMaybe<ProgramMetaDataWhereInput>;
  isNot?: InputMaybe<ProgramMetaDataWhereInput>;
  isSet?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ProgramMetaDataNullableCreateEnvelopeInput = {
  set?: InputMaybe<ProgramMetaDataCreateInput>;
};

export type ProgramMetaDataNullableUpdateEnvelopeInput = {
  set?: InputMaybe<ProgramMetaDataCreateInput>;
  unset?: InputMaybe<Scalars['Boolean']['input']>;
  upsert?: InputMaybe<ProgramMetaDataUpsertInput>;
};

export type ProgramMetaDataObjectEqualityInput = {
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  linkedinDesc: Scalars['String']['input'];
  linkedinImage?: InputMaybe<Scalars['JSON']['input']>;
  linkedinTitle: Scalars['String']['input'];
  linkedinUrl: Scalars['String']['input'];
  metaDesc: Scalars['String']['input'];
  ogDesc: Scalars['String']['input'];
  ogImage?: InputMaybe<Scalars['JSON']['input']>;
  ogTitle: Scalars['String']['input'];
  ogUrl: Scalars['String']['input'];
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  twitterDesc: Scalars['String']['input'];
  twitterImage?: InputMaybe<Scalars['JSON']['input']>;
  twitterTitle: Scalars['String']['input'];
  twitterUrl: Scalars['String']['input'];
};

export type ProgramMetaDataUpdateInput = {
  keywords?: InputMaybe<ProgramMetaDataUpdatekeywordsInput>;
  linkedinDesc?: InputMaybe<StringFieldUpdateOperationsInput>;
  linkedinImage?: InputMaybe<Scalars['JSON']['input']>;
  linkedinTitle?: InputMaybe<StringFieldUpdateOperationsInput>;
  linkedinUrl?: InputMaybe<StringFieldUpdateOperationsInput>;
  metaDesc?: InputMaybe<StringFieldUpdateOperationsInput>;
  ogDesc?: InputMaybe<StringFieldUpdateOperationsInput>;
  ogImage?: InputMaybe<Scalars['JSON']['input']>;
  ogTitle?: InputMaybe<StringFieldUpdateOperationsInput>;
  ogUrl?: InputMaybe<StringFieldUpdateOperationsInput>;
  tags?: InputMaybe<ProgramMetaDataUpdatetagsInput>;
  twitterDesc?: InputMaybe<StringFieldUpdateOperationsInput>;
  twitterImage?: InputMaybe<Scalars['JSON']['input']>;
  twitterTitle?: InputMaybe<StringFieldUpdateOperationsInput>;
  twitterUrl?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type ProgramMetaDataUpdatekeywordsInput = {
  push?: InputMaybe<Array<Scalars['String']['input']>>;
  set?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type ProgramMetaDataUpdatetagsInput = {
  push?: InputMaybe<Array<Scalars['String']['input']>>;
  set?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type ProgramMetaDataUpsertInput = {
  set: ProgramMetaDataCreateInput;
  update: ProgramMetaDataUpdateInput;
};

export type ProgramMetaDataWhereInput = {
  AND?: InputMaybe<Array<ProgramMetaDataWhereInput>>;
  NOT?: InputMaybe<Array<ProgramMetaDataWhereInput>>;
  OR?: InputMaybe<Array<ProgramMetaDataWhereInput>>;
  keywords?: InputMaybe<StringNullableListFilter>;
  linkedinDesc?: InputMaybe<StringFilter>;
  linkedinImage?: InputMaybe<JsonNullableFilter>;
  linkedinTitle?: InputMaybe<StringFilter>;
  linkedinUrl?: InputMaybe<StringFilter>;
  metaDesc?: InputMaybe<StringFilter>;
  ogDesc?: InputMaybe<StringFilter>;
  ogImage?: InputMaybe<JsonNullableFilter>;
  ogTitle?: InputMaybe<StringFilter>;
  ogUrl?: InputMaybe<StringFilter>;
  tags?: InputMaybe<StringNullableListFilter>;
  twitterDesc?: InputMaybe<StringFilter>;
  twitterImage?: InputMaybe<JsonNullableFilter>;
  twitterTitle?: InputMaybe<StringFilter>;
  twitterUrl?: InputMaybe<StringFilter>;
};

export type ProgramMinAggregate = {
  __typename?: 'ProgramMinAggregate';
  activityNotification?: Maybe<Scalars['Boolean']['output']>;
  airtable_link?: Maybe<Scalars['String']['output']>;
  colors?: Maybe<Scalars['String']['output']>;
  compilationStatus?: Maybe<Scalars['String']['output']>;
  creationMode?: Maybe<Scalars['String']['output']>;
  dateCreated?: Maybe<Scalars['DateTime']['output']>;
  deadlineCompletion?: Maybe<Scalars['String']['output']>;
  deliveryModality?: Maybe<Scalars['String']['output']>;
  domain?: Maybe<Scalars['String']['output']>;
  embedded_descriptor?: Maybe<Scalars['String']['output']>;
  file_draft?: Maybe<Scalars['Boolean']['output']>;
  flippedDescription?: Maybe<Scalars['String']['output']>;
  flippedPresentation?: Maybe<Scalars['String']['output']>;
  flippedRegistration?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  isChennelCreated?: Maybe<Scalars['Boolean']['output']>;
  isLastModifiedAtExists?: Maybe<Scalars['Boolean']['output']>;
  isProgramSchemaAdded?: Maybe<Scalars['Boolean']['output']>;
  isPublic?: Maybe<Scalars['Boolean']['output']>;
  isSaveAdkMoleculeAdded?: Maybe<Scalars['Boolean']['output']>;
  isShowTimer?: Maybe<Scalars['Boolean']['output']>;
  isUniqueFieldIdAdded?: Maybe<Scalars['Boolean']['output']>;
  isUniqueIdAdded?: Maybe<Scalars['Boolean']['output']>;
  isUnsponsoredProgram?: Maybe<Scalars['Boolean']['output']>;
  isUpdateOrg?: Maybe<Scalars['Boolean']['output']>;
  isUpdateParticipants?: Maybe<Scalars['Boolean']['output']>;
  lastSaved?: Maybe<Scalars['DateTime']['output']>;
  organizationId?: Maybe<Scalars['String']['output']>;
  organizationName?: Maybe<Scalars['String']['output']>;
  programDesc?: Maybe<Scalars['String']['output']>;
  programDesignId?: Maybe<Scalars['String']['output']>;
  programImage?: Maybe<Scalars['String']['output']>;
  programName?: Maybe<Scalars['String']['output']>;
  programPrice?: Maybe<Scalars['String']['output']>;
  program_schema_id?: Maybe<Scalars['String']['output']>;
  public_url?: Maybe<Scalars['String']['output']>;
  published?: Maybe<Scalars['Boolean']['output']>;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  resourceWeb?: Maybe<Scalars['String']['output']>;
  sharable_url?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  start_activity_status?: Maybe<Scalars['String']['output']>;
  templateId?: Maybe<Scalars['String']['output']>;
  templateName?: Maybe<Scalars['String']['output']>;
  timerType?: Maybe<Scalars['String']['output']>;
  tokens?: Maybe<Scalars['Int']['output']>;
  unsponsoredAdk?: Maybe<Scalars['String']['output']>;
  videoAskShareId?: Maybe<Scalars['String']['output']>;
  visibility?: Maybe<Scalars['String']['output']>;
};

export type ProgramOrderByInput = {
  /** Field to sort by */
  field: ProgramSortField;
  /** Sort order direction */
  order: SortOrder;
};

export type ProgramOrganizers = {
  __typename?: 'ProgramOrganizers';
  googleDetails?: Maybe<ProgramOrganizersGoogleDetails>;
  type?: Maybe<Scalars['String']['output']>;
  /** MongoDB ObjectId reference to User collection (id field) */
  userId?: Maybe<Scalars['String']['output']>;
};

export type ProgramOrganizersCreateInput = {
  googleDetails?: InputMaybe<ProgramOrganizersGoogleDetailsCreateInput>;
  type?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type ProgramOrganizersGoogleDetails = {
  __typename?: 'ProgramOrganizersGoogleDetails';
  access_token: Scalars['String']['output'];
  email: Scalars['String']['output'];
  expiry_date: Scalars['Float']['output'];
  id_token: Scalars['String']['output'];
  refresh_token: Scalars['String']['output'];
  scope: Scalars['String']['output'];
  token_type: Scalars['String']['output'];
};

export type ProgramOrganizersGoogleDetailsCreateInput = {
  access_token: Scalars['String']['input'];
  email: Scalars['String']['input'];
  expiry_date: Scalars['Float']['input'];
  id_token: Scalars['String']['input'];
  refresh_token: Scalars['String']['input'];
  scope: Scalars['String']['input'];
  token_type: Scalars['String']['input'];
};

export type ProgramOrganizersGoogleDetailsObjectEqualityInput = {
  access_token: Scalars['String']['input'];
  email: Scalars['String']['input'];
  expiry_date: Scalars['Float']['input'];
  id_token: Scalars['String']['input'];
  refresh_token: Scalars['String']['input'];
  scope: Scalars['String']['input'];
  token_type: Scalars['String']['input'];
};

export type ProgramOrganizersObjectEqualityInput = {
  googleDetails?: InputMaybe<ProgramOrganizersGoogleDetailsObjectEqualityInput>;
  type?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type ProgramProgramSchema = {
  __typename?: 'ProgramProgramSchema';
  adks?: Maybe<Array<ProgramProgramSchemaAdks>>;
  id: Scalars['String']['output'];
};

export type ProgramProgramSchemaAdks = {
  __typename?: 'ProgramProgramSchemaAdks';
  buildScope?: Maybe<ProgramProgramSchemaAdksBuildScope>;
  category: Scalars['String']['output'];
  fields?: Maybe<Array<ProgramProgramSchemaAdksFields>>;
  icon?: Maybe<Scalars['String']['output']>;
  instruction?: Maybe<ProgramProgramSchemaAdksInstruction>;
  isSkippable?: Maybe<Scalars['Boolean']['output']>;
  isTeamAdk?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  optional?: Maybe<Scalars['Boolean']['output']>;
  permissions?: Maybe<Array<ProgramProgramSchemaAdksPermissions>>;
  position: Scalars['Int']['output'];
  presetFields?: Maybe<Array<ProgramProgramSchemaAdksPresetFields>>;
  preview: Scalars['Boolean']['output'];
  setupRequired: Scalars['Boolean']['output'];
  status: Scalars['Boolean']['output'];
  styling: ProgramProgramSchemaAdksStyling;
};

export type ProgramProgramSchemaAdksBuildScope = {
  __typename?: 'ProgramProgramSchemaAdksBuildScope';
  objectives?: Maybe<Array<ProgramProgramSchemaAdksBuildScopeObjectives>>;
  projects?: Maybe<Array<ProgramProgramSchemaAdksBuildScopeProjects>>;
};

export type ProgramProgramSchemaAdksBuildScopeCreateInput = {
  objectives?: InputMaybe<Array<ProgramProgramSchemaAdksBuildScopeObjectivesCreateInput>>;
  projects?: InputMaybe<Array<ProgramProgramSchemaAdksBuildScopeProjectsCreateInput>>;
};

export type ProgramProgramSchemaAdksBuildScopeObjectEqualityInput = {
  objectives?: InputMaybe<Array<ProgramProgramSchemaAdksBuildScopeObjectivesObjectEqualityInput>>;
  projects?: InputMaybe<Array<ProgramProgramSchemaAdksBuildScopeProjectsObjectEqualityInput>>;
};

export type ProgramProgramSchemaAdksBuildScopeObjectives = {
  __typename?: 'ProgramProgramSchemaAdksBuildScopeObjectives';
  action?: Maybe<Scalars['String']['output']>;
  icon?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  position: Scalars['Int']['output'];
  roles?: Maybe<Array<Scalars['String']['output']>>;
  /** Could not determine type: the field only had null or empty values in the sample set. */
  rules?: Maybe<Scalars['JSON']['output']>;
  styling?: Maybe<ProgramProgramSchemaAdksBuildScopeObjectivesStyling>;
  target?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
};

export type ProgramProgramSchemaAdksBuildScopeObjectivesCreateInput = {
  action?: InputMaybe<Scalars['String']['input']>;
  icon?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  position: Scalars['Int']['input'];
  roles?: InputMaybe<ProgramProgramSchemaAdksBuildScopeObjectivesCreaterolesInput>;
  rules?: InputMaybe<Scalars['JSON']['input']>;
  styling?: InputMaybe<ProgramProgramSchemaAdksBuildScopeObjectivesStylingCreateInput>;
  target?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  type: Scalars['String']['input'];
};

export type ProgramProgramSchemaAdksBuildScopeObjectivesCreaterolesInput = {
  set: Array<Scalars['String']['input']>;
};

export type ProgramProgramSchemaAdksBuildScopeObjectivesObjectEqualityInput = {
  action?: InputMaybe<Scalars['String']['input']>;
  icon?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  position: Scalars['Int']['input'];
  roles?: InputMaybe<Array<Scalars['String']['input']>>;
  rules?: InputMaybe<Scalars['JSON']['input']>;
  styling?: InputMaybe<ProgramProgramSchemaAdksBuildScopeObjectivesStylingObjectEqualityInput>;
  target?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  type: Scalars['String']['input'];
};

export type ProgramProgramSchemaAdksBuildScopeObjectivesStyling = {
  __typename?: 'ProgramProgramSchemaAdksBuildScopeObjectivesStyling';
  depressed?: Maybe<Scalars['Boolean']['output']>;
  hint?: Maybe<Scalars['String']['output']>;
  icon?: Maybe<Scalars['String']['output']>;
  label: Scalars['String']['output'];
  leftIcon?: Maybe<Scalars['String']['output']>;
  outlined: Scalars['Boolean']['output'];
  placeholder?: Maybe<Scalars['String']['output']>;
  rightIcon?: Maybe<Scalars['String']['output']>;
  rounded: Scalars['Boolean']['output'];
  small?: Maybe<Scalars['Boolean']['output']>;
};

export type ProgramProgramSchemaAdksBuildScopeObjectivesStylingCreateInput = {
  depressed?: InputMaybe<Scalars['Boolean']['input']>;
  hint?: InputMaybe<Scalars['String']['input']>;
  icon?: InputMaybe<Scalars['String']['input']>;
  label: Scalars['String']['input'];
  leftIcon?: InputMaybe<Scalars['String']['input']>;
  outlined: Scalars['Boolean']['input'];
  placeholder?: InputMaybe<Scalars['String']['input']>;
  rightIcon?: InputMaybe<Scalars['String']['input']>;
  rounded: Scalars['Boolean']['input'];
  small?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ProgramProgramSchemaAdksBuildScopeObjectivesStylingObjectEqualityInput = {
  depressed?: InputMaybe<Scalars['Boolean']['input']>;
  hint?: InputMaybe<Scalars['String']['input']>;
  icon?: InputMaybe<Scalars['String']['input']>;
  label: Scalars['String']['input'];
  leftIcon?: InputMaybe<Scalars['String']['input']>;
  outlined: Scalars['Boolean']['input'];
  placeholder?: InputMaybe<Scalars['String']['input']>;
  rightIcon?: InputMaybe<Scalars['String']['input']>;
  rounded: Scalars['Boolean']['input'];
  small?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ProgramProgramSchemaAdksBuildScopeProjects = {
  __typename?: 'ProgramProgramSchemaAdksBuildScopeProjects';
  action?: Maybe<Scalars['String']['output']>;
  icon?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  position: Scalars['Int']['output'];
  roles?: Maybe<Array<Scalars['String']['output']>>;
  styling?: Maybe<ProgramProgramSchemaAdksBuildScopeProjectsStyling>;
  target?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
};

export type ProgramProgramSchemaAdksBuildScopeProjectsCreateInput = {
  action?: InputMaybe<Scalars['String']['input']>;
  icon?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  position: Scalars['Int']['input'];
  roles?: InputMaybe<ProgramProgramSchemaAdksBuildScopeProjectsCreaterolesInput>;
  styling?: InputMaybe<ProgramProgramSchemaAdksBuildScopeProjectsStylingCreateInput>;
  target?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  type: Scalars['String']['input'];
};

export type ProgramProgramSchemaAdksBuildScopeProjectsCreaterolesInput = {
  set: Array<Scalars['String']['input']>;
};

export type ProgramProgramSchemaAdksBuildScopeProjectsObjectEqualityInput = {
  action?: InputMaybe<Scalars['String']['input']>;
  icon?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  position: Scalars['Int']['input'];
  roles?: InputMaybe<Array<Scalars['String']['input']>>;
  styling?: InputMaybe<ProgramProgramSchemaAdksBuildScopeProjectsStylingObjectEqualityInput>;
  target?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  type: Scalars['String']['input'];
};

export type ProgramProgramSchemaAdksBuildScopeProjectsStyling = {
  __typename?: 'ProgramProgramSchemaAdksBuildScopeProjectsStyling';
  color: Scalars['String']['output'];
  depressed: Scalars['Boolean']['output'];
  label: Scalars['String']['output'];
  leftIcon: Scalars['String']['output'];
  rounded: Scalars['Boolean']['output'];
};

export type ProgramProgramSchemaAdksBuildScopeProjectsStylingCreateInput = {
  color: Scalars['String']['input'];
  depressed: Scalars['Boolean']['input'];
  label: Scalars['String']['input'];
  leftIcon: Scalars['String']['input'];
  rounded: Scalars['Boolean']['input'];
};

export type ProgramProgramSchemaAdksBuildScopeProjectsStylingObjectEqualityInput = {
  color: Scalars['String']['input'];
  depressed: Scalars['Boolean']['input'];
  label: Scalars['String']['input'];
  leftIcon: Scalars['String']['input'];
  rounded: Scalars['Boolean']['input'];
};

export type ProgramProgramSchemaAdksCreateInput = {
  buildScope?: InputMaybe<ProgramProgramSchemaAdksBuildScopeCreateInput>;
  category: Scalars['String']['input'];
  fields?: InputMaybe<Array<ProgramProgramSchemaAdksFieldsCreateInput>>;
  icon?: InputMaybe<Scalars['String']['input']>;
  instruction?: InputMaybe<ProgramProgramSchemaAdksInstructionCreateInput>;
  isSkippable?: InputMaybe<Scalars['Boolean']['input']>;
  isTeamAdk?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  optional?: InputMaybe<Scalars['Boolean']['input']>;
  permissions?: InputMaybe<Array<ProgramProgramSchemaAdksPermissionsCreateInput>>;
  position: Scalars['Int']['input'];
  presetFields?: InputMaybe<Array<ProgramProgramSchemaAdksPresetFieldsCreateInput>>;
  preview: Scalars['Boolean']['input'];
  setupRequired: Scalars['Boolean']['input'];
  status: Scalars['Boolean']['input'];
  styling: ProgramProgramSchemaAdksStylingCreateInput;
};

export type ProgramProgramSchemaAdksFields = {
  __typename?: 'ProgramProgramSchemaAdksFields';
  action?: Maybe<Scalars['String']['output']>;
  adk?: Maybe<Scalars['String']['output']>;
  ages?: Maybe<Scalars['String']['output']>;
  align?: Maybe<Scalars['String']['output']>;
  blank?: Maybe<Scalars['Boolean']['output']>;
  color?: Maybe<Scalars['String']['output']>;
  dark?: Maybe<Scalars['Boolean']['output']>;
  /** Multiple data types found: String: 18.5%, Boolean: 59.3%, Int: 22.2% out of 27 sampled entries */
  defaultValue?: Maybe<Scalars['JSON']['output']>;
  /** Multiple data types found: String: 25%, ProgramProgramSchemaAdksFieldsEvent: 75% out of 4 sampled entries */
  event?: Maybe<Scalars['JSON']['output']>;
  header?: Maybe<Scalars['String']['output']>;
  href?: Maybe<Scalars['String']['output']>;
  icon?: Maybe<Scalars['String']['output']>;
  /** Multiple data types found: Array(String): 71.4%, Array(Int): 28.6% out of 8 sampled entries */
  items?: Maybe<Scalars['JSON']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  max?: Maybe<Scalars['String']['output']>;
  maxDate?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  min?: Maybe<Scalars['String']['output']>;
  minDate?: Maybe<Scalars['String']['output']>;
  model?: Maybe<Scalars['String']['output']>;
  modelItems?: Maybe<Array<ProgramProgramSchemaAdksFieldsModelItems>>;
  multiple?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  noSetup?: Maybe<Scalars['Boolean']['output']>;
  outlined?: Maybe<Scalars['Boolean']['output']>;
  placeholder?: Maybe<Scalars['String']['output']>;
  position: Scalars['Int']['output'];
  preset?: Maybe<ProgramProgramSchemaAdksFieldsPreset>;
  radioButtons?: Maybe<Array<ProgramProgramSchemaAdksFieldsRadioButtons>>;
  roles?: Maybe<Array<Scalars['String']['output']>>;
  rounded?: Maybe<Scalars['Boolean']['output']>;
  rules?: Maybe<Array<Scalars['String']['output']>>;
  searchInput?: Maybe<Scalars['String']['output']>;
  searchType?: Maybe<Scalars['String']['output']>;
  /** Nested objects had no data in the sample dataset to introspect a nested type. */
  setup?: Maybe<Scalars['JSON']['output']>;
  styling?: Maybe<ProgramProgramSchemaAdksFieldsStyling>;
  subTitle?: Maybe<Scalars['String']['output']>;
  target?: Maybe<Scalars['String']['output']>;
  tickSize?: Maybe<Scalars['Int']['output']>;
  ticks?: Maybe<Scalars['Boolean']['output']>;
  timelineItems?: Maybe<Array<ProgramProgramSchemaAdksFieldsTimelineItems>>;
  title?: Maybe<Scalars['String']['output']>;
  titleAfterChip?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  vChipContent?: Maybe<Scalars['String']['output']>;
  value?: Maybe<ProgramProgramSchemaAdksFieldsValue>;
  videoAskLabel?: Maybe<Scalars['String']['output']>;
  videoAskUrl?: Maybe<Scalars['String']['output']>;
};

export type ProgramProgramSchemaAdksFieldsCreateInput = {
  action?: InputMaybe<Scalars['String']['input']>;
  adk?: InputMaybe<Scalars['String']['input']>;
  ages?: InputMaybe<Scalars['String']['input']>;
  align?: InputMaybe<Scalars['String']['input']>;
  blank?: InputMaybe<Scalars['Boolean']['input']>;
  color?: InputMaybe<Scalars['String']['input']>;
  dark?: InputMaybe<Scalars['Boolean']['input']>;
  defaultValue?: InputMaybe<Scalars['JSON']['input']>;
  event?: InputMaybe<Scalars['JSON']['input']>;
  header?: InputMaybe<Scalars['String']['input']>;
  href?: InputMaybe<Scalars['String']['input']>;
  icon?: InputMaybe<Scalars['String']['input']>;
  items?: InputMaybe<Scalars['JSON']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  max?: InputMaybe<Scalars['String']['input']>;
  maxDate?: InputMaybe<Scalars['String']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  min?: InputMaybe<Scalars['String']['input']>;
  minDate?: InputMaybe<Scalars['String']['input']>;
  model?: InputMaybe<Scalars['String']['input']>;
  modelItems?: InputMaybe<Array<ProgramProgramSchemaAdksFieldsModelItemsCreateInput>>;
  multiple?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  noSetup?: InputMaybe<Scalars['Boolean']['input']>;
  outlined?: InputMaybe<Scalars['Boolean']['input']>;
  placeholder?: InputMaybe<Scalars['String']['input']>;
  position: Scalars['Int']['input'];
  preset?: InputMaybe<ProgramProgramSchemaAdksFieldsPresetCreateInput>;
  radioButtons?: InputMaybe<Array<ProgramProgramSchemaAdksFieldsRadioButtonsCreateInput>>;
  roles?: InputMaybe<ProgramProgramSchemaAdksFieldsCreaterolesInput>;
  rounded?: InputMaybe<Scalars['Boolean']['input']>;
  rules?: InputMaybe<ProgramProgramSchemaAdksFieldsCreaterulesInput>;
  searchInput?: InputMaybe<Scalars['String']['input']>;
  searchType?: InputMaybe<Scalars['String']['input']>;
  setup?: InputMaybe<Scalars['JSON']['input']>;
  styling?: InputMaybe<ProgramProgramSchemaAdksFieldsStylingCreateInput>;
  subTitle?: InputMaybe<Scalars['String']['input']>;
  target?: InputMaybe<Scalars['String']['input']>;
  tickSize?: InputMaybe<Scalars['Int']['input']>;
  ticks?: InputMaybe<Scalars['Boolean']['input']>;
  timelineItems?: InputMaybe<Array<ProgramProgramSchemaAdksFieldsTimelineItemsCreateInput>>;
  title?: InputMaybe<Scalars['String']['input']>;
  titleAfterChip?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  vChipContent?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<ProgramProgramSchemaAdksFieldsValueCreateInput>;
  videoAskLabel?: InputMaybe<Scalars['String']['input']>;
  videoAskUrl?: InputMaybe<Scalars['String']['input']>;
};

export type ProgramProgramSchemaAdksFieldsCreaterolesInput = {
  set: Array<Scalars['String']['input']>;
};

export type ProgramProgramSchemaAdksFieldsCreaterulesInput = {
  set: Array<Scalars['String']['input']>;
};

export type ProgramProgramSchemaAdksFieldsModelItems = {
  __typename?: 'ProgramProgramSchemaAdksFieldsModelItems';
  name: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type ProgramProgramSchemaAdksFieldsModelItemsCreateInput = {
  name: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export type ProgramProgramSchemaAdksFieldsModelItemsObjectEqualityInput = {
  name: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export type ProgramProgramSchemaAdksFieldsObjectEqualityInput = {
  action?: InputMaybe<Scalars['String']['input']>;
  adk?: InputMaybe<Scalars['String']['input']>;
  ages?: InputMaybe<Scalars['String']['input']>;
  align?: InputMaybe<Scalars['String']['input']>;
  blank?: InputMaybe<Scalars['Boolean']['input']>;
  color?: InputMaybe<Scalars['String']['input']>;
  dark?: InputMaybe<Scalars['Boolean']['input']>;
  defaultValue?: InputMaybe<Scalars['JSON']['input']>;
  event?: InputMaybe<Scalars['JSON']['input']>;
  header?: InputMaybe<Scalars['String']['input']>;
  href?: InputMaybe<Scalars['String']['input']>;
  icon?: InputMaybe<Scalars['String']['input']>;
  items?: InputMaybe<Scalars['JSON']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  max?: InputMaybe<Scalars['String']['input']>;
  maxDate?: InputMaybe<Scalars['String']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  min?: InputMaybe<Scalars['String']['input']>;
  minDate?: InputMaybe<Scalars['String']['input']>;
  model?: InputMaybe<Scalars['String']['input']>;
  modelItems?: InputMaybe<Array<ProgramProgramSchemaAdksFieldsModelItemsObjectEqualityInput>>;
  multiple?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  noSetup?: InputMaybe<Scalars['Boolean']['input']>;
  outlined?: InputMaybe<Scalars['Boolean']['input']>;
  placeholder?: InputMaybe<Scalars['String']['input']>;
  position: Scalars['Int']['input'];
  preset?: InputMaybe<ProgramProgramSchemaAdksFieldsPresetObjectEqualityInput>;
  radioButtons?: InputMaybe<Array<ProgramProgramSchemaAdksFieldsRadioButtonsObjectEqualityInput>>;
  roles?: InputMaybe<Array<Scalars['String']['input']>>;
  rounded?: InputMaybe<Scalars['Boolean']['input']>;
  rules?: InputMaybe<Array<Scalars['String']['input']>>;
  searchInput?: InputMaybe<Scalars['String']['input']>;
  searchType?: InputMaybe<Scalars['String']['input']>;
  setup?: InputMaybe<Scalars['JSON']['input']>;
  styling?: InputMaybe<ProgramProgramSchemaAdksFieldsStylingObjectEqualityInput>;
  subTitle?: InputMaybe<Scalars['String']['input']>;
  target?: InputMaybe<Scalars['String']['input']>;
  tickSize?: InputMaybe<Scalars['Int']['input']>;
  ticks?: InputMaybe<Scalars['Boolean']['input']>;
  timelineItems?: InputMaybe<Array<ProgramProgramSchemaAdksFieldsTimelineItemsObjectEqualityInput>>;
  title?: InputMaybe<Scalars['String']['input']>;
  titleAfterChip?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  vChipContent?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<ProgramProgramSchemaAdksFieldsValueObjectEqualityInput>;
  videoAskLabel?: InputMaybe<Scalars['String']['input']>;
  videoAskUrl?: InputMaybe<Scalars['String']['input']>;
};

export type ProgramProgramSchemaAdksFieldsPreset = {
  __typename?: 'ProgramProgramSchemaAdksFieldsPreset';
  acceptanceDeadline?: Maybe<Scalars['String']['output']>;
  apprentice?: Maybe<Scalars['Boolean']['output']>;
  compensation1?: Maybe<Scalars['Boolean']['output']>;
  compensation2?: Maybe<Scalars['Boolean']['output']>;
  compensation3?: Maybe<Scalars['Boolean']['output']>;
  compensation4?: Maybe<Scalars['Boolean']['output']>;
  compensation5?: Maybe<Scalars['Boolean']['output']>;
  compensation6?: Maybe<Scalars['Boolean']['output']>;
  continuation?: Maybe<Scalars['Int']['output']>;
  eir?: Maybe<Scalars['Boolean']['output']>;
  employerRecord?: Maybe<Scalars['Int']['output']>;
  extern?: Maybe<Scalars['Boolean']['output']>;
  externCredential?: Maybe<Scalars['Int']['output']>;
  fellow?: Maybe<Scalars['Boolean']['output']>;
  intern?: Maybe<Scalars['Boolean']['output']>;
  internshipEnd?: Maybe<Scalars['String']['output']>;
  internshipProject1?: Maybe<Scalars['Boolean']['output']>;
  internshipProject2?: Maybe<Scalars['Boolean']['output']>;
  internshipProject3?: Maybe<Scalars['Boolean']['output']>;
  internshipStart?: Maybe<Scalars['String']['output']>;
  licenseRequirement?: Maybe<Scalars['Int']['output']>;
  maxHours?: Maybe<Scalars['Int']['output']>;
  maximumBudget?: Maybe<Scalars['String']['output']>;
  minHours?: Maybe<Scalars['Int']['output']>;
  minimumBudget?: Maybe<Scalars['String']['output']>;
  preApprentice?: Maybe<Scalars['Boolean']['output']>;
  preInternship?: Maybe<Scalars['Boolean']['output']>;
};

export type ProgramProgramSchemaAdksFieldsPresetCreateInput = {
  acceptanceDeadline?: InputMaybe<Scalars['String']['input']>;
  apprentice?: InputMaybe<Scalars['Boolean']['input']>;
  compensation1?: InputMaybe<Scalars['Boolean']['input']>;
  compensation2?: InputMaybe<Scalars['Boolean']['input']>;
  compensation3?: InputMaybe<Scalars['Boolean']['input']>;
  compensation4?: InputMaybe<Scalars['Boolean']['input']>;
  compensation5?: InputMaybe<Scalars['Boolean']['input']>;
  compensation6?: InputMaybe<Scalars['Boolean']['input']>;
  continuation?: InputMaybe<Scalars['Int']['input']>;
  eir?: InputMaybe<Scalars['Boolean']['input']>;
  employerRecord?: InputMaybe<Scalars['Int']['input']>;
  extern?: InputMaybe<Scalars['Boolean']['input']>;
  externCredential?: InputMaybe<Scalars['Int']['input']>;
  fellow?: InputMaybe<Scalars['Boolean']['input']>;
  intern?: InputMaybe<Scalars['Boolean']['input']>;
  internshipEnd?: InputMaybe<Scalars['String']['input']>;
  internshipProject1?: InputMaybe<Scalars['Boolean']['input']>;
  internshipProject2?: InputMaybe<Scalars['Boolean']['input']>;
  internshipProject3?: InputMaybe<Scalars['Boolean']['input']>;
  internshipStart?: InputMaybe<Scalars['String']['input']>;
  licenseRequirement?: InputMaybe<Scalars['Int']['input']>;
  maxHours?: InputMaybe<Scalars['Int']['input']>;
  maximumBudget?: InputMaybe<Scalars['String']['input']>;
  minHours?: InputMaybe<Scalars['Int']['input']>;
  minimumBudget?: InputMaybe<Scalars['String']['input']>;
  preApprentice?: InputMaybe<Scalars['Boolean']['input']>;
  preInternship?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ProgramProgramSchemaAdksFieldsPresetObjectEqualityInput = {
  acceptanceDeadline?: InputMaybe<Scalars['String']['input']>;
  apprentice?: InputMaybe<Scalars['Boolean']['input']>;
  compensation1?: InputMaybe<Scalars['Boolean']['input']>;
  compensation2?: InputMaybe<Scalars['Boolean']['input']>;
  compensation3?: InputMaybe<Scalars['Boolean']['input']>;
  compensation4?: InputMaybe<Scalars['Boolean']['input']>;
  compensation5?: InputMaybe<Scalars['Boolean']['input']>;
  compensation6?: InputMaybe<Scalars['Boolean']['input']>;
  continuation?: InputMaybe<Scalars['Int']['input']>;
  eir?: InputMaybe<Scalars['Boolean']['input']>;
  employerRecord?: InputMaybe<Scalars['Int']['input']>;
  extern?: InputMaybe<Scalars['Boolean']['input']>;
  externCredential?: InputMaybe<Scalars['Int']['input']>;
  fellow?: InputMaybe<Scalars['Boolean']['input']>;
  intern?: InputMaybe<Scalars['Boolean']['input']>;
  internshipEnd?: InputMaybe<Scalars['String']['input']>;
  internshipProject1?: InputMaybe<Scalars['Boolean']['input']>;
  internshipProject2?: InputMaybe<Scalars['Boolean']['input']>;
  internshipProject3?: InputMaybe<Scalars['Boolean']['input']>;
  internshipStart?: InputMaybe<Scalars['String']['input']>;
  licenseRequirement?: InputMaybe<Scalars['Int']['input']>;
  maxHours?: InputMaybe<Scalars['Int']['input']>;
  maximumBudget?: InputMaybe<Scalars['String']['input']>;
  minHours?: InputMaybe<Scalars['Int']['input']>;
  minimumBudget?: InputMaybe<Scalars['String']['input']>;
  preApprentice?: InputMaybe<Scalars['Boolean']['input']>;
  preInternship?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ProgramProgramSchemaAdksFieldsRadioButtons = {
  __typename?: 'ProgramProgramSchemaAdksFieldsRadioButtons';
  action?: Maybe<Scalars['String']['output']>;
  clickable?: Maybe<Scalars['Boolean']['output']>;
  event?: Maybe<ProgramProgramSchemaAdksFieldsRadioButtonsEvent>;
  label: Scalars['String']['output'];
};

export type ProgramProgramSchemaAdksFieldsRadioButtonsCreateInput = {
  action?: InputMaybe<Scalars['String']['input']>;
  clickable?: InputMaybe<Scalars['Boolean']['input']>;
  event?: InputMaybe<ProgramProgramSchemaAdksFieldsRadioButtonsEventCreateInput>;
  label: Scalars['String']['input'];
};

export type ProgramProgramSchemaAdksFieldsRadioButtonsEvent = {
  __typename?: 'ProgramProgramSchemaAdksFieldsRadioButtonsEvent';
  body: Scalars['String']['output'];
  buttons?: Maybe<Array<ProgramProgramSchemaAdksFieldsRadioButtonsEventButtons>>;
  component: Scalars['String']['output'];
  title: Scalars['String']['output'];
  trigger: Scalars['String']['output'];
};

export type ProgramProgramSchemaAdksFieldsRadioButtonsEventButtons = {
  __typename?: 'ProgramProgramSchemaAdksFieldsRadioButtonsEventButtons';
  label: Scalars['String']['output'];
  model: Scalars['String']['output'];
  style: ProgramProgramSchemaAdksFieldsRadioButtonsEventButtonsStyle;
};

export type ProgramProgramSchemaAdksFieldsRadioButtonsEventButtonsCreateInput = {
  label: Scalars['String']['input'];
  model: Scalars['String']['input'];
  style: ProgramProgramSchemaAdksFieldsRadioButtonsEventButtonsStyleCreateInput;
};

export type ProgramProgramSchemaAdksFieldsRadioButtonsEventButtonsObjectEqualityInput = {
  label: Scalars['String']['input'];
  model: Scalars['String']['input'];
  style: ProgramProgramSchemaAdksFieldsRadioButtonsEventButtonsStyleObjectEqualityInput;
};

export type ProgramProgramSchemaAdksFieldsRadioButtonsEventButtonsStyle = {
  __typename?: 'ProgramProgramSchemaAdksFieldsRadioButtonsEventButtonsStyle';
  class: Scalars['String']['output'];
  color: Scalars['String']['output'];
  dark?: Maybe<Scalars['Boolean']['output']>;
  depressed?: Maybe<Scalars['Boolean']['output']>;
  outlined?: Maybe<Scalars['Boolean']['output']>;
  rounded: Scalars['Boolean']['output'];
  xLarge: Scalars['Boolean']['output'];
};

export type ProgramProgramSchemaAdksFieldsRadioButtonsEventButtonsStyleCreateInput = {
  class: Scalars['String']['input'];
  color: Scalars['String']['input'];
  dark?: InputMaybe<Scalars['Boolean']['input']>;
  depressed?: InputMaybe<Scalars['Boolean']['input']>;
  outlined?: InputMaybe<Scalars['Boolean']['input']>;
  rounded: Scalars['Boolean']['input'];
  xLarge: Scalars['Boolean']['input'];
};

export type ProgramProgramSchemaAdksFieldsRadioButtonsEventButtonsStyleObjectEqualityInput = {
  class: Scalars['String']['input'];
  color: Scalars['String']['input'];
  dark?: InputMaybe<Scalars['Boolean']['input']>;
  depressed?: InputMaybe<Scalars['Boolean']['input']>;
  outlined?: InputMaybe<Scalars['Boolean']['input']>;
  rounded: Scalars['Boolean']['input'];
  xLarge: Scalars['Boolean']['input'];
};

export type ProgramProgramSchemaAdksFieldsRadioButtonsEventCreateInput = {
  body: Scalars['String']['input'];
  buttons?: InputMaybe<Array<ProgramProgramSchemaAdksFieldsRadioButtonsEventButtonsCreateInput>>;
  component: Scalars['String']['input'];
  title: Scalars['String']['input'];
  trigger: Scalars['String']['input'];
};

export type ProgramProgramSchemaAdksFieldsRadioButtonsEventObjectEqualityInput = {
  body: Scalars['String']['input'];
  buttons?: InputMaybe<Array<ProgramProgramSchemaAdksFieldsRadioButtonsEventButtonsObjectEqualityInput>>;
  component: Scalars['String']['input'];
  title: Scalars['String']['input'];
  trigger: Scalars['String']['input'];
};

export type ProgramProgramSchemaAdksFieldsRadioButtonsObjectEqualityInput = {
  action?: InputMaybe<Scalars['String']['input']>;
  clickable?: InputMaybe<Scalars['Boolean']['input']>;
  event?: InputMaybe<ProgramProgramSchemaAdksFieldsRadioButtonsEventObjectEqualityInput>;
  label: Scalars['String']['input'];
};

export type ProgramProgramSchemaAdksFieldsStyling = {
  __typename?: 'ProgramProgramSchemaAdksFieldsStyling';
  appendIcon?: Maybe<Scalars['String']['output']>;
  chips?: Maybe<Scalars['Boolean']['output']>;
  class?: Maybe<Scalars['String']['output']>;
  color?: Maybe<Scalars['String']['output']>;
  /** Multiple data types found: String: 78.6%, Int: 21.4% out of 14 sampled entries */
  counter?: Maybe<Scalars['JSON']['output']>;
  dark?: Maybe<Scalars['Boolean']['output']>;
  dense?: Maybe<Scalars['Boolean']['output']>;
  denseIcon?: Maybe<Scalars['Boolean']['output']>;
  depressed?: Maybe<Scalars['Boolean']['output']>;
  flat?: Maybe<Scalars['Boolean']['output']>;
  hide_details?: Maybe<Scalars['Boolean']['output']>;
  hint?: Maybe<Scalars['String']['output']>;
  icon?: Maybe<Scalars['Boolean']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  leftIcon?: Maybe<Scalars['Boolean']['output']>;
  multiple?: Maybe<Scalars['Boolean']['output']>;
  outlined?: Maybe<Scalars['Boolean']['output']>;
  placeholder?: Maybe<Scalars['String']['output']>;
  prependIcon?: Maybe<Scalars['String']['output']>;
  rightIcon?: Maybe<Scalars['Boolean']['output']>;
  rounded?: Maybe<Scalars['Boolean']['output']>;
  small?: Maybe<Scalars['Boolean']['output']>;
  small_chips?: Maybe<Scalars['Boolean']['output']>;
  wrapperClass?: Maybe<Scalars['String']['output']>;
  xLarge?: Maybe<Scalars['Boolean']['output']>;
  xSmall?: Maybe<Scalars['Boolean']['output']>;
};

export type ProgramProgramSchemaAdksFieldsStylingCreateInput = {
  appendIcon?: InputMaybe<Scalars['String']['input']>;
  chips?: InputMaybe<Scalars['Boolean']['input']>;
  class?: InputMaybe<Scalars['String']['input']>;
  color?: InputMaybe<Scalars['String']['input']>;
  counter?: InputMaybe<Scalars['JSON']['input']>;
  dark?: InputMaybe<Scalars['Boolean']['input']>;
  dense?: InputMaybe<Scalars['Boolean']['input']>;
  denseIcon?: InputMaybe<Scalars['Boolean']['input']>;
  depressed?: InputMaybe<Scalars['Boolean']['input']>;
  flat?: InputMaybe<Scalars['Boolean']['input']>;
  hide_details?: InputMaybe<Scalars['Boolean']['input']>;
  hint?: InputMaybe<Scalars['String']['input']>;
  icon?: InputMaybe<Scalars['Boolean']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  leftIcon?: InputMaybe<Scalars['Boolean']['input']>;
  multiple?: InputMaybe<Scalars['Boolean']['input']>;
  outlined?: InputMaybe<Scalars['Boolean']['input']>;
  placeholder?: InputMaybe<Scalars['String']['input']>;
  prependIcon?: InputMaybe<Scalars['String']['input']>;
  rightIcon?: InputMaybe<Scalars['Boolean']['input']>;
  rounded?: InputMaybe<Scalars['Boolean']['input']>;
  small?: InputMaybe<Scalars['Boolean']['input']>;
  small_chips?: InputMaybe<Scalars['Boolean']['input']>;
  wrapperClass?: InputMaybe<Scalars['String']['input']>;
  xLarge?: InputMaybe<Scalars['Boolean']['input']>;
  xSmall?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ProgramProgramSchemaAdksFieldsStylingObjectEqualityInput = {
  appendIcon?: InputMaybe<Scalars['String']['input']>;
  chips?: InputMaybe<Scalars['Boolean']['input']>;
  class?: InputMaybe<Scalars['String']['input']>;
  color?: InputMaybe<Scalars['String']['input']>;
  counter?: InputMaybe<Scalars['JSON']['input']>;
  dark?: InputMaybe<Scalars['Boolean']['input']>;
  dense?: InputMaybe<Scalars['Boolean']['input']>;
  denseIcon?: InputMaybe<Scalars['Boolean']['input']>;
  depressed?: InputMaybe<Scalars['Boolean']['input']>;
  flat?: InputMaybe<Scalars['Boolean']['input']>;
  hide_details?: InputMaybe<Scalars['Boolean']['input']>;
  hint?: InputMaybe<Scalars['String']['input']>;
  icon?: InputMaybe<Scalars['Boolean']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  leftIcon?: InputMaybe<Scalars['Boolean']['input']>;
  multiple?: InputMaybe<Scalars['Boolean']['input']>;
  outlined?: InputMaybe<Scalars['Boolean']['input']>;
  placeholder?: InputMaybe<Scalars['String']['input']>;
  prependIcon?: InputMaybe<Scalars['String']['input']>;
  rightIcon?: InputMaybe<Scalars['Boolean']['input']>;
  rounded?: InputMaybe<Scalars['Boolean']['input']>;
  small?: InputMaybe<Scalars['Boolean']['input']>;
  small_chips?: InputMaybe<Scalars['Boolean']['input']>;
  wrapperClass?: InputMaybe<Scalars['String']['input']>;
  xLarge?: InputMaybe<Scalars['Boolean']['input']>;
  xSmall?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ProgramProgramSchemaAdksFieldsTimelineItems = {
  __typename?: 'ProgramProgramSchemaAdksFieldsTimelineItems';
  answer: Scalars['String']['output'];
  color: Scalars['String']['output'];
  question: Scalars['String']['output'];
};

export type ProgramProgramSchemaAdksFieldsTimelineItemsCreateInput = {
  answer: Scalars['String']['input'];
  color: Scalars['String']['input'];
  question: Scalars['String']['input'];
};

export type ProgramProgramSchemaAdksFieldsTimelineItemsObjectEqualityInput = {
  answer: Scalars['String']['input'];
  color: Scalars['String']['input'];
  question: Scalars['String']['input'];
};

export type ProgramProgramSchemaAdksFieldsValue = {
  __typename?: 'ProgramProgramSchemaAdksFieldsValue';
  deliverable?: Maybe<Array<Scalars['String']['output']>>;
  outcome?: Maybe<Array<Scalars['String']['output']>>;
};

export type ProgramProgramSchemaAdksFieldsValueCreateInput = {
  deliverable?: InputMaybe<ProgramProgramSchemaAdksFieldsValueCreatedeliverableInput>;
  outcome?: InputMaybe<ProgramProgramSchemaAdksFieldsValueCreateoutcomeInput>;
};

export type ProgramProgramSchemaAdksFieldsValueCreatedeliverableInput = {
  set: Array<Scalars['String']['input']>;
};

export type ProgramProgramSchemaAdksFieldsValueCreateoutcomeInput = {
  set: Array<Scalars['String']['input']>;
};

export type ProgramProgramSchemaAdksFieldsValueObjectEqualityInput = {
  deliverable?: InputMaybe<Array<Scalars['String']['input']>>;
  outcome?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type ProgramProgramSchemaAdksInstruction = {
  __typename?: 'ProgramProgramSchemaAdksInstruction';
  boilerInstructions?: Maybe<Array<Scalars['String']['output']>>;
  discordUrl: Scalars['String']['output'];
  goal: Scalars['String']['output'];
  youtubeUrl: Scalars['String']['output'];
};

export type ProgramProgramSchemaAdksInstructionCreateInput = {
  boilerInstructions?: InputMaybe<ProgramProgramSchemaAdksInstructionCreateboilerInstructionsInput>;
  discordUrl: Scalars['String']['input'];
  goal: Scalars['String']['input'];
  youtubeUrl: Scalars['String']['input'];
};

export type ProgramProgramSchemaAdksInstructionCreateboilerInstructionsInput = {
  set: Array<Scalars['String']['input']>;
};

export type ProgramProgramSchemaAdksInstructionObjectEqualityInput = {
  boilerInstructions?: InputMaybe<Array<Scalars['String']['input']>>;
  discordUrl: Scalars['String']['input'];
  goal: Scalars['String']['input'];
  youtubeUrl: Scalars['String']['input'];
};

export type ProgramProgramSchemaAdksObjectEqualityInput = {
  buildScope?: InputMaybe<ProgramProgramSchemaAdksBuildScopeObjectEqualityInput>;
  category: Scalars['String']['input'];
  fields?: InputMaybe<Array<ProgramProgramSchemaAdksFieldsObjectEqualityInput>>;
  icon?: InputMaybe<Scalars['String']['input']>;
  instruction?: InputMaybe<ProgramProgramSchemaAdksInstructionObjectEqualityInput>;
  isSkippable?: InputMaybe<Scalars['Boolean']['input']>;
  isTeamAdk?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  optional?: InputMaybe<Scalars['Boolean']['input']>;
  permissions?: InputMaybe<Array<ProgramProgramSchemaAdksPermissionsObjectEqualityInput>>;
  position: Scalars['Int']['input'];
  presetFields?: InputMaybe<Array<ProgramProgramSchemaAdksPresetFieldsObjectEqualityInput>>;
  preview: Scalars['Boolean']['input'];
  setupRequired: Scalars['Boolean']['input'];
  status: Scalars['Boolean']['input'];
  styling: ProgramProgramSchemaAdksStylingObjectEqualityInput;
};

export type ProgramProgramSchemaAdksPermissions = {
  __typename?: 'ProgramProgramSchemaAdksPermissions';
  permissions_matrix?: Maybe<Array<Scalars['String']['output']>>;
  role?: Maybe<Scalars['String']['output']>;
  roles?: Maybe<Scalars['String']['output']>;
};

export type ProgramProgramSchemaAdksPermissionsCreateInput = {
  permissions_matrix?: InputMaybe<ProgramProgramSchemaAdksPermissionsCreatepermissions_MatrixInput>;
  role?: InputMaybe<Scalars['String']['input']>;
  roles?: InputMaybe<Scalars['String']['input']>;
};

export type ProgramProgramSchemaAdksPermissionsCreatepermissions_MatrixInput = {
  set: Array<Scalars['String']['input']>;
};

export type ProgramProgramSchemaAdksPermissionsObjectEqualityInput = {
  permissions_matrix?: InputMaybe<Array<Scalars['String']['input']>>;
  role?: InputMaybe<Scalars['String']['input']>;
  roles?: InputMaybe<Scalars['String']['input']>;
};

export type ProgramProgramSchemaAdksPresetFields = {
  __typename?: 'ProgramProgramSchemaAdksPresetFields';
  action?: Maybe<Scalars['String']['output']>;
  /** Multiple data types found: String: 33.3%, Int: 66.7% out of 6 sampled entries */
  defaultValue?: Maybe<Scalars['JSON']['output']>;
  /** Multiple data types found: Array(String): 33.3%, Array(Int): 66.7% out of 6 sampled entries */
  items?: Maybe<Scalars['JSON']['output']>;
  model?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  noSetup?: Maybe<Scalars['Boolean']['output']>;
  position: Scalars['Int']['output'];
  preset?: Maybe<ProgramProgramSchemaAdksPresetFieldsPreset>;
  roles?: Maybe<Array<Scalars['String']['output']>>;
  /** Could not determine type: the field only had null or empty values in the sample set. */
  rules?: Maybe<Scalars['JSON']['output']>;
  /** Nested objects had no data in the sample dataset to introspect a nested type. */
  setup?: Maybe<Scalars['JSON']['output']>;
  styling?: Maybe<ProgramProgramSchemaAdksPresetFieldsStyling>;
  target?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
  /** Nested objects had no data in the sample dataset to introspect a nested type. */
  value?: Maybe<Scalars['JSON']['output']>;
  videoAskLabel?: Maybe<Scalars['String']['output']>;
  videoAskUrl?: Maybe<Scalars['String']['output']>;
};

export type ProgramProgramSchemaAdksPresetFieldsCreateInput = {
  action?: InputMaybe<Scalars['String']['input']>;
  defaultValue?: InputMaybe<Scalars['JSON']['input']>;
  items?: InputMaybe<Scalars['JSON']['input']>;
  model?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  noSetup?: InputMaybe<Scalars['Boolean']['input']>;
  position: Scalars['Int']['input'];
  preset?: InputMaybe<ProgramProgramSchemaAdksPresetFieldsPresetCreateInput>;
  roles?: InputMaybe<ProgramProgramSchemaAdksPresetFieldsCreaterolesInput>;
  rules?: InputMaybe<Scalars['JSON']['input']>;
  setup?: InputMaybe<Scalars['JSON']['input']>;
  styling?: InputMaybe<ProgramProgramSchemaAdksPresetFieldsStylingCreateInput>;
  target?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  type: Scalars['String']['input'];
  value?: InputMaybe<Scalars['JSON']['input']>;
  videoAskLabel?: InputMaybe<Scalars['String']['input']>;
  videoAskUrl?: InputMaybe<Scalars['String']['input']>;
};

export type ProgramProgramSchemaAdksPresetFieldsCreaterolesInput = {
  set: Array<Scalars['String']['input']>;
};

export type ProgramProgramSchemaAdksPresetFieldsObjectEqualityInput = {
  action?: InputMaybe<Scalars['String']['input']>;
  defaultValue?: InputMaybe<Scalars['JSON']['input']>;
  items?: InputMaybe<Scalars['JSON']['input']>;
  model?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  noSetup?: InputMaybe<Scalars['Boolean']['input']>;
  position: Scalars['Int']['input'];
  preset?: InputMaybe<ProgramProgramSchemaAdksPresetFieldsPresetObjectEqualityInput>;
  roles?: InputMaybe<Array<Scalars['String']['input']>>;
  rules?: InputMaybe<Scalars['JSON']['input']>;
  setup?: InputMaybe<Scalars['JSON']['input']>;
  styling?: InputMaybe<ProgramProgramSchemaAdksPresetFieldsStylingObjectEqualityInput>;
  target?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  type: Scalars['String']['input'];
  value?: InputMaybe<Scalars['JSON']['input']>;
  videoAskLabel?: InputMaybe<Scalars['String']['input']>;
  videoAskUrl?: InputMaybe<Scalars['String']['input']>;
};

export type ProgramProgramSchemaAdksPresetFieldsPreset = {
  __typename?: 'ProgramProgramSchemaAdksPresetFieldsPreset';
  maxCharacters?: Maybe<Scalars['String']['output']>;
  maxQuestions?: Maybe<Scalars['Int']['output']>;
  maxTeamMembers?: Maybe<Scalars['Int']['output']>;
  minLogs?: Maybe<Scalars['Int']['output']>;
  minimumHoursNow?: Maybe<Scalars['String']['output']>;
  videoMaxLength?: Maybe<Scalars['Int']['output']>;
};

export type ProgramProgramSchemaAdksPresetFieldsPresetCreateInput = {
  maxCharacters?: InputMaybe<Scalars['String']['input']>;
  maxQuestions?: InputMaybe<Scalars['Int']['input']>;
  maxTeamMembers?: InputMaybe<Scalars['Int']['input']>;
  minLogs?: InputMaybe<Scalars['Int']['input']>;
  minimumHoursNow?: InputMaybe<Scalars['String']['input']>;
  videoMaxLength?: InputMaybe<Scalars['Int']['input']>;
};

export type ProgramProgramSchemaAdksPresetFieldsPresetObjectEqualityInput = {
  maxCharacters?: InputMaybe<Scalars['String']['input']>;
  maxQuestions?: InputMaybe<Scalars['Int']['input']>;
  maxTeamMembers?: InputMaybe<Scalars['Int']['input']>;
  minLogs?: InputMaybe<Scalars['Int']['input']>;
  minimumHoursNow?: InputMaybe<Scalars['String']['input']>;
  videoMaxLength?: InputMaybe<Scalars['Int']['input']>;
};

export type ProgramProgramSchemaAdksPresetFieldsStyling = {
  __typename?: 'ProgramProgramSchemaAdksPresetFieldsStyling';
  class?: Maybe<Scalars['String']['output']>;
  depressed?: Maybe<Scalars['Boolean']['output']>;
  label: Scalars['String']['output'];
  outlined: Scalars['Boolean']['output'];
  placeholder?: Maybe<Scalars['String']['output']>;
  prependIcon?: Maybe<Scalars['String']['output']>;
  rounded: Scalars['Boolean']['output'];
  wrapperClass?: Maybe<Scalars['String']['output']>;
  xLarge?: Maybe<Scalars['Boolean']['output']>;
};

export type ProgramProgramSchemaAdksPresetFieldsStylingCreateInput = {
  class?: InputMaybe<Scalars['String']['input']>;
  depressed?: InputMaybe<Scalars['Boolean']['input']>;
  label: Scalars['String']['input'];
  outlined: Scalars['Boolean']['input'];
  placeholder?: InputMaybe<Scalars['String']['input']>;
  prependIcon?: InputMaybe<Scalars['String']['input']>;
  rounded: Scalars['Boolean']['input'];
  wrapperClass?: InputMaybe<Scalars['String']['input']>;
  xLarge?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ProgramProgramSchemaAdksPresetFieldsStylingObjectEqualityInput = {
  class?: InputMaybe<Scalars['String']['input']>;
  depressed?: InputMaybe<Scalars['Boolean']['input']>;
  label: Scalars['String']['input'];
  outlined: Scalars['Boolean']['input'];
  placeholder?: InputMaybe<Scalars['String']['input']>;
  prependIcon?: InputMaybe<Scalars['String']['input']>;
  rounded: Scalars['Boolean']['input'];
  wrapperClass?: InputMaybe<Scalars['String']['input']>;
  xLarge?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ProgramProgramSchemaAdksStyling = {
  __typename?: 'ProgramProgramSchemaAdksStyling';
  borderColor: Scalars['String']['output'];
};

export type ProgramProgramSchemaAdksStylingCreateInput = {
  borderColor: Scalars['String']['input'];
};

export type ProgramProgramSchemaAdksStylingObjectEqualityInput = {
  borderColor: Scalars['String']['input'];
};

export type ProgramProgramSchemaCreateInput = {
  adks?: InputMaybe<Array<ProgramProgramSchemaAdksCreateInput>>;
  id: Scalars['String']['input'];
};

export type ProgramProgramSchemaObjectEqualityInput = {
  adks?: InputMaybe<Array<ProgramProgramSchemaAdksObjectEqualityInput>>;
  id: Scalars['String']['input'];
};

export type ProgramRelationFilter = {
  is?: InputMaybe<ProgramWhereInput>;
  isNot?: InputMaybe<ProgramWhereInput>;
};

/** How a program relates to an organization */
export enum ProgramRelationship {
  Created = 'CREATED',
  MemberOrganized = 'MEMBER_ORGANIZED',
  Sponsored = 'SPONSORED'
}

export type ProgramRevisionAdks = {
  __typename?: 'ProgramRevisionAdks';
  activityImage?: Maybe<Scalars['String']['output']>;
  activitySettings?: Maybe<ProgramRevisionAdksActivitySettings>;
  agreementInstructions?: Maybe<Scalars['String']['output']>;
  agreementLink?: Maybe<Scalars['String']['output']>;
  airtableRecordId?: Maybe<Scalars['String']['output']>;
  buildScope?: Maybe<ProgramRevisionAdksBuildScope>;
  builderType?: Maybe<Scalars['String']['output']>;
  category?: Maybe<Scalars['String']['output']>;
  clockIn?: Maybe<Scalars['String']['output']>;
  clockOut?: Maybe<Scalars['String']['output']>;
  /** Multiple data types found: String: 87.9%, Boolean: 0%, DateTime (Date): 12.1% out of 3742 sampled entries */
  completed?: Maybe<Scalars['JSON']['output']>;
  connection?: Maybe<Scalars['String']['output']>;
  /** Could not determine type: the field only had null or empty values in the sample set. */
  credentials?: Maybe<Scalars['JSON']['output']>;
  defaultActivity?: Maybe<ProgramRevisionAdksDefaultActivity>;
  deliverable?: Maybe<Scalars['String']['output']>;
  deliverableActivity?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  discordEmployerChannel?: Maybe<Scalars['String']['output']>;
  discordEntityType?: Maybe<Scalars['String']['output']>;
  employerWebsite?: Maybe<Scalars['String']['output']>;
  endEarlyActivity?: Maybe<Scalars['String']['output']>;
  fields?: Maybe<Array<ProgramRevisionAdksFields>>;
  finalPresentationDate?: Maybe<Scalars['String']['output']>;
  formEmbedUrl?: Maybe<Scalars['String']['output']>;
  groupActivity?: Maybe<Scalars['String']['output']>;
  icon?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  idealActivityCompletionTime?: Maybe<Scalars['Int']['output']>;
  instruction?: Maybe<ProgramRevisionAdksInstruction>;
  interviewReqeust?: Maybe<Scalars['String']['output']>;
  introVideo?: Maybe<Scalars['String']['output']>;
  isPreview?: Maybe<Scalars['Boolean']['output']>;
  isSaved?: Maybe<Scalars['Boolean']['output']>;
  isSkippable?: Maybe<Scalars['Boolean']['output']>;
  isTeamAdk?: Maybe<Scalars['Boolean']['output']>;
  isVideoask?: Maybe<Scalars['Boolean']['output']>;
  keyResults?: Maybe<Array<Scalars['String']['output']>>;
  name: Scalars['String']['output'];
  optional?: Maybe<Scalars['Boolean']['output']>;
  permissions?: Maybe<Array<ProgramRevisionAdksPermissions>>;
  position?: Maybe<Scalars['Int']['output']>;
  presetFields?: Maybe<Array<ProgramRevisionAdksPresetFields>>;
  preview?: Maybe<Scalars['Boolean']['output']>;
  primaryObjective?: Maybe<Scalars['String']['output']>;
  projectScope?: Maybe<Scalars['String']['output']>;
  reminder?: Maybe<Scalars['String']['output']>;
  required?: Maybe<Scalars['Boolean']['output']>;
  requiredActivity?: Maybe<Scalars['String']['output']>;
  /** Could not determine type: the field only had null or empty values in the sample set. */
  rewards?: Maybe<Scalars['JSON']['output']>;
  rfp?: Maybe<ProgramRevisionAdksRfp>;
  scope?: Maybe<ProgramRevisionAdksScope>;
  setupRequired?: Maybe<Scalars['Boolean']['output']>;
  /** Multiple data types found: String: 0.7%, Boolean: 99.3% out of 10410 sampled entries */
  status?: Maybe<Scalars['JSON']['output']>;
  styling?: Maybe<ProgramRevisionAdksStyling>;
  tagId?: Maybe<Scalars['String']['output']>;
  timeInForCountDown?: Maybe<Scalars['String']['output']>;
  timeToSolveProblem?: Maybe<Scalars['Int']['output']>;
  weeklyConferenceLink?: Maybe<Scalars['String']['output']>;
  weeklyMeetingCadence?: Maybe<Scalars['String']['output']>;
  weeklyMeetingDay?: Maybe<Scalars['String']['output']>;
  weeklyMeetingTime?: Maybe<Scalars['String']['output']>;
};

export type ProgramRevisionAdksActivitySettings = {
  __typename?: 'ProgramRevisionAdksActivitySettings';
  /** Could not determine type: the field only had null or empty values in the sample set. */
  activityGroups?: Maybe<Scalars['JSON']['output']>;
  activityPlacement?: Maybe<Scalars['String']['output']>;
  activityRequired?: Maybe<Scalars['String']['output']>;
  /** Could not determine type: the field only had null or empty values in the sample set. */
  activityView?: Maybe<Scalars['JSON']['output']>;
  /** Could not determine type: the field only had null or empty values in the sample set. */
  allowToEndProgramEarly?: Maybe<Scalars['JSON']['output']>;
  idealTime?: Maybe<Scalars['String']['output']>;
  instructions?: Maybe<Scalars['String']['output']>;
  isDeliverable?: Maybe<Scalars['String']['output']>;
  /** Could not determine type: the field only had null or empty values in the sample set. */
  makeActivityAccessible?: Maybe<Scalars['JSON']['output']>;
  /** Could not determine type: the field only had null or empty values in the sample set. */
  merits?: Maybe<Scalars['JSON']['output']>;
  mongoDbChart?: Maybe<Scalars['String']['output']>;
  outcomes?: Maybe<Scalars['String']['output']>;
  /** Could not determine type: the field only had null or empty values in the sample set. */
  participantAndTeamData?: Maybe<Scalars['JSON']['output']>;
  /** Could not determine type: the field only had null or empty values in the sample set. */
  postActivityReflection?: Maybe<Scalars['JSON']['output']>;
  /** Could not determine type: the field only had null or empty values in the sample set. */
  presetAndSetup?: Maybe<Scalars['JSON']['output']>;
  /** Could not determine type: the field only had null or empty values in the sample set. */
  programTemplates?: Maybe<Scalars['JSON']['output']>;
  reminder?: Maybe<Scalars['String']['output']>;
  requirements?: Maybe<Array<Scalars['String']['output']>>;
  /** Could not determine type: the field only had null or empty values in the sample set. */
  resourceTypes?: Maybe<Scalars['JSON']['output']>;
  timeInForCountDown?: Maybe<Scalars['String']['output']>;
  /** Could not determine type: the field only had null or empty values in the sample set. */
  typeOfCharts?: Maybe<Scalars['JSON']['output']>;
};

export type ProgramRevisionAdksBuildScope = {
  __typename?: 'ProgramRevisionAdksBuildScope';
  objectives?: Maybe<Array<ProgramRevisionAdksBuildScopeObjectives>>;
  projects?: Maybe<Array<ProgramRevisionAdksBuildScopeProjects>>;
};

export type ProgramRevisionAdksBuildScopeObjectives = {
  __typename?: 'ProgramRevisionAdksBuildScopeObjectives';
  action?: Maybe<Scalars['String']['output']>;
  icon?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  position: Scalars['Int']['output'];
  roles?: Maybe<Array<Scalars['String']['output']>>;
  /** Could not determine type: the field only had null or empty values in the sample set. */
  rules?: Maybe<Scalars['JSON']['output']>;
  styling?: Maybe<ProgramRevisionAdksBuildScopeObjectivesStyling>;
  target?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
};

export type ProgramRevisionAdksBuildScopeObjectivesStyling = {
  __typename?: 'ProgramRevisionAdksBuildScopeObjectivesStyling';
  depressed?: Maybe<Scalars['Boolean']['output']>;
  hint?: Maybe<Scalars['String']['output']>;
  icon?: Maybe<Scalars['String']['output']>;
  label: Scalars['String']['output'];
  leftIcon?: Maybe<Scalars['String']['output']>;
  outlined: Scalars['Boolean']['output'];
  placeholder?: Maybe<Scalars['String']['output']>;
  rightIcon?: Maybe<Scalars['String']['output']>;
  rounded: Scalars['Boolean']['output'];
  small?: Maybe<Scalars['Boolean']['output']>;
};

export type ProgramRevisionAdksBuildScopeProjects = {
  __typename?: 'ProgramRevisionAdksBuildScopeProjects';
  action?: Maybe<Scalars['String']['output']>;
  icon?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  position: Scalars['Int']['output'];
  roles?: Maybe<Array<Scalars['String']['output']>>;
  styling?: Maybe<ProgramRevisionAdksBuildScopeProjectsStyling>;
  target?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
};

export type ProgramRevisionAdksBuildScopeProjectsStyling = {
  __typename?: 'ProgramRevisionAdksBuildScopeProjectsStyling';
  color: Scalars['String']['output'];
  depressed: Scalars['Boolean']['output'];
  label: Scalars['String']['output'];
  leftIcon: Scalars['String']['output'];
  rounded: Scalars['Boolean']['output'];
};

export type ProgramRevisionAdksDefaultActivity = {
  __typename?: 'ProgramRevisionAdksDefaultActivity';
  deliverableActivity: Scalars['String']['output'];
  endEarlyActivity: Scalars['String']['output'];
  groupActivity: Scalars['String']['output'];
  required: Scalars['Boolean']['output'];
  requiredActivity: Scalars['String']['output'];
};

export type ProgramRevisionAdksFields = {
  __typename?: 'ProgramRevisionAdksFields';
  action?: Maybe<Scalars['String']['output']>;
  active?: Maybe<Scalars['Boolean']['output']>;
  adk?: Maybe<Scalars['String']['output']>;
  ages?: Maybe<Scalars['String']['output']>;
  align?: Maybe<Scalars['String']['output']>;
  blank?: Maybe<Scalars['Boolean']['output']>;
  builderType?: Maybe<Scalars['String']['output']>;
  color?: Maybe<Scalars['String']['output']>;
  dark?: Maybe<Scalars['Boolean']['output']>;
  /** Multiple data types found: String: 18.5%, Boolean: 59.2%, Int: 22.2% out of 12667 sampled entries */
  defaultValue?: Maybe<Scalars['JSON']['output']>;
  /** Multiple data types found: String: 23%, ProgramRevisionAdksFieldsEvent: 77% out of 965 sampled entries */
  event?: Maybe<Scalars['JSON']['output']>;
  header?: Maybe<Scalars['String']['output']>;
  href?: Maybe<Scalars['String']['output']>;
  icon?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  /** Multiple data types found: Array(String): 71.1%, Array(Int): 28.9% out of 3483 sampled entries */
  items?: Maybe<Scalars['JSON']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  max?: Maybe<Scalars['String']['output']>;
  maxDate?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  min?: Maybe<Scalars['String']['output']>;
  minDate?: Maybe<Scalars['String']['output']>;
  model?: Maybe<Scalars['String']['output']>;
  modelItems?: Maybe<Array<ProgramRevisionAdksFieldsModelItems>>;
  multiple?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  noSetup?: Maybe<Scalars['Boolean']['output']>;
  outlined?: Maybe<Scalars['Boolean']['output']>;
  placeholder?: Maybe<Scalars['String']['output']>;
  position?: Maybe<Scalars['Int']['output']>;
  preset?: Maybe<ProgramRevisionAdksFieldsPreset>;
  radioButtons?: Maybe<Array<ProgramRevisionAdksFieldsRadioButtons>>;
  required?: Maybe<Scalars['Boolean']['output']>;
  roles?: Maybe<Array<Scalars['String']['output']>>;
  rounded?: Maybe<Scalars['Boolean']['output']>;
  rules?: Maybe<Array<Scalars['String']['output']>>;
  searchInput?: Maybe<Scalars['String']['output']>;
  searchType?: Maybe<Scalars['String']['output']>;
  setup?: Maybe<ProgramRevisionAdksFieldsSetup>;
  styling?: Maybe<ProgramRevisionAdksFieldsStyling>;
  subTitle?: Maybe<Scalars['String']['output']>;
  target?: Maybe<Scalars['String']['output']>;
  tickSize?: Maybe<Scalars['Int']['output']>;
  ticks?: Maybe<Scalars['Boolean']['output']>;
  timelineItems?: Maybe<Array<ProgramRevisionAdksFieldsTimelineItems>>;
  title?: Maybe<Scalars['String']['output']>;
  titleAfterChip?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  vChipContent?: Maybe<Scalars['String']['output']>;
  value?: Maybe<ProgramRevisionAdksFieldsValue>;
  videoAskLabel?: Maybe<Scalars['String']['output']>;
  videoAskUrl?: Maybe<Scalars['String']['output']>;
};

export type ProgramRevisionAdksFieldsModelItems = {
  __typename?: 'ProgramRevisionAdksFieldsModelItems';
  name: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type ProgramRevisionAdksFieldsPreset = {
  __typename?: 'ProgramRevisionAdksFieldsPreset';
  aboutOrg?: Maybe<Scalars['String']['output']>;
  acceptanceDeadline?: Maybe<Scalars['String']['output']>;
  apprentice?: Maybe<Scalars['Boolean']['output']>;
  compensation1?: Maybe<Scalars['Boolean']['output']>;
  compensation2?: Maybe<Scalars['Boolean']['output']>;
  compensation3?: Maybe<Scalars['Boolean']['output']>;
  compensation4?: Maybe<Scalars['Boolean']['output']>;
  compensation5?: Maybe<Scalars['Boolean']['output']>;
  compensation6?: Maybe<Scalars['Boolean']['output']>;
  continuation?: Maybe<Scalars['Int']['output']>;
  eir?: Maybe<Scalars['Boolean']['output']>;
  employerRecord?: Maybe<Scalars['Int']['output']>;
  extern?: Maybe<Scalars['Boolean']['output']>;
  externCredential?: Maybe<Scalars['Int']['output']>;
  fellow?: Maybe<Scalars['Boolean']['output']>;
  intern?: Maybe<Scalars['Boolean']['output']>;
  internshipEnd?: Maybe<Scalars['String']['output']>;
  internshipProject1?: Maybe<Scalars['Boolean']['output']>;
  internshipProject2?: Maybe<Scalars['Boolean']['output']>;
  internshipProject3?: Maybe<Scalars['Boolean']['output']>;
  internshipStart?: Maybe<Scalars['String']['output']>;
  interviewChallenge?: Maybe<Scalars['String']['output']>;
  interviewOpportunity?: Maybe<Scalars['String']['output']>;
  interviewProblem?: Maybe<Scalars['String']['output']>;
  interviewRequest?: Maybe<Scalars['String']['output']>;
  interviewSolution?: Maybe<Scalars['String']['output']>;
  licenseRequirement?: Maybe<Scalars['Int']['output']>;
  maxCharacters?: Maybe<Scalars['String']['output']>;
  maxHours?: Maybe<Scalars['Int']['output']>;
  maxTeamMembers?: Maybe<Scalars['Int']['output']>;
  maximumBudget?: Maybe<Scalars['String']['output']>;
  minHours?: Maybe<Scalars['Int']['output']>;
  minLogs?: Maybe<Scalars['Int']['output']>;
  minimumBudget?: Maybe<Scalars['String']['output']>;
  pathways?: Maybe<Array<Scalars['String']['output']>>;
  preApprentice?: Maybe<Scalars['Boolean']['output']>;
  preInternship?: Maybe<Scalars['Boolean']['output']>;
  programDesc?: Maybe<Scalars['String']['output']>;
  programName?: Maybe<Scalars['String']['output']>;
  projectReq?: Maybe<Array<Scalars['String']['output']>>;
  /** Could not determine type: the field only had null or empty values in the sample set. */
  requiredResidency?: Maybe<Scalars['JSON']['output']>;
  requiredSkills?: Maybe<Array<Scalars['String']['output']>>;
  /** Could not determine type: the field only had null or empty values in the sample set. */
  resourceDrive?: Maybe<Scalars['JSON']['output']>;
  resourceFacebook?: Maybe<Scalars['String']['output']>;
  /** Could not determine type: the field only had null or empty values in the sample set. */
  resourceInsta?: Maybe<Scalars['JSON']['output']>;
  resourceLinkedIn?: Maybe<Scalars['String']['output']>;
  resourceTwitter?: Maybe<Scalars['String']['output']>;
  resourceWeb?: Maybe<Scalars['String']['output']>;
  /** Could not determine type: the field only had null or empty values in the sample set. */
  resourceYouTube?: Maybe<Scalars['JSON']['output']>;
  rewards?: Maybe<Array<Scalars['String']['output']>>;
  videoMaxLength?: Maybe<Scalars['Int']['output']>;
};

export type ProgramRevisionAdksFieldsRadioButtons = {
  __typename?: 'ProgramRevisionAdksFieldsRadioButtons';
  action?: Maybe<Scalars['String']['output']>;
  clickable?: Maybe<Scalars['Boolean']['output']>;
  event?: Maybe<ProgramRevisionAdksFieldsRadioButtonsEvent>;
  label: Scalars['String']['output'];
};

export type ProgramRevisionAdksFieldsRadioButtonsEvent = {
  __typename?: 'ProgramRevisionAdksFieldsRadioButtonsEvent';
  body: Scalars['String']['output'];
  buttons?: Maybe<Array<ProgramRevisionAdksFieldsRadioButtonsEventButtons>>;
  component: Scalars['String']['output'];
  title: Scalars['String']['output'];
  trigger: Scalars['String']['output'];
};

export type ProgramRevisionAdksFieldsRadioButtonsEventButtons = {
  __typename?: 'ProgramRevisionAdksFieldsRadioButtonsEventButtons';
  label: Scalars['String']['output'];
  model: Scalars['String']['output'];
  style: ProgramRevisionAdksFieldsRadioButtonsEventButtonsStyle;
};

export type ProgramRevisionAdksFieldsRadioButtonsEventButtonsStyle = {
  __typename?: 'ProgramRevisionAdksFieldsRadioButtonsEventButtonsStyle';
  class: Scalars['String']['output'];
  color: Scalars['String']['output'];
  dark?: Maybe<Scalars['Boolean']['output']>;
  depressed?: Maybe<Scalars['Boolean']['output']>;
  outlined: Scalars['Boolean']['output'];
  rounded: Scalars['Boolean']['output'];
  xLarge: Scalars['Boolean']['output'];
};

export type ProgramRevisionAdksFieldsSetup = {
  __typename?: 'ProgramRevisionAdksFieldsSetup';
  Link?: Maybe<Scalars['String']['output']>;
  aboutOrg?: Maybe<Scalars['String']['output']>;
  acceptanceDeadline?: Maybe<Scalars['String']['output']>;
  action?: Maybe<ProgramRevisionAdksFieldsSetupAction>;
  /** Multiple data types found: Array(String): 7.2%, Array(Int): 92.8% out of 207 sampled entries */
  ageRange?: Maybe<Scalars['JSON']['output']>;
  airtableFormLink?: Maybe<Scalars['String']['output']>;
  airtableLink?: Maybe<Scalars['String']['output']>;
  airtableResponseLink?: Maybe<Scalars['String']['output']>;
  airtableTableLink?: Maybe<Scalars['String']['output']>;
  apprentice?: Maybe<Scalars['Boolean']['output']>;
  arrivalLink?: Maybe<Scalars['String']['output']>;
  arrivalStatus?: Maybe<Scalars['String']['output']>;
  attendeeList?: Maybe<Scalars['String']['output']>;
  /** Could not determine type: the field only had null or empty values in the sample set. */
  boards?: Maybe<Scalars['JSON']['output']>;
  channels?: Maybe<Array<ProgramRevisionAdksFieldsSetupChannels>>;
  checkinLink?: Maybe<Scalars['String']['output']>;
  compensation1?: Maybe<Scalars['Boolean']['output']>;
  compensation2?: Maybe<Scalars['Boolean']['output']>;
  compensation3?: Maybe<Scalars['Boolean']['output']>;
  compensation4?: Maybe<Scalars['Boolean']['output']>;
  compensation5?: Maybe<Scalars['Boolean']['output']>;
  compensation6?: Maybe<Scalars['Boolean']['output']>;
  connection?: Maybe<Scalars['String']['output']>;
  continuation?: Maybe<Scalars['Int']['output']>;
  defaultActivity?: Maybe<ProgramRevisionAdksFieldsSetupDefaultActivity>;
  deliverable?: Maybe<Array<Scalars['String']['output']>>;
  discordLink?: Maybe<Scalars['String']['output']>;
  docDesc?: Maybe<Scalars['String']['output']>;
  eir?: Maybe<Scalars['Boolean']['output']>;
  employerRecord?: Maybe<Scalars['Int']['output']>;
  eventAgenda?: Maybe<Scalars['String']['output']>;
  eventDate?: Maybe<Scalars['String']['output']>;
  eventLocations?: Maybe<Scalars['String']['output']>;
  eventName?: Maybe<Scalars['String']['output']>;
  events?: Maybe<ProgramRevisionAdksFieldsSetupEvents>;
  extern?: Maybe<Scalars['Boolean']['output']>;
  /** Multiple data types found: Float: 1.1%, Int: 98.9% out of 263 sampled entries */
  externCredential?: Maybe<Scalars['JSON']['output']>;
  fellow?: Maybe<Scalars['Boolean']['output']>;
  fileType?: Maybe<Array<Scalars['String']['output']>>;
  form_id?: Maybe<Scalars['String']['output']>;
  form_url?: Maybe<Scalars['String']['output']>;
  instagramEmbedLink?: Maybe<Scalars['String']['output']>;
  instructions?: Maybe<Scalars['String']['output']>;
  intern?: Maybe<Scalars['Boolean']['output']>;
  internshipEnd?: Maybe<Scalars['String']['output']>;
  internshipProject1?: Maybe<Scalars['Boolean']['output']>;
  internshipProject2?: Maybe<Scalars['Boolean']['output']>;
  internshipProject3?: Maybe<Scalars['Boolean']['output']>;
  internshipStart?: Maybe<Scalars['String']['output']>;
  interviewChallenge?: Maybe<Scalars['String']['output']>;
  interviewOpportunity?: Maybe<Scalars['String']['output']>;
  interviewProblem?: Maybe<Scalars['String']['output']>;
  interviewRequest?: Maybe<Scalars['String']['output']>;
  interviewSolution?: Maybe<Scalars['String']['output']>;
  /** Could not determine type: the field only had null or empty values in the sample set. */
  keyResults?: Maybe<Scalars['JSON']['output']>;
  licenseRequirement?: Maybe<Scalars['Int']['output']>;
  link?: Maybe<Scalars['String']['output']>;
  maxHours?: Maybe<Scalars['Int']['output']>;
  maximumBudget?: Maybe<Scalars['String']['output']>;
  minHours?: Maybe<Scalars['Int']['output']>;
  minimumBudget?: Maybe<Scalars['String']['output']>;
  objective?: Maybe<Scalars['String']['output']>;
  outcome?: Maybe<Array<Scalars['String']['output']>>;
  pathways?: Maybe<Array<Scalars['String']['output']>>;
  preApprentice?: Maybe<Scalars['Boolean']['output']>;
  preInternship?: Maybe<Scalars['Boolean']['output']>;
  programDesc?: Maybe<Scalars['String']['output']>;
  programName?: Maybe<Scalars['String']['output']>;
  /** Multiple data types found: String: 1.3%, Array(String): 98.7% out of 962 sampled entries */
  projectReq?: Maybe<Scalars['JSON']['output']>;
  providers?: Maybe<ProgramRevisionAdksFieldsSetupProviders>;
  /** Multiple data types found: String: 66.7%, Array(String): 33.3% out of 66 sampled entries */
  requiredResidency?: Maybe<Scalars['JSON']['output']>;
  requiredSkills?: Maybe<Array<Scalars['String']['output']>>;
  researchLinks?: Maybe<Array<ProgramRevisionAdksFieldsSetupResearchLinks>>;
  researchProgress?: Maybe<Array<ProgramRevisionAdksFieldsSetupResearchProgress>>;
  resourceDrive?: Maybe<Scalars['String']['output']>;
  resourceFacebook?: Maybe<Scalars['String']['output']>;
  resourceInsta?: Maybe<Scalars['String']['output']>;
  resourceLinkedIn?: Maybe<Scalars['String']['output']>;
  resourceTwitter?: Maybe<Scalars['String']['output']>;
  resourceWeb?: Maybe<Scalars['String']['output']>;
  resourceYouTube?: Maybe<Scalars['String']['output']>;
  rewards?: Maybe<Array<Scalars['String']['output']>>;
  rsvpLink?: Maybe<Scalars['String']['output']>;
  sponsorHandle?: Maybe<Scalars['String']['output']>;
  sponsorOrganization?: Maybe<Scalars['String']['output']>;
  timeFrame?: Maybe<Array<ProgramRevisionAdksFieldsSetupTimeFrame>>;
  timeZone?: Maybe<Scalars['String']['output']>;
  uploadLimit?: Maybe<ProgramRevisionAdksFieldsSetupUploadLimit>;
  uploadLink?: Maybe<Scalars['String']['output']>;
  videoLinks?: Maybe<Array<ProgramRevisionAdksFieldsSetupVideoLinks>>;
  videoaskEmbed?: Maybe<Scalars['String']['output']>;
  videoaskLink?: Maybe<Scalars['String']['output']>;
  videoaskResponseLink?: Maybe<Scalars['String']['output']>;
  youtubeLink?: Maybe<Scalars['String']['output']>;
};

export type ProgramRevisionAdksFieldsSetupAction = {
  __typename?: 'ProgramRevisionAdksFieldsSetupAction';
  desc: Scalars['String']['output'];
  link: Scalars['String']['output'];
};

export type ProgramRevisionAdksFieldsSetupChannels = {
  __typename?: 'ProgramRevisionAdksFieldsSetupChannels';
  linkName?: Maybe<Scalars['String']['output']>;
  teamName?: Maybe<Scalars['String']['output']>;
  url: Scalars['String']['output'];
};

export type ProgramRevisionAdksFieldsSetupDefaultActivity = {
  __typename?: 'ProgramRevisionAdksFieldsSetupDefaultActivity';
  deliverableActivity: Scalars['String']['output'];
  endEarlyActivity: Scalars['String']['output'];
  groupActivity: Scalars['String']['output'];
  required: Scalars['Boolean']['output'];
  requiredActivity: Scalars['String']['output'];
};

export type ProgramRevisionAdksFieldsSetupEvents = {
  __typename?: 'ProgramRevisionAdksFieldsSetupEvents';
  created_by: Scalars['String']['output'];
  startDateTime: Scalars['String']['output'];
  weekly_meeting: ProgramRevisionAdksFieldsSetupEventsWeeklyMeeting;
  weekly_meeting_participants?: Maybe<Array<Scalars['String']['output']>>;
};

export type ProgramRevisionAdksFieldsSetupEventsWeeklyMeeting = {
  __typename?: 'ProgramRevisionAdksFieldsSetupEventsWeeklyMeeting';
  attendees?: Maybe<Array<ProgramRevisionAdksFieldsSetupEventsWeeklyMeetingAttendees>>;
  conferenceData: ProgramRevisionAdksFieldsSetupEventsWeeklyMeetingConferenceData;
  created: Scalars['String']['output'];
  creator: ProgramRevisionAdksFieldsSetupEventsWeeklyMeetingCreator;
  description: Scalars['String']['output'];
  end: ProgramRevisionAdksFieldsSetupEventsWeeklyMeetingEnd;
  etag: Scalars['String']['output'];
  eventType: Scalars['String']['output'];
  hangoutLink: Scalars['String']['output'];
  htmlLink: Scalars['String']['output'];
  iCalUID: Scalars['String']['output'];
  id: Scalars['String']['output'];
  kind: Scalars['String']['output'];
  organizer: ProgramRevisionAdksFieldsSetupEventsWeeklyMeetingOrganizer;
  recurrence?: Maybe<Array<Scalars['String']['output']>>;
  reminders: ProgramRevisionAdksFieldsSetupEventsWeeklyMeetingReminders;
  sequence?: Maybe<Scalars['Int']['output']>;
  start: ProgramRevisionAdksFieldsSetupEventsWeeklyMeetingStart;
  status: Scalars['String']['output'];
  summary: Scalars['String']['output'];
  updated: Scalars['String']['output'];
};

export type ProgramRevisionAdksFieldsSetupEventsWeeklyMeetingAttendees = {
  __typename?: 'ProgramRevisionAdksFieldsSetupEventsWeeklyMeetingAttendees';
  email: Scalars['String']['output'];
  organizer?: Maybe<Scalars['Boolean']['output']>;
  responseStatus?: Maybe<Scalars['String']['output']>;
  self?: Maybe<Scalars['Boolean']['output']>;
};

export type ProgramRevisionAdksFieldsSetupEventsWeeklyMeetingConferenceData = {
  __typename?: 'ProgramRevisionAdksFieldsSetupEventsWeeklyMeetingConferenceData';
  conferenceId: Scalars['String']['output'];
  conferenceSolution: ProgramRevisionAdksFieldsSetupEventsWeeklyMeetingConferenceDataConferenceSolution;
  createRequest: ProgramRevisionAdksFieldsSetupEventsWeeklyMeetingConferenceDataCreateRequest;
  entryPoints?: Maybe<Array<ProgramRevisionAdksFieldsSetupEventsWeeklyMeetingConferenceDataEntryPoints>>;
};

export type ProgramRevisionAdksFieldsSetupEventsWeeklyMeetingConferenceDataConferenceSolution = {
  __typename?: 'ProgramRevisionAdksFieldsSetupEventsWeeklyMeetingConferenceDataConferenceSolution';
  iconUri: Scalars['String']['output'];
  key: ProgramRevisionAdksFieldsSetupEventsWeeklyMeetingConferenceDataConferenceSolutionKey;
  name: Scalars['String']['output'];
};

export type ProgramRevisionAdksFieldsSetupEventsWeeklyMeetingConferenceDataConferenceSolutionKey = {
  __typename?: 'ProgramRevisionAdksFieldsSetupEventsWeeklyMeetingConferenceDataConferenceSolutionKey';
  type: Scalars['String']['output'];
};

export type ProgramRevisionAdksFieldsSetupEventsWeeklyMeetingConferenceDataCreateRequest = {
  __typename?: 'ProgramRevisionAdksFieldsSetupEventsWeeklyMeetingConferenceDataCreateRequest';
  conferenceSolutionKey: ProgramRevisionAdksFieldsSetupEventsWeeklyMeetingConferenceDataCreateRequestConferenceSolutionKey;
  requestId: Scalars['String']['output'];
  status: ProgramRevisionAdksFieldsSetupEventsWeeklyMeetingConferenceDataCreateRequestStatus;
};

export type ProgramRevisionAdksFieldsSetupEventsWeeklyMeetingConferenceDataCreateRequestConferenceSolutionKey = {
  __typename?: 'ProgramRevisionAdksFieldsSetupEventsWeeklyMeetingConferenceDataCreateRequestConferenceSolutionKey';
  type: Scalars['String']['output'];
};

export type ProgramRevisionAdksFieldsSetupEventsWeeklyMeetingConferenceDataCreateRequestStatus = {
  __typename?: 'ProgramRevisionAdksFieldsSetupEventsWeeklyMeetingConferenceDataCreateRequestStatus';
  statusCode: Scalars['String']['output'];
};

export type ProgramRevisionAdksFieldsSetupEventsWeeklyMeetingConferenceDataEntryPoints = {
  __typename?: 'ProgramRevisionAdksFieldsSetupEventsWeeklyMeetingConferenceDataEntryPoints';
  entryPointType: Scalars['String']['output'];
  label?: Maybe<Scalars['String']['output']>;
  pin?: Maybe<Scalars['String']['output']>;
  regionCode?: Maybe<Scalars['String']['output']>;
  uri: Scalars['String']['output'];
};

export type ProgramRevisionAdksFieldsSetupEventsWeeklyMeetingCreator = {
  __typename?: 'ProgramRevisionAdksFieldsSetupEventsWeeklyMeetingCreator';
  email: Scalars['String']['output'];
  self: Scalars['Boolean']['output'];
};

export type ProgramRevisionAdksFieldsSetupEventsWeeklyMeetingEnd = {
  __typename?: 'ProgramRevisionAdksFieldsSetupEventsWeeklyMeetingEnd';
  dateTime: Scalars['String']['output'];
  timeZone: Scalars['String']['output'];
};

export type ProgramRevisionAdksFieldsSetupEventsWeeklyMeetingOrganizer = {
  __typename?: 'ProgramRevisionAdksFieldsSetupEventsWeeklyMeetingOrganizer';
  email: Scalars['String']['output'];
  self: Scalars['Boolean']['output'];
};

export type ProgramRevisionAdksFieldsSetupEventsWeeklyMeetingReminders = {
  __typename?: 'ProgramRevisionAdksFieldsSetupEventsWeeklyMeetingReminders';
  overrides?: Maybe<Array<ProgramRevisionAdksFieldsSetupEventsWeeklyMeetingRemindersOverrides>>;
  useDefault: Scalars['Boolean']['output'];
};

export type ProgramRevisionAdksFieldsSetupEventsWeeklyMeetingRemindersOverrides = {
  __typename?: 'ProgramRevisionAdksFieldsSetupEventsWeeklyMeetingRemindersOverrides';
  method: Scalars['String']['output'];
  minutes: Scalars['Int']['output'];
};

export type ProgramRevisionAdksFieldsSetupEventsWeeklyMeetingStart = {
  __typename?: 'ProgramRevisionAdksFieldsSetupEventsWeeklyMeetingStart';
  dateTime: Scalars['String']['output'];
  timeZone: Scalars['String']['output'];
};

export type ProgramRevisionAdksFieldsSetupProviders = {
  __typename?: 'ProgramRevisionAdksFieldsSetupProviders';
  apple: Scalars['Boolean']['output'];
  google: Scalars['Boolean']['output'];
  web: Scalars['Boolean']['output'];
};

export type ProgramRevisionAdksFieldsSetupResearchLinks = {
  __typename?: 'ProgramRevisionAdksFieldsSetupResearchLinks';
  completed?: Maybe<Scalars['Boolean']['output']>;
  isValid?: Maybe<Scalars['Boolean']['output']>;
  link: Scalars['String']['output'];
  required: Scalars['Boolean']['output'];
  resource: Scalars['String']['output'];
  unlocked?: Maybe<Scalars['Boolean']['output']>;
};

export type ProgramRevisionAdksFieldsSetupResearchProgress = {
  __typename?: 'ProgramRevisionAdksFieldsSetupResearchProgress';
  link: Scalars['String']['output'];
  required: Scalars['Boolean']['output'];
  resource: Scalars['String']['output'];
};

export type ProgramRevisionAdksFieldsSetupTimeFrame = {
  __typename?: 'ProgramRevisionAdksFieldsSetupTimeFrame';
  end: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  isCondensed: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  notes: Scalars['String']['output'];
  start: Scalars['String']['output'];
  visibility: Scalars['String']['output'];
};

export type ProgramRevisionAdksFieldsSetupUploadLimit = {
  __typename?: 'ProgramRevisionAdksFieldsSetupUploadLimit';
  max: Scalars['Int']['output'];
  min: Scalars['Int']['output'];
};

export type ProgramRevisionAdksFieldsSetupVideoLinks = {
  __typename?: 'ProgramRevisionAdksFieldsSetupVideoLinks';
  completed?: Maybe<Scalars['Boolean']['output']>;
  is_processing?: Maybe<Scalars['Boolean']['output']>;
  is_videoask?: Maybe<Scalars['Boolean']['output']>;
  link: Scalars['String']['output'];
  name: Scalars['String']['output'];
  required?: Maybe<Scalars['Boolean']['output']>;
  unlocked?: Maybe<Scalars['Boolean']['output']>;
  videoAskResponse?: Maybe<ProgramRevisionAdksFieldsSetupVideoLinksVideoAskResponse>;
  videoask_question_url?: Maybe<Scalars['String']['output']>;
};

export type ProgramRevisionAdksFieldsSetupVideoLinksVideoAskResponse = {
  __typename?: 'ProgramRevisionAdksFieldsSetupVideoLinksVideoAskResponse';
  contact: ProgramRevisionAdksFieldsSetupVideoLinksVideoAskResponseContact;
  event_id: Scalars['String']['output'];
  event_type: Scalars['String']['output'];
  form: ProgramRevisionAdksFieldsSetupVideoLinksVideoAskResponseForm;
  interaction_id: Scalars['String']['output'];
};

export type ProgramRevisionAdksFieldsSetupVideoLinksVideoAskResponseContact = {
  __typename?: 'ProgramRevisionAdksFieldsSetupVideoLinksVideoAskResponseContact';
  answers?: Maybe<Array<ProgramRevisionAdksFieldsSetupVideoLinksVideoAskResponseContactAnswers>>;
  are_answers_public: Scalars['Boolean']['output'];
  are_messages_public: Scalars['Boolean']['output'];
  contact_id: Scalars['String']['output'];
  email: Scalars['String']['output'];
  platform: Scalars['String']['output'];
  share_id: Scalars['String']['output'];
  share_url: Scalars['String']['output'];
  status: Scalars['String']['output'];
};

export type ProgramRevisionAdksFieldsSetupVideoLinksVideoAskResponseContactAnswers = {
  __typename?: 'ProgramRevisionAdksFieldsSetupVideoLinksVideoAskResponseContactAnswers';
  answer_id: Scalars['String']['output'];
  media_id?: Maybe<Scalars['String']['output']>;
  media_url?: Maybe<Scalars['String']['output']>;
  poll_options?: Maybe<Array<ProgramRevisionAdksFieldsSetupVideoLinksVideoAskResponseContactAnswersPollOptions>>;
  question_id: Scalars['String']['output'];
};

export type ProgramRevisionAdksFieldsSetupVideoLinksVideoAskResponseContactAnswersPollOptions = {
  __typename?: 'ProgramRevisionAdksFieldsSetupVideoLinksVideoAskResponseContactAnswersPollOptions';
  content: Scalars['String']['output'];
  id: Scalars['String']['output'];
  ref: Scalars['String']['output'];
};

export type ProgramRevisionAdksFieldsSetupVideoLinksVideoAskResponseForm = {
  __typename?: 'ProgramRevisionAdksFieldsSetupVideoLinksVideoAskResponseForm';
  are_answers_public: Scalars['Boolean']['output'];
  are_messages_public: Scalars['Boolean']['output'];
  form_id: Scalars['String']['output'];
  hide_branding: Scalars['Boolean']['output'];
  idle_deadline_time_in_minutes: Scalars['Int']['output'];
  notifications: ProgramRevisionAdksFieldsSetupVideoLinksVideoAskResponseFormNotifications;
  questions?: Maybe<Array<ProgramRevisionAdksFieldsSetupVideoLinksVideoAskResponseFormQuestions>>;
  requires_consent: Scalars['Boolean']['output'];
  requires_contact_email: Scalars['Boolean']['output'];
  requires_contact_info: Scalars['Boolean']['output'];
  requires_contact_name: Scalars['Boolean']['output'];
  requires_contact_phone_number: Scalars['Boolean']['output'];
  respondents_count: Scalars['Int']['output'];
  responses_share_id: Scalars['String']['output'];
  responses_share_url: Scalars['String']['output'];
  share_id: Scalars['String']['output'];
  share_url: Scalars['String']['output'];
  show_consent: Scalars['Boolean']['output'];
  show_contact_email: Scalars['Boolean']['output'];
  show_contact_name: Scalars['Boolean']['output'];
  show_contact_phone_number: Scalars['Boolean']['output'];
  tag_share_id: Scalars['String']['output'];
  tag_share_url: Scalars['String']['output'];
};

export type ProgramRevisionAdksFieldsSetupVideoLinksVideoAskResponseFormNotifications = {
  __typename?: 'ProgramRevisionAdksFieldsSetupVideoLinksVideoAskResponseFormNotifications';
  send_contact_message_emails: Scalars['Boolean']['output'];
};

export type ProgramRevisionAdksFieldsSetupVideoLinksVideoAskResponseFormQuestions = {
  __typename?: 'ProgramRevisionAdksFieldsSetupVideoLinksVideoAskResponseFormQuestions';
  question_id: Scalars['String']['output'];
};

export type ProgramRevisionAdksFieldsStyling = {
  __typename?: 'ProgramRevisionAdksFieldsStyling';
  appendIcon?: Maybe<Scalars['String']['output']>;
  chips?: Maybe<Scalars['Boolean']['output']>;
  class?: Maybe<Scalars['String']['output']>;
  color?: Maybe<Scalars['String']['output']>;
  /** Multiple data types found: String: 83.1%, Int: 16.9% out of 12404 sampled entries */
  counter?: Maybe<Scalars['JSON']['output']>;
  dark?: Maybe<Scalars['Boolean']['output']>;
  dense?: Maybe<Scalars['Boolean']['output']>;
  denseIcon?: Maybe<Scalars['Boolean']['output']>;
  depressed?: Maybe<Scalars['Boolean']['output']>;
  flat?: Maybe<Scalars['Boolean']['output']>;
  hide_details?: Maybe<Scalars['Boolean']['output']>;
  hint?: Maybe<Scalars['String']['output']>;
  icon?: Maybe<Scalars['Boolean']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  leftIcon?: Maybe<Scalars['Boolean']['output']>;
  multiple?: Maybe<Scalars['Boolean']['output']>;
  outlined?: Maybe<Scalars['Boolean']['output']>;
  placeholder?: Maybe<Scalars['String']['output']>;
  prependIcon?: Maybe<Scalars['String']['output']>;
  rightIcon?: Maybe<Scalars['Boolean']['output']>;
  rounded?: Maybe<Scalars['Boolean']['output']>;
  small?: Maybe<Scalars['Boolean']['output']>;
  small_chips?: Maybe<Scalars['Boolean']['output']>;
  wrapperClass?: Maybe<Scalars['String']['output']>;
  xLarge?: Maybe<Scalars['Boolean']['output']>;
  xSmall?: Maybe<Scalars['Boolean']['output']>;
};

export type ProgramRevisionAdksFieldsTimelineItems = {
  __typename?: 'ProgramRevisionAdksFieldsTimelineItems';
  answer: Scalars['String']['output'];
  color: Scalars['String']['output'];
  question: Scalars['String']['output'];
};

export type ProgramRevisionAdksFieldsValue = {
  __typename?: 'ProgramRevisionAdksFieldsValue';
  aboutOrg?: Maybe<Scalars['String']['output']>;
  deliverable?: Maybe<Array<Scalars['String']['output']>>;
  description?: Maybe<Scalars['String']['output']>;
  docLink?: Maybe<Scalars['String']['output']>;
  fileUpload?: Maybe<Array<ProgramRevisionAdksFieldsValueFileUpload>>;
  interviewChallenge?: Maybe<Scalars['String']['output']>;
  interviewOpportunity?: Maybe<Scalars['String']['output']>;
  interviewProblem?: Maybe<Scalars['String']['output']>;
  interviewRequest?: Maybe<Scalars['String']['output']>;
  interviewSolution?: Maybe<Scalars['String']['output']>;
  /** Could not determine type: the field only had null or empty values in the sample set. */
  keyResults?: Maybe<Scalars['JSON']['output']>;
  loaded?: Maybe<Array<Scalars['String']['output']>>;
  objective?: Maybe<Scalars['String']['output']>;
  /** Could not determine type: the field only had null or empty values in the sample set. */
  okrAck?: Maybe<Scalars['JSON']['output']>;
  outcome?: Maybe<Array<Scalars['String']['output']>>;
  programDesc?: Maybe<Scalars['String']['output']>;
  programName?: Maybe<Scalars['String']['output']>;
  projectReq?: Maybe<Array<Scalars['String']['output']>>;
  researchLinks?: Maybe<Array<ProgramRevisionAdksFieldsValueResearchLinks>>;
  researchProgress?: Maybe<Array<ProgramRevisionAdksFieldsValueResearchProgress>>;
  /** Could not determine type: the field only had null or empty values in the sample set. */
  resourceDrive?: Maybe<Scalars['JSON']['output']>;
  /** Could not determine type: the field only had null or empty values in the sample set. */
  resourceFacebook?: Maybe<Scalars['JSON']['output']>;
  /** Could not determine type: the field only had null or empty values in the sample set. */
  resourceInsta?: Maybe<Scalars['JSON']['output']>;
  /** Could not determine type: the field only had null or empty values in the sample set. */
  resourceLinkedIn?: Maybe<Scalars['JSON']['output']>;
  /** Could not determine type: the field only had null or empty values in the sample set. */
  resourceTwitter?: Maybe<Scalars['JSON']['output']>;
  resourceWeb?: Maybe<Scalars['String']['output']>;
  /** Could not determine type: the field only had null or empty values in the sample set. */
  resourceYouTube?: Maybe<Scalars['JSON']['output']>;
  submission?: Maybe<ProgramRevisionAdksFieldsValueSubmission>;
  textFields?: Maybe<Array<Scalars['String']['output']>>;
};

export type ProgramRevisionAdksFieldsValueFileUpload = {
  __typename?: 'ProgramRevisionAdksFieldsValueFileUpload';
  description: Scalars['String']['output'];
  /** Could not determine type: the field only had null or empty values in the sample set. */
  file?: Maybe<Scalars['JSON']['output']>;
  fileName: Scalars['String']['output'];
  timestamp: Scalars['String']['output'];
};

export type ProgramRevisionAdksFieldsValueResearchLinks = {
  __typename?: 'ProgramRevisionAdksFieldsValueResearchLinks';
  link: Scalars['String']['output'];
  required: Scalars['Boolean']['output'];
  resource: Scalars['String']['output'];
};

export type ProgramRevisionAdksFieldsValueResearchProgress = {
  __typename?: 'ProgramRevisionAdksFieldsValueResearchProgress';
  link: Scalars['String']['output'];
  required: Scalars['Boolean']['output'];
  resource: Scalars['String']['output'];
};

export type ProgramRevisionAdksFieldsValueSubmission = {
  __typename?: 'ProgramRevisionAdksFieldsValueSubmission';
  apple: Scalars['String']['output'];
  google: Scalars['String']['output'];
  web: Scalars['String']['output'];
};

export type ProgramRevisionAdksInstruction = {
  __typename?: 'ProgramRevisionAdksInstruction';
  boilerInstructions?: Maybe<Array<Scalars['String']['output']>>;
  discordUrl?: Maybe<Scalars['String']['output']>;
  goal?: Maybe<Scalars['String']['output']>;
  youtubeUrl?: Maybe<Scalars['String']['output']>;
};

export type ProgramRevisionAdksPermissions = {
  __typename?: 'ProgramRevisionAdksPermissions';
  permissions_matrix?: Maybe<Array<Scalars['String']['output']>>;
  role?: Maybe<Scalars['String']['output']>;
  roles?: Maybe<Scalars['String']['output']>;
};

export type ProgramRevisionAdksPresetFields = {
  __typename?: 'ProgramRevisionAdksPresetFields';
  action?: Maybe<Scalars['String']['output']>;
  /** Multiple data types found: String: 28.6%, Int: 71.4% out of 3443 sampled entries */
  defaultValue?: Maybe<Scalars['JSON']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  /** Multiple data types found: Array(String): 28.6%, Array(Int): 71.4% out of 3443 sampled entries */
  items?: Maybe<Scalars['JSON']['output']>;
  model?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  noSetup?: Maybe<Scalars['Boolean']['output']>;
  position?: Maybe<Scalars['Int']['output']>;
  preset?: Maybe<ProgramRevisionAdksPresetFieldsPreset>;
  roles?: Maybe<Array<Scalars['String']['output']>>;
  /** Could not determine type: the field only had null or empty values in the sample set. */
  rules?: Maybe<Scalars['JSON']['output']>;
  setup?: Maybe<ProgramRevisionAdksPresetFieldsSetup>;
  styling?: Maybe<ProgramRevisionAdksPresetFieldsStyling>;
  target?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
  /** Nested objects had no data in the sample dataset to introspect a nested type. */
  value?: Maybe<Scalars['JSON']['output']>;
  videoAskLabel?: Maybe<Scalars['String']['output']>;
  videoAskUrl?: Maybe<Scalars['String']['output']>;
};

export type ProgramRevisionAdksPresetFieldsPreset = {
  __typename?: 'ProgramRevisionAdksPresetFieldsPreset';
  maxCharacters?: Maybe<Scalars['String']['output']>;
  maxQuestions?: Maybe<Scalars['Int']['output']>;
  maxTeamMembers?: Maybe<Scalars['Int']['output']>;
  minLogs?: Maybe<Scalars['Int']['output']>;
  minimumHoursNow?: Maybe<Scalars['String']['output']>;
  videoMaxLength?: Maybe<Scalars['Int']['output']>;
};

export type ProgramRevisionAdksPresetFieldsSetup = {
  __typename?: 'ProgramRevisionAdksPresetFieldsSetup';
  directoryPreferences?: Maybe<Array<ProgramRevisionAdksPresetFieldsSetupDirectoryPreferences>>;
  discordData?: Maybe<ProgramRevisionAdksPresetFieldsSetupDiscordData>;
  driveLink?: Maybe<Scalars['String']['output']>;
  endEarlyActivity?: Maybe<Scalars['String']['output']>;
  groupActivity?: Maybe<Scalars['String']['output']>;
  maxCharacters?: Maybe<Scalars['String']['output']>;
  maxQuestions?: Maybe<Scalars['Int']['output']>;
  maxTeamMembers?: Maybe<Scalars['Int']['output']>;
  minLogs?: Maybe<Scalars['Int']['output']>;
  minimumHoursNow?: Maybe<Scalars['String']['output']>;
  requiredActivity?: Maybe<Scalars['String']['output']>;
  settings?: Maybe<ProgramRevisionAdksPresetFieldsSetupSettings>;
  signInVideoAskResponse?: Maybe<ProgramRevisionAdksPresetFieldsSetupSignInVideoAskResponse>;
  videoMaxLength?: Maybe<Scalars['Int']['output']>;
  welcomeActivity?: Maybe<Scalars['String']['output']>;
};

export type ProgramRevisionAdksPresetFieldsSetupDirectoryPreferences = {
  __typename?: 'ProgramRevisionAdksPresetFieldsSetupDirectoryPreferences';
  contactMethod?: Maybe<Array<Scalars['String']['output']>>;
  contactMethods?: Maybe<Array<Scalars['String']['output']>>;
  contactPreferences?: Maybe<Array<Scalars['String']['output']>>;
  hideEmail: Scalars['Boolean']['output'];
  hidePhone: Scalars['Boolean']['output'];
  schedulingLink?: Maybe<Scalars['String']['output']>;
  /** Multiple data types found: String: 38.9%, String (ObjectId): 61.1% out of 18 sampled entries */
  userId: Scalars['JSON']['output'];
};

export type ProgramRevisionAdksPresetFieldsSetupDiscordData = {
  __typename?: 'ProgramRevisionAdksPresetFieldsSetupDiscordData';
  channel?: Maybe<ProgramRevisionAdksPresetFieldsSetupDiscordDataChannel>;
  createdBy: ProgramRevisionAdksPresetFieldsSetupDiscordDataCreatedBy;
  role: ProgramRevisionAdksPresetFieldsSetupDiscordDataRole;
};

export type ProgramRevisionAdksPresetFieldsSetupDiscordDataChannel = {
  __typename?: 'ProgramRevisionAdksPresetFieldsSetupDiscordDataChannel';
  flags: Scalars['Int']['output'];
  guild_id: Scalars['String']['output'];
  id: Scalars['String']['output'];
  /** Could not determine type: the field only had null or empty values in the sample set. */
  last_message_id?: Maybe<Scalars['JSON']['output']>;
  name: Scalars['String']['output'];
  nsfw: Scalars['Boolean']['output'];
  parent_id: Scalars['String']['output'];
  permission_overwrites?: Maybe<Array<ProgramRevisionAdksPresetFieldsSetupDiscordDataChannelPermissionOverwrites>>;
  position: Scalars['Int']['output'];
  rate_limit_per_user: Scalars['Int']['output'];
  /** Could not determine type: the field only had null or empty values in the sample set. */
  topic?: Maybe<Scalars['JSON']['output']>;
  type: Scalars['Int']['output'];
};

export type ProgramRevisionAdksPresetFieldsSetupDiscordDataChannelPermissionOverwrites = {
  __typename?: 'ProgramRevisionAdksPresetFieldsSetupDiscordDataChannelPermissionOverwrites';
  allow: Scalars['Int']['output'];
  allow_new: Scalars['String']['output'];
  deny: Scalars['Int']['output'];
  deny_new: Scalars['String']['output'];
  id: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type ProgramRevisionAdksPresetFieldsSetupDiscordDataCreatedBy = {
  __typename?: 'ProgramRevisionAdksPresetFieldsSetupDiscordDataCreatedBy';
  email: Scalars['String']['output'];
  userType: Scalars['String']['output'];
};

export type ProgramRevisionAdksPresetFieldsSetupDiscordDataRole = {
  __typename?: 'ProgramRevisionAdksPresetFieldsSetupDiscordDataRole';
  color: Scalars['Int']['output'];
  /** Could not determine type: the field only had null or empty values in the sample set. */
  description?: Maybe<Scalars['JSON']['output']>;
  flags: Scalars['Int']['output'];
  hoist: Scalars['Boolean']['output'];
  /** Could not determine type: the field only had null or empty values in the sample set. */
  icon?: Maybe<Scalars['JSON']['output']>;
  id: Scalars['String']['output'];
  managed: Scalars['Boolean']['output'];
  mentionable: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  permissions: Scalars['Int']['output'];
  permissions_new: Scalars['String']['output'];
  position: Scalars['Int']['output'];
  /** Could not determine type: the field only had null or empty values in the sample set. */
  unicode_emoji?: Maybe<Scalars['JSON']['output']>;
};

export type ProgramRevisionAdksPresetFieldsSetupSettings = {
  __typename?: 'ProgramRevisionAdksPresetFieldsSetupSettings';
  caseStudySettings: ProgramRevisionAdksPresetFieldsSetupSettingsCaseStudySettings;
  digitalResumeSettings: Scalars['Boolean']['output'];
  presentationSettings: ProgramRevisionAdksPresetFieldsSetupSettingsPresentationSettings;
  projectFAQSettings: Scalars['Boolean']['output'];
  projectImplementationSettings: ProgramRevisionAdksPresetFieldsSetupSettingsProjectImplementationSettings;
  projectPlanSettings: ProgramRevisionAdksPresetFieldsSetupSettingsProjectPlanSettings;
  projectTaskSettings: ProgramRevisionAdksPresetFieldsSetupSettingsProjectTaskSettings;
  teamSettings: ProgramRevisionAdksPresetFieldsSetupSettingsTeamSettings;
  userInterviewSettings: ProgramRevisionAdksPresetFieldsSetupSettingsUserInterviewSettings;
};

export type ProgramRevisionAdksPresetFieldsSetupSettingsCaseStudySettings = {
  __typename?: 'ProgramRevisionAdksPresetFieldsSetupSettingsCaseStudySettings';
  required: Scalars['Boolean']['output'];
};

export type ProgramRevisionAdksPresetFieldsSetupSettingsPresentationSettings = {
  __typename?: 'ProgramRevisionAdksPresetFieldsSetupSettingsPresentationSettings';
  required: Scalars['Boolean']['output'];
};

export type ProgramRevisionAdksPresetFieldsSetupSettingsProjectImplementationSettings = {
  __typename?: 'ProgramRevisionAdksPresetFieldsSetupSettingsProjectImplementationSettings';
  required: Scalars['Boolean']['output'];
};

export type ProgramRevisionAdksPresetFieldsSetupSettingsProjectPlanSettings = {
  __typename?: 'ProgramRevisionAdksPresetFieldsSetupSettingsProjectPlanSettings';
  required: Scalars['Boolean']['output'];
};

export type ProgramRevisionAdksPresetFieldsSetupSettingsProjectTaskSettings = {
  __typename?: 'ProgramRevisionAdksPresetFieldsSetupSettingsProjectTaskSettings';
  required: Scalars['Boolean']['output'];
};

export type ProgramRevisionAdksPresetFieldsSetupSettingsTeamSettings = {
  __typename?: 'ProgramRevisionAdksPresetFieldsSetupSettingsTeamSettings';
  required: Scalars['Boolean']['output'];
};

export type ProgramRevisionAdksPresetFieldsSetupSettingsUserInterviewSettings = {
  __typename?: 'ProgramRevisionAdksPresetFieldsSetupSettingsUserInterviewSettings';
  required: Scalars['Boolean']['output'];
};

export type ProgramRevisionAdksPresetFieldsSetupSignInVideoAskResponse = {
  __typename?: 'ProgramRevisionAdksPresetFieldsSetupSignInVideoAskResponse';
  contact: ProgramRevisionAdksPresetFieldsSetupSignInVideoAskResponseContact;
  event_id: Scalars['String']['output'];
  event_type: Scalars['String']['output'];
  form: ProgramRevisionAdksPresetFieldsSetupSignInVideoAskResponseForm;
  interaction_id: Scalars['String']['output'];
};

export type ProgramRevisionAdksPresetFieldsSetupSignInVideoAskResponseContact = {
  __typename?: 'ProgramRevisionAdksPresetFieldsSetupSignInVideoAskResponseContact';
  answers?: Maybe<Array<ProgramRevisionAdksPresetFieldsSetupSignInVideoAskResponseContactAnswers>>;
  are_answers_public: Scalars['Boolean']['output'];
  are_messages_public: Scalars['Boolean']['output'];
  contact_id: Scalars['String']['output'];
  email: Scalars['String']['output'];
  platform: Scalars['String']['output'];
  share_id: Scalars['String']['output'];
  share_url: Scalars['String']['output'];
  status: Scalars['String']['output'];
};

export type ProgramRevisionAdksPresetFieldsSetupSignInVideoAskResponseContactAnswers = {
  __typename?: 'ProgramRevisionAdksPresetFieldsSetupSignInVideoAskResponseContactAnswers';
  answer_id: Scalars['String']['output'];
  media_id: Scalars['String']['output'];
  media_url: Scalars['String']['output'];
  /** Could not determine type: the field only had null or empty values in the sample set. */
  poll_options?: Maybe<Scalars['JSON']['output']>;
  question_id: Scalars['String']['output'];
};

export type ProgramRevisionAdksPresetFieldsSetupSignInVideoAskResponseForm = {
  __typename?: 'ProgramRevisionAdksPresetFieldsSetupSignInVideoAskResponseForm';
  are_answers_public: Scalars['Boolean']['output'];
  are_messages_public: Scalars['Boolean']['output'];
  form_id: Scalars['String']['output'];
  hide_branding: Scalars['Boolean']['output'];
  idle_deadline_time_in_minutes: Scalars['Int']['output'];
  notifications: ProgramRevisionAdksPresetFieldsSetupSignInVideoAskResponseFormNotifications;
  questions?: Maybe<Array<ProgramRevisionAdksPresetFieldsSetupSignInVideoAskResponseFormQuestions>>;
  requires_consent: Scalars['Boolean']['output'];
  requires_contact_email: Scalars['Boolean']['output'];
  requires_contact_info: Scalars['Boolean']['output'];
  requires_contact_name: Scalars['Boolean']['output'];
  requires_contact_phone_number: Scalars['Boolean']['output'];
  respondents_count: Scalars['Int']['output'];
  responses_share_id: Scalars['String']['output'];
  responses_share_url: Scalars['String']['output'];
  share_id: Scalars['String']['output'];
  share_url: Scalars['String']['output'];
  show_consent: Scalars['Boolean']['output'];
  show_contact_email: Scalars['Boolean']['output'];
  show_contact_name: Scalars['Boolean']['output'];
  show_contact_phone_number: Scalars['Boolean']['output'];
  tag_share_id: Scalars['String']['output'];
  tag_share_url: Scalars['String']['output'];
};

export type ProgramRevisionAdksPresetFieldsSetupSignInVideoAskResponseFormNotifications = {
  __typename?: 'ProgramRevisionAdksPresetFieldsSetupSignInVideoAskResponseFormNotifications';
  send_contact_message_emails: Scalars['Boolean']['output'];
};

export type ProgramRevisionAdksPresetFieldsSetupSignInVideoAskResponseFormQuestions = {
  __typename?: 'ProgramRevisionAdksPresetFieldsSetupSignInVideoAskResponseFormQuestions';
  question_id: Scalars['String']['output'];
};

export type ProgramRevisionAdksPresetFieldsStyling = {
  __typename?: 'ProgramRevisionAdksPresetFieldsStyling';
  class?: Maybe<Scalars['String']['output']>;
  depressed?: Maybe<Scalars['Boolean']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  outlined?: Maybe<Scalars['Boolean']['output']>;
  placeholder?: Maybe<Scalars['String']['output']>;
  prependIcon?: Maybe<Scalars['String']['output']>;
  rounded?: Maybe<Scalars['Boolean']['output']>;
  wrapperClass?: Maybe<Scalars['String']['output']>;
  xLarge?: Maybe<Scalars['Boolean']['output']>;
};

export type ProgramRevisionAdksRfp = {
  __typename?: 'ProgramRevisionAdksRfp';
  aboutOrg: Scalars['String']['output'];
  deliverable?: Maybe<Array<Scalars['String']['output']>>;
  employerName: Scalars['String']['output'];
  employerWebsite: Scalars['String']['output'];
  interviewChallenge: Scalars['String']['output'];
  interviewOpportunity: Scalars['String']['output'];
  interviewProblem: Scalars['String']['output'];
  interviewReqeust: Scalars['String']['output'];
  interviewSolution: Scalars['String']['output'];
  introVideo: Scalars['String']['output'];
  outcome?: Maybe<Array<Scalars['String']['output']>>;
  projectReq: Scalars['String']['output'];
  projectScope: Scalars['String']['output'];
  required: Scalars['Boolean']['output'];
  resourceDrive: Scalars['String']['output'];
  resourceFacebook: Scalars['String']['output'];
  resourceInsta: Scalars['String']['output'];
  resourceLinkedIn: Scalars['String']['output'];
  resourceTwitter: Scalars['String']['output'];
  resourceWeb: Scalars['String']['output'];
  resourceYouTube: Scalars['String']['output'];
};

export type ProgramRevisionAdksScope = {
  __typename?: 'ProgramRevisionAdksScope';
  aboutOrg: Scalars['String']['output'];
  deliverable?: Maybe<Array<Scalars['String']['output']>>;
  employerName: Scalars['String']['output'];
  employerWebsite: Scalars['String']['output'];
  interviewChallenge: Scalars['String']['output'];
  interviewOpportunity: Scalars['String']['output'];
  interviewProblem: Scalars['String']['output'];
  interviewReqeust: Scalars['String']['output'];
  interviewSolution: Scalars['String']['output'];
  introVideo: Scalars['String']['output'];
  outcome?: Maybe<Array<Scalars['String']['output']>>;
  projectReq: Scalars['String']['output'];
  projectScope: Scalars['String']['output'];
  required: Scalars['Boolean']['output'];
  resourceDrive: Scalars['String']['output'];
  resourceFacebook: Scalars['String']['output'];
  resourceInsta: Scalars['String']['output'];
  resourceLinkedIn: Scalars['String']['output'];
  resourceTwitter: Scalars['String']['output'];
  resourceWeb: Scalars['String']['output'];
  resourceYouTube: Scalars['String']['output'];
};

export type ProgramRevisionAdksStyling = {
  __typename?: 'ProgramRevisionAdksStyling';
  borderColor: Scalars['String']['output'];
};

export type ProgramRevisionAirtable = {
  __typename?: 'ProgramRevisionAirtable';
  airtable_id: Scalars['String']['output'];
  /** Multiple data types found: String: 36.8%, DateTime (Date): 63.2% out of 326 sampled entries */
  created_at: Scalars['JSON']['output'];
  /** Multiple data types found: String: 36.8%, DateTime (Date): 63.2% out of 326 sampled entries */
  last_modified_at: Scalars['JSON']['output'];
  spreadsheet: Scalars['String']['output'];
};

export type ProgramRevisionAvgAggregate = {
  __typename?: 'ProgramRevisionAvgAggregate';
  tokens?: Maybe<Scalars['Float']['output']>;
  version?: Maybe<Scalars['Float']['output']>;
};

export type ProgramRevisionCategories = {
  __typename?: 'ProgramRevisionCategories';
  icon: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type ProgramRevisionCheckoutQualification = {
  __typename?: 'ProgramRevisionCheckoutQualification';
  ageLimit?: Maybe<Array<Scalars['Int']['output']>>;
};

export type ProgramRevisionCountAggregate = {
  __typename?: 'ProgramRevisionCountAggregate';
  _all: Scalars['Int']['output'];
  activityNotification: Scalars['Int']['output'];
  ageRange: Scalars['Int']['output'];
  airtable_link: Scalars['Int']['output'];
  colors: Scalars['Int']['output'];
  completed: Scalars['Int']['output'];
  createdBy: Scalars['Int']['output'];
  created_at: Scalars['Int']['output'];
  dateCreated: Scalars['Int']['output'];
  deadlineCompletion: Scalars['Int']['output'];
  file_draft: Scalars['Int']['output'];
  flippedDescription: Scalars['Int']['output'];
  flippedPresentation: Scalars['Int']['output'];
  flippedRegistration: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  industries: Scalars['Int']['output'];
  isChennelCreated: Scalars['Int']['output'];
  isLastModifiedAtExists: Scalars['Int']['output'];
  isProgramSchemaAdded: Scalars['Int']['output'];
  isPublic: Scalars['Int']['output'];
  isSaveAdkMoleculeAdded: Scalars['Int']['output'];
  isShowTimer: Scalars['Int']['output'];
  isUniqueFieldIdAdded: Scalars['Int']['output'];
  isUniqueIdAdded: Scalars['Int']['output'];
  isUnsponsoredProgram: Scalars['Int']['output'];
  isUpdateOrg: Scalars['Int']['output'];
  isUpdateParticipants: Scalars['Int']['output'];
  keywords: Scalars['Int']['output'];
  lastSaved: Scalars['Int']['output'];
  last_synced_at: Scalars['Int']['output'];
  licensed: Scalars['Int']['output'];
  organizers: Scalars['Int']['output'];
  originalProgramId: Scalars['Int']['output'];
  owner: Scalars['Int']['output'];
  participants: Scalars['Int']['output'];
  pathways: Scalars['Int']['output'];
  programDesc: Scalars['Int']['output'];
  programImage: Scalars['Int']['output'];
  programName: Scalars['Int']['output'];
  program_id: Scalars['Int']['output'];
  program_schema_id: Scalars['Int']['output'];
  public_url: Scalars['Int']['output'];
  published: Scalars['Int']['output'];
  requiredResidency: Scalars['Int']['output'];
  requiredSkills: Scalars['Int']['output'];
  requiredTech: Scalars['Int']['output'];
  resourceWeb: Scalars['Int']['output'];
  reward: Scalars['Int']['output'];
  rewardPresets: Scalars['Int']['output'];
  rewards: Scalars['Int']['output'];
  selectedDistrict: Scalars['Int']['output'];
  sharable_url: Scalars['Int']['output'];
  slug: Scalars['Int']['output'];
  start_activity_status: Scalars['Int']['output'];
  templateId: Scalars['Int']['output'];
  templateImage: Scalars['Int']['output'];
  templateName: Scalars['Int']['output'];
  timerType: Scalars['Int']['output'];
  tokens: Scalars['Int']['output'];
  unsponsoredAdk: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  versionChange: Scalars['Int']['output'];
  videoAskShareId: Scalars['Int']['output'];
  visibility: Scalars['Int']['output'];
};

export type ProgramRevisionCredentials = {
  __typename?: 'ProgramRevisionCredentials';
  activities?: Maybe<Array<Scalars['String']['output']>>;
  credentials?: Maybe<Array<Scalars['String']['output']>>;
  id: Scalars['Int']['output'];
};

export type ProgramRevisionMaxAggregate = {
  __typename?: 'ProgramRevisionMaxAggregate';
  activityNotification?: Maybe<Scalars['Boolean']['output']>;
  airtable_link?: Maybe<Scalars['String']['output']>;
  colors?: Maybe<Scalars['String']['output']>;
  completed?: Maybe<Scalars['DateTime']['output']>;
  created_at?: Maybe<Scalars['DateTime']['output']>;
  deadlineCompletion?: Maybe<Scalars['String']['output']>;
  file_draft?: Maybe<Scalars['Boolean']['output']>;
  flippedDescription?: Maybe<Scalars['String']['output']>;
  flippedPresentation?: Maybe<Scalars['String']['output']>;
  flippedRegistration?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  isChennelCreated?: Maybe<Scalars['Boolean']['output']>;
  isLastModifiedAtExists?: Maybe<Scalars['Boolean']['output']>;
  isProgramSchemaAdded?: Maybe<Scalars['Boolean']['output']>;
  isPublic?: Maybe<Scalars['Boolean']['output']>;
  isSaveAdkMoleculeAdded?: Maybe<Scalars['Boolean']['output']>;
  isShowTimer?: Maybe<Scalars['Boolean']['output']>;
  isUniqueFieldIdAdded?: Maybe<Scalars['Boolean']['output']>;
  isUniqueIdAdded?: Maybe<Scalars['Boolean']['output']>;
  isUnsponsoredProgram?: Maybe<Scalars['Boolean']['output']>;
  isUpdateOrg?: Maybe<Scalars['Boolean']['output']>;
  isUpdateParticipants?: Maybe<Scalars['Boolean']['output']>;
  owner?: Maybe<Scalars['String']['output']>;
  programDesc?: Maybe<Scalars['String']['output']>;
  programImage?: Maybe<Scalars['String']['output']>;
  programName?: Maybe<Scalars['String']['output']>;
  program_id?: Maybe<Scalars['String']['output']>;
  program_schema_id?: Maybe<Scalars['String']['output']>;
  public_url?: Maybe<Scalars['String']['output']>;
  published?: Maybe<Scalars['Boolean']['output']>;
  resourceWeb?: Maybe<Scalars['String']['output']>;
  reward?: Maybe<Scalars['String']['output']>;
  selectedDistrict?: Maybe<Scalars['String']['output']>;
  sharable_url?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  start_activity_status?: Maybe<Scalars['String']['output']>;
  templateName?: Maybe<Scalars['String']['output']>;
  timerType?: Maybe<Scalars['String']['output']>;
  tokens?: Maybe<Scalars['Int']['output']>;
  unsponsoredAdk?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['Int']['output']>;
  versionChange?: Maybe<Scalars['String']['output']>;
  videoAskShareId?: Maybe<Scalars['String']['output']>;
  visibility?: Maybe<Scalars['String']['output']>;
};

export type ProgramRevisionMetaData = {
  __typename?: 'ProgramRevisionMetaData';
  keywords?: Maybe<Array<Scalars['String']['output']>>;
  linkedinDesc: Scalars['String']['output'];
  /** Could not determine type: the field only had null or empty values in the sample set. */
  linkedinImage?: Maybe<Scalars['JSON']['output']>;
  linkedinTitle: Scalars['String']['output'];
  linkedinUrl: Scalars['String']['output'];
  metaDesc: Scalars['String']['output'];
  ogDesc: Scalars['String']['output'];
  /** Could not determine type: the field only had null or empty values in the sample set. */
  ogImage?: Maybe<Scalars['JSON']['output']>;
  ogTitle: Scalars['String']['output'];
  ogUrl: Scalars['String']['output'];
  tags?: Maybe<Array<Scalars['String']['output']>>;
  twitterDesc: Scalars['String']['output'];
  /** Could not determine type: the field only had null or empty values in the sample set. */
  twitterImage?: Maybe<Scalars['JSON']['output']>;
  twitterTitle: Scalars['String']['output'];
  twitterUrl: Scalars['String']['output'];
};

export type ProgramRevisionMinAggregate = {
  __typename?: 'ProgramRevisionMinAggregate';
  activityNotification?: Maybe<Scalars['Boolean']['output']>;
  airtable_link?: Maybe<Scalars['String']['output']>;
  colors?: Maybe<Scalars['String']['output']>;
  completed?: Maybe<Scalars['DateTime']['output']>;
  created_at?: Maybe<Scalars['DateTime']['output']>;
  deadlineCompletion?: Maybe<Scalars['String']['output']>;
  file_draft?: Maybe<Scalars['Boolean']['output']>;
  flippedDescription?: Maybe<Scalars['String']['output']>;
  flippedPresentation?: Maybe<Scalars['String']['output']>;
  flippedRegistration?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  isChennelCreated?: Maybe<Scalars['Boolean']['output']>;
  isLastModifiedAtExists?: Maybe<Scalars['Boolean']['output']>;
  isProgramSchemaAdded?: Maybe<Scalars['Boolean']['output']>;
  isPublic?: Maybe<Scalars['Boolean']['output']>;
  isSaveAdkMoleculeAdded?: Maybe<Scalars['Boolean']['output']>;
  isShowTimer?: Maybe<Scalars['Boolean']['output']>;
  isUniqueFieldIdAdded?: Maybe<Scalars['Boolean']['output']>;
  isUniqueIdAdded?: Maybe<Scalars['Boolean']['output']>;
  isUnsponsoredProgram?: Maybe<Scalars['Boolean']['output']>;
  isUpdateOrg?: Maybe<Scalars['Boolean']['output']>;
  isUpdateParticipants?: Maybe<Scalars['Boolean']['output']>;
  owner?: Maybe<Scalars['String']['output']>;
  programDesc?: Maybe<Scalars['String']['output']>;
  programImage?: Maybe<Scalars['String']['output']>;
  programName?: Maybe<Scalars['String']['output']>;
  program_id?: Maybe<Scalars['String']['output']>;
  program_schema_id?: Maybe<Scalars['String']['output']>;
  public_url?: Maybe<Scalars['String']['output']>;
  published?: Maybe<Scalars['Boolean']['output']>;
  resourceWeb?: Maybe<Scalars['String']['output']>;
  reward?: Maybe<Scalars['String']['output']>;
  selectedDistrict?: Maybe<Scalars['String']['output']>;
  sharable_url?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  start_activity_status?: Maybe<Scalars['String']['output']>;
  templateName?: Maybe<Scalars['String']['output']>;
  timerType?: Maybe<Scalars['String']['output']>;
  tokens?: Maybe<Scalars['Int']['output']>;
  unsponsoredAdk?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['Int']['output']>;
  versionChange?: Maybe<Scalars['String']['output']>;
  videoAskShareId?: Maybe<Scalars['String']['output']>;
  visibility?: Maybe<Scalars['String']['output']>;
};

export type ProgramRevisionProgramSchema = {
  __typename?: 'ProgramRevisionProgramSchema';
  adks?: Maybe<Array<ProgramRevisionProgramSchemaAdks>>;
  id: Scalars['String']['output'];
};

export type ProgramRevisionProgramSchemaAdks = {
  __typename?: 'ProgramRevisionProgramSchemaAdks';
  buildScope?: Maybe<ProgramRevisionProgramSchemaAdksBuildScope>;
  category: Scalars['String']['output'];
  fields?: Maybe<Array<ProgramRevisionProgramSchemaAdksFields>>;
  icon: Scalars['String']['output'];
  instruction?: Maybe<ProgramRevisionProgramSchemaAdksInstruction>;
  isSkippable?: Maybe<Scalars['Boolean']['output']>;
  isTeamAdk?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  optional?: Maybe<Scalars['Boolean']['output']>;
  permissions?: Maybe<Array<ProgramRevisionProgramSchemaAdksPermissions>>;
  position: Scalars['Int']['output'];
  presetFields?: Maybe<Array<ProgramRevisionProgramSchemaAdksPresetFields>>;
  preview: Scalars['Boolean']['output'];
  setupRequired: Scalars['Boolean']['output'];
  status: Scalars['Boolean']['output'];
  styling: ProgramRevisionProgramSchemaAdksStyling;
};

export type ProgramRevisionProgramSchemaAdksBuildScope = {
  __typename?: 'ProgramRevisionProgramSchemaAdksBuildScope';
  objectives?: Maybe<Array<ProgramRevisionProgramSchemaAdksBuildScopeObjectives>>;
  projects?: Maybe<Array<ProgramRevisionProgramSchemaAdksBuildScopeProjects>>;
};

export type ProgramRevisionProgramSchemaAdksBuildScopeObjectives = {
  __typename?: 'ProgramRevisionProgramSchemaAdksBuildScopeObjectives';
  action?: Maybe<Scalars['String']['output']>;
  icon?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  position: Scalars['Int']['output'];
  roles?: Maybe<Array<Scalars['String']['output']>>;
  /** Could not determine type: the field only had null or empty values in the sample set. */
  rules?: Maybe<Scalars['JSON']['output']>;
  styling?: Maybe<ProgramRevisionProgramSchemaAdksBuildScopeObjectivesStyling>;
  target?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
};

export type ProgramRevisionProgramSchemaAdksBuildScopeObjectivesStyling = {
  __typename?: 'ProgramRevisionProgramSchemaAdksBuildScopeObjectivesStyling';
  depressed?: Maybe<Scalars['Boolean']['output']>;
  hint?: Maybe<Scalars['String']['output']>;
  icon?: Maybe<Scalars['String']['output']>;
  label: Scalars['String']['output'];
  leftIcon?: Maybe<Scalars['String']['output']>;
  outlined: Scalars['Boolean']['output'];
  placeholder?: Maybe<Scalars['String']['output']>;
  rightIcon?: Maybe<Scalars['String']['output']>;
  rounded: Scalars['Boolean']['output'];
  small?: Maybe<Scalars['Boolean']['output']>;
};

export type ProgramRevisionProgramSchemaAdksBuildScopeProjects = {
  __typename?: 'ProgramRevisionProgramSchemaAdksBuildScopeProjects';
  action?: Maybe<Scalars['String']['output']>;
  icon?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  position: Scalars['Int']['output'];
  roles?: Maybe<Array<Scalars['String']['output']>>;
  styling?: Maybe<ProgramRevisionProgramSchemaAdksBuildScopeProjectsStyling>;
  target?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
};

export type ProgramRevisionProgramSchemaAdksBuildScopeProjectsStyling = {
  __typename?: 'ProgramRevisionProgramSchemaAdksBuildScopeProjectsStyling';
  color: Scalars['String']['output'];
  depressed: Scalars['Boolean']['output'];
  label: Scalars['String']['output'];
  leftIcon: Scalars['String']['output'];
  rounded: Scalars['Boolean']['output'];
};

export type ProgramRevisionProgramSchemaAdksFields = {
  __typename?: 'ProgramRevisionProgramSchemaAdksFields';
  action?: Maybe<Scalars['String']['output']>;
  adk?: Maybe<Scalars['String']['output']>;
  ages?: Maybe<Scalars['String']['output']>;
  align?: Maybe<Scalars['String']['output']>;
  blank?: Maybe<Scalars['Boolean']['output']>;
  color?: Maybe<Scalars['String']['output']>;
  dark?: Maybe<Scalars['Boolean']['output']>;
  /** Multiple data types found: String: 18.5%, Boolean: 59.3%, Int: 22.2% out of 27 sampled entries */
  defaultValue?: Maybe<Scalars['JSON']['output']>;
  /** Multiple data types found: String: 25%, ProgramRevisionProgramSchemaAdksFieldsEvent: 75% out of 4 sampled entries */
  event?: Maybe<Scalars['JSON']['output']>;
  header?: Maybe<Scalars['String']['output']>;
  href?: Maybe<Scalars['String']['output']>;
  icon?: Maybe<Scalars['String']['output']>;
  /** Multiple data types found: Array(String): 71.4%, Array(Int): 28.6% out of 8 sampled entries */
  items?: Maybe<Scalars['JSON']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  max?: Maybe<Scalars['String']['output']>;
  maxDate?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  min?: Maybe<Scalars['String']['output']>;
  minDate?: Maybe<Scalars['String']['output']>;
  model?: Maybe<Scalars['String']['output']>;
  modelItems?: Maybe<Array<ProgramRevisionProgramSchemaAdksFieldsModelItems>>;
  multiple?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  noSetup?: Maybe<Scalars['Boolean']['output']>;
  outlined?: Maybe<Scalars['Boolean']['output']>;
  placeholder?: Maybe<Scalars['String']['output']>;
  position: Scalars['Int']['output'];
  preset?: Maybe<ProgramRevisionProgramSchemaAdksFieldsPreset>;
  radioButtons?: Maybe<Array<ProgramRevisionProgramSchemaAdksFieldsRadioButtons>>;
  roles?: Maybe<Array<Scalars['String']['output']>>;
  rounded?: Maybe<Scalars['Boolean']['output']>;
  rules?: Maybe<Array<Scalars['String']['output']>>;
  searchInput?: Maybe<Scalars['String']['output']>;
  searchType?: Maybe<Scalars['String']['output']>;
  /** Nested objects had no data in the sample dataset to introspect a nested type. */
  setup?: Maybe<Scalars['JSON']['output']>;
  styling?: Maybe<ProgramRevisionProgramSchemaAdksFieldsStyling>;
  subTitle?: Maybe<Scalars['String']['output']>;
  target?: Maybe<Scalars['String']['output']>;
  tickSize?: Maybe<Scalars['Int']['output']>;
  ticks?: Maybe<Scalars['Boolean']['output']>;
  timelineItems?: Maybe<Array<ProgramRevisionProgramSchemaAdksFieldsTimelineItems>>;
  title?: Maybe<Scalars['String']['output']>;
  titleAfterChip?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  vChipContent?: Maybe<Scalars['String']['output']>;
  value?: Maybe<ProgramRevisionProgramSchemaAdksFieldsValue>;
  videoAskLabel?: Maybe<Scalars['String']['output']>;
  videoAskUrl?: Maybe<Scalars['String']['output']>;
};

export type ProgramRevisionProgramSchemaAdksFieldsModelItems = {
  __typename?: 'ProgramRevisionProgramSchemaAdksFieldsModelItems';
  name: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type ProgramRevisionProgramSchemaAdksFieldsPreset = {
  __typename?: 'ProgramRevisionProgramSchemaAdksFieldsPreset';
  acceptanceDeadline?: Maybe<Scalars['String']['output']>;
  apprentice?: Maybe<Scalars['Boolean']['output']>;
  compensation1?: Maybe<Scalars['Boolean']['output']>;
  compensation2?: Maybe<Scalars['Boolean']['output']>;
  compensation3?: Maybe<Scalars['Boolean']['output']>;
  compensation4?: Maybe<Scalars['Boolean']['output']>;
  compensation5?: Maybe<Scalars['Boolean']['output']>;
  compensation6?: Maybe<Scalars['Boolean']['output']>;
  continuation?: Maybe<Scalars['Int']['output']>;
  eir?: Maybe<Scalars['Boolean']['output']>;
  employerRecord?: Maybe<Scalars['Int']['output']>;
  extern?: Maybe<Scalars['Boolean']['output']>;
  externCredential?: Maybe<Scalars['Int']['output']>;
  fellow?: Maybe<Scalars['Boolean']['output']>;
  intern?: Maybe<Scalars['Boolean']['output']>;
  internshipEnd?: Maybe<Scalars['String']['output']>;
  internshipProject1?: Maybe<Scalars['Boolean']['output']>;
  internshipProject2?: Maybe<Scalars['Boolean']['output']>;
  internshipProject3?: Maybe<Scalars['Boolean']['output']>;
  internshipStart?: Maybe<Scalars['String']['output']>;
  licenseRequirement?: Maybe<Scalars['Int']['output']>;
  maxHours?: Maybe<Scalars['Int']['output']>;
  maximumBudget?: Maybe<Scalars['String']['output']>;
  minHours?: Maybe<Scalars['Int']['output']>;
  minimumBudget?: Maybe<Scalars['String']['output']>;
  preApprentice?: Maybe<Scalars['Boolean']['output']>;
  preInternship?: Maybe<Scalars['Boolean']['output']>;
};

export type ProgramRevisionProgramSchemaAdksFieldsRadioButtons = {
  __typename?: 'ProgramRevisionProgramSchemaAdksFieldsRadioButtons';
  action?: Maybe<Scalars['String']['output']>;
  clickable?: Maybe<Scalars['Boolean']['output']>;
  event?: Maybe<ProgramRevisionProgramSchemaAdksFieldsRadioButtonsEvent>;
  label: Scalars['String']['output'];
};

export type ProgramRevisionProgramSchemaAdksFieldsRadioButtonsEvent = {
  __typename?: 'ProgramRevisionProgramSchemaAdksFieldsRadioButtonsEvent';
  body: Scalars['String']['output'];
  buttons?: Maybe<Array<ProgramRevisionProgramSchemaAdksFieldsRadioButtonsEventButtons>>;
  component: Scalars['String']['output'];
  title: Scalars['String']['output'];
  trigger: Scalars['String']['output'];
};

export type ProgramRevisionProgramSchemaAdksFieldsRadioButtonsEventButtons = {
  __typename?: 'ProgramRevisionProgramSchemaAdksFieldsRadioButtonsEventButtons';
  label: Scalars['String']['output'];
  model: Scalars['String']['output'];
  style: ProgramRevisionProgramSchemaAdksFieldsRadioButtonsEventButtonsStyle;
};

export type ProgramRevisionProgramSchemaAdksFieldsRadioButtonsEventButtonsStyle = {
  __typename?: 'ProgramRevisionProgramSchemaAdksFieldsRadioButtonsEventButtonsStyle';
  class: Scalars['String']['output'];
  color: Scalars['String']['output'];
  dark?: Maybe<Scalars['Boolean']['output']>;
  depressed?: Maybe<Scalars['Boolean']['output']>;
  outlined: Scalars['Boolean']['output'];
  rounded: Scalars['Boolean']['output'];
  xLarge: Scalars['Boolean']['output'];
};

export type ProgramRevisionProgramSchemaAdksFieldsStyling = {
  __typename?: 'ProgramRevisionProgramSchemaAdksFieldsStyling';
  appendIcon?: Maybe<Scalars['String']['output']>;
  chips?: Maybe<Scalars['Boolean']['output']>;
  class?: Maybe<Scalars['String']['output']>;
  color?: Maybe<Scalars['String']['output']>;
  /** Multiple data types found: String: 78.6%, Int: 21.4% out of 14 sampled entries */
  counter?: Maybe<Scalars['JSON']['output']>;
  dark?: Maybe<Scalars['Boolean']['output']>;
  dense?: Maybe<Scalars['Boolean']['output']>;
  denseIcon?: Maybe<Scalars['Boolean']['output']>;
  depressed?: Maybe<Scalars['Boolean']['output']>;
  flat?: Maybe<Scalars['Boolean']['output']>;
  hide_details?: Maybe<Scalars['Boolean']['output']>;
  hint?: Maybe<Scalars['String']['output']>;
  icon?: Maybe<Scalars['Boolean']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  leftIcon?: Maybe<Scalars['Boolean']['output']>;
  multiple?: Maybe<Scalars['Boolean']['output']>;
  outlined?: Maybe<Scalars['Boolean']['output']>;
  placeholder?: Maybe<Scalars['String']['output']>;
  prependIcon?: Maybe<Scalars['String']['output']>;
  rightIcon?: Maybe<Scalars['Boolean']['output']>;
  rounded?: Maybe<Scalars['Boolean']['output']>;
  small?: Maybe<Scalars['Boolean']['output']>;
  small_chips?: Maybe<Scalars['Boolean']['output']>;
  wrapperClass?: Maybe<Scalars['String']['output']>;
  xLarge?: Maybe<Scalars['Boolean']['output']>;
  xSmall?: Maybe<Scalars['Boolean']['output']>;
};

export type ProgramRevisionProgramSchemaAdksFieldsTimelineItems = {
  __typename?: 'ProgramRevisionProgramSchemaAdksFieldsTimelineItems';
  answer: Scalars['String']['output'];
  color: Scalars['String']['output'];
  question: Scalars['String']['output'];
};

export type ProgramRevisionProgramSchemaAdksFieldsValue = {
  __typename?: 'ProgramRevisionProgramSchemaAdksFieldsValue';
  deliverable?: Maybe<Array<Scalars['String']['output']>>;
  outcome?: Maybe<Array<Scalars['String']['output']>>;
};

export type ProgramRevisionProgramSchemaAdksInstruction = {
  __typename?: 'ProgramRevisionProgramSchemaAdksInstruction';
  boilerInstructions?: Maybe<Array<Scalars['String']['output']>>;
  discordUrl: Scalars['String']['output'];
  goal: Scalars['String']['output'];
  youtubeUrl: Scalars['String']['output'];
};

export type ProgramRevisionProgramSchemaAdksPermissions = {
  __typename?: 'ProgramRevisionProgramSchemaAdksPermissions';
  permissions_matrix?: Maybe<Array<Scalars['String']['output']>>;
  role?: Maybe<Scalars['String']['output']>;
  roles?: Maybe<Scalars['String']['output']>;
};

export type ProgramRevisionProgramSchemaAdksPresetFields = {
  __typename?: 'ProgramRevisionProgramSchemaAdksPresetFields';
  action?: Maybe<Scalars['String']['output']>;
  /** Multiple data types found: String: 33.3%, Int: 66.7% out of 6 sampled entries */
  defaultValue?: Maybe<Scalars['JSON']['output']>;
  /** Multiple data types found: Array(String): 33.3%, Array(Int): 66.7% out of 6 sampled entries */
  items?: Maybe<Scalars['JSON']['output']>;
  model?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  noSetup?: Maybe<Scalars['Boolean']['output']>;
  position: Scalars['Int']['output'];
  preset?: Maybe<ProgramRevisionProgramSchemaAdksPresetFieldsPreset>;
  roles?: Maybe<Array<Scalars['String']['output']>>;
  /** Could not determine type: the field only had null or empty values in the sample set. */
  rules?: Maybe<Scalars['JSON']['output']>;
  /** Nested objects had no data in the sample dataset to introspect a nested type. */
  setup?: Maybe<Scalars['JSON']['output']>;
  styling?: Maybe<ProgramRevisionProgramSchemaAdksPresetFieldsStyling>;
  target?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
  /** Nested objects had no data in the sample dataset to introspect a nested type. */
  value?: Maybe<Scalars['JSON']['output']>;
  videoAskLabel?: Maybe<Scalars['String']['output']>;
  videoAskUrl?: Maybe<Scalars['String']['output']>;
};

export type ProgramRevisionProgramSchemaAdksPresetFieldsPreset = {
  __typename?: 'ProgramRevisionProgramSchemaAdksPresetFieldsPreset';
  maxCharacters?: Maybe<Scalars['String']['output']>;
  maxQuestions?: Maybe<Scalars['Int']['output']>;
  maxTeamMembers?: Maybe<Scalars['Int']['output']>;
  minLogs?: Maybe<Scalars['Int']['output']>;
  minimumHoursNow?: Maybe<Scalars['String']['output']>;
  videoMaxLength?: Maybe<Scalars['Int']['output']>;
};

export type ProgramRevisionProgramSchemaAdksPresetFieldsStyling = {
  __typename?: 'ProgramRevisionProgramSchemaAdksPresetFieldsStyling';
  class?: Maybe<Scalars['String']['output']>;
  depressed?: Maybe<Scalars['Boolean']['output']>;
  label: Scalars['String']['output'];
  outlined: Scalars['Boolean']['output'];
  placeholder?: Maybe<Scalars['String']['output']>;
  prependIcon?: Maybe<Scalars['String']['output']>;
  rounded: Scalars['Boolean']['output'];
  wrapperClass?: Maybe<Scalars['String']['output']>;
  xLarge?: Maybe<Scalars['Boolean']['output']>;
};

export type ProgramRevisionProgramSchemaAdksStyling = {
  __typename?: 'ProgramRevisionProgramSchemaAdksStyling';
  borderColor: Scalars['String']['output'];
};

export type ProgramRevisionSumAggregate = {
  __typename?: 'ProgramRevisionSumAggregate';
  tokens?: Maybe<Scalars['Int']['output']>;
  version?: Maybe<Scalars['Int']['output']>;
};

export type ProgramRevisionTokensRange = {
  __typename?: 'ProgramRevisionTokensRange';
  max: Scalars['Int']['output'];
  min: Scalars['Int']['output'];
};

/** User role in relation to a program */
export enum ProgramRole {
  Organizer = 'ORGANIZER',
  Participant = 'PARTICIPANT'
}

/** Program roster user with activity status (active + inactive) */
export type ProgramRosterUser = {
  __typename?: 'ProgramRosterUser';
  /** Current activity name if user is active in THIS program */
  currentActivity?: Maybe<Scalars['String']['output']>;
  /** User first name */
  firstName: Scalars['String']['output'];
  /** Whether user is currently active in THIS program */
  isActive: Scalars['Boolean']['output'];
  /** Last activity user was working on (if inactive) */
  lastActivity?: Maybe<Scalars['String']['output']>;
  /** User last name */
  lastName: Scalars['String']['output'];
  /** Last program user was in (if inactive and not in current program) */
  lastProgram?: Maybe<Scalars['String']['output']>;
  /** ISO timestamp of last activity (omitted if user has never been active) */
  lastSeen?: Maybe<Scalars['String']['output']>;
  /** URL to user profile image */
  profileImage?: Maybe<Scalars['String']['output']>;
  /** User ID */
  userId: Scalars['ID']['output'];
};

export type ProgramSchemaAdks = {
  __typename?: 'ProgramSchemaAdks';
  activityImage?: Maybe<Scalars['String']['output']>;
  buildScope?: Maybe<ProgramSchemaAdksBuildScope>;
  builderType?: Maybe<Scalars['String']['output']>;
  category: Scalars['String']['output'];
  /** Multiple data types found: String: 3.5%, Boolean: 2.3%, DateTime (Date): 94.3% out of 666 sampled entries */
  completed?: Maybe<Scalars['JSON']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  discordEntityType?: Maybe<Scalars['String']['output']>;
  employerWebsite?: Maybe<Scalars['String']['output']>;
  fields?: Maybe<Array<ProgramSchemaAdksFields>>;
  icon: Scalars['String']['output'];
  id: Scalars['String']['output'];
  instruction?: Maybe<ProgramSchemaAdksInstruction>;
  interviewReqeust?: Maybe<Scalars['String']['output']>;
  introVideo?: Maybe<Scalars['String']['output']>;
  isPreview?: Maybe<Scalars['Boolean']['output']>;
  isSaved?: Maybe<Scalars['Boolean']['output']>;
  isSkippable?: Maybe<Scalars['Boolean']['output']>;
  isTeamAdk?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  optional?: Maybe<Scalars['Boolean']['output']>;
  permissions?: Maybe<Array<ProgramSchemaAdksPermissions>>;
  position: Scalars['Int']['output'];
  presetFields?: Maybe<Array<ProgramSchemaAdksPresetFields>>;
  preview?: Maybe<Scalars['Boolean']['output']>;
  projectScope?: Maybe<Scalars['String']['output']>;
  required?: Maybe<Scalars['Boolean']['output']>;
  setupRequired: Scalars['Boolean']['output'];
  status: Scalars['Boolean']['output'];
  styling: ProgramSchemaAdksStyling;
};

export type ProgramSchemaAdksBuildScope = {
  __typename?: 'ProgramSchemaAdksBuildScope';
  objectives?: Maybe<Array<ProgramSchemaAdksBuildScopeObjectives>>;
  projects?: Maybe<Array<ProgramSchemaAdksBuildScopeProjects>>;
};

export type ProgramSchemaAdksBuildScopeObjectives = {
  __typename?: 'ProgramSchemaAdksBuildScopeObjectives';
  action?: Maybe<Scalars['String']['output']>;
  icon?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  position: Scalars['Int']['output'];
  roles?: Maybe<Array<Scalars['String']['output']>>;
  /** Could not determine type: the field only had null or empty values in the sample set. */
  rules?: Maybe<Scalars['JSON']['output']>;
  styling?: Maybe<ProgramSchemaAdksBuildScopeObjectivesStyling>;
  target?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
};

export type ProgramSchemaAdksBuildScopeObjectivesStyling = {
  __typename?: 'ProgramSchemaAdksBuildScopeObjectivesStyling';
  depressed?: Maybe<Scalars['Boolean']['output']>;
  hint?: Maybe<Scalars['String']['output']>;
  icon?: Maybe<Scalars['String']['output']>;
  label: Scalars['String']['output'];
  leftIcon?: Maybe<Scalars['String']['output']>;
  outlined: Scalars['Boolean']['output'];
  placeholder?: Maybe<Scalars['String']['output']>;
  rightIcon?: Maybe<Scalars['String']['output']>;
  rounded: Scalars['Boolean']['output'];
  small?: Maybe<Scalars['Boolean']['output']>;
};

export type ProgramSchemaAdksBuildScopeProjects = {
  __typename?: 'ProgramSchemaAdksBuildScopeProjects';
  action?: Maybe<Scalars['String']['output']>;
  icon?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  position: Scalars['Int']['output'];
  roles?: Maybe<Array<Scalars['String']['output']>>;
  styling?: Maybe<ProgramSchemaAdksBuildScopeProjectsStyling>;
  target?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
};

export type ProgramSchemaAdksBuildScopeProjectsStyling = {
  __typename?: 'ProgramSchemaAdksBuildScopeProjectsStyling';
  color: Scalars['String']['output'];
  depressed: Scalars['Boolean']['output'];
  label: Scalars['String']['output'];
  leftIcon: Scalars['String']['output'];
  rounded: Scalars['Boolean']['output'];
};

export type ProgramSchemaAdksFields = {
  __typename?: 'ProgramSchemaAdksFields';
  action?: Maybe<Scalars['String']['output']>;
  active?: Maybe<Scalars['Boolean']['output']>;
  addButtonLabel?: Maybe<Scalars['String']['output']>;
  adk?: Maybe<Scalars['String']['output']>;
  ages?: Maybe<Scalars['String']['output']>;
  align?: Maybe<Scalars['String']['output']>;
  blank?: Maybe<Scalars['Boolean']['output']>;
  builderType?: Maybe<Scalars['String']['output']>;
  color?: Maybe<Scalars['String']['output']>;
  /** ISO timestamp of last compilation */
  compiledAt?: Maybe<Scalars['DateTime']['output']>;
  /** Compilation metadata: { vue: "2.7.16", vuetify: "2.4.6" } */
  compiledWith?: Maybe<Scalars['JSON']['output']>;
  dark?: Maybe<Scalars['Boolean']['output']>;
  /** Multiple data types found: String: 18.5%, Boolean: 59.3%, Int: 22.2% out of 16985 sampled entries */
  defaultValue?: Maybe<Scalars['JSON']['output']>;
  /** Multiple data types found: String: 32.4%, ProgramSchemaAdksFieldsEvent: 67.6% out of 2457 sampled entries */
  event?: Maybe<Scalars['JSON']['output']>;
  groupLabel?: Maybe<Scalars['String']['output']>;
  header?: Maybe<Scalars['String']['output']>;
  href?: Maybe<Scalars['String']['output']>;
  icon?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  /** Multiple data types found: Array(String): 75.1%, Array(Int): 24.9% out of 5856 sampled entries */
  items?: Maybe<Scalars['JSON']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  linkLabel?: Maybe<Scalars['String']['output']>;
  link_type?: Maybe<Scalars['String']['output']>;
  max?: Maybe<Scalars['String']['output']>;
  maxDate?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  min?: Maybe<Scalars['String']['output']>;
  minDate?: Maybe<Scalars['String']['output']>;
  model?: Maybe<Scalars['String']['output']>;
  modelItems?: Maybe<Array<ProgramSchemaAdksFieldsModelItems>>;
  multiple?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  noSetup?: Maybe<Scalars['Boolean']['output']>;
  outlined?: Maybe<Scalars['Boolean']['output']>;
  placeholder?: Maybe<Scalars['String']['output']>;
  position?: Maybe<Scalars['Int']['output']>;
  preset?: Maybe<ProgramSchemaAdksFieldsPreset>;
  radioButtons?: Maybe<Array<ProgramSchemaAdksFieldsRadioButtons>>;
  required?: Maybe<Scalars['Boolean']['output']>;
  roles?: Maybe<Array<Scalars['String']['output']>>;
  rounded?: Maybe<Scalars['Boolean']['output']>;
  rules?: Maybe<Array<Scalars['String']['output']>>;
  searchInput?: Maybe<Scalars['String']['output']>;
  searchType?: Maybe<Scalars['String']['output']>;
  /** Semantic contract for tri-mode participation (UI, text chat, voice) */
  semantic?: Maybe<Scalars['JSON']['output']>;
  setup?: Maybe<ProgramSchemaAdksFieldsSetup>;
  styling?: Maybe<ProgramSchemaAdksFieldsStyling>;
  subTitle?: Maybe<Scalars['String']['output']>;
  target?: Maybe<Scalars['String']['output']>;
  tickSize?: Maybe<Scalars['Int']['output']>;
  ticks?: Maybe<Scalars['Boolean']['output']>;
  timelineItems?: Maybe<Array<ProgramSchemaAdksFieldsTimelineItems>>;
  title?: Maybe<Scalars['String']['output']>;
  titleAfterChip?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  vChipContent?: Maybe<Scalars['String']['output']>;
  /** Multiple data types found: String: 0%, ProgramSchemaAdksFieldsValue: 100% out of 60130 sampled entries */
  value?: Maybe<Scalars['JSON']['output']>;
  videoAskLabel?: Maybe<Scalars['String']['output']>;
  videoAskUrl?: Maybe<Scalars['String']['output']>;
  videoName?: Maybe<Scalars['String']['output']>;
  /** Raw .vue source code (generated widgets only) */
  widgetSource?: Maybe<Scalars['String']['output']>;
  /** CDN URL for compiled widget JS (generated widgets only) */
  widgetUrl?: Maybe<Scalars['String']['output']>;
  /** Widget version number for immutability tracking */
  widgetVersion?: Maybe<Scalars['Int']['output']>;
};

export type ProgramSchemaAdksFieldsModelItems = {
  __typename?: 'ProgramSchemaAdksFieldsModelItems';
  name: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type ProgramSchemaAdksFieldsPreset = {
  __typename?: 'ProgramSchemaAdksFieldsPreset';
  aboutOrg?: Maybe<Scalars['String']['output']>;
  acceptanceDeadline?: Maybe<Scalars['String']['output']>;
  apprentice?: Maybe<Scalars['Boolean']['output']>;
  compensation1?: Maybe<Scalars['Boolean']['output']>;
  compensation2?: Maybe<Scalars['Boolean']['output']>;
  compensation3?: Maybe<Scalars['Boolean']['output']>;
  compensation4?: Maybe<Scalars['Boolean']['output']>;
  compensation5?: Maybe<Scalars['Boolean']['output']>;
  compensation6?: Maybe<Scalars['Boolean']['output']>;
  continuation?: Maybe<Scalars['Int']['output']>;
  eir?: Maybe<Scalars['Boolean']['output']>;
  employerRecord?: Maybe<Scalars['Int']['output']>;
  extern?: Maybe<Scalars['Boolean']['output']>;
  externCredential?: Maybe<Scalars['Int']['output']>;
  fellow?: Maybe<Scalars['Boolean']['output']>;
  intern?: Maybe<Scalars['Boolean']['output']>;
  internshipEnd?: Maybe<Scalars['String']['output']>;
  internshipProject1?: Maybe<Scalars['Boolean']['output']>;
  internshipProject2?: Maybe<Scalars['Boolean']['output']>;
  internshipProject3?: Maybe<Scalars['Boolean']['output']>;
  internshipStart?: Maybe<Scalars['String']['output']>;
  interviewChallenge?: Maybe<Scalars['String']['output']>;
  interviewOpportunity?: Maybe<Scalars['String']['output']>;
  interviewProblem?: Maybe<Scalars['String']['output']>;
  interviewRequest?: Maybe<Scalars['String']['output']>;
  interviewSolution?: Maybe<Scalars['String']['output']>;
  licenseRequirement?: Maybe<Scalars['Int']['output']>;
  maxHours?: Maybe<Scalars['Int']['output']>;
  maximumBudget?: Maybe<Scalars['String']['output']>;
  minHours?: Maybe<Scalars['Int']['output']>;
  minimumBudget?: Maybe<Scalars['String']['output']>;
  pathways?: Maybe<Array<Scalars['String']['output']>>;
  preApprentice?: Maybe<Scalars['Boolean']['output']>;
  preInternship?: Maybe<Scalars['Boolean']['output']>;
  programDesc?: Maybe<Scalars['String']['output']>;
  programName?: Maybe<Scalars['String']['output']>;
  projectReq?: Maybe<Array<Scalars['String']['output']>>;
  /** Could not determine type: the field only had null or empty values in the sample set. */
  requiredResidency?: Maybe<Scalars['JSON']['output']>;
  requiredSkills?: Maybe<Array<Scalars['String']['output']>>;
  /** Could not determine type: the field only had null or empty values in the sample set. */
  resourceDrive?: Maybe<Scalars['JSON']['output']>;
  resourceFacebook?: Maybe<Scalars['String']['output']>;
  /** Could not determine type: the field only had null or empty values in the sample set. */
  resourceInsta?: Maybe<Scalars['JSON']['output']>;
  resourceLinkedIn?: Maybe<Scalars['String']['output']>;
  resourceTwitter?: Maybe<Scalars['String']['output']>;
  resourceWeb?: Maybe<Scalars['String']['output']>;
  /** Could not determine type: the field only had null or empty values in the sample set. */
  resourceYouTube?: Maybe<Scalars['JSON']['output']>;
  /** Multiple data types found: String: 4.3%, Array(String): 95.7% out of 28 sampled entries */
  rewards?: Maybe<Scalars['JSON']['output']>;
};

export type ProgramSchemaAdksFieldsRadioButtons = {
  __typename?: 'ProgramSchemaAdksFieldsRadioButtons';
  action?: Maybe<Scalars['String']['output']>;
  clickable?: Maybe<Scalars['Boolean']['output']>;
  event?: Maybe<ProgramSchemaAdksFieldsRadioButtonsEvent>;
  label: Scalars['String']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type ProgramSchemaAdksFieldsRadioButtonsEvent = {
  __typename?: 'ProgramSchemaAdksFieldsRadioButtonsEvent';
  body: Scalars['String']['output'];
  buttons?: Maybe<Array<ProgramSchemaAdksFieldsRadioButtonsEventButtons>>;
  component: Scalars['String']['output'];
  title: Scalars['String']['output'];
  trigger: Scalars['String']['output'];
};

export type ProgramSchemaAdksFieldsRadioButtonsEventButtons = {
  __typename?: 'ProgramSchemaAdksFieldsRadioButtonsEventButtons';
  label: Scalars['String']['output'];
  model: Scalars['String']['output'];
  style: ProgramSchemaAdksFieldsRadioButtonsEventButtonsStyle;
};

export type ProgramSchemaAdksFieldsRadioButtonsEventButtonsStyle = {
  __typename?: 'ProgramSchemaAdksFieldsRadioButtonsEventButtonsStyle';
  class: Scalars['String']['output'];
  color: Scalars['String']['output'];
  dark?: Maybe<Scalars['Boolean']['output']>;
  depressed?: Maybe<Scalars['Boolean']['output']>;
  outlined?: Maybe<Scalars['Boolean']['output']>;
  rounded: Scalars['Boolean']['output'];
  xLarge: Scalars['Boolean']['output'];
};

export type ProgramSchemaAdksFieldsSetup = {
  __typename?: 'ProgramSchemaAdksFieldsSetup';
  aboutOrg?: Maybe<Scalars['String']['output']>;
  acceptanceDeadline?: Maybe<Scalars['String']['output']>;
  ageRange?: Maybe<Array<Scalars['Int']['output']>>;
  apprentice?: Maybe<Scalars['Boolean']['output']>;
  compensation1?: Maybe<Scalars['Boolean']['output']>;
  compensation2?: Maybe<Scalars['Boolean']['output']>;
  compensation3?: Maybe<Scalars['Boolean']['output']>;
  compensation4?: Maybe<Scalars['Boolean']['output']>;
  compensation5?: Maybe<Scalars['Boolean']['output']>;
  compensation6?: Maybe<Scalars['Boolean']['output']>;
  continuation?: Maybe<Scalars['Int']['output']>;
  eir?: Maybe<Scalars['Boolean']['output']>;
  employerRecord?: Maybe<Scalars['Int']['output']>;
  extern?: Maybe<Scalars['Boolean']['output']>;
  externCredential?: Maybe<Scalars['Int']['output']>;
  fellow?: Maybe<Scalars['Boolean']['output']>;
  intern?: Maybe<Scalars['Boolean']['output']>;
  internshipEnd?: Maybe<Scalars['String']['output']>;
  internshipProject1?: Maybe<Scalars['Boolean']['output']>;
  internshipProject2?: Maybe<Scalars['Boolean']['output']>;
  internshipProject3?: Maybe<Scalars['Boolean']['output']>;
  internshipStart?: Maybe<Scalars['String']['output']>;
  interviewChallenge?: Maybe<Scalars['String']['output']>;
  interviewOpportunity?: Maybe<Scalars['String']['output']>;
  interviewProblem?: Maybe<Scalars['String']['output']>;
  interviewRequest?: Maybe<Scalars['String']['output']>;
  interviewSolution?: Maybe<Scalars['String']['output']>;
  licenseRequirement?: Maybe<Scalars['Int']['output']>;
  maxHours?: Maybe<Scalars['Int']['output']>;
  maximumBudget?: Maybe<Scalars['String']['output']>;
  minHours?: Maybe<Scalars['Int']['output']>;
  minimumBudget?: Maybe<Scalars['String']['output']>;
  pathways?: Maybe<Array<Scalars['String']['output']>>;
  preApprentice?: Maybe<Scalars['Boolean']['output']>;
  preInternship?: Maybe<Scalars['Boolean']['output']>;
  programDesc?: Maybe<Scalars['String']['output']>;
  programName?: Maybe<Scalars['String']['output']>;
  projectReq?: Maybe<Array<Scalars['String']['output']>>;
  /** Could not determine type: the field only had null or empty values in the sample set. */
  requiredResidency?: Maybe<Scalars['JSON']['output']>;
  requiredSkills?: Maybe<Array<Scalars['String']['output']>>;
  researchLinks?: Maybe<Array<ProgramSchemaAdksFieldsSetupResearchLinks>>;
  /** Could not determine type: the field only had null or empty values in the sample set. */
  resourceDrive?: Maybe<Scalars['JSON']['output']>;
  resourceFacebook?: Maybe<Scalars['String']['output']>;
  /** Could not determine type: the field only had null or empty values in the sample set. */
  resourceInsta?: Maybe<Scalars['JSON']['output']>;
  resourceLinkedIn?: Maybe<Scalars['String']['output']>;
  resourceTwitter?: Maybe<Scalars['String']['output']>;
  resourceWeb?: Maybe<Scalars['String']['output']>;
  /** Could not determine type: the field only had null or empty values in the sample set. */
  resourceYouTube?: Maybe<Scalars['JSON']['output']>;
  /** Multiple data types found: String: 4.3%, Array(String): 95.7% out of 28 sampled entries */
  rewards?: Maybe<Scalars['JSON']['output']>;
  videoaskLink?: Maybe<Scalars['String']['output']>;
};

export type ProgramSchemaAdksFieldsSetupResearchLinks = {
  __typename?: 'ProgramSchemaAdksFieldsSetupResearchLinks';
  link: Scalars['String']['output'];
  required: Scalars['Boolean']['output'];
  resource: Scalars['String']['output'];
};

export type ProgramSchemaAdksFieldsStyling = {
  __typename?: 'ProgramSchemaAdksFieldsStyling';
  appendIcon?: Maybe<Scalars['String']['output']>;
  chips?: Maybe<Scalars['Boolean']['output']>;
  class?: Maybe<Scalars['String']['output']>;
  clearable?: Maybe<Scalars['Boolean']['output']>;
  color?: Maybe<Scalars['String']['output']>;
  cols?: Maybe<Scalars['String']['output']>;
  /** Multiple data types found: String: 79.5%, Int: 20.5% out of 13187 sampled entries */
  counter?: Maybe<Scalars['JSON']['output']>;
  dark?: Maybe<Scalars['Boolean']['output']>;
  dense?: Maybe<Scalars['Boolean']['output']>;
  denseIcon?: Maybe<Scalars['Boolean']['output']>;
  depressed?: Maybe<Scalars['Boolean']['output']>;
  flat?: Maybe<Scalars['Boolean']['output']>;
  generate_btn_label?: Maybe<Scalars['String']['output']>;
  hide_details?: Maybe<Scalars['Boolean']['output']>;
  hint?: Maybe<Scalars['String']['output']>;
  icon?: Maybe<Scalars['Boolean']['output']>;
  itemColor?: Maybe<Scalars['String']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  leftIcon?: Maybe<Scalars['Boolean']['output']>;
  multiple?: Maybe<Scalars['Boolean']['output']>;
  outlined?: Maybe<Scalars['Boolean']['output']>;
  placeholder?: Maybe<Scalars['String']['output']>;
  prependIcon?: Maybe<Scalars['String']['output']>;
  rightIcon?: Maybe<Scalars['Boolean']['output']>;
  rounded?: Maybe<Scalars['Boolean']['output']>;
  rows?: Maybe<Scalars['String']['output']>;
  small?: Maybe<Scalars['Boolean']['output']>;
  small_chips?: Maybe<Scalars['Boolean']['output']>;
  wrapperClass?: Maybe<Scalars['String']['output']>;
  xLarge?: Maybe<Scalars['Boolean']['output']>;
  xSmall?: Maybe<Scalars['Boolean']['output']>;
};

export type ProgramSchemaAdksFieldsTimelineItems = {
  __typename?: 'ProgramSchemaAdksFieldsTimelineItems';
  answer: Scalars['String']['output'];
  color: Scalars['String']['output'];
  question: Scalars['String']['output'];
};

export type ProgramSchemaAdksInstruction = {
  __typename?: 'ProgramSchemaAdksInstruction';
  boilerInstructions?: Maybe<Array<Scalars['String']['output']>>;
  discordUrl?: Maybe<Scalars['String']['output']>;
  goal?: Maybe<Scalars['String']['output']>;
  youtubeUrl?: Maybe<Scalars['String']['output']>;
};

export type ProgramSchemaAdksPermissions = {
  __typename?: 'ProgramSchemaAdksPermissions';
  permissions_matrix?: Maybe<Array<Scalars['String']['output']>>;
  role?: Maybe<Scalars['String']['output']>;
  roles?: Maybe<Scalars['String']['output']>;
};

export type ProgramSchemaAdksPresetFields = {
  __typename?: 'ProgramSchemaAdksPresetFields';
  /** Multiple data types found: String: 27.7%, Int: 72.3% out of 4284 sampled entries */
  defaultValue?: Maybe<Scalars['JSON']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  /** Multiple data types found: Array(String): 27.7%, Array(Int): 72.3% out of 4284 sampled entries */
  items?: Maybe<Scalars['JSON']['output']>;
  model?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  noSetup?: Maybe<Scalars['Boolean']['output']>;
  position?: Maybe<Scalars['Int']['output']>;
  preset?: Maybe<ProgramSchemaAdksPresetFieldsPreset>;
  roles?: Maybe<Array<Scalars['String']['output']>>;
  /** Could not determine type: the field only had null or empty values in the sample set. */
  rules?: Maybe<Scalars['JSON']['output']>;
  setup?: Maybe<ProgramSchemaAdksPresetFieldsSetup>;
  styling?: Maybe<ProgramSchemaAdksPresetFieldsStyling>;
  title?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
  /** Nested objects had no data in the sample dataset to introspect a nested type. */
  value?: Maybe<Scalars['JSON']['output']>;
  videoAskLabel?: Maybe<Scalars['String']['output']>;
  videoAskUrl?: Maybe<Scalars['String']['output']>;
};

export type ProgramSchemaAdksPresetFieldsPreset = {
  __typename?: 'ProgramSchemaAdksPresetFieldsPreset';
  maxCharacters?: Maybe<Scalars['String']['output']>;
  maxQuestions?: Maybe<Scalars['Int']['output']>;
  maxTeamMembers?: Maybe<Scalars['Int']['output']>;
  minLogs?: Maybe<Scalars['Int']['output']>;
  minimumHoursNow?: Maybe<Scalars['String']['output']>;
  videoMaxLength?: Maybe<Scalars['Int']['output']>;
};

export type ProgramSchemaAdksPresetFieldsSetup = {
  __typename?: 'ProgramSchemaAdksPresetFieldsSetup';
  maxCharacters?: Maybe<Scalars['String']['output']>;
  maxQuestions?: Maybe<Scalars['Int']['output']>;
  maxTeamMembers?: Maybe<Scalars['Int']['output']>;
  minLogs?: Maybe<Scalars['Int']['output']>;
  minimumHoursNow?: Maybe<Scalars['String']['output']>;
  videoMaxLength?: Maybe<Scalars['Int']['output']>;
};

export type ProgramSchemaAdksPresetFieldsStyling = {
  __typename?: 'ProgramSchemaAdksPresetFieldsStyling';
  label?: Maybe<Scalars['String']['output']>;
  outlined?: Maybe<Scalars['Boolean']['output']>;
  placeholder?: Maybe<Scalars['String']['output']>;
  prependIcon?: Maybe<Scalars['String']['output']>;
  rounded?: Maybe<Scalars['Boolean']['output']>;
};

export type ProgramSchemaAdksStyling = {
  __typename?: 'ProgramSchemaAdksStyling';
  borderColor: Scalars['String']['output'];
};

export type ProgramSchemaAirtable = {
  __typename?: 'ProgramSchemaAirtable';
  airtable_id: Scalars['String']['output'];
  created_at: Scalars['DateTime']['output'];
  last_modified_at: Scalars['DateTime']['output'];
};

export type ProgramSchemaAvgAggregate = {
  __typename?: 'ProgramSchemaAvgAggregate';
  displayOrder?: Maybe<Scalars['Float']['output']>;
  tokens?: Maybe<Scalars['Float']['output']>;
};

export type ProgramSchemaCategories = {
  __typename?: 'ProgramSchemaCategories';
  icon: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type ProgramSchemaCheckoutQualification = {
  __typename?: 'ProgramSchemaCheckoutQualification';
  ageLimit?: Maybe<Array<Scalars['Int']['output']>>;
};

export type ProgramSchemaCountAggregate = {
  __typename?: 'ProgramSchemaCountAggregate';
  _all: Scalars['Int']['output'];
  activityNotification: Scalars['Int']['output'];
  deadlineCompletion: Scalars['Int']['output'];
  displayColor: Scalars['Int']['output'];
  displayIcon: Scalars['Int']['output'];
  displayOrder: Scalars['Int']['output'];
  estimatedDuration: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  isCloned: Scalars['Int']['output'];
  isDefault: Scalars['Int']['output'];
  isLastModifiedAtExists: Scalars['Int']['output'];
  isPlatformBirth: Scalars['Int']['output'];
  isSaveAdkMoleculeAdded: Scalars['Int']['output'];
  isShowTimer: Scalars['Int']['output'];
  isTemplate: Scalars['Int']['output'];
  isUniqueIdAdded: Scalars['Int']['output'];
  isUnsponsoredProgram: Scalars['Int']['output'];
  last_synced_at: Scalars['Int']['output'];
  programImage: Scalars['Int']['output'];
  sharable_url: Scalars['Int']['output'];
  templateDesc: Scalars['Int']['output'];
  templateId: Scalars['Int']['output'];
  templateImage: Scalars['Int']['output'];
  templateName: Scalars['Int']['output'];
  timerType: Scalars['Int']['output'];
  tokens: Scalars['Int']['output'];
  unsponsoredAdk: Scalars['Int']['output'];
  visibility: Scalars['Int']['output'];
};

export type ProgramSchemaCredentials = {
  __typename?: 'ProgramSchemaCredentials';
  activities?: Maybe<Array<Scalars['String']['output']>>;
  credentials?: Maybe<Array<Scalars['String']['output']>>;
  id: Scalars['Int']['output'];
};

export type ProgramSchemaMaxAggregate = {
  __typename?: 'ProgramSchemaMaxAggregate';
  activityNotification?: Maybe<Scalars['Boolean']['output']>;
  displayColor?: Maybe<Scalars['String']['output']>;
  displayIcon?: Maybe<Scalars['String']['output']>;
  displayOrder?: Maybe<Scalars['Int']['output']>;
  estimatedDuration?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  isCloned?: Maybe<Scalars['Boolean']['output']>;
  isDefault?: Maybe<Scalars['Boolean']['output']>;
  isLastModifiedAtExists?: Maybe<Scalars['Boolean']['output']>;
  isPlatformBirth?: Maybe<Scalars['Boolean']['output']>;
  isSaveAdkMoleculeAdded?: Maybe<Scalars['Boolean']['output']>;
  isShowTimer?: Maybe<Scalars['Boolean']['output']>;
  isTemplate?: Maybe<Scalars['Boolean']['output']>;
  isUniqueIdAdded?: Maybe<Scalars['Boolean']['output']>;
  isUnsponsoredProgram?: Maybe<Scalars['Boolean']['output']>;
  last_synced_at?: Maybe<Scalars['DateTime']['output']>;
  sharable_url?: Maybe<Scalars['String']['output']>;
  templateDesc?: Maybe<Scalars['String']['output']>;
  templateId?: Maybe<Scalars['String']['output']>;
  templateImage?: Maybe<Scalars['String']['output']>;
  templateName?: Maybe<Scalars['String']['output']>;
  timerType?: Maybe<Scalars['String']['output']>;
  tokens?: Maybe<Scalars['Int']['output']>;
  unsponsoredAdk?: Maybe<Scalars['String']['output']>;
  visibility?: Maybe<Scalars['String']['output']>;
};

export type ProgramSchemaMetaData = {
  __typename?: 'ProgramSchemaMetaData';
  keywords?: Maybe<Array<Scalars['String']['output']>>;
  linkedinDesc: Scalars['String']['output'];
  /** Could not determine type: the field only had null or empty values in the sample set. */
  linkedinImage?: Maybe<Scalars['JSON']['output']>;
  linkedinTitle: Scalars['String']['output'];
  linkedinUrl: Scalars['String']['output'];
  metaDesc: Scalars['String']['output'];
  ogDesc: Scalars['String']['output'];
  /** Could not determine type: the field only had null or empty values in the sample set. */
  ogImage?: Maybe<Scalars['JSON']['output']>;
  ogTitle: Scalars['String']['output'];
  ogUrl: Scalars['String']['output'];
  tags?: Maybe<Array<Scalars['String']['output']>>;
  twitterDesc: Scalars['String']['output'];
  /** Could not determine type: the field only had null or empty values in the sample set. */
  twitterImage?: Maybe<Scalars['JSON']['output']>;
  twitterTitle: Scalars['String']['output'];
  twitterUrl: Scalars['String']['output'];
};

export type ProgramSchemaMinAggregate = {
  __typename?: 'ProgramSchemaMinAggregate';
  activityNotification?: Maybe<Scalars['Boolean']['output']>;
  displayColor?: Maybe<Scalars['String']['output']>;
  displayIcon?: Maybe<Scalars['String']['output']>;
  displayOrder?: Maybe<Scalars['Int']['output']>;
  estimatedDuration?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  isCloned?: Maybe<Scalars['Boolean']['output']>;
  isDefault?: Maybe<Scalars['Boolean']['output']>;
  isLastModifiedAtExists?: Maybe<Scalars['Boolean']['output']>;
  isPlatformBirth?: Maybe<Scalars['Boolean']['output']>;
  isSaveAdkMoleculeAdded?: Maybe<Scalars['Boolean']['output']>;
  isShowTimer?: Maybe<Scalars['Boolean']['output']>;
  isTemplate?: Maybe<Scalars['Boolean']['output']>;
  isUniqueIdAdded?: Maybe<Scalars['Boolean']['output']>;
  isUnsponsoredProgram?: Maybe<Scalars['Boolean']['output']>;
  last_synced_at?: Maybe<Scalars['DateTime']['output']>;
  sharable_url?: Maybe<Scalars['String']['output']>;
  templateDesc?: Maybe<Scalars['String']['output']>;
  templateId?: Maybe<Scalars['String']['output']>;
  templateImage?: Maybe<Scalars['String']['output']>;
  templateName?: Maybe<Scalars['String']['output']>;
  timerType?: Maybe<Scalars['String']['output']>;
  tokens?: Maybe<Scalars['Int']['output']>;
  unsponsoredAdk?: Maybe<Scalars['String']['output']>;
  visibility?: Maybe<Scalars['String']['output']>;
};

export type ProgramSchemaOption = {
  __typename?: 'ProgramSchemaOption';
  id: Scalars['String']['output'];
  templateName: Scalars['String']['output'];
};

export type ProgramSchemaRewards = {
  __typename?: 'ProgramSchemaRewards';
  /** Could not determine type: the field only had null or empty values in the sample set. */
  activities?: Maybe<Scalars['JSON']['output']>;
  id: Scalars['Int']['output'];
  /** Could not determine type: the field only had null or empty values in the sample set. */
  rewards?: Maybe<Scalars['JSON']['output']>;
};

export type ProgramSchemaSumAggregate = {
  __typename?: 'ProgramSchemaSumAggregate';
  displayOrder?: Maybe<Scalars['Int']['output']>;
  tokens?: Maybe<Scalars['Int']['output']>;
};

export type ProgramSchemaTokensRange = {
  __typename?: 'ProgramSchemaTokensRange';
  max: Scalars['Int']['output'];
  min: Scalars['Int']['output'];
};

export type ProgramSequenceStepInput = {
  /** Deadline date for this step */
  deadlineDate?: InputMaybe<Scalars['String']['input']>;
  /** Whether deadline date menu is shown */
  deadlineDateMenu?: InputMaybe<Scalars['Boolean']['input']>;
  /** Duration for this step */
  duration?: InputMaybe<Scalars['String']['input']>;
  /** Step label */
  label?: InputMaybe<Scalars['String']['input']>;
  /** Program model/template name */
  programModel?: InputMaybe<Scalars['String']['input']>;
  /** Number of programs to complete in this step */
  programsToComplete?: InputMaybe<Scalars['Int']['input']>;
  /** Real programs fetched from database */
  realPrograms?: InputMaybe<Scalars['JSON']['input']>;
  /** Whether this step is required */
  required?: InputMaybe<Scalars['Boolean']['input']>;
  /** Specific programs selected for this step */
  specificPrograms?: InputMaybe<Scalars['JSON']['input']>;
  /** Start date for this step */
  startDate?: InputMaybe<Scalars['String']['input']>;
  /** Whether start date menu is shown */
  startDateMenu?: InputMaybe<Scalars['Boolean']['input']>;
  /** Template ID for filtering */
  templateId?: InputMaybe<Scalars['String']['input']>;
};

/** Fields available for sorting programs */
export enum ProgramSortField {
  DateCreated = 'DATE_CREATED',
  LastSaved = 'LAST_SAVED',
  ParticipantCount = 'PARTICIPANT_COUNT',
  ProgramName = 'PROGRAM_NAME'
}

/** Computed status of a program based on user role and program state */
export enum ProgramStatus {
  Active = 'ACTIVE',
  AwaitingSponsor = 'AWAITING_SPONSOR',
  Completed = 'COMPLETED',
  Draft = 'DRAFT',
  NotStarted = 'NOT_STARTED',
  Published = 'PUBLISHED'
}

export type ProgramSumAggregate = {
  __typename?: 'ProgramSumAggregate';
  embeddings?: Maybe<Array<Scalars['Float']['output']>>;
  tokens?: Maybe<Scalars['Int']['output']>;
};

export type ProgramTeamAdk = {
  __typename?: 'ProgramTeamAdk';
  activityEndedOn?: Maybe<Scalars['DateTime']['output']>;
  activityModifiedOn?: Maybe<Scalars['DateTime']['output']>;
  activityStartedOn?: Maybe<Scalars['DateTime']['output']>;
  completed?: Maybe<Scalars['JSON']['output']>;
  logs?: Maybe<Array<ProgramTeamAdkLog>>;
  minimumHoursNow?: Maybe<Scalars['Float']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  practiceLog?: Maybe<Array<ProgramTeamAdkPracticeLog>>;
  questionsAsked?: Maybe<Array<Scalars['String']['output']>>;
  submittedVideo?: Maybe<Scalars['JSON']['output']>;
  valueDrafts?: Maybe<Array<ProgramTeamAdkValueDraft>>;
  videoMaxLength?: Maybe<Scalars['Int']['output']>;
};

export type ProgramTeamAdkLog = {
  __typename?: 'ProgramTeamAdkLog';
  author?: Maybe<Scalars['String']['output']>;
  avatar?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  log?: Maybe<Scalars['String']['output']>;
  proof?: Maybe<Array<ProgramTeamAdkLogProof>>;
  time?: Maybe<Scalars['DateTime']['output']>;
};

export type ProgramTeamAdkLogProof = {
  __typename?: 'ProgramTeamAdkLogProof';
  name?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type ProgramTeamAdkPracticeLog = {
  __typename?: 'ProgramTeamAdkPracticeLog';
  avatar?: Maybe<Scalars['String']['output']>;
  minutes?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  timestamp?: Maybe<Scalars['DateTime']['output']>;
  user_id?: Maybe<Scalars['String']['output']>;
};

export type ProgramTeamAdkValueDraft = {
  __typename?: 'ProgramTeamAdkValueDraft';
  elevatorPitch?: Maybe<Scalars['String']['output']>;
  finalDraft?: Maybe<Scalars['Boolean']['output']>;
  innovation?: Maybe<Scalars['String']['output']>;
  onePitch?: Maybe<Scalars['String']['output']>;
  problem?: Maybe<Scalars['String']['output']>;
  solution?: Maybe<Scalars['String']['output']>;
  user?: Maybe<Scalars['String']['output']>;
};

export type ProgramTeamCountAggregate = {
  __typename?: 'ProgramTeamCountAggregate';
  _all: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  lastSaved: Scalars['Int']['output'];
  name: Scalars['Int']['output'];
  owner: Scalars['Int']['output'];
  password: Scalars['Int']['output'];
  program_id: Scalars['Int']['output'];
};

export type ProgramTeamMaxAggregate = {
  __typename?: 'ProgramTeamMaxAggregate';
  id?: Maybe<Scalars['String']['output']>;
  lastSaved?: Maybe<Scalars['DateTime']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  owner?: Maybe<Scalars['String']['output']>;
  password?: Maybe<Scalars['String']['output']>;
  program_id?: Maybe<Scalars['String']['output']>;
};

export type ProgramTeamMember = {
  __typename?: 'ProgramTeamMember';
  avatar?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
};

export type ProgramTeamMinAggregate = {
  __typename?: 'ProgramTeamMinAggregate';
  id?: Maybe<Scalars['String']['output']>;
  lastSaved?: Maybe<Scalars['DateTime']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  owner?: Maybe<Scalars['String']['output']>;
  password?: Maybe<Scalars['String']['output']>;
  program_id?: Maybe<Scalars['String']['output']>;
};

/** Program-level time boundaries — outer limits for all activity dates */
export type ProgramTimeConfig = {
  __typename?: 'ProgramTimeConfig';
  /** Latest any activity can be due */
  programEndDate?: Maybe<Scalars['DateTime']['output']>;
  /** Earliest any activity can begin */
  programStartDate?: Maybe<Scalars['DateTime']['output']>;
};

export type ProgramTimeConfigCreateInput = {
  programEndDate?: InputMaybe<Scalars['DateTime']['input']>;
  programStartDate?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ProgramTimeConfigNullableCompositeFilter = {
  equals?: InputMaybe<ProgramTimeConfigObjectEqualityInput>;
  is?: InputMaybe<ProgramTimeConfigWhereInput>;
  isNot?: InputMaybe<ProgramTimeConfigWhereInput>;
  isSet?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ProgramTimeConfigNullableCreateEnvelopeInput = {
  set?: InputMaybe<ProgramTimeConfigCreateInput>;
};

export type ProgramTimeConfigNullableUpdateEnvelopeInput = {
  set?: InputMaybe<ProgramTimeConfigCreateInput>;
  unset?: InputMaybe<Scalars['Boolean']['input']>;
  upsert?: InputMaybe<ProgramTimeConfigUpsertInput>;
};

export type ProgramTimeConfigObjectEqualityInput = {
  programEndDate?: InputMaybe<Scalars['DateTime']['input']>;
  programStartDate?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ProgramTimeConfigUpdateInput = {
  programEndDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  programStartDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
};

export type ProgramTimeConfigUpsertInput = {
  set: ProgramTimeConfigCreateInput;
  update: ProgramTimeConfigUpdateInput;
};

export type ProgramTimeConfigWhereInput = {
  AND?: InputMaybe<Array<ProgramTimeConfigWhereInput>>;
  NOT?: InputMaybe<Array<ProgramTimeConfigWhereInput>>;
  OR?: InputMaybe<Array<ProgramTimeConfigWhereInput>>;
  programEndDate?: InputMaybe<DateTimeNullableFilter>;
  programStartDate?: InputMaybe<DateTimeNullableFilter>;
};

export type ProgramTokensRange = {
  __typename?: 'ProgramTokensRange';
  max: Scalars['Int']['output'];
  min: Scalars['Int']['output'];
};

export type ProgramTokensRangeCreateInput = {
  max: Scalars['Int']['input'];
  min: Scalars['Int']['input'];
};

export type ProgramTokensRangeNullableCompositeFilter = {
  equals?: InputMaybe<ProgramTokensRangeObjectEqualityInput>;
  is?: InputMaybe<ProgramTokensRangeWhereInput>;
  isNot?: InputMaybe<ProgramTokensRangeWhereInput>;
  isSet?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ProgramTokensRangeNullableCreateEnvelopeInput = {
  set?: InputMaybe<ProgramTokensRangeCreateInput>;
};

export type ProgramTokensRangeNullableUpdateEnvelopeInput = {
  set?: InputMaybe<ProgramTokensRangeCreateInput>;
  unset?: InputMaybe<Scalars['Boolean']['input']>;
  upsert?: InputMaybe<ProgramTokensRangeUpsertInput>;
};

export type ProgramTokensRangeObjectEqualityInput = {
  max: Scalars['Int']['input'];
  min: Scalars['Int']['input'];
};

export type ProgramTokensRangeUpdateInput = {
  max?: InputMaybe<IntFieldUpdateOperationsInput>;
  min?: InputMaybe<IntFieldUpdateOperationsInput>;
};

export type ProgramTokensRangeUpsertInput = {
  set: ProgramTokensRangeCreateInput;
  update: ProgramTokensRangeUpdateInput;
};

export type ProgramTokensRangeWhereInput = {
  AND?: InputMaybe<Array<ProgramTokensRangeWhereInput>>;
  NOT?: InputMaybe<Array<ProgramTokensRangeWhereInput>>;
  OR?: InputMaybe<Array<ProgramTokensRangeWhereInput>>;
  max?: InputMaybe<IntFilter>;
  min?: InputMaybe<IntFilter>;
};

export type ProgramUpdateOneRequiredWithoutStudentWalletTransactionsNestedInput = {
  connect?: InputMaybe<ProgramWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ProgramCreateOrConnectWithoutStudentWalletTransactionsInput>;
  create?: InputMaybe<ProgramCreateWithoutStudentWalletTransactionsInput>;
  update?: InputMaybe<ProgramUpdateToOneWithWhereWithoutStudentWalletTransactionsInput>;
  upsert?: InputMaybe<ProgramUpsertWithoutStudentWalletTransactionsInput>;
};

export type ProgramUpdateOneRequiredWithoutWalletTransactionsNestedInput = {
  connect?: InputMaybe<ProgramWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ProgramCreateOrConnectWithoutWalletTransactionsInput>;
  create?: InputMaybe<ProgramCreateWithoutWalletTransactionsInput>;
  update?: InputMaybe<ProgramUpdateToOneWithWhereWithoutWalletTransactionsInput>;
  upsert?: InputMaybe<ProgramUpsertWithoutWalletTransactionsInput>;
};

export type ProgramUpdateToOneWithWhereWithoutStudentWalletTransactionsInput = {
  data: ProgramUpdateWithoutStudentWalletTransactionsInput;
  where?: InputMaybe<ProgramWhereInput>;
};

export type ProgramUpdateToOneWithWhereWithoutWalletTransactionsInput = {
  data: ProgramUpdateWithoutWalletTransactionsInput;
  where?: InputMaybe<ProgramWhereInput>;
};

export type ProgramUpdateWithoutStudentWalletTransactionsInput = {
  activityNotification?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  adks?: InputMaybe<Array<ProgramAdksCreateInput>>;
  ageRange?: InputMaybe<Scalars['JSON']['input']>;
  airtable?: InputMaybe<Array<ProgramAirtableCreateInput>>;
  airtable_link?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  categories?: InputMaybe<Array<ProgramCategoriesCreateInput>>;
  checkoutQualification?: InputMaybe<ProgramCheckoutQualificationNullableUpdateEnvelopeInput>;
  colors?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  compilationStatus?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<Scalars['JSON']['input']>;
  creationMode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  credentials?: InputMaybe<Array<ProgramCredentialsCreateInput>>;
  dateCreated?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  deadlineCompletion?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  deliveryModality?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  domain?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  embedded_descriptor?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  embeddings?: InputMaybe<ProgramUpdateembeddingsInput>;
  file_draft?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  flippedDescription?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  flippedPresentation?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  flippedRegistration?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  industries?: InputMaybe<ProgramUpdateindustriesInput>;
  isChennelCreated?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isLastModifiedAtExists?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isProgramSchemaAdded?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isPublic?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isSaveAdkMoleculeAdded?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isShowTimer?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isUniqueFieldIdAdded?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isUniqueIdAdded?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isUnsponsoredProgram?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isUpdateOrg?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isUpdateParticipants?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  keywords?: InputMaybe<ProgramUpdatekeywordsInput>;
  lastSaved?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  last_synced_at?: InputMaybe<Scalars['JSON']['input']>;
  licensed?: InputMaybe<Scalars['JSON']['input']>;
  locations?: InputMaybe<Array<ProgramLocationCreateInput>>;
  metaData?: InputMaybe<ProgramMetaDataNullableUpdateEnvelopeInput>;
  organizationId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  organizationName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  organizers?: InputMaybe<Array<ProgramOrganizersCreateInput>>;
  originalProgramId?: InputMaybe<Scalars['JSON']['input']>;
  participants?: InputMaybe<Scalars['JSON']['input']>;
  pathways?: InputMaybe<ProgramUpdatepathwaysInput>;
  programDesc?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  programDesignId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  programImage?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  programKeywords?: InputMaybe<Scalars['JSON']['input']>;
  programName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  programPrice?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  program_schema?: InputMaybe<Array<ProgramProgramSchemaCreateInput>>;
  program_schema_id?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  public_url?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  published?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  publishedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  requiredResidency?: InputMaybe<Scalars['JSON']['input']>;
  requiredSkills?: InputMaybe<Scalars['JSON']['input']>;
  requiredTech?: InputMaybe<ProgramUpdaterequiredTechInput>;
  resourceWeb?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  reward?: InputMaybe<Scalars['JSON']['input']>;
  rewardPresets?: InputMaybe<ProgramUpdaterewardPresetsInput>;
  rewards?: InputMaybe<Scalars['JSON']['input']>;
  selectedDistrict?: InputMaybe<Scalars['JSON']['input']>;
  sharable_url?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  slug?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  socCodes?: InputMaybe<ProgramUpdatesocCodesInput>;
  start_activity_status?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  templateId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  templateImage?: InputMaybe<Scalars['JSON']['input']>;
  templateName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  timeConfig?: InputMaybe<ProgramTimeConfigNullableUpdateEnvelopeInput>;
  timerType?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  tokens?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  tokensRange?: InputMaybe<ProgramTokensRangeNullableUpdateEnvelopeInput>;
  unsponsoredAdk?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  videoAskShareId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  visibility?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  walletTransactions?: InputMaybe<WalletTransactionUpdateManyWithoutProgramNestedInput>;
};

export type ProgramUpdateWithoutWalletTransactionsInput = {
  activityNotification?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  adks?: InputMaybe<Array<ProgramAdksCreateInput>>;
  ageRange?: InputMaybe<Scalars['JSON']['input']>;
  airtable?: InputMaybe<Array<ProgramAirtableCreateInput>>;
  airtable_link?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  categories?: InputMaybe<Array<ProgramCategoriesCreateInput>>;
  checkoutQualification?: InputMaybe<ProgramCheckoutQualificationNullableUpdateEnvelopeInput>;
  colors?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  compilationStatus?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<Scalars['JSON']['input']>;
  creationMode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  credentials?: InputMaybe<Array<ProgramCredentialsCreateInput>>;
  dateCreated?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  deadlineCompletion?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  deliveryModality?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  domain?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  embedded_descriptor?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  embeddings?: InputMaybe<ProgramUpdateembeddingsInput>;
  file_draft?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  flippedDescription?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  flippedPresentation?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  flippedRegistration?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  industries?: InputMaybe<ProgramUpdateindustriesInput>;
  isChennelCreated?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isLastModifiedAtExists?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isProgramSchemaAdded?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isPublic?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isSaveAdkMoleculeAdded?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isShowTimer?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isUniqueFieldIdAdded?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isUniqueIdAdded?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isUnsponsoredProgram?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isUpdateOrg?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isUpdateParticipants?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  keywords?: InputMaybe<ProgramUpdatekeywordsInput>;
  lastSaved?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  last_synced_at?: InputMaybe<Scalars['JSON']['input']>;
  licensed?: InputMaybe<Scalars['JSON']['input']>;
  locations?: InputMaybe<Array<ProgramLocationCreateInput>>;
  metaData?: InputMaybe<ProgramMetaDataNullableUpdateEnvelopeInput>;
  organizationId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  organizationName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  organizers?: InputMaybe<Array<ProgramOrganizersCreateInput>>;
  originalProgramId?: InputMaybe<Scalars['JSON']['input']>;
  participants?: InputMaybe<Scalars['JSON']['input']>;
  pathways?: InputMaybe<ProgramUpdatepathwaysInput>;
  programDesc?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  programDesignId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  programImage?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  programKeywords?: InputMaybe<Scalars['JSON']['input']>;
  programName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  programPrice?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  program_schema?: InputMaybe<Array<ProgramProgramSchemaCreateInput>>;
  program_schema_id?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  public_url?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  published?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  publishedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  requiredResidency?: InputMaybe<Scalars['JSON']['input']>;
  requiredSkills?: InputMaybe<Scalars['JSON']['input']>;
  requiredTech?: InputMaybe<ProgramUpdaterequiredTechInput>;
  resourceWeb?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  reward?: InputMaybe<Scalars['JSON']['input']>;
  rewardPresets?: InputMaybe<ProgramUpdaterewardPresetsInput>;
  rewards?: InputMaybe<Scalars['JSON']['input']>;
  selectedDistrict?: InputMaybe<Scalars['JSON']['input']>;
  sharable_url?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  slug?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  socCodes?: InputMaybe<ProgramUpdatesocCodesInput>;
  start_activity_status?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  studentWalletTransactions?: InputMaybe<StudentWalletTransactionUpdateManyWithoutProgramNestedInput>;
  templateId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  templateImage?: InputMaybe<Scalars['JSON']['input']>;
  templateName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  timeConfig?: InputMaybe<ProgramTimeConfigNullableUpdateEnvelopeInput>;
  timerType?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  tokens?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  tokensRange?: InputMaybe<ProgramTokensRangeNullableUpdateEnvelopeInput>;
  unsponsoredAdk?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  videoAskShareId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  visibility?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type ProgramUpdateembeddingsInput = {
  push?: InputMaybe<Array<Scalars['Float']['input']>>;
  set?: InputMaybe<Array<Scalars['Float']['input']>>;
};

export type ProgramUpdateindustriesInput = {
  push?: InputMaybe<Array<Scalars['String']['input']>>;
  set?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type ProgramUpdatekeywordsInput = {
  push?: InputMaybe<Array<Scalars['String']['input']>>;
  set?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type ProgramUpdatepathwaysInput = {
  push?: InputMaybe<Array<Scalars['String']['input']>>;
  set?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type ProgramUpdaterequiredTechInput = {
  push?: InputMaybe<Array<Scalars['String']['input']>>;
  set?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type ProgramUpdaterewardPresetsInput = {
  push?: InputMaybe<Array<Scalars['String']['input']>>;
  set?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type ProgramUpdatesocCodesInput = {
  push?: InputMaybe<Array<Scalars['String']['input']>>;
  set?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type ProgramUpsertWithoutStudentWalletTransactionsInput = {
  create: ProgramCreateWithoutStudentWalletTransactionsInput;
  update: ProgramUpdateWithoutStudentWalletTransactionsInput;
  where?: InputMaybe<ProgramWhereInput>;
};

export type ProgramUpsertWithoutWalletTransactionsInput = {
  create: ProgramCreateWithoutWalletTransactionsInput;
  update: ProgramUpdateWithoutWalletTransactionsInput;
  where?: InputMaybe<ProgramWhereInput>;
};

export type ProgramWhereInput = {
  AND?: InputMaybe<Array<ProgramWhereInput>>;
  NOT?: InputMaybe<Array<ProgramWhereInput>>;
  OR?: InputMaybe<Array<ProgramWhereInput>>;
  activityNotification?: InputMaybe<BoolNullableFilter>;
  adks?: InputMaybe<Array<ProgramAdksObjectEqualityInput>>;
  ageRange?: InputMaybe<JsonNullableFilter>;
  airtable?: InputMaybe<Array<ProgramAirtableObjectEqualityInput>>;
  airtable_link?: InputMaybe<StringNullableFilter>;
  categories?: InputMaybe<Array<ProgramCategoriesObjectEqualityInput>>;
  checkoutQualification?: InputMaybe<ProgramCheckoutQualificationNullableCompositeFilter>;
  colors?: InputMaybe<StringNullableFilter>;
  compilationStatus?: InputMaybe<StringNullableFilter>;
  createdBy?: InputMaybe<JsonNullableFilter>;
  creationMode?: InputMaybe<StringNullableFilter>;
  credentials?: InputMaybe<Array<ProgramCredentialsObjectEqualityInput>>;
  dateCreated?: InputMaybe<DateTimeFilter>;
  deadlineCompletion?: InputMaybe<StringNullableFilter>;
  deliveryModality?: InputMaybe<StringNullableFilter>;
  domain?: InputMaybe<StringNullableFilter>;
  embedded_descriptor?: InputMaybe<StringNullableFilter>;
  embeddings?: InputMaybe<FloatNullableListFilter>;
  file_draft?: InputMaybe<BoolNullableFilter>;
  flippedDescription?: InputMaybe<StringNullableFilter>;
  flippedPresentation?: InputMaybe<StringNullableFilter>;
  flippedRegistration?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<StringFilter>;
  industries?: InputMaybe<StringNullableListFilter>;
  isChennelCreated?: InputMaybe<BoolNullableFilter>;
  isLastModifiedAtExists?: InputMaybe<BoolNullableFilter>;
  isProgramSchemaAdded?: InputMaybe<BoolNullableFilter>;
  isPublic?: InputMaybe<BoolNullableFilter>;
  isSaveAdkMoleculeAdded?: InputMaybe<BoolNullableFilter>;
  isShowTimer?: InputMaybe<BoolNullableFilter>;
  isUniqueFieldIdAdded?: InputMaybe<BoolNullableFilter>;
  isUniqueIdAdded?: InputMaybe<BoolNullableFilter>;
  isUnsponsoredProgram?: InputMaybe<BoolNullableFilter>;
  isUpdateOrg?: InputMaybe<BoolNullableFilter>;
  isUpdateParticipants?: InputMaybe<BoolNullableFilter>;
  keywords?: InputMaybe<StringNullableListFilter>;
  lastSaved?: InputMaybe<DateTimeFilter>;
  last_synced_at?: InputMaybe<JsonNullableFilter>;
  licensed?: InputMaybe<JsonNullableFilter>;
  locations?: InputMaybe<Array<ProgramLocationObjectEqualityInput>>;
  metaData?: InputMaybe<ProgramMetaDataNullableCompositeFilter>;
  organizationId?: InputMaybe<StringNullableFilter>;
  organizationName?: InputMaybe<StringNullableFilter>;
  organizers?: InputMaybe<Array<ProgramOrganizersObjectEqualityInput>>;
  originalProgramId?: InputMaybe<JsonNullableFilter>;
  participants?: InputMaybe<JsonNullableFilter>;
  pathways?: InputMaybe<StringNullableListFilter>;
  programDesc?: InputMaybe<StringNullableFilter>;
  programDesignId?: InputMaybe<StringNullableFilter>;
  programImage?: InputMaybe<StringNullableFilter>;
  programKeywords?: InputMaybe<JsonNullableFilter>;
  programName?: InputMaybe<StringNullableFilter>;
  programPrice?: InputMaybe<StringNullableFilter>;
  program_schema?: InputMaybe<Array<ProgramProgramSchemaObjectEqualityInput>>;
  program_schema_id?: InputMaybe<StringNullableFilter>;
  public_url?: InputMaybe<StringNullableFilter>;
  published?: InputMaybe<BoolNullableFilter>;
  publishedAt?: InputMaybe<DateTimeNullableFilter>;
  requiredResidency?: InputMaybe<JsonNullableFilter>;
  requiredSkills?: InputMaybe<JsonNullableFilter>;
  requiredTech?: InputMaybe<StringNullableListFilter>;
  resourceWeb?: InputMaybe<StringNullableFilter>;
  reward?: InputMaybe<JsonNullableFilter>;
  rewardPresets?: InputMaybe<StringNullableListFilter>;
  rewards?: InputMaybe<JsonNullableFilter>;
  selectedDistrict?: InputMaybe<JsonNullableFilter>;
  sharable_url?: InputMaybe<StringNullableFilter>;
  slug?: InputMaybe<StringNullableFilter>;
  socCodes?: InputMaybe<StringNullableListFilter>;
  start_activity_status?: InputMaybe<StringNullableFilter>;
  studentWalletTransactions?: InputMaybe<StudentWalletTransactionListRelationFilter>;
  templateId?: InputMaybe<StringNullableFilter>;
  templateImage?: InputMaybe<JsonNullableFilter>;
  templateName?: InputMaybe<StringNullableFilter>;
  timeConfig?: InputMaybe<ProgramTimeConfigNullableCompositeFilter>;
  timerType?: InputMaybe<StringNullableFilter>;
  tokens?: InputMaybe<IntNullableFilter>;
  tokensRange?: InputMaybe<ProgramTokensRangeNullableCompositeFilter>;
  unsponsoredAdk?: InputMaybe<StringNullableFilter>;
  videoAskShareId?: InputMaybe<StringNullableFilter>;
  visibility?: InputMaybe<StringNullableFilter>;
  walletTransactions?: InputMaybe<WalletTransactionListRelationFilter>;
};

export type ProgramWhereUniqueInput = {
  AND?: InputMaybe<Array<ProgramWhereInput>>;
  NOT?: InputMaybe<Array<ProgramWhereInput>>;
  OR?: InputMaybe<Array<ProgramWhereInput>>;
  activityNotification?: InputMaybe<BoolNullableFilter>;
  adks?: InputMaybe<Array<ProgramAdksObjectEqualityInput>>;
  ageRange?: InputMaybe<JsonNullableFilter>;
  airtable?: InputMaybe<Array<ProgramAirtableObjectEqualityInput>>;
  airtable_link?: InputMaybe<StringNullableFilter>;
  categories?: InputMaybe<Array<ProgramCategoriesObjectEqualityInput>>;
  checkoutQualification?: InputMaybe<ProgramCheckoutQualificationNullableCompositeFilter>;
  colors?: InputMaybe<StringNullableFilter>;
  compilationStatus?: InputMaybe<StringNullableFilter>;
  createdBy?: InputMaybe<JsonNullableFilter>;
  creationMode?: InputMaybe<StringNullableFilter>;
  credentials?: InputMaybe<Array<ProgramCredentialsObjectEqualityInput>>;
  dateCreated?: InputMaybe<DateTimeFilter>;
  deadlineCompletion?: InputMaybe<StringNullableFilter>;
  deliveryModality?: InputMaybe<StringNullableFilter>;
  domain?: InputMaybe<StringNullableFilter>;
  embedded_descriptor?: InputMaybe<StringNullableFilter>;
  embeddings?: InputMaybe<FloatNullableListFilter>;
  file_draft?: InputMaybe<BoolNullableFilter>;
  flippedDescription?: InputMaybe<StringNullableFilter>;
  flippedPresentation?: InputMaybe<StringNullableFilter>;
  flippedRegistration?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  industries?: InputMaybe<StringNullableListFilter>;
  isChennelCreated?: InputMaybe<BoolNullableFilter>;
  isLastModifiedAtExists?: InputMaybe<BoolNullableFilter>;
  isProgramSchemaAdded?: InputMaybe<BoolNullableFilter>;
  isPublic?: InputMaybe<BoolNullableFilter>;
  isSaveAdkMoleculeAdded?: InputMaybe<BoolNullableFilter>;
  isShowTimer?: InputMaybe<BoolNullableFilter>;
  isUniqueFieldIdAdded?: InputMaybe<BoolNullableFilter>;
  isUniqueIdAdded?: InputMaybe<BoolNullableFilter>;
  isUnsponsoredProgram?: InputMaybe<BoolNullableFilter>;
  isUpdateOrg?: InputMaybe<BoolNullableFilter>;
  isUpdateParticipants?: InputMaybe<BoolNullableFilter>;
  keywords?: InputMaybe<StringNullableListFilter>;
  lastSaved?: InputMaybe<DateTimeFilter>;
  last_synced_at?: InputMaybe<JsonNullableFilter>;
  licensed?: InputMaybe<JsonNullableFilter>;
  locations?: InputMaybe<Array<ProgramLocationObjectEqualityInput>>;
  metaData?: InputMaybe<ProgramMetaDataNullableCompositeFilter>;
  organizationId?: InputMaybe<StringNullableFilter>;
  organizationName?: InputMaybe<StringNullableFilter>;
  organizers?: InputMaybe<Array<ProgramOrganizersObjectEqualityInput>>;
  originalProgramId?: InputMaybe<JsonNullableFilter>;
  participants?: InputMaybe<JsonNullableFilter>;
  pathways?: InputMaybe<StringNullableListFilter>;
  programDesc?: InputMaybe<StringNullableFilter>;
  programDesignId?: InputMaybe<StringNullableFilter>;
  programImage?: InputMaybe<StringNullableFilter>;
  programKeywords?: InputMaybe<JsonNullableFilter>;
  programName?: InputMaybe<StringNullableFilter>;
  programPrice?: InputMaybe<StringNullableFilter>;
  program_schema?: InputMaybe<Array<ProgramProgramSchemaObjectEqualityInput>>;
  program_schema_id?: InputMaybe<StringNullableFilter>;
  public_url?: InputMaybe<StringNullableFilter>;
  published?: InputMaybe<BoolNullableFilter>;
  publishedAt?: InputMaybe<DateTimeNullableFilter>;
  requiredResidency?: InputMaybe<JsonNullableFilter>;
  requiredSkills?: InputMaybe<JsonNullableFilter>;
  requiredTech?: InputMaybe<StringNullableListFilter>;
  resourceWeb?: InputMaybe<StringNullableFilter>;
  reward?: InputMaybe<JsonNullableFilter>;
  rewardPresets?: InputMaybe<StringNullableListFilter>;
  rewards?: InputMaybe<JsonNullableFilter>;
  selectedDistrict?: InputMaybe<JsonNullableFilter>;
  sharable_url?: InputMaybe<StringNullableFilter>;
  slug?: InputMaybe<StringNullableFilter>;
  socCodes?: InputMaybe<StringNullableListFilter>;
  start_activity_status?: InputMaybe<StringNullableFilter>;
  studentWalletTransactions?: InputMaybe<StudentWalletTransactionListRelationFilter>;
  templateId?: InputMaybe<StringNullableFilter>;
  templateImage?: InputMaybe<JsonNullableFilter>;
  templateName?: InputMaybe<StringNullableFilter>;
  timeConfig?: InputMaybe<ProgramTimeConfigNullableCompositeFilter>;
  timerType?: InputMaybe<StringNullableFilter>;
  tokens?: InputMaybe<IntNullableFilter>;
  tokensRange?: InputMaybe<ProgramTokensRangeNullableCompositeFilter>;
  unsponsoredAdk?: InputMaybe<StringNullableFilter>;
  videoAskShareId?: InputMaybe<StringNullableFilter>;
  visibility?: InputMaybe<StringNullableFilter>;
  walletTransactions?: InputMaybe<WalletTransactionListRelationFilter>;
};

export type ProgramWithGroundingTags = {
  __typename?: 'ProgramWithGroundingTags';
  programId: Scalars['String']['output'];
  programName?: Maybe<Scalars['String']['output']>;
  tags: Array<ProgramGroundingTag>;
};

export type PublicOrgProfile = {
  __typename?: 'PublicOrgProfile';
  domains?: Maybe<Array<Scalars['String']['output']>>;
  id: Scalars['String']['output'];
  isMember: Scalars['Boolean']['output'];
  isOwner: Scalars['Boolean']['output'];
  logo?: Maybe<Scalars['String']['output']>;
  memberCount: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  primaryDomain?: Maybe<Scalars['String']['output']>;
  slug: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type PublicProfileEdge = {
  __typename?: 'PublicProfileEdge';
  cursor: Scalars['String']['output'];
  node: PublicProfileOutput;
};

export type PublicProfileOutput = PublicOrgProfile | PublicUserProfile;

export type PublicProfilesConnection = {
  __typename?: 'PublicProfilesConnection';
  edges: Array<PublicProfileEdge>;
  pageInfo: PublicProfilesPageInfo;
  totalCount: Scalars['Int']['output'];
};

export type PublicProfilesFilterInput = {
  /** Search by name (partial match) */
  search?: InputMaybe<Scalars['String']['input']>;
  /** Filter by type: "user" or "organization" */
  type?: InputMaybe<Scalars['String']['input']>;
};

export type PublicProfilesPageInfo = {
  __typename?: 'PublicProfilesPageInfo';
  endCursor?: Maybe<Scalars['String']['output']>;
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
  startCursor?: Maybe<Scalars['String']['output']>;
};

export type PublicProfilesPaginationInput = {
  /** Number of items to return (default 24, max 100) */
  first?: InputMaybe<Scalars['Int']['input']>;
  /** Number of items to skip */
  skip?: InputMaybe<Scalars['Int']['input']>;
};

export type PublicUserProfile = {
  __typename?: 'PublicUserProfile';
  badges?: Maybe<Scalars['JSON']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  isOwner: Scalars['Boolean']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  profile?: Maybe<Scalars['JSON']['output']>;
  shareCode?: Maybe<Scalars['String']['output']>;
  slug: Scalars['String']['output'];
  type: Scalars['String']['output'];
  userTypes?: Maybe<Array<Scalars['String']['output']>>;
};

/** Product purchased by user from checkout or invoice */
export type PurchasedProduct = {
  __typename?: 'PurchasedProduct';
  /** Amount paid in cents */
  amount: Scalars['Int']['output'];
  /** Currency code */
  currency: Scalars['String']['output'];
  /** Stripe Invoice ID (if source is invoice) */
  invoiceId?: Maybe<Scalars['String']['output']>;
  /** Stripe Product ID */
  productId: Scalars['String']['output'];
  /** Product name at time of purchase */
  productName: Scalars['String']['output'];
  /** Date of purchase */
  purchaseDate: Scalars['DateTime']['output'];
  /** Quantity purchased */
  quantity: Scalars['Int']['output'];
  /** Stripe Checkout Session ID (if source is checkout) */
  sessionId?: Maybe<Scalars['String']['output']>;
  /** Purchase source: "checkout" or "invoice" */
  source: Scalars['String']['output'];
  /** Number of tokens granted from this purchase */
  tokens: Scalars['Int']['output'];
};

/** Paginated response of purchased products */
export type PurchasedProductsResponse = {
  __typename?: 'PurchasedProductsResponse';
  /** Whether there are more products to load */
  hasMore: Scalars['Boolean']['output'];
  /** List of purchased products */
  products: Array<PurchasedProduct>;
};

export type Query = {
  __typename?: 'Query';
  /** Get list of active AI mentor personas for selection */
  activePersonas: Array<PersonaGraphQlType>;
  /** Get the count of active users in a program */
  activeUserCount: Scalars['Float']['output'];
  /** Get all active users in a program (users who sent a heartbeat in the last 30 seconds) */
  activeUsersInProgram: Array<ActiveUser>;
  /** Get completion time analytics for activities (superadmin only - @pilotcity.com) */
  activityCompletionAnalytics: ActivityAnalyticsOutput;
  /** Get simplified duration analytics per activity for a program (authenticated users) */
  activityDurationAnalytics: ActivityDurationAnalyticsOutput;
  /** Query a single ActivitySchema by unique fields. */
  activitySchema?: Maybe<ActivitySchema>;
  /** Query the ActivitySchema library with filters for browsing templates. */
  activitySchemaLibrary: ActivitySchemaLibraryResult;
  /** Query the ActivitySchema collection with full query functionality (filtering, ordering, pagination). */
  activitySchemas: Array<ActivitySchema>;
  /** Get aggregated onboarding funnel stats for a program (coordinator only) */
  aipmOnboardingFunnel: CoordinatorFunnelStatsType;
  /** Get AIPM onboarding status for the current user and program */
  aipmOnboardingStatus: OnboardingStatusType;
  /** Fetch all programs from Airtable */
  airtablePrograms: Array<AirtableProgram>;
  /** List Ecosystems visible to the current user (own + public/shared) */
  allEcosystems: Array<Ecosystem>;
  /** Load all RSVP records */
  allRSVPData: Array<RsvpRecord>;
  assistant?: Maybe<LangGraphAssistant>;
  assistants: Array<LangGraphAssistant>;
  /** Check available authentication methods for a user. */
  authCheckAuthMethods: CheckAuthMethodsResponse;
  /** Check if an identity is eligible for merging with existing accounts. */
  authCheckMergeEligibility: MergeEligibilityResponse;
  /** Check if a user exists by email or phone. */
  authCheckUserExists: Scalars['Boolean']['output'];
  /** Get permissions and statistics for the authenticated user. */
  authGetUserPermissions: UserPermissionsOutput;
  /** Check if a user's portfolio is complete. */
  authIsPortfolioComplete: Scalars['Boolean']['output'];
  /** Get a specific auto-pilot configuration by ID. User must own the configuration. */
  autoPilot?: Maybe<AutoPilot>;
  /** List bank accounts from Stripe Connect account */
  bankAccounts: Array<BankAccount>;
  /** Get cache performance metrics (hits, misses, hit rate) */
  cacheMetrics: CacheMetrics;
  /** Check if a shareCode is available for use */
  checkShareCodeAvailability: ShareCodeAvailabilityOutput;
  /** Check if a slug is available (public) */
  checkSlugAvailability: SlugAvailabilityOutput;
  /** Check if a student is covered by an existing auto-pilot. User must have access to the student. */
  checkStudentCoverage: StudentCoverageResult;
  commsAudienceCount: Scalars['Int']['output'];
  commsAudiencePreview: CommsAudiencePreview;
  commsAudiences: Array<CommsAudience>;
  commsCampaign: CommsCampaignWithRecipients;
  commsCampaigns: Array<CommsCampaign>;
  /** Get a single conversation with its messages */
  commsConversation: CommsConversationWithMessages;
  /** Get paginated conversation list with optional filters */
  commsConversations: Array<CommsConversation>;
  commsDiscoverFields: Array<CommsDiscoveredCategory>;
  commsDistinctValues: Scalars['JSON']['output'];
  commsExpansionSuggestions: CommsExpansionSuggestions;
  commsExperiment: CommsExperiment;
  commsExperimentAnalysis: CommsExperimentAnalysis;
  commsExperimentPreActivationCheck: Array<CommsPreActivationCheck>;
  commsExperimentTimeline: CommsExperimentTimeline;
  commsExperiments: Array<CommsExperiment>;
  commsOpportunities: Array<CommsOpportunity>;
  commsOpportunity: CommsOpportunity;
  /** Get all active phone lines */
  commsPhoneLines: Array<CommsPhoneLine>;
  /** Get all rules ordered by sortOrder */
  commsRules: Array<CommsRule>;
  commsSequence: CommsSequenceWithDetails;
  commsSequenceEnrollments: Array<CommsSequenceEnrollment>;
  commsSequences: Array<CommsSequence>;
  /** Get all tags ordered by sortOrder */
  commsTags: Array<CommsTag>;
  /** Get total unread count with optional phone line or tag filter */
  commsUnreadCount: CommsUnreadCount;
  /** Get Stripe Connect account status with verification details */
  connectAccount?: Maybe<StripeAccountResponse>;
  /** Get a specific AI Creator thread by ID */
  creatorThread?: Maybe<CreatorThreadOutput>;
  /** Get AI Creator threads for the authenticated user */
  creatorThreads: Array<CreatorThreadOutput>;
  /** Get all participants sponsored via credentials/badges by an organization (member only) */
  credentialSponsors: OrganizationParticipantsOutput;
  /** Detect schema changes that might break a template */
  detectSchemaChanges: SchemaChangeReport;
  /** Discover existing users whose email matches org domains (for invite autocomplete) */
  discoverDomainUsers: DomainUserDiscoveryOutput;
  /** Discover available fields from a ProgramSchema for custom reports */
  discoverReportFields: Array<DiscoveredFieldCategory>;
  /** Get the status and result of a document validation by ID. */
  documentValidationStatus: DocumentValidationStatusResponse;
  /** Get an Ecosystem by ID */
  ecosystem?: Maybe<Ecosystem>;
  /** Get an Ecosystem by share token (public, no auth) */
  ecosystemByShareToken?: Maybe<Ecosystem>;
  /** Get an EcosystemPlace by ID */
  ecosystemPlace?: Maybe<EcosystemPlace>;
  /** List EcosystemPlaces by IDs (public) or all (requires auth) */
  ecosystemPlaces: Array<EcosystemPlace>;
  /** Get view logs for an ecosystem (owner only) */
  ecosystemViewLogs: Scalars['JSON']['output'];
  /** Resolve effective time settings for a specific participant + activity. Returns computed dates, lock state, and time allowance info. */
  effectiveActivityTime?: Maybe<Scalars['JSON']['output']>;
  /** Fetch employers/companies with optional search and pagination */
  employers: EmployerConnection;
  /** Get a single endorsement request by token */
  endorsementByToken?: Maybe<EndorsementDashboardItem>;
  /** Get all endorsements for a token (public - no auth required) */
  endorsementDashboard: EndorsementDashboardResponse;
  /** Get all endorsements for the authenticated user's email */
  endorsementDashboardByEmail: EndorsementDashboardResponse;
  family?: Maybe<Family>;
  familyMemberPhotos: Array<FamilyPhoto>;
  familyMembers: Array<FamilyMember>;
  familyPhotos: Array<FamilyPhoto>;
  familyRelationships: Array<FamilyRelationship>;
  familySearchMembers: Array<FamilyMember>;
  /** Full subgraph for a family the user has edit access to (no masking). */
  familySubgraph: FamilySubgraph;
  /** PUBLIC: Resolve a share token to a view + member subgraph. Minor-subject masking applied when viewer lacks edit access. */
  familyViewByShareToken: FamilySubgraph;
  generateMultipleScopePrompt: Array<Scalars['String']['output']>;
  generateScopePrompt: Array<Scalars['String']['output']>;
  generateTitlePrompt: Scalars['String']['output'];
  /** Get the best Student instance for a user+program using smart selection hierarchy */
  getBestStudentInstance?: Maybe<StudentInstanceType>;
  getBulkSetupScopes: Array<Scalars['JSONObject']['output']>;
  /** Get invoice details by ID */
  getInvoice?: Maybe<Invoice>;
  /** Get last seen presence information for a list of users */
  getLastSeenForUsers: Array<UserLastSeen>;
  /** Get monitored students data with adk completion metrics */
  getMonitorData: MonitorResponse;
  /** Get per-program participant counts for the program filter dialog */
  getMonitorProgramCounts: MonitorProgramCountsResponse;
  /** Get lightweight roster data for Monitor page (~500 bytes/student vs 3-8KB) */
  getMonitorRoster: MonitorRosterResponse;
  /** Get scores-only data for all scored students (Quadrant view) — no pagination */
  getMonitorScores: MonitorScoresResponse;
  getMySubscription: MySubscriptionStatus;
  /** Get random user IDs from database (for cache demo) */
  getRandomUserIds: Array<Scalars['String']['output']>;
  /** Get a single roadmap by ID */
  getRoadmapById?: Maybe<SavedScopeOutput>;
  /** Get all roadmaps for a given email address (rate-limited) */
  getRoadmapsByEmail: Array<SavedScopeOutput>;
  /** Get all roadmaps for the authenticated user (includes email-matched roadmaps) */
  getRoadmapsByUserId: Array<SavedScopeOutput>;
  /** Get all Student instances for a user+program combination */
  getStudentInstances: Array<StudentInstanceType>;
  /** Get single subscription by ID */
  getSubscription?: Maybe<Subscription>;
  /** Get authenticated user role (organizer/participant) for a specific program. Returns null if user has no relationship. */
  getUserRoleForProgram?: Maybe<Scalars['String']['output']>;
  /** Get current phone/email verification status for check-first logic */
  getVerificationStatus: VerificationStatusType;
  getVideoAskResponseStatus: VideoAskStatusResult;
  /** Returns a personalized greeting for the authenticated user */
  greet: Greeting;
  /** Returns a simple greeting message with an optional name parameter */
  greeting: Greeting;
  /** Returns a greeting message that includes the current time */
  greetingWithTime: GreetingWithTime;
  /** Lists available GroundingSources sponsors can attach to their share link. */
  groundingSources: Array<GroundingSourceOutput>;
  /** Fetch invitees for a participant */
  invitees: Array<Invitee>;
  /** Check if the journal feature is enabled for a student in a specific program. Requires authentication. */
  isJournalEnabled: Scalars['Boolean']['output'];
  /** Get a single journal entry by ID. User must own the entry. */
  journal?: Maybe<Journals>;
  /** Get journal entries with optional filtering, ordering, and pagination. Returns only entries owned by the authenticated user. */
  journals: Array<Journals>;
  /** Top cities by total presence (programs + portfolios + orgs). Powers the /home18 Places lens grid. Public. */
  landingPlaces: PlaceProfilesPage;
  /** List all subscriptions for a user */
  listUserSubscriptions: Array<Subscription>;
  me?: Maybe<CurrentUser>;
  /** Get or auto-generate an org sponsor link for a specific member (owner/admin only) */
  memberSponsorLink: SponsorLinkOutput;
  /** Get all auto-pilot configurations owned by the authenticated user. */
  myAutoPilots: Array<AutoPilot>;
  myCustomProfile?: Maybe<AuthUserProfile>;
  /** List families the authenticated user has edit access to */
  myFamilies: Array<Family>;
  myFullDetails?: Maybe<AuthUserRecord>;
  /** Get the current nurse user's portfolio (creates if missing). */
  myNursePortfolio: NursePortfolioOutput;
  /** Get all organizations where the current user is a member (includes domain fields) */
  myOrganizations: Array<Organization>;
  /** Get all people connected to the current user through program participation. Paginated per category. */
  myPeople: MyPeopleResponse;
  /** Get all places for the current user from their portfolio data */
  myPlaces: MyPlacesResponse;
  myProfile?: Maybe<AuthUserProfile>;
  /** Get all programs for the current user (as organizer or participant) with computed status and role fields. Paginated. */
  myPrograms: MyProgramsResponse;
  /** List ShiftSpend goals for the current nurse (reverse-chrono). */
  myShiftSpendGoals: Array<ShiftSpendGoalOutput>;
  /** Get or auto-generate sponsor link for current user (personal or organization) */
  mySponsorLink: SponsorLinkOutput;
  /** Get all sponsors for the current user across all program enrollments */
  mySponsors: Array<Sponsor>;
  /** Get all messages in a thread. User must be the participant (owner) of the thread. */
  myThreadMessages: ThreadMessagesResult;
  /** List message threads for the authenticated participant. Returns threads where the user is the participant with unread status and last message preview. */
  myThreads: MyInboxResult;
  openAIChatProxy: Scalars['String']['output'];
  /** Get basic organization info by ID (public, for sponsor landing page) */
  organizationBasicInfo?: Maybe<OrganizationByDomain>;
  /** Get organization with domain details (member only) */
  organizationDomains: Organization;
  /** Get all participants sponsored by an organization (public if org portfolio is public) */
  organizationParticipants?: Maybe<OrganizationParticipantsOutput>;
  /** List all ProgramDesigns for an organization */
  organizationProgramDesigns: Array<ProgramDesign>;
  /** Get ProgramSchemas available to an organization for custom reports */
  organizationProgramSchemas: Array<ProgramSchemaOption>;
  /** Get all programs related to an organization (created, member-organized, or sponsored) */
  organizationPrograms?: Maybe<OrganizationProgramsResponse>;
  /** Get team members for an organization (public if portfolioPublic=true) */
  organizationTeam?: Maybe<OrganizationTeamResponse>;
  /** Fetch organizations with optional search */
  organizations: Array<AirtableOrganization>;
  /** Find organizations that match a given email domain (excludes already joined). Super-admins (@pilotcity.com) can access all organizations. */
  organizationsByDomain: Array<OrganizationByDomain>;
  /** Public batch lookup of organizations by id (used for sponsor map pins) */
  organizationsByIds: Array<Organization>;
  /** Get outreach log entries for a program. Requires program access (organizer or stakeholder). */
  outreachLogs: Array<OutreachLog>;
  /** Get quadrant distribution statistics for a program. Requires program access. */
  outreachStats: OutreachStats;
  /** Load detailed RSVP records for a participant */
  participantDetails: ParticipantDetails;
  /** Get participant report data for endorser review (validates token) */
  participantReportForEndorser: ParticipantReportOutput;
  /** Fetch participants with optional filters */
  participants: Array<Participant>;
  /** Fetch participants filtered by domain */
  participantsByDomain: Array<Participant>;
  /** Public aggregation of StudentPortfolio counts by city/ZIP for the PEL Strategic Locator tool */
  pelLocatorPortfolioCounts: Array<PelLocatorCityCount>;
  /** Resolve a city slug (e.g. "san-leandro-ca") to its aggregated PlaceProfile. Public. Returns null when no presence data exists. */
  placeProfile?: Maybe<PlaceProfile>;
  /** Fetch premiere participants (returns raw Airtable records) */
  premiereParticipants: Array<Scalars['String']['output']>;
  /** Get presence statistics (total active users and breakdown by program) */
  presenceStats: Scalars['String']['output'];
  /** List Stripe products with token metadata */
  products: Array<Product>;
  /** Get full Program document by ID. Accessible by superadmins, organizers, or participants. */
  programById?: Maybe<Program>;
  /** Get full Program document by ID as raw JSON. Accessible by superadmins, organizers, or participants. */
  programByIdRaw?: Maybe<Scalars['JSON']['output']>;
  /** Get a ProgramDesign by ID */
  programDesign?: Maybe<ProgramDesign>;
  /** Get the ProgramDesign linked to a specific Program */
  programDesignByProgram?: Maybe<ProgramDesign>;
  /** Batch fetch ProgramDesigns by IDs (for ecosystem timeline, accessible to share-token users) */
  programDesignsByIds: Array<ProgramDesign>;
  /** Get roster of all enrolled users in a program with their activity status (active + inactive users) */
  programRosterStatus: Array<ProgramRosterUser>;
  /** Fetch programs with role-aware filtering, pagination, and aggregations. Handles both authenticated and unauthenticated requests. */
  programs: ProgramConnection;
  /** Fetch programs by templateId using raw MongoDB query with ObjectId handling. Returns programs with their ADKs. */
  programsByTemplateId: Array<Scalars['JSON']['output']>;
  /** Given the program IDs visible on a share link, return their current grounding tags. Used by the sponsor settings tag-review UI. Frontend computes the program list (same logic that drives the participant view) and passes IDs in. */
  programsWithGroundingTags: Array<ProgramWithGroundingTags>;
  /** Returns a greeting message that doesn't require authentication */
  publicGreet: Greeting;
  /** Resolve a slug to a user or organization profile (public) */
  publicProfile?: Maybe<PublicProfileOutput>;
  /** List all public user and organization profiles */
  publicProfiles: PublicProfilesConnection;
  /** Get user purchase history from Stripe */
  purchasedProducts: PurchasedProductsResponse;
  /** Fetch qualification options by type */
  qualificationOptions: Array<Scalars['String']['output']>;
  /** Get report data via share token (requires verified email) */
  reportByShareToken: ReportDataOutput;
  /** Get report data for export based on a template (member only) */
  reportData: ReportDataOutput;
  /** Get export history for a report template (member only) */
  reportExportHistory: Array<ReportExportLog>;
  /** Get all share links and access logs for a report template (org member only) */
  reportSharesForTemplate: ReportShareListOutput;
  /** Get available report templates for an organization (member only) */
  reportTemplates: Array<OrgReportTemplate>;
  /** Get all resources for a context */
  resourceContextByContextId: Array<ResourceContext>;
  /** Load RSVP count and comment count for a participant */
  rsvpData: RsvpData;
  /** Load saved scopes for a user */
  savedScopes: Array<AirtableSavedScope>;
  /** Search journal entries by text content using full-text search. Returns only entries owned by the authenticated user. */
  searchJournals: Array<Journals>;
  /** Semantic search for resources within a context */
  searchResourceContext: Array<ResourceExcerptGql>;
  /** Semantic search for resources scoped to a specific activity */
  searchResourcesByActivity: Array<ResourceExcerptGql>;
  /** Search students by name */
  searchStudents: Array<StudentSearchResult>;
  /** Get a single ShiftSpend goal by id (owner-only). */
  shiftSpendGoal: ShiftSpendGoalOutput;
  simulateProgramDetails: SimulatedProgramResult;
  simulateScope: Array<Scalars['String']['output']>;
  /** Get sponsor link by share code (public, for landing page) */
  sponsorLinkByShareCode?: Maybe<SponsorLinkOutput>;
  /** Get Stripe Connect account verification status */
  stripeConnectAccount: StripeConnectAccountType;
  /** Get full Student document by ID. Accessible by superadmins, the student themselves, or program organizers. */
  studentById?: Maybe<Student>;
  /** Get full Student document by ID as raw JSON. Same auth as studentById. */
  studentByIdRaw?: Maybe<Scalars['JSON']['output']>;
  /**
   * Get student wallet balance and status
   * @deprecated Use unifiedWallet query instead. The unified wallet combines both sponsor and student payments.
   */
  studentWallet: StudentWalletResponse;
  /** Get all Student instances for a program (superadmin only). Used for debug panel. */
  studentsByProgram: Array<StudentInstanceType>;
  /** Get ProgramTeam document for a user (as owner or member) in a program. Returns null if no team found. */
  teamDocByUser?: Maybe<Scalars['JSON']['output']>;
  /** Get all ProgramTeam documents for a program. Used for team list/join team UI. */
  teamsByProgram: Array<Scalars['JSON']['output']>;
  /** Discover available program templates with display metadata */
  templateDiscovery: Array<TemplateDiscoveryItem>;
  /** Check if a template needs revalidation based on schema changes */
  templateNeedsRevalidation: Scalars['Boolean']['output'];
  thread?: Maybe<LangGraphThread>;
  threads: Array<LangGraphThread>;
  /** Get single transaction by ID */
  transaction?: Maybe<StudentTransactionType>;
  /** Get transaction history with pagination and filtering */
  transactions: Array<StudentTransactionType>;
  /** Get unified wallet balance with breakdown by payment type */
  unifiedWallet: UnifiedWalletResponse;
  /** Aggregated stats of unsupported resource requests grouped by platform */
  unsupportedResourceStats: Array<UnsupportedResourceStatGql>;
  /** Get full user details for a specific user (public access if portfolio is public) */
  userFullDetails?: Maybe<AuthUserRecord>;
  /** Get all people connected to a specific user (public access if portfolio is public). Paginated per category. */
  userPeople?: Maybe<MyPeopleResponse>;
  /** Get places for a specific user by ID (with privacy filtering) */
  userPlaces?: Maybe<MyPlacesResponse>;
  /** Get the complete portfolio for the authenticated user, aggregating data from user profile and all role-specific portfolios. */
  userPortfolio: Portfolio;
  /** Get the complete portfolio for a specific user by ID (admin/organizer access only). */
  userPortfolioById: Portfolio;
  /** Get program counts (created/participated) for multiple users in a batch */
  userProgramCounts: UserProgramCountsOutput;
  /** Get programs for a specific user (public access if portfolio is public). Paginated. */
  userPrograms?: Maybe<MyProgramsResponse>;
  /** Get all sponsors for a specific user (public access if portfolio is public) */
  userSponsors?: Maybe<Array<Sponsor>>;
  /** Validate a persona is suitable for a published Born-Intelligent program */
  validatePersonaForPublish: Scalars['JSON']['output'];
  /** Validate a report share token (public) */
  validateReportShare: ValidateReportShareOutput;
  /** Validate a report template against actual data (member only) */
  validateReportTemplate: TemplateValidationResult;
  /**
   * Get wallet balance showing available, pending, and transferred funds
   * @deprecated Use unifiedWallet query instead. This query will be removed in a future release.
   */
  wallet: WalletBalance;
  /** Get paginated wallet transaction history with filtering */
  walletTransactions: WalletTransactionConnection;
  /** Get paginated wallet withdrawal history with payout status */
  walletWithdrawals: WalletWithdrawalConnection;
  /** List webhook events (admin-only) */
  webhookEvents: Array<WebhookEventType>;
};


export type QueryActiveUserCountArgs = {
  programId: Scalars['ID']['input'];
};


export type QueryActiveUsersInProgramArgs = {
  programId: Scalars['ID']['input'];
};


export type QueryActivityCompletionAnalyticsArgs = {
  input?: InputMaybe<ActivityAnalyticsInput>;
};


export type QueryActivityDurationAnalyticsArgs = {
  activityIndex?: InputMaybe<Scalars['Int']['input']>;
  programId: Scalars['String']['input'];
};


export type QueryActivitySchemaArgs = {
  where: ActivitySchemaWhereUniqueInput;
};


export type QueryActivitySchemaLibraryArgs = {
  category?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ActivitySchemaLibraryFilterInput>;
  search?: InputMaybe<Scalars['String']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  statusType?: InputMaybe<Scalars['String']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryActivitySchemasArgs = {
  orderBy?: InputMaybe<ActivitySchemaOrderByWithRelationInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ActivitySchemaWhereInput>;
};


export type QueryAipmOnboardingFunnelArgs = {
  input: GetFunnelStatsInput;
};


export type QueryAipmOnboardingStatusArgs = {
  input: OnboardingStatusInput;
};


export type QueryAssistantArgs = {
  id: Scalars['String']['input'];
};


export type QueryAssistantsArgs = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryAuthCheckAuthMethodsArgs = {
  input: CheckAuthMethodsInput;
};


export type QueryAuthCheckMergeEligibilityArgs = {
  input: CheckMergeEligibilityInput;
};


export type QueryAuthCheckUserExistsArgs = {
  input: CheckUserExistsInput;
};


export type QueryAutoPilotArgs = {
  id: Scalars['String']['input'];
};


export type QueryCheckShareCodeAvailabilityArgs = {
  shareCode: Scalars['String']['input'];
};


export type QueryCheckSlugAvailabilityArgs = {
  slug: Scalars['String']['input'];
};


export type QueryCheckStudentCoverageArgs = {
  studentId: Scalars['String']['input'];
};


export type QueryCommsAudienceCountArgs = {
  filterState: Scalars['JSON']['input'];
};


export type QueryCommsAudiencePreviewArgs = {
  filterState: Scalars['JSON']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryCommsCampaignArgs = {
  id: Scalars['String']['input'];
  recipientLimit?: InputMaybe<Scalars['Int']['input']>;
  recipientOffset?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryCommsCampaignsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};


export type QueryCommsConversationArgs = {
  id: Scalars['String']['input'];
};


export type QueryCommsConversationsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  phoneLineId?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  tagIds?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type QueryCommsDistinctValuesArgs = {
  collection: Scalars['String']['input'];
  fieldPath: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryCommsExpansionSuggestionsArgs = {
  id: Scalars['String']['input'];
};


export type QueryCommsExperimentArgs = {
  id: Scalars['String']['input'];
};


export type QueryCommsExperimentAnalysisArgs = {
  id: Scalars['String']['input'];
};


export type QueryCommsExperimentPreActivationCheckArgs = {
  id: Scalars['String']['input'];
};


export type QueryCommsExperimentTimelineArgs = {
  id: Scalars['String']['input'];
};


export type QueryCommsExperimentsArgs = {
  status?: InputMaybe<Scalars['String']['input']>;
};


export type QueryCommsOpportunityArgs = {
  id: Scalars['String']['input'];
};


export type QueryCommsSequenceArgs = {
  id: Scalars['String']['input'];
};


export type QueryCommsSequenceEnrollmentsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sequenceId: Scalars['String']['input'];
  status?: InputMaybe<Scalars['String']['input']>;
};


export type QueryCommsSequencesArgs = {
  status?: InputMaybe<Scalars['String']['input']>;
};


export type QueryCommsUnreadCountArgs = {
  phoneLineId?: InputMaybe<Scalars['String']['input']>;
  tagId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryCreatorThreadArgs = {
  threadId: Scalars['String']['input'];
};


export type QueryCreatorThreadsArgs = {
  entityId?: InputMaybe<Scalars['String']['input']>;
  scope?: InputMaybe<Scalars['String']['input']>;
};


export type QueryCredentialSponsorsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  organizationId: Scalars['String']['input'];
};


export type QueryDetectSchemaChangesArgs = {
  templateId: Scalars['String']['input'];
};


export type QueryDiscoverDomainUsersArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  organizationId: Scalars['String']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryDiscoverReportFieldsArgs = {
  programSchemaId: Scalars['String']['input'];
};


export type QueryDocumentValidationStatusArgs = {
  validationId: Scalars['String']['input'];
};


export type QueryEcosystemArgs = {
  id: Scalars['String']['input'];
};


export type QueryEcosystemByShareTokenArgs = {
  token: Scalars['String']['input'];
};


export type QueryEcosystemPlaceArgs = {
  id: Scalars['String']['input'];
};


export type QueryEcosystemPlacesArgs = {
  ids?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type QueryEcosystemViewLogsArgs = {
  ecosystemId: Scalars['String']['input'];
};


export type QueryEffectiveActivityTimeArgs = {
  activityIndex: Scalars['Int']['input'];
  programId: Scalars['String']['input'];
  studentId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryEmployersArgs = {
  input?: InputMaybe<FetchEmployersInput>;
};


export type QueryEndorsementByTokenArgs = {
  token: Scalars['String']['input'];
};


export type QueryEndorsementDashboardArgs = {
  token: Scalars['String']['input'];
};


export type QueryFamilyArgs = {
  id: Scalars['ID']['input'];
};


export type QueryFamilyMemberPhotosArgs = {
  memberId: Scalars['ID']['input'];
};


export type QueryFamilyMembersArgs = {
  familyId: Scalars['ID']['input'];
};


export type QueryFamilyPhotosArgs = {
  familyId: Scalars['ID']['input'];
};


export type QueryFamilyRelationshipsArgs = {
  familyId: Scalars['ID']['input'];
};


export type QueryFamilySearchMembersArgs = {
  familyId: Scalars['ID']['input'];
  limit?: Scalars['Int']['input'];
  q: Scalars['String']['input'];
};


export type QueryFamilySubgraphArgs = {
  familyId: Scalars['ID']['input'];
};


export type QueryFamilyViewByShareTokenArgs = {
  token: Scalars['String']['input'];
};


export type QueryGenerateMultipleScopePromptArgs = {
  careers?: InputMaybe<Scalars['String']['input']>;
  deliverables?: InputMaybe<Scalars['String']['input']>;
  goals?: InputMaybe<Scalars['String']['input']>;
  jobs?: InputMaybe<Scalars['String']['input']>;
  passions?: InputMaybe<Scalars['String']['input']>;
  problems?: InputMaybe<Scalars['String']['input']>;
  skills?: InputMaybe<Scalars['String']['input']>;
  strengths?: InputMaybe<Scalars['String']['input']>;
  tools?: InputMaybe<Scalars['String']['input']>;
  user?: InputMaybe<Scalars['String']['input']>;
  websiteUrls: Array<Scalars['String']['input']>;
};


export type QueryGenerateScopePromptArgs = {
  careers?: InputMaybe<Scalars['String']['input']>;
  deliverables?: InputMaybe<Scalars['String']['input']>;
  goals?: InputMaybe<Scalars['String']['input']>;
  jobs?: InputMaybe<Scalars['String']['input']>;
  passions?: InputMaybe<Scalars['String']['input']>;
  problems?: InputMaybe<Scalars['String']['input']>;
  skills?: InputMaybe<Scalars['String']['input']>;
  strengths?: InputMaybe<Scalars['String']['input']>;
  tools?: InputMaybe<Scalars['String']['input']>;
  user?: InputMaybe<Scalars['String']['input']>;
  websiteUrl: Scalars['String']['input'];
};


export type QueryGenerateTitlePromptArgs = {
  scope: Scalars['String']['input'];
  websiteUrl: Scalars['String']['input'];
};


export type QueryGetBestStudentInstanceArgs = {
  input: GetStudentInstancesInput;
};


export type QueryGetBulkSetupScopesArgs = {
  bulkId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetInvoiceArgs = {
  invoiceId: Scalars['String']['input'];
};


export type QueryGetLastSeenForUsersArgs = {
  userIds: Array<Scalars['ID']['input']>;
};


export type QueryGetMonitorDataArgs = {
  input: GetMonitorInput;
};


export type QueryGetMonitorProgramCountsArgs = {
  input: GetMonitorProgramCountsInput;
};


export type QueryGetMonitorRosterArgs = {
  input: GetMonitorRosterInput;
};


export type QueryGetMonitorScoresArgs = {
  input: GetMonitorScoresInput;
};


export type QueryGetRandomUserIdsArgs = {
  count?: Scalars['Float']['input'];
};


export type QueryGetRoadmapByIdArgs = {
  id: Scalars['String']['input'];
};


export type QueryGetRoadmapsByEmailArgs = {
  email: Scalars['String']['input'];
};


export type QueryGetStudentInstancesArgs = {
  input: GetStudentInstancesInput;
};


export type QueryGetSubscriptionArgs = {
  subscriptionId: Scalars['String']['input'];
};


export type QueryGetUserRoleForProgramArgs = {
  programId: Scalars['String']['input'];
};


export type QueryGetVideoAskResponseStatusArgs = {
  input: GetVideoAskStatusInput;
};


export type QueryGreetingArgs = {
  name?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGreetingWithTimeArgs = {
  name?: InputMaybe<Scalars['String']['input']>;
};


export type QueryInviteesArgs = {
  participantName: Scalars['String']['input'];
};


export type QueryIsJournalEnabledArgs = {
  programId: Scalars['String']['input'];
};


export type QueryJournalArgs = {
  id: Scalars['String']['input'];
};


export type QueryJournalsArgs = {
  orderBy?: InputMaybe<Array<JournalOrderByInput>>;
  skip?: InputMaybe<Scalars['Float']['input']>;
  take?: InputMaybe<Scalars['Float']['input']>;
  where?: InputMaybe<JournalWhereInput>;
};


export type QueryLandingPlacesArgs = {
  input?: InputMaybe<LandingPlacesInput>;
};


export type QueryListUserSubscriptionsArgs = {
  userId: Scalars['String']['input'];
};


export type QueryMemberSponsorLinkArgs = {
  memberId: Scalars['String']['input'];
  organizationId: Scalars['String']['input'];
};


export type QueryMyPeopleArgs = {
  cohortWeeks?: InputMaybe<Scalars['Int']['input']>;
  creatorsLimit?: InputMaybe<Scalars['Int']['input']>;
  creatorsOffset?: InputMaybe<Scalars['Int']['input']>;
  participantsLimit?: InputMaybe<Scalars['Int']['input']>;
  participantsOffset?: InputMaybe<Scalars['Int']['input']>;
  sponsorsLimit?: InputMaybe<Scalars['Int']['input']>;
  sponsorsOffset?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryMyProgramsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryMyShiftSpendGoalsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};


export type QueryMySponsorLinkArgs = {
  organizationId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryMyThreadMessagesArgs = {
  threadId: Scalars['String']['input'];
};


export type QueryMyThreadsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryOpenAiChatProxyArgs = {
  maxTokens?: InputMaybe<Scalars['Float']['input']>;
  model?: InputMaybe<Scalars['String']['input']>;
  prompt: Scalars['String']['input'];
  requesterId?: InputMaybe<Scalars['String']['input']>;
  systemPrompt?: InputMaybe<Scalars['String']['input']>;
  temperature?: InputMaybe<Scalars['Float']['input']>;
};


export type QueryOrganizationBasicInfoArgs = {
  organizationId: Scalars['String']['input'];
};


export type QueryOrganizationDomainsArgs = {
  organizationId: Scalars['String']['input'];
};


export type QueryOrganizationParticipantsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  organizationId: Scalars['String']['input'];
};


export type QueryOrganizationProgramDesignsArgs = {
  organizationId: Scalars['String']['input'];
};


export type QueryOrganizationProgramSchemasArgs = {
  organizationId: Scalars['String']['input'];
};


export type QueryOrganizationProgramsArgs = {
  organizationId: Scalars['String']['input'];
};


export type QueryOrganizationTeamArgs = {
  organizationId: Scalars['String']['input'];
};


export type QueryOrganizationsArgs = {
  input?: InputMaybe<FetchOrganizationsInput>;
};


export type QueryOrganizationsByDomainArgs = {
  domain: Scalars['String']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryOrganizationsByIdsArgs = {
  ids: Array<Scalars['String']['input']>;
};


export type QueryOutreachLogsArgs = {
  programId: Scalars['String']['input'];
  quadrant?: InputMaybe<Scalars['String']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryOutreachStatsArgs = {
  programId: Scalars['String']['input'];
};


export type QueryParticipantDetailsArgs = {
  participantName: Scalars['String']['input'];
};


export type QueryParticipantReportForEndorserArgs = {
  programId: Scalars['String']['input'];
  studentId: Scalars['String']['input'];
  token: Scalars['String']['input'];
};


export type QueryParticipantsArgs = {
  filters?: InputMaybe<ParticipantFiltersInput>;
};


export type QueryParticipantsByDomainArgs = {
  domain: Scalars['String']['input'];
};


export type QueryPelLocatorPortfolioCountsArgs = {
  groupByZip?: Scalars['Boolean']['input'];
  minCount?: Scalars['Int']['input'];
  state?: Scalars['String']['input'];
};


export type QueryPlaceProfileArgs = {
  slug: Scalars['String']['input'];
};


export type QueryProductsArgs = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Float']['input']>;
  startingAfter?: InputMaybe<Scalars['String']['input']>;
};


export type QueryProgramByIdArgs = {
  id: Scalars['String']['input'];
};


export type QueryProgramByIdRawArgs = {
  id: Scalars['String']['input'];
};


export type QueryProgramDesignArgs = {
  id: Scalars['String']['input'];
};


export type QueryProgramDesignByProgramArgs = {
  programId: Scalars['String']['input'];
};


export type QueryProgramDesignsByIdsArgs = {
  ids: Array<Scalars['String']['input']>;
};


export type QueryProgramRosterStatusArgs = {
  programId: Scalars['ID']['input'];
};


export type QueryProgramsArgs = {
  filter?: InputMaybe<ProgramFilterInput>;
  orderBy?: InputMaybe<Array<ProgramOrderByInput>>;
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryProgramsByTemplateIdArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  templateId: Scalars['String']['input'];
};


export type QueryProgramsWithGroundingTagsArgs = {
  programIds: Array<Scalars['String']['input']>;
};


export type QueryPublicProfileArgs = {
  slug: Scalars['String']['input'];
};


export type QueryPublicProfilesArgs = {
  filter?: InputMaybe<PublicProfilesFilterInput>;
  pagination?: InputMaybe<PublicProfilesPaginationInput>;
};


export type QueryPurchasedProductsArgs = {
  limit?: InputMaybe<Scalars['Float']['input']>;
  offset?: InputMaybe<Scalars['Float']['input']>;
  userId: Scalars['String']['input'];
};


export type QueryQualificationOptionsArgs = {
  type: Scalars['String']['input'];
};


export type QueryReportByShareTokenArgs = {
  email: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  token: Scalars['String']['input'];
};


export type QueryReportDataArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  organizationId: Scalars['String']['input'];
  programId?: InputMaybe<Scalars['String']['input']>;
  templateId: Scalars['String']['input'];
};


export type QueryReportExportHistoryArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  organizationId: Scalars['String']['input'];
  templateId: Scalars['String']['input'];
};


export type QueryReportSharesForTemplateArgs = {
  organizationId: Scalars['String']['input'];
  templateId: Scalars['String']['input'];
};


export type QueryReportTemplatesArgs = {
  organizationId: Scalars['String']['input'];
  programSchemaId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryResourceContextByContextIdArgs = {
  contextId: Scalars['String']['input'];
};


export type QueryRsvpDataArgs = {
  participantName: Scalars['String']['input'];
};


export type QuerySavedScopesArgs = {
  userId: Scalars['String']['input'];
};


export type QuerySearchJournalsArgs = {
  programId?: InputMaybe<Scalars['String']['input']>;
  query: Scalars['String']['input'];
  skip?: InputMaybe<Scalars['Float']['input']>;
  take?: InputMaybe<Scalars['Float']['input']>;
};


export type QuerySearchResourceContextArgs = {
  contextId: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  query: Scalars['String']['input'];
};


export type QuerySearchResourcesByActivityArgs = {
  activityName: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  programId: Scalars['String']['input'];
  query: Scalars['String']['input'];
};


export type QuerySearchStudentsArgs = {
  query?: InputMaybe<Scalars['String']['input']>;
};


export type QueryShiftSpendGoalArgs = {
  id: Scalars['ID']['input'];
};


export type QuerySimulateProgramDetailsArgs = {
  scope: Scalars['String']['input'];
  website: Scalars['String']['input'];
};


export type QuerySimulateScopeArgs = {
  website: Scalars['String']['input'];
};


export type QuerySponsorLinkByShareCodeArgs = {
  shareCode: Scalars['String']['input'];
};


export type QueryStudentByIdArgs = {
  id: Scalars['String']['input'];
};


export type QueryStudentByIdRawArgs = {
  id: Scalars['String']['input'];
};


export type QueryStudentWalletArgs = {
  studentId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryStudentsByProgramArgs = {
  input: StudentsByProgramInput;
};


export type QueryTeamDocByUserArgs = {
  programId: Scalars['String']['input'];
  // HAND-AUTHORED (STUDENT_INSTANCES) — optional loaded-instance id so the backend
  // can scope teamDocByUser per Student instance. The local codegen schema.gql does
  // not yet declare this arg (backend built in parallel); re-running codegen once it
  // ships will regenerate this identically.
  studentId?: InputMaybe<Scalars['String']['input']>;
  userId: Scalars['String']['input'];
};


export type QueryTeamsByProgramArgs = {
  programId: Scalars['String']['input'];
};


export type QueryTemplateNeedsRevalidationArgs = {
  templateId: Scalars['String']['input'];
};


export type QueryThreadArgs = {
  id: Scalars['String']['input'];
};


export type QueryThreadsArgs = {
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  assistantId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryTransactionArgs = {
  id: Scalars['String']['input'];
};


export type QueryTransactionsArgs = {
  filter?: InputMaybe<TransactionFilterInput>;
  pagination?: InputMaybe<TransactionPaginationInput>;
};


export type QueryUnifiedWalletArgs = {
  userId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryUserFullDetailsArgs = {
  userId: Scalars['String']['input'];
};


export type QueryUserPeopleArgs = {
  cohortWeeks?: InputMaybe<Scalars['Int']['input']>;
  creatorsLimit?: InputMaybe<Scalars['Int']['input']>;
  creatorsOffset?: InputMaybe<Scalars['Int']['input']>;
  participantsLimit?: InputMaybe<Scalars['Int']['input']>;
  participantsOffset?: InputMaybe<Scalars['Int']['input']>;
  sponsorsLimit?: InputMaybe<Scalars['Int']['input']>;
  sponsorsOffset?: InputMaybe<Scalars['Int']['input']>;
  userId: Scalars['String']['input'];
};


export type QueryUserPlacesArgs = {
  userId: Scalars['String']['input'];
};


export type QueryUserPortfolioByIdArgs = {
  userId: Scalars['String']['input'];
};


export type QueryUserProgramCountsArgs = {
  userIds: Array<Scalars['String']['input']>;
};


export type QueryUserProgramsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  userId: Scalars['String']['input'];
};


export type QueryUserSponsorsArgs = {
  userId: Scalars['String']['input'];
};


export type QueryValidatePersonaForPublishArgs = {
  personaId: Scalars['String']['input'];
};


export type QueryValidateReportShareArgs = {
  password?: InputMaybe<Scalars['String']['input']>;
  token: Scalars['String']['input'];
};


export type QueryValidateReportTemplateArgs = {
  input: ValidateTemplateInput;
};


export type QueryWalletArgs = {
  input?: InputMaybe<WalletBalanceInput>;
};


export type QueryWalletTransactionsArgs = {
  filter?: InputMaybe<WalletTransactionFilterInput>;
  pagination?: InputMaybe<WalletPaginationInput>;
};


export type QueryWalletWithdrawalsArgs = {
  filter?: InputMaybe<WalletWithdrawalFilterInput>;
  pagination?: InputMaybe<WalletPaginationInput>;
};


export type QueryWebhookEventsArgs = {
  limit?: InputMaybe<Scalars['Float']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};

export enum QueryMode {
  Default = 'default',
  Insensitive = 'insensitive'
}

/** BullMQ queue processing status */
export enum QueueStatus {
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  Processing = 'PROCESSING',
  Queued = 'QUEUED',
  Retrying = 'RETRYING'
}

export type RsvpData = {
  __typename?: 'RSVPData';
  commentCount: Scalars['Int']['output'];
  count: Scalars['Int']['output'];
};

export type RsvpInput = {
  attendInPerson?: InputMaybe<Scalars['Boolean']['input']>;
  comment?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  participantId?: InputMaybe<Scalars['String']['input']>;
  participantName: Scalars['String']['input'];
  phone?: InputMaybe<Scalars['String']['input']>;
  premiereState: Scalars['String']['input'];
  smsOptIn?: InputMaybe<Scalars['Boolean']['input']>;
};

export type RsvpRecord = {
  __typename?: 'RSVPRecord';
  attendInPerson?: Maybe<Scalars['String']['output']>;
  comment?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  participantName: Scalars['String']['output'];
  phone?: Maybe<Scalars['String']['output']>;
  premiereState: Scalars['String']['output'];
  smsOptIn?: Maybe<Scalars['String']['output']>;
};

export type ReattachVideoAskInput = {
  adkName: Scalars['String']['input'];
  formId?: InputMaybe<Scalars['String']['input']>;
  programId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};

export type RefreshResponse = {
  __typename?: 'RefreshResponse';
  accessToken?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
  refreshToken?: Maybe<Scalars['String']['output']>;
};

/** Input for refunding a payment (admin only) */
export type RefundPaymentInput = {
  /** Refund amount in dollars (null for full refund) */
  amount?: InputMaybe<Scalars['Float']['input']>;
  /** Reason for refund */
  reason?: InputMaybe<Scalars['String']['input']>;
  /** Transaction ID to refund */
  transactionId: Scalars['String']['input'];
};

export type RemoveOrganizationMemberInput = {
  /** The Organization ID */
  organizationId: Scalars['String']['input'];
  /** User ID of the member to remove */
  userId: Scalars['String']['input'];
};

export type ReportDataOutput = {
  __typename?: 'ReportDataOutput';
  fieldIds: Array<Scalars['String']['output']>;
  hasMore: Scalars['Boolean']['output'];
  headers: Array<Scalars['String']['output']>;
  rows: Array<ReportDataRow>;
  totalCount: Scalars['Int']['output'];
  warnings: Array<Scalars['String']['output']>;
};

export type ReportDataRow = {
  __typename?: 'ReportDataRow';
  data: Scalars['JSON']['output'];
  participantId: Scalars['String']['output'];
  studentId: Scalars['String']['output'];
};

export type ReportExportConfigInput = {
  csvDelimiter?: InputMaybe<Scalars['String']['input']>;
  filenamePrefix?: InputMaybe<Scalars['String']['input']>;
  includeHeaders?: InputMaybe<Scalars['Boolean']['input']>;
  includeTimestamp?: InputMaybe<Scalars['Boolean']['input']>;
  jsonHandling?: InputMaybe<Scalars['String']['input']>;
  maxRows?: InputMaybe<Scalars['Int']['input']>;
};

export type ReportExportLog = {
  __typename?: 'ReportExportLog';
  createdAt: Scalars['DateTime']['output'];
  email?: Maybe<Scalars['String']['output']>;
  exportType: Scalars['String']['output'];
  exporterType: Scalars['String']['output'];
  id: Scalars['String']['output'];
  rowCount: Scalars['Int']['output'];
  userId?: Maybe<Scalars['String']['output']>;
  userName?: Maybe<Scalars['String']['output']>;
};

export type ReportExportLogAvgAggregate = {
  __typename?: 'ReportExportLogAvgAggregate';
  rowCount?: Maybe<Scalars['Float']['output']>;
};

export type ReportExportLogCountAggregate = {
  __typename?: 'ReportExportLogCountAggregate';
  _all: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  email: Scalars['Int']['output'];
  exportType: Scalars['Int']['output'];
  exporterType: Scalars['Int']['output'];
  firstName: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  lastName: Scalars['Int']['output'];
  organizationId: Scalars['Int']['output'];
  rowCount: Scalars['Int']['output'];
  shareTokenId: Scalars['Int']['output'];
  templateId: Scalars['Int']['output'];
  userId: Scalars['Int']['output'];
};

export type ReportExportLogMaxAggregate = {
  __typename?: 'ReportExportLogMaxAggregate';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  exportType?: Maybe<Scalars['String']['output']>;
  exporterType?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  organizationId?: Maybe<Scalars['String']['output']>;
  rowCount?: Maybe<Scalars['Int']['output']>;
  shareTokenId?: Maybe<Scalars['String']['output']>;
  templateId?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
};

export type ReportExportLogMinAggregate = {
  __typename?: 'ReportExportLogMinAggregate';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  exportType?: Maybe<Scalars['String']['output']>;
  exporterType?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  organizationId?: Maybe<Scalars['String']['output']>;
  rowCount?: Maybe<Scalars['Int']['output']>;
  shareTokenId?: Maybe<Scalars['String']['output']>;
  templateId?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
};

export type ReportExportLogSumAggregate = {
  __typename?: 'ReportExportLogSumAggregate';
  rowCount?: Maybe<Scalars['Int']['output']>;
};

export type ReportExportOptions = {
  __typename?: 'ReportExportOptions';
  csvDelimiter: Scalars['String']['output'];
  filenamePrefix?: Maybe<Scalars['String']['output']>;
  includeHeaders: Scalars['Boolean']['output'];
  includeTimestamp: Scalars['Boolean']['output'];
  jsonHandling: Scalars['String']['output'];
  maxRows: Scalars['Int']['output'];
};

export type ReportFieldConfig = {
  __typename?: 'ReportFieldConfig';
  activityName?: Maybe<Scalars['String']['output']>;
  arrayHandling?: Maybe<Scalars['String']['output']>;
  arraySeparator?: Maybe<Scalars['String']['output']>;
  dataType: Scalars['String']['output'];
  defaultValue?: Maybe<Scalars['String']['output']>;
  displayName: Scalars['String']['output'];
  fieldIndex?: Maybe<Scalars['Int']['output']>;
  fieldName?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  includeByDefault: Scalars['Boolean']['output'];
  isRequired: Scalars['Boolean']['output'];
  path: Scalars['String']['output'];
  position: Scalars['Int']['output'];
  source: Scalars['String']['output'];
  widgetType?: Maybe<Scalars['String']['output']>;
};

export type ReportFieldInput = {
  activityName?: InputMaybe<Scalars['String']['input']>;
  arrayHandling?: InputMaybe<Scalars['String']['input']>;
  arraySeparator?: InputMaybe<Scalars['String']['input']>;
  dataType: Scalars['String']['input'];
  defaultValue?: InputMaybe<Scalars['String']['input']>;
  displayName: Scalars['String']['input'];
  fieldIndex?: InputMaybe<Scalars['Int']['input']>;
  fieldName?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  includeByDefault?: InputMaybe<Scalars['Boolean']['input']>;
  isRequired?: InputMaybe<Scalars['Boolean']['input']>;
  path: Scalars['String']['input'];
  position?: InputMaybe<Scalars['Int']['input']>;
  source: Scalars['String']['input'];
  widgetType?: InputMaybe<Scalars['String']['input']>;
};

export type ReportShareAccessCountAggregate = {
  __typename?: 'ReportShareAccessCountAggregate';
  _all: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  downloadedAt: Scalars['Int']['output'];
  email: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  ipAddress: Scalars['Int']['output'];
  tokenId: Scalars['Int']['output'];
  userAgent: Scalars['Int']['output'];
  verifiedAt: Scalars['Int']['output'];
};

export type ReportShareAccessEntry = {
  __typename?: 'ReportShareAccessEntry';
  /** When report was downloaded */
  downloadedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Email that accessed the report */
  email: Scalars['String']['output'];
  /** Access record ID */
  id: Scalars['String']['output'];
  /** When email was verified */
  verifiedAt: Scalars['DateTime']['output'];
};

export type ReportShareAccessMaxAggregate = {
  __typename?: 'ReportShareAccessMaxAggregate';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  downloadedAt?: Maybe<Scalars['DateTime']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  ipAddress?: Maybe<Scalars['String']['output']>;
  tokenId?: Maybe<Scalars['String']['output']>;
  userAgent?: Maybe<Scalars['String']['output']>;
  verifiedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type ReportShareAccessMinAggregate = {
  __typename?: 'ReportShareAccessMinAggregate';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  downloadedAt?: Maybe<Scalars['DateTime']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  ipAddress?: Maybe<Scalars['String']['output']>;
  tokenId?: Maybe<Scalars['String']['output']>;
  userAgent?: Maybe<Scalars['String']['output']>;
  verifiedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type ReportShareListOutput = {
  __typename?: 'ReportShareListOutput';
  /** List of share tokens with access logs */
  shares: Array<ReportShareWithAccess>;
  /** Total number of unique accessors */
  totalAccessors: Scalars['Float']['output'];
  /** Total number of shares */
  totalShares: Scalars['Float']['output'];
};

export type ReportShareTokenCountAggregate = {
  __typename?: 'ReportShareTokenCountAggregate';
  _all: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  createdBy: Scalars['Int']['output'];
  expiresAt: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  isRevoked: Scalars['Int']['output'];
  organizationId: Scalars['Int']['output'];
  password: Scalars['Int']['output'];
  templateId: Scalars['Int']['output'];
  token: Scalars['Int']['output'];
  updatedAt: Scalars['Int']['output'];
};

export type ReportShareTokenMaxAggregate = {
  __typename?: 'ReportShareTokenMaxAggregate';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  expiresAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  isRevoked?: Maybe<Scalars['Boolean']['output']>;
  organizationId?: Maybe<Scalars['String']['output']>;
  password?: Maybe<Scalars['String']['output']>;
  templateId?: Maybe<Scalars['String']['output']>;
  token?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type ReportShareTokenMinAggregate = {
  __typename?: 'ReportShareTokenMinAggregate';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  expiresAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  isRevoked?: Maybe<Scalars['Boolean']['output']>;
  organizationId?: Maybe<Scalars['String']['output']>;
  password?: Maybe<Scalars['String']['output']>;
  templateId?: Maybe<Scalars['String']['output']>;
  token?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type ReportShareTokenOutput = {
  __typename?: 'ReportShareTokenOutput';
  /** Creation timestamp */
  createdAt: Scalars['DateTime']['output'];
  /** Expiration timestamp */
  expiresAt?: Maybe<Scalars['DateTime']['output']>;
  /** Whether password is required */
  hasPassword: Scalars['Boolean']['output'];
  /** Share token ID */
  id: Scalars['String']['output'];
  /** Full share URL */
  shareUrl: Scalars['String']['output'];
  /** Unique share token */
  token: Scalars['String']['output'];
};

export type ReportShareVerificationCodeAvgAggregate = {
  __typename?: 'ReportShareVerificationCodeAvgAggregate';
  attempts?: Maybe<Scalars['Float']['output']>;
};

export type ReportShareVerificationCodeCountAggregate = {
  __typename?: 'ReportShareVerificationCodeCountAggregate';
  _all: Scalars['Int']['output'];
  attempts: Scalars['Int']['output'];
  code: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  email: Scalars['Int']['output'];
  expiresAt: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  tokenId: Scalars['Int']['output'];
};

export type ReportShareVerificationCodeMaxAggregate = {
  __typename?: 'ReportShareVerificationCodeMaxAggregate';
  attempts?: Maybe<Scalars['Int']['output']>;
  code?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  expiresAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  tokenId?: Maybe<Scalars['String']['output']>;
};

export type ReportShareVerificationCodeMinAggregate = {
  __typename?: 'ReportShareVerificationCodeMinAggregate';
  attempts?: Maybe<Scalars['Int']['output']>;
  code?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  expiresAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  tokenId?: Maybe<Scalars['String']['output']>;
};

export type ReportShareVerificationCodeSumAggregate = {
  __typename?: 'ReportShareVerificationCodeSumAggregate';
  attempts?: Maybe<Scalars['Int']['output']>;
};

export type ReportShareWithAccess = {
  __typename?: 'ReportShareWithAccess';
  /** Access log entries */
  accesses: Array<ReportShareAccessEntry>;
  /** Creation timestamp */
  createdAt: Scalars['DateTime']['output'];
  /** Expiration timestamp */
  expiresAt?: Maybe<Scalars['DateTime']['output']>;
  /** Whether password is required */
  hasPassword: Scalars['Boolean']['output'];
  /** Share token ID */
  id: Scalars['String']['output'];
  /** Whether share has been revoked */
  isRevoked: Scalars['Boolean']['output'];
  /** Share token (first 8 chars only for security) */
  tokenPreview: Scalars['String']['output'];
};

export type ReportTemplateAvgAggregate = {
  __typename?: 'ReportTemplateAvgAggregate';
  lastValidatedSchemaVersion?: Maybe<Scalars['Float']['output']>;
  version?: Maybe<Scalars['Float']['output']>;
};

export type ReportTemplateCountAggregate = {
  __typename?: 'ReportTemplateCountAggregate';
  _all: Scalars['Int']['output'];
  clonedFrom: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  createdBy: Scalars['Int']['output'];
  description: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  isSystemTemplate: Scalars['Int']['output'];
  lastValidatedAt: Scalars['Int']['output'];
  lastValidatedSchemaVersion: Scalars['Int']['output'];
  name: Scalars['Int']['output'];
  organizationId: Scalars['Int']['output'];
  programSchemaId: Scalars['Int']['output'];
  updatedAt: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
};

/** Export configuration for the report */
export type ReportTemplateExportConfig = {
  __typename?: 'ReportTemplateExportConfig';
  /** CSV delimiter character (default: ",") */
  csvDelimiter: Scalars['String']['output'];
  /** Default filename prefix (e.g., "civic-seals-report") */
  filenamePrefix?: Maybe<Scalars['String']['output']>;
  /** Include header row in CSV (default: true) */
  includeHeaders: Scalars['Boolean']['output'];
  /** Include timestamp in filename (default: true) */
  includeTimestamp: Scalars['Boolean']['output'];
  /**
   * How to handle nested JSON in CSV exports
   * 'stringify' - JSON.stringify (default)
   * 'flatten' - Flatten nested objects with dot notation keys
   * 'omit' - Skip JSON fields in CSV
   */
  jsonHandling: Scalars['String']['output'];
  /** Maximum rows per export (0 = unlimited) */
  maxRows: Scalars['Int']['output'];
};

/**
 * Individual field definition within a report template
 * Defines how to extract and format a single column in the exported report
 */
export type ReportTemplateField = {
  __typename?: 'ReportTemplateField';
  /** For ADK fields: the activity name for dynamic lookup (alternative to index-based access) */
  activityName?: Maybe<Scalars['String']['output']>;
  /**
   * How to handle array values
   * 'first' - Return first element
   * 'last' - Return last element
   * 'count' - Return array length
   * 'join' - Join with separator
   * 'expand' - Create multiple rows (one per element)
   * 'stringify' - JSON.stringify the array (default for json dataType)
   */
  arrayHandling?: Maybe<Scalars['String']['output']>;
  /** Separator for 'join' arrayHandling (default: ', ') */
  arraySeparator?: Maybe<Scalars['String']['output']>;
  /** Data type for formatting: 'string' | 'number' | 'date' | 'boolean' | 'json' | 'array' */
  dataType: Scalars['String']['output'];
  /** Default value if field is missing or null */
  defaultValue?: Maybe<Scalars['String']['output']>;
  /** Display name shown as column header in export (e.g., "First Name", "Civics Total XP") */
  displayName: Scalars['String']['output'];
  /** For ADK fields: specific field index within the activity */
  fieldIndex?: Maybe<Scalars['Int']['output']>;
  /** For ADK fields: specific field name within the activity */
  fieldName?: Maybe<Scalars['String']['output']>;
  /** Unique identifier for this field within the template */
  id: Scalars['String']['output'];
  /** Whether to include this field in default exports */
  includeByDefault: Scalars['Boolean']['output'];
  /** Whether this field is required (affects validation warnings) */
  isRequired: Scalars['Boolean']['output'];
  /**
   * JSON path to extract the value (supports dot notation, array indices, and named lookups)
   * Simple: "firstName"
   * Nested: "school.name"
   * Array index: "adks[0].fields[11].value.civicSealTrack"
   * Named lookup: "adks[name=Civics].fields[0].value.totalXP"
   * Combined: "adks[name=Endorse].fields[0].value.endorsementRequests[0].endorserName"
   */
  path: Scalars['String']['output'];
  /** Position/order in the export (0-indexed) */
  position: Scalars['Int']['output'];
  /**
   * Source collection for the data
   * 'student' | 'user' | 'studentPortfolio' | 'program' | 'programSchema' | 'programTeam'
   */
  source: Scalars['String']['output'];
  /**
   * Widget type this field comes from (for documentation and validation)
   * e.g., 'm-civics', 'm-endorse', 'm-presentation', 'm-checkoutForm'
   */
  widgetType?: Maybe<Scalars['String']['output']>;
};

export type ReportTemplateMaxAggregate = {
  __typename?: 'ReportTemplateMaxAggregate';
  clonedFrom?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  isSystemTemplate?: Maybe<Scalars['Boolean']['output']>;
  lastValidatedAt?: Maybe<Scalars['DateTime']['output']>;
  lastValidatedSchemaVersion?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  organizationId?: Maybe<Scalars['String']['output']>;
  programSchemaId?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  version?: Maybe<Scalars['Int']['output']>;
};

export type ReportTemplateMinAggregate = {
  __typename?: 'ReportTemplateMinAggregate';
  clonedFrom?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  isSystemTemplate?: Maybe<Scalars['Boolean']['output']>;
  lastValidatedAt?: Maybe<Scalars['DateTime']['output']>;
  lastValidatedSchemaVersion?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  organizationId?: Maybe<Scalars['String']['output']>;
  programSchemaId?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  version?: Maybe<Scalars['Int']['output']>;
};

export type ReportTemplateSumAggregate = {
  __typename?: 'ReportTemplateSumAggregate';
  lastValidatedSchemaVersion?: Maybe<Scalars['Int']['output']>;
  version?: Maybe<Scalars['Int']['output']>;
};

export type ResendCaptchaInput = {
  /** Context for the captcha (e.g., SIGN_UP_PHONE) */
  context: Scalars['String']['input'];
  /** Previous captcha ID, if refreshing */
  previousCaptchaId?: InputMaybe<Scalars['String']['input']>;
};

export type ResendCaptchaResponse = {
  __typename?: 'ResendCaptchaResponse';
  captcha: CaptchaData;
};

export type ResendEndorsementEmailInput = {
  adkIndex: Scalars['Float']['input'];
  fieldIndex: Scalars['Float']['input'];
  programId: Scalars['String']['input'];
  requestId: Scalars['String']['input'];
  studentId: Scalars['String']['input'];
};

export type ResendEndorsementEmailResponse = {
  __typename?: 'ResendEndorsementEmailResponse';
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type ResendOtpInput = {
  /** Context for the OTP resend (SIGN_IN or SIGN_UP) */
  context: OtpContext;
  /** Email or phone number to resend OTP to */
  identifier: Scalars['String']['input'];
  /** Type of identifier: EMAIL or PHONE */
  type: Scalars['String']['input'];
};

export type ResendOtpResponse = {
  __typename?: 'ResendOtpResponse';
  /** Human-readable status message */
  message: Scalars['String']['output'];
  /** ISO timestamp when next resend will be allowed */
  nextResendAllowedAt?: Maybe<Scalars['String']['output']>;
  /** Whether OTP was already sent recently (duplicate prevention) */
  otpAlreadySent?: Maybe<Scalars['Boolean']['output']>;
  /** Whether OTP was successfully sent */
  otpSent?: Maybe<Scalars['Boolean']['output']>;
  /** Time in milliseconds until next resend is allowed */
  resendCooldownMs?: Maybe<Scalars['Float']['output']>;
  /** Whether the resend operation was successful */
  success: Scalars['Boolean']['output'];
};

/** Input for coordinator to resend verification OTP */
export type ResendVerificationInput = {
  /** Program ID context */
  programId: Scalars['String']['input'];
  /** User ID of participant to resend OTP to */
  userId: Scalars['String']['input'];
};

/** Result of resending verification OTP */
export type ResendVerificationResultType = {
  __typename?: 'ResendVerificationResultType';
  /** Error message if resend failed */
  error?: Maybe<Scalars['String']['output']>;
  /** Whether resend was successful */
  sent: Scalars['Boolean']['output'];
};

export type ResourceContext = {
  __typename?: 'ResourceContext';
  contentChunks: Scalars['JSON']['output'];
  contentHash?: Maybe<Scalars['String']['output']>;
  contextId: Scalars['String']['output'];
  contextType: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  extractedAt?: Maybe<Scalars['DateTime']['output']>;
  failureCount: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  lastFailedAt?: Maybe<Scalars['DateTime']['output']>;
  metadata?: Maybe<Scalars['JSON']['output']>;
  rawContent?: Maybe<Scalars['String']['output']>;
  references?: Maybe<Scalars['JSON']['output']>;
  sourceLabel?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
  summary?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  url: Scalars['String']['output'];
  urlType: Scalars['String']['output'];
};

export type ResourceContextAvgAggregate = {
  __typename?: 'ResourceContextAvgAggregate';
  failureCount?: Maybe<Scalars['Float']['output']>;
};

export type ResourceContextCountAggregate = {
  __typename?: 'ResourceContextCountAggregate';
  _all: Scalars['Int']['output'];
  contentChunks: Scalars['Int']['output'];
  contentHash: Scalars['Int']['output'];
  contextId: Scalars['Int']['output'];
  contextType: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  extractedAt: Scalars['Int']['output'];
  failureCount: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  lastFailedAt: Scalars['Int']['output'];
  metadata: Scalars['Int']['output'];
  rawContent: Scalars['Int']['output'];
  references: Scalars['Int']['output'];
  sourceLabel: Scalars['Int']['output'];
  status: Scalars['Int']['output'];
  summary: Scalars['Int']['output'];
  title: Scalars['Int']['output'];
  updatedAt: Scalars['Int']['output'];
  url: Scalars['Int']['output'];
  urlType: Scalars['Int']['output'];
};

export type ResourceContextMaxAggregate = {
  __typename?: 'ResourceContextMaxAggregate';
  contentHash?: Maybe<Scalars['String']['output']>;
  contextId?: Maybe<Scalars['String']['output']>;
  contextType?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  extractedAt?: Maybe<Scalars['DateTime']['output']>;
  failureCount?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  lastFailedAt?: Maybe<Scalars['DateTime']['output']>;
  rawContent?: Maybe<Scalars['String']['output']>;
  sourceLabel?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  summary?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  url?: Maybe<Scalars['String']['output']>;
  urlType?: Maybe<Scalars['String']['output']>;
};

export type ResourceContextMinAggregate = {
  __typename?: 'ResourceContextMinAggregate';
  contentHash?: Maybe<Scalars['String']['output']>;
  contextId?: Maybe<Scalars['String']['output']>;
  contextType?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  extractedAt?: Maybe<Scalars['DateTime']['output']>;
  failureCount?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  lastFailedAt?: Maybe<Scalars['DateTime']['output']>;
  rawContent?: Maybe<Scalars['String']['output']>;
  sourceLabel?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  summary?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  url?: Maybe<Scalars['String']['output']>;
  urlType?: Maybe<Scalars['String']['output']>;
};

export type ResourceContextSumAggregate = {
  __typename?: 'ResourceContextSumAggregate';
  failureCount?: Maybe<Scalars['Int']['output']>;
};

export type ResourceExcerptGql = {
  __typename?: 'ResourceExcerptGql';
  chunkIndex?: Maybe<Scalars['Int']['output']>;
  contextType: Scalars['String']['output'];
  excerpt: Scalars['String']['output'];
  score: Scalars['Float']['output'];
  title: Scalars['String']['output'];
  totalChunks?: Maybe<Scalars['Int']['output']>;
  url: Scalars['String']['output'];
};

export type ResourceUploadAvgAggregate = {
  __typename?: 'ResourceUploadAvgAggregate';
  extractionCostUsd?: Maybe<Scalars['Float']['output']>;
  sizeBytes?: Maybe<Scalars['Float']['output']>;
  transcriptCharCount?: Maybe<Scalars['Float']['output']>;
  transcriptionDurationSeconds?: Maybe<Scalars['Float']['output']>;
};

export type ResourceUploadCountAggregate = {
  __typename?: 'ResourceUploadCountAggregate';
  _all: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  expiresAt: Scalars['Int']['output'];
  extractionCostUsd: Scalars['Int']['output'];
  extractionStatus: Scalars['Int']['output'];
  filename: Scalars['Int']['output'];
  firstFetchedAt: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  mimeType: Scalars['Int']['output'];
  r2Key: Scalars['Int']['output'];
  resourceUrl: Scalars['Int']['output'];
  sizeBytes: Scalars['Int']['output'];
  tokenId: Scalars['Int']['output'];
  transcriptCharCount: Scalars['Int']['output'];
  transcriptionDurationSeconds: Scalars['Int']['output'];
  uploadCompleted: Scalars['Int']['output'];
  userId: Scalars['Int']['output'];
};

export type ResourceUploadMaxAggregate = {
  __typename?: 'ResourceUploadMaxAggregate';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  expiresAt?: Maybe<Scalars['DateTime']['output']>;
  extractionCostUsd?: Maybe<Scalars['Float']['output']>;
  extractionStatus?: Maybe<Scalars['String']['output']>;
  filename?: Maybe<Scalars['String']['output']>;
  firstFetchedAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  mimeType?: Maybe<Scalars['String']['output']>;
  r2Key?: Maybe<Scalars['String']['output']>;
  resourceUrl?: Maybe<Scalars['String']['output']>;
  sizeBytes?: Maybe<Scalars['Int']['output']>;
  tokenId?: Maybe<Scalars['String']['output']>;
  transcriptCharCount?: Maybe<Scalars['Int']['output']>;
  transcriptionDurationSeconds?: Maybe<Scalars['Float']['output']>;
  uploadCompleted?: Maybe<Scalars['Boolean']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
};

export type ResourceUploadMinAggregate = {
  __typename?: 'ResourceUploadMinAggregate';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  expiresAt?: Maybe<Scalars['DateTime']['output']>;
  extractionCostUsd?: Maybe<Scalars['Float']['output']>;
  extractionStatus?: Maybe<Scalars['String']['output']>;
  filename?: Maybe<Scalars['String']['output']>;
  firstFetchedAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  mimeType?: Maybe<Scalars['String']['output']>;
  r2Key?: Maybe<Scalars['String']['output']>;
  resourceUrl?: Maybe<Scalars['String']['output']>;
  sizeBytes?: Maybe<Scalars['Int']['output']>;
  tokenId?: Maybe<Scalars['String']['output']>;
  transcriptCharCount?: Maybe<Scalars['Int']['output']>;
  transcriptionDurationSeconds?: Maybe<Scalars['Float']['output']>;
  uploadCompleted?: Maybe<Scalars['Boolean']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
};

export type ResourceUploadSumAggregate = {
  __typename?: 'ResourceUploadSumAggregate';
  extractionCostUsd?: Maybe<Scalars['Float']['output']>;
  sizeBytes?: Maybe<Scalars['Int']['output']>;
  transcriptCharCount?: Maybe<Scalars['Int']['output']>;
  transcriptionDurationSeconds?: Maybe<Scalars['Float']['output']>;
};

export type Roadmap = {
  __typename?: 'Roadmap';
  estimatedDuration: Scalars['String']['output'];
  generatedAt: Scalars['String']['output'];
  keySkills: Array<Scalars['String']['output']>;
  parsedSuccessfully?: Maybe<Scalars['Boolean']['output']>;
  phases: Array<RoadmapPhase>;
  rawResponse?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
  summary: Scalars['String']['output'];
};

export type RoadmapPhase = {
  __typename?: 'RoadmapPhase';
  activities: Array<Scalars['String']['output']>;
  description: Scalars['String']['output'];
  duration?: Maybe<Scalars['String']['output']>;
  outcomes?: Maybe<Array<Scalars['String']['output']>>;
  title: Scalars['String']['output'];
};

export type RolesCountAggregate = {
  __typename?: 'RolesCountAggregate';
  _all: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  role: Scalars['Int']['output'];
};

export type RolesMaxAggregate = {
  __typename?: 'RolesMaxAggregate';
  id?: Maybe<Scalars['String']['output']>;
  role?: Maybe<Scalars['String']['output']>;
};

export type RolesMinAggregate = {
  __typename?: 'RolesMinAggregate';
  id?: Maybe<Scalars['String']['output']>;
  role?: Maybe<Scalars['String']['output']>;
};

export type RolesPermissions = {
  __typename?: 'RolesPermissions';
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

/** Lightweight student record for roster view (~500 bytes vs 3-8KB) */
export type RosterStudent = {
  __typename?: 'RosterStudent';
  _id?: Maybe<Scalars['String']['output']>;
  adksCompletion?: Maybe<Scalars['Float']['output']>;
  /** Name of the last incomplete ADK activity */
  currentActivity?: Maybe<Scalars['String']['output']>;
  grade?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  participant_id?: Maybe<Scalars['String']['output']>;
  /** Profile image URLs object with small, medium, large */
  profile?: Maybe<Scalars['JSONObject']['output']>;
  /** Program name resolved from Program lookup */
  programName?: Maybe<Scalars['String']['output']>;
  program_id?: Maybe<Scalars['String']['output']>;
  /** School info object with name, district, etc. from StudentPortfolio */
  school?: Maybe<Scalars['JSONObject']['output']>;
  /** Scoring data: riskScore, potentialScore, quadrant, scoredAt */
  scores?: Maybe<Scalars['JSONObject']['output']>;
  teamName?: Maybe<Scalars['String']['output']>;
};

export type Run = {
  __typename?: 'Run';
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  error?: Maybe<Scalars['JSON']['output']>;
  id: Scalars['String']['output'];
  langGraphId: Scalars['String']['output'];
  metadata?: Maybe<Scalars['JSON']['output']>;
  startedAt?: Maybe<Scalars['DateTime']['output']>;
  status: Scalars['String']['output'];
};

export type RunCreateInput = {
  completedAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt: Scalars['DateTime']['input'];
  error?: InputMaybe<Scalars['JSON']['input']>;
  id: Scalars['String']['input'];
  langGraphId: Scalars['String']['input'];
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  startedAt?: InputMaybe<Scalars['DateTime']['input']>;
  status: Scalars['String']['input'];
};

export type RunObjectEqualityInput = {
  completedAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt: Scalars['DateTime']['input'];
  error?: InputMaybe<Scalars['JSON']['input']>;
  id: Scalars['String']['input'];
  langGraphId: Scalars['String']['input'];
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  startedAt?: InputMaybe<Scalars['DateTime']['input']>;
  status: Scalars['String']['input'];
};

export type SaturationFlagsInput = {
  /** Cite a stat in each stage culmination */
  culmination?: InputMaybe<Scalars['Boolean']['input']>;
  /** Cite a stat in the heroHook headline */
  heroHook?: InputMaybe<Scalars['Boolean']['input']>;
  /** Cite a stat in the introSentence */
  introSentence?: InputMaybe<Scalars['Boolean']['input']>;
  /** Cite a stat in each journeyPaths.result */
  journeyPathResult?: InputMaybe<Scalars['Boolean']['input']>;
  /** Cite a stat in each rankedProgram matchReason */
  matchReason?: InputMaybe<Scalars['Boolean']['input']>;
  /** Cite a stat in each stage description */
  stageDescription?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SaveRoadmapInput = {
  /** Device ID for anonymous tracking */
  deviceId?: InputMaybe<Scalars['String']['input']>;
  /** Device metadata (browser, platform, etc.) */
  deviceInfo?: InputMaybe<Scalars['JSON']['input']>;
  /** User email address for roadmap retrieval */
  email: Scalars['String']['input'];
  /** Display name for this saved roadmap */
  name: Scalars['String']['input'];
  /** Generated roadmap data with phases, summary, skills */
  roadmap: Scalars['JSON']['input'];
  /** User customization inputs (strengths, passions, goals, etc.) */
  savedInputs: Scalars['JSON']['input'];
  /** User ID if authenticated */
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type SavedScope = {
  __typename?: 'SavedScope';
  deviceId?: Maybe<Scalars['String']['output']>;
  /** Device metadata (browser, platform, timezone, etc.) */
  deviceInfo?: Maybe<Scalars['JSON']['output']>;
  email: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  /** Embedded roadmap data with phases, summary, skills, etc. */
  roadmap?: Maybe<Scalars['JSON']['output']>;
  /** Timestamps */
  savedAt: Scalars['DateTime']['output'];
  /** Customization inputs from roadmap generator (strengths, passions, goals, etc.) */
  savedInputs: Scalars['JSON']['output'];
  /** Legacy Airtable fields for migration compatibility */
  scopesList?: Maybe<Scalars['JSON']['output']>;
  scopesPerEmployer?: Maybe<Scalars['Int']['output']>;
  selectedScopes?: Maybe<Scalars['JSON']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  user?: Maybe<User>;
  userId?: Maybe<Scalars['String']['output']>;
};

export type SavedScopeAvgAggregate = {
  __typename?: 'SavedScopeAvgAggregate';
  scopesPerEmployer?: Maybe<Scalars['Float']['output']>;
};

export type SavedScopeCountAggregate = {
  __typename?: 'SavedScopeCountAggregate';
  _all: Scalars['Int']['output'];
  deviceId: Scalars['Int']['output'];
  deviceInfo: Scalars['Int']['output'];
  email: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['Int']['output'];
  roadmap: Scalars['Int']['output'];
  savedAt: Scalars['Int']['output'];
  savedInputs: Scalars['Int']['output'];
  scopesList: Scalars['Int']['output'];
  scopesPerEmployer: Scalars['Int']['output'];
  selectedScopes: Scalars['Int']['output'];
  updatedAt: Scalars['Int']['output'];
  userId: Scalars['Int']['output'];
};

export type SavedScopeCreateManyUserInput = {
  deviceId?: InputMaybe<Scalars['String']['input']>;
  deviceInfo?: InputMaybe<Scalars['JSON']['input']>;
  email: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  roadmap?: InputMaybe<Scalars['JSON']['input']>;
  savedAt?: InputMaybe<Scalars['DateTime']['input']>;
  savedInputs: Scalars['JSON']['input'];
  scopesList?: InputMaybe<Scalars['JSON']['input']>;
  scopesPerEmployer?: InputMaybe<Scalars['Int']['input']>;
  selectedScopes?: InputMaybe<Scalars['JSON']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type SavedScopeCreateManyUserInputEnvelope = {
  data: Array<SavedScopeCreateManyUserInput>;
};

export type SavedScopeCreateNestedManyWithoutUserInput = {
  connect?: InputMaybe<Array<SavedScopeWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<SavedScopeCreateOrConnectWithoutUserInput>>;
  create?: InputMaybe<Array<SavedScopeCreateWithoutUserInput>>;
  createMany?: InputMaybe<SavedScopeCreateManyUserInputEnvelope>;
};

export type SavedScopeCreateOrConnectWithoutUserInput = {
  create: SavedScopeCreateWithoutUserInput;
  where: SavedScopeWhereUniqueInput;
};

export type SavedScopeCreateWithoutUserInput = {
  deviceId?: InputMaybe<Scalars['String']['input']>;
  deviceInfo?: InputMaybe<Scalars['JSON']['input']>;
  email: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  roadmap?: InputMaybe<Scalars['JSON']['input']>;
  savedAt?: InputMaybe<Scalars['DateTime']['input']>;
  savedInputs: Scalars['JSON']['input'];
  scopesList?: InputMaybe<Scalars['JSON']['input']>;
  scopesPerEmployer?: InputMaybe<Scalars['Int']['input']>;
  selectedScopes?: InputMaybe<Scalars['JSON']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type SavedScopeListRelationFilter = {
  every?: InputMaybe<SavedScopeWhereInput>;
  none?: InputMaybe<SavedScopeWhereInput>;
  some?: InputMaybe<SavedScopeWhereInput>;
};

export type SavedScopeMaxAggregate = {
  __typename?: 'SavedScopeMaxAggregate';
  deviceId?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  savedAt?: Maybe<Scalars['DateTime']['output']>;
  scopesPerEmployer?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
};

export type SavedScopeMinAggregate = {
  __typename?: 'SavedScopeMinAggregate';
  deviceId?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  savedAt?: Maybe<Scalars['DateTime']['output']>;
  scopesPerEmployer?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
};

/** Saved roadmap scope with embedded roadmap data */
export type SavedScopeOutput = {
  __typename?: 'SavedScopeOutput';
  /** Device ID for anonymous users */
  deviceId?: Maybe<Scalars['String']['output']>;
  /** Device metadata */
  deviceInfo?: Maybe<Scalars['JSON']['output']>;
  /** User email address */
  email: Scalars['String']['output'];
  /** Unique identifier for the saved scope */
  id: Scalars['ID']['output'];
  /** Display name for this saved roadmap */
  name: Scalars['String']['output'];
  /** Generated roadmap data */
  roadmap?: Maybe<Scalars['JSON']['output']>;
  /** Timestamp when roadmap was saved */
  savedAt: Scalars['DateTime']['output'];
  /** User customization inputs */
  savedInputs: Scalars['JSON']['output'];
  /** Timestamp when roadmap was last updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User ID if authenticated */
  userId?: Maybe<Scalars['ID']['output']>;
};

export type SavedScopeScalarWhereInput = {
  AND?: InputMaybe<Array<SavedScopeScalarWhereInput>>;
  NOT?: InputMaybe<Array<SavedScopeScalarWhereInput>>;
  OR?: InputMaybe<Array<SavedScopeScalarWhereInput>>;
  deviceId?: InputMaybe<StringNullableFilter>;
  deviceInfo?: InputMaybe<JsonNullableFilter>;
  email?: InputMaybe<StringFilter>;
  id?: InputMaybe<StringFilter>;
  name?: InputMaybe<StringFilter>;
  roadmap?: InputMaybe<JsonNullableFilter>;
  savedAt?: InputMaybe<DateTimeFilter>;
  savedInputs?: InputMaybe<JsonFilter>;
  scopesList?: InputMaybe<JsonNullableFilter>;
  scopesPerEmployer?: InputMaybe<IntNullableFilter>;
  selectedScopes?: InputMaybe<JsonNullableFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  userId?: InputMaybe<StringNullableFilter>;
};

export type SavedScopeSumAggregate = {
  __typename?: 'SavedScopeSumAggregate';
  scopesPerEmployer?: Maybe<Scalars['Int']['output']>;
};

export type SavedScopeUpdateManyMutationInput = {
  deviceId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  deviceInfo?: InputMaybe<Scalars['JSON']['input']>;
  email?: InputMaybe<StringFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  roadmap?: InputMaybe<Scalars['JSON']['input']>;
  savedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  savedInputs?: InputMaybe<Scalars['JSON']['input']>;
  scopesList?: InputMaybe<Scalars['JSON']['input']>;
  scopesPerEmployer?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  selectedScopes?: InputMaybe<Scalars['JSON']['input']>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type SavedScopeUpdateManyWithWhereWithoutUserInput = {
  data: SavedScopeUpdateManyMutationInput;
  where: SavedScopeScalarWhereInput;
};

export type SavedScopeUpdateManyWithoutUserNestedInput = {
  connect?: InputMaybe<Array<SavedScopeWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<SavedScopeCreateOrConnectWithoutUserInput>>;
  create?: InputMaybe<Array<SavedScopeCreateWithoutUserInput>>;
  createMany?: InputMaybe<SavedScopeCreateManyUserInputEnvelope>;
  delete?: InputMaybe<Array<SavedScopeWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<SavedScopeScalarWhereInput>>;
  disconnect?: InputMaybe<Array<SavedScopeWhereUniqueInput>>;
  set?: InputMaybe<Array<SavedScopeWhereUniqueInput>>;
  update?: InputMaybe<Array<SavedScopeUpdateWithWhereUniqueWithoutUserInput>>;
  updateMany?: InputMaybe<Array<SavedScopeUpdateManyWithWhereWithoutUserInput>>;
  upsert?: InputMaybe<Array<SavedScopeUpsertWithWhereUniqueWithoutUserInput>>;
};

export type SavedScopeUpdateWithWhereUniqueWithoutUserInput = {
  data: SavedScopeUpdateWithoutUserInput;
  where: SavedScopeWhereUniqueInput;
};

export type SavedScopeUpdateWithoutUserInput = {
  deviceId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  deviceInfo?: InputMaybe<Scalars['JSON']['input']>;
  email?: InputMaybe<StringFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  roadmap?: InputMaybe<Scalars['JSON']['input']>;
  savedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  savedInputs?: InputMaybe<Scalars['JSON']['input']>;
  scopesList?: InputMaybe<Scalars['JSON']['input']>;
  scopesPerEmployer?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  selectedScopes?: InputMaybe<Scalars['JSON']['input']>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type SavedScopeUpsertWithWhereUniqueWithoutUserInput = {
  create: SavedScopeCreateWithoutUserInput;
  update: SavedScopeUpdateWithoutUserInput;
  where: SavedScopeWhereUniqueInput;
};

export type SavedScopeWhereInput = {
  AND?: InputMaybe<Array<SavedScopeWhereInput>>;
  NOT?: InputMaybe<Array<SavedScopeWhereInput>>;
  OR?: InputMaybe<Array<SavedScopeWhereInput>>;
  deviceId?: InputMaybe<StringNullableFilter>;
  deviceInfo?: InputMaybe<JsonNullableFilter>;
  email?: InputMaybe<StringFilter>;
  id?: InputMaybe<StringFilter>;
  name?: InputMaybe<StringFilter>;
  roadmap?: InputMaybe<JsonNullableFilter>;
  savedAt?: InputMaybe<DateTimeFilter>;
  savedInputs?: InputMaybe<JsonFilter>;
  scopesList?: InputMaybe<JsonNullableFilter>;
  scopesPerEmployer?: InputMaybe<IntNullableFilter>;
  selectedScopes?: InputMaybe<JsonNullableFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  user?: InputMaybe<UserNullableRelationFilter>;
  userId?: InputMaybe<StringNullableFilter>;
};

export type SavedScopeWhereUniqueInput = {
  AND?: InputMaybe<Array<SavedScopeWhereInput>>;
  NOT?: InputMaybe<Array<SavedScopeWhereInput>>;
  OR?: InputMaybe<Array<SavedScopeWhereInput>>;
  deviceId?: InputMaybe<StringNullableFilter>;
  deviceInfo?: InputMaybe<JsonNullableFilter>;
  email?: InputMaybe<StringFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<StringFilter>;
  roadmap?: InputMaybe<JsonNullableFilter>;
  savedAt?: InputMaybe<DateTimeFilter>;
  savedInputs?: InputMaybe<JsonFilter>;
  scopesList?: InputMaybe<JsonNullableFilter>;
  scopesPerEmployer?: InputMaybe<IntNullableFilter>;
  selectedScopes?: InputMaybe<JsonNullableFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  user?: InputMaybe<UserNullableRelationFilter>;
  userId?: InputMaybe<StringNullableFilter>;
};

export type SchemaChange = {
  __typename?: 'SchemaChange';
  activityName?: Maybe<Scalars['String']['output']>;
  actualValue?: Maybe<Scalars['String']['output']>;
  expectedValue?: Maybe<Scalars['String']['output']>;
  fieldId: Scalars['String']['output'];
  message: Scalars['String']['output'];
  severity: SchemaChangeSeverity;
  type: SchemaChangeType;
};

export type SchemaChangeReport = {
  __typename?: 'SchemaChangeReport';
  changes: Array<SchemaChange>;
  checkedAt: Scalars['DateTime']['output'];
  hasBreakingChanges: Scalars['Boolean']['output'];
  schemaVersion?: Maybe<Scalars['Float']['output']>;
  templateId: Scalars['String']['output'];
};

/** Severity level of schema changes */
export enum SchemaChangeSeverity {
  Error = 'ERROR',
  Warning = 'WARNING'
}

/** Types of schema changes that can break templates */
export enum SchemaChangeType {
  ActivityRemoved = 'ACTIVITY_REMOVED',
  ActivityRenamed = 'ACTIVITY_RENAMED',
  FieldIndexInvalid = 'FIELD_INDEX_INVALID',
  FieldStructureChanged = 'FIELD_STRUCTURE_CHANGED',
  WidgetChanged = 'WIDGET_CHANGED'
}

export type SchoolPortfolio = {
  __typename?: 'SchoolPortfolio';
  airtable?: Maybe<Array<SchoolPortfolioAirtable>>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  district?: Maybe<SchoolPortfolioDistrict>;
  id: Scalars['ID']['output'];
  last_modified_at?: Maybe<Scalars['DateTime']['output']>;
  last_synced_at?: Maybe<Scalars['DateTime']['output']>;
  position?: Maybe<Scalars['String']['output']>;
  schoolDistrict?: Maybe<Scalars['String']['output']>;
  staffType?: Maybe<Array<Scalars['String']['output']>>;
};

export type SchoolPortfolioAirtable = {
  __typename?: 'SchoolPortfolioAirtable';
  airtable_id: Scalars['String']['output'];
  created_at: Scalars['DateTime']['output'];
  last_modified_at: Scalars['DateTime']['output'];
  spreadsheet: Scalars['String']['output'];
};

export type SchoolPortfolioCountAggregate = {
  __typename?: 'SchoolPortfolioCountAggregate';
  _all: Scalars['Int']['output'];
  deletedAt: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  last_modified_at: Scalars['Int']['output'];
  last_synced_at: Scalars['Int']['output'];
  position: Scalars['Int']['output'];
  schoolDistrict: Scalars['Int']['output'];
  staffType: Scalars['Int']['output'];
};

export type SchoolPortfolioDistrict = {
  __typename?: 'SchoolPortfolioDistrict';
  city: Scalars['String']['output'];
  state: Scalars['String']['output'];
  streetAddress: Scalars['String']['output'];
  typeName?: Maybe<Scalars['String']['output']>;
  zipcode: Scalars['String']['output'];
};

export type SchoolPortfolioMaxAggregate = {
  __typename?: 'SchoolPortfolioMaxAggregate';
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  last_modified_at?: Maybe<Scalars['DateTime']['output']>;
  last_synced_at?: Maybe<Scalars['DateTime']['output']>;
  position?: Maybe<Scalars['String']['output']>;
  schoolDistrict?: Maybe<Scalars['String']['output']>;
};

export type SchoolPortfolioMinAggregate = {
  __typename?: 'SchoolPortfolioMinAggregate';
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  last_modified_at?: Maybe<Scalars['DateTime']['output']>;
  last_synced_at?: Maybe<Scalars['DateTime']['output']>;
  position?: Maybe<Scalars['String']['output']>;
  schoolDistrict?: Maybe<Scalars['String']['output']>;
};

/** Input for selecting AI mentor persona */
export type SelectPersonaInput = {
  /** Persona ID to select */
  personaId: Scalars['String']['input'];
};

/** Result of selecting a persona */
export type SelectPersonaResultType = {
  __typename?: 'SelectPersonaResultType';
  /** Selected persona ID */
  personaId: Scalars['String']['output'];
};

export type SendActivityEmailOtpInput = {
  /** Optional context identifier (e.g., activity ID) for tracking */
  context?: InputMaybe<Scalars['String']['input']>;
  /** Email address to verify */
  email: Scalars['String']['input'];
};

export type SendActivityPhoneOtpInput = {
  /** Optional context identifier (e.g., activity ID) for tracking */
  context?: InputMaybe<Scalars['String']['input']>;
  /** Phone number to verify (E.164 format preferred, e.g., +14155551234) */
  phoneNumber: Scalars['String']['input'];
};

/** Input for sending email verification OTP */
export type SendEmailVerificationInput = {
  /** Email address to send verification to */
  email: Scalars['String']['input'];
};

/** Input for sending phone verification OTP */
export type SendPhoneVerificationInput = {
  /** Phone number in any format (will be converted to E.164) */
  phoneNumber: Scalars['String']['input'];
};

export type SendVerificationCodeInput = {
  /** Email address to verify */
  email: Scalars['String']['input'];
  /** Organization ID to join */
  organizationId: Scalars['String']['input'];
};

export type SetCredentialValidatorInput = {
  /** The credential/badge name to target a specific credential type. */
  credentialName?: InputMaybe<Scalars['String']['input']>;
  /** The organization ID (for authorization check) */
  organizationId: Scalars['String']['input'];
  /** The participant/badge ID to update (from organizationParticipants query) */
  participantId: Scalars['String']['input'];
  /** The Student document _id to target badges for a specific enrollment. This is the "id" field from the organizationParticipants row. */
  studentId?: InputMaybe<Scalars['String']['input']>;
  /** The user ID of the validator. Set to null to clear validation. */
  validatorId?: InputMaybe<Scalars['String']['input']>;
};

export type SetCredentialValidatorResponse = {
  __typename?: 'SetCredentialValidatorResponse';
  /** Error message if update failed */
  error?: Maybe<Scalars['String']['output']>;
  /** The participant/badge ID that was updated */
  participantId?: Maybe<Scalars['String']['output']>;
  /** Whether the update was successful */
  success: Scalars['Boolean']['output'];
  /** The validator ID that was set */
  validatorId?: Maybe<Scalars['String']['output']>;
  /** The validator name (for display) */
  validatorName?: Maybe<Scalars['String']['output']>;
};

export type SetDefaultInstanceInput = {
  participantId: Scalars['String']['input'];
  programId: Scalars['String']['input'];
  studentId: Scalars['String']['input'];
};

// HAND-AUTHORED (STUDENT_INSTANCES feature) — mirrors SetDefaultInstanceInput.
// The local codegen schema.gql does not yet declare this input (backend built in
// parallel). Re-running codegen once the backend ships createStudentInstance will
// regenerate this block identically. See src/services/graphql/nexus/student.ts.
export type CreateStudentInstanceInput = {
  makeDefault?: InputMaybe<Scalars['Boolean']['input']>;
  participantId: Scalars['String']['input'];
  programId: Scalars['String']['input'];
};

export type SetSlugOutput = {
  __typename?: 'SetSlugOutput';
  error?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

/** Result of checking shareCode availability */
export type ShareCodeAvailabilityOutput = {
  __typename?: 'ShareCodeAvailabilityOutput';
  /** Whether the shareCode is available for use */
  available: Scalars['Boolean']['output'];
  /** Reason why the shareCode is not available (if not available) */
  reason?: Maybe<Scalars['String']['output']>;
};

/** Expiration duration options for report share links */
export enum ShareExpiryOption {
  Days_7 = 'DAYS_7',
  Days_30 = 'DAYS_30',
  Hours_24 = 'HOURS_24',
  Never = 'NEVER'
}

export type ShiftSpendGoal = {
  __typename?: 'ShiftSpendGoal';
  assumptions: Scalars['JSON']['output'];
  breakdown: Scalars['JSON']['output'];
  clonedFromId?: Maybe<Scalars['String']['output']>;
  confidence: Scalars['String']['output'];
  costRangeMaxUsd: Scalars['Float']['output'];
  costRangeMinUsd: Scalars['Float']['output'];
  createdAt: Scalars['DateTime']['output'];
  estimatedCostUsd: Scalars['Float']['output'];
  explanation: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  label: Scalars['String']['output'];
  originalInput: Scalars['String']['output'];
  rateProfileSlug?: Maybe<Scalars['String']['output']>;
  shiftsNeeded: Scalars['Float']['output'];
  shiftsPerWeekIfDated?: Maybe<Scalars['Float']['output']>;
  status: Scalars['String']['output'];
  targetDate?: Maybe<Scalars['DateTime']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  user: User;
  userId: Scalars['String']['output'];
};

export type ShiftSpendGoalAvgAggregate = {
  __typename?: 'ShiftSpendGoalAvgAggregate';
  costRangeMaxUsd?: Maybe<Scalars['Float']['output']>;
  costRangeMinUsd?: Maybe<Scalars['Float']['output']>;
  estimatedCostUsd?: Maybe<Scalars['Float']['output']>;
  shiftsNeeded?: Maybe<Scalars['Float']['output']>;
  shiftsPerWeekIfDated?: Maybe<Scalars['Float']['output']>;
};

export type ShiftSpendGoalCountAggregate = {
  __typename?: 'ShiftSpendGoalCountAggregate';
  _all: Scalars['Int']['output'];
  assumptions: Scalars['Int']['output'];
  breakdown: Scalars['Int']['output'];
  clonedFromId: Scalars['Int']['output'];
  confidence: Scalars['Int']['output'];
  costRangeMaxUsd: Scalars['Int']['output'];
  costRangeMinUsd: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  estimatedCostUsd: Scalars['Int']['output'];
  explanation: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  label: Scalars['Int']['output'];
  originalInput: Scalars['Int']['output'];
  rateProfileSlug: Scalars['Int']['output'];
  shiftsNeeded: Scalars['Int']['output'];
  shiftsPerWeekIfDated: Scalars['Int']['output'];
  status: Scalars['Int']['output'];
  targetDate: Scalars['Int']['output'];
  updatedAt: Scalars['Int']['output'];
  userId: Scalars['Int']['output'];
};

export type ShiftSpendGoalCreateManyUserInput = {
  assumptions: Scalars['JSON']['input'];
  breakdown: Scalars['JSON']['input'];
  clonedFromId?: InputMaybe<Scalars['String']['input']>;
  confidence: Scalars['String']['input'];
  costRangeMaxUsd: Scalars['Float']['input'];
  costRangeMinUsd: Scalars['Float']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  estimatedCostUsd: Scalars['Float']['input'];
  explanation: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  label: Scalars['String']['input'];
  originalInput: Scalars['String']['input'];
  rateProfileSlug?: InputMaybe<Scalars['String']['input']>;
  shiftsNeeded: Scalars['Float']['input'];
  shiftsPerWeekIfDated?: InputMaybe<Scalars['Float']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  targetDate?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ShiftSpendGoalCreateManyUserInputEnvelope = {
  data: Array<ShiftSpendGoalCreateManyUserInput>;
};

export type ShiftSpendGoalCreateNestedManyWithoutUserInput = {
  connect?: InputMaybe<Array<ShiftSpendGoalWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ShiftSpendGoalCreateOrConnectWithoutUserInput>>;
  create?: InputMaybe<Array<ShiftSpendGoalCreateWithoutUserInput>>;
  createMany?: InputMaybe<ShiftSpendGoalCreateManyUserInputEnvelope>;
};

export type ShiftSpendGoalCreateOrConnectWithoutUserInput = {
  create: ShiftSpendGoalCreateWithoutUserInput;
  where: ShiftSpendGoalWhereUniqueInput;
};

export type ShiftSpendGoalCreateWithoutUserInput = {
  assumptions: Scalars['JSON']['input'];
  breakdown: Scalars['JSON']['input'];
  clonedFromId?: InputMaybe<Scalars['String']['input']>;
  confidence: Scalars['String']['input'];
  costRangeMaxUsd: Scalars['Float']['input'];
  costRangeMinUsd: Scalars['Float']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  estimatedCostUsd: Scalars['Float']['input'];
  explanation: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  label: Scalars['String']['input'];
  originalInput: Scalars['String']['input'];
  rateProfileSlug?: InputMaybe<Scalars['String']['input']>;
  shiftsNeeded: Scalars['Float']['input'];
  shiftsPerWeekIfDated?: InputMaybe<Scalars['Float']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  targetDate?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ShiftSpendGoalListRelationFilter = {
  every?: InputMaybe<ShiftSpendGoalWhereInput>;
  none?: InputMaybe<ShiftSpendGoalWhereInput>;
  some?: InputMaybe<ShiftSpendGoalWhereInput>;
};

export type ShiftSpendGoalMaxAggregate = {
  __typename?: 'ShiftSpendGoalMaxAggregate';
  clonedFromId?: Maybe<Scalars['String']['output']>;
  confidence?: Maybe<Scalars['String']['output']>;
  costRangeMaxUsd?: Maybe<Scalars['Float']['output']>;
  costRangeMinUsd?: Maybe<Scalars['Float']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  estimatedCostUsd?: Maybe<Scalars['Float']['output']>;
  explanation?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  originalInput?: Maybe<Scalars['String']['output']>;
  rateProfileSlug?: Maybe<Scalars['String']['output']>;
  shiftsNeeded?: Maybe<Scalars['Float']['output']>;
  shiftsPerWeekIfDated?: Maybe<Scalars['Float']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  targetDate?: Maybe<Scalars['DateTime']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
};

export type ShiftSpendGoalMinAggregate = {
  __typename?: 'ShiftSpendGoalMinAggregate';
  clonedFromId?: Maybe<Scalars['String']['output']>;
  confidence?: Maybe<Scalars['String']['output']>;
  costRangeMaxUsd?: Maybe<Scalars['Float']['output']>;
  costRangeMinUsd?: Maybe<Scalars['Float']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  estimatedCostUsd?: Maybe<Scalars['Float']['output']>;
  explanation?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  originalInput?: Maybe<Scalars['String']['output']>;
  rateProfileSlug?: Maybe<Scalars['String']['output']>;
  shiftsNeeded?: Maybe<Scalars['Float']['output']>;
  shiftsPerWeekIfDated?: Maybe<Scalars['Float']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  targetDate?: Maybe<Scalars['DateTime']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
};

export type ShiftSpendGoalOutput = {
  __typename?: 'ShiftSpendGoalOutput';
  assumptions: Scalars['JSON']['output'];
  breakdown: Scalars['JSON']['output'];
  clonedFromId?: Maybe<Scalars['ID']['output']>;
  confidence: Scalars['String']['output'];
  costRangeMaxUsd: Scalars['Float']['output'];
  costRangeMinUsd: Scalars['Float']['output'];
  createdAt: Scalars['DateTime']['output'];
  estimatedCostUsd: Scalars['Float']['output'];
  explanation: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  label: Scalars['String']['output'];
  originalInput: Scalars['String']['output'];
  rateProfileSlug?: Maybe<Scalars['String']['output']>;
  shiftsNeeded: Scalars['Float']['output'];
  shiftsPerWeekIfDated?: Maybe<Scalars['Float']['output']>;
  status: Scalars['String']['output'];
  targetDate?: Maybe<Scalars['DateTime']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  userId: Scalars['ID']['output'];
};

export type ShiftSpendGoalScalarWhereInput = {
  AND?: InputMaybe<Array<ShiftSpendGoalScalarWhereInput>>;
  NOT?: InputMaybe<Array<ShiftSpendGoalScalarWhereInput>>;
  OR?: InputMaybe<Array<ShiftSpendGoalScalarWhereInput>>;
  assumptions?: InputMaybe<JsonFilter>;
  breakdown?: InputMaybe<JsonFilter>;
  clonedFromId?: InputMaybe<StringNullableFilter>;
  confidence?: InputMaybe<StringFilter>;
  costRangeMaxUsd?: InputMaybe<FloatFilter>;
  costRangeMinUsd?: InputMaybe<FloatFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  estimatedCostUsd?: InputMaybe<FloatFilter>;
  explanation?: InputMaybe<StringFilter>;
  id?: InputMaybe<StringFilter>;
  label?: InputMaybe<StringFilter>;
  originalInput?: InputMaybe<StringFilter>;
  rateProfileSlug?: InputMaybe<StringNullableFilter>;
  shiftsNeeded?: InputMaybe<FloatFilter>;
  shiftsPerWeekIfDated?: InputMaybe<FloatNullableFilter>;
  status?: InputMaybe<StringFilter>;
  targetDate?: InputMaybe<DateTimeNullableFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  userId?: InputMaybe<StringFilter>;
};

export type ShiftSpendGoalSumAggregate = {
  __typename?: 'ShiftSpendGoalSumAggregate';
  costRangeMaxUsd?: Maybe<Scalars['Float']['output']>;
  costRangeMinUsd?: Maybe<Scalars['Float']['output']>;
  estimatedCostUsd?: Maybe<Scalars['Float']['output']>;
  shiftsNeeded?: Maybe<Scalars['Float']['output']>;
  shiftsPerWeekIfDated?: Maybe<Scalars['Float']['output']>;
};

export type ShiftSpendGoalUpdateManyMutationInput = {
  assumptions?: InputMaybe<Scalars['JSON']['input']>;
  breakdown?: InputMaybe<Scalars['JSON']['input']>;
  clonedFromId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  confidence?: InputMaybe<StringFieldUpdateOperationsInput>;
  costRangeMaxUsd?: InputMaybe<FloatFieldUpdateOperationsInput>;
  costRangeMinUsd?: InputMaybe<FloatFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  estimatedCostUsd?: InputMaybe<FloatFieldUpdateOperationsInput>;
  explanation?: InputMaybe<StringFieldUpdateOperationsInput>;
  label?: InputMaybe<StringFieldUpdateOperationsInput>;
  originalInput?: InputMaybe<StringFieldUpdateOperationsInput>;
  rateProfileSlug?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  shiftsNeeded?: InputMaybe<FloatFieldUpdateOperationsInput>;
  shiftsPerWeekIfDated?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  status?: InputMaybe<StringFieldUpdateOperationsInput>;
  targetDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ShiftSpendGoalUpdateManyWithWhereWithoutUserInput = {
  data: ShiftSpendGoalUpdateManyMutationInput;
  where: ShiftSpendGoalScalarWhereInput;
};

export type ShiftSpendGoalUpdateManyWithoutUserNestedInput = {
  connect?: InputMaybe<Array<ShiftSpendGoalWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ShiftSpendGoalCreateOrConnectWithoutUserInput>>;
  create?: InputMaybe<Array<ShiftSpendGoalCreateWithoutUserInput>>;
  createMany?: InputMaybe<ShiftSpendGoalCreateManyUserInputEnvelope>;
  delete?: InputMaybe<Array<ShiftSpendGoalWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ShiftSpendGoalScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ShiftSpendGoalWhereUniqueInput>>;
  set?: InputMaybe<Array<ShiftSpendGoalWhereUniqueInput>>;
  update?: InputMaybe<Array<ShiftSpendGoalUpdateWithWhereUniqueWithoutUserInput>>;
  updateMany?: InputMaybe<Array<ShiftSpendGoalUpdateManyWithWhereWithoutUserInput>>;
  upsert?: InputMaybe<Array<ShiftSpendGoalUpsertWithWhereUniqueWithoutUserInput>>;
};

export type ShiftSpendGoalUpdateWithWhereUniqueWithoutUserInput = {
  data: ShiftSpendGoalUpdateWithoutUserInput;
  where: ShiftSpendGoalWhereUniqueInput;
};

export type ShiftSpendGoalUpdateWithoutUserInput = {
  assumptions?: InputMaybe<Scalars['JSON']['input']>;
  breakdown?: InputMaybe<Scalars['JSON']['input']>;
  clonedFromId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  confidence?: InputMaybe<StringFieldUpdateOperationsInput>;
  costRangeMaxUsd?: InputMaybe<FloatFieldUpdateOperationsInput>;
  costRangeMinUsd?: InputMaybe<FloatFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  estimatedCostUsd?: InputMaybe<FloatFieldUpdateOperationsInput>;
  explanation?: InputMaybe<StringFieldUpdateOperationsInput>;
  label?: InputMaybe<StringFieldUpdateOperationsInput>;
  originalInput?: InputMaybe<StringFieldUpdateOperationsInput>;
  rateProfileSlug?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  shiftsNeeded?: InputMaybe<FloatFieldUpdateOperationsInput>;
  shiftsPerWeekIfDated?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  status?: InputMaybe<StringFieldUpdateOperationsInput>;
  targetDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ShiftSpendGoalUpsertWithWhereUniqueWithoutUserInput = {
  create: ShiftSpendGoalCreateWithoutUserInput;
  update: ShiftSpendGoalUpdateWithoutUserInput;
  where: ShiftSpendGoalWhereUniqueInput;
};

export type ShiftSpendGoalWhereInput = {
  AND?: InputMaybe<Array<ShiftSpendGoalWhereInput>>;
  NOT?: InputMaybe<Array<ShiftSpendGoalWhereInput>>;
  OR?: InputMaybe<Array<ShiftSpendGoalWhereInput>>;
  assumptions?: InputMaybe<JsonFilter>;
  breakdown?: InputMaybe<JsonFilter>;
  clonedFromId?: InputMaybe<StringNullableFilter>;
  confidence?: InputMaybe<StringFilter>;
  costRangeMaxUsd?: InputMaybe<FloatFilter>;
  costRangeMinUsd?: InputMaybe<FloatFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  estimatedCostUsd?: InputMaybe<FloatFilter>;
  explanation?: InputMaybe<StringFilter>;
  id?: InputMaybe<StringFilter>;
  label?: InputMaybe<StringFilter>;
  originalInput?: InputMaybe<StringFilter>;
  rateProfileSlug?: InputMaybe<StringNullableFilter>;
  shiftsNeeded?: InputMaybe<FloatFilter>;
  shiftsPerWeekIfDated?: InputMaybe<FloatNullableFilter>;
  status?: InputMaybe<StringFilter>;
  targetDate?: InputMaybe<DateTimeNullableFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  user?: InputMaybe<UserRelationFilter>;
  userId?: InputMaybe<StringFilter>;
};

export type ShiftSpendGoalWhereUniqueInput = {
  AND?: InputMaybe<Array<ShiftSpendGoalWhereInput>>;
  NOT?: InputMaybe<Array<ShiftSpendGoalWhereInput>>;
  OR?: InputMaybe<Array<ShiftSpendGoalWhereInput>>;
  assumptions?: InputMaybe<JsonFilter>;
  breakdown?: InputMaybe<JsonFilter>;
  clonedFromId?: InputMaybe<StringNullableFilter>;
  confidence?: InputMaybe<StringFilter>;
  costRangeMaxUsd?: InputMaybe<FloatFilter>;
  costRangeMinUsd?: InputMaybe<FloatFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  estimatedCostUsd?: InputMaybe<FloatFilter>;
  explanation?: InputMaybe<StringFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  label?: InputMaybe<StringFilter>;
  originalInput?: InputMaybe<StringFilter>;
  rateProfileSlug?: InputMaybe<StringNullableFilter>;
  shiftsNeeded?: InputMaybe<FloatFilter>;
  shiftsPerWeekIfDated?: InputMaybe<FloatNullableFilter>;
  status?: InputMaybe<StringFilter>;
  targetDate?: InputMaybe<DateTimeNullableFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  user?: InputMaybe<UserRelationFilter>;
  userId?: InputMaybe<StringFilter>;
};

export type SignInInput = {
  /** User email to impersonate for ADMIN_IMPERSONATION */
  impersonateEmail?: InputMaybe<Scalars['String']['input']>;
  /** Admin password for ADMIN_IMPERSONATION */
  impersonatePassword?: InputMaybe<Scalars['String']['input']>;
  /** Password, required for EMAIL_PASSWORD provider */
  password?: InputMaybe<Scalars['String']['input']>;
  /** Phone number for PHONE_OTP provider */
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  /** Authentication provider */
  provider: SignInProvider;
  /** Username, typically email or phone number */
  username: Scalars['String']['input'];
};

/** The authentication provider used for signing in. */
export enum SignInProvider {
  AdminImpersonation = 'ADMIN_IMPERSONATION',
  EmailOtp = 'EMAIL_OTP',
  EmailPassword = 'EMAIL_PASSWORD',
  Google = 'GOOGLE',
  PhoneOtp = 'PHONE_OTP'
}

export type SignUpInput = {
  /** Captcha verification token to prevent automated signups */
  captchaToken?: InputMaybe<Scalars['String']['input']>;
  /** Email address for signup */
  email?: InputMaybe<Scalars['String']['input']>;
  /** User's first name for profile creation */
  firstName?: InputMaybe<Scalars['String']['input']>;
  /** User's last name for profile creation */
  lastName?: InputMaybe<Scalars['String']['input']>;
  /** Signup method: EMAIL or PHONE */
  method: Scalars['String']['input'];
  /** Password for the new account (optional if OTP sets it) */
  password?: InputMaybe<Scalars['String']['input']>;
  /** Phone number for signup */
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  /** Unique username for the account */
  username?: InputMaybe<Scalars['String']['input']>;
};

/** Result of simulating program details with raw ADK data */
export type SimulatedProgramResult = {
  __typename?: 'SimulatedProgramResult';
  adks?: Maybe<Array<Scalars['JSONObject']['output']>>;
  id: Scalars['String']['output'];
  keywords?: Maybe<Array<Scalars['String']['output']>>;
  organizationName?: Maybe<Scalars['String']['output']>;
  pathways?: Maybe<Array<Scalars['String']['output']>>;
  programDesc?: Maybe<Scalars['String']['output']>;
  programName: Scalars['String']['output'];
  published?: Maybe<Scalars['Boolean']['output']>;
  requiredSkills?: Maybe<Array<Scalars['String']['output']>>;
  requiredTech?: Maybe<Array<Scalars['String']['output']>>;
};

/** Input for coordinator to skip onboarding for participant */
export type SkipOnboardingInput = {
  /** Program ID context */
  programId: Scalars['String']['input'];
  /** User ID of participant to skip onboarding for */
  userId: Scalars['String']['input'];
};

/** Result of skipping onboarding for participant */
export type SkipOnboardingResultType = {
  __typename?: 'SkipOnboardingResultType';
  /** Error message if skip failed */
  error?: Maybe<Scalars['String']['output']>;
  /** Whether skip was successful */
  skipped: Scalars['Boolean']['output'];
};

export type SlugAvailabilityOutput = {
  __typename?: 'SlugAvailabilityOutput';
  available: Scalars['Boolean']['output'];
  /** If taken, who owns it: "user" or "organization" */
  takenBy?: Maybe<Scalars['String']['output']>;
};

export type SortInput = {
  direction?: InputMaybe<Scalars['String']['input']>;
  field: Scalars['String']['input'];
};

export enum SortOrder {
  Asc = 'asc',
  Desc = 'desc'
}

export type Sponsor = {
  __typename?: 'Sponsor';
  /** Credential badges earned from this organization sponsor */
  badges?: Maybe<Array<SponsorBadge>>;
  /** Individual cash payment details for display in modal */
  cashPayments?: Maybe<Array<CashPayment>>;
  /** Total cash received from this sponsor in dollars */
  cashReceived?: Maybe<Scalars['Float']['output']>;
  /** First name (for user sponsors only) */
  firstName?: Maybe<Scalars['String']['output']>;
  /** Unique identifier of the sponsor */
  id: Scalars['String']['output'];
  /** Initials for avatar fallback display */
  initials: Scalars['String']['output'];
  /** Whether this sponsor chose to remain anonymous */
  isAnonymous?: Maybe<Scalars['Boolean']['output']>;
  /** Whether this sponsor is validated (organizations are auto-validated) */
  isValidated?: Maybe<Scalars['Boolean']['output']>;
  /** Link to join or learn more about the sponsor organization */
  joinLink?: Maybe<Scalars['String']['output']>;
  /** Last name (for user sponsors only) */
  lastName?: Maybe<Scalars['String']['output']>;
  /** URL to the sponsor logo (organizations) or profile image (users) */
  logoUrl?: Maybe<Scalars['String']['output']>;
  /** Array of personal messages from the sponsor */
  messages?: Maybe<Array<Scalars['String']['output']>>;
  /** Display name of the sponsor */
  name: Scalars['String']['output'];
  /** Number of cash payments received from this sponsor */
  paymentCount?: Maybe<Scalars['Int']['output']>;
  /** Number of programs this sponsor has supported you in */
  programsSupported?: Maybe<Scalars['Int']['output']>;
  /** Slug for the sponsor public portfolio (only returned if organization has portfolioPublic=true) */
  slug?: Maybe<Scalars['String']['output']>;
  /** Category of sponsorship (CHECKOUT, CREDENTIAL, CASH, or MIXED) */
  sponsorCategory?: Maybe<SponsorCategory>;
  /** Date when the sponsorship was claimed (ISO string) */
  sponsoredAt?: Maybe<Scalars['String']['output']>;
  /** Total tokens received from this sponsor across all enrollments */
  tokensReceived?: Maybe<Scalars['Int']['output']>;
  /** Type of sponsor (ORGANIZATION or USER) */
  type: SponsorType;
};

export type SponsorBadge = {
  __typename?: 'SponsorBadge';
  /** Badge type (e.g., internship, course) */
  badgeType: Scalars['String']['output'];
  /** Number of times this badge was earned */
  count: Scalars['Int']['output'];
  /** Date when this badge was most recently earned (ISO string) */
  earnedAt?: Maybe<Scalars['String']['output']>;
  /** Badge/credential name */
  name: Scalars['String']['output'];
};

/** The category of sponsorship: CHECKOUT (token-based), CREDENTIAL (badge-based), CASH (direct payment), or MIXED (multiple types) */
export enum SponsorCategory {
  Cash = 'CASH',
  Checkout = 'CHECKOUT',
  Credential = 'CREDENTIAL',
  Mixed = 'MIXED'
}

/** A sponsor link for a user (personal wallet) or user in an organization */
export type SponsorLinkOutput = {
  __typename?: 'SponsorLinkOutput';
  /** Creator of the sponsor link. For personal: userId. For organization: organizationId */
  createdBy: Scalars['ID']['output'];
  /** SponsorLinks document ID */
  id: Scalars['ID']['output'];
  /** If true, this result is from a redirect lookup (the requested shareCode was in previousShareCodes) */
  isRedirect?: Maybe<Scalars['Boolean']['output']>;
  /** Previous share codes that redirect to this link (for backward compatibility) */
  previousShareCodes?: Maybe<Array<Scalars['String']['output']>>;
  /** Landing page settings (landingTitleText, landingSponsorFirstName, etc.) */
  programSettings?: Maybe<Scalars['JSON']['output']>;
  /** The original shareCode that was looked up (only present when isRedirect is true) */
  requestedShareCode?: Maybe<Scalars['String']['output']>;
  /** The share code used in sponsor URLs (e.g., https://www.pilotcity.com/sponsor/ABC123) */
  shareCode: Scalars['String']['output'];
  /** Type of sponsor link: "personal" or "organization" */
  type: Scalars['String']['output'];
  /** User ID for organization links. Null for personal wallet links. */
  userId?: Maybe<Scalars['ID']['output']>;
};

/**
 * Per-activity time override for SponsorLink cascade.
 * Mirrors ProgramAdksTimeSettings — null fields inherit from Program.
 */
export type SponsorLinkTimeOverride = {
  __typename?: 'SponsorLinkTimeOverride';
  activityIndex: Scalars['Int']['output'];
  closeDate?: Maybe<Scalars['String']['output']>;
  closeDateAnchor?: Maybe<Scalars['String']['output']>;
  dueDate?: Maybe<Scalars['String']['output']>;
  dueDateAnchor?: Maybe<Scalars['String']['output']>;
  expectedDuration?: Maybe<Scalars['Int']['output']>;
  startDate?: Maybe<Scalars['String']['output']>;
  startDateAnchor?: Maybe<Scalars['String']['output']>;
  timeAllowance?: Maybe<Scalars['Int']['output']>;
  timeAllowanceMode?: Maybe<Scalars['String']['output']>;
};

export type SponsorLinksAirtable = {
  __typename?: 'SponsorLinksAirtable';
  airtable_id: Scalars['String']['output'];
  created_at: Scalars['DateTime']['output'];
  last_modified_at: Scalars['DateTime']['output'];
  spreadsheet: Scalars['String']['output'];
};

export type SponsorLinksAvgAggregate = {
  __typename?: 'SponsorLinksAvgAggregate';
  balance?: Maybe<Scalars['Float']['output']>;
  claimQuotaPerUser?: Maybe<Scalars['Float']['output']>;
  index?: Maybe<Scalars['Float']['output']>;
};

export type SponsorLinksCountAggregate = {
  __typename?: 'SponsorLinksCountAggregate';
  _all: Scalars['Int']['output'];
  autoMonitor: Scalars['Int']['output'];
  balance: Scalars['Int']['output'];
  claimQuotaPerUser: Scalars['Int']['output'];
  claimedBy: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  createdBy: Scalars['Int']['output'];
  creationType: Scalars['Int']['output'];
  expireAt: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  index: Scalars['Int']['output'];
  last_synced_at: Scalars['Int']['output'];
  previousShareCodes: Scalars['Int']['output'];
  shareCode: Scalars['Int']['output'];
  status: Scalars['Int']['output'];
  tokenPool: Scalars['Int']['output'];
  type: Scalars['Int']['output'];
  userId: Scalars['Int']['output'];
};

export type SponsorLinksMaxAggregate = {
  __typename?: 'SponsorLinksMaxAggregate';
  autoMonitor?: Maybe<Scalars['Boolean']['output']>;
  balance?: Maybe<Scalars['Int']['output']>;
  claimQuotaPerUser?: Maybe<Scalars['Int']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  creationType?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  index?: Maybe<Scalars['Int']['output']>;
  last_synced_at?: Maybe<Scalars['DateTime']['output']>;
  shareCode?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
};

export type SponsorLinksMinAggregate = {
  __typename?: 'SponsorLinksMinAggregate';
  autoMonitor?: Maybe<Scalars['Boolean']['output']>;
  balance?: Maybe<Scalars['Int']['output']>;
  claimQuotaPerUser?: Maybe<Scalars['Int']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  creationType?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  index?: Maybe<Scalars['Int']['output']>;
  last_synced_at?: Maybe<Scalars['DateTime']['output']>;
  shareCode?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
};

/** A specific program in the initiative sequence */
export type SponsorLinksProgramSequenceSpecificProgram = {
  __typename?: 'SponsorLinksProgramSequenceSpecificProgram';
  id: Scalars['String']['output'];
  programName: Scalars['String']['output'];
  templateId?: Maybe<Scalars['String']['output']>;
};

/** A step in the initiative design program sequence */
export type SponsorLinksProgramSequenceStep = {
  __typename?: 'SponsorLinksProgramSequenceStep';
  /** Deadline date for this step (ISO date string) */
  deadlineDate?: Maybe<Scalars['String']['output']>;
  deadlineDateMenu?: Maybe<Scalars['Boolean']['output']>;
  /** Duration description (e.g., "4 weeks") */
  duration?: Maybe<Scalars['String']['output']>;
  /** Display label for this step (e.g., "Step 1: Getting Started") */
  label?: Maybe<Scalars['String']['output']>;
  /** The program model/template for this step */
  programModel: Scalars['String']['output'];
  /** Number of programs to complete in this step (default: 1) */
  programsToComplete?: Maybe<Scalars['Int']['output']>;
  /** Whether this step is required before moving to next */
  required?: Maybe<Scalars['Boolean']['output']>;
  /** Specific programs to show for this step (if empty, shows all from template) */
  specificPrograms?: Maybe<Array<SponsorLinksProgramSequenceSpecificProgram>>;
  /** Start date for this step (ISO date string) */
  startDate?: Maybe<Scalars['String']['output']>;
  /** UI state flags for date pickers */
  startDateMenu?: Maybe<Scalars['Boolean']['output']>;
  /** Template ID reference */
  templateId?: Maybe<Scalars['String']['output']>;
  /**
   * Per-activity time setting overrides (Phase 2 cascade)
   * Each entry overrides specific time properties for one activity.
   * Null fields inherit from Program's ProgramAdksTimeSettings.
   */
  timeOverrides?: Maybe<Array<SponsorLinkTimeOverride>>;
};

export type SponsorLinksProgramSettings = {
  __typename?: 'SponsorLinksProgramSettings';
  /** Allow participants to skip steps in the sequence */
  allowParticipantSkip?: Maybe<Scalars['Boolean']['output']>;
  changeDefaultTab: Scalars['Boolean']['output'];
  /**
   * Custom hint text to display below pricing (optional override)
   * If empty, uses default hint based on sponsorshipCoversCost
   */
  checkoutHintText?: Maybe<Scalars['String']['output']>;
  customScopeText: SponsorLinksProgramSettingsCustomScopeText;
  defaultPathways: Scalars['String']['output'];
  defaultProgramModel: Scalars['String']['output'];
  defaultTab: Scalars['String']['output'];
  /**
   * Disable auto-population of sponsor link in checkout dialog
   * When true: Checkout dialog opens normally without pre-filling sponsor link
   * When false/null: Sponsor link is auto-filled from localStorage
   */
  disableAutoPopulateSponsorLink?: Maybe<Scalars['Boolean']['output']>;
  displayAllPublicPrograms: Scalars['Boolean']['output'];
  employerDomains?: Maybe<Array<Scalars['String']['output']>>;
  /**
   * ============================================================
   * Initiative Design / Participant Roadmap Settings
   * ============================================================
   * Enable the Initiative Design feature which provides a curated
   * program sequence/roadmap for participants
   */
  enableInitiativeDesign?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Feature toggle for journal/reflection functionality in this program
   * When true: Students can create journal entries via TimelineBar UI
   * When false: Journal button is completely hidden from UI (not just disabled)
   * Default: false (opt-in feature for backward compatibility)
   */
  enableJournalFeature: Scalars['Boolean']['output'];
  /**
   * Enable the Opportunity Map view (Cards/Map toggle on the sponsor landing).
   * Off by default to preserve pre-feature behavior on existing links.
   */
  enableMapView?: Maybe<Scalars['Boolean']['output']>;
  /**
   * ============================================================
   * Roadmap Grounding Settings
   * ============================================================
   * Master switch for roadmap grounding. When false (default), grounding is
   * disabled regardless of attached sources — sponsors can configure sources
   * then pause the feature without losing the configuration. When true and
   * at least one source is attached, the AI roadmap generator pulls real-
   * world evidence and weaves it into the generated narrative.
   */
  enableRoadmapGrounding?: Maybe<Scalars['Boolean']['output']>;
  enabledTabs?: Maybe<Array<Scalars['String']['output']>>;
  filterPathways: Scalars['Boolean']['output'];
  filterProgramModels: Scalars['Boolean']['output'];
  /**
   * IDs of GroundingSource records attached to this share link.
   * Only used when enableRoadmapGrounding is true AND the participant has
   * not opted out via the participant-side toggle.
   */
  groundingSourceIds?: Maybe<Array<Scalars['String']['output']>>;
  /**
   * Hide the "Enter Sponsor Link" option entirely in checkout
   * Use when organization doesn't cover costs and doesn't want manual sponsor link entry
   */
  hideSponsorLinkOption?: Maybe<Scalars['Boolean']['output']>;
  includeChangeTitleText: Scalars['Boolean']['output'];
  includeCreatedPrograms: Scalars['Boolean']['output'];
  includeSelfCreationOfPrograms: Scalars['Boolean']['output'];
  includeSponsoredPrograms: Scalars['Boolean']['output'];
  insertCustomScope: Scalars['Boolean']['output'];
  /**
   * Auto-trigger journal prompt when student completes an activity
   * Only applies when enableJournalFeature is true
   * Default: true (prompts enabled by default when journal feature is on)
   */
  journalTriggerOnActivityComplete: Scalars['Boolean']['output'];
  /**
   * Auto-trigger journal prompt when student starts an activity
   * Only applies when enableJournalFeature is true
   * Default: true (prompts enabled by default when journal feature is on)
   */
  journalTriggerOnActivityStart: Scalars['Boolean']['output'];
  landingOrganizationName?: Maybe<Scalars['String']['output']>;
  landingSponsorFirstName: Scalars['String']['output'];
  landingSponsorLastName: Scalars['String']['output'];
  landingTitleText: Scalars['String']['output'];
  preselectEmployerOptions: Scalars['Boolean']['output'];
  /** Ordered sequence of program steps for the initiative roadmap */
  programSequence?: Maybe<Array<SponsorLinksProgramSequenceStep>>;
  selectedPathways?: Maybe<Array<Scalars['String']['output']>>;
  selectedProgramModels?: Maybe<Array<Scalars['String']['output']>>;
  selectedSelfCreationProgram?: Maybe<Array<Scalars['String']['output']>>;
  /** Show pricing info (tokens/price) on program cards */
  showPricingInfo?: Maybe<Scalars['Boolean']['output']>;
  /** Show progress tracker UI to participants */
  showProgressTracker?: Maybe<Scalars['Boolean']['output']>;
  /**
   * ============================================================
   * Sponsorship Coverage Settings
   * ============================================================
   * Indicates if the sponsor organization covers program costs
   * When true: Shows "sponsored by [OrgName]" hint on program cards
   * When false/null: Shows "or get sponsored" hint
   */
  sponsorshipCoversCost?: Maybe<Scalars['Boolean']['output']>;
  /** Toggle to enable public programs to be started directly */
  startPublicProgram?: Maybe<Scalars['Boolean']['output']>;
  toggleTabs: Scalars['Boolean']['output'];
  type: Scalars['String']['output'];
  /** Use AI to recommend programs based on participant interests */
  useAIRecommendations?: Maybe<Scalars['Boolean']['output']>;
};

export type SponsorLinksProgramSettingsCustomScopeText = {
  __typename?: 'SponsorLinksProgramSettingsCustomScopeText';
  careers?: Maybe<Scalars['String']['output']>;
  carrers?: Maybe<Scalars['String']['output']>;
  deliverables?: Maybe<Scalars['String']['output']>;
  goals?: Maybe<Scalars['String']['output']>;
  jobs?: Maybe<Scalars['String']['output']>;
  passions?: Maybe<Scalars['String']['output']>;
  problems?: Maybe<Scalars['String']['output']>;
  skills?: Maybe<Scalars['String']['output']>;
  strengths?: Maybe<Scalars['String']['output']>;
  tools?: Maybe<Scalars['String']['output']>;
  user?: Maybe<Scalars['String']['output']>;
};

export type SponsorLinksSumAggregate = {
  __typename?: 'SponsorLinksSumAggregate';
  balance?: Maybe<Scalars['Int']['output']>;
  claimQuotaPerUser?: Maybe<Scalars['Int']['output']>;
  index?: Maybe<Scalars['Int']['output']>;
};

/** The type of sponsor (Organization or User) */
export enum SponsorType {
  Organization = 'ORGANIZATION',
  User = 'USER'
}

export type StringFieldUpdateOperationsInput = {
  set?: InputMaybe<Scalars['String']['input']>;
};

export type StringFilter = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equals?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  mode?: InputMaybe<QueryMode>;
  not?: InputMaybe<NestedStringFilter>;
  notIn?: InputMaybe<Array<Scalars['String']['input']>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};

export type StringNullableFilter = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equals?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  isSet?: InputMaybe<Scalars['Boolean']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  mode?: InputMaybe<QueryMode>;
  not?: InputMaybe<NestedStringNullableFilter>;
  notIn?: InputMaybe<Array<Scalars['String']['input']>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};

export type StringNullableListFilter = {
  equals?: InputMaybe<Array<Scalars['String']['input']>>;
  has?: InputMaybe<Scalars['String']['input']>;
  hasEvery?: InputMaybe<Array<Scalars['String']['input']>>;
  hasSome?: InputMaybe<Array<Scalars['String']['input']>>;
  isEmpty?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Response from Stripe Connect account operations */
export type StripeAccountResponse = {
  __typename?: 'StripeAccountResponse';
  /** Stripe Connect account ID */
  accountId: Scalars['String']['output'];
  /** Whether charges are enabled on this account */
  chargesEnabled: Scalars['Boolean']['output'];
  /** URL for Stripe onboarding flow (if account needs setup) */
  onboardingUrl?: Maybe<Scalars['String']['output']>;
  /** Whether payouts are enabled on this account */
  payoutsEnabled: Scalars['Boolean']['output'];
  /** List of currently due verification requirements */
  requirementsDue?: Maybe<Array<Scalars['String']['output']>>;
  /** Account verification status */
  verificationStatus: Scalars['String']['output'];
};

/** Stripe BalanceTransaction with fee breakdown (admin/organizer only) */
export type StripeBalanceTransactionDetails = {
  __typename?: 'StripeBalanceTransactionDetails';
  /** Gross amount in dollars */
  amount: Scalars['Float']['output'];
  /** When funds are available */
  available_on: Scalars['DateTime']['output'];
  /** Currency code */
  currency: Scalars['String']['output'];
  /** Total fees charged in dollars */
  fee: Scalars['Float']['output'];
  /** Detailed fee breakdown */
  fee_details: Array<FeeDetail>;
  /** BalanceTransaction ID */
  id: Scalars['String']['output'];
  /** Net amount after fees in dollars */
  net: Scalars['Float']['output'];
  /** Type of transaction (charge, refund, etc.) */
  type: Scalars['String']['output'];
};

/** Stripe Connect account with verification status */
export type StripeConnectAccountType = {
  __typename?: 'StripeConnectAccountType';
  /** Whether the account can accept charges */
  chargesEnabled: Scalars['Boolean']['output'];
  /** Whether onboarding details have been submitted */
  detailsSubmitted: Scalars['Boolean']['output'];
  /** Stripe Connect account ID (acct_xxx) */
  id: Scalars['String']['output'];
  /** Whether payouts are enabled (can withdraw to bank) */
  payoutsEnabled: Scalars['Boolean']['output'];
  /** Verification status and requirements */
  verification: ConnectVerificationStatusType;
};

/** Stripe PaymentIntent details fetched on demand */
export type StripePaymentIntentDetails = {
  __typename?: 'StripePaymentIntentDetails';
  /** Amount in dollars */
  amount: Scalars['Float']['output'];
  /** When the PaymentIntent was created */
  created: Scalars['DateTime']['output'];
  /** Currency code (usd, eur, etc.) */
  currency: Scalars['String']['output'];
  /** Customer ID who made the payment */
  customer?: Maybe<Scalars['String']['output']>;
  /** Description of the payment */
  description?: Maybe<Scalars['String']['output']>;
  /** PaymentIntent ID */
  id: Scalars['String']['output'];
  /** Payment method used */
  payment_method?: Maybe<Scalars['String']['output']>;
  /** Payment status (succeeded, requires_action, etc.) */
  status: Scalars['String']['output'];
};

/** Stripe Payout details fetched on demand */
export type StripePayoutDetails = {
  __typename?: 'StripePayoutDetails';
  /** Amount in cents */
  amount: Scalars['Int']['output'];
  /** When funds will arrive */
  arrival_date: Scalars['DateTime']['output'];
  /** When payout was created */
  created: Scalars['DateTime']['output'];
  /** Currency code */
  currency: Scalars['String']['output'];
  /** Failure code if payout failed */
  failure_code?: Maybe<Scalars['String']['output']>;
  /** Failure message if payout failed */
  failure_message?: Maybe<Scalars['String']['output']>;
  /** Payout ID */
  id: Scalars['String']['output'];
  /** Method of payout (standard, instant) */
  method: Scalars['String']['output'];
  /** Statement descriptor on bank statement */
  statement_descriptor?: Maybe<Scalars['String']['output']>;
  /** Payout status from Stripe */
  status: Scalars['String']['output'];
  /** Type of payout (bank_account, card) */
  type: Scalars['String']['output'];
};

/**
 * Student represents a student's instance of a program
 * Each student has their own unique instance that tracks their progress and submissions
 */
export type Student = {
  __typename?: 'Student';
  Access_to_a_Smartphone?: Maybe<Scalars['Boolean']['output']>;
  Adobe?: Maybe<Scalars['Boolean']['output']>;
  Adobe_Illustrator?: Maybe<Scalars['Boolean']['output']>;
  Alan_AI?: Maybe<Scalars['Boolean']['output']>;
  Any_type_of_Video_Editting_Software?: Maybe<Scalars['Boolean']['output']>;
  Any_type_of_spreadsheet?: Maybe<Scalars['Boolean']['output']>;
  Bexi?: Maybe<StudentBexi>;
  Bucket?: Maybe<StudentBucket>;
  Cognixion_Speakprose_app?: Maybe<Scalars['Boolean']['output']>;
  D_design?: Maybe<Scalars['Boolean']['output']>;
  Email?: Maybe<Scalars['Boolean']['output']>;
  Good_oral_and_written_communication_skills?: Maybe<Scalars['Boolean']['output']>;
  Graphic_Design_tools?: Maybe<Scalars['Boolean']['output']>;
  Instagram?: Maybe<Scalars['Boolean']['output']>;
  LinkedIn?: Maybe<Scalars['Boolean']['output']>;
  No?: Maybe<Scalars['Boolean']['output']>;
  None__but_comfort_with_video_editing_could_be_helpful?: Maybe<Scalars['Boolean']['output']>;
  Picterra_platform?: Maybe<Scalars['Boolean']['output']>;
  Picterra_university?: Maybe<Scalars['Boolean']['output']>;
  Python_coding_language?: Maybe<Scalars['Boolean']['output']>;
  Social_Media_experience?: Maybe<Scalars['Boolean']['output']>;
  Trello?: Maybe<Scalars['Boolean']['output']>;
  Website_Design?: Maybe<Scalars['Boolean']['output']>;
  accessSkills?: Maybe<Array<Scalars['String']['output']>>;
  activityNotification?: Maybe<Scalars['Boolean']['output']>;
  /** Student's personal copies of program activities, including their progress and submissions */
  adks?: Maybe<Array<StudentAdks>>;
  airtable?: Maybe<Array<StudentAirtable>>;
  anonymous?: Maybe<Scalars['Boolean']['output']>;
  applicationStatus?: Maybe<Scalars['String']['output']>;
  categories?: Maybe<Array<StudentCategories>>;
  checkoutQualification?: Maybe<StudentCheckoutQualification>;
  claimedSponsorshipDetails?: Maybe<StudentClaimedSponsorshipDetails>;
  /**
   * Multiple data types found: DateTime (Date): 93.8%, BigInt: 6.2% out of 1000 sampled entries
   * When this student instance was created
   */
  created: Scalars['JSON']['output'];
  credentials?: Maybe<Array<StudentCredentials>>;
  deadlineCompletion?: Maybe<Scalars['String']['output']>;
  /** Domain inherited from Program for organization linkage (e.g., "acme.com") */
  domain?: Maybe<Scalars['String']['output']>;
  /**
   * Timestamp of when this student was enrolled AFTER monetization launched.
   * Null for grandfathered (pre-monetization) enrollments — those don't
   * count toward the owning user's plan participant cap. Set on every new
   * enrollment by ProgramBuilderService.bulkEnroll().
   */
  enrolledAt?: Maybe<Scalars['DateTime']['output']>;
  externShip?: Maybe<Scalars['String']['output']>;
  googleDetails?: Maybe<StudentGoogleDetails>;
  google_drive?: Maybe<Scalars['Boolean']['output']>;
  hideCelebrationDialog?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  id__baas_transaction?: Maybe<Scalars['String']['output']>;
  isChennelCreated?: Maybe<Scalars['Boolean']['output']>;
  isContainString?: Maybe<Scalars['Boolean']['output']>;
  isDeliverableAdkCompletedAdded?: Maybe<Scalars['Boolean']['output']>;
  isDeliverableNotExists?: Maybe<Scalars['Boolean']['output']>;
  isLastModifiedAtExists?: Maybe<Scalars['Boolean']['output']>;
  isProgramCheckout?: Maybe<Scalars['Boolean']['output']>;
  isProgramCheckoutBy?: Maybe<Scalars['String']['output']>;
  isProgramTeamNotExists?: Maybe<Scalars['Boolean']['output']>;
  isProgramTeamNotExistsByOwnerOrMember?: Maybe<Scalars['Boolean']['output']>;
  isPublic?: Maybe<Scalars['Boolean']['output']>;
  isResearchProgressAdded?: Maybe<Scalars['Boolean']['output']>;
  isSaveAdkMoleculeAdded?: Maybe<Scalars['Boolean']['output']>;
  isShowTimer?: Maybe<Scalars['Boolean']['output']>;
  isStakeholdersUpdated?: Maybe<Scalars['Boolean']['output']>;
  isStudentSchemaAdded?: Maybe<Scalars['Boolean']['output']>;
  isTeamAdkCompletedAdded?: Maybe<Scalars['Boolean']['output']>;
  isTrainProgressAdded?: Maybe<Scalars['Boolean']['output']>;
  isUniqueFieldIdAdded?: Maybe<Scalars['Boolean']['output']>;
  isUniqueIdAdded?: Maybe<Scalars['Boolean']['output']>;
  isUnsponsoredProgram?: Maybe<Scalars['Boolean']['output']>;
  isUpdateOrg?: Maybe<Scalars['Boolean']['output']>;
  /** Indicates if this is the default instance for the user+program combination */
  is_default?: Maybe<Scalars['Boolean']['output']>;
  /** When this student instance was last modified */
  lastSaved?: Maybe<Scalars['DateTime']['output']>;
  last_clock_in?: Maybe<Scalars['String']['output']>;
  last_clock_out?: Maybe<Scalars['String']['output']>;
  last_synced_at: Scalars['DateTime']['output'];
  microsoft_office?: Maybe<Scalars['Boolean']['output']>;
  navigate_various_workflow_mapping_?: Maybe<Scalars['Boolean']['output']>;
  offerDetails?: Maybe<StudentOfferDetails>;
  /** Reference to the Organization that sponsors this student's program */
  organizationId?: Maybe<Scalars['String']['output']>;
  /** Denormalized organization name for display (inherited from Program) */
  organizationName?: Maybe<Scalars['String']['output']>;
  /** Relation to User (participant) for name lookups */
  participant: User;
  /** Born-Intelligent Programs: 'human' | 'agent' | 'test-agent' — null defaults to 'human' */
  participantType?: Maybe<Scalars['String']['output']>;
  /** Reference to the user account of this student */
  participant_id: Scalars['String']['output'];
  /** Overall completion percentage of the program */
  percentageCompleted?: Maybe<Scalars['Float']['output']>;
  previouslyUnsponsored?: Maybe<Scalars['Boolean']['output']>;
  problemScope?: Maybe<Array<StudentProblemScope>>;
  programName?: Maybe<Scalars['String']['output']>;
  /** Reference to the program this student instance is based on */
  program_id: Scalars['String']['output'];
  /**
   * Multiple data types found: Float: 11.5%, Int: 83.8%, BigInt: 4.6% out of 130 sampled entries
   * Tracks student's progress through the program
   */
  progress?: Maybe<Scalars['JSON']['output']>;
  /**
   * Tracks the sponsor link share code that referred the user to this program
   * Populated when user starts program via a sponsor link, regardless of checkout method
   * Join to SponsorLinks collection for full sponsor details (orgId, orgName, etc.)
   * Separate from claimedSponsorshipDetails which tracks actual sponsor link checkout
   */
  referralShareCode?: Maybe<Scalars['String']['output']>;
  resourceWeb?: Maybe<Scalars['String']['output']>;
  /**
   * Multiple data types found: String: 62.1%, Array(String): 24.4%, Array(StudentRewards): 13.4% out of 454 sampled entries
   * Rewards earned by the student
   */
  rewards?: Maybe<Scalars['JSON']['output']>;
  /** Field referred in an index, but found no data to define the type. */
  role?: Maybe<Scalars['JSON']['output']>;
  schemaJobProgress?: Maybe<Scalars['Boolean']['output']>;
  sharable_url?: Maybe<Scalars['String']['output']>;
  social_media?: Maybe<Scalars['Boolean']['output']>;
  sponsorDetails?: Maybe<StudentSponsorDetails>;
  sponsorRequest_id?: Maybe<Scalars['String']['output']>;
  spreadsheets?: Maybe<Scalars['Boolean']['output']>;
  stakeholders?: Maybe<Array<StudentStakeholders>>;
  studentEthnicity?: Maybe<Array<Scalars['String']['output']>>;
  /** Multiple data types found: String: 35%, Int: 65% out of 40 sampled entries */
  studentLocation?: Maybe<Scalars['JSON']['output']>;
  studentResidence?: Maybe<Scalars['String']['output']>;
  studentSchool?: Maybe<Scalars['String']['output']>;
  this_is_for_testing?: Maybe<Scalars['Boolean']['output']>;
  timerType?: Maybe<Scalars['String']['output']>;
  tokens?: Maybe<Scalars['Int']['output']>;
  unsponsoredAdk?: Maybe<Scalars['String']['output']>;
};

/** Represents a student's personal copy of a program activity */
export type StudentAdks = {
  __typename?: 'StudentAdks';
  acknowledge?: Maybe<Scalars['Boolean']['output']>;
  acknowledgeScope?: Maybe<Scalars['Boolean']['output']>;
  /** When this activity was completed by the student */
  activityEndedOn?: Maybe<Scalars['DateTime']['output']>;
  activityFieldSchema?: Maybe<Scalars['JSON']['output']>;
  activityImage?: Maybe<Scalars['String']['output']>;
  /** When this activity was last modified by the student */
  activityModifiedOn?: Maybe<Scalars['DateTime']['output']>;
  activitySettings?: Maybe<StudentAdksActivitySettings>;
  /**
   * Multiple data types found: String: 77.2%, DateTime (Date): 22.8% out of 1805 sampled entries
   * When the student started this activity
   */
  activityStartedOn?: Maybe<Scalars['JSON']['output']>;
  agentBrief?: Maybe<Scalars['JSON']['output']>;
  agreementInstructions?: Maybe<Scalars['String']['output']>;
  agreementLink?: Maybe<Scalars['String']['output']>;
  airtableRecordId?: Maybe<Scalars['String']['output']>;
  bookmarkedQuestions?: Maybe<Array<Scalars['String']['output']>>;
  buildScope?: Maybe<StudentAdksBuildScope>;
  builderType?: Maybe<Scalars['String']['output']>;
  calendarPreference?: Maybe<Scalars['Boolean']['output']>;
  category?: Maybe<Scalars['String']['output']>;
  /** Multiple data types found: Float: 58.8%, Int: 41.2% out of 17 sampled entries */
  clockAdjustedHours?: Maybe<Scalars['JSON']['output']>;
  clockIn?: Maybe<Scalars['String']['output']>;
  clockOut?: Maybe<Scalars['String']['output']>;
  /**
   * Multiple data types found: String: 45.7%, Float: 1.4%, DateTime (Date): 52.9% out of 4624 sampled entries
   * Whether this activity is completed by the student
   */
  completed?: Maybe<Scalars['JSON']['output']>;
  connection?: Maybe<Scalars['String']['output']>;
  conversationProtocol?: Maybe<Scalars['JSON']['output']>;
  credentials?: Maybe<Array<Scalars['String']['output']>>;
  dailyCoworkingCount?: Maybe<Scalars['Int']['output']>;
  dailyCoworkingLastConnected?: Maybe<Scalars['String']['output']>;
  /** Multiple data types found: Float: 26.7%, Int: 73.3% out of 15 sampled entries */
  dailyCoworkingLastTimestamp?: Maybe<Scalars['JSON']['output']>;
  dailyCoworkingTotalDuration?: Maybe<Scalars['String']['output']>;
  /** Multiple data types found: Float: 6.7%, Int: 93.3% out of 15 sampled entries */
  dailyCoworkingTotalTimestamp?: Maybe<Scalars['JSON']['output']>;
  defaultActivity?: Maybe<StudentAdksDefaultActivity>;
  deliverable?: Maybe<Scalars['String']['output']>;
  deliverableActivity?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  details?: Maybe<StudentAdksDetails>;
  discordEmployerChannel?: Maybe<Scalars['String']['output']>;
  discordEntityType?: Maybe<Scalars['String']['output']>;
  discordIntegraionSkipped?: Maybe<Scalars['Boolean']['output']>;
  dislikedQuestions?: Maybe<Array<Scalars['String']['output']>>;
  employerWebsite?: Maybe<Scalars['String']['output']>;
  endEarlyActivity?: Maybe<Scalars['String']['output']>;
  exitInterviewComplete?: Maybe<Scalars['String']['output']>;
  /** Could not determine type: the field only had null or empty values in the sample set. */
  exitInterviewIncomplete?: Maybe<Scalars['JSON']['output']>;
  /** Student's responses and submissions for this activity */
  fields?: Maybe<Array<StudentAdksFields>>;
  finalPresentationAbsence?: Maybe<Scalars['String']['output']>;
  finalPresentationConfirmation?: Maybe<Scalars['String']['output']>;
  finalPresentationDate?: Maybe<Scalars['String']['output']>;
  /** Could not determine type: the field only had null or empty values in the sample set. */
  flaggedComments?: Maybe<Scalars['JSON']['output']>;
  /** Could not determine type: the field only had null or empty values in the sample set. */
  flaggedQuestions?: Maybe<Scalars['JSON']['output']>;
  groupActivity?: Maybe<Scalars['String']['output']>;
  hasReceivedInternshipEndConfirmation?: Maybe<Scalars['Boolean']['output']>;
  hoursPriorLaunch?: Maybe<Scalars['String']['output']>;
  icon?: Maybe<Scalars['String']['output']>;
  /** Reference to the original activity ID from the program */
  id?: Maybe<Scalars['String']['output']>;
  instruction?: Maybe<StudentAdksInstruction>;
  internshipCompletion?: Maybe<Scalars['Boolean']['output']>;
  interviewReqeust?: Maybe<Scalars['String']['output']>;
  introVideo?: Maybe<Scalars['String']['output']>;
  isAdkAdded?: Maybe<Scalars['Boolean']['output']>;
  isAdkDeleted?: Maybe<Scalars['Boolean']['output']>;
  isBadgesAdded?: Maybe<Scalars['Boolean']['output']>;
  isComplete?: Maybe<Scalars['Boolean']['output']>;
  isFieldEdited?: Maybe<Scalars['Boolean']['output']>;
  isPreview?: Maybe<Scalars['Boolean']['output']>;
  isSaved?: Maybe<Scalars['Boolean']['output']>;
  isSkippable?: Maybe<Scalars['Boolean']['output']>;
  isTeamAdk?: Maybe<Scalars['Boolean']['output']>;
  keyResults?: Maybe<Array<Scalars['String']['output']>>;
  lastInteraction?: Maybe<Scalars['String']['output']>;
  lastInteractionId?: Maybe<Scalars['String']['output']>;
  lastTimestamp?: Maybe<Scalars['Int']['output']>;
  likedComments?: Maybe<Array<Scalars['String']['output']>>;
  likedQuestions?: Maybe<Array<Scalars['String']['output']>>;
  name?: Maybe<Scalars['String']['output']>;
  objectiveKeyResults?: Maybe<Array<Scalars['String']['output']>>;
  optional?: Maybe<Scalars['Boolean']['output']>;
  package?: Maybe<Scalars['String']['output']>;
  participationLevel?: Maybe<Scalars['String']['output']>;
  permissions?: Maybe<Array<StudentAdksPermissions>>;
  pilot?: Maybe<Scalars['String']['output']>;
  position?: Maybe<Scalars['Int']['output']>;
  presetFields?: Maybe<Array<StudentAdksPresetFields>>;
  preview?: Maybe<Scalars['Boolean']['output']>;
  primaryObjective?: Maybe<Scalars['String']['output']>;
  process?: Maybe<Scalars['String']['output']>;
  produce?: Maybe<Scalars['String']['output']>;
  projectScope?: Maybe<Scalars['String']['output']>;
  promote?: Maybe<Scalars['String']['output']>;
  proposal?: Maybe<Scalars['String']['output']>;
  ratingAcknowledgeDeliverablesCompletion?: Maybe<Scalars['Boolean']['output']>;
  ratingAcknowledgeMinHours?: Maybe<Scalars['Boolean']['output']>;
  ratingAcknowledgeSignoff?: Maybe<Scalars['Boolean']['output']>;
  ratingAttendingSocials?: Maybe<Scalars['Int']['output']>;
  ratingCoworkingChange?: Maybe<Scalars['String']['output']>;
  ratingCoworkingMood?: Maybe<Scalars['Int']['output']>;
  ratingEmployerDirection?: Maybe<Scalars['Int']['output']>;
  ratingEmployerWeeklyMeeting?: Maybe<Scalars['Int']['output']>;
  ratingEmployerWorkingRelationship?: Maybe<Scalars['Int']['output']>;
  ratingInPersonSocials?: Maybe<Scalars['Int']['output']>;
  ratingInternshipOverall?: Maybe<Scalars['Int']['output']>;
  ratingNewDeadlineDate?: Maybe<Scalars['String']['output']>;
  ratingNewFriends?: Maybe<Scalars['String']['output']>;
  ratingOneImprovement?: Maybe<Scalars['String']['output']>;
  ratingProjectProgress?: Maybe<Scalars['Int']['output']>;
  ratingVax?: Maybe<Scalars['Boolean']['output']>;
  ratingWeeklyMeetingChange?: Maybe<Scalars['String']['output']>;
  ratingWorkshop?: Maybe<Scalars['Boolean']['output']>;
  ratingWorkshopHelpfulness?: Maybe<Scalars['Int']['output']>;
  referralRep?: Maybe<Scalars['String']['output']>;
  reminder?: Maybe<Scalars['String']['output']>;
  required?: Maybe<Scalars['Boolean']['output']>;
  requiredActivity?: Maybe<Scalars['String']['output']>;
  rewards?: Maybe<Array<Scalars['String']['output']>>;
  rfp?: Maybe<StudentAdksRfp>;
  schoolStartDate2021?: Maybe<Scalars['String']['output']>;
  scope?: Maybe<StudentAdksScope>;
  setupRequired?: Maybe<Scalars['Boolean']['output']>;
  sevenPointInternshipCompletion?: Maybe<Scalars['Boolean']['output']>;
  signOffVideoAskResponse?: Maybe<StudentAdksSignOffVideoAskResponse>;
  /**
   * Multiple data types found: String: 10.4%, Boolean: 89.6% out of 14758 sampled entries
   * Current status of this activity for the student
   */
  status?: Maybe<Scalars['JSON']['output']>;
  styling?: Maybe<StudentAdksStyling>;
  tagId?: Maybe<Scalars['String']['output']>;
  timeTaken?: Maybe<Scalars['Int']['output']>;
  timeToSolveProblem?: Maybe<Scalars['Int']['output']>;
  timesheetDetails?: Maybe<Array<StudentAdksTimesheetDetails>>;
  trainProgress?: Maybe<Array<StudentAdksTrainProgress>>;
  weeklyConferenceLink?: Maybe<Scalars['String']['output']>;
  weeklyMeetingCadence?: Maybe<Scalars['String']['output']>;
  weeklyMeetingDay?: Maybe<Scalars['String']['output']>;
  weeklyMeetingTime?: Maybe<Scalars['String']['output']>;
};

export type StudentAdksActivitySettings = {
  __typename?: 'StudentAdksActivitySettings';
  /** Could not determine type: the field only had null or empty values in the sample set. */
  activityGroups?: Maybe<Scalars['JSON']['output']>;
  activityPlacement?: Maybe<Scalars['String']['output']>;
  activityRequired?: Maybe<Scalars['String']['output']>;
  /** Could not determine type: the field only had null or empty values in the sample set. */
  activityView?: Maybe<Scalars['JSON']['output']>;
  /** Could not determine type: the field only had null or empty values in the sample set. */
  allowToEndProgramEarly?: Maybe<Scalars['JSON']['output']>;
  idealTime?: Maybe<Scalars['String']['output']>;
  instructions?: Maybe<Scalars['String']['output']>;
  isDeliverable?: Maybe<Scalars['String']['output']>;
  /** Could not determine type: the field only had null or empty values in the sample set. */
  makeActivityAccessible?: Maybe<Scalars['JSON']['output']>;
  /** Could not determine type: the field only had null or empty values in the sample set. */
  merits?: Maybe<Scalars['JSON']['output']>;
  mongoDbChart?: Maybe<Scalars['String']['output']>;
  outcomes?: Maybe<Scalars['String']['output']>;
  /** Could not determine type: the field only had null or empty values in the sample set. */
  participantAndTeamData?: Maybe<Scalars['JSON']['output']>;
  /** Could not determine type: the field only had null or empty values in the sample set. */
  postActivityReflection?: Maybe<Scalars['JSON']['output']>;
  /** Could not determine type: the field only had null or empty values in the sample set. */
  presetAndSetup?: Maybe<Scalars['JSON']['output']>;
  /** Could not determine type: the field only had null or empty values in the sample set. */
  programTemplates?: Maybe<Scalars['JSON']['output']>;
  reminder?: Maybe<Scalars['String']['output']>;
  requirements?: Maybe<Array<Scalars['String']['output']>>;
  /** Could not determine type: the field only had null or empty values in the sample set. */
  resourceTypes?: Maybe<Scalars['JSON']['output']>;
  timeInForCountDown?: Maybe<Scalars['String']['output']>;
  /** Could not determine type: the field only had null or empty values in the sample set. */
  typeOfCharts?: Maybe<Scalars['JSON']['output']>;
};

export type StudentAdksActivitySettingsCreateInput = {
  activityGroups?: InputMaybe<Scalars['JSON']['input']>;
  activityPlacement?: InputMaybe<Scalars['String']['input']>;
  activityRequired?: InputMaybe<Scalars['String']['input']>;
  activityView?: InputMaybe<Scalars['JSON']['input']>;
  allowToEndProgramEarly?: InputMaybe<Scalars['JSON']['input']>;
  idealTime?: InputMaybe<Scalars['String']['input']>;
  instructions?: InputMaybe<Scalars['String']['input']>;
  isDeliverable?: InputMaybe<Scalars['String']['input']>;
  makeActivityAccessible?: InputMaybe<Scalars['JSON']['input']>;
  merits?: InputMaybe<Scalars['JSON']['input']>;
  mongoDbChart?: InputMaybe<Scalars['String']['input']>;
  outcomes?: InputMaybe<Scalars['String']['input']>;
  participantAndTeamData?: InputMaybe<Scalars['JSON']['input']>;
  postActivityReflection?: InputMaybe<Scalars['JSON']['input']>;
  presetAndSetup?: InputMaybe<Scalars['JSON']['input']>;
  programTemplates?: InputMaybe<Scalars['JSON']['input']>;
  reminder?: InputMaybe<Scalars['String']['input']>;
  requirements?: InputMaybe<StudentAdksActivitySettingsCreaterequirementsInput>;
  resourceTypes?: InputMaybe<Scalars['JSON']['input']>;
  timeInForCountDown?: InputMaybe<Scalars['String']['input']>;
  typeOfCharts?: InputMaybe<Scalars['JSON']['input']>;
};

export type StudentAdksActivitySettingsCreaterequirementsInput = {
  set: Array<Scalars['String']['input']>;
};

export type StudentAdksActivitySettingsObjectEqualityInput = {
  activityGroups?: InputMaybe<Scalars['JSON']['input']>;
  activityPlacement?: InputMaybe<Scalars['String']['input']>;
  activityRequired?: InputMaybe<Scalars['String']['input']>;
  activityView?: InputMaybe<Scalars['JSON']['input']>;
  allowToEndProgramEarly?: InputMaybe<Scalars['JSON']['input']>;
  idealTime?: InputMaybe<Scalars['String']['input']>;
  instructions?: InputMaybe<Scalars['String']['input']>;
  isDeliverable?: InputMaybe<Scalars['String']['input']>;
  makeActivityAccessible?: InputMaybe<Scalars['JSON']['input']>;
  merits?: InputMaybe<Scalars['JSON']['input']>;
  mongoDbChart?: InputMaybe<Scalars['String']['input']>;
  outcomes?: InputMaybe<Scalars['String']['input']>;
  participantAndTeamData?: InputMaybe<Scalars['JSON']['input']>;
  postActivityReflection?: InputMaybe<Scalars['JSON']['input']>;
  presetAndSetup?: InputMaybe<Scalars['JSON']['input']>;
  programTemplates?: InputMaybe<Scalars['JSON']['input']>;
  reminder?: InputMaybe<Scalars['String']['input']>;
  requirements?: InputMaybe<Array<Scalars['String']['input']>>;
  resourceTypes?: InputMaybe<Scalars['JSON']['input']>;
  timeInForCountDown?: InputMaybe<Scalars['String']['input']>;
  typeOfCharts?: InputMaybe<Scalars['JSON']['input']>;
};

export type StudentAdksBuildScope = {
  __typename?: 'StudentAdksBuildScope';
  objectives?: Maybe<Array<StudentAdksBuildScopeObjectives>>;
  projects?: Maybe<Array<StudentAdksBuildScopeProjects>>;
};

export type StudentAdksBuildScopeCreateInput = {
  objectives?: InputMaybe<Array<StudentAdksBuildScopeObjectivesCreateInput>>;
  projects?: InputMaybe<Array<StudentAdksBuildScopeProjectsCreateInput>>;
};

export type StudentAdksBuildScopeObjectEqualityInput = {
  objectives?: InputMaybe<Array<StudentAdksBuildScopeObjectivesObjectEqualityInput>>;
  projects?: InputMaybe<Array<StudentAdksBuildScopeProjectsObjectEqualityInput>>;
};

export type StudentAdksBuildScopeObjectives = {
  __typename?: 'StudentAdksBuildScopeObjectives';
  action?: Maybe<Scalars['String']['output']>;
  icon?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  position: Scalars['Int']['output'];
  roles?: Maybe<Array<Scalars['String']['output']>>;
  /** Could not determine type: the field only had null or empty values in the sample set. */
  rules?: Maybe<Scalars['JSON']['output']>;
  styling?: Maybe<StudentAdksBuildScopeObjectivesStyling>;
  target?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
};

export type StudentAdksBuildScopeObjectivesCreateInput = {
  action?: InputMaybe<Scalars['String']['input']>;
  icon?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  position: Scalars['Int']['input'];
  roles?: InputMaybe<StudentAdksBuildScopeObjectivesCreaterolesInput>;
  rules?: InputMaybe<Scalars['JSON']['input']>;
  styling?: InputMaybe<StudentAdksBuildScopeObjectivesStylingCreateInput>;
  target?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  type: Scalars['String']['input'];
};

export type StudentAdksBuildScopeObjectivesCreaterolesInput = {
  set: Array<Scalars['String']['input']>;
};

export type StudentAdksBuildScopeObjectivesObjectEqualityInput = {
  action?: InputMaybe<Scalars['String']['input']>;
  icon?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  position: Scalars['Int']['input'];
  roles?: InputMaybe<Array<Scalars['String']['input']>>;
  rules?: InputMaybe<Scalars['JSON']['input']>;
  styling?: InputMaybe<StudentAdksBuildScopeObjectivesStylingObjectEqualityInput>;
  target?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  type: Scalars['String']['input'];
};

export type StudentAdksBuildScopeObjectivesStyling = {
  __typename?: 'StudentAdksBuildScopeObjectivesStyling';
  depressed?: Maybe<Scalars['Boolean']['output']>;
  hint?: Maybe<Scalars['String']['output']>;
  icon?: Maybe<Scalars['String']['output']>;
  label: Scalars['String']['output'];
  leftIcon?: Maybe<Scalars['String']['output']>;
  outlined: Scalars['Boolean']['output'];
  placeholder?: Maybe<Scalars['String']['output']>;
  rightIcon?: Maybe<Scalars['String']['output']>;
  rounded: Scalars['Boolean']['output'];
  small?: Maybe<Scalars['Boolean']['output']>;
};

export type StudentAdksBuildScopeObjectivesStylingCreateInput = {
  depressed?: InputMaybe<Scalars['Boolean']['input']>;
  hint?: InputMaybe<Scalars['String']['input']>;
  icon?: InputMaybe<Scalars['String']['input']>;
  label: Scalars['String']['input'];
  leftIcon?: InputMaybe<Scalars['String']['input']>;
  outlined: Scalars['Boolean']['input'];
  placeholder?: InputMaybe<Scalars['String']['input']>;
  rightIcon?: InputMaybe<Scalars['String']['input']>;
  rounded: Scalars['Boolean']['input'];
  small?: InputMaybe<Scalars['Boolean']['input']>;
};

export type StudentAdksBuildScopeObjectivesStylingObjectEqualityInput = {
  depressed?: InputMaybe<Scalars['Boolean']['input']>;
  hint?: InputMaybe<Scalars['String']['input']>;
  icon?: InputMaybe<Scalars['String']['input']>;
  label: Scalars['String']['input'];
  leftIcon?: InputMaybe<Scalars['String']['input']>;
  outlined: Scalars['Boolean']['input'];
  placeholder?: InputMaybe<Scalars['String']['input']>;
  rightIcon?: InputMaybe<Scalars['String']['input']>;
  rounded: Scalars['Boolean']['input'];
  small?: InputMaybe<Scalars['Boolean']['input']>;
};

export type StudentAdksBuildScopeProjects = {
  __typename?: 'StudentAdksBuildScopeProjects';
  action?: Maybe<Scalars['String']['output']>;
  icon?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  position: Scalars['Int']['output'];
  roles?: Maybe<Array<Scalars['String']['output']>>;
  styling?: Maybe<StudentAdksBuildScopeProjectsStyling>;
  target?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
};

export type StudentAdksBuildScopeProjectsCreateInput = {
  action?: InputMaybe<Scalars['String']['input']>;
  icon?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  position: Scalars['Int']['input'];
  roles?: InputMaybe<StudentAdksBuildScopeProjectsCreaterolesInput>;
  styling?: InputMaybe<StudentAdksBuildScopeProjectsStylingCreateInput>;
  target?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  type: Scalars['String']['input'];
};

export type StudentAdksBuildScopeProjectsCreaterolesInput = {
  set: Array<Scalars['String']['input']>;
};

export type StudentAdksBuildScopeProjectsObjectEqualityInput = {
  action?: InputMaybe<Scalars['String']['input']>;
  icon?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  position: Scalars['Int']['input'];
  roles?: InputMaybe<Array<Scalars['String']['input']>>;
  styling?: InputMaybe<StudentAdksBuildScopeProjectsStylingObjectEqualityInput>;
  target?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  type: Scalars['String']['input'];
};

export type StudentAdksBuildScopeProjectsStyling = {
  __typename?: 'StudentAdksBuildScopeProjectsStyling';
  color: Scalars['String']['output'];
  depressed: Scalars['Boolean']['output'];
  label: Scalars['String']['output'];
  leftIcon: Scalars['String']['output'];
  rounded: Scalars['Boolean']['output'];
};

export type StudentAdksBuildScopeProjectsStylingCreateInput = {
  color: Scalars['String']['input'];
  depressed: Scalars['Boolean']['input'];
  label: Scalars['String']['input'];
  leftIcon: Scalars['String']['input'];
  rounded: Scalars['Boolean']['input'];
};

export type StudentAdksBuildScopeProjectsStylingObjectEqualityInput = {
  color: Scalars['String']['input'];
  depressed: Scalars['Boolean']['input'];
  label: Scalars['String']['input'];
  leftIcon: Scalars['String']['input'];
  rounded: Scalars['Boolean']['input'];
};

export type StudentAdksCreateInput = {
  acknowledge?: InputMaybe<Scalars['Boolean']['input']>;
  acknowledgeScope?: InputMaybe<Scalars['Boolean']['input']>;
  activityEndedOn?: InputMaybe<Scalars['DateTime']['input']>;
  activityFieldSchema?: InputMaybe<Scalars['JSON']['input']>;
  activityImage?: InputMaybe<Scalars['String']['input']>;
  activityModifiedOn?: InputMaybe<Scalars['DateTime']['input']>;
  activitySettings?: InputMaybe<StudentAdksActivitySettingsCreateInput>;
  activityStartedOn?: InputMaybe<Scalars['JSON']['input']>;
  agentBrief?: InputMaybe<Scalars['JSON']['input']>;
  agreementInstructions?: InputMaybe<Scalars['String']['input']>;
  agreementLink?: InputMaybe<Scalars['String']['input']>;
  airtableRecordId?: InputMaybe<Scalars['String']['input']>;
  bookmarkedQuestions?: InputMaybe<StudentAdksCreatebookmarkedQuestionsInput>;
  buildScope?: InputMaybe<StudentAdksBuildScopeCreateInput>;
  builderType?: InputMaybe<Scalars['String']['input']>;
  calendarPreference?: InputMaybe<Scalars['Boolean']['input']>;
  category?: InputMaybe<Scalars['String']['input']>;
  clockAdjustedHours?: InputMaybe<Scalars['JSON']['input']>;
  clockIn?: InputMaybe<Scalars['String']['input']>;
  clockOut?: InputMaybe<Scalars['String']['input']>;
  completed?: InputMaybe<Scalars['JSON']['input']>;
  connection?: InputMaybe<Scalars['String']['input']>;
  conversationProtocol?: InputMaybe<Scalars['JSON']['input']>;
  credentials?: InputMaybe<StudentAdksCreatecredentialsInput>;
  dailyCoworkingCount?: InputMaybe<Scalars['Int']['input']>;
  dailyCoworkingLastConnected?: InputMaybe<Scalars['String']['input']>;
  dailyCoworkingLastTimestamp?: InputMaybe<Scalars['JSON']['input']>;
  dailyCoworkingTotalDuration?: InputMaybe<Scalars['String']['input']>;
  dailyCoworkingTotalTimestamp?: InputMaybe<Scalars['JSON']['input']>;
  defaultActivity?: InputMaybe<StudentAdksDefaultActivityCreateInput>;
  deliverable?: InputMaybe<Scalars['String']['input']>;
  deliverableActivity?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  details?: InputMaybe<StudentAdksDetailsCreateInput>;
  discordEmployerChannel?: InputMaybe<Scalars['String']['input']>;
  discordEntityType?: InputMaybe<Scalars['String']['input']>;
  discordIntegraionSkipped?: InputMaybe<Scalars['Boolean']['input']>;
  dislikedQuestions?: InputMaybe<StudentAdksCreatedislikedQuestionsInput>;
  employerWebsite?: InputMaybe<Scalars['String']['input']>;
  endEarlyActivity?: InputMaybe<Scalars['String']['input']>;
  exitInterviewComplete?: InputMaybe<Scalars['String']['input']>;
  exitInterviewIncomplete?: InputMaybe<Scalars['JSON']['input']>;
  fields?: InputMaybe<Array<StudentAdksFieldsCreateInput>>;
  finalPresentationAbsence?: InputMaybe<Scalars['String']['input']>;
  finalPresentationConfirmation?: InputMaybe<Scalars['String']['input']>;
  finalPresentationDate?: InputMaybe<Scalars['String']['input']>;
  flaggedComments?: InputMaybe<Scalars['JSON']['input']>;
  flaggedQuestions?: InputMaybe<Scalars['JSON']['input']>;
  groupActivity?: InputMaybe<Scalars['String']['input']>;
  hasReceivedInternshipEndConfirmation?: InputMaybe<Scalars['Boolean']['input']>;
  hoursPriorLaunch?: InputMaybe<Scalars['String']['input']>;
  icon?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  instruction?: InputMaybe<StudentAdksInstructionCreateInput>;
  internshipCompletion?: InputMaybe<Scalars['Boolean']['input']>;
  interviewReqeust?: InputMaybe<Scalars['String']['input']>;
  introVideo?: InputMaybe<Scalars['String']['input']>;
  isAdkAdded?: InputMaybe<Scalars['Boolean']['input']>;
  isAdkDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  isBadgesAdded?: InputMaybe<Scalars['Boolean']['input']>;
  isComplete?: InputMaybe<Scalars['Boolean']['input']>;
  isFieldEdited?: InputMaybe<Scalars['Boolean']['input']>;
  isPreview?: InputMaybe<Scalars['Boolean']['input']>;
  isSaved?: InputMaybe<Scalars['Boolean']['input']>;
  isSkippable?: InputMaybe<Scalars['Boolean']['input']>;
  isTeamAdk?: InputMaybe<Scalars['Boolean']['input']>;
  keyResults?: InputMaybe<StudentAdksCreatekeyResultsInput>;
  lastInteraction?: InputMaybe<Scalars['String']['input']>;
  lastInteractionId?: InputMaybe<Scalars['String']['input']>;
  lastTimestamp?: InputMaybe<Scalars['Int']['input']>;
  likedComments?: InputMaybe<StudentAdksCreatelikedCommentsInput>;
  likedQuestions?: InputMaybe<StudentAdksCreatelikedQuestionsInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  objectiveKeyResults?: InputMaybe<StudentAdksCreateobjectiveKeyResultsInput>;
  optional?: InputMaybe<Scalars['Boolean']['input']>;
  package?: InputMaybe<Scalars['String']['input']>;
  participationLevel?: InputMaybe<Scalars['String']['input']>;
  permissions?: InputMaybe<Array<StudentAdksPermissionsCreateInput>>;
  pilot?: InputMaybe<Scalars['String']['input']>;
  position?: InputMaybe<Scalars['Int']['input']>;
  presetFields?: InputMaybe<Array<StudentAdksPresetFieldsCreateInput>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  primaryObjective?: InputMaybe<Scalars['String']['input']>;
  process?: InputMaybe<Scalars['String']['input']>;
  produce?: InputMaybe<Scalars['String']['input']>;
  projectScope?: InputMaybe<Scalars['String']['input']>;
  promote?: InputMaybe<Scalars['String']['input']>;
  proposal?: InputMaybe<Scalars['String']['input']>;
  ratingAcknowledgeDeliverablesCompletion?: InputMaybe<Scalars['Boolean']['input']>;
  ratingAcknowledgeMinHours?: InputMaybe<Scalars['Boolean']['input']>;
  ratingAcknowledgeSignoff?: InputMaybe<Scalars['Boolean']['input']>;
  ratingAttendingSocials?: InputMaybe<Scalars['Int']['input']>;
  ratingCoworkingChange?: InputMaybe<Scalars['String']['input']>;
  ratingCoworkingMood?: InputMaybe<Scalars['Int']['input']>;
  ratingEmployerDirection?: InputMaybe<Scalars['Int']['input']>;
  ratingEmployerWeeklyMeeting?: InputMaybe<Scalars['Int']['input']>;
  ratingEmployerWorkingRelationship?: InputMaybe<Scalars['Int']['input']>;
  ratingInPersonSocials?: InputMaybe<Scalars['Int']['input']>;
  ratingInternshipOverall?: InputMaybe<Scalars['Int']['input']>;
  ratingNewDeadlineDate?: InputMaybe<Scalars['String']['input']>;
  ratingNewFriends?: InputMaybe<Scalars['String']['input']>;
  ratingOneImprovement?: InputMaybe<Scalars['String']['input']>;
  ratingProjectProgress?: InputMaybe<Scalars['Int']['input']>;
  ratingVax?: InputMaybe<Scalars['Boolean']['input']>;
  ratingWeeklyMeetingChange?: InputMaybe<Scalars['String']['input']>;
  ratingWorkshop?: InputMaybe<Scalars['Boolean']['input']>;
  ratingWorkshopHelpfulness?: InputMaybe<Scalars['Int']['input']>;
  referralRep?: InputMaybe<Scalars['String']['input']>;
  reminder?: InputMaybe<Scalars['String']['input']>;
  required?: InputMaybe<Scalars['Boolean']['input']>;
  requiredActivity?: InputMaybe<Scalars['String']['input']>;
  rewards?: InputMaybe<StudentAdksCreaterewardsInput>;
  rfp?: InputMaybe<StudentAdksRfpCreateInput>;
  schoolStartDate2021?: InputMaybe<Scalars['String']['input']>;
  scope?: InputMaybe<StudentAdksScopeCreateInput>;
  setupRequired?: InputMaybe<Scalars['Boolean']['input']>;
  sevenPointInternshipCompletion?: InputMaybe<Scalars['Boolean']['input']>;
  signOffVideoAskResponse?: InputMaybe<StudentAdksSignOffVideoAskResponseCreateInput>;
  status?: InputMaybe<Scalars['JSON']['input']>;
  styling?: InputMaybe<StudentAdksStylingCreateInput>;
  tagId?: InputMaybe<Scalars['String']['input']>;
  timeTaken?: InputMaybe<Scalars['Int']['input']>;
  timeToSolveProblem?: InputMaybe<Scalars['Int']['input']>;
  timesheetDetails?: InputMaybe<Array<StudentAdksTimesheetDetailsCreateInput>>;
  trainProgress?: InputMaybe<Array<StudentAdksTrainProgressCreateInput>>;
  weeklyConferenceLink?: InputMaybe<Scalars['String']['input']>;
  weeklyMeetingCadence?: InputMaybe<Scalars['String']['input']>;
  weeklyMeetingDay?: InputMaybe<Scalars['String']['input']>;
  weeklyMeetingTime?: InputMaybe<Scalars['String']['input']>;
};

export type StudentAdksCreatebookmarkedQuestionsInput = {
  set: Array<Scalars['String']['input']>;
};

export type StudentAdksCreatecredentialsInput = {
  set: Array<Scalars['String']['input']>;
};

export type StudentAdksCreatedislikedQuestionsInput = {
  set: Array<Scalars['String']['input']>;
};

export type StudentAdksCreatekeyResultsInput = {
  set: Array<Scalars['String']['input']>;
};

export type StudentAdksCreatelikedCommentsInput = {
  set: Array<Scalars['String']['input']>;
};

export type StudentAdksCreatelikedQuestionsInput = {
  set: Array<Scalars['String']['input']>;
};

export type StudentAdksCreateobjectiveKeyResultsInput = {
  set: Array<Scalars['String']['input']>;
};

export type StudentAdksCreaterewardsInput = {
  set: Array<Scalars['String']['input']>;
};

export type StudentAdksDefaultActivity = {
  __typename?: 'StudentAdksDefaultActivity';
  deliverableActivity: Scalars['String']['output'];
  endEarlyActivity: Scalars['String']['output'];
  groupActivity: Scalars['String']['output'];
  required: Scalars['Boolean']['output'];
  requiredActivity: Scalars['String']['output'];
};

export type StudentAdksDefaultActivityCreateInput = {
  deliverableActivity: Scalars['String']['input'];
  endEarlyActivity: Scalars['String']['input'];
  groupActivity: Scalars['String']['input'];
  required: Scalars['Boolean']['input'];
  requiredActivity: Scalars['String']['input'];
};

export type StudentAdksDefaultActivityObjectEqualityInput = {
  deliverableActivity: Scalars['String']['input'];
  endEarlyActivity: Scalars['String']['input'];
  groupActivity: Scalars['String']['input'];
  required: Scalars['Boolean']['input'];
  requiredActivity: Scalars['String']['input'];
};

export type StudentAdksDetails = {
  __typename?: 'StudentAdksDetails';
  ratings?: Maybe<Array<StudentAdksDetailsRatings>>;
  remarks?: Maybe<Scalars['String']['output']>;
  signOffDetails: StudentAdksDetailsSignOffDetails;
  terminationReason?: Maybe<Scalars['String']['output']>;
  totalHrsSpent: Scalars['String']['output'];
};

export type StudentAdksDetailsCreateInput = {
  ratings?: InputMaybe<Array<StudentAdksDetailsRatingsCreateInput>>;
  remarks?: InputMaybe<Scalars['String']['input']>;
  signOffDetails: StudentAdksDetailsSignOffDetailsCreateInput;
  terminationReason?: InputMaybe<Scalars['String']['input']>;
  totalHrsSpent: Scalars['String']['input'];
};

export type StudentAdksDetailsObjectEqualityInput = {
  ratings?: InputMaybe<Array<StudentAdksDetailsRatingsObjectEqualityInput>>;
  remarks?: InputMaybe<Scalars['String']['input']>;
  signOffDetails: StudentAdksDetailsSignOffDetailsObjectEqualityInput;
  terminationReason?: InputMaybe<Scalars['String']['input']>;
  totalHrsSpent: Scalars['String']['input'];
};

export type StudentAdksDetailsRatings = {
  __typename?: 'StudentAdksDetailsRatings';
  label: Scalars['String']['output'];
  value: Scalars['Int']['output'];
};

export type StudentAdksDetailsRatingsCreateInput = {
  label: Scalars['String']['input'];
  value: Scalars['Int']['input'];
};

export type StudentAdksDetailsRatingsObjectEqualityInput = {
  label: Scalars['String']['input'];
  value: Scalars['Int']['input'];
};

export type StudentAdksDetailsSignOffDetails = {
  __typename?: 'StudentAdksDetailsSignOffDetails';
  acceptanceDeadline: Scalars['String']['output'];
  compensation: Scalars['String']['output'];
  continuation: Scalars['Boolean']['output'];
  customCompensation: Scalars['Boolean']['output'];
  customInternshipProject: Scalars['Boolean']['output'];
  customPosition: Scalars['Boolean']['output'];
  employerRecord: Scalars['Boolean']['output'];
  internshipEnd: Scalars['String']['output'];
  internshipProject: Scalars['String']['output'];
  internshipStart: Scalars['String']['output'];
  isInternshipCompleted?: Maybe<Scalars['Boolean']['output']>;
  licenseRequirement: Scalars['Boolean']['output'];
  maxHours: Scalars['Int']['output'];
  minHours: Scalars['Int']['output'];
  position: Scalars['String']['output'];
  signoffRequestedBy?: Maybe<Scalars['String']['output']>;
  signoffRequestedDate?: Maybe<Scalars['DateTime']['output']>;
};

export type StudentAdksDetailsSignOffDetailsCreateInput = {
  acceptanceDeadline: Scalars['String']['input'];
  compensation: Scalars['String']['input'];
  continuation: Scalars['Boolean']['input'];
  customCompensation: Scalars['Boolean']['input'];
  customInternshipProject: Scalars['Boolean']['input'];
  customPosition: Scalars['Boolean']['input'];
  employerRecord: Scalars['Boolean']['input'];
  internshipEnd: Scalars['String']['input'];
  internshipProject: Scalars['String']['input'];
  internshipStart: Scalars['String']['input'];
  isInternshipCompleted?: InputMaybe<Scalars['Boolean']['input']>;
  licenseRequirement: Scalars['Boolean']['input'];
  maxHours: Scalars['Int']['input'];
  minHours: Scalars['Int']['input'];
  position: Scalars['String']['input'];
  signoffRequestedBy?: InputMaybe<Scalars['String']['input']>;
  signoffRequestedDate?: InputMaybe<Scalars['DateTime']['input']>;
};

export type StudentAdksDetailsSignOffDetailsObjectEqualityInput = {
  acceptanceDeadline: Scalars['String']['input'];
  compensation: Scalars['String']['input'];
  continuation: Scalars['Boolean']['input'];
  customCompensation: Scalars['Boolean']['input'];
  customInternshipProject: Scalars['Boolean']['input'];
  customPosition: Scalars['Boolean']['input'];
  employerRecord: Scalars['Boolean']['input'];
  internshipEnd: Scalars['String']['input'];
  internshipProject: Scalars['String']['input'];
  internshipStart: Scalars['String']['input'];
  isInternshipCompleted?: InputMaybe<Scalars['Boolean']['input']>;
  licenseRequirement: Scalars['Boolean']['input'];
  maxHours: Scalars['Int']['input'];
  minHours: Scalars['Int']['input'];
  position: Scalars['String']['input'];
  signoffRequestedBy?: InputMaybe<Scalars['String']['input']>;
  signoffRequestedDate?: InputMaybe<Scalars['DateTime']['input']>;
};

export type StudentAdksFields = {
  __typename?: 'StudentAdksFields';
  action?: Maybe<Scalars['String']['output']>;
  active?: Maybe<Scalars['Boolean']['output']>;
  addButtonLabel?: Maybe<Scalars['String']['output']>;
  adk?: Maybe<Scalars['String']['output']>;
  ages?: Maybe<Scalars['String']['output']>;
  align?: Maybe<Scalars['String']['output']>;
  blank?: Maybe<Scalars['Boolean']['output']>;
  builderType?: Maybe<Scalars['String']['output']>;
  color?: Maybe<Scalars['String']['output']>;
  compiledAt?: Maybe<Scalars['String']['output']>;
  customWidgetDescription?: Maybe<Scalars['String']['output']>;
  dark?: Maybe<Scalars['Boolean']['output']>;
  /** Multiple data types found: String: 21.6%, Boolean: 47.5%, Int: 30.9% out of 21638 sampled entries */
  defaultValue?: Maybe<Scalars['JSON']['output']>;
  /** Multiple data types found: String: 27.4%, StudentAdksFieldsEvent: 72.6% out of 2707 sampled entries */
  event?: Maybe<Scalars['JSON']['output']>;
  header?: Maybe<Scalars['String']['output']>;
  href?: Maybe<Scalars['String']['output']>;
  icon?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  intelligence?: Maybe<Scalars['JSON']['output']>;
  isCustomWidget?: Maybe<Scalars['Boolean']['output']>;
  isFieldEdited?: Maybe<Scalars['Boolean']['output']>;
  /** Multiple data types found: Array(String): 55.3%, Array(Int): 44.7% out of 9977 sampled entries */
  items?: Maybe<Scalars['JSON']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  linkLabel?: Maybe<Scalars['String']['output']>;
  link_type?: Maybe<Scalars['String']['output']>;
  max?: Maybe<Scalars['String']['output']>;
  maxDate?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  min?: Maybe<Scalars['String']['output']>;
  minDate?: Maybe<Scalars['String']['output']>;
  model?: Maybe<Scalars['String']['output']>;
  modelItems?: Maybe<Array<StudentAdksFieldsModelItems>>;
  multiple?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  noSetup?: Maybe<Scalars['Boolean']['output']>;
  outlined?: Maybe<Scalars['Boolean']['output']>;
  placeholder?: Maybe<Scalars['String']['output']>;
  position?: Maybe<Scalars['Int']['output']>;
  preset?: Maybe<StudentAdksFieldsPreset>;
  radioButtons?: Maybe<Array<StudentAdksFieldsRadioButtons>>;
  required?: Maybe<Scalars['Boolean']['output']>;
  roles?: Maybe<Array<Scalars['String']['output']>>;
  rounded?: Maybe<Scalars['Boolean']['output']>;
  rules?: Maybe<Array<Scalars['String']['output']>>;
  searchInput?: Maybe<Scalars['String']['output']>;
  searchType?: Maybe<Scalars['String']['output']>;
  setup?: Maybe<StudentAdksFieldsSetup>;
  styling?: Maybe<StudentAdksFieldsStyling>;
  subTitle?: Maybe<Scalars['String']['output']>;
  target?: Maybe<Scalars['String']['output']>;
  tickSize?: Maybe<Scalars['Int']['output']>;
  ticks?: Maybe<Scalars['Boolean']['output']>;
  timelineItems?: Maybe<Array<StudentAdksFieldsTimelineItems>>;
  title?: Maybe<Scalars['String']['output']>;
  titleAfterChip?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  vChipContent?: Maybe<Scalars['String']['output']>;
  value?: Maybe<StudentAdksFieldsValue>;
  videoAskLabel?: Maybe<Scalars['String']['output']>;
  videoAskUrl?: Maybe<Scalars['String']['output']>;
  videoName?: Maybe<Scalars['String']['output']>;
  widgetSource?: Maybe<Scalars['String']['output']>;
  widgetUrl?: Maybe<Scalars['String']['output']>;
  widgetVersion?: Maybe<Scalars['Int']['output']>;
};

export type StudentAdksFieldsCreateInput = {
  action?: InputMaybe<Scalars['String']['input']>;
  active?: InputMaybe<Scalars['Boolean']['input']>;
  addButtonLabel?: InputMaybe<Scalars['String']['input']>;
  adk?: InputMaybe<Scalars['String']['input']>;
  ages?: InputMaybe<Scalars['String']['input']>;
  align?: InputMaybe<Scalars['String']['input']>;
  blank?: InputMaybe<Scalars['Boolean']['input']>;
  builderType?: InputMaybe<Scalars['String']['input']>;
  color?: InputMaybe<Scalars['String']['input']>;
  compiledAt?: InputMaybe<Scalars['String']['input']>;
  customWidgetDescription?: InputMaybe<Scalars['String']['input']>;
  dark?: InputMaybe<Scalars['Boolean']['input']>;
  defaultValue?: InputMaybe<Scalars['JSON']['input']>;
  event?: InputMaybe<Scalars['JSON']['input']>;
  header?: InputMaybe<Scalars['String']['input']>;
  href?: InputMaybe<Scalars['String']['input']>;
  icon?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  intelligence?: InputMaybe<Scalars['JSON']['input']>;
  isCustomWidget?: InputMaybe<Scalars['Boolean']['input']>;
  isFieldEdited?: InputMaybe<Scalars['Boolean']['input']>;
  items?: InputMaybe<Scalars['JSON']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  linkLabel?: InputMaybe<Scalars['String']['input']>;
  link_type?: InputMaybe<Scalars['String']['input']>;
  max?: InputMaybe<Scalars['String']['input']>;
  maxDate?: InputMaybe<Scalars['String']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  min?: InputMaybe<Scalars['String']['input']>;
  minDate?: InputMaybe<Scalars['String']['input']>;
  model?: InputMaybe<Scalars['String']['input']>;
  modelItems?: InputMaybe<Array<StudentAdksFieldsModelItemsCreateInput>>;
  multiple?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  noSetup?: InputMaybe<Scalars['Boolean']['input']>;
  outlined?: InputMaybe<Scalars['Boolean']['input']>;
  placeholder?: InputMaybe<Scalars['String']['input']>;
  position?: InputMaybe<Scalars['Int']['input']>;
  preset?: InputMaybe<StudentAdksFieldsPresetCreateInput>;
  radioButtons?: InputMaybe<Array<StudentAdksFieldsRadioButtonsCreateInput>>;
  required?: InputMaybe<Scalars['Boolean']['input']>;
  roles?: InputMaybe<StudentAdksFieldsCreaterolesInput>;
  rounded?: InputMaybe<Scalars['Boolean']['input']>;
  rules?: InputMaybe<StudentAdksFieldsCreaterulesInput>;
  searchInput?: InputMaybe<Scalars['String']['input']>;
  searchType?: InputMaybe<Scalars['String']['input']>;
  setup?: InputMaybe<StudentAdksFieldsSetupCreateInput>;
  styling?: InputMaybe<StudentAdksFieldsStylingCreateInput>;
  subTitle?: InputMaybe<Scalars['String']['input']>;
  target?: InputMaybe<Scalars['String']['input']>;
  tickSize?: InputMaybe<Scalars['Int']['input']>;
  ticks?: InputMaybe<Scalars['Boolean']['input']>;
  timelineItems?: InputMaybe<Array<StudentAdksFieldsTimelineItemsCreateInput>>;
  title?: InputMaybe<Scalars['String']['input']>;
  titleAfterChip?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  vChipContent?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<StudentAdksFieldsValueCreateInput>;
  videoAskLabel?: InputMaybe<Scalars['String']['input']>;
  videoAskUrl?: InputMaybe<Scalars['String']['input']>;
  videoName?: InputMaybe<Scalars['String']['input']>;
  widgetSource?: InputMaybe<Scalars['String']['input']>;
  widgetUrl?: InputMaybe<Scalars['String']['input']>;
  widgetVersion?: InputMaybe<Scalars['Int']['input']>;
};

export type StudentAdksFieldsCreaterolesInput = {
  set: Array<Scalars['String']['input']>;
};

export type StudentAdksFieldsCreaterulesInput = {
  set: Array<Scalars['String']['input']>;
};

export type StudentAdksFieldsModelItems = {
  __typename?: 'StudentAdksFieldsModelItems';
  name: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type StudentAdksFieldsModelItemsCreateInput = {
  name: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export type StudentAdksFieldsModelItemsObjectEqualityInput = {
  name: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export type StudentAdksFieldsObjectEqualityInput = {
  action?: InputMaybe<Scalars['String']['input']>;
  active?: InputMaybe<Scalars['Boolean']['input']>;
  addButtonLabel?: InputMaybe<Scalars['String']['input']>;
  adk?: InputMaybe<Scalars['String']['input']>;
  ages?: InputMaybe<Scalars['String']['input']>;
  align?: InputMaybe<Scalars['String']['input']>;
  blank?: InputMaybe<Scalars['Boolean']['input']>;
  builderType?: InputMaybe<Scalars['String']['input']>;
  color?: InputMaybe<Scalars['String']['input']>;
  compiledAt?: InputMaybe<Scalars['String']['input']>;
  customWidgetDescription?: InputMaybe<Scalars['String']['input']>;
  dark?: InputMaybe<Scalars['Boolean']['input']>;
  defaultValue?: InputMaybe<Scalars['JSON']['input']>;
  event?: InputMaybe<Scalars['JSON']['input']>;
  header?: InputMaybe<Scalars['String']['input']>;
  href?: InputMaybe<Scalars['String']['input']>;
  icon?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  intelligence?: InputMaybe<Scalars['JSON']['input']>;
  isCustomWidget?: InputMaybe<Scalars['Boolean']['input']>;
  isFieldEdited?: InputMaybe<Scalars['Boolean']['input']>;
  items?: InputMaybe<Scalars['JSON']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  linkLabel?: InputMaybe<Scalars['String']['input']>;
  link_type?: InputMaybe<Scalars['String']['input']>;
  max?: InputMaybe<Scalars['String']['input']>;
  maxDate?: InputMaybe<Scalars['String']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  min?: InputMaybe<Scalars['String']['input']>;
  minDate?: InputMaybe<Scalars['String']['input']>;
  model?: InputMaybe<Scalars['String']['input']>;
  modelItems?: InputMaybe<Array<StudentAdksFieldsModelItemsObjectEqualityInput>>;
  multiple?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  noSetup?: InputMaybe<Scalars['Boolean']['input']>;
  outlined?: InputMaybe<Scalars['Boolean']['input']>;
  placeholder?: InputMaybe<Scalars['String']['input']>;
  position?: InputMaybe<Scalars['Int']['input']>;
  preset?: InputMaybe<StudentAdksFieldsPresetObjectEqualityInput>;
  radioButtons?: InputMaybe<Array<StudentAdksFieldsRadioButtonsObjectEqualityInput>>;
  required?: InputMaybe<Scalars['Boolean']['input']>;
  roles?: InputMaybe<Array<Scalars['String']['input']>>;
  rounded?: InputMaybe<Scalars['Boolean']['input']>;
  rules?: InputMaybe<Array<Scalars['String']['input']>>;
  searchInput?: InputMaybe<Scalars['String']['input']>;
  searchType?: InputMaybe<Scalars['String']['input']>;
  setup?: InputMaybe<StudentAdksFieldsSetupObjectEqualityInput>;
  styling?: InputMaybe<StudentAdksFieldsStylingObjectEqualityInput>;
  subTitle?: InputMaybe<Scalars['String']['input']>;
  target?: InputMaybe<Scalars['String']['input']>;
  tickSize?: InputMaybe<Scalars['Int']['input']>;
  ticks?: InputMaybe<Scalars['Boolean']['input']>;
  timelineItems?: InputMaybe<Array<StudentAdksFieldsTimelineItemsObjectEqualityInput>>;
  title?: InputMaybe<Scalars['String']['input']>;
  titleAfterChip?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  vChipContent?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<StudentAdksFieldsValueObjectEqualityInput>;
  videoAskLabel?: InputMaybe<Scalars['String']['input']>;
  videoAskUrl?: InputMaybe<Scalars['String']['input']>;
  videoName?: InputMaybe<Scalars['String']['input']>;
  widgetSource?: InputMaybe<Scalars['String']['input']>;
  widgetUrl?: InputMaybe<Scalars['String']['input']>;
  widgetVersion?: InputMaybe<Scalars['Int']['input']>;
};

export type StudentAdksFieldsPreset = {
  __typename?: 'StudentAdksFieldsPreset';
  aboutOrg?: Maybe<Scalars['String']['output']>;
  acceptanceDeadline?: Maybe<Scalars['String']['output']>;
  apprentice?: Maybe<Scalars['Boolean']['output']>;
  compensation1?: Maybe<Scalars['Boolean']['output']>;
  compensation2?: Maybe<Scalars['Boolean']['output']>;
  compensation3?: Maybe<Scalars['Boolean']['output']>;
  compensation4?: Maybe<Scalars['Boolean']['output']>;
  compensation5?: Maybe<Scalars['Boolean']['output']>;
  compensation6?: Maybe<Scalars['Boolean']['output']>;
  continuation?: Maybe<Scalars['Int']['output']>;
  eir?: Maybe<Scalars['Boolean']['output']>;
  employerRecord?: Maybe<Scalars['Int']['output']>;
  extern?: Maybe<Scalars['Boolean']['output']>;
  externCredential?: Maybe<Scalars['Int']['output']>;
  fellow?: Maybe<Scalars['Boolean']['output']>;
  intern?: Maybe<Scalars['Boolean']['output']>;
  internshipEnd?: Maybe<Scalars['String']['output']>;
  internshipProject1?: Maybe<Scalars['Boolean']['output']>;
  internshipProject2?: Maybe<Scalars['Boolean']['output']>;
  internshipProject3?: Maybe<Scalars['Boolean']['output']>;
  internshipStart?: Maybe<Scalars['String']['output']>;
  interviewChallenge?: Maybe<Scalars['String']['output']>;
  interviewOpportunity?: Maybe<Scalars['String']['output']>;
  interviewProblem?: Maybe<Scalars['String']['output']>;
  interviewRequest?: Maybe<Scalars['String']['output']>;
  interviewSolution?: Maybe<Scalars['String']['output']>;
  licenseRequirement?: Maybe<Scalars['Int']['output']>;
  maxCharacters?: Maybe<Scalars['String']['output']>;
  maxHours?: Maybe<Scalars['Int']['output']>;
  maxQuestions?: Maybe<Scalars['Int']['output']>;
  maxTeamMembers?: Maybe<Scalars['Int']['output']>;
  maximumBudget?: Maybe<Scalars['String']['output']>;
  minHours?: Maybe<Scalars['Int']['output']>;
  minLogs?: Maybe<Scalars['Int']['output']>;
  minimumBudget?: Maybe<Scalars['String']['output']>;
  minimumHoursNow?: Maybe<Scalars['String']['output']>;
  pathways?: Maybe<Array<Scalars['String']['output']>>;
  preApprentice?: Maybe<Scalars['Boolean']['output']>;
  preInternship?: Maybe<Scalars['Boolean']['output']>;
  programDesc?: Maybe<Scalars['String']['output']>;
  programName?: Maybe<Scalars['String']['output']>;
  projectReq?: Maybe<Array<Scalars['String']['output']>>;
  /** Could not determine type: the field only had null or empty values in the sample set. */
  requiredResidency?: Maybe<Scalars['JSON']['output']>;
  requiredSkills?: Maybe<Array<Scalars['String']['output']>>;
  /** Could not determine type: the field only had null or empty values in the sample set. */
  resourceDrive?: Maybe<Scalars['JSON']['output']>;
  resourceFacebook?: Maybe<Scalars['String']['output']>;
  /** Could not determine type: the field only had null or empty values in the sample set. */
  resourceInsta?: Maybe<Scalars['JSON']['output']>;
  resourceLinkedIn?: Maybe<Scalars['String']['output']>;
  resourceTwitter?: Maybe<Scalars['String']['output']>;
  resourceWeb?: Maybe<Scalars['String']['output']>;
  /** Could not determine type: the field only had null or empty values in the sample set. */
  resourceYouTube?: Maybe<Scalars['JSON']['output']>;
  rewards?: Maybe<Array<Scalars['String']['output']>>;
  videoMaxLength?: Maybe<Scalars['Int']['output']>;
};

export type StudentAdksFieldsPresetCreateInput = {
  aboutOrg?: InputMaybe<Scalars['String']['input']>;
  acceptanceDeadline?: InputMaybe<Scalars['String']['input']>;
  apprentice?: InputMaybe<Scalars['Boolean']['input']>;
  compensation1?: InputMaybe<Scalars['Boolean']['input']>;
  compensation2?: InputMaybe<Scalars['Boolean']['input']>;
  compensation3?: InputMaybe<Scalars['Boolean']['input']>;
  compensation4?: InputMaybe<Scalars['Boolean']['input']>;
  compensation5?: InputMaybe<Scalars['Boolean']['input']>;
  compensation6?: InputMaybe<Scalars['Boolean']['input']>;
  continuation?: InputMaybe<Scalars['Int']['input']>;
  eir?: InputMaybe<Scalars['Boolean']['input']>;
  employerRecord?: InputMaybe<Scalars['Int']['input']>;
  extern?: InputMaybe<Scalars['Boolean']['input']>;
  externCredential?: InputMaybe<Scalars['Int']['input']>;
  fellow?: InputMaybe<Scalars['Boolean']['input']>;
  intern?: InputMaybe<Scalars['Boolean']['input']>;
  internshipEnd?: InputMaybe<Scalars['String']['input']>;
  internshipProject1?: InputMaybe<Scalars['Boolean']['input']>;
  internshipProject2?: InputMaybe<Scalars['Boolean']['input']>;
  internshipProject3?: InputMaybe<Scalars['Boolean']['input']>;
  internshipStart?: InputMaybe<Scalars['String']['input']>;
  interviewChallenge?: InputMaybe<Scalars['String']['input']>;
  interviewOpportunity?: InputMaybe<Scalars['String']['input']>;
  interviewProblem?: InputMaybe<Scalars['String']['input']>;
  interviewRequest?: InputMaybe<Scalars['String']['input']>;
  interviewSolution?: InputMaybe<Scalars['String']['input']>;
  licenseRequirement?: InputMaybe<Scalars['Int']['input']>;
  maxCharacters?: InputMaybe<Scalars['String']['input']>;
  maxHours?: InputMaybe<Scalars['Int']['input']>;
  maxQuestions?: InputMaybe<Scalars['Int']['input']>;
  maxTeamMembers?: InputMaybe<Scalars['Int']['input']>;
  maximumBudget?: InputMaybe<Scalars['String']['input']>;
  minHours?: InputMaybe<Scalars['Int']['input']>;
  minLogs?: InputMaybe<Scalars['Int']['input']>;
  minimumBudget?: InputMaybe<Scalars['String']['input']>;
  minimumHoursNow?: InputMaybe<Scalars['String']['input']>;
  pathways?: InputMaybe<StudentAdksFieldsPresetCreatepathwaysInput>;
  preApprentice?: InputMaybe<Scalars['Boolean']['input']>;
  preInternship?: InputMaybe<Scalars['Boolean']['input']>;
  programDesc?: InputMaybe<Scalars['String']['input']>;
  programName?: InputMaybe<Scalars['String']['input']>;
  projectReq?: InputMaybe<StudentAdksFieldsPresetCreateprojectReqInput>;
  requiredResidency?: InputMaybe<Scalars['JSON']['input']>;
  requiredSkills?: InputMaybe<StudentAdksFieldsPresetCreaterequiredSkillsInput>;
  resourceDrive?: InputMaybe<Scalars['JSON']['input']>;
  resourceFacebook?: InputMaybe<Scalars['String']['input']>;
  resourceInsta?: InputMaybe<Scalars['JSON']['input']>;
  resourceLinkedIn?: InputMaybe<Scalars['String']['input']>;
  resourceTwitter?: InputMaybe<Scalars['String']['input']>;
  resourceWeb?: InputMaybe<Scalars['String']['input']>;
  resourceYouTube?: InputMaybe<Scalars['JSON']['input']>;
  rewards?: InputMaybe<StudentAdksFieldsPresetCreaterewardsInput>;
  videoMaxLength?: InputMaybe<Scalars['Int']['input']>;
};

export type StudentAdksFieldsPresetCreatepathwaysInput = {
  set: Array<Scalars['String']['input']>;
};

export type StudentAdksFieldsPresetCreateprojectReqInput = {
  set: Array<Scalars['String']['input']>;
};

export type StudentAdksFieldsPresetCreaterequiredSkillsInput = {
  set: Array<Scalars['String']['input']>;
};

export type StudentAdksFieldsPresetCreaterewardsInput = {
  set: Array<Scalars['String']['input']>;
};

export type StudentAdksFieldsPresetObjectEqualityInput = {
  aboutOrg?: InputMaybe<Scalars['String']['input']>;
  acceptanceDeadline?: InputMaybe<Scalars['String']['input']>;
  apprentice?: InputMaybe<Scalars['Boolean']['input']>;
  compensation1?: InputMaybe<Scalars['Boolean']['input']>;
  compensation2?: InputMaybe<Scalars['Boolean']['input']>;
  compensation3?: InputMaybe<Scalars['Boolean']['input']>;
  compensation4?: InputMaybe<Scalars['Boolean']['input']>;
  compensation5?: InputMaybe<Scalars['Boolean']['input']>;
  compensation6?: InputMaybe<Scalars['Boolean']['input']>;
  continuation?: InputMaybe<Scalars['Int']['input']>;
  eir?: InputMaybe<Scalars['Boolean']['input']>;
  employerRecord?: InputMaybe<Scalars['Int']['input']>;
  extern?: InputMaybe<Scalars['Boolean']['input']>;
  externCredential?: InputMaybe<Scalars['Int']['input']>;
  fellow?: InputMaybe<Scalars['Boolean']['input']>;
  intern?: InputMaybe<Scalars['Boolean']['input']>;
  internshipEnd?: InputMaybe<Scalars['String']['input']>;
  internshipProject1?: InputMaybe<Scalars['Boolean']['input']>;
  internshipProject2?: InputMaybe<Scalars['Boolean']['input']>;
  internshipProject3?: InputMaybe<Scalars['Boolean']['input']>;
  internshipStart?: InputMaybe<Scalars['String']['input']>;
  interviewChallenge?: InputMaybe<Scalars['String']['input']>;
  interviewOpportunity?: InputMaybe<Scalars['String']['input']>;
  interviewProblem?: InputMaybe<Scalars['String']['input']>;
  interviewRequest?: InputMaybe<Scalars['String']['input']>;
  interviewSolution?: InputMaybe<Scalars['String']['input']>;
  licenseRequirement?: InputMaybe<Scalars['Int']['input']>;
  maxCharacters?: InputMaybe<Scalars['String']['input']>;
  maxHours?: InputMaybe<Scalars['Int']['input']>;
  maxQuestions?: InputMaybe<Scalars['Int']['input']>;
  maxTeamMembers?: InputMaybe<Scalars['Int']['input']>;
  maximumBudget?: InputMaybe<Scalars['String']['input']>;
  minHours?: InputMaybe<Scalars['Int']['input']>;
  minLogs?: InputMaybe<Scalars['Int']['input']>;
  minimumBudget?: InputMaybe<Scalars['String']['input']>;
  minimumHoursNow?: InputMaybe<Scalars['String']['input']>;
  pathways?: InputMaybe<Array<Scalars['String']['input']>>;
  preApprentice?: InputMaybe<Scalars['Boolean']['input']>;
  preInternship?: InputMaybe<Scalars['Boolean']['input']>;
  programDesc?: InputMaybe<Scalars['String']['input']>;
  programName?: InputMaybe<Scalars['String']['input']>;
  projectReq?: InputMaybe<Array<Scalars['String']['input']>>;
  requiredResidency?: InputMaybe<Scalars['JSON']['input']>;
  requiredSkills?: InputMaybe<Array<Scalars['String']['input']>>;
  resourceDrive?: InputMaybe<Scalars['JSON']['input']>;
  resourceFacebook?: InputMaybe<Scalars['String']['input']>;
  resourceInsta?: InputMaybe<Scalars['JSON']['input']>;
  resourceLinkedIn?: InputMaybe<Scalars['String']['input']>;
  resourceTwitter?: InputMaybe<Scalars['String']['input']>;
  resourceWeb?: InputMaybe<Scalars['String']['input']>;
  resourceYouTube?: InputMaybe<Scalars['JSON']['input']>;
  rewards?: InputMaybe<Array<Scalars['String']['input']>>;
  videoMaxLength?: InputMaybe<Scalars['Int']['input']>;
};

export type StudentAdksFieldsRadioButtons = {
  __typename?: 'StudentAdksFieldsRadioButtons';
  action?: Maybe<Scalars['String']['output']>;
  clickable?: Maybe<Scalars['Boolean']['output']>;
  event?: Maybe<StudentAdksFieldsRadioButtonsEvent>;
  label: Scalars['String']['output'];
};

export type StudentAdksFieldsRadioButtonsCreateInput = {
  action?: InputMaybe<Scalars['String']['input']>;
  clickable?: InputMaybe<Scalars['Boolean']['input']>;
  event?: InputMaybe<StudentAdksFieldsRadioButtonsEventCreateInput>;
  label: Scalars['String']['input'];
};

export type StudentAdksFieldsRadioButtonsEvent = {
  __typename?: 'StudentAdksFieldsRadioButtonsEvent';
  body: Scalars['String']['output'];
  buttons?: Maybe<Array<StudentAdksFieldsRadioButtonsEventButtons>>;
  component: Scalars['String']['output'];
  title: Scalars['String']['output'];
  trigger: Scalars['String']['output'];
};

export type StudentAdksFieldsRadioButtonsEventButtons = {
  __typename?: 'StudentAdksFieldsRadioButtonsEventButtons';
  label: Scalars['String']['output'];
  model: Scalars['String']['output'];
  style: StudentAdksFieldsRadioButtonsEventButtonsStyle;
};

export type StudentAdksFieldsRadioButtonsEventButtonsCreateInput = {
  label: Scalars['String']['input'];
  model: Scalars['String']['input'];
  style: StudentAdksFieldsRadioButtonsEventButtonsStyleCreateInput;
};

export type StudentAdksFieldsRadioButtonsEventButtonsObjectEqualityInput = {
  label: Scalars['String']['input'];
  model: Scalars['String']['input'];
  style: StudentAdksFieldsRadioButtonsEventButtonsStyleObjectEqualityInput;
};

export type StudentAdksFieldsRadioButtonsEventButtonsStyle = {
  __typename?: 'StudentAdksFieldsRadioButtonsEventButtonsStyle';
  class: Scalars['String']['output'];
  color: Scalars['String']['output'];
  dark?: Maybe<Scalars['Boolean']['output']>;
  depressed?: Maybe<Scalars['Boolean']['output']>;
  outlined?: Maybe<Scalars['Boolean']['output']>;
  rounded: Scalars['Boolean']['output'];
  xLarge: Scalars['Boolean']['output'];
};

export type StudentAdksFieldsRadioButtonsEventButtonsStyleCreateInput = {
  class: Scalars['String']['input'];
  color: Scalars['String']['input'];
  dark?: InputMaybe<Scalars['Boolean']['input']>;
  depressed?: InputMaybe<Scalars['Boolean']['input']>;
  outlined?: InputMaybe<Scalars['Boolean']['input']>;
  rounded: Scalars['Boolean']['input'];
  xLarge: Scalars['Boolean']['input'];
};

export type StudentAdksFieldsRadioButtonsEventButtonsStyleObjectEqualityInput = {
  class: Scalars['String']['input'];
  color: Scalars['String']['input'];
  dark?: InputMaybe<Scalars['Boolean']['input']>;
  depressed?: InputMaybe<Scalars['Boolean']['input']>;
  outlined?: InputMaybe<Scalars['Boolean']['input']>;
  rounded: Scalars['Boolean']['input'];
  xLarge: Scalars['Boolean']['input'];
};

export type StudentAdksFieldsRadioButtonsEventCreateInput = {
  body: Scalars['String']['input'];
  buttons?: InputMaybe<Array<StudentAdksFieldsRadioButtonsEventButtonsCreateInput>>;
  component: Scalars['String']['input'];
  title: Scalars['String']['input'];
  trigger: Scalars['String']['input'];
};

export type StudentAdksFieldsRadioButtonsEventObjectEqualityInput = {
  body: Scalars['String']['input'];
  buttons?: InputMaybe<Array<StudentAdksFieldsRadioButtonsEventButtonsObjectEqualityInput>>;
  component: Scalars['String']['input'];
  title: Scalars['String']['input'];
  trigger: Scalars['String']['input'];
};

export type StudentAdksFieldsRadioButtonsObjectEqualityInput = {
  action?: InputMaybe<Scalars['String']['input']>;
  clickable?: InputMaybe<Scalars['Boolean']['input']>;
  event?: InputMaybe<StudentAdksFieldsRadioButtonsEventObjectEqualityInput>;
  label: Scalars['String']['input'];
};

export type StudentAdksFieldsSetup = {
  __typename?: 'StudentAdksFieldsSetup';
  Description_1689596544146?: Maybe<Scalars['String']['output']>;
  Description_1689610327886?: Maybe<Scalars['String']['output']>;
  Select_1689610316209?: Maybe<Scalars['String']['output']>;
  aboutOrg?: Maybe<Scalars['String']['output']>;
  acceptanceDeadline?: Maybe<Scalars['String']['output']>;
  action?: Maybe<StudentAdksFieldsSetupAction>;
  /** Multiple data types found: Array(String): 2.2%, Array(Int): 97.8% out of 729 sampled entries */
  ageRange?: Maybe<Scalars['JSON']['output']>;
  airtableFormLink?: Maybe<Scalars['String']['output']>;
  airtableLink?: Maybe<Scalars['String']['output']>;
  airtableResponseLink?: Maybe<Scalars['String']['output']>;
  airtableTableLink?: Maybe<Scalars['String']['output']>;
  apprentice?: Maybe<Scalars['Boolean']['output']>;
  arrivalLink?: Maybe<Scalars['String']['output']>;
  arrivalStatus?: Maybe<Scalars['String']['output']>;
  attendeeList?: Maybe<Scalars['String']['output']>;
  boards?: Maybe<Array<StudentAdksFieldsSetupBoards>>;
  channels?: Maybe<Array<StudentAdksFieldsSetupChannels>>;
  checkinLink?: Maybe<Scalars['String']['output']>;
  compensation1?: Maybe<Scalars['Boolean']['output']>;
  compensation2?: Maybe<Scalars['Boolean']['output']>;
  compensation3?: Maybe<Scalars['Boolean']['output']>;
  compensation4?: Maybe<Scalars['Boolean']['output']>;
  compensation5?: Maybe<Scalars['Boolean']['output']>;
  compensation6?: Maybe<Scalars['Boolean']['output']>;
  connection?: Maybe<Scalars['String']['output']>;
  continuation?: Maybe<Scalars['Int']['output']>;
  defaultActivity?: Maybe<StudentAdksFieldsSetupDefaultActivity>;
  deliverable?: Maybe<Array<Scalars['String']['output']>>;
  directoryPreferences?: Maybe<Array<StudentAdksFieldsSetupDirectoryPreferences>>;
  discordData?: Maybe<StudentAdksFieldsSetupDiscordData>;
  discordLink?: Maybe<Scalars['String']['output']>;
  docDesc?: Maybe<Scalars['String']['output']>;
  driveLink?: Maybe<Scalars['String']['output']>;
  eir?: Maybe<Scalars['Boolean']['output']>;
  employerRecord?: Maybe<Scalars['Int']['output']>;
  endEarlyActivity?: Maybe<Scalars['String']['output']>;
  eventAgenda?: Maybe<Scalars['String']['output']>;
  eventDate?: Maybe<Scalars['String']['output']>;
  eventLocations?: Maybe<Scalars['String']['output']>;
  eventName?: Maybe<Scalars['String']['output']>;
  events?: Maybe<StudentAdksFieldsSetupEvents>;
  extern?: Maybe<Scalars['Boolean']['output']>;
  /** Multiple data types found: Float: 4.2%, Int: 95.8% out of 513 sampled entries */
  externCredential?: Maybe<Scalars['JSON']['output']>;
  fellow?: Maybe<Scalars['Boolean']['output']>;
  fileType?: Maybe<Array<Scalars['String']['output']>>;
  form_id?: Maybe<Scalars['String']['output']>;
  form_url?: Maybe<Scalars['String']['output']>;
  groupActivity?: Maybe<Scalars['String']['output']>;
  instructions?: Maybe<Scalars['String']['output']>;
  intern?: Maybe<Scalars['Boolean']['output']>;
  internshipEnd?: Maybe<Scalars['String']['output']>;
  internshipProject1?: Maybe<Scalars['Boolean']['output']>;
  internshipProject2?: Maybe<Scalars['Boolean']['output']>;
  internshipProject3?: Maybe<Scalars['Boolean']['output']>;
  internshipStart?: Maybe<Scalars['String']['output']>;
  interviewChallenge?: Maybe<Scalars['String']['output']>;
  interviewOpportunity?: Maybe<Scalars['String']['output']>;
  interviewProblem?: Maybe<Scalars['String']['output']>;
  interviewRequest?: Maybe<Scalars['String']['output']>;
  interviewSolution?: Maybe<Scalars['String']['output']>;
  licenseRequirement?: Maybe<Scalars['Int']['output']>;
  maxCharacters?: Maybe<Scalars['String']['output']>;
  maxHours?: Maybe<Scalars['Int']['output']>;
  maxQuestions?: Maybe<Scalars['Int']['output']>;
  maxTeamMembers?: Maybe<Scalars['Int']['output']>;
  maximumBudget?: Maybe<Scalars['String']['output']>;
  minHours?: Maybe<Scalars['Int']['output']>;
  minLogs?: Maybe<Scalars['Int']['output']>;
  minimumBudget?: Maybe<Scalars['String']['output']>;
  minimumHoursNow?: Maybe<Scalars['String']['output']>;
  outcome?: Maybe<Array<Scalars['String']['output']>>;
  pathways?: Maybe<Array<Scalars['String']['output']>>;
  preApprentice?: Maybe<Scalars['Boolean']['output']>;
  preInternship?: Maybe<Scalars['Boolean']['output']>;
  programDesc?: Maybe<Scalars['String']['output']>;
  programName?: Maybe<Scalars['String']['output']>;
  /** Multiple data types found: String: 24.5%, Array(String): 75.5% out of 1445 sampled entries */
  projectReq?: Maybe<Scalars['JSON']['output']>;
  providers?: Maybe<StudentAdksFieldsSetupProviders>;
  requiredActivity?: Maybe<Scalars['String']['output']>;
  /** Multiple data types found: String: 41.4%, Array(String): 58.6% out of 595 sampled entries */
  requiredResidency?: Maybe<Scalars['JSON']['output']>;
  requiredSkills?: Maybe<Array<Scalars['String']['output']>>;
  researchLinks?: Maybe<Array<StudentAdksFieldsSetupResearchLinks>>;
  researchProgress?: Maybe<Array<StudentAdksFieldsSetupResearchProgress>>;
  resourceDrive?: Maybe<Scalars['String']['output']>;
  resourceFacebook?: Maybe<Scalars['String']['output']>;
  resourceInsta?: Maybe<Scalars['String']['output']>;
  resourceLinkedIn?: Maybe<Scalars['String']['output']>;
  resourceTwitter?: Maybe<Scalars['String']['output']>;
  resourceWeb?: Maybe<Scalars['String']['output']>;
  resourceYouTube?: Maybe<Scalars['String']['output']>;
  rewards?: Maybe<Array<Scalars['String']['output']>>;
  rsvpLink?: Maybe<Scalars['String']['output']>;
  settings?: Maybe<StudentAdksFieldsSetupSettings>;
  signInVideoAskResponse?: Maybe<StudentAdksFieldsSetupSignInVideoAskResponse>;
  text_input_1689596540310?: Maybe<Scalars['String']['output']>;
  timeFrame?: Maybe<Array<StudentAdksFieldsSetupTimeFrame>>;
  timeZone?: Maybe<Scalars['String']['output']>;
  trainProgress?: Maybe<Array<StudentAdksFieldsSetupTrainProgress>>;
  uploadLimit?: Maybe<StudentAdksFieldsSetupUploadLimit>;
  uploadLink?: Maybe<Scalars['String']['output']>;
  videoLinks?: Maybe<Array<StudentAdksFieldsSetupVideoLinks>>;
  videoMaxLength?: Maybe<Scalars['Int']['output']>;
  videoaskEmbed?: Maybe<Scalars['String']['output']>;
  videoaskLink?: Maybe<Scalars['String']['output']>;
  videoaskResponseLink?: Maybe<Scalars['String']['output']>;
  welcomeActivity?: Maybe<Scalars['String']['output']>;
  youtubeLink?: Maybe<Scalars['String']['output']>;
};

export type StudentAdksFieldsSetupAction = {
  __typename?: 'StudentAdksFieldsSetupAction';
  desc: Scalars['String']['output'];
  link: Scalars['String']['output'];
};

export type StudentAdksFieldsSetupActionCreateInput = {
  desc: Scalars['String']['input'];
  link: Scalars['String']['input'];
};

export type StudentAdksFieldsSetupActionObjectEqualityInput = {
  desc: Scalars['String']['input'];
  link: Scalars['String']['input'];
};

export type StudentAdksFieldsSetupBoards = {
  __typename?: 'StudentAdksFieldsSetupBoards';
  teamName: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type StudentAdksFieldsSetupBoardsCreateInput = {
  teamName: Scalars['String']['input'];
  url: Scalars['String']['input'];
};

export type StudentAdksFieldsSetupBoardsObjectEqualityInput = {
  teamName: Scalars['String']['input'];
  url: Scalars['String']['input'];
};

export type StudentAdksFieldsSetupChannels = {
  __typename?: 'StudentAdksFieldsSetupChannels';
  linkName?: Maybe<Scalars['String']['output']>;
  teamName?: Maybe<Scalars['String']['output']>;
  url: Scalars['String']['output'];
};

export type StudentAdksFieldsSetupChannelsCreateInput = {
  linkName?: InputMaybe<Scalars['String']['input']>;
  teamName?: InputMaybe<Scalars['String']['input']>;
  url: Scalars['String']['input'];
};

export type StudentAdksFieldsSetupChannelsObjectEqualityInput = {
  linkName?: InputMaybe<Scalars['String']['input']>;
  teamName?: InputMaybe<Scalars['String']['input']>;
  url: Scalars['String']['input'];
};

export type StudentAdksFieldsSetupCreateInput = {
  Description_1689596544146?: InputMaybe<Scalars['String']['input']>;
  Description_1689610327886?: InputMaybe<Scalars['String']['input']>;
  Select_1689610316209?: InputMaybe<Scalars['String']['input']>;
  aboutOrg?: InputMaybe<Scalars['String']['input']>;
  acceptanceDeadline?: InputMaybe<Scalars['String']['input']>;
  action?: InputMaybe<StudentAdksFieldsSetupActionCreateInput>;
  ageRange?: InputMaybe<Scalars['JSON']['input']>;
  airtableFormLink?: InputMaybe<Scalars['String']['input']>;
  airtableLink?: InputMaybe<Scalars['String']['input']>;
  airtableResponseLink?: InputMaybe<Scalars['String']['input']>;
  airtableTableLink?: InputMaybe<Scalars['String']['input']>;
  apprentice?: InputMaybe<Scalars['Boolean']['input']>;
  arrivalLink?: InputMaybe<Scalars['String']['input']>;
  arrivalStatus?: InputMaybe<Scalars['String']['input']>;
  attendeeList?: InputMaybe<Scalars['String']['input']>;
  boards?: InputMaybe<Array<StudentAdksFieldsSetupBoardsCreateInput>>;
  channels?: InputMaybe<Array<StudentAdksFieldsSetupChannelsCreateInput>>;
  checkinLink?: InputMaybe<Scalars['String']['input']>;
  compensation1?: InputMaybe<Scalars['Boolean']['input']>;
  compensation2?: InputMaybe<Scalars['Boolean']['input']>;
  compensation3?: InputMaybe<Scalars['Boolean']['input']>;
  compensation4?: InputMaybe<Scalars['Boolean']['input']>;
  compensation5?: InputMaybe<Scalars['Boolean']['input']>;
  compensation6?: InputMaybe<Scalars['Boolean']['input']>;
  connection?: InputMaybe<Scalars['String']['input']>;
  continuation?: InputMaybe<Scalars['Int']['input']>;
  defaultActivity?: InputMaybe<StudentAdksFieldsSetupDefaultActivityCreateInput>;
  deliverable?: InputMaybe<StudentAdksFieldsSetupCreatedeliverableInput>;
  directoryPreferences?: InputMaybe<Array<StudentAdksFieldsSetupDirectoryPreferencesCreateInput>>;
  discordData?: InputMaybe<StudentAdksFieldsSetupDiscordDataCreateInput>;
  discordLink?: InputMaybe<Scalars['String']['input']>;
  docDesc?: InputMaybe<Scalars['String']['input']>;
  driveLink?: InputMaybe<Scalars['String']['input']>;
  eir?: InputMaybe<Scalars['Boolean']['input']>;
  employerRecord?: InputMaybe<Scalars['Int']['input']>;
  endEarlyActivity?: InputMaybe<Scalars['String']['input']>;
  eventAgenda?: InputMaybe<Scalars['String']['input']>;
  eventDate?: InputMaybe<Scalars['String']['input']>;
  eventLocations?: InputMaybe<Scalars['String']['input']>;
  eventName?: InputMaybe<Scalars['String']['input']>;
  events?: InputMaybe<StudentAdksFieldsSetupEventsCreateInput>;
  extern?: InputMaybe<Scalars['Boolean']['input']>;
  externCredential?: InputMaybe<Scalars['JSON']['input']>;
  fellow?: InputMaybe<Scalars['Boolean']['input']>;
  fileType?: InputMaybe<StudentAdksFieldsSetupCreatefileTypeInput>;
  form_id?: InputMaybe<Scalars['String']['input']>;
  form_url?: InputMaybe<Scalars['String']['input']>;
  groupActivity?: InputMaybe<Scalars['String']['input']>;
  instructions?: InputMaybe<Scalars['String']['input']>;
  intern?: InputMaybe<Scalars['Boolean']['input']>;
  internshipEnd?: InputMaybe<Scalars['String']['input']>;
  internshipProject1?: InputMaybe<Scalars['Boolean']['input']>;
  internshipProject2?: InputMaybe<Scalars['Boolean']['input']>;
  internshipProject3?: InputMaybe<Scalars['Boolean']['input']>;
  internshipStart?: InputMaybe<Scalars['String']['input']>;
  interviewChallenge?: InputMaybe<Scalars['String']['input']>;
  interviewOpportunity?: InputMaybe<Scalars['String']['input']>;
  interviewProblem?: InputMaybe<Scalars['String']['input']>;
  interviewRequest?: InputMaybe<Scalars['String']['input']>;
  interviewSolution?: InputMaybe<Scalars['String']['input']>;
  licenseRequirement?: InputMaybe<Scalars['Int']['input']>;
  maxCharacters?: InputMaybe<Scalars['String']['input']>;
  maxHours?: InputMaybe<Scalars['Int']['input']>;
  maxQuestions?: InputMaybe<Scalars['Int']['input']>;
  maxTeamMembers?: InputMaybe<Scalars['Int']['input']>;
  maximumBudget?: InputMaybe<Scalars['String']['input']>;
  minHours?: InputMaybe<Scalars['Int']['input']>;
  minLogs?: InputMaybe<Scalars['Int']['input']>;
  minimumBudget?: InputMaybe<Scalars['String']['input']>;
  minimumHoursNow?: InputMaybe<Scalars['String']['input']>;
  outcome?: InputMaybe<StudentAdksFieldsSetupCreateoutcomeInput>;
  pathways?: InputMaybe<StudentAdksFieldsSetupCreatepathwaysInput>;
  preApprentice?: InputMaybe<Scalars['Boolean']['input']>;
  preInternship?: InputMaybe<Scalars['Boolean']['input']>;
  programDesc?: InputMaybe<Scalars['String']['input']>;
  programName?: InputMaybe<Scalars['String']['input']>;
  projectReq?: InputMaybe<Scalars['JSON']['input']>;
  providers?: InputMaybe<StudentAdksFieldsSetupProvidersCreateInput>;
  requiredActivity?: InputMaybe<Scalars['String']['input']>;
  requiredResidency?: InputMaybe<Scalars['JSON']['input']>;
  requiredSkills?: InputMaybe<StudentAdksFieldsSetupCreaterequiredSkillsInput>;
  researchLinks?: InputMaybe<Array<StudentAdksFieldsSetupResearchLinksCreateInput>>;
  researchProgress?: InputMaybe<Array<StudentAdksFieldsSetupResearchProgressCreateInput>>;
  resourceDrive?: InputMaybe<Scalars['String']['input']>;
  resourceFacebook?: InputMaybe<Scalars['String']['input']>;
  resourceInsta?: InputMaybe<Scalars['String']['input']>;
  resourceLinkedIn?: InputMaybe<Scalars['String']['input']>;
  resourceTwitter?: InputMaybe<Scalars['String']['input']>;
  resourceWeb?: InputMaybe<Scalars['String']['input']>;
  resourceYouTube?: InputMaybe<Scalars['String']['input']>;
  rewards?: InputMaybe<StudentAdksFieldsSetupCreaterewardsInput>;
  rsvpLink?: InputMaybe<Scalars['String']['input']>;
  settings?: InputMaybe<StudentAdksFieldsSetupSettingsCreateInput>;
  signInVideoAskResponse?: InputMaybe<StudentAdksFieldsSetupSignInVideoAskResponseCreateInput>;
  text_input_1689596540310?: InputMaybe<Scalars['String']['input']>;
  timeFrame?: InputMaybe<Array<StudentAdksFieldsSetupTimeFrameCreateInput>>;
  timeZone?: InputMaybe<Scalars['String']['input']>;
  trainProgress?: InputMaybe<Array<StudentAdksFieldsSetupTrainProgressCreateInput>>;
  uploadLimit?: InputMaybe<StudentAdksFieldsSetupUploadLimitCreateInput>;
  uploadLink?: InputMaybe<Scalars['String']['input']>;
  videoLinks?: InputMaybe<Array<StudentAdksFieldsSetupVideoLinksCreateInput>>;
  videoMaxLength?: InputMaybe<Scalars['Int']['input']>;
  videoaskEmbed?: InputMaybe<Scalars['String']['input']>;
  videoaskLink?: InputMaybe<Scalars['String']['input']>;
  videoaskResponseLink?: InputMaybe<Scalars['String']['input']>;
  welcomeActivity?: InputMaybe<Scalars['String']['input']>;
  youtubeLink?: InputMaybe<Scalars['String']['input']>;
};

export type StudentAdksFieldsSetupCreatedeliverableInput = {
  set: Array<Scalars['String']['input']>;
};

export type StudentAdksFieldsSetupCreatefileTypeInput = {
  set: Array<Scalars['String']['input']>;
};

export type StudentAdksFieldsSetupCreateoutcomeInput = {
  set: Array<Scalars['String']['input']>;
};

export type StudentAdksFieldsSetupCreatepathwaysInput = {
  set: Array<Scalars['String']['input']>;
};

export type StudentAdksFieldsSetupCreaterequiredSkillsInput = {
  set: Array<Scalars['String']['input']>;
};

export type StudentAdksFieldsSetupCreaterewardsInput = {
  set: Array<Scalars['String']['input']>;
};

export type StudentAdksFieldsSetupDefaultActivity = {
  __typename?: 'StudentAdksFieldsSetupDefaultActivity';
  deliverableActivity: Scalars['String']['output'];
  endEarlyActivity: Scalars['String']['output'];
  groupActivity: Scalars['String']['output'];
  required: Scalars['Boolean']['output'];
  requiredActivity: Scalars['String']['output'];
};

export type StudentAdksFieldsSetupDefaultActivityCreateInput = {
  deliverableActivity: Scalars['String']['input'];
  endEarlyActivity: Scalars['String']['input'];
  groupActivity: Scalars['String']['input'];
  required: Scalars['Boolean']['input'];
  requiredActivity: Scalars['String']['input'];
};

export type StudentAdksFieldsSetupDefaultActivityObjectEqualityInput = {
  deliverableActivity: Scalars['String']['input'];
  endEarlyActivity: Scalars['String']['input'];
  groupActivity: Scalars['String']['input'];
  required: Scalars['Boolean']['input'];
  requiredActivity: Scalars['String']['input'];
};

export type StudentAdksFieldsSetupDirectoryPreferences = {
  __typename?: 'StudentAdksFieldsSetupDirectoryPreferences';
  contactMethod?: Maybe<Array<Scalars['String']['output']>>;
  contactMethods?: Maybe<Array<Scalars['String']['output']>>;
  contactPreferences?: Maybe<Array<Scalars['String']['output']>>;
  hideEmail: Scalars['Boolean']['output'];
  hidePhone: Scalars['Boolean']['output'];
  schedulingLink?: Maybe<Scalars['String']['output']>;
  /** Multiple data types found: String: 1.7%, String (ObjectId): 98.3% out of 242 sampled entries */
  userId: Scalars['JSON']['output'];
};

export type StudentAdksFieldsSetupDirectoryPreferencesCreateInput = {
  contactMethod?: InputMaybe<StudentAdksFieldsSetupDirectoryPreferencesCreatecontactMethodInput>;
  contactMethods?: InputMaybe<StudentAdksFieldsSetupDirectoryPreferencesCreatecontactMethodsInput>;
  contactPreferences?: InputMaybe<StudentAdksFieldsSetupDirectoryPreferencesCreatecontactPreferencesInput>;
  hideEmail: Scalars['Boolean']['input'];
  hidePhone: Scalars['Boolean']['input'];
  schedulingLink?: InputMaybe<Scalars['String']['input']>;
  userId: Scalars['JSON']['input'];
};

export type StudentAdksFieldsSetupDirectoryPreferencesCreatecontactMethodInput = {
  set: Array<Scalars['String']['input']>;
};

export type StudentAdksFieldsSetupDirectoryPreferencesCreatecontactMethodsInput = {
  set: Array<Scalars['String']['input']>;
};

export type StudentAdksFieldsSetupDirectoryPreferencesCreatecontactPreferencesInput = {
  set: Array<Scalars['String']['input']>;
};

export type StudentAdksFieldsSetupDirectoryPreferencesObjectEqualityInput = {
  contactMethod?: InputMaybe<Array<Scalars['String']['input']>>;
  contactMethods?: InputMaybe<Array<Scalars['String']['input']>>;
  contactPreferences?: InputMaybe<Array<Scalars['String']['input']>>;
  hideEmail: Scalars['Boolean']['input'];
  hidePhone: Scalars['Boolean']['input'];
  schedulingLink?: InputMaybe<Scalars['String']['input']>;
  userId: Scalars['JSON']['input'];
};

export type StudentAdksFieldsSetupDiscordData = {
  __typename?: 'StudentAdksFieldsSetupDiscordData';
  channel?: Maybe<StudentAdksFieldsSetupDiscordDataChannel>;
  createdBy: StudentAdksFieldsSetupDiscordDataCreatedBy;
  role: StudentAdksFieldsSetupDiscordDataRole;
};

export type StudentAdksFieldsSetupDiscordDataChannel = {
  __typename?: 'StudentAdksFieldsSetupDiscordDataChannel';
  flags: Scalars['Int']['output'];
  guild_id: Scalars['String']['output'];
  icon_emoji?: Maybe<StudentAdksFieldsSetupDiscordDataChannelIconEmoji>;
  id: Scalars['String']['output'];
  /** Could not determine type: the field only had null or empty values in the sample set. */
  last_message_id?: Maybe<Scalars['JSON']['output']>;
  name: Scalars['String']['output'];
  nsfw: Scalars['Boolean']['output'];
  parent_id: Scalars['String']['output'];
  permission_overwrites?: Maybe<Array<StudentAdksFieldsSetupDiscordDataChannelPermissionOverwrites>>;
  position: Scalars['Int']['output'];
  rate_limit_per_user: Scalars['Int']['output'];
  /** Could not determine type: the field only had null or empty values in the sample set. */
  theme_color?: Maybe<Scalars['JSON']['output']>;
  /** Could not determine type: the field only had null or empty values in the sample set. */
  topic?: Maybe<Scalars['JSON']['output']>;
  type: Scalars['Int']['output'];
};

export type StudentAdksFieldsSetupDiscordDataChannelCreateInput = {
  flags: Scalars['Int']['input'];
  guild_id: Scalars['String']['input'];
  icon_emoji?: InputMaybe<StudentAdksFieldsSetupDiscordDataChannelIconEmojiCreateInput>;
  id: Scalars['String']['input'];
  last_message_id?: InputMaybe<Scalars['JSON']['input']>;
  name: Scalars['String']['input'];
  nsfw: Scalars['Boolean']['input'];
  parent_id: Scalars['String']['input'];
  permission_overwrites?: InputMaybe<Array<StudentAdksFieldsSetupDiscordDataChannelPermissionOverwritesCreateInput>>;
  position: Scalars['Int']['input'];
  rate_limit_per_user: Scalars['Int']['input'];
  theme_color?: InputMaybe<Scalars['JSON']['input']>;
  topic?: InputMaybe<Scalars['JSON']['input']>;
  type: Scalars['Int']['input'];
};

export type StudentAdksFieldsSetupDiscordDataChannelIconEmoji = {
  __typename?: 'StudentAdksFieldsSetupDiscordDataChannelIconEmoji';
  /** Could not determine type: the field only had null or empty values in the sample set. */
  id?: Maybe<Scalars['JSON']['output']>;
  name: Scalars['String']['output'];
};

export type StudentAdksFieldsSetupDiscordDataChannelIconEmojiCreateInput = {
  id?: InputMaybe<Scalars['JSON']['input']>;
  name: Scalars['String']['input'];
};

export type StudentAdksFieldsSetupDiscordDataChannelIconEmojiObjectEqualityInput = {
  id?: InputMaybe<Scalars['JSON']['input']>;
  name: Scalars['String']['input'];
};

export type StudentAdksFieldsSetupDiscordDataChannelObjectEqualityInput = {
  flags: Scalars['Int']['input'];
  guild_id: Scalars['String']['input'];
  icon_emoji?: InputMaybe<StudentAdksFieldsSetupDiscordDataChannelIconEmojiObjectEqualityInput>;
  id: Scalars['String']['input'];
  last_message_id?: InputMaybe<Scalars['JSON']['input']>;
  name: Scalars['String']['input'];
  nsfw: Scalars['Boolean']['input'];
  parent_id: Scalars['String']['input'];
  permission_overwrites?: InputMaybe<Array<StudentAdksFieldsSetupDiscordDataChannelPermissionOverwritesObjectEqualityInput>>;
  position: Scalars['Int']['input'];
  rate_limit_per_user: Scalars['Int']['input'];
  theme_color?: InputMaybe<Scalars['JSON']['input']>;
  topic?: InputMaybe<Scalars['JSON']['input']>;
  type: Scalars['Int']['input'];
};

export type StudentAdksFieldsSetupDiscordDataChannelPermissionOverwrites = {
  __typename?: 'StudentAdksFieldsSetupDiscordDataChannelPermissionOverwrites';
  allow: Scalars['Int']['output'];
  allow_new: Scalars['String']['output'];
  deny: Scalars['Int']['output'];
  deny_new: Scalars['String']['output'];
  id: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type StudentAdksFieldsSetupDiscordDataChannelPermissionOverwritesCreateInput = {
  allow: Scalars['Int']['input'];
  allow_new: Scalars['String']['input'];
  deny: Scalars['Int']['input'];
  deny_new: Scalars['String']['input'];
  id: Scalars['String']['input'];
  type: Scalars['String']['input'];
};

export type StudentAdksFieldsSetupDiscordDataChannelPermissionOverwritesObjectEqualityInput = {
  allow: Scalars['Int']['input'];
  allow_new: Scalars['String']['input'];
  deny: Scalars['Int']['input'];
  deny_new: Scalars['String']['input'];
  id: Scalars['String']['input'];
  type: Scalars['String']['input'];
};

export type StudentAdksFieldsSetupDiscordDataCreateInput = {
  channel?: InputMaybe<StudentAdksFieldsSetupDiscordDataChannelCreateInput>;
  createdBy: StudentAdksFieldsSetupDiscordDataCreatedByCreateInput;
  role: StudentAdksFieldsSetupDiscordDataRoleCreateInput;
};

export type StudentAdksFieldsSetupDiscordDataCreatedBy = {
  __typename?: 'StudentAdksFieldsSetupDiscordDataCreatedBy';
  email: Scalars['String']['output'];
  userType: Scalars['String']['output'];
};

export type StudentAdksFieldsSetupDiscordDataCreatedByCreateInput = {
  email: Scalars['String']['input'];
  userType: Scalars['String']['input'];
};

export type StudentAdksFieldsSetupDiscordDataCreatedByObjectEqualityInput = {
  email: Scalars['String']['input'];
  userType: Scalars['String']['input'];
};

export type StudentAdksFieldsSetupDiscordDataObjectEqualityInput = {
  channel?: InputMaybe<StudentAdksFieldsSetupDiscordDataChannelObjectEqualityInput>;
  createdBy: StudentAdksFieldsSetupDiscordDataCreatedByObjectEqualityInput;
  role: StudentAdksFieldsSetupDiscordDataRoleObjectEqualityInput;
};

export type StudentAdksFieldsSetupDiscordDataRole = {
  __typename?: 'StudentAdksFieldsSetupDiscordDataRole';
  color?: Maybe<Scalars['Int']['output']>;
  /** Could not determine type: the field only had null or empty values in the sample set. */
  description?: Maybe<Scalars['JSON']['output']>;
  flags?: Maybe<Scalars['Int']['output']>;
  global?: Maybe<Scalars['Boolean']['output']>;
  hoist?: Maybe<Scalars['Boolean']['output']>;
  /** Could not determine type: the field only had null or empty values in the sample set. */
  icon?: Maybe<Scalars['JSON']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  managed?: Maybe<Scalars['Boolean']['output']>;
  mentionable?: Maybe<Scalars['Boolean']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  permissions?: Maybe<Scalars['Int']['output']>;
  permissions_new?: Maybe<Scalars['String']['output']>;
  position?: Maybe<Scalars['Int']['output']>;
  retry_after?: Maybe<Scalars['Float']['output']>;
  /** Could not determine type: the field only had null or empty values in the sample set. */
  unicode_emoji?: Maybe<Scalars['JSON']['output']>;
};

export type StudentAdksFieldsSetupDiscordDataRoleCreateInput = {
  color?: InputMaybe<Scalars['Int']['input']>;
  description?: InputMaybe<Scalars['JSON']['input']>;
  flags?: InputMaybe<Scalars['Int']['input']>;
  global?: InputMaybe<Scalars['Boolean']['input']>;
  hoist?: InputMaybe<Scalars['Boolean']['input']>;
  icon?: InputMaybe<Scalars['JSON']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  managed?: InputMaybe<Scalars['Boolean']['input']>;
  mentionable?: InputMaybe<Scalars['Boolean']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  permissions?: InputMaybe<Scalars['Int']['input']>;
  permissions_new?: InputMaybe<Scalars['String']['input']>;
  position?: InputMaybe<Scalars['Int']['input']>;
  retry_after?: InputMaybe<Scalars['Float']['input']>;
  unicode_emoji?: InputMaybe<Scalars['JSON']['input']>;
};

export type StudentAdksFieldsSetupDiscordDataRoleObjectEqualityInput = {
  color?: InputMaybe<Scalars['Int']['input']>;
  description?: InputMaybe<Scalars['JSON']['input']>;
  flags?: InputMaybe<Scalars['Int']['input']>;
  global?: InputMaybe<Scalars['Boolean']['input']>;
  hoist?: InputMaybe<Scalars['Boolean']['input']>;
  icon?: InputMaybe<Scalars['JSON']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  managed?: InputMaybe<Scalars['Boolean']['input']>;
  mentionable?: InputMaybe<Scalars['Boolean']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  permissions?: InputMaybe<Scalars['Int']['input']>;
  permissions_new?: InputMaybe<Scalars['String']['input']>;
  position?: InputMaybe<Scalars['Int']['input']>;
  retry_after?: InputMaybe<Scalars['Float']['input']>;
  unicode_emoji?: InputMaybe<Scalars['JSON']['input']>;
};

export type StudentAdksFieldsSetupEvents = {
  __typename?: 'StudentAdksFieldsSetupEvents';
  created_by: Scalars['String']['output'];
  startDateTime?: Maybe<Scalars['String']['output']>;
  weekly_meeting: StudentAdksFieldsSetupEventsWeeklyMeeting;
  weekly_meeting_participants?: Maybe<Array<Scalars['String']['output']>>;
};

export type StudentAdksFieldsSetupEventsCreateInput = {
  created_by: Scalars['String']['input'];
  startDateTime?: InputMaybe<Scalars['String']['input']>;
  weekly_meeting: StudentAdksFieldsSetupEventsWeeklyMeetingCreateInput;
  weekly_meeting_participants?: InputMaybe<StudentAdksFieldsSetupEventsCreateweekly_Meeting_ParticipantsInput>;
};

export type StudentAdksFieldsSetupEventsCreateweekly_Meeting_ParticipantsInput = {
  set: Array<Scalars['String']['input']>;
};

export type StudentAdksFieldsSetupEventsObjectEqualityInput = {
  created_by: Scalars['String']['input'];
  startDateTime?: InputMaybe<Scalars['String']['input']>;
  weekly_meeting: StudentAdksFieldsSetupEventsWeeklyMeetingObjectEqualityInput;
  weekly_meeting_participants?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type StudentAdksFieldsSetupEventsWeeklyMeeting = {
  __typename?: 'StudentAdksFieldsSetupEventsWeeklyMeeting';
  allowNewTimeProposals?: Maybe<Scalars['Boolean']['output']>;
  attendees?: Maybe<Array<StudentAdksFieldsSetupEventsWeeklyMeetingAttendees>>;
  body?: Maybe<StudentAdksFieldsSetupEventsWeeklyMeetingBody>;
  bodyPreview?: Maybe<Scalars['String']['output']>;
  /** Could not determine type: the field only had null or empty values in the sample set. */
  categories?: Maybe<Scalars['JSON']['output']>;
  changeKey?: Maybe<Scalars['String']['output']>;
  conferenceData?: Maybe<StudentAdksFieldsSetupEventsWeeklyMeetingConferenceData>;
  created?: Maybe<Scalars['String']['output']>;
  createdDateTime?: Maybe<Scalars['String']['output']>;
  creator?: Maybe<StudentAdksFieldsSetupEventsWeeklyMeetingCreator>;
  description?: Maybe<Scalars['String']['output']>;
  end?: Maybe<StudentAdksFieldsSetupEventsWeeklyMeetingEnd>;
  error?: Maybe<StudentAdksFieldsSetupEventsWeeklyMeetingError>;
  etag?: Maybe<Scalars['String']['output']>;
  eventType?: Maybe<Scalars['String']['output']>;
  hangoutLink?: Maybe<Scalars['String']['output']>;
  hasAttachments?: Maybe<Scalars['Boolean']['output']>;
  hideAttendees?: Maybe<Scalars['Boolean']['output']>;
  htmlLink?: Maybe<Scalars['String']['output']>;
  iCalUID?: Maybe<Scalars['String']['output']>;
  iCalUId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  importance?: Maybe<Scalars['String']['output']>;
  isAllDay?: Maybe<Scalars['Boolean']['output']>;
  isCancelled?: Maybe<Scalars['Boolean']['output']>;
  isDraft?: Maybe<Scalars['Boolean']['output']>;
  isOnlineMeeting?: Maybe<Scalars['Boolean']['output']>;
  isOrganizer?: Maybe<Scalars['Boolean']['output']>;
  isReminderOn?: Maybe<Scalars['Boolean']['output']>;
  kind?: Maybe<Scalars['String']['output']>;
  lastModifiedDateTime?: Maybe<Scalars['String']['output']>;
  /** Multiple data types found: String: 90%, StudentAdksFieldsSetupEventsWeeklyMeetingLocation: 10% out of 10 sampled entries */
  location?: Maybe<Scalars['JSON']['output']>;
  locations?: Maybe<Array<StudentAdksFieldsSetupEventsWeeklyMeetingLocations>>;
  /** Could not determine type: the field only had null or empty values in the sample set. */
  occurrenceId?: Maybe<Scalars['JSON']['output']>;
  odata_context?: Maybe<Scalars['String']['output']>;
  odata_etag?: Maybe<Scalars['String']['output']>;
  /** Could not determine type: the field only had null or empty values in the sample set. */
  onlineMeeting?: Maybe<Scalars['JSON']['output']>;
  onlineMeetingProvider?: Maybe<Scalars['String']['output']>;
  /** Could not determine type: the field only had null or empty values in the sample set. */
  onlineMeetingUrl?: Maybe<Scalars['JSON']['output']>;
  organizer?: Maybe<StudentAdksFieldsSetupEventsWeeklyMeetingOrganizer>;
  originalEndTimeZone?: Maybe<Scalars['String']['output']>;
  originalStartTimeZone?: Maybe<Scalars['String']['output']>;
  /** Multiple data types found: StudentAdksFieldsSetupEventsWeeklyMeetingRecurrence: 0.7%, Array(String): 99.3% out of 147 sampled entries */
  recurrence?: Maybe<Scalars['JSON']['output']>;
  reminderMinutesBeforeStart?: Maybe<Scalars['Int']['output']>;
  reminders?: Maybe<StudentAdksFieldsSetupEventsWeeklyMeetingReminders>;
  responseRequested?: Maybe<Scalars['Boolean']['output']>;
  responseStatus?: Maybe<StudentAdksFieldsSetupEventsWeeklyMeetingResponseStatus>;
  sensitivity?: Maybe<Scalars['String']['output']>;
  sequence?: Maybe<Scalars['Int']['output']>;
  /** Could not determine type: the field only had null or empty values in the sample set. */
  seriesMasterId?: Maybe<Scalars['JSON']['output']>;
  showAs?: Maybe<Scalars['String']['output']>;
  start?: Maybe<StudentAdksFieldsSetupEventsWeeklyMeetingStart>;
  status?: Maybe<Scalars['String']['output']>;
  subject?: Maybe<Scalars['String']['output']>;
  summary?: Maybe<Scalars['String']['output']>;
  /** Could not determine type: the field only had null or empty values in the sample set. */
  transactionId?: Maybe<Scalars['JSON']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updated?: Maybe<Scalars['String']['output']>;
  webLink?: Maybe<Scalars['String']['output']>;
};

export type StudentAdksFieldsSetupEventsWeeklyMeetingAttendees = {
  __typename?: 'StudentAdksFieldsSetupEventsWeeklyMeetingAttendees';
  email?: Maybe<Scalars['String']['output']>;
  emailAddress?: Maybe<StudentAdksFieldsSetupEventsWeeklyMeetingAttendeesEmailAddress>;
  organizer?: Maybe<Scalars['Boolean']['output']>;
  responseStatus?: Maybe<Scalars['String']['output']>;
  self?: Maybe<Scalars['Boolean']['output']>;
  status?: Maybe<StudentAdksFieldsSetupEventsWeeklyMeetingAttendeesStatus>;
  type?: Maybe<Scalars['String']['output']>;
};

export type StudentAdksFieldsSetupEventsWeeklyMeetingAttendeesCreateInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  emailAddress?: InputMaybe<StudentAdksFieldsSetupEventsWeeklyMeetingAttendeesEmailAddressCreateInput>;
  organizer?: InputMaybe<Scalars['Boolean']['input']>;
  responseStatus?: InputMaybe<Scalars['String']['input']>;
  self?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<StudentAdksFieldsSetupEventsWeeklyMeetingAttendeesStatusCreateInput>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type StudentAdksFieldsSetupEventsWeeklyMeetingAttendeesEmailAddress = {
  __typename?: 'StudentAdksFieldsSetupEventsWeeklyMeetingAttendeesEmailAddress';
  address: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type StudentAdksFieldsSetupEventsWeeklyMeetingAttendeesEmailAddressCreateInput = {
  address: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type StudentAdksFieldsSetupEventsWeeklyMeetingAttendeesEmailAddressObjectEqualityInput = {
  address: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type StudentAdksFieldsSetupEventsWeeklyMeetingAttendeesObjectEqualityInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  emailAddress?: InputMaybe<StudentAdksFieldsSetupEventsWeeklyMeetingAttendeesEmailAddressObjectEqualityInput>;
  organizer?: InputMaybe<Scalars['Boolean']['input']>;
  responseStatus?: InputMaybe<Scalars['String']['input']>;
  self?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<StudentAdksFieldsSetupEventsWeeklyMeetingAttendeesStatusObjectEqualityInput>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type StudentAdksFieldsSetupEventsWeeklyMeetingAttendeesStatus = {
  __typename?: 'StudentAdksFieldsSetupEventsWeeklyMeetingAttendeesStatus';
  response: Scalars['String']['output'];
  time: Scalars['String']['output'];
};

export type StudentAdksFieldsSetupEventsWeeklyMeetingAttendeesStatusCreateInput = {
  response: Scalars['String']['input'];
  time: Scalars['String']['input'];
};

export type StudentAdksFieldsSetupEventsWeeklyMeetingAttendeesStatusObjectEqualityInput = {
  response: Scalars['String']['input'];
  time: Scalars['String']['input'];
};

export type StudentAdksFieldsSetupEventsWeeklyMeetingBody = {
  __typename?: 'StudentAdksFieldsSetupEventsWeeklyMeetingBody';
  content: Scalars['String']['output'];
  contentType: Scalars['String']['output'];
};

export type StudentAdksFieldsSetupEventsWeeklyMeetingBodyCreateInput = {
  content: Scalars['String']['input'];
  contentType: Scalars['String']['input'];
};

export type StudentAdksFieldsSetupEventsWeeklyMeetingBodyObjectEqualityInput = {
  content: Scalars['String']['input'];
  contentType: Scalars['String']['input'];
};

export type StudentAdksFieldsSetupEventsWeeklyMeetingConferenceData = {
  __typename?: 'StudentAdksFieldsSetupEventsWeeklyMeetingConferenceData';
  conferenceId: Scalars['String']['output'];
  conferenceSolution: StudentAdksFieldsSetupEventsWeeklyMeetingConferenceDataConferenceSolution;
  createRequest: StudentAdksFieldsSetupEventsWeeklyMeetingConferenceDataCreateRequest;
  entryPoints?: Maybe<Array<StudentAdksFieldsSetupEventsWeeklyMeetingConferenceDataEntryPoints>>;
};

export type StudentAdksFieldsSetupEventsWeeklyMeetingConferenceDataConferenceSolution = {
  __typename?: 'StudentAdksFieldsSetupEventsWeeklyMeetingConferenceDataConferenceSolution';
  iconUri: Scalars['String']['output'];
  key: StudentAdksFieldsSetupEventsWeeklyMeetingConferenceDataConferenceSolutionKey;
  name: Scalars['String']['output'];
};

export type StudentAdksFieldsSetupEventsWeeklyMeetingConferenceDataConferenceSolutionCreateInput = {
  iconUri: Scalars['String']['input'];
  key: StudentAdksFieldsSetupEventsWeeklyMeetingConferenceDataConferenceSolutionKeyCreateInput;
  name: Scalars['String']['input'];
};

export type StudentAdksFieldsSetupEventsWeeklyMeetingConferenceDataConferenceSolutionKey = {
  __typename?: 'StudentAdksFieldsSetupEventsWeeklyMeetingConferenceDataConferenceSolutionKey';
  type: Scalars['String']['output'];
};

export type StudentAdksFieldsSetupEventsWeeklyMeetingConferenceDataConferenceSolutionKeyCreateInput = {
  type: Scalars['String']['input'];
};

export type StudentAdksFieldsSetupEventsWeeklyMeetingConferenceDataConferenceSolutionKeyObjectEqualityInput = {
  type: Scalars['String']['input'];
};

export type StudentAdksFieldsSetupEventsWeeklyMeetingConferenceDataConferenceSolutionObjectEqualityInput = {
  iconUri: Scalars['String']['input'];
  key: StudentAdksFieldsSetupEventsWeeklyMeetingConferenceDataConferenceSolutionKeyObjectEqualityInput;
  name: Scalars['String']['input'];
};

export type StudentAdksFieldsSetupEventsWeeklyMeetingConferenceDataCreateInput = {
  conferenceId: Scalars['String']['input'];
  conferenceSolution: StudentAdksFieldsSetupEventsWeeklyMeetingConferenceDataConferenceSolutionCreateInput;
  createRequest: StudentAdksFieldsSetupEventsWeeklyMeetingConferenceDataCreateRequestCreateInput;
  entryPoints?: InputMaybe<Array<StudentAdksFieldsSetupEventsWeeklyMeetingConferenceDataEntryPointsCreateInput>>;
};

export type StudentAdksFieldsSetupEventsWeeklyMeetingConferenceDataCreateRequest = {
  __typename?: 'StudentAdksFieldsSetupEventsWeeklyMeetingConferenceDataCreateRequest';
  conferenceSolutionKey: StudentAdksFieldsSetupEventsWeeklyMeetingConferenceDataCreateRequestConferenceSolutionKey;
  requestId: Scalars['String']['output'];
  status: StudentAdksFieldsSetupEventsWeeklyMeetingConferenceDataCreateRequestStatus;
};

export type StudentAdksFieldsSetupEventsWeeklyMeetingConferenceDataCreateRequestConferenceSolutionKey = {
  __typename?: 'StudentAdksFieldsSetupEventsWeeklyMeetingConferenceDataCreateRequestConferenceSolutionKey';
  type: Scalars['String']['output'];
};

export type StudentAdksFieldsSetupEventsWeeklyMeetingConferenceDataCreateRequestConferenceSolutionKeyCreateInput = {
  type: Scalars['String']['input'];
};

export type StudentAdksFieldsSetupEventsWeeklyMeetingConferenceDataCreateRequestConferenceSolutionKeyObjectEqualityInput = {
  type: Scalars['String']['input'];
};

export type StudentAdksFieldsSetupEventsWeeklyMeetingConferenceDataCreateRequestCreateInput = {
  conferenceSolutionKey: StudentAdksFieldsSetupEventsWeeklyMeetingConferenceDataCreateRequestConferenceSolutionKeyCreateInput;
  requestId: Scalars['String']['input'];
  status: StudentAdksFieldsSetupEventsWeeklyMeetingConferenceDataCreateRequestStatusCreateInput;
};

export type StudentAdksFieldsSetupEventsWeeklyMeetingConferenceDataCreateRequestObjectEqualityInput = {
  conferenceSolutionKey: StudentAdksFieldsSetupEventsWeeklyMeetingConferenceDataCreateRequestConferenceSolutionKeyObjectEqualityInput;
  requestId: Scalars['String']['input'];
  status: StudentAdksFieldsSetupEventsWeeklyMeetingConferenceDataCreateRequestStatusObjectEqualityInput;
};

export type StudentAdksFieldsSetupEventsWeeklyMeetingConferenceDataCreateRequestStatus = {
  __typename?: 'StudentAdksFieldsSetupEventsWeeklyMeetingConferenceDataCreateRequestStatus';
  statusCode: Scalars['String']['output'];
};

export type StudentAdksFieldsSetupEventsWeeklyMeetingConferenceDataCreateRequestStatusCreateInput = {
  statusCode: Scalars['String']['input'];
};

export type StudentAdksFieldsSetupEventsWeeklyMeetingConferenceDataCreateRequestStatusObjectEqualityInput = {
  statusCode: Scalars['String']['input'];
};

export type StudentAdksFieldsSetupEventsWeeklyMeetingConferenceDataEntryPoints = {
  __typename?: 'StudentAdksFieldsSetupEventsWeeklyMeetingConferenceDataEntryPoints';
  entryPointType: Scalars['String']['output'];
  label?: Maybe<Scalars['String']['output']>;
  pin?: Maybe<Scalars['String']['output']>;
  regionCode?: Maybe<Scalars['String']['output']>;
  uri: Scalars['String']['output'];
};

export type StudentAdksFieldsSetupEventsWeeklyMeetingConferenceDataEntryPointsCreateInput = {
  entryPointType: Scalars['String']['input'];
  label?: InputMaybe<Scalars['String']['input']>;
  pin?: InputMaybe<Scalars['String']['input']>;
  regionCode?: InputMaybe<Scalars['String']['input']>;
  uri: Scalars['String']['input'];
};

export type StudentAdksFieldsSetupEventsWeeklyMeetingConferenceDataEntryPointsObjectEqualityInput = {
  entryPointType: Scalars['String']['input'];
  label?: InputMaybe<Scalars['String']['input']>;
  pin?: InputMaybe<Scalars['String']['input']>;
  regionCode?: InputMaybe<Scalars['String']['input']>;
  uri: Scalars['String']['input'];
};

export type StudentAdksFieldsSetupEventsWeeklyMeetingConferenceDataObjectEqualityInput = {
  conferenceId: Scalars['String']['input'];
  conferenceSolution: StudentAdksFieldsSetupEventsWeeklyMeetingConferenceDataConferenceSolutionObjectEqualityInput;
  createRequest: StudentAdksFieldsSetupEventsWeeklyMeetingConferenceDataCreateRequestObjectEqualityInput;
  entryPoints?: InputMaybe<Array<StudentAdksFieldsSetupEventsWeeklyMeetingConferenceDataEntryPointsObjectEqualityInput>>;
};

export type StudentAdksFieldsSetupEventsWeeklyMeetingCreateInput = {
  allowNewTimeProposals?: InputMaybe<Scalars['Boolean']['input']>;
  attendees?: InputMaybe<Array<StudentAdksFieldsSetupEventsWeeklyMeetingAttendeesCreateInput>>;
  body?: InputMaybe<StudentAdksFieldsSetupEventsWeeklyMeetingBodyCreateInput>;
  bodyPreview?: InputMaybe<Scalars['String']['input']>;
  categories?: InputMaybe<Scalars['JSON']['input']>;
  changeKey?: InputMaybe<Scalars['String']['input']>;
  conferenceData?: InputMaybe<StudentAdksFieldsSetupEventsWeeklyMeetingConferenceDataCreateInput>;
  created?: InputMaybe<Scalars['String']['input']>;
  createdDateTime?: InputMaybe<Scalars['String']['input']>;
  creator?: InputMaybe<StudentAdksFieldsSetupEventsWeeklyMeetingCreatorCreateInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  end?: InputMaybe<StudentAdksFieldsSetupEventsWeeklyMeetingEndCreateInput>;
  error?: InputMaybe<StudentAdksFieldsSetupEventsWeeklyMeetingErrorCreateInput>;
  etag?: InputMaybe<Scalars['String']['input']>;
  eventType?: InputMaybe<Scalars['String']['input']>;
  hangoutLink?: InputMaybe<Scalars['String']['input']>;
  hasAttachments?: InputMaybe<Scalars['Boolean']['input']>;
  hideAttendees?: InputMaybe<Scalars['Boolean']['input']>;
  htmlLink?: InputMaybe<Scalars['String']['input']>;
  iCalUID?: InputMaybe<Scalars['String']['input']>;
  iCalUId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  importance?: InputMaybe<Scalars['String']['input']>;
  isAllDay?: InputMaybe<Scalars['Boolean']['input']>;
  isCancelled?: InputMaybe<Scalars['Boolean']['input']>;
  isDraft?: InputMaybe<Scalars['Boolean']['input']>;
  isOnlineMeeting?: InputMaybe<Scalars['Boolean']['input']>;
  isOrganizer?: InputMaybe<Scalars['Boolean']['input']>;
  isReminderOn?: InputMaybe<Scalars['Boolean']['input']>;
  kind?: InputMaybe<Scalars['String']['input']>;
  lastModifiedDateTime?: InputMaybe<Scalars['String']['input']>;
  location?: InputMaybe<Scalars['JSON']['input']>;
  locations?: InputMaybe<Array<StudentAdksFieldsSetupEventsWeeklyMeetingLocationsCreateInput>>;
  occurrenceId?: InputMaybe<Scalars['JSON']['input']>;
  odata_context?: InputMaybe<Scalars['String']['input']>;
  odata_etag?: InputMaybe<Scalars['String']['input']>;
  onlineMeeting?: InputMaybe<Scalars['JSON']['input']>;
  onlineMeetingProvider?: InputMaybe<Scalars['String']['input']>;
  onlineMeetingUrl?: InputMaybe<Scalars['JSON']['input']>;
  organizer?: InputMaybe<StudentAdksFieldsSetupEventsWeeklyMeetingOrganizerCreateInput>;
  originalEndTimeZone?: InputMaybe<Scalars['String']['input']>;
  originalStartTimeZone?: InputMaybe<Scalars['String']['input']>;
  recurrence?: InputMaybe<Scalars['JSON']['input']>;
  reminderMinutesBeforeStart?: InputMaybe<Scalars['Int']['input']>;
  reminders?: InputMaybe<StudentAdksFieldsSetupEventsWeeklyMeetingRemindersCreateInput>;
  responseRequested?: InputMaybe<Scalars['Boolean']['input']>;
  responseStatus?: InputMaybe<StudentAdksFieldsSetupEventsWeeklyMeetingResponseStatusCreateInput>;
  sensitivity?: InputMaybe<Scalars['String']['input']>;
  sequence?: InputMaybe<Scalars['Int']['input']>;
  seriesMasterId?: InputMaybe<Scalars['JSON']['input']>;
  showAs?: InputMaybe<Scalars['String']['input']>;
  start?: InputMaybe<StudentAdksFieldsSetupEventsWeeklyMeetingStartCreateInput>;
  status?: InputMaybe<Scalars['String']['input']>;
  subject?: InputMaybe<Scalars['String']['input']>;
  summary?: InputMaybe<Scalars['String']['input']>;
  transactionId?: InputMaybe<Scalars['JSON']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  updated?: InputMaybe<Scalars['String']['input']>;
  webLink?: InputMaybe<Scalars['String']['input']>;
};

export type StudentAdksFieldsSetupEventsWeeklyMeetingCreator = {
  __typename?: 'StudentAdksFieldsSetupEventsWeeklyMeetingCreator';
  email: Scalars['String']['output'];
  self: Scalars['Boolean']['output'];
};

export type StudentAdksFieldsSetupEventsWeeklyMeetingCreatorCreateInput = {
  email: Scalars['String']['input'];
  self: Scalars['Boolean']['input'];
};

export type StudentAdksFieldsSetupEventsWeeklyMeetingCreatorObjectEqualityInput = {
  email: Scalars['String']['input'];
  self: Scalars['Boolean']['input'];
};

export type StudentAdksFieldsSetupEventsWeeklyMeetingEnd = {
  __typename?: 'StudentAdksFieldsSetupEventsWeeklyMeetingEnd';
  dateTime: Scalars['String']['output'];
  timeZone: Scalars['String']['output'];
};

export type StudentAdksFieldsSetupEventsWeeklyMeetingEndCreateInput = {
  dateTime: Scalars['String']['input'];
  timeZone: Scalars['String']['input'];
};

export type StudentAdksFieldsSetupEventsWeeklyMeetingEndObjectEqualityInput = {
  dateTime: Scalars['String']['input'];
  timeZone: Scalars['String']['input'];
};

export type StudentAdksFieldsSetupEventsWeeklyMeetingError = {
  __typename?: 'StudentAdksFieldsSetupEventsWeeklyMeetingError';
  code: Scalars['Int']['output'];
  errors?: Maybe<Array<StudentAdksFieldsSetupEventsWeeklyMeetingErrorErrors>>;
  message: Scalars['String']['output'];
  status: Scalars['String']['output'];
};

export type StudentAdksFieldsSetupEventsWeeklyMeetingErrorCreateInput = {
  code: Scalars['Int']['input'];
  errors?: InputMaybe<Array<StudentAdksFieldsSetupEventsWeeklyMeetingErrorErrorsCreateInput>>;
  message: Scalars['String']['input'];
  status: Scalars['String']['input'];
};

export type StudentAdksFieldsSetupEventsWeeklyMeetingErrorErrors = {
  __typename?: 'StudentAdksFieldsSetupEventsWeeklyMeetingErrorErrors';
  domain: Scalars['String']['output'];
  location: Scalars['String']['output'];
  locationType: Scalars['String']['output'];
  message: Scalars['String']['output'];
  reason: Scalars['String']['output'];
};

export type StudentAdksFieldsSetupEventsWeeklyMeetingErrorErrorsCreateInput = {
  domain: Scalars['String']['input'];
  location: Scalars['String']['input'];
  locationType: Scalars['String']['input'];
  message: Scalars['String']['input'];
  reason: Scalars['String']['input'];
};

export type StudentAdksFieldsSetupEventsWeeklyMeetingErrorErrorsObjectEqualityInput = {
  domain: Scalars['String']['input'];
  location: Scalars['String']['input'];
  locationType: Scalars['String']['input'];
  message: Scalars['String']['input'];
  reason: Scalars['String']['input'];
};

export type StudentAdksFieldsSetupEventsWeeklyMeetingErrorObjectEqualityInput = {
  code: Scalars['Int']['input'];
  errors?: InputMaybe<Array<StudentAdksFieldsSetupEventsWeeklyMeetingErrorErrorsObjectEqualityInput>>;
  message: Scalars['String']['input'];
  status: Scalars['String']['input'];
};

export type StudentAdksFieldsSetupEventsWeeklyMeetingLocations = {
  __typename?: 'StudentAdksFieldsSetupEventsWeeklyMeetingLocations';
  displayName: Scalars['String']['output'];
  locationType: Scalars['String']['output'];
  uniqueId: Scalars['String']['output'];
  uniqueIdType: Scalars['String']['output'];
};

export type StudentAdksFieldsSetupEventsWeeklyMeetingLocationsCreateInput = {
  displayName: Scalars['String']['input'];
  locationType: Scalars['String']['input'];
  uniqueId: Scalars['String']['input'];
  uniqueIdType: Scalars['String']['input'];
};

export type StudentAdksFieldsSetupEventsWeeklyMeetingLocationsObjectEqualityInput = {
  displayName: Scalars['String']['input'];
  locationType: Scalars['String']['input'];
  uniqueId: Scalars['String']['input'];
  uniqueIdType: Scalars['String']['input'];
};

export type StudentAdksFieldsSetupEventsWeeklyMeetingObjectEqualityInput = {
  allowNewTimeProposals?: InputMaybe<Scalars['Boolean']['input']>;
  attendees?: InputMaybe<Array<StudentAdksFieldsSetupEventsWeeklyMeetingAttendeesObjectEqualityInput>>;
  body?: InputMaybe<StudentAdksFieldsSetupEventsWeeklyMeetingBodyObjectEqualityInput>;
  bodyPreview?: InputMaybe<Scalars['String']['input']>;
  categories?: InputMaybe<Scalars['JSON']['input']>;
  changeKey?: InputMaybe<Scalars['String']['input']>;
  conferenceData?: InputMaybe<StudentAdksFieldsSetupEventsWeeklyMeetingConferenceDataObjectEqualityInput>;
  created?: InputMaybe<Scalars['String']['input']>;
  createdDateTime?: InputMaybe<Scalars['String']['input']>;
  creator?: InputMaybe<StudentAdksFieldsSetupEventsWeeklyMeetingCreatorObjectEqualityInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  end?: InputMaybe<StudentAdksFieldsSetupEventsWeeklyMeetingEndObjectEqualityInput>;
  error?: InputMaybe<StudentAdksFieldsSetupEventsWeeklyMeetingErrorObjectEqualityInput>;
  etag?: InputMaybe<Scalars['String']['input']>;
  eventType?: InputMaybe<Scalars['String']['input']>;
  hangoutLink?: InputMaybe<Scalars['String']['input']>;
  hasAttachments?: InputMaybe<Scalars['Boolean']['input']>;
  hideAttendees?: InputMaybe<Scalars['Boolean']['input']>;
  htmlLink?: InputMaybe<Scalars['String']['input']>;
  iCalUID?: InputMaybe<Scalars['String']['input']>;
  iCalUId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  importance?: InputMaybe<Scalars['String']['input']>;
  isAllDay?: InputMaybe<Scalars['Boolean']['input']>;
  isCancelled?: InputMaybe<Scalars['Boolean']['input']>;
  isDraft?: InputMaybe<Scalars['Boolean']['input']>;
  isOnlineMeeting?: InputMaybe<Scalars['Boolean']['input']>;
  isOrganizer?: InputMaybe<Scalars['Boolean']['input']>;
  isReminderOn?: InputMaybe<Scalars['Boolean']['input']>;
  kind?: InputMaybe<Scalars['String']['input']>;
  lastModifiedDateTime?: InputMaybe<Scalars['String']['input']>;
  location?: InputMaybe<Scalars['JSON']['input']>;
  locations?: InputMaybe<Array<StudentAdksFieldsSetupEventsWeeklyMeetingLocationsObjectEqualityInput>>;
  occurrenceId?: InputMaybe<Scalars['JSON']['input']>;
  odata_context?: InputMaybe<Scalars['String']['input']>;
  odata_etag?: InputMaybe<Scalars['String']['input']>;
  onlineMeeting?: InputMaybe<Scalars['JSON']['input']>;
  onlineMeetingProvider?: InputMaybe<Scalars['String']['input']>;
  onlineMeetingUrl?: InputMaybe<Scalars['JSON']['input']>;
  organizer?: InputMaybe<StudentAdksFieldsSetupEventsWeeklyMeetingOrganizerObjectEqualityInput>;
  originalEndTimeZone?: InputMaybe<Scalars['String']['input']>;
  originalStartTimeZone?: InputMaybe<Scalars['String']['input']>;
  recurrence?: InputMaybe<Scalars['JSON']['input']>;
  reminderMinutesBeforeStart?: InputMaybe<Scalars['Int']['input']>;
  reminders?: InputMaybe<StudentAdksFieldsSetupEventsWeeklyMeetingRemindersObjectEqualityInput>;
  responseRequested?: InputMaybe<Scalars['Boolean']['input']>;
  responseStatus?: InputMaybe<StudentAdksFieldsSetupEventsWeeklyMeetingResponseStatusObjectEqualityInput>;
  sensitivity?: InputMaybe<Scalars['String']['input']>;
  sequence?: InputMaybe<Scalars['Int']['input']>;
  seriesMasterId?: InputMaybe<Scalars['JSON']['input']>;
  showAs?: InputMaybe<Scalars['String']['input']>;
  start?: InputMaybe<StudentAdksFieldsSetupEventsWeeklyMeetingStartObjectEqualityInput>;
  status?: InputMaybe<Scalars['String']['input']>;
  subject?: InputMaybe<Scalars['String']['input']>;
  summary?: InputMaybe<Scalars['String']['input']>;
  transactionId?: InputMaybe<Scalars['JSON']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  updated?: InputMaybe<Scalars['String']['input']>;
  webLink?: InputMaybe<Scalars['String']['input']>;
};

export type StudentAdksFieldsSetupEventsWeeklyMeetingOrganizer = {
  __typename?: 'StudentAdksFieldsSetupEventsWeeklyMeetingOrganizer';
  email?: Maybe<Scalars['String']['output']>;
  emailAddress?: Maybe<StudentAdksFieldsSetupEventsWeeklyMeetingOrganizerEmailAddress>;
  self?: Maybe<Scalars['Boolean']['output']>;
};

export type StudentAdksFieldsSetupEventsWeeklyMeetingOrganizerCreateInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  emailAddress?: InputMaybe<StudentAdksFieldsSetupEventsWeeklyMeetingOrganizerEmailAddressCreateInput>;
  self?: InputMaybe<Scalars['Boolean']['input']>;
};

export type StudentAdksFieldsSetupEventsWeeklyMeetingOrganizerEmailAddress = {
  __typename?: 'StudentAdksFieldsSetupEventsWeeklyMeetingOrganizerEmailAddress';
  address: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type StudentAdksFieldsSetupEventsWeeklyMeetingOrganizerEmailAddressCreateInput = {
  address: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type StudentAdksFieldsSetupEventsWeeklyMeetingOrganizerEmailAddressObjectEqualityInput = {
  address: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type StudentAdksFieldsSetupEventsWeeklyMeetingOrganizerObjectEqualityInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  emailAddress?: InputMaybe<StudentAdksFieldsSetupEventsWeeklyMeetingOrganizerEmailAddressObjectEqualityInput>;
  self?: InputMaybe<Scalars['Boolean']['input']>;
};

export type StudentAdksFieldsSetupEventsWeeklyMeetingReminders = {
  __typename?: 'StudentAdksFieldsSetupEventsWeeklyMeetingReminders';
  overrides?: Maybe<Array<StudentAdksFieldsSetupEventsWeeklyMeetingRemindersOverrides>>;
  useDefault: Scalars['Boolean']['output'];
};

export type StudentAdksFieldsSetupEventsWeeklyMeetingRemindersCreateInput = {
  overrides?: InputMaybe<Array<StudentAdksFieldsSetupEventsWeeklyMeetingRemindersOverridesCreateInput>>;
  useDefault: Scalars['Boolean']['input'];
};

export type StudentAdksFieldsSetupEventsWeeklyMeetingRemindersObjectEqualityInput = {
  overrides?: InputMaybe<Array<StudentAdksFieldsSetupEventsWeeklyMeetingRemindersOverridesObjectEqualityInput>>;
  useDefault: Scalars['Boolean']['input'];
};

export type StudentAdksFieldsSetupEventsWeeklyMeetingRemindersOverrides = {
  __typename?: 'StudentAdksFieldsSetupEventsWeeklyMeetingRemindersOverrides';
  method: Scalars['String']['output'];
  minutes: Scalars['Int']['output'];
};

export type StudentAdksFieldsSetupEventsWeeklyMeetingRemindersOverridesCreateInput = {
  method: Scalars['String']['input'];
  minutes: Scalars['Int']['input'];
};

export type StudentAdksFieldsSetupEventsWeeklyMeetingRemindersOverridesObjectEqualityInput = {
  method: Scalars['String']['input'];
  minutes: Scalars['Int']['input'];
};

export type StudentAdksFieldsSetupEventsWeeklyMeetingResponseStatus = {
  __typename?: 'StudentAdksFieldsSetupEventsWeeklyMeetingResponseStatus';
  response: Scalars['String']['output'];
  time: Scalars['String']['output'];
};

export type StudentAdksFieldsSetupEventsWeeklyMeetingResponseStatusCreateInput = {
  response: Scalars['String']['input'];
  time: Scalars['String']['input'];
};

export type StudentAdksFieldsSetupEventsWeeklyMeetingResponseStatusObjectEqualityInput = {
  response: Scalars['String']['input'];
  time: Scalars['String']['input'];
};

export type StudentAdksFieldsSetupEventsWeeklyMeetingStart = {
  __typename?: 'StudentAdksFieldsSetupEventsWeeklyMeetingStart';
  dateTime: Scalars['String']['output'];
  timeZone: Scalars['String']['output'];
};

export type StudentAdksFieldsSetupEventsWeeklyMeetingStartCreateInput = {
  dateTime: Scalars['String']['input'];
  timeZone: Scalars['String']['input'];
};

export type StudentAdksFieldsSetupEventsWeeklyMeetingStartObjectEqualityInput = {
  dateTime: Scalars['String']['input'];
  timeZone: Scalars['String']['input'];
};

export type StudentAdksFieldsSetupObjectEqualityInput = {
  Description_1689596544146?: InputMaybe<Scalars['String']['input']>;
  Description_1689610327886?: InputMaybe<Scalars['String']['input']>;
  Select_1689610316209?: InputMaybe<Scalars['String']['input']>;
  aboutOrg?: InputMaybe<Scalars['String']['input']>;
  acceptanceDeadline?: InputMaybe<Scalars['String']['input']>;
  action?: InputMaybe<StudentAdksFieldsSetupActionObjectEqualityInput>;
  ageRange?: InputMaybe<Scalars['JSON']['input']>;
  airtableFormLink?: InputMaybe<Scalars['String']['input']>;
  airtableLink?: InputMaybe<Scalars['String']['input']>;
  airtableResponseLink?: InputMaybe<Scalars['String']['input']>;
  airtableTableLink?: InputMaybe<Scalars['String']['input']>;
  apprentice?: InputMaybe<Scalars['Boolean']['input']>;
  arrivalLink?: InputMaybe<Scalars['String']['input']>;
  arrivalStatus?: InputMaybe<Scalars['String']['input']>;
  attendeeList?: InputMaybe<Scalars['String']['input']>;
  boards?: InputMaybe<Array<StudentAdksFieldsSetupBoardsObjectEqualityInput>>;
  channels?: InputMaybe<Array<StudentAdksFieldsSetupChannelsObjectEqualityInput>>;
  checkinLink?: InputMaybe<Scalars['String']['input']>;
  compensation1?: InputMaybe<Scalars['Boolean']['input']>;
  compensation2?: InputMaybe<Scalars['Boolean']['input']>;
  compensation3?: InputMaybe<Scalars['Boolean']['input']>;
  compensation4?: InputMaybe<Scalars['Boolean']['input']>;
  compensation5?: InputMaybe<Scalars['Boolean']['input']>;
  compensation6?: InputMaybe<Scalars['Boolean']['input']>;
  connection?: InputMaybe<Scalars['String']['input']>;
  continuation?: InputMaybe<Scalars['Int']['input']>;
  defaultActivity?: InputMaybe<StudentAdksFieldsSetupDefaultActivityObjectEqualityInput>;
  deliverable?: InputMaybe<Array<Scalars['String']['input']>>;
  directoryPreferences?: InputMaybe<Array<StudentAdksFieldsSetupDirectoryPreferencesObjectEqualityInput>>;
  discordData?: InputMaybe<StudentAdksFieldsSetupDiscordDataObjectEqualityInput>;
  discordLink?: InputMaybe<Scalars['String']['input']>;
  docDesc?: InputMaybe<Scalars['String']['input']>;
  driveLink?: InputMaybe<Scalars['String']['input']>;
  eir?: InputMaybe<Scalars['Boolean']['input']>;
  employerRecord?: InputMaybe<Scalars['Int']['input']>;
  endEarlyActivity?: InputMaybe<Scalars['String']['input']>;
  eventAgenda?: InputMaybe<Scalars['String']['input']>;
  eventDate?: InputMaybe<Scalars['String']['input']>;
  eventLocations?: InputMaybe<Scalars['String']['input']>;
  eventName?: InputMaybe<Scalars['String']['input']>;
  events?: InputMaybe<StudentAdksFieldsSetupEventsObjectEqualityInput>;
  extern?: InputMaybe<Scalars['Boolean']['input']>;
  externCredential?: InputMaybe<Scalars['JSON']['input']>;
  fellow?: InputMaybe<Scalars['Boolean']['input']>;
  fileType?: InputMaybe<Array<Scalars['String']['input']>>;
  form_id?: InputMaybe<Scalars['String']['input']>;
  form_url?: InputMaybe<Scalars['String']['input']>;
  groupActivity?: InputMaybe<Scalars['String']['input']>;
  instructions?: InputMaybe<Scalars['String']['input']>;
  intern?: InputMaybe<Scalars['Boolean']['input']>;
  internshipEnd?: InputMaybe<Scalars['String']['input']>;
  internshipProject1?: InputMaybe<Scalars['Boolean']['input']>;
  internshipProject2?: InputMaybe<Scalars['Boolean']['input']>;
  internshipProject3?: InputMaybe<Scalars['Boolean']['input']>;
  internshipStart?: InputMaybe<Scalars['String']['input']>;
  interviewChallenge?: InputMaybe<Scalars['String']['input']>;
  interviewOpportunity?: InputMaybe<Scalars['String']['input']>;
  interviewProblem?: InputMaybe<Scalars['String']['input']>;
  interviewRequest?: InputMaybe<Scalars['String']['input']>;
  interviewSolution?: InputMaybe<Scalars['String']['input']>;
  licenseRequirement?: InputMaybe<Scalars['Int']['input']>;
  maxCharacters?: InputMaybe<Scalars['String']['input']>;
  maxHours?: InputMaybe<Scalars['Int']['input']>;
  maxQuestions?: InputMaybe<Scalars['Int']['input']>;
  maxTeamMembers?: InputMaybe<Scalars['Int']['input']>;
  maximumBudget?: InputMaybe<Scalars['String']['input']>;
  minHours?: InputMaybe<Scalars['Int']['input']>;
  minLogs?: InputMaybe<Scalars['Int']['input']>;
  minimumBudget?: InputMaybe<Scalars['String']['input']>;
  minimumHoursNow?: InputMaybe<Scalars['String']['input']>;
  outcome?: InputMaybe<Array<Scalars['String']['input']>>;
  pathways?: InputMaybe<Array<Scalars['String']['input']>>;
  preApprentice?: InputMaybe<Scalars['Boolean']['input']>;
  preInternship?: InputMaybe<Scalars['Boolean']['input']>;
  programDesc?: InputMaybe<Scalars['String']['input']>;
  programName?: InputMaybe<Scalars['String']['input']>;
  projectReq?: InputMaybe<Scalars['JSON']['input']>;
  providers?: InputMaybe<StudentAdksFieldsSetupProvidersObjectEqualityInput>;
  requiredActivity?: InputMaybe<Scalars['String']['input']>;
  requiredResidency?: InputMaybe<Scalars['JSON']['input']>;
  requiredSkills?: InputMaybe<Array<Scalars['String']['input']>>;
  researchLinks?: InputMaybe<Array<StudentAdksFieldsSetupResearchLinksObjectEqualityInput>>;
  researchProgress?: InputMaybe<Array<StudentAdksFieldsSetupResearchProgressObjectEqualityInput>>;
  resourceDrive?: InputMaybe<Scalars['String']['input']>;
  resourceFacebook?: InputMaybe<Scalars['String']['input']>;
  resourceInsta?: InputMaybe<Scalars['String']['input']>;
  resourceLinkedIn?: InputMaybe<Scalars['String']['input']>;
  resourceTwitter?: InputMaybe<Scalars['String']['input']>;
  resourceWeb?: InputMaybe<Scalars['String']['input']>;
  resourceYouTube?: InputMaybe<Scalars['String']['input']>;
  rewards?: InputMaybe<Array<Scalars['String']['input']>>;
  rsvpLink?: InputMaybe<Scalars['String']['input']>;
  settings?: InputMaybe<StudentAdksFieldsSetupSettingsObjectEqualityInput>;
  signInVideoAskResponse?: InputMaybe<StudentAdksFieldsSetupSignInVideoAskResponseObjectEqualityInput>;
  text_input_1689596540310?: InputMaybe<Scalars['String']['input']>;
  timeFrame?: InputMaybe<Array<StudentAdksFieldsSetupTimeFrameObjectEqualityInput>>;
  timeZone?: InputMaybe<Scalars['String']['input']>;
  trainProgress?: InputMaybe<Array<StudentAdksFieldsSetupTrainProgressObjectEqualityInput>>;
  uploadLimit?: InputMaybe<StudentAdksFieldsSetupUploadLimitObjectEqualityInput>;
  uploadLink?: InputMaybe<Scalars['String']['input']>;
  videoLinks?: InputMaybe<Array<StudentAdksFieldsSetupVideoLinksObjectEqualityInput>>;
  videoMaxLength?: InputMaybe<Scalars['Int']['input']>;
  videoaskEmbed?: InputMaybe<Scalars['String']['input']>;
  videoaskLink?: InputMaybe<Scalars['String']['input']>;
  videoaskResponseLink?: InputMaybe<Scalars['String']['input']>;
  welcomeActivity?: InputMaybe<Scalars['String']['input']>;
  youtubeLink?: InputMaybe<Scalars['String']['input']>;
};

export type StudentAdksFieldsSetupProviders = {
  __typename?: 'StudentAdksFieldsSetupProviders';
  apple: Scalars['Boolean']['output'];
  google: Scalars['Boolean']['output'];
  web: Scalars['Boolean']['output'];
};

export type StudentAdksFieldsSetupProvidersCreateInput = {
  apple: Scalars['Boolean']['input'];
  google: Scalars['Boolean']['input'];
  web: Scalars['Boolean']['input'];
};

export type StudentAdksFieldsSetupProvidersObjectEqualityInput = {
  apple: Scalars['Boolean']['input'];
  google: Scalars['Boolean']['input'];
  web: Scalars['Boolean']['input'];
};

export type StudentAdksFieldsSetupResearchLinks = {
  __typename?: 'StudentAdksFieldsSetupResearchLinks';
  completed?: Maybe<Scalars['Boolean']['output']>;
  isValid?: Maybe<Scalars['Boolean']['output']>;
  link: Scalars['String']['output'];
  required: Scalars['Boolean']['output'];
  resource: Scalars['String']['output'];
  unlocked?: Maybe<Scalars['Boolean']['output']>;
};

export type StudentAdksFieldsSetupResearchLinksCreateInput = {
  completed?: InputMaybe<Scalars['Boolean']['input']>;
  isValid?: InputMaybe<Scalars['Boolean']['input']>;
  link: Scalars['String']['input'];
  required: Scalars['Boolean']['input'];
  resource: Scalars['String']['input'];
  unlocked?: InputMaybe<Scalars['Boolean']['input']>;
};

export type StudentAdksFieldsSetupResearchLinksObjectEqualityInput = {
  completed?: InputMaybe<Scalars['Boolean']['input']>;
  isValid?: InputMaybe<Scalars['Boolean']['input']>;
  link: Scalars['String']['input'];
  required: Scalars['Boolean']['input'];
  resource: Scalars['String']['input'];
  unlocked?: InputMaybe<Scalars['Boolean']['input']>;
};

export type StudentAdksFieldsSetupResearchProgress = {
  __typename?: 'StudentAdksFieldsSetupResearchProgress';
  completed?: Maybe<Scalars['Boolean']['output']>;
  link: Scalars['String']['output'];
  required: Scalars['Boolean']['output'];
  resource: Scalars['String']['output'];
  unlocked?: Maybe<Scalars['Boolean']['output']>;
};

export type StudentAdksFieldsSetupResearchProgressCreateInput = {
  completed?: InputMaybe<Scalars['Boolean']['input']>;
  link: Scalars['String']['input'];
  required: Scalars['Boolean']['input'];
  resource: Scalars['String']['input'];
  unlocked?: InputMaybe<Scalars['Boolean']['input']>;
};

export type StudentAdksFieldsSetupResearchProgressObjectEqualityInput = {
  completed?: InputMaybe<Scalars['Boolean']['input']>;
  link: Scalars['String']['input'];
  required: Scalars['Boolean']['input'];
  resource: Scalars['String']['input'];
  unlocked?: InputMaybe<Scalars['Boolean']['input']>;
};

export type StudentAdksFieldsSetupSettings = {
  __typename?: 'StudentAdksFieldsSetupSettings';
  caseStudySettings: StudentAdksFieldsSetupSettingsCaseStudySettings;
  digitalResumeSettings: Scalars['Boolean']['output'];
  presentationSettings: StudentAdksFieldsSetupSettingsPresentationSettings;
  projectFAQSettings: Scalars['Boolean']['output'];
  projectImplementationSettings: StudentAdksFieldsSetupSettingsProjectImplementationSettings;
  projectPlanSettings: StudentAdksFieldsSetupSettingsProjectPlanSettings;
  projectTaskSettings: StudentAdksFieldsSetupSettingsProjectTaskSettings;
  teamSettings: StudentAdksFieldsSetupSettingsTeamSettings;
  userInterviewSettings: StudentAdksFieldsSetupSettingsUserInterviewSettings;
};

export type StudentAdksFieldsSetupSettingsCaseStudySettings = {
  __typename?: 'StudentAdksFieldsSetupSettingsCaseStudySettings';
  contentSetting?: Maybe<Scalars['String']['output']>;
  required: Scalars['Boolean']['output'];
};

export type StudentAdksFieldsSetupSettingsCaseStudySettingsCreateInput = {
  contentSetting?: InputMaybe<Scalars['String']['input']>;
  required: Scalars['Boolean']['input'];
};

export type StudentAdksFieldsSetupSettingsCaseStudySettingsObjectEqualityInput = {
  contentSetting?: InputMaybe<Scalars['String']['input']>;
  required: Scalars['Boolean']['input'];
};

export type StudentAdksFieldsSetupSettingsCreateInput = {
  caseStudySettings: StudentAdksFieldsSetupSettingsCaseStudySettingsCreateInput;
  digitalResumeSettings: Scalars['Boolean']['input'];
  presentationSettings: StudentAdksFieldsSetupSettingsPresentationSettingsCreateInput;
  projectFAQSettings: Scalars['Boolean']['input'];
  projectImplementationSettings: StudentAdksFieldsSetupSettingsProjectImplementationSettingsCreateInput;
  projectPlanSettings: StudentAdksFieldsSetupSettingsProjectPlanSettingsCreateInput;
  projectTaskSettings: StudentAdksFieldsSetupSettingsProjectTaskSettingsCreateInput;
  teamSettings: StudentAdksFieldsSetupSettingsTeamSettingsCreateInput;
  userInterviewSettings: StudentAdksFieldsSetupSettingsUserInterviewSettingsCreateInput;
};

export type StudentAdksFieldsSetupSettingsObjectEqualityInput = {
  caseStudySettings: StudentAdksFieldsSetupSettingsCaseStudySettingsObjectEqualityInput;
  digitalResumeSettings: Scalars['Boolean']['input'];
  presentationSettings: StudentAdksFieldsSetupSettingsPresentationSettingsObjectEqualityInput;
  projectFAQSettings: Scalars['Boolean']['input'];
  projectImplementationSettings: StudentAdksFieldsSetupSettingsProjectImplementationSettingsObjectEqualityInput;
  projectPlanSettings: StudentAdksFieldsSetupSettingsProjectPlanSettingsObjectEqualityInput;
  projectTaskSettings: StudentAdksFieldsSetupSettingsProjectTaskSettingsObjectEqualityInput;
  teamSettings: StudentAdksFieldsSetupSettingsTeamSettingsObjectEqualityInput;
  userInterviewSettings: StudentAdksFieldsSetupSettingsUserInterviewSettingsObjectEqualityInput;
};

export type StudentAdksFieldsSetupSettingsPresentationSettings = {
  __typename?: 'StudentAdksFieldsSetupSettingsPresentationSettings';
  maxMins?: Maybe<Scalars['String']['output']>;
  required: Scalars['Boolean']['output'];
};

export type StudentAdksFieldsSetupSettingsPresentationSettingsCreateInput = {
  maxMins?: InputMaybe<Scalars['String']['input']>;
  required: Scalars['Boolean']['input'];
};

export type StudentAdksFieldsSetupSettingsPresentationSettingsObjectEqualityInput = {
  maxMins?: InputMaybe<Scalars['String']['input']>;
  required: Scalars['Boolean']['input'];
};

export type StudentAdksFieldsSetupSettingsProjectImplementationSettings = {
  __typename?: 'StudentAdksFieldsSetupSettingsProjectImplementationSettings';
  pilots?: Maybe<Scalars['String']['output']>;
  required: Scalars['Boolean']['output'];
};

export type StudentAdksFieldsSetupSettingsProjectImplementationSettingsCreateInput = {
  pilots?: InputMaybe<Scalars['String']['input']>;
  required: Scalars['Boolean']['input'];
};

export type StudentAdksFieldsSetupSettingsProjectImplementationSettingsObjectEqualityInput = {
  pilots?: InputMaybe<Scalars['String']['input']>;
  required: Scalars['Boolean']['input'];
};

export type StudentAdksFieldsSetupSettingsProjectPlanSettings = {
  __typename?: 'StudentAdksFieldsSetupSettingsProjectPlanSettings';
  prePopulate?: Maybe<Scalars['String']['output']>;
  required: Scalars['Boolean']['output'];
};

export type StudentAdksFieldsSetupSettingsProjectPlanSettingsCreateInput = {
  prePopulate?: InputMaybe<Scalars['String']['input']>;
  required: Scalars['Boolean']['input'];
};

export type StudentAdksFieldsSetupSettingsProjectPlanSettingsObjectEqualityInput = {
  prePopulate?: InputMaybe<Scalars['String']['input']>;
  required: Scalars['Boolean']['input'];
};

export type StudentAdksFieldsSetupSettingsProjectTaskSettings = {
  __typename?: 'StudentAdksFieldsSetupSettingsProjectTaskSettings';
  required: Scalars['Boolean']['output'];
  taskSetting?: Maybe<Scalars['String']['output']>;
};

export type StudentAdksFieldsSetupSettingsProjectTaskSettingsCreateInput = {
  required: Scalars['Boolean']['input'];
  taskSetting?: InputMaybe<Scalars['String']['input']>;
};

export type StudentAdksFieldsSetupSettingsProjectTaskSettingsObjectEqualityInput = {
  required: Scalars['Boolean']['input'];
  taskSetting?: InputMaybe<Scalars['String']['input']>;
};

export type StudentAdksFieldsSetupSettingsTeamSettings = {
  __typename?: 'StudentAdksFieldsSetupSettingsTeamSettings';
  editViewSetting?: Maybe<Scalars['String']['output']>;
  required: Scalars['Boolean']['output'];
};

export type StudentAdksFieldsSetupSettingsTeamSettingsCreateInput = {
  editViewSetting?: InputMaybe<Scalars['String']['input']>;
  required: Scalars['Boolean']['input'];
};

export type StudentAdksFieldsSetupSettingsTeamSettingsObjectEqualityInput = {
  editViewSetting?: InputMaybe<Scalars['String']['input']>;
  required: Scalars['Boolean']['input'];
};

export type StudentAdksFieldsSetupSettingsUserInterviewSettings = {
  __typename?: 'StudentAdksFieldsSetupSettingsUserInterviewSettings';
  required: Scalars['Boolean']['output'];
  totalUsers?: Maybe<Scalars['String']['output']>;
};

export type StudentAdksFieldsSetupSettingsUserInterviewSettingsCreateInput = {
  required: Scalars['Boolean']['input'];
  totalUsers?: InputMaybe<Scalars['String']['input']>;
};

export type StudentAdksFieldsSetupSettingsUserInterviewSettingsObjectEqualityInput = {
  required: Scalars['Boolean']['input'];
  totalUsers?: InputMaybe<Scalars['String']['input']>;
};

export type StudentAdksFieldsSetupSignInVideoAskResponse = {
  __typename?: 'StudentAdksFieldsSetupSignInVideoAskResponse';
  contact: StudentAdksFieldsSetupSignInVideoAskResponseContact;
  event_id: Scalars['String']['output'];
  event_type: Scalars['String']['output'];
  form: StudentAdksFieldsSetupSignInVideoAskResponseForm;
  interaction_id: Scalars['String']['output'];
};

export type StudentAdksFieldsSetupSignInVideoAskResponseContact = {
  __typename?: 'StudentAdksFieldsSetupSignInVideoAskResponseContact';
  answers?: Maybe<Array<StudentAdksFieldsSetupSignInVideoAskResponseContactAnswers>>;
  are_answers_public: Scalars['Boolean']['output'];
  are_messages_public: Scalars['Boolean']['output'];
  contact_id: Scalars['String']['output'];
  email: Scalars['String']['output'];
  platform: Scalars['String']['output'];
  share_id: Scalars['String']['output'];
  share_url: Scalars['String']['output'];
  status: Scalars['String']['output'];
};

export type StudentAdksFieldsSetupSignInVideoAskResponseContactAnswers = {
  __typename?: 'StudentAdksFieldsSetupSignInVideoAskResponseContactAnswers';
  answer_id: Scalars['String']['output'];
  media_id: Scalars['String']['output'];
  media_url: Scalars['String']['output'];
  /** Could not determine type: the field only had null or empty values in the sample set. */
  poll_options?: Maybe<Scalars['JSON']['output']>;
  question_id: Scalars['String']['output'];
};

export type StudentAdksFieldsSetupSignInVideoAskResponseContactAnswersCreateInput = {
  answer_id: Scalars['String']['input'];
  media_id: Scalars['String']['input'];
  media_url: Scalars['String']['input'];
  poll_options?: InputMaybe<Scalars['JSON']['input']>;
  question_id: Scalars['String']['input'];
};

export type StudentAdksFieldsSetupSignInVideoAskResponseContactAnswersObjectEqualityInput = {
  answer_id: Scalars['String']['input'];
  media_id: Scalars['String']['input'];
  media_url: Scalars['String']['input'];
  poll_options?: InputMaybe<Scalars['JSON']['input']>;
  question_id: Scalars['String']['input'];
};

export type StudentAdksFieldsSetupSignInVideoAskResponseContactCreateInput = {
  answers?: InputMaybe<Array<StudentAdksFieldsSetupSignInVideoAskResponseContactAnswersCreateInput>>;
  are_answers_public: Scalars['Boolean']['input'];
  are_messages_public: Scalars['Boolean']['input'];
  contact_id: Scalars['String']['input'];
  email: Scalars['String']['input'];
  platform: Scalars['String']['input'];
  share_id: Scalars['String']['input'];
  share_url: Scalars['String']['input'];
  status: Scalars['String']['input'];
};

export type StudentAdksFieldsSetupSignInVideoAskResponseContactObjectEqualityInput = {
  answers?: InputMaybe<Array<StudentAdksFieldsSetupSignInVideoAskResponseContactAnswersObjectEqualityInput>>;
  are_answers_public: Scalars['Boolean']['input'];
  are_messages_public: Scalars['Boolean']['input'];
  contact_id: Scalars['String']['input'];
  email: Scalars['String']['input'];
  platform: Scalars['String']['input'];
  share_id: Scalars['String']['input'];
  share_url: Scalars['String']['input'];
  status: Scalars['String']['input'];
};

export type StudentAdksFieldsSetupSignInVideoAskResponseCreateInput = {
  contact: StudentAdksFieldsSetupSignInVideoAskResponseContactCreateInput;
  event_id: Scalars['String']['input'];
  event_type: Scalars['String']['input'];
  form: StudentAdksFieldsSetupSignInVideoAskResponseFormCreateInput;
  interaction_id: Scalars['String']['input'];
};

export type StudentAdksFieldsSetupSignInVideoAskResponseForm = {
  __typename?: 'StudentAdksFieldsSetupSignInVideoAskResponseForm';
  are_answers_public: Scalars['Boolean']['output'];
  are_messages_public: Scalars['Boolean']['output'];
  form_id: Scalars['String']['output'];
  hide_branding: Scalars['Boolean']['output'];
  idle_deadline_time_in_minutes: Scalars['Int']['output'];
  notifications: StudentAdksFieldsSetupSignInVideoAskResponseFormNotifications;
  questions?: Maybe<Array<StudentAdksFieldsSetupSignInVideoAskResponseFormQuestions>>;
  requires_consent: Scalars['Boolean']['output'];
  requires_contact_email: Scalars['Boolean']['output'];
  requires_contact_info: Scalars['Boolean']['output'];
  requires_contact_name: Scalars['Boolean']['output'];
  requires_contact_phone_number: Scalars['Boolean']['output'];
  respondents_count: Scalars['Int']['output'];
  responses_share_id: Scalars['String']['output'];
  responses_share_url: Scalars['String']['output'];
  share_id: Scalars['String']['output'];
  share_url: Scalars['String']['output'];
  show_consent: Scalars['Boolean']['output'];
  show_contact_email: Scalars['Boolean']['output'];
  show_contact_name: Scalars['Boolean']['output'];
  show_contact_phone_number: Scalars['Boolean']['output'];
  tag_share_id: Scalars['String']['output'];
  tag_share_url: Scalars['String']['output'];
};

export type StudentAdksFieldsSetupSignInVideoAskResponseFormCreateInput = {
  are_answers_public: Scalars['Boolean']['input'];
  are_messages_public: Scalars['Boolean']['input'];
  form_id: Scalars['String']['input'];
  hide_branding: Scalars['Boolean']['input'];
  idle_deadline_time_in_minutes: Scalars['Int']['input'];
  notifications: StudentAdksFieldsSetupSignInVideoAskResponseFormNotificationsCreateInput;
  questions?: InputMaybe<Array<StudentAdksFieldsSetupSignInVideoAskResponseFormQuestionsCreateInput>>;
  requires_consent: Scalars['Boolean']['input'];
  requires_contact_email: Scalars['Boolean']['input'];
  requires_contact_info: Scalars['Boolean']['input'];
  requires_contact_name: Scalars['Boolean']['input'];
  requires_contact_phone_number: Scalars['Boolean']['input'];
  respondents_count: Scalars['Int']['input'];
  responses_share_id: Scalars['String']['input'];
  responses_share_url: Scalars['String']['input'];
  share_id: Scalars['String']['input'];
  share_url: Scalars['String']['input'];
  show_consent: Scalars['Boolean']['input'];
  show_contact_email: Scalars['Boolean']['input'];
  show_contact_name: Scalars['Boolean']['input'];
  show_contact_phone_number: Scalars['Boolean']['input'];
  tag_share_id: Scalars['String']['input'];
  tag_share_url: Scalars['String']['input'];
};

export type StudentAdksFieldsSetupSignInVideoAskResponseFormNotifications = {
  __typename?: 'StudentAdksFieldsSetupSignInVideoAskResponseFormNotifications';
  send_contact_message_emails: Scalars['Boolean']['output'];
};

export type StudentAdksFieldsSetupSignInVideoAskResponseFormNotificationsCreateInput = {
  send_contact_message_emails: Scalars['Boolean']['input'];
};

export type StudentAdksFieldsSetupSignInVideoAskResponseFormNotificationsObjectEqualityInput = {
  send_contact_message_emails: Scalars['Boolean']['input'];
};

export type StudentAdksFieldsSetupSignInVideoAskResponseFormObjectEqualityInput = {
  are_answers_public: Scalars['Boolean']['input'];
  are_messages_public: Scalars['Boolean']['input'];
  form_id: Scalars['String']['input'];
  hide_branding: Scalars['Boolean']['input'];
  idle_deadline_time_in_minutes: Scalars['Int']['input'];
  notifications: StudentAdksFieldsSetupSignInVideoAskResponseFormNotificationsObjectEqualityInput;
  questions?: InputMaybe<Array<StudentAdksFieldsSetupSignInVideoAskResponseFormQuestionsObjectEqualityInput>>;
  requires_consent: Scalars['Boolean']['input'];
  requires_contact_email: Scalars['Boolean']['input'];
  requires_contact_info: Scalars['Boolean']['input'];
  requires_contact_name: Scalars['Boolean']['input'];
  requires_contact_phone_number: Scalars['Boolean']['input'];
  respondents_count: Scalars['Int']['input'];
  responses_share_id: Scalars['String']['input'];
  responses_share_url: Scalars['String']['input'];
  share_id: Scalars['String']['input'];
  share_url: Scalars['String']['input'];
  show_consent: Scalars['Boolean']['input'];
  show_contact_email: Scalars['Boolean']['input'];
  show_contact_name: Scalars['Boolean']['input'];
  show_contact_phone_number: Scalars['Boolean']['input'];
  tag_share_id: Scalars['String']['input'];
  tag_share_url: Scalars['String']['input'];
};

export type StudentAdksFieldsSetupSignInVideoAskResponseFormQuestions = {
  __typename?: 'StudentAdksFieldsSetupSignInVideoAskResponseFormQuestions';
  question_id: Scalars['String']['output'];
};

export type StudentAdksFieldsSetupSignInVideoAskResponseFormQuestionsCreateInput = {
  question_id: Scalars['String']['input'];
};

export type StudentAdksFieldsSetupSignInVideoAskResponseFormQuestionsObjectEqualityInput = {
  question_id: Scalars['String']['input'];
};

export type StudentAdksFieldsSetupSignInVideoAskResponseObjectEqualityInput = {
  contact: StudentAdksFieldsSetupSignInVideoAskResponseContactObjectEqualityInput;
  event_id: Scalars['String']['input'];
  event_type: Scalars['String']['input'];
  form: StudentAdksFieldsSetupSignInVideoAskResponseFormObjectEqualityInput;
  interaction_id: Scalars['String']['input'];
};

export type StudentAdksFieldsSetupTimeFrame = {
  __typename?: 'StudentAdksFieldsSetupTimeFrame';
  end: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  isCondensed: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  notes: Scalars['String']['output'];
  start: Scalars['String']['output'];
  visibility: Scalars['String']['output'];
};

export type StudentAdksFieldsSetupTimeFrameCreateInput = {
  end: Scalars['String']['input'];
  id: Scalars['Int']['input'];
  isCondensed: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  notes: Scalars['String']['input'];
  start: Scalars['String']['input'];
  visibility: Scalars['String']['input'];
};

export type StudentAdksFieldsSetupTimeFrameObjectEqualityInput = {
  end: Scalars['String']['input'];
  id: Scalars['Int']['input'];
  isCondensed: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  notes: Scalars['String']['input'];
  start: Scalars['String']['input'];
  visibility: Scalars['String']['input'];
};

export type StudentAdksFieldsSetupTrainProgress = {
  __typename?: 'StudentAdksFieldsSetupTrainProgress';
  completed?: Maybe<Scalars['Boolean']['output']>;
  is_processing?: Maybe<Scalars['Boolean']['output']>;
  is_videoask?: Maybe<Scalars['Boolean']['output']>;
  link: Scalars['String']['output'];
  name: Scalars['String']['output'];
  required?: Maybe<Scalars['Boolean']['output']>;
  unlocked?: Maybe<Scalars['Boolean']['output']>;
  videoAskResponse?: Maybe<StudentAdksFieldsSetupTrainProgressVideoAskResponse>;
  videoask_question_url?: Maybe<Scalars['String']['output']>;
};

export type StudentAdksFieldsSetupTrainProgressCreateInput = {
  completed?: InputMaybe<Scalars['Boolean']['input']>;
  is_processing?: InputMaybe<Scalars['Boolean']['input']>;
  is_videoask?: InputMaybe<Scalars['Boolean']['input']>;
  link: Scalars['String']['input'];
  name: Scalars['String']['input'];
  required?: InputMaybe<Scalars['Boolean']['input']>;
  unlocked?: InputMaybe<Scalars['Boolean']['input']>;
  videoAskResponse?: InputMaybe<StudentAdksFieldsSetupTrainProgressVideoAskResponseCreateInput>;
  videoask_question_url?: InputMaybe<Scalars['String']['input']>;
};

export type StudentAdksFieldsSetupTrainProgressObjectEqualityInput = {
  completed?: InputMaybe<Scalars['Boolean']['input']>;
  is_processing?: InputMaybe<Scalars['Boolean']['input']>;
  is_videoask?: InputMaybe<Scalars['Boolean']['input']>;
  link: Scalars['String']['input'];
  name: Scalars['String']['input'];
  required?: InputMaybe<Scalars['Boolean']['input']>;
  unlocked?: InputMaybe<Scalars['Boolean']['input']>;
  videoAskResponse?: InputMaybe<StudentAdksFieldsSetupTrainProgressVideoAskResponseObjectEqualityInput>;
  videoask_question_url?: InputMaybe<Scalars['String']['input']>;
};

export type StudentAdksFieldsSetupTrainProgressVideoAskResponse = {
  __typename?: 'StudentAdksFieldsSetupTrainProgressVideoAskResponse';
  contact: StudentAdksFieldsSetupTrainProgressVideoAskResponseContact;
  event_id: Scalars['String']['output'];
  event_type: Scalars['String']['output'];
  form: StudentAdksFieldsSetupTrainProgressVideoAskResponseForm;
  interaction_id: Scalars['String']['output'];
};

export type StudentAdksFieldsSetupTrainProgressVideoAskResponseContact = {
  __typename?: 'StudentAdksFieldsSetupTrainProgressVideoAskResponseContact';
  answers?: Maybe<Array<StudentAdksFieldsSetupTrainProgressVideoAskResponseContactAnswers>>;
  are_answers_public: Scalars['Boolean']['output'];
  are_messages_public: Scalars['Boolean']['output'];
  contact_id: Scalars['String']['output'];
  email: Scalars['String']['output'];
  platform: Scalars['String']['output'];
  share_id: Scalars['String']['output'];
  share_url: Scalars['String']['output'];
  status: Scalars['String']['output'];
};

export type StudentAdksFieldsSetupTrainProgressVideoAskResponseContactAnswers = {
  __typename?: 'StudentAdksFieldsSetupTrainProgressVideoAskResponseContactAnswers';
  answer_id: Scalars['String']['output'];
  media_id?: Maybe<Scalars['String']['output']>;
  media_url?: Maybe<Scalars['String']['output']>;
  poll_options?: Maybe<Array<StudentAdksFieldsSetupTrainProgressVideoAskResponseContactAnswersPollOptions>>;
  question_id: Scalars['String']['output'];
};

export type StudentAdksFieldsSetupTrainProgressVideoAskResponseContactAnswersCreateInput = {
  answer_id: Scalars['String']['input'];
  media_id?: InputMaybe<Scalars['String']['input']>;
  media_url?: InputMaybe<Scalars['String']['input']>;
  poll_options?: InputMaybe<Array<StudentAdksFieldsSetupTrainProgressVideoAskResponseContactAnswersPollOptionsCreateInput>>;
  question_id: Scalars['String']['input'];
};

export type StudentAdksFieldsSetupTrainProgressVideoAskResponseContactAnswersObjectEqualityInput = {
  answer_id: Scalars['String']['input'];
  media_id?: InputMaybe<Scalars['String']['input']>;
  media_url?: InputMaybe<Scalars['String']['input']>;
  poll_options?: InputMaybe<Array<StudentAdksFieldsSetupTrainProgressVideoAskResponseContactAnswersPollOptionsObjectEqualityInput>>;
  question_id: Scalars['String']['input'];
};

export type StudentAdksFieldsSetupTrainProgressVideoAskResponseContactAnswersPollOptions = {
  __typename?: 'StudentAdksFieldsSetupTrainProgressVideoAskResponseContactAnswersPollOptions';
  content: Scalars['String']['output'];
  id: Scalars['String']['output'];
  ref: Scalars['String']['output'];
};

export type StudentAdksFieldsSetupTrainProgressVideoAskResponseContactAnswersPollOptionsCreateInput = {
  content: Scalars['String']['input'];
  id: Scalars['String']['input'];
  ref: Scalars['String']['input'];
};

export type StudentAdksFieldsSetupTrainProgressVideoAskResponseContactAnswersPollOptionsObjectEqualityInput = {
  content: Scalars['String']['input'];
  id: Scalars['String']['input'];
  ref: Scalars['String']['input'];
};

export type StudentAdksFieldsSetupTrainProgressVideoAskResponseContactCreateInput = {
  answers?: InputMaybe<Array<StudentAdksFieldsSetupTrainProgressVideoAskResponseContactAnswersCreateInput>>;
  are_answers_public: Scalars['Boolean']['input'];
  are_messages_public: Scalars['Boolean']['input'];
  contact_id: Scalars['String']['input'];
  email: Scalars['String']['input'];
  platform: Scalars['String']['input'];
  share_id: Scalars['String']['input'];
  share_url: Scalars['String']['input'];
  status: Scalars['String']['input'];
};

export type StudentAdksFieldsSetupTrainProgressVideoAskResponseContactObjectEqualityInput = {
  answers?: InputMaybe<Array<StudentAdksFieldsSetupTrainProgressVideoAskResponseContactAnswersObjectEqualityInput>>;
  are_answers_public: Scalars['Boolean']['input'];
  are_messages_public: Scalars['Boolean']['input'];
  contact_id: Scalars['String']['input'];
  email: Scalars['String']['input'];
  platform: Scalars['String']['input'];
  share_id: Scalars['String']['input'];
  share_url: Scalars['String']['input'];
  status: Scalars['String']['input'];
};

export type StudentAdksFieldsSetupTrainProgressVideoAskResponseCreateInput = {
  contact: StudentAdksFieldsSetupTrainProgressVideoAskResponseContactCreateInput;
  event_id: Scalars['String']['input'];
  event_type: Scalars['String']['input'];
  form: StudentAdksFieldsSetupTrainProgressVideoAskResponseFormCreateInput;
  interaction_id: Scalars['String']['input'];
};

export type StudentAdksFieldsSetupTrainProgressVideoAskResponseForm = {
  __typename?: 'StudentAdksFieldsSetupTrainProgressVideoAskResponseForm';
  are_answers_public: Scalars['Boolean']['output'];
  are_messages_public: Scalars['Boolean']['output'];
  form_id: Scalars['String']['output'];
  hide_branding: Scalars['Boolean']['output'];
  idle_deadline_time_in_minutes: Scalars['Int']['output'];
  notifications: StudentAdksFieldsSetupTrainProgressVideoAskResponseFormNotifications;
  questions?: Maybe<Array<StudentAdksFieldsSetupTrainProgressVideoAskResponseFormQuestions>>;
  requires_consent: Scalars['Boolean']['output'];
  requires_contact_email: Scalars['Boolean']['output'];
  requires_contact_info: Scalars['Boolean']['output'];
  requires_contact_name: Scalars['Boolean']['output'];
  requires_contact_phone_number: Scalars['Boolean']['output'];
  respondents_count: Scalars['Int']['output'];
  responses_share_id: Scalars['String']['output'];
  responses_share_url: Scalars['String']['output'];
  share_id: Scalars['String']['output'];
  share_url: Scalars['String']['output'];
  show_consent: Scalars['Boolean']['output'];
  show_contact_email: Scalars['Boolean']['output'];
  show_contact_name: Scalars['Boolean']['output'];
  show_contact_phone_number: Scalars['Boolean']['output'];
  tag_share_id: Scalars['String']['output'];
  tag_share_url: Scalars['String']['output'];
};

export type StudentAdksFieldsSetupTrainProgressVideoAskResponseFormCreateInput = {
  are_answers_public: Scalars['Boolean']['input'];
  are_messages_public: Scalars['Boolean']['input'];
  form_id: Scalars['String']['input'];
  hide_branding: Scalars['Boolean']['input'];
  idle_deadline_time_in_minutes: Scalars['Int']['input'];
  notifications: StudentAdksFieldsSetupTrainProgressVideoAskResponseFormNotificationsCreateInput;
  questions?: InputMaybe<Array<StudentAdksFieldsSetupTrainProgressVideoAskResponseFormQuestionsCreateInput>>;
  requires_consent: Scalars['Boolean']['input'];
  requires_contact_email: Scalars['Boolean']['input'];
  requires_contact_info: Scalars['Boolean']['input'];
  requires_contact_name: Scalars['Boolean']['input'];
  requires_contact_phone_number: Scalars['Boolean']['input'];
  respondents_count: Scalars['Int']['input'];
  responses_share_id: Scalars['String']['input'];
  responses_share_url: Scalars['String']['input'];
  share_id: Scalars['String']['input'];
  share_url: Scalars['String']['input'];
  show_consent: Scalars['Boolean']['input'];
  show_contact_email: Scalars['Boolean']['input'];
  show_contact_name: Scalars['Boolean']['input'];
  show_contact_phone_number: Scalars['Boolean']['input'];
  tag_share_id: Scalars['String']['input'];
  tag_share_url: Scalars['String']['input'];
};

export type StudentAdksFieldsSetupTrainProgressVideoAskResponseFormNotifications = {
  __typename?: 'StudentAdksFieldsSetupTrainProgressVideoAskResponseFormNotifications';
  send_contact_message_emails: Scalars['Boolean']['output'];
};

export type StudentAdksFieldsSetupTrainProgressVideoAskResponseFormNotificationsCreateInput = {
  send_contact_message_emails: Scalars['Boolean']['input'];
};

export type StudentAdksFieldsSetupTrainProgressVideoAskResponseFormNotificationsObjectEqualityInput = {
  send_contact_message_emails: Scalars['Boolean']['input'];
};

export type StudentAdksFieldsSetupTrainProgressVideoAskResponseFormObjectEqualityInput = {
  are_answers_public: Scalars['Boolean']['input'];
  are_messages_public: Scalars['Boolean']['input'];
  form_id: Scalars['String']['input'];
  hide_branding: Scalars['Boolean']['input'];
  idle_deadline_time_in_minutes: Scalars['Int']['input'];
  notifications: StudentAdksFieldsSetupTrainProgressVideoAskResponseFormNotificationsObjectEqualityInput;
  questions?: InputMaybe<Array<StudentAdksFieldsSetupTrainProgressVideoAskResponseFormQuestionsObjectEqualityInput>>;
  requires_consent: Scalars['Boolean']['input'];
  requires_contact_email: Scalars['Boolean']['input'];
  requires_contact_info: Scalars['Boolean']['input'];
  requires_contact_name: Scalars['Boolean']['input'];
  requires_contact_phone_number: Scalars['Boolean']['input'];
  respondents_count: Scalars['Int']['input'];
  responses_share_id: Scalars['String']['input'];
  responses_share_url: Scalars['String']['input'];
  share_id: Scalars['String']['input'];
  share_url: Scalars['String']['input'];
  show_consent: Scalars['Boolean']['input'];
  show_contact_email: Scalars['Boolean']['input'];
  show_contact_name: Scalars['Boolean']['input'];
  show_contact_phone_number: Scalars['Boolean']['input'];
  tag_share_id: Scalars['String']['input'];
  tag_share_url: Scalars['String']['input'];
};

export type StudentAdksFieldsSetupTrainProgressVideoAskResponseFormQuestions = {
  __typename?: 'StudentAdksFieldsSetupTrainProgressVideoAskResponseFormQuestions';
  question_id: Scalars['String']['output'];
};

export type StudentAdksFieldsSetupTrainProgressVideoAskResponseFormQuestionsCreateInput = {
  question_id: Scalars['String']['input'];
};

export type StudentAdksFieldsSetupTrainProgressVideoAskResponseFormQuestionsObjectEqualityInput = {
  question_id: Scalars['String']['input'];
};

export type StudentAdksFieldsSetupTrainProgressVideoAskResponseObjectEqualityInput = {
  contact: StudentAdksFieldsSetupTrainProgressVideoAskResponseContactObjectEqualityInput;
  event_id: Scalars['String']['input'];
  event_type: Scalars['String']['input'];
  form: StudentAdksFieldsSetupTrainProgressVideoAskResponseFormObjectEqualityInput;
  interaction_id: Scalars['String']['input'];
};

export type StudentAdksFieldsSetupUploadLimit = {
  __typename?: 'StudentAdksFieldsSetupUploadLimit';
  max: Scalars['Int']['output'];
  min: Scalars['Int']['output'];
};

export type StudentAdksFieldsSetupUploadLimitCreateInput = {
  max: Scalars['Int']['input'];
  min: Scalars['Int']['input'];
};

export type StudentAdksFieldsSetupUploadLimitObjectEqualityInput = {
  max: Scalars['Int']['input'];
  min: Scalars['Int']['input'];
};

export type StudentAdksFieldsSetupVideoLinks = {
  __typename?: 'StudentAdksFieldsSetupVideoLinks';
  completed?: Maybe<Scalars['Boolean']['output']>;
  is_processing?: Maybe<Scalars['Boolean']['output']>;
  is_videoask?: Maybe<Scalars['Boolean']['output']>;
  link: Scalars['String']['output'];
  name: Scalars['String']['output'];
  required?: Maybe<Scalars['Boolean']['output']>;
  unlocked?: Maybe<Scalars['Boolean']['output']>;
  videoAskResponse?: Maybe<StudentAdksFieldsSetupVideoLinksVideoAskResponse>;
  videoask_question_url?: Maybe<Scalars['String']['output']>;
};

export type StudentAdksFieldsSetupVideoLinksCreateInput = {
  completed?: InputMaybe<Scalars['Boolean']['input']>;
  is_processing?: InputMaybe<Scalars['Boolean']['input']>;
  is_videoask?: InputMaybe<Scalars['Boolean']['input']>;
  link: Scalars['String']['input'];
  name: Scalars['String']['input'];
  required?: InputMaybe<Scalars['Boolean']['input']>;
  unlocked?: InputMaybe<Scalars['Boolean']['input']>;
  videoAskResponse?: InputMaybe<StudentAdksFieldsSetupVideoLinksVideoAskResponseCreateInput>;
  videoask_question_url?: InputMaybe<Scalars['String']['input']>;
};

export type StudentAdksFieldsSetupVideoLinksObjectEqualityInput = {
  completed?: InputMaybe<Scalars['Boolean']['input']>;
  is_processing?: InputMaybe<Scalars['Boolean']['input']>;
  is_videoask?: InputMaybe<Scalars['Boolean']['input']>;
  link: Scalars['String']['input'];
  name: Scalars['String']['input'];
  required?: InputMaybe<Scalars['Boolean']['input']>;
  unlocked?: InputMaybe<Scalars['Boolean']['input']>;
  videoAskResponse?: InputMaybe<StudentAdksFieldsSetupVideoLinksVideoAskResponseObjectEqualityInput>;
  videoask_question_url?: InputMaybe<Scalars['String']['input']>;
};

export type StudentAdksFieldsSetupVideoLinksVideoAskResponse = {
  __typename?: 'StudentAdksFieldsSetupVideoLinksVideoAskResponse';
  contact: StudentAdksFieldsSetupVideoLinksVideoAskResponseContact;
  event_id: Scalars['String']['output'];
  event_type: Scalars['String']['output'];
  form: StudentAdksFieldsSetupVideoLinksVideoAskResponseForm;
  interaction_id: Scalars['String']['output'];
};

export type StudentAdksFieldsSetupVideoLinksVideoAskResponseContact = {
  __typename?: 'StudentAdksFieldsSetupVideoLinksVideoAskResponseContact';
  answers?: Maybe<Array<StudentAdksFieldsSetupVideoLinksVideoAskResponseContactAnswers>>;
  are_answers_public: Scalars['Boolean']['output'];
  are_messages_public: Scalars['Boolean']['output'];
  contact_id: Scalars['String']['output'];
  email: Scalars['String']['output'];
  platform: Scalars['String']['output'];
  share_id: Scalars['String']['output'];
  share_url: Scalars['String']['output'];
  status: Scalars['String']['output'];
};

export type StudentAdksFieldsSetupVideoLinksVideoAskResponseContactAnswers = {
  __typename?: 'StudentAdksFieldsSetupVideoLinksVideoAskResponseContactAnswers';
  answer_id: Scalars['String']['output'];
  media_id?: Maybe<Scalars['String']['output']>;
  media_url?: Maybe<Scalars['String']['output']>;
  poll_options?: Maybe<Array<StudentAdksFieldsSetupVideoLinksVideoAskResponseContactAnswersPollOptions>>;
  question_id: Scalars['String']['output'];
};

export type StudentAdksFieldsSetupVideoLinksVideoAskResponseContactAnswersCreateInput = {
  answer_id: Scalars['String']['input'];
  media_id?: InputMaybe<Scalars['String']['input']>;
  media_url?: InputMaybe<Scalars['String']['input']>;
  poll_options?: InputMaybe<Array<StudentAdksFieldsSetupVideoLinksVideoAskResponseContactAnswersPollOptionsCreateInput>>;
  question_id: Scalars['String']['input'];
};

export type StudentAdksFieldsSetupVideoLinksVideoAskResponseContactAnswersObjectEqualityInput = {
  answer_id: Scalars['String']['input'];
  media_id?: InputMaybe<Scalars['String']['input']>;
  media_url?: InputMaybe<Scalars['String']['input']>;
  poll_options?: InputMaybe<Array<StudentAdksFieldsSetupVideoLinksVideoAskResponseContactAnswersPollOptionsObjectEqualityInput>>;
  question_id: Scalars['String']['input'];
};

export type StudentAdksFieldsSetupVideoLinksVideoAskResponseContactAnswersPollOptions = {
  __typename?: 'StudentAdksFieldsSetupVideoLinksVideoAskResponseContactAnswersPollOptions';
  content: Scalars['String']['output'];
  id: Scalars['String']['output'];
  ref: Scalars['String']['output'];
};

export type StudentAdksFieldsSetupVideoLinksVideoAskResponseContactAnswersPollOptionsCreateInput = {
  content: Scalars['String']['input'];
  id: Scalars['String']['input'];
  ref: Scalars['String']['input'];
};

export type StudentAdksFieldsSetupVideoLinksVideoAskResponseContactAnswersPollOptionsObjectEqualityInput = {
  content: Scalars['String']['input'];
  id: Scalars['String']['input'];
  ref: Scalars['String']['input'];
};

export type StudentAdksFieldsSetupVideoLinksVideoAskResponseContactCreateInput = {
  answers?: InputMaybe<Array<StudentAdksFieldsSetupVideoLinksVideoAskResponseContactAnswersCreateInput>>;
  are_answers_public: Scalars['Boolean']['input'];
  are_messages_public: Scalars['Boolean']['input'];
  contact_id: Scalars['String']['input'];
  email: Scalars['String']['input'];
  platform: Scalars['String']['input'];
  share_id: Scalars['String']['input'];
  share_url: Scalars['String']['input'];
  status: Scalars['String']['input'];
};

export type StudentAdksFieldsSetupVideoLinksVideoAskResponseContactObjectEqualityInput = {
  answers?: InputMaybe<Array<StudentAdksFieldsSetupVideoLinksVideoAskResponseContactAnswersObjectEqualityInput>>;
  are_answers_public: Scalars['Boolean']['input'];
  are_messages_public: Scalars['Boolean']['input'];
  contact_id: Scalars['String']['input'];
  email: Scalars['String']['input'];
  platform: Scalars['String']['input'];
  share_id: Scalars['String']['input'];
  share_url: Scalars['String']['input'];
  status: Scalars['String']['input'];
};

export type StudentAdksFieldsSetupVideoLinksVideoAskResponseCreateInput = {
  contact: StudentAdksFieldsSetupVideoLinksVideoAskResponseContactCreateInput;
  event_id: Scalars['String']['input'];
  event_type: Scalars['String']['input'];
  form: StudentAdksFieldsSetupVideoLinksVideoAskResponseFormCreateInput;
  interaction_id: Scalars['String']['input'];
};

export type StudentAdksFieldsSetupVideoLinksVideoAskResponseForm = {
  __typename?: 'StudentAdksFieldsSetupVideoLinksVideoAskResponseForm';
  are_answers_public: Scalars['Boolean']['output'];
  are_messages_public: Scalars['Boolean']['output'];
  form_id: Scalars['String']['output'];
  hide_branding: Scalars['Boolean']['output'];
  idle_deadline_time_in_minutes: Scalars['Int']['output'];
  notifications: StudentAdksFieldsSetupVideoLinksVideoAskResponseFormNotifications;
  questions?: Maybe<Array<StudentAdksFieldsSetupVideoLinksVideoAskResponseFormQuestions>>;
  requires_consent: Scalars['Boolean']['output'];
  requires_contact_email: Scalars['Boolean']['output'];
  requires_contact_info: Scalars['Boolean']['output'];
  requires_contact_name: Scalars['Boolean']['output'];
  requires_contact_phone_number: Scalars['Boolean']['output'];
  respondents_count: Scalars['Int']['output'];
  responses_share_id: Scalars['String']['output'];
  responses_share_url: Scalars['String']['output'];
  share_id: Scalars['String']['output'];
  share_url: Scalars['String']['output'];
  show_consent: Scalars['Boolean']['output'];
  show_contact_email: Scalars['Boolean']['output'];
  show_contact_name: Scalars['Boolean']['output'];
  show_contact_phone_number: Scalars['Boolean']['output'];
  tag_share_id: Scalars['String']['output'];
  tag_share_url: Scalars['String']['output'];
};

export type StudentAdksFieldsSetupVideoLinksVideoAskResponseFormCreateInput = {
  are_answers_public: Scalars['Boolean']['input'];
  are_messages_public: Scalars['Boolean']['input'];
  form_id: Scalars['String']['input'];
  hide_branding: Scalars['Boolean']['input'];
  idle_deadline_time_in_minutes: Scalars['Int']['input'];
  notifications: StudentAdksFieldsSetupVideoLinksVideoAskResponseFormNotificationsCreateInput;
  questions?: InputMaybe<Array<StudentAdksFieldsSetupVideoLinksVideoAskResponseFormQuestionsCreateInput>>;
  requires_consent: Scalars['Boolean']['input'];
  requires_contact_email: Scalars['Boolean']['input'];
  requires_contact_info: Scalars['Boolean']['input'];
  requires_contact_name: Scalars['Boolean']['input'];
  requires_contact_phone_number: Scalars['Boolean']['input'];
  respondents_count: Scalars['Int']['input'];
  responses_share_id: Scalars['String']['input'];
  responses_share_url: Scalars['String']['input'];
  share_id: Scalars['String']['input'];
  share_url: Scalars['String']['input'];
  show_consent: Scalars['Boolean']['input'];
  show_contact_email: Scalars['Boolean']['input'];
  show_contact_name: Scalars['Boolean']['input'];
  show_contact_phone_number: Scalars['Boolean']['input'];
  tag_share_id: Scalars['String']['input'];
  tag_share_url: Scalars['String']['input'];
};

export type StudentAdksFieldsSetupVideoLinksVideoAskResponseFormNotifications = {
  __typename?: 'StudentAdksFieldsSetupVideoLinksVideoAskResponseFormNotifications';
  send_contact_message_emails: Scalars['Boolean']['output'];
};

export type StudentAdksFieldsSetupVideoLinksVideoAskResponseFormNotificationsCreateInput = {
  send_contact_message_emails: Scalars['Boolean']['input'];
};

export type StudentAdksFieldsSetupVideoLinksVideoAskResponseFormNotificationsObjectEqualityInput = {
  send_contact_message_emails: Scalars['Boolean']['input'];
};

export type StudentAdksFieldsSetupVideoLinksVideoAskResponseFormObjectEqualityInput = {
  are_answers_public: Scalars['Boolean']['input'];
  are_messages_public: Scalars['Boolean']['input'];
  form_id: Scalars['String']['input'];
  hide_branding: Scalars['Boolean']['input'];
  idle_deadline_time_in_minutes: Scalars['Int']['input'];
  notifications: StudentAdksFieldsSetupVideoLinksVideoAskResponseFormNotificationsObjectEqualityInput;
  questions?: InputMaybe<Array<StudentAdksFieldsSetupVideoLinksVideoAskResponseFormQuestionsObjectEqualityInput>>;
  requires_consent: Scalars['Boolean']['input'];
  requires_contact_email: Scalars['Boolean']['input'];
  requires_contact_info: Scalars['Boolean']['input'];
  requires_contact_name: Scalars['Boolean']['input'];
  requires_contact_phone_number: Scalars['Boolean']['input'];
  respondents_count: Scalars['Int']['input'];
  responses_share_id: Scalars['String']['input'];
  responses_share_url: Scalars['String']['input'];
  share_id: Scalars['String']['input'];
  share_url: Scalars['String']['input'];
  show_consent: Scalars['Boolean']['input'];
  show_contact_email: Scalars['Boolean']['input'];
  show_contact_name: Scalars['Boolean']['input'];
  show_contact_phone_number: Scalars['Boolean']['input'];
  tag_share_id: Scalars['String']['input'];
  tag_share_url: Scalars['String']['input'];
};

export type StudentAdksFieldsSetupVideoLinksVideoAskResponseFormQuestions = {
  __typename?: 'StudentAdksFieldsSetupVideoLinksVideoAskResponseFormQuestions';
  question_id: Scalars['String']['output'];
};

export type StudentAdksFieldsSetupVideoLinksVideoAskResponseFormQuestionsCreateInput = {
  question_id: Scalars['String']['input'];
};

export type StudentAdksFieldsSetupVideoLinksVideoAskResponseFormQuestionsObjectEqualityInput = {
  question_id: Scalars['String']['input'];
};

export type StudentAdksFieldsSetupVideoLinksVideoAskResponseObjectEqualityInput = {
  contact: StudentAdksFieldsSetupVideoLinksVideoAskResponseContactObjectEqualityInput;
  event_id: Scalars['String']['input'];
  event_type: Scalars['String']['input'];
  form: StudentAdksFieldsSetupVideoLinksVideoAskResponseFormObjectEqualityInput;
  interaction_id: Scalars['String']['input'];
};

export type StudentAdksFieldsStyling = {
  __typename?: 'StudentAdksFieldsStyling';
  appendIcon?: Maybe<Scalars['String']['output']>;
  chips?: Maybe<Scalars['Boolean']['output']>;
  class?: Maybe<Scalars['String']['output']>;
  color?: Maybe<Scalars['String']['output']>;
  cols?: Maybe<Scalars['String']['output']>;
  /** Multiple data types found: String: 79.4%, Int: 20.6% out of 12172 sampled entries */
  counter?: Maybe<Scalars['JSON']['output']>;
  dark?: Maybe<Scalars['Boolean']['output']>;
  dense?: Maybe<Scalars['Boolean']['output']>;
  denseIcon?: Maybe<Scalars['Boolean']['output']>;
  depressed?: Maybe<Scalars['Boolean']['output']>;
  flat?: Maybe<Scalars['Boolean']['output']>;
  hide_details?: Maybe<Scalars['Boolean']['output']>;
  hint?: Maybe<Scalars['String']['output']>;
  icon?: Maybe<Scalars['Boolean']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  leftIcon?: Maybe<Scalars['Boolean']['output']>;
  meetHeader?: Maybe<Scalars['String']['output']>;
  multiple?: Maybe<Scalars['Boolean']['output']>;
  outlined?: Maybe<Scalars['Boolean']['output']>;
  placeholder?: Maybe<Scalars['String']['output']>;
  prependIcon?: Maybe<Scalars['String']['output']>;
  rightIcon?: Maybe<Scalars['Boolean']['output']>;
  rounded?: Maybe<Scalars['Boolean']['output']>;
  rows?: Maybe<Scalars['String']['output']>;
  small?: Maybe<Scalars['Boolean']['output']>;
  small_chips?: Maybe<Scalars['Boolean']['output']>;
  wrapperClass?: Maybe<Scalars['String']['output']>;
  xLarge?: Maybe<Scalars['Boolean']['output']>;
  xSmall?: Maybe<Scalars['Boolean']['output']>;
};

export type StudentAdksFieldsStylingCreateInput = {
  appendIcon?: InputMaybe<Scalars['String']['input']>;
  chips?: InputMaybe<Scalars['Boolean']['input']>;
  class?: InputMaybe<Scalars['String']['input']>;
  color?: InputMaybe<Scalars['String']['input']>;
  cols?: InputMaybe<Scalars['String']['input']>;
  counter?: InputMaybe<Scalars['JSON']['input']>;
  dark?: InputMaybe<Scalars['Boolean']['input']>;
  dense?: InputMaybe<Scalars['Boolean']['input']>;
  denseIcon?: InputMaybe<Scalars['Boolean']['input']>;
  depressed?: InputMaybe<Scalars['Boolean']['input']>;
  flat?: InputMaybe<Scalars['Boolean']['input']>;
  hide_details?: InputMaybe<Scalars['Boolean']['input']>;
  hint?: InputMaybe<Scalars['String']['input']>;
  icon?: InputMaybe<Scalars['Boolean']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  leftIcon?: InputMaybe<Scalars['Boolean']['input']>;
  meetHeader?: InputMaybe<Scalars['String']['input']>;
  multiple?: InputMaybe<Scalars['Boolean']['input']>;
  outlined?: InputMaybe<Scalars['Boolean']['input']>;
  placeholder?: InputMaybe<Scalars['String']['input']>;
  prependIcon?: InputMaybe<Scalars['String']['input']>;
  rightIcon?: InputMaybe<Scalars['Boolean']['input']>;
  rounded?: InputMaybe<Scalars['Boolean']['input']>;
  rows?: InputMaybe<Scalars['String']['input']>;
  small?: InputMaybe<Scalars['Boolean']['input']>;
  small_chips?: InputMaybe<Scalars['Boolean']['input']>;
  wrapperClass?: InputMaybe<Scalars['String']['input']>;
  xLarge?: InputMaybe<Scalars['Boolean']['input']>;
  xSmall?: InputMaybe<Scalars['Boolean']['input']>;
};

export type StudentAdksFieldsStylingObjectEqualityInput = {
  appendIcon?: InputMaybe<Scalars['String']['input']>;
  chips?: InputMaybe<Scalars['Boolean']['input']>;
  class?: InputMaybe<Scalars['String']['input']>;
  color?: InputMaybe<Scalars['String']['input']>;
  cols?: InputMaybe<Scalars['String']['input']>;
  counter?: InputMaybe<Scalars['JSON']['input']>;
  dark?: InputMaybe<Scalars['Boolean']['input']>;
  dense?: InputMaybe<Scalars['Boolean']['input']>;
  denseIcon?: InputMaybe<Scalars['Boolean']['input']>;
  depressed?: InputMaybe<Scalars['Boolean']['input']>;
  flat?: InputMaybe<Scalars['Boolean']['input']>;
  hide_details?: InputMaybe<Scalars['Boolean']['input']>;
  hint?: InputMaybe<Scalars['String']['input']>;
  icon?: InputMaybe<Scalars['Boolean']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  leftIcon?: InputMaybe<Scalars['Boolean']['input']>;
  meetHeader?: InputMaybe<Scalars['String']['input']>;
  multiple?: InputMaybe<Scalars['Boolean']['input']>;
  outlined?: InputMaybe<Scalars['Boolean']['input']>;
  placeholder?: InputMaybe<Scalars['String']['input']>;
  prependIcon?: InputMaybe<Scalars['String']['input']>;
  rightIcon?: InputMaybe<Scalars['Boolean']['input']>;
  rounded?: InputMaybe<Scalars['Boolean']['input']>;
  rows?: InputMaybe<Scalars['String']['input']>;
  small?: InputMaybe<Scalars['Boolean']['input']>;
  small_chips?: InputMaybe<Scalars['Boolean']['input']>;
  wrapperClass?: InputMaybe<Scalars['String']['input']>;
  xLarge?: InputMaybe<Scalars['Boolean']['input']>;
  xSmall?: InputMaybe<Scalars['Boolean']['input']>;
};

export type StudentAdksFieldsTimelineItems = {
  __typename?: 'StudentAdksFieldsTimelineItems';
  answer: Scalars['String']['output'];
  color: Scalars['String']['output'];
  question: Scalars['String']['output'];
};

export type StudentAdksFieldsTimelineItemsCreateInput = {
  answer: Scalars['String']['input'];
  color: Scalars['String']['input'];
  question: Scalars['String']['input'];
};

export type StudentAdksFieldsTimelineItemsObjectEqualityInput = {
  answer: Scalars['String']['input'];
  color: Scalars['String']['input'];
  question: Scalars['String']['input'];
};

export type StudentAdksFieldsValue = {
  __typename?: 'StudentAdksFieldsValue';
  Description_1689596544146?: Maybe<Scalars['String']['output']>;
  Description_1689610327886?: Maybe<Scalars['String']['output']>;
  Select_1689610316209?: Maybe<Scalars['String']['output']>;
  aboutOrg?: Maybe<Scalars['String']['output']>;
  acceptanceDeadline?: Maybe<Scalars['String']['output']>;
  accessSkills?: Maybe<Array<Scalars['String']['output']>>;
  action?: Maybe<StudentAdksFieldsValueAction>;
  /** Multiple data types found: Array(String): 2.2%, Array(Int): 97.8% out of 729 sampled entries */
  ageRange?: Maybe<Scalars['JSON']['output']>;
  agreement?: Maybe<StudentAdksFieldsValueAgreement>;
  airtableFormLink?: Maybe<Scalars['String']['output']>;
  airtableLink?: Maybe<Scalars['String']['output']>;
  airtableResponseLink?: Maybe<Scalars['String']['output']>;
  airtableTableLink?: Maybe<Scalars['String']['output']>;
  apprentice?: Maybe<Scalars['Boolean']['output']>;
  arrivalLink?: Maybe<Scalars['String']['output']>;
  arrivalStatus?: Maybe<Scalars['String']['output']>;
  attendeeList?: Maybe<Scalars['String']['output']>;
  autoapply?: Maybe<StudentAdksFieldsValueAutoapply>;
  boards?: Maybe<Array<StudentAdksFieldsValueBoards>>;
  bookmarkedQuestions?: Maybe<Array<Scalars['String']['output']>>;
  channels?: Maybe<Array<StudentAdksFieldsValueChannels>>;
  checkinLink?: Maybe<Scalars['String']['output']>;
  compensation1?: Maybe<Scalars['Boolean']['output']>;
  compensation2?: Maybe<Scalars['Boolean']['output']>;
  compensation3?: Maybe<Scalars['Boolean']['output']>;
  compensation4?: Maybe<Scalars['Boolean']['output']>;
  compensation5?: Maybe<Scalars['Boolean']['output']>;
  compensation6?: Maybe<Scalars['Boolean']['output']>;
  connection?: Maybe<Scalars['String']['output']>;
  continuation?: Maybe<Scalars['Int']['output']>;
  defaultActivity?: Maybe<StudentAdksFieldsValueDefaultActivity>;
  deliverable?: Maybe<Array<Scalars['String']['output']>>;
  description?: Maybe<Scalars['String']['output']>;
  /** Multiple data types found: StudentAdksFieldsValueDirectoryPreferences: 5.4%, Array(StudentAdksFieldsValueDirectoryPreferences): 94.6% out of 260 sampled entries */
  directoryPreferences?: Maybe<Scalars['JSON']['output']>;
  discordData?: Maybe<StudentAdksFieldsValueDiscordData>;
  discordInfo?: Maybe<StudentAdksFieldsValueDiscordInfo>;
  discordIntegraionSkipped?: Maybe<Scalars['Boolean']['output']>;
  discordLink?: Maybe<Scalars['String']['output']>;
  dislikedQuestions?: Maybe<Array<Scalars['String']['output']>>;
  docDesc?: Maybe<Scalars['String']['output']>;
  docLink?: Maybe<Scalars['String']['output']>;
  driveLink?: Maybe<Scalars['String']['output']>;
  eir?: Maybe<Scalars['Boolean']['output']>;
  employerRecord?: Maybe<Scalars['Int']['output']>;
  endEarlyActivity?: Maybe<Scalars['String']['output']>;
  eventAgenda?: Maybe<Scalars['String']['output']>;
  eventDate?: Maybe<Scalars['String']['output']>;
  eventLocations?: Maybe<Scalars['String']['output']>;
  eventName?: Maybe<Scalars['String']['output']>;
  events?: Maybe<StudentAdksFieldsValueEvents>;
  extern?: Maybe<Scalars['Boolean']['output']>;
  /** Multiple data types found: Float: 4.2%, Int: 95.8% out of 508 sampled entries */
  externCredential?: Maybe<Scalars['JSON']['output']>;
  fellow?: Maybe<Scalars['Boolean']['output']>;
  fileType?: Maybe<Array<Scalars['String']['output']>>;
  flaggedComments?: Maybe<Array<Scalars['String']['output']>>;
  form_id?: Maybe<Scalars['String']['output']>;
  form_url?: Maybe<Scalars['String']['output']>;
  groupActivity?: Maybe<Scalars['String']['output']>;
  instructions?: Maybe<Scalars['String']['output']>;
  intern?: Maybe<Scalars['Boolean']['output']>;
  internshipEnd?: Maybe<Scalars['String']['output']>;
  internshipProject1?: Maybe<Scalars['Boolean']['output']>;
  internshipProject2?: Maybe<Scalars['Boolean']['output']>;
  internshipProject3?: Maybe<Scalars['Boolean']['output']>;
  internshipStart?: Maybe<Scalars['String']['output']>;
  interviewChallenge?: Maybe<Scalars['String']['output']>;
  interviewOpportunity?: Maybe<Scalars['String']['output']>;
  interviewProblem?: Maybe<Scalars['String']['output']>;
  interviewRequest?: Maybe<Scalars['String']['output']>;
  interviewSolution?: Maybe<Scalars['String']['output']>;
  lastInteraction?: Maybe<Scalars['String']['output']>;
  lastInteractionId?: Maybe<Scalars['String']['output']>;
  licenseRequirement?: Maybe<Scalars['Int']['output']>;
  likedComments?: Maybe<Array<Scalars['String']['output']>>;
  likedQuestions?: Maybe<Array<Scalars['String']['output']>>;
  loaded?: Maybe<Array<Scalars['String']['output']>>;
  logs?: Maybe<Array<StudentAdksFieldsValueLogs>>;
  maxCharacters?: Maybe<Scalars['String']['output']>;
  maxHours?: Maybe<Scalars['Int']['output']>;
  maxQuestions?: Maybe<Scalars['Int']['output']>;
  maxTeamMembers?: Maybe<Scalars['Int']['output']>;
  maximumBudget?: Maybe<Scalars['String']['output']>;
  minHours?: Maybe<Scalars['Int']['output']>;
  minLogs?: Maybe<Scalars['Int']['output']>;
  minimumBudget?: Maybe<Scalars['String']['output']>;
  /** Multiple data types found: String: 74.9%, Int: 25.1% out of 633 sampled entries */
  minimumHoursNow?: Maybe<Scalars['JSON']['output']>;
  offerStatus?: Maybe<Scalars['Boolean']['output']>;
  outcome?: Maybe<Array<Scalars['String']['output']>>;
  pathways?: Maybe<Array<Scalars['String']['output']>>;
  practiceLog?: Maybe<Array<StudentAdksFieldsValuePracticeLog>>;
  preApprentice?: Maybe<Scalars['Boolean']['output']>;
  preInternship?: Maybe<Scalars['Boolean']['output']>;
  programDesc?: Maybe<Scalars['String']['output']>;
  programName?: Maybe<Scalars['String']['output']>;
  /** Multiple data types found: String: 24.5%, Array(String): 75.5% out of 1445 sampled entries */
  projectReq?: Maybe<Scalars['JSON']['output']>;
  providers?: Maybe<StudentAdksFieldsValueProviders>;
  questionsAsked?: Maybe<Array<Scalars['String']['output']>>;
  requiredActivity?: Maybe<Scalars['String']['output']>;
  /** Multiple data types found: String: 41.1%, Array(String): 58.9% out of 594 sampled entries */
  requiredResidency?: Maybe<Scalars['JSON']['output']>;
  requiredSkills?: Maybe<Array<Scalars['String']['output']>>;
  researchLinks?: Maybe<Array<StudentAdksFieldsValueResearchLinks>>;
  researchProgress?: Maybe<Array<StudentAdksFieldsValueResearchProgress>>;
  resourceDrive?: Maybe<Scalars['String']['output']>;
  resourceFacebook?: Maybe<Scalars['String']['output']>;
  resourceInsta?: Maybe<Scalars['String']['output']>;
  resourceLinkedIn?: Maybe<Scalars['String']['output']>;
  resourceTwitter?: Maybe<Scalars['String']['output']>;
  resourceWeb?: Maybe<Scalars['String']['output']>;
  resourceYouTube?: Maybe<Scalars['String']['output']>;
  /** Multiple data types found: String: 36.9%, Array(String): 63.1% out of 1154 sampled entries */
  rewards?: Maybe<Scalars['JSON']['output']>;
  rsvpLink?: Maybe<Scalars['String']['output']>;
  settings?: Maybe<StudentAdksFieldsValueSettings>;
  signInVideoAskResponse?: Maybe<StudentAdksFieldsValueSignInVideoAskResponse>;
  signOffVideoAskResponse?: Maybe<StudentAdksFieldsValueSignOffVideoAskResponse>;
  studentEthnicity?: Maybe<Array<Scalars['String']['output']>>;
  /** Multiple data types found: String: 30.2%, Int: 69.8% out of 43 sampled entries */
  studentLocation?: Maybe<Scalars['JSON']['output']>;
  studentResidence?: Maybe<Scalars['String']['output']>;
  studentSchool?: Maybe<Scalars['String']['output']>;
  submission?: Maybe<StudentAdksFieldsValueSubmission>;
  submittedVideo?: Maybe<StudentAdksFieldsValueSubmittedVideo>;
  textFields?: Maybe<Array<Scalars['String']['output']>>;
  text_input_1689596540310?: Maybe<Scalars['String']['output']>;
  timeFrame?: Maybe<Array<StudentAdksFieldsValueTimeFrame>>;
  timeZone?: Maybe<Scalars['String']['output']>;
  timesheetDetails?: Maybe<Array<StudentAdksFieldsValueTimesheetDetails>>;
  trainProgress?: Maybe<Array<StudentAdksFieldsValueTrainProgress>>;
  uploadLimit?: Maybe<StudentAdksFieldsValueUploadLimit>;
  uploadLink?: Maybe<Scalars['String']['output']>;
  valueDrafts?: Maybe<Array<StudentAdksFieldsValueValueDrafts>>;
  videoAskResponse?: Maybe<StudentAdksFieldsValueVideoAskResponse>;
  videoLinks?: Maybe<Array<StudentAdksFieldsValueVideoLinks>>;
  videoMaxLength?: Maybe<Scalars['Int']['output']>;
  videoaskEmbed?: Maybe<Scalars['String']['output']>;
  videoaskLink?: Maybe<Scalars['String']['output']>;
  videoaskResponseLink?: Maybe<Scalars['String']['output']>;
  welcomeActivity?: Maybe<Scalars['String']['output']>;
  youtubeLink?: Maybe<Scalars['String']['output']>;
};

export type StudentAdksFieldsValueAction = {
  __typename?: 'StudentAdksFieldsValueAction';
  desc: Scalars['String']['output'];
  link: Scalars['String']['output'];
};

export type StudentAdksFieldsValueActionCreateInput = {
  desc: Scalars['String']['input'];
  link: Scalars['String']['input'];
};

export type StudentAdksFieldsValueActionObjectEqualityInput = {
  desc: Scalars['String']['input'];
  link: Scalars['String']['input'];
};

export type StudentAdksFieldsValueAgreement = {
  __typename?: 'StudentAdksFieldsValueAgreement';
  activityStartedOn?: Maybe<Scalars['DateTime']['output']>;
  adult?: Maybe<StudentAdksFieldsValueAgreementAdult>;
  completed?: Maybe<Scalars['DateTime']['output']>;
  envelopeId?: Maybe<Scalars['String']['output']>;
  guardian?: Maybe<StudentAdksFieldsValueAgreementGuardian>;
  minor?: Maybe<StudentAdksFieldsValueAgreementMinor>;
  name?: Maybe<Scalars['String']['output']>;
};

export type StudentAdksFieldsValueAgreementAdult = {
  __typename?: 'StudentAdksFieldsValueAgreementAdult';
  birthDate: Scalars['String']['output'];
  consent_date_time: Scalars['String']['output'];
  email: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  lastName: Scalars['String']['output'];
  phone: Scalars['String']['output'];
  signature: Scalars['String']['output'];
  signed_agreement_content: Scalars['String']['output'];
  socialSecurityNumber: Scalars['String']['output'];
  streetAddress: Scalars['String']['output'];
};

export type StudentAdksFieldsValueAgreementAdultCreateInput = {
  birthDate: Scalars['String']['input'];
  consent_date_time: Scalars['String']['input'];
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  phone: Scalars['String']['input'];
  signature: Scalars['String']['input'];
  signed_agreement_content: Scalars['String']['input'];
  socialSecurityNumber: Scalars['String']['input'];
  streetAddress: Scalars['String']['input'];
};

export type StudentAdksFieldsValueAgreementAdultObjectEqualityInput = {
  birthDate: Scalars['String']['input'];
  consent_date_time: Scalars['String']['input'];
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  phone: Scalars['String']['input'];
  signature: Scalars['String']['input'];
  signed_agreement_content: Scalars['String']['input'];
  socialSecurityNumber: Scalars['String']['input'];
  streetAddress: Scalars['String']['input'];
};

export type StudentAdksFieldsValueAgreementCreateInput = {
  activityStartedOn?: InputMaybe<Scalars['DateTime']['input']>;
  adult?: InputMaybe<StudentAdksFieldsValueAgreementAdultCreateInput>;
  completed?: InputMaybe<Scalars['DateTime']['input']>;
  envelopeId?: InputMaybe<Scalars['String']['input']>;
  guardian?: InputMaybe<StudentAdksFieldsValueAgreementGuardianCreateInput>;
  minor?: InputMaybe<StudentAdksFieldsValueAgreementMinorCreateInput>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type StudentAdksFieldsValueAgreementGuardian = {
  __typename?: 'StudentAdksFieldsValueAgreementGuardian';
  birthDate: Scalars['String']['output'];
  consent_date_time: Scalars['String']['output'];
  email: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  guardianEmail: Scalars['String']['output'];
  guardianFirstName: Scalars['String']['output'];
  guardianLastName: Scalars['String']['output'];
  guardianPhone?: Maybe<Scalars['String']['output']>;
  guardianRelationship: Scalars['String']['output'];
  guardianStreetAddress?: Maybe<Scalars['String']['output']>;
  lastName: Scalars['String']['output'];
  pending_signup: Scalars['Boolean']['output'];
  phone: Scalars['String']['output'];
  signed_agreement_content: Scalars['String']['output'];
  streetAddress?: Maybe<Scalars['String']['output']>;
  studentSocialSecurityNumber?: Maybe<Scalars['String']['output']>;
};

export type StudentAdksFieldsValueAgreementGuardianCreateInput = {
  birthDate: Scalars['String']['input'];
  consent_date_time: Scalars['String']['input'];
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  guardianEmail: Scalars['String']['input'];
  guardianFirstName: Scalars['String']['input'];
  guardianLastName: Scalars['String']['input'];
  guardianPhone?: InputMaybe<Scalars['String']['input']>;
  guardianRelationship: Scalars['String']['input'];
  guardianStreetAddress?: InputMaybe<Scalars['String']['input']>;
  lastName: Scalars['String']['input'];
  pending_signup: Scalars['Boolean']['input'];
  phone: Scalars['String']['input'];
  signed_agreement_content: Scalars['String']['input'];
  streetAddress?: InputMaybe<Scalars['String']['input']>;
  studentSocialSecurityNumber?: InputMaybe<Scalars['String']['input']>;
};

export type StudentAdksFieldsValueAgreementGuardianObjectEqualityInput = {
  birthDate: Scalars['String']['input'];
  consent_date_time: Scalars['String']['input'];
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  guardianEmail: Scalars['String']['input'];
  guardianFirstName: Scalars['String']['input'];
  guardianLastName: Scalars['String']['input'];
  guardianPhone?: InputMaybe<Scalars['String']['input']>;
  guardianRelationship: Scalars['String']['input'];
  guardianStreetAddress?: InputMaybe<Scalars['String']['input']>;
  lastName: Scalars['String']['input'];
  pending_signup: Scalars['Boolean']['input'];
  phone: Scalars['String']['input'];
  signed_agreement_content: Scalars['String']['input'];
  streetAddress?: InputMaybe<Scalars['String']['input']>;
  studentSocialSecurityNumber?: InputMaybe<Scalars['String']['input']>;
};

export type StudentAdksFieldsValueAgreementMinor = {
  __typename?: 'StudentAdksFieldsValueAgreementMinor';
  birthDate: Scalars['String']['output'];
  consent_date_time: Scalars['String']['output'];
  email: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  guardianEmail: Scalars['String']['output'];
  guardianFirstName: Scalars['String']['output'];
  guardianLastName: Scalars['String']['output'];
  guardianPhone: Scalars['String']['output'];
  guardianRelationship: Scalars['String']['output'];
  guardianStreetAddress?: Maybe<Scalars['String']['output']>;
  lastName: Scalars['String']['output'];
  phone: Scalars['String']['output'];
  signed_agreement_content: Scalars['String']['output'];
  streetAddress?: Maybe<Scalars['String']['output']>;
};

export type StudentAdksFieldsValueAgreementMinorCreateInput = {
  birthDate: Scalars['String']['input'];
  consent_date_time: Scalars['String']['input'];
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  guardianEmail: Scalars['String']['input'];
  guardianFirstName: Scalars['String']['input'];
  guardianLastName: Scalars['String']['input'];
  guardianPhone: Scalars['String']['input'];
  guardianRelationship: Scalars['String']['input'];
  guardianStreetAddress?: InputMaybe<Scalars['String']['input']>;
  lastName: Scalars['String']['input'];
  phone: Scalars['String']['input'];
  signed_agreement_content: Scalars['String']['input'];
  streetAddress?: InputMaybe<Scalars['String']['input']>;
};

export type StudentAdksFieldsValueAgreementMinorObjectEqualityInput = {
  birthDate: Scalars['String']['input'];
  consent_date_time: Scalars['String']['input'];
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  guardianEmail: Scalars['String']['input'];
  guardianFirstName: Scalars['String']['input'];
  guardianLastName: Scalars['String']['input'];
  guardianPhone: Scalars['String']['input'];
  guardianRelationship: Scalars['String']['input'];
  guardianStreetAddress?: InputMaybe<Scalars['String']['input']>;
  lastName: Scalars['String']['input'];
  phone: Scalars['String']['input'];
  signed_agreement_content: Scalars['String']['input'];
  streetAddress?: InputMaybe<Scalars['String']['input']>;
};

export type StudentAdksFieldsValueAgreementObjectEqualityInput = {
  activityStartedOn?: InputMaybe<Scalars['DateTime']['input']>;
  adult?: InputMaybe<StudentAdksFieldsValueAgreementAdultObjectEqualityInput>;
  completed?: InputMaybe<Scalars['DateTime']['input']>;
  envelopeId?: InputMaybe<Scalars['String']['input']>;
  guardian?: InputMaybe<StudentAdksFieldsValueAgreementGuardianObjectEqualityInput>;
  minor?: InputMaybe<StudentAdksFieldsValueAgreementMinorObjectEqualityInput>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type StudentAdksFieldsValueAutoapply = {
  __typename?: 'StudentAdksFieldsValueAutoapply';
  activityEndedOn?: Maybe<Scalars['DateTime']['output']>;
  autoApply: Scalars['Boolean']['output'];
  autoapply?: Maybe<StudentAdksFieldsValueAutoapplyAutoapply>;
  cancelApplication: Scalars['Boolean']['output'];
  completed?: Maybe<Scalars['DateTime']['output']>;
  endEarly: Scalars['Boolean']['output'];
  estimatedhours: Scalars['String']['output'];
  hasReceivedInterviewConfirmationNotification?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  setUpAutoapply: Scalars['Boolean']['output'];
  setupAuto: Scalars['Boolean']['output'];
  setupEndEarly: Scalars['Boolean']['output'];
  startTime?: Maybe<Scalars['Float']['output']>;
  summerClasses: Scalars['Boolean']['output'];
  summerClassesDates?: Maybe<Array<Scalars['String']['output']>>;
  summerDates?: Maybe<Array<Scalars['String']['output']>>;
  summerHours: Scalars['String']['output'];
  summerJob: Scalars['Boolean']['output'];
  summerVacation: Scalars['Boolean']['output'];
  summerVacationDates?: Maybe<Array<Scalars['String']['output']>>;
  vacationDates?: Maybe<Array<Scalars['String']['output']>>;
  videoAskResponse?: Maybe<StudentAdksFieldsValueAutoapplyVideoAskResponse>;
};

export type StudentAdksFieldsValueAutoapplyAutoapply = {
  __typename?: 'StudentAdksFieldsValueAutoapplyAutoapply';
  autoApply: Scalars['Boolean']['output'];
  autoapply?: Maybe<StudentAdksFieldsValueAutoapplyAutoapplyAutoapply>;
  cancelApplication: Scalars['Boolean']['output'];
  completed?: Maybe<Scalars['DateTime']['output']>;
  endEarly: Scalars['Boolean']['output'];
  estimatedhours: Scalars['String']['output'];
  hasReceivedInterviewConfirmationNotification: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  setUpAutoapply: Scalars['Boolean']['output'];
  setupAuto: Scalars['Boolean']['output'];
  setupEndEarly: Scalars['Boolean']['output'];
  startTime?: Maybe<Scalars['Float']['output']>;
  summerClasses: Scalars['Boolean']['output'];
  summerClassesDates?: Maybe<Array<Scalars['String']['output']>>;
  summerDates?: Maybe<Array<Scalars['String']['output']>>;
  summerHours: Scalars['String']['output'];
  summerJob: Scalars['Boolean']['output'];
  summerVacation: Scalars['Boolean']['output'];
  /** Could not determine type: the field only had null or empty values in the sample set. */
  summerVacationDates?: Maybe<Scalars['JSON']['output']>;
  /** Could not determine type: the field only had null or empty values in the sample set. */
  vacationDates?: Maybe<Scalars['JSON']['output']>;
  videoAskResponse?: Maybe<StudentAdksFieldsValueAutoapplyAutoapplyVideoAskResponse>;
};

export type StudentAdksFieldsValueAutoapplyAutoapplyAutoapply = {
  __typename?: 'StudentAdksFieldsValueAutoapplyAutoapplyAutoapply';
  autoApply: Scalars['Boolean']['output'];
  cancelApplication: Scalars['Boolean']['output'];
  endEarly: Scalars['Boolean']['output'];
  estimatedhours: Scalars['String']['output'];
  hasReceivedInterviewConfirmationNotification: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  setUpAutoapply: Scalars['Boolean']['output'];
  setupAuto: Scalars['Boolean']['output'];
  setupEndEarly: Scalars['Boolean']['output'];
  /** Could not determine type: the field only had null or empty values in the sample set. */
  startTime?: Maybe<Scalars['JSON']['output']>;
  summerClasses: Scalars['Boolean']['output'];
  /** Could not determine type: the field only had null or empty values in the sample set. */
  summerClassesDates?: Maybe<Scalars['JSON']['output']>;
  /** Could not determine type: the field only had null or empty values in the sample set. */
  summerDates?: Maybe<Scalars['JSON']['output']>;
  summerHours: Scalars['String']['output'];
  summerJob: Scalars['Boolean']['output'];
  summerVacation: Scalars['Boolean']['output'];
  /** Could not determine type: the field only had null or empty values in the sample set. */
  summerVacationDates?: Maybe<Scalars['JSON']['output']>;
  /** Could not determine type: the field only had null or empty values in the sample set. */
  vacationDates?: Maybe<Scalars['JSON']['output']>;
};

export type StudentAdksFieldsValueAutoapplyAutoapplyAutoapplyCreateInput = {
  autoApply: Scalars['Boolean']['input'];
  cancelApplication: Scalars['Boolean']['input'];
  endEarly: Scalars['Boolean']['input'];
  estimatedhours: Scalars['String']['input'];
  hasReceivedInterviewConfirmationNotification: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  setUpAutoapply: Scalars['Boolean']['input'];
  setupAuto: Scalars['Boolean']['input'];
  setupEndEarly: Scalars['Boolean']['input'];
  startTime?: InputMaybe<Scalars['JSON']['input']>;
  summerClasses: Scalars['Boolean']['input'];
  summerClassesDates?: InputMaybe<Scalars['JSON']['input']>;
  summerDates?: InputMaybe<Scalars['JSON']['input']>;
  summerHours: Scalars['String']['input'];
  summerJob: Scalars['Boolean']['input'];
  summerVacation: Scalars['Boolean']['input'];
  summerVacationDates?: InputMaybe<Scalars['JSON']['input']>;
  vacationDates?: InputMaybe<Scalars['JSON']['input']>;
};

export type StudentAdksFieldsValueAutoapplyAutoapplyAutoapplyObjectEqualityInput = {
  autoApply: Scalars['Boolean']['input'];
  cancelApplication: Scalars['Boolean']['input'];
  endEarly: Scalars['Boolean']['input'];
  estimatedhours: Scalars['String']['input'];
  hasReceivedInterviewConfirmationNotification: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  setUpAutoapply: Scalars['Boolean']['input'];
  setupAuto: Scalars['Boolean']['input'];
  setupEndEarly: Scalars['Boolean']['input'];
  startTime?: InputMaybe<Scalars['JSON']['input']>;
  summerClasses: Scalars['Boolean']['input'];
  summerClassesDates?: InputMaybe<Scalars['JSON']['input']>;
  summerDates?: InputMaybe<Scalars['JSON']['input']>;
  summerHours: Scalars['String']['input'];
  summerJob: Scalars['Boolean']['input'];
  summerVacation: Scalars['Boolean']['input'];
  summerVacationDates?: InputMaybe<Scalars['JSON']['input']>;
  vacationDates?: InputMaybe<Scalars['JSON']['input']>;
};

export type StudentAdksFieldsValueAutoapplyAutoapplyCreateInput = {
  autoApply: Scalars['Boolean']['input'];
  autoapply?: InputMaybe<StudentAdksFieldsValueAutoapplyAutoapplyAutoapplyCreateInput>;
  cancelApplication: Scalars['Boolean']['input'];
  completed?: InputMaybe<Scalars['DateTime']['input']>;
  endEarly: Scalars['Boolean']['input'];
  estimatedhours: Scalars['String']['input'];
  hasReceivedInterviewConfirmationNotification: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  setUpAutoapply: Scalars['Boolean']['input'];
  setupAuto: Scalars['Boolean']['input'];
  setupEndEarly: Scalars['Boolean']['input'];
  startTime?: InputMaybe<Scalars['Float']['input']>;
  summerClasses: Scalars['Boolean']['input'];
  summerClassesDates?: InputMaybe<StudentAdksFieldsValueAutoapplyAutoapplyCreatesummerClassesDatesInput>;
  summerDates?: InputMaybe<StudentAdksFieldsValueAutoapplyAutoapplyCreatesummerDatesInput>;
  summerHours: Scalars['String']['input'];
  summerJob: Scalars['Boolean']['input'];
  summerVacation: Scalars['Boolean']['input'];
  summerVacationDates?: InputMaybe<Scalars['JSON']['input']>;
  vacationDates?: InputMaybe<Scalars['JSON']['input']>;
  videoAskResponse?: InputMaybe<StudentAdksFieldsValueAutoapplyAutoapplyVideoAskResponseCreateInput>;
};

export type StudentAdksFieldsValueAutoapplyAutoapplyCreatesummerClassesDatesInput = {
  set: Array<Scalars['String']['input']>;
};

export type StudentAdksFieldsValueAutoapplyAutoapplyCreatesummerDatesInput = {
  set: Array<Scalars['String']['input']>;
};

export type StudentAdksFieldsValueAutoapplyAutoapplyObjectEqualityInput = {
  autoApply: Scalars['Boolean']['input'];
  autoapply?: InputMaybe<StudentAdksFieldsValueAutoapplyAutoapplyAutoapplyObjectEqualityInput>;
  cancelApplication: Scalars['Boolean']['input'];
  completed?: InputMaybe<Scalars['DateTime']['input']>;
  endEarly: Scalars['Boolean']['input'];
  estimatedhours: Scalars['String']['input'];
  hasReceivedInterviewConfirmationNotification: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  setUpAutoapply: Scalars['Boolean']['input'];
  setupAuto: Scalars['Boolean']['input'];
  setupEndEarly: Scalars['Boolean']['input'];
  startTime?: InputMaybe<Scalars['Float']['input']>;
  summerClasses: Scalars['Boolean']['input'];
  summerClassesDates?: InputMaybe<Array<Scalars['String']['input']>>;
  summerDates?: InputMaybe<Array<Scalars['String']['input']>>;
  summerHours: Scalars['String']['input'];
  summerJob: Scalars['Boolean']['input'];
  summerVacation: Scalars['Boolean']['input'];
  summerVacationDates?: InputMaybe<Scalars['JSON']['input']>;
  vacationDates?: InputMaybe<Scalars['JSON']['input']>;
  videoAskResponse?: InputMaybe<StudentAdksFieldsValueAutoapplyAutoapplyVideoAskResponseObjectEqualityInput>;
};

export type StudentAdksFieldsValueAutoapplyAutoapplyVideoAskResponse = {
  __typename?: 'StudentAdksFieldsValueAutoapplyAutoapplyVideoAskResponse';
  contact: StudentAdksFieldsValueAutoapplyAutoapplyVideoAskResponseContact;
  event_id: Scalars['String']['output'];
  event_type: Scalars['String']['output'];
  form: StudentAdksFieldsValueAutoapplyAutoapplyVideoAskResponseForm;
  interaction_id: Scalars['String']['output'];
};

export type StudentAdksFieldsValueAutoapplyAutoapplyVideoAskResponseContact = {
  __typename?: 'StudentAdksFieldsValueAutoapplyAutoapplyVideoAskResponseContact';
  answers?: Maybe<Array<StudentAdksFieldsValueAutoapplyAutoapplyVideoAskResponseContactAnswers>>;
  are_answers_public: Scalars['Boolean']['output'];
  are_messages_public: Scalars['Boolean']['output'];
  contact_id: Scalars['String']['output'];
  email: Scalars['String']['output'];
  platform: Scalars['String']['output'];
  share_id: Scalars['String']['output'];
  share_url: Scalars['String']['output'];
  status: Scalars['String']['output'];
};

export type StudentAdksFieldsValueAutoapplyAutoapplyVideoAskResponseContactAnswers = {
  __typename?: 'StudentAdksFieldsValueAutoapplyAutoapplyVideoAskResponseContactAnswers';
  answer_id: Scalars['String']['output'];
  media_id: Scalars['String']['output'];
  media_url: Scalars['String']['output'];
  /** Could not determine type: the field only had null or empty values in the sample set. */
  poll_options?: Maybe<Scalars['JSON']['output']>;
  question_id: Scalars['String']['output'];
};

export type StudentAdksFieldsValueAutoapplyAutoapplyVideoAskResponseContactAnswersCreateInput = {
  answer_id: Scalars['String']['input'];
  media_id: Scalars['String']['input'];
  media_url: Scalars['String']['input'];
  poll_options?: InputMaybe<Scalars['JSON']['input']>;
  question_id: Scalars['String']['input'];
};

export type StudentAdksFieldsValueAutoapplyAutoapplyVideoAskResponseContactAnswersObjectEqualityInput = {
  answer_id: Scalars['String']['input'];
  media_id: Scalars['String']['input'];
  media_url: Scalars['String']['input'];
  poll_options?: InputMaybe<Scalars['JSON']['input']>;
  question_id: Scalars['String']['input'];
};

export type StudentAdksFieldsValueAutoapplyAutoapplyVideoAskResponseContactCreateInput = {
  answers?: InputMaybe<Array<StudentAdksFieldsValueAutoapplyAutoapplyVideoAskResponseContactAnswersCreateInput>>;
  are_answers_public: Scalars['Boolean']['input'];
  are_messages_public: Scalars['Boolean']['input'];
  contact_id: Scalars['String']['input'];
  email: Scalars['String']['input'];
  platform: Scalars['String']['input'];
  share_id: Scalars['String']['input'];
  share_url: Scalars['String']['input'];
  status: Scalars['String']['input'];
};

export type StudentAdksFieldsValueAutoapplyAutoapplyVideoAskResponseContactObjectEqualityInput = {
  answers?: InputMaybe<Array<StudentAdksFieldsValueAutoapplyAutoapplyVideoAskResponseContactAnswersObjectEqualityInput>>;
  are_answers_public: Scalars['Boolean']['input'];
  are_messages_public: Scalars['Boolean']['input'];
  contact_id: Scalars['String']['input'];
  email: Scalars['String']['input'];
  platform: Scalars['String']['input'];
  share_id: Scalars['String']['input'];
  share_url: Scalars['String']['input'];
  status: Scalars['String']['input'];
};

export type StudentAdksFieldsValueAutoapplyAutoapplyVideoAskResponseCreateInput = {
  contact: StudentAdksFieldsValueAutoapplyAutoapplyVideoAskResponseContactCreateInput;
  event_id: Scalars['String']['input'];
  event_type: Scalars['String']['input'];
  form: StudentAdksFieldsValueAutoapplyAutoapplyVideoAskResponseFormCreateInput;
  interaction_id: Scalars['String']['input'];
};

export type StudentAdksFieldsValueAutoapplyAutoapplyVideoAskResponseForm = {
  __typename?: 'StudentAdksFieldsValueAutoapplyAutoapplyVideoAskResponseForm';
  are_answers_public: Scalars['Boolean']['output'];
  are_messages_public: Scalars['Boolean']['output'];
  form_id: Scalars['String']['output'];
  hide_branding: Scalars['Boolean']['output'];
  idle_deadline_time_in_minutes: Scalars['Int']['output'];
  notifications: StudentAdksFieldsValueAutoapplyAutoapplyVideoAskResponseFormNotifications;
  questions?: Maybe<Array<StudentAdksFieldsValueAutoapplyAutoapplyVideoAskResponseFormQuestions>>;
  requires_consent: Scalars['Boolean']['output'];
  requires_contact_email: Scalars['Boolean']['output'];
  requires_contact_info: Scalars['Boolean']['output'];
  requires_contact_name: Scalars['Boolean']['output'];
  requires_contact_phone_number: Scalars['Boolean']['output'];
  respondents_count: Scalars['Int']['output'];
  responses_share_id: Scalars['String']['output'];
  responses_share_url: Scalars['String']['output'];
  share_id: Scalars['String']['output'];
  share_url: Scalars['String']['output'];
  show_consent: Scalars['Boolean']['output'];
  show_contact_email: Scalars['Boolean']['output'];
  show_contact_name: Scalars['Boolean']['output'];
  show_contact_phone_number: Scalars['Boolean']['output'];
  tag_share_id: Scalars['String']['output'];
  tag_share_url: Scalars['String']['output'];
};

export type StudentAdksFieldsValueAutoapplyAutoapplyVideoAskResponseFormCreateInput = {
  are_answers_public: Scalars['Boolean']['input'];
  are_messages_public: Scalars['Boolean']['input'];
  form_id: Scalars['String']['input'];
  hide_branding: Scalars['Boolean']['input'];
  idle_deadline_time_in_minutes: Scalars['Int']['input'];
  notifications: StudentAdksFieldsValueAutoapplyAutoapplyVideoAskResponseFormNotificationsCreateInput;
  questions?: InputMaybe<Array<StudentAdksFieldsValueAutoapplyAutoapplyVideoAskResponseFormQuestionsCreateInput>>;
  requires_consent: Scalars['Boolean']['input'];
  requires_contact_email: Scalars['Boolean']['input'];
  requires_contact_info: Scalars['Boolean']['input'];
  requires_contact_name: Scalars['Boolean']['input'];
  requires_contact_phone_number: Scalars['Boolean']['input'];
  respondents_count: Scalars['Int']['input'];
  responses_share_id: Scalars['String']['input'];
  responses_share_url: Scalars['String']['input'];
  share_id: Scalars['String']['input'];
  share_url: Scalars['String']['input'];
  show_consent: Scalars['Boolean']['input'];
  show_contact_email: Scalars['Boolean']['input'];
  show_contact_name: Scalars['Boolean']['input'];
  show_contact_phone_number: Scalars['Boolean']['input'];
  tag_share_id: Scalars['String']['input'];
  tag_share_url: Scalars['String']['input'];
};

export type StudentAdksFieldsValueAutoapplyAutoapplyVideoAskResponseFormNotifications = {
  __typename?: 'StudentAdksFieldsValueAutoapplyAutoapplyVideoAskResponseFormNotifications';
  send_contact_message_emails: Scalars['Boolean']['output'];
};

export type StudentAdksFieldsValueAutoapplyAutoapplyVideoAskResponseFormNotificationsCreateInput = {
  send_contact_message_emails: Scalars['Boolean']['input'];
};

export type StudentAdksFieldsValueAutoapplyAutoapplyVideoAskResponseFormNotificationsObjectEqualityInput = {
  send_contact_message_emails: Scalars['Boolean']['input'];
};

export type StudentAdksFieldsValueAutoapplyAutoapplyVideoAskResponseFormObjectEqualityInput = {
  are_answers_public: Scalars['Boolean']['input'];
  are_messages_public: Scalars['Boolean']['input'];
  form_id: Scalars['String']['input'];
  hide_branding: Scalars['Boolean']['input'];
  idle_deadline_time_in_minutes: Scalars['Int']['input'];
  notifications: StudentAdksFieldsValueAutoapplyAutoapplyVideoAskResponseFormNotificationsObjectEqualityInput;
  questions?: InputMaybe<Array<StudentAdksFieldsValueAutoapplyAutoapplyVideoAskResponseFormQuestionsObjectEqualityInput>>;
  requires_consent: Scalars['Boolean']['input'];
  requires_contact_email: Scalars['Boolean']['input'];
  requires_contact_info: Scalars['Boolean']['input'];
  requires_contact_name: Scalars['Boolean']['input'];
  requires_contact_phone_number: Scalars['Boolean']['input'];
  respondents_count: Scalars['Int']['input'];
  responses_share_id: Scalars['String']['input'];
  responses_share_url: Scalars['String']['input'];
  share_id: Scalars['String']['input'];
  share_url: Scalars['String']['input'];
  show_consent: Scalars['Boolean']['input'];
  show_contact_email: Scalars['Boolean']['input'];
  show_contact_name: Scalars['Boolean']['input'];
  show_contact_phone_number: Scalars['Boolean']['input'];
  tag_share_id: Scalars['String']['input'];
  tag_share_url: Scalars['String']['input'];
};

export type StudentAdksFieldsValueAutoapplyAutoapplyVideoAskResponseFormQuestions = {
  __typename?: 'StudentAdksFieldsValueAutoapplyAutoapplyVideoAskResponseFormQuestions';
  question_id: Scalars['String']['output'];
};

export type StudentAdksFieldsValueAutoapplyAutoapplyVideoAskResponseFormQuestionsCreateInput = {
  question_id: Scalars['String']['input'];
};

export type StudentAdksFieldsValueAutoapplyAutoapplyVideoAskResponseFormQuestionsObjectEqualityInput = {
  question_id: Scalars['String']['input'];
};

export type StudentAdksFieldsValueAutoapplyAutoapplyVideoAskResponseObjectEqualityInput = {
  contact: StudentAdksFieldsValueAutoapplyAutoapplyVideoAskResponseContactObjectEqualityInput;
  event_id: Scalars['String']['input'];
  event_type: Scalars['String']['input'];
  form: StudentAdksFieldsValueAutoapplyAutoapplyVideoAskResponseFormObjectEqualityInput;
  interaction_id: Scalars['String']['input'];
};

export type StudentAdksFieldsValueAutoapplyCreateInput = {
  activityEndedOn?: InputMaybe<Scalars['DateTime']['input']>;
  autoApply: Scalars['Boolean']['input'];
  autoapply?: InputMaybe<StudentAdksFieldsValueAutoapplyAutoapplyCreateInput>;
  cancelApplication: Scalars['Boolean']['input'];
  completed?: InputMaybe<Scalars['DateTime']['input']>;
  endEarly: Scalars['Boolean']['input'];
  estimatedhours: Scalars['String']['input'];
  hasReceivedInterviewConfirmationNotification?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  setUpAutoapply: Scalars['Boolean']['input'];
  setupAuto: Scalars['Boolean']['input'];
  setupEndEarly: Scalars['Boolean']['input'];
  startTime?: InputMaybe<Scalars['Float']['input']>;
  summerClasses: Scalars['Boolean']['input'];
  summerClassesDates?: InputMaybe<StudentAdksFieldsValueAutoapplyCreatesummerClassesDatesInput>;
  summerDates?: InputMaybe<StudentAdksFieldsValueAutoapplyCreatesummerDatesInput>;
  summerHours: Scalars['String']['input'];
  summerJob: Scalars['Boolean']['input'];
  summerVacation: Scalars['Boolean']['input'];
  summerVacationDates?: InputMaybe<StudentAdksFieldsValueAutoapplyCreatesummerVacationDatesInput>;
  vacationDates?: InputMaybe<StudentAdksFieldsValueAutoapplyCreatevacationDatesInput>;
  videoAskResponse?: InputMaybe<StudentAdksFieldsValueAutoapplyVideoAskResponseCreateInput>;
};

export type StudentAdksFieldsValueAutoapplyCreatesummerClassesDatesInput = {
  set: Array<Scalars['String']['input']>;
};

export type StudentAdksFieldsValueAutoapplyCreatesummerDatesInput = {
  set: Array<Scalars['String']['input']>;
};

export type StudentAdksFieldsValueAutoapplyCreatesummerVacationDatesInput = {
  set: Array<Scalars['String']['input']>;
};

export type StudentAdksFieldsValueAutoapplyCreatevacationDatesInput = {
  set: Array<Scalars['String']['input']>;
};

export type StudentAdksFieldsValueAutoapplyObjectEqualityInput = {
  activityEndedOn?: InputMaybe<Scalars['DateTime']['input']>;
  autoApply: Scalars['Boolean']['input'];
  autoapply?: InputMaybe<StudentAdksFieldsValueAutoapplyAutoapplyObjectEqualityInput>;
  cancelApplication: Scalars['Boolean']['input'];
  completed?: InputMaybe<Scalars['DateTime']['input']>;
  endEarly: Scalars['Boolean']['input'];
  estimatedhours: Scalars['String']['input'];
  hasReceivedInterviewConfirmationNotification?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  setUpAutoapply: Scalars['Boolean']['input'];
  setupAuto: Scalars['Boolean']['input'];
  setupEndEarly: Scalars['Boolean']['input'];
  startTime?: InputMaybe<Scalars['Float']['input']>;
  summerClasses: Scalars['Boolean']['input'];
  summerClassesDates?: InputMaybe<Array<Scalars['String']['input']>>;
  summerDates?: InputMaybe<Array<Scalars['String']['input']>>;
  summerHours: Scalars['String']['input'];
  summerJob: Scalars['Boolean']['input'];
  summerVacation: Scalars['Boolean']['input'];
  summerVacationDates?: InputMaybe<Array<Scalars['String']['input']>>;
  vacationDates?: InputMaybe<Array<Scalars['String']['input']>>;
  videoAskResponse?: InputMaybe<StudentAdksFieldsValueAutoapplyVideoAskResponseObjectEqualityInput>;
};

export type StudentAdksFieldsValueAutoapplyVideoAskResponse = {
  __typename?: 'StudentAdksFieldsValueAutoapplyVideoAskResponse';
  contact: StudentAdksFieldsValueAutoapplyVideoAskResponseContact;
  event_id: Scalars['String']['output'];
  event_type: Scalars['String']['output'];
  form: StudentAdksFieldsValueAutoapplyVideoAskResponseForm;
  interaction_id: Scalars['String']['output'];
};

export type StudentAdksFieldsValueAutoapplyVideoAskResponseContact = {
  __typename?: 'StudentAdksFieldsValueAutoapplyVideoAskResponseContact';
  answers?: Maybe<Array<StudentAdksFieldsValueAutoapplyVideoAskResponseContactAnswers>>;
  are_answers_public: Scalars['Boolean']['output'];
  are_messages_public: Scalars['Boolean']['output'];
  contact_id: Scalars['String']['output'];
  email: Scalars['String']['output'];
  platform: Scalars['String']['output'];
  share_id: Scalars['String']['output'];
  share_url: Scalars['String']['output'];
  status: Scalars['String']['output'];
};

export type StudentAdksFieldsValueAutoapplyVideoAskResponseContactAnswers = {
  __typename?: 'StudentAdksFieldsValueAutoapplyVideoAskResponseContactAnswers';
  answer_id: Scalars['String']['output'];
  media_id: Scalars['String']['output'];
  media_url: Scalars['String']['output'];
  /** Could not determine type: the field only had null or empty values in the sample set. */
  poll_options?: Maybe<Scalars['JSON']['output']>;
  question_id: Scalars['String']['output'];
};

export type StudentAdksFieldsValueAutoapplyVideoAskResponseContactAnswersCreateInput = {
  answer_id: Scalars['String']['input'];
  media_id: Scalars['String']['input'];
  media_url: Scalars['String']['input'];
  poll_options?: InputMaybe<Scalars['JSON']['input']>;
  question_id: Scalars['String']['input'];
};

export type StudentAdksFieldsValueAutoapplyVideoAskResponseContactAnswersObjectEqualityInput = {
  answer_id: Scalars['String']['input'];
  media_id: Scalars['String']['input'];
  media_url: Scalars['String']['input'];
  poll_options?: InputMaybe<Scalars['JSON']['input']>;
  question_id: Scalars['String']['input'];
};

export type StudentAdksFieldsValueAutoapplyVideoAskResponseContactCreateInput = {
  answers?: InputMaybe<Array<StudentAdksFieldsValueAutoapplyVideoAskResponseContactAnswersCreateInput>>;
  are_answers_public: Scalars['Boolean']['input'];
  are_messages_public: Scalars['Boolean']['input'];
  contact_id: Scalars['String']['input'];
  email: Scalars['String']['input'];
  platform: Scalars['String']['input'];
  share_id: Scalars['String']['input'];
  share_url: Scalars['String']['input'];
  status: Scalars['String']['input'];
};

export type StudentAdksFieldsValueAutoapplyVideoAskResponseContactObjectEqualityInput = {
  answers?: InputMaybe<Array<StudentAdksFieldsValueAutoapplyVideoAskResponseContactAnswersObjectEqualityInput>>;
  are_answers_public: Scalars['Boolean']['input'];
  are_messages_public: Scalars['Boolean']['input'];
  contact_id: Scalars['String']['input'];
  email: Scalars['String']['input'];
  platform: Scalars['String']['input'];
  share_id: Scalars['String']['input'];
  share_url: Scalars['String']['input'];
  status: Scalars['String']['input'];
};

export type StudentAdksFieldsValueAutoapplyVideoAskResponseCreateInput = {
  contact: StudentAdksFieldsValueAutoapplyVideoAskResponseContactCreateInput;
  event_id: Scalars['String']['input'];
  event_type: Scalars['String']['input'];
  form: StudentAdksFieldsValueAutoapplyVideoAskResponseFormCreateInput;
  interaction_id: Scalars['String']['input'];
};

export type StudentAdksFieldsValueAutoapplyVideoAskResponseForm = {
  __typename?: 'StudentAdksFieldsValueAutoapplyVideoAskResponseForm';
  are_answers_public: Scalars['Boolean']['output'];
  are_messages_public: Scalars['Boolean']['output'];
  form_id: Scalars['String']['output'];
  hide_branding: Scalars['Boolean']['output'];
  idle_deadline_time_in_minutes: Scalars['Int']['output'];
  notifications: StudentAdksFieldsValueAutoapplyVideoAskResponseFormNotifications;
  questions?: Maybe<Array<StudentAdksFieldsValueAutoapplyVideoAskResponseFormQuestions>>;
  requires_consent: Scalars['Boolean']['output'];
  requires_contact_email: Scalars['Boolean']['output'];
  requires_contact_info: Scalars['Boolean']['output'];
  requires_contact_name: Scalars['Boolean']['output'];
  requires_contact_phone_number: Scalars['Boolean']['output'];
  respondents_count: Scalars['Int']['output'];
  responses_share_id: Scalars['String']['output'];
  responses_share_url: Scalars['String']['output'];
  share_id: Scalars['String']['output'];
  share_url: Scalars['String']['output'];
  show_consent: Scalars['Boolean']['output'];
  show_contact_email: Scalars['Boolean']['output'];
  show_contact_name: Scalars['Boolean']['output'];
  show_contact_phone_number: Scalars['Boolean']['output'];
  tag_share_id: Scalars['String']['output'];
  tag_share_url: Scalars['String']['output'];
};

export type StudentAdksFieldsValueAutoapplyVideoAskResponseFormCreateInput = {
  are_answers_public: Scalars['Boolean']['input'];
  are_messages_public: Scalars['Boolean']['input'];
  form_id: Scalars['String']['input'];
  hide_branding: Scalars['Boolean']['input'];
  idle_deadline_time_in_minutes: Scalars['Int']['input'];
  notifications: StudentAdksFieldsValueAutoapplyVideoAskResponseFormNotificationsCreateInput;
  questions?: InputMaybe<Array<StudentAdksFieldsValueAutoapplyVideoAskResponseFormQuestionsCreateInput>>;
  requires_consent: Scalars['Boolean']['input'];
  requires_contact_email: Scalars['Boolean']['input'];
  requires_contact_info: Scalars['Boolean']['input'];
  requires_contact_name: Scalars['Boolean']['input'];
  requires_contact_phone_number: Scalars['Boolean']['input'];
  respondents_count: Scalars['Int']['input'];
  responses_share_id: Scalars['String']['input'];
  responses_share_url: Scalars['String']['input'];
  share_id: Scalars['String']['input'];
  share_url: Scalars['String']['input'];
  show_consent: Scalars['Boolean']['input'];
  show_contact_email: Scalars['Boolean']['input'];
  show_contact_name: Scalars['Boolean']['input'];
  show_contact_phone_number: Scalars['Boolean']['input'];
  tag_share_id: Scalars['String']['input'];
  tag_share_url: Scalars['String']['input'];
};

export type StudentAdksFieldsValueAutoapplyVideoAskResponseFormNotifications = {
  __typename?: 'StudentAdksFieldsValueAutoapplyVideoAskResponseFormNotifications';
  send_contact_message_emails: Scalars['Boolean']['output'];
};

export type StudentAdksFieldsValueAutoapplyVideoAskResponseFormNotificationsCreateInput = {
  send_contact_message_emails: Scalars['Boolean']['input'];
};

export type StudentAdksFieldsValueAutoapplyVideoAskResponseFormNotificationsObjectEqualityInput = {
  send_contact_message_emails: Scalars['Boolean']['input'];
};

export type StudentAdksFieldsValueAutoapplyVideoAskResponseFormObjectEqualityInput = {
  are_answers_public: Scalars['Boolean']['input'];
  are_messages_public: Scalars['Boolean']['input'];
  form_id: Scalars['String']['input'];
  hide_branding: Scalars['Boolean']['input'];
  idle_deadline_time_in_minutes: Scalars['Int']['input'];
  notifications: StudentAdksFieldsValueAutoapplyVideoAskResponseFormNotificationsObjectEqualityInput;
  questions?: InputMaybe<Array<StudentAdksFieldsValueAutoapplyVideoAskResponseFormQuestionsObjectEqualityInput>>;
  requires_consent: Scalars['Boolean']['input'];
  requires_contact_email: Scalars['Boolean']['input'];
  requires_contact_info: Scalars['Boolean']['input'];
  requires_contact_name: Scalars['Boolean']['input'];
  requires_contact_phone_number: Scalars['Boolean']['input'];
  respondents_count: Scalars['Int']['input'];
  responses_share_id: Scalars['String']['input'];
  responses_share_url: Scalars['String']['input'];
  share_id: Scalars['String']['input'];
  share_url: Scalars['String']['input'];
  show_consent: Scalars['Boolean']['input'];
  show_contact_email: Scalars['Boolean']['input'];
  show_contact_name: Scalars['Boolean']['input'];
  show_contact_phone_number: Scalars['Boolean']['input'];
  tag_share_id: Scalars['String']['input'];
  tag_share_url: Scalars['String']['input'];
};

export type StudentAdksFieldsValueAutoapplyVideoAskResponseFormQuestions = {
  __typename?: 'StudentAdksFieldsValueAutoapplyVideoAskResponseFormQuestions';
  question_id: Scalars['String']['output'];
};

export type StudentAdksFieldsValueAutoapplyVideoAskResponseFormQuestionsCreateInput = {
  question_id: Scalars['String']['input'];
};

export type StudentAdksFieldsValueAutoapplyVideoAskResponseFormQuestionsObjectEqualityInput = {
  question_id: Scalars['String']['input'];
};

export type StudentAdksFieldsValueAutoapplyVideoAskResponseObjectEqualityInput = {
  contact: StudentAdksFieldsValueAutoapplyVideoAskResponseContactObjectEqualityInput;
  event_id: Scalars['String']['input'];
  event_type: Scalars['String']['input'];
  form: StudentAdksFieldsValueAutoapplyVideoAskResponseFormObjectEqualityInput;
  interaction_id: Scalars['String']['input'];
};

export type StudentAdksFieldsValueBoards = {
  __typename?: 'StudentAdksFieldsValueBoards';
  teamName: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type StudentAdksFieldsValueBoardsCreateInput = {
  teamName: Scalars['String']['input'];
  url: Scalars['String']['input'];
};

export type StudentAdksFieldsValueBoardsObjectEqualityInput = {
  teamName: Scalars['String']['input'];
  url: Scalars['String']['input'];
};

export type StudentAdksFieldsValueChannels = {
  __typename?: 'StudentAdksFieldsValueChannels';
  linkName?: Maybe<Scalars['String']['output']>;
  teamName?: Maybe<Scalars['String']['output']>;
  url: Scalars['String']['output'];
};

export type StudentAdksFieldsValueChannelsCreateInput = {
  linkName?: InputMaybe<Scalars['String']['input']>;
  teamName?: InputMaybe<Scalars['String']['input']>;
  url: Scalars['String']['input'];
};

export type StudentAdksFieldsValueChannelsObjectEqualityInput = {
  linkName?: InputMaybe<Scalars['String']['input']>;
  teamName?: InputMaybe<Scalars['String']['input']>;
  url: Scalars['String']['input'];
};

export type StudentAdksFieldsValueCreateInput = {
  Description_1689596544146?: InputMaybe<Scalars['String']['input']>;
  Description_1689610327886?: InputMaybe<Scalars['String']['input']>;
  Select_1689610316209?: InputMaybe<Scalars['String']['input']>;
  aboutOrg?: InputMaybe<Scalars['String']['input']>;
  acceptanceDeadline?: InputMaybe<Scalars['String']['input']>;
  accessSkills?: InputMaybe<StudentAdksFieldsValueCreateaccessSkillsInput>;
  action?: InputMaybe<StudentAdksFieldsValueActionCreateInput>;
  ageRange?: InputMaybe<Scalars['JSON']['input']>;
  agreement?: InputMaybe<StudentAdksFieldsValueAgreementCreateInput>;
  airtableFormLink?: InputMaybe<Scalars['String']['input']>;
  airtableLink?: InputMaybe<Scalars['String']['input']>;
  airtableResponseLink?: InputMaybe<Scalars['String']['input']>;
  airtableTableLink?: InputMaybe<Scalars['String']['input']>;
  apprentice?: InputMaybe<Scalars['Boolean']['input']>;
  arrivalLink?: InputMaybe<Scalars['String']['input']>;
  arrivalStatus?: InputMaybe<Scalars['String']['input']>;
  attendeeList?: InputMaybe<Scalars['String']['input']>;
  autoapply?: InputMaybe<StudentAdksFieldsValueAutoapplyCreateInput>;
  boards?: InputMaybe<Array<StudentAdksFieldsValueBoardsCreateInput>>;
  bookmarkedQuestions?: InputMaybe<StudentAdksFieldsValueCreatebookmarkedQuestionsInput>;
  channels?: InputMaybe<Array<StudentAdksFieldsValueChannelsCreateInput>>;
  checkinLink?: InputMaybe<Scalars['String']['input']>;
  compensation1?: InputMaybe<Scalars['Boolean']['input']>;
  compensation2?: InputMaybe<Scalars['Boolean']['input']>;
  compensation3?: InputMaybe<Scalars['Boolean']['input']>;
  compensation4?: InputMaybe<Scalars['Boolean']['input']>;
  compensation5?: InputMaybe<Scalars['Boolean']['input']>;
  compensation6?: InputMaybe<Scalars['Boolean']['input']>;
  connection?: InputMaybe<Scalars['String']['input']>;
  continuation?: InputMaybe<Scalars['Int']['input']>;
  defaultActivity?: InputMaybe<StudentAdksFieldsValueDefaultActivityCreateInput>;
  deliverable?: InputMaybe<StudentAdksFieldsValueCreatedeliverableInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  directoryPreferences?: InputMaybe<Scalars['JSON']['input']>;
  discordData?: InputMaybe<StudentAdksFieldsValueDiscordDataCreateInput>;
  discordInfo?: InputMaybe<StudentAdksFieldsValueDiscordInfoCreateInput>;
  discordIntegraionSkipped?: InputMaybe<Scalars['Boolean']['input']>;
  discordLink?: InputMaybe<Scalars['String']['input']>;
  dislikedQuestions?: InputMaybe<StudentAdksFieldsValueCreatedislikedQuestionsInput>;
  docDesc?: InputMaybe<Scalars['String']['input']>;
  docLink?: InputMaybe<Scalars['String']['input']>;
  driveLink?: InputMaybe<Scalars['String']['input']>;
  eir?: InputMaybe<Scalars['Boolean']['input']>;
  employerRecord?: InputMaybe<Scalars['Int']['input']>;
  endEarlyActivity?: InputMaybe<Scalars['String']['input']>;
  eventAgenda?: InputMaybe<Scalars['String']['input']>;
  eventDate?: InputMaybe<Scalars['String']['input']>;
  eventLocations?: InputMaybe<Scalars['String']['input']>;
  eventName?: InputMaybe<Scalars['String']['input']>;
  events?: InputMaybe<StudentAdksFieldsValueEventsCreateInput>;
  extern?: InputMaybe<Scalars['Boolean']['input']>;
  externCredential?: InputMaybe<Scalars['JSON']['input']>;
  fellow?: InputMaybe<Scalars['Boolean']['input']>;
  fileType?: InputMaybe<StudentAdksFieldsValueCreatefileTypeInput>;
  flaggedComments?: InputMaybe<StudentAdksFieldsValueCreateflaggedCommentsInput>;
  form_id?: InputMaybe<Scalars['String']['input']>;
  form_url?: InputMaybe<Scalars['String']['input']>;
  groupActivity?: InputMaybe<Scalars['String']['input']>;
  instructions?: InputMaybe<Scalars['String']['input']>;
  intern?: InputMaybe<Scalars['Boolean']['input']>;
  internshipEnd?: InputMaybe<Scalars['String']['input']>;
  internshipProject1?: InputMaybe<Scalars['Boolean']['input']>;
  internshipProject2?: InputMaybe<Scalars['Boolean']['input']>;
  internshipProject3?: InputMaybe<Scalars['Boolean']['input']>;
  internshipStart?: InputMaybe<Scalars['String']['input']>;
  interviewChallenge?: InputMaybe<Scalars['String']['input']>;
  interviewOpportunity?: InputMaybe<Scalars['String']['input']>;
  interviewProblem?: InputMaybe<Scalars['String']['input']>;
  interviewRequest?: InputMaybe<Scalars['String']['input']>;
  interviewSolution?: InputMaybe<Scalars['String']['input']>;
  lastInteraction?: InputMaybe<Scalars['String']['input']>;
  lastInteractionId?: InputMaybe<Scalars['String']['input']>;
  licenseRequirement?: InputMaybe<Scalars['Int']['input']>;
  likedComments?: InputMaybe<StudentAdksFieldsValueCreatelikedCommentsInput>;
  likedQuestions?: InputMaybe<StudentAdksFieldsValueCreatelikedQuestionsInput>;
  loaded?: InputMaybe<StudentAdksFieldsValueCreateloadedInput>;
  logs?: InputMaybe<Array<StudentAdksFieldsValueLogsCreateInput>>;
  maxCharacters?: InputMaybe<Scalars['String']['input']>;
  maxHours?: InputMaybe<Scalars['Int']['input']>;
  maxQuestions?: InputMaybe<Scalars['Int']['input']>;
  maxTeamMembers?: InputMaybe<Scalars['Int']['input']>;
  maximumBudget?: InputMaybe<Scalars['String']['input']>;
  minHours?: InputMaybe<Scalars['Int']['input']>;
  minLogs?: InputMaybe<Scalars['Int']['input']>;
  minimumBudget?: InputMaybe<Scalars['String']['input']>;
  minimumHoursNow?: InputMaybe<Scalars['JSON']['input']>;
  offerStatus?: InputMaybe<Scalars['Boolean']['input']>;
  outcome?: InputMaybe<StudentAdksFieldsValueCreateoutcomeInput>;
  pathways?: InputMaybe<StudentAdksFieldsValueCreatepathwaysInput>;
  practiceLog?: InputMaybe<Array<StudentAdksFieldsValuePracticeLogCreateInput>>;
  preApprentice?: InputMaybe<Scalars['Boolean']['input']>;
  preInternship?: InputMaybe<Scalars['Boolean']['input']>;
  programDesc?: InputMaybe<Scalars['String']['input']>;
  programName?: InputMaybe<Scalars['String']['input']>;
  projectReq?: InputMaybe<Scalars['JSON']['input']>;
  providers?: InputMaybe<StudentAdksFieldsValueProvidersCreateInput>;
  questionsAsked?: InputMaybe<StudentAdksFieldsValueCreatequestionsAskedInput>;
  requiredActivity?: InputMaybe<Scalars['String']['input']>;
  requiredResidency?: InputMaybe<Scalars['JSON']['input']>;
  requiredSkills?: InputMaybe<StudentAdksFieldsValueCreaterequiredSkillsInput>;
  researchLinks?: InputMaybe<Array<StudentAdksFieldsValueResearchLinksCreateInput>>;
  researchProgress?: InputMaybe<Array<StudentAdksFieldsValueResearchProgressCreateInput>>;
  resourceDrive?: InputMaybe<Scalars['String']['input']>;
  resourceFacebook?: InputMaybe<Scalars['String']['input']>;
  resourceInsta?: InputMaybe<Scalars['String']['input']>;
  resourceLinkedIn?: InputMaybe<Scalars['String']['input']>;
  resourceTwitter?: InputMaybe<Scalars['String']['input']>;
  resourceWeb?: InputMaybe<Scalars['String']['input']>;
  resourceYouTube?: InputMaybe<Scalars['String']['input']>;
  rewards?: InputMaybe<Scalars['JSON']['input']>;
  rsvpLink?: InputMaybe<Scalars['String']['input']>;
  settings?: InputMaybe<StudentAdksFieldsValueSettingsCreateInput>;
  signInVideoAskResponse?: InputMaybe<StudentAdksFieldsValueSignInVideoAskResponseCreateInput>;
  signOffVideoAskResponse?: InputMaybe<StudentAdksFieldsValueSignOffVideoAskResponseCreateInput>;
  studentEthnicity?: InputMaybe<StudentAdksFieldsValueCreatestudentEthnicityInput>;
  studentLocation?: InputMaybe<Scalars['JSON']['input']>;
  studentResidence?: InputMaybe<Scalars['String']['input']>;
  studentSchool?: InputMaybe<Scalars['String']['input']>;
  submission?: InputMaybe<StudentAdksFieldsValueSubmissionCreateInput>;
  submittedVideo?: InputMaybe<StudentAdksFieldsValueSubmittedVideoCreateInput>;
  textFields?: InputMaybe<StudentAdksFieldsValueCreatetextFieldsInput>;
  text_input_1689596540310?: InputMaybe<Scalars['String']['input']>;
  timeFrame?: InputMaybe<Array<StudentAdksFieldsValueTimeFrameCreateInput>>;
  timeZone?: InputMaybe<Scalars['String']['input']>;
  timesheetDetails?: InputMaybe<Array<StudentAdksFieldsValueTimesheetDetailsCreateInput>>;
  trainProgress?: InputMaybe<Array<StudentAdksFieldsValueTrainProgressCreateInput>>;
  uploadLimit?: InputMaybe<StudentAdksFieldsValueUploadLimitCreateInput>;
  uploadLink?: InputMaybe<Scalars['String']['input']>;
  valueDrafts?: InputMaybe<Array<StudentAdksFieldsValueValueDraftsCreateInput>>;
  videoAskResponse?: InputMaybe<StudentAdksFieldsValueVideoAskResponseCreateInput>;
  videoLinks?: InputMaybe<Array<StudentAdksFieldsValueVideoLinksCreateInput>>;
  videoMaxLength?: InputMaybe<Scalars['Int']['input']>;
  videoaskEmbed?: InputMaybe<Scalars['String']['input']>;
  videoaskLink?: InputMaybe<Scalars['String']['input']>;
  videoaskResponseLink?: InputMaybe<Scalars['String']['input']>;
  welcomeActivity?: InputMaybe<Scalars['String']['input']>;
  youtubeLink?: InputMaybe<Scalars['String']['input']>;
};

export type StudentAdksFieldsValueCreateaccessSkillsInput = {
  set: Array<Scalars['String']['input']>;
};

export type StudentAdksFieldsValueCreatebookmarkedQuestionsInput = {
  set: Array<Scalars['String']['input']>;
};

export type StudentAdksFieldsValueCreatedeliverableInput = {
  set: Array<Scalars['String']['input']>;
};

export type StudentAdksFieldsValueCreatedislikedQuestionsInput = {
  set: Array<Scalars['String']['input']>;
};

export type StudentAdksFieldsValueCreatefileTypeInput = {
  set: Array<Scalars['String']['input']>;
};

export type StudentAdksFieldsValueCreateflaggedCommentsInput = {
  set: Array<Scalars['String']['input']>;
};

export type StudentAdksFieldsValueCreatelikedCommentsInput = {
  set: Array<Scalars['String']['input']>;
};

export type StudentAdksFieldsValueCreatelikedQuestionsInput = {
  set: Array<Scalars['String']['input']>;
};

export type StudentAdksFieldsValueCreateloadedInput = {
  set: Array<Scalars['String']['input']>;
};

export type StudentAdksFieldsValueCreateoutcomeInput = {
  set: Array<Scalars['String']['input']>;
};

export type StudentAdksFieldsValueCreatepathwaysInput = {
  set: Array<Scalars['String']['input']>;
};

export type StudentAdksFieldsValueCreatequestionsAskedInput = {
  set: Array<Scalars['String']['input']>;
};

export type StudentAdksFieldsValueCreaterequiredSkillsInput = {
  set: Array<Scalars['String']['input']>;
};

export type StudentAdksFieldsValueCreatestudentEthnicityInput = {
  set: Array<Scalars['String']['input']>;
};

export type StudentAdksFieldsValueCreatetextFieldsInput = {
  set: Array<Scalars['String']['input']>;
};

export type StudentAdksFieldsValueDefaultActivity = {
  __typename?: 'StudentAdksFieldsValueDefaultActivity';
  deliverableActivity: Scalars['String']['output'];
  endEarlyActivity: Scalars['String']['output'];
  groupActivity: Scalars['String']['output'];
  required: Scalars['Boolean']['output'];
  requiredActivity: Scalars['String']['output'];
};

export type StudentAdksFieldsValueDefaultActivityCreateInput = {
  deliverableActivity: Scalars['String']['input'];
  endEarlyActivity: Scalars['String']['input'];
  groupActivity: Scalars['String']['input'];
  required: Scalars['Boolean']['input'];
  requiredActivity: Scalars['String']['input'];
};

export type StudentAdksFieldsValueDefaultActivityObjectEqualityInput = {
  deliverableActivity: Scalars['String']['input'];
  endEarlyActivity: Scalars['String']['input'];
  groupActivity: Scalars['String']['input'];
  required: Scalars['Boolean']['input'];
  requiredActivity: Scalars['String']['input'];
};

export type StudentAdksFieldsValueDiscordData = {
  __typename?: 'StudentAdksFieldsValueDiscordData';
  channel?: Maybe<StudentAdksFieldsValueDiscordDataChannel>;
  createdBy: StudentAdksFieldsValueDiscordDataCreatedBy;
  role: StudentAdksFieldsValueDiscordDataRole;
};

export type StudentAdksFieldsValueDiscordDataChannel = {
  __typename?: 'StudentAdksFieldsValueDiscordDataChannel';
  flags: Scalars['Int']['output'];
  guild_id: Scalars['String']['output'];
  icon_emoji?: Maybe<StudentAdksFieldsValueDiscordDataChannelIconEmoji>;
  id: Scalars['String']['output'];
  /** Could not determine type: the field only had null or empty values in the sample set. */
  last_message_id?: Maybe<Scalars['JSON']['output']>;
  name: Scalars['String']['output'];
  nsfw: Scalars['Boolean']['output'];
  parent_id: Scalars['String']['output'];
  permission_overwrites?: Maybe<Array<StudentAdksFieldsValueDiscordDataChannelPermissionOverwrites>>;
  position: Scalars['Int']['output'];
  rate_limit_per_user: Scalars['Int']['output'];
  /** Could not determine type: the field only had null or empty values in the sample set. */
  theme_color?: Maybe<Scalars['JSON']['output']>;
  /** Could not determine type: the field only had null or empty values in the sample set. */
  topic?: Maybe<Scalars['JSON']['output']>;
  type: Scalars['Int']['output'];
};

export type StudentAdksFieldsValueDiscordDataChannelCreateInput = {
  flags: Scalars['Int']['input'];
  guild_id: Scalars['String']['input'];
  icon_emoji?: InputMaybe<StudentAdksFieldsValueDiscordDataChannelIconEmojiCreateInput>;
  id: Scalars['String']['input'];
  last_message_id?: InputMaybe<Scalars['JSON']['input']>;
  name: Scalars['String']['input'];
  nsfw: Scalars['Boolean']['input'];
  parent_id: Scalars['String']['input'];
  permission_overwrites?: InputMaybe<Array<StudentAdksFieldsValueDiscordDataChannelPermissionOverwritesCreateInput>>;
  position: Scalars['Int']['input'];
  rate_limit_per_user: Scalars['Int']['input'];
  theme_color?: InputMaybe<Scalars['JSON']['input']>;
  topic?: InputMaybe<Scalars['JSON']['input']>;
  type: Scalars['Int']['input'];
};

export type StudentAdksFieldsValueDiscordDataChannelIconEmoji = {
  __typename?: 'StudentAdksFieldsValueDiscordDataChannelIconEmoji';
  /** Could not determine type: the field only had null or empty values in the sample set. */
  id?: Maybe<Scalars['JSON']['output']>;
  name: Scalars['String']['output'];
};

export type StudentAdksFieldsValueDiscordDataChannelIconEmojiCreateInput = {
  id?: InputMaybe<Scalars['JSON']['input']>;
  name: Scalars['String']['input'];
};

export type StudentAdksFieldsValueDiscordDataChannelIconEmojiObjectEqualityInput = {
  id?: InputMaybe<Scalars['JSON']['input']>;
  name: Scalars['String']['input'];
};

export type StudentAdksFieldsValueDiscordDataChannelObjectEqualityInput = {
  flags: Scalars['Int']['input'];
  guild_id: Scalars['String']['input'];
  icon_emoji?: InputMaybe<StudentAdksFieldsValueDiscordDataChannelIconEmojiObjectEqualityInput>;
  id: Scalars['String']['input'];
  last_message_id?: InputMaybe<Scalars['JSON']['input']>;
  name: Scalars['String']['input'];
  nsfw: Scalars['Boolean']['input'];
  parent_id: Scalars['String']['input'];
  permission_overwrites?: InputMaybe<Array<StudentAdksFieldsValueDiscordDataChannelPermissionOverwritesObjectEqualityInput>>;
  position: Scalars['Int']['input'];
  rate_limit_per_user: Scalars['Int']['input'];
  theme_color?: InputMaybe<Scalars['JSON']['input']>;
  topic?: InputMaybe<Scalars['JSON']['input']>;
  type: Scalars['Int']['input'];
};

export type StudentAdksFieldsValueDiscordDataChannelPermissionOverwrites = {
  __typename?: 'StudentAdksFieldsValueDiscordDataChannelPermissionOverwrites';
  allow: Scalars['Int']['output'];
  allow_new: Scalars['String']['output'];
  deny: Scalars['Int']['output'];
  deny_new: Scalars['String']['output'];
  id: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type StudentAdksFieldsValueDiscordDataChannelPermissionOverwritesCreateInput = {
  allow: Scalars['Int']['input'];
  allow_new: Scalars['String']['input'];
  deny: Scalars['Int']['input'];
  deny_new: Scalars['String']['input'];
  id: Scalars['String']['input'];
  type: Scalars['String']['input'];
};

export type StudentAdksFieldsValueDiscordDataChannelPermissionOverwritesObjectEqualityInput = {
  allow: Scalars['Int']['input'];
  allow_new: Scalars['String']['input'];
  deny: Scalars['Int']['input'];
  deny_new: Scalars['String']['input'];
  id: Scalars['String']['input'];
  type: Scalars['String']['input'];
};

export type StudentAdksFieldsValueDiscordDataCreateInput = {
  channel?: InputMaybe<StudentAdksFieldsValueDiscordDataChannelCreateInput>;
  createdBy: StudentAdksFieldsValueDiscordDataCreatedByCreateInput;
  role: StudentAdksFieldsValueDiscordDataRoleCreateInput;
};

export type StudentAdksFieldsValueDiscordDataCreatedBy = {
  __typename?: 'StudentAdksFieldsValueDiscordDataCreatedBy';
  email: Scalars['String']['output'];
  userType: Scalars['String']['output'];
};

export type StudentAdksFieldsValueDiscordDataCreatedByCreateInput = {
  email: Scalars['String']['input'];
  userType: Scalars['String']['input'];
};

export type StudentAdksFieldsValueDiscordDataCreatedByObjectEqualityInput = {
  email: Scalars['String']['input'];
  userType: Scalars['String']['input'];
};

export type StudentAdksFieldsValueDiscordDataObjectEqualityInput = {
  channel?: InputMaybe<StudentAdksFieldsValueDiscordDataChannelObjectEqualityInput>;
  createdBy: StudentAdksFieldsValueDiscordDataCreatedByObjectEqualityInput;
  role: StudentAdksFieldsValueDiscordDataRoleObjectEqualityInput;
};

export type StudentAdksFieldsValueDiscordDataRole = {
  __typename?: 'StudentAdksFieldsValueDiscordDataRole';
  color?: Maybe<Scalars['Int']['output']>;
  /** Could not determine type: the field only had null or empty values in the sample set. */
  description?: Maybe<Scalars['JSON']['output']>;
  flags?: Maybe<Scalars['Int']['output']>;
  global?: Maybe<Scalars['Boolean']['output']>;
  hoist?: Maybe<Scalars['Boolean']['output']>;
  /** Could not determine type: the field only had null or empty values in the sample set. */
  icon?: Maybe<Scalars['JSON']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  managed?: Maybe<Scalars['Boolean']['output']>;
  mentionable?: Maybe<Scalars['Boolean']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  permissions?: Maybe<Scalars['Int']['output']>;
  permissions_new?: Maybe<Scalars['String']['output']>;
  position?: Maybe<Scalars['Int']['output']>;
  retry_after?: Maybe<Scalars['Float']['output']>;
  /** Could not determine type: the field only had null or empty values in the sample set. */
  unicode_emoji?: Maybe<Scalars['JSON']['output']>;
};

export type StudentAdksFieldsValueDiscordDataRoleCreateInput = {
  color?: InputMaybe<Scalars['Int']['input']>;
  description?: InputMaybe<Scalars['JSON']['input']>;
  flags?: InputMaybe<Scalars['Int']['input']>;
  global?: InputMaybe<Scalars['Boolean']['input']>;
  hoist?: InputMaybe<Scalars['Boolean']['input']>;
  icon?: InputMaybe<Scalars['JSON']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  managed?: InputMaybe<Scalars['Boolean']['input']>;
  mentionable?: InputMaybe<Scalars['Boolean']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  permissions?: InputMaybe<Scalars['Int']['input']>;
  permissions_new?: InputMaybe<Scalars['String']['input']>;
  position?: InputMaybe<Scalars['Int']['input']>;
  retry_after?: InputMaybe<Scalars['Float']['input']>;
  unicode_emoji?: InputMaybe<Scalars['JSON']['input']>;
};

export type StudentAdksFieldsValueDiscordDataRoleObjectEqualityInput = {
  color?: InputMaybe<Scalars['Int']['input']>;
  description?: InputMaybe<Scalars['JSON']['input']>;
  flags?: InputMaybe<Scalars['Int']['input']>;
  global?: InputMaybe<Scalars['Boolean']['input']>;
  hoist?: InputMaybe<Scalars['Boolean']['input']>;
  icon?: InputMaybe<Scalars['JSON']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  managed?: InputMaybe<Scalars['Boolean']['input']>;
  mentionable?: InputMaybe<Scalars['Boolean']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  permissions?: InputMaybe<Scalars['Int']['input']>;
  permissions_new?: InputMaybe<Scalars['String']['input']>;
  position?: InputMaybe<Scalars['Int']['input']>;
  retry_after?: InputMaybe<Scalars['Float']['input']>;
  unicode_emoji?: InputMaybe<Scalars['JSON']['input']>;
};

export type StudentAdksFieldsValueDiscordInfo = {
  __typename?: 'StudentAdksFieldsValueDiscordInfo';
  avatarSrc?: Maybe<Scalars['String']['output']>;
  discordAccessToken: Scalars['String']['output'];
  discordId?: Maybe<Scalars['String']['output']>;
  discordRefreshToken: Scalars['String']['output'];
  discordUsername?: Maybe<Scalars['String']['output']>;
  expiresIn?: Maybe<Scalars['Int']['output']>;
  scope?: Maybe<Scalars['String']['output']>;
};

export type StudentAdksFieldsValueDiscordInfoCreateInput = {
  avatarSrc?: InputMaybe<Scalars['String']['input']>;
  discordAccessToken: Scalars['String']['input'];
  discordId?: InputMaybe<Scalars['String']['input']>;
  discordRefreshToken: Scalars['String']['input'];
  discordUsername?: InputMaybe<Scalars['String']['input']>;
  expiresIn?: InputMaybe<Scalars['Int']['input']>;
  scope?: InputMaybe<Scalars['String']['input']>;
};

export type StudentAdksFieldsValueDiscordInfoObjectEqualityInput = {
  avatarSrc?: InputMaybe<Scalars['String']['input']>;
  discordAccessToken: Scalars['String']['input'];
  discordId?: InputMaybe<Scalars['String']['input']>;
  discordRefreshToken: Scalars['String']['input'];
  discordUsername?: InputMaybe<Scalars['String']['input']>;
  expiresIn?: InputMaybe<Scalars['Int']['input']>;
  scope?: InputMaybe<Scalars['String']['input']>;
};

export type StudentAdksFieldsValueEvents = {
  __typename?: 'StudentAdksFieldsValueEvents';
  created_by: Scalars['String']['output'];
  startDateTime?: Maybe<Scalars['String']['output']>;
  weekly_meeting: StudentAdksFieldsValueEventsWeeklyMeeting;
  weekly_meeting_participants?: Maybe<Array<Scalars['String']['output']>>;
};

export type StudentAdksFieldsValueEventsCreateInput = {
  created_by: Scalars['String']['input'];
  startDateTime?: InputMaybe<Scalars['String']['input']>;
  weekly_meeting: StudentAdksFieldsValueEventsWeeklyMeetingCreateInput;
  weekly_meeting_participants?: InputMaybe<StudentAdksFieldsValueEventsCreateweekly_Meeting_ParticipantsInput>;
};

export type StudentAdksFieldsValueEventsCreateweekly_Meeting_ParticipantsInput = {
  set: Array<Scalars['String']['input']>;
};

export type StudentAdksFieldsValueEventsObjectEqualityInput = {
  created_by: Scalars['String']['input'];
  startDateTime?: InputMaybe<Scalars['String']['input']>;
  weekly_meeting: StudentAdksFieldsValueEventsWeeklyMeetingObjectEqualityInput;
  weekly_meeting_participants?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type StudentAdksFieldsValueEventsWeeklyMeeting = {
  __typename?: 'StudentAdksFieldsValueEventsWeeklyMeeting';
  allowNewTimeProposals?: Maybe<Scalars['Boolean']['output']>;
  attendees?: Maybe<Array<StudentAdksFieldsValueEventsWeeklyMeetingAttendees>>;
  body?: Maybe<StudentAdksFieldsValueEventsWeeklyMeetingBody>;
  bodyPreview?: Maybe<Scalars['String']['output']>;
  /** Could not determine type: the field only had null or empty values in the sample set. */
  categories?: Maybe<Scalars['JSON']['output']>;
  changeKey?: Maybe<Scalars['String']['output']>;
  conferenceData?: Maybe<StudentAdksFieldsValueEventsWeeklyMeetingConferenceData>;
  created?: Maybe<Scalars['String']['output']>;
  createdDateTime?: Maybe<Scalars['String']['output']>;
  creator?: Maybe<StudentAdksFieldsValueEventsWeeklyMeetingCreator>;
  description?: Maybe<Scalars['String']['output']>;
  end?: Maybe<StudentAdksFieldsValueEventsWeeklyMeetingEnd>;
  error?: Maybe<StudentAdksFieldsValueEventsWeeklyMeetingError>;
  etag?: Maybe<Scalars['String']['output']>;
  eventType?: Maybe<Scalars['String']['output']>;
  hangoutLink?: Maybe<Scalars['String']['output']>;
  hasAttachments?: Maybe<Scalars['Boolean']['output']>;
  hideAttendees?: Maybe<Scalars['Boolean']['output']>;
  htmlLink?: Maybe<Scalars['String']['output']>;
  iCalUID?: Maybe<Scalars['String']['output']>;
  iCalUId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  importance?: Maybe<Scalars['String']['output']>;
  isAllDay?: Maybe<Scalars['Boolean']['output']>;
  isCancelled?: Maybe<Scalars['Boolean']['output']>;
  isDraft?: Maybe<Scalars['Boolean']['output']>;
  isOnlineMeeting?: Maybe<Scalars['Boolean']['output']>;
  isOrganizer?: Maybe<Scalars['Boolean']['output']>;
  isReminderOn?: Maybe<Scalars['Boolean']['output']>;
  kind?: Maybe<Scalars['String']['output']>;
  lastModifiedDateTime?: Maybe<Scalars['String']['output']>;
  /** Multiple data types found: String: 90%, StudentAdksFieldsValueEventsWeeklyMeetingLocation: 10% out of 10 sampled entries */
  location?: Maybe<Scalars['JSON']['output']>;
  locations?: Maybe<Array<StudentAdksFieldsValueEventsWeeklyMeetingLocations>>;
  /** Could not determine type: the field only had null or empty values in the sample set. */
  occurrenceId?: Maybe<Scalars['JSON']['output']>;
  odata_context?: Maybe<Scalars['String']['output']>;
  odata_etag?: Maybe<Scalars['String']['output']>;
  /** Could not determine type: the field only had null or empty values in the sample set. */
  onlineMeeting?: Maybe<Scalars['JSON']['output']>;
  onlineMeetingProvider?: Maybe<Scalars['String']['output']>;
  /** Could not determine type: the field only had null or empty values in the sample set. */
  onlineMeetingUrl?: Maybe<Scalars['JSON']['output']>;
  organizer?: Maybe<StudentAdksFieldsValueEventsWeeklyMeetingOrganizer>;
  originalEndTimeZone?: Maybe<Scalars['String']['output']>;
  originalStartTimeZone?: Maybe<Scalars['String']['output']>;
  /** Multiple data types found: StudentAdksFieldsValueEventsWeeklyMeetingRecurrence: 0.7%, Array(String): 99.3% out of 139 sampled entries */
  recurrence?: Maybe<Scalars['JSON']['output']>;
  reminderMinutesBeforeStart?: Maybe<Scalars['Int']['output']>;
  reminders?: Maybe<StudentAdksFieldsValueEventsWeeklyMeetingReminders>;
  responseRequested?: Maybe<Scalars['Boolean']['output']>;
  responseStatus?: Maybe<StudentAdksFieldsValueEventsWeeklyMeetingResponseStatus>;
  sensitivity?: Maybe<Scalars['String']['output']>;
  sequence?: Maybe<Scalars['Int']['output']>;
  /** Could not determine type: the field only had null or empty values in the sample set. */
  seriesMasterId?: Maybe<Scalars['JSON']['output']>;
  showAs?: Maybe<Scalars['String']['output']>;
  start?: Maybe<StudentAdksFieldsValueEventsWeeklyMeetingStart>;
  status?: Maybe<Scalars['String']['output']>;
  subject?: Maybe<Scalars['String']['output']>;
  summary?: Maybe<Scalars['String']['output']>;
  /** Could not determine type: the field only had null or empty values in the sample set. */
  transactionId?: Maybe<Scalars['JSON']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updated?: Maybe<Scalars['String']['output']>;
  webLink?: Maybe<Scalars['String']['output']>;
};

export type StudentAdksFieldsValueEventsWeeklyMeetingAttendees = {
  __typename?: 'StudentAdksFieldsValueEventsWeeklyMeetingAttendees';
  email?: Maybe<Scalars['String']['output']>;
  emailAddress?: Maybe<StudentAdksFieldsValueEventsWeeklyMeetingAttendeesEmailAddress>;
  organizer?: Maybe<Scalars['Boolean']['output']>;
  responseStatus?: Maybe<Scalars['String']['output']>;
  self?: Maybe<Scalars['Boolean']['output']>;
  status?: Maybe<StudentAdksFieldsValueEventsWeeklyMeetingAttendeesStatus>;
  type?: Maybe<Scalars['String']['output']>;
};

export type StudentAdksFieldsValueEventsWeeklyMeetingAttendeesCreateInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  emailAddress?: InputMaybe<StudentAdksFieldsValueEventsWeeklyMeetingAttendeesEmailAddressCreateInput>;
  organizer?: InputMaybe<Scalars['Boolean']['input']>;
  responseStatus?: InputMaybe<Scalars['String']['input']>;
  self?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<StudentAdksFieldsValueEventsWeeklyMeetingAttendeesStatusCreateInput>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type StudentAdksFieldsValueEventsWeeklyMeetingAttendeesEmailAddress = {
  __typename?: 'StudentAdksFieldsValueEventsWeeklyMeetingAttendeesEmailAddress';
  address: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type StudentAdksFieldsValueEventsWeeklyMeetingAttendeesEmailAddressCreateInput = {
  address: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type StudentAdksFieldsValueEventsWeeklyMeetingAttendeesEmailAddressObjectEqualityInput = {
  address: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type StudentAdksFieldsValueEventsWeeklyMeetingAttendeesObjectEqualityInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  emailAddress?: InputMaybe<StudentAdksFieldsValueEventsWeeklyMeetingAttendeesEmailAddressObjectEqualityInput>;
  organizer?: InputMaybe<Scalars['Boolean']['input']>;
  responseStatus?: InputMaybe<Scalars['String']['input']>;
  self?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<StudentAdksFieldsValueEventsWeeklyMeetingAttendeesStatusObjectEqualityInput>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type StudentAdksFieldsValueEventsWeeklyMeetingAttendeesStatus = {
  __typename?: 'StudentAdksFieldsValueEventsWeeklyMeetingAttendeesStatus';
  response: Scalars['String']['output'];
  time: Scalars['String']['output'];
};

export type StudentAdksFieldsValueEventsWeeklyMeetingAttendeesStatusCreateInput = {
  response: Scalars['String']['input'];
  time: Scalars['String']['input'];
};

export type StudentAdksFieldsValueEventsWeeklyMeetingAttendeesStatusObjectEqualityInput = {
  response: Scalars['String']['input'];
  time: Scalars['String']['input'];
};

export type StudentAdksFieldsValueEventsWeeklyMeetingBody = {
  __typename?: 'StudentAdksFieldsValueEventsWeeklyMeetingBody';
  content: Scalars['String']['output'];
  contentType: Scalars['String']['output'];
};

export type StudentAdksFieldsValueEventsWeeklyMeetingBodyCreateInput = {
  content: Scalars['String']['input'];
  contentType: Scalars['String']['input'];
};

export type StudentAdksFieldsValueEventsWeeklyMeetingBodyObjectEqualityInput = {
  content: Scalars['String']['input'];
  contentType: Scalars['String']['input'];
};

export type StudentAdksFieldsValueEventsWeeklyMeetingConferenceData = {
  __typename?: 'StudentAdksFieldsValueEventsWeeklyMeetingConferenceData';
  conferenceId: Scalars['String']['output'];
  conferenceSolution: StudentAdksFieldsValueEventsWeeklyMeetingConferenceDataConferenceSolution;
  createRequest: StudentAdksFieldsValueEventsWeeklyMeetingConferenceDataCreateRequest;
  entryPoints?: Maybe<Array<StudentAdksFieldsValueEventsWeeklyMeetingConferenceDataEntryPoints>>;
};

export type StudentAdksFieldsValueEventsWeeklyMeetingConferenceDataConferenceSolution = {
  __typename?: 'StudentAdksFieldsValueEventsWeeklyMeetingConferenceDataConferenceSolution';
  iconUri: Scalars['String']['output'];
  key: StudentAdksFieldsValueEventsWeeklyMeetingConferenceDataConferenceSolutionKey;
  name: Scalars['String']['output'];
};

export type StudentAdksFieldsValueEventsWeeklyMeetingConferenceDataConferenceSolutionCreateInput = {
  iconUri: Scalars['String']['input'];
  key: StudentAdksFieldsValueEventsWeeklyMeetingConferenceDataConferenceSolutionKeyCreateInput;
  name: Scalars['String']['input'];
};

export type StudentAdksFieldsValueEventsWeeklyMeetingConferenceDataConferenceSolutionKey = {
  __typename?: 'StudentAdksFieldsValueEventsWeeklyMeetingConferenceDataConferenceSolutionKey';
  type: Scalars['String']['output'];
};

export type StudentAdksFieldsValueEventsWeeklyMeetingConferenceDataConferenceSolutionKeyCreateInput = {
  type: Scalars['String']['input'];
};

export type StudentAdksFieldsValueEventsWeeklyMeetingConferenceDataConferenceSolutionKeyObjectEqualityInput = {
  type: Scalars['String']['input'];
};

export type StudentAdksFieldsValueEventsWeeklyMeetingConferenceDataConferenceSolutionObjectEqualityInput = {
  iconUri: Scalars['String']['input'];
  key: StudentAdksFieldsValueEventsWeeklyMeetingConferenceDataConferenceSolutionKeyObjectEqualityInput;
  name: Scalars['String']['input'];
};

export type StudentAdksFieldsValueEventsWeeklyMeetingConferenceDataCreateInput = {
  conferenceId: Scalars['String']['input'];
  conferenceSolution: StudentAdksFieldsValueEventsWeeklyMeetingConferenceDataConferenceSolutionCreateInput;
  createRequest: StudentAdksFieldsValueEventsWeeklyMeetingConferenceDataCreateRequestCreateInput;
  entryPoints?: InputMaybe<Array<StudentAdksFieldsValueEventsWeeklyMeetingConferenceDataEntryPointsCreateInput>>;
};

export type StudentAdksFieldsValueEventsWeeklyMeetingConferenceDataCreateRequest = {
  __typename?: 'StudentAdksFieldsValueEventsWeeklyMeetingConferenceDataCreateRequest';
  conferenceSolutionKey: StudentAdksFieldsValueEventsWeeklyMeetingConferenceDataCreateRequestConferenceSolutionKey;
  requestId: Scalars['String']['output'];
  status: StudentAdksFieldsValueEventsWeeklyMeetingConferenceDataCreateRequestStatus;
};

export type StudentAdksFieldsValueEventsWeeklyMeetingConferenceDataCreateRequestConferenceSolutionKey = {
  __typename?: 'StudentAdksFieldsValueEventsWeeklyMeetingConferenceDataCreateRequestConferenceSolutionKey';
  type: Scalars['String']['output'];
};

export type StudentAdksFieldsValueEventsWeeklyMeetingConferenceDataCreateRequestConferenceSolutionKeyCreateInput = {
  type: Scalars['String']['input'];
};

export type StudentAdksFieldsValueEventsWeeklyMeetingConferenceDataCreateRequestConferenceSolutionKeyObjectEqualityInput = {
  type: Scalars['String']['input'];
};

export type StudentAdksFieldsValueEventsWeeklyMeetingConferenceDataCreateRequestCreateInput = {
  conferenceSolutionKey: StudentAdksFieldsValueEventsWeeklyMeetingConferenceDataCreateRequestConferenceSolutionKeyCreateInput;
  requestId: Scalars['String']['input'];
  status: StudentAdksFieldsValueEventsWeeklyMeetingConferenceDataCreateRequestStatusCreateInput;
};

export type StudentAdksFieldsValueEventsWeeklyMeetingConferenceDataCreateRequestObjectEqualityInput = {
  conferenceSolutionKey: StudentAdksFieldsValueEventsWeeklyMeetingConferenceDataCreateRequestConferenceSolutionKeyObjectEqualityInput;
  requestId: Scalars['String']['input'];
  status: StudentAdksFieldsValueEventsWeeklyMeetingConferenceDataCreateRequestStatusObjectEqualityInput;
};

export type StudentAdksFieldsValueEventsWeeklyMeetingConferenceDataCreateRequestStatus = {
  __typename?: 'StudentAdksFieldsValueEventsWeeklyMeetingConferenceDataCreateRequestStatus';
  statusCode: Scalars['String']['output'];
};

export type StudentAdksFieldsValueEventsWeeklyMeetingConferenceDataCreateRequestStatusCreateInput = {
  statusCode: Scalars['String']['input'];
};

export type StudentAdksFieldsValueEventsWeeklyMeetingConferenceDataCreateRequestStatusObjectEqualityInput = {
  statusCode: Scalars['String']['input'];
};

export type StudentAdksFieldsValueEventsWeeklyMeetingConferenceDataEntryPoints = {
  __typename?: 'StudentAdksFieldsValueEventsWeeklyMeetingConferenceDataEntryPoints';
  entryPointType: Scalars['String']['output'];
  label?: Maybe<Scalars['String']['output']>;
  pin?: Maybe<Scalars['String']['output']>;
  regionCode?: Maybe<Scalars['String']['output']>;
  uri: Scalars['String']['output'];
};

export type StudentAdksFieldsValueEventsWeeklyMeetingConferenceDataEntryPointsCreateInput = {
  entryPointType: Scalars['String']['input'];
  label?: InputMaybe<Scalars['String']['input']>;
  pin?: InputMaybe<Scalars['String']['input']>;
  regionCode?: InputMaybe<Scalars['String']['input']>;
  uri: Scalars['String']['input'];
};

export type StudentAdksFieldsValueEventsWeeklyMeetingConferenceDataEntryPointsObjectEqualityInput = {
  entryPointType: Scalars['String']['input'];
  label?: InputMaybe<Scalars['String']['input']>;
  pin?: InputMaybe<Scalars['String']['input']>;
  regionCode?: InputMaybe<Scalars['String']['input']>;
  uri: Scalars['String']['input'];
};

export type StudentAdksFieldsValueEventsWeeklyMeetingConferenceDataObjectEqualityInput = {
  conferenceId: Scalars['String']['input'];
  conferenceSolution: StudentAdksFieldsValueEventsWeeklyMeetingConferenceDataConferenceSolutionObjectEqualityInput;
  createRequest: StudentAdksFieldsValueEventsWeeklyMeetingConferenceDataCreateRequestObjectEqualityInput;
  entryPoints?: InputMaybe<Array<StudentAdksFieldsValueEventsWeeklyMeetingConferenceDataEntryPointsObjectEqualityInput>>;
};

export type StudentAdksFieldsValueEventsWeeklyMeetingCreateInput = {
  allowNewTimeProposals?: InputMaybe<Scalars['Boolean']['input']>;
  attendees?: InputMaybe<Array<StudentAdksFieldsValueEventsWeeklyMeetingAttendeesCreateInput>>;
  body?: InputMaybe<StudentAdksFieldsValueEventsWeeklyMeetingBodyCreateInput>;
  bodyPreview?: InputMaybe<Scalars['String']['input']>;
  categories?: InputMaybe<Scalars['JSON']['input']>;
  changeKey?: InputMaybe<Scalars['String']['input']>;
  conferenceData?: InputMaybe<StudentAdksFieldsValueEventsWeeklyMeetingConferenceDataCreateInput>;
  created?: InputMaybe<Scalars['String']['input']>;
  createdDateTime?: InputMaybe<Scalars['String']['input']>;
  creator?: InputMaybe<StudentAdksFieldsValueEventsWeeklyMeetingCreatorCreateInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  end?: InputMaybe<StudentAdksFieldsValueEventsWeeklyMeetingEndCreateInput>;
  error?: InputMaybe<StudentAdksFieldsValueEventsWeeklyMeetingErrorCreateInput>;
  etag?: InputMaybe<Scalars['String']['input']>;
  eventType?: InputMaybe<Scalars['String']['input']>;
  hangoutLink?: InputMaybe<Scalars['String']['input']>;
  hasAttachments?: InputMaybe<Scalars['Boolean']['input']>;
  hideAttendees?: InputMaybe<Scalars['Boolean']['input']>;
  htmlLink?: InputMaybe<Scalars['String']['input']>;
  iCalUID?: InputMaybe<Scalars['String']['input']>;
  iCalUId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  importance?: InputMaybe<Scalars['String']['input']>;
  isAllDay?: InputMaybe<Scalars['Boolean']['input']>;
  isCancelled?: InputMaybe<Scalars['Boolean']['input']>;
  isDraft?: InputMaybe<Scalars['Boolean']['input']>;
  isOnlineMeeting?: InputMaybe<Scalars['Boolean']['input']>;
  isOrganizer?: InputMaybe<Scalars['Boolean']['input']>;
  isReminderOn?: InputMaybe<Scalars['Boolean']['input']>;
  kind?: InputMaybe<Scalars['String']['input']>;
  lastModifiedDateTime?: InputMaybe<Scalars['String']['input']>;
  location?: InputMaybe<Scalars['JSON']['input']>;
  locations?: InputMaybe<Array<StudentAdksFieldsValueEventsWeeklyMeetingLocationsCreateInput>>;
  occurrenceId?: InputMaybe<Scalars['JSON']['input']>;
  odata_context?: InputMaybe<Scalars['String']['input']>;
  odata_etag?: InputMaybe<Scalars['String']['input']>;
  onlineMeeting?: InputMaybe<Scalars['JSON']['input']>;
  onlineMeetingProvider?: InputMaybe<Scalars['String']['input']>;
  onlineMeetingUrl?: InputMaybe<Scalars['JSON']['input']>;
  organizer?: InputMaybe<StudentAdksFieldsValueEventsWeeklyMeetingOrganizerCreateInput>;
  originalEndTimeZone?: InputMaybe<Scalars['String']['input']>;
  originalStartTimeZone?: InputMaybe<Scalars['String']['input']>;
  recurrence?: InputMaybe<Scalars['JSON']['input']>;
  reminderMinutesBeforeStart?: InputMaybe<Scalars['Int']['input']>;
  reminders?: InputMaybe<StudentAdksFieldsValueEventsWeeklyMeetingRemindersCreateInput>;
  responseRequested?: InputMaybe<Scalars['Boolean']['input']>;
  responseStatus?: InputMaybe<StudentAdksFieldsValueEventsWeeklyMeetingResponseStatusCreateInput>;
  sensitivity?: InputMaybe<Scalars['String']['input']>;
  sequence?: InputMaybe<Scalars['Int']['input']>;
  seriesMasterId?: InputMaybe<Scalars['JSON']['input']>;
  showAs?: InputMaybe<Scalars['String']['input']>;
  start?: InputMaybe<StudentAdksFieldsValueEventsWeeklyMeetingStartCreateInput>;
  status?: InputMaybe<Scalars['String']['input']>;
  subject?: InputMaybe<Scalars['String']['input']>;
  summary?: InputMaybe<Scalars['String']['input']>;
  transactionId?: InputMaybe<Scalars['JSON']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  updated?: InputMaybe<Scalars['String']['input']>;
  webLink?: InputMaybe<Scalars['String']['input']>;
};

export type StudentAdksFieldsValueEventsWeeklyMeetingCreator = {
  __typename?: 'StudentAdksFieldsValueEventsWeeklyMeetingCreator';
  email: Scalars['String']['output'];
  self: Scalars['Boolean']['output'];
};

export type StudentAdksFieldsValueEventsWeeklyMeetingCreatorCreateInput = {
  email: Scalars['String']['input'];
  self: Scalars['Boolean']['input'];
};

export type StudentAdksFieldsValueEventsWeeklyMeetingCreatorObjectEqualityInput = {
  email: Scalars['String']['input'];
  self: Scalars['Boolean']['input'];
};

export type StudentAdksFieldsValueEventsWeeklyMeetingEnd = {
  __typename?: 'StudentAdksFieldsValueEventsWeeklyMeetingEnd';
  dateTime: Scalars['String']['output'];
  timeZone: Scalars['String']['output'];
};

export type StudentAdksFieldsValueEventsWeeklyMeetingEndCreateInput = {
  dateTime: Scalars['String']['input'];
  timeZone: Scalars['String']['input'];
};

export type StudentAdksFieldsValueEventsWeeklyMeetingEndObjectEqualityInput = {
  dateTime: Scalars['String']['input'];
  timeZone: Scalars['String']['input'];
};

export type StudentAdksFieldsValueEventsWeeklyMeetingError = {
  __typename?: 'StudentAdksFieldsValueEventsWeeklyMeetingError';
  code: Scalars['Int']['output'];
  errors?: Maybe<Array<StudentAdksFieldsValueEventsWeeklyMeetingErrorErrors>>;
  message: Scalars['String']['output'];
  status: Scalars['String']['output'];
};

export type StudentAdksFieldsValueEventsWeeklyMeetingErrorCreateInput = {
  code: Scalars['Int']['input'];
  errors?: InputMaybe<Array<StudentAdksFieldsValueEventsWeeklyMeetingErrorErrorsCreateInput>>;
  message: Scalars['String']['input'];
  status: Scalars['String']['input'];
};

export type StudentAdksFieldsValueEventsWeeklyMeetingErrorErrors = {
  __typename?: 'StudentAdksFieldsValueEventsWeeklyMeetingErrorErrors';
  domain: Scalars['String']['output'];
  location: Scalars['String']['output'];
  locationType: Scalars['String']['output'];
  message: Scalars['String']['output'];
  reason: Scalars['String']['output'];
};

export type StudentAdksFieldsValueEventsWeeklyMeetingErrorErrorsCreateInput = {
  domain: Scalars['String']['input'];
  location: Scalars['String']['input'];
  locationType: Scalars['String']['input'];
  message: Scalars['String']['input'];
  reason: Scalars['String']['input'];
};

export type StudentAdksFieldsValueEventsWeeklyMeetingErrorErrorsObjectEqualityInput = {
  domain: Scalars['String']['input'];
  location: Scalars['String']['input'];
  locationType: Scalars['String']['input'];
  message: Scalars['String']['input'];
  reason: Scalars['String']['input'];
};

export type StudentAdksFieldsValueEventsWeeklyMeetingErrorObjectEqualityInput = {
  code: Scalars['Int']['input'];
  errors?: InputMaybe<Array<StudentAdksFieldsValueEventsWeeklyMeetingErrorErrorsObjectEqualityInput>>;
  message: Scalars['String']['input'];
  status: Scalars['String']['input'];
};

export type StudentAdksFieldsValueEventsWeeklyMeetingLocations = {
  __typename?: 'StudentAdksFieldsValueEventsWeeklyMeetingLocations';
  displayName: Scalars['String']['output'];
  locationType: Scalars['String']['output'];
  uniqueId: Scalars['String']['output'];
  uniqueIdType: Scalars['String']['output'];
};

export type StudentAdksFieldsValueEventsWeeklyMeetingLocationsCreateInput = {
  displayName: Scalars['String']['input'];
  locationType: Scalars['String']['input'];
  uniqueId: Scalars['String']['input'];
  uniqueIdType: Scalars['String']['input'];
};

export type StudentAdksFieldsValueEventsWeeklyMeetingLocationsObjectEqualityInput = {
  displayName: Scalars['String']['input'];
  locationType: Scalars['String']['input'];
  uniqueId: Scalars['String']['input'];
  uniqueIdType: Scalars['String']['input'];
};

export type StudentAdksFieldsValueEventsWeeklyMeetingObjectEqualityInput = {
  allowNewTimeProposals?: InputMaybe<Scalars['Boolean']['input']>;
  attendees?: InputMaybe<Array<StudentAdksFieldsValueEventsWeeklyMeetingAttendeesObjectEqualityInput>>;
  body?: InputMaybe<StudentAdksFieldsValueEventsWeeklyMeetingBodyObjectEqualityInput>;
  bodyPreview?: InputMaybe<Scalars['String']['input']>;
  categories?: InputMaybe<Scalars['JSON']['input']>;
  changeKey?: InputMaybe<Scalars['String']['input']>;
  conferenceData?: InputMaybe<StudentAdksFieldsValueEventsWeeklyMeetingConferenceDataObjectEqualityInput>;
  created?: InputMaybe<Scalars['String']['input']>;
  createdDateTime?: InputMaybe<Scalars['String']['input']>;
  creator?: InputMaybe<StudentAdksFieldsValueEventsWeeklyMeetingCreatorObjectEqualityInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  end?: InputMaybe<StudentAdksFieldsValueEventsWeeklyMeetingEndObjectEqualityInput>;
  error?: InputMaybe<StudentAdksFieldsValueEventsWeeklyMeetingErrorObjectEqualityInput>;
  etag?: InputMaybe<Scalars['String']['input']>;
  eventType?: InputMaybe<Scalars['String']['input']>;
  hangoutLink?: InputMaybe<Scalars['String']['input']>;
  hasAttachments?: InputMaybe<Scalars['Boolean']['input']>;
  hideAttendees?: InputMaybe<Scalars['Boolean']['input']>;
  htmlLink?: InputMaybe<Scalars['String']['input']>;
  iCalUID?: InputMaybe<Scalars['String']['input']>;
  iCalUId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  importance?: InputMaybe<Scalars['String']['input']>;
  isAllDay?: InputMaybe<Scalars['Boolean']['input']>;
  isCancelled?: InputMaybe<Scalars['Boolean']['input']>;
  isDraft?: InputMaybe<Scalars['Boolean']['input']>;
  isOnlineMeeting?: InputMaybe<Scalars['Boolean']['input']>;
  isOrganizer?: InputMaybe<Scalars['Boolean']['input']>;
  isReminderOn?: InputMaybe<Scalars['Boolean']['input']>;
  kind?: InputMaybe<Scalars['String']['input']>;
  lastModifiedDateTime?: InputMaybe<Scalars['String']['input']>;
  location?: InputMaybe<Scalars['JSON']['input']>;
  locations?: InputMaybe<Array<StudentAdksFieldsValueEventsWeeklyMeetingLocationsObjectEqualityInput>>;
  occurrenceId?: InputMaybe<Scalars['JSON']['input']>;
  odata_context?: InputMaybe<Scalars['String']['input']>;
  odata_etag?: InputMaybe<Scalars['String']['input']>;
  onlineMeeting?: InputMaybe<Scalars['JSON']['input']>;
  onlineMeetingProvider?: InputMaybe<Scalars['String']['input']>;
  onlineMeetingUrl?: InputMaybe<Scalars['JSON']['input']>;
  organizer?: InputMaybe<StudentAdksFieldsValueEventsWeeklyMeetingOrganizerObjectEqualityInput>;
  originalEndTimeZone?: InputMaybe<Scalars['String']['input']>;
  originalStartTimeZone?: InputMaybe<Scalars['String']['input']>;
  recurrence?: InputMaybe<Scalars['JSON']['input']>;
  reminderMinutesBeforeStart?: InputMaybe<Scalars['Int']['input']>;
  reminders?: InputMaybe<StudentAdksFieldsValueEventsWeeklyMeetingRemindersObjectEqualityInput>;
  responseRequested?: InputMaybe<Scalars['Boolean']['input']>;
  responseStatus?: InputMaybe<StudentAdksFieldsValueEventsWeeklyMeetingResponseStatusObjectEqualityInput>;
  sensitivity?: InputMaybe<Scalars['String']['input']>;
  sequence?: InputMaybe<Scalars['Int']['input']>;
  seriesMasterId?: InputMaybe<Scalars['JSON']['input']>;
  showAs?: InputMaybe<Scalars['String']['input']>;
  start?: InputMaybe<StudentAdksFieldsValueEventsWeeklyMeetingStartObjectEqualityInput>;
  status?: InputMaybe<Scalars['String']['input']>;
  subject?: InputMaybe<Scalars['String']['input']>;
  summary?: InputMaybe<Scalars['String']['input']>;
  transactionId?: InputMaybe<Scalars['JSON']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  updated?: InputMaybe<Scalars['String']['input']>;
  webLink?: InputMaybe<Scalars['String']['input']>;
};

export type StudentAdksFieldsValueEventsWeeklyMeetingOrganizer = {
  __typename?: 'StudentAdksFieldsValueEventsWeeklyMeetingOrganizer';
  email?: Maybe<Scalars['String']['output']>;
  emailAddress?: Maybe<StudentAdksFieldsValueEventsWeeklyMeetingOrganizerEmailAddress>;
  self?: Maybe<Scalars['Boolean']['output']>;
};

export type StudentAdksFieldsValueEventsWeeklyMeetingOrganizerCreateInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  emailAddress?: InputMaybe<StudentAdksFieldsValueEventsWeeklyMeetingOrganizerEmailAddressCreateInput>;
  self?: InputMaybe<Scalars['Boolean']['input']>;
};

export type StudentAdksFieldsValueEventsWeeklyMeetingOrganizerEmailAddress = {
  __typename?: 'StudentAdksFieldsValueEventsWeeklyMeetingOrganizerEmailAddress';
  address: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type StudentAdksFieldsValueEventsWeeklyMeetingOrganizerEmailAddressCreateInput = {
  address: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type StudentAdksFieldsValueEventsWeeklyMeetingOrganizerEmailAddressObjectEqualityInput = {
  address: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type StudentAdksFieldsValueEventsWeeklyMeetingOrganizerObjectEqualityInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  emailAddress?: InputMaybe<StudentAdksFieldsValueEventsWeeklyMeetingOrganizerEmailAddressObjectEqualityInput>;
  self?: InputMaybe<Scalars['Boolean']['input']>;
};

export type StudentAdksFieldsValueEventsWeeklyMeetingReminders = {
  __typename?: 'StudentAdksFieldsValueEventsWeeklyMeetingReminders';
  overrides?: Maybe<Array<StudentAdksFieldsValueEventsWeeklyMeetingRemindersOverrides>>;
  useDefault: Scalars['Boolean']['output'];
};

export type StudentAdksFieldsValueEventsWeeklyMeetingRemindersCreateInput = {
  overrides?: InputMaybe<Array<StudentAdksFieldsValueEventsWeeklyMeetingRemindersOverridesCreateInput>>;
  useDefault: Scalars['Boolean']['input'];
};

export type StudentAdksFieldsValueEventsWeeklyMeetingRemindersObjectEqualityInput = {
  overrides?: InputMaybe<Array<StudentAdksFieldsValueEventsWeeklyMeetingRemindersOverridesObjectEqualityInput>>;
  useDefault: Scalars['Boolean']['input'];
};

export type StudentAdksFieldsValueEventsWeeklyMeetingRemindersOverrides = {
  __typename?: 'StudentAdksFieldsValueEventsWeeklyMeetingRemindersOverrides';
  method: Scalars['String']['output'];
  minutes: Scalars['Int']['output'];
};

export type StudentAdksFieldsValueEventsWeeklyMeetingRemindersOverridesCreateInput = {
  method: Scalars['String']['input'];
  minutes: Scalars['Int']['input'];
};

export type StudentAdksFieldsValueEventsWeeklyMeetingRemindersOverridesObjectEqualityInput = {
  method: Scalars['String']['input'];
  minutes: Scalars['Int']['input'];
};

export type StudentAdksFieldsValueEventsWeeklyMeetingResponseStatus = {
  __typename?: 'StudentAdksFieldsValueEventsWeeklyMeetingResponseStatus';
  response: Scalars['String']['output'];
  time: Scalars['String']['output'];
};

export type StudentAdksFieldsValueEventsWeeklyMeetingResponseStatusCreateInput = {
  response: Scalars['String']['input'];
  time: Scalars['String']['input'];
};

export type StudentAdksFieldsValueEventsWeeklyMeetingResponseStatusObjectEqualityInput = {
  response: Scalars['String']['input'];
  time: Scalars['String']['input'];
};

export type StudentAdksFieldsValueEventsWeeklyMeetingStart = {
  __typename?: 'StudentAdksFieldsValueEventsWeeklyMeetingStart';
  dateTime: Scalars['String']['output'];
  timeZone: Scalars['String']['output'];
};

export type StudentAdksFieldsValueEventsWeeklyMeetingStartCreateInput = {
  dateTime: Scalars['String']['input'];
  timeZone: Scalars['String']['input'];
};

export type StudentAdksFieldsValueEventsWeeklyMeetingStartObjectEqualityInput = {
  dateTime: Scalars['String']['input'];
  timeZone: Scalars['String']['input'];
};

export type StudentAdksFieldsValueLogs = {
  __typename?: 'StudentAdksFieldsValueLogs';
  /** Multiple data types found: String: 35.7%, String (ObjectId): 64.3% out of 931 sampled entries */
  author: Scalars['JSON']['output'];
  avatar: Scalars['String']['output'];
  /** Multiple data types found: String: 35.7%, String (ObjectId): 64.3% out of 931 sampled entries */
  id: Scalars['JSON']['output'];
  log: Scalars['String']['output'];
  proof?: Maybe<Array<StudentAdksFieldsValueLogsProof>>;
  /** Multiple data types found: String: 35.7%, DateTime (Date): 64.3% out of 931 sampled entries */
  time: Scalars['JSON']['output'];
};

export type StudentAdksFieldsValueLogsCreateInput = {
  author: Scalars['JSON']['input'];
  avatar: Scalars['String']['input'];
  id: Scalars['JSON']['input'];
  log: Scalars['String']['input'];
  proof?: InputMaybe<Array<StudentAdksFieldsValueLogsProofCreateInput>>;
  time: Scalars['JSON']['input'];
};

export type StudentAdksFieldsValueLogsObjectEqualityInput = {
  author: Scalars['JSON']['input'];
  avatar: Scalars['String']['input'];
  id: Scalars['JSON']['input'];
  log: Scalars['String']['input'];
  proof?: InputMaybe<Array<StudentAdksFieldsValueLogsProofObjectEqualityInput>>;
  time: Scalars['JSON']['input'];
};

export type StudentAdksFieldsValueLogsProof = {
  __typename?: 'StudentAdksFieldsValueLogsProof';
  name: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type StudentAdksFieldsValueLogsProofCreateInput = {
  name: Scalars['String']['input'];
  url: Scalars['String']['input'];
};

export type StudentAdksFieldsValueLogsProofObjectEqualityInput = {
  name: Scalars['String']['input'];
  url: Scalars['String']['input'];
};

export type StudentAdksFieldsValueObjectEqualityInput = {
  Description_1689596544146?: InputMaybe<Scalars['String']['input']>;
  Description_1689610327886?: InputMaybe<Scalars['String']['input']>;
  Select_1689610316209?: InputMaybe<Scalars['String']['input']>;
  aboutOrg?: InputMaybe<Scalars['String']['input']>;
  acceptanceDeadline?: InputMaybe<Scalars['String']['input']>;
  accessSkills?: InputMaybe<Array<Scalars['String']['input']>>;
  action?: InputMaybe<StudentAdksFieldsValueActionObjectEqualityInput>;
  ageRange?: InputMaybe<Scalars['JSON']['input']>;
  agreement?: InputMaybe<StudentAdksFieldsValueAgreementObjectEqualityInput>;
  airtableFormLink?: InputMaybe<Scalars['String']['input']>;
  airtableLink?: InputMaybe<Scalars['String']['input']>;
  airtableResponseLink?: InputMaybe<Scalars['String']['input']>;
  airtableTableLink?: InputMaybe<Scalars['String']['input']>;
  apprentice?: InputMaybe<Scalars['Boolean']['input']>;
  arrivalLink?: InputMaybe<Scalars['String']['input']>;
  arrivalStatus?: InputMaybe<Scalars['String']['input']>;
  attendeeList?: InputMaybe<Scalars['String']['input']>;
  autoapply?: InputMaybe<StudentAdksFieldsValueAutoapplyObjectEqualityInput>;
  boards?: InputMaybe<Array<StudentAdksFieldsValueBoardsObjectEqualityInput>>;
  bookmarkedQuestions?: InputMaybe<Array<Scalars['String']['input']>>;
  channels?: InputMaybe<Array<StudentAdksFieldsValueChannelsObjectEqualityInput>>;
  checkinLink?: InputMaybe<Scalars['String']['input']>;
  compensation1?: InputMaybe<Scalars['Boolean']['input']>;
  compensation2?: InputMaybe<Scalars['Boolean']['input']>;
  compensation3?: InputMaybe<Scalars['Boolean']['input']>;
  compensation4?: InputMaybe<Scalars['Boolean']['input']>;
  compensation5?: InputMaybe<Scalars['Boolean']['input']>;
  compensation6?: InputMaybe<Scalars['Boolean']['input']>;
  connection?: InputMaybe<Scalars['String']['input']>;
  continuation?: InputMaybe<Scalars['Int']['input']>;
  defaultActivity?: InputMaybe<StudentAdksFieldsValueDefaultActivityObjectEqualityInput>;
  deliverable?: InputMaybe<Array<Scalars['String']['input']>>;
  description?: InputMaybe<Scalars['String']['input']>;
  directoryPreferences?: InputMaybe<Scalars['JSON']['input']>;
  discordData?: InputMaybe<StudentAdksFieldsValueDiscordDataObjectEqualityInput>;
  discordInfo?: InputMaybe<StudentAdksFieldsValueDiscordInfoObjectEqualityInput>;
  discordIntegraionSkipped?: InputMaybe<Scalars['Boolean']['input']>;
  discordLink?: InputMaybe<Scalars['String']['input']>;
  dislikedQuestions?: InputMaybe<Array<Scalars['String']['input']>>;
  docDesc?: InputMaybe<Scalars['String']['input']>;
  docLink?: InputMaybe<Scalars['String']['input']>;
  driveLink?: InputMaybe<Scalars['String']['input']>;
  eir?: InputMaybe<Scalars['Boolean']['input']>;
  employerRecord?: InputMaybe<Scalars['Int']['input']>;
  endEarlyActivity?: InputMaybe<Scalars['String']['input']>;
  eventAgenda?: InputMaybe<Scalars['String']['input']>;
  eventDate?: InputMaybe<Scalars['String']['input']>;
  eventLocations?: InputMaybe<Scalars['String']['input']>;
  eventName?: InputMaybe<Scalars['String']['input']>;
  events?: InputMaybe<StudentAdksFieldsValueEventsObjectEqualityInput>;
  extern?: InputMaybe<Scalars['Boolean']['input']>;
  externCredential?: InputMaybe<Scalars['JSON']['input']>;
  fellow?: InputMaybe<Scalars['Boolean']['input']>;
  fileType?: InputMaybe<Array<Scalars['String']['input']>>;
  flaggedComments?: InputMaybe<Array<Scalars['String']['input']>>;
  form_id?: InputMaybe<Scalars['String']['input']>;
  form_url?: InputMaybe<Scalars['String']['input']>;
  groupActivity?: InputMaybe<Scalars['String']['input']>;
  instructions?: InputMaybe<Scalars['String']['input']>;
  intern?: InputMaybe<Scalars['Boolean']['input']>;
  internshipEnd?: InputMaybe<Scalars['String']['input']>;
  internshipProject1?: InputMaybe<Scalars['Boolean']['input']>;
  internshipProject2?: InputMaybe<Scalars['Boolean']['input']>;
  internshipProject3?: InputMaybe<Scalars['Boolean']['input']>;
  internshipStart?: InputMaybe<Scalars['String']['input']>;
  interviewChallenge?: InputMaybe<Scalars['String']['input']>;
  interviewOpportunity?: InputMaybe<Scalars['String']['input']>;
  interviewProblem?: InputMaybe<Scalars['String']['input']>;
  interviewRequest?: InputMaybe<Scalars['String']['input']>;
  interviewSolution?: InputMaybe<Scalars['String']['input']>;
  lastInteraction?: InputMaybe<Scalars['String']['input']>;
  lastInteractionId?: InputMaybe<Scalars['String']['input']>;
  licenseRequirement?: InputMaybe<Scalars['Int']['input']>;
  likedComments?: InputMaybe<Array<Scalars['String']['input']>>;
  likedQuestions?: InputMaybe<Array<Scalars['String']['input']>>;
  loaded?: InputMaybe<Array<Scalars['String']['input']>>;
  logs?: InputMaybe<Array<StudentAdksFieldsValueLogsObjectEqualityInput>>;
  maxCharacters?: InputMaybe<Scalars['String']['input']>;
  maxHours?: InputMaybe<Scalars['Int']['input']>;
  maxQuestions?: InputMaybe<Scalars['Int']['input']>;
  maxTeamMembers?: InputMaybe<Scalars['Int']['input']>;
  maximumBudget?: InputMaybe<Scalars['String']['input']>;
  minHours?: InputMaybe<Scalars['Int']['input']>;
  minLogs?: InputMaybe<Scalars['Int']['input']>;
  minimumBudget?: InputMaybe<Scalars['String']['input']>;
  minimumHoursNow?: InputMaybe<Scalars['JSON']['input']>;
  offerStatus?: InputMaybe<Scalars['Boolean']['input']>;
  outcome?: InputMaybe<Array<Scalars['String']['input']>>;
  pathways?: InputMaybe<Array<Scalars['String']['input']>>;
  practiceLog?: InputMaybe<Array<StudentAdksFieldsValuePracticeLogObjectEqualityInput>>;
  preApprentice?: InputMaybe<Scalars['Boolean']['input']>;
  preInternship?: InputMaybe<Scalars['Boolean']['input']>;
  programDesc?: InputMaybe<Scalars['String']['input']>;
  programName?: InputMaybe<Scalars['String']['input']>;
  projectReq?: InputMaybe<Scalars['JSON']['input']>;
  providers?: InputMaybe<StudentAdksFieldsValueProvidersObjectEqualityInput>;
  questionsAsked?: InputMaybe<Array<Scalars['String']['input']>>;
  requiredActivity?: InputMaybe<Scalars['String']['input']>;
  requiredResidency?: InputMaybe<Scalars['JSON']['input']>;
  requiredSkills?: InputMaybe<Array<Scalars['String']['input']>>;
  researchLinks?: InputMaybe<Array<StudentAdksFieldsValueResearchLinksObjectEqualityInput>>;
  researchProgress?: InputMaybe<Array<StudentAdksFieldsValueResearchProgressObjectEqualityInput>>;
  resourceDrive?: InputMaybe<Scalars['String']['input']>;
  resourceFacebook?: InputMaybe<Scalars['String']['input']>;
  resourceInsta?: InputMaybe<Scalars['String']['input']>;
  resourceLinkedIn?: InputMaybe<Scalars['String']['input']>;
  resourceTwitter?: InputMaybe<Scalars['String']['input']>;
  resourceWeb?: InputMaybe<Scalars['String']['input']>;
  resourceYouTube?: InputMaybe<Scalars['String']['input']>;
  rewards?: InputMaybe<Scalars['JSON']['input']>;
  rsvpLink?: InputMaybe<Scalars['String']['input']>;
  settings?: InputMaybe<StudentAdksFieldsValueSettingsObjectEqualityInput>;
  signInVideoAskResponse?: InputMaybe<StudentAdksFieldsValueSignInVideoAskResponseObjectEqualityInput>;
  signOffVideoAskResponse?: InputMaybe<StudentAdksFieldsValueSignOffVideoAskResponseObjectEqualityInput>;
  studentEthnicity?: InputMaybe<Array<Scalars['String']['input']>>;
  studentLocation?: InputMaybe<Scalars['JSON']['input']>;
  studentResidence?: InputMaybe<Scalars['String']['input']>;
  studentSchool?: InputMaybe<Scalars['String']['input']>;
  submission?: InputMaybe<StudentAdksFieldsValueSubmissionObjectEqualityInput>;
  submittedVideo?: InputMaybe<StudentAdksFieldsValueSubmittedVideoObjectEqualityInput>;
  textFields?: InputMaybe<Array<Scalars['String']['input']>>;
  text_input_1689596540310?: InputMaybe<Scalars['String']['input']>;
  timeFrame?: InputMaybe<Array<StudentAdksFieldsValueTimeFrameObjectEqualityInput>>;
  timeZone?: InputMaybe<Scalars['String']['input']>;
  timesheetDetails?: InputMaybe<Array<StudentAdksFieldsValueTimesheetDetailsObjectEqualityInput>>;
  trainProgress?: InputMaybe<Array<StudentAdksFieldsValueTrainProgressObjectEqualityInput>>;
  uploadLimit?: InputMaybe<StudentAdksFieldsValueUploadLimitObjectEqualityInput>;
  uploadLink?: InputMaybe<Scalars['String']['input']>;
  valueDrafts?: InputMaybe<Array<StudentAdksFieldsValueValueDraftsObjectEqualityInput>>;
  videoAskResponse?: InputMaybe<StudentAdksFieldsValueVideoAskResponseObjectEqualityInput>;
  videoLinks?: InputMaybe<Array<StudentAdksFieldsValueVideoLinksObjectEqualityInput>>;
  videoMaxLength?: InputMaybe<Scalars['Int']['input']>;
  videoaskEmbed?: InputMaybe<Scalars['String']['input']>;
  videoaskLink?: InputMaybe<Scalars['String']['input']>;
  videoaskResponseLink?: InputMaybe<Scalars['String']['input']>;
  welcomeActivity?: InputMaybe<Scalars['String']['input']>;
  youtubeLink?: InputMaybe<Scalars['String']['input']>;
};

export type StudentAdksFieldsValuePracticeLog = {
  __typename?: 'StudentAdksFieldsValuePracticeLog';
  avatar: Scalars['String']['output'];
  minutes?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  /** Multiple data types found: String: 25.7%, DateTime (Date): 74.3% out of 1010 sampled entries */
  timestamp: Scalars['JSON']['output'];
  /** Multiple data types found: String: 25.7%, String (ObjectId): 74.3% out of 1010 sampled entries */
  user_id: Scalars['JSON']['output'];
};

export type StudentAdksFieldsValuePracticeLogCreateInput = {
  avatar: Scalars['String']['input'];
  minutes?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  timestamp: Scalars['JSON']['input'];
  user_id: Scalars['JSON']['input'];
};

export type StudentAdksFieldsValuePracticeLogObjectEqualityInput = {
  avatar: Scalars['String']['input'];
  minutes?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  timestamp: Scalars['JSON']['input'];
  user_id: Scalars['JSON']['input'];
};

export type StudentAdksFieldsValueProviders = {
  __typename?: 'StudentAdksFieldsValueProviders';
  apple: Scalars['Boolean']['output'];
  google: Scalars['Boolean']['output'];
  web: Scalars['Boolean']['output'];
};

export type StudentAdksFieldsValueProvidersCreateInput = {
  apple: Scalars['Boolean']['input'];
  google: Scalars['Boolean']['input'];
  web: Scalars['Boolean']['input'];
};

export type StudentAdksFieldsValueProvidersObjectEqualityInput = {
  apple: Scalars['Boolean']['input'];
  google: Scalars['Boolean']['input'];
  web: Scalars['Boolean']['input'];
};

export type StudentAdksFieldsValueResearchLinks = {
  __typename?: 'StudentAdksFieldsValueResearchLinks';
  completed?: Maybe<Scalars['Boolean']['output']>;
  link: Scalars['String']['output'];
  required: Scalars['Boolean']['output'];
  resource: Scalars['String']['output'];
  unlocked?: Maybe<Scalars['Boolean']['output']>;
};

export type StudentAdksFieldsValueResearchLinksCreateInput = {
  completed?: InputMaybe<Scalars['Boolean']['input']>;
  link: Scalars['String']['input'];
  required: Scalars['Boolean']['input'];
  resource: Scalars['String']['input'];
  unlocked?: InputMaybe<Scalars['Boolean']['input']>;
};

export type StudentAdksFieldsValueResearchLinksObjectEqualityInput = {
  completed?: InputMaybe<Scalars['Boolean']['input']>;
  link: Scalars['String']['input'];
  required: Scalars['Boolean']['input'];
  resource: Scalars['String']['input'];
  unlocked?: InputMaybe<Scalars['Boolean']['input']>;
};

export type StudentAdksFieldsValueResearchProgress = {
  __typename?: 'StudentAdksFieldsValueResearchProgress';
  completed?: Maybe<Scalars['Boolean']['output']>;
  isValid?: Maybe<Scalars['Boolean']['output']>;
  link: Scalars['String']['output'];
  newCandidate?: Maybe<Scalars['Boolean']['output']>;
  required: Scalars['Boolean']['output'];
  resource: Scalars['String']['output'];
  unlocked?: Maybe<Scalars['Boolean']['output']>;
  viewed?: Maybe<Scalars['Boolean']['output']>;
};

export type StudentAdksFieldsValueResearchProgressCreateInput = {
  completed?: InputMaybe<Scalars['Boolean']['input']>;
  isValid?: InputMaybe<Scalars['Boolean']['input']>;
  link: Scalars['String']['input'];
  newCandidate?: InputMaybe<Scalars['Boolean']['input']>;
  required: Scalars['Boolean']['input'];
  resource: Scalars['String']['input'];
  unlocked?: InputMaybe<Scalars['Boolean']['input']>;
  viewed?: InputMaybe<Scalars['Boolean']['input']>;
};

export type StudentAdksFieldsValueResearchProgressObjectEqualityInput = {
  completed?: InputMaybe<Scalars['Boolean']['input']>;
  isValid?: InputMaybe<Scalars['Boolean']['input']>;
  link: Scalars['String']['input'];
  newCandidate?: InputMaybe<Scalars['Boolean']['input']>;
  required: Scalars['Boolean']['input'];
  resource: Scalars['String']['input'];
  unlocked?: InputMaybe<Scalars['Boolean']['input']>;
  viewed?: InputMaybe<Scalars['Boolean']['input']>;
};

export type StudentAdksFieldsValueSettings = {
  __typename?: 'StudentAdksFieldsValueSettings';
  caseStudySettings: StudentAdksFieldsValueSettingsCaseStudySettings;
  digitalResumeSettings: Scalars['Boolean']['output'];
  presentationSettings: StudentAdksFieldsValueSettingsPresentationSettings;
  projectFAQSettings: Scalars['Boolean']['output'];
  projectImplementationSettings: StudentAdksFieldsValueSettingsProjectImplementationSettings;
  projectPlanSettings: StudentAdksFieldsValueSettingsProjectPlanSettings;
  projectTaskSettings: StudentAdksFieldsValueSettingsProjectTaskSettings;
  teamSettings: StudentAdksFieldsValueSettingsTeamSettings;
  userInterviewSettings: StudentAdksFieldsValueSettingsUserInterviewSettings;
};

export type StudentAdksFieldsValueSettingsCaseStudySettings = {
  __typename?: 'StudentAdksFieldsValueSettingsCaseStudySettings';
  contentSetting?: Maybe<Scalars['String']['output']>;
  required: Scalars['Boolean']['output'];
};

export type StudentAdksFieldsValueSettingsCaseStudySettingsCreateInput = {
  contentSetting?: InputMaybe<Scalars['String']['input']>;
  required: Scalars['Boolean']['input'];
};

export type StudentAdksFieldsValueSettingsCaseStudySettingsObjectEqualityInput = {
  contentSetting?: InputMaybe<Scalars['String']['input']>;
  required: Scalars['Boolean']['input'];
};

export type StudentAdksFieldsValueSettingsCreateInput = {
  caseStudySettings: StudentAdksFieldsValueSettingsCaseStudySettingsCreateInput;
  digitalResumeSettings: Scalars['Boolean']['input'];
  presentationSettings: StudentAdksFieldsValueSettingsPresentationSettingsCreateInput;
  projectFAQSettings: Scalars['Boolean']['input'];
  projectImplementationSettings: StudentAdksFieldsValueSettingsProjectImplementationSettingsCreateInput;
  projectPlanSettings: StudentAdksFieldsValueSettingsProjectPlanSettingsCreateInput;
  projectTaskSettings: StudentAdksFieldsValueSettingsProjectTaskSettingsCreateInput;
  teamSettings: StudentAdksFieldsValueSettingsTeamSettingsCreateInput;
  userInterviewSettings: StudentAdksFieldsValueSettingsUserInterviewSettingsCreateInput;
};

export type StudentAdksFieldsValueSettingsObjectEqualityInput = {
  caseStudySettings: StudentAdksFieldsValueSettingsCaseStudySettingsObjectEqualityInput;
  digitalResumeSettings: Scalars['Boolean']['input'];
  presentationSettings: StudentAdksFieldsValueSettingsPresentationSettingsObjectEqualityInput;
  projectFAQSettings: Scalars['Boolean']['input'];
  projectImplementationSettings: StudentAdksFieldsValueSettingsProjectImplementationSettingsObjectEqualityInput;
  projectPlanSettings: StudentAdksFieldsValueSettingsProjectPlanSettingsObjectEqualityInput;
  projectTaskSettings: StudentAdksFieldsValueSettingsProjectTaskSettingsObjectEqualityInput;
  teamSettings: StudentAdksFieldsValueSettingsTeamSettingsObjectEqualityInput;
  userInterviewSettings: StudentAdksFieldsValueSettingsUserInterviewSettingsObjectEqualityInput;
};

export type StudentAdksFieldsValueSettingsPresentationSettings = {
  __typename?: 'StudentAdksFieldsValueSettingsPresentationSettings';
  maxMins?: Maybe<Scalars['String']['output']>;
  required: Scalars['Boolean']['output'];
};

export type StudentAdksFieldsValueSettingsPresentationSettingsCreateInput = {
  maxMins?: InputMaybe<Scalars['String']['input']>;
  required: Scalars['Boolean']['input'];
};

export type StudentAdksFieldsValueSettingsPresentationSettingsObjectEqualityInput = {
  maxMins?: InputMaybe<Scalars['String']['input']>;
  required: Scalars['Boolean']['input'];
};

export type StudentAdksFieldsValueSettingsProjectImplementationSettings = {
  __typename?: 'StudentAdksFieldsValueSettingsProjectImplementationSettings';
  pilots?: Maybe<Scalars['String']['output']>;
  required: Scalars['Boolean']['output'];
};

export type StudentAdksFieldsValueSettingsProjectImplementationSettingsCreateInput = {
  pilots?: InputMaybe<Scalars['String']['input']>;
  required: Scalars['Boolean']['input'];
};

export type StudentAdksFieldsValueSettingsProjectImplementationSettingsObjectEqualityInput = {
  pilots?: InputMaybe<Scalars['String']['input']>;
  required: Scalars['Boolean']['input'];
};

export type StudentAdksFieldsValueSettingsProjectPlanSettings = {
  __typename?: 'StudentAdksFieldsValueSettingsProjectPlanSettings';
  prePopulate?: Maybe<Scalars['String']['output']>;
  required: Scalars['Boolean']['output'];
};

export type StudentAdksFieldsValueSettingsProjectPlanSettingsCreateInput = {
  prePopulate?: InputMaybe<Scalars['String']['input']>;
  required: Scalars['Boolean']['input'];
};

export type StudentAdksFieldsValueSettingsProjectPlanSettingsObjectEqualityInput = {
  prePopulate?: InputMaybe<Scalars['String']['input']>;
  required: Scalars['Boolean']['input'];
};

export type StudentAdksFieldsValueSettingsProjectTaskSettings = {
  __typename?: 'StudentAdksFieldsValueSettingsProjectTaskSettings';
  required: Scalars['Boolean']['output'];
  taskSetting?: Maybe<Scalars['String']['output']>;
};

export type StudentAdksFieldsValueSettingsProjectTaskSettingsCreateInput = {
  required: Scalars['Boolean']['input'];
  taskSetting?: InputMaybe<Scalars['String']['input']>;
};

export type StudentAdksFieldsValueSettingsProjectTaskSettingsObjectEqualityInput = {
  required: Scalars['Boolean']['input'];
  taskSetting?: InputMaybe<Scalars['String']['input']>;
};

export type StudentAdksFieldsValueSettingsTeamSettings = {
  __typename?: 'StudentAdksFieldsValueSettingsTeamSettings';
  editViewSetting?: Maybe<Scalars['String']['output']>;
  required: Scalars['Boolean']['output'];
};

export type StudentAdksFieldsValueSettingsTeamSettingsCreateInput = {
  editViewSetting?: InputMaybe<Scalars['String']['input']>;
  required: Scalars['Boolean']['input'];
};

export type StudentAdksFieldsValueSettingsTeamSettingsObjectEqualityInput = {
  editViewSetting?: InputMaybe<Scalars['String']['input']>;
  required: Scalars['Boolean']['input'];
};

export type StudentAdksFieldsValueSettingsUserInterviewSettings = {
  __typename?: 'StudentAdksFieldsValueSettingsUserInterviewSettings';
  required: Scalars['Boolean']['output'];
  totalUsers?: Maybe<Scalars['String']['output']>;
};

export type StudentAdksFieldsValueSettingsUserInterviewSettingsCreateInput = {
  required: Scalars['Boolean']['input'];
  totalUsers?: InputMaybe<Scalars['String']['input']>;
};

export type StudentAdksFieldsValueSettingsUserInterviewSettingsObjectEqualityInput = {
  required: Scalars['Boolean']['input'];
  totalUsers?: InputMaybe<Scalars['String']['input']>;
};

export type StudentAdksFieldsValueSignInVideoAskResponse = {
  __typename?: 'StudentAdksFieldsValueSignInVideoAskResponse';
  contact: StudentAdksFieldsValueSignInVideoAskResponseContact;
  event_id: Scalars['String']['output'];
  event_type: Scalars['String']['output'];
  form: StudentAdksFieldsValueSignInVideoAskResponseForm;
  interaction_id: Scalars['String']['output'];
};

export type StudentAdksFieldsValueSignInVideoAskResponseContact = {
  __typename?: 'StudentAdksFieldsValueSignInVideoAskResponseContact';
  answers?: Maybe<Array<StudentAdksFieldsValueSignInVideoAskResponseContactAnswers>>;
  are_answers_public: Scalars['Boolean']['output'];
  are_messages_public: Scalars['Boolean']['output'];
  contact_id: Scalars['String']['output'];
  email: Scalars['String']['output'];
  platform: Scalars['String']['output'];
  share_id: Scalars['String']['output'];
  share_url: Scalars['String']['output'];
  status: Scalars['String']['output'];
};

export type StudentAdksFieldsValueSignInVideoAskResponseContactAnswers = {
  __typename?: 'StudentAdksFieldsValueSignInVideoAskResponseContactAnswers';
  answer_id: Scalars['String']['output'];
  media_id: Scalars['String']['output'];
  media_url: Scalars['String']['output'];
  /** Could not determine type: the field only had null or empty values in the sample set. */
  poll_options?: Maybe<Scalars['JSON']['output']>;
  question_id: Scalars['String']['output'];
};

export type StudentAdksFieldsValueSignInVideoAskResponseContactAnswersCreateInput = {
  answer_id: Scalars['String']['input'];
  media_id: Scalars['String']['input'];
  media_url: Scalars['String']['input'];
  poll_options?: InputMaybe<Scalars['JSON']['input']>;
  question_id: Scalars['String']['input'];
};

export type StudentAdksFieldsValueSignInVideoAskResponseContactAnswersObjectEqualityInput = {
  answer_id: Scalars['String']['input'];
  media_id: Scalars['String']['input'];
  media_url: Scalars['String']['input'];
  poll_options?: InputMaybe<Scalars['JSON']['input']>;
  question_id: Scalars['String']['input'];
};

export type StudentAdksFieldsValueSignInVideoAskResponseContactCreateInput = {
  answers?: InputMaybe<Array<StudentAdksFieldsValueSignInVideoAskResponseContactAnswersCreateInput>>;
  are_answers_public: Scalars['Boolean']['input'];
  are_messages_public: Scalars['Boolean']['input'];
  contact_id: Scalars['String']['input'];
  email: Scalars['String']['input'];
  platform: Scalars['String']['input'];
  share_id: Scalars['String']['input'];
  share_url: Scalars['String']['input'];
  status: Scalars['String']['input'];
};

export type StudentAdksFieldsValueSignInVideoAskResponseContactObjectEqualityInput = {
  answers?: InputMaybe<Array<StudentAdksFieldsValueSignInVideoAskResponseContactAnswersObjectEqualityInput>>;
  are_answers_public: Scalars['Boolean']['input'];
  are_messages_public: Scalars['Boolean']['input'];
  contact_id: Scalars['String']['input'];
  email: Scalars['String']['input'];
  platform: Scalars['String']['input'];
  share_id: Scalars['String']['input'];
  share_url: Scalars['String']['input'];
  status: Scalars['String']['input'];
};

export type StudentAdksFieldsValueSignInVideoAskResponseCreateInput = {
  contact: StudentAdksFieldsValueSignInVideoAskResponseContactCreateInput;
  event_id: Scalars['String']['input'];
  event_type: Scalars['String']['input'];
  form: StudentAdksFieldsValueSignInVideoAskResponseFormCreateInput;
  interaction_id: Scalars['String']['input'];
};

export type StudentAdksFieldsValueSignInVideoAskResponseForm = {
  __typename?: 'StudentAdksFieldsValueSignInVideoAskResponseForm';
  are_answers_public: Scalars['Boolean']['output'];
  are_messages_public: Scalars['Boolean']['output'];
  form_id: Scalars['String']['output'];
  hide_branding: Scalars['Boolean']['output'];
  idle_deadline_time_in_minutes: Scalars['Int']['output'];
  notifications: StudentAdksFieldsValueSignInVideoAskResponseFormNotifications;
  questions?: Maybe<Array<StudentAdksFieldsValueSignInVideoAskResponseFormQuestions>>;
  requires_consent: Scalars['Boolean']['output'];
  requires_contact_email: Scalars['Boolean']['output'];
  requires_contact_info: Scalars['Boolean']['output'];
  requires_contact_name: Scalars['Boolean']['output'];
  requires_contact_phone_number: Scalars['Boolean']['output'];
  respondents_count: Scalars['Int']['output'];
  responses_share_id: Scalars['String']['output'];
  responses_share_url: Scalars['String']['output'];
  share_id: Scalars['String']['output'];
  share_url: Scalars['String']['output'];
  show_consent: Scalars['Boolean']['output'];
  show_contact_email: Scalars['Boolean']['output'];
  show_contact_name: Scalars['Boolean']['output'];
  show_contact_phone_number: Scalars['Boolean']['output'];
  tag_share_id: Scalars['String']['output'];
  tag_share_url: Scalars['String']['output'];
};

export type StudentAdksFieldsValueSignInVideoAskResponseFormCreateInput = {
  are_answers_public: Scalars['Boolean']['input'];
  are_messages_public: Scalars['Boolean']['input'];
  form_id: Scalars['String']['input'];
  hide_branding: Scalars['Boolean']['input'];
  idle_deadline_time_in_minutes: Scalars['Int']['input'];
  notifications: StudentAdksFieldsValueSignInVideoAskResponseFormNotificationsCreateInput;
  questions?: InputMaybe<Array<StudentAdksFieldsValueSignInVideoAskResponseFormQuestionsCreateInput>>;
  requires_consent: Scalars['Boolean']['input'];
  requires_contact_email: Scalars['Boolean']['input'];
  requires_contact_info: Scalars['Boolean']['input'];
  requires_contact_name: Scalars['Boolean']['input'];
  requires_contact_phone_number: Scalars['Boolean']['input'];
  respondents_count: Scalars['Int']['input'];
  responses_share_id: Scalars['String']['input'];
  responses_share_url: Scalars['String']['input'];
  share_id: Scalars['String']['input'];
  share_url: Scalars['String']['input'];
  show_consent: Scalars['Boolean']['input'];
  show_contact_email: Scalars['Boolean']['input'];
  show_contact_name: Scalars['Boolean']['input'];
  show_contact_phone_number: Scalars['Boolean']['input'];
  tag_share_id: Scalars['String']['input'];
  tag_share_url: Scalars['String']['input'];
};

export type StudentAdksFieldsValueSignInVideoAskResponseFormNotifications = {
  __typename?: 'StudentAdksFieldsValueSignInVideoAskResponseFormNotifications';
  send_contact_message_emails: Scalars['Boolean']['output'];
};

export type StudentAdksFieldsValueSignInVideoAskResponseFormNotificationsCreateInput = {
  send_contact_message_emails: Scalars['Boolean']['input'];
};

export type StudentAdksFieldsValueSignInVideoAskResponseFormNotificationsObjectEqualityInput = {
  send_contact_message_emails: Scalars['Boolean']['input'];
};

export type StudentAdksFieldsValueSignInVideoAskResponseFormObjectEqualityInput = {
  are_answers_public: Scalars['Boolean']['input'];
  are_messages_public: Scalars['Boolean']['input'];
  form_id: Scalars['String']['input'];
  hide_branding: Scalars['Boolean']['input'];
  idle_deadline_time_in_minutes: Scalars['Int']['input'];
  notifications: StudentAdksFieldsValueSignInVideoAskResponseFormNotificationsObjectEqualityInput;
  questions?: InputMaybe<Array<StudentAdksFieldsValueSignInVideoAskResponseFormQuestionsObjectEqualityInput>>;
  requires_consent: Scalars['Boolean']['input'];
  requires_contact_email: Scalars['Boolean']['input'];
  requires_contact_info: Scalars['Boolean']['input'];
  requires_contact_name: Scalars['Boolean']['input'];
  requires_contact_phone_number: Scalars['Boolean']['input'];
  respondents_count: Scalars['Int']['input'];
  responses_share_id: Scalars['String']['input'];
  responses_share_url: Scalars['String']['input'];
  share_id: Scalars['String']['input'];
  share_url: Scalars['String']['input'];
  show_consent: Scalars['Boolean']['input'];
  show_contact_email: Scalars['Boolean']['input'];
  show_contact_name: Scalars['Boolean']['input'];
  show_contact_phone_number: Scalars['Boolean']['input'];
  tag_share_id: Scalars['String']['input'];
  tag_share_url: Scalars['String']['input'];
};

export type StudentAdksFieldsValueSignInVideoAskResponseFormQuestions = {
  __typename?: 'StudentAdksFieldsValueSignInVideoAskResponseFormQuestions';
  question_id: Scalars['String']['output'];
};

export type StudentAdksFieldsValueSignInVideoAskResponseFormQuestionsCreateInput = {
  question_id: Scalars['String']['input'];
};

export type StudentAdksFieldsValueSignInVideoAskResponseFormQuestionsObjectEqualityInput = {
  question_id: Scalars['String']['input'];
};

export type StudentAdksFieldsValueSignInVideoAskResponseObjectEqualityInput = {
  contact: StudentAdksFieldsValueSignInVideoAskResponseContactObjectEqualityInput;
  event_id: Scalars['String']['input'];
  event_type: Scalars['String']['input'];
  form: StudentAdksFieldsValueSignInVideoAskResponseFormObjectEqualityInput;
  interaction_id: Scalars['String']['input'];
};

export type StudentAdksFieldsValueSignOffVideoAskResponse = {
  __typename?: 'StudentAdksFieldsValueSignOffVideoAskResponse';
  contact: StudentAdksFieldsValueSignOffVideoAskResponseContact;
  event_id: Scalars['String']['output'];
  event_type: Scalars['String']['output'];
  form: StudentAdksFieldsValueSignOffVideoAskResponseForm;
  interaction_id: Scalars['String']['output'];
};

export type StudentAdksFieldsValueSignOffVideoAskResponseContact = {
  __typename?: 'StudentAdksFieldsValueSignOffVideoAskResponseContact';
  answers?: Maybe<Array<StudentAdksFieldsValueSignOffVideoAskResponseContactAnswers>>;
  are_answers_public: Scalars['Boolean']['output'];
  are_messages_public: Scalars['Boolean']['output'];
  contact_id: Scalars['String']['output'];
  email: Scalars['String']['output'];
  platform: Scalars['String']['output'];
  share_id: Scalars['String']['output'];
  share_url: Scalars['String']['output'];
  status: Scalars['String']['output'];
};

export type StudentAdksFieldsValueSignOffVideoAskResponseContactAnswers = {
  __typename?: 'StudentAdksFieldsValueSignOffVideoAskResponseContactAnswers';
  answer_id: Scalars['String']['output'];
  media_id?: Maybe<Scalars['String']['output']>;
  media_url?: Maybe<Scalars['String']['output']>;
  /** Could not determine type: the field only had null or empty values in the sample set. */
  poll_options?: Maybe<Scalars['JSON']['output']>;
  question_id: Scalars['String']['output'];
};

export type StudentAdksFieldsValueSignOffVideoAskResponseContactAnswersCreateInput = {
  answer_id: Scalars['String']['input'];
  media_id?: InputMaybe<Scalars['String']['input']>;
  media_url?: InputMaybe<Scalars['String']['input']>;
  poll_options?: InputMaybe<Scalars['JSON']['input']>;
  question_id: Scalars['String']['input'];
};

export type StudentAdksFieldsValueSignOffVideoAskResponseContactAnswersObjectEqualityInput = {
  answer_id: Scalars['String']['input'];
  media_id?: InputMaybe<Scalars['String']['input']>;
  media_url?: InputMaybe<Scalars['String']['input']>;
  poll_options?: InputMaybe<Scalars['JSON']['input']>;
  question_id: Scalars['String']['input'];
};

export type StudentAdksFieldsValueSignOffVideoAskResponseContactCreateInput = {
  answers?: InputMaybe<Array<StudentAdksFieldsValueSignOffVideoAskResponseContactAnswersCreateInput>>;
  are_answers_public: Scalars['Boolean']['input'];
  are_messages_public: Scalars['Boolean']['input'];
  contact_id: Scalars['String']['input'];
  email: Scalars['String']['input'];
  platform: Scalars['String']['input'];
  share_id: Scalars['String']['input'];
  share_url: Scalars['String']['input'];
  status: Scalars['String']['input'];
};

export type StudentAdksFieldsValueSignOffVideoAskResponseContactObjectEqualityInput = {
  answers?: InputMaybe<Array<StudentAdksFieldsValueSignOffVideoAskResponseContactAnswersObjectEqualityInput>>;
  are_answers_public: Scalars['Boolean']['input'];
  are_messages_public: Scalars['Boolean']['input'];
  contact_id: Scalars['String']['input'];
  email: Scalars['String']['input'];
  platform: Scalars['String']['input'];
  share_id: Scalars['String']['input'];
  share_url: Scalars['String']['input'];
  status: Scalars['String']['input'];
};

export type StudentAdksFieldsValueSignOffVideoAskResponseCreateInput = {
  contact: StudentAdksFieldsValueSignOffVideoAskResponseContactCreateInput;
  event_id: Scalars['String']['input'];
  event_type: Scalars['String']['input'];
  form: StudentAdksFieldsValueSignOffVideoAskResponseFormCreateInput;
  interaction_id: Scalars['String']['input'];
};

export type StudentAdksFieldsValueSignOffVideoAskResponseForm = {
  __typename?: 'StudentAdksFieldsValueSignOffVideoAskResponseForm';
  are_answers_public: Scalars['Boolean']['output'];
  are_messages_public: Scalars['Boolean']['output'];
  form_id: Scalars['String']['output'];
  hide_branding: Scalars['Boolean']['output'];
  idle_deadline_time_in_minutes: Scalars['Int']['output'];
  notifications: StudentAdksFieldsValueSignOffVideoAskResponseFormNotifications;
  questions?: Maybe<Array<StudentAdksFieldsValueSignOffVideoAskResponseFormQuestions>>;
  requires_consent: Scalars['Boolean']['output'];
  requires_contact_email: Scalars['Boolean']['output'];
  requires_contact_info: Scalars['Boolean']['output'];
  requires_contact_name: Scalars['Boolean']['output'];
  requires_contact_phone_number: Scalars['Boolean']['output'];
  respondents_count: Scalars['Int']['output'];
  responses_share_id: Scalars['String']['output'];
  responses_share_url: Scalars['String']['output'];
  share_id: Scalars['String']['output'];
  share_url: Scalars['String']['output'];
  show_consent: Scalars['Boolean']['output'];
  show_contact_email: Scalars['Boolean']['output'];
  show_contact_name: Scalars['Boolean']['output'];
  show_contact_phone_number: Scalars['Boolean']['output'];
  tag_share_id: Scalars['String']['output'];
  tag_share_url: Scalars['String']['output'];
};

export type StudentAdksFieldsValueSignOffVideoAskResponseFormCreateInput = {
  are_answers_public: Scalars['Boolean']['input'];
  are_messages_public: Scalars['Boolean']['input'];
  form_id: Scalars['String']['input'];
  hide_branding: Scalars['Boolean']['input'];
  idle_deadline_time_in_minutes: Scalars['Int']['input'];
  notifications: StudentAdksFieldsValueSignOffVideoAskResponseFormNotificationsCreateInput;
  questions?: InputMaybe<Array<StudentAdksFieldsValueSignOffVideoAskResponseFormQuestionsCreateInput>>;
  requires_consent: Scalars['Boolean']['input'];
  requires_contact_email: Scalars['Boolean']['input'];
  requires_contact_info: Scalars['Boolean']['input'];
  requires_contact_name: Scalars['Boolean']['input'];
  requires_contact_phone_number: Scalars['Boolean']['input'];
  respondents_count: Scalars['Int']['input'];
  responses_share_id: Scalars['String']['input'];
  responses_share_url: Scalars['String']['input'];
  share_id: Scalars['String']['input'];
  share_url: Scalars['String']['input'];
  show_consent: Scalars['Boolean']['input'];
  show_contact_email: Scalars['Boolean']['input'];
  show_contact_name: Scalars['Boolean']['input'];
  show_contact_phone_number: Scalars['Boolean']['input'];
  tag_share_id: Scalars['String']['input'];
  tag_share_url: Scalars['String']['input'];
};

export type StudentAdksFieldsValueSignOffVideoAskResponseFormNotifications = {
  __typename?: 'StudentAdksFieldsValueSignOffVideoAskResponseFormNotifications';
  send_contact_message_emails: Scalars['Boolean']['output'];
};

export type StudentAdksFieldsValueSignOffVideoAskResponseFormNotificationsCreateInput = {
  send_contact_message_emails: Scalars['Boolean']['input'];
};

export type StudentAdksFieldsValueSignOffVideoAskResponseFormNotificationsObjectEqualityInput = {
  send_contact_message_emails: Scalars['Boolean']['input'];
};

export type StudentAdksFieldsValueSignOffVideoAskResponseFormObjectEqualityInput = {
  are_answers_public: Scalars['Boolean']['input'];
  are_messages_public: Scalars['Boolean']['input'];
  form_id: Scalars['String']['input'];
  hide_branding: Scalars['Boolean']['input'];
  idle_deadline_time_in_minutes: Scalars['Int']['input'];
  notifications: StudentAdksFieldsValueSignOffVideoAskResponseFormNotificationsObjectEqualityInput;
  questions?: InputMaybe<Array<StudentAdksFieldsValueSignOffVideoAskResponseFormQuestionsObjectEqualityInput>>;
  requires_consent: Scalars['Boolean']['input'];
  requires_contact_email: Scalars['Boolean']['input'];
  requires_contact_info: Scalars['Boolean']['input'];
  requires_contact_name: Scalars['Boolean']['input'];
  requires_contact_phone_number: Scalars['Boolean']['input'];
  respondents_count: Scalars['Int']['input'];
  responses_share_id: Scalars['String']['input'];
  responses_share_url: Scalars['String']['input'];
  share_id: Scalars['String']['input'];
  share_url: Scalars['String']['input'];
  show_consent: Scalars['Boolean']['input'];
  show_contact_email: Scalars['Boolean']['input'];
  show_contact_name: Scalars['Boolean']['input'];
  show_contact_phone_number: Scalars['Boolean']['input'];
  tag_share_id: Scalars['String']['input'];
  tag_share_url: Scalars['String']['input'];
};

export type StudentAdksFieldsValueSignOffVideoAskResponseFormQuestions = {
  __typename?: 'StudentAdksFieldsValueSignOffVideoAskResponseFormQuestions';
  question_id: Scalars['String']['output'];
};

export type StudentAdksFieldsValueSignOffVideoAskResponseFormQuestionsCreateInput = {
  question_id: Scalars['String']['input'];
};

export type StudentAdksFieldsValueSignOffVideoAskResponseFormQuestionsObjectEqualityInput = {
  question_id: Scalars['String']['input'];
};

export type StudentAdksFieldsValueSignOffVideoAskResponseObjectEqualityInput = {
  contact: StudentAdksFieldsValueSignOffVideoAskResponseContactObjectEqualityInput;
  event_id: Scalars['String']['input'];
  event_type: Scalars['String']['input'];
  form: StudentAdksFieldsValueSignOffVideoAskResponseFormObjectEqualityInput;
  interaction_id: Scalars['String']['input'];
};

export type StudentAdksFieldsValueSubmission = {
  __typename?: 'StudentAdksFieldsValueSubmission';
  apple: Scalars['String']['output'];
  google: Scalars['String']['output'];
  web: Scalars['String']['output'];
};

export type StudentAdksFieldsValueSubmissionCreateInput = {
  apple: Scalars['String']['input'];
  google: Scalars['String']['input'];
  web: Scalars['String']['input'];
};

export type StudentAdksFieldsValueSubmissionObjectEqualityInput = {
  apple: Scalars['String']['input'];
  google: Scalars['String']['input'];
  web: Scalars['String']['input'];
};

export type StudentAdksFieldsValueSubmittedVideo = {
  __typename?: 'StudentAdksFieldsValueSubmittedVideo';
  contentDetails: StudentAdksFieldsValueSubmittedVideoContentDetails;
  etag: Scalars['String']['output'];
  id: Scalars['String']['output'];
  kind: Scalars['String']['output'];
  snippet: StudentAdksFieldsValueSubmittedVideoSnippet;
  status: StudentAdksFieldsValueSubmittedVideoStatus;
};

export type StudentAdksFieldsValueSubmittedVideoContentDetails = {
  __typename?: 'StudentAdksFieldsValueSubmittedVideoContentDetails';
  caption: Scalars['String']['output'];
  contentRating: StudentAdksFieldsValueSubmittedVideoContentDetailsContentRating;
  definition: Scalars['String']['output'];
  dimension: Scalars['String']['output'];
  duration: Scalars['String']['output'];
  licensedContent: Scalars['Boolean']['output'];
  projection: Scalars['String']['output'];
  regionRestriction?: Maybe<StudentAdksFieldsValueSubmittedVideoContentDetailsRegionRestriction>;
};

export type StudentAdksFieldsValueSubmittedVideoContentDetailsContentRating = {
  __typename?: 'StudentAdksFieldsValueSubmittedVideoContentDetailsContentRating';
  ytRating?: Maybe<Scalars['String']['output']>;
};

export type StudentAdksFieldsValueSubmittedVideoContentDetailsContentRatingCreateInput = {
  ytRating?: InputMaybe<Scalars['String']['input']>;
};

export type StudentAdksFieldsValueSubmittedVideoContentDetailsContentRatingObjectEqualityInput = {
  ytRating?: InputMaybe<Scalars['String']['input']>;
};

export type StudentAdksFieldsValueSubmittedVideoContentDetailsCreateInput = {
  caption: Scalars['String']['input'];
  contentRating: StudentAdksFieldsValueSubmittedVideoContentDetailsContentRatingCreateInput;
  definition: Scalars['String']['input'];
  dimension: Scalars['String']['input'];
  duration: Scalars['String']['input'];
  licensedContent: Scalars['Boolean']['input'];
  projection: Scalars['String']['input'];
  regionRestriction?: InputMaybe<StudentAdksFieldsValueSubmittedVideoContentDetailsRegionRestrictionCreateInput>;
};

export type StudentAdksFieldsValueSubmittedVideoContentDetailsObjectEqualityInput = {
  caption: Scalars['String']['input'];
  contentRating: StudentAdksFieldsValueSubmittedVideoContentDetailsContentRatingObjectEqualityInput;
  definition: Scalars['String']['input'];
  dimension: Scalars['String']['input'];
  duration: Scalars['String']['input'];
  licensedContent: Scalars['Boolean']['input'];
  projection: Scalars['String']['input'];
  regionRestriction?: InputMaybe<StudentAdksFieldsValueSubmittedVideoContentDetailsRegionRestrictionObjectEqualityInput>;
};

export type StudentAdksFieldsValueSubmittedVideoContentDetailsRegionRestriction = {
  __typename?: 'StudentAdksFieldsValueSubmittedVideoContentDetailsRegionRestriction';
  blocked?: Maybe<Array<Scalars['String']['output']>>;
};

export type StudentAdksFieldsValueSubmittedVideoContentDetailsRegionRestrictionCreateInput = {
  blocked?: InputMaybe<StudentAdksFieldsValueSubmittedVideoContentDetailsRegionRestrictionCreateblockedInput>;
};

export type StudentAdksFieldsValueSubmittedVideoContentDetailsRegionRestrictionCreateblockedInput = {
  set: Array<Scalars['String']['input']>;
};

export type StudentAdksFieldsValueSubmittedVideoContentDetailsRegionRestrictionObjectEqualityInput = {
  blocked?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type StudentAdksFieldsValueSubmittedVideoCreateInput = {
  contentDetails: StudentAdksFieldsValueSubmittedVideoContentDetailsCreateInput;
  etag: Scalars['String']['input'];
  id: Scalars['String']['input'];
  kind: Scalars['String']['input'];
  snippet: StudentAdksFieldsValueSubmittedVideoSnippetCreateInput;
  status: StudentAdksFieldsValueSubmittedVideoStatusCreateInput;
};

export type StudentAdksFieldsValueSubmittedVideoObjectEqualityInput = {
  contentDetails: StudentAdksFieldsValueSubmittedVideoContentDetailsObjectEqualityInput;
  etag: Scalars['String']['input'];
  id: Scalars['String']['input'];
  kind: Scalars['String']['input'];
  snippet: StudentAdksFieldsValueSubmittedVideoSnippetObjectEqualityInput;
  status: StudentAdksFieldsValueSubmittedVideoStatusObjectEqualityInput;
};

export type StudentAdksFieldsValueSubmittedVideoSnippet = {
  __typename?: 'StudentAdksFieldsValueSubmittedVideoSnippet';
  categoryId: Scalars['String']['output'];
  channelId: Scalars['String']['output'];
  channelTitle: Scalars['String']['output'];
  defaultAudioLanguage?: Maybe<Scalars['String']['output']>;
  defaultLanguage?: Maybe<Scalars['String']['output']>;
  description: Scalars['String']['output'];
  liveBroadcastContent: Scalars['String']['output'];
  localized: StudentAdksFieldsValueSubmittedVideoSnippetLocalized;
  publishedAt: Scalars['String']['output'];
  tags?: Maybe<Array<Scalars['String']['output']>>;
  thumbnails: StudentAdksFieldsValueSubmittedVideoSnippetThumbnails;
  title: Scalars['String']['output'];
};

export type StudentAdksFieldsValueSubmittedVideoSnippetCreateInput = {
  categoryId: Scalars['String']['input'];
  channelId: Scalars['String']['input'];
  channelTitle: Scalars['String']['input'];
  defaultAudioLanguage?: InputMaybe<Scalars['String']['input']>;
  defaultLanguage?: InputMaybe<Scalars['String']['input']>;
  description: Scalars['String']['input'];
  liveBroadcastContent: Scalars['String']['input'];
  localized: StudentAdksFieldsValueSubmittedVideoSnippetLocalizedCreateInput;
  publishedAt: Scalars['String']['input'];
  tags?: InputMaybe<StudentAdksFieldsValueSubmittedVideoSnippetCreatetagsInput>;
  thumbnails: StudentAdksFieldsValueSubmittedVideoSnippetThumbnailsCreateInput;
  title: Scalars['String']['input'];
};

export type StudentAdksFieldsValueSubmittedVideoSnippetCreatetagsInput = {
  set: Array<Scalars['String']['input']>;
};

export type StudentAdksFieldsValueSubmittedVideoSnippetLocalized = {
  __typename?: 'StudentAdksFieldsValueSubmittedVideoSnippetLocalized';
  description: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type StudentAdksFieldsValueSubmittedVideoSnippetLocalizedCreateInput = {
  description: Scalars['String']['input'];
  title: Scalars['String']['input'];
};

export type StudentAdksFieldsValueSubmittedVideoSnippetLocalizedObjectEqualityInput = {
  description: Scalars['String']['input'];
  title: Scalars['String']['input'];
};

export type StudentAdksFieldsValueSubmittedVideoSnippetObjectEqualityInput = {
  categoryId: Scalars['String']['input'];
  channelId: Scalars['String']['input'];
  channelTitle: Scalars['String']['input'];
  defaultAudioLanguage?: InputMaybe<Scalars['String']['input']>;
  defaultLanguage?: InputMaybe<Scalars['String']['input']>;
  description: Scalars['String']['input'];
  liveBroadcastContent: Scalars['String']['input'];
  localized: StudentAdksFieldsValueSubmittedVideoSnippetLocalizedObjectEqualityInput;
  publishedAt: Scalars['String']['input'];
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  thumbnails: StudentAdksFieldsValueSubmittedVideoSnippetThumbnailsObjectEqualityInput;
  title: Scalars['String']['input'];
};

export type StudentAdksFieldsValueSubmittedVideoSnippetThumbnails = {
  __typename?: 'StudentAdksFieldsValueSubmittedVideoSnippetThumbnails';
  default: StudentAdksFieldsValueSubmittedVideoSnippetThumbnailsDefault;
  high: StudentAdksFieldsValueSubmittedVideoSnippetThumbnailsHigh;
  maxres?: Maybe<StudentAdksFieldsValueSubmittedVideoSnippetThumbnailsMaxres>;
  medium: StudentAdksFieldsValueSubmittedVideoSnippetThumbnailsMedium;
  standard?: Maybe<StudentAdksFieldsValueSubmittedVideoSnippetThumbnailsStandard>;
};

export type StudentAdksFieldsValueSubmittedVideoSnippetThumbnailsCreateInput = {
  default: StudentAdksFieldsValueSubmittedVideoSnippetThumbnailsDefaultCreateInput;
  high: StudentAdksFieldsValueSubmittedVideoSnippetThumbnailsHighCreateInput;
  maxres?: InputMaybe<StudentAdksFieldsValueSubmittedVideoSnippetThumbnailsMaxresCreateInput>;
  medium: StudentAdksFieldsValueSubmittedVideoSnippetThumbnailsMediumCreateInput;
  standard?: InputMaybe<StudentAdksFieldsValueSubmittedVideoSnippetThumbnailsStandardCreateInput>;
};

export type StudentAdksFieldsValueSubmittedVideoSnippetThumbnailsDefault = {
  __typename?: 'StudentAdksFieldsValueSubmittedVideoSnippetThumbnailsDefault';
  height: Scalars['Int']['output'];
  url: Scalars['String']['output'];
  width: Scalars['Int']['output'];
};

export type StudentAdksFieldsValueSubmittedVideoSnippetThumbnailsDefaultCreateInput = {
  height: Scalars['Int']['input'];
  url: Scalars['String']['input'];
  width: Scalars['Int']['input'];
};

export type StudentAdksFieldsValueSubmittedVideoSnippetThumbnailsDefaultObjectEqualityInput = {
  height: Scalars['Int']['input'];
  url: Scalars['String']['input'];
  width: Scalars['Int']['input'];
};

export type StudentAdksFieldsValueSubmittedVideoSnippetThumbnailsHigh = {
  __typename?: 'StudentAdksFieldsValueSubmittedVideoSnippetThumbnailsHigh';
  height: Scalars['Int']['output'];
  url: Scalars['String']['output'];
  width: Scalars['Int']['output'];
};

export type StudentAdksFieldsValueSubmittedVideoSnippetThumbnailsHighCreateInput = {
  height: Scalars['Int']['input'];
  url: Scalars['String']['input'];
  width: Scalars['Int']['input'];
};

export type StudentAdksFieldsValueSubmittedVideoSnippetThumbnailsHighObjectEqualityInput = {
  height: Scalars['Int']['input'];
  url: Scalars['String']['input'];
  width: Scalars['Int']['input'];
};

export type StudentAdksFieldsValueSubmittedVideoSnippetThumbnailsMaxres = {
  __typename?: 'StudentAdksFieldsValueSubmittedVideoSnippetThumbnailsMaxres';
  height: Scalars['Int']['output'];
  url: Scalars['String']['output'];
  width: Scalars['Int']['output'];
};

export type StudentAdksFieldsValueSubmittedVideoSnippetThumbnailsMaxresCreateInput = {
  height: Scalars['Int']['input'];
  url: Scalars['String']['input'];
  width: Scalars['Int']['input'];
};

export type StudentAdksFieldsValueSubmittedVideoSnippetThumbnailsMaxresObjectEqualityInput = {
  height: Scalars['Int']['input'];
  url: Scalars['String']['input'];
  width: Scalars['Int']['input'];
};

export type StudentAdksFieldsValueSubmittedVideoSnippetThumbnailsMedium = {
  __typename?: 'StudentAdksFieldsValueSubmittedVideoSnippetThumbnailsMedium';
  height: Scalars['Int']['output'];
  url: Scalars['String']['output'];
  width: Scalars['Int']['output'];
};

export type StudentAdksFieldsValueSubmittedVideoSnippetThumbnailsMediumCreateInput = {
  height: Scalars['Int']['input'];
  url: Scalars['String']['input'];
  width: Scalars['Int']['input'];
};

export type StudentAdksFieldsValueSubmittedVideoSnippetThumbnailsMediumObjectEqualityInput = {
  height: Scalars['Int']['input'];
  url: Scalars['String']['input'];
  width: Scalars['Int']['input'];
};

export type StudentAdksFieldsValueSubmittedVideoSnippetThumbnailsObjectEqualityInput = {
  default: StudentAdksFieldsValueSubmittedVideoSnippetThumbnailsDefaultObjectEqualityInput;
  high: StudentAdksFieldsValueSubmittedVideoSnippetThumbnailsHighObjectEqualityInput;
  maxres?: InputMaybe<StudentAdksFieldsValueSubmittedVideoSnippetThumbnailsMaxresObjectEqualityInput>;
  medium: StudentAdksFieldsValueSubmittedVideoSnippetThumbnailsMediumObjectEqualityInput;
  standard?: InputMaybe<StudentAdksFieldsValueSubmittedVideoSnippetThumbnailsStandardObjectEqualityInput>;
};

export type StudentAdksFieldsValueSubmittedVideoSnippetThumbnailsStandard = {
  __typename?: 'StudentAdksFieldsValueSubmittedVideoSnippetThumbnailsStandard';
  height: Scalars['Int']['output'];
  url: Scalars['String']['output'];
  width: Scalars['Int']['output'];
};

export type StudentAdksFieldsValueSubmittedVideoSnippetThumbnailsStandardCreateInput = {
  height: Scalars['Int']['input'];
  url: Scalars['String']['input'];
  width: Scalars['Int']['input'];
};

export type StudentAdksFieldsValueSubmittedVideoSnippetThumbnailsStandardObjectEqualityInput = {
  height: Scalars['Int']['input'];
  url: Scalars['String']['input'];
  width: Scalars['Int']['input'];
};

export type StudentAdksFieldsValueSubmittedVideoStatus = {
  __typename?: 'StudentAdksFieldsValueSubmittedVideoStatus';
  embeddable: Scalars['Boolean']['output'];
  license: Scalars['String']['output'];
  madeForKids: Scalars['Boolean']['output'];
  privacyStatus: Scalars['String']['output'];
  publicStatsViewable: Scalars['Boolean']['output'];
  uploadStatus: Scalars['String']['output'];
};

export type StudentAdksFieldsValueSubmittedVideoStatusCreateInput = {
  embeddable: Scalars['Boolean']['input'];
  license: Scalars['String']['input'];
  madeForKids: Scalars['Boolean']['input'];
  privacyStatus: Scalars['String']['input'];
  publicStatsViewable: Scalars['Boolean']['input'];
  uploadStatus: Scalars['String']['input'];
};

export type StudentAdksFieldsValueSubmittedVideoStatusObjectEqualityInput = {
  embeddable: Scalars['Boolean']['input'];
  license: Scalars['String']['input'];
  madeForKids: Scalars['Boolean']['input'];
  privacyStatus: Scalars['String']['input'];
  publicStatsViewable: Scalars['Boolean']['input'];
  uploadStatus: Scalars['String']['input'];
};

export type StudentAdksFieldsValueTimeFrame = {
  __typename?: 'StudentAdksFieldsValueTimeFrame';
  end: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  isCondensed: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  notes: Scalars['String']['output'];
  start: Scalars['String']['output'];
  visibility: Scalars['String']['output'];
};

export type StudentAdksFieldsValueTimeFrameCreateInput = {
  end: Scalars['String']['input'];
  id: Scalars['Int']['input'];
  isCondensed: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  notes: Scalars['String']['input'];
  start: Scalars['String']['input'];
  visibility: Scalars['String']['input'];
};

export type StudentAdksFieldsValueTimeFrameObjectEqualityInput = {
  end: Scalars['String']['input'];
  id: Scalars['Int']['input'];
  isCondensed: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  notes: Scalars['String']['input'];
  start: Scalars['String']['input'];
  visibility: Scalars['String']['input'];
};

export type StudentAdksFieldsValueTimesheetDetails = {
  __typename?: 'StudentAdksFieldsValueTimesheetDetails';
  answerType: Scalars['String']['output'];
  interactionId?: Maybe<Scalars['String']['output']>;
  shareUrl?: Maybe<Scalars['String']['output']>;
  system_generated?: Maybe<Scalars['Boolean']['output']>;
  timesheetFilledAt: Scalars['String']['output'];
  timesheetFor: Scalars['String']['output'];
  timesheetText?: Maybe<Scalars['String']['output']>;
  transcription?: Maybe<Scalars['String']['output']>;
  vibeRating?: Maybe<Scalars['String']['output']>;
};

export type StudentAdksFieldsValueTimesheetDetailsCreateInput = {
  answerType: Scalars['String']['input'];
  interactionId?: InputMaybe<Scalars['String']['input']>;
  shareUrl?: InputMaybe<Scalars['String']['input']>;
  system_generated?: InputMaybe<Scalars['Boolean']['input']>;
  timesheetFilledAt: Scalars['String']['input'];
  timesheetFor: Scalars['String']['input'];
  timesheetText?: InputMaybe<Scalars['String']['input']>;
  transcription?: InputMaybe<Scalars['String']['input']>;
  vibeRating?: InputMaybe<Scalars['String']['input']>;
};

export type StudentAdksFieldsValueTimesheetDetailsObjectEqualityInput = {
  answerType: Scalars['String']['input'];
  interactionId?: InputMaybe<Scalars['String']['input']>;
  shareUrl?: InputMaybe<Scalars['String']['input']>;
  system_generated?: InputMaybe<Scalars['Boolean']['input']>;
  timesheetFilledAt: Scalars['String']['input'];
  timesheetFor: Scalars['String']['input'];
  timesheetText?: InputMaybe<Scalars['String']['input']>;
  transcription?: InputMaybe<Scalars['String']['input']>;
  vibeRating?: InputMaybe<Scalars['String']['input']>;
};

export type StudentAdksFieldsValueTrainProgress = {
  __typename?: 'StudentAdksFieldsValueTrainProgress';
  completed?: Maybe<Scalars['Boolean']['output']>;
  is_processing?: Maybe<Scalars['Boolean']['output']>;
  is_videoask?: Maybe<Scalars['Boolean']['output']>;
  link: Scalars['String']['output'];
  name: Scalars['String']['output'];
  newCandidate?: Maybe<Scalars['Boolean']['output']>;
  required?: Maybe<Scalars['Boolean']['output']>;
  unlocked?: Maybe<Scalars['Boolean']['output']>;
  videoAskResponse?: Maybe<StudentAdksFieldsValueTrainProgressVideoAskResponse>;
  videoask_question_url?: Maybe<Scalars['String']['output']>;
};

export type StudentAdksFieldsValueTrainProgressCreateInput = {
  completed?: InputMaybe<Scalars['Boolean']['input']>;
  is_processing?: InputMaybe<Scalars['Boolean']['input']>;
  is_videoask?: InputMaybe<Scalars['Boolean']['input']>;
  link: Scalars['String']['input'];
  name: Scalars['String']['input'];
  newCandidate?: InputMaybe<Scalars['Boolean']['input']>;
  required?: InputMaybe<Scalars['Boolean']['input']>;
  unlocked?: InputMaybe<Scalars['Boolean']['input']>;
  videoAskResponse?: InputMaybe<StudentAdksFieldsValueTrainProgressVideoAskResponseCreateInput>;
  videoask_question_url?: InputMaybe<Scalars['String']['input']>;
};

export type StudentAdksFieldsValueTrainProgressObjectEqualityInput = {
  completed?: InputMaybe<Scalars['Boolean']['input']>;
  is_processing?: InputMaybe<Scalars['Boolean']['input']>;
  is_videoask?: InputMaybe<Scalars['Boolean']['input']>;
  link: Scalars['String']['input'];
  name: Scalars['String']['input'];
  newCandidate?: InputMaybe<Scalars['Boolean']['input']>;
  required?: InputMaybe<Scalars['Boolean']['input']>;
  unlocked?: InputMaybe<Scalars['Boolean']['input']>;
  videoAskResponse?: InputMaybe<StudentAdksFieldsValueTrainProgressVideoAskResponseObjectEqualityInput>;
  videoask_question_url?: InputMaybe<Scalars['String']['input']>;
};

export type StudentAdksFieldsValueTrainProgressVideoAskResponse = {
  __typename?: 'StudentAdksFieldsValueTrainProgressVideoAskResponse';
  contact: StudentAdksFieldsValueTrainProgressVideoAskResponseContact;
  event_id: Scalars['String']['output'];
  event_type: Scalars['String']['output'];
  form: StudentAdksFieldsValueTrainProgressVideoAskResponseForm;
  interaction_id: Scalars['String']['output'];
};

export type StudentAdksFieldsValueTrainProgressVideoAskResponseContact = {
  __typename?: 'StudentAdksFieldsValueTrainProgressVideoAskResponseContact';
  answers?: Maybe<Array<StudentAdksFieldsValueTrainProgressVideoAskResponseContactAnswers>>;
  are_answers_public: Scalars['Boolean']['output'];
  are_messages_public: Scalars['Boolean']['output'];
  contact_id: Scalars['String']['output'];
  email: Scalars['String']['output'];
  platform: Scalars['String']['output'];
  share_id: Scalars['String']['output'];
  share_url: Scalars['String']['output'];
  status: Scalars['String']['output'];
};

export type StudentAdksFieldsValueTrainProgressVideoAskResponseContactAnswers = {
  __typename?: 'StudentAdksFieldsValueTrainProgressVideoAskResponseContactAnswers';
  answer_id: Scalars['String']['output'];
  media_id?: Maybe<Scalars['String']['output']>;
  media_url?: Maybe<Scalars['String']['output']>;
  poll_options?: Maybe<Array<StudentAdksFieldsValueTrainProgressVideoAskResponseContactAnswersPollOptions>>;
  question_id: Scalars['String']['output'];
};

export type StudentAdksFieldsValueTrainProgressVideoAskResponseContactAnswersCreateInput = {
  answer_id: Scalars['String']['input'];
  media_id?: InputMaybe<Scalars['String']['input']>;
  media_url?: InputMaybe<Scalars['String']['input']>;
  poll_options?: InputMaybe<Array<StudentAdksFieldsValueTrainProgressVideoAskResponseContactAnswersPollOptionsCreateInput>>;
  question_id: Scalars['String']['input'];
};

export type StudentAdksFieldsValueTrainProgressVideoAskResponseContactAnswersObjectEqualityInput = {
  answer_id: Scalars['String']['input'];
  media_id?: InputMaybe<Scalars['String']['input']>;
  media_url?: InputMaybe<Scalars['String']['input']>;
  poll_options?: InputMaybe<Array<StudentAdksFieldsValueTrainProgressVideoAskResponseContactAnswersPollOptionsObjectEqualityInput>>;
  question_id: Scalars['String']['input'];
};

export type StudentAdksFieldsValueTrainProgressVideoAskResponseContactAnswersPollOptions = {
  __typename?: 'StudentAdksFieldsValueTrainProgressVideoAskResponseContactAnswersPollOptions';
  content: Scalars['String']['output'];
  id: Scalars['String']['output'];
  ref: Scalars['String']['output'];
};

export type StudentAdksFieldsValueTrainProgressVideoAskResponseContactAnswersPollOptionsCreateInput = {
  content: Scalars['String']['input'];
  id: Scalars['String']['input'];
  ref: Scalars['String']['input'];
};

export type StudentAdksFieldsValueTrainProgressVideoAskResponseContactAnswersPollOptionsObjectEqualityInput = {
  content: Scalars['String']['input'];
  id: Scalars['String']['input'];
  ref: Scalars['String']['input'];
};

export type StudentAdksFieldsValueTrainProgressVideoAskResponseContactCreateInput = {
  answers?: InputMaybe<Array<StudentAdksFieldsValueTrainProgressVideoAskResponseContactAnswersCreateInput>>;
  are_answers_public: Scalars['Boolean']['input'];
  are_messages_public: Scalars['Boolean']['input'];
  contact_id: Scalars['String']['input'];
  email: Scalars['String']['input'];
  platform: Scalars['String']['input'];
  share_id: Scalars['String']['input'];
  share_url: Scalars['String']['input'];
  status: Scalars['String']['input'];
};

export type StudentAdksFieldsValueTrainProgressVideoAskResponseContactObjectEqualityInput = {
  answers?: InputMaybe<Array<StudentAdksFieldsValueTrainProgressVideoAskResponseContactAnswersObjectEqualityInput>>;
  are_answers_public: Scalars['Boolean']['input'];
  are_messages_public: Scalars['Boolean']['input'];
  contact_id: Scalars['String']['input'];
  email: Scalars['String']['input'];
  platform: Scalars['String']['input'];
  share_id: Scalars['String']['input'];
  share_url: Scalars['String']['input'];
  status: Scalars['String']['input'];
};

export type StudentAdksFieldsValueTrainProgressVideoAskResponseCreateInput = {
  contact: StudentAdksFieldsValueTrainProgressVideoAskResponseContactCreateInput;
  event_id: Scalars['String']['input'];
  event_type: Scalars['String']['input'];
  form: StudentAdksFieldsValueTrainProgressVideoAskResponseFormCreateInput;
  interaction_id: Scalars['String']['input'];
};

export type StudentAdksFieldsValueTrainProgressVideoAskResponseForm = {
  __typename?: 'StudentAdksFieldsValueTrainProgressVideoAskResponseForm';
  are_answers_public: Scalars['Boolean']['output'];
  are_messages_public: Scalars['Boolean']['output'];
  form_id: Scalars['String']['output'];
  hide_branding: Scalars['Boolean']['output'];
  idle_deadline_time_in_minutes: Scalars['Int']['output'];
  notifications: StudentAdksFieldsValueTrainProgressVideoAskResponseFormNotifications;
  questions?: Maybe<Array<StudentAdksFieldsValueTrainProgressVideoAskResponseFormQuestions>>;
  requires_consent: Scalars['Boolean']['output'];
  requires_contact_email: Scalars['Boolean']['output'];
  requires_contact_info: Scalars['Boolean']['output'];
  requires_contact_name: Scalars['Boolean']['output'];
  requires_contact_phone_number: Scalars['Boolean']['output'];
  respondents_count: Scalars['Int']['output'];
  responses_share_id: Scalars['String']['output'];
  responses_share_url: Scalars['String']['output'];
  share_id: Scalars['String']['output'];
  share_url: Scalars['String']['output'];
  show_consent: Scalars['Boolean']['output'];
  show_contact_email: Scalars['Boolean']['output'];
  show_contact_name: Scalars['Boolean']['output'];
  show_contact_phone_number: Scalars['Boolean']['output'];
  tag_share_id: Scalars['String']['output'];
  tag_share_url: Scalars['String']['output'];
};

export type StudentAdksFieldsValueTrainProgressVideoAskResponseFormCreateInput = {
  are_answers_public: Scalars['Boolean']['input'];
  are_messages_public: Scalars['Boolean']['input'];
  form_id: Scalars['String']['input'];
  hide_branding: Scalars['Boolean']['input'];
  idle_deadline_time_in_minutes: Scalars['Int']['input'];
  notifications: StudentAdksFieldsValueTrainProgressVideoAskResponseFormNotificationsCreateInput;
  questions?: InputMaybe<Array<StudentAdksFieldsValueTrainProgressVideoAskResponseFormQuestionsCreateInput>>;
  requires_consent: Scalars['Boolean']['input'];
  requires_contact_email: Scalars['Boolean']['input'];
  requires_contact_info: Scalars['Boolean']['input'];
  requires_contact_name: Scalars['Boolean']['input'];
  requires_contact_phone_number: Scalars['Boolean']['input'];
  respondents_count: Scalars['Int']['input'];
  responses_share_id: Scalars['String']['input'];
  responses_share_url: Scalars['String']['input'];
  share_id: Scalars['String']['input'];
  share_url: Scalars['String']['input'];
  show_consent: Scalars['Boolean']['input'];
  show_contact_email: Scalars['Boolean']['input'];
  show_contact_name: Scalars['Boolean']['input'];
  show_contact_phone_number: Scalars['Boolean']['input'];
  tag_share_id: Scalars['String']['input'];
  tag_share_url: Scalars['String']['input'];
};

export type StudentAdksFieldsValueTrainProgressVideoAskResponseFormNotifications = {
  __typename?: 'StudentAdksFieldsValueTrainProgressVideoAskResponseFormNotifications';
  send_contact_message_emails: Scalars['Boolean']['output'];
};

export type StudentAdksFieldsValueTrainProgressVideoAskResponseFormNotificationsCreateInput = {
  send_contact_message_emails: Scalars['Boolean']['input'];
};

export type StudentAdksFieldsValueTrainProgressVideoAskResponseFormNotificationsObjectEqualityInput = {
  send_contact_message_emails: Scalars['Boolean']['input'];
};

export type StudentAdksFieldsValueTrainProgressVideoAskResponseFormObjectEqualityInput = {
  are_answers_public: Scalars['Boolean']['input'];
  are_messages_public: Scalars['Boolean']['input'];
  form_id: Scalars['String']['input'];
  hide_branding: Scalars['Boolean']['input'];
  idle_deadline_time_in_minutes: Scalars['Int']['input'];
  notifications: StudentAdksFieldsValueTrainProgressVideoAskResponseFormNotificationsObjectEqualityInput;
  questions?: InputMaybe<Array<StudentAdksFieldsValueTrainProgressVideoAskResponseFormQuestionsObjectEqualityInput>>;
  requires_consent: Scalars['Boolean']['input'];
  requires_contact_email: Scalars['Boolean']['input'];
  requires_contact_info: Scalars['Boolean']['input'];
  requires_contact_name: Scalars['Boolean']['input'];
  requires_contact_phone_number: Scalars['Boolean']['input'];
  respondents_count: Scalars['Int']['input'];
  responses_share_id: Scalars['String']['input'];
  responses_share_url: Scalars['String']['input'];
  share_id: Scalars['String']['input'];
  share_url: Scalars['String']['input'];
  show_consent: Scalars['Boolean']['input'];
  show_contact_email: Scalars['Boolean']['input'];
  show_contact_name: Scalars['Boolean']['input'];
  show_contact_phone_number: Scalars['Boolean']['input'];
  tag_share_id: Scalars['String']['input'];
  tag_share_url: Scalars['String']['input'];
};

export type StudentAdksFieldsValueTrainProgressVideoAskResponseFormQuestions = {
  __typename?: 'StudentAdksFieldsValueTrainProgressVideoAskResponseFormQuestions';
  question_id: Scalars['String']['output'];
};

export type StudentAdksFieldsValueTrainProgressVideoAskResponseFormQuestionsCreateInput = {
  question_id: Scalars['String']['input'];
};

export type StudentAdksFieldsValueTrainProgressVideoAskResponseFormQuestionsObjectEqualityInput = {
  question_id: Scalars['String']['input'];
};

export type StudentAdksFieldsValueTrainProgressVideoAskResponseObjectEqualityInput = {
  contact: StudentAdksFieldsValueTrainProgressVideoAskResponseContactObjectEqualityInput;
  event_id: Scalars['String']['input'];
  event_type: Scalars['String']['input'];
  form: StudentAdksFieldsValueTrainProgressVideoAskResponseFormObjectEqualityInput;
  interaction_id: Scalars['String']['input'];
};

export type StudentAdksFieldsValueUploadLimit = {
  __typename?: 'StudentAdksFieldsValueUploadLimit';
  max: Scalars['Int']['output'];
  min: Scalars['Int']['output'];
};

export type StudentAdksFieldsValueUploadLimitCreateInput = {
  max: Scalars['Int']['input'];
  min: Scalars['Int']['input'];
};

export type StudentAdksFieldsValueUploadLimitObjectEqualityInput = {
  max: Scalars['Int']['input'];
  min: Scalars['Int']['input'];
};

export type StudentAdksFieldsValueValueDrafts = {
  __typename?: 'StudentAdksFieldsValueValueDrafts';
  elevatorPitch?: Maybe<Scalars['String']['output']>;
  finalDraft: Scalars['Boolean']['output'];
  innovation?: Maybe<Scalars['String']['output']>;
  onePitch?: Maybe<Scalars['String']['output']>;
  problem?: Maybe<Scalars['String']['output']>;
  solution?: Maybe<Scalars['String']['output']>;
  user?: Maybe<Scalars['String']['output']>;
};

export type StudentAdksFieldsValueValueDraftsCreateInput = {
  elevatorPitch?: InputMaybe<Scalars['String']['input']>;
  finalDraft: Scalars['Boolean']['input'];
  innovation?: InputMaybe<Scalars['String']['input']>;
  onePitch?: InputMaybe<Scalars['String']['input']>;
  problem?: InputMaybe<Scalars['String']['input']>;
  solution?: InputMaybe<Scalars['String']['input']>;
  user?: InputMaybe<Scalars['String']['input']>;
};

export type StudentAdksFieldsValueValueDraftsObjectEqualityInput = {
  elevatorPitch?: InputMaybe<Scalars['String']['input']>;
  finalDraft: Scalars['Boolean']['input'];
  innovation?: InputMaybe<Scalars['String']['input']>;
  onePitch?: InputMaybe<Scalars['String']['input']>;
  problem?: InputMaybe<Scalars['String']['input']>;
  solution?: InputMaybe<Scalars['String']['input']>;
  user?: InputMaybe<Scalars['String']['input']>;
};

export type StudentAdksFieldsValueVideoAskResponse = {
  __typename?: 'StudentAdksFieldsValueVideoAskResponse';
  contact: StudentAdksFieldsValueVideoAskResponseContact;
  event_id: Scalars['String']['output'];
  event_type: Scalars['String']['output'];
  form: StudentAdksFieldsValueVideoAskResponseForm;
  interaction_id: Scalars['String']['output'];
};

export type StudentAdksFieldsValueVideoAskResponseContact = {
  __typename?: 'StudentAdksFieldsValueVideoAskResponseContact';
  answers?: Maybe<Array<StudentAdksFieldsValueVideoAskResponseContactAnswers>>;
  /** Multiple data types found: String: 23.7%, Boolean: 76.3% out of 114 sampled entries */
  are_answers_public: Scalars['JSON']['output'];
  /** Multiple data types found: String: 23.7%, Boolean: 76.3% out of 114 sampled entries */
  are_messages_public: Scalars['JSON']['output'];
  /** Could not determine type: the field only had null or empty values in the sample set. */
  consent_given?: Maybe<Scalars['JSON']['output']>;
  contact_id: Scalars['String']['output'];
  created_at?: Maybe<Scalars['String']['output']>;
  email: Scalars['String']['output'];
  name?: Maybe<Scalars['String']['output']>;
  organization_id?: Maybe<Scalars['String']['output']>;
  /** Could not determine type: the field only had null or empty values in the sample set. */
  phone_number?: Maybe<Scalars['JSON']['output']>;
  platform: Scalars['String']['output'];
  /** Could not determine type: the field only had null or empty values in the sample set. */
  respondent_id?: Maybe<Scalars['JSON']['output']>;
  share_id: Scalars['String']['output'];
  share_url: Scalars['String']['output'];
  status: Scalars['String']['output'];
  /** Could not determine type: the field only had null or empty values in the sample set. */
  tags?: Maybe<Scalars['JSON']['output']>;
  thumbnail?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['String']['output']>;
  variables?: Maybe<StudentAdksFieldsValueVideoAskResponseContactVariables>;
};

export type StudentAdksFieldsValueVideoAskResponseContactAnswers = {
  __typename?: 'StudentAdksFieldsValueVideoAskResponseContactAnswers';
  answer_id: Scalars['String']['output'];
  created_at?: Maybe<Scalars['String']['output']>;
  /** Could not determine type: the field only had null or empty values in the sample set. */
  file_uploads?: Maybe<Scalars['JSON']['output']>;
  gif?: Maybe<Scalars['String']['output']>;
  is_public?: Maybe<Scalars['Boolean']['output']>;
  media_duration?: Maybe<Scalars['Int']['output']>;
  media_id?: Maybe<Scalars['String']['output']>;
  media_url?: Maybe<Scalars['String']['output']>;
  /** Could not determine type: the field only had null or empty values in the sample set. */
  poll_options?: Maybe<Scalars['JSON']['output']>;
  question_id: Scalars['String']['output'];
  share_id?: Maybe<Scalars['String']['output']>;
  share_url?: Maybe<Scalars['String']['output']>;
  thumbnail?: Maybe<Scalars['String']['output']>;
  transcode_status?: Maybe<Scalars['String']['output']>;
  transcribe_status?: Maybe<Scalars['String']['output']>;
  transcription?: Maybe<Scalars['String']['output']>;
  transcription_data?: Maybe<Array<StudentAdksFieldsValueVideoAskResponseContactAnswersTranscriptionData>>;
  type?: Maybe<Scalars['String']['output']>;
};

export type StudentAdksFieldsValueVideoAskResponseContactAnswersCreateInput = {
  answer_id: Scalars['String']['input'];
  created_at?: InputMaybe<Scalars['String']['input']>;
  file_uploads?: InputMaybe<Scalars['JSON']['input']>;
  gif?: InputMaybe<Scalars['String']['input']>;
  is_public?: InputMaybe<Scalars['Boolean']['input']>;
  media_duration?: InputMaybe<Scalars['Int']['input']>;
  media_id?: InputMaybe<Scalars['String']['input']>;
  media_url?: InputMaybe<Scalars['String']['input']>;
  poll_options?: InputMaybe<Scalars['JSON']['input']>;
  question_id: Scalars['String']['input'];
  share_id?: InputMaybe<Scalars['String']['input']>;
  share_url?: InputMaybe<Scalars['String']['input']>;
  thumbnail?: InputMaybe<Scalars['String']['input']>;
  transcode_status?: InputMaybe<Scalars['String']['input']>;
  transcribe_status?: InputMaybe<Scalars['String']['input']>;
  transcription?: InputMaybe<Scalars['String']['input']>;
  transcription_data?: InputMaybe<Array<StudentAdksFieldsValueVideoAskResponseContactAnswersTranscriptionDataCreateInput>>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type StudentAdksFieldsValueVideoAskResponseContactAnswersObjectEqualityInput = {
  answer_id: Scalars['String']['input'];
  created_at?: InputMaybe<Scalars['String']['input']>;
  file_uploads?: InputMaybe<Scalars['JSON']['input']>;
  gif?: InputMaybe<Scalars['String']['input']>;
  is_public?: InputMaybe<Scalars['Boolean']['input']>;
  media_duration?: InputMaybe<Scalars['Int']['input']>;
  media_id?: InputMaybe<Scalars['String']['input']>;
  media_url?: InputMaybe<Scalars['String']['input']>;
  poll_options?: InputMaybe<Scalars['JSON']['input']>;
  question_id: Scalars['String']['input'];
  share_id?: InputMaybe<Scalars['String']['input']>;
  share_url?: InputMaybe<Scalars['String']['input']>;
  thumbnail?: InputMaybe<Scalars['String']['input']>;
  transcode_status?: InputMaybe<Scalars['String']['input']>;
  transcribe_status?: InputMaybe<Scalars['String']['input']>;
  transcription?: InputMaybe<Scalars['String']['input']>;
  transcription_data?: InputMaybe<Array<StudentAdksFieldsValueVideoAskResponseContactAnswersTranscriptionDataObjectEqualityInput>>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type StudentAdksFieldsValueVideoAskResponseContactAnswersTranscriptionData = {
  __typename?: 'StudentAdksFieldsValueVideoAskResponseContactAnswersTranscriptionData';
  confidence: Scalars['Float']['output'];
  transcript: Scalars['String']['output'];
  words?: Maybe<Array<StudentAdksFieldsValueVideoAskResponseContactAnswersTranscriptionDataWords>>;
};

export type StudentAdksFieldsValueVideoAskResponseContactAnswersTranscriptionDataCreateInput = {
  confidence: Scalars['Float']['input'];
  transcript: Scalars['String']['input'];
  words?: InputMaybe<Array<StudentAdksFieldsValueVideoAskResponseContactAnswersTranscriptionDataWordsCreateInput>>;
};

export type StudentAdksFieldsValueVideoAskResponseContactAnswersTranscriptionDataObjectEqualityInput = {
  confidence: Scalars['Float']['input'];
  transcript: Scalars['String']['input'];
  words?: InputMaybe<Array<StudentAdksFieldsValueVideoAskResponseContactAnswersTranscriptionDataWordsObjectEqualityInput>>;
};

export type StudentAdksFieldsValueVideoAskResponseContactAnswersTranscriptionDataWords = {
  __typename?: 'StudentAdksFieldsValueVideoAskResponseContactAnswersTranscriptionDataWords';
  /** Multiple data types found: Float: 90.1%, Int: 9.9% out of 40925 sampled entries */
  end_time: Scalars['JSON']['output'];
  /** Multiple data types found: Float: 89.9%, Int: 10.1% out of 40925 sampled entries */
  start_time: Scalars['JSON']['output'];
  word: Scalars['String']['output'];
};

export type StudentAdksFieldsValueVideoAskResponseContactAnswersTranscriptionDataWordsCreateInput = {
  end_time: Scalars['JSON']['input'];
  start_time: Scalars['JSON']['input'];
  word: Scalars['String']['input'];
};

export type StudentAdksFieldsValueVideoAskResponseContactAnswersTranscriptionDataWordsObjectEqualityInput = {
  end_time: Scalars['JSON']['input'];
  start_time: Scalars['JSON']['input'];
  word: Scalars['String']['input'];
};

export type StudentAdksFieldsValueVideoAskResponseContactCreateInput = {
  answers?: InputMaybe<Array<StudentAdksFieldsValueVideoAskResponseContactAnswersCreateInput>>;
  are_answers_public: Scalars['JSON']['input'];
  are_messages_public: Scalars['JSON']['input'];
  consent_given?: InputMaybe<Scalars['JSON']['input']>;
  contact_id: Scalars['String']['input'];
  created_at?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  organization_id?: InputMaybe<Scalars['String']['input']>;
  phone_number?: InputMaybe<Scalars['JSON']['input']>;
  platform: Scalars['String']['input'];
  respondent_id?: InputMaybe<Scalars['JSON']['input']>;
  share_id: Scalars['String']['input'];
  share_url: Scalars['String']['input'];
  status: Scalars['String']['input'];
  tags?: InputMaybe<Scalars['JSON']['input']>;
  thumbnail?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['String']['input']>;
  variables?: InputMaybe<StudentAdksFieldsValueVideoAskResponseContactVariablesCreateInput>;
};

export type StudentAdksFieldsValueVideoAskResponseContactObjectEqualityInput = {
  answers?: InputMaybe<Array<StudentAdksFieldsValueVideoAskResponseContactAnswersObjectEqualityInput>>;
  are_answers_public: Scalars['JSON']['input'];
  are_messages_public: Scalars['JSON']['input'];
  consent_given?: InputMaybe<Scalars['JSON']['input']>;
  contact_id: Scalars['String']['input'];
  created_at?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  organization_id?: InputMaybe<Scalars['String']['input']>;
  phone_number?: InputMaybe<Scalars['JSON']['input']>;
  platform: Scalars['String']['input'];
  respondent_id?: InputMaybe<Scalars['JSON']['input']>;
  share_id: Scalars['String']['input'];
  share_url: Scalars['String']['input'];
  status: Scalars['String']['input'];
  tags?: InputMaybe<Scalars['JSON']['input']>;
  thumbnail?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['String']['input']>;
  variables?: InputMaybe<StudentAdksFieldsValueVideoAskResponseContactVariablesObjectEqualityInput>;
};

export type StudentAdksFieldsValueVideoAskResponseContactVariables = {
  __typename?: 'StudentAdksFieldsValueVideoAskResponseContactVariables';
  program_id: Scalars['String']['output'];
};

export type StudentAdksFieldsValueVideoAskResponseContactVariablesCreateInput = {
  program_id: Scalars['String']['input'];
};

export type StudentAdksFieldsValueVideoAskResponseContactVariablesObjectEqualityInput = {
  program_id: Scalars['String']['input'];
};

export type StudentAdksFieldsValueVideoAskResponseCreateInput = {
  contact: StudentAdksFieldsValueVideoAskResponseContactCreateInput;
  event_id: Scalars['String']['input'];
  event_type: Scalars['String']['input'];
  form: StudentAdksFieldsValueVideoAskResponseFormCreateInput;
  interaction_id: Scalars['String']['input'];
};

export type StudentAdksFieldsValueVideoAskResponseForm = {
  __typename?: 'StudentAdksFieldsValueVideoAskResponseForm';
  are_answers_public: Scalars['Boolean']['output'];
  /** Multiple data types found: String: 23.7%, Boolean: 76.3% out of 114 sampled entries */
  are_messages_public: Scalars['JSON']['output'];
  author_id?: Maybe<Scalars['String']['output']>;
  branding?: Maybe<StudentAdksFieldsValueVideoAskResponseFormBranding>;
  created_at?: Maybe<Scalars['String']['output']>;
  folder_id?: Maybe<Scalars['String']['output']>;
  form_id: Scalars['String']['output'];
  /** Multiple data types found: String: 23.7%, Boolean: 76.3% out of 114 sampled entries */
  hide_branding: Scalars['JSON']['output'];
  idle_deadline_time_in_minutes: Scalars['Int']['output'];
  metadata?: Maybe<StudentAdksFieldsValueVideoAskResponseFormMetadata>;
  notifications: StudentAdksFieldsValueVideoAskResponseFormNotifications;
  organization_id?: Maybe<Scalars['String']['output']>;
  questions?: Maybe<Array<StudentAdksFieldsValueVideoAskResponseFormQuestions>>;
  /** Multiple data types found: String: 23.7%, Boolean: 76.3% out of 114 sampled entries */
  requires_consent: Scalars['JSON']['output'];
  requires_contact_email: Scalars['Boolean']['output'];
  requires_contact_info: Scalars['Boolean']['output'];
  requires_contact_name: Scalars['Boolean']['output'];
  requires_contact_phone_number: Scalars['Boolean']['output'];
  /** Multiple data types found: String: 0.9%, Int: 99.1% out of 114 sampled entries */
  respondents_count?: Maybe<Scalars['JSON']['output']>;
  responses_share_id: Scalars['String']['output'];
  responses_share_url: Scalars['String']['output'];
  share_id: Scalars['String']['output'];
  share_url: Scalars['String']['output'];
  /** Multiple data types found: String: 23.7%, Boolean: 76.3% out of 114 sampled entries */
  show_consent: Scalars['JSON']['output'];
  show_contact_email: Scalars['Boolean']['output'];
  show_contact_name: Scalars['Boolean']['output'];
  show_contact_phone_number: Scalars['Boolean']['output'];
  tag_share_id: Scalars['String']['output'];
  tag_share_url: Scalars['String']['output'];
  title?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['String']['output']>;
  variables?: Maybe<Array<StudentAdksFieldsValueVideoAskResponseFormVariables>>;
};

export type StudentAdksFieldsValueVideoAskResponseFormBranding = {
  __typename?: 'StudentAdksFieldsValueVideoAskResponseFormBranding';
  branding_id: Scalars['String']['output'];
  branding_url: Scalars['String']['output'];
  /** Could not determine type: the field only had null or empty values in the sample set. */
  custom_domain?: Maybe<Scalars['JSON']['output']>;
  /** Could not determine type: the field only had null or empty values in the sample set. */
  dns_validated_at?: Maybe<Scalars['JSON']['output']>;
  /** Could not determine type: the field only had null or empty values in the sample set. */
  favicon?: Maybe<Scalars['JSON']['output']>;
  /** Could not determine type: the field only had null or empty values in the sample set. */
  favicon_url?: Maybe<Scalars['JSON']['output']>;
  id: Scalars['String']['output'];
  logo: Scalars['String']['output'];
  logo_url: Scalars['String']['output'];
  name: Scalars['String']['output'];
  organization_id: Scalars['String']['output'];
};

export type StudentAdksFieldsValueVideoAskResponseFormBrandingCreateInput = {
  branding_id: Scalars['String']['input'];
  branding_url: Scalars['String']['input'];
  custom_domain?: InputMaybe<Scalars['JSON']['input']>;
  dns_validated_at?: InputMaybe<Scalars['JSON']['input']>;
  favicon?: InputMaybe<Scalars['JSON']['input']>;
  favicon_url?: InputMaybe<Scalars['JSON']['input']>;
  id: Scalars['String']['input'];
  logo: Scalars['String']['input'];
  logo_url: Scalars['String']['input'];
  name: Scalars['String']['input'];
  organization_id: Scalars['String']['input'];
};

export type StudentAdksFieldsValueVideoAskResponseFormBrandingObjectEqualityInput = {
  branding_id: Scalars['String']['input'];
  branding_url: Scalars['String']['input'];
  custom_domain?: InputMaybe<Scalars['JSON']['input']>;
  dns_validated_at?: InputMaybe<Scalars['JSON']['input']>;
  favicon?: InputMaybe<Scalars['JSON']['input']>;
  favicon_url?: InputMaybe<Scalars['JSON']['input']>;
  id: Scalars['String']['input'];
  logo: Scalars['String']['input'];
  logo_url: Scalars['String']['input'];
  name: Scalars['String']['input'];
  organization_id: Scalars['String']['input'];
};

export type StudentAdksFieldsValueVideoAskResponseFormCreateInput = {
  are_answers_public: Scalars['Boolean']['input'];
  are_messages_public: Scalars['JSON']['input'];
  author_id?: InputMaybe<Scalars['String']['input']>;
  branding?: InputMaybe<StudentAdksFieldsValueVideoAskResponseFormBrandingCreateInput>;
  created_at?: InputMaybe<Scalars['String']['input']>;
  folder_id?: InputMaybe<Scalars['String']['input']>;
  form_id: Scalars['String']['input'];
  hide_branding: Scalars['JSON']['input'];
  idle_deadline_time_in_minutes: Scalars['Int']['input'];
  metadata?: InputMaybe<StudentAdksFieldsValueVideoAskResponseFormMetadataCreateInput>;
  notifications: StudentAdksFieldsValueVideoAskResponseFormNotificationsCreateInput;
  organization_id?: InputMaybe<Scalars['String']['input']>;
  questions?: InputMaybe<Array<StudentAdksFieldsValueVideoAskResponseFormQuestionsCreateInput>>;
  requires_consent: Scalars['JSON']['input'];
  requires_contact_email: Scalars['Boolean']['input'];
  requires_contact_info: Scalars['Boolean']['input'];
  requires_contact_name: Scalars['Boolean']['input'];
  requires_contact_phone_number: Scalars['Boolean']['input'];
  respondents_count?: InputMaybe<Scalars['JSON']['input']>;
  responses_share_id: Scalars['String']['input'];
  responses_share_url: Scalars['String']['input'];
  share_id: Scalars['String']['input'];
  share_url: Scalars['String']['input'];
  show_consent: Scalars['JSON']['input'];
  show_contact_email: Scalars['Boolean']['input'];
  show_contact_name: Scalars['Boolean']['input'];
  show_contact_phone_number: Scalars['Boolean']['input'];
  tag_share_id: Scalars['String']['input'];
  tag_share_url: Scalars['String']['input'];
  title?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['String']['input']>;
  variables?: InputMaybe<Array<StudentAdksFieldsValueVideoAskResponseFormVariablesCreateInput>>;
};

export type StudentAdksFieldsValueVideoAskResponseFormMetadata = {
  __typename?: 'StudentAdksFieldsValueVideoAskResponseFormMetadata';
  background_color: Scalars['String']['output'];
  consent_label: Scalars['String']['output'];
  created_from: Scalars['String']['output'];
  default_country_code: Scalars['String']['output'];
  enhance_video_button: Scalars['Boolean']['output'];
  expired_at_timezone: Scalars['String']['output'];
  filter_profanities: Scalars['Boolean']['output'];
  font_family: Scalars['String']['output'];
  font_value: Scalars['String']['output'];
  live_recording: Scalars['Boolean']['output'];
  locale: Scalars['String']['output'];
  overlay_text_color: Scalars['String']['output'];
  pause_autoplay: Scalars['Boolean']['output'];
  primary_color: Scalars['String']['output'];
  secondary_color: Scalars['String']['output'];
  show_form_title: Scalars['Boolean']['output'];
  show_overlay_close_button: Scalars['Boolean']['output'];
  show_player_controls: Scalars['Boolean']['output'];
  show_subtitles_by_default: Scalars['Boolean']['output'];
  transcription_locale: Scalars['String']['output'];
};

export type StudentAdksFieldsValueVideoAskResponseFormMetadataCreateInput = {
  background_color: Scalars['String']['input'];
  consent_label: Scalars['String']['input'];
  created_from: Scalars['String']['input'];
  default_country_code: Scalars['String']['input'];
  enhance_video_button: Scalars['Boolean']['input'];
  expired_at_timezone: Scalars['String']['input'];
  filter_profanities: Scalars['Boolean']['input'];
  font_family: Scalars['String']['input'];
  font_value: Scalars['String']['input'];
  live_recording: Scalars['Boolean']['input'];
  locale: Scalars['String']['input'];
  overlay_text_color: Scalars['String']['input'];
  pause_autoplay: Scalars['Boolean']['input'];
  primary_color: Scalars['String']['input'];
  secondary_color: Scalars['String']['input'];
  show_form_title: Scalars['Boolean']['input'];
  show_overlay_close_button: Scalars['Boolean']['input'];
  show_player_controls: Scalars['Boolean']['input'];
  show_subtitles_by_default: Scalars['Boolean']['input'];
  transcription_locale: Scalars['String']['input'];
};

export type StudentAdksFieldsValueVideoAskResponseFormMetadataObjectEqualityInput = {
  background_color: Scalars['String']['input'];
  consent_label: Scalars['String']['input'];
  created_from: Scalars['String']['input'];
  default_country_code: Scalars['String']['input'];
  enhance_video_button: Scalars['Boolean']['input'];
  expired_at_timezone: Scalars['String']['input'];
  filter_profanities: Scalars['Boolean']['input'];
  font_family: Scalars['String']['input'];
  font_value: Scalars['String']['input'];
  live_recording: Scalars['Boolean']['input'];
  locale: Scalars['String']['input'];
  overlay_text_color: Scalars['String']['input'];
  pause_autoplay: Scalars['Boolean']['input'];
  primary_color: Scalars['String']['input'];
  secondary_color: Scalars['String']['input'];
  show_form_title: Scalars['Boolean']['input'];
  show_overlay_close_button: Scalars['Boolean']['input'];
  show_player_controls: Scalars['Boolean']['input'];
  show_subtitles_by_default: Scalars['Boolean']['input'];
  transcription_locale: Scalars['String']['input'];
};

export type StudentAdksFieldsValueVideoAskResponseFormNotifications = {
  __typename?: 'StudentAdksFieldsValueVideoAskResponseFormNotifications';
  send_contact_message_emails: Scalars['Boolean']['output'];
};

export type StudentAdksFieldsValueVideoAskResponseFormNotificationsCreateInput = {
  send_contact_message_emails: Scalars['Boolean']['input'];
};

export type StudentAdksFieldsValueVideoAskResponseFormNotificationsObjectEqualityInput = {
  send_contact_message_emails: Scalars['Boolean']['input'];
};

export type StudentAdksFieldsValueVideoAskResponseFormObjectEqualityInput = {
  are_answers_public: Scalars['Boolean']['input'];
  are_messages_public: Scalars['JSON']['input'];
  author_id?: InputMaybe<Scalars['String']['input']>;
  branding?: InputMaybe<StudentAdksFieldsValueVideoAskResponseFormBrandingObjectEqualityInput>;
  created_at?: InputMaybe<Scalars['String']['input']>;
  folder_id?: InputMaybe<Scalars['String']['input']>;
  form_id: Scalars['String']['input'];
  hide_branding: Scalars['JSON']['input'];
  idle_deadline_time_in_minutes: Scalars['Int']['input'];
  metadata?: InputMaybe<StudentAdksFieldsValueVideoAskResponseFormMetadataObjectEqualityInput>;
  notifications: StudentAdksFieldsValueVideoAskResponseFormNotificationsObjectEqualityInput;
  organization_id?: InputMaybe<Scalars['String']['input']>;
  questions?: InputMaybe<Array<StudentAdksFieldsValueVideoAskResponseFormQuestionsObjectEqualityInput>>;
  requires_consent: Scalars['JSON']['input'];
  requires_contact_email: Scalars['Boolean']['input'];
  requires_contact_info: Scalars['Boolean']['input'];
  requires_contact_name: Scalars['Boolean']['input'];
  requires_contact_phone_number: Scalars['Boolean']['input'];
  respondents_count?: InputMaybe<Scalars['JSON']['input']>;
  responses_share_id: Scalars['String']['input'];
  responses_share_url: Scalars['String']['input'];
  share_id: Scalars['String']['input'];
  share_url: Scalars['String']['input'];
  show_consent: Scalars['JSON']['input'];
  show_contact_email: Scalars['Boolean']['input'];
  show_contact_name: Scalars['Boolean']['input'];
  show_contact_phone_number: Scalars['Boolean']['input'];
  tag_share_id: Scalars['String']['input'];
  tag_share_url: Scalars['String']['input'];
  title?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['String']['input']>;
  variables?: InputMaybe<Array<StudentAdksFieldsValueVideoAskResponseFormVariablesObjectEqualityInput>>;
};

export type StudentAdksFieldsValueVideoAskResponseFormQuestions = {
  __typename?: 'StudentAdksFieldsValueVideoAskResponseFormQuestions';
  allow_multiple_selection?: Maybe<Scalars['Boolean']['output']>;
  allowed_answer_media_types?: Maybe<Array<Scalars['String']['output']>>;
  answers_count?: Maybe<Scalars['Int']['output']>;
  collect_contact_information?: Maybe<Scalars['Boolean']['output']>;
  created_at?: Maybe<Scalars['String']['output']>;
  form_id?: Maybe<Scalars['String']['output']>;
  gif?: Maybe<Scalars['String']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  logic_actions?: Maybe<Array<StudentAdksFieldsValueVideoAskResponseFormQuestionsLogicActions>>;
  media_duration?: Maybe<Scalars['Int']['output']>;
  media_id?: Maybe<Scalars['String']['output']>;
  media_time_limit?: Maybe<Scalars['Int']['output']>;
  media_type?: Maybe<Scalars['String']['output']>;
  media_url?: Maybe<Scalars['String']['output']>;
  metadata?: Maybe<StudentAdksFieldsValueVideoAskResponseFormQuestionsMetadata>;
  poll_options?: Maybe<Array<StudentAdksFieldsValueVideoAskResponseFormQuestionsPollOptions>>;
  question_id: Scalars['String']['output'];
  share_id?: Maybe<Scalars['String']['output']>;
  share_url?: Maybe<Scalars['String']['output']>;
  thumbnail?: Maybe<Scalars['String']['output']>;
  transcode_status?: Maybe<Scalars['String']['output']>;
  transcribe_status?: Maybe<Scalars['String']['output']>;
  transcription?: Maybe<Scalars['String']['output']>;
  transcription_data?: Maybe<Array<StudentAdksFieldsValueVideoAskResponseFormQuestionsTranscriptionData>>;
  type?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['String']['output']>;
};

export type StudentAdksFieldsValueVideoAskResponseFormQuestionsCreateInput = {
  allow_multiple_selection?: InputMaybe<Scalars['Boolean']['input']>;
  allowed_answer_media_types?: InputMaybe<StudentAdksFieldsValueVideoAskResponseFormQuestionsCreateallowed_Answer_Media_TypesInput>;
  answers_count?: InputMaybe<Scalars['Int']['input']>;
  collect_contact_information?: InputMaybe<Scalars['Boolean']['input']>;
  created_at?: InputMaybe<Scalars['String']['input']>;
  form_id?: InputMaybe<Scalars['String']['input']>;
  gif?: InputMaybe<Scalars['String']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  logic_actions?: InputMaybe<Array<StudentAdksFieldsValueVideoAskResponseFormQuestionsLogicActionsCreateInput>>;
  media_duration?: InputMaybe<Scalars['Int']['input']>;
  media_id?: InputMaybe<Scalars['String']['input']>;
  media_time_limit?: InputMaybe<Scalars['Int']['input']>;
  media_type?: InputMaybe<Scalars['String']['input']>;
  media_url?: InputMaybe<Scalars['String']['input']>;
  metadata?: InputMaybe<StudentAdksFieldsValueVideoAskResponseFormQuestionsMetadataCreateInput>;
  poll_options?: InputMaybe<Array<StudentAdksFieldsValueVideoAskResponseFormQuestionsPollOptionsCreateInput>>;
  question_id: Scalars['String']['input'];
  share_id?: InputMaybe<Scalars['String']['input']>;
  share_url?: InputMaybe<Scalars['String']['input']>;
  thumbnail?: InputMaybe<Scalars['String']['input']>;
  transcode_status?: InputMaybe<Scalars['String']['input']>;
  transcribe_status?: InputMaybe<Scalars['String']['input']>;
  transcription?: InputMaybe<Scalars['String']['input']>;
  transcription_data?: InputMaybe<Array<StudentAdksFieldsValueVideoAskResponseFormQuestionsTranscriptionDataCreateInput>>;
  type?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['String']['input']>;
};

export type StudentAdksFieldsValueVideoAskResponseFormQuestionsCreateallowed_Answer_Media_TypesInput = {
  set: Array<Scalars['String']['input']>;
};

export type StudentAdksFieldsValueVideoAskResponseFormQuestionsLogicActions = {
  __typename?: 'StudentAdksFieldsValueVideoAskResponseFormQuestionsLogicActions';
  action: Scalars['String']['output'];
  condition: StudentAdksFieldsValueVideoAskResponseFormQuestionsLogicActionsCondition;
  details: StudentAdksFieldsValueVideoAskResponseFormQuestionsLogicActionsDetails;
};

export type StudentAdksFieldsValueVideoAskResponseFormQuestionsLogicActionsCondition = {
  __typename?: 'StudentAdksFieldsValueVideoAskResponseFormQuestionsLogicActionsCondition';
  op: Scalars['String']['output'];
  vars?: Maybe<Array<StudentAdksFieldsValueVideoAskResponseFormQuestionsLogicActionsConditionVars>>;
};

export type StudentAdksFieldsValueVideoAskResponseFormQuestionsLogicActionsConditionCreateInput = {
  op: Scalars['String']['input'];
  vars?: InputMaybe<Array<StudentAdksFieldsValueVideoAskResponseFormQuestionsLogicActionsConditionVarsCreateInput>>;
};

export type StudentAdksFieldsValueVideoAskResponseFormQuestionsLogicActionsConditionObjectEqualityInput = {
  op: Scalars['String']['input'];
  vars?: InputMaybe<Array<StudentAdksFieldsValueVideoAskResponseFormQuestionsLogicActionsConditionVarsObjectEqualityInput>>;
};

export type StudentAdksFieldsValueVideoAskResponseFormQuestionsLogicActionsConditionVars = {
  __typename?: 'StudentAdksFieldsValueVideoAskResponseFormQuestionsLogicActionsConditionVars';
  type: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type StudentAdksFieldsValueVideoAskResponseFormQuestionsLogicActionsConditionVarsCreateInput = {
  type: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export type StudentAdksFieldsValueVideoAskResponseFormQuestionsLogicActionsConditionVarsObjectEqualityInput = {
  type: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export type StudentAdksFieldsValueVideoAskResponseFormQuestionsLogicActionsCreateInput = {
  action: Scalars['String']['input'];
  condition: StudentAdksFieldsValueVideoAskResponseFormQuestionsLogicActionsConditionCreateInput;
  details: StudentAdksFieldsValueVideoAskResponseFormQuestionsLogicActionsDetailsCreateInput;
};

export type StudentAdksFieldsValueVideoAskResponseFormQuestionsLogicActionsDetails = {
  __typename?: 'StudentAdksFieldsValueVideoAskResponseFormQuestionsLogicActionsDetails';
  to: StudentAdksFieldsValueVideoAskResponseFormQuestionsLogicActionsDetailsTo;
};

export type StudentAdksFieldsValueVideoAskResponseFormQuestionsLogicActionsDetailsCreateInput = {
  to: StudentAdksFieldsValueVideoAskResponseFormQuestionsLogicActionsDetailsToCreateInput;
};

export type StudentAdksFieldsValueVideoAskResponseFormQuestionsLogicActionsDetailsObjectEqualityInput = {
  to: StudentAdksFieldsValueVideoAskResponseFormQuestionsLogicActionsDetailsToObjectEqualityInput;
};

export type StudentAdksFieldsValueVideoAskResponseFormQuestionsLogicActionsDetailsTo = {
  __typename?: 'StudentAdksFieldsValueVideoAskResponseFormQuestionsLogicActionsDetailsTo';
  type: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type StudentAdksFieldsValueVideoAskResponseFormQuestionsLogicActionsDetailsToCreateInput = {
  type: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export type StudentAdksFieldsValueVideoAskResponseFormQuestionsLogicActionsDetailsToObjectEqualityInput = {
  type: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export type StudentAdksFieldsValueVideoAskResponseFormQuestionsLogicActionsObjectEqualityInput = {
  action: Scalars['String']['input'];
  condition: StudentAdksFieldsValueVideoAskResponseFormQuestionsLogicActionsConditionObjectEqualityInput;
  details: StudentAdksFieldsValueVideoAskResponseFormQuestionsLogicActionsDetailsObjectEqualityInput;
};

export type StudentAdksFieldsValueVideoAskResponseFormQuestionsMetadata = {
  __typename?: 'StudentAdksFieldsValueVideoAskResponseFormQuestionsMetadata';
  answer_reveal_delay_time?: Maybe<Scalars['Int']['output']>;
  custom_type?: Maybe<Scalars['String']['output']>;
  darken_text_background?: Maybe<Scalars['Boolean']['output']>;
  disable_data_collection?: Maybe<Scalars['Boolean']['output']>;
  fit_video?: Maybe<Scalars['Boolean']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  overlay_text_size?: Maybe<Scalars['Int']['output']>;
  text?: Maybe<Scalars['String']['output']>;
  text_fade_delay_time?: Maybe<Scalars['Int']['output']>;
  text_reveal_delay_time?: Maybe<Scalars['Int']['output']>;
};

export type StudentAdksFieldsValueVideoAskResponseFormQuestionsMetadataCreateInput = {
  answer_reveal_delay_time?: InputMaybe<Scalars['Int']['input']>;
  custom_type?: InputMaybe<Scalars['String']['input']>;
  darken_text_background?: InputMaybe<Scalars['Boolean']['input']>;
  disable_data_collection?: InputMaybe<Scalars['Boolean']['input']>;
  fit_video?: InputMaybe<Scalars['Boolean']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  overlay_text_size?: InputMaybe<Scalars['Int']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
  text_fade_delay_time?: InputMaybe<Scalars['Int']['input']>;
  text_reveal_delay_time?: InputMaybe<Scalars['Int']['input']>;
};

export type StudentAdksFieldsValueVideoAskResponseFormQuestionsMetadataObjectEqualityInput = {
  answer_reveal_delay_time?: InputMaybe<Scalars['Int']['input']>;
  custom_type?: InputMaybe<Scalars['String']['input']>;
  darken_text_background?: InputMaybe<Scalars['Boolean']['input']>;
  disable_data_collection?: InputMaybe<Scalars['Boolean']['input']>;
  fit_video?: InputMaybe<Scalars['Boolean']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  overlay_text_size?: InputMaybe<Scalars['Int']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
  text_fade_delay_time?: InputMaybe<Scalars['Int']['input']>;
  text_reveal_delay_time?: InputMaybe<Scalars['Int']['input']>;
};

export type StudentAdksFieldsValueVideoAskResponseFormQuestionsObjectEqualityInput = {
  allow_multiple_selection?: InputMaybe<Scalars['Boolean']['input']>;
  allowed_answer_media_types?: InputMaybe<Array<Scalars['String']['input']>>;
  answers_count?: InputMaybe<Scalars['Int']['input']>;
  collect_contact_information?: InputMaybe<Scalars['Boolean']['input']>;
  created_at?: InputMaybe<Scalars['String']['input']>;
  form_id?: InputMaybe<Scalars['String']['input']>;
  gif?: InputMaybe<Scalars['String']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  logic_actions?: InputMaybe<Array<StudentAdksFieldsValueVideoAskResponseFormQuestionsLogicActionsObjectEqualityInput>>;
  media_duration?: InputMaybe<Scalars['Int']['input']>;
  media_id?: InputMaybe<Scalars['String']['input']>;
  media_time_limit?: InputMaybe<Scalars['Int']['input']>;
  media_type?: InputMaybe<Scalars['String']['input']>;
  media_url?: InputMaybe<Scalars['String']['input']>;
  metadata?: InputMaybe<StudentAdksFieldsValueVideoAskResponseFormQuestionsMetadataObjectEqualityInput>;
  poll_options?: InputMaybe<Array<StudentAdksFieldsValueVideoAskResponseFormQuestionsPollOptionsObjectEqualityInput>>;
  question_id: Scalars['String']['input'];
  share_id?: InputMaybe<Scalars['String']['input']>;
  share_url?: InputMaybe<Scalars['String']['input']>;
  thumbnail?: InputMaybe<Scalars['String']['input']>;
  transcode_status?: InputMaybe<Scalars['String']['input']>;
  transcribe_status?: InputMaybe<Scalars['String']['input']>;
  transcription?: InputMaybe<Scalars['String']['input']>;
  transcription_data?: InputMaybe<Array<StudentAdksFieldsValueVideoAskResponseFormQuestionsTranscriptionDataObjectEqualityInput>>;
  type?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['String']['input']>;
};

export type StudentAdksFieldsValueVideoAskResponseFormQuestionsPollOptions = {
  __typename?: 'StudentAdksFieldsValueVideoAskResponseFormQuestionsPollOptions';
  content: Scalars['String']['output'];
  id: Scalars['String']['output'];
  option_id: Scalars['String']['output'];
  ref: Scalars['String']['output'];
  total_count: Scalars['Int']['output'];
};

export type StudentAdksFieldsValueVideoAskResponseFormQuestionsPollOptionsCreateInput = {
  content: Scalars['String']['input'];
  id: Scalars['String']['input'];
  option_id: Scalars['String']['input'];
  ref: Scalars['String']['input'];
  total_count: Scalars['Int']['input'];
};

export type StudentAdksFieldsValueVideoAskResponseFormQuestionsPollOptionsObjectEqualityInput = {
  content: Scalars['String']['input'];
  id: Scalars['String']['input'];
  option_id: Scalars['String']['input'];
  ref: Scalars['String']['input'];
  total_count: Scalars['Int']['input'];
};

export type StudentAdksFieldsValueVideoAskResponseFormQuestionsTranscriptionData = {
  __typename?: 'StudentAdksFieldsValueVideoAskResponseFormQuestionsTranscriptionData';
  confidence: Scalars['Float']['output'];
  transcript: Scalars['String']['output'];
  words?: Maybe<Array<StudentAdksFieldsValueVideoAskResponseFormQuestionsTranscriptionDataWords>>;
};

export type StudentAdksFieldsValueVideoAskResponseFormQuestionsTranscriptionDataCreateInput = {
  confidence: Scalars['Float']['input'];
  transcript: Scalars['String']['input'];
  words?: InputMaybe<Array<StudentAdksFieldsValueVideoAskResponseFormQuestionsTranscriptionDataWordsCreateInput>>;
};

export type StudentAdksFieldsValueVideoAskResponseFormQuestionsTranscriptionDataObjectEqualityInput = {
  confidence: Scalars['Float']['input'];
  transcript: Scalars['String']['input'];
  words?: InputMaybe<Array<StudentAdksFieldsValueVideoAskResponseFormQuestionsTranscriptionDataWordsObjectEqualityInput>>;
};

export type StudentAdksFieldsValueVideoAskResponseFormQuestionsTranscriptionDataWords = {
  __typename?: 'StudentAdksFieldsValueVideoAskResponseFormQuestionsTranscriptionDataWords';
  /** Multiple data types found: Float: 89.7%, Int: 10.3% out of 40787 sampled entries */
  end_time: Scalars['JSON']['output'];
  /** Multiple data types found: Float: 90.3%, Int: 9.7% out of 40787 sampled entries */
  start_time: Scalars['JSON']['output'];
  word: Scalars['String']['output'];
};

export type StudentAdksFieldsValueVideoAskResponseFormQuestionsTranscriptionDataWordsCreateInput = {
  end_time: Scalars['JSON']['input'];
  start_time: Scalars['JSON']['input'];
  word: Scalars['String']['input'];
};

export type StudentAdksFieldsValueVideoAskResponseFormQuestionsTranscriptionDataWordsObjectEqualityInput = {
  end_time: Scalars['JSON']['input'];
  start_time: Scalars['JSON']['input'];
  word: Scalars['String']['input'];
};

export type StudentAdksFieldsValueVideoAskResponseFormVariables = {
  __typename?: 'StudentAdksFieldsValueVideoAskResponseFormVariables';
  key: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type StudentAdksFieldsValueVideoAskResponseFormVariablesCreateInput = {
  key: Scalars['String']['input'];
  type: Scalars['String']['input'];
};

export type StudentAdksFieldsValueVideoAskResponseFormVariablesObjectEqualityInput = {
  key: Scalars['String']['input'];
  type: Scalars['String']['input'];
};

export type StudentAdksFieldsValueVideoAskResponseObjectEqualityInput = {
  contact: StudentAdksFieldsValueVideoAskResponseContactObjectEqualityInput;
  event_id: Scalars['String']['input'];
  event_type: Scalars['String']['input'];
  form: StudentAdksFieldsValueVideoAskResponseFormObjectEqualityInput;
  interaction_id: Scalars['String']['input'];
};

export type StudentAdksFieldsValueVideoLinks = {
  __typename?: 'StudentAdksFieldsValueVideoLinks';
  completed?: Maybe<Scalars['Boolean']['output']>;
  is_processing?: Maybe<Scalars['Boolean']['output']>;
  is_videoask?: Maybe<Scalars['Boolean']['output']>;
  link: Scalars['String']['output'];
  name: Scalars['String']['output'];
  required?: Maybe<Scalars['Boolean']['output']>;
  unlocked?: Maybe<Scalars['Boolean']['output']>;
  videoAskResponse?: Maybe<StudentAdksFieldsValueVideoLinksVideoAskResponse>;
  videoask_question_url?: Maybe<Scalars['String']['output']>;
};

export type StudentAdksFieldsValueVideoLinksCreateInput = {
  completed?: InputMaybe<Scalars['Boolean']['input']>;
  is_processing?: InputMaybe<Scalars['Boolean']['input']>;
  is_videoask?: InputMaybe<Scalars['Boolean']['input']>;
  link: Scalars['String']['input'];
  name: Scalars['String']['input'];
  required?: InputMaybe<Scalars['Boolean']['input']>;
  unlocked?: InputMaybe<Scalars['Boolean']['input']>;
  videoAskResponse?: InputMaybe<StudentAdksFieldsValueVideoLinksVideoAskResponseCreateInput>;
  videoask_question_url?: InputMaybe<Scalars['String']['input']>;
};

export type StudentAdksFieldsValueVideoLinksObjectEqualityInput = {
  completed?: InputMaybe<Scalars['Boolean']['input']>;
  is_processing?: InputMaybe<Scalars['Boolean']['input']>;
  is_videoask?: InputMaybe<Scalars['Boolean']['input']>;
  link: Scalars['String']['input'];
  name: Scalars['String']['input'];
  required?: InputMaybe<Scalars['Boolean']['input']>;
  unlocked?: InputMaybe<Scalars['Boolean']['input']>;
  videoAskResponse?: InputMaybe<StudentAdksFieldsValueVideoLinksVideoAskResponseObjectEqualityInput>;
  videoask_question_url?: InputMaybe<Scalars['String']['input']>;
};

export type StudentAdksFieldsValueVideoLinksVideoAskResponse = {
  __typename?: 'StudentAdksFieldsValueVideoLinksVideoAskResponse';
  contact: StudentAdksFieldsValueVideoLinksVideoAskResponseContact;
  event_id: Scalars['String']['output'];
  event_type: Scalars['String']['output'];
  form: StudentAdksFieldsValueVideoLinksVideoAskResponseForm;
  interaction_id: Scalars['String']['output'];
};

export type StudentAdksFieldsValueVideoLinksVideoAskResponseContact = {
  __typename?: 'StudentAdksFieldsValueVideoLinksVideoAskResponseContact';
  answers?: Maybe<Array<StudentAdksFieldsValueVideoLinksVideoAskResponseContactAnswers>>;
  are_answers_public: Scalars['Boolean']['output'];
  are_messages_public: Scalars['Boolean']['output'];
  contact_id: Scalars['String']['output'];
  email: Scalars['String']['output'];
  platform: Scalars['String']['output'];
  share_id: Scalars['String']['output'];
  share_url: Scalars['String']['output'];
  status: Scalars['String']['output'];
};

export type StudentAdksFieldsValueVideoLinksVideoAskResponseContactAnswers = {
  __typename?: 'StudentAdksFieldsValueVideoLinksVideoAskResponseContactAnswers';
  answer_id: Scalars['String']['output'];
  media_id?: Maybe<Scalars['String']['output']>;
  media_url?: Maybe<Scalars['String']['output']>;
  poll_options?: Maybe<Array<StudentAdksFieldsValueVideoLinksVideoAskResponseContactAnswersPollOptions>>;
  question_id: Scalars['String']['output'];
};

export type StudentAdksFieldsValueVideoLinksVideoAskResponseContactAnswersCreateInput = {
  answer_id: Scalars['String']['input'];
  media_id?: InputMaybe<Scalars['String']['input']>;
  media_url?: InputMaybe<Scalars['String']['input']>;
  poll_options?: InputMaybe<Array<StudentAdksFieldsValueVideoLinksVideoAskResponseContactAnswersPollOptionsCreateInput>>;
  question_id: Scalars['String']['input'];
};

export type StudentAdksFieldsValueVideoLinksVideoAskResponseContactAnswersObjectEqualityInput = {
  answer_id: Scalars['String']['input'];
  media_id?: InputMaybe<Scalars['String']['input']>;
  media_url?: InputMaybe<Scalars['String']['input']>;
  poll_options?: InputMaybe<Array<StudentAdksFieldsValueVideoLinksVideoAskResponseContactAnswersPollOptionsObjectEqualityInput>>;
  question_id: Scalars['String']['input'];
};

export type StudentAdksFieldsValueVideoLinksVideoAskResponseContactAnswersPollOptions = {
  __typename?: 'StudentAdksFieldsValueVideoLinksVideoAskResponseContactAnswersPollOptions';
  content: Scalars['String']['output'];
  id: Scalars['String']['output'];
  ref: Scalars['String']['output'];
};

export type StudentAdksFieldsValueVideoLinksVideoAskResponseContactAnswersPollOptionsCreateInput = {
  content: Scalars['String']['input'];
  id: Scalars['String']['input'];
  ref: Scalars['String']['input'];
};

export type StudentAdksFieldsValueVideoLinksVideoAskResponseContactAnswersPollOptionsObjectEqualityInput = {
  content: Scalars['String']['input'];
  id: Scalars['String']['input'];
  ref: Scalars['String']['input'];
};

export type StudentAdksFieldsValueVideoLinksVideoAskResponseContactCreateInput = {
  answers?: InputMaybe<Array<StudentAdksFieldsValueVideoLinksVideoAskResponseContactAnswersCreateInput>>;
  are_answers_public: Scalars['Boolean']['input'];
  are_messages_public: Scalars['Boolean']['input'];
  contact_id: Scalars['String']['input'];
  email: Scalars['String']['input'];
  platform: Scalars['String']['input'];
  share_id: Scalars['String']['input'];
  share_url: Scalars['String']['input'];
  status: Scalars['String']['input'];
};

export type StudentAdksFieldsValueVideoLinksVideoAskResponseContactObjectEqualityInput = {
  answers?: InputMaybe<Array<StudentAdksFieldsValueVideoLinksVideoAskResponseContactAnswersObjectEqualityInput>>;
  are_answers_public: Scalars['Boolean']['input'];
  are_messages_public: Scalars['Boolean']['input'];
  contact_id: Scalars['String']['input'];
  email: Scalars['String']['input'];
  platform: Scalars['String']['input'];
  share_id: Scalars['String']['input'];
  share_url: Scalars['String']['input'];
  status: Scalars['String']['input'];
};

export type StudentAdksFieldsValueVideoLinksVideoAskResponseCreateInput = {
  contact: StudentAdksFieldsValueVideoLinksVideoAskResponseContactCreateInput;
  event_id: Scalars['String']['input'];
  event_type: Scalars['String']['input'];
  form: StudentAdksFieldsValueVideoLinksVideoAskResponseFormCreateInput;
  interaction_id: Scalars['String']['input'];
};

export type StudentAdksFieldsValueVideoLinksVideoAskResponseForm = {
  __typename?: 'StudentAdksFieldsValueVideoLinksVideoAskResponseForm';
  are_answers_public: Scalars['Boolean']['output'];
  are_messages_public: Scalars['Boolean']['output'];
  form_id: Scalars['String']['output'];
  hide_branding: Scalars['Boolean']['output'];
  idle_deadline_time_in_minutes: Scalars['Int']['output'];
  notifications: StudentAdksFieldsValueVideoLinksVideoAskResponseFormNotifications;
  questions?: Maybe<Array<StudentAdksFieldsValueVideoLinksVideoAskResponseFormQuestions>>;
  requires_consent: Scalars['Boolean']['output'];
  requires_contact_email: Scalars['Boolean']['output'];
  requires_contact_info: Scalars['Boolean']['output'];
  requires_contact_name: Scalars['Boolean']['output'];
  requires_contact_phone_number: Scalars['Boolean']['output'];
  respondents_count: Scalars['Int']['output'];
  responses_share_id: Scalars['String']['output'];
  responses_share_url: Scalars['String']['output'];
  share_id: Scalars['String']['output'];
  share_url: Scalars['String']['output'];
  show_consent: Scalars['Boolean']['output'];
  show_contact_email: Scalars['Boolean']['output'];
  show_contact_name: Scalars['Boolean']['output'];
  show_contact_phone_number: Scalars['Boolean']['output'];
  tag_share_id: Scalars['String']['output'];
  tag_share_url: Scalars['String']['output'];
};

export type StudentAdksFieldsValueVideoLinksVideoAskResponseFormCreateInput = {
  are_answers_public: Scalars['Boolean']['input'];
  are_messages_public: Scalars['Boolean']['input'];
  form_id: Scalars['String']['input'];
  hide_branding: Scalars['Boolean']['input'];
  idle_deadline_time_in_minutes: Scalars['Int']['input'];
  notifications: StudentAdksFieldsValueVideoLinksVideoAskResponseFormNotificationsCreateInput;
  questions?: InputMaybe<Array<StudentAdksFieldsValueVideoLinksVideoAskResponseFormQuestionsCreateInput>>;
  requires_consent: Scalars['Boolean']['input'];
  requires_contact_email: Scalars['Boolean']['input'];
  requires_contact_info: Scalars['Boolean']['input'];
  requires_contact_name: Scalars['Boolean']['input'];
  requires_contact_phone_number: Scalars['Boolean']['input'];
  respondents_count: Scalars['Int']['input'];
  responses_share_id: Scalars['String']['input'];
  responses_share_url: Scalars['String']['input'];
  share_id: Scalars['String']['input'];
  share_url: Scalars['String']['input'];
  show_consent: Scalars['Boolean']['input'];
  show_contact_email: Scalars['Boolean']['input'];
  show_contact_name: Scalars['Boolean']['input'];
  show_contact_phone_number: Scalars['Boolean']['input'];
  tag_share_id: Scalars['String']['input'];
  tag_share_url: Scalars['String']['input'];
};

export type StudentAdksFieldsValueVideoLinksVideoAskResponseFormNotifications = {
  __typename?: 'StudentAdksFieldsValueVideoLinksVideoAskResponseFormNotifications';
  send_contact_message_emails: Scalars['Boolean']['output'];
};

export type StudentAdksFieldsValueVideoLinksVideoAskResponseFormNotificationsCreateInput = {
  send_contact_message_emails: Scalars['Boolean']['input'];
};

export type StudentAdksFieldsValueVideoLinksVideoAskResponseFormNotificationsObjectEqualityInput = {
  send_contact_message_emails: Scalars['Boolean']['input'];
};

export type StudentAdksFieldsValueVideoLinksVideoAskResponseFormObjectEqualityInput = {
  are_answers_public: Scalars['Boolean']['input'];
  are_messages_public: Scalars['Boolean']['input'];
  form_id: Scalars['String']['input'];
  hide_branding: Scalars['Boolean']['input'];
  idle_deadline_time_in_minutes: Scalars['Int']['input'];
  notifications: StudentAdksFieldsValueVideoLinksVideoAskResponseFormNotificationsObjectEqualityInput;
  questions?: InputMaybe<Array<StudentAdksFieldsValueVideoLinksVideoAskResponseFormQuestionsObjectEqualityInput>>;
  requires_consent: Scalars['Boolean']['input'];
  requires_contact_email: Scalars['Boolean']['input'];
  requires_contact_info: Scalars['Boolean']['input'];
  requires_contact_name: Scalars['Boolean']['input'];
  requires_contact_phone_number: Scalars['Boolean']['input'];
  respondents_count: Scalars['Int']['input'];
  responses_share_id: Scalars['String']['input'];
  responses_share_url: Scalars['String']['input'];
  share_id: Scalars['String']['input'];
  share_url: Scalars['String']['input'];
  show_consent: Scalars['Boolean']['input'];
  show_contact_email: Scalars['Boolean']['input'];
  show_contact_name: Scalars['Boolean']['input'];
  show_contact_phone_number: Scalars['Boolean']['input'];
  tag_share_id: Scalars['String']['input'];
  tag_share_url: Scalars['String']['input'];
};

export type StudentAdksFieldsValueVideoLinksVideoAskResponseFormQuestions = {
  __typename?: 'StudentAdksFieldsValueVideoLinksVideoAskResponseFormQuestions';
  question_id: Scalars['String']['output'];
};

export type StudentAdksFieldsValueVideoLinksVideoAskResponseFormQuestionsCreateInput = {
  question_id: Scalars['String']['input'];
};

export type StudentAdksFieldsValueVideoLinksVideoAskResponseFormQuestionsObjectEqualityInput = {
  question_id: Scalars['String']['input'];
};

export type StudentAdksFieldsValueVideoLinksVideoAskResponseObjectEqualityInput = {
  contact: StudentAdksFieldsValueVideoLinksVideoAskResponseContactObjectEqualityInput;
  event_id: Scalars['String']['input'];
  event_type: Scalars['String']['input'];
  form: StudentAdksFieldsValueVideoLinksVideoAskResponseFormObjectEqualityInput;
  interaction_id: Scalars['String']['input'];
};

export type StudentAdksInstruction = {
  __typename?: 'StudentAdksInstruction';
  boilerInstructions?: Maybe<Array<Scalars['String']['output']>>;
  discordUrl?: Maybe<Scalars['String']['output']>;
  goal?: Maybe<Scalars['String']['output']>;
  youtubeUrl?: Maybe<Scalars['String']['output']>;
};

export type StudentAdksInstructionCreateInput = {
  boilerInstructions?: InputMaybe<StudentAdksInstructionCreateboilerInstructionsInput>;
  discordUrl?: InputMaybe<Scalars['String']['input']>;
  goal?: InputMaybe<Scalars['String']['input']>;
  youtubeUrl?: InputMaybe<Scalars['String']['input']>;
};

export type StudentAdksInstructionCreateboilerInstructionsInput = {
  set: Array<Scalars['String']['input']>;
};

export type StudentAdksInstructionObjectEqualityInput = {
  boilerInstructions?: InputMaybe<Array<Scalars['String']['input']>>;
  discordUrl?: InputMaybe<Scalars['String']['input']>;
  goal?: InputMaybe<Scalars['String']['input']>;
  youtubeUrl?: InputMaybe<Scalars['String']['input']>;
};

export type StudentAdksObjectEqualityInput = {
  acknowledge?: InputMaybe<Scalars['Boolean']['input']>;
  acknowledgeScope?: InputMaybe<Scalars['Boolean']['input']>;
  activityEndedOn?: InputMaybe<Scalars['DateTime']['input']>;
  activityFieldSchema?: InputMaybe<Scalars['JSON']['input']>;
  activityImage?: InputMaybe<Scalars['String']['input']>;
  activityModifiedOn?: InputMaybe<Scalars['DateTime']['input']>;
  activitySettings?: InputMaybe<StudentAdksActivitySettingsObjectEqualityInput>;
  activityStartedOn?: InputMaybe<Scalars['JSON']['input']>;
  agentBrief?: InputMaybe<Scalars['JSON']['input']>;
  agreementInstructions?: InputMaybe<Scalars['String']['input']>;
  agreementLink?: InputMaybe<Scalars['String']['input']>;
  airtableRecordId?: InputMaybe<Scalars['String']['input']>;
  bookmarkedQuestions?: InputMaybe<Array<Scalars['String']['input']>>;
  buildScope?: InputMaybe<StudentAdksBuildScopeObjectEqualityInput>;
  builderType?: InputMaybe<Scalars['String']['input']>;
  calendarPreference?: InputMaybe<Scalars['Boolean']['input']>;
  category?: InputMaybe<Scalars['String']['input']>;
  clockAdjustedHours?: InputMaybe<Scalars['JSON']['input']>;
  clockIn?: InputMaybe<Scalars['String']['input']>;
  clockOut?: InputMaybe<Scalars['String']['input']>;
  completed?: InputMaybe<Scalars['JSON']['input']>;
  connection?: InputMaybe<Scalars['String']['input']>;
  conversationProtocol?: InputMaybe<Scalars['JSON']['input']>;
  credentials?: InputMaybe<Array<Scalars['String']['input']>>;
  dailyCoworkingCount?: InputMaybe<Scalars['Int']['input']>;
  dailyCoworkingLastConnected?: InputMaybe<Scalars['String']['input']>;
  dailyCoworkingLastTimestamp?: InputMaybe<Scalars['JSON']['input']>;
  dailyCoworkingTotalDuration?: InputMaybe<Scalars['String']['input']>;
  dailyCoworkingTotalTimestamp?: InputMaybe<Scalars['JSON']['input']>;
  defaultActivity?: InputMaybe<StudentAdksDefaultActivityObjectEqualityInput>;
  deliverable?: InputMaybe<Scalars['String']['input']>;
  deliverableActivity?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  details?: InputMaybe<StudentAdksDetailsObjectEqualityInput>;
  discordEmployerChannel?: InputMaybe<Scalars['String']['input']>;
  discordEntityType?: InputMaybe<Scalars['String']['input']>;
  discordIntegraionSkipped?: InputMaybe<Scalars['Boolean']['input']>;
  dislikedQuestions?: InputMaybe<Array<Scalars['String']['input']>>;
  employerWebsite?: InputMaybe<Scalars['String']['input']>;
  endEarlyActivity?: InputMaybe<Scalars['String']['input']>;
  exitInterviewComplete?: InputMaybe<Scalars['String']['input']>;
  exitInterviewIncomplete?: InputMaybe<Scalars['JSON']['input']>;
  fields?: InputMaybe<Array<StudentAdksFieldsObjectEqualityInput>>;
  finalPresentationAbsence?: InputMaybe<Scalars['String']['input']>;
  finalPresentationConfirmation?: InputMaybe<Scalars['String']['input']>;
  finalPresentationDate?: InputMaybe<Scalars['String']['input']>;
  flaggedComments?: InputMaybe<Scalars['JSON']['input']>;
  flaggedQuestions?: InputMaybe<Scalars['JSON']['input']>;
  groupActivity?: InputMaybe<Scalars['String']['input']>;
  hasReceivedInternshipEndConfirmation?: InputMaybe<Scalars['Boolean']['input']>;
  hoursPriorLaunch?: InputMaybe<Scalars['String']['input']>;
  icon?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  instruction?: InputMaybe<StudentAdksInstructionObjectEqualityInput>;
  internshipCompletion?: InputMaybe<Scalars['Boolean']['input']>;
  interviewReqeust?: InputMaybe<Scalars['String']['input']>;
  introVideo?: InputMaybe<Scalars['String']['input']>;
  isAdkAdded?: InputMaybe<Scalars['Boolean']['input']>;
  isAdkDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  isBadgesAdded?: InputMaybe<Scalars['Boolean']['input']>;
  isComplete?: InputMaybe<Scalars['Boolean']['input']>;
  isFieldEdited?: InputMaybe<Scalars['Boolean']['input']>;
  isPreview?: InputMaybe<Scalars['Boolean']['input']>;
  isSaved?: InputMaybe<Scalars['Boolean']['input']>;
  isSkippable?: InputMaybe<Scalars['Boolean']['input']>;
  isTeamAdk?: InputMaybe<Scalars['Boolean']['input']>;
  keyResults?: InputMaybe<Array<Scalars['String']['input']>>;
  lastInteraction?: InputMaybe<Scalars['String']['input']>;
  lastInteractionId?: InputMaybe<Scalars['String']['input']>;
  lastTimestamp?: InputMaybe<Scalars['Int']['input']>;
  likedComments?: InputMaybe<Array<Scalars['String']['input']>>;
  likedQuestions?: InputMaybe<Array<Scalars['String']['input']>>;
  name?: InputMaybe<Scalars['String']['input']>;
  objectiveKeyResults?: InputMaybe<Array<Scalars['String']['input']>>;
  optional?: InputMaybe<Scalars['Boolean']['input']>;
  package?: InputMaybe<Scalars['String']['input']>;
  participationLevel?: InputMaybe<Scalars['String']['input']>;
  permissions?: InputMaybe<Array<StudentAdksPermissionsObjectEqualityInput>>;
  pilot?: InputMaybe<Scalars['String']['input']>;
  position?: InputMaybe<Scalars['Int']['input']>;
  presetFields?: InputMaybe<Array<StudentAdksPresetFieldsObjectEqualityInput>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  primaryObjective?: InputMaybe<Scalars['String']['input']>;
  process?: InputMaybe<Scalars['String']['input']>;
  produce?: InputMaybe<Scalars['String']['input']>;
  projectScope?: InputMaybe<Scalars['String']['input']>;
  promote?: InputMaybe<Scalars['String']['input']>;
  proposal?: InputMaybe<Scalars['String']['input']>;
  ratingAcknowledgeDeliverablesCompletion?: InputMaybe<Scalars['Boolean']['input']>;
  ratingAcknowledgeMinHours?: InputMaybe<Scalars['Boolean']['input']>;
  ratingAcknowledgeSignoff?: InputMaybe<Scalars['Boolean']['input']>;
  ratingAttendingSocials?: InputMaybe<Scalars['Int']['input']>;
  ratingCoworkingChange?: InputMaybe<Scalars['String']['input']>;
  ratingCoworkingMood?: InputMaybe<Scalars['Int']['input']>;
  ratingEmployerDirection?: InputMaybe<Scalars['Int']['input']>;
  ratingEmployerWeeklyMeeting?: InputMaybe<Scalars['Int']['input']>;
  ratingEmployerWorkingRelationship?: InputMaybe<Scalars['Int']['input']>;
  ratingInPersonSocials?: InputMaybe<Scalars['Int']['input']>;
  ratingInternshipOverall?: InputMaybe<Scalars['Int']['input']>;
  ratingNewDeadlineDate?: InputMaybe<Scalars['String']['input']>;
  ratingNewFriends?: InputMaybe<Scalars['String']['input']>;
  ratingOneImprovement?: InputMaybe<Scalars['String']['input']>;
  ratingProjectProgress?: InputMaybe<Scalars['Int']['input']>;
  ratingVax?: InputMaybe<Scalars['Boolean']['input']>;
  ratingWeeklyMeetingChange?: InputMaybe<Scalars['String']['input']>;
  ratingWorkshop?: InputMaybe<Scalars['Boolean']['input']>;
  ratingWorkshopHelpfulness?: InputMaybe<Scalars['Int']['input']>;
  referralRep?: InputMaybe<Scalars['String']['input']>;
  reminder?: InputMaybe<Scalars['String']['input']>;
  required?: InputMaybe<Scalars['Boolean']['input']>;
  requiredActivity?: InputMaybe<Scalars['String']['input']>;
  rewards?: InputMaybe<Array<Scalars['String']['input']>>;
  rfp?: InputMaybe<StudentAdksRfpObjectEqualityInput>;
  schoolStartDate2021?: InputMaybe<Scalars['String']['input']>;
  scope?: InputMaybe<StudentAdksScopeObjectEqualityInput>;
  setupRequired?: InputMaybe<Scalars['Boolean']['input']>;
  sevenPointInternshipCompletion?: InputMaybe<Scalars['Boolean']['input']>;
  signOffVideoAskResponse?: InputMaybe<StudentAdksSignOffVideoAskResponseObjectEqualityInput>;
  status?: InputMaybe<Scalars['JSON']['input']>;
  styling?: InputMaybe<StudentAdksStylingObjectEqualityInput>;
  tagId?: InputMaybe<Scalars['String']['input']>;
  timeTaken?: InputMaybe<Scalars['Int']['input']>;
  timeToSolveProblem?: InputMaybe<Scalars['Int']['input']>;
  timesheetDetails?: InputMaybe<Array<StudentAdksTimesheetDetailsObjectEqualityInput>>;
  trainProgress?: InputMaybe<Array<StudentAdksTrainProgressObjectEqualityInput>>;
  weeklyConferenceLink?: InputMaybe<Scalars['String']['input']>;
  weeklyMeetingCadence?: InputMaybe<Scalars['String']['input']>;
  weeklyMeetingDay?: InputMaybe<Scalars['String']['input']>;
  weeklyMeetingTime?: InputMaybe<Scalars['String']['input']>;
};

export type StudentAdksPermissions = {
  __typename?: 'StudentAdksPermissions';
  permissions_matrix?: Maybe<Array<Scalars['String']['output']>>;
  role?: Maybe<Scalars['String']['output']>;
  roles?: Maybe<Scalars['String']['output']>;
};

export type StudentAdksPermissionsCreateInput = {
  permissions_matrix?: InputMaybe<StudentAdksPermissionsCreatepermissions_MatrixInput>;
  role?: InputMaybe<Scalars['String']['input']>;
  roles?: InputMaybe<Scalars['String']['input']>;
};

export type StudentAdksPermissionsCreatepermissions_MatrixInput = {
  set: Array<Scalars['String']['input']>;
};

export type StudentAdksPermissionsObjectEqualityInput = {
  permissions_matrix?: InputMaybe<Array<Scalars['String']['input']>>;
  role?: InputMaybe<Scalars['String']['input']>;
  roles?: InputMaybe<Scalars['String']['input']>;
};

export type StudentAdksPresetFields = {
  __typename?: 'StudentAdksPresetFields';
  /** Multiple data types found: String: 33.9%, Int: 66.1% out of 4303 sampled entries */
  defaultValue?: Maybe<Scalars['JSON']['output']>;
  /** Multiple data types found: String: 0%, String (ObjectId): 100% out of 6894 sampled entries */
  id?: Maybe<Scalars['JSON']['output']>;
  isFieldEdited?: Maybe<Scalars['Boolean']['output']>;
  /** Multiple data types found: Array(String): 33.9%, Array(Int): 66.1% out of 4303 sampled entries */
  items?: Maybe<Scalars['JSON']['output']>;
  model?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  noSetup?: Maybe<Scalars['Boolean']['output']>;
  position?: Maybe<Scalars['Int']['output']>;
  preset?: Maybe<StudentAdksPresetFieldsPreset>;
  roles?: Maybe<Array<Scalars['String']['output']>>;
  /** Could not determine type: the field only had null or empty values in the sample set. */
  rules?: Maybe<Scalars['JSON']['output']>;
  setup?: Maybe<StudentAdksPresetFieldsSetup>;
  styling?: Maybe<StudentAdksPresetFieldsStyling>;
  title?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
  value?: Maybe<StudentAdksPresetFieldsValue>;
  videoAskLabel?: Maybe<Scalars['String']['output']>;
  videoAskUrl?: Maybe<Scalars['String']['output']>;
};

export type StudentAdksPresetFieldsCreateInput = {
  defaultValue?: InputMaybe<Scalars['JSON']['input']>;
  id?: InputMaybe<Scalars['JSON']['input']>;
  isFieldEdited?: InputMaybe<Scalars['Boolean']['input']>;
  items?: InputMaybe<Scalars['JSON']['input']>;
  model?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  noSetup?: InputMaybe<Scalars['Boolean']['input']>;
  position?: InputMaybe<Scalars['Int']['input']>;
  preset?: InputMaybe<StudentAdksPresetFieldsPresetCreateInput>;
  roles?: InputMaybe<StudentAdksPresetFieldsCreaterolesInput>;
  rules?: InputMaybe<Scalars['JSON']['input']>;
  setup?: InputMaybe<StudentAdksPresetFieldsSetupCreateInput>;
  styling?: InputMaybe<StudentAdksPresetFieldsStylingCreateInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  type: Scalars['String']['input'];
  value?: InputMaybe<StudentAdksPresetFieldsValueCreateInput>;
  videoAskLabel?: InputMaybe<Scalars['String']['input']>;
  videoAskUrl?: InputMaybe<Scalars['String']['input']>;
};

export type StudentAdksPresetFieldsCreaterolesInput = {
  set: Array<Scalars['String']['input']>;
};

export type StudentAdksPresetFieldsObjectEqualityInput = {
  defaultValue?: InputMaybe<Scalars['JSON']['input']>;
  id?: InputMaybe<Scalars['JSON']['input']>;
  isFieldEdited?: InputMaybe<Scalars['Boolean']['input']>;
  items?: InputMaybe<Scalars['JSON']['input']>;
  model?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  noSetup?: InputMaybe<Scalars['Boolean']['input']>;
  position?: InputMaybe<Scalars['Int']['input']>;
  preset?: InputMaybe<StudentAdksPresetFieldsPresetObjectEqualityInput>;
  roles?: InputMaybe<Array<Scalars['String']['input']>>;
  rules?: InputMaybe<Scalars['JSON']['input']>;
  setup?: InputMaybe<StudentAdksPresetFieldsSetupObjectEqualityInput>;
  styling?: InputMaybe<StudentAdksPresetFieldsStylingObjectEqualityInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  type: Scalars['String']['input'];
  value?: InputMaybe<StudentAdksPresetFieldsValueObjectEqualityInput>;
  videoAskLabel?: InputMaybe<Scalars['String']['input']>;
  videoAskUrl?: InputMaybe<Scalars['String']['input']>;
};

export type StudentAdksPresetFieldsPreset = {
  __typename?: 'StudentAdksPresetFieldsPreset';
  maxCharacters?: Maybe<Scalars['String']['output']>;
  maxQuestions?: Maybe<Scalars['Int']['output']>;
  maxTeamMembers?: Maybe<Scalars['Int']['output']>;
  minLogs?: Maybe<Scalars['Int']['output']>;
  minimumHoursNow?: Maybe<Scalars['String']['output']>;
  videoMaxLength?: Maybe<Scalars['Int']['output']>;
};

export type StudentAdksPresetFieldsPresetCreateInput = {
  maxCharacters?: InputMaybe<Scalars['String']['input']>;
  maxQuestions?: InputMaybe<Scalars['Int']['input']>;
  maxTeamMembers?: InputMaybe<Scalars['Int']['input']>;
  minLogs?: InputMaybe<Scalars['Int']['input']>;
  minimumHoursNow?: InputMaybe<Scalars['String']['input']>;
  videoMaxLength?: InputMaybe<Scalars['Int']['input']>;
};

export type StudentAdksPresetFieldsPresetObjectEqualityInput = {
  maxCharacters?: InputMaybe<Scalars['String']['input']>;
  maxQuestions?: InputMaybe<Scalars['Int']['input']>;
  maxTeamMembers?: InputMaybe<Scalars['Int']['input']>;
  minLogs?: InputMaybe<Scalars['Int']['input']>;
  minimumHoursNow?: InputMaybe<Scalars['String']['input']>;
  videoMaxLength?: InputMaybe<Scalars['Int']['input']>;
};

export type StudentAdksPresetFieldsSetup = {
  __typename?: 'StudentAdksPresetFieldsSetup';
  /** Could not determine type: the field only had null or empty values in the sample set. */
  boards?: Maybe<Scalars['JSON']['output']>;
  directoryPreferences?: Maybe<Array<StudentAdksPresetFieldsSetupDirectoryPreferences>>;
  discordData?: Maybe<StudentAdksPresetFieldsSetupDiscordData>;
  driveLink?: Maybe<Scalars['String']['output']>;
  endEarlyActivity?: Maybe<Scalars['String']['output']>;
  groupActivity?: Maybe<Scalars['String']['output']>;
  maxCharacters?: Maybe<Scalars['String']['output']>;
  maxQuestions?: Maybe<Scalars['Int']['output']>;
  maxTeamMembers?: Maybe<Scalars['Int']['output']>;
  minLogs?: Maybe<Scalars['Int']['output']>;
  minimumHoursNow?: Maybe<Scalars['String']['output']>;
  requiredActivity?: Maybe<Scalars['String']['output']>;
  settings?: Maybe<StudentAdksPresetFieldsSetupSettings>;
  signInVideoAskResponse?: Maybe<StudentAdksPresetFieldsSetupSignInVideoAskResponse>;
  videoMaxLength?: Maybe<Scalars['Int']['output']>;
  welcomeActivity?: Maybe<Scalars['String']['output']>;
};

export type StudentAdksPresetFieldsSetupCreateInput = {
  boards?: InputMaybe<Scalars['JSON']['input']>;
  directoryPreferences?: InputMaybe<Array<StudentAdksPresetFieldsSetupDirectoryPreferencesCreateInput>>;
  discordData?: InputMaybe<StudentAdksPresetFieldsSetupDiscordDataCreateInput>;
  driveLink?: InputMaybe<Scalars['String']['input']>;
  endEarlyActivity?: InputMaybe<Scalars['String']['input']>;
  groupActivity?: InputMaybe<Scalars['String']['input']>;
  maxCharacters?: InputMaybe<Scalars['String']['input']>;
  maxQuestions?: InputMaybe<Scalars['Int']['input']>;
  maxTeamMembers?: InputMaybe<Scalars['Int']['input']>;
  minLogs?: InputMaybe<Scalars['Int']['input']>;
  minimumHoursNow?: InputMaybe<Scalars['String']['input']>;
  requiredActivity?: InputMaybe<Scalars['String']['input']>;
  settings?: InputMaybe<StudentAdksPresetFieldsSetupSettingsCreateInput>;
  signInVideoAskResponse?: InputMaybe<StudentAdksPresetFieldsSetupSignInVideoAskResponseCreateInput>;
  videoMaxLength?: InputMaybe<Scalars['Int']['input']>;
  welcomeActivity?: InputMaybe<Scalars['String']['input']>;
};

export type StudentAdksPresetFieldsSetupDirectoryPreferences = {
  __typename?: 'StudentAdksPresetFieldsSetupDirectoryPreferences';
  contactMethod?: Maybe<Array<Scalars['String']['output']>>;
  contactMethods?: Maybe<Array<Scalars['String']['output']>>;
  contactPreferences?: Maybe<Array<Scalars['String']['output']>>;
  hideEmail: Scalars['Boolean']['output'];
  hidePhone: Scalars['Boolean']['output'];
  schedulingLink?: Maybe<Scalars['String']['output']>;
  /** Multiple data types found: String: 1.7%, String (ObjectId): 98.3% out of 242 sampled entries */
  userId: Scalars['JSON']['output'];
};

export type StudentAdksPresetFieldsSetupDirectoryPreferencesCreateInput = {
  contactMethod?: InputMaybe<StudentAdksPresetFieldsSetupDirectoryPreferencesCreatecontactMethodInput>;
  contactMethods?: InputMaybe<StudentAdksPresetFieldsSetupDirectoryPreferencesCreatecontactMethodsInput>;
  contactPreferences?: InputMaybe<StudentAdksPresetFieldsSetupDirectoryPreferencesCreatecontactPreferencesInput>;
  hideEmail: Scalars['Boolean']['input'];
  hidePhone: Scalars['Boolean']['input'];
  schedulingLink?: InputMaybe<Scalars['String']['input']>;
  userId: Scalars['JSON']['input'];
};

export type StudentAdksPresetFieldsSetupDirectoryPreferencesCreatecontactMethodInput = {
  set: Array<Scalars['String']['input']>;
};

export type StudentAdksPresetFieldsSetupDirectoryPreferencesCreatecontactMethodsInput = {
  set: Array<Scalars['String']['input']>;
};

export type StudentAdksPresetFieldsSetupDirectoryPreferencesCreatecontactPreferencesInput = {
  set: Array<Scalars['String']['input']>;
};

export type StudentAdksPresetFieldsSetupDirectoryPreferencesObjectEqualityInput = {
  contactMethod?: InputMaybe<Array<Scalars['String']['input']>>;
  contactMethods?: InputMaybe<Array<Scalars['String']['input']>>;
  contactPreferences?: InputMaybe<Array<Scalars['String']['input']>>;
  hideEmail: Scalars['Boolean']['input'];
  hidePhone: Scalars['Boolean']['input'];
  schedulingLink?: InputMaybe<Scalars['String']['input']>;
  userId: Scalars['JSON']['input'];
};

export type StudentAdksPresetFieldsSetupDiscordData = {
  __typename?: 'StudentAdksPresetFieldsSetupDiscordData';
  channel?: Maybe<StudentAdksPresetFieldsSetupDiscordDataChannel>;
  createdBy: StudentAdksPresetFieldsSetupDiscordDataCreatedBy;
  role: StudentAdksPresetFieldsSetupDiscordDataRole;
};

export type StudentAdksPresetFieldsSetupDiscordDataChannel = {
  __typename?: 'StudentAdksPresetFieldsSetupDiscordDataChannel';
  flags: Scalars['Int']['output'];
  guild_id: Scalars['String']['output'];
  id: Scalars['String']['output'];
  /** Could not determine type: the field only had null or empty values in the sample set. */
  last_message_id?: Maybe<Scalars['JSON']['output']>;
  name: Scalars['String']['output'];
  nsfw: Scalars['Boolean']['output'];
  parent_id: Scalars['String']['output'];
  permission_overwrites?: Maybe<Array<StudentAdksPresetFieldsSetupDiscordDataChannelPermissionOverwrites>>;
  position: Scalars['Int']['output'];
  rate_limit_per_user: Scalars['Int']['output'];
  /** Could not determine type: the field only had null or empty values in the sample set. */
  topic?: Maybe<Scalars['JSON']['output']>;
  type: Scalars['Int']['output'];
};

export type StudentAdksPresetFieldsSetupDiscordDataChannelCreateInput = {
  flags: Scalars['Int']['input'];
  guild_id: Scalars['String']['input'];
  id: Scalars['String']['input'];
  last_message_id?: InputMaybe<Scalars['JSON']['input']>;
  name: Scalars['String']['input'];
  nsfw: Scalars['Boolean']['input'];
  parent_id: Scalars['String']['input'];
  permission_overwrites?: InputMaybe<Array<StudentAdksPresetFieldsSetupDiscordDataChannelPermissionOverwritesCreateInput>>;
  position: Scalars['Int']['input'];
  rate_limit_per_user: Scalars['Int']['input'];
  topic?: InputMaybe<Scalars['JSON']['input']>;
  type: Scalars['Int']['input'];
};

export type StudentAdksPresetFieldsSetupDiscordDataChannelObjectEqualityInput = {
  flags: Scalars['Int']['input'];
  guild_id: Scalars['String']['input'];
  id: Scalars['String']['input'];
  last_message_id?: InputMaybe<Scalars['JSON']['input']>;
  name: Scalars['String']['input'];
  nsfw: Scalars['Boolean']['input'];
  parent_id: Scalars['String']['input'];
  permission_overwrites?: InputMaybe<Array<StudentAdksPresetFieldsSetupDiscordDataChannelPermissionOverwritesObjectEqualityInput>>;
  position: Scalars['Int']['input'];
  rate_limit_per_user: Scalars['Int']['input'];
  topic?: InputMaybe<Scalars['JSON']['input']>;
  type: Scalars['Int']['input'];
};

export type StudentAdksPresetFieldsSetupDiscordDataChannelPermissionOverwrites = {
  __typename?: 'StudentAdksPresetFieldsSetupDiscordDataChannelPermissionOverwrites';
  allow: Scalars['Int']['output'];
  allow_new: Scalars['String']['output'];
  deny: Scalars['Int']['output'];
  deny_new: Scalars['String']['output'];
  id: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type StudentAdksPresetFieldsSetupDiscordDataChannelPermissionOverwritesCreateInput = {
  allow: Scalars['Int']['input'];
  allow_new: Scalars['String']['input'];
  deny: Scalars['Int']['input'];
  deny_new: Scalars['String']['input'];
  id: Scalars['String']['input'];
  type: Scalars['String']['input'];
};

export type StudentAdksPresetFieldsSetupDiscordDataChannelPermissionOverwritesObjectEqualityInput = {
  allow: Scalars['Int']['input'];
  allow_new: Scalars['String']['input'];
  deny: Scalars['Int']['input'];
  deny_new: Scalars['String']['input'];
  id: Scalars['String']['input'];
  type: Scalars['String']['input'];
};

export type StudentAdksPresetFieldsSetupDiscordDataCreateInput = {
  channel?: InputMaybe<StudentAdksPresetFieldsSetupDiscordDataChannelCreateInput>;
  createdBy: StudentAdksPresetFieldsSetupDiscordDataCreatedByCreateInput;
  role: StudentAdksPresetFieldsSetupDiscordDataRoleCreateInput;
};

export type StudentAdksPresetFieldsSetupDiscordDataCreatedBy = {
  __typename?: 'StudentAdksPresetFieldsSetupDiscordDataCreatedBy';
  email: Scalars['String']['output'];
  userType: Scalars['String']['output'];
};

export type StudentAdksPresetFieldsSetupDiscordDataCreatedByCreateInput = {
  email: Scalars['String']['input'];
  userType: Scalars['String']['input'];
};

export type StudentAdksPresetFieldsSetupDiscordDataCreatedByObjectEqualityInput = {
  email: Scalars['String']['input'];
  userType: Scalars['String']['input'];
};

export type StudentAdksPresetFieldsSetupDiscordDataObjectEqualityInput = {
  channel?: InputMaybe<StudentAdksPresetFieldsSetupDiscordDataChannelObjectEqualityInput>;
  createdBy: StudentAdksPresetFieldsSetupDiscordDataCreatedByObjectEqualityInput;
  role: StudentAdksPresetFieldsSetupDiscordDataRoleObjectEqualityInput;
};

export type StudentAdksPresetFieldsSetupDiscordDataRole = {
  __typename?: 'StudentAdksPresetFieldsSetupDiscordDataRole';
  color?: Maybe<Scalars['Int']['output']>;
  /** Could not determine type: the field only had null or empty values in the sample set. */
  description?: Maybe<Scalars['JSON']['output']>;
  flags?: Maybe<Scalars['Int']['output']>;
  global?: Maybe<Scalars['Boolean']['output']>;
  hoist?: Maybe<Scalars['Boolean']['output']>;
  /** Could not determine type: the field only had null or empty values in the sample set. */
  icon?: Maybe<Scalars['JSON']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  managed?: Maybe<Scalars['Boolean']['output']>;
  mentionable?: Maybe<Scalars['Boolean']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  permissions?: Maybe<Scalars['Int']['output']>;
  permissions_new?: Maybe<Scalars['String']['output']>;
  position?: Maybe<Scalars['Int']['output']>;
  retry_after?: Maybe<Scalars['Float']['output']>;
  /** Could not determine type: the field only had null or empty values in the sample set. */
  unicode_emoji?: Maybe<Scalars['JSON']['output']>;
};

export type StudentAdksPresetFieldsSetupDiscordDataRoleCreateInput = {
  color?: InputMaybe<Scalars['Int']['input']>;
  description?: InputMaybe<Scalars['JSON']['input']>;
  flags?: InputMaybe<Scalars['Int']['input']>;
  global?: InputMaybe<Scalars['Boolean']['input']>;
  hoist?: InputMaybe<Scalars['Boolean']['input']>;
  icon?: InputMaybe<Scalars['JSON']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  managed?: InputMaybe<Scalars['Boolean']['input']>;
  mentionable?: InputMaybe<Scalars['Boolean']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  permissions?: InputMaybe<Scalars['Int']['input']>;
  permissions_new?: InputMaybe<Scalars['String']['input']>;
  position?: InputMaybe<Scalars['Int']['input']>;
  retry_after?: InputMaybe<Scalars['Float']['input']>;
  unicode_emoji?: InputMaybe<Scalars['JSON']['input']>;
};

export type StudentAdksPresetFieldsSetupDiscordDataRoleObjectEqualityInput = {
  color?: InputMaybe<Scalars['Int']['input']>;
  description?: InputMaybe<Scalars['JSON']['input']>;
  flags?: InputMaybe<Scalars['Int']['input']>;
  global?: InputMaybe<Scalars['Boolean']['input']>;
  hoist?: InputMaybe<Scalars['Boolean']['input']>;
  icon?: InputMaybe<Scalars['JSON']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  managed?: InputMaybe<Scalars['Boolean']['input']>;
  mentionable?: InputMaybe<Scalars['Boolean']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  permissions?: InputMaybe<Scalars['Int']['input']>;
  permissions_new?: InputMaybe<Scalars['String']['input']>;
  position?: InputMaybe<Scalars['Int']['input']>;
  retry_after?: InputMaybe<Scalars['Float']['input']>;
  unicode_emoji?: InputMaybe<Scalars['JSON']['input']>;
};

export type StudentAdksPresetFieldsSetupObjectEqualityInput = {
  boards?: InputMaybe<Scalars['JSON']['input']>;
  directoryPreferences?: InputMaybe<Array<StudentAdksPresetFieldsSetupDirectoryPreferencesObjectEqualityInput>>;
  discordData?: InputMaybe<StudentAdksPresetFieldsSetupDiscordDataObjectEqualityInput>;
  driveLink?: InputMaybe<Scalars['String']['input']>;
  endEarlyActivity?: InputMaybe<Scalars['String']['input']>;
  groupActivity?: InputMaybe<Scalars['String']['input']>;
  maxCharacters?: InputMaybe<Scalars['String']['input']>;
  maxQuestions?: InputMaybe<Scalars['Int']['input']>;
  maxTeamMembers?: InputMaybe<Scalars['Int']['input']>;
  minLogs?: InputMaybe<Scalars['Int']['input']>;
  minimumHoursNow?: InputMaybe<Scalars['String']['input']>;
  requiredActivity?: InputMaybe<Scalars['String']['input']>;
  settings?: InputMaybe<StudentAdksPresetFieldsSetupSettingsObjectEqualityInput>;
  signInVideoAskResponse?: InputMaybe<StudentAdksPresetFieldsSetupSignInVideoAskResponseObjectEqualityInput>;
  videoMaxLength?: InputMaybe<Scalars['Int']['input']>;
  welcomeActivity?: InputMaybe<Scalars['String']['input']>;
};

export type StudentAdksPresetFieldsSetupSettings = {
  __typename?: 'StudentAdksPresetFieldsSetupSettings';
  caseStudySettings: StudentAdksPresetFieldsSetupSettingsCaseStudySettings;
  digitalResumeSettings: Scalars['Boolean']['output'];
  presentationSettings: StudentAdksPresetFieldsSetupSettingsPresentationSettings;
  projectFAQSettings: Scalars['Boolean']['output'];
  projectImplementationSettings: StudentAdksPresetFieldsSetupSettingsProjectImplementationSettings;
  projectPlanSettings: StudentAdksPresetFieldsSetupSettingsProjectPlanSettings;
  projectTaskSettings: StudentAdksPresetFieldsSetupSettingsProjectTaskSettings;
  teamSettings: StudentAdksPresetFieldsSetupSettingsTeamSettings;
  userInterviewSettings: StudentAdksPresetFieldsSetupSettingsUserInterviewSettings;
};

export type StudentAdksPresetFieldsSetupSettingsCaseStudySettings = {
  __typename?: 'StudentAdksPresetFieldsSetupSettingsCaseStudySettings';
  contentSetting?: Maybe<Scalars['String']['output']>;
  required: Scalars['Boolean']['output'];
};

export type StudentAdksPresetFieldsSetupSettingsCaseStudySettingsCreateInput = {
  contentSetting?: InputMaybe<Scalars['String']['input']>;
  required: Scalars['Boolean']['input'];
};

export type StudentAdksPresetFieldsSetupSettingsCaseStudySettingsObjectEqualityInput = {
  contentSetting?: InputMaybe<Scalars['String']['input']>;
  required: Scalars['Boolean']['input'];
};

export type StudentAdksPresetFieldsSetupSettingsCreateInput = {
  caseStudySettings: StudentAdksPresetFieldsSetupSettingsCaseStudySettingsCreateInput;
  digitalResumeSettings: Scalars['Boolean']['input'];
  presentationSettings: StudentAdksPresetFieldsSetupSettingsPresentationSettingsCreateInput;
  projectFAQSettings: Scalars['Boolean']['input'];
  projectImplementationSettings: StudentAdksPresetFieldsSetupSettingsProjectImplementationSettingsCreateInput;
  projectPlanSettings: StudentAdksPresetFieldsSetupSettingsProjectPlanSettingsCreateInput;
  projectTaskSettings: StudentAdksPresetFieldsSetupSettingsProjectTaskSettingsCreateInput;
  teamSettings: StudentAdksPresetFieldsSetupSettingsTeamSettingsCreateInput;
  userInterviewSettings: StudentAdksPresetFieldsSetupSettingsUserInterviewSettingsCreateInput;
};

export type StudentAdksPresetFieldsSetupSettingsObjectEqualityInput = {
  caseStudySettings: StudentAdksPresetFieldsSetupSettingsCaseStudySettingsObjectEqualityInput;
  digitalResumeSettings: Scalars['Boolean']['input'];
  presentationSettings: StudentAdksPresetFieldsSetupSettingsPresentationSettingsObjectEqualityInput;
  projectFAQSettings: Scalars['Boolean']['input'];
  projectImplementationSettings: StudentAdksPresetFieldsSetupSettingsProjectImplementationSettingsObjectEqualityInput;
  projectPlanSettings: StudentAdksPresetFieldsSetupSettingsProjectPlanSettingsObjectEqualityInput;
  projectTaskSettings: StudentAdksPresetFieldsSetupSettingsProjectTaskSettingsObjectEqualityInput;
  teamSettings: StudentAdksPresetFieldsSetupSettingsTeamSettingsObjectEqualityInput;
  userInterviewSettings: StudentAdksPresetFieldsSetupSettingsUserInterviewSettingsObjectEqualityInput;
};

export type StudentAdksPresetFieldsSetupSettingsPresentationSettings = {
  __typename?: 'StudentAdksPresetFieldsSetupSettingsPresentationSettings';
  maxMins?: Maybe<Scalars['String']['output']>;
  required: Scalars['Boolean']['output'];
};

export type StudentAdksPresetFieldsSetupSettingsPresentationSettingsCreateInput = {
  maxMins?: InputMaybe<Scalars['String']['input']>;
  required: Scalars['Boolean']['input'];
};

export type StudentAdksPresetFieldsSetupSettingsPresentationSettingsObjectEqualityInput = {
  maxMins?: InputMaybe<Scalars['String']['input']>;
  required: Scalars['Boolean']['input'];
};

export type StudentAdksPresetFieldsSetupSettingsProjectImplementationSettings = {
  __typename?: 'StudentAdksPresetFieldsSetupSettingsProjectImplementationSettings';
  pilots?: Maybe<Scalars['String']['output']>;
  required: Scalars['Boolean']['output'];
};

export type StudentAdksPresetFieldsSetupSettingsProjectImplementationSettingsCreateInput = {
  pilots?: InputMaybe<Scalars['String']['input']>;
  required: Scalars['Boolean']['input'];
};

export type StudentAdksPresetFieldsSetupSettingsProjectImplementationSettingsObjectEqualityInput = {
  pilots?: InputMaybe<Scalars['String']['input']>;
  required: Scalars['Boolean']['input'];
};

export type StudentAdksPresetFieldsSetupSettingsProjectPlanSettings = {
  __typename?: 'StudentAdksPresetFieldsSetupSettingsProjectPlanSettings';
  prePopulate?: Maybe<Scalars['String']['output']>;
  required: Scalars['Boolean']['output'];
};

export type StudentAdksPresetFieldsSetupSettingsProjectPlanSettingsCreateInput = {
  prePopulate?: InputMaybe<Scalars['String']['input']>;
  required: Scalars['Boolean']['input'];
};

export type StudentAdksPresetFieldsSetupSettingsProjectPlanSettingsObjectEqualityInput = {
  prePopulate?: InputMaybe<Scalars['String']['input']>;
  required: Scalars['Boolean']['input'];
};

export type StudentAdksPresetFieldsSetupSettingsProjectTaskSettings = {
  __typename?: 'StudentAdksPresetFieldsSetupSettingsProjectTaskSettings';
  required: Scalars['Boolean']['output'];
  taskSetting?: Maybe<Scalars['String']['output']>;
};

export type StudentAdksPresetFieldsSetupSettingsProjectTaskSettingsCreateInput = {
  required: Scalars['Boolean']['input'];
  taskSetting?: InputMaybe<Scalars['String']['input']>;
};

export type StudentAdksPresetFieldsSetupSettingsProjectTaskSettingsObjectEqualityInput = {
  required: Scalars['Boolean']['input'];
  taskSetting?: InputMaybe<Scalars['String']['input']>;
};

export type StudentAdksPresetFieldsSetupSettingsTeamSettings = {
  __typename?: 'StudentAdksPresetFieldsSetupSettingsTeamSettings';
  editViewSetting?: Maybe<Scalars['String']['output']>;
  required: Scalars['Boolean']['output'];
};

export type StudentAdksPresetFieldsSetupSettingsTeamSettingsCreateInput = {
  editViewSetting?: InputMaybe<Scalars['String']['input']>;
  required: Scalars['Boolean']['input'];
};

export type StudentAdksPresetFieldsSetupSettingsTeamSettingsObjectEqualityInput = {
  editViewSetting?: InputMaybe<Scalars['String']['input']>;
  required: Scalars['Boolean']['input'];
};

export type StudentAdksPresetFieldsSetupSettingsUserInterviewSettings = {
  __typename?: 'StudentAdksPresetFieldsSetupSettingsUserInterviewSettings';
  required: Scalars['Boolean']['output'];
  totalUsers?: Maybe<Scalars['String']['output']>;
};

export type StudentAdksPresetFieldsSetupSettingsUserInterviewSettingsCreateInput = {
  required: Scalars['Boolean']['input'];
  totalUsers?: InputMaybe<Scalars['String']['input']>;
};

export type StudentAdksPresetFieldsSetupSettingsUserInterviewSettingsObjectEqualityInput = {
  required: Scalars['Boolean']['input'];
  totalUsers?: InputMaybe<Scalars['String']['input']>;
};

export type StudentAdksPresetFieldsSetupSignInVideoAskResponse = {
  __typename?: 'StudentAdksPresetFieldsSetupSignInVideoAskResponse';
  contact: StudentAdksPresetFieldsSetupSignInVideoAskResponseContact;
  event_id: Scalars['String']['output'];
  event_type: Scalars['String']['output'];
  form: StudentAdksPresetFieldsSetupSignInVideoAskResponseForm;
  interaction_id: Scalars['String']['output'];
};

export type StudentAdksPresetFieldsSetupSignInVideoAskResponseContact = {
  __typename?: 'StudentAdksPresetFieldsSetupSignInVideoAskResponseContact';
  answers?: Maybe<Array<StudentAdksPresetFieldsSetupSignInVideoAskResponseContactAnswers>>;
  are_answers_public: Scalars['Boolean']['output'];
  are_messages_public: Scalars['Boolean']['output'];
  contact_id: Scalars['String']['output'];
  email: Scalars['String']['output'];
  platform: Scalars['String']['output'];
  share_id: Scalars['String']['output'];
  share_url: Scalars['String']['output'];
  status: Scalars['String']['output'];
};

export type StudentAdksPresetFieldsSetupSignInVideoAskResponseContactAnswers = {
  __typename?: 'StudentAdksPresetFieldsSetupSignInVideoAskResponseContactAnswers';
  answer_id: Scalars['String']['output'];
  media_id: Scalars['String']['output'];
  media_url: Scalars['String']['output'];
  /** Could not determine type: the field only had null or empty values in the sample set. */
  poll_options?: Maybe<Scalars['JSON']['output']>;
  question_id: Scalars['String']['output'];
};

export type StudentAdksPresetFieldsSetupSignInVideoAskResponseContactAnswersCreateInput = {
  answer_id: Scalars['String']['input'];
  media_id: Scalars['String']['input'];
  media_url: Scalars['String']['input'];
  poll_options?: InputMaybe<Scalars['JSON']['input']>;
  question_id: Scalars['String']['input'];
};

export type StudentAdksPresetFieldsSetupSignInVideoAskResponseContactAnswersObjectEqualityInput = {
  answer_id: Scalars['String']['input'];
  media_id: Scalars['String']['input'];
  media_url: Scalars['String']['input'];
  poll_options?: InputMaybe<Scalars['JSON']['input']>;
  question_id: Scalars['String']['input'];
};

export type StudentAdksPresetFieldsSetupSignInVideoAskResponseContactCreateInput = {
  answers?: InputMaybe<Array<StudentAdksPresetFieldsSetupSignInVideoAskResponseContactAnswersCreateInput>>;
  are_answers_public: Scalars['Boolean']['input'];
  are_messages_public: Scalars['Boolean']['input'];
  contact_id: Scalars['String']['input'];
  email: Scalars['String']['input'];
  platform: Scalars['String']['input'];
  share_id: Scalars['String']['input'];
  share_url: Scalars['String']['input'];
  status: Scalars['String']['input'];
};

export type StudentAdksPresetFieldsSetupSignInVideoAskResponseContactObjectEqualityInput = {
  answers?: InputMaybe<Array<StudentAdksPresetFieldsSetupSignInVideoAskResponseContactAnswersObjectEqualityInput>>;
  are_answers_public: Scalars['Boolean']['input'];
  are_messages_public: Scalars['Boolean']['input'];
  contact_id: Scalars['String']['input'];
  email: Scalars['String']['input'];
  platform: Scalars['String']['input'];
  share_id: Scalars['String']['input'];
  share_url: Scalars['String']['input'];
  status: Scalars['String']['input'];
};

export type StudentAdksPresetFieldsSetupSignInVideoAskResponseCreateInput = {
  contact: StudentAdksPresetFieldsSetupSignInVideoAskResponseContactCreateInput;
  event_id: Scalars['String']['input'];
  event_type: Scalars['String']['input'];
  form: StudentAdksPresetFieldsSetupSignInVideoAskResponseFormCreateInput;
  interaction_id: Scalars['String']['input'];
};

export type StudentAdksPresetFieldsSetupSignInVideoAskResponseForm = {
  __typename?: 'StudentAdksPresetFieldsSetupSignInVideoAskResponseForm';
  are_answers_public: Scalars['Boolean']['output'];
  are_messages_public: Scalars['Boolean']['output'];
  form_id: Scalars['String']['output'];
  hide_branding: Scalars['Boolean']['output'];
  idle_deadline_time_in_minutes: Scalars['Int']['output'];
  notifications: StudentAdksPresetFieldsSetupSignInVideoAskResponseFormNotifications;
  questions?: Maybe<Array<StudentAdksPresetFieldsSetupSignInVideoAskResponseFormQuestions>>;
  requires_consent: Scalars['Boolean']['output'];
  requires_contact_email: Scalars['Boolean']['output'];
  requires_contact_info: Scalars['Boolean']['output'];
  requires_contact_name: Scalars['Boolean']['output'];
  requires_contact_phone_number: Scalars['Boolean']['output'];
  respondents_count: Scalars['Int']['output'];
  responses_share_id: Scalars['String']['output'];
  responses_share_url: Scalars['String']['output'];
  share_id: Scalars['String']['output'];
  share_url: Scalars['String']['output'];
  show_consent: Scalars['Boolean']['output'];
  show_contact_email: Scalars['Boolean']['output'];
  show_contact_name: Scalars['Boolean']['output'];
  show_contact_phone_number: Scalars['Boolean']['output'];
  tag_share_id: Scalars['String']['output'];
  tag_share_url: Scalars['String']['output'];
};

export type StudentAdksPresetFieldsSetupSignInVideoAskResponseFormCreateInput = {
  are_answers_public: Scalars['Boolean']['input'];
  are_messages_public: Scalars['Boolean']['input'];
  form_id: Scalars['String']['input'];
  hide_branding: Scalars['Boolean']['input'];
  idle_deadline_time_in_minutes: Scalars['Int']['input'];
  notifications: StudentAdksPresetFieldsSetupSignInVideoAskResponseFormNotificationsCreateInput;
  questions?: InputMaybe<Array<StudentAdksPresetFieldsSetupSignInVideoAskResponseFormQuestionsCreateInput>>;
  requires_consent: Scalars['Boolean']['input'];
  requires_contact_email: Scalars['Boolean']['input'];
  requires_contact_info: Scalars['Boolean']['input'];
  requires_contact_name: Scalars['Boolean']['input'];
  requires_contact_phone_number: Scalars['Boolean']['input'];
  respondents_count: Scalars['Int']['input'];
  responses_share_id: Scalars['String']['input'];
  responses_share_url: Scalars['String']['input'];
  share_id: Scalars['String']['input'];
  share_url: Scalars['String']['input'];
  show_consent: Scalars['Boolean']['input'];
  show_contact_email: Scalars['Boolean']['input'];
  show_contact_name: Scalars['Boolean']['input'];
  show_contact_phone_number: Scalars['Boolean']['input'];
  tag_share_id: Scalars['String']['input'];
  tag_share_url: Scalars['String']['input'];
};

export type StudentAdksPresetFieldsSetupSignInVideoAskResponseFormNotifications = {
  __typename?: 'StudentAdksPresetFieldsSetupSignInVideoAskResponseFormNotifications';
  send_contact_message_emails: Scalars['Boolean']['output'];
};

export type StudentAdksPresetFieldsSetupSignInVideoAskResponseFormNotificationsCreateInput = {
  send_contact_message_emails: Scalars['Boolean']['input'];
};

export type StudentAdksPresetFieldsSetupSignInVideoAskResponseFormNotificationsObjectEqualityInput = {
  send_contact_message_emails: Scalars['Boolean']['input'];
};

export type StudentAdksPresetFieldsSetupSignInVideoAskResponseFormObjectEqualityInput = {
  are_answers_public: Scalars['Boolean']['input'];
  are_messages_public: Scalars['Boolean']['input'];
  form_id: Scalars['String']['input'];
  hide_branding: Scalars['Boolean']['input'];
  idle_deadline_time_in_minutes: Scalars['Int']['input'];
  notifications: StudentAdksPresetFieldsSetupSignInVideoAskResponseFormNotificationsObjectEqualityInput;
  questions?: InputMaybe<Array<StudentAdksPresetFieldsSetupSignInVideoAskResponseFormQuestionsObjectEqualityInput>>;
  requires_consent: Scalars['Boolean']['input'];
  requires_contact_email: Scalars['Boolean']['input'];
  requires_contact_info: Scalars['Boolean']['input'];
  requires_contact_name: Scalars['Boolean']['input'];
  requires_contact_phone_number: Scalars['Boolean']['input'];
  respondents_count: Scalars['Int']['input'];
  responses_share_id: Scalars['String']['input'];
  responses_share_url: Scalars['String']['input'];
  share_id: Scalars['String']['input'];
  share_url: Scalars['String']['input'];
  show_consent: Scalars['Boolean']['input'];
  show_contact_email: Scalars['Boolean']['input'];
  show_contact_name: Scalars['Boolean']['input'];
  show_contact_phone_number: Scalars['Boolean']['input'];
  tag_share_id: Scalars['String']['input'];
  tag_share_url: Scalars['String']['input'];
};

export type StudentAdksPresetFieldsSetupSignInVideoAskResponseFormQuestions = {
  __typename?: 'StudentAdksPresetFieldsSetupSignInVideoAskResponseFormQuestions';
  question_id: Scalars['String']['output'];
};

export type StudentAdksPresetFieldsSetupSignInVideoAskResponseFormQuestionsCreateInput = {
  question_id: Scalars['String']['input'];
};

export type StudentAdksPresetFieldsSetupSignInVideoAskResponseFormQuestionsObjectEqualityInput = {
  question_id: Scalars['String']['input'];
};

export type StudentAdksPresetFieldsSetupSignInVideoAskResponseObjectEqualityInput = {
  contact: StudentAdksPresetFieldsSetupSignInVideoAskResponseContactObjectEqualityInput;
  event_id: Scalars['String']['input'];
  event_type: Scalars['String']['input'];
  form: StudentAdksPresetFieldsSetupSignInVideoAskResponseFormObjectEqualityInput;
  interaction_id: Scalars['String']['input'];
};

export type StudentAdksPresetFieldsStyling = {
  __typename?: 'StudentAdksPresetFieldsStyling';
  label?: Maybe<Scalars['String']['output']>;
  outlined?: Maybe<Scalars['Boolean']['output']>;
  placeholder?: Maybe<Scalars['String']['output']>;
  prependIcon?: Maybe<Scalars['String']['output']>;
  rounded?: Maybe<Scalars['Boolean']['output']>;
};

export type StudentAdksPresetFieldsStylingCreateInput = {
  label?: InputMaybe<Scalars['String']['input']>;
  outlined?: InputMaybe<Scalars['Boolean']['input']>;
  placeholder?: InputMaybe<Scalars['String']['input']>;
  prependIcon?: InputMaybe<Scalars['String']['input']>;
  rounded?: InputMaybe<Scalars['Boolean']['input']>;
};

export type StudentAdksPresetFieldsStylingObjectEqualityInput = {
  label?: InputMaybe<Scalars['String']['input']>;
  outlined?: InputMaybe<Scalars['Boolean']['input']>;
  placeholder?: InputMaybe<Scalars['String']['input']>;
  prependIcon?: InputMaybe<Scalars['String']['input']>;
  rounded?: InputMaybe<Scalars['Boolean']['input']>;
};

export type StudentAdksPresetFieldsValue = {
  __typename?: 'StudentAdksPresetFieldsValue';
  /** Could not determine type: the field only had null or empty values in the sample set. */
  boards?: Maybe<Scalars['JSON']['output']>;
  bookmarkedQuestions?: Maybe<Array<Scalars['String']['output']>>;
  directoryPreferences?: Maybe<Array<StudentAdksPresetFieldsValueDirectoryPreferences>>;
  discordData?: Maybe<StudentAdksPresetFieldsValueDiscordData>;
  discordInfo?: Maybe<StudentAdksPresetFieldsValueDiscordInfo>;
  dislikedQuestions?: Maybe<Array<Scalars['String']['output']>>;
  driveLink?: Maybe<Scalars['String']['output']>;
  endEarlyActivity?: Maybe<Scalars['String']['output']>;
  flaggedComments?: Maybe<Array<Scalars['String']['output']>>;
  groupActivity?: Maybe<Scalars['String']['output']>;
  lastInteraction?: Maybe<Scalars['String']['output']>;
  lastInteractionId?: Maybe<Scalars['String']['output']>;
  likedComments?: Maybe<Array<Scalars['String']['output']>>;
  likedQuestions?: Maybe<Array<Scalars['String']['output']>>;
  logs?: Maybe<Array<StudentAdksPresetFieldsValueLogs>>;
  maxCharacters?: Maybe<Scalars['String']['output']>;
  maxQuestions?: Maybe<Scalars['Int']['output']>;
  maxTeamMembers?: Maybe<Scalars['Int']['output']>;
  minLogs?: Maybe<Scalars['Int']['output']>;
  minimumHoursNow?: Maybe<Scalars['String']['output']>;
  practiceLog?: Maybe<Array<StudentAdksPresetFieldsValuePracticeLog>>;
  /** Could not determine type: the field only had null or empty values in the sample set. */
  questionsAsked?: Maybe<Scalars['JSON']['output']>;
  requiredActivity?: Maybe<Scalars['String']['output']>;
  settings?: Maybe<StudentAdksPresetFieldsValueSettings>;
  signInVideoAskResponse?: Maybe<StudentAdksPresetFieldsValueSignInVideoAskResponse>;
  signOffVideoAskResponse?: Maybe<StudentAdksPresetFieldsValueSignOffVideoAskResponse>;
  submittedVideo?: Maybe<StudentAdksPresetFieldsValueSubmittedVideo>;
  timesheetDetails?: Maybe<Array<StudentAdksPresetFieldsValueTimesheetDetails>>;
  valueDrafts?: Maybe<Array<StudentAdksPresetFieldsValueValueDrafts>>;
  videoMaxLength?: Maybe<Scalars['Int']['output']>;
  welcomeActivity?: Maybe<Scalars['String']['output']>;
};

export type StudentAdksPresetFieldsValueCreateInput = {
  boards?: InputMaybe<Scalars['JSON']['input']>;
  bookmarkedQuestions?: InputMaybe<StudentAdksPresetFieldsValueCreatebookmarkedQuestionsInput>;
  directoryPreferences?: InputMaybe<Array<StudentAdksPresetFieldsValueDirectoryPreferencesCreateInput>>;
  discordData?: InputMaybe<StudentAdksPresetFieldsValueDiscordDataCreateInput>;
  discordInfo?: InputMaybe<StudentAdksPresetFieldsValueDiscordInfoCreateInput>;
  dislikedQuestions?: InputMaybe<StudentAdksPresetFieldsValueCreatedislikedQuestionsInput>;
  driveLink?: InputMaybe<Scalars['String']['input']>;
  endEarlyActivity?: InputMaybe<Scalars['String']['input']>;
  flaggedComments?: InputMaybe<StudentAdksPresetFieldsValueCreateflaggedCommentsInput>;
  groupActivity?: InputMaybe<Scalars['String']['input']>;
  lastInteraction?: InputMaybe<Scalars['String']['input']>;
  lastInteractionId?: InputMaybe<Scalars['String']['input']>;
  likedComments?: InputMaybe<StudentAdksPresetFieldsValueCreatelikedCommentsInput>;
  likedQuestions?: InputMaybe<StudentAdksPresetFieldsValueCreatelikedQuestionsInput>;
  logs?: InputMaybe<Array<StudentAdksPresetFieldsValueLogsCreateInput>>;
  maxCharacters?: InputMaybe<Scalars['String']['input']>;
  maxQuestions?: InputMaybe<Scalars['Int']['input']>;
  maxTeamMembers?: InputMaybe<Scalars['Int']['input']>;
  minLogs?: InputMaybe<Scalars['Int']['input']>;
  minimumHoursNow?: InputMaybe<Scalars['String']['input']>;
  practiceLog?: InputMaybe<Array<StudentAdksPresetFieldsValuePracticeLogCreateInput>>;
  questionsAsked?: InputMaybe<Scalars['JSON']['input']>;
  requiredActivity?: InputMaybe<Scalars['String']['input']>;
  settings?: InputMaybe<StudentAdksPresetFieldsValueSettingsCreateInput>;
  signInVideoAskResponse?: InputMaybe<StudentAdksPresetFieldsValueSignInVideoAskResponseCreateInput>;
  signOffVideoAskResponse?: InputMaybe<StudentAdksPresetFieldsValueSignOffVideoAskResponseCreateInput>;
  submittedVideo?: InputMaybe<StudentAdksPresetFieldsValueSubmittedVideoCreateInput>;
  timesheetDetails?: InputMaybe<Array<StudentAdksPresetFieldsValueTimesheetDetailsCreateInput>>;
  valueDrafts?: InputMaybe<Array<StudentAdksPresetFieldsValueValueDraftsCreateInput>>;
  videoMaxLength?: InputMaybe<Scalars['Int']['input']>;
  welcomeActivity?: InputMaybe<Scalars['String']['input']>;
};

export type StudentAdksPresetFieldsValueCreatebookmarkedQuestionsInput = {
  set: Array<Scalars['String']['input']>;
};

export type StudentAdksPresetFieldsValueCreatedislikedQuestionsInput = {
  set: Array<Scalars['String']['input']>;
};

export type StudentAdksPresetFieldsValueCreateflaggedCommentsInput = {
  set: Array<Scalars['String']['input']>;
};

export type StudentAdksPresetFieldsValueCreatelikedCommentsInput = {
  set: Array<Scalars['String']['input']>;
};

export type StudentAdksPresetFieldsValueCreatelikedQuestionsInput = {
  set: Array<Scalars['String']['input']>;
};

export type StudentAdksPresetFieldsValueDirectoryPreferences = {
  __typename?: 'StudentAdksPresetFieldsValueDirectoryPreferences';
  contactMethod?: Maybe<Array<Scalars['String']['output']>>;
  contactMethods?: Maybe<Array<Scalars['String']['output']>>;
  contactPreferences?: Maybe<Array<Scalars['String']['output']>>;
  hideEmail: Scalars['Boolean']['output'];
  hidePhone: Scalars['Boolean']['output'];
  schedulingLink?: Maybe<Scalars['String']['output']>;
  /** Multiple data types found: String: 1.7%, String (ObjectId): 98.3% out of 242 sampled entries */
  userId?: Maybe<Scalars['JSON']['output']>;
};

export type StudentAdksPresetFieldsValueDirectoryPreferencesCreateInput = {
  contactMethod?: InputMaybe<StudentAdksPresetFieldsValueDirectoryPreferencesCreatecontactMethodInput>;
  contactMethods?: InputMaybe<StudentAdksPresetFieldsValueDirectoryPreferencesCreatecontactMethodsInput>;
  contactPreferences?: InputMaybe<StudentAdksPresetFieldsValueDirectoryPreferencesCreatecontactPreferencesInput>;
  hideEmail: Scalars['Boolean']['input'];
  hidePhone: Scalars['Boolean']['input'];
  schedulingLink?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['JSON']['input']>;
};

export type StudentAdksPresetFieldsValueDirectoryPreferencesCreatecontactMethodInput = {
  set: Array<Scalars['String']['input']>;
};

export type StudentAdksPresetFieldsValueDirectoryPreferencesCreatecontactMethodsInput = {
  set: Array<Scalars['String']['input']>;
};

export type StudentAdksPresetFieldsValueDirectoryPreferencesCreatecontactPreferencesInput = {
  set: Array<Scalars['String']['input']>;
};

export type StudentAdksPresetFieldsValueDirectoryPreferencesObjectEqualityInput = {
  contactMethod?: InputMaybe<Array<Scalars['String']['input']>>;
  contactMethods?: InputMaybe<Array<Scalars['String']['input']>>;
  contactPreferences?: InputMaybe<Array<Scalars['String']['input']>>;
  hideEmail: Scalars['Boolean']['input'];
  hidePhone: Scalars['Boolean']['input'];
  schedulingLink?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['JSON']['input']>;
};

export type StudentAdksPresetFieldsValueDiscordData = {
  __typename?: 'StudentAdksPresetFieldsValueDiscordData';
  channel?: Maybe<StudentAdksPresetFieldsValueDiscordDataChannel>;
  createdBy: StudentAdksPresetFieldsValueDiscordDataCreatedBy;
  role: StudentAdksPresetFieldsValueDiscordDataRole;
};

export type StudentAdksPresetFieldsValueDiscordDataChannel = {
  __typename?: 'StudentAdksPresetFieldsValueDiscordDataChannel';
  flags: Scalars['Int']['output'];
  guild_id: Scalars['String']['output'];
  id: Scalars['String']['output'];
  /** Could not determine type: the field only had null or empty values in the sample set. */
  last_message_id?: Maybe<Scalars['JSON']['output']>;
  name: Scalars['String']['output'];
  nsfw: Scalars['Boolean']['output'];
  parent_id: Scalars['String']['output'];
  permission_overwrites?: Maybe<Array<StudentAdksPresetFieldsValueDiscordDataChannelPermissionOverwrites>>;
  position: Scalars['Int']['output'];
  rate_limit_per_user: Scalars['Int']['output'];
  /** Could not determine type: the field only had null or empty values in the sample set. */
  topic?: Maybe<Scalars['JSON']['output']>;
  type: Scalars['Int']['output'];
};

export type StudentAdksPresetFieldsValueDiscordDataChannelCreateInput = {
  flags: Scalars['Int']['input'];
  guild_id: Scalars['String']['input'];
  id: Scalars['String']['input'];
  last_message_id?: InputMaybe<Scalars['JSON']['input']>;
  name: Scalars['String']['input'];
  nsfw: Scalars['Boolean']['input'];
  parent_id: Scalars['String']['input'];
  permission_overwrites?: InputMaybe<Array<StudentAdksPresetFieldsValueDiscordDataChannelPermissionOverwritesCreateInput>>;
  position: Scalars['Int']['input'];
  rate_limit_per_user: Scalars['Int']['input'];
  topic?: InputMaybe<Scalars['JSON']['input']>;
  type: Scalars['Int']['input'];
};

export type StudentAdksPresetFieldsValueDiscordDataChannelObjectEqualityInput = {
  flags: Scalars['Int']['input'];
  guild_id: Scalars['String']['input'];
  id: Scalars['String']['input'];
  last_message_id?: InputMaybe<Scalars['JSON']['input']>;
  name: Scalars['String']['input'];
  nsfw: Scalars['Boolean']['input'];
  parent_id: Scalars['String']['input'];
  permission_overwrites?: InputMaybe<Array<StudentAdksPresetFieldsValueDiscordDataChannelPermissionOverwritesObjectEqualityInput>>;
  position: Scalars['Int']['input'];
  rate_limit_per_user: Scalars['Int']['input'];
  topic?: InputMaybe<Scalars['JSON']['input']>;
  type: Scalars['Int']['input'];
};

export type StudentAdksPresetFieldsValueDiscordDataChannelPermissionOverwrites = {
  __typename?: 'StudentAdksPresetFieldsValueDiscordDataChannelPermissionOverwrites';
  allow: Scalars['Int']['output'];
  allow_new: Scalars['String']['output'];
  deny: Scalars['Int']['output'];
  deny_new: Scalars['String']['output'];
  id: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type StudentAdksPresetFieldsValueDiscordDataChannelPermissionOverwritesCreateInput = {
  allow: Scalars['Int']['input'];
  allow_new: Scalars['String']['input'];
  deny: Scalars['Int']['input'];
  deny_new: Scalars['String']['input'];
  id: Scalars['String']['input'];
  type: Scalars['String']['input'];
};

export type StudentAdksPresetFieldsValueDiscordDataChannelPermissionOverwritesObjectEqualityInput = {
  allow: Scalars['Int']['input'];
  allow_new: Scalars['String']['input'];
  deny: Scalars['Int']['input'];
  deny_new: Scalars['String']['input'];
  id: Scalars['String']['input'];
  type: Scalars['String']['input'];
};

export type StudentAdksPresetFieldsValueDiscordDataCreateInput = {
  channel?: InputMaybe<StudentAdksPresetFieldsValueDiscordDataChannelCreateInput>;
  createdBy: StudentAdksPresetFieldsValueDiscordDataCreatedByCreateInput;
  role: StudentAdksPresetFieldsValueDiscordDataRoleCreateInput;
};

export type StudentAdksPresetFieldsValueDiscordDataCreatedBy = {
  __typename?: 'StudentAdksPresetFieldsValueDiscordDataCreatedBy';
  email: Scalars['String']['output'];
  userType: Scalars['String']['output'];
};

export type StudentAdksPresetFieldsValueDiscordDataCreatedByCreateInput = {
  email: Scalars['String']['input'];
  userType: Scalars['String']['input'];
};

export type StudentAdksPresetFieldsValueDiscordDataCreatedByObjectEqualityInput = {
  email: Scalars['String']['input'];
  userType: Scalars['String']['input'];
};

export type StudentAdksPresetFieldsValueDiscordDataObjectEqualityInput = {
  channel?: InputMaybe<StudentAdksPresetFieldsValueDiscordDataChannelObjectEqualityInput>;
  createdBy: StudentAdksPresetFieldsValueDiscordDataCreatedByObjectEqualityInput;
  role: StudentAdksPresetFieldsValueDiscordDataRoleObjectEqualityInput;
};

export type StudentAdksPresetFieldsValueDiscordDataRole = {
  __typename?: 'StudentAdksPresetFieldsValueDiscordDataRole';
  color?: Maybe<Scalars['Int']['output']>;
  /** Could not determine type: the field only had null or empty values in the sample set. */
  description?: Maybe<Scalars['JSON']['output']>;
  flags?: Maybe<Scalars['Int']['output']>;
  global?: Maybe<Scalars['Boolean']['output']>;
  hoist?: Maybe<Scalars['Boolean']['output']>;
  /** Could not determine type: the field only had null or empty values in the sample set. */
  icon?: Maybe<Scalars['JSON']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  managed?: Maybe<Scalars['Boolean']['output']>;
  mentionable?: Maybe<Scalars['Boolean']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  permissions?: Maybe<Scalars['Int']['output']>;
  permissions_new?: Maybe<Scalars['String']['output']>;
  position?: Maybe<Scalars['Int']['output']>;
  retry_after?: Maybe<Scalars['Float']['output']>;
  /** Could not determine type: the field only had null or empty values in the sample set. */
  unicode_emoji?: Maybe<Scalars['JSON']['output']>;
};

export type StudentAdksPresetFieldsValueDiscordDataRoleCreateInput = {
  color?: InputMaybe<Scalars['Int']['input']>;
  description?: InputMaybe<Scalars['JSON']['input']>;
  flags?: InputMaybe<Scalars['Int']['input']>;
  global?: InputMaybe<Scalars['Boolean']['input']>;
  hoist?: InputMaybe<Scalars['Boolean']['input']>;
  icon?: InputMaybe<Scalars['JSON']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  managed?: InputMaybe<Scalars['Boolean']['input']>;
  mentionable?: InputMaybe<Scalars['Boolean']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  permissions?: InputMaybe<Scalars['Int']['input']>;
  permissions_new?: InputMaybe<Scalars['String']['input']>;
  position?: InputMaybe<Scalars['Int']['input']>;
  retry_after?: InputMaybe<Scalars['Float']['input']>;
  unicode_emoji?: InputMaybe<Scalars['JSON']['input']>;
};

export type StudentAdksPresetFieldsValueDiscordDataRoleObjectEqualityInput = {
  color?: InputMaybe<Scalars['Int']['input']>;
  description?: InputMaybe<Scalars['JSON']['input']>;
  flags?: InputMaybe<Scalars['Int']['input']>;
  global?: InputMaybe<Scalars['Boolean']['input']>;
  hoist?: InputMaybe<Scalars['Boolean']['input']>;
  icon?: InputMaybe<Scalars['JSON']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  managed?: InputMaybe<Scalars['Boolean']['input']>;
  mentionable?: InputMaybe<Scalars['Boolean']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  permissions?: InputMaybe<Scalars['Int']['input']>;
  permissions_new?: InputMaybe<Scalars['String']['input']>;
  position?: InputMaybe<Scalars['Int']['input']>;
  retry_after?: InputMaybe<Scalars['Float']['input']>;
  unicode_emoji?: InputMaybe<Scalars['JSON']['input']>;
};

export type StudentAdksPresetFieldsValueDiscordInfo = {
  __typename?: 'StudentAdksPresetFieldsValueDiscordInfo';
  avatarSrc?: Maybe<Scalars['String']['output']>;
  discordAccessToken: Scalars['String']['output'];
  discordId: Scalars['String']['output'];
  discordRefreshToken: Scalars['String']['output'];
  discordUsername: Scalars['String']['output'];
  expiresIn: Scalars['Int']['output'];
  scope: Scalars['String']['output'];
};

export type StudentAdksPresetFieldsValueDiscordInfoCreateInput = {
  avatarSrc?: InputMaybe<Scalars['String']['input']>;
  discordAccessToken: Scalars['String']['input'];
  discordId: Scalars['String']['input'];
  discordRefreshToken: Scalars['String']['input'];
  discordUsername: Scalars['String']['input'];
  expiresIn: Scalars['Int']['input'];
  scope: Scalars['String']['input'];
};

export type StudentAdksPresetFieldsValueDiscordInfoObjectEqualityInput = {
  avatarSrc?: InputMaybe<Scalars['String']['input']>;
  discordAccessToken: Scalars['String']['input'];
  discordId: Scalars['String']['input'];
  discordRefreshToken: Scalars['String']['input'];
  discordUsername: Scalars['String']['input'];
  expiresIn: Scalars['Int']['input'];
  scope: Scalars['String']['input'];
};

export type StudentAdksPresetFieldsValueLogs = {
  __typename?: 'StudentAdksPresetFieldsValueLogs';
  author: Scalars['String']['output'];
  avatar: Scalars['String']['output'];
  id: Scalars['String']['output'];
  log: Scalars['String']['output'];
  proof?: Maybe<Array<StudentAdksPresetFieldsValueLogsProof>>;
  time: Scalars['String']['output'];
};

export type StudentAdksPresetFieldsValueLogsCreateInput = {
  author: Scalars['String']['input'];
  avatar: Scalars['String']['input'];
  id: Scalars['String']['input'];
  log: Scalars['String']['input'];
  proof?: InputMaybe<Array<StudentAdksPresetFieldsValueLogsProofCreateInput>>;
  time: Scalars['String']['input'];
};

export type StudentAdksPresetFieldsValueLogsObjectEqualityInput = {
  author: Scalars['String']['input'];
  avatar: Scalars['String']['input'];
  id: Scalars['String']['input'];
  log: Scalars['String']['input'];
  proof?: InputMaybe<Array<StudentAdksPresetFieldsValueLogsProofObjectEqualityInput>>;
  time: Scalars['String']['input'];
};

export type StudentAdksPresetFieldsValueLogsProof = {
  __typename?: 'StudentAdksPresetFieldsValueLogsProof';
  name: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type StudentAdksPresetFieldsValueLogsProofCreateInput = {
  name: Scalars['String']['input'];
  url: Scalars['String']['input'];
};

export type StudentAdksPresetFieldsValueLogsProofObjectEqualityInput = {
  name: Scalars['String']['input'];
  url: Scalars['String']['input'];
};

export type StudentAdksPresetFieldsValueObjectEqualityInput = {
  boards?: InputMaybe<Scalars['JSON']['input']>;
  bookmarkedQuestions?: InputMaybe<Array<Scalars['String']['input']>>;
  directoryPreferences?: InputMaybe<Array<StudentAdksPresetFieldsValueDirectoryPreferencesObjectEqualityInput>>;
  discordData?: InputMaybe<StudentAdksPresetFieldsValueDiscordDataObjectEqualityInput>;
  discordInfo?: InputMaybe<StudentAdksPresetFieldsValueDiscordInfoObjectEqualityInput>;
  dislikedQuestions?: InputMaybe<Array<Scalars['String']['input']>>;
  driveLink?: InputMaybe<Scalars['String']['input']>;
  endEarlyActivity?: InputMaybe<Scalars['String']['input']>;
  flaggedComments?: InputMaybe<Array<Scalars['String']['input']>>;
  groupActivity?: InputMaybe<Scalars['String']['input']>;
  lastInteraction?: InputMaybe<Scalars['String']['input']>;
  lastInteractionId?: InputMaybe<Scalars['String']['input']>;
  likedComments?: InputMaybe<Array<Scalars['String']['input']>>;
  likedQuestions?: InputMaybe<Array<Scalars['String']['input']>>;
  logs?: InputMaybe<Array<StudentAdksPresetFieldsValueLogsObjectEqualityInput>>;
  maxCharacters?: InputMaybe<Scalars['String']['input']>;
  maxQuestions?: InputMaybe<Scalars['Int']['input']>;
  maxTeamMembers?: InputMaybe<Scalars['Int']['input']>;
  minLogs?: InputMaybe<Scalars['Int']['input']>;
  minimumHoursNow?: InputMaybe<Scalars['String']['input']>;
  practiceLog?: InputMaybe<Array<StudentAdksPresetFieldsValuePracticeLogObjectEqualityInput>>;
  questionsAsked?: InputMaybe<Scalars['JSON']['input']>;
  requiredActivity?: InputMaybe<Scalars['String']['input']>;
  settings?: InputMaybe<StudentAdksPresetFieldsValueSettingsObjectEqualityInput>;
  signInVideoAskResponse?: InputMaybe<StudentAdksPresetFieldsValueSignInVideoAskResponseObjectEqualityInput>;
  signOffVideoAskResponse?: InputMaybe<StudentAdksPresetFieldsValueSignOffVideoAskResponseObjectEqualityInput>;
  submittedVideo?: InputMaybe<StudentAdksPresetFieldsValueSubmittedVideoObjectEqualityInput>;
  timesheetDetails?: InputMaybe<Array<StudentAdksPresetFieldsValueTimesheetDetailsObjectEqualityInput>>;
  valueDrafts?: InputMaybe<Array<StudentAdksPresetFieldsValueValueDraftsObjectEqualityInput>>;
  videoMaxLength?: InputMaybe<Scalars['Int']['input']>;
  welcomeActivity?: InputMaybe<Scalars['String']['input']>;
};

export type StudentAdksPresetFieldsValuePracticeLog = {
  __typename?: 'StudentAdksPresetFieldsValuePracticeLog';
  avatar: Scalars['String']['output'];
  minutes: Scalars['String']['output'];
  name: Scalars['String']['output'];
  timestamp: Scalars['String']['output'];
  user_id: Scalars['String']['output'];
};

export type StudentAdksPresetFieldsValuePracticeLogCreateInput = {
  avatar: Scalars['String']['input'];
  minutes: Scalars['String']['input'];
  name: Scalars['String']['input'];
  timestamp: Scalars['String']['input'];
  user_id: Scalars['String']['input'];
};

export type StudentAdksPresetFieldsValuePracticeLogObjectEqualityInput = {
  avatar: Scalars['String']['input'];
  minutes: Scalars['String']['input'];
  name: Scalars['String']['input'];
  timestamp: Scalars['String']['input'];
  user_id: Scalars['String']['input'];
};

export type StudentAdksPresetFieldsValueSettings = {
  __typename?: 'StudentAdksPresetFieldsValueSettings';
  caseStudySettings: StudentAdksPresetFieldsValueSettingsCaseStudySettings;
  digitalResumeSettings: Scalars['Boolean']['output'];
  presentationSettings: StudentAdksPresetFieldsValueSettingsPresentationSettings;
  projectFAQSettings: Scalars['Boolean']['output'];
  projectImplementationSettings: StudentAdksPresetFieldsValueSettingsProjectImplementationSettings;
  projectPlanSettings: StudentAdksPresetFieldsValueSettingsProjectPlanSettings;
  projectTaskSettings: StudentAdksPresetFieldsValueSettingsProjectTaskSettings;
  teamSettings: StudentAdksPresetFieldsValueSettingsTeamSettings;
  userInterviewSettings: StudentAdksPresetFieldsValueSettingsUserInterviewSettings;
};

export type StudentAdksPresetFieldsValueSettingsCaseStudySettings = {
  __typename?: 'StudentAdksPresetFieldsValueSettingsCaseStudySettings';
  contentSetting?: Maybe<Scalars['String']['output']>;
  required: Scalars['Boolean']['output'];
};

export type StudentAdksPresetFieldsValueSettingsCaseStudySettingsCreateInput = {
  contentSetting?: InputMaybe<Scalars['String']['input']>;
  required: Scalars['Boolean']['input'];
};

export type StudentAdksPresetFieldsValueSettingsCaseStudySettingsObjectEqualityInput = {
  contentSetting?: InputMaybe<Scalars['String']['input']>;
  required: Scalars['Boolean']['input'];
};

export type StudentAdksPresetFieldsValueSettingsCreateInput = {
  caseStudySettings: StudentAdksPresetFieldsValueSettingsCaseStudySettingsCreateInput;
  digitalResumeSettings: Scalars['Boolean']['input'];
  presentationSettings: StudentAdksPresetFieldsValueSettingsPresentationSettingsCreateInput;
  projectFAQSettings: Scalars['Boolean']['input'];
  projectImplementationSettings: StudentAdksPresetFieldsValueSettingsProjectImplementationSettingsCreateInput;
  projectPlanSettings: StudentAdksPresetFieldsValueSettingsProjectPlanSettingsCreateInput;
  projectTaskSettings: StudentAdksPresetFieldsValueSettingsProjectTaskSettingsCreateInput;
  teamSettings: StudentAdksPresetFieldsValueSettingsTeamSettingsCreateInput;
  userInterviewSettings: StudentAdksPresetFieldsValueSettingsUserInterviewSettingsCreateInput;
};

export type StudentAdksPresetFieldsValueSettingsObjectEqualityInput = {
  caseStudySettings: StudentAdksPresetFieldsValueSettingsCaseStudySettingsObjectEqualityInput;
  digitalResumeSettings: Scalars['Boolean']['input'];
  presentationSettings: StudentAdksPresetFieldsValueSettingsPresentationSettingsObjectEqualityInput;
  projectFAQSettings: Scalars['Boolean']['input'];
  projectImplementationSettings: StudentAdksPresetFieldsValueSettingsProjectImplementationSettingsObjectEqualityInput;
  projectPlanSettings: StudentAdksPresetFieldsValueSettingsProjectPlanSettingsObjectEqualityInput;
  projectTaskSettings: StudentAdksPresetFieldsValueSettingsProjectTaskSettingsObjectEqualityInput;
  teamSettings: StudentAdksPresetFieldsValueSettingsTeamSettingsObjectEqualityInput;
  userInterviewSettings: StudentAdksPresetFieldsValueSettingsUserInterviewSettingsObjectEqualityInput;
};

export type StudentAdksPresetFieldsValueSettingsPresentationSettings = {
  __typename?: 'StudentAdksPresetFieldsValueSettingsPresentationSettings';
  maxMins?: Maybe<Scalars['String']['output']>;
  required: Scalars['Boolean']['output'];
};

export type StudentAdksPresetFieldsValueSettingsPresentationSettingsCreateInput = {
  maxMins?: InputMaybe<Scalars['String']['input']>;
  required: Scalars['Boolean']['input'];
};

export type StudentAdksPresetFieldsValueSettingsPresentationSettingsObjectEqualityInput = {
  maxMins?: InputMaybe<Scalars['String']['input']>;
  required: Scalars['Boolean']['input'];
};

export type StudentAdksPresetFieldsValueSettingsProjectImplementationSettings = {
  __typename?: 'StudentAdksPresetFieldsValueSettingsProjectImplementationSettings';
  pilots?: Maybe<Scalars['String']['output']>;
  required: Scalars['Boolean']['output'];
};

export type StudentAdksPresetFieldsValueSettingsProjectImplementationSettingsCreateInput = {
  pilots?: InputMaybe<Scalars['String']['input']>;
  required: Scalars['Boolean']['input'];
};

export type StudentAdksPresetFieldsValueSettingsProjectImplementationSettingsObjectEqualityInput = {
  pilots?: InputMaybe<Scalars['String']['input']>;
  required: Scalars['Boolean']['input'];
};

export type StudentAdksPresetFieldsValueSettingsProjectPlanSettings = {
  __typename?: 'StudentAdksPresetFieldsValueSettingsProjectPlanSettings';
  prePopulate?: Maybe<Scalars['String']['output']>;
  required: Scalars['Boolean']['output'];
};

export type StudentAdksPresetFieldsValueSettingsProjectPlanSettingsCreateInput = {
  prePopulate?: InputMaybe<Scalars['String']['input']>;
  required: Scalars['Boolean']['input'];
};

export type StudentAdksPresetFieldsValueSettingsProjectPlanSettingsObjectEqualityInput = {
  prePopulate?: InputMaybe<Scalars['String']['input']>;
  required: Scalars['Boolean']['input'];
};

export type StudentAdksPresetFieldsValueSettingsProjectTaskSettings = {
  __typename?: 'StudentAdksPresetFieldsValueSettingsProjectTaskSettings';
  required: Scalars['Boolean']['output'];
  taskSetting?: Maybe<Scalars['String']['output']>;
};

export type StudentAdksPresetFieldsValueSettingsProjectTaskSettingsCreateInput = {
  required: Scalars['Boolean']['input'];
  taskSetting?: InputMaybe<Scalars['String']['input']>;
};

export type StudentAdksPresetFieldsValueSettingsProjectTaskSettingsObjectEqualityInput = {
  required: Scalars['Boolean']['input'];
  taskSetting?: InputMaybe<Scalars['String']['input']>;
};

export type StudentAdksPresetFieldsValueSettingsTeamSettings = {
  __typename?: 'StudentAdksPresetFieldsValueSettingsTeamSettings';
  editViewSetting?: Maybe<Scalars['String']['output']>;
  required: Scalars['Boolean']['output'];
};

export type StudentAdksPresetFieldsValueSettingsTeamSettingsCreateInput = {
  editViewSetting?: InputMaybe<Scalars['String']['input']>;
  required: Scalars['Boolean']['input'];
};

export type StudentAdksPresetFieldsValueSettingsTeamSettingsObjectEqualityInput = {
  editViewSetting?: InputMaybe<Scalars['String']['input']>;
  required: Scalars['Boolean']['input'];
};

export type StudentAdksPresetFieldsValueSettingsUserInterviewSettings = {
  __typename?: 'StudentAdksPresetFieldsValueSettingsUserInterviewSettings';
  required: Scalars['Boolean']['output'];
  totalUsers?: Maybe<Scalars['String']['output']>;
};

export type StudentAdksPresetFieldsValueSettingsUserInterviewSettingsCreateInput = {
  required: Scalars['Boolean']['input'];
  totalUsers?: InputMaybe<Scalars['String']['input']>;
};

export type StudentAdksPresetFieldsValueSettingsUserInterviewSettingsObjectEqualityInput = {
  required: Scalars['Boolean']['input'];
  totalUsers?: InputMaybe<Scalars['String']['input']>;
};

export type StudentAdksPresetFieldsValueSignInVideoAskResponse = {
  __typename?: 'StudentAdksPresetFieldsValueSignInVideoAskResponse';
  contact: StudentAdksPresetFieldsValueSignInVideoAskResponseContact;
  event_id: Scalars['String']['output'];
  event_type: Scalars['String']['output'];
  form: StudentAdksPresetFieldsValueSignInVideoAskResponseForm;
  interaction_id: Scalars['String']['output'];
};

export type StudentAdksPresetFieldsValueSignInVideoAskResponseContact = {
  __typename?: 'StudentAdksPresetFieldsValueSignInVideoAskResponseContact';
  answers?: Maybe<Array<StudentAdksPresetFieldsValueSignInVideoAskResponseContactAnswers>>;
  are_answers_public: Scalars['Boolean']['output'];
  are_messages_public: Scalars['Boolean']['output'];
  contact_id: Scalars['String']['output'];
  email: Scalars['String']['output'];
  platform: Scalars['String']['output'];
  share_id: Scalars['String']['output'];
  share_url: Scalars['String']['output'];
  status: Scalars['String']['output'];
};

export type StudentAdksPresetFieldsValueSignInVideoAskResponseContactAnswers = {
  __typename?: 'StudentAdksPresetFieldsValueSignInVideoAskResponseContactAnswers';
  answer_id: Scalars['String']['output'];
  media_id: Scalars['String']['output'];
  media_url: Scalars['String']['output'];
  /** Could not determine type: the field only had null or empty values in the sample set. */
  poll_options?: Maybe<Scalars['JSON']['output']>;
  question_id: Scalars['String']['output'];
};

export type StudentAdksPresetFieldsValueSignInVideoAskResponseContactAnswersCreateInput = {
  answer_id: Scalars['String']['input'];
  media_id: Scalars['String']['input'];
  media_url: Scalars['String']['input'];
  poll_options?: InputMaybe<Scalars['JSON']['input']>;
  question_id: Scalars['String']['input'];
};

export type StudentAdksPresetFieldsValueSignInVideoAskResponseContactAnswersObjectEqualityInput = {
  answer_id: Scalars['String']['input'];
  media_id: Scalars['String']['input'];
  media_url: Scalars['String']['input'];
  poll_options?: InputMaybe<Scalars['JSON']['input']>;
  question_id: Scalars['String']['input'];
};

export type StudentAdksPresetFieldsValueSignInVideoAskResponseContactCreateInput = {
  answers?: InputMaybe<Array<StudentAdksPresetFieldsValueSignInVideoAskResponseContactAnswersCreateInput>>;
  are_answers_public: Scalars['Boolean']['input'];
  are_messages_public: Scalars['Boolean']['input'];
  contact_id: Scalars['String']['input'];
  email: Scalars['String']['input'];
  platform: Scalars['String']['input'];
  share_id: Scalars['String']['input'];
  share_url: Scalars['String']['input'];
  status: Scalars['String']['input'];
};

export type StudentAdksPresetFieldsValueSignInVideoAskResponseContactObjectEqualityInput = {
  answers?: InputMaybe<Array<StudentAdksPresetFieldsValueSignInVideoAskResponseContactAnswersObjectEqualityInput>>;
  are_answers_public: Scalars['Boolean']['input'];
  are_messages_public: Scalars['Boolean']['input'];
  contact_id: Scalars['String']['input'];
  email: Scalars['String']['input'];
  platform: Scalars['String']['input'];
  share_id: Scalars['String']['input'];
  share_url: Scalars['String']['input'];
  status: Scalars['String']['input'];
};

export type StudentAdksPresetFieldsValueSignInVideoAskResponseCreateInput = {
  contact: StudentAdksPresetFieldsValueSignInVideoAskResponseContactCreateInput;
  event_id: Scalars['String']['input'];
  event_type: Scalars['String']['input'];
  form: StudentAdksPresetFieldsValueSignInVideoAskResponseFormCreateInput;
  interaction_id: Scalars['String']['input'];
};

export type StudentAdksPresetFieldsValueSignInVideoAskResponseForm = {
  __typename?: 'StudentAdksPresetFieldsValueSignInVideoAskResponseForm';
  are_answers_public: Scalars['Boolean']['output'];
  are_messages_public: Scalars['Boolean']['output'];
  form_id: Scalars['String']['output'];
  hide_branding: Scalars['Boolean']['output'];
  idle_deadline_time_in_minutes: Scalars['Int']['output'];
  notifications: StudentAdksPresetFieldsValueSignInVideoAskResponseFormNotifications;
  questions?: Maybe<Array<StudentAdksPresetFieldsValueSignInVideoAskResponseFormQuestions>>;
  requires_consent: Scalars['Boolean']['output'];
  requires_contact_email: Scalars['Boolean']['output'];
  requires_contact_info: Scalars['Boolean']['output'];
  requires_contact_name: Scalars['Boolean']['output'];
  requires_contact_phone_number: Scalars['Boolean']['output'];
  respondents_count: Scalars['Int']['output'];
  responses_share_id: Scalars['String']['output'];
  responses_share_url: Scalars['String']['output'];
  share_id: Scalars['String']['output'];
  share_url: Scalars['String']['output'];
  show_consent: Scalars['Boolean']['output'];
  show_contact_email: Scalars['Boolean']['output'];
  show_contact_name: Scalars['Boolean']['output'];
  show_contact_phone_number: Scalars['Boolean']['output'];
  tag_share_id: Scalars['String']['output'];
  tag_share_url: Scalars['String']['output'];
};

export type StudentAdksPresetFieldsValueSignInVideoAskResponseFormCreateInput = {
  are_answers_public: Scalars['Boolean']['input'];
  are_messages_public: Scalars['Boolean']['input'];
  form_id: Scalars['String']['input'];
  hide_branding: Scalars['Boolean']['input'];
  idle_deadline_time_in_minutes: Scalars['Int']['input'];
  notifications: StudentAdksPresetFieldsValueSignInVideoAskResponseFormNotificationsCreateInput;
  questions?: InputMaybe<Array<StudentAdksPresetFieldsValueSignInVideoAskResponseFormQuestionsCreateInput>>;
  requires_consent: Scalars['Boolean']['input'];
  requires_contact_email: Scalars['Boolean']['input'];
  requires_contact_info: Scalars['Boolean']['input'];
  requires_contact_name: Scalars['Boolean']['input'];
  requires_contact_phone_number: Scalars['Boolean']['input'];
  respondents_count: Scalars['Int']['input'];
  responses_share_id: Scalars['String']['input'];
  responses_share_url: Scalars['String']['input'];
  share_id: Scalars['String']['input'];
  share_url: Scalars['String']['input'];
  show_consent: Scalars['Boolean']['input'];
  show_contact_email: Scalars['Boolean']['input'];
  show_contact_name: Scalars['Boolean']['input'];
  show_contact_phone_number: Scalars['Boolean']['input'];
  tag_share_id: Scalars['String']['input'];
  tag_share_url: Scalars['String']['input'];
};

export type StudentAdksPresetFieldsValueSignInVideoAskResponseFormNotifications = {
  __typename?: 'StudentAdksPresetFieldsValueSignInVideoAskResponseFormNotifications';
  send_contact_message_emails: Scalars['Boolean']['output'];
};

export type StudentAdksPresetFieldsValueSignInVideoAskResponseFormNotificationsCreateInput = {
  send_contact_message_emails: Scalars['Boolean']['input'];
};

export type StudentAdksPresetFieldsValueSignInVideoAskResponseFormNotificationsObjectEqualityInput = {
  send_contact_message_emails: Scalars['Boolean']['input'];
};

export type StudentAdksPresetFieldsValueSignInVideoAskResponseFormObjectEqualityInput = {
  are_answers_public: Scalars['Boolean']['input'];
  are_messages_public: Scalars['Boolean']['input'];
  form_id: Scalars['String']['input'];
  hide_branding: Scalars['Boolean']['input'];
  idle_deadline_time_in_minutes: Scalars['Int']['input'];
  notifications: StudentAdksPresetFieldsValueSignInVideoAskResponseFormNotificationsObjectEqualityInput;
  questions?: InputMaybe<Array<StudentAdksPresetFieldsValueSignInVideoAskResponseFormQuestionsObjectEqualityInput>>;
  requires_consent: Scalars['Boolean']['input'];
  requires_contact_email: Scalars['Boolean']['input'];
  requires_contact_info: Scalars['Boolean']['input'];
  requires_contact_name: Scalars['Boolean']['input'];
  requires_contact_phone_number: Scalars['Boolean']['input'];
  respondents_count: Scalars['Int']['input'];
  responses_share_id: Scalars['String']['input'];
  responses_share_url: Scalars['String']['input'];
  share_id: Scalars['String']['input'];
  share_url: Scalars['String']['input'];
  show_consent: Scalars['Boolean']['input'];
  show_contact_email: Scalars['Boolean']['input'];
  show_contact_name: Scalars['Boolean']['input'];
  show_contact_phone_number: Scalars['Boolean']['input'];
  tag_share_id: Scalars['String']['input'];
  tag_share_url: Scalars['String']['input'];
};

export type StudentAdksPresetFieldsValueSignInVideoAskResponseFormQuestions = {
  __typename?: 'StudentAdksPresetFieldsValueSignInVideoAskResponseFormQuestions';
  question_id: Scalars['String']['output'];
};

export type StudentAdksPresetFieldsValueSignInVideoAskResponseFormQuestionsCreateInput = {
  question_id: Scalars['String']['input'];
};

export type StudentAdksPresetFieldsValueSignInVideoAskResponseFormQuestionsObjectEqualityInput = {
  question_id: Scalars['String']['input'];
};

export type StudentAdksPresetFieldsValueSignInVideoAskResponseObjectEqualityInput = {
  contact: StudentAdksPresetFieldsValueSignInVideoAskResponseContactObjectEqualityInput;
  event_id: Scalars['String']['input'];
  event_type: Scalars['String']['input'];
  form: StudentAdksPresetFieldsValueSignInVideoAskResponseFormObjectEqualityInput;
  interaction_id: Scalars['String']['input'];
};

export type StudentAdksPresetFieldsValueSignOffVideoAskResponse = {
  __typename?: 'StudentAdksPresetFieldsValueSignOffVideoAskResponse';
  contact: StudentAdksPresetFieldsValueSignOffVideoAskResponseContact;
  event_id: Scalars['String']['output'];
  event_type: Scalars['String']['output'];
  form: StudentAdksPresetFieldsValueSignOffVideoAskResponseForm;
  interaction_id: Scalars['String']['output'];
};

export type StudentAdksPresetFieldsValueSignOffVideoAskResponseContact = {
  __typename?: 'StudentAdksPresetFieldsValueSignOffVideoAskResponseContact';
  answers?: Maybe<Array<StudentAdksPresetFieldsValueSignOffVideoAskResponseContactAnswers>>;
  are_answers_public: Scalars['Boolean']['output'];
  are_messages_public: Scalars['Boolean']['output'];
  contact_id: Scalars['String']['output'];
  email: Scalars['String']['output'];
  platform: Scalars['String']['output'];
  share_id: Scalars['String']['output'];
  share_url: Scalars['String']['output'];
  status: Scalars['String']['output'];
};

export type StudentAdksPresetFieldsValueSignOffVideoAskResponseContactAnswers = {
  __typename?: 'StudentAdksPresetFieldsValueSignOffVideoAskResponseContactAnswers';
  answer_id: Scalars['String']['output'];
  media_id?: Maybe<Scalars['String']['output']>;
  media_url?: Maybe<Scalars['String']['output']>;
  /** Could not determine type: the field only had null or empty values in the sample set. */
  poll_options?: Maybe<Scalars['JSON']['output']>;
  question_id: Scalars['String']['output'];
};

export type StudentAdksPresetFieldsValueSignOffVideoAskResponseContactAnswersCreateInput = {
  answer_id: Scalars['String']['input'];
  media_id?: InputMaybe<Scalars['String']['input']>;
  media_url?: InputMaybe<Scalars['String']['input']>;
  poll_options?: InputMaybe<Scalars['JSON']['input']>;
  question_id: Scalars['String']['input'];
};

export type StudentAdksPresetFieldsValueSignOffVideoAskResponseContactAnswersObjectEqualityInput = {
  answer_id: Scalars['String']['input'];
  media_id?: InputMaybe<Scalars['String']['input']>;
  media_url?: InputMaybe<Scalars['String']['input']>;
  poll_options?: InputMaybe<Scalars['JSON']['input']>;
  question_id: Scalars['String']['input'];
};

export type StudentAdksPresetFieldsValueSignOffVideoAskResponseContactCreateInput = {
  answers?: InputMaybe<Array<StudentAdksPresetFieldsValueSignOffVideoAskResponseContactAnswersCreateInput>>;
  are_answers_public: Scalars['Boolean']['input'];
  are_messages_public: Scalars['Boolean']['input'];
  contact_id: Scalars['String']['input'];
  email: Scalars['String']['input'];
  platform: Scalars['String']['input'];
  share_id: Scalars['String']['input'];
  share_url: Scalars['String']['input'];
  status: Scalars['String']['input'];
};

export type StudentAdksPresetFieldsValueSignOffVideoAskResponseContactObjectEqualityInput = {
  answers?: InputMaybe<Array<StudentAdksPresetFieldsValueSignOffVideoAskResponseContactAnswersObjectEqualityInput>>;
  are_answers_public: Scalars['Boolean']['input'];
  are_messages_public: Scalars['Boolean']['input'];
  contact_id: Scalars['String']['input'];
  email: Scalars['String']['input'];
  platform: Scalars['String']['input'];
  share_id: Scalars['String']['input'];
  share_url: Scalars['String']['input'];
  status: Scalars['String']['input'];
};

export type StudentAdksPresetFieldsValueSignOffVideoAskResponseCreateInput = {
  contact: StudentAdksPresetFieldsValueSignOffVideoAskResponseContactCreateInput;
  event_id: Scalars['String']['input'];
  event_type: Scalars['String']['input'];
  form: StudentAdksPresetFieldsValueSignOffVideoAskResponseFormCreateInput;
  interaction_id: Scalars['String']['input'];
};

export type StudentAdksPresetFieldsValueSignOffVideoAskResponseForm = {
  __typename?: 'StudentAdksPresetFieldsValueSignOffVideoAskResponseForm';
  are_answers_public: Scalars['Boolean']['output'];
  are_messages_public: Scalars['Boolean']['output'];
  form_id: Scalars['String']['output'];
  hide_branding: Scalars['Boolean']['output'];
  idle_deadline_time_in_minutes: Scalars['Int']['output'];
  notifications: StudentAdksPresetFieldsValueSignOffVideoAskResponseFormNotifications;
  questions?: Maybe<Array<StudentAdksPresetFieldsValueSignOffVideoAskResponseFormQuestions>>;
  requires_consent: Scalars['Boolean']['output'];
  requires_contact_email: Scalars['Boolean']['output'];
  requires_contact_info: Scalars['Boolean']['output'];
  requires_contact_name: Scalars['Boolean']['output'];
  requires_contact_phone_number: Scalars['Boolean']['output'];
  respondents_count: Scalars['Int']['output'];
  responses_share_id: Scalars['String']['output'];
  responses_share_url: Scalars['String']['output'];
  share_id: Scalars['String']['output'];
  share_url: Scalars['String']['output'];
  show_consent: Scalars['Boolean']['output'];
  show_contact_email: Scalars['Boolean']['output'];
  show_contact_name: Scalars['Boolean']['output'];
  show_contact_phone_number: Scalars['Boolean']['output'];
  tag_share_id: Scalars['String']['output'];
  tag_share_url: Scalars['String']['output'];
};

export type StudentAdksPresetFieldsValueSignOffVideoAskResponseFormCreateInput = {
  are_answers_public: Scalars['Boolean']['input'];
  are_messages_public: Scalars['Boolean']['input'];
  form_id: Scalars['String']['input'];
  hide_branding: Scalars['Boolean']['input'];
  idle_deadline_time_in_minutes: Scalars['Int']['input'];
  notifications: StudentAdksPresetFieldsValueSignOffVideoAskResponseFormNotificationsCreateInput;
  questions?: InputMaybe<Array<StudentAdksPresetFieldsValueSignOffVideoAskResponseFormQuestionsCreateInput>>;
  requires_consent: Scalars['Boolean']['input'];
  requires_contact_email: Scalars['Boolean']['input'];
  requires_contact_info: Scalars['Boolean']['input'];
  requires_contact_name: Scalars['Boolean']['input'];
  requires_contact_phone_number: Scalars['Boolean']['input'];
  respondents_count: Scalars['Int']['input'];
  responses_share_id: Scalars['String']['input'];
  responses_share_url: Scalars['String']['input'];
  share_id: Scalars['String']['input'];
  share_url: Scalars['String']['input'];
  show_consent: Scalars['Boolean']['input'];
  show_contact_email: Scalars['Boolean']['input'];
  show_contact_name: Scalars['Boolean']['input'];
  show_contact_phone_number: Scalars['Boolean']['input'];
  tag_share_id: Scalars['String']['input'];
  tag_share_url: Scalars['String']['input'];
};

export type StudentAdksPresetFieldsValueSignOffVideoAskResponseFormNotifications = {
  __typename?: 'StudentAdksPresetFieldsValueSignOffVideoAskResponseFormNotifications';
  send_contact_message_emails: Scalars['Boolean']['output'];
};

export type StudentAdksPresetFieldsValueSignOffVideoAskResponseFormNotificationsCreateInput = {
  send_contact_message_emails: Scalars['Boolean']['input'];
};

export type StudentAdksPresetFieldsValueSignOffVideoAskResponseFormNotificationsObjectEqualityInput = {
  send_contact_message_emails: Scalars['Boolean']['input'];
};

export type StudentAdksPresetFieldsValueSignOffVideoAskResponseFormObjectEqualityInput = {
  are_answers_public: Scalars['Boolean']['input'];
  are_messages_public: Scalars['Boolean']['input'];
  form_id: Scalars['String']['input'];
  hide_branding: Scalars['Boolean']['input'];
  idle_deadline_time_in_minutes: Scalars['Int']['input'];
  notifications: StudentAdksPresetFieldsValueSignOffVideoAskResponseFormNotificationsObjectEqualityInput;
  questions?: InputMaybe<Array<StudentAdksPresetFieldsValueSignOffVideoAskResponseFormQuestionsObjectEqualityInput>>;
  requires_consent: Scalars['Boolean']['input'];
  requires_contact_email: Scalars['Boolean']['input'];
  requires_contact_info: Scalars['Boolean']['input'];
  requires_contact_name: Scalars['Boolean']['input'];
  requires_contact_phone_number: Scalars['Boolean']['input'];
  respondents_count: Scalars['Int']['input'];
  responses_share_id: Scalars['String']['input'];
  responses_share_url: Scalars['String']['input'];
  share_id: Scalars['String']['input'];
  share_url: Scalars['String']['input'];
  show_consent: Scalars['Boolean']['input'];
  show_contact_email: Scalars['Boolean']['input'];
  show_contact_name: Scalars['Boolean']['input'];
  show_contact_phone_number: Scalars['Boolean']['input'];
  tag_share_id: Scalars['String']['input'];
  tag_share_url: Scalars['String']['input'];
};

export type StudentAdksPresetFieldsValueSignOffVideoAskResponseFormQuestions = {
  __typename?: 'StudentAdksPresetFieldsValueSignOffVideoAskResponseFormQuestions';
  question_id: Scalars['String']['output'];
};

export type StudentAdksPresetFieldsValueSignOffVideoAskResponseFormQuestionsCreateInput = {
  question_id: Scalars['String']['input'];
};

export type StudentAdksPresetFieldsValueSignOffVideoAskResponseFormQuestionsObjectEqualityInput = {
  question_id: Scalars['String']['input'];
};

export type StudentAdksPresetFieldsValueSignOffVideoAskResponseObjectEqualityInput = {
  contact: StudentAdksPresetFieldsValueSignOffVideoAskResponseContactObjectEqualityInput;
  event_id: Scalars['String']['input'];
  event_type: Scalars['String']['input'];
  form: StudentAdksPresetFieldsValueSignOffVideoAskResponseFormObjectEqualityInput;
  interaction_id: Scalars['String']['input'];
};

export type StudentAdksPresetFieldsValueSubmittedVideo = {
  __typename?: 'StudentAdksPresetFieldsValueSubmittedVideo';
  contentDetails: StudentAdksPresetFieldsValueSubmittedVideoContentDetails;
  etag: Scalars['String']['output'];
  id: Scalars['String']['output'];
  kind: Scalars['String']['output'];
  snippet: StudentAdksPresetFieldsValueSubmittedVideoSnippet;
  status: StudentAdksPresetFieldsValueSubmittedVideoStatus;
};

export type StudentAdksPresetFieldsValueSubmittedVideoContentDetails = {
  __typename?: 'StudentAdksPresetFieldsValueSubmittedVideoContentDetails';
  caption: Scalars['String']['output'];
  contentRating: StudentAdksPresetFieldsValueSubmittedVideoContentDetailsContentRating;
  definition: Scalars['String']['output'];
  dimension: Scalars['String']['output'];
  duration: Scalars['String']['output'];
  licensedContent: Scalars['Boolean']['output'];
  projection: Scalars['String']['output'];
  regionRestriction?: Maybe<StudentAdksPresetFieldsValueSubmittedVideoContentDetailsRegionRestriction>;
};

export type StudentAdksPresetFieldsValueSubmittedVideoContentDetailsContentRating = {
  __typename?: 'StudentAdksPresetFieldsValueSubmittedVideoContentDetailsContentRating';
  ytRating?: Maybe<Scalars['String']['output']>;
};

export type StudentAdksPresetFieldsValueSubmittedVideoContentDetailsContentRatingCreateInput = {
  ytRating?: InputMaybe<Scalars['String']['input']>;
};

export type StudentAdksPresetFieldsValueSubmittedVideoContentDetailsContentRatingObjectEqualityInput = {
  ytRating?: InputMaybe<Scalars['String']['input']>;
};

export type StudentAdksPresetFieldsValueSubmittedVideoContentDetailsCreateInput = {
  caption: Scalars['String']['input'];
  contentRating: StudentAdksPresetFieldsValueSubmittedVideoContentDetailsContentRatingCreateInput;
  definition: Scalars['String']['input'];
  dimension: Scalars['String']['input'];
  duration: Scalars['String']['input'];
  licensedContent: Scalars['Boolean']['input'];
  projection: Scalars['String']['input'];
  regionRestriction?: InputMaybe<StudentAdksPresetFieldsValueSubmittedVideoContentDetailsRegionRestrictionCreateInput>;
};

export type StudentAdksPresetFieldsValueSubmittedVideoContentDetailsObjectEqualityInput = {
  caption: Scalars['String']['input'];
  contentRating: StudentAdksPresetFieldsValueSubmittedVideoContentDetailsContentRatingObjectEqualityInput;
  definition: Scalars['String']['input'];
  dimension: Scalars['String']['input'];
  duration: Scalars['String']['input'];
  licensedContent: Scalars['Boolean']['input'];
  projection: Scalars['String']['input'];
  regionRestriction?: InputMaybe<StudentAdksPresetFieldsValueSubmittedVideoContentDetailsRegionRestrictionObjectEqualityInput>;
};

export type StudentAdksPresetFieldsValueSubmittedVideoContentDetailsRegionRestriction = {
  __typename?: 'StudentAdksPresetFieldsValueSubmittedVideoContentDetailsRegionRestriction';
  blocked?: Maybe<Array<Scalars['String']['output']>>;
};

export type StudentAdksPresetFieldsValueSubmittedVideoContentDetailsRegionRestrictionCreateInput = {
  blocked?: InputMaybe<StudentAdksPresetFieldsValueSubmittedVideoContentDetailsRegionRestrictionCreateblockedInput>;
};

export type StudentAdksPresetFieldsValueSubmittedVideoContentDetailsRegionRestrictionCreateblockedInput = {
  set: Array<Scalars['String']['input']>;
};

export type StudentAdksPresetFieldsValueSubmittedVideoContentDetailsRegionRestrictionObjectEqualityInput = {
  blocked?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type StudentAdksPresetFieldsValueSubmittedVideoCreateInput = {
  contentDetails: StudentAdksPresetFieldsValueSubmittedVideoContentDetailsCreateInput;
  etag: Scalars['String']['input'];
  id: Scalars['String']['input'];
  kind: Scalars['String']['input'];
  snippet: StudentAdksPresetFieldsValueSubmittedVideoSnippetCreateInput;
  status: StudentAdksPresetFieldsValueSubmittedVideoStatusCreateInput;
};

export type StudentAdksPresetFieldsValueSubmittedVideoObjectEqualityInput = {
  contentDetails: StudentAdksPresetFieldsValueSubmittedVideoContentDetailsObjectEqualityInput;
  etag: Scalars['String']['input'];
  id: Scalars['String']['input'];
  kind: Scalars['String']['input'];
  snippet: StudentAdksPresetFieldsValueSubmittedVideoSnippetObjectEqualityInput;
  status: StudentAdksPresetFieldsValueSubmittedVideoStatusObjectEqualityInput;
};

export type StudentAdksPresetFieldsValueSubmittedVideoSnippet = {
  __typename?: 'StudentAdksPresetFieldsValueSubmittedVideoSnippet';
  categoryId: Scalars['String']['output'];
  channelId: Scalars['String']['output'];
  channelTitle: Scalars['String']['output'];
  defaultAudioLanguage?: Maybe<Scalars['String']['output']>;
  defaultLanguage?: Maybe<Scalars['String']['output']>;
  description: Scalars['String']['output'];
  liveBroadcastContent: Scalars['String']['output'];
  localized: StudentAdksPresetFieldsValueSubmittedVideoSnippetLocalized;
  publishedAt: Scalars['String']['output'];
  tags?: Maybe<Array<Scalars['String']['output']>>;
  thumbnails: StudentAdksPresetFieldsValueSubmittedVideoSnippetThumbnails;
  title: Scalars['String']['output'];
};

export type StudentAdksPresetFieldsValueSubmittedVideoSnippetCreateInput = {
  categoryId: Scalars['String']['input'];
  channelId: Scalars['String']['input'];
  channelTitle: Scalars['String']['input'];
  defaultAudioLanguage?: InputMaybe<Scalars['String']['input']>;
  defaultLanguage?: InputMaybe<Scalars['String']['input']>;
  description: Scalars['String']['input'];
  liveBroadcastContent: Scalars['String']['input'];
  localized: StudentAdksPresetFieldsValueSubmittedVideoSnippetLocalizedCreateInput;
  publishedAt: Scalars['String']['input'];
  tags?: InputMaybe<StudentAdksPresetFieldsValueSubmittedVideoSnippetCreatetagsInput>;
  thumbnails: StudentAdksPresetFieldsValueSubmittedVideoSnippetThumbnailsCreateInput;
  title: Scalars['String']['input'];
};

export type StudentAdksPresetFieldsValueSubmittedVideoSnippetCreatetagsInput = {
  set: Array<Scalars['String']['input']>;
};

export type StudentAdksPresetFieldsValueSubmittedVideoSnippetLocalized = {
  __typename?: 'StudentAdksPresetFieldsValueSubmittedVideoSnippetLocalized';
  description: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type StudentAdksPresetFieldsValueSubmittedVideoSnippetLocalizedCreateInput = {
  description: Scalars['String']['input'];
  title: Scalars['String']['input'];
};

export type StudentAdksPresetFieldsValueSubmittedVideoSnippetLocalizedObjectEqualityInput = {
  description: Scalars['String']['input'];
  title: Scalars['String']['input'];
};

export type StudentAdksPresetFieldsValueSubmittedVideoSnippetObjectEqualityInput = {
  categoryId: Scalars['String']['input'];
  channelId: Scalars['String']['input'];
  channelTitle: Scalars['String']['input'];
  defaultAudioLanguage?: InputMaybe<Scalars['String']['input']>;
  defaultLanguage?: InputMaybe<Scalars['String']['input']>;
  description: Scalars['String']['input'];
  liveBroadcastContent: Scalars['String']['input'];
  localized: StudentAdksPresetFieldsValueSubmittedVideoSnippetLocalizedObjectEqualityInput;
  publishedAt: Scalars['String']['input'];
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  thumbnails: StudentAdksPresetFieldsValueSubmittedVideoSnippetThumbnailsObjectEqualityInput;
  title: Scalars['String']['input'];
};

export type StudentAdksPresetFieldsValueSubmittedVideoSnippetThumbnails = {
  __typename?: 'StudentAdksPresetFieldsValueSubmittedVideoSnippetThumbnails';
  default: StudentAdksPresetFieldsValueSubmittedVideoSnippetThumbnailsDefault;
  high: StudentAdksPresetFieldsValueSubmittedVideoSnippetThumbnailsHigh;
  maxres?: Maybe<StudentAdksPresetFieldsValueSubmittedVideoSnippetThumbnailsMaxres>;
  medium: StudentAdksPresetFieldsValueSubmittedVideoSnippetThumbnailsMedium;
  standard?: Maybe<StudentAdksPresetFieldsValueSubmittedVideoSnippetThumbnailsStandard>;
};

export type StudentAdksPresetFieldsValueSubmittedVideoSnippetThumbnailsCreateInput = {
  default: StudentAdksPresetFieldsValueSubmittedVideoSnippetThumbnailsDefaultCreateInput;
  high: StudentAdksPresetFieldsValueSubmittedVideoSnippetThumbnailsHighCreateInput;
  maxres?: InputMaybe<StudentAdksPresetFieldsValueSubmittedVideoSnippetThumbnailsMaxresCreateInput>;
  medium: StudentAdksPresetFieldsValueSubmittedVideoSnippetThumbnailsMediumCreateInput;
  standard?: InputMaybe<StudentAdksPresetFieldsValueSubmittedVideoSnippetThumbnailsStandardCreateInput>;
};

export type StudentAdksPresetFieldsValueSubmittedVideoSnippetThumbnailsDefault = {
  __typename?: 'StudentAdksPresetFieldsValueSubmittedVideoSnippetThumbnailsDefault';
  height: Scalars['Int']['output'];
  url: Scalars['String']['output'];
  width: Scalars['Int']['output'];
};

export type StudentAdksPresetFieldsValueSubmittedVideoSnippetThumbnailsDefaultCreateInput = {
  height: Scalars['Int']['input'];
  url: Scalars['String']['input'];
  width: Scalars['Int']['input'];
};

export type StudentAdksPresetFieldsValueSubmittedVideoSnippetThumbnailsDefaultObjectEqualityInput = {
  height: Scalars['Int']['input'];
  url: Scalars['String']['input'];
  width: Scalars['Int']['input'];
};

export type StudentAdksPresetFieldsValueSubmittedVideoSnippetThumbnailsHigh = {
  __typename?: 'StudentAdksPresetFieldsValueSubmittedVideoSnippetThumbnailsHigh';
  height: Scalars['Int']['output'];
  url: Scalars['String']['output'];
  width: Scalars['Int']['output'];
};

export type StudentAdksPresetFieldsValueSubmittedVideoSnippetThumbnailsHighCreateInput = {
  height: Scalars['Int']['input'];
  url: Scalars['String']['input'];
  width: Scalars['Int']['input'];
};

export type StudentAdksPresetFieldsValueSubmittedVideoSnippetThumbnailsHighObjectEqualityInput = {
  height: Scalars['Int']['input'];
  url: Scalars['String']['input'];
  width: Scalars['Int']['input'];
};

export type StudentAdksPresetFieldsValueSubmittedVideoSnippetThumbnailsMaxres = {
  __typename?: 'StudentAdksPresetFieldsValueSubmittedVideoSnippetThumbnailsMaxres';
  height: Scalars['Int']['output'];
  url: Scalars['String']['output'];
  width: Scalars['Int']['output'];
};

export type StudentAdksPresetFieldsValueSubmittedVideoSnippetThumbnailsMaxresCreateInput = {
  height: Scalars['Int']['input'];
  url: Scalars['String']['input'];
  width: Scalars['Int']['input'];
};

export type StudentAdksPresetFieldsValueSubmittedVideoSnippetThumbnailsMaxresObjectEqualityInput = {
  height: Scalars['Int']['input'];
  url: Scalars['String']['input'];
  width: Scalars['Int']['input'];
};

export type StudentAdksPresetFieldsValueSubmittedVideoSnippetThumbnailsMedium = {
  __typename?: 'StudentAdksPresetFieldsValueSubmittedVideoSnippetThumbnailsMedium';
  height: Scalars['Int']['output'];
  url: Scalars['String']['output'];
  width: Scalars['Int']['output'];
};

export type StudentAdksPresetFieldsValueSubmittedVideoSnippetThumbnailsMediumCreateInput = {
  height: Scalars['Int']['input'];
  url: Scalars['String']['input'];
  width: Scalars['Int']['input'];
};

export type StudentAdksPresetFieldsValueSubmittedVideoSnippetThumbnailsMediumObjectEqualityInput = {
  height: Scalars['Int']['input'];
  url: Scalars['String']['input'];
  width: Scalars['Int']['input'];
};

export type StudentAdksPresetFieldsValueSubmittedVideoSnippetThumbnailsObjectEqualityInput = {
  default: StudentAdksPresetFieldsValueSubmittedVideoSnippetThumbnailsDefaultObjectEqualityInput;
  high: StudentAdksPresetFieldsValueSubmittedVideoSnippetThumbnailsHighObjectEqualityInput;
  maxres?: InputMaybe<StudentAdksPresetFieldsValueSubmittedVideoSnippetThumbnailsMaxresObjectEqualityInput>;
  medium: StudentAdksPresetFieldsValueSubmittedVideoSnippetThumbnailsMediumObjectEqualityInput;
  standard?: InputMaybe<StudentAdksPresetFieldsValueSubmittedVideoSnippetThumbnailsStandardObjectEqualityInput>;
};

export type StudentAdksPresetFieldsValueSubmittedVideoSnippetThumbnailsStandard = {
  __typename?: 'StudentAdksPresetFieldsValueSubmittedVideoSnippetThumbnailsStandard';
  height: Scalars['Int']['output'];
  url: Scalars['String']['output'];
  width: Scalars['Int']['output'];
};

export type StudentAdksPresetFieldsValueSubmittedVideoSnippetThumbnailsStandardCreateInput = {
  height: Scalars['Int']['input'];
  url: Scalars['String']['input'];
  width: Scalars['Int']['input'];
};

export type StudentAdksPresetFieldsValueSubmittedVideoSnippetThumbnailsStandardObjectEqualityInput = {
  height: Scalars['Int']['input'];
  url: Scalars['String']['input'];
  width: Scalars['Int']['input'];
};

export type StudentAdksPresetFieldsValueSubmittedVideoStatus = {
  __typename?: 'StudentAdksPresetFieldsValueSubmittedVideoStatus';
  embeddable: Scalars['Boolean']['output'];
  license: Scalars['String']['output'];
  madeForKids: Scalars['Boolean']['output'];
  privacyStatus: Scalars['String']['output'];
  publicStatsViewable: Scalars['Boolean']['output'];
  uploadStatus: Scalars['String']['output'];
};

export type StudentAdksPresetFieldsValueSubmittedVideoStatusCreateInput = {
  embeddable: Scalars['Boolean']['input'];
  license: Scalars['String']['input'];
  madeForKids: Scalars['Boolean']['input'];
  privacyStatus: Scalars['String']['input'];
  publicStatsViewable: Scalars['Boolean']['input'];
  uploadStatus: Scalars['String']['input'];
};

export type StudentAdksPresetFieldsValueSubmittedVideoStatusObjectEqualityInput = {
  embeddable: Scalars['Boolean']['input'];
  license: Scalars['String']['input'];
  madeForKids: Scalars['Boolean']['input'];
  privacyStatus: Scalars['String']['input'];
  publicStatsViewable: Scalars['Boolean']['input'];
  uploadStatus: Scalars['String']['input'];
};

export type StudentAdksPresetFieldsValueTimesheetDetails = {
  __typename?: 'StudentAdksPresetFieldsValueTimesheetDetails';
  answerType: Scalars['String']['output'];
  interactionId?: Maybe<Scalars['String']['output']>;
  shareUrl?: Maybe<Scalars['String']['output']>;
  system_generated?: Maybe<Scalars['Boolean']['output']>;
  timesheetFilledAt: Scalars['String']['output'];
  timesheetFor: Scalars['String']['output'];
  timesheetText?: Maybe<Scalars['String']['output']>;
  transcription?: Maybe<Scalars['String']['output']>;
  vibeRating?: Maybe<Scalars['String']['output']>;
};

export type StudentAdksPresetFieldsValueTimesheetDetailsCreateInput = {
  answerType: Scalars['String']['input'];
  interactionId?: InputMaybe<Scalars['String']['input']>;
  shareUrl?: InputMaybe<Scalars['String']['input']>;
  system_generated?: InputMaybe<Scalars['Boolean']['input']>;
  timesheetFilledAt: Scalars['String']['input'];
  timesheetFor: Scalars['String']['input'];
  timesheetText?: InputMaybe<Scalars['String']['input']>;
  transcription?: InputMaybe<Scalars['String']['input']>;
  vibeRating?: InputMaybe<Scalars['String']['input']>;
};

export type StudentAdksPresetFieldsValueTimesheetDetailsObjectEqualityInput = {
  answerType: Scalars['String']['input'];
  interactionId?: InputMaybe<Scalars['String']['input']>;
  shareUrl?: InputMaybe<Scalars['String']['input']>;
  system_generated?: InputMaybe<Scalars['Boolean']['input']>;
  timesheetFilledAt: Scalars['String']['input'];
  timesheetFor: Scalars['String']['input'];
  timesheetText?: InputMaybe<Scalars['String']['input']>;
  transcription?: InputMaybe<Scalars['String']['input']>;
  vibeRating?: InputMaybe<Scalars['String']['input']>;
};

export type StudentAdksPresetFieldsValueValueDrafts = {
  __typename?: 'StudentAdksPresetFieldsValueValueDrafts';
  elevatorPitch?: Maybe<Scalars['String']['output']>;
  finalDraft: Scalars['Boolean']['output'];
  innovation?: Maybe<Scalars['String']['output']>;
  onePitch?: Maybe<Scalars['String']['output']>;
  problem?: Maybe<Scalars['String']['output']>;
  solution?: Maybe<Scalars['String']['output']>;
  user?: Maybe<Scalars['String']['output']>;
};

export type StudentAdksPresetFieldsValueValueDraftsCreateInput = {
  elevatorPitch?: InputMaybe<Scalars['String']['input']>;
  finalDraft: Scalars['Boolean']['input'];
  innovation?: InputMaybe<Scalars['String']['input']>;
  onePitch?: InputMaybe<Scalars['String']['input']>;
  problem?: InputMaybe<Scalars['String']['input']>;
  solution?: InputMaybe<Scalars['String']['input']>;
  user?: InputMaybe<Scalars['String']['input']>;
};

export type StudentAdksPresetFieldsValueValueDraftsObjectEqualityInput = {
  elevatorPitch?: InputMaybe<Scalars['String']['input']>;
  finalDraft: Scalars['Boolean']['input'];
  innovation?: InputMaybe<Scalars['String']['input']>;
  onePitch?: InputMaybe<Scalars['String']['input']>;
  problem?: InputMaybe<Scalars['String']['input']>;
  solution?: InputMaybe<Scalars['String']['input']>;
  user?: InputMaybe<Scalars['String']['input']>;
};

export type StudentAdksRfp = {
  __typename?: 'StudentAdksRfp';
  aboutOrg: Scalars['String']['output'];
  deliverable?: Maybe<Array<Scalars['String']['output']>>;
  employerName: Scalars['String']['output'];
  employerWebsite: Scalars['String']['output'];
  interviewChallenge: Scalars['String']['output'];
  interviewOpportunity: Scalars['String']['output'];
  interviewProblem: Scalars['String']['output'];
  interviewReqeust: Scalars['String']['output'];
  interviewSolution: Scalars['String']['output'];
  introVideo: Scalars['String']['output'];
  outcome?: Maybe<Array<Scalars['String']['output']>>;
  projectReq: Scalars['String']['output'];
  projectScope: Scalars['String']['output'];
  required: Scalars['Boolean']['output'];
  resourceDrive: Scalars['String']['output'];
  resourceFacebook: Scalars['String']['output'];
  resourceInsta: Scalars['String']['output'];
  resourceLinkedIn: Scalars['String']['output'];
  resourceTwitter?: Maybe<Scalars['String']['output']>;
  resourceWeb: Scalars['String']['output'];
  resourceYouTube: Scalars['String']['output'];
};

export type StudentAdksRfpCreateInput = {
  aboutOrg: Scalars['String']['input'];
  deliverable?: InputMaybe<StudentAdksRfpCreatedeliverableInput>;
  employerName: Scalars['String']['input'];
  employerWebsite: Scalars['String']['input'];
  interviewChallenge: Scalars['String']['input'];
  interviewOpportunity: Scalars['String']['input'];
  interviewProblem: Scalars['String']['input'];
  interviewReqeust: Scalars['String']['input'];
  interviewSolution: Scalars['String']['input'];
  introVideo: Scalars['String']['input'];
  outcome?: InputMaybe<StudentAdksRfpCreateoutcomeInput>;
  projectReq: Scalars['String']['input'];
  projectScope: Scalars['String']['input'];
  required: Scalars['Boolean']['input'];
  resourceDrive: Scalars['String']['input'];
  resourceFacebook: Scalars['String']['input'];
  resourceInsta: Scalars['String']['input'];
  resourceLinkedIn: Scalars['String']['input'];
  resourceTwitter?: InputMaybe<Scalars['String']['input']>;
  resourceWeb: Scalars['String']['input'];
  resourceYouTube: Scalars['String']['input'];
};

export type StudentAdksRfpCreatedeliverableInput = {
  set: Array<Scalars['String']['input']>;
};

export type StudentAdksRfpCreateoutcomeInput = {
  set: Array<Scalars['String']['input']>;
};

export type StudentAdksRfpObjectEqualityInput = {
  aboutOrg: Scalars['String']['input'];
  deliverable?: InputMaybe<Array<Scalars['String']['input']>>;
  employerName: Scalars['String']['input'];
  employerWebsite: Scalars['String']['input'];
  interviewChallenge: Scalars['String']['input'];
  interviewOpportunity: Scalars['String']['input'];
  interviewProblem: Scalars['String']['input'];
  interviewReqeust: Scalars['String']['input'];
  interviewSolution: Scalars['String']['input'];
  introVideo: Scalars['String']['input'];
  outcome?: InputMaybe<Array<Scalars['String']['input']>>;
  projectReq: Scalars['String']['input'];
  projectScope: Scalars['String']['input'];
  required: Scalars['Boolean']['input'];
  resourceDrive: Scalars['String']['input'];
  resourceFacebook: Scalars['String']['input'];
  resourceInsta: Scalars['String']['input'];
  resourceLinkedIn: Scalars['String']['input'];
  resourceTwitter?: InputMaybe<Scalars['String']['input']>;
  resourceWeb: Scalars['String']['input'];
  resourceYouTube: Scalars['String']['input'];
};

export type StudentAdksScope = {
  __typename?: 'StudentAdksScope';
  aboutOrg: Scalars['String']['output'];
  deliverable?: Maybe<Array<Scalars['String']['output']>>;
  employerName: Scalars['String']['output'];
  employerWebsite: Scalars['String']['output'];
  interviewChallenge: Scalars['String']['output'];
  interviewOpportunity: Scalars['String']['output'];
  interviewProblem: Scalars['String']['output'];
  interviewReqeust: Scalars['String']['output'];
  interviewSolution: Scalars['String']['output'];
  introVideo: Scalars['String']['output'];
  outcome?: Maybe<Array<Scalars['String']['output']>>;
  projectReq: Scalars['String']['output'];
  projectScope: Scalars['String']['output'];
  required: Scalars['Boolean']['output'];
  resourceDrive: Scalars['String']['output'];
  resourceFacebook: Scalars['String']['output'];
  resourceInsta: Scalars['String']['output'];
  resourceLinkedIn: Scalars['String']['output'];
  resourceTwitter?: Maybe<Scalars['String']['output']>;
  resourceWeb: Scalars['String']['output'];
  resourceYouTube: Scalars['String']['output'];
};

export type StudentAdksScopeCreateInput = {
  aboutOrg: Scalars['String']['input'];
  deliverable?: InputMaybe<StudentAdksScopeCreatedeliverableInput>;
  employerName: Scalars['String']['input'];
  employerWebsite: Scalars['String']['input'];
  interviewChallenge: Scalars['String']['input'];
  interviewOpportunity: Scalars['String']['input'];
  interviewProblem: Scalars['String']['input'];
  interviewReqeust: Scalars['String']['input'];
  interviewSolution: Scalars['String']['input'];
  introVideo: Scalars['String']['input'];
  outcome?: InputMaybe<StudentAdksScopeCreateoutcomeInput>;
  projectReq: Scalars['String']['input'];
  projectScope: Scalars['String']['input'];
  required: Scalars['Boolean']['input'];
  resourceDrive: Scalars['String']['input'];
  resourceFacebook: Scalars['String']['input'];
  resourceInsta: Scalars['String']['input'];
  resourceLinkedIn: Scalars['String']['input'];
  resourceTwitter?: InputMaybe<Scalars['String']['input']>;
  resourceWeb: Scalars['String']['input'];
  resourceYouTube: Scalars['String']['input'];
};

export type StudentAdksScopeCreatedeliverableInput = {
  set: Array<Scalars['String']['input']>;
};

export type StudentAdksScopeCreateoutcomeInput = {
  set: Array<Scalars['String']['input']>;
};

export type StudentAdksScopeObjectEqualityInput = {
  aboutOrg: Scalars['String']['input'];
  deliverable?: InputMaybe<Array<Scalars['String']['input']>>;
  employerName: Scalars['String']['input'];
  employerWebsite: Scalars['String']['input'];
  interviewChallenge: Scalars['String']['input'];
  interviewOpportunity: Scalars['String']['input'];
  interviewProblem: Scalars['String']['input'];
  interviewReqeust: Scalars['String']['input'];
  interviewSolution: Scalars['String']['input'];
  introVideo: Scalars['String']['input'];
  outcome?: InputMaybe<Array<Scalars['String']['input']>>;
  projectReq: Scalars['String']['input'];
  projectScope: Scalars['String']['input'];
  required: Scalars['Boolean']['input'];
  resourceDrive: Scalars['String']['input'];
  resourceFacebook: Scalars['String']['input'];
  resourceInsta: Scalars['String']['input'];
  resourceLinkedIn: Scalars['String']['input'];
  resourceTwitter?: InputMaybe<Scalars['String']['input']>;
  resourceWeb: Scalars['String']['input'];
  resourceYouTube: Scalars['String']['input'];
};

export type StudentAdksSignOffVideoAskResponse = {
  __typename?: 'StudentAdksSignOffVideoAskResponse';
  contact: StudentAdksSignOffVideoAskResponseContact;
  event_id: Scalars['String']['output'];
  event_type: Scalars['String']['output'];
  form: StudentAdksSignOffVideoAskResponseForm;
  interaction_id: Scalars['String']['output'];
};

export type StudentAdksSignOffVideoAskResponseContact = {
  __typename?: 'StudentAdksSignOffVideoAskResponseContact';
  answers?: Maybe<Array<StudentAdksSignOffVideoAskResponseContactAnswers>>;
  are_answers_public: Scalars['String']['output'];
  are_messages_public: Scalars['String']['output'];
  contact_id: Scalars['String']['output'];
  email: Scalars['String']['output'];
  platform: Scalars['String']['output'];
  share_id: Scalars['String']['output'];
  share_url: Scalars['String']['output'];
  status: Scalars['String']['output'];
};

export type StudentAdksSignOffVideoAskResponseContactAnswers = {
  __typename?: 'StudentAdksSignOffVideoAskResponseContactAnswers';
  answer_id: Scalars['String']['output'];
  media_id?: Maybe<Scalars['String']['output']>;
  media_url?: Maybe<Scalars['String']['output']>;
  /** Could not determine type: the field only had null or empty values in the sample set. */
  poll_options?: Maybe<Scalars['JSON']['output']>;
  question_id: Scalars['String']['output'];
};

export type StudentAdksSignOffVideoAskResponseContactAnswersCreateInput = {
  answer_id: Scalars['String']['input'];
  media_id?: InputMaybe<Scalars['String']['input']>;
  media_url?: InputMaybe<Scalars['String']['input']>;
  poll_options?: InputMaybe<Scalars['JSON']['input']>;
  question_id: Scalars['String']['input'];
};

export type StudentAdksSignOffVideoAskResponseContactAnswersObjectEqualityInput = {
  answer_id: Scalars['String']['input'];
  media_id?: InputMaybe<Scalars['String']['input']>;
  media_url?: InputMaybe<Scalars['String']['input']>;
  poll_options?: InputMaybe<Scalars['JSON']['input']>;
  question_id: Scalars['String']['input'];
};

export type StudentAdksSignOffVideoAskResponseContactCreateInput = {
  answers?: InputMaybe<Array<StudentAdksSignOffVideoAskResponseContactAnswersCreateInput>>;
  are_answers_public: Scalars['String']['input'];
  are_messages_public: Scalars['String']['input'];
  contact_id: Scalars['String']['input'];
  email: Scalars['String']['input'];
  platform: Scalars['String']['input'];
  share_id: Scalars['String']['input'];
  share_url: Scalars['String']['input'];
  status: Scalars['String']['input'];
};

export type StudentAdksSignOffVideoAskResponseContactObjectEqualityInput = {
  answers?: InputMaybe<Array<StudentAdksSignOffVideoAskResponseContactAnswersObjectEqualityInput>>;
  are_answers_public: Scalars['String']['input'];
  are_messages_public: Scalars['String']['input'];
  contact_id: Scalars['String']['input'];
  email: Scalars['String']['input'];
  platform: Scalars['String']['input'];
  share_id: Scalars['String']['input'];
  share_url: Scalars['String']['input'];
  status: Scalars['String']['input'];
};

export type StudentAdksSignOffVideoAskResponseCreateInput = {
  contact: StudentAdksSignOffVideoAskResponseContactCreateInput;
  event_id: Scalars['String']['input'];
  event_type: Scalars['String']['input'];
  form: StudentAdksSignOffVideoAskResponseFormCreateInput;
  interaction_id: Scalars['String']['input'];
};

export type StudentAdksSignOffVideoAskResponseForm = {
  __typename?: 'StudentAdksSignOffVideoAskResponseForm';
  are_answers_public: Scalars['Boolean']['output'];
  are_messages_public: Scalars['Boolean']['output'];
  form_id: Scalars['String']['output'];
  hide_branding: Scalars['String']['output'];
  idle_deadline_time_in_minutes: Scalars['Int']['output'];
  notifications: StudentAdksSignOffVideoAskResponseFormNotifications;
  questions?: Maybe<Array<StudentAdksSignOffVideoAskResponseFormQuestions>>;
  requires_consent: Scalars['String']['output'];
  requires_contact_email: Scalars['Boolean']['output'];
  requires_contact_info: Scalars['Boolean']['output'];
  requires_contact_name: Scalars['Boolean']['output'];
  requires_contact_phone_number: Scalars['Boolean']['output'];
  respondents_count: Scalars['Int']['output'];
  responses_share_id: Scalars['String']['output'];
  responses_share_url: Scalars['String']['output'];
  share_id: Scalars['String']['output'];
  share_url: Scalars['String']['output'];
  show_consent: Scalars['String']['output'];
  show_contact_email: Scalars['Boolean']['output'];
  show_contact_name: Scalars['Boolean']['output'];
  show_contact_phone_number: Scalars['Boolean']['output'];
  tag_share_id: Scalars['String']['output'];
  tag_share_url: Scalars['String']['output'];
};

export type StudentAdksSignOffVideoAskResponseFormCreateInput = {
  are_answers_public: Scalars['Boolean']['input'];
  are_messages_public: Scalars['Boolean']['input'];
  form_id: Scalars['String']['input'];
  hide_branding: Scalars['String']['input'];
  idle_deadline_time_in_minutes: Scalars['Int']['input'];
  notifications: StudentAdksSignOffVideoAskResponseFormNotificationsCreateInput;
  questions?: InputMaybe<Array<StudentAdksSignOffVideoAskResponseFormQuestionsCreateInput>>;
  requires_consent: Scalars['String']['input'];
  requires_contact_email: Scalars['Boolean']['input'];
  requires_contact_info: Scalars['Boolean']['input'];
  requires_contact_name: Scalars['Boolean']['input'];
  requires_contact_phone_number: Scalars['Boolean']['input'];
  respondents_count: Scalars['Int']['input'];
  responses_share_id: Scalars['String']['input'];
  responses_share_url: Scalars['String']['input'];
  share_id: Scalars['String']['input'];
  share_url: Scalars['String']['input'];
  show_consent: Scalars['String']['input'];
  show_contact_email: Scalars['Boolean']['input'];
  show_contact_name: Scalars['Boolean']['input'];
  show_contact_phone_number: Scalars['Boolean']['input'];
  tag_share_id: Scalars['String']['input'];
  tag_share_url: Scalars['String']['input'];
};

export type StudentAdksSignOffVideoAskResponseFormNotifications = {
  __typename?: 'StudentAdksSignOffVideoAskResponseFormNotifications';
  send_contact_message_emails: Scalars['Boolean']['output'];
};

export type StudentAdksSignOffVideoAskResponseFormNotificationsCreateInput = {
  send_contact_message_emails: Scalars['Boolean']['input'];
};

export type StudentAdksSignOffVideoAskResponseFormNotificationsObjectEqualityInput = {
  send_contact_message_emails: Scalars['Boolean']['input'];
};

export type StudentAdksSignOffVideoAskResponseFormObjectEqualityInput = {
  are_answers_public: Scalars['Boolean']['input'];
  are_messages_public: Scalars['Boolean']['input'];
  form_id: Scalars['String']['input'];
  hide_branding: Scalars['String']['input'];
  idle_deadline_time_in_minutes: Scalars['Int']['input'];
  notifications: StudentAdksSignOffVideoAskResponseFormNotificationsObjectEqualityInput;
  questions?: InputMaybe<Array<StudentAdksSignOffVideoAskResponseFormQuestionsObjectEqualityInput>>;
  requires_consent: Scalars['String']['input'];
  requires_contact_email: Scalars['Boolean']['input'];
  requires_contact_info: Scalars['Boolean']['input'];
  requires_contact_name: Scalars['Boolean']['input'];
  requires_contact_phone_number: Scalars['Boolean']['input'];
  respondents_count: Scalars['Int']['input'];
  responses_share_id: Scalars['String']['input'];
  responses_share_url: Scalars['String']['input'];
  share_id: Scalars['String']['input'];
  share_url: Scalars['String']['input'];
  show_consent: Scalars['String']['input'];
  show_contact_email: Scalars['Boolean']['input'];
  show_contact_name: Scalars['Boolean']['input'];
  show_contact_phone_number: Scalars['Boolean']['input'];
  tag_share_id: Scalars['String']['input'];
  tag_share_url: Scalars['String']['input'];
};

export type StudentAdksSignOffVideoAskResponseFormQuestions = {
  __typename?: 'StudentAdksSignOffVideoAskResponseFormQuestions';
  question_id: Scalars['String']['output'];
};

export type StudentAdksSignOffVideoAskResponseFormQuestionsCreateInput = {
  question_id: Scalars['String']['input'];
};

export type StudentAdksSignOffVideoAskResponseFormQuestionsObjectEqualityInput = {
  question_id: Scalars['String']['input'];
};

export type StudentAdksSignOffVideoAskResponseObjectEqualityInput = {
  contact: StudentAdksSignOffVideoAskResponseContactObjectEqualityInput;
  event_id: Scalars['String']['input'];
  event_type: Scalars['String']['input'];
  form: StudentAdksSignOffVideoAskResponseFormObjectEqualityInput;
  interaction_id: Scalars['String']['input'];
};

export type StudentAdksStyling = {
  __typename?: 'StudentAdksStyling';
  borderColor: Scalars['String']['output'];
};

export type StudentAdksStylingCreateInput = {
  borderColor: Scalars['String']['input'];
};

export type StudentAdksStylingObjectEqualityInput = {
  borderColor: Scalars['String']['input'];
};

export type StudentAdksTimesheetDetails = {
  __typename?: 'StudentAdksTimesheetDetails';
  answerType: Scalars['String']['output'];
  /** Could not determine type: the field only had null or empty values in the sample set. */
  shareUrl?: Maybe<Scalars['JSON']['output']>;
  system_generated: Scalars['Boolean']['output'];
  timesheetFilledAt: Scalars['String']['output'];
  timesheetFor: Scalars['String']['output'];
  timesheetText: Scalars['String']['output'];
  /** Could not determine type: the field only had null or empty values in the sample set. */
  transcription?: Maybe<Scalars['JSON']['output']>;
  /** Could not determine type: the field only had null or empty values in the sample set. */
  vibeRating?: Maybe<Scalars['JSON']['output']>;
};

export type StudentAdksTimesheetDetailsCreateInput = {
  answerType: Scalars['String']['input'];
  shareUrl?: InputMaybe<Scalars['JSON']['input']>;
  system_generated: Scalars['Boolean']['input'];
  timesheetFilledAt: Scalars['String']['input'];
  timesheetFor: Scalars['String']['input'];
  timesheetText: Scalars['String']['input'];
  transcription?: InputMaybe<Scalars['JSON']['input']>;
  vibeRating?: InputMaybe<Scalars['JSON']['input']>;
};

export type StudentAdksTimesheetDetailsObjectEqualityInput = {
  answerType: Scalars['String']['input'];
  shareUrl?: InputMaybe<Scalars['JSON']['input']>;
  system_generated: Scalars['Boolean']['input'];
  timesheetFilledAt: Scalars['String']['input'];
  timesheetFor: Scalars['String']['input'];
  timesheetText: Scalars['String']['input'];
  transcription?: InputMaybe<Scalars['JSON']['input']>;
  vibeRating?: InputMaybe<Scalars['JSON']['input']>;
};

export type StudentAdksTrainProgress = {
  __typename?: 'StudentAdksTrainProgress';
  completed: Scalars['Boolean']['output'];
  is_processing: Scalars['Boolean']['output'];
  is_videoask?: Maybe<Scalars['Boolean']['output']>;
  link: Scalars['String']['output'];
  name: Scalars['String']['output'];
  required: Scalars['Boolean']['output'];
  unlocked: Scalars['Boolean']['output'];
  videoAskResponse?: Maybe<StudentAdksTrainProgressVideoAskResponse>;
  videoask_question_url: Scalars['String']['output'];
};

export type StudentAdksTrainProgressCreateInput = {
  completed: Scalars['Boolean']['input'];
  is_processing: Scalars['Boolean']['input'];
  is_videoask?: InputMaybe<Scalars['Boolean']['input']>;
  link: Scalars['String']['input'];
  name: Scalars['String']['input'];
  required: Scalars['Boolean']['input'];
  unlocked: Scalars['Boolean']['input'];
  videoAskResponse?: InputMaybe<StudentAdksTrainProgressVideoAskResponseCreateInput>;
  videoask_question_url: Scalars['String']['input'];
};

export type StudentAdksTrainProgressObjectEqualityInput = {
  completed: Scalars['Boolean']['input'];
  is_processing: Scalars['Boolean']['input'];
  is_videoask?: InputMaybe<Scalars['Boolean']['input']>;
  link: Scalars['String']['input'];
  name: Scalars['String']['input'];
  required: Scalars['Boolean']['input'];
  unlocked: Scalars['Boolean']['input'];
  videoAskResponse?: InputMaybe<StudentAdksTrainProgressVideoAskResponseObjectEqualityInput>;
  videoask_question_url: Scalars['String']['input'];
};

export type StudentAdksTrainProgressVideoAskResponse = {
  __typename?: 'StudentAdksTrainProgressVideoAskResponse';
  contact: StudentAdksTrainProgressVideoAskResponseContact;
  event_id: Scalars['String']['output'];
  event_type: Scalars['String']['output'];
  form: StudentAdksTrainProgressVideoAskResponseForm;
  interaction_id: Scalars['String']['output'];
};

export type StudentAdksTrainProgressVideoAskResponseContact = {
  __typename?: 'StudentAdksTrainProgressVideoAskResponseContact';
  answers?: Maybe<Array<StudentAdksTrainProgressVideoAskResponseContactAnswers>>;
  are_answers_public: Scalars['Boolean']['output'];
  are_messages_public: Scalars['Boolean']['output'];
  contact_id: Scalars['String']['output'];
  email: Scalars['String']['output'];
  platform: Scalars['String']['output'];
  share_id: Scalars['String']['output'];
  share_url: Scalars['String']['output'];
  status: Scalars['String']['output'];
};

export type StudentAdksTrainProgressVideoAskResponseContactAnswers = {
  __typename?: 'StudentAdksTrainProgressVideoAskResponseContactAnswers';
  answer_id: Scalars['String']['output'];
  media_id: Scalars['String']['output'];
  media_url: Scalars['String']['output'];
  /** Could not determine type: the field only had null or empty values in the sample set. */
  poll_options?: Maybe<Scalars['JSON']['output']>;
  question_id: Scalars['String']['output'];
};

export type StudentAdksTrainProgressVideoAskResponseContactAnswersCreateInput = {
  answer_id: Scalars['String']['input'];
  media_id: Scalars['String']['input'];
  media_url: Scalars['String']['input'];
  poll_options?: InputMaybe<Scalars['JSON']['input']>;
  question_id: Scalars['String']['input'];
};

export type StudentAdksTrainProgressVideoAskResponseContactAnswersObjectEqualityInput = {
  answer_id: Scalars['String']['input'];
  media_id: Scalars['String']['input'];
  media_url: Scalars['String']['input'];
  poll_options?: InputMaybe<Scalars['JSON']['input']>;
  question_id: Scalars['String']['input'];
};

export type StudentAdksTrainProgressVideoAskResponseContactCreateInput = {
  answers?: InputMaybe<Array<StudentAdksTrainProgressVideoAskResponseContactAnswersCreateInput>>;
  are_answers_public: Scalars['Boolean']['input'];
  are_messages_public: Scalars['Boolean']['input'];
  contact_id: Scalars['String']['input'];
  email: Scalars['String']['input'];
  platform: Scalars['String']['input'];
  share_id: Scalars['String']['input'];
  share_url: Scalars['String']['input'];
  status: Scalars['String']['input'];
};

export type StudentAdksTrainProgressVideoAskResponseContactObjectEqualityInput = {
  answers?: InputMaybe<Array<StudentAdksTrainProgressVideoAskResponseContactAnswersObjectEqualityInput>>;
  are_answers_public: Scalars['Boolean']['input'];
  are_messages_public: Scalars['Boolean']['input'];
  contact_id: Scalars['String']['input'];
  email: Scalars['String']['input'];
  platform: Scalars['String']['input'];
  share_id: Scalars['String']['input'];
  share_url: Scalars['String']['input'];
  status: Scalars['String']['input'];
};

export type StudentAdksTrainProgressVideoAskResponseCreateInput = {
  contact: StudentAdksTrainProgressVideoAskResponseContactCreateInput;
  event_id: Scalars['String']['input'];
  event_type: Scalars['String']['input'];
  form: StudentAdksTrainProgressVideoAskResponseFormCreateInput;
  interaction_id: Scalars['String']['input'];
};

export type StudentAdksTrainProgressVideoAskResponseForm = {
  __typename?: 'StudentAdksTrainProgressVideoAskResponseForm';
  are_answers_public: Scalars['Boolean']['output'];
  are_messages_public: Scalars['Boolean']['output'];
  form_id: Scalars['String']['output'];
  hide_branding: Scalars['Boolean']['output'];
  idle_deadline_time_in_minutes: Scalars['Int']['output'];
  notifications: StudentAdksTrainProgressVideoAskResponseFormNotifications;
  questions?: Maybe<Array<StudentAdksTrainProgressVideoAskResponseFormQuestions>>;
  requires_consent: Scalars['Boolean']['output'];
  requires_contact_email: Scalars['Boolean']['output'];
  requires_contact_info: Scalars['Boolean']['output'];
  requires_contact_name: Scalars['Boolean']['output'];
  requires_contact_phone_number: Scalars['Boolean']['output'];
  respondents_count: Scalars['Int']['output'];
  responses_share_id: Scalars['String']['output'];
  responses_share_url: Scalars['String']['output'];
  share_id: Scalars['String']['output'];
  share_url: Scalars['String']['output'];
  show_consent: Scalars['Boolean']['output'];
  show_contact_email: Scalars['Boolean']['output'];
  show_contact_name: Scalars['Boolean']['output'];
  show_contact_phone_number: Scalars['Boolean']['output'];
  tag_share_id: Scalars['String']['output'];
  tag_share_url: Scalars['String']['output'];
};

export type StudentAdksTrainProgressVideoAskResponseFormCreateInput = {
  are_answers_public: Scalars['Boolean']['input'];
  are_messages_public: Scalars['Boolean']['input'];
  form_id: Scalars['String']['input'];
  hide_branding: Scalars['Boolean']['input'];
  idle_deadline_time_in_minutes: Scalars['Int']['input'];
  notifications: StudentAdksTrainProgressVideoAskResponseFormNotificationsCreateInput;
  questions?: InputMaybe<Array<StudentAdksTrainProgressVideoAskResponseFormQuestionsCreateInput>>;
  requires_consent: Scalars['Boolean']['input'];
  requires_contact_email: Scalars['Boolean']['input'];
  requires_contact_info: Scalars['Boolean']['input'];
  requires_contact_name: Scalars['Boolean']['input'];
  requires_contact_phone_number: Scalars['Boolean']['input'];
  respondents_count: Scalars['Int']['input'];
  responses_share_id: Scalars['String']['input'];
  responses_share_url: Scalars['String']['input'];
  share_id: Scalars['String']['input'];
  share_url: Scalars['String']['input'];
  show_consent: Scalars['Boolean']['input'];
  show_contact_email: Scalars['Boolean']['input'];
  show_contact_name: Scalars['Boolean']['input'];
  show_contact_phone_number: Scalars['Boolean']['input'];
  tag_share_id: Scalars['String']['input'];
  tag_share_url: Scalars['String']['input'];
};

export type StudentAdksTrainProgressVideoAskResponseFormNotifications = {
  __typename?: 'StudentAdksTrainProgressVideoAskResponseFormNotifications';
  send_contact_message_emails: Scalars['Boolean']['output'];
};

export type StudentAdksTrainProgressVideoAskResponseFormNotificationsCreateInput = {
  send_contact_message_emails: Scalars['Boolean']['input'];
};

export type StudentAdksTrainProgressVideoAskResponseFormNotificationsObjectEqualityInput = {
  send_contact_message_emails: Scalars['Boolean']['input'];
};

export type StudentAdksTrainProgressVideoAskResponseFormObjectEqualityInput = {
  are_answers_public: Scalars['Boolean']['input'];
  are_messages_public: Scalars['Boolean']['input'];
  form_id: Scalars['String']['input'];
  hide_branding: Scalars['Boolean']['input'];
  idle_deadline_time_in_minutes: Scalars['Int']['input'];
  notifications: StudentAdksTrainProgressVideoAskResponseFormNotificationsObjectEqualityInput;
  questions?: InputMaybe<Array<StudentAdksTrainProgressVideoAskResponseFormQuestionsObjectEqualityInput>>;
  requires_consent: Scalars['Boolean']['input'];
  requires_contact_email: Scalars['Boolean']['input'];
  requires_contact_info: Scalars['Boolean']['input'];
  requires_contact_name: Scalars['Boolean']['input'];
  requires_contact_phone_number: Scalars['Boolean']['input'];
  respondents_count: Scalars['Int']['input'];
  responses_share_id: Scalars['String']['input'];
  responses_share_url: Scalars['String']['input'];
  share_id: Scalars['String']['input'];
  share_url: Scalars['String']['input'];
  show_consent: Scalars['Boolean']['input'];
  show_contact_email: Scalars['Boolean']['input'];
  show_contact_name: Scalars['Boolean']['input'];
  show_contact_phone_number: Scalars['Boolean']['input'];
  tag_share_id: Scalars['String']['input'];
  tag_share_url: Scalars['String']['input'];
};

export type StudentAdksTrainProgressVideoAskResponseFormQuestions = {
  __typename?: 'StudentAdksTrainProgressVideoAskResponseFormQuestions';
  question_id: Scalars['String']['output'];
};

export type StudentAdksTrainProgressVideoAskResponseFormQuestionsCreateInput = {
  question_id: Scalars['String']['input'];
};

export type StudentAdksTrainProgressVideoAskResponseFormQuestionsObjectEqualityInput = {
  question_id: Scalars['String']['input'];
};

export type StudentAdksTrainProgressVideoAskResponseObjectEqualityInput = {
  contact: StudentAdksTrainProgressVideoAskResponseContactObjectEqualityInput;
  event_id: Scalars['String']['input'];
  event_type: Scalars['String']['input'];
  form: StudentAdksTrainProgressVideoAskResponseFormObjectEqualityInput;
  interaction_id: Scalars['String']['input'];
};

export type StudentAirtable = {
  __typename?: 'StudentAirtable';
  airtable_id: Scalars['String']['output'];
  created_at: Scalars['DateTime']['output'];
  last_modified_at: Scalars['DateTime']['output'];
  spreadsheet: Scalars['String']['output'];
};

export type StudentAirtableCreateInput = {
  airtable_id: Scalars['String']['input'];
  created_at: Scalars['DateTime']['input'];
  last_modified_at: Scalars['DateTime']['input'];
  spreadsheet: Scalars['String']['input'];
};

export type StudentAirtableObjectEqualityInput = {
  airtable_id: Scalars['String']['input'];
  created_at: Scalars['DateTime']['input'];
  last_modified_at: Scalars['DateTime']['input'];
  spreadsheet: Scalars['String']['input'];
};

export type StudentAvgAggregate = {
  __typename?: 'StudentAvgAggregate';
  percentageCompleted?: Maybe<Scalars['Float']['output']>;
  tokens?: Maybe<Scalars['Float']['output']>;
};

export type StudentBexi = {
  __typename?: 'StudentBexi';
  io: Scalars['Boolean']['output'];
};

export type StudentBexiCreateInput = {
  io: Scalars['Boolean']['input'];
};

export type StudentBexiNullableCompositeFilter = {
  equals?: InputMaybe<StudentBexiObjectEqualityInput>;
  is?: InputMaybe<StudentBexiWhereInput>;
  isNot?: InputMaybe<StudentBexiWhereInput>;
  isSet?: InputMaybe<Scalars['Boolean']['input']>;
};

export type StudentBexiNullableCreateEnvelopeInput = {
  set?: InputMaybe<StudentBexiCreateInput>;
};

export type StudentBexiNullableUpdateEnvelopeInput = {
  set?: InputMaybe<StudentBexiCreateInput>;
  unset?: InputMaybe<Scalars['Boolean']['input']>;
  upsert?: InputMaybe<StudentBexiUpsertInput>;
};

export type StudentBexiObjectEqualityInput = {
  io: Scalars['Boolean']['input'];
};

export type StudentBexiUpdateInput = {
  io?: InputMaybe<BoolFieldUpdateOperationsInput>;
};

export type StudentBexiUpsertInput = {
  set: StudentBexiCreateInput;
  update: StudentBexiUpdateInput;
};

export type StudentBexiWhereInput = {
  AND?: InputMaybe<Array<StudentBexiWhereInput>>;
  NOT?: InputMaybe<Array<StudentBexiWhereInput>>;
  OR?: InputMaybe<Array<StudentBexiWhereInput>>;
  io?: InputMaybe<BoolFilter>;
};

export type StudentBucket = {
  __typename?: 'StudentBucket';
  io: Scalars['Boolean']['output'];
};

export type StudentBucketCreateInput = {
  io: Scalars['Boolean']['input'];
};

export type StudentBucketNullableCompositeFilter = {
  equals?: InputMaybe<StudentBucketObjectEqualityInput>;
  is?: InputMaybe<StudentBucketWhereInput>;
  isNot?: InputMaybe<StudentBucketWhereInput>;
  isSet?: InputMaybe<Scalars['Boolean']['input']>;
};

export type StudentBucketNullableCreateEnvelopeInput = {
  set?: InputMaybe<StudentBucketCreateInput>;
};

export type StudentBucketNullableUpdateEnvelopeInput = {
  set?: InputMaybe<StudentBucketCreateInput>;
  unset?: InputMaybe<Scalars['Boolean']['input']>;
  upsert?: InputMaybe<StudentBucketUpsertInput>;
};

export type StudentBucketObjectEqualityInput = {
  io: Scalars['Boolean']['input'];
};

export type StudentBucketUpdateInput = {
  io?: InputMaybe<BoolFieldUpdateOperationsInput>;
};

export type StudentBucketUpsertInput = {
  set: StudentBucketCreateInput;
  update: StudentBucketUpdateInput;
};

export type StudentBucketWhereInput = {
  AND?: InputMaybe<Array<StudentBucketWhereInput>>;
  NOT?: InputMaybe<Array<StudentBucketWhereInput>>;
  OR?: InputMaybe<Array<StudentBucketWhereInput>>;
  io?: InputMaybe<BoolFilter>;
};

export type StudentCategories = {
  __typename?: 'StudentCategories';
  icon: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type StudentCategoriesCreateInput = {
  icon: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type StudentCategoriesObjectEqualityInput = {
  icon: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type StudentCheckoutQualification = {
  __typename?: 'StudentCheckoutQualification';
  ageLimit?: Maybe<Array<Scalars['Int']['output']>>;
};

export type StudentCheckoutQualificationCreateInput = {
  ageLimit?: InputMaybe<StudentCheckoutQualificationCreateageLimitInput>;
};

export type StudentCheckoutQualificationCreateageLimitInput = {
  set: Array<Scalars['Int']['input']>;
};

export type StudentCheckoutQualificationNullableCompositeFilter = {
  equals?: InputMaybe<StudentCheckoutQualificationObjectEqualityInput>;
  is?: InputMaybe<StudentCheckoutQualificationWhereInput>;
  isNot?: InputMaybe<StudentCheckoutQualificationWhereInput>;
  isSet?: InputMaybe<Scalars['Boolean']['input']>;
};

export type StudentCheckoutQualificationNullableCreateEnvelopeInput = {
  set?: InputMaybe<StudentCheckoutQualificationCreateInput>;
};

export type StudentCheckoutQualificationNullableUpdateEnvelopeInput = {
  set?: InputMaybe<StudentCheckoutQualificationCreateInput>;
  unset?: InputMaybe<Scalars['Boolean']['input']>;
  upsert?: InputMaybe<StudentCheckoutQualificationUpsertInput>;
};

export type StudentCheckoutQualificationObjectEqualityInput = {
  ageLimit?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type StudentCheckoutQualificationUpdateInput = {
  ageLimit?: InputMaybe<StudentCheckoutQualificationUpdateageLimitInput>;
};

export type StudentCheckoutQualificationUpdateageLimitInput = {
  push?: InputMaybe<Array<Scalars['Int']['input']>>;
  set?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type StudentCheckoutQualificationUpsertInput = {
  set: StudentCheckoutQualificationCreateInput;
  update: StudentCheckoutQualificationUpdateInput;
};

export type StudentCheckoutQualificationWhereInput = {
  AND?: InputMaybe<Array<StudentCheckoutQualificationWhereInput>>;
  NOT?: InputMaybe<Array<StudentCheckoutQualificationWhereInput>>;
  OR?: InputMaybe<Array<StudentCheckoutQualificationWhereInput>>;
  ageLimit?: InputMaybe<IntNullableListFilter>;
};

export type StudentClaimedSponsorshipDetails = {
  __typename?: 'StudentClaimedSponsorshipDetails';
  date: Scalars['DateTime']['output'];
  orgId?: Maybe<Scalars['String']['output']>;
  shareCode: Scalars['String']['output'];
  sponsorId: Scalars['String']['output'];
  tokens: Scalars['Int']['output'];
};

export type StudentClaimedSponsorshipDetailsCreateInput = {
  date: Scalars['DateTime']['input'];
  orgId?: InputMaybe<Scalars['String']['input']>;
  shareCode: Scalars['String']['input'];
  sponsorId: Scalars['String']['input'];
  tokens: Scalars['Int']['input'];
};

export type StudentClaimedSponsorshipDetailsNullableCompositeFilter = {
  equals?: InputMaybe<StudentClaimedSponsorshipDetailsObjectEqualityInput>;
  is?: InputMaybe<StudentClaimedSponsorshipDetailsWhereInput>;
  isNot?: InputMaybe<StudentClaimedSponsorshipDetailsWhereInput>;
  isSet?: InputMaybe<Scalars['Boolean']['input']>;
};

export type StudentClaimedSponsorshipDetailsNullableCreateEnvelopeInput = {
  set?: InputMaybe<StudentClaimedSponsorshipDetailsCreateInput>;
};

export type StudentClaimedSponsorshipDetailsNullableUpdateEnvelopeInput = {
  set?: InputMaybe<StudentClaimedSponsorshipDetailsCreateInput>;
  unset?: InputMaybe<Scalars['Boolean']['input']>;
  upsert?: InputMaybe<StudentClaimedSponsorshipDetailsUpsertInput>;
};

export type StudentClaimedSponsorshipDetailsObjectEqualityInput = {
  date: Scalars['DateTime']['input'];
  orgId?: InputMaybe<Scalars['String']['input']>;
  shareCode: Scalars['String']['input'];
  sponsorId: Scalars['String']['input'];
  tokens: Scalars['Int']['input'];
};

export type StudentClaimedSponsorshipDetailsUpdateInput = {
  date?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  orgId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  shareCode?: InputMaybe<StringFieldUpdateOperationsInput>;
  sponsorId?: InputMaybe<StringFieldUpdateOperationsInput>;
  tokens?: InputMaybe<IntFieldUpdateOperationsInput>;
};

export type StudentClaimedSponsorshipDetailsUpsertInput = {
  set: StudentClaimedSponsorshipDetailsCreateInput;
  update: StudentClaimedSponsorshipDetailsUpdateInput;
};

export type StudentClaimedSponsorshipDetailsWhereInput = {
  AND?: InputMaybe<Array<StudentClaimedSponsorshipDetailsWhereInput>>;
  NOT?: InputMaybe<Array<StudentClaimedSponsorshipDetailsWhereInput>>;
  OR?: InputMaybe<Array<StudentClaimedSponsorshipDetailsWhereInput>>;
  date?: InputMaybe<DateTimeFilter>;
  orgId?: InputMaybe<StringNullableFilter>;
  shareCode?: InputMaybe<StringFilter>;
  sponsorId?: InputMaybe<StringFilter>;
  tokens?: InputMaybe<IntFilter>;
};

export type StudentContext = {
  __typename?: 'StudentContext';
  adkIndex: Scalars['Float']['output'];
  fieldIndex: Scalars['Float']['output'];
  programId: Scalars['String']['output'];
  programName: Scalars['String']['output'];
  studentId: Scalars['String']['output'];
  studentName: Scalars['String']['output'];
  studentSchool?: Maybe<Scalars['String']['output']>;
};

export type StudentCountAggregate = {
  __typename?: 'StudentCountAggregate';
  Access_to_a_Smartphone: Scalars['Int']['output'];
  Adobe: Scalars['Int']['output'];
  Adobe_Illustrator: Scalars['Int']['output'];
  Alan_AI: Scalars['Int']['output'];
  Any_type_of_Video_Editting_Software: Scalars['Int']['output'];
  Any_type_of_spreadsheet: Scalars['Int']['output'];
  Cognixion_Speakprose_app: Scalars['Int']['output'];
  D_design: Scalars['Int']['output'];
  Email: Scalars['Int']['output'];
  Good_oral_and_written_communication_skills: Scalars['Int']['output'];
  Graphic_Design_tools: Scalars['Int']['output'];
  Instagram: Scalars['Int']['output'];
  LinkedIn: Scalars['Int']['output'];
  No: Scalars['Int']['output'];
  None__but_comfort_with_video_editing_could_be_helpful: Scalars['Int']['output'];
  Picterra_platform: Scalars['Int']['output'];
  Picterra_university: Scalars['Int']['output'];
  Python_coding_language: Scalars['Int']['output'];
  Social_Media_experience: Scalars['Int']['output'];
  Trello: Scalars['Int']['output'];
  Website_Design: Scalars['Int']['output'];
  _all: Scalars['Int']['output'];
  accessSkills: Scalars['Int']['output'];
  activityNotification: Scalars['Int']['output'];
  anonymous: Scalars['Int']['output'];
  applicationStatus: Scalars['Int']['output'];
  created: Scalars['Int']['output'];
  deadlineCompletion: Scalars['Int']['output'];
  domain: Scalars['Int']['output'];
  enrolledAt: Scalars['Int']['output'];
  externShip: Scalars['Int']['output'];
  google_drive: Scalars['Int']['output'];
  hideCelebrationDialog: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  id__baas_transaction: Scalars['Int']['output'];
  isChennelCreated: Scalars['Int']['output'];
  isContainString: Scalars['Int']['output'];
  isDeliverableAdkCompletedAdded: Scalars['Int']['output'];
  isDeliverableNotExists: Scalars['Int']['output'];
  isLastModifiedAtExists: Scalars['Int']['output'];
  isProgramCheckout: Scalars['Int']['output'];
  isProgramCheckoutBy: Scalars['Int']['output'];
  isProgramTeamNotExists: Scalars['Int']['output'];
  isProgramTeamNotExistsByOwnerOrMember: Scalars['Int']['output'];
  isPublic: Scalars['Int']['output'];
  isResearchProgressAdded: Scalars['Int']['output'];
  isSaveAdkMoleculeAdded: Scalars['Int']['output'];
  isShowTimer: Scalars['Int']['output'];
  isStakeholdersUpdated: Scalars['Int']['output'];
  isStudentSchemaAdded: Scalars['Int']['output'];
  isTeamAdkCompletedAdded: Scalars['Int']['output'];
  isTrainProgressAdded: Scalars['Int']['output'];
  isUniqueFieldIdAdded: Scalars['Int']['output'];
  isUniqueIdAdded: Scalars['Int']['output'];
  isUnsponsoredProgram: Scalars['Int']['output'];
  isUpdateOrg: Scalars['Int']['output'];
  is_default: Scalars['Int']['output'];
  lastSaved: Scalars['Int']['output'];
  last_clock_in: Scalars['Int']['output'];
  last_clock_out: Scalars['Int']['output'];
  last_synced_at: Scalars['Int']['output'];
  microsoft_office: Scalars['Int']['output'];
  navigate_various_workflow_mapping_: Scalars['Int']['output'];
  organizationId: Scalars['Int']['output'];
  organizationName: Scalars['Int']['output'];
  participantType: Scalars['Int']['output'];
  participant_id: Scalars['Int']['output'];
  percentageCompleted: Scalars['Int']['output'];
  previouslyUnsponsored: Scalars['Int']['output'];
  programName: Scalars['Int']['output'];
  program_id: Scalars['Int']['output'];
  progress: Scalars['Int']['output'];
  referralShareCode: Scalars['Int']['output'];
  resourceWeb: Scalars['Int']['output'];
  rewards: Scalars['Int']['output'];
  role: Scalars['Int']['output'];
  schemaJobProgress: Scalars['Int']['output'];
  sharable_url: Scalars['Int']['output'];
  social_media: Scalars['Int']['output'];
  sponsorRequest_id: Scalars['Int']['output'];
  spreadsheets: Scalars['Int']['output'];
  studentEthnicity: Scalars['Int']['output'];
  studentLocation: Scalars['Int']['output'];
  studentResidence: Scalars['Int']['output'];
  studentSchool: Scalars['Int']['output'];
  this_is_for_testing: Scalars['Int']['output'];
  timerType: Scalars['Int']['output'];
  tokens: Scalars['Int']['output'];
  unsponsoredAdk: Scalars['Int']['output'];
};

export type StudentCoverageResult = {
  __typename?: 'StudentCoverageResult';
  covered: Scalars['Boolean']['output'];
  coveredBy?: Maybe<CoveredByInfo>;
};

export type StudentCreateManyParticipantInput = {
  Access_to_a_Smartphone?: InputMaybe<Scalars['Boolean']['input']>;
  Adobe?: InputMaybe<Scalars['Boolean']['input']>;
  Adobe_Illustrator?: InputMaybe<Scalars['Boolean']['input']>;
  Alan_AI?: InputMaybe<Scalars['Boolean']['input']>;
  Any_type_of_Video_Editting_Software?: InputMaybe<Scalars['Boolean']['input']>;
  Any_type_of_spreadsheet?: InputMaybe<Scalars['Boolean']['input']>;
  Bexi?: InputMaybe<StudentBexiNullableCreateEnvelopeInput>;
  Bucket?: InputMaybe<StudentBucketNullableCreateEnvelopeInput>;
  Cognixion_Speakprose_app?: InputMaybe<Scalars['Boolean']['input']>;
  D_design?: InputMaybe<Scalars['Boolean']['input']>;
  Email?: InputMaybe<Scalars['Boolean']['input']>;
  Good_oral_and_written_communication_skills?: InputMaybe<Scalars['Boolean']['input']>;
  Graphic_Design_tools?: InputMaybe<Scalars['Boolean']['input']>;
  Instagram?: InputMaybe<Scalars['Boolean']['input']>;
  LinkedIn?: InputMaybe<Scalars['Boolean']['input']>;
  No?: InputMaybe<Scalars['Boolean']['input']>;
  None__but_comfort_with_video_editing_could_be_helpful?: InputMaybe<Scalars['Boolean']['input']>;
  Picterra_platform?: InputMaybe<Scalars['Boolean']['input']>;
  Picterra_university?: InputMaybe<Scalars['Boolean']['input']>;
  Python_coding_language?: InputMaybe<Scalars['Boolean']['input']>;
  Social_Media_experience?: InputMaybe<Scalars['Boolean']['input']>;
  Trello?: InputMaybe<Scalars['Boolean']['input']>;
  Website_Design?: InputMaybe<Scalars['Boolean']['input']>;
  accessSkills?: InputMaybe<StudentCreateaccessSkillsInput>;
  activityNotification?: InputMaybe<Scalars['Boolean']['input']>;
  adks?: InputMaybe<Array<StudentAdksCreateInput>>;
  airtable?: InputMaybe<Array<StudentAirtableCreateInput>>;
  anonymous?: InputMaybe<Scalars['Boolean']['input']>;
  applicationStatus?: InputMaybe<Scalars['String']['input']>;
  categories?: InputMaybe<Array<StudentCategoriesCreateInput>>;
  checkoutQualification?: InputMaybe<StudentCheckoutQualificationNullableCreateEnvelopeInput>;
  claimedSponsorshipDetails?: InputMaybe<StudentClaimedSponsorshipDetailsNullableCreateEnvelopeInput>;
  created: Scalars['JSON']['input'];
  credentials?: InputMaybe<Array<StudentCredentialsCreateInput>>;
  deadlineCompletion?: InputMaybe<Scalars['String']['input']>;
  domain?: InputMaybe<Scalars['String']['input']>;
  enrolledAt?: InputMaybe<Scalars['DateTime']['input']>;
  externShip?: InputMaybe<Scalars['String']['input']>;
  googleDetails?: InputMaybe<StudentGoogleDetailsNullableCreateEnvelopeInput>;
  google_drive?: InputMaybe<Scalars['Boolean']['input']>;
  hideCelebrationDialog?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  id__baas_transaction?: InputMaybe<Scalars['String']['input']>;
  isChennelCreated?: InputMaybe<Scalars['Boolean']['input']>;
  isContainString?: InputMaybe<Scalars['Boolean']['input']>;
  isDeliverableAdkCompletedAdded?: InputMaybe<Scalars['Boolean']['input']>;
  isDeliverableNotExists?: InputMaybe<Scalars['Boolean']['input']>;
  isLastModifiedAtExists?: InputMaybe<Scalars['Boolean']['input']>;
  isProgramCheckout?: InputMaybe<Scalars['Boolean']['input']>;
  isProgramCheckoutBy?: InputMaybe<Scalars['String']['input']>;
  isProgramTeamNotExists?: InputMaybe<Scalars['Boolean']['input']>;
  isProgramTeamNotExistsByOwnerOrMember?: InputMaybe<Scalars['Boolean']['input']>;
  isPublic?: InputMaybe<Scalars['Boolean']['input']>;
  isResearchProgressAdded?: InputMaybe<Scalars['Boolean']['input']>;
  isSaveAdkMoleculeAdded?: InputMaybe<Scalars['Boolean']['input']>;
  isShowTimer?: InputMaybe<Scalars['Boolean']['input']>;
  isStakeholdersUpdated?: InputMaybe<Scalars['Boolean']['input']>;
  isStudentSchemaAdded?: InputMaybe<Scalars['Boolean']['input']>;
  isTeamAdkCompletedAdded?: InputMaybe<Scalars['Boolean']['input']>;
  isTrainProgressAdded?: InputMaybe<Scalars['Boolean']['input']>;
  isUniqueFieldIdAdded?: InputMaybe<Scalars['Boolean']['input']>;
  isUniqueIdAdded?: InputMaybe<Scalars['Boolean']['input']>;
  isUnsponsoredProgram?: InputMaybe<Scalars['Boolean']['input']>;
  isUpdateOrg?: InputMaybe<Scalars['Boolean']['input']>;
  is_default?: InputMaybe<Scalars['Boolean']['input']>;
  lastSaved?: InputMaybe<Scalars['DateTime']['input']>;
  last_clock_in?: InputMaybe<Scalars['String']['input']>;
  last_clock_out?: InputMaybe<Scalars['String']['input']>;
  last_synced_at: Scalars['DateTime']['input'];
  microsoft_office?: InputMaybe<Scalars['Boolean']['input']>;
  navigate_various_workflow_mapping_?: InputMaybe<Scalars['Boolean']['input']>;
  offerDetails?: InputMaybe<StudentOfferDetailsNullableCreateEnvelopeInput>;
  organizationId?: InputMaybe<Scalars['String']['input']>;
  organizationName?: InputMaybe<Scalars['String']['input']>;
  participantType?: InputMaybe<Scalars['String']['input']>;
  percentageCompleted?: InputMaybe<Scalars['Float']['input']>;
  previouslyUnsponsored?: InputMaybe<Scalars['Boolean']['input']>;
  problemScope?: InputMaybe<Array<StudentProblemScopeCreateInput>>;
  programName?: InputMaybe<Scalars['String']['input']>;
  program_id: Scalars['String']['input'];
  progress?: InputMaybe<Scalars['JSON']['input']>;
  referralShareCode?: InputMaybe<Scalars['String']['input']>;
  resourceWeb?: InputMaybe<Scalars['String']['input']>;
  rewards?: InputMaybe<Scalars['JSON']['input']>;
  role?: InputMaybe<Scalars['JSON']['input']>;
  schemaJobProgress?: InputMaybe<Scalars['Boolean']['input']>;
  sharable_url?: InputMaybe<Scalars['String']['input']>;
  social_media?: InputMaybe<Scalars['Boolean']['input']>;
  sponsorDetails?: InputMaybe<StudentSponsorDetailsNullableCreateEnvelopeInput>;
  sponsorRequest_id?: InputMaybe<Scalars['String']['input']>;
  spreadsheets?: InputMaybe<Scalars['Boolean']['input']>;
  stakeholders?: InputMaybe<Array<StudentStakeholdersCreateInput>>;
  studentEthnicity?: InputMaybe<StudentCreatestudentEthnicityInput>;
  studentLocation?: InputMaybe<Scalars['JSON']['input']>;
  studentResidence?: InputMaybe<Scalars['String']['input']>;
  studentSchool?: InputMaybe<Scalars['String']['input']>;
  this_is_for_testing?: InputMaybe<Scalars['Boolean']['input']>;
  timerType?: InputMaybe<Scalars['String']['input']>;
  tokens?: InputMaybe<Scalars['Int']['input']>;
  unsponsoredAdk?: InputMaybe<Scalars['String']['input']>;
};

export type StudentCreateManyParticipantInputEnvelope = {
  data: Array<StudentCreateManyParticipantInput>;
};

export type StudentCreateNestedManyWithoutParticipantInput = {
  connect?: InputMaybe<Array<StudentWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<StudentCreateOrConnectWithoutParticipantInput>>;
  create?: InputMaybe<Array<StudentCreateWithoutParticipantInput>>;
  createMany?: InputMaybe<StudentCreateManyParticipantInputEnvelope>;
};

export type StudentCreateOrConnectWithoutParticipantInput = {
  create: StudentCreateWithoutParticipantInput;
  where: StudentWhereUniqueInput;
};

export type StudentCreateWithoutParticipantInput = {
  Access_to_a_Smartphone?: InputMaybe<Scalars['Boolean']['input']>;
  Adobe?: InputMaybe<Scalars['Boolean']['input']>;
  Adobe_Illustrator?: InputMaybe<Scalars['Boolean']['input']>;
  Alan_AI?: InputMaybe<Scalars['Boolean']['input']>;
  Any_type_of_Video_Editting_Software?: InputMaybe<Scalars['Boolean']['input']>;
  Any_type_of_spreadsheet?: InputMaybe<Scalars['Boolean']['input']>;
  Bexi?: InputMaybe<StudentBexiNullableCreateEnvelopeInput>;
  Bucket?: InputMaybe<StudentBucketNullableCreateEnvelopeInput>;
  Cognixion_Speakprose_app?: InputMaybe<Scalars['Boolean']['input']>;
  D_design?: InputMaybe<Scalars['Boolean']['input']>;
  Email?: InputMaybe<Scalars['Boolean']['input']>;
  Good_oral_and_written_communication_skills?: InputMaybe<Scalars['Boolean']['input']>;
  Graphic_Design_tools?: InputMaybe<Scalars['Boolean']['input']>;
  Instagram?: InputMaybe<Scalars['Boolean']['input']>;
  LinkedIn?: InputMaybe<Scalars['Boolean']['input']>;
  No?: InputMaybe<Scalars['Boolean']['input']>;
  None__but_comfort_with_video_editing_could_be_helpful?: InputMaybe<Scalars['Boolean']['input']>;
  Picterra_platform?: InputMaybe<Scalars['Boolean']['input']>;
  Picterra_university?: InputMaybe<Scalars['Boolean']['input']>;
  Python_coding_language?: InputMaybe<Scalars['Boolean']['input']>;
  Social_Media_experience?: InputMaybe<Scalars['Boolean']['input']>;
  Trello?: InputMaybe<Scalars['Boolean']['input']>;
  Website_Design?: InputMaybe<Scalars['Boolean']['input']>;
  accessSkills?: InputMaybe<StudentCreateaccessSkillsInput>;
  activityNotification?: InputMaybe<Scalars['Boolean']['input']>;
  adks?: InputMaybe<Array<StudentAdksCreateInput>>;
  airtable?: InputMaybe<Array<StudentAirtableCreateInput>>;
  anonymous?: InputMaybe<Scalars['Boolean']['input']>;
  applicationStatus?: InputMaybe<Scalars['String']['input']>;
  categories?: InputMaybe<Array<StudentCategoriesCreateInput>>;
  checkoutQualification?: InputMaybe<StudentCheckoutQualificationNullableCreateEnvelopeInput>;
  claimedSponsorshipDetails?: InputMaybe<StudentClaimedSponsorshipDetailsNullableCreateEnvelopeInput>;
  created: Scalars['JSON']['input'];
  credentials?: InputMaybe<Array<StudentCredentialsCreateInput>>;
  deadlineCompletion?: InputMaybe<Scalars['String']['input']>;
  domain?: InputMaybe<Scalars['String']['input']>;
  enrolledAt?: InputMaybe<Scalars['DateTime']['input']>;
  externShip?: InputMaybe<Scalars['String']['input']>;
  googleDetails?: InputMaybe<StudentGoogleDetailsNullableCreateEnvelopeInput>;
  google_drive?: InputMaybe<Scalars['Boolean']['input']>;
  hideCelebrationDialog?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  id__baas_transaction?: InputMaybe<Scalars['String']['input']>;
  isChennelCreated?: InputMaybe<Scalars['Boolean']['input']>;
  isContainString?: InputMaybe<Scalars['Boolean']['input']>;
  isDeliverableAdkCompletedAdded?: InputMaybe<Scalars['Boolean']['input']>;
  isDeliverableNotExists?: InputMaybe<Scalars['Boolean']['input']>;
  isLastModifiedAtExists?: InputMaybe<Scalars['Boolean']['input']>;
  isProgramCheckout?: InputMaybe<Scalars['Boolean']['input']>;
  isProgramCheckoutBy?: InputMaybe<Scalars['String']['input']>;
  isProgramTeamNotExists?: InputMaybe<Scalars['Boolean']['input']>;
  isProgramTeamNotExistsByOwnerOrMember?: InputMaybe<Scalars['Boolean']['input']>;
  isPublic?: InputMaybe<Scalars['Boolean']['input']>;
  isResearchProgressAdded?: InputMaybe<Scalars['Boolean']['input']>;
  isSaveAdkMoleculeAdded?: InputMaybe<Scalars['Boolean']['input']>;
  isShowTimer?: InputMaybe<Scalars['Boolean']['input']>;
  isStakeholdersUpdated?: InputMaybe<Scalars['Boolean']['input']>;
  isStudentSchemaAdded?: InputMaybe<Scalars['Boolean']['input']>;
  isTeamAdkCompletedAdded?: InputMaybe<Scalars['Boolean']['input']>;
  isTrainProgressAdded?: InputMaybe<Scalars['Boolean']['input']>;
  isUniqueFieldIdAdded?: InputMaybe<Scalars['Boolean']['input']>;
  isUniqueIdAdded?: InputMaybe<Scalars['Boolean']['input']>;
  isUnsponsoredProgram?: InputMaybe<Scalars['Boolean']['input']>;
  isUpdateOrg?: InputMaybe<Scalars['Boolean']['input']>;
  is_default?: InputMaybe<Scalars['Boolean']['input']>;
  lastSaved?: InputMaybe<Scalars['DateTime']['input']>;
  last_clock_in?: InputMaybe<Scalars['String']['input']>;
  last_clock_out?: InputMaybe<Scalars['String']['input']>;
  last_synced_at: Scalars['DateTime']['input'];
  microsoft_office?: InputMaybe<Scalars['Boolean']['input']>;
  navigate_various_workflow_mapping_?: InputMaybe<Scalars['Boolean']['input']>;
  offerDetails?: InputMaybe<StudentOfferDetailsNullableCreateEnvelopeInput>;
  organizationId?: InputMaybe<Scalars['String']['input']>;
  organizationName?: InputMaybe<Scalars['String']['input']>;
  participantType?: InputMaybe<Scalars['String']['input']>;
  percentageCompleted?: InputMaybe<Scalars['Float']['input']>;
  previouslyUnsponsored?: InputMaybe<Scalars['Boolean']['input']>;
  problemScope?: InputMaybe<Array<StudentProblemScopeCreateInput>>;
  programName?: InputMaybe<Scalars['String']['input']>;
  program_id: Scalars['String']['input'];
  progress?: InputMaybe<Scalars['JSON']['input']>;
  referralShareCode?: InputMaybe<Scalars['String']['input']>;
  resourceWeb?: InputMaybe<Scalars['String']['input']>;
  rewards?: InputMaybe<Scalars['JSON']['input']>;
  role?: InputMaybe<Scalars['JSON']['input']>;
  schemaJobProgress?: InputMaybe<Scalars['Boolean']['input']>;
  sharable_url?: InputMaybe<Scalars['String']['input']>;
  social_media?: InputMaybe<Scalars['Boolean']['input']>;
  sponsorDetails?: InputMaybe<StudentSponsorDetailsNullableCreateEnvelopeInput>;
  sponsorRequest_id?: InputMaybe<Scalars['String']['input']>;
  spreadsheets?: InputMaybe<Scalars['Boolean']['input']>;
  stakeholders?: InputMaybe<Array<StudentStakeholdersCreateInput>>;
  studentEthnicity?: InputMaybe<StudentCreatestudentEthnicityInput>;
  studentLocation?: InputMaybe<Scalars['JSON']['input']>;
  studentResidence?: InputMaybe<Scalars['String']['input']>;
  studentSchool?: InputMaybe<Scalars['String']['input']>;
  this_is_for_testing?: InputMaybe<Scalars['Boolean']['input']>;
  timerType?: InputMaybe<Scalars['String']['input']>;
  tokens?: InputMaybe<Scalars['Int']['input']>;
  unsponsoredAdk?: InputMaybe<Scalars['String']['input']>;
};

export type StudentCreateaccessSkillsInput = {
  set: Array<Scalars['String']['input']>;
};

export type StudentCreatestudentEthnicityInput = {
  set: Array<Scalars['String']['input']>;
};

export type StudentCredentials = {
  __typename?: 'StudentCredentials';
  activities?: Maybe<Array<Scalars['String']['output']>>;
  credentials?: Maybe<Array<Scalars['String']['output']>>;
  id: Scalars['Int']['output'];
};

export type StudentCredentialsCreateInput = {
  activities?: InputMaybe<StudentCredentialsCreateactivitiesInput>;
  credentials?: InputMaybe<StudentCredentialsCreatecredentialsInput>;
  id: Scalars['Int']['input'];
};

export type StudentCredentialsCreateactivitiesInput = {
  set: Array<Scalars['String']['input']>;
};

export type StudentCredentialsCreatecredentialsInput = {
  set: Array<Scalars['String']['input']>;
};

export type StudentCredentialsObjectEqualityInput = {
  activities?: InputMaybe<Array<Scalars['String']['input']>>;
  credentials?: InputMaybe<Array<Scalars['String']['input']>>;
  id: Scalars['Int']['input'];
};

export type StudentGoogleDetails = {
  __typename?: 'StudentGoogleDetails';
  access_token: Scalars['String']['output'];
  email: Scalars['String']['output'];
  expiry_date: Scalars['Float']['output'];
  id_token: Scalars['String']['output'];
  refresh_token: Scalars['String']['output'];
  scope: Scalars['String']['output'];
  token_type: Scalars['String']['output'];
};

export type StudentGoogleDetailsCreateInput = {
  access_token: Scalars['String']['input'];
  email: Scalars['String']['input'];
  expiry_date: Scalars['Float']['input'];
  id_token: Scalars['String']['input'];
  refresh_token: Scalars['String']['input'];
  scope: Scalars['String']['input'];
  token_type: Scalars['String']['input'];
};

export type StudentGoogleDetailsNullableCompositeFilter = {
  equals?: InputMaybe<StudentGoogleDetailsObjectEqualityInput>;
  is?: InputMaybe<StudentGoogleDetailsWhereInput>;
  isNot?: InputMaybe<StudentGoogleDetailsWhereInput>;
  isSet?: InputMaybe<Scalars['Boolean']['input']>;
};

export type StudentGoogleDetailsNullableCreateEnvelopeInput = {
  set?: InputMaybe<StudentGoogleDetailsCreateInput>;
};

export type StudentGoogleDetailsNullableUpdateEnvelopeInput = {
  set?: InputMaybe<StudentGoogleDetailsCreateInput>;
  unset?: InputMaybe<Scalars['Boolean']['input']>;
  upsert?: InputMaybe<StudentGoogleDetailsUpsertInput>;
};

export type StudentGoogleDetailsObjectEqualityInput = {
  access_token: Scalars['String']['input'];
  email: Scalars['String']['input'];
  expiry_date: Scalars['Float']['input'];
  id_token: Scalars['String']['input'];
  refresh_token: Scalars['String']['input'];
  scope: Scalars['String']['input'];
  token_type: Scalars['String']['input'];
};

export type StudentGoogleDetailsUpdateInput = {
  access_token?: InputMaybe<StringFieldUpdateOperationsInput>;
  email?: InputMaybe<StringFieldUpdateOperationsInput>;
  expiry_date?: InputMaybe<FloatFieldUpdateOperationsInput>;
  id_token?: InputMaybe<StringFieldUpdateOperationsInput>;
  refresh_token?: InputMaybe<StringFieldUpdateOperationsInput>;
  scope?: InputMaybe<StringFieldUpdateOperationsInput>;
  token_type?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type StudentGoogleDetailsUpsertInput = {
  set: StudentGoogleDetailsCreateInput;
  update: StudentGoogleDetailsUpdateInput;
};

export type StudentGoogleDetailsWhereInput = {
  AND?: InputMaybe<Array<StudentGoogleDetailsWhereInput>>;
  NOT?: InputMaybe<Array<StudentGoogleDetailsWhereInput>>;
  OR?: InputMaybe<Array<StudentGoogleDetailsWhereInput>>;
  access_token?: InputMaybe<StringFilter>;
  email?: InputMaybe<StringFilter>;
  expiry_date?: InputMaybe<FloatFilter>;
  id_token?: InputMaybe<StringFilter>;
  refresh_token?: InputMaybe<StringFilter>;
  scope?: InputMaybe<StringFilter>;
  token_type?: InputMaybe<StringFilter>;
};

export type StudentInstanceType = {
  __typename?: 'StudentInstanceType';
  created?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isProgramCheckout?: Maybe<Scalars['Boolean']['output']>;
  isProgramCheckoutBy?: Maybe<Scalars['String']['output']>;
  is_default?: Maybe<Scalars['Boolean']['output']>;
  lastSaved?: Maybe<Scalars['DateTime']['output']>;
  latestActivityIndex?: Maybe<Scalars['Float']['output']>;
  latestActivityName?: Maybe<Scalars['String']['output']>;
  latestActivityStartedOn?: Maybe<Scalars['DateTime']['output']>;
  participant_id: Scalars['String']['output'];
  percentageCompleted?: Maybe<Scalars['Float']['output']>;
  program_id: Scalars['String']['output'];
};

export type StudentListRelationFilter = {
  every?: InputMaybe<StudentWhereInput>;
  none?: InputMaybe<StudentWhereInput>;
  some?: InputMaybe<StudentWhereInput>;
};

export type StudentMaxAggregate = {
  __typename?: 'StudentMaxAggregate';
  Access_to_a_Smartphone?: Maybe<Scalars['Boolean']['output']>;
  Adobe?: Maybe<Scalars['Boolean']['output']>;
  Adobe_Illustrator?: Maybe<Scalars['Boolean']['output']>;
  Alan_AI?: Maybe<Scalars['Boolean']['output']>;
  Any_type_of_Video_Editting_Software?: Maybe<Scalars['Boolean']['output']>;
  Any_type_of_spreadsheet?: Maybe<Scalars['Boolean']['output']>;
  Cognixion_Speakprose_app?: Maybe<Scalars['Boolean']['output']>;
  D_design?: Maybe<Scalars['Boolean']['output']>;
  Email?: Maybe<Scalars['Boolean']['output']>;
  Good_oral_and_written_communication_skills?: Maybe<Scalars['Boolean']['output']>;
  Graphic_Design_tools?: Maybe<Scalars['Boolean']['output']>;
  Instagram?: Maybe<Scalars['Boolean']['output']>;
  LinkedIn?: Maybe<Scalars['Boolean']['output']>;
  No?: Maybe<Scalars['Boolean']['output']>;
  None__but_comfort_with_video_editing_could_be_helpful?: Maybe<Scalars['Boolean']['output']>;
  Picterra_platform?: Maybe<Scalars['Boolean']['output']>;
  Picterra_university?: Maybe<Scalars['Boolean']['output']>;
  Python_coding_language?: Maybe<Scalars['Boolean']['output']>;
  Social_Media_experience?: Maybe<Scalars['Boolean']['output']>;
  Trello?: Maybe<Scalars['Boolean']['output']>;
  Website_Design?: Maybe<Scalars['Boolean']['output']>;
  activityNotification?: Maybe<Scalars['Boolean']['output']>;
  anonymous?: Maybe<Scalars['Boolean']['output']>;
  applicationStatus?: Maybe<Scalars['String']['output']>;
  deadlineCompletion?: Maybe<Scalars['String']['output']>;
  domain?: Maybe<Scalars['String']['output']>;
  enrolledAt?: Maybe<Scalars['DateTime']['output']>;
  externShip?: Maybe<Scalars['String']['output']>;
  google_drive?: Maybe<Scalars['Boolean']['output']>;
  hideCelebrationDialog?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  id__baas_transaction?: Maybe<Scalars['String']['output']>;
  isChennelCreated?: Maybe<Scalars['Boolean']['output']>;
  isContainString?: Maybe<Scalars['Boolean']['output']>;
  isDeliverableAdkCompletedAdded?: Maybe<Scalars['Boolean']['output']>;
  isDeliverableNotExists?: Maybe<Scalars['Boolean']['output']>;
  isLastModifiedAtExists?: Maybe<Scalars['Boolean']['output']>;
  isProgramCheckout?: Maybe<Scalars['Boolean']['output']>;
  isProgramCheckoutBy?: Maybe<Scalars['String']['output']>;
  isProgramTeamNotExists?: Maybe<Scalars['Boolean']['output']>;
  isProgramTeamNotExistsByOwnerOrMember?: Maybe<Scalars['Boolean']['output']>;
  isPublic?: Maybe<Scalars['Boolean']['output']>;
  isResearchProgressAdded?: Maybe<Scalars['Boolean']['output']>;
  isSaveAdkMoleculeAdded?: Maybe<Scalars['Boolean']['output']>;
  isShowTimer?: Maybe<Scalars['Boolean']['output']>;
  isStakeholdersUpdated?: Maybe<Scalars['Boolean']['output']>;
  isStudentSchemaAdded?: Maybe<Scalars['Boolean']['output']>;
  isTeamAdkCompletedAdded?: Maybe<Scalars['Boolean']['output']>;
  isTrainProgressAdded?: Maybe<Scalars['Boolean']['output']>;
  isUniqueFieldIdAdded?: Maybe<Scalars['Boolean']['output']>;
  isUniqueIdAdded?: Maybe<Scalars['Boolean']['output']>;
  isUnsponsoredProgram?: Maybe<Scalars['Boolean']['output']>;
  isUpdateOrg?: Maybe<Scalars['Boolean']['output']>;
  is_default?: Maybe<Scalars['Boolean']['output']>;
  lastSaved?: Maybe<Scalars['DateTime']['output']>;
  last_clock_in?: Maybe<Scalars['String']['output']>;
  last_clock_out?: Maybe<Scalars['String']['output']>;
  last_synced_at?: Maybe<Scalars['DateTime']['output']>;
  microsoft_office?: Maybe<Scalars['Boolean']['output']>;
  navigate_various_workflow_mapping_?: Maybe<Scalars['Boolean']['output']>;
  organizationId?: Maybe<Scalars['String']['output']>;
  organizationName?: Maybe<Scalars['String']['output']>;
  participantType?: Maybe<Scalars['String']['output']>;
  participant_id?: Maybe<Scalars['String']['output']>;
  percentageCompleted?: Maybe<Scalars['Float']['output']>;
  previouslyUnsponsored?: Maybe<Scalars['Boolean']['output']>;
  programName?: Maybe<Scalars['String']['output']>;
  program_id?: Maybe<Scalars['String']['output']>;
  referralShareCode?: Maybe<Scalars['String']['output']>;
  resourceWeb?: Maybe<Scalars['String']['output']>;
  schemaJobProgress?: Maybe<Scalars['Boolean']['output']>;
  sharable_url?: Maybe<Scalars['String']['output']>;
  social_media?: Maybe<Scalars['Boolean']['output']>;
  sponsorRequest_id?: Maybe<Scalars['String']['output']>;
  spreadsheets?: Maybe<Scalars['Boolean']['output']>;
  studentResidence?: Maybe<Scalars['String']['output']>;
  studentSchool?: Maybe<Scalars['String']['output']>;
  this_is_for_testing?: Maybe<Scalars['Boolean']['output']>;
  timerType?: Maybe<Scalars['String']['output']>;
  tokens?: Maybe<Scalars['Int']['output']>;
  unsponsoredAdk?: Maybe<Scalars['String']['output']>;
};

export type StudentMinAggregate = {
  __typename?: 'StudentMinAggregate';
  Access_to_a_Smartphone?: Maybe<Scalars['Boolean']['output']>;
  Adobe?: Maybe<Scalars['Boolean']['output']>;
  Adobe_Illustrator?: Maybe<Scalars['Boolean']['output']>;
  Alan_AI?: Maybe<Scalars['Boolean']['output']>;
  Any_type_of_Video_Editting_Software?: Maybe<Scalars['Boolean']['output']>;
  Any_type_of_spreadsheet?: Maybe<Scalars['Boolean']['output']>;
  Cognixion_Speakprose_app?: Maybe<Scalars['Boolean']['output']>;
  D_design?: Maybe<Scalars['Boolean']['output']>;
  Email?: Maybe<Scalars['Boolean']['output']>;
  Good_oral_and_written_communication_skills?: Maybe<Scalars['Boolean']['output']>;
  Graphic_Design_tools?: Maybe<Scalars['Boolean']['output']>;
  Instagram?: Maybe<Scalars['Boolean']['output']>;
  LinkedIn?: Maybe<Scalars['Boolean']['output']>;
  No?: Maybe<Scalars['Boolean']['output']>;
  None__but_comfort_with_video_editing_could_be_helpful?: Maybe<Scalars['Boolean']['output']>;
  Picterra_platform?: Maybe<Scalars['Boolean']['output']>;
  Picterra_university?: Maybe<Scalars['Boolean']['output']>;
  Python_coding_language?: Maybe<Scalars['Boolean']['output']>;
  Social_Media_experience?: Maybe<Scalars['Boolean']['output']>;
  Trello?: Maybe<Scalars['Boolean']['output']>;
  Website_Design?: Maybe<Scalars['Boolean']['output']>;
  activityNotification?: Maybe<Scalars['Boolean']['output']>;
  anonymous?: Maybe<Scalars['Boolean']['output']>;
  applicationStatus?: Maybe<Scalars['String']['output']>;
  deadlineCompletion?: Maybe<Scalars['String']['output']>;
  domain?: Maybe<Scalars['String']['output']>;
  enrolledAt?: Maybe<Scalars['DateTime']['output']>;
  externShip?: Maybe<Scalars['String']['output']>;
  google_drive?: Maybe<Scalars['Boolean']['output']>;
  hideCelebrationDialog?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  id__baas_transaction?: Maybe<Scalars['String']['output']>;
  isChennelCreated?: Maybe<Scalars['Boolean']['output']>;
  isContainString?: Maybe<Scalars['Boolean']['output']>;
  isDeliverableAdkCompletedAdded?: Maybe<Scalars['Boolean']['output']>;
  isDeliverableNotExists?: Maybe<Scalars['Boolean']['output']>;
  isLastModifiedAtExists?: Maybe<Scalars['Boolean']['output']>;
  isProgramCheckout?: Maybe<Scalars['Boolean']['output']>;
  isProgramCheckoutBy?: Maybe<Scalars['String']['output']>;
  isProgramTeamNotExists?: Maybe<Scalars['Boolean']['output']>;
  isProgramTeamNotExistsByOwnerOrMember?: Maybe<Scalars['Boolean']['output']>;
  isPublic?: Maybe<Scalars['Boolean']['output']>;
  isResearchProgressAdded?: Maybe<Scalars['Boolean']['output']>;
  isSaveAdkMoleculeAdded?: Maybe<Scalars['Boolean']['output']>;
  isShowTimer?: Maybe<Scalars['Boolean']['output']>;
  isStakeholdersUpdated?: Maybe<Scalars['Boolean']['output']>;
  isStudentSchemaAdded?: Maybe<Scalars['Boolean']['output']>;
  isTeamAdkCompletedAdded?: Maybe<Scalars['Boolean']['output']>;
  isTrainProgressAdded?: Maybe<Scalars['Boolean']['output']>;
  isUniqueFieldIdAdded?: Maybe<Scalars['Boolean']['output']>;
  isUniqueIdAdded?: Maybe<Scalars['Boolean']['output']>;
  isUnsponsoredProgram?: Maybe<Scalars['Boolean']['output']>;
  isUpdateOrg?: Maybe<Scalars['Boolean']['output']>;
  is_default?: Maybe<Scalars['Boolean']['output']>;
  lastSaved?: Maybe<Scalars['DateTime']['output']>;
  last_clock_in?: Maybe<Scalars['String']['output']>;
  last_clock_out?: Maybe<Scalars['String']['output']>;
  last_synced_at?: Maybe<Scalars['DateTime']['output']>;
  microsoft_office?: Maybe<Scalars['Boolean']['output']>;
  navigate_various_workflow_mapping_?: Maybe<Scalars['Boolean']['output']>;
  organizationId?: Maybe<Scalars['String']['output']>;
  organizationName?: Maybe<Scalars['String']['output']>;
  participantType?: Maybe<Scalars['String']['output']>;
  participant_id?: Maybe<Scalars['String']['output']>;
  percentageCompleted?: Maybe<Scalars['Float']['output']>;
  previouslyUnsponsored?: Maybe<Scalars['Boolean']['output']>;
  programName?: Maybe<Scalars['String']['output']>;
  program_id?: Maybe<Scalars['String']['output']>;
  referralShareCode?: Maybe<Scalars['String']['output']>;
  resourceWeb?: Maybe<Scalars['String']['output']>;
  schemaJobProgress?: Maybe<Scalars['Boolean']['output']>;
  sharable_url?: Maybe<Scalars['String']['output']>;
  social_media?: Maybe<Scalars['Boolean']['output']>;
  sponsorRequest_id?: Maybe<Scalars['String']['output']>;
  spreadsheets?: Maybe<Scalars['Boolean']['output']>;
  studentResidence?: Maybe<Scalars['String']['output']>;
  studentSchool?: Maybe<Scalars['String']['output']>;
  this_is_for_testing?: Maybe<Scalars['Boolean']['output']>;
  timerType?: Maybe<Scalars['String']['output']>;
  tokens?: Maybe<Scalars['Int']['output']>;
  unsponsoredAdk?: Maybe<Scalars['String']['output']>;
};

export type StudentOfferDetails = {
  __typename?: 'StudentOfferDetails';
  acceptanceDeadline?: Maybe<Scalars['String']['output']>;
  compensation?: Maybe<Scalars['String']['output']>;
  continuation?: Maybe<Scalars['Boolean']['output']>;
  customCompensation?: Maybe<Scalars['Boolean']['output']>;
  customInternshipProject?: Maybe<Scalars['Boolean']['output']>;
  customPosition?: Maybe<Scalars['Boolean']['output']>;
  employerRecord?: Maybe<Scalars['Boolean']['output']>;
  internshipEnd?: Maybe<Scalars['String']['output']>;
  internshipProject?: Maybe<Scalars['String']['output']>;
  internshipStart?: Maybe<Scalars['String']['output']>;
  isInternshipCompleted?: Maybe<Scalars['Boolean']['output']>;
  licenseRequirement?: Maybe<Scalars['Boolean']['output']>;
  maxHours?: Maybe<Scalars['Int']['output']>;
  minHours?: Maybe<Scalars['Int']['output']>;
  position?: Maybe<Scalars['String']['output']>;
  rejectionReason?: Maybe<Scalars['String']['output']>;
  signoffRequestedBy?: Maybe<Scalars['String']['output']>;
  /** Multiple data types found: String: 72.7%, DateTime (Date): 27.3% out of 22 sampled entries */
  signoffRequestedDate?: Maybe<Scalars['JSON']['output']>;
  terminationRequestedDate?: Maybe<Scalars['DateTime']['output']>;
};

export type StudentOfferDetailsCreateInput = {
  acceptanceDeadline?: InputMaybe<Scalars['String']['input']>;
  compensation?: InputMaybe<Scalars['String']['input']>;
  continuation?: InputMaybe<Scalars['Boolean']['input']>;
  customCompensation?: InputMaybe<Scalars['Boolean']['input']>;
  customInternshipProject?: InputMaybe<Scalars['Boolean']['input']>;
  customPosition?: InputMaybe<Scalars['Boolean']['input']>;
  employerRecord?: InputMaybe<Scalars['Boolean']['input']>;
  internshipEnd?: InputMaybe<Scalars['String']['input']>;
  internshipProject?: InputMaybe<Scalars['String']['input']>;
  internshipStart?: InputMaybe<Scalars['String']['input']>;
  isInternshipCompleted?: InputMaybe<Scalars['Boolean']['input']>;
  licenseRequirement?: InputMaybe<Scalars['Boolean']['input']>;
  maxHours?: InputMaybe<Scalars['Int']['input']>;
  minHours?: InputMaybe<Scalars['Int']['input']>;
  position?: InputMaybe<Scalars['String']['input']>;
  rejectionReason?: InputMaybe<Scalars['String']['input']>;
  signoffRequestedBy?: InputMaybe<Scalars['String']['input']>;
  signoffRequestedDate?: InputMaybe<Scalars['JSON']['input']>;
  terminationRequestedDate?: InputMaybe<Scalars['DateTime']['input']>;
};

export type StudentOfferDetailsNullableCompositeFilter = {
  equals?: InputMaybe<StudentOfferDetailsObjectEqualityInput>;
  is?: InputMaybe<StudentOfferDetailsWhereInput>;
  isNot?: InputMaybe<StudentOfferDetailsWhereInput>;
  isSet?: InputMaybe<Scalars['Boolean']['input']>;
};

export type StudentOfferDetailsNullableCreateEnvelopeInput = {
  set?: InputMaybe<StudentOfferDetailsCreateInput>;
};

export type StudentOfferDetailsNullableUpdateEnvelopeInput = {
  set?: InputMaybe<StudentOfferDetailsCreateInput>;
  unset?: InputMaybe<Scalars['Boolean']['input']>;
  upsert?: InputMaybe<StudentOfferDetailsUpsertInput>;
};

export type StudentOfferDetailsObjectEqualityInput = {
  acceptanceDeadline?: InputMaybe<Scalars['String']['input']>;
  compensation?: InputMaybe<Scalars['String']['input']>;
  continuation?: InputMaybe<Scalars['Boolean']['input']>;
  customCompensation?: InputMaybe<Scalars['Boolean']['input']>;
  customInternshipProject?: InputMaybe<Scalars['Boolean']['input']>;
  customPosition?: InputMaybe<Scalars['Boolean']['input']>;
  employerRecord?: InputMaybe<Scalars['Boolean']['input']>;
  internshipEnd?: InputMaybe<Scalars['String']['input']>;
  internshipProject?: InputMaybe<Scalars['String']['input']>;
  internshipStart?: InputMaybe<Scalars['String']['input']>;
  isInternshipCompleted?: InputMaybe<Scalars['Boolean']['input']>;
  licenseRequirement?: InputMaybe<Scalars['Boolean']['input']>;
  maxHours?: InputMaybe<Scalars['Int']['input']>;
  minHours?: InputMaybe<Scalars['Int']['input']>;
  position?: InputMaybe<Scalars['String']['input']>;
  rejectionReason?: InputMaybe<Scalars['String']['input']>;
  signoffRequestedBy?: InputMaybe<Scalars['String']['input']>;
  signoffRequestedDate?: InputMaybe<Scalars['JSON']['input']>;
  terminationRequestedDate?: InputMaybe<Scalars['DateTime']['input']>;
};

export type StudentOfferDetailsUpdateInput = {
  acceptanceDeadline?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  compensation?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  continuation?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  customCompensation?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  customInternshipProject?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  customPosition?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  employerRecord?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  internshipEnd?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  internshipProject?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  internshipStart?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  isInternshipCompleted?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  licenseRequirement?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  maxHours?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  minHours?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  position?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  rejectionReason?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  signoffRequestedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  signoffRequestedDate?: InputMaybe<Scalars['JSON']['input']>;
  terminationRequestedDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
};

export type StudentOfferDetailsUpsertInput = {
  set: StudentOfferDetailsCreateInput;
  update: StudentOfferDetailsUpdateInput;
};

export type StudentOfferDetailsWhereInput = {
  AND?: InputMaybe<Array<StudentOfferDetailsWhereInput>>;
  NOT?: InputMaybe<Array<StudentOfferDetailsWhereInput>>;
  OR?: InputMaybe<Array<StudentOfferDetailsWhereInput>>;
  acceptanceDeadline?: InputMaybe<StringNullableFilter>;
  compensation?: InputMaybe<StringNullableFilter>;
  continuation?: InputMaybe<BoolNullableFilter>;
  customCompensation?: InputMaybe<BoolNullableFilter>;
  customInternshipProject?: InputMaybe<BoolNullableFilter>;
  customPosition?: InputMaybe<BoolNullableFilter>;
  employerRecord?: InputMaybe<BoolNullableFilter>;
  internshipEnd?: InputMaybe<StringNullableFilter>;
  internshipProject?: InputMaybe<StringNullableFilter>;
  internshipStart?: InputMaybe<StringNullableFilter>;
  isInternshipCompleted?: InputMaybe<BoolNullableFilter>;
  licenseRequirement?: InputMaybe<BoolNullableFilter>;
  maxHours?: InputMaybe<IntNullableFilter>;
  minHours?: InputMaybe<IntNullableFilter>;
  position?: InputMaybe<StringNullableFilter>;
  rejectionReason?: InputMaybe<StringNullableFilter>;
  signoffRequestedBy?: InputMaybe<StringNullableFilter>;
  signoffRequestedDate?: InputMaybe<JsonNullableFilter>;
  terminationRequestedDate?: InputMaybe<DateTimeNullableFilter>;
};

/** Response from creating a student payment checkout session */
export type StudentPaymentCheckoutResponse = {
  __typename?: 'StudentPaymentCheckoutResponse';
  /** Stripe Checkout URL to redirect user to */
  checkoutUrl: Scalars['String']['output'];
  /** Stripe Checkout Session ID for tracking */
  sessionId: Scalars['String']['output'];
};

export type StudentPortfolio = {
  __typename?: 'StudentPortfolio';
  airtable?: Maybe<Array<StudentPortfolioAirtable>>;
  date?: Maybe<Scalars['String']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  ethnicity?: Maybe<Array<Scalars['String']['output']>>;
  gender?: Maybe<Scalars['String']['output']>;
  grade?: Maybe<Scalars['String']['output']>;
  guardian?: Maybe<StudentPortfolioGuardian>;
  home?: Maybe<StudentPortfolioHome>;
  id: Scalars['ID']['output'];
  invited?: Maybe<Scalars['Boolean']['output']>;
  isUserNotExists?: Maybe<Scalars['Boolean']['output']>;
  last_modified_at?: Maybe<Scalars['DateTime']['output']>;
  last_synced_at?: Maybe<Scalars['DateTime']['output']>;
  school?: Maybe<StudentPortfolioSchool>;
  studentId?: Maybe<Scalars['String']['output']>;
};

export type StudentPortfolioAirtable = {
  __typename?: 'StudentPortfolioAirtable';
  airtable_id: Scalars['String']['output'];
  created_at: Scalars['DateTime']['output'];
  last_modified_at: Scalars['DateTime']['output'];
  spreadsheet: Scalars['String']['output'];
};

export type StudentPortfolioCountAggregate = {
  __typename?: 'StudentPortfolioCountAggregate';
  _all: Scalars['Int']['output'];
  date: Scalars['Int']['output'];
  deletedAt: Scalars['Int']['output'];
  ethnicity: Scalars['Int']['output'];
  gender: Scalars['Int']['output'];
  grade: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  invited: Scalars['Int']['output'];
  isUserNotExists: Scalars['Int']['output'];
  last_modified_at: Scalars['Int']['output'];
  last_synced_at: Scalars['Int']['output'];
  studentId: Scalars['Int']['output'];
};

export type StudentPortfolioGuardian = {
  __typename?: 'StudentPortfolioGuardian';
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  phoneVerified?: Maybe<Scalars['DateTime']['output']>;
  relationship?: Maybe<Scalars['String']['output']>;
  typeName?: Maybe<Scalars['String']['output']>;
};

export type StudentPortfolioHome = {
  __typename?: 'StudentPortfolioHome';
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  countryCode?: Maybe<Scalars['String']['output']>;
  county?: Maybe<Scalars['String']['output']>;
  formattedAddress?: Maybe<Scalars['String']['output']>;
  geocodeConfidence?: Maybe<Scalars['String']['output']>;
  geocodeSource?: Maybe<Scalars['String']['output']>;
  geocodedAt?: Maybe<Scalars['DateTime']['output']>;
  isPrivate?: Maybe<Scalars['Boolean']['output']>;
  language?: Maybe<Array<Scalars['String']['output']>>;
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  placeId?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  stateCode?: Maybe<Scalars['String']['output']>;
  streetAddress?: Maybe<Scalars['String']['output']>;
  typeName?: Maybe<Scalars['String']['output']>;
  zipcode?: Maybe<Scalars['String']['output']>;
};

export type StudentPortfolioMaxAggregate = {
  __typename?: 'StudentPortfolioMaxAggregate';
  date?: Maybe<Scalars['String']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  gender?: Maybe<Scalars['String']['output']>;
  grade?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  invited?: Maybe<Scalars['Boolean']['output']>;
  isUserNotExists?: Maybe<Scalars['Boolean']['output']>;
  last_modified_at?: Maybe<Scalars['DateTime']['output']>;
  last_synced_at?: Maybe<Scalars['DateTime']['output']>;
  studentId?: Maybe<Scalars['String']['output']>;
};

export type StudentPortfolioMinAggregate = {
  __typename?: 'StudentPortfolioMinAggregate';
  date?: Maybe<Scalars['String']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  gender?: Maybe<Scalars['String']['output']>;
  grade?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  invited?: Maybe<Scalars['Boolean']['output']>;
  isUserNotExists?: Maybe<Scalars['Boolean']['output']>;
  last_modified_at?: Maybe<Scalars['DateTime']['output']>;
  last_synced_at?: Maybe<Scalars['DateTime']['output']>;
  studentId?: Maybe<Scalars['String']['output']>;
};

export type StudentPortfolioSchool = {
  __typename?: 'StudentPortfolioSchool';
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  countryCode?: Maybe<Scalars['String']['output']>;
  county?: Maybe<Scalars['String']['output']>;
  district?: Maybe<Scalars['String']['output']>;
  formattedAddress?: Maybe<Scalars['String']['output']>;
  geocodeConfidence?: Maybe<Scalars['String']['output']>;
  geocodeSource?: Maybe<Scalars['String']['output']>;
  geocodedAt?: Maybe<Scalars['DateTime']['output']>;
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  placeId?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  stateCode?: Maybe<Scalars['String']['output']>;
  streetAddress?: Maybe<Scalars['String']['output']>;
  typeName?: Maybe<Scalars['String']['output']>;
  zipcode?: Maybe<Scalars['String']['output']>;
};

export type StudentProblemScope = {
  __typename?: 'StudentProblemScope';
  employer: Scalars['String']['output'];
  pathways: Scalars['String']['output'];
  problem: Scalars['String']['output'];
  solution?: Maybe<Scalars['String']['output']>;
  timeSpent: Scalars['String']['output'];
};

export type StudentProblemScopeCreateInput = {
  employer: Scalars['String']['input'];
  pathways: Scalars['String']['input'];
  problem: Scalars['String']['input'];
  solution?: InputMaybe<Scalars['String']['input']>;
  timeSpent: Scalars['String']['input'];
};

export type StudentProblemScopeObjectEqualityInput = {
  employer: Scalars['String']['input'];
  pathways: Scalars['String']['input'];
  problem: Scalars['String']['input'];
  solution?: InputMaybe<Scalars['String']['input']>;
  timeSpent: Scalars['String']['input'];
};

export type StudentScalarWhereInput = {
  AND?: InputMaybe<Array<StudentScalarWhereInput>>;
  Access_to_a_Smartphone?: InputMaybe<BoolNullableFilter>;
  Adobe?: InputMaybe<BoolNullableFilter>;
  Adobe_Illustrator?: InputMaybe<BoolNullableFilter>;
  Alan_AI?: InputMaybe<BoolNullableFilter>;
  Any_type_of_Video_Editting_Software?: InputMaybe<BoolNullableFilter>;
  Any_type_of_spreadsheet?: InputMaybe<BoolNullableFilter>;
  Cognixion_Speakprose_app?: InputMaybe<BoolNullableFilter>;
  D_design?: InputMaybe<BoolNullableFilter>;
  Email?: InputMaybe<BoolNullableFilter>;
  Good_oral_and_written_communication_skills?: InputMaybe<BoolNullableFilter>;
  Graphic_Design_tools?: InputMaybe<BoolNullableFilter>;
  Instagram?: InputMaybe<BoolNullableFilter>;
  LinkedIn?: InputMaybe<BoolNullableFilter>;
  NOT?: InputMaybe<Array<StudentScalarWhereInput>>;
  No?: InputMaybe<BoolNullableFilter>;
  None__but_comfort_with_video_editing_could_be_helpful?: InputMaybe<BoolNullableFilter>;
  OR?: InputMaybe<Array<StudentScalarWhereInput>>;
  Picterra_platform?: InputMaybe<BoolNullableFilter>;
  Picterra_university?: InputMaybe<BoolNullableFilter>;
  Python_coding_language?: InputMaybe<BoolNullableFilter>;
  Social_Media_experience?: InputMaybe<BoolNullableFilter>;
  Trello?: InputMaybe<BoolNullableFilter>;
  Website_Design?: InputMaybe<BoolNullableFilter>;
  accessSkills?: InputMaybe<StringNullableListFilter>;
  activityNotification?: InputMaybe<BoolNullableFilter>;
  anonymous?: InputMaybe<BoolNullableFilter>;
  applicationStatus?: InputMaybe<StringNullableFilter>;
  created?: InputMaybe<JsonFilter>;
  deadlineCompletion?: InputMaybe<StringNullableFilter>;
  domain?: InputMaybe<StringNullableFilter>;
  enrolledAt?: InputMaybe<DateTimeNullableFilter>;
  externShip?: InputMaybe<StringNullableFilter>;
  google_drive?: InputMaybe<BoolNullableFilter>;
  hideCelebrationDialog?: InputMaybe<BoolNullableFilter>;
  id?: InputMaybe<StringFilter>;
  id__baas_transaction?: InputMaybe<StringNullableFilter>;
  isChennelCreated?: InputMaybe<BoolNullableFilter>;
  isContainString?: InputMaybe<BoolNullableFilter>;
  isDeliverableAdkCompletedAdded?: InputMaybe<BoolNullableFilter>;
  isDeliverableNotExists?: InputMaybe<BoolNullableFilter>;
  isLastModifiedAtExists?: InputMaybe<BoolNullableFilter>;
  isProgramCheckout?: InputMaybe<BoolNullableFilter>;
  isProgramCheckoutBy?: InputMaybe<StringNullableFilter>;
  isProgramTeamNotExists?: InputMaybe<BoolNullableFilter>;
  isProgramTeamNotExistsByOwnerOrMember?: InputMaybe<BoolNullableFilter>;
  isPublic?: InputMaybe<BoolNullableFilter>;
  isResearchProgressAdded?: InputMaybe<BoolNullableFilter>;
  isSaveAdkMoleculeAdded?: InputMaybe<BoolNullableFilter>;
  isShowTimer?: InputMaybe<BoolNullableFilter>;
  isStakeholdersUpdated?: InputMaybe<BoolNullableFilter>;
  isStudentSchemaAdded?: InputMaybe<BoolNullableFilter>;
  isTeamAdkCompletedAdded?: InputMaybe<BoolNullableFilter>;
  isTrainProgressAdded?: InputMaybe<BoolNullableFilter>;
  isUniqueFieldIdAdded?: InputMaybe<BoolNullableFilter>;
  isUniqueIdAdded?: InputMaybe<BoolNullableFilter>;
  isUnsponsoredProgram?: InputMaybe<BoolNullableFilter>;
  isUpdateOrg?: InputMaybe<BoolNullableFilter>;
  is_default?: InputMaybe<BoolNullableFilter>;
  lastSaved?: InputMaybe<DateTimeNullableFilter>;
  last_clock_in?: InputMaybe<StringNullableFilter>;
  last_clock_out?: InputMaybe<StringNullableFilter>;
  last_synced_at?: InputMaybe<DateTimeFilter>;
  microsoft_office?: InputMaybe<BoolNullableFilter>;
  navigate_various_workflow_mapping_?: InputMaybe<BoolNullableFilter>;
  organizationId?: InputMaybe<StringNullableFilter>;
  organizationName?: InputMaybe<StringNullableFilter>;
  participantType?: InputMaybe<StringNullableFilter>;
  participant_id?: InputMaybe<StringFilter>;
  percentageCompleted?: InputMaybe<FloatNullableFilter>;
  previouslyUnsponsored?: InputMaybe<BoolNullableFilter>;
  programName?: InputMaybe<StringNullableFilter>;
  program_id?: InputMaybe<StringFilter>;
  progress?: InputMaybe<JsonNullableFilter>;
  referralShareCode?: InputMaybe<StringNullableFilter>;
  resourceWeb?: InputMaybe<StringNullableFilter>;
  rewards?: InputMaybe<JsonNullableFilter>;
  role?: InputMaybe<JsonNullableFilter>;
  schemaJobProgress?: InputMaybe<BoolNullableFilter>;
  sharable_url?: InputMaybe<StringNullableFilter>;
  social_media?: InputMaybe<BoolNullableFilter>;
  sponsorRequest_id?: InputMaybe<StringNullableFilter>;
  spreadsheets?: InputMaybe<BoolNullableFilter>;
  studentEthnicity?: InputMaybe<StringNullableListFilter>;
  studentLocation?: InputMaybe<JsonNullableFilter>;
  studentResidence?: InputMaybe<StringNullableFilter>;
  studentSchool?: InputMaybe<StringNullableFilter>;
  this_is_for_testing?: InputMaybe<BoolNullableFilter>;
  timerType?: InputMaybe<StringNullableFilter>;
  tokens?: InputMaybe<IntNullableFilter>;
  unsponsoredAdk?: InputMaybe<StringNullableFilter>;
};

export type StudentSearchResult = {
  __typename?: 'StudentSearchResult';
  email: Scalars['String']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  phone: Scalars['String']['output'];
};

export type StudentSponsorDetails = {
  __typename?: 'StudentSponsorDetails';
  birthDate?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  ethnicity?: Maybe<Array<Scalars['String']['output']>>;
  hobbies?: Maybe<Array<Scalars['String']['output']>>;
  options?: Maybe<Array<Scalars['String']['output']>>;
  reference: Scalars['String']['output'];
  residence: Scalars['String']['output'];
  roles?: Maybe<Array<Scalars['String']['output']>>;
  school: Scalars['String']['output'];
  schoolDistrict?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
};

export type StudentSponsorDetailsCreateInput = {
  birthDate?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  ethnicity?: InputMaybe<StudentSponsorDetailsCreateethnicityInput>;
  hobbies?: InputMaybe<StudentSponsorDetailsCreatehobbiesInput>;
  options?: InputMaybe<StudentSponsorDetailsCreateoptionsInput>;
  reference: Scalars['String']['input'];
  residence: Scalars['String']['input'];
  roles?: InputMaybe<StudentSponsorDetailsCreaterolesInput>;
  school: Scalars['String']['input'];
  schoolDistrict?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};

export type StudentSponsorDetailsCreateethnicityInput = {
  set: Array<Scalars['String']['input']>;
};

export type StudentSponsorDetailsCreatehobbiesInput = {
  set: Array<Scalars['String']['input']>;
};

export type StudentSponsorDetailsCreateoptionsInput = {
  set: Array<Scalars['String']['input']>;
};

export type StudentSponsorDetailsCreaterolesInput = {
  set: Array<Scalars['String']['input']>;
};

export type StudentSponsorDetailsNullableCompositeFilter = {
  equals?: InputMaybe<StudentSponsorDetailsObjectEqualityInput>;
  is?: InputMaybe<StudentSponsorDetailsWhereInput>;
  isNot?: InputMaybe<StudentSponsorDetailsWhereInput>;
  isSet?: InputMaybe<Scalars['Boolean']['input']>;
};

export type StudentSponsorDetailsNullableCreateEnvelopeInput = {
  set?: InputMaybe<StudentSponsorDetailsCreateInput>;
};

export type StudentSponsorDetailsNullableUpdateEnvelopeInput = {
  set?: InputMaybe<StudentSponsorDetailsCreateInput>;
  unset?: InputMaybe<Scalars['Boolean']['input']>;
  upsert?: InputMaybe<StudentSponsorDetailsUpsertInput>;
};

export type StudentSponsorDetailsObjectEqualityInput = {
  birthDate?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  ethnicity?: InputMaybe<Array<Scalars['String']['input']>>;
  hobbies?: InputMaybe<Array<Scalars['String']['input']>>;
  options?: InputMaybe<Array<Scalars['String']['input']>>;
  reference: Scalars['String']['input'];
  residence: Scalars['String']['input'];
  roles?: InputMaybe<Array<Scalars['String']['input']>>;
  school: Scalars['String']['input'];
  schoolDistrict?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};

export type StudentSponsorDetailsUpdateInput = {
  birthDate?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  city?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  ethnicity?: InputMaybe<StudentSponsorDetailsUpdateethnicityInput>;
  hobbies?: InputMaybe<StudentSponsorDetailsUpdatehobbiesInput>;
  options?: InputMaybe<StudentSponsorDetailsUpdateoptionsInput>;
  reference?: InputMaybe<StringFieldUpdateOperationsInput>;
  residence?: InputMaybe<StringFieldUpdateOperationsInput>;
  roles?: InputMaybe<StudentSponsorDetailsUpdaterolesInput>;
  school?: InputMaybe<StringFieldUpdateOperationsInput>;
  schoolDistrict?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  state?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  status?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type StudentSponsorDetailsUpdateethnicityInput = {
  push?: InputMaybe<Array<Scalars['String']['input']>>;
  set?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type StudentSponsorDetailsUpdatehobbiesInput = {
  push?: InputMaybe<Array<Scalars['String']['input']>>;
  set?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type StudentSponsorDetailsUpdateoptionsInput = {
  push?: InputMaybe<Array<Scalars['String']['input']>>;
  set?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type StudentSponsorDetailsUpdaterolesInput = {
  push?: InputMaybe<Array<Scalars['String']['input']>>;
  set?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type StudentSponsorDetailsUpsertInput = {
  set: StudentSponsorDetailsCreateInput;
  update: StudentSponsorDetailsUpdateInput;
};

export type StudentSponsorDetailsWhereInput = {
  AND?: InputMaybe<Array<StudentSponsorDetailsWhereInput>>;
  NOT?: InputMaybe<Array<StudentSponsorDetailsWhereInput>>;
  OR?: InputMaybe<Array<StudentSponsorDetailsWhereInput>>;
  birthDate?: InputMaybe<StringNullableFilter>;
  city?: InputMaybe<StringNullableFilter>;
  ethnicity?: InputMaybe<StringNullableListFilter>;
  hobbies?: InputMaybe<StringNullableListFilter>;
  options?: InputMaybe<StringNullableListFilter>;
  reference?: InputMaybe<StringFilter>;
  residence?: InputMaybe<StringFilter>;
  roles?: InputMaybe<StringNullableListFilter>;
  school?: InputMaybe<StringFilter>;
  schoolDistrict?: InputMaybe<StringNullableFilter>;
  state?: InputMaybe<StringNullableFilter>;
  status?: InputMaybe<StringNullableFilter>;
};

export type StudentStakeholders = {
  __typename?: 'StudentStakeholders';
  googleDetails?: Maybe<StudentStakeholdersGoogleDetails>;
  type: Scalars['String']['output'];
  userId: Scalars['String']['output'];
};

export type StudentStakeholdersCreateInput = {
  googleDetails?: InputMaybe<StudentStakeholdersGoogleDetailsCreateInput>;
  type: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};

export type StudentStakeholdersGoogleDetails = {
  __typename?: 'StudentStakeholdersGoogleDetails';
  access_token: Scalars['String']['output'];
  email: Scalars['String']['output'];
  expiry_date: Scalars['Float']['output'];
  id_token: Scalars['String']['output'];
  refresh_token: Scalars['String']['output'];
  scope: Scalars['String']['output'];
  token_type: Scalars['String']['output'];
};

export type StudentStakeholdersGoogleDetailsCreateInput = {
  access_token: Scalars['String']['input'];
  email: Scalars['String']['input'];
  expiry_date: Scalars['Float']['input'];
  id_token: Scalars['String']['input'];
  refresh_token: Scalars['String']['input'];
  scope: Scalars['String']['input'];
  token_type: Scalars['String']['input'];
};

export type StudentStakeholdersGoogleDetailsObjectEqualityInput = {
  access_token: Scalars['String']['input'];
  email: Scalars['String']['input'];
  expiry_date: Scalars['Float']['input'];
  id_token: Scalars['String']['input'];
  refresh_token: Scalars['String']['input'];
  scope: Scalars['String']['input'];
  token_type: Scalars['String']['input'];
};

export type StudentStakeholdersObjectEqualityInput = {
  googleDetails?: InputMaybe<StudentStakeholdersGoogleDetailsObjectEqualityInput>;
  type: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};

export type StudentSumAggregate = {
  __typename?: 'StudentSumAggregate';
  percentageCompleted?: Maybe<Scalars['Float']['output']>;
  tokens?: Maybe<Scalars['Int']['output']>;
};

export type StudentTransactionAvgAggregate = {
  __typename?: 'StudentTransactionAvgAggregate';
  amount?: Maybe<Scalars['Float']['output']>;
  platform_fee?: Maybe<Scalars['Float']['output']>;
  refund_amount?: Maybe<Scalars['Float']['output']>;
};

export type StudentTransactionCountAggregate = {
  __typename?: 'StudentTransactionCountAggregate';
  _all: Scalars['Int']['output'];
  amount: Scalars['Int']['output'];
  created_at: Scalars['Int']['output'];
  description: Scalars['Int']['output'];
  dispute_id: Scalars['Int']['output'];
  disputed_at: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  isSponsor: Scalars['Int']['output'];
  organizer_id: Scalars['Int']['output'];
  original_transaction_id: Scalars['Int']['output'];
  payment_intent_id: Scalars['Int']['output'];
  platform_fee: Scalars['Int']['output'];
  program_id: Scalars['Int']['output'];
  refund_amount: Scalars['Int']['output'];
  refunded_at: Scalars['Int']['output'];
  sponsor_id: Scalars['Int']['output'];
  status: Scalars['Int']['output'];
  student_id: Scalars['Int']['output'];
  transfer_id: Scalars['Int']['output'];
  transfer_started_at: Scalars['Int']['output'];
  transfer_status: Scalars['Int']['output'];
  transferred_at: Scalars['Int']['output'];
  updated_at: Scalars['Int']['output'];
};

export type StudentTransactionMaxAggregate = {
  __typename?: 'StudentTransactionMaxAggregate';
  amount?: Maybe<Scalars['Float']['output']>;
  created_at?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  dispute_id?: Maybe<Scalars['String']['output']>;
  disputed_at?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  isSponsor?: Maybe<Scalars['Boolean']['output']>;
  organizer_id?: Maybe<Scalars['String']['output']>;
  original_transaction_id?: Maybe<Scalars['String']['output']>;
  payment_intent_id?: Maybe<Scalars['String']['output']>;
  platform_fee?: Maybe<Scalars['Float']['output']>;
  program_id?: Maybe<Scalars['String']['output']>;
  refund_amount?: Maybe<Scalars['Float']['output']>;
  refunded_at?: Maybe<Scalars['DateTime']['output']>;
  sponsor_id?: Maybe<Scalars['String']['output']>;
  status?: Maybe<TransactionStatus>;
  student_id?: Maybe<Scalars['String']['output']>;
  transfer_id?: Maybe<Scalars['String']['output']>;
  transfer_started_at?: Maybe<Scalars['DateTime']['output']>;
  transfer_status?: Maybe<TransferStatus>;
  transferred_at?: Maybe<Scalars['DateTime']['output']>;
  updated_at?: Maybe<Scalars['DateTime']['output']>;
};

export type StudentTransactionMinAggregate = {
  __typename?: 'StudentTransactionMinAggregate';
  amount?: Maybe<Scalars['Float']['output']>;
  created_at?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  dispute_id?: Maybe<Scalars['String']['output']>;
  disputed_at?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  isSponsor?: Maybe<Scalars['Boolean']['output']>;
  organizer_id?: Maybe<Scalars['String']['output']>;
  original_transaction_id?: Maybe<Scalars['String']['output']>;
  payment_intent_id?: Maybe<Scalars['String']['output']>;
  platform_fee?: Maybe<Scalars['Float']['output']>;
  program_id?: Maybe<Scalars['String']['output']>;
  refund_amount?: Maybe<Scalars['Float']['output']>;
  refunded_at?: Maybe<Scalars['DateTime']['output']>;
  sponsor_id?: Maybe<Scalars['String']['output']>;
  status?: Maybe<TransactionStatus>;
  student_id?: Maybe<Scalars['String']['output']>;
  transfer_id?: Maybe<Scalars['String']['output']>;
  transfer_started_at?: Maybe<Scalars['DateTime']['output']>;
  transfer_status?: Maybe<TransferStatus>;
  transferred_at?: Maybe<Scalars['DateTime']['output']>;
  updated_at?: Maybe<Scalars['DateTime']['output']>;
};

export type StudentTransactionSumAggregate = {
  __typename?: 'StudentTransactionSumAggregate';
  amount?: Maybe<Scalars['Float']['output']>;
  platform_fee?: Maybe<Scalars['Float']['output']>;
  refund_amount?: Maybe<Scalars['Float']['output']>;
};

/** Payment transaction record with lazy-loaded Stripe details */
export type StudentTransactionType = {
  __typename?: 'StudentTransactionType';
  /** Dollar amount (90% of sponsor payment, can be NEGATIVE for chargebacks) */
  amount: Scalars['Float']['output'];
  /** Transaction creation timestamp */
  created_at: Scalars['DateTime']['output'];
  /** Human-readable description of transaction */
  description?: Maybe<Scalars['String']['output']>;
  /** Stripe Dispute ID (dp_xxx) - set if payment disputed */
  dispute_id?: Maybe<Scalars['String']['output']>;
  /** When dispute was filed */
  disputed_at?: Maybe<Scalars['DateTime']['output']>;
  /** Unique transaction identifier */
  id: Scalars['ID']['output'];
  /** True if this is a sponsorship payment */
  isSponsor: Scalars['Boolean']['output'];
  /** Organizer ID (program creator who receives the funds) */
  organizer_id: Scalars['String']['output'];
  /** Links to original transaction (for chargeback debt entries) */
  original_transaction_id?: Maybe<Scalars['String']['output']>;
  /** Stripe PaymentIntent ID (pi_xxx) */
  payment_intent_id: Scalars['String']['output'];
  /** Platform fee amount (typically 10% of sponsor payment) */
  platform_fee?: Maybe<Scalars['Float']['output']>;
  /** Program ID this payment is for */
  program_id: Scalars['String']['output'];
  /** Amount refunded (for partial refunds) */
  refund_amount?: Maybe<Scalars['Float']['output']>;
  /** When refund was processed */
  refunded_at?: Maybe<Scalars['DateTime']['output']>;
  /** Sponsor ID (person who paid, null for direct program payments) */
  sponsor_id?: Maybe<Scalars['String']['output']>;
  /** Payment lifecycle status */
  status: TransactionStatus;
  /** Stripe BalanceTransaction with fee breakdown (lazy loaded, admin/organizer only) */
  stripeBalanceDetails?: Maybe<StripeBalanceTransactionDetails>;
  /** Detailed Stripe PaymentIntent information (lazy loaded from Stripe API) */
  stripePaymentDetails?: Maybe<StripePaymentIntentDetails>;
  /** Student ID (person being sponsored or enrolled) */
  student_id: Scalars['String']['output'];
  /** Stripe Transfer ID (tr_xxx) - set when organizer withdraws */
  transfer_id?: Maybe<Scalars['String']['output']>;
  /** When withdrawal began (status → 'transferring') */
  transfer_started_at?: Maybe<Scalars['DateTime']['output']>;
  /** Wallet transfer status */
  transfer_status: TransferStatus;
  /** When transfer completed (status → 'transferred') */
  transferred_at?: Maybe<Scalars['DateTime']['output']>;
  /** Transaction last update timestamp */
  updated_at: Scalars['DateTime']['output'];
};

export type StudentUpdateManyMutationInput = {
  Access_to_a_Smartphone?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  Adobe?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  Adobe_Illustrator?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  Alan_AI?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  Any_type_of_Video_Editting_Software?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  Any_type_of_spreadsheet?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  Bexi?: InputMaybe<StudentBexiNullableUpdateEnvelopeInput>;
  Bucket?: InputMaybe<StudentBucketNullableUpdateEnvelopeInput>;
  Cognixion_Speakprose_app?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  D_design?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  Email?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  Good_oral_and_written_communication_skills?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  Graphic_Design_tools?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  Instagram?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  LinkedIn?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  No?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  None__but_comfort_with_video_editing_could_be_helpful?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  Picterra_platform?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  Picterra_university?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  Python_coding_language?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  Social_Media_experience?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  Trello?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  Website_Design?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  accessSkills?: InputMaybe<StudentUpdateaccessSkillsInput>;
  activityNotification?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  adks?: InputMaybe<Array<StudentAdksCreateInput>>;
  airtable?: InputMaybe<Array<StudentAirtableCreateInput>>;
  anonymous?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  applicationStatus?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  categories?: InputMaybe<Array<StudentCategoriesCreateInput>>;
  checkoutQualification?: InputMaybe<StudentCheckoutQualificationNullableUpdateEnvelopeInput>;
  claimedSponsorshipDetails?: InputMaybe<StudentClaimedSponsorshipDetailsNullableUpdateEnvelopeInput>;
  created?: InputMaybe<Scalars['JSON']['input']>;
  credentials?: InputMaybe<Array<StudentCredentialsCreateInput>>;
  deadlineCompletion?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  domain?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  enrolledAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  externShip?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  googleDetails?: InputMaybe<StudentGoogleDetailsNullableUpdateEnvelopeInput>;
  google_drive?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  hideCelebrationDialog?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  id__baas_transaction?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  isChennelCreated?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isContainString?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isDeliverableAdkCompletedAdded?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isDeliverableNotExists?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isLastModifiedAtExists?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isProgramCheckout?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isProgramCheckoutBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  isProgramTeamNotExists?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isProgramTeamNotExistsByOwnerOrMember?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isPublic?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isResearchProgressAdded?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isSaveAdkMoleculeAdded?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isShowTimer?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isStakeholdersUpdated?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isStudentSchemaAdded?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isTeamAdkCompletedAdded?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isTrainProgressAdded?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isUniqueFieldIdAdded?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isUniqueIdAdded?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isUnsponsoredProgram?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isUpdateOrg?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  is_default?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  lastSaved?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  last_clock_in?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  last_clock_out?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  last_synced_at?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  microsoft_office?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  navigate_various_workflow_mapping_?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  offerDetails?: InputMaybe<StudentOfferDetailsNullableUpdateEnvelopeInput>;
  organizationId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  organizationName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  participantType?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  percentageCompleted?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  previouslyUnsponsored?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  problemScope?: InputMaybe<Array<StudentProblemScopeCreateInput>>;
  programName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  program_id?: InputMaybe<StringFieldUpdateOperationsInput>;
  progress?: InputMaybe<Scalars['JSON']['input']>;
  referralShareCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  resourceWeb?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  rewards?: InputMaybe<Scalars['JSON']['input']>;
  role?: InputMaybe<Scalars['JSON']['input']>;
  schemaJobProgress?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  sharable_url?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  social_media?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  sponsorDetails?: InputMaybe<StudentSponsorDetailsNullableUpdateEnvelopeInput>;
  sponsorRequest_id?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  spreadsheets?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  stakeholders?: InputMaybe<Array<StudentStakeholdersCreateInput>>;
  studentEthnicity?: InputMaybe<StudentUpdatestudentEthnicityInput>;
  studentLocation?: InputMaybe<Scalars['JSON']['input']>;
  studentResidence?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  studentSchool?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  this_is_for_testing?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  timerType?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  tokens?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  unsponsoredAdk?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type StudentUpdateManyWithWhereWithoutParticipantInput = {
  data: StudentUpdateManyMutationInput;
  where: StudentScalarWhereInput;
};

export type StudentUpdateManyWithoutParticipantNestedInput = {
  connect?: InputMaybe<Array<StudentWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<StudentCreateOrConnectWithoutParticipantInput>>;
  create?: InputMaybe<Array<StudentCreateWithoutParticipantInput>>;
  createMany?: InputMaybe<StudentCreateManyParticipantInputEnvelope>;
  delete?: InputMaybe<Array<StudentWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<StudentScalarWhereInput>>;
  disconnect?: InputMaybe<Array<StudentWhereUniqueInput>>;
  set?: InputMaybe<Array<StudentWhereUniqueInput>>;
  update?: InputMaybe<Array<StudentUpdateWithWhereUniqueWithoutParticipantInput>>;
  updateMany?: InputMaybe<Array<StudentUpdateManyWithWhereWithoutParticipantInput>>;
  upsert?: InputMaybe<Array<StudentUpsertWithWhereUniqueWithoutParticipantInput>>;
};

export type StudentUpdateWithWhereUniqueWithoutParticipantInput = {
  data: StudentUpdateWithoutParticipantInput;
  where: StudentWhereUniqueInput;
};

export type StudentUpdateWithoutParticipantInput = {
  Access_to_a_Smartphone?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  Adobe?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  Adobe_Illustrator?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  Alan_AI?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  Any_type_of_Video_Editting_Software?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  Any_type_of_spreadsheet?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  Bexi?: InputMaybe<StudentBexiNullableUpdateEnvelopeInput>;
  Bucket?: InputMaybe<StudentBucketNullableUpdateEnvelopeInput>;
  Cognixion_Speakprose_app?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  D_design?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  Email?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  Good_oral_and_written_communication_skills?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  Graphic_Design_tools?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  Instagram?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  LinkedIn?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  No?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  None__but_comfort_with_video_editing_could_be_helpful?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  Picterra_platform?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  Picterra_university?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  Python_coding_language?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  Social_Media_experience?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  Trello?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  Website_Design?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  accessSkills?: InputMaybe<StudentUpdateaccessSkillsInput>;
  activityNotification?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  adks?: InputMaybe<Array<StudentAdksCreateInput>>;
  airtable?: InputMaybe<Array<StudentAirtableCreateInput>>;
  anonymous?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  applicationStatus?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  categories?: InputMaybe<Array<StudentCategoriesCreateInput>>;
  checkoutQualification?: InputMaybe<StudentCheckoutQualificationNullableUpdateEnvelopeInput>;
  claimedSponsorshipDetails?: InputMaybe<StudentClaimedSponsorshipDetailsNullableUpdateEnvelopeInput>;
  created?: InputMaybe<Scalars['JSON']['input']>;
  credentials?: InputMaybe<Array<StudentCredentialsCreateInput>>;
  deadlineCompletion?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  domain?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  enrolledAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  externShip?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  googleDetails?: InputMaybe<StudentGoogleDetailsNullableUpdateEnvelopeInput>;
  google_drive?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  hideCelebrationDialog?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  id__baas_transaction?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  isChennelCreated?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isContainString?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isDeliverableAdkCompletedAdded?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isDeliverableNotExists?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isLastModifiedAtExists?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isProgramCheckout?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isProgramCheckoutBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  isProgramTeamNotExists?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isProgramTeamNotExistsByOwnerOrMember?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isPublic?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isResearchProgressAdded?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isSaveAdkMoleculeAdded?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isShowTimer?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isStakeholdersUpdated?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isStudentSchemaAdded?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isTeamAdkCompletedAdded?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isTrainProgressAdded?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isUniqueFieldIdAdded?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isUniqueIdAdded?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isUnsponsoredProgram?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isUpdateOrg?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  is_default?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  lastSaved?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  last_clock_in?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  last_clock_out?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  last_synced_at?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  microsoft_office?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  navigate_various_workflow_mapping_?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  offerDetails?: InputMaybe<StudentOfferDetailsNullableUpdateEnvelopeInput>;
  organizationId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  organizationName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  participantType?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  percentageCompleted?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  previouslyUnsponsored?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  problemScope?: InputMaybe<Array<StudentProblemScopeCreateInput>>;
  programName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  program_id?: InputMaybe<StringFieldUpdateOperationsInput>;
  progress?: InputMaybe<Scalars['JSON']['input']>;
  referralShareCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  resourceWeb?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  rewards?: InputMaybe<Scalars['JSON']['input']>;
  role?: InputMaybe<Scalars['JSON']['input']>;
  schemaJobProgress?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  sharable_url?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  social_media?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  sponsorDetails?: InputMaybe<StudentSponsorDetailsNullableUpdateEnvelopeInput>;
  sponsorRequest_id?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  spreadsheets?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  stakeholders?: InputMaybe<Array<StudentStakeholdersCreateInput>>;
  studentEthnicity?: InputMaybe<StudentUpdatestudentEthnicityInput>;
  studentLocation?: InputMaybe<Scalars['JSON']['input']>;
  studentResidence?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  studentSchool?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  this_is_for_testing?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  timerType?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  tokens?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  unsponsoredAdk?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type StudentUpdateaccessSkillsInput = {
  push?: InputMaybe<Array<Scalars['String']['input']>>;
  set?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type StudentUpdatestudentEthnicityInput = {
  push?: InputMaybe<Array<Scalars['String']['input']>>;
  set?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type StudentUpsertWithWhereUniqueWithoutParticipantInput = {
  create: StudentCreateWithoutParticipantInput;
  update: StudentUpdateWithoutParticipantInput;
  where: StudentWhereUniqueInput;
};

/** Student wallet balance and transaction information */
export type StudentWalletResponse = {
  __typename?: 'StudentWalletResponse';
  /** Current available balance (can withdraw now, may be negative from chargebacks) */
  availableBalance: Scalars['Float']['output'];
  /** True if student can withdraw (balance > 0, no disputes, has Stripe Connect) */
  canWithdraw: Scalars['Boolean']['output'];
  /** True if any payment is under active dispute */
  hasDisputedPayments: Scalars['Boolean']['output'];
  /** True if balance is negative (student owes money from chargebacks) */
  hasNegativeBalance: Scalars['Boolean']['output'];
  /** Net earnings (total - chargebacks) */
  netEarnings: Scalars['Float']['output'];
  /** Amount currently being transferred to bank */
  processingBalance: Scalars['Float']['output'];
  /** Recent transactions for display */
  recentTransactions: Array<StudentWalletTransactionType>;
  /** Lifetime gross earnings (positive transactions only) */
  totalEarned: Scalars['Float']['output'];
  /** Reason why withdrawal is blocked (if canWithdraw is false) */
  withdrawalBlockedReason?: Maybe<Scalars['String']['output']>;
  /** Total amount already withdrawn to bank */
  withdrawnBalance: Scalars['Float']['output'];
};

export enum StudentWalletStatus {
  /**
   * Negative entry created from lost dispute or refund
   * These entries reduce available balance (can create debt)
   */
  ChargebackDebt = 'chargeback_debt',
  /** Payment successful and money received in student's wallet */
  Completed = 'completed',
  /** Under active dispute investigation - withdrawal blocked while disputed */
  Disputed = 'disputed',
  /** Partial refund issued - original transaction amount reduced */
  PartiallyRefunded = 'partially_refunded',
  /** Fully refunded to payer - full amount deducted from student wallet */
  Refunded = 'refunded'
}

export type StudentWalletTransaction = {
  __typename?: 'StudentWalletTransaction';
  /**
   * Transaction amount in USD dollars (NOT cents)
   * Can be NEGATIVE for chargebacks and refunds
   * Positive: Money added to student wallet
   * Negative: Money deducted (chargeback debt, refund)
   * NO PLATFORM FEE - student receives 100% of amount
   */
  amount: Scalars['Float']['output'];
  /**
   * Stripe Checkout Session ID that created this payment
   * Example: 'cs_test_a1b2c3d4e5...'
   * Used for tracking and idempotency
   */
  checkout_session_id?: Maybe<Scalars['String']['output']>;
  /** When this transaction was created */
  created_at: Scalars['DateTime']['output'];
  /**
   * Human-readable description/memo for the payment
   * Examples: "Project milestone 1", "Final presentation bonus"
   */
  description?: Maybe<Scalars['String']['output']>;
  /**
   * Stripe Dispute ID if payment was disputed
   * Example: 'dp_3MtwBwLkdIwHu7ix28a3tqPc'
   * Set when status changes to 'disputed'
   */
  dispute_id?: Maybe<Scalars['String']['output']>;
  /**
   * When dispute was filed against this transaction
   * Only set when status='disputed'
   */
  disputed_at?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  /**
   * Links negative entry back to original payment
   * Set on chargeback_debt entries to trace the original transaction
   * Used for: refunds, chargebacks, and audit trail
   */
  original_transaction_id?: Maybe<Scalars['String']['output']>;
  payer: User;
  /**
   * Person who made the payment (sponsor, organizer, or any authenticated user)
   * The payer - tracked for audit trail and receipts
   */
  payer_id: Scalars['String']['output'];
  /**
   * Stripe PaymentIntent ID for this transaction
   * Example: 'pi_3MtwBwLkdIwHu7ix28a3tqPa'
   * Primary identifier for idempotency checks in webhook handlers
   */
  payment_intent_id?: Maybe<Scalars['String']['output']>;
  program: Program;
  /**
   * Program context - student must be enrolled to receive payment
   * Required for validation: ensures student is enrolled in program
   */
  program_id: Scalars['String']['output'];
  /**
   * Stripe Refund ID for refund entries
   * Example: 're_3MtwBwLkdIwHu7ix28a3tqPd'
   * Set on negative entries created from refunds
   */
  refund_id?: Maybe<Scalars['String']['output']>;
  /**
   * Transaction status - tracks payment health
   * See StudentWalletStatus enum for values and meanings
   */
  status: StudentWalletStatus;
  student: User;
  /**
   * Student who owns this wallet entry (receives the money)
   * This is the wallet owner - balance calculated by SUM WHERE student_id=X
   */
  student_id: Scalars['String']['output'];
  /**
   * Stripe Transfer ID when funds withdrawn to student's bank
   * Example: 'tr_3MtwBwLkdIwHu7ix28a3tqPb'
   * Only set after successful withdrawal (transfer_status='transferred')
   */
  transfer_id?: Maybe<Scalars['String']['output']>;
  /**
   * Withdrawal status - tracks fund availability and transfer state
   * pending = in wallet, available for withdrawal
   * transferring = locked, transfer to bank in progress
   * transferred = successfully sent to student's bank account
   */
  transfer_status: TransferStatus;
  /**
   * When funds were transferred to student's bank account
   * Only set when transfer_status='transferred'
   */
  transferred_at?: Maybe<Scalars['DateTime']['output']>;
  /** When this transaction was last updated */
  updated_at: Scalars['DateTime']['output'];
};

export type StudentWalletTransactionAvgAggregate = {
  __typename?: 'StudentWalletTransactionAvgAggregate';
  amount?: Maybe<Scalars['Float']['output']>;
};

export type StudentWalletTransactionCountAggregate = {
  __typename?: 'StudentWalletTransactionCountAggregate';
  _all: Scalars['Int']['output'];
  amount: Scalars['Int']['output'];
  checkout_session_id: Scalars['Int']['output'];
  created_at: Scalars['Int']['output'];
  description: Scalars['Int']['output'];
  dispute_id: Scalars['Int']['output'];
  disputed_at: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  original_transaction_id: Scalars['Int']['output'];
  payer_id: Scalars['Int']['output'];
  payment_intent_id: Scalars['Int']['output'];
  program_id: Scalars['Int']['output'];
  refund_id: Scalars['Int']['output'];
  status: Scalars['Int']['output'];
  student_id: Scalars['Int']['output'];
  transfer_id: Scalars['Int']['output'];
  transfer_status: Scalars['Int']['output'];
  transferred_at: Scalars['Int']['output'];
  updated_at: Scalars['Int']['output'];
};

export type StudentWalletTransactionCreateManyPayerInput = {
  amount: Scalars['Float']['input'];
  checkout_session_id?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  dispute_id?: InputMaybe<Scalars['String']['input']>;
  disputed_at?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  original_transaction_id?: InputMaybe<Scalars['String']['input']>;
  payment_intent_id?: InputMaybe<Scalars['String']['input']>;
  program_id: Scalars['String']['input'];
  refund_id?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<StudentWalletStatus>;
  student_id: Scalars['String']['input'];
  transfer_id?: InputMaybe<Scalars['String']['input']>;
  transfer_status?: InputMaybe<TransferStatus>;
  transferred_at?: InputMaybe<Scalars['DateTime']['input']>;
  updated_at?: InputMaybe<Scalars['DateTime']['input']>;
};

export type StudentWalletTransactionCreateManyPayerInputEnvelope = {
  data: Array<StudentWalletTransactionCreateManyPayerInput>;
};

export type StudentWalletTransactionCreateManyProgramInput = {
  amount: Scalars['Float']['input'];
  checkout_session_id?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  dispute_id?: InputMaybe<Scalars['String']['input']>;
  disputed_at?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  original_transaction_id?: InputMaybe<Scalars['String']['input']>;
  payer_id: Scalars['String']['input'];
  payment_intent_id?: InputMaybe<Scalars['String']['input']>;
  refund_id?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<StudentWalletStatus>;
  student_id: Scalars['String']['input'];
  transfer_id?: InputMaybe<Scalars['String']['input']>;
  transfer_status?: InputMaybe<TransferStatus>;
  transferred_at?: InputMaybe<Scalars['DateTime']['input']>;
  updated_at?: InputMaybe<Scalars['DateTime']['input']>;
};

export type StudentWalletTransactionCreateManyProgramInputEnvelope = {
  data: Array<StudentWalletTransactionCreateManyProgramInput>;
};

export type StudentWalletTransactionCreateManyStudentInput = {
  amount: Scalars['Float']['input'];
  checkout_session_id?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  dispute_id?: InputMaybe<Scalars['String']['input']>;
  disputed_at?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  original_transaction_id?: InputMaybe<Scalars['String']['input']>;
  payer_id: Scalars['String']['input'];
  payment_intent_id?: InputMaybe<Scalars['String']['input']>;
  program_id: Scalars['String']['input'];
  refund_id?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<StudentWalletStatus>;
  transfer_id?: InputMaybe<Scalars['String']['input']>;
  transfer_status?: InputMaybe<TransferStatus>;
  transferred_at?: InputMaybe<Scalars['DateTime']['input']>;
  updated_at?: InputMaybe<Scalars['DateTime']['input']>;
};

export type StudentWalletTransactionCreateManyStudentInputEnvelope = {
  data: Array<StudentWalletTransactionCreateManyStudentInput>;
};

export type StudentWalletTransactionCreateNestedManyWithoutPayerInput = {
  connect?: InputMaybe<Array<StudentWalletTransactionWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<StudentWalletTransactionCreateOrConnectWithoutPayerInput>>;
  create?: InputMaybe<Array<StudentWalletTransactionCreateWithoutPayerInput>>;
  createMany?: InputMaybe<StudentWalletTransactionCreateManyPayerInputEnvelope>;
};

export type StudentWalletTransactionCreateNestedManyWithoutProgramInput = {
  connect?: InputMaybe<Array<StudentWalletTransactionWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<StudentWalletTransactionCreateOrConnectWithoutProgramInput>>;
  create?: InputMaybe<Array<StudentWalletTransactionCreateWithoutProgramInput>>;
  createMany?: InputMaybe<StudentWalletTransactionCreateManyProgramInputEnvelope>;
};

export type StudentWalletTransactionCreateNestedManyWithoutStudentInput = {
  connect?: InputMaybe<Array<StudentWalletTransactionWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<StudentWalletTransactionCreateOrConnectWithoutStudentInput>>;
  create?: InputMaybe<Array<StudentWalletTransactionCreateWithoutStudentInput>>;
  createMany?: InputMaybe<StudentWalletTransactionCreateManyStudentInputEnvelope>;
};

export type StudentWalletTransactionCreateOrConnectWithoutPayerInput = {
  create: StudentWalletTransactionCreateWithoutPayerInput;
  where: StudentWalletTransactionWhereUniqueInput;
};

export type StudentWalletTransactionCreateOrConnectWithoutProgramInput = {
  create: StudentWalletTransactionCreateWithoutProgramInput;
  where: StudentWalletTransactionWhereUniqueInput;
};

export type StudentWalletTransactionCreateOrConnectWithoutStudentInput = {
  create: StudentWalletTransactionCreateWithoutStudentInput;
  where: StudentWalletTransactionWhereUniqueInput;
};

export type StudentWalletTransactionCreateWithoutPayerInput = {
  amount: Scalars['Float']['input'];
  checkout_session_id?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  dispute_id?: InputMaybe<Scalars['String']['input']>;
  disputed_at?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  original_transaction_id?: InputMaybe<Scalars['String']['input']>;
  payment_intent_id?: InputMaybe<Scalars['String']['input']>;
  program: ProgramCreateNestedOneWithoutStudentWalletTransactionsInput;
  refund_id?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<StudentWalletStatus>;
  student: UserCreateNestedOneWithoutStudentWalletTransactionsInput;
  transfer_id?: InputMaybe<Scalars['String']['input']>;
  transfer_status?: InputMaybe<TransferStatus>;
  transferred_at?: InputMaybe<Scalars['DateTime']['input']>;
  updated_at?: InputMaybe<Scalars['DateTime']['input']>;
};

export type StudentWalletTransactionCreateWithoutProgramInput = {
  amount: Scalars['Float']['input'];
  checkout_session_id?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  dispute_id?: InputMaybe<Scalars['String']['input']>;
  disputed_at?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  original_transaction_id?: InputMaybe<Scalars['String']['input']>;
  payer: UserCreateNestedOneWithoutStudentWalletPaymentsInput;
  payment_intent_id?: InputMaybe<Scalars['String']['input']>;
  refund_id?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<StudentWalletStatus>;
  student: UserCreateNestedOneWithoutStudentWalletTransactionsInput;
  transfer_id?: InputMaybe<Scalars['String']['input']>;
  transfer_status?: InputMaybe<TransferStatus>;
  transferred_at?: InputMaybe<Scalars['DateTime']['input']>;
  updated_at?: InputMaybe<Scalars['DateTime']['input']>;
};

export type StudentWalletTransactionCreateWithoutStudentInput = {
  amount: Scalars['Float']['input'];
  checkout_session_id?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  dispute_id?: InputMaybe<Scalars['String']['input']>;
  disputed_at?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  original_transaction_id?: InputMaybe<Scalars['String']['input']>;
  payer: UserCreateNestedOneWithoutStudentWalletPaymentsInput;
  payment_intent_id?: InputMaybe<Scalars['String']['input']>;
  program: ProgramCreateNestedOneWithoutStudentWalletTransactionsInput;
  refund_id?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<StudentWalletStatus>;
  transfer_id?: InputMaybe<Scalars['String']['input']>;
  transfer_status?: InputMaybe<TransferStatus>;
  transferred_at?: InputMaybe<Scalars['DateTime']['input']>;
  updated_at?: InputMaybe<Scalars['DateTime']['input']>;
};

export type StudentWalletTransactionListRelationFilter = {
  every?: InputMaybe<StudentWalletTransactionWhereInput>;
  none?: InputMaybe<StudentWalletTransactionWhereInput>;
  some?: InputMaybe<StudentWalletTransactionWhereInput>;
};

export type StudentWalletTransactionMaxAggregate = {
  __typename?: 'StudentWalletTransactionMaxAggregate';
  amount?: Maybe<Scalars['Float']['output']>;
  checkout_session_id?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  dispute_id?: Maybe<Scalars['String']['output']>;
  disputed_at?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  original_transaction_id?: Maybe<Scalars['String']['output']>;
  payer_id?: Maybe<Scalars['String']['output']>;
  payment_intent_id?: Maybe<Scalars['String']['output']>;
  program_id?: Maybe<Scalars['String']['output']>;
  refund_id?: Maybe<Scalars['String']['output']>;
  status?: Maybe<StudentWalletStatus>;
  student_id?: Maybe<Scalars['String']['output']>;
  transfer_id?: Maybe<Scalars['String']['output']>;
  transfer_status?: Maybe<TransferStatus>;
  transferred_at?: Maybe<Scalars['DateTime']['output']>;
  updated_at?: Maybe<Scalars['DateTime']['output']>;
};

export type StudentWalletTransactionMinAggregate = {
  __typename?: 'StudentWalletTransactionMinAggregate';
  amount?: Maybe<Scalars['Float']['output']>;
  checkout_session_id?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  dispute_id?: Maybe<Scalars['String']['output']>;
  disputed_at?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  original_transaction_id?: Maybe<Scalars['String']['output']>;
  payer_id?: Maybe<Scalars['String']['output']>;
  payment_intent_id?: Maybe<Scalars['String']['output']>;
  program_id?: Maybe<Scalars['String']['output']>;
  refund_id?: Maybe<Scalars['String']['output']>;
  status?: Maybe<StudentWalletStatus>;
  student_id?: Maybe<Scalars['String']['output']>;
  transfer_id?: Maybe<Scalars['String']['output']>;
  transfer_status?: Maybe<TransferStatus>;
  transferred_at?: Maybe<Scalars['DateTime']['output']>;
  updated_at?: Maybe<Scalars['DateTime']['output']>;
};

export type StudentWalletTransactionScalarWhereInput = {
  AND?: InputMaybe<Array<StudentWalletTransactionScalarWhereInput>>;
  NOT?: InputMaybe<Array<StudentWalletTransactionScalarWhereInput>>;
  OR?: InputMaybe<Array<StudentWalletTransactionScalarWhereInput>>;
  amount?: InputMaybe<FloatFilter>;
  checkout_session_id?: InputMaybe<StringNullableFilter>;
  created_at?: InputMaybe<DateTimeFilter>;
  description?: InputMaybe<StringNullableFilter>;
  dispute_id?: InputMaybe<StringNullableFilter>;
  disputed_at?: InputMaybe<DateTimeNullableFilter>;
  id?: InputMaybe<StringFilter>;
  original_transaction_id?: InputMaybe<StringNullableFilter>;
  payer_id?: InputMaybe<StringFilter>;
  payment_intent_id?: InputMaybe<StringNullableFilter>;
  program_id?: InputMaybe<StringFilter>;
  refund_id?: InputMaybe<StringNullableFilter>;
  status?: InputMaybe<EnumStudentWalletStatusFilter>;
  student_id?: InputMaybe<StringFilter>;
  transfer_id?: InputMaybe<StringNullableFilter>;
  transfer_status?: InputMaybe<EnumTransferStatusFilter>;
  transferred_at?: InputMaybe<DateTimeNullableFilter>;
  updated_at?: InputMaybe<DateTimeFilter>;
};

export type StudentWalletTransactionSumAggregate = {
  __typename?: 'StudentWalletTransactionSumAggregate';
  amount?: Maybe<Scalars['Float']['output']>;
};

/** A transaction in a student wallet */
export type StudentWalletTransactionType = {
  __typename?: 'StudentWalletTransactionType';
  /** Amount in dollars (positive for credits, negative for chargebacks/refunds) */
  amount: Scalars['Float']['output'];
  /** Stripe Checkout Session ID */
  checkout_session_id?: Maybe<Scalars['String']['output']>;
  /** When this transaction was created */
  created_at: Scalars['DateTime']['output'];
  /** Human-readable payment description */
  description?: Maybe<Scalars['String']['output']>;
  /** Stripe Dispute ID (if disputed) */
  dispute_id?: Maybe<Scalars['String']['output']>;
  /** When dispute was filed */
  disputed_at?: Maybe<Scalars['DateTime']['output']>;
  /** Unique transaction identifier */
  id: Scalars['ID']['output'];
  /** Original transaction ID for refund/chargeback entries */
  original_transaction_id?: Maybe<Scalars['String']['output']>;
  /** Payer ID who made the payment */
  payer_id: Scalars['String']['output'];
  /** Stripe PaymentIntent ID */
  payment_intent_id?: Maybe<Scalars['String']['output']>;
  /** Program ID the payment is associated with */
  program_id: Scalars['String']['output'];
  /** Stripe Refund ID (for refund entries) */
  refund_id?: Maybe<Scalars['String']['output']>;
  /** Transaction status (payment health) */
  status: StudentWalletStatus;
  /** Student ID who owns this wallet entry */
  student_id: Scalars['String']['output'];
  /** Stripe Transfer ID (set after withdrawal) */
  transfer_id?: Maybe<Scalars['String']['output']>;
  /** Transfer status (withdrawal state) */
  transfer_status: TransferStatus;
  /** When funds were transferred to bank */
  transferred_at?: Maybe<Scalars['DateTime']['output']>;
  /** When this transaction was last updated */
  updated_at: Scalars['DateTime']['output'];
};

export type StudentWalletTransactionUpdateManyMutationInput = {
  amount?: InputMaybe<FloatFieldUpdateOperationsInput>;
  checkout_session_id?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  created_at?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  dispute_id?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  disputed_at?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  original_transaction_id?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payment_intent_id?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  refund_id?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumStudentWalletStatusFieldUpdateOperationsInput>;
  transfer_id?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  transfer_status?: InputMaybe<EnumTransferStatusFieldUpdateOperationsInput>;
  transferred_at?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  updated_at?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type StudentWalletTransactionUpdateManyWithWhereWithoutPayerInput = {
  data: StudentWalletTransactionUpdateManyMutationInput;
  where: StudentWalletTransactionScalarWhereInput;
};

export type StudentWalletTransactionUpdateManyWithWhereWithoutProgramInput = {
  data: StudentWalletTransactionUpdateManyMutationInput;
  where: StudentWalletTransactionScalarWhereInput;
};

export type StudentWalletTransactionUpdateManyWithWhereWithoutStudentInput = {
  data: StudentWalletTransactionUpdateManyMutationInput;
  where: StudentWalletTransactionScalarWhereInput;
};

export type StudentWalletTransactionUpdateManyWithoutPayerNestedInput = {
  connect?: InputMaybe<Array<StudentWalletTransactionWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<StudentWalletTransactionCreateOrConnectWithoutPayerInput>>;
  create?: InputMaybe<Array<StudentWalletTransactionCreateWithoutPayerInput>>;
  createMany?: InputMaybe<StudentWalletTransactionCreateManyPayerInputEnvelope>;
  delete?: InputMaybe<Array<StudentWalletTransactionWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<StudentWalletTransactionScalarWhereInput>>;
  disconnect?: InputMaybe<Array<StudentWalletTransactionWhereUniqueInput>>;
  set?: InputMaybe<Array<StudentWalletTransactionWhereUniqueInput>>;
  update?: InputMaybe<Array<StudentWalletTransactionUpdateWithWhereUniqueWithoutPayerInput>>;
  updateMany?: InputMaybe<Array<StudentWalletTransactionUpdateManyWithWhereWithoutPayerInput>>;
  upsert?: InputMaybe<Array<StudentWalletTransactionUpsertWithWhereUniqueWithoutPayerInput>>;
};

export type StudentWalletTransactionUpdateManyWithoutProgramNestedInput = {
  connect?: InputMaybe<Array<StudentWalletTransactionWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<StudentWalletTransactionCreateOrConnectWithoutProgramInput>>;
  create?: InputMaybe<Array<StudentWalletTransactionCreateWithoutProgramInput>>;
  createMany?: InputMaybe<StudentWalletTransactionCreateManyProgramInputEnvelope>;
  delete?: InputMaybe<Array<StudentWalletTransactionWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<StudentWalletTransactionScalarWhereInput>>;
  disconnect?: InputMaybe<Array<StudentWalletTransactionWhereUniqueInput>>;
  set?: InputMaybe<Array<StudentWalletTransactionWhereUniqueInput>>;
  update?: InputMaybe<Array<StudentWalletTransactionUpdateWithWhereUniqueWithoutProgramInput>>;
  updateMany?: InputMaybe<Array<StudentWalletTransactionUpdateManyWithWhereWithoutProgramInput>>;
  upsert?: InputMaybe<Array<StudentWalletTransactionUpsertWithWhereUniqueWithoutProgramInput>>;
};

export type StudentWalletTransactionUpdateManyWithoutStudentNestedInput = {
  connect?: InputMaybe<Array<StudentWalletTransactionWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<StudentWalletTransactionCreateOrConnectWithoutStudentInput>>;
  create?: InputMaybe<Array<StudentWalletTransactionCreateWithoutStudentInput>>;
  createMany?: InputMaybe<StudentWalletTransactionCreateManyStudentInputEnvelope>;
  delete?: InputMaybe<Array<StudentWalletTransactionWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<StudentWalletTransactionScalarWhereInput>>;
  disconnect?: InputMaybe<Array<StudentWalletTransactionWhereUniqueInput>>;
  set?: InputMaybe<Array<StudentWalletTransactionWhereUniqueInput>>;
  update?: InputMaybe<Array<StudentWalletTransactionUpdateWithWhereUniqueWithoutStudentInput>>;
  updateMany?: InputMaybe<Array<StudentWalletTransactionUpdateManyWithWhereWithoutStudentInput>>;
  upsert?: InputMaybe<Array<StudentWalletTransactionUpsertWithWhereUniqueWithoutStudentInput>>;
};

export type StudentWalletTransactionUpdateWithWhereUniqueWithoutPayerInput = {
  data: StudentWalletTransactionUpdateWithoutPayerInput;
  where: StudentWalletTransactionWhereUniqueInput;
};

export type StudentWalletTransactionUpdateWithWhereUniqueWithoutProgramInput = {
  data: StudentWalletTransactionUpdateWithoutProgramInput;
  where: StudentWalletTransactionWhereUniqueInput;
};

export type StudentWalletTransactionUpdateWithWhereUniqueWithoutStudentInput = {
  data: StudentWalletTransactionUpdateWithoutStudentInput;
  where: StudentWalletTransactionWhereUniqueInput;
};

export type StudentWalletTransactionUpdateWithoutPayerInput = {
  amount?: InputMaybe<FloatFieldUpdateOperationsInput>;
  checkout_session_id?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  created_at?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  dispute_id?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  disputed_at?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  original_transaction_id?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payment_intent_id?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  program?: InputMaybe<ProgramUpdateOneRequiredWithoutStudentWalletTransactionsNestedInput>;
  refund_id?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumStudentWalletStatusFieldUpdateOperationsInput>;
  student?: InputMaybe<UserUpdateOneRequiredWithoutStudentWalletTransactionsNestedInput>;
  transfer_id?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  transfer_status?: InputMaybe<EnumTransferStatusFieldUpdateOperationsInput>;
  transferred_at?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  updated_at?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type StudentWalletTransactionUpdateWithoutProgramInput = {
  amount?: InputMaybe<FloatFieldUpdateOperationsInput>;
  checkout_session_id?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  created_at?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  dispute_id?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  disputed_at?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  original_transaction_id?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payer?: InputMaybe<UserUpdateOneRequiredWithoutStudentWalletPaymentsNestedInput>;
  payment_intent_id?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  refund_id?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumStudentWalletStatusFieldUpdateOperationsInput>;
  student?: InputMaybe<UserUpdateOneRequiredWithoutStudentWalletTransactionsNestedInput>;
  transfer_id?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  transfer_status?: InputMaybe<EnumTransferStatusFieldUpdateOperationsInput>;
  transferred_at?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  updated_at?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type StudentWalletTransactionUpdateWithoutStudentInput = {
  amount?: InputMaybe<FloatFieldUpdateOperationsInput>;
  checkout_session_id?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  created_at?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  dispute_id?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  disputed_at?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  original_transaction_id?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payer?: InputMaybe<UserUpdateOneRequiredWithoutStudentWalletPaymentsNestedInput>;
  payment_intent_id?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  program?: InputMaybe<ProgramUpdateOneRequiredWithoutStudentWalletTransactionsNestedInput>;
  refund_id?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumStudentWalletStatusFieldUpdateOperationsInput>;
  transfer_id?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  transfer_status?: InputMaybe<EnumTransferStatusFieldUpdateOperationsInput>;
  transferred_at?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  updated_at?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type StudentWalletTransactionUpsertWithWhereUniqueWithoutPayerInput = {
  create: StudentWalletTransactionCreateWithoutPayerInput;
  update: StudentWalletTransactionUpdateWithoutPayerInput;
  where: StudentWalletTransactionWhereUniqueInput;
};

export type StudentWalletTransactionUpsertWithWhereUniqueWithoutProgramInput = {
  create: StudentWalletTransactionCreateWithoutProgramInput;
  update: StudentWalletTransactionUpdateWithoutProgramInput;
  where: StudentWalletTransactionWhereUniqueInput;
};

export type StudentWalletTransactionUpsertWithWhereUniqueWithoutStudentInput = {
  create: StudentWalletTransactionCreateWithoutStudentInput;
  update: StudentWalletTransactionUpdateWithoutStudentInput;
  where: StudentWalletTransactionWhereUniqueInput;
};

export type StudentWalletTransactionWhereInput = {
  AND?: InputMaybe<Array<StudentWalletTransactionWhereInput>>;
  NOT?: InputMaybe<Array<StudentWalletTransactionWhereInput>>;
  OR?: InputMaybe<Array<StudentWalletTransactionWhereInput>>;
  amount?: InputMaybe<FloatFilter>;
  checkout_session_id?: InputMaybe<StringNullableFilter>;
  created_at?: InputMaybe<DateTimeFilter>;
  description?: InputMaybe<StringNullableFilter>;
  dispute_id?: InputMaybe<StringNullableFilter>;
  disputed_at?: InputMaybe<DateTimeNullableFilter>;
  id?: InputMaybe<StringFilter>;
  original_transaction_id?: InputMaybe<StringNullableFilter>;
  payer?: InputMaybe<UserRelationFilter>;
  payer_id?: InputMaybe<StringFilter>;
  payment_intent_id?: InputMaybe<StringNullableFilter>;
  program?: InputMaybe<ProgramRelationFilter>;
  program_id?: InputMaybe<StringFilter>;
  refund_id?: InputMaybe<StringNullableFilter>;
  status?: InputMaybe<EnumStudentWalletStatusFilter>;
  student?: InputMaybe<UserRelationFilter>;
  student_id?: InputMaybe<StringFilter>;
  transfer_id?: InputMaybe<StringNullableFilter>;
  transfer_status?: InputMaybe<EnumTransferStatusFilter>;
  transferred_at?: InputMaybe<DateTimeNullableFilter>;
  updated_at?: InputMaybe<DateTimeFilter>;
};

export type StudentWalletTransactionWhereUniqueInput = {
  AND?: InputMaybe<Array<StudentWalletTransactionWhereInput>>;
  NOT?: InputMaybe<Array<StudentWalletTransactionWhereInput>>;
  OR?: InputMaybe<Array<StudentWalletTransactionWhereInput>>;
  amount?: InputMaybe<FloatFilter>;
  checkout_session_id?: InputMaybe<StringNullableFilter>;
  created_at?: InputMaybe<DateTimeFilter>;
  description?: InputMaybe<StringNullableFilter>;
  dispute_id?: InputMaybe<StringNullableFilter>;
  disputed_at?: InputMaybe<DateTimeNullableFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  original_transaction_id?: InputMaybe<StringNullableFilter>;
  payer?: InputMaybe<UserRelationFilter>;
  payer_id?: InputMaybe<StringFilter>;
  payment_intent_id?: InputMaybe<StringNullableFilter>;
  program?: InputMaybe<ProgramRelationFilter>;
  program_id?: InputMaybe<StringFilter>;
  refund_id?: InputMaybe<StringNullableFilter>;
  status?: InputMaybe<EnumStudentWalletStatusFilter>;
  student?: InputMaybe<UserRelationFilter>;
  student_id?: InputMaybe<StringFilter>;
  transfer_id?: InputMaybe<StringNullableFilter>;
  transfer_status?: InputMaybe<EnumTransferStatusFilter>;
  transferred_at?: InputMaybe<DateTimeNullableFilter>;
  updated_at?: InputMaybe<DateTimeFilter>;
};

/** Response from processing a student withdrawal */
export type StudentWalletWithdrawalResponse = {
  __typename?: 'StudentWalletWithdrawalResponse';
  /** Amount withdrawn in dollars */
  amount?: Maybe<Scalars['Float']['output']>;
  /** Human-readable result message */
  message?: Maybe<Scalars['String']['output']>;
  /** Whether the withdrawal succeeded */
  success: Scalars['Boolean']['output'];
  /** Stripe Transfer ID (if successful) */
  transferId?: Maybe<Scalars['String']['output']>;
};

export type StudentWhereInput = {
  AND?: InputMaybe<Array<StudentWhereInput>>;
  Access_to_a_Smartphone?: InputMaybe<BoolNullableFilter>;
  Adobe?: InputMaybe<BoolNullableFilter>;
  Adobe_Illustrator?: InputMaybe<BoolNullableFilter>;
  Alan_AI?: InputMaybe<BoolNullableFilter>;
  Any_type_of_Video_Editting_Software?: InputMaybe<BoolNullableFilter>;
  Any_type_of_spreadsheet?: InputMaybe<BoolNullableFilter>;
  Bexi?: InputMaybe<StudentBexiNullableCompositeFilter>;
  Bucket?: InputMaybe<StudentBucketNullableCompositeFilter>;
  Cognixion_Speakprose_app?: InputMaybe<BoolNullableFilter>;
  D_design?: InputMaybe<BoolNullableFilter>;
  Email?: InputMaybe<BoolNullableFilter>;
  Good_oral_and_written_communication_skills?: InputMaybe<BoolNullableFilter>;
  Graphic_Design_tools?: InputMaybe<BoolNullableFilter>;
  Instagram?: InputMaybe<BoolNullableFilter>;
  LinkedIn?: InputMaybe<BoolNullableFilter>;
  NOT?: InputMaybe<Array<StudentWhereInput>>;
  No?: InputMaybe<BoolNullableFilter>;
  None__but_comfort_with_video_editing_could_be_helpful?: InputMaybe<BoolNullableFilter>;
  OR?: InputMaybe<Array<StudentWhereInput>>;
  Picterra_platform?: InputMaybe<BoolNullableFilter>;
  Picterra_university?: InputMaybe<BoolNullableFilter>;
  Python_coding_language?: InputMaybe<BoolNullableFilter>;
  Social_Media_experience?: InputMaybe<BoolNullableFilter>;
  Trello?: InputMaybe<BoolNullableFilter>;
  Website_Design?: InputMaybe<BoolNullableFilter>;
  accessSkills?: InputMaybe<StringNullableListFilter>;
  activityNotification?: InputMaybe<BoolNullableFilter>;
  adks?: InputMaybe<Array<StudentAdksObjectEqualityInput>>;
  airtable?: InputMaybe<Array<StudentAirtableObjectEqualityInput>>;
  anonymous?: InputMaybe<BoolNullableFilter>;
  applicationStatus?: InputMaybe<StringNullableFilter>;
  categories?: InputMaybe<Array<StudentCategoriesObjectEqualityInput>>;
  checkoutQualification?: InputMaybe<StudentCheckoutQualificationNullableCompositeFilter>;
  claimedSponsorshipDetails?: InputMaybe<StudentClaimedSponsorshipDetailsNullableCompositeFilter>;
  created?: InputMaybe<JsonFilter>;
  credentials?: InputMaybe<Array<StudentCredentialsObjectEqualityInput>>;
  deadlineCompletion?: InputMaybe<StringNullableFilter>;
  domain?: InputMaybe<StringNullableFilter>;
  enrolledAt?: InputMaybe<DateTimeNullableFilter>;
  externShip?: InputMaybe<StringNullableFilter>;
  googleDetails?: InputMaybe<StudentGoogleDetailsNullableCompositeFilter>;
  google_drive?: InputMaybe<BoolNullableFilter>;
  hideCelebrationDialog?: InputMaybe<BoolNullableFilter>;
  id?: InputMaybe<StringFilter>;
  id__baas_transaction?: InputMaybe<StringNullableFilter>;
  isChennelCreated?: InputMaybe<BoolNullableFilter>;
  isContainString?: InputMaybe<BoolNullableFilter>;
  isDeliverableAdkCompletedAdded?: InputMaybe<BoolNullableFilter>;
  isDeliverableNotExists?: InputMaybe<BoolNullableFilter>;
  isLastModifiedAtExists?: InputMaybe<BoolNullableFilter>;
  isProgramCheckout?: InputMaybe<BoolNullableFilter>;
  isProgramCheckoutBy?: InputMaybe<StringNullableFilter>;
  isProgramTeamNotExists?: InputMaybe<BoolNullableFilter>;
  isProgramTeamNotExistsByOwnerOrMember?: InputMaybe<BoolNullableFilter>;
  isPublic?: InputMaybe<BoolNullableFilter>;
  isResearchProgressAdded?: InputMaybe<BoolNullableFilter>;
  isSaveAdkMoleculeAdded?: InputMaybe<BoolNullableFilter>;
  isShowTimer?: InputMaybe<BoolNullableFilter>;
  isStakeholdersUpdated?: InputMaybe<BoolNullableFilter>;
  isStudentSchemaAdded?: InputMaybe<BoolNullableFilter>;
  isTeamAdkCompletedAdded?: InputMaybe<BoolNullableFilter>;
  isTrainProgressAdded?: InputMaybe<BoolNullableFilter>;
  isUniqueFieldIdAdded?: InputMaybe<BoolNullableFilter>;
  isUniqueIdAdded?: InputMaybe<BoolNullableFilter>;
  isUnsponsoredProgram?: InputMaybe<BoolNullableFilter>;
  isUpdateOrg?: InputMaybe<BoolNullableFilter>;
  is_default?: InputMaybe<BoolNullableFilter>;
  lastSaved?: InputMaybe<DateTimeNullableFilter>;
  last_clock_in?: InputMaybe<StringNullableFilter>;
  last_clock_out?: InputMaybe<StringNullableFilter>;
  last_synced_at?: InputMaybe<DateTimeFilter>;
  microsoft_office?: InputMaybe<BoolNullableFilter>;
  navigate_various_workflow_mapping_?: InputMaybe<BoolNullableFilter>;
  offerDetails?: InputMaybe<StudentOfferDetailsNullableCompositeFilter>;
  organizationId?: InputMaybe<StringNullableFilter>;
  organizationName?: InputMaybe<StringNullableFilter>;
  participant?: InputMaybe<UserRelationFilter>;
  participantType?: InputMaybe<StringNullableFilter>;
  participant_id?: InputMaybe<StringFilter>;
  percentageCompleted?: InputMaybe<FloatNullableFilter>;
  previouslyUnsponsored?: InputMaybe<BoolNullableFilter>;
  problemScope?: InputMaybe<Array<StudentProblemScopeObjectEqualityInput>>;
  programName?: InputMaybe<StringNullableFilter>;
  program_id?: InputMaybe<StringFilter>;
  progress?: InputMaybe<JsonNullableFilter>;
  referralShareCode?: InputMaybe<StringNullableFilter>;
  resourceWeb?: InputMaybe<StringNullableFilter>;
  rewards?: InputMaybe<JsonNullableFilter>;
  role?: InputMaybe<JsonNullableFilter>;
  schemaJobProgress?: InputMaybe<BoolNullableFilter>;
  sharable_url?: InputMaybe<StringNullableFilter>;
  social_media?: InputMaybe<BoolNullableFilter>;
  sponsorDetails?: InputMaybe<StudentSponsorDetailsNullableCompositeFilter>;
  sponsorRequest_id?: InputMaybe<StringNullableFilter>;
  spreadsheets?: InputMaybe<BoolNullableFilter>;
  stakeholders?: InputMaybe<Array<StudentStakeholdersObjectEqualityInput>>;
  studentEthnicity?: InputMaybe<StringNullableListFilter>;
  studentLocation?: InputMaybe<JsonNullableFilter>;
  studentResidence?: InputMaybe<StringNullableFilter>;
  studentSchool?: InputMaybe<StringNullableFilter>;
  this_is_for_testing?: InputMaybe<BoolNullableFilter>;
  timerType?: InputMaybe<StringNullableFilter>;
  tokens?: InputMaybe<IntNullableFilter>;
  unsponsoredAdk?: InputMaybe<StringNullableFilter>;
};

export type StudentWhereUniqueInput = {
  AND?: InputMaybe<Array<StudentWhereInput>>;
  Access_to_a_Smartphone?: InputMaybe<BoolNullableFilter>;
  Adobe?: InputMaybe<BoolNullableFilter>;
  Adobe_Illustrator?: InputMaybe<BoolNullableFilter>;
  Alan_AI?: InputMaybe<BoolNullableFilter>;
  Any_type_of_Video_Editting_Software?: InputMaybe<BoolNullableFilter>;
  Any_type_of_spreadsheet?: InputMaybe<BoolNullableFilter>;
  Bexi?: InputMaybe<StudentBexiNullableCompositeFilter>;
  Bucket?: InputMaybe<StudentBucketNullableCompositeFilter>;
  Cognixion_Speakprose_app?: InputMaybe<BoolNullableFilter>;
  D_design?: InputMaybe<BoolNullableFilter>;
  Email?: InputMaybe<BoolNullableFilter>;
  Good_oral_and_written_communication_skills?: InputMaybe<BoolNullableFilter>;
  Graphic_Design_tools?: InputMaybe<BoolNullableFilter>;
  Instagram?: InputMaybe<BoolNullableFilter>;
  LinkedIn?: InputMaybe<BoolNullableFilter>;
  NOT?: InputMaybe<Array<StudentWhereInput>>;
  No?: InputMaybe<BoolNullableFilter>;
  None__but_comfort_with_video_editing_could_be_helpful?: InputMaybe<BoolNullableFilter>;
  OR?: InputMaybe<Array<StudentWhereInput>>;
  Picterra_platform?: InputMaybe<BoolNullableFilter>;
  Picterra_university?: InputMaybe<BoolNullableFilter>;
  Python_coding_language?: InputMaybe<BoolNullableFilter>;
  Social_Media_experience?: InputMaybe<BoolNullableFilter>;
  Trello?: InputMaybe<BoolNullableFilter>;
  Website_Design?: InputMaybe<BoolNullableFilter>;
  accessSkills?: InputMaybe<StringNullableListFilter>;
  activityNotification?: InputMaybe<BoolNullableFilter>;
  adks?: InputMaybe<Array<StudentAdksObjectEqualityInput>>;
  airtable?: InputMaybe<Array<StudentAirtableObjectEqualityInput>>;
  anonymous?: InputMaybe<BoolNullableFilter>;
  applicationStatus?: InputMaybe<StringNullableFilter>;
  categories?: InputMaybe<Array<StudentCategoriesObjectEqualityInput>>;
  checkoutQualification?: InputMaybe<StudentCheckoutQualificationNullableCompositeFilter>;
  claimedSponsorshipDetails?: InputMaybe<StudentClaimedSponsorshipDetailsNullableCompositeFilter>;
  created?: InputMaybe<JsonFilter>;
  credentials?: InputMaybe<Array<StudentCredentialsObjectEqualityInput>>;
  deadlineCompletion?: InputMaybe<StringNullableFilter>;
  domain?: InputMaybe<StringNullableFilter>;
  enrolledAt?: InputMaybe<DateTimeNullableFilter>;
  externShip?: InputMaybe<StringNullableFilter>;
  googleDetails?: InputMaybe<StudentGoogleDetailsNullableCompositeFilter>;
  google_drive?: InputMaybe<BoolNullableFilter>;
  hideCelebrationDialog?: InputMaybe<BoolNullableFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  id__baas_transaction?: InputMaybe<StringNullableFilter>;
  isChennelCreated?: InputMaybe<BoolNullableFilter>;
  isContainString?: InputMaybe<BoolNullableFilter>;
  isDeliverableAdkCompletedAdded?: InputMaybe<BoolNullableFilter>;
  isDeliverableNotExists?: InputMaybe<BoolNullableFilter>;
  isLastModifiedAtExists?: InputMaybe<BoolNullableFilter>;
  isProgramCheckout?: InputMaybe<BoolNullableFilter>;
  isProgramCheckoutBy?: InputMaybe<StringNullableFilter>;
  isProgramTeamNotExists?: InputMaybe<BoolNullableFilter>;
  isProgramTeamNotExistsByOwnerOrMember?: InputMaybe<BoolNullableFilter>;
  isPublic?: InputMaybe<BoolNullableFilter>;
  isResearchProgressAdded?: InputMaybe<BoolNullableFilter>;
  isSaveAdkMoleculeAdded?: InputMaybe<BoolNullableFilter>;
  isShowTimer?: InputMaybe<BoolNullableFilter>;
  isStakeholdersUpdated?: InputMaybe<BoolNullableFilter>;
  isStudentSchemaAdded?: InputMaybe<BoolNullableFilter>;
  isTeamAdkCompletedAdded?: InputMaybe<BoolNullableFilter>;
  isTrainProgressAdded?: InputMaybe<BoolNullableFilter>;
  isUniqueFieldIdAdded?: InputMaybe<BoolNullableFilter>;
  isUniqueIdAdded?: InputMaybe<BoolNullableFilter>;
  isUnsponsoredProgram?: InputMaybe<BoolNullableFilter>;
  isUpdateOrg?: InputMaybe<BoolNullableFilter>;
  is_default?: InputMaybe<BoolNullableFilter>;
  lastSaved?: InputMaybe<DateTimeNullableFilter>;
  last_clock_in?: InputMaybe<StringNullableFilter>;
  last_clock_out?: InputMaybe<StringNullableFilter>;
  last_synced_at?: InputMaybe<DateTimeFilter>;
  microsoft_office?: InputMaybe<BoolNullableFilter>;
  navigate_various_workflow_mapping_?: InputMaybe<BoolNullableFilter>;
  offerDetails?: InputMaybe<StudentOfferDetailsNullableCompositeFilter>;
  organizationId?: InputMaybe<StringNullableFilter>;
  organizationName?: InputMaybe<StringNullableFilter>;
  participant?: InputMaybe<UserRelationFilter>;
  participantType?: InputMaybe<StringNullableFilter>;
  participant_id?: InputMaybe<StringFilter>;
  percentageCompleted?: InputMaybe<FloatNullableFilter>;
  previouslyUnsponsored?: InputMaybe<BoolNullableFilter>;
  problemScope?: InputMaybe<Array<StudentProblemScopeObjectEqualityInput>>;
  programName?: InputMaybe<StringNullableFilter>;
  program_id?: InputMaybe<StringFilter>;
  progress?: InputMaybe<JsonNullableFilter>;
  referralShareCode?: InputMaybe<StringNullableFilter>;
  resourceWeb?: InputMaybe<StringNullableFilter>;
  rewards?: InputMaybe<JsonNullableFilter>;
  role?: InputMaybe<JsonNullableFilter>;
  schemaJobProgress?: InputMaybe<BoolNullableFilter>;
  sharable_url?: InputMaybe<StringNullableFilter>;
  social_media?: InputMaybe<BoolNullableFilter>;
  sponsorDetails?: InputMaybe<StudentSponsorDetailsNullableCompositeFilter>;
  sponsorRequest_id?: InputMaybe<StringNullableFilter>;
  spreadsheets?: InputMaybe<BoolNullableFilter>;
  stakeholders?: InputMaybe<Array<StudentStakeholdersObjectEqualityInput>>;
  studentEthnicity?: InputMaybe<StringNullableListFilter>;
  studentLocation?: InputMaybe<JsonNullableFilter>;
  studentResidence?: InputMaybe<StringNullableFilter>;
  studentSchool?: InputMaybe<StringNullableFilter>;
  this_is_for_testing?: InputMaybe<BoolNullableFilter>;
  timerType?: InputMaybe<StringNullableFilter>;
  tokens?: InputMaybe<IntNullableFilter>;
  unsponsoredAdk?: InputMaybe<StringNullableFilter>;
};

export type StudentsByProgramInput = {
  programId: Scalars['String']['input'];
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};

export type SubmitEndorsementInput = {
  adkIndex: Scalars['Float']['input'];
  criteriaResponses: Scalars['JSON']['input'];
  endorserPhone?: InputMaybe<Scalars['String']['input']>;
  fieldIndex: Scalars['Float']['input'];
  observations: Scalars['String']['input'];
  programId: Scalars['String']['input'];
  requestId: Scalars['String']['input'];
  studentId: Scalars['String']['input'];
  token: Scalars['String']['input'];
};

export type SubmitEndorsementResponse = {
  __typename?: 'SubmitEndorsementResponse';
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type Subscription = {
  __typename?: 'Subscription';
  /**
   * Subscription amount in USD (dollars, not cents)
   * Example: 10.00 for $10/month platform donation
   * Matches stripe_price_id amount at creation time
   * Frozen for grandfathering - won't change if Dashboard price changes
   */
  amount: Scalars['Float']['output'];
  /**
   * Timestamp when subscription was canceled
   * Example: 2024-06-15T14:00:00Z
   * Nullable: Only set when status changes to 'canceled'
   * Set by customer.subscription.deleted webhook
   * Note: Customer keeps access until current_period_end
   */
  canceled_at?: Maybe<Scalars['DateTime']['output']>;
  created_at: Scalars['DateTime']['output'];
  /**
   * End of current billing period (next invoice date)
   * Example: 2024-02-01T00:00:00Z (next month's billing date)
   * Updated monthly by invoice.payment_succeeded webhook
   * Customer has access until this date even if canceled
   */
  current_period_end: Scalars['DateTime']['output'];
  /**
   * Start of current billing period
   * Example: 2024-01-01T00:00:00Z for January billing cycle
   * Updated monthly by invoice.payment_succeeded webhook
   * Used for prorated cancellations and billing history
   */
  current_period_start: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  /**
   * Type-specific data stored as JSON for extensibility
   * Nullable: Optional based on subscription type needs
   * Example structures:
   * - platform_donation: { "donation_tier": "supporter", "public_profile": true }
   * - org_premium: { "features": ["analytics", "branding", "api_access"], "user_limit": 50 }
   * - user_premium: { "tier": "pro", "custom_domain": "mysite.pilotcity.com" }
   * - program_access: { "access_level": "full", "modules": ["1", "2", "3"], "video_downloads": true }
   * Allows adding new features without schema migration
   */
  metadata?: Maybe<Scalars['JSON']['output']>;
  /**
   * Organization for premium organization subscriptions
   * Example: ObjectId('507f1f77bcf86cd799439012')
   * Nullable: Only set for org_premium type (future implementation)
   * Null for all other types
   * Business logic: Organization gets premium features (analytics, branding, etc.)
   */
  organization_id?: Maybe<Scalars['String']['output']>;
  /**
   * Program for recurring program access subscriptions
   * Example: ObjectId('507f1f77bcf86cd799439014')
   * Nullable: Only set for program_access type (future implementation)
   * Null for all other types
   * Use case: Monthly membership to specific program curriculum
   */
  program_id?: Maybe<Scalars['String']['output']>;
  /**
   * Timestamp when subscription was first created
   * Example: 2024-01-01T10:30:00Z
   * Immutable after creation
   * Used for subscription age calculations and retention analytics
   */
  started_at: Scalars['DateTime']['output'];
  /**
   * Current subscription status (see SubscriptionStatus enum below)
   * Lifecycle: incomplete → trialing → active → past_due → unpaid/canceled
   * Updated by Stripe webhooks: customer.subscription.updated, invoice.payment_failed
   * Example: 'active' for healthy subscription, 'past_due' for failed payment
   */
  status: SubscriptionStatus;
  /**
   * Stripe customer ID who owns this subscription
   * Example: 'cus_NffrFeUfNV2Hib'
   * Links subscription to customer's payment methods
   * Required for all subscription types
   */
  stripe_customer_id: Scalars['String']['output'];
  /**
   * Stripe price ID that was active when subscription created
   * Example: 'price_1MowQVLkdIwHu7ixraBm864M'
   * Records exact price for grandfathering (frozen at creation time)
   * Allows changing Dashboard prices without affecting existing subscriptions
   * Note: New subscriptions fetch latest active price dynamically
   */
  stripe_price_id: Scalars['String']['output'];
  /**
   * Stripe subscription ID for this recurring payment
   * Example: 'sub_1MowQVLkdIwHu7ixeRlqHVzs'
   * Unique constraint ensures idempotency in webhook processing
   * Used to sync subscription status changes from Stripe webhooks
   */
  stripe_subscription_id: Scalars['String']['output'];
  /**
   * Student for program access subscriptions
   * Example: ObjectId('507f1f77bcf86cd799439013')
   * Nullable: Only set for program_access type (future implementation)
   * Null for all other types
   * Use case: Parents paying monthly for child's program access
   */
  student_id?: Maybe<Scalars['String']['output']>;
  /**
   * Determines which subscription type and business logic to apply
   * Values: platform_donation (implemented), org_premium (future), user_premium (future), program_access (future)
   * Used in webhook routing and relationship field validation
   * Example: 'platform_donation' routes to donation processing logic
   */
  subscription_type: SubscriptionType;
  /**
   * End of trial period for trial subscriptions
   * Example: 2024-01-15T00:00:00Z for 14-day trial
   * Nullable: Only set if subscription started with trial
   * After trial_end, first invoice charged (status: trialing → active)
   */
  trial_end?: Maybe<Scalars['DateTime']['output']>;
  updated_at: Scalars['DateTime']['output'];
  /**
   * User who owns this subscription
   * Example: ObjectId('507f1f77bcf86cd799439011')
   * Nullable: Set for platform_donation, user_premium, program_access types
   * Null for org_premium (uses organization_id instead)
   * Field usage by type:
   * - platform_donation: user donating to PilotCity
   * - user_premium: user with premium features
   * - program_access: user enrolled in program
   */
  user_id?: Maybe<Scalars['String']['output']>;
};

export type SubscriptionAvgAggregate = {
  __typename?: 'SubscriptionAvgAggregate';
  amount?: Maybe<Scalars['Float']['output']>;
};

export type SubscriptionCountAggregate = {
  __typename?: 'SubscriptionCountAggregate';
  _all: Scalars['Int']['output'];
  amount: Scalars['Int']['output'];
  canceled_at: Scalars['Int']['output'];
  created_at: Scalars['Int']['output'];
  current_period_end: Scalars['Int']['output'];
  current_period_start: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  metadata: Scalars['Int']['output'];
  organization_id: Scalars['Int']['output'];
  program_id: Scalars['Int']['output'];
  started_at: Scalars['Int']['output'];
  status: Scalars['Int']['output'];
  stripe_customer_id: Scalars['Int']['output'];
  stripe_price_id: Scalars['Int']['output'];
  stripe_subscription_id: Scalars['Int']['output'];
  student_id: Scalars['Int']['output'];
  subscription_type: Scalars['Int']['output'];
  trial_end: Scalars['Int']['output'];
  updated_at: Scalars['Int']['output'];
  user_id: Scalars['Int']['output'];
};

export type SubscriptionMaxAggregate = {
  __typename?: 'SubscriptionMaxAggregate';
  amount?: Maybe<Scalars['Float']['output']>;
  canceled_at?: Maybe<Scalars['DateTime']['output']>;
  created_at?: Maybe<Scalars['DateTime']['output']>;
  current_period_end?: Maybe<Scalars['DateTime']['output']>;
  current_period_start?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  organization_id?: Maybe<Scalars['String']['output']>;
  program_id?: Maybe<Scalars['String']['output']>;
  started_at?: Maybe<Scalars['DateTime']['output']>;
  status?: Maybe<SubscriptionStatus>;
  stripe_customer_id?: Maybe<Scalars['String']['output']>;
  stripe_price_id?: Maybe<Scalars['String']['output']>;
  stripe_subscription_id?: Maybe<Scalars['String']['output']>;
  student_id?: Maybe<Scalars['String']['output']>;
  subscription_type?: Maybe<SubscriptionType>;
  trial_end?: Maybe<Scalars['DateTime']['output']>;
  updated_at?: Maybe<Scalars['DateTime']['output']>;
  user_id?: Maybe<Scalars['String']['output']>;
};

export type SubscriptionMinAggregate = {
  __typename?: 'SubscriptionMinAggregate';
  amount?: Maybe<Scalars['Float']['output']>;
  canceled_at?: Maybe<Scalars['DateTime']['output']>;
  created_at?: Maybe<Scalars['DateTime']['output']>;
  current_period_end?: Maybe<Scalars['DateTime']['output']>;
  current_period_start?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  organization_id?: Maybe<Scalars['String']['output']>;
  program_id?: Maybe<Scalars['String']['output']>;
  started_at?: Maybe<Scalars['DateTime']['output']>;
  status?: Maybe<SubscriptionStatus>;
  stripe_customer_id?: Maybe<Scalars['String']['output']>;
  stripe_price_id?: Maybe<Scalars['String']['output']>;
  stripe_subscription_id?: Maybe<Scalars['String']['output']>;
  student_id?: Maybe<Scalars['String']['output']>;
  subscription_type?: Maybe<SubscriptionType>;
  trial_end?: Maybe<Scalars['DateTime']['output']>;
  updated_at?: Maybe<Scalars['DateTime']['output']>;
  user_id?: Maybe<Scalars['String']['output']>;
};

export enum SubscriptionStatus {
  /**
   * Subscription active and current (invoices paid, access granted)
   * Healthy state - customer has full access and billing continues
   */
  Active = 'active',
  /**
   * Subscription canceled by user or system
   * Customer keeps access until current_period_end, then loses access
   * No more invoices created after cancellation
   */
  Canceled = 'canceled',
  /**
   * Payment method required or first invoice unpaid
   * Subscription created but not fully set up
   * Waiting for payment method confirmation
   */
  Incomplete = 'incomplete',
  /**
   * Payment failed, Stripe attempting to collect
   * Customer may lose access depending on business rules
   * Stripe auto-retries failed payments based on retry rules
   */
  PastDue = 'past_due',
  /**
   * In trial period (trial_end not yet reached)
   * Customer has full access, no charges yet
   * Transitions to active when trial ends and first invoice paid
   */
  Trialing = 'trialing',
  /**
   * All payment retry attempts exhausted
   * Subscription effectively dead, customer loses access
   * Requires manual intervention to reactivate
   */
  Unpaid = 'unpaid'
}

export type SubscriptionSumAggregate = {
  __typename?: 'SubscriptionSumAggregate';
  amount?: Maybe<Scalars['Float']['output']>;
};

export enum SubscriptionType {
  /**
   * Premium organization features (FUTURE)
   * Organizations pay for advanced analytics, branding, API access
   * Sets organization_id relationship field
   */
  OrgPremium = 'org_premium',
  /**
   * Monthly donations to PilotCity (IMPLEMENTED)
   * User donates to support platform operations
   * No StudentTransaction created - money stays with PilotCity
   */
  PlatformDonation = 'platform_donation',
  /**
   * Recurring program enrollment payments (FUTURE)
   * Parents pay monthly for child's program membership
   * Sets user_id + student_id + program_id relationship fields
   * Creates StudentTransaction on successful payment
   */
  ProgramAccess = 'program_access',
  /**
   * Premium user features (FUTURE)
   * Individual users pay for custom domains, priority support
   * Sets user_id relationship field
   */
  UserPremium = 'user_premium'
}

export type TeacherPortfolio = {
  __typename?: 'TeacherPortfolio';
  airtable?: Maybe<Array<TeacherPortfolioAirtable>>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  last_modified_at?: Maybe<Scalars['DateTime']['output']>;
  last_synced_at?: Maybe<Scalars['DateTime']['output']>;
  schoolDistrict?: Maybe<Scalars['String']['output']>;
  schoolName?: Maybe<Scalars['String']['output']>;
  schools?: Maybe<TeacherPortfolioSchools>;
  subjects?: Maybe<Array<Scalars['String']['output']>>;
};

export type TeacherPortfolioAirtable = {
  __typename?: 'TeacherPortfolioAirtable';
  airtable_id: Scalars['String']['output'];
  created_at: Scalars['DateTime']['output'];
  last_modified_at: Scalars['DateTime']['output'];
  spreadsheet: Scalars['String']['output'];
};

export type TeacherPortfolioCountAggregate = {
  __typename?: 'TeacherPortfolioCountAggregate';
  _all: Scalars['Int']['output'];
  deletedAt: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  last_modified_at: Scalars['Int']['output'];
  last_synced_at: Scalars['Int']['output'];
  schoolDistrict: Scalars['Int']['output'];
  schoolName: Scalars['Int']['output'];
  subjects: Scalars['Int']['output'];
};

export type TeacherPortfolioMaxAggregate = {
  __typename?: 'TeacherPortfolioMaxAggregate';
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  last_modified_at?: Maybe<Scalars['DateTime']['output']>;
  last_synced_at?: Maybe<Scalars['DateTime']['output']>;
  schoolDistrict?: Maybe<Scalars['String']['output']>;
  schoolName?: Maybe<Scalars['String']['output']>;
};

export type TeacherPortfolioMinAggregate = {
  __typename?: 'TeacherPortfolioMinAggregate';
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  last_modified_at?: Maybe<Scalars['DateTime']['output']>;
  last_synced_at?: Maybe<Scalars['DateTime']['output']>;
  schoolDistrict?: Maybe<Scalars['String']['output']>;
  schoolName?: Maybe<Scalars['String']['output']>;
};

export type TeacherPortfolioSchools = {
  __typename?: 'TeacherPortfolioSchools';
  city: Scalars['String']['output'];
  country?: Maybe<Scalars['String']['output']>;
  countryCode?: Maybe<Scalars['String']['output']>;
  county?: Maybe<Scalars['String']['output']>;
  formattedAddress?: Maybe<Scalars['String']['output']>;
  geocodeConfidence?: Maybe<Scalars['String']['output']>;
  geocodeSource?: Maybe<Scalars['String']['output']>;
  geocodedAt?: Maybe<Scalars['DateTime']['output']>;
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  placeId?: Maybe<Scalars['String']['output']>;
  state: Scalars['String']['output'];
  stateCode?: Maybe<Scalars['String']['output']>;
  streetAddress: Scalars['String']['output'];
  typeName?: Maybe<Scalars['String']['output']>;
  zipcode: Scalars['String']['output'];
};

export type TemplateCount = {
  __typename?: 'TemplateCount';
  /** Number of programs using this template */
  count: Scalars['Int']['output'];
  /** The template ID */
  templateId?: Maybe<Scalars['String']['output']>;
  /** The template name */
  templateName: Scalars['String']['output'];
};

/** Template metadata for discovery and display */
export type TemplateDiscoveryItem = {
  __typename?: 'TemplateDiscoveryItem';
  displayColor?: Maybe<Scalars['String']['output']>;
  displayIcon?: Maybe<Scalars['String']['output']>;
  displayOrder?: Maybe<Scalars['Float']['output']>;
  estimatedDuration?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  templateDesc?: Maybe<Scalars['String']['output']>;
  templateName: Scalars['String']['output'];
};

export type TemplateValidationResult = {
  __typename?: 'TemplateValidationResult';
  fields: Array<FieldValidationResult>;
  hasErrors: Scalars['Boolean']['output'];
  overallStatus: TemplateValidationStatus;
  sampleSize: Scalars['Float']['output'];
  templateId: Scalars['String']['output'];
  validatedAt: Scalars['DateTime']['output'];
  warnings: Array<Scalars['String']['output']>;
};

/** Report template validation status levels */
export enum TemplateValidationStatus {
  Error = 'ERROR',
  Ok = 'OK',
  Warning = 'WARNING'
}

export type TestRunAvgAggregate = {
  __typename?: 'TestRunAvgAggregate';
  overallScore?: Maybe<Scalars['Float']['output']>;
};

export type TestRunCountAggregate = {
  __typename?: 'TestRunCountAggregate';
  _all: Scalars['Int']['output'];
  activityResults: Scalars['Int']['output'];
  completedAt: Scalars['Int']['output'];
  createdBy: Scalars['Int']['output'];
  designIssues: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  overallScore: Scalars['Int']['output'];
  programId: Scalars['Int']['output'];
  startedAt: Scalars['Int']['output'];
  status: Scalars['Int']['output'];
  studentId: Scalars['Int']['output'];
};

export type TestRunMaxAggregate = {
  __typename?: 'TestRunMaxAggregate';
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  overallScore?: Maybe<Scalars['Float']['output']>;
  programId?: Maybe<Scalars['String']['output']>;
  startedAt?: Maybe<Scalars['DateTime']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  studentId?: Maybe<Scalars['String']['output']>;
};

export type TestRunMinAggregate = {
  __typename?: 'TestRunMinAggregate';
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  overallScore?: Maybe<Scalars['Float']['output']>;
  programId?: Maybe<Scalars['String']['output']>;
  startedAt?: Maybe<Scalars['DateTime']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  studentId?: Maybe<Scalars['String']['output']>;
};

export type TestRunSumAggregate = {
  __typename?: 'TestRunSumAggregate';
  overallScore?: Maybe<Scalars['Float']['output']>;
};

/** Individual message in a thread */
export type ThreadMessage = {
  __typename?: 'ThreadMessage';
  /** Channel: sms or email */
  channel: Scalars['String']['output'];
  content?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  status?: Maybe<Scalars['String']['output']>;
  /** Email subject (email channel only) */
  subject?: Maybe<Scalars['String']['output']>;
  timestamp: Scalars['DateTime']['output'];
  /** Message type: outreach (sent to user) or inbound (from user) */
  type: Scalars['String']['output'];
};

/** Result for myThreadMessages query */
export type ThreadMessagesResult = {
  __typename?: 'ThreadMessagesResult';
  messages: Array<ThreadMessage>;
  thread: MyThreadInfo;
};

/** Input for toggling AIPM messages */
export type ToggleAipmInput = {
  /** Whether AIPM messages should be enabled */
  enabled: Scalars['Boolean']['input'];
  /** Program ID context */
  programId: Scalars['String']['input'];
};

/** Result of toggling AIPM messages */
export type ToggleAipmResultType = {
  __typename?: 'ToggleAIPMResultType';
  /** New AIPM enabled state */
  enabled: Scalars['Boolean']['output'];
  /** Error message if toggle failed */
  error?: Maybe<Scalars['String']['output']>;
  /** Whether toggle was successful */
  success: Scalars['Boolean']['output'];
};

/** Edge type for paginated transactions */
export type TransactionEdge = {
  __typename?: 'TransactionEdge';
  /** Cursor for this edge */
  cursor: Scalars['String']['output'];
  /** The transaction */
  node: StudentTransactionType;
};

/** Filter criteria for transaction queries */
export type TransactionFilterInput = {
  /** Filter transactions created after this date */
  createdAfter?: InputMaybe<Scalars['DateTime']['input']>;
  /** Filter transactions created before this date */
  createdBefore?: InputMaybe<Scalars['DateTime']['input']>;
  /** Filter by sponsorship status (true = sponsored payments only) */
  isSponsor?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by organizer ID */
  organizerId?: InputMaybe<Scalars['String']['input']>;
  /** Filter by program ID */
  programId?: InputMaybe<Scalars['String']['input']>;
  /** Filter by sponsor ID */
  sponsorId?: InputMaybe<Scalars['String']['input']>;
  /** Filter by transaction status */
  status?: InputMaybe<Scalars['String']['input']>;
  /** Filter by student ID */
  studentId?: InputMaybe<Scalars['String']['input']>;
  /** Filter by transfer status */
  transferStatus?: InputMaybe<Scalars['String']['input']>;
};

/** Pagination parameters for transaction queries */
export type TransactionPaginationInput = {
  /** Cursor to start fetching after */
  after?: InputMaybe<Scalars['String']['input']>;
  /** Cursor to start fetching before */
  before?: InputMaybe<Scalars['String']['input']>;
  /** Number of records to fetch (default: 20, max: 100) */
  first?: InputMaybe<Scalars['Int']['input']>;
  /** Number of records to fetch from end (max: 100) */
  last?: InputMaybe<Scalars['Int']['input']>;
};

/** Status of a payment transaction */
export enum TransactionStatus {
  ChargebackDebt = 'chargeback_debt',
  Completed = 'completed',
  Disputed = 'disputed',
  PartiallyRefunded = 'partially_refunded',
  Refunded = 'refunded'
}

/** Status of fund transfer to organizer */
export enum TransferStatus {
  Failed = 'failed',
  Pending = 'pending',
  Transferred = 'transferred',
  Transferring = 'transferring'
}

/** Input for triggering completion celebration */
export type TriggerCompletionCelebrationInput = {
  /** Program ID context */
  programId: Scalars['String']['input'];
  /** Student ID to trigger celebration for */
  studentId: Scalars['String']['input'];
};

export type TypeDescriptionInput = {
  /** Description of the document type */
  description: Scalars['String']['input'];
  /** Document type key */
  type: Scalars['String']['input'];
};

/** Unified wallet balance and transaction information */
export type UnifiedWalletResponse = {
  __typename?: 'UnifiedWalletResponse';
  /** True if user can withdraw (balance > 0, no disputes, has Stripe Connect) */
  canWithdraw: Scalars['Boolean']['output'];
  /** True if any payment is under active dispute */
  hasDisputedPayments: Scalars['Boolean']['output'];
  /** True if balance is negative (user owes money from chargebacks) */
  hasNegativeBalance: Scalars['Boolean']['output'];
  /** Net earnings (total income minus refunds/chargebacks) */
  netEarnings: Scalars['Float']['output'];
  /** Recent transactions for display (last 5) */
  recentTransactions: Array<WalletTransactionType>;
  /** Available balance in cents from sponsorship payments (0% fee - money TO students) */
  sponsorshipBalance: Scalars['Float']['output'];
  /** Available balance in cents from student payments (10% fee - money TO organizers) */
  studentPaymentBalance: Scalars['Float']['output'];
  /** Total available balance (can withdraw now) */
  totalAvailable: Scalars['Float']['output'];
  /** Amount currently being transferred to bank */
  totalProcessing: Scalars['Float']['output'];
  /** Total amount already withdrawn to bank */
  totalWithdrawn: Scalars['Float']['output'];
  /** Reason why withdrawal is blocked (if canWithdraw is false) */
  withdrawalBlockedReason?: Maybe<Scalars['String']['output']>;
};

/** Response from processing a unified wallet withdrawal */
export type UnifiedWithdrawalResponse = {
  __typename?: 'UnifiedWithdrawalResponse';
  /** Amount withdrawn in cents */
  amount?: Maybe<Scalars['Float']['output']>;
  /** Human-readable result message */
  message?: Maybe<Scalars['String']['output']>;
  /** Whether the withdrawal succeeded */
  success: Scalars['Boolean']['output'];
  /** Stripe Transfer ID (if successful) */
  transferId?: Maybe<Scalars['String']['output']>;
};

export type UnsupportedResourceStatGql = {
  __typename?: 'UnsupportedResourceStatGql';
  count: Scalars['Int']['output'];
  platformName: Scalars['String']['output'];
};

/** Input type for updating an existing ActivitySchema */
export type UpdateActivitySchemaInput = {
  /** JSON Schema for validation */
  JSONSchema?: InputMaybe<Scalars['JSON']['input']>;
  /** Activity image URL */
  activityImage?: InputMaybe<Scalars['String']['input']>;
  /** Build scope configuration as JSON */
  buildScope?: InputMaybe<Scalars['JSON']['input']>;
  /** Builder type identifier */
  builderType?: InputMaybe<Scalars['String']['input']>;
  /** Category of the activity (Pre, Do, Reflect, etc.) */
  category?: InputMaybe<Scalars['String']['input']>;
  /** Whether this activity is completed */
  completed?: InputMaybe<Scalars['Boolean']['input']>;
  /** Description of the activity */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Discord entity type for integration */
  discordEntityType?: InputMaybe<Scalars['String']['input']>;
  /** Employer website URL */
  employerWebsite?: InputMaybe<Scalars['String']['input']>;
  /** Activity fields configuration as JSON */
  fields?: InputMaybe<Scalars['JSON']['input']>;
  /** Icon identifier (e.g., mdi-check) */
  icon?: InputMaybe<Scalars['String']['input']>;
  /** Instruction configuration as JSON */
  instruction?: InputMaybe<Scalars['JSON']['input']>;
  /** Interview request text */
  interviewRequest?: InputMaybe<Scalars['String']['input']>;
  /** Intro video URL */
  introVideo?: InputMaybe<Scalars['String']['input']>;
  /** Whether this is a preview activity */
  isPreview?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether this activity can be skipped */
  isSkippable?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether this is a team-based activity */
  isTeamAdk?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether this uses VideoAsk integration */
  isVideoask?: InputMaybe<Scalars['Boolean']['input']>;
  /** Name of the activity */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Whether this activity is optional */
  optional?: InputMaybe<Scalars['Boolean']['input']>;
  /** Permissions configuration as JSON */
  permissions?: InputMaybe<Scalars['JSON']['input']>;
  /** Position/order of the activity */
  position?: InputMaybe<Scalars['Int']['input']>;
  /** Preset fields configuration as JSON */
  presetFields?: InputMaybe<Scalars['JSON']['input']>;
  /** Preview mode flag */
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  /** Project scope text */
  projectScope?: InputMaybe<Scalars['String']['input']>;
  /** Whether this activity is required */
  required?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether setup is required for this activity */
  setupRequired?: InputMaybe<Scalars['Boolean']['input']>;
  /** Status of the activity (active/inactive) */
  status?: InputMaybe<Scalars['Boolean']['input']>;
  /** Status type (draft, published, archived) */
  statusType?: InputMaybe<Scalars['String']['input']>;
  /** Styling configuration as JSON */
  styling?: InputMaybe<Scalars['JSON']['input']>;
  /** Estimated time to solve the problem in minutes */
  timeToSolveProblem?: InputMaybe<Scalars['Int']['input']>;
};

/** Input for updating a bank account */
export type UpdateBankAccountInput = {
  /** New account holder name */
  accountHolderName?: InputMaybe<Scalars['String']['input']>;
  /** Account holder type (individual or company) */
  accountHolderType?: InputMaybe<Scalars['String']['input']>;
  /** Bank account ID to update */
  bankAccountId: Scalars['String']['input'];
  /** Set as default payout account */
  defaultForCurrency?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateFamilyMemberInput = {
  bio?: InputMaybe<Scalars['String']['input']>;
  birthDate?: InputMaybe<Scalars['String']['input']>;
  colorTag?: InputMaybe<Scalars['String']['input']>;
  deathDate?: InputMaybe<Scalars['String']['input']>;
  generationName?: InputMaybe<Scalars['String']['input']>;
  hometown?: InputMaybe<Scalars['String']['input']>;
  hometownPlaceId?: InputMaybe<Scalars['String']['input']>;
  isAdopted?: InputMaybe<Scalars['Boolean']['input']>;
  isDeceased?: InputMaybe<Scalars['Boolean']['input']>;
  maternalPaternalLine?: InputMaybe<Scalars['String']['input']>;
  nameEn?: InputMaybe<Scalars['String']['input']>;
  nameZh?: InputMaybe<Scalars['String']['input']>;
  nickname?: InputMaybe<Scalars['String']['input']>;
  publicDisplayOverride?: InputMaybe<Scalars['Boolean']['input']>;
  siblingOrder?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateFamilyViewInput = {
  downDepth?: InputMaybe<Scalars['Int']['input']>;
  includeSpouses?: InputMaybe<Scalars['Boolean']['input']>;
  rootMemberId?: InputMaybe<Scalars['ID']['input']>;
  titleEn?: InputMaybe<Scalars['String']['input']>;
  titleZh?: InputMaybe<Scalars['String']['input']>;
  upDepth?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateJournalInput = {
  content?: InputMaybe<Scalars['String']['input']>;
  emojis?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateOrganizationLogoInput = {
  /** The new logo URL */
  logoUrl: Scalars['String']['input'];
  /** The Organization ID to update */
  organizationId: Scalars['String']['input'];
};

export type UpdateOrganizationNameInput = {
  /** The new organization name */
  name: Scalars['String']['input'];
  /** The Organization ID to update */
  organizationId: Scalars['String']['input'];
};

export type UpdatePortfolioInput = {
  data: Scalars['JSON']['input'];
  type: PortfolioUpdateType;
};

export type UpdatePortfolioResponse = {
  __typename?: 'UpdatePortfolioResponse';
  message?: Maybe<Scalars['String']['output']>;
  portfolio?: Maybe<Portfolio>;
  success: Scalars['Boolean']['output'];
};

export type UpdateReportTemplateInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  exportConfig?: InputMaybe<ReportExportConfigInput>;
  fields?: InputMaybe<Array<ReportFieldInput>>;
  name?: InputMaybe<Scalars['String']['input']>;
};

/** Input for updating a sponsor link shareCode */
export type UpdateShareCodeInput = {
  /** The new shareCode to use (4-30 characters, alphanumeric with hyphens/underscores) */
  newShareCode: Scalars['String']['input'];
  /** Organization ID if updating an organization sponsor link */
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  /** The ID of the SponsorLink to update */
  sponsorLinkId: Scalars['ID']['input'];
};

/** Input for updating a Stripe Connect account */
export type UpdateStripeAccountInput = {
  /** Business or individual address */
  address?: InputMaybe<AddressInput>;
  /** Business name or individual name */
  businessName?: InputMaybe<Scalars['String']['input']>;
  /** Business URL */
  businessUrl?: InputMaybe<Scalars['String']['input']>;
  /** Account representative information */
  person?: InputMaybe<PersonInput>;
  /** Business phone number */
  phone?: InputMaybe<Scalars['String']['input']>;
  /** Business tax ID / SSN (last 4 digits) */
  taxId?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateStudentPreferenceInput = {
  hideCelebrationDialog?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UploadDocumentInput = {
  /** The ADK MongoDB ID */
  adkId: Scalars['String']['input'];
  /** Base64 encoded file data (with or without data URI prefix) */
  file: Scalars['String']['input'];
  /** Original filename */
  fileName: Scalars['String']['input'];
  /** MIME type of the file (e.g., application/pdf) */
  mimeType: Scalars['String']['input'];
  /** The program MongoDB ID */
  programId: Scalars['String']['input'];
};

export type UploadDocumentResponse = {
  __typename?: 'UploadDocumentResponse';
  /** Original filename */
  fileName?: Maybe<Scalars['String']['output']>;
  /** File size in bytes */
  fileSize?: Maybe<Scalars['Int']['output']>;
  /** S3 URL of the uploaded file */
  fileUrl?: Maybe<Scalars['String']['output']>;
  /** Success or error message */
  message?: Maybe<Scalars['String']['output']>;
  /** MIME type of the file */
  mimeType?: Maybe<Scalars['String']['output']>;
  /** Whether the upload was successful */
  ok: Scalars['Boolean']['output'];
  /** ISO timestamp of when the file was uploaded */
  uploadedAt?: Maybe<Scalars['String']['output']>;
};

export type UploadOrganizationLogoImageInput = {
  /** Base64-encoded image data (with data URI prefix) */
  logoImage: Scalars['String']['input'];
  /** The Organization ID to update */
  organizationId: Scalars['String']['input'];
};

export type UploadProfileImageInput = {
  profileImage: Scalars['String']['input'];
};

export type UploadProfileImageResponse = {
  __typename?: 'UploadProfileImageResponse';
  message?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
  profile?: Maybe<ProfileImage>;
};

export type UpsertNursePortfolioInput = {
  defaultRateProfileSlug?: InputMaybe<Scalars['String']['input']>;
  effectiveTaxRate?: InputMaybe<Scalars['Float']['input']>;
  employers?: InputMaybe<Array<NursePortfolioEmployerInput>>;
  licenseNumber?: InputMaybe<Scalars['String']['input']>;
  licenseState?: InputMaybe<Scalars['String']['input']>;
  rateProfiles?: InputMaybe<Array<NursePortfolioRateProfileInput>>;
  specialty?: InputMaybe<Scalars['String']['input']>;
};

export type UsageEventAvgAggregate = {
  __typename?: 'UsageEventAvgAggregate';
  cost?: Maybe<Scalars['Float']['output']>;
};

export type UsageEventCountAggregate = {
  __typename?: 'UsageEventCountAggregate';
  _all: Scalars['Int']['output'];
  cost: Scalars['Int']['output'];
  created_at: Scalars['Int']['output'];
  event_type: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  metadata: Scalars['Int']['output'];
  participant_id: Scalars['Int']['output'];
  program_id: Scalars['Int']['output'];
  user_id: Scalars['Int']['output'];
};

export type UsageEventMaxAggregate = {
  __typename?: 'UsageEventMaxAggregate';
  cost?: Maybe<Scalars['Float']['output']>;
  created_at?: Maybe<Scalars['DateTime']['output']>;
  event_type?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  participant_id?: Maybe<Scalars['String']['output']>;
  program_id?: Maybe<Scalars['String']['output']>;
  user_id?: Maybe<Scalars['String']['output']>;
};

export type UsageEventMinAggregate = {
  __typename?: 'UsageEventMinAggregate';
  cost?: Maybe<Scalars['Float']['output']>;
  created_at?: Maybe<Scalars['DateTime']['output']>;
  event_type?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  participant_id?: Maybe<Scalars['String']['output']>;
  program_id?: Maybe<Scalars['String']['output']>;
  user_id?: Maybe<Scalars['String']['output']>;
};

export type UsageEventSumAggregate = {
  __typename?: 'UsageEventSumAggregate';
  cost?: Maybe<Scalars['Float']['output']>;
};

export type UsageMeter = {
  __typename?: 'UsageMeter';
  cap: Scalars['Int']['output'];
  current: Scalars['Int']['output'];
};

export type User = {
  __typename?: 'User';
  _count: UserCount;
  aipmSettings?: Maybe<UserAipmSettings>;
  airtable?: Maybe<Array<UserAirtable>>;
  airtime2022?: Maybe<Scalars['String']['output']>;
  anonymous?: Maybe<Scalars['Boolean']['output']>;
  assistantAccess?: Maybe<Array<UserAssistantAccess>>;
  autoSponsoringAllowed?: Maybe<Scalars['Boolean']['output']>;
  badges?: Maybe<Array<UserBadges>>;
  birthDate?: Maybe<Scalars['String']['output']>;
  creatorThreads?: Maybe<Array<CreatorThread>>;
  current_subscription_id?: Maybe<Scalars['String']['output']>;
  discordAccessToken?: Maybe<Scalars['String']['output']>;
  discordId?: Maybe<Scalars['String']['output']>;
  discordRefreshToken?: Maybe<Scalars['String']['output']>;
  discordUsername?: Maybe<Scalars['String']['output']>;
  /** Multiple data types found: String: 99.1%, UserEmail: 0.9% out of 980 sampled entries */
  email?: Maybe<Scalars['JSON']['output']>;
  emailOptedOut?: Maybe<Scalars['Boolean']['output']>;
  emailOptedOutAt?: Maybe<Scalars['DateTime']['output']>;
  emailVerified?: Maybe<Scalars['Boolean']['output']>;
  eventLog?: Maybe<Array<UserEventLog>>;
  firstName?: Maybe<Scalars['String']['output']>;
  forceChangedPwd?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  identities?: Maybe<Array<UserIdentities>>;
  invitedUser?: Maybe<Scalars['Boolean']['output']>;
  langGraphThreads?: Maybe<Array<LangGraphThread>>;
  lastName?: Maybe<Scalars['String']['output']>;
  last_modified_at: Scalars['DateTime']['output'];
  last_synced_at: Scalars['DateTime']['output'];
  leadStatus?: Maybe<Scalars['String']['output']>;
  migrated?: Maybe<Scalars['Boolean']['output']>;
  monetization_started_at?: Maybe<Scalars['DateTime']['output']>;
  needMoreTime2022?: Maybe<Scalars['String']['output']>;
  nursePortfolio?: Maybe<NursePortfolio>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  /** can be datetime or boolean */
  phoneVerified?: Maybe<Scalars['JSON']['output']>;
  planToInterview2022?: Maybe<Scalars['String']['output']>;
  planToInterview2022User?: Maybe<Scalars['String']['output']>;
  portfolioPublic?: Maybe<Scalars['Boolean']['output']>;
  profile?: Maybe<UserProfile>;
  /** Field referred in an index, but found no data to define the type. */
  profileImg?: Maybe<Scalars['JSON']['output']>;
  programIds?: Maybe<Array<Scalars['String']['output']>>;
  savedScopes?: Maybe<Array<SavedScope>>;
  shareCode?: Maybe<Scalars['String']['output']>;
  shiftSpendGoals?: Maybe<Array<ShiftSpendGoal>>;
  slug?: Maybe<Scalars['String']['output']>;
  smsOptedOut?: Maybe<Scalars['Boolean']['output']>;
  smsOptedOutAt?: Maybe<Scalars['DateTime']['output']>;
  sponsorLinkSharable?: Maybe<Scalars['Boolean']['output']>;
  sponsorName?: Maybe<Scalars['String']['output']>;
  stripeConnectId?: Maybe<Scalars['String']['output']>;
  stripeCurrentlyDue?: Maybe<Array<Scalars['String']['output']>>;
  stripeId?: Maybe<Scalars['String']['output']>;
  stripeVerified?: Maybe<Scalars['String']['output']>;
  stripe_customer_id?: Maybe<Scalars['String']['output']>;
  /** Transactions where this user is the payer (paid money to a student) */
  studentWalletPayments?: Maybe<Array<StudentWalletTransaction>>;
  /** Transactions where this user is the student (wallet owner, receives money) */
  studentWalletTransactions?: Maybe<Array<StudentWalletTransaction>>;
  /** Students where this user is the participant (student instances) */
  students?: Maybe<Array<Student>>;
  subscription_tier?: Maybe<Scalars['String']['output']>;
  timezone?: Maybe<Scalars['String']['output']>;
  token?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
  userTypes?: Maybe<Array<Scalars['String']['output']>>;
  /** Transactions where this user is the payer (paid money) */
  walletPayments?: Maybe<Array<WalletTransaction>>;
  /** Transactions where this user is the wallet owner (receives money) */
  walletTransactions?: Maybe<Array<WalletTransaction>>;
};

export type UserAipmSettings = {
  __typename?: 'UserAipmSettings';
  aipmEnabled?: Maybe<Scalars['Boolean']['output']>;
  aipmPrograms?: Maybe<Scalars['JSON']['output']>;
  firstGoal?: Maybe<Scalars['String']['output']>;
  lastDismissedAt?: Maybe<Scalars['DateTime']['output']>;
  onboardingCompletedAt?: Maybe<Scalars['DateTime']['output']>;
  perProgramOverrides?: Maybe<Scalars['JSON']['output']>;
  personaId?: Maybe<Scalars['String']['output']>;
  preferredChannel?: Maybe<Scalars['String']['output']>;
};

export type UserAipmSettingsCreateInput = {
  aipmEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  aipmPrograms?: InputMaybe<Scalars['JSON']['input']>;
  firstGoal?: InputMaybe<Scalars['String']['input']>;
  lastDismissedAt?: InputMaybe<Scalars['DateTime']['input']>;
  onboardingCompletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  perProgramOverrides?: InputMaybe<Scalars['JSON']['input']>;
  personaId?: InputMaybe<Scalars['String']['input']>;
  preferredChannel?: InputMaybe<Scalars['String']['input']>;
};

export type UserAipmSettingsNullableCompositeFilter = {
  equals?: InputMaybe<UserAipmSettingsObjectEqualityInput>;
  is?: InputMaybe<UserAipmSettingsWhereInput>;
  isNot?: InputMaybe<UserAipmSettingsWhereInput>;
  isSet?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UserAipmSettingsNullableCreateEnvelopeInput = {
  set?: InputMaybe<UserAipmSettingsCreateInput>;
};

export type UserAipmSettingsNullableUpdateEnvelopeInput = {
  set?: InputMaybe<UserAipmSettingsCreateInput>;
  unset?: InputMaybe<Scalars['Boolean']['input']>;
  upsert?: InputMaybe<UserAipmSettingsUpsertInput>;
};

export type UserAipmSettingsObjectEqualityInput = {
  aipmEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  aipmPrograms?: InputMaybe<Scalars['JSON']['input']>;
  firstGoal?: InputMaybe<Scalars['String']['input']>;
  lastDismissedAt?: InputMaybe<Scalars['DateTime']['input']>;
  onboardingCompletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  perProgramOverrides?: InputMaybe<Scalars['JSON']['input']>;
  personaId?: InputMaybe<Scalars['String']['input']>;
  preferredChannel?: InputMaybe<Scalars['String']['input']>;
};

export type UserAipmSettingsUpdateInput = {
  aipmEnabled?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  aipmPrograms?: InputMaybe<Scalars['JSON']['input']>;
  firstGoal?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  lastDismissedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  onboardingCompletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  perProgramOverrides?: InputMaybe<Scalars['JSON']['input']>;
  personaId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  preferredChannel?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type UserAipmSettingsUpsertInput = {
  set: UserAipmSettingsCreateInput;
  update: UserAipmSettingsUpdateInput;
};

export type UserAipmSettingsWhereInput = {
  AND?: InputMaybe<Array<UserAipmSettingsWhereInput>>;
  NOT?: InputMaybe<Array<UserAipmSettingsWhereInput>>;
  OR?: InputMaybe<Array<UserAipmSettingsWhereInput>>;
  aipmEnabled?: InputMaybe<BoolNullableFilter>;
  aipmPrograms?: InputMaybe<JsonNullableFilter>;
  firstGoal?: InputMaybe<StringNullableFilter>;
  lastDismissedAt?: InputMaybe<DateTimeNullableFilter>;
  onboardingCompletedAt?: InputMaybe<DateTimeNullableFilter>;
  perProgramOverrides?: InputMaybe<JsonNullableFilter>;
  personaId?: InputMaybe<StringNullableFilter>;
  preferredChannel?: InputMaybe<StringNullableFilter>;
};

export type UserAirtable = {
  __typename?: 'UserAirtable';
  airtable_id: Scalars['String']['output'];
  created_at: Scalars['DateTime']['output'];
  last_modified_at: Scalars['DateTime']['output'];
  spreadsheet: Scalars['String']['output'];
};

export type UserAirtableCreateInput = {
  airtable_id: Scalars['String']['input'];
  created_at: Scalars['DateTime']['input'];
  last_modified_at: Scalars['DateTime']['input'];
  spreadsheet: Scalars['String']['input'];
};

export type UserAirtableObjectEqualityInput = {
  airtable_id: Scalars['String']['input'];
  created_at: Scalars['DateTime']['input'];
  last_modified_at: Scalars['DateTime']['input'];
  spreadsheet: Scalars['String']['input'];
};

export type UserAssistantAccess = {
  __typename?: 'UserAssistantAccess';
  assistant: LangGraphAssistant;
  assistantId: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  permissions?: Maybe<Array<Scalars['String']['output']>>;
  updatedAt: Scalars['DateTime']['output'];
  user: User;
  userId: Scalars['String']['output'];
};

export type UserAssistantAccessCountAggregate = {
  __typename?: 'UserAssistantAccessCountAggregate';
  _all: Scalars['Int']['output'];
  assistantId: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  permissions: Scalars['Int']['output'];
  updatedAt: Scalars['Int']['output'];
  userId: Scalars['Int']['output'];
};

export type UserAssistantAccessCreateManyAssistantInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  permissions?: InputMaybe<UserAssistantAccessCreatepermissionsInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  userId: Scalars['String']['input'];
};

export type UserAssistantAccessCreateManyAssistantInputEnvelope = {
  data: Array<UserAssistantAccessCreateManyAssistantInput>;
};

export type UserAssistantAccessCreateManyUserInput = {
  assistantId: Scalars['String']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  permissions?: InputMaybe<UserAssistantAccessCreatepermissionsInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type UserAssistantAccessCreateManyUserInputEnvelope = {
  data: Array<UserAssistantAccessCreateManyUserInput>;
};

export type UserAssistantAccessCreateNestedManyWithoutAssistantInput = {
  connect?: InputMaybe<Array<UserAssistantAccessWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<UserAssistantAccessCreateOrConnectWithoutAssistantInput>>;
  create?: InputMaybe<Array<UserAssistantAccessCreateWithoutAssistantInput>>;
  createMany?: InputMaybe<UserAssistantAccessCreateManyAssistantInputEnvelope>;
};

export type UserAssistantAccessCreateNestedManyWithoutUserInput = {
  connect?: InputMaybe<Array<UserAssistantAccessWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<UserAssistantAccessCreateOrConnectWithoutUserInput>>;
  create?: InputMaybe<Array<UserAssistantAccessCreateWithoutUserInput>>;
  createMany?: InputMaybe<UserAssistantAccessCreateManyUserInputEnvelope>;
};

export type UserAssistantAccessCreateOrConnectWithoutAssistantInput = {
  create: UserAssistantAccessCreateWithoutAssistantInput;
  where: UserAssistantAccessWhereUniqueInput;
};

export type UserAssistantAccessCreateOrConnectWithoutUserInput = {
  create: UserAssistantAccessCreateWithoutUserInput;
  where: UserAssistantAccessWhereUniqueInput;
};

export type UserAssistantAccessCreateWithoutAssistantInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  permissions?: InputMaybe<UserAssistantAccessCreatepermissionsInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  user: UserCreateNestedOneWithoutAssistantAccessInput;
};

export type UserAssistantAccessCreateWithoutUserInput = {
  assistant: LangGraphAssistantCreateNestedOneWithoutUserAccessInput;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  permissions?: InputMaybe<UserAssistantAccessCreatepermissionsInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type UserAssistantAccessCreatepermissionsInput = {
  set: Array<Scalars['String']['input']>;
};

export type UserAssistantAccessListRelationFilter = {
  every?: InputMaybe<UserAssistantAccessWhereInput>;
  none?: InputMaybe<UserAssistantAccessWhereInput>;
  some?: InputMaybe<UserAssistantAccessWhereInput>;
};

export type UserAssistantAccessMaxAggregate = {
  __typename?: 'UserAssistantAccessMaxAggregate';
  assistantId?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
};

export type UserAssistantAccessMinAggregate = {
  __typename?: 'UserAssistantAccessMinAggregate';
  assistantId?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
};

export type UserAssistantAccessScalarWhereInput = {
  AND?: InputMaybe<Array<UserAssistantAccessScalarWhereInput>>;
  NOT?: InputMaybe<Array<UserAssistantAccessScalarWhereInput>>;
  OR?: InputMaybe<Array<UserAssistantAccessScalarWhereInput>>;
  assistantId?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<StringFilter>;
  permissions?: InputMaybe<StringNullableListFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  userId?: InputMaybe<StringFilter>;
};

export type UserAssistantAccessUpdateManyMutationInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  permissions?: InputMaybe<UserAssistantAccessUpdatepermissionsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type UserAssistantAccessUpdateManyWithWhereWithoutAssistantInput = {
  data: UserAssistantAccessUpdateManyMutationInput;
  where: UserAssistantAccessScalarWhereInput;
};

export type UserAssistantAccessUpdateManyWithWhereWithoutUserInput = {
  data: UserAssistantAccessUpdateManyMutationInput;
  where: UserAssistantAccessScalarWhereInput;
};

export type UserAssistantAccessUpdateManyWithoutAssistantNestedInput = {
  connect?: InputMaybe<Array<UserAssistantAccessWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<UserAssistantAccessCreateOrConnectWithoutAssistantInput>>;
  create?: InputMaybe<Array<UserAssistantAccessCreateWithoutAssistantInput>>;
  createMany?: InputMaybe<UserAssistantAccessCreateManyAssistantInputEnvelope>;
  delete?: InputMaybe<Array<UserAssistantAccessWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<UserAssistantAccessScalarWhereInput>>;
  disconnect?: InputMaybe<Array<UserAssistantAccessWhereUniqueInput>>;
  set?: InputMaybe<Array<UserAssistantAccessWhereUniqueInput>>;
  update?: InputMaybe<Array<UserAssistantAccessUpdateWithWhereUniqueWithoutAssistantInput>>;
  updateMany?: InputMaybe<Array<UserAssistantAccessUpdateManyWithWhereWithoutAssistantInput>>;
  upsert?: InputMaybe<Array<UserAssistantAccessUpsertWithWhereUniqueWithoutAssistantInput>>;
};

export type UserAssistantAccessUpdateManyWithoutUserNestedInput = {
  connect?: InputMaybe<Array<UserAssistantAccessWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<UserAssistantAccessCreateOrConnectWithoutUserInput>>;
  create?: InputMaybe<Array<UserAssistantAccessCreateWithoutUserInput>>;
  createMany?: InputMaybe<UserAssistantAccessCreateManyUserInputEnvelope>;
  delete?: InputMaybe<Array<UserAssistantAccessWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<UserAssistantAccessScalarWhereInput>>;
  disconnect?: InputMaybe<Array<UserAssistantAccessWhereUniqueInput>>;
  set?: InputMaybe<Array<UserAssistantAccessWhereUniqueInput>>;
  update?: InputMaybe<Array<UserAssistantAccessUpdateWithWhereUniqueWithoutUserInput>>;
  updateMany?: InputMaybe<Array<UserAssistantAccessUpdateManyWithWhereWithoutUserInput>>;
  upsert?: InputMaybe<Array<UserAssistantAccessUpsertWithWhereUniqueWithoutUserInput>>;
};

export type UserAssistantAccessUpdateWithWhereUniqueWithoutAssistantInput = {
  data: UserAssistantAccessUpdateWithoutAssistantInput;
  where: UserAssistantAccessWhereUniqueInput;
};

export type UserAssistantAccessUpdateWithWhereUniqueWithoutUserInput = {
  data: UserAssistantAccessUpdateWithoutUserInput;
  where: UserAssistantAccessWhereUniqueInput;
};

export type UserAssistantAccessUpdateWithoutAssistantInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  permissions?: InputMaybe<UserAssistantAccessUpdatepermissionsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  user?: InputMaybe<UserUpdateOneRequiredWithoutAssistantAccessNestedInput>;
};

export type UserAssistantAccessUpdateWithoutUserInput = {
  assistant?: InputMaybe<LangGraphAssistantUpdateOneRequiredWithoutUserAccessNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  permissions?: InputMaybe<UserAssistantAccessUpdatepermissionsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type UserAssistantAccessUpdatepermissionsInput = {
  push?: InputMaybe<Array<Scalars['String']['input']>>;
  set?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type UserAssistantAccessUpsertWithWhereUniqueWithoutAssistantInput = {
  create: UserAssistantAccessCreateWithoutAssistantInput;
  update: UserAssistantAccessUpdateWithoutAssistantInput;
  where: UserAssistantAccessWhereUniqueInput;
};

export type UserAssistantAccessUpsertWithWhereUniqueWithoutUserInput = {
  create: UserAssistantAccessCreateWithoutUserInput;
  update: UserAssistantAccessUpdateWithoutUserInput;
  where: UserAssistantAccessWhereUniqueInput;
};

export type UserAssistantAccessUserIdAssistantIdCompoundUniqueInput = {
  assistantId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};

export type UserAssistantAccessWhereInput = {
  AND?: InputMaybe<Array<UserAssistantAccessWhereInput>>;
  NOT?: InputMaybe<Array<UserAssistantAccessWhereInput>>;
  OR?: InputMaybe<Array<UserAssistantAccessWhereInput>>;
  assistant?: InputMaybe<LangGraphAssistantRelationFilter>;
  assistantId?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<StringFilter>;
  permissions?: InputMaybe<StringNullableListFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  user?: InputMaybe<UserRelationFilter>;
  userId?: InputMaybe<StringFilter>;
};

export type UserAssistantAccessWhereUniqueInput = {
  AND?: InputMaybe<Array<UserAssistantAccessWhereInput>>;
  NOT?: InputMaybe<Array<UserAssistantAccessWhereInput>>;
  OR?: InputMaybe<Array<UserAssistantAccessWhereInput>>;
  assistant?: InputMaybe<LangGraphAssistantRelationFilter>;
  assistantId?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  permissions?: InputMaybe<StringNullableListFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  user?: InputMaybe<UserRelationFilter>;
  userId?: InputMaybe<StringFilter>;
  userId_assistantId?: InputMaybe<UserAssistantAccessUserIdAssistantIdCompoundUniqueInput>;
};

/** Embedded type for user badges/credentials with organization provenance and validation tracking */
export type UserBadges = {
  __typename?: 'UserBadges';
  count: Scalars['Int']['output'];
  /** Reference to the CredentialTemplate this badge is based on */
  credentialTemplateId?: Maybe<Scalars['String']['output']>;
  /** Domain of the organization that issued this credential */
  domain?: Maybe<Scalars['String']['output']>;
  /** S3 URL to the credential file (PDF, image, or document) */
  file?: Maybe<Scalars['String']['output']>;
  /** Whether this badge has been validated by an organization member */
  isValidated?: Maybe<Scalars['Boolean']['output']>;
  /** Array of timestamps when this badge was issued (supports multiple issuances) */
  issuedAt?: Maybe<Array<Scalars['DateTime']['output']>>;
  name: Scalars['String']['output'];
  /** Reference to the Organization that issued this credential */
  organizationId?: Maybe<Scalars['String']['output']>;
  /** Organization logo URL for display */
  organizationLogo?: Maybe<Scalars['String']['output']>;
  /** Denormalized organization name for display */
  organizationName?: Maybe<Scalars['String']['output']>;
  /** Array of program IDs where this badge was earned */
  programIds?: Maybe<Array<Scalars['String']['output']>>;
  /** Array of Student document IDs that earned this badge (enables reverse lookup from badge to Student instances) */
  studentIds?: Maybe<Array<Scalars['String']['output']>>;
  type: Scalars['String']['output'];
  /** When this badge was validated */
  validatedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User ID of the person who validated this badge */
  validatedBy?: Maybe<Scalars['String']['output']>;
};

export type UserBadgesCreateInput = {
  count: Scalars['Int']['input'];
  credentialTemplateId?: InputMaybe<Scalars['String']['input']>;
  domain?: InputMaybe<Scalars['String']['input']>;
  file?: InputMaybe<Scalars['String']['input']>;
  isValidated?: InputMaybe<Scalars['Boolean']['input']>;
  issuedAt?: InputMaybe<UserBadgesCreateissuedAtInput>;
  name: Scalars['String']['input'];
  organizationId?: InputMaybe<Scalars['String']['input']>;
  organizationLogo?: InputMaybe<Scalars['String']['input']>;
  organizationName?: InputMaybe<Scalars['String']['input']>;
  programIds?: InputMaybe<UserBadgesCreateprogramIdsInput>;
  studentIds?: InputMaybe<UserBadgesCreatestudentIdsInput>;
  type: Scalars['String']['input'];
  validatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  validatedBy?: InputMaybe<Scalars['String']['input']>;
};

export type UserBadgesCreateissuedAtInput = {
  set: Array<Scalars['DateTime']['input']>;
};

export type UserBadgesCreateprogramIdsInput = {
  set: Array<Scalars['String']['input']>;
};

export type UserBadgesCreatestudentIdsInput = {
  set: Array<Scalars['String']['input']>;
};

export type UserBadgesObjectEqualityInput = {
  count: Scalars['Int']['input'];
  credentialTemplateId?: InputMaybe<Scalars['String']['input']>;
  domain?: InputMaybe<Scalars['String']['input']>;
  file?: InputMaybe<Scalars['String']['input']>;
  isValidated?: InputMaybe<Scalars['Boolean']['input']>;
  issuedAt?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  name: Scalars['String']['input'];
  organizationId?: InputMaybe<Scalars['String']['input']>;
  organizationLogo?: InputMaybe<Scalars['String']['input']>;
  organizationName?: InputMaybe<Scalars['String']['input']>;
  programIds?: InputMaybe<Array<Scalars['String']['input']>>;
  studentIds?: InputMaybe<Array<Scalars['String']['input']>>;
  type: Scalars['String']['input'];
  validatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  validatedBy?: InputMaybe<Scalars['String']['input']>;
};

export type UserCount = {
  __typename?: 'UserCount';
  assistantAccess: Scalars['Int']['output'];
  creatorThreads: Scalars['Int']['output'];
  langGraphThreads: Scalars['Int']['output'];
  savedScopes: Scalars['Int']['output'];
  shiftSpendGoals: Scalars['Int']['output'];
  studentWalletPayments: Scalars['Int']['output'];
  studentWalletTransactions: Scalars['Int']['output'];
  students: Scalars['Int']['output'];
  walletPayments: Scalars['Int']['output'];
  walletTransactions: Scalars['Int']['output'];
};

export type UserCountAggregate = {
  __typename?: 'UserCountAggregate';
  _all: Scalars['Int']['output'];
  airtime2022: Scalars['Int']['output'];
  anonymous: Scalars['Int']['output'];
  autoSponsoringAllowed: Scalars['Int']['output'];
  birthDate: Scalars['Int']['output'];
  current_subscription_id: Scalars['Int']['output'];
  discordAccessToken: Scalars['Int']['output'];
  discordId: Scalars['Int']['output'];
  discordRefreshToken: Scalars['Int']['output'];
  discordUsername: Scalars['Int']['output'];
  email: Scalars['Int']['output'];
  emailOptedOut: Scalars['Int']['output'];
  emailOptedOutAt: Scalars['Int']['output'];
  emailVerified: Scalars['Int']['output'];
  firstName: Scalars['Int']['output'];
  forceChangedPwd: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  invitedUser: Scalars['Int']['output'];
  lastName: Scalars['Int']['output'];
  last_modified_at: Scalars['Int']['output'];
  last_synced_at: Scalars['Int']['output'];
  leadStatus: Scalars['Int']['output'];
  migrated: Scalars['Int']['output'];
  monetization_started_at: Scalars['Int']['output'];
  needMoreTime2022: Scalars['Int']['output'];
  phoneNumber: Scalars['Int']['output'];
  phoneVerified: Scalars['Int']['output'];
  planToInterview2022: Scalars['Int']['output'];
  planToInterview2022User: Scalars['Int']['output'];
  portfolioPublic: Scalars['Int']['output'];
  profileImg: Scalars['Int']['output'];
  programIds: Scalars['Int']['output'];
  shareCode: Scalars['Int']['output'];
  slug: Scalars['Int']['output'];
  smsOptedOut: Scalars['Int']['output'];
  smsOptedOutAt: Scalars['Int']['output'];
  sponsorLinkSharable: Scalars['Int']['output'];
  sponsorName: Scalars['Int']['output'];
  stripeConnectId: Scalars['Int']['output'];
  stripeCurrentlyDue: Scalars['Int']['output'];
  stripeId: Scalars['Int']['output'];
  stripeVerified: Scalars['Int']['output'];
  stripe_customer_id: Scalars['Int']['output'];
  subscription_tier: Scalars['Int']['output'];
  timezone: Scalars['Int']['output'];
  token: Scalars['Int']['output'];
  userId: Scalars['Int']['output'];
  userTypes: Scalars['Int']['output'];
};

export type UserCreateNestedOneWithoutAssistantAccessInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutAssistantAccessInput>;
  create?: InputMaybe<UserCreateWithoutAssistantAccessInput>;
};

export type UserCreateNestedOneWithoutLangGraphThreadsInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutLangGraphThreadsInput>;
  create?: InputMaybe<UserCreateWithoutLangGraphThreadsInput>;
};

export type UserCreateNestedOneWithoutStudentWalletPaymentsInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutStudentWalletPaymentsInput>;
  create?: InputMaybe<UserCreateWithoutStudentWalletPaymentsInput>;
};

export type UserCreateNestedOneWithoutStudentWalletTransactionsInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutStudentWalletTransactionsInput>;
  create?: InputMaybe<UserCreateWithoutStudentWalletTransactionsInput>;
};

export type UserCreateNestedOneWithoutWalletPaymentsInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutWalletPaymentsInput>;
  create?: InputMaybe<UserCreateWithoutWalletPaymentsInput>;
};

export type UserCreateNestedOneWithoutWalletTransactionsInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutWalletTransactionsInput>;
  create?: InputMaybe<UserCreateWithoutWalletTransactionsInput>;
};

export type UserCreateOrConnectWithoutAssistantAccessInput = {
  create: UserCreateWithoutAssistantAccessInput;
  where: UserWhereUniqueInput;
};

export type UserCreateOrConnectWithoutLangGraphThreadsInput = {
  create: UserCreateWithoutLangGraphThreadsInput;
  where: UserWhereUniqueInput;
};

export type UserCreateOrConnectWithoutStudentWalletPaymentsInput = {
  create: UserCreateWithoutStudentWalletPaymentsInput;
  where: UserWhereUniqueInput;
};

export type UserCreateOrConnectWithoutStudentWalletTransactionsInput = {
  create: UserCreateWithoutStudentWalletTransactionsInput;
  where: UserWhereUniqueInput;
};

export type UserCreateOrConnectWithoutWalletPaymentsInput = {
  create: UserCreateWithoutWalletPaymentsInput;
  where: UserWhereUniqueInput;
};

export type UserCreateOrConnectWithoutWalletTransactionsInput = {
  create: UserCreateWithoutWalletTransactionsInput;
  where: UserWhereUniqueInput;
};

export type UserCreateWithoutAssistantAccessInput = {
  aipmSettings?: InputMaybe<UserAipmSettingsNullableCreateEnvelopeInput>;
  airtable?: InputMaybe<Array<UserAirtableCreateInput>>;
  airtime2022?: InputMaybe<Scalars['String']['input']>;
  anonymous?: InputMaybe<Scalars['Boolean']['input']>;
  autoSponsoringAllowed?: InputMaybe<Scalars['Boolean']['input']>;
  badges?: InputMaybe<Array<UserBadgesCreateInput>>;
  birthDate?: InputMaybe<Scalars['String']['input']>;
  creatorThreads?: InputMaybe<CreatorThreadCreateNestedManyWithoutUserInput>;
  current_subscription_id?: InputMaybe<Scalars['String']['input']>;
  discordAccessToken?: InputMaybe<Scalars['String']['input']>;
  discordId?: InputMaybe<Scalars['String']['input']>;
  discordRefreshToken?: InputMaybe<Scalars['String']['input']>;
  discordUsername?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['JSON']['input']>;
  emailOptedOut?: InputMaybe<Scalars['Boolean']['input']>;
  emailOptedOutAt?: InputMaybe<Scalars['DateTime']['input']>;
  emailVerified?: InputMaybe<Scalars['Boolean']['input']>;
  eventLog?: InputMaybe<Array<UserEventLogCreateInput>>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  forceChangedPwd?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  identities?: InputMaybe<Array<UserIdentitiesCreateInput>>;
  invitedUser?: InputMaybe<Scalars['Boolean']['input']>;
  langGraphThreads?: InputMaybe<LangGraphThreadCreateNestedManyWithoutUserInput>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  last_modified_at: Scalars['DateTime']['input'];
  last_synced_at: Scalars['DateTime']['input'];
  leadStatus?: InputMaybe<Scalars['String']['input']>;
  migrated?: InputMaybe<Scalars['Boolean']['input']>;
  monetization_started_at?: InputMaybe<Scalars['DateTime']['input']>;
  needMoreTime2022?: InputMaybe<Scalars['String']['input']>;
  nursePortfolio?: InputMaybe<NursePortfolioCreateNestedOneWithoutUserInput>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  phoneVerified?: InputMaybe<Scalars['JSON']['input']>;
  planToInterview2022?: InputMaybe<Scalars['String']['input']>;
  planToInterview2022User?: InputMaybe<Scalars['String']['input']>;
  portfolioPublic?: InputMaybe<Scalars['Boolean']['input']>;
  profile?: InputMaybe<UserProfileNullableCreateEnvelopeInput>;
  profileImg?: InputMaybe<Scalars['JSON']['input']>;
  programIds?: InputMaybe<UserCreateprogramIdsInput>;
  savedScopes?: InputMaybe<SavedScopeCreateNestedManyWithoutUserInput>;
  shareCode?: InputMaybe<Scalars['String']['input']>;
  shiftSpendGoals?: InputMaybe<ShiftSpendGoalCreateNestedManyWithoutUserInput>;
  slug?: InputMaybe<Scalars['String']['input']>;
  smsOptedOut?: InputMaybe<Scalars['Boolean']['input']>;
  smsOptedOutAt?: InputMaybe<Scalars['DateTime']['input']>;
  sponsorLinkSharable?: InputMaybe<Scalars['Boolean']['input']>;
  sponsorName?: InputMaybe<Scalars['String']['input']>;
  stripeConnectId?: InputMaybe<Scalars['String']['input']>;
  stripeCurrentlyDue?: InputMaybe<UserCreatestripeCurrentlyDueInput>;
  stripeId?: InputMaybe<Scalars['String']['input']>;
  stripeVerified?: InputMaybe<Scalars['String']['input']>;
  stripe_customer_id?: InputMaybe<Scalars['String']['input']>;
  studentWalletPayments?: InputMaybe<StudentWalletTransactionCreateNestedManyWithoutPayerInput>;
  studentWalletTransactions?: InputMaybe<StudentWalletTransactionCreateNestedManyWithoutStudentInput>;
  students?: InputMaybe<StudentCreateNestedManyWithoutParticipantInput>;
  subscription_tier?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  token?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
  userTypes?: InputMaybe<UserCreateuserTypesInput>;
  walletPayments?: InputMaybe<WalletTransactionCreateNestedManyWithoutSource_UserInput>;
  walletTransactions?: InputMaybe<WalletTransactionCreateNestedManyWithoutUserInput>;
};

export type UserCreateWithoutLangGraphThreadsInput = {
  aipmSettings?: InputMaybe<UserAipmSettingsNullableCreateEnvelopeInput>;
  airtable?: InputMaybe<Array<UserAirtableCreateInput>>;
  airtime2022?: InputMaybe<Scalars['String']['input']>;
  anonymous?: InputMaybe<Scalars['Boolean']['input']>;
  assistantAccess?: InputMaybe<UserAssistantAccessCreateNestedManyWithoutUserInput>;
  autoSponsoringAllowed?: InputMaybe<Scalars['Boolean']['input']>;
  badges?: InputMaybe<Array<UserBadgesCreateInput>>;
  birthDate?: InputMaybe<Scalars['String']['input']>;
  creatorThreads?: InputMaybe<CreatorThreadCreateNestedManyWithoutUserInput>;
  current_subscription_id?: InputMaybe<Scalars['String']['input']>;
  discordAccessToken?: InputMaybe<Scalars['String']['input']>;
  discordId?: InputMaybe<Scalars['String']['input']>;
  discordRefreshToken?: InputMaybe<Scalars['String']['input']>;
  discordUsername?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['JSON']['input']>;
  emailOptedOut?: InputMaybe<Scalars['Boolean']['input']>;
  emailOptedOutAt?: InputMaybe<Scalars['DateTime']['input']>;
  emailVerified?: InputMaybe<Scalars['Boolean']['input']>;
  eventLog?: InputMaybe<Array<UserEventLogCreateInput>>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  forceChangedPwd?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  identities?: InputMaybe<Array<UserIdentitiesCreateInput>>;
  invitedUser?: InputMaybe<Scalars['Boolean']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  last_modified_at: Scalars['DateTime']['input'];
  last_synced_at: Scalars['DateTime']['input'];
  leadStatus?: InputMaybe<Scalars['String']['input']>;
  migrated?: InputMaybe<Scalars['Boolean']['input']>;
  monetization_started_at?: InputMaybe<Scalars['DateTime']['input']>;
  needMoreTime2022?: InputMaybe<Scalars['String']['input']>;
  nursePortfolio?: InputMaybe<NursePortfolioCreateNestedOneWithoutUserInput>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  phoneVerified?: InputMaybe<Scalars['JSON']['input']>;
  planToInterview2022?: InputMaybe<Scalars['String']['input']>;
  planToInterview2022User?: InputMaybe<Scalars['String']['input']>;
  portfolioPublic?: InputMaybe<Scalars['Boolean']['input']>;
  profile?: InputMaybe<UserProfileNullableCreateEnvelopeInput>;
  profileImg?: InputMaybe<Scalars['JSON']['input']>;
  programIds?: InputMaybe<UserCreateprogramIdsInput>;
  savedScopes?: InputMaybe<SavedScopeCreateNestedManyWithoutUserInput>;
  shareCode?: InputMaybe<Scalars['String']['input']>;
  shiftSpendGoals?: InputMaybe<ShiftSpendGoalCreateNestedManyWithoutUserInput>;
  slug?: InputMaybe<Scalars['String']['input']>;
  smsOptedOut?: InputMaybe<Scalars['Boolean']['input']>;
  smsOptedOutAt?: InputMaybe<Scalars['DateTime']['input']>;
  sponsorLinkSharable?: InputMaybe<Scalars['Boolean']['input']>;
  sponsorName?: InputMaybe<Scalars['String']['input']>;
  stripeConnectId?: InputMaybe<Scalars['String']['input']>;
  stripeCurrentlyDue?: InputMaybe<UserCreatestripeCurrentlyDueInput>;
  stripeId?: InputMaybe<Scalars['String']['input']>;
  stripeVerified?: InputMaybe<Scalars['String']['input']>;
  stripe_customer_id?: InputMaybe<Scalars['String']['input']>;
  studentWalletPayments?: InputMaybe<StudentWalletTransactionCreateNestedManyWithoutPayerInput>;
  studentWalletTransactions?: InputMaybe<StudentWalletTransactionCreateNestedManyWithoutStudentInput>;
  students?: InputMaybe<StudentCreateNestedManyWithoutParticipantInput>;
  subscription_tier?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  token?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
  userTypes?: InputMaybe<UserCreateuserTypesInput>;
  walletPayments?: InputMaybe<WalletTransactionCreateNestedManyWithoutSource_UserInput>;
  walletTransactions?: InputMaybe<WalletTransactionCreateNestedManyWithoutUserInput>;
};

export type UserCreateWithoutStudentWalletPaymentsInput = {
  aipmSettings?: InputMaybe<UserAipmSettingsNullableCreateEnvelopeInput>;
  airtable?: InputMaybe<Array<UserAirtableCreateInput>>;
  airtime2022?: InputMaybe<Scalars['String']['input']>;
  anonymous?: InputMaybe<Scalars['Boolean']['input']>;
  assistantAccess?: InputMaybe<UserAssistantAccessCreateNestedManyWithoutUserInput>;
  autoSponsoringAllowed?: InputMaybe<Scalars['Boolean']['input']>;
  badges?: InputMaybe<Array<UserBadgesCreateInput>>;
  birthDate?: InputMaybe<Scalars['String']['input']>;
  creatorThreads?: InputMaybe<CreatorThreadCreateNestedManyWithoutUserInput>;
  current_subscription_id?: InputMaybe<Scalars['String']['input']>;
  discordAccessToken?: InputMaybe<Scalars['String']['input']>;
  discordId?: InputMaybe<Scalars['String']['input']>;
  discordRefreshToken?: InputMaybe<Scalars['String']['input']>;
  discordUsername?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['JSON']['input']>;
  emailOptedOut?: InputMaybe<Scalars['Boolean']['input']>;
  emailOptedOutAt?: InputMaybe<Scalars['DateTime']['input']>;
  emailVerified?: InputMaybe<Scalars['Boolean']['input']>;
  eventLog?: InputMaybe<Array<UserEventLogCreateInput>>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  forceChangedPwd?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  identities?: InputMaybe<Array<UserIdentitiesCreateInput>>;
  invitedUser?: InputMaybe<Scalars['Boolean']['input']>;
  langGraphThreads?: InputMaybe<LangGraphThreadCreateNestedManyWithoutUserInput>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  last_modified_at: Scalars['DateTime']['input'];
  last_synced_at: Scalars['DateTime']['input'];
  leadStatus?: InputMaybe<Scalars['String']['input']>;
  migrated?: InputMaybe<Scalars['Boolean']['input']>;
  monetization_started_at?: InputMaybe<Scalars['DateTime']['input']>;
  needMoreTime2022?: InputMaybe<Scalars['String']['input']>;
  nursePortfolio?: InputMaybe<NursePortfolioCreateNestedOneWithoutUserInput>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  phoneVerified?: InputMaybe<Scalars['JSON']['input']>;
  planToInterview2022?: InputMaybe<Scalars['String']['input']>;
  planToInterview2022User?: InputMaybe<Scalars['String']['input']>;
  portfolioPublic?: InputMaybe<Scalars['Boolean']['input']>;
  profile?: InputMaybe<UserProfileNullableCreateEnvelopeInput>;
  profileImg?: InputMaybe<Scalars['JSON']['input']>;
  programIds?: InputMaybe<UserCreateprogramIdsInput>;
  savedScopes?: InputMaybe<SavedScopeCreateNestedManyWithoutUserInput>;
  shareCode?: InputMaybe<Scalars['String']['input']>;
  shiftSpendGoals?: InputMaybe<ShiftSpendGoalCreateNestedManyWithoutUserInput>;
  slug?: InputMaybe<Scalars['String']['input']>;
  smsOptedOut?: InputMaybe<Scalars['Boolean']['input']>;
  smsOptedOutAt?: InputMaybe<Scalars['DateTime']['input']>;
  sponsorLinkSharable?: InputMaybe<Scalars['Boolean']['input']>;
  sponsorName?: InputMaybe<Scalars['String']['input']>;
  stripeConnectId?: InputMaybe<Scalars['String']['input']>;
  stripeCurrentlyDue?: InputMaybe<UserCreatestripeCurrentlyDueInput>;
  stripeId?: InputMaybe<Scalars['String']['input']>;
  stripeVerified?: InputMaybe<Scalars['String']['input']>;
  stripe_customer_id?: InputMaybe<Scalars['String']['input']>;
  studentWalletTransactions?: InputMaybe<StudentWalletTransactionCreateNestedManyWithoutStudentInput>;
  students?: InputMaybe<StudentCreateNestedManyWithoutParticipantInput>;
  subscription_tier?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  token?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
  userTypes?: InputMaybe<UserCreateuserTypesInput>;
  walletPayments?: InputMaybe<WalletTransactionCreateNestedManyWithoutSource_UserInput>;
  walletTransactions?: InputMaybe<WalletTransactionCreateNestedManyWithoutUserInput>;
};

export type UserCreateWithoutStudentWalletTransactionsInput = {
  aipmSettings?: InputMaybe<UserAipmSettingsNullableCreateEnvelopeInput>;
  airtable?: InputMaybe<Array<UserAirtableCreateInput>>;
  airtime2022?: InputMaybe<Scalars['String']['input']>;
  anonymous?: InputMaybe<Scalars['Boolean']['input']>;
  assistantAccess?: InputMaybe<UserAssistantAccessCreateNestedManyWithoutUserInput>;
  autoSponsoringAllowed?: InputMaybe<Scalars['Boolean']['input']>;
  badges?: InputMaybe<Array<UserBadgesCreateInput>>;
  birthDate?: InputMaybe<Scalars['String']['input']>;
  creatorThreads?: InputMaybe<CreatorThreadCreateNestedManyWithoutUserInput>;
  current_subscription_id?: InputMaybe<Scalars['String']['input']>;
  discordAccessToken?: InputMaybe<Scalars['String']['input']>;
  discordId?: InputMaybe<Scalars['String']['input']>;
  discordRefreshToken?: InputMaybe<Scalars['String']['input']>;
  discordUsername?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['JSON']['input']>;
  emailOptedOut?: InputMaybe<Scalars['Boolean']['input']>;
  emailOptedOutAt?: InputMaybe<Scalars['DateTime']['input']>;
  emailVerified?: InputMaybe<Scalars['Boolean']['input']>;
  eventLog?: InputMaybe<Array<UserEventLogCreateInput>>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  forceChangedPwd?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  identities?: InputMaybe<Array<UserIdentitiesCreateInput>>;
  invitedUser?: InputMaybe<Scalars['Boolean']['input']>;
  langGraphThreads?: InputMaybe<LangGraphThreadCreateNestedManyWithoutUserInput>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  last_modified_at: Scalars['DateTime']['input'];
  last_synced_at: Scalars['DateTime']['input'];
  leadStatus?: InputMaybe<Scalars['String']['input']>;
  migrated?: InputMaybe<Scalars['Boolean']['input']>;
  monetization_started_at?: InputMaybe<Scalars['DateTime']['input']>;
  needMoreTime2022?: InputMaybe<Scalars['String']['input']>;
  nursePortfolio?: InputMaybe<NursePortfolioCreateNestedOneWithoutUserInput>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  phoneVerified?: InputMaybe<Scalars['JSON']['input']>;
  planToInterview2022?: InputMaybe<Scalars['String']['input']>;
  planToInterview2022User?: InputMaybe<Scalars['String']['input']>;
  portfolioPublic?: InputMaybe<Scalars['Boolean']['input']>;
  profile?: InputMaybe<UserProfileNullableCreateEnvelopeInput>;
  profileImg?: InputMaybe<Scalars['JSON']['input']>;
  programIds?: InputMaybe<UserCreateprogramIdsInput>;
  savedScopes?: InputMaybe<SavedScopeCreateNestedManyWithoutUserInput>;
  shareCode?: InputMaybe<Scalars['String']['input']>;
  shiftSpendGoals?: InputMaybe<ShiftSpendGoalCreateNestedManyWithoutUserInput>;
  slug?: InputMaybe<Scalars['String']['input']>;
  smsOptedOut?: InputMaybe<Scalars['Boolean']['input']>;
  smsOptedOutAt?: InputMaybe<Scalars['DateTime']['input']>;
  sponsorLinkSharable?: InputMaybe<Scalars['Boolean']['input']>;
  sponsorName?: InputMaybe<Scalars['String']['input']>;
  stripeConnectId?: InputMaybe<Scalars['String']['input']>;
  stripeCurrentlyDue?: InputMaybe<UserCreatestripeCurrentlyDueInput>;
  stripeId?: InputMaybe<Scalars['String']['input']>;
  stripeVerified?: InputMaybe<Scalars['String']['input']>;
  stripe_customer_id?: InputMaybe<Scalars['String']['input']>;
  studentWalletPayments?: InputMaybe<StudentWalletTransactionCreateNestedManyWithoutPayerInput>;
  students?: InputMaybe<StudentCreateNestedManyWithoutParticipantInput>;
  subscription_tier?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  token?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
  userTypes?: InputMaybe<UserCreateuserTypesInput>;
  walletPayments?: InputMaybe<WalletTransactionCreateNestedManyWithoutSource_UserInput>;
  walletTransactions?: InputMaybe<WalletTransactionCreateNestedManyWithoutUserInput>;
};

export type UserCreateWithoutWalletPaymentsInput = {
  aipmSettings?: InputMaybe<UserAipmSettingsNullableCreateEnvelopeInput>;
  airtable?: InputMaybe<Array<UserAirtableCreateInput>>;
  airtime2022?: InputMaybe<Scalars['String']['input']>;
  anonymous?: InputMaybe<Scalars['Boolean']['input']>;
  assistantAccess?: InputMaybe<UserAssistantAccessCreateNestedManyWithoutUserInput>;
  autoSponsoringAllowed?: InputMaybe<Scalars['Boolean']['input']>;
  badges?: InputMaybe<Array<UserBadgesCreateInput>>;
  birthDate?: InputMaybe<Scalars['String']['input']>;
  creatorThreads?: InputMaybe<CreatorThreadCreateNestedManyWithoutUserInput>;
  current_subscription_id?: InputMaybe<Scalars['String']['input']>;
  discordAccessToken?: InputMaybe<Scalars['String']['input']>;
  discordId?: InputMaybe<Scalars['String']['input']>;
  discordRefreshToken?: InputMaybe<Scalars['String']['input']>;
  discordUsername?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['JSON']['input']>;
  emailOptedOut?: InputMaybe<Scalars['Boolean']['input']>;
  emailOptedOutAt?: InputMaybe<Scalars['DateTime']['input']>;
  emailVerified?: InputMaybe<Scalars['Boolean']['input']>;
  eventLog?: InputMaybe<Array<UserEventLogCreateInput>>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  forceChangedPwd?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  identities?: InputMaybe<Array<UserIdentitiesCreateInput>>;
  invitedUser?: InputMaybe<Scalars['Boolean']['input']>;
  langGraphThreads?: InputMaybe<LangGraphThreadCreateNestedManyWithoutUserInput>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  last_modified_at: Scalars['DateTime']['input'];
  last_synced_at: Scalars['DateTime']['input'];
  leadStatus?: InputMaybe<Scalars['String']['input']>;
  migrated?: InputMaybe<Scalars['Boolean']['input']>;
  monetization_started_at?: InputMaybe<Scalars['DateTime']['input']>;
  needMoreTime2022?: InputMaybe<Scalars['String']['input']>;
  nursePortfolio?: InputMaybe<NursePortfolioCreateNestedOneWithoutUserInput>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  phoneVerified?: InputMaybe<Scalars['JSON']['input']>;
  planToInterview2022?: InputMaybe<Scalars['String']['input']>;
  planToInterview2022User?: InputMaybe<Scalars['String']['input']>;
  portfolioPublic?: InputMaybe<Scalars['Boolean']['input']>;
  profile?: InputMaybe<UserProfileNullableCreateEnvelopeInput>;
  profileImg?: InputMaybe<Scalars['JSON']['input']>;
  programIds?: InputMaybe<UserCreateprogramIdsInput>;
  savedScopes?: InputMaybe<SavedScopeCreateNestedManyWithoutUserInput>;
  shareCode?: InputMaybe<Scalars['String']['input']>;
  shiftSpendGoals?: InputMaybe<ShiftSpendGoalCreateNestedManyWithoutUserInput>;
  slug?: InputMaybe<Scalars['String']['input']>;
  smsOptedOut?: InputMaybe<Scalars['Boolean']['input']>;
  smsOptedOutAt?: InputMaybe<Scalars['DateTime']['input']>;
  sponsorLinkSharable?: InputMaybe<Scalars['Boolean']['input']>;
  sponsorName?: InputMaybe<Scalars['String']['input']>;
  stripeConnectId?: InputMaybe<Scalars['String']['input']>;
  stripeCurrentlyDue?: InputMaybe<UserCreatestripeCurrentlyDueInput>;
  stripeId?: InputMaybe<Scalars['String']['input']>;
  stripeVerified?: InputMaybe<Scalars['String']['input']>;
  stripe_customer_id?: InputMaybe<Scalars['String']['input']>;
  studentWalletPayments?: InputMaybe<StudentWalletTransactionCreateNestedManyWithoutPayerInput>;
  studentWalletTransactions?: InputMaybe<StudentWalletTransactionCreateNestedManyWithoutStudentInput>;
  students?: InputMaybe<StudentCreateNestedManyWithoutParticipantInput>;
  subscription_tier?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  token?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
  userTypes?: InputMaybe<UserCreateuserTypesInput>;
  walletTransactions?: InputMaybe<WalletTransactionCreateNestedManyWithoutUserInput>;
};

export type UserCreateWithoutWalletTransactionsInput = {
  aipmSettings?: InputMaybe<UserAipmSettingsNullableCreateEnvelopeInput>;
  airtable?: InputMaybe<Array<UserAirtableCreateInput>>;
  airtime2022?: InputMaybe<Scalars['String']['input']>;
  anonymous?: InputMaybe<Scalars['Boolean']['input']>;
  assistantAccess?: InputMaybe<UserAssistantAccessCreateNestedManyWithoutUserInput>;
  autoSponsoringAllowed?: InputMaybe<Scalars['Boolean']['input']>;
  badges?: InputMaybe<Array<UserBadgesCreateInput>>;
  birthDate?: InputMaybe<Scalars['String']['input']>;
  creatorThreads?: InputMaybe<CreatorThreadCreateNestedManyWithoutUserInput>;
  current_subscription_id?: InputMaybe<Scalars['String']['input']>;
  discordAccessToken?: InputMaybe<Scalars['String']['input']>;
  discordId?: InputMaybe<Scalars['String']['input']>;
  discordRefreshToken?: InputMaybe<Scalars['String']['input']>;
  discordUsername?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['JSON']['input']>;
  emailOptedOut?: InputMaybe<Scalars['Boolean']['input']>;
  emailOptedOutAt?: InputMaybe<Scalars['DateTime']['input']>;
  emailVerified?: InputMaybe<Scalars['Boolean']['input']>;
  eventLog?: InputMaybe<Array<UserEventLogCreateInput>>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  forceChangedPwd?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  identities?: InputMaybe<Array<UserIdentitiesCreateInput>>;
  invitedUser?: InputMaybe<Scalars['Boolean']['input']>;
  langGraphThreads?: InputMaybe<LangGraphThreadCreateNestedManyWithoutUserInput>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  last_modified_at: Scalars['DateTime']['input'];
  last_synced_at: Scalars['DateTime']['input'];
  leadStatus?: InputMaybe<Scalars['String']['input']>;
  migrated?: InputMaybe<Scalars['Boolean']['input']>;
  monetization_started_at?: InputMaybe<Scalars['DateTime']['input']>;
  needMoreTime2022?: InputMaybe<Scalars['String']['input']>;
  nursePortfolio?: InputMaybe<NursePortfolioCreateNestedOneWithoutUserInput>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  phoneVerified?: InputMaybe<Scalars['JSON']['input']>;
  planToInterview2022?: InputMaybe<Scalars['String']['input']>;
  planToInterview2022User?: InputMaybe<Scalars['String']['input']>;
  portfolioPublic?: InputMaybe<Scalars['Boolean']['input']>;
  profile?: InputMaybe<UserProfileNullableCreateEnvelopeInput>;
  profileImg?: InputMaybe<Scalars['JSON']['input']>;
  programIds?: InputMaybe<UserCreateprogramIdsInput>;
  savedScopes?: InputMaybe<SavedScopeCreateNestedManyWithoutUserInput>;
  shareCode?: InputMaybe<Scalars['String']['input']>;
  shiftSpendGoals?: InputMaybe<ShiftSpendGoalCreateNestedManyWithoutUserInput>;
  slug?: InputMaybe<Scalars['String']['input']>;
  smsOptedOut?: InputMaybe<Scalars['Boolean']['input']>;
  smsOptedOutAt?: InputMaybe<Scalars['DateTime']['input']>;
  sponsorLinkSharable?: InputMaybe<Scalars['Boolean']['input']>;
  sponsorName?: InputMaybe<Scalars['String']['input']>;
  stripeConnectId?: InputMaybe<Scalars['String']['input']>;
  stripeCurrentlyDue?: InputMaybe<UserCreatestripeCurrentlyDueInput>;
  stripeId?: InputMaybe<Scalars['String']['input']>;
  stripeVerified?: InputMaybe<Scalars['String']['input']>;
  stripe_customer_id?: InputMaybe<Scalars['String']['input']>;
  studentWalletPayments?: InputMaybe<StudentWalletTransactionCreateNestedManyWithoutPayerInput>;
  studentWalletTransactions?: InputMaybe<StudentWalletTransactionCreateNestedManyWithoutStudentInput>;
  students?: InputMaybe<StudentCreateNestedManyWithoutParticipantInput>;
  subscription_tier?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  token?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
  userTypes?: InputMaybe<UserCreateuserTypesInput>;
  walletPayments?: InputMaybe<WalletTransactionCreateNestedManyWithoutSource_UserInput>;
};

export type UserCreateprogramIdsInput = {
  set: Array<Scalars['String']['input']>;
};

export type UserCreatestripeCurrentlyDueInput = {
  set: Array<Scalars['String']['input']>;
};

export type UserCreateuserTypesInput = {
  set: Array<Scalars['String']['input']>;
};

export type UserEventLog = {
  __typename?: 'UserEventLog';
  event: Scalars['String']['output'];
  timestamp: Scalars['DateTime']['output'];
};

export type UserEventLogCreateInput = {
  event: Scalars['String']['input'];
  timestamp: Scalars['DateTime']['input'];
};

export type UserEventLogObjectEqualityInput = {
  event: Scalars['String']['input'];
  timestamp: Scalars['DateTime']['input'];
};

export type UserIdentities = {
  __typename?: 'UserIdentities';
  connection: Scalars['String']['output'];
  isSocial: Scalars['Boolean']['output'];
  profileData?: Maybe<UserIdentitiesProfileData>;
  provider: Scalars['String']['output'];
  user_id: Scalars['String']['output'];
};

export type UserIdentitiesCreateInput = {
  connection: Scalars['String']['input'];
  isSocial: Scalars['Boolean']['input'];
  profileData?: InputMaybe<UserIdentitiesProfileDataCreateInput>;
  provider: Scalars['String']['input'];
  user_id: Scalars['String']['input'];
};

export type UserIdentitiesObjectEqualityInput = {
  connection: Scalars['String']['input'];
  isSocial: Scalars['Boolean']['input'];
  profileData?: InputMaybe<UserIdentitiesProfileDataObjectEqualityInput>;
  provider: Scalars['String']['input'];
  user_id: Scalars['String']['input'];
};

export type UserIdentitiesProfileData = {
  __typename?: 'UserIdentitiesProfileData';
  claimed?: Maybe<Scalars['Boolean']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  email_verified?: Maybe<Scalars['Boolean']['output']>;
  last_attempted_login?: Maybe<Scalars['String']['output']>;
  last_password_reset?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  phone_number?: Maybe<Scalars['String']['output']>;
  phone_verified?: Maybe<Scalars['Boolean']['output']>;
  /** Could not determine type: the field only had null or empty values in the sample set. */
  request_language?: Maybe<Scalars['JSON']['output']>;
};

export type UserIdentitiesProfileDataCreateInput = {
  claimed?: InputMaybe<Scalars['Boolean']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  email_verified?: InputMaybe<Scalars['Boolean']['input']>;
  last_attempted_login?: InputMaybe<Scalars['String']['input']>;
  last_password_reset?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  phone_number?: InputMaybe<Scalars['String']['input']>;
  phone_verified?: InputMaybe<Scalars['Boolean']['input']>;
  request_language?: InputMaybe<Scalars['JSON']['input']>;
};

export type UserIdentitiesProfileDataObjectEqualityInput = {
  claimed?: InputMaybe<Scalars['Boolean']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  email_verified?: InputMaybe<Scalars['Boolean']['input']>;
  last_attempted_login?: InputMaybe<Scalars['String']['input']>;
  last_password_reset?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  phone_number?: InputMaybe<Scalars['String']['input']>;
  phone_verified?: InputMaybe<Scalars['Boolean']['input']>;
  request_language?: InputMaybe<Scalars['JSON']['input']>;
};

export type UserIdentity = {
  __typename?: 'UserIdentity';
  /** Auth0 connection name (e.g., "email", "Username-Password-Authentication") */
  connection: Scalars['String']['output'];
  /** Whether this identity is from a social provider */
  isSocial: Scalars['Boolean']['output'];
  /** Auth0 provider name (e.g., "email", "auth0") */
  provider: Scalars['String']['output'];
  /** Auth0 user ID for this identity (e.g., "email|123", "auth0|456") */
  userId: Scalars['String']['output'];
};

/** Last seen presence information for a user */
export type UserLastSeen = {
  __typename?: 'UserLastSeen';
  /** Whether user is currently active (within 30 seconds) */
  isCurrentlyActive: Scalars['Boolean']['output'];
  /** Last activity timestamp */
  lastActiveDate?: Maybe<Scalars['DateTime']['output']>;
  /** Last activity name */
  lastActivity?: Maybe<Scalars['String']['output']>;
  /** Last program ID */
  lastProgram?: Maybe<Scalars['String']['output']>;
  /** User ID */
  userId: Scalars['ID']['output'];
};

export type UserMaxAggregate = {
  __typename?: 'UserMaxAggregate';
  airtime2022?: Maybe<Scalars['String']['output']>;
  anonymous?: Maybe<Scalars['Boolean']['output']>;
  autoSponsoringAllowed?: Maybe<Scalars['Boolean']['output']>;
  birthDate?: Maybe<Scalars['String']['output']>;
  current_subscription_id?: Maybe<Scalars['String']['output']>;
  discordAccessToken?: Maybe<Scalars['String']['output']>;
  discordId?: Maybe<Scalars['String']['output']>;
  discordRefreshToken?: Maybe<Scalars['String']['output']>;
  discordUsername?: Maybe<Scalars['String']['output']>;
  emailOptedOut?: Maybe<Scalars['Boolean']['output']>;
  emailOptedOutAt?: Maybe<Scalars['DateTime']['output']>;
  emailVerified?: Maybe<Scalars['Boolean']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  forceChangedPwd?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  invitedUser?: Maybe<Scalars['Boolean']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  last_modified_at?: Maybe<Scalars['DateTime']['output']>;
  last_synced_at?: Maybe<Scalars['DateTime']['output']>;
  leadStatus?: Maybe<Scalars['String']['output']>;
  migrated?: Maybe<Scalars['Boolean']['output']>;
  monetization_started_at?: Maybe<Scalars['DateTime']['output']>;
  needMoreTime2022?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  planToInterview2022?: Maybe<Scalars['String']['output']>;
  planToInterview2022User?: Maybe<Scalars['String']['output']>;
  portfolioPublic?: Maybe<Scalars['Boolean']['output']>;
  shareCode?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  smsOptedOut?: Maybe<Scalars['Boolean']['output']>;
  smsOptedOutAt?: Maybe<Scalars['DateTime']['output']>;
  sponsorLinkSharable?: Maybe<Scalars['Boolean']['output']>;
  sponsorName?: Maybe<Scalars['String']['output']>;
  stripeConnectId?: Maybe<Scalars['String']['output']>;
  stripeId?: Maybe<Scalars['String']['output']>;
  stripeVerified?: Maybe<Scalars['String']['output']>;
  stripe_customer_id?: Maybe<Scalars['String']['output']>;
  subscription_tier?: Maybe<Scalars['String']['output']>;
  timezone?: Maybe<Scalars['String']['output']>;
  token?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
};

export type UserMinAggregate = {
  __typename?: 'UserMinAggregate';
  airtime2022?: Maybe<Scalars['String']['output']>;
  anonymous?: Maybe<Scalars['Boolean']['output']>;
  autoSponsoringAllowed?: Maybe<Scalars['Boolean']['output']>;
  birthDate?: Maybe<Scalars['String']['output']>;
  current_subscription_id?: Maybe<Scalars['String']['output']>;
  discordAccessToken?: Maybe<Scalars['String']['output']>;
  discordId?: Maybe<Scalars['String']['output']>;
  discordRefreshToken?: Maybe<Scalars['String']['output']>;
  discordUsername?: Maybe<Scalars['String']['output']>;
  emailOptedOut?: Maybe<Scalars['Boolean']['output']>;
  emailOptedOutAt?: Maybe<Scalars['DateTime']['output']>;
  emailVerified?: Maybe<Scalars['Boolean']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  forceChangedPwd?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  invitedUser?: Maybe<Scalars['Boolean']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  last_modified_at?: Maybe<Scalars['DateTime']['output']>;
  last_synced_at?: Maybe<Scalars['DateTime']['output']>;
  leadStatus?: Maybe<Scalars['String']['output']>;
  migrated?: Maybe<Scalars['Boolean']['output']>;
  monetization_started_at?: Maybe<Scalars['DateTime']['output']>;
  needMoreTime2022?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  planToInterview2022?: Maybe<Scalars['String']['output']>;
  planToInterview2022User?: Maybe<Scalars['String']['output']>;
  portfolioPublic?: Maybe<Scalars['Boolean']['output']>;
  shareCode?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  smsOptedOut?: Maybe<Scalars['Boolean']['output']>;
  smsOptedOutAt?: Maybe<Scalars['DateTime']['output']>;
  sponsorLinkSharable?: Maybe<Scalars['Boolean']['output']>;
  sponsorName?: Maybe<Scalars['String']['output']>;
  stripeConnectId?: Maybe<Scalars['String']['output']>;
  stripeId?: Maybe<Scalars['String']['output']>;
  stripeVerified?: Maybe<Scalars['String']['output']>;
  stripe_customer_id?: Maybe<Scalars['String']['output']>;
  subscription_tier?: Maybe<Scalars['String']['output']>;
  timezone?: Maybe<Scalars['String']['output']>;
  token?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
};

export type UserNullableRelationFilter = {
  is?: InputMaybe<UserWhereInput>;
  isNot?: InputMaybe<UserWhereInput>;
};

/** Withdrawal/payout record for instructor withdrawals */
export type UserPayoutType = {
  __typename?: 'UserPayoutType';
  /** Amount in cents (not dollars) */
  amount: Scalars['Int']['output'];
  /** Unix timestamp when funds arrive at bank */
  arrival_date?: Maybe<Scalars['Int']['output']>;
  /** Stripe external account ID (ba_xxx) */
  bankAccountId?: Maybe<Scalars['String']['output']>;
  /** Last 4 digits of bank account */
  bankAccountLast4?: Maybe<Scalars['String']['output']>;
  /** Name of the bank */
  bankName?: Maybe<Scalars['String']['output']>;
  /** When payout was created */
  created: Scalars['DateTime']['output'];
  /** Currency code */
  currency: Scalars['String']['output'];
  /** Human-readable description */
  description?: Maybe<Scalars['String']['output']>;
  /** Unique payout identifier */
  id: Scalars['ID']['output'];
  /** Transaction IDs included in this payout (lazy loaded from DB) */
  relatedTransactionIds: Array<Scalars['String']['output']>;
  /** Payout status (pending, in_transit, paid, failed, canceled) */
  status: PayoutStatus;
  /** Stripe Connect account ID (acct_xxx) */
  stripeConnectId: Scalars['String']['output'];
  /** Detailed Stripe Payout information (lazy loaded from Stripe API) */
  stripePayoutDetails?: Maybe<StripePayoutDetails>;
  /** Stripe Payout/Transfer ID (po_xxx or tr_xxx) */
  stripePayoutId: Scalars['String']['output'];
  /** When payout was last updated */
  updated_at?: Maybe<Scalars['DateTime']['output']>;
  /** Organizer ID who requested withdrawal */
  user_id: Scalars['String']['output'];
};

export type UserPermissionsData = {
  __typename?: 'UserPermissionsData';
  permissions: Array<Scalars['String']['output']>;
  statistics?: Maybe<Scalars['JSON']['output']>;
};

export type UserPermissionsOutput = {
  __typename?: 'UserPermissionsOutput';
  data: UserPermissionsData;
  message: Scalars['String']['output'];
};

export type UserProfile = {
  __typename?: 'UserProfile';
  large: Scalars['String']['output'];
  medium: Scalars['String']['output'];
  small: Scalars['String']['output'];
};

export type UserProfileCreateInput = {
  large: Scalars['String']['input'];
  medium: Scalars['String']['input'];
  small: Scalars['String']['input'];
};

export type UserProfileNullableCompositeFilter = {
  equals?: InputMaybe<UserProfileObjectEqualityInput>;
  is?: InputMaybe<UserProfileWhereInput>;
  isNot?: InputMaybe<UserProfileWhereInput>;
  isSet?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UserProfileNullableCreateEnvelopeInput = {
  set?: InputMaybe<UserProfileCreateInput>;
};

export type UserProfileNullableUpdateEnvelopeInput = {
  set?: InputMaybe<UserProfileCreateInput>;
  unset?: InputMaybe<Scalars['Boolean']['input']>;
  upsert?: InputMaybe<UserProfileUpsertInput>;
};

export type UserProfileObjectEqualityInput = {
  large: Scalars['String']['input'];
  medium: Scalars['String']['input'];
  small: Scalars['String']['input'];
};

export type UserProfileUpdateInput = {
  large?: InputMaybe<StringFieldUpdateOperationsInput>;
  medium?: InputMaybe<StringFieldUpdateOperationsInput>;
  small?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type UserProfileUpsertInput = {
  set: UserProfileCreateInput;
  update: UserProfileUpdateInput;
};

export type UserProfileWhereInput = {
  AND?: InputMaybe<Array<UserProfileWhereInput>>;
  NOT?: InputMaybe<Array<UserProfileWhereInput>>;
  OR?: InputMaybe<Array<UserProfileWhereInput>>;
  large?: InputMaybe<StringFilter>;
  medium?: InputMaybe<StringFilter>;
  small?: InputMaybe<StringFilter>;
};

export type UserProgramCount = {
  __typename?: 'UserProgramCount';
  /** Count of programs where user is creator (createdBy) or organizer (organizers[].userId) */
  programsCreated: Scalars['Int']['output'];
  /** Count of distinct programs user has participated in (via Student.participant_id) */
  programsParticipated: Scalars['Int']['output'];
  /** User ID */
  userId: Scalars['String']['output'];
};

export type UserProgramCountsOutput = {
  __typename?: 'UserProgramCountsOutput';
  /** Array of program counts for each requested user */
  counts: Array<UserProgramCount>;
};

export type UserRelationFilter = {
  is?: InputMaybe<UserWhereInput>;
  isNot?: InputMaybe<UserWhereInput>;
};

export type UserSettingsCountAggregate = {
  __typename?: 'UserSettingsCountAggregate';
  _all: Scalars['Int']['output'];
  aipmEnabled: Scalars['Int']['output'];
  aipmPrograms: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  email: Scalars['Int']['output'];
  emailVerified: Scalars['Int']['output'];
  firstGoal: Scalars['Int']['output'];
  firstName: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  lastDismissedAt: Scalars['Int']['output'];
  lastName: Scalars['Int']['output'];
  onboardingCompletedAt: Scalars['Int']['output'];
  perProgramOverrides: Scalars['Int']['output'];
  personaId: Scalars['Int']['output'];
  phone: Scalars['Int']['output'];
  phoneVerified: Scalars['Int']['output'];
  preferredChannel: Scalars['Int']['output'];
  updatedAt: Scalars['Int']['output'];
  userId: Scalars['Int']['output'];
};

export type UserSettingsMaxAggregate = {
  __typename?: 'UserSettingsMaxAggregate';
  aipmEnabled?: Maybe<Scalars['Boolean']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  emailVerified?: Maybe<Scalars['Boolean']['output']>;
  firstGoal?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  lastDismissedAt?: Maybe<Scalars['DateTime']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  onboardingCompletedAt?: Maybe<Scalars['DateTime']['output']>;
  personaId?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  phoneVerified?: Maybe<Scalars['Boolean']['output']>;
  preferredChannel?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
};

export type UserSettingsMinAggregate = {
  __typename?: 'UserSettingsMinAggregate';
  aipmEnabled?: Maybe<Scalars['Boolean']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  emailVerified?: Maybe<Scalars['Boolean']['output']>;
  firstGoal?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  lastDismissedAt?: Maybe<Scalars['DateTime']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  onboardingCompletedAt?: Maybe<Scalars['DateTime']['output']>;
  personaId?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  phoneVerified?: Maybe<Scalars['Boolean']['output']>;
  preferredChannel?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
};

export type UserUpdateOneRequiredWithoutAssistantAccessNestedInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutAssistantAccessInput>;
  create?: InputMaybe<UserCreateWithoutAssistantAccessInput>;
  update?: InputMaybe<UserUpdateToOneWithWhereWithoutAssistantAccessInput>;
  upsert?: InputMaybe<UserUpsertWithoutAssistantAccessInput>;
};

export type UserUpdateOneRequiredWithoutLangGraphThreadsNestedInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutLangGraphThreadsInput>;
  create?: InputMaybe<UserCreateWithoutLangGraphThreadsInput>;
  update?: InputMaybe<UserUpdateToOneWithWhereWithoutLangGraphThreadsInput>;
  upsert?: InputMaybe<UserUpsertWithoutLangGraphThreadsInput>;
};

export type UserUpdateOneRequiredWithoutStudentWalletPaymentsNestedInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutStudentWalletPaymentsInput>;
  create?: InputMaybe<UserCreateWithoutStudentWalletPaymentsInput>;
  update?: InputMaybe<UserUpdateToOneWithWhereWithoutStudentWalletPaymentsInput>;
  upsert?: InputMaybe<UserUpsertWithoutStudentWalletPaymentsInput>;
};

export type UserUpdateOneRequiredWithoutStudentWalletTransactionsNestedInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutStudentWalletTransactionsInput>;
  create?: InputMaybe<UserCreateWithoutStudentWalletTransactionsInput>;
  update?: InputMaybe<UserUpdateToOneWithWhereWithoutStudentWalletTransactionsInput>;
  upsert?: InputMaybe<UserUpsertWithoutStudentWalletTransactionsInput>;
};

export type UserUpdateOneRequiredWithoutWalletPaymentsNestedInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutWalletPaymentsInput>;
  create?: InputMaybe<UserCreateWithoutWalletPaymentsInput>;
  update?: InputMaybe<UserUpdateToOneWithWhereWithoutWalletPaymentsInput>;
  upsert?: InputMaybe<UserUpsertWithoutWalletPaymentsInput>;
};

export type UserUpdateOneRequiredWithoutWalletTransactionsNestedInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutWalletTransactionsInput>;
  create?: InputMaybe<UserCreateWithoutWalletTransactionsInput>;
  update?: InputMaybe<UserUpdateToOneWithWhereWithoutWalletTransactionsInput>;
  upsert?: InputMaybe<UserUpsertWithoutWalletTransactionsInput>;
};

export type UserUpdateToOneWithWhereWithoutAssistantAccessInput = {
  data: UserUpdateWithoutAssistantAccessInput;
  where?: InputMaybe<UserWhereInput>;
};

export type UserUpdateToOneWithWhereWithoutLangGraphThreadsInput = {
  data: UserUpdateWithoutLangGraphThreadsInput;
  where?: InputMaybe<UserWhereInput>;
};

export type UserUpdateToOneWithWhereWithoutStudentWalletPaymentsInput = {
  data: UserUpdateWithoutStudentWalletPaymentsInput;
  where?: InputMaybe<UserWhereInput>;
};

export type UserUpdateToOneWithWhereWithoutStudentWalletTransactionsInput = {
  data: UserUpdateWithoutStudentWalletTransactionsInput;
  where?: InputMaybe<UserWhereInput>;
};

export type UserUpdateToOneWithWhereWithoutWalletPaymentsInput = {
  data: UserUpdateWithoutWalletPaymentsInput;
  where?: InputMaybe<UserWhereInput>;
};

export type UserUpdateToOneWithWhereWithoutWalletTransactionsInput = {
  data: UserUpdateWithoutWalletTransactionsInput;
  where?: InputMaybe<UserWhereInput>;
};

export type UserUpdateWithoutAssistantAccessInput = {
  aipmSettings?: InputMaybe<UserAipmSettingsNullableUpdateEnvelopeInput>;
  airtable?: InputMaybe<Array<UserAirtableCreateInput>>;
  airtime2022?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  anonymous?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  autoSponsoringAllowed?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  badges?: InputMaybe<Array<UserBadgesCreateInput>>;
  birthDate?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  creatorThreads?: InputMaybe<CreatorThreadUpdateManyWithoutUserNestedInput>;
  current_subscription_id?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  discordAccessToken?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  discordId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  discordRefreshToken?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  discordUsername?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  email?: InputMaybe<Scalars['JSON']['input']>;
  emailOptedOut?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  emailOptedOutAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  emailVerified?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  eventLog?: InputMaybe<Array<UserEventLogCreateInput>>;
  firstName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  forceChangedPwd?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  identities?: InputMaybe<Array<UserIdentitiesCreateInput>>;
  invitedUser?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  langGraphThreads?: InputMaybe<LangGraphThreadUpdateManyWithoutUserNestedInput>;
  lastName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  last_modified_at?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  last_synced_at?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  leadStatus?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  migrated?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  monetization_started_at?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  needMoreTime2022?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  nursePortfolio?: InputMaybe<NursePortfolioUpdateOneWithoutUserNestedInput>;
  phoneNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  phoneVerified?: InputMaybe<Scalars['JSON']['input']>;
  planToInterview2022?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  planToInterview2022User?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  portfolioPublic?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  profile?: InputMaybe<UserProfileNullableUpdateEnvelopeInput>;
  profileImg?: InputMaybe<Scalars['JSON']['input']>;
  programIds?: InputMaybe<UserUpdateprogramIdsInput>;
  savedScopes?: InputMaybe<SavedScopeUpdateManyWithoutUserNestedInput>;
  shareCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  shiftSpendGoals?: InputMaybe<ShiftSpendGoalUpdateManyWithoutUserNestedInput>;
  slug?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  smsOptedOut?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  smsOptedOutAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  sponsorLinkSharable?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  sponsorName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  stripeConnectId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  stripeCurrentlyDue?: InputMaybe<UserUpdatestripeCurrentlyDueInput>;
  stripeId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  stripeVerified?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  stripe_customer_id?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  studentWalletPayments?: InputMaybe<StudentWalletTransactionUpdateManyWithoutPayerNestedInput>;
  studentWalletTransactions?: InputMaybe<StudentWalletTransactionUpdateManyWithoutStudentNestedInput>;
  students?: InputMaybe<StudentUpdateManyWithoutParticipantNestedInput>;
  subscription_tier?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  timezone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  token?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  userId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  userTypes?: InputMaybe<UserUpdateuserTypesInput>;
  walletPayments?: InputMaybe<WalletTransactionUpdateManyWithoutSource_UserNestedInput>;
  walletTransactions?: InputMaybe<WalletTransactionUpdateManyWithoutUserNestedInput>;
};

export type UserUpdateWithoutLangGraphThreadsInput = {
  aipmSettings?: InputMaybe<UserAipmSettingsNullableUpdateEnvelopeInput>;
  airtable?: InputMaybe<Array<UserAirtableCreateInput>>;
  airtime2022?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  anonymous?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  assistantAccess?: InputMaybe<UserAssistantAccessUpdateManyWithoutUserNestedInput>;
  autoSponsoringAllowed?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  badges?: InputMaybe<Array<UserBadgesCreateInput>>;
  birthDate?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  creatorThreads?: InputMaybe<CreatorThreadUpdateManyWithoutUserNestedInput>;
  current_subscription_id?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  discordAccessToken?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  discordId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  discordRefreshToken?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  discordUsername?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  email?: InputMaybe<Scalars['JSON']['input']>;
  emailOptedOut?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  emailOptedOutAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  emailVerified?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  eventLog?: InputMaybe<Array<UserEventLogCreateInput>>;
  firstName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  forceChangedPwd?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  identities?: InputMaybe<Array<UserIdentitiesCreateInput>>;
  invitedUser?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  lastName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  last_modified_at?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  last_synced_at?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  leadStatus?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  migrated?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  monetization_started_at?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  needMoreTime2022?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  nursePortfolio?: InputMaybe<NursePortfolioUpdateOneWithoutUserNestedInput>;
  phoneNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  phoneVerified?: InputMaybe<Scalars['JSON']['input']>;
  planToInterview2022?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  planToInterview2022User?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  portfolioPublic?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  profile?: InputMaybe<UserProfileNullableUpdateEnvelopeInput>;
  profileImg?: InputMaybe<Scalars['JSON']['input']>;
  programIds?: InputMaybe<UserUpdateprogramIdsInput>;
  savedScopes?: InputMaybe<SavedScopeUpdateManyWithoutUserNestedInput>;
  shareCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  shiftSpendGoals?: InputMaybe<ShiftSpendGoalUpdateManyWithoutUserNestedInput>;
  slug?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  smsOptedOut?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  smsOptedOutAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  sponsorLinkSharable?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  sponsorName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  stripeConnectId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  stripeCurrentlyDue?: InputMaybe<UserUpdatestripeCurrentlyDueInput>;
  stripeId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  stripeVerified?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  stripe_customer_id?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  studentWalletPayments?: InputMaybe<StudentWalletTransactionUpdateManyWithoutPayerNestedInput>;
  studentWalletTransactions?: InputMaybe<StudentWalletTransactionUpdateManyWithoutStudentNestedInput>;
  students?: InputMaybe<StudentUpdateManyWithoutParticipantNestedInput>;
  subscription_tier?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  timezone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  token?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  userId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  userTypes?: InputMaybe<UserUpdateuserTypesInput>;
  walletPayments?: InputMaybe<WalletTransactionUpdateManyWithoutSource_UserNestedInput>;
  walletTransactions?: InputMaybe<WalletTransactionUpdateManyWithoutUserNestedInput>;
};

export type UserUpdateWithoutStudentWalletPaymentsInput = {
  aipmSettings?: InputMaybe<UserAipmSettingsNullableUpdateEnvelopeInput>;
  airtable?: InputMaybe<Array<UserAirtableCreateInput>>;
  airtime2022?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  anonymous?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  assistantAccess?: InputMaybe<UserAssistantAccessUpdateManyWithoutUserNestedInput>;
  autoSponsoringAllowed?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  badges?: InputMaybe<Array<UserBadgesCreateInput>>;
  birthDate?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  creatorThreads?: InputMaybe<CreatorThreadUpdateManyWithoutUserNestedInput>;
  current_subscription_id?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  discordAccessToken?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  discordId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  discordRefreshToken?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  discordUsername?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  email?: InputMaybe<Scalars['JSON']['input']>;
  emailOptedOut?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  emailOptedOutAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  emailVerified?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  eventLog?: InputMaybe<Array<UserEventLogCreateInput>>;
  firstName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  forceChangedPwd?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  identities?: InputMaybe<Array<UserIdentitiesCreateInput>>;
  invitedUser?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  langGraphThreads?: InputMaybe<LangGraphThreadUpdateManyWithoutUserNestedInput>;
  lastName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  last_modified_at?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  last_synced_at?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  leadStatus?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  migrated?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  monetization_started_at?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  needMoreTime2022?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  nursePortfolio?: InputMaybe<NursePortfolioUpdateOneWithoutUserNestedInput>;
  phoneNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  phoneVerified?: InputMaybe<Scalars['JSON']['input']>;
  planToInterview2022?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  planToInterview2022User?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  portfolioPublic?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  profile?: InputMaybe<UserProfileNullableUpdateEnvelopeInput>;
  profileImg?: InputMaybe<Scalars['JSON']['input']>;
  programIds?: InputMaybe<UserUpdateprogramIdsInput>;
  savedScopes?: InputMaybe<SavedScopeUpdateManyWithoutUserNestedInput>;
  shareCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  shiftSpendGoals?: InputMaybe<ShiftSpendGoalUpdateManyWithoutUserNestedInput>;
  slug?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  smsOptedOut?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  smsOptedOutAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  sponsorLinkSharable?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  sponsorName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  stripeConnectId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  stripeCurrentlyDue?: InputMaybe<UserUpdatestripeCurrentlyDueInput>;
  stripeId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  stripeVerified?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  stripe_customer_id?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  studentWalletTransactions?: InputMaybe<StudentWalletTransactionUpdateManyWithoutStudentNestedInput>;
  students?: InputMaybe<StudentUpdateManyWithoutParticipantNestedInput>;
  subscription_tier?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  timezone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  token?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  userId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  userTypes?: InputMaybe<UserUpdateuserTypesInput>;
  walletPayments?: InputMaybe<WalletTransactionUpdateManyWithoutSource_UserNestedInput>;
  walletTransactions?: InputMaybe<WalletTransactionUpdateManyWithoutUserNestedInput>;
};

export type UserUpdateWithoutStudentWalletTransactionsInput = {
  aipmSettings?: InputMaybe<UserAipmSettingsNullableUpdateEnvelopeInput>;
  airtable?: InputMaybe<Array<UserAirtableCreateInput>>;
  airtime2022?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  anonymous?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  assistantAccess?: InputMaybe<UserAssistantAccessUpdateManyWithoutUserNestedInput>;
  autoSponsoringAllowed?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  badges?: InputMaybe<Array<UserBadgesCreateInput>>;
  birthDate?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  creatorThreads?: InputMaybe<CreatorThreadUpdateManyWithoutUserNestedInput>;
  current_subscription_id?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  discordAccessToken?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  discordId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  discordRefreshToken?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  discordUsername?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  email?: InputMaybe<Scalars['JSON']['input']>;
  emailOptedOut?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  emailOptedOutAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  emailVerified?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  eventLog?: InputMaybe<Array<UserEventLogCreateInput>>;
  firstName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  forceChangedPwd?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  identities?: InputMaybe<Array<UserIdentitiesCreateInput>>;
  invitedUser?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  langGraphThreads?: InputMaybe<LangGraphThreadUpdateManyWithoutUserNestedInput>;
  lastName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  last_modified_at?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  last_synced_at?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  leadStatus?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  migrated?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  monetization_started_at?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  needMoreTime2022?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  nursePortfolio?: InputMaybe<NursePortfolioUpdateOneWithoutUserNestedInput>;
  phoneNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  phoneVerified?: InputMaybe<Scalars['JSON']['input']>;
  planToInterview2022?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  planToInterview2022User?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  portfolioPublic?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  profile?: InputMaybe<UserProfileNullableUpdateEnvelopeInput>;
  profileImg?: InputMaybe<Scalars['JSON']['input']>;
  programIds?: InputMaybe<UserUpdateprogramIdsInput>;
  savedScopes?: InputMaybe<SavedScopeUpdateManyWithoutUserNestedInput>;
  shareCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  shiftSpendGoals?: InputMaybe<ShiftSpendGoalUpdateManyWithoutUserNestedInput>;
  slug?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  smsOptedOut?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  smsOptedOutAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  sponsorLinkSharable?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  sponsorName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  stripeConnectId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  stripeCurrentlyDue?: InputMaybe<UserUpdatestripeCurrentlyDueInput>;
  stripeId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  stripeVerified?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  stripe_customer_id?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  studentWalletPayments?: InputMaybe<StudentWalletTransactionUpdateManyWithoutPayerNestedInput>;
  students?: InputMaybe<StudentUpdateManyWithoutParticipantNestedInput>;
  subscription_tier?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  timezone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  token?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  userId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  userTypes?: InputMaybe<UserUpdateuserTypesInput>;
  walletPayments?: InputMaybe<WalletTransactionUpdateManyWithoutSource_UserNestedInput>;
  walletTransactions?: InputMaybe<WalletTransactionUpdateManyWithoutUserNestedInput>;
};

export type UserUpdateWithoutWalletPaymentsInput = {
  aipmSettings?: InputMaybe<UserAipmSettingsNullableUpdateEnvelopeInput>;
  airtable?: InputMaybe<Array<UserAirtableCreateInput>>;
  airtime2022?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  anonymous?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  assistantAccess?: InputMaybe<UserAssistantAccessUpdateManyWithoutUserNestedInput>;
  autoSponsoringAllowed?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  badges?: InputMaybe<Array<UserBadgesCreateInput>>;
  birthDate?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  creatorThreads?: InputMaybe<CreatorThreadUpdateManyWithoutUserNestedInput>;
  current_subscription_id?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  discordAccessToken?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  discordId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  discordRefreshToken?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  discordUsername?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  email?: InputMaybe<Scalars['JSON']['input']>;
  emailOptedOut?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  emailOptedOutAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  emailVerified?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  eventLog?: InputMaybe<Array<UserEventLogCreateInput>>;
  firstName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  forceChangedPwd?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  identities?: InputMaybe<Array<UserIdentitiesCreateInput>>;
  invitedUser?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  langGraphThreads?: InputMaybe<LangGraphThreadUpdateManyWithoutUserNestedInput>;
  lastName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  last_modified_at?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  last_synced_at?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  leadStatus?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  migrated?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  monetization_started_at?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  needMoreTime2022?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  nursePortfolio?: InputMaybe<NursePortfolioUpdateOneWithoutUserNestedInput>;
  phoneNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  phoneVerified?: InputMaybe<Scalars['JSON']['input']>;
  planToInterview2022?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  planToInterview2022User?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  portfolioPublic?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  profile?: InputMaybe<UserProfileNullableUpdateEnvelopeInput>;
  profileImg?: InputMaybe<Scalars['JSON']['input']>;
  programIds?: InputMaybe<UserUpdateprogramIdsInput>;
  savedScopes?: InputMaybe<SavedScopeUpdateManyWithoutUserNestedInput>;
  shareCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  shiftSpendGoals?: InputMaybe<ShiftSpendGoalUpdateManyWithoutUserNestedInput>;
  slug?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  smsOptedOut?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  smsOptedOutAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  sponsorLinkSharable?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  sponsorName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  stripeConnectId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  stripeCurrentlyDue?: InputMaybe<UserUpdatestripeCurrentlyDueInput>;
  stripeId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  stripeVerified?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  stripe_customer_id?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  studentWalletPayments?: InputMaybe<StudentWalletTransactionUpdateManyWithoutPayerNestedInput>;
  studentWalletTransactions?: InputMaybe<StudentWalletTransactionUpdateManyWithoutStudentNestedInput>;
  students?: InputMaybe<StudentUpdateManyWithoutParticipantNestedInput>;
  subscription_tier?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  timezone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  token?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  userId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  userTypes?: InputMaybe<UserUpdateuserTypesInput>;
  walletTransactions?: InputMaybe<WalletTransactionUpdateManyWithoutUserNestedInput>;
};

export type UserUpdateWithoutWalletTransactionsInput = {
  aipmSettings?: InputMaybe<UserAipmSettingsNullableUpdateEnvelopeInput>;
  airtable?: InputMaybe<Array<UserAirtableCreateInput>>;
  airtime2022?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  anonymous?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  assistantAccess?: InputMaybe<UserAssistantAccessUpdateManyWithoutUserNestedInput>;
  autoSponsoringAllowed?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  badges?: InputMaybe<Array<UserBadgesCreateInput>>;
  birthDate?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  creatorThreads?: InputMaybe<CreatorThreadUpdateManyWithoutUserNestedInput>;
  current_subscription_id?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  discordAccessToken?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  discordId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  discordRefreshToken?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  discordUsername?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  email?: InputMaybe<Scalars['JSON']['input']>;
  emailOptedOut?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  emailOptedOutAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  emailVerified?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  eventLog?: InputMaybe<Array<UserEventLogCreateInput>>;
  firstName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  forceChangedPwd?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  identities?: InputMaybe<Array<UserIdentitiesCreateInput>>;
  invitedUser?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  langGraphThreads?: InputMaybe<LangGraphThreadUpdateManyWithoutUserNestedInput>;
  lastName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  last_modified_at?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  last_synced_at?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  leadStatus?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  migrated?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  monetization_started_at?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  needMoreTime2022?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  nursePortfolio?: InputMaybe<NursePortfolioUpdateOneWithoutUserNestedInput>;
  phoneNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  phoneVerified?: InputMaybe<Scalars['JSON']['input']>;
  planToInterview2022?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  planToInterview2022User?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  portfolioPublic?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  profile?: InputMaybe<UserProfileNullableUpdateEnvelopeInput>;
  profileImg?: InputMaybe<Scalars['JSON']['input']>;
  programIds?: InputMaybe<UserUpdateprogramIdsInput>;
  savedScopes?: InputMaybe<SavedScopeUpdateManyWithoutUserNestedInput>;
  shareCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  shiftSpendGoals?: InputMaybe<ShiftSpendGoalUpdateManyWithoutUserNestedInput>;
  slug?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  smsOptedOut?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  smsOptedOutAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  sponsorLinkSharable?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  sponsorName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  stripeConnectId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  stripeCurrentlyDue?: InputMaybe<UserUpdatestripeCurrentlyDueInput>;
  stripeId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  stripeVerified?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  stripe_customer_id?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  studentWalletPayments?: InputMaybe<StudentWalletTransactionUpdateManyWithoutPayerNestedInput>;
  studentWalletTransactions?: InputMaybe<StudentWalletTransactionUpdateManyWithoutStudentNestedInput>;
  students?: InputMaybe<StudentUpdateManyWithoutParticipantNestedInput>;
  subscription_tier?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  timezone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  token?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  userId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  userTypes?: InputMaybe<UserUpdateuserTypesInput>;
  walletPayments?: InputMaybe<WalletTransactionUpdateManyWithoutSource_UserNestedInput>;
};

export type UserUpdateprogramIdsInput = {
  push?: InputMaybe<Array<Scalars['String']['input']>>;
  set?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type UserUpdatestripeCurrentlyDueInput = {
  push?: InputMaybe<Array<Scalars['String']['input']>>;
  set?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type UserUpdateuserTypesInput = {
  push?: InputMaybe<Array<Scalars['String']['input']>>;
  set?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type UserUpsertWithoutAssistantAccessInput = {
  create: UserCreateWithoutAssistantAccessInput;
  update: UserUpdateWithoutAssistantAccessInput;
  where?: InputMaybe<UserWhereInput>;
};

export type UserUpsertWithoutLangGraphThreadsInput = {
  create: UserCreateWithoutLangGraphThreadsInput;
  update: UserUpdateWithoutLangGraphThreadsInput;
  where?: InputMaybe<UserWhereInput>;
};

export type UserUpsertWithoutStudentWalletPaymentsInput = {
  create: UserCreateWithoutStudentWalletPaymentsInput;
  update: UserUpdateWithoutStudentWalletPaymentsInput;
  where?: InputMaybe<UserWhereInput>;
};

export type UserUpsertWithoutStudentWalletTransactionsInput = {
  create: UserCreateWithoutStudentWalletTransactionsInput;
  update: UserUpdateWithoutStudentWalletTransactionsInput;
  where?: InputMaybe<UserWhereInput>;
};

export type UserUpsertWithoutWalletPaymentsInput = {
  create: UserCreateWithoutWalletPaymentsInput;
  update: UserUpdateWithoutWalletPaymentsInput;
  where?: InputMaybe<UserWhereInput>;
};

export type UserUpsertWithoutWalletTransactionsInput = {
  create: UserCreateWithoutWalletTransactionsInput;
  update: UserUpdateWithoutWalletTransactionsInput;
  where?: InputMaybe<UserWhereInput>;
};

export type UserWhereInput = {
  AND?: InputMaybe<Array<UserWhereInput>>;
  NOT?: InputMaybe<Array<UserWhereInput>>;
  OR?: InputMaybe<Array<UserWhereInput>>;
  aipmSettings?: InputMaybe<UserAipmSettingsNullableCompositeFilter>;
  airtable?: InputMaybe<Array<UserAirtableObjectEqualityInput>>;
  airtime2022?: InputMaybe<StringNullableFilter>;
  anonymous?: InputMaybe<BoolNullableFilter>;
  assistantAccess?: InputMaybe<UserAssistantAccessListRelationFilter>;
  autoSponsoringAllowed?: InputMaybe<BoolNullableFilter>;
  badges?: InputMaybe<Array<UserBadgesObjectEqualityInput>>;
  birthDate?: InputMaybe<StringNullableFilter>;
  creatorThreads?: InputMaybe<CreatorThreadListRelationFilter>;
  current_subscription_id?: InputMaybe<StringNullableFilter>;
  discordAccessToken?: InputMaybe<StringNullableFilter>;
  discordId?: InputMaybe<StringNullableFilter>;
  discordRefreshToken?: InputMaybe<StringNullableFilter>;
  discordUsername?: InputMaybe<StringNullableFilter>;
  email?: InputMaybe<JsonNullableFilter>;
  emailOptedOut?: InputMaybe<BoolNullableFilter>;
  emailOptedOutAt?: InputMaybe<DateTimeNullableFilter>;
  emailVerified?: InputMaybe<BoolNullableFilter>;
  eventLog?: InputMaybe<Array<UserEventLogObjectEqualityInput>>;
  firstName?: InputMaybe<StringNullableFilter>;
  forceChangedPwd?: InputMaybe<BoolNullableFilter>;
  id?: InputMaybe<StringFilter>;
  identities?: InputMaybe<Array<UserIdentitiesObjectEqualityInput>>;
  invitedUser?: InputMaybe<BoolNullableFilter>;
  langGraphThreads?: InputMaybe<LangGraphThreadListRelationFilter>;
  lastName?: InputMaybe<StringNullableFilter>;
  last_modified_at?: InputMaybe<DateTimeFilter>;
  last_synced_at?: InputMaybe<DateTimeFilter>;
  leadStatus?: InputMaybe<StringNullableFilter>;
  migrated?: InputMaybe<BoolNullableFilter>;
  monetization_started_at?: InputMaybe<DateTimeNullableFilter>;
  needMoreTime2022?: InputMaybe<StringNullableFilter>;
  nursePortfolio?: InputMaybe<NursePortfolioNullableRelationFilter>;
  phoneNumber?: InputMaybe<StringNullableFilter>;
  phoneVerified?: InputMaybe<JsonNullableFilter>;
  planToInterview2022?: InputMaybe<StringNullableFilter>;
  planToInterview2022User?: InputMaybe<StringNullableFilter>;
  portfolioPublic?: InputMaybe<BoolNullableFilter>;
  profile?: InputMaybe<UserProfileNullableCompositeFilter>;
  profileImg?: InputMaybe<JsonNullableFilter>;
  programIds?: InputMaybe<StringNullableListFilter>;
  savedScopes?: InputMaybe<SavedScopeListRelationFilter>;
  shareCode?: InputMaybe<StringNullableFilter>;
  shiftSpendGoals?: InputMaybe<ShiftSpendGoalListRelationFilter>;
  slug?: InputMaybe<StringNullableFilter>;
  smsOptedOut?: InputMaybe<BoolNullableFilter>;
  smsOptedOutAt?: InputMaybe<DateTimeNullableFilter>;
  sponsorLinkSharable?: InputMaybe<BoolNullableFilter>;
  sponsorName?: InputMaybe<StringNullableFilter>;
  stripeConnectId?: InputMaybe<StringNullableFilter>;
  stripeCurrentlyDue?: InputMaybe<StringNullableListFilter>;
  stripeId?: InputMaybe<StringNullableFilter>;
  stripeVerified?: InputMaybe<StringNullableFilter>;
  stripe_customer_id?: InputMaybe<StringNullableFilter>;
  studentWalletPayments?: InputMaybe<StudentWalletTransactionListRelationFilter>;
  studentWalletTransactions?: InputMaybe<StudentWalletTransactionListRelationFilter>;
  students?: InputMaybe<StudentListRelationFilter>;
  subscription_tier?: InputMaybe<StringNullableFilter>;
  timezone?: InputMaybe<StringNullableFilter>;
  token?: InputMaybe<StringNullableFilter>;
  userId?: InputMaybe<StringNullableFilter>;
  userTypes?: InputMaybe<StringNullableListFilter>;
  walletPayments?: InputMaybe<WalletTransactionListRelationFilter>;
  walletTransactions?: InputMaybe<WalletTransactionListRelationFilter>;
};

export type UserWhereUniqueInput = {
  AND?: InputMaybe<Array<UserWhereInput>>;
  NOT?: InputMaybe<Array<UserWhereInput>>;
  OR?: InputMaybe<Array<UserWhereInput>>;
  aipmSettings?: InputMaybe<UserAipmSettingsNullableCompositeFilter>;
  airtable?: InputMaybe<Array<UserAirtableObjectEqualityInput>>;
  airtime2022?: InputMaybe<StringNullableFilter>;
  anonymous?: InputMaybe<BoolNullableFilter>;
  assistantAccess?: InputMaybe<UserAssistantAccessListRelationFilter>;
  autoSponsoringAllowed?: InputMaybe<BoolNullableFilter>;
  badges?: InputMaybe<Array<UserBadgesObjectEqualityInput>>;
  birthDate?: InputMaybe<StringNullableFilter>;
  creatorThreads?: InputMaybe<CreatorThreadListRelationFilter>;
  current_subscription_id?: InputMaybe<StringNullableFilter>;
  discordAccessToken?: InputMaybe<StringNullableFilter>;
  discordId?: InputMaybe<StringNullableFilter>;
  discordRefreshToken?: InputMaybe<StringNullableFilter>;
  discordUsername?: InputMaybe<StringNullableFilter>;
  email?: InputMaybe<JsonNullableFilter>;
  emailOptedOut?: InputMaybe<BoolNullableFilter>;
  emailOptedOutAt?: InputMaybe<DateTimeNullableFilter>;
  emailVerified?: InputMaybe<BoolNullableFilter>;
  eventLog?: InputMaybe<Array<UserEventLogObjectEqualityInput>>;
  firstName?: InputMaybe<StringNullableFilter>;
  forceChangedPwd?: InputMaybe<BoolNullableFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  identities?: InputMaybe<Array<UserIdentitiesObjectEqualityInput>>;
  invitedUser?: InputMaybe<BoolNullableFilter>;
  langGraphThreads?: InputMaybe<LangGraphThreadListRelationFilter>;
  lastName?: InputMaybe<StringNullableFilter>;
  last_modified_at?: InputMaybe<DateTimeFilter>;
  last_synced_at?: InputMaybe<DateTimeFilter>;
  leadStatus?: InputMaybe<StringNullableFilter>;
  migrated?: InputMaybe<BoolNullableFilter>;
  monetization_started_at?: InputMaybe<DateTimeNullableFilter>;
  needMoreTime2022?: InputMaybe<StringNullableFilter>;
  nursePortfolio?: InputMaybe<NursePortfolioNullableRelationFilter>;
  phoneNumber?: InputMaybe<StringNullableFilter>;
  phoneVerified?: InputMaybe<JsonNullableFilter>;
  planToInterview2022?: InputMaybe<StringNullableFilter>;
  planToInterview2022User?: InputMaybe<StringNullableFilter>;
  portfolioPublic?: InputMaybe<BoolNullableFilter>;
  profile?: InputMaybe<UserProfileNullableCompositeFilter>;
  profileImg?: InputMaybe<JsonNullableFilter>;
  programIds?: InputMaybe<StringNullableListFilter>;
  savedScopes?: InputMaybe<SavedScopeListRelationFilter>;
  shareCode?: InputMaybe<StringNullableFilter>;
  shiftSpendGoals?: InputMaybe<ShiftSpendGoalListRelationFilter>;
  slug?: InputMaybe<Scalars['String']['input']>;
  smsOptedOut?: InputMaybe<BoolNullableFilter>;
  smsOptedOutAt?: InputMaybe<DateTimeNullableFilter>;
  sponsorLinkSharable?: InputMaybe<BoolNullableFilter>;
  sponsorName?: InputMaybe<StringNullableFilter>;
  stripeConnectId?: InputMaybe<StringNullableFilter>;
  stripeCurrentlyDue?: InputMaybe<StringNullableListFilter>;
  stripeId?: InputMaybe<StringNullableFilter>;
  stripeVerified?: InputMaybe<StringNullableFilter>;
  stripe_customer_id?: InputMaybe<StringNullableFilter>;
  studentWalletPayments?: InputMaybe<StudentWalletTransactionListRelationFilter>;
  studentWalletTransactions?: InputMaybe<StudentWalletTransactionListRelationFilter>;
  students?: InputMaybe<StudentListRelationFilter>;
  subscription_tier?: InputMaybe<StringNullableFilter>;
  timezone?: InputMaybe<StringNullableFilter>;
  token?: InputMaybe<StringNullableFilter>;
  userId?: InputMaybe<StringNullableFilter>;
  userTypes?: InputMaybe<StringNullableListFilter>;
  walletPayments?: InputMaybe<WalletTransactionListRelationFilter>;
  walletTransactions?: InputMaybe<WalletTransactionListRelationFilter>;
};

export type ValidateDocumentInput = {
  /** S3 URL of the uploaded document */
  fileUrl: Scalars['String']['input'];
  /** The document type selected by the participant */
  selectedType: Scalars['String']['input'];
  /** Descriptions for each document type to help AI understand context */
  typeDescriptions?: InputMaybe<Array<TypeDescriptionInput>>;
};

export type ValidateDocumentResponse = {
  __typename?: 'ValidateDocumentResponse';
  /** Error message if request failed */
  message?: Maybe<Scalars['String']['output']>;
  /** Whether the validation request was accepted */
  ok: Scalars['Boolean']['output'];
  /** Validation ID for status polling */
  validationId?: Maybe<Scalars['String']['output']>;
};

export type ValidateReportShareOutput = {
  __typename?: 'ValidateReportShareOutput';
  /** Allowed email domains for access (e.g., scusd.edu) */
  allowedDomains?: Maybe<Array<Scalars['String']['output']>>;
  /** Error message if invalid */
  error?: Maybe<Scalars['String']['output']>;
  /** Organization logo URL */
  organizationLogo?: Maybe<Scalars['String']['output']>;
  /** Organization name for display */
  organizationName?: Maybe<Scalars['String']['output']>;
  /** Report template description */
  reportDescription?: Maybe<Scalars['String']['output']>;
  /** Report template name */
  reportName?: Maybe<Scalars['String']['output']>;
  /** Whether password is required to continue */
  requiresPassword: Scalars['Boolean']['output'];
  /** Whether the token is valid */
  valid: Scalars['Boolean']['output'];
};

export type ValidateTemplateInput = {
  organizationId: Scalars['String']['input'];
  sampleSize?: InputMaybe<Scalars['Float']['input']>;
  templateId: Scalars['String']['input'];
};

/** Document validation status */
export enum ValidationStatus {
  Error = 'ERROR',
  Mismatch = 'MISMATCH',
  Pending = 'PENDING',
  Uncertain = 'UNCERTAIN',
  Validated = 'VALIDATED'
}

export type VerificationResponse = {
  __typename?: 'VerificationResponse';
  /** Whether email was sent (for sendVerificationCode) */
  emailSent?: Maybe<Scalars['Boolean']['output']>;
  /** Whether user was added to organization (for verifyCode) */
  joined?: Maybe<Scalars['Boolean']['output']>;
  /** Human-readable message */
  message?: Maybe<Scalars['String']['output']>;
  /** Organization ID if joined */
  organizationId?: Maybe<Scalars['String']['output']>;
  /** Organization name if joined */
  organizationName?: Maybe<Scalars['String']['output']>;
  /** Whether the operation was successful */
  success: Scalars['Boolean']['output'];
};

/** Current verification status for phone and email */
export type VerificationStatusType = {
  __typename?: 'VerificationStatusType';
  /** User email if available */
  email?: Maybe<Scalars['String']['output']>;
  /** Whether email is verified (in Auth0 or User doc) */
  emailVerified: Scalars['Boolean']['output'];
  /** User phone number if available */
  phone?: Maybe<Scalars['String']['output']>;
  /** Whether phone is verified (in Auth0 or User doc) */
  phoneVerified: Scalars['Boolean']['output'];
  /** Whether to skip email verification step */
  skipEmailVerification: Scalars['Boolean']['output'];
  /** Whether to skip phone verification step */
  skipPhoneVerification: Scalars['Boolean']['output'];
};

export type VerifyActivityEmailOtpInput = {
  /** 6-digit verification code */
  code: Scalars['String']['input'];
  /** Optional context identifier (must match the one used when sending) */
  context?: InputMaybe<Scalars['String']['input']>;
  /** Email address that received the code */
  email: Scalars['String']['input'];
};

export type VerifyActivityPhoneOtpInput = {
  /** 6-digit verification code */
  code: Scalars['String']['input'];
  /** Optional context identifier (must match the one used when sending) */
  context?: InputMaybe<Scalars['String']['input']>;
  /** Phone number that received the code (E.164 format preferred) */
  phoneNumber: Scalars['String']['input'];
};

/** Input for verifying a bank account via microdeposits or document upload */
export type VerifyBankAccountInput = {
  /** Two microdeposit amounts in cents (e.g., [32, 45] for $0.32 and $0.45). Provide this OR documentBase64, not both. */
  amounts?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Bank account ID to verify */
  bankAccountId: Scalars['String']['input'];
  /** Base64 encoded identity document for verification. Provide this OR amounts, not both. */
  documentBase64?: InputMaybe<Scalars['String']['input']>;
};

export type VerifyCodeInput = {
  /** 6-digit verification code */
  code: Scalars['String']['input'];
  /** Email address that received the code */
  email: Scalars['String']['input'];
  /** Organization ID to join */
  organizationId: Scalars['String']['input'];
};

/** Input for verifying email OTP code */
export type VerifyEmailInput = {
  /** 6-digit OTP code */
  code: Scalars['String']['input'];
};

export type VerifyJwtInput = {
  /** JWT token to verify */
  token: Scalars['String']['input'];
};

export type VerifyJwtResponse = {
  __typename?: 'VerifyJwtResponse';
  /** Response message */
  message?: Maybe<Scalars['String']['output']>;
  /** Whether the JWT verification was successful */
  success: Scalars['Boolean']['output'];
  /** User information if verification successful */
  user?: Maybe<AuthUserOutput>;
};

export type VerifyOtpInput = {
  /** The OTP code received by the user */
  otpCode: Scalars['String']['input'];
  /** The type of OTP verification (EMAIL or PHONE) */
  otpType: OtpVerificationType;
  /** Phone number for PHONE OTP verification */
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  /** Username, typically email or phone number used to receive the OTP */
  username: Scalars['String']['input'];
};

/** Input for verifying phone OTP code */
export type VerifyPhoneInput = {
  /** 6-digit OTP code */
  code: Scalars['String']['input'];
};

export type VerifyReportAccessOutput = {
  __typename?: 'VerifyReportAccessOutput';
  /** Access record ID for downloading */
  accessId?: Maybe<Scalars['String']['output']>;
  /** Error message if failed */
  error?: Maybe<Scalars['String']['output']>;
  /** Whether verification succeeded */
  success: Scalars['Boolean']['output'];
};

export type VideoAskAnswer = {
  __typename?: 'VideoAskAnswer';
  answerId?: Maybe<Scalars['String']['output']>;
  mediaUrl?: Maybe<Scalars['String']['output']>;
  questionId?: Maybe<Scalars['String']['output']>;
  transcription?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type VideoAskContactInfo = {
  __typename?: 'VideoAskContactInfo';
  answers?: Maybe<Array<VideoAskAnswer>>;
  contactId?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  shareUrl?: Maybe<Scalars['String']['output']>;
};

export type VideoAskOperationResult = {
  __typename?: 'VideoAskOperationResult';
  message: Scalars['String']['output'];
  studentId?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type VideoAskStatusResult = {
  __typename?: 'VideoAskStatusResult';
  completedAt?: Maybe<Scalars['String']['output']>;
  hasResponse: Scalars['Boolean']['output'];
  shareUrl?: Maybe<Scalars['String']['output']>;
};

export type WalletAvgAggregate = {
  __typename?: 'WalletAvgAggregate';
  balance?: Maybe<Scalars['Float']['output']>;
};

/** Wallet balance showing available, pending, and transferred funds */
export type WalletBalance = {
  __typename?: 'WalletBalance';
  /** Available balance (pending transfer) in dollars - ready for withdrawal */
  available: Scalars['Float']['output'];
  /** When balance was calculated */
  calculatedAt: Scalars['DateTime']['output'];
  /** Currency code */
  currency: Scalars['String']['output'];
  /** Pending balance (transfer in progress) in dollars - withdrawal initiated */
  pending: Scalars['Float']['output'];
  /** Total balance (available + pending + transferred) in dollars */
  total: Scalars['Float']['output'];
  /** Transferred balance (completed transfers) in dollars - historical total */
  transferred: Scalars['Float']['output'];
};

/** Input for querying wallet balance (optional user ID for admin) */
export type WalletBalanceInput = {
  /** User ID to query balance for (admin only, uses authenticated user if not provided) */
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type WalletCountAggregate = {
  __typename?: 'WalletCountAggregate';
  _all: Scalars['Int']['output'];
  balance: Scalars['Int']['output'];
  created_at: Scalars['Int']['output'];
  customer_id: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  ownerId: Scalars['Int']['output'];
  type: Scalars['Int']['output'];
  updated_at: Scalars['Int']['output'];
};

export type WalletLog = {
  __typename?: 'WalletLog';
  date?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  event?: Maybe<Scalars['String']['output']>;
  recipientId?: Maybe<Scalars['String']['output']>;
  senderId?: Maybe<Scalars['String']['output']>;
  stripeEventId?: Maybe<Scalars['String']['output']>;
  timestamp?: Maybe<Scalars['Float']['output']>;
  tokens: Scalars['Int']['output'];
  transactionId?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
  user_id?: Maybe<Scalars['String']['output']>;
};

export type WalletMaxAggregate = {
  __typename?: 'WalletMaxAggregate';
  balance?: Maybe<Scalars['Int']['output']>;
  created_at?: Maybe<Scalars['DateTime']['output']>;
  customer_id?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  ownerId?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['DateTime']['output']>;
};

export type WalletMinAggregate = {
  __typename?: 'WalletMinAggregate';
  balance?: Maybe<Scalars['Int']['output']>;
  created_at?: Maybe<Scalars['DateTime']['output']>;
  customer_id?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  ownerId?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['DateTime']['output']>;
};

/** Pagination options for wallet transactions query */
export type WalletPaginationInput = {
  /** Cursor to start after (for forward pagination) */
  after?: InputMaybe<Scalars['String']['input']>;
  /** Cursor to start before (for backward pagination) */
  before?: InputMaybe<Scalars['String']['input']>;
  /** Number of items to return (default: 20, max: 100) */
  first?: InputMaybe<Scalars['Int']['input']>;
  /** Number of items to return before cursor (for backward pagination) */
  last?: InputMaybe<Scalars['Int']['input']>;
};

/** Response from creating a wallet payment checkout session */
export type WalletPaymentCheckoutResponse = {
  __typename?: 'WalletPaymentCheckoutResponse';
  /** Stripe Checkout URL to redirect user to */
  checkoutUrl: Scalars['String']['output'];
  /** Stripe Checkout Session ID for tracking */
  sessionId: Scalars['String']['output'];
};

/** Response from creating a wallet payment intent for embedded card forms */
export type WalletPaymentIntentResponse = {
  __typename?: 'WalletPaymentIntentResponse';
  /** Stripe PaymentIntent client secret for frontend stripe.confirmPayment() */
  clientSecret: Scalars['String']['output'];
  /** Stripe PaymentIntent ID for tracking and confirmation */
  paymentIntentId: Scalars['String']['output'];
};

export enum WalletPaymentType {
  /**
   * Chargeback debt entry - negative amount from lost dispute
   * Use case: Cardholder disputes charge and wins, user owes money back
   * Can result in negative wallet balance (debt to be offset by future payments)
   */
  Chargeback = 'chargeback',
  /**
   * Full refund entry - creates negative amount to offset original payment
   * Use case: Payer requests refund, original transaction reversed
   * Creates a negative ledger entry (append-only pattern)
   */
  Refund = 'refund',
  /**
   * Sponsorship payment - student receives 100% (no platform fee)
   * Use case: User/organizer sponsors a student's work in a program
   * - Sponsor pays student for project contributions
   * - Organizer compensates student for completed milestones
   * Money flows TO the student (sponsoring their work), no platform fee.
   */
  Sponsorship = 'sponsorship',
  /**
   * Student payment - organizer receives 90% (10% platform fee)
   * Use case: Student pays to join/enroll in a program
   * - Student pays for program access
   * - Student pays enrollment fee
   * Money flows TO the organizer (program monetization), PilotCity takes 10% cut.
   */
  StudentPayment = 'student_payment'
}

export type WalletSumAggregate = {
  __typename?: 'WalletSumAggregate';
  balance?: Maybe<Scalars['Int']['output']>;
};

export type WalletTransaction = {
  __typename?: 'WalletTransaction';
  /**
   * Gross amount in CENTS (integer) - NOT dollars
   * Positive: Money coming in (payment received)
   * Negative: Money going out (refund, chargeback)
   * Example: 10000 for $100.00 sponsorship
   */
  amount: Scalars['Float']['output'];
  /**
   * Stripe Checkout Session ID that created this payment
   * Example: 'cs_test_a1b2c3d4e5...'
   */
  checkout_session_id?: Maybe<Scalars['String']['output']>;
  created_at: Scalars['DateTime']['output'];
  /**
   * Human-readable description for transaction history
   * Example: 'Sponsorship for John Doe - Web Development Bootcamp'
   */
  description?: Maybe<Scalars['String']['output']>;
  /**
   * Stripe Dispute ID if payment was disputed
   * Example: 'dp_3MtwBwLkdIwHu7ix28a3tqPc'
   */
  dispute_id?: Maybe<Scalars['String']['output']>;
  /**
   * Human-readable DateTime when funds become available for withdrawal
   * Derived from stripe_available_on: new Date(stripe_available_on * 1000)
   * Null means funds are immediately available (legacy transactions or instant settlement)
   */
  funds_available_at?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  /**
   * Name of the legacy collection this record was migrated from
   * Values: 'StudentTransaction' or 'StudentWalletTransaction'
   * Null for records created directly in the unified system
   */
  legacy_collection?: Maybe<Scalars['String']['output']>;
  /**
   * Original record ID from the legacy collection
   * Used for audit trail, rollback capability, and deduplication
   * Null for records created directly in the unified system
   */
  legacy_id?: Maybe<Scalars['String']['output']>;
  /**
   * Net amount after fee in CENTS - this is what affects user's balance
   * Formula: amount - platform_fee (or just amount if no fee)
   * Example: 10000 for $100.00 sponsorship (no fee, net = gross)
   * Balance is calculated from SUM(net_amount)
   */
  net_amount: Scalars['Float']['output'];
  /**
   * Links negative entry back to original payment
   * Used for refunds and chargebacks to trace audit trail
   */
  original_transaction_id?: Maybe<Scalars['String']['output']>;
  /**
   * Stripe PaymentIntent ID - primary idempotency key for webhooks
   * Example: 'pi_3MtwBwLkdIwHu7ix28a3tqPa'
   */
  payment_intent_id?: Maybe<Scalars['String']['output']>;
  /**
   * Type of payment - determines fee structure and UI categorization
   * sponsorship = 0% fee (to student), student_payment = 10% fee (to organizer)
   * refund/chargeback = negative entries that reduce balance
   */
  payment_type: WalletPaymentType;
  /**
   * Platform fee in CENTS (10% for student_payment, null for others)
   * Example: 1000 for 10% fee on $100.00 student payment (10000 cents)
   * Null for sponsorship (0% fee), refund, chargeback
   */
  platform_fee?: Maybe<Scalars['Float']['output']>;
  program: Program;
  /**
   * Program context - payment is associated with this program
   * Used for validation, analytics, and transaction history display
   */
  program_id: Scalars['String']['output'];
  source_user: User;
  /**
   * Who made the payment (payer) - for audit trail and receipts
   * Example: Sponsor who paid, or organizer who paid a student
   */
  source_user_id: Scalars['String']['output'];
  /**
   * Payment health status - did the money come through?
   * Uses existing TransactionStatus enum for compatibility
   * completed -> disputed -> refunded/chargeback_debt
   */
  status: TransactionStatus;
  /**
   * Unix timestamp when Stripe will have funds available for transfer
   * Captured from charge.balance_transaction.available_on in webhook
   * Used to determine if funds are truly withdrawable vs still processing
   */
  stripe_available_on?: Maybe<Scalars['Int']['output']>;
  /**
   * Error message from Stripe when transfer fails
   * Captured from transfer.failure_message in webhook
   * Displayed to user in UI with retry option
   */
  transfer_error?: Maybe<Scalars['String']['output']>;
  /**
   * Timestamp when transfer to Express account failed
   * Set by transfer.failed or transfer.reversed webhook handlers
   * Null for successful or pending transfers
   */
  transfer_failed_at?: Maybe<Scalars['DateTime']['output']>;
  /**
   * Stripe Transfer ID when funds withdrawn to user's bank
   * Example: 'tr_3MtwBwLkdIwHu7ix28a3tqPb'
   * Only set after successful withdrawal (transfer_status='transferred')
   */
  transfer_id?: Maybe<Scalars['String']['output']>;
  /**
   * Withdrawal state - is this money still available?
   * pending = in wallet, available for withdrawal
   * transferring = locked, transfer in progress
   * transferred = successfully sent to user's bank
   */
  transfer_status: TransferStatus;
  transferred_at?: Maybe<Scalars['DateTime']['output']>;
  updated_at: Scalars['DateTime']['output'];
  user: User;
  /**
   * Wallet owner (recipient) - the user whose balance is affected
   * This is the key field for balance calculation: SUM WHERE user_id = X
   */
  user_id: Scalars['String']['output'];
};

export type WalletTransactionAvgAggregate = {
  __typename?: 'WalletTransactionAvgAggregate';
  amount?: Maybe<Scalars['Float']['output']>;
  net_amount?: Maybe<Scalars['Float']['output']>;
  platform_fee?: Maybe<Scalars['Float']['output']>;
  stripe_available_on?: Maybe<Scalars['Float']['output']>;
};

/** Paginated list of wallet transactions */
export type WalletTransactionConnection = {
  __typename?: 'WalletTransactionConnection';
  /** List of transaction edges */
  edges: Array<WalletTransactionEdge>;
  /** Pagination information */
  pageInfo: WalletTransactionPageInfo;
  /** Total count of transactions matching the filter */
  totalCount: Scalars['Int']['output'];
};

export type WalletTransactionCountAggregate = {
  __typename?: 'WalletTransactionCountAggregate';
  _all: Scalars['Int']['output'];
  amount: Scalars['Int']['output'];
  checkout_session_id: Scalars['Int']['output'];
  created_at: Scalars['Int']['output'];
  description: Scalars['Int']['output'];
  dispute_id: Scalars['Int']['output'];
  funds_available_at: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  legacy_collection: Scalars['Int']['output'];
  legacy_id: Scalars['Int']['output'];
  net_amount: Scalars['Int']['output'];
  original_transaction_id: Scalars['Int']['output'];
  payment_intent_id: Scalars['Int']['output'];
  payment_type: Scalars['Int']['output'];
  platform_fee: Scalars['Int']['output'];
  program_id: Scalars['Int']['output'];
  source_user_id: Scalars['Int']['output'];
  status: Scalars['Int']['output'];
  stripe_available_on: Scalars['Int']['output'];
  transfer_error: Scalars['Int']['output'];
  transfer_failed_at: Scalars['Int']['output'];
  transfer_id: Scalars['Int']['output'];
  transfer_status: Scalars['Int']['output'];
  transferred_at: Scalars['Int']['output'];
  updated_at: Scalars['Int']['output'];
  user_id: Scalars['Int']['output'];
};

export type WalletTransactionCreateManyProgramInput = {
  amount: Scalars['Float']['input'];
  checkout_session_id?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  dispute_id?: InputMaybe<Scalars['String']['input']>;
  funds_available_at?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  legacy_collection?: InputMaybe<Scalars['String']['input']>;
  legacy_id?: InputMaybe<Scalars['String']['input']>;
  net_amount: Scalars['Float']['input'];
  original_transaction_id?: InputMaybe<Scalars['String']['input']>;
  payment_intent_id?: InputMaybe<Scalars['String']['input']>;
  payment_type: WalletPaymentType;
  platform_fee?: InputMaybe<Scalars['Float']['input']>;
  source_user_id: Scalars['String']['input'];
  status?: InputMaybe<TransactionStatus>;
  stripe_available_on?: InputMaybe<Scalars['Int']['input']>;
  transfer_error?: InputMaybe<Scalars['String']['input']>;
  transfer_failed_at?: InputMaybe<Scalars['DateTime']['input']>;
  transfer_id?: InputMaybe<Scalars['String']['input']>;
  transfer_status?: InputMaybe<TransferStatus>;
  transferred_at?: InputMaybe<Scalars['DateTime']['input']>;
  updated_at?: InputMaybe<Scalars['DateTime']['input']>;
  user_id: Scalars['String']['input'];
};

export type WalletTransactionCreateManyProgramInputEnvelope = {
  data: Array<WalletTransactionCreateManyProgramInput>;
};

export type WalletTransactionCreateManySource_UserInput = {
  amount: Scalars['Float']['input'];
  checkout_session_id?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  dispute_id?: InputMaybe<Scalars['String']['input']>;
  funds_available_at?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  legacy_collection?: InputMaybe<Scalars['String']['input']>;
  legacy_id?: InputMaybe<Scalars['String']['input']>;
  net_amount: Scalars['Float']['input'];
  original_transaction_id?: InputMaybe<Scalars['String']['input']>;
  payment_intent_id?: InputMaybe<Scalars['String']['input']>;
  payment_type: WalletPaymentType;
  platform_fee?: InputMaybe<Scalars['Float']['input']>;
  program_id: Scalars['String']['input'];
  status?: InputMaybe<TransactionStatus>;
  stripe_available_on?: InputMaybe<Scalars['Int']['input']>;
  transfer_error?: InputMaybe<Scalars['String']['input']>;
  transfer_failed_at?: InputMaybe<Scalars['DateTime']['input']>;
  transfer_id?: InputMaybe<Scalars['String']['input']>;
  transfer_status?: InputMaybe<TransferStatus>;
  transferred_at?: InputMaybe<Scalars['DateTime']['input']>;
  updated_at?: InputMaybe<Scalars['DateTime']['input']>;
  user_id: Scalars['String']['input'];
};

export type WalletTransactionCreateManySource_UserInputEnvelope = {
  data: Array<WalletTransactionCreateManySource_UserInput>;
};

export type WalletTransactionCreateManyUserInput = {
  amount: Scalars['Float']['input'];
  checkout_session_id?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  dispute_id?: InputMaybe<Scalars['String']['input']>;
  funds_available_at?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  legacy_collection?: InputMaybe<Scalars['String']['input']>;
  legacy_id?: InputMaybe<Scalars['String']['input']>;
  net_amount: Scalars['Float']['input'];
  original_transaction_id?: InputMaybe<Scalars['String']['input']>;
  payment_intent_id?: InputMaybe<Scalars['String']['input']>;
  payment_type: WalletPaymentType;
  platform_fee?: InputMaybe<Scalars['Float']['input']>;
  program_id: Scalars['String']['input'];
  source_user_id: Scalars['String']['input'];
  status?: InputMaybe<TransactionStatus>;
  stripe_available_on?: InputMaybe<Scalars['Int']['input']>;
  transfer_error?: InputMaybe<Scalars['String']['input']>;
  transfer_failed_at?: InputMaybe<Scalars['DateTime']['input']>;
  transfer_id?: InputMaybe<Scalars['String']['input']>;
  transfer_status?: InputMaybe<TransferStatus>;
  transferred_at?: InputMaybe<Scalars['DateTime']['input']>;
  updated_at?: InputMaybe<Scalars['DateTime']['input']>;
};

export type WalletTransactionCreateManyUserInputEnvelope = {
  data: Array<WalletTransactionCreateManyUserInput>;
};

export type WalletTransactionCreateNestedManyWithoutProgramInput = {
  connect?: InputMaybe<Array<WalletTransactionWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<WalletTransactionCreateOrConnectWithoutProgramInput>>;
  create?: InputMaybe<Array<WalletTransactionCreateWithoutProgramInput>>;
  createMany?: InputMaybe<WalletTransactionCreateManyProgramInputEnvelope>;
};

export type WalletTransactionCreateNestedManyWithoutSource_UserInput = {
  connect?: InputMaybe<Array<WalletTransactionWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<WalletTransactionCreateOrConnectWithoutSource_UserInput>>;
  create?: InputMaybe<Array<WalletTransactionCreateWithoutSource_UserInput>>;
  createMany?: InputMaybe<WalletTransactionCreateManySource_UserInputEnvelope>;
};

export type WalletTransactionCreateNestedManyWithoutUserInput = {
  connect?: InputMaybe<Array<WalletTransactionWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<WalletTransactionCreateOrConnectWithoutUserInput>>;
  create?: InputMaybe<Array<WalletTransactionCreateWithoutUserInput>>;
  createMany?: InputMaybe<WalletTransactionCreateManyUserInputEnvelope>;
};

export type WalletTransactionCreateOrConnectWithoutProgramInput = {
  create: WalletTransactionCreateWithoutProgramInput;
  where: WalletTransactionWhereUniqueInput;
};

export type WalletTransactionCreateOrConnectWithoutSource_UserInput = {
  create: WalletTransactionCreateWithoutSource_UserInput;
  where: WalletTransactionWhereUniqueInput;
};

export type WalletTransactionCreateOrConnectWithoutUserInput = {
  create: WalletTransactionCreateWithoutUserInput;
  where: WalletTransactionWhereUniqueInput;
};

export type WalletTransactionCreateWithoutProgramInput = {
  amount: Scalars['Float']['input'];
  checkout_session_id?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  dispute_id?: InputMaybe<Scalars['String']['input']>;
  funds_available_at?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  legacy_collection?: InputMaybe<Scalars['String']['input']>;
  legacy_id?: InputMaybe<Scalars['String']['input']>;
  net_amount: Scalars['Float']['input'];
  original_transaction_id?: InputMaybe<Scalars['String']['input']>;
  payment_intent_id?: InputMaybe<Scalars['String']['input']>;
  payment_type: WalletPaymentType;
  platform_fee?: InputMaybe<Scalars['Float']['input']>;
  source_user: UserCreateNestedOneWithoutWalletPaymentsInput;
  status?: InputMaybe<TransactionStatus>;
  stripe_available_on?: InputMaybe<Scalars['Int']['input']>;
  transfer_error?: InputMaybe<Scalars['String']['input']>;
  transfer_failed_at?: InputMaybe<Scalars['DateTime']['input']>;
  transfer_id?: InputMaybe<Scalars['String']['input']>;
  transfer_status?: InputMaybe<TransferStatus>;
  transferred_at?: InputMaybe<Scalars['DateTime']['input']>;
  updated_at?: InputMaybe<Scalars['DateTime']['input']>;
  user: UserCreateNestedOneWithoutWalletTransactionsInput;
};

export type WalletTransactionCreateWithoutSource_UserInput = {
  amount: Scalars['Float']['input'];
  checkout_session_id?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  dispute_id?: InputMaybe<Scalars['String']['input']>;
  funds_available_at?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  legacy_collection?: InputMaybe<Scalars['String']['input']>;
  legacy_id?: InputMaybe<Scalars['String']['input']>;
  net_amount: Scalars['Float']['input'];
  original_transaction_id?: InputMaybe<Scalars['String']['input']>;
  payment_intent_id?: InputMaybe<Scalars['String']['input']>;
  payment_type: WalletPaymentType;
  platform_fee?: InputMaybe<Scalars['Float']['input']>;
  program: ProgramCreateNestedOneWithoutWalletTransactionsInput;
  status?: InputMaybe<TransactionStatus>;
  stripe_available_on?: InputMaybe<Scalars['Int']['input']>;
  transfer_error?: InputMaybe<Scalars['String']['input']>;
  transfer_failed_at?: InputMaybe<Scalars['DateTime']['input']>;
  transfer_id?: InputMaybe<Scalars['String']['input']>;
  transfer_status?: InputMaybe<TransferStatus>;
  transferred_at?: InputMaybe<Scalars['DateTime']['input']>;
  updated_at?: InputMaybe<Scalars['DateTime']['input']>;
  user: UserCreateNestedOneWithoutWalletTransactionsInput;
};

export type WalletTransactionCreateWithoutUserInput = {
  amount: Scalars['Float']['input'];
  checkout_session_id?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  dispute_id?: InputMaybe<Scalars['String']['input']>;
  funds_available_at?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  legacy_collection?: InputMaybe<Scalars['String']['input']>;
  legacy_id?: InputMaybe<Scalars['String']['input']>;
  net_amount: Scalars['Float']['input'];
  original_transaction_id?: InputMaybe<Scalars['String']['input']>;
  payment_intent_id?: InputMaybe<Scalars['String']['input']>;
  payment_type: WalletPaymentType;
  platform_fee?: InputMaybe<Scalars['Float']['input']>;
  program: ProgramCreateNestedOneWithoutWalletTransactionsInput;
  source_user: UserCreateNestedOneWithoutWalletPaymentsInput;
  status?: InputMaybe<TransactionStatus>;
  stripe_available_on?: InputMaybe<Scalars['Int']['input']>;
  transfer_error?: InputMaybe<Scalars['String']['input']>;
  transfer_failed_at?: InputMaybe<Scalars['DateTime']['input']>;
  transfer_id?: InputMaybe<Scalars['String']['input']>;
  transfer_status?: InputMaybe<TransferStatus>;
  transferred_at?: InputMaybe<Scalars['DateTime']['input']>;
  updated_at?: InputMaybe<Scalars['DateTime']['input']>;
};

/** Edge containing a wallet transaction and its cursor */
export type WalletTransactionEdge = {
  __typename?: 'WalletTransactionEdge';
  /** Cursor for this item (used for pagination) */
  cursor: Scalars['String']['output'];
  /** The wallet transaction */
  node: WalletTransactionType;
};

/** Filter options for wallet transactions query */
export type WalletTransactionFilterInput = {
  /** When true, queries transactions where user is the source (payer) instead of recipient */
  asSource?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter transactions created on or after this date */
  fromDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** Filter by single payment type (deprecated, use paymentTypes for array filter) */
  paymentType?: InputMaybe<WalletPaymentType>;
  /** Filter by multiple payment types (OR logic - matches ANY type in array) */
  paymentTypes?: InputMaybe<Array<WalletPaymentType>>;
  /** Filter by transaction status (completed, disputed, refunded, etc.) */
  status?: InputMaybe<TransactionStatus>;
  /** Filter transactions created on or before this date */
  toDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** Filter by transfer status (pending, transferring, transferred) */
  transferStatus?: InputMaybe<TransferStatus>;
};

export type WalletTransactionListRelationFilter = {
  every?: InputMaybe<WalletTransactionWhereInput>;
  none?: InputMaybe<WalletTransactionWhereInput>;
  some?: InputMaybe<WalletTransactionWhereInput>;
};

export type WalletTransactionMaxAggregate = {
  __typename?: 'WalletTransactionMaxAggregate';
  amount?: Maybe<Scalars['Float']['output']>;
  checkout_session_id?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  dispute_id?: Maybe<Scalars['String']['output']>;
  funds_available_at?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  legacy_collection?: Maybe<Scalars['String']['output']>;
  legacy_id?: Maybe<Scalars['String']['output']>;
  net_amount?: Maybe<Scalars['Float']['output']>;
  original_transaction_id?: Maybe<Scalars['String']['output']>;
  payment_intent_id?: Maybe<Scalars['String']['output']>;
  payment_type?: Maybe<WalletPaymentType>;
  platform_fee?: Maybe<Scalars['Float']['output']>;
  program_id?: Maybe<Scalars['String']['output']>;
  source_user_id?: Maybe<Scalars['String']['output']>;
  status?: Maybe<TransactionStatus>;
  stripe_available_on?: Maybe<Scalars['Int']['output']>;
  transfer_error?: Maybe<Scalars['String']['output']>;
  transfer_failed_at?: Maybe<Scalars['DateTime']['output']>;
  transfer_id?: Maybe<Scalars['String']['output']>;
  transfer_status?: Maybe<TransferStatus>;
  transferred_at?: Maybe<Scalars['DateTime']['output']>;
  updated_at?: Maybe<Scalars['DateTime']['output']>;
  user_id?: Maybe<Scalars['String']['output']>;
};

export type WalletTransactionMinAggregate = {
  __typename?: 'WalletTransactionMinAggregate';
  amount?: Maybe<Scalars['Float']['output']>;
  checkout_session_id?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  dispute_id?: Maybe<Scalars['String']['output']>;
  funds_available_at?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  legacy_collection?: Maybe<Scalars['String']['output']>;
  legacy_id?: Maybe<Scalars['String']['output']>;
  net_amount?: Maybe<Scalars['Float']['output']>;
  original_transaction_id?: Maybe<Scalars['String']['output']>;
  payment_intent_id?: Maybe<Scalars['String']['output']>;
  payment_type?: Maybe<WalletPaymentType>;
  platform_fee?: Maybe<Scalars['Float']['output']>;
  program_id?: Maybe<Scalars['String']['output']>;
  source_user_id?: Maybe<Scalars['String']['output']>;
  status?: Maybe<TransactionStatus>;
  stripe_available_on?: Maybe<Scalars['Int']['output']>;
  transfer_error?: Maybe<Scalars['String']['output']>;
  transfer_failed_at?: Maybe<Scalars['DateTime']['output']>;
  transfer_id?: Maybe<Scalars['String']['output']>;
  transfer_status?: Maybe<TransferStatus>;
  transferred_at?: Maybe<Scalars['DateTime']['output']>;
  updated_at?: Maybe<Scalars['DateTime']['output']>;
  user_id?: Maybe<Scalars['String']['output']>;
};

/** Pagination information for wallet transaction list */
export type WalletTransactionPageInfo = {
  __typename?: 'WalletTransactionPageInfo';
  /** Cursor for the last item in this page */
  endCursor?: Maybe<Scalars['String']['output']>;
  /** Whether there are more results after this page */
  hasNextPage: Scalars['Boolean']['output'];
  /** Whether there are results before this page */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** Cursor for the first item in this page */
  startCursor?: Maybe<Scalars['String']['output']>;
};

export type WalletTransactionScalarWhereInput = {
  AND?: InputMaybe<Array<WalletTransactionScalarWhereInput>>;
  NOT?: InputMaybe<Array<WalletTransactionScalarWhereInput>>;
  OR?: InputMaybe<Array<WalletTransactionScalarWhereInput>>;
  amount?: InputMaybe<FloatFilter>;
  checkout_session_id?: InputMaybe<StringNullableFilter>;
  created_at?: InputMaybe<DateTimeFilter>;
  description?: InputMaybe<StringNullableFilter>;
  dispute_id?: InputMaybe<StringNullableFilter>;
  funds_available_at?: InputMaybe<DateTimeNullableFilter>;
  id?: InputMaybe<StringFilter>;
  legacy_collection?: InputMaybe<StringNullableFilter>;
  legacy_id?: InputMaybe<StringNullableFilter>;
  net_amount?: InputMaybe<FloatFilter>;
  original_transaction_id?: InputMaybe<StringNullableFilter>;
  payment_intent_id?: InputMaybe<StringNullableFilter>;
  payment_type?: InputMaybe<EnumWalletPaymentTypeFilter>;
  platform_fee?: InputMaybe<FloatNullableFilter>;
  program_id?: InputMaybe<StringFilter>;
  source_user_id?: InputMaybe<StringFilter>;
  status?: InputMaybe<EnumTransactionStatusFilter>;
  stripe_available_on?: InputMaybe<IntNullableFilter>;
  transfer_error?: InputMaybe<StringNullableFilter>;
  transfer_failed_at?: InputMaybe<DateTimeNullableFilter>;
  transfer_id?: InputMaybe<StringNullableFilter>;
  transfer_status?: InputMaybe<EnumTransferStatusFilter>;
  transferred_at?: InputMaybe<DateTimeNullableFilter>;
  updated_at?: InputMaybe<DateTimeFilter>;
  user_id?: InputMaybe<StringFilter>;
};

export type WalletTransactionSumAggregate = {
  __typename?: 'WalletTransactionSumAggregate';
  amount?: Maybe<Scalars['Float']['output']>;
  net_amount?: Maybe<Scalars['Float']['output']>;
  platform_fee?: Maybe<Scalars['Float']['output']>;
  stripe_available_on?: Maybe<Scalars['Int']['output']>;
};

/** A transaction in the unified wallet */
export type WalletTransactionType = {
  __typename?: 'WalletTransactionType';
  /** Gross amount in cents (positive for credits, negative for refunds/chargebacks) */
  amount: Scalars['Float']['output'];
  /** Stripe Checkout Session ID */
  checkout_session_id?: Maybe<Scalars['String']['output']>;
  /** When this transaction was created */
  created_at: Scalars['DateTime']['output'];
  /** Human-readable payment description */
  description?: Maybe<Scalars['String']['output']>;
  /** Stripe Dispute ID (if disputed) */
  dispute_id?: Maybe<Scalars['String']['output']>;
  /** True if funds have settled with Stripe and are available for withdrawal. False if funds_available_at is in the future (still processing). */
  fundsSettled: Scalars['Boolean']['output'];
  /** When funds will be available for withdrawal (from Stripe settlement) */
  funds_available_at?: Maybe<Scalars['DateTime']['output']>;
  /** Unique transaction identifier */
  id: Scalars['ID']['output'];
  /** Net amount in cents after fee - affects balance calculation */
  net_amount: Scalars['Float']['output'];
  /** Original transaction ID for refund/chargeback entries */
  original_transaction_id?: Maybe<Scalars['String']['output']>;
  /** Stripe PaymentIntent ID */
  payment_intent_id?: Maybe<Scalars['String']['output']>;
  /** Type of payment: sponsorship (0% fee - money TO students), student_payment (10% fee - money TO organizers), refund, chargeback */
  payment_type: WalletPaymentType;
  /** Platform fee in cents (10% for student_payment, null for sponsorship/refund/chargeback) */
  platform_fee?: Maybe<Scalars['Float']['output']>;
  /** Program ID the payment is associated with */
  program_id: Scalars['String']['output'];
  /** User ID who made the payment (payer) */
  source_user_id: Scalars['String']['output'];
  /** Transaction status (payment health) */
  status: TransactionStatus;
  /** Error message from Stripe when transfer fails (for user display and retry) */
  transfer_error?: Maybe<Scalars['String']['output']>;
  /** When the transfer to Express account failed (set by transfer.failed/transfer.reversed webhooks) */
  transfer_failed_at?: Maybe<Scalars['DateTime']['output']>;
  /** Stripe Transfer ID (set after withdrawal) */
  transfer_id?: Maybe<Scalars['String']['output']>;
  /** Transfer status (withdrawal state) */
  transfer_status: TransferStatus;
  /** When funds were transferred to bank */
  transferred_at?: Maybe<Scalars['DateTime']['output']>;
  /** When this transaction was last updated */
  updated_at: Scalars['DateTime']['output'];
  /** User ID who owns this wallet entry (recipient) */
  user_id: Scalars['String']['output'];
};

export type WalletTransactionUpdateManyMutationInput = {
  amount?: InputMaybe<FloatFieldUpdateOperationsInput>;
  checkout_session_id?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  created_at?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  dispute_id?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  funds_available_at?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  legacy_collection?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  legacy_id?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  net_amount?: InputMaybe<FloatFieldUpdateOperationsInput>;
  original_transaction_id?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payment_intent_id?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payment_type?: InputMaybe<EnumWalletPaymentTypeFieldUpdateOperationsInput>;
  platform_fee?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumTransactionStatusFieldUpdateOperationsInput>;
  stripe_available_on?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  transfer_error?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  transfer_failed_at?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  transfer_id?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  transfer_status?: InputMaybe<EnumTransferStatusFieldUpdateOperationsInput>;
  transferred_at?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  updated_at?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type WalletTransactionUpdateManyWithWhereWithoutProgramInput = {
  data: WalletTransactionUpdateManyMutationInput;
  where: WalletTransactionScalarWhereInput;
};

export type WalletTransactionUpdateManyWithWhereWithoutSource_UserInput = {
  data: WalletTransactionUpdateManyMutationInput;
  where: WalletTransactionScalarWhereInput;
};

export type WalletTransactionUpdateManyWithWhereWithoutUserInput = {
  data: WalletTransactionUpdateManyMutationInput;
  where: WalletTransactionScalarWhereInput;
};

export type WalletTransactionUpdateManyWithoutProgramNestedInput = {
  connect?: InputMaybe<Array<WalletTransactionWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<WalletTransactionCreateOrConnectWithoutProgramInput>>;
  create?: InputMaybe<Array<WalletTransactionCreateWithoutProgramInput>>;
  createMany?: InputMaybe<WalletTransactionCreateManyProgramInputEnvelope>;
  delete?: InputMaybe<Array<WalletTransactionWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<WalletTransactionScalarWhereInput>>;
  disconnect?: InputMaybe<Array<WalletTransactionWhereUniqueInput>>;
  set?: InputMaybe<Array<WalletTransactionWhereUniqueInput>>;
  update?: InputMaybe<Array<WalletTransactionUpdateWithWhereUniqueWithoutProgramInput>>;
  updateMany?: InputMaybe<Array<WalletTransactionUpdateManyWithWhereWithoutProgramInput>>;
  upsert?: InputMaybe<Array<WalletTransactionUpsertWithWhereUniqueWithoutProgramInput>>;
};

export type WalletTransactionUpdateManyWithoutSource_UserNestedInput = {
  connect?: InputMaybe<Array<WalletTransactionWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<WalletTransactionCreateOrConnectWithoutSource_UserInput>>;
  create?: InputMaybe<Array<WalletTransactionCreateWithoutSource_UserInput>>;
  createMany?: InputMaybe<WalletTransactionCreateManySource_UserInputEnvelope>;
  delete?: InputMaybe<Array<WalletTransactionWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<WalletTransactionScalarWhereInput>>;
  disconnect?: InputMaybe<Array<WalletTransactionWhereUniqueInput>>;
  set?: InputMaybe<Array<WalletTransactionWhereUniqueInput>>;
  update?: InputMaybe<Array<WalletTransactionUpdateWithWhereUniqueWithoutSource_UserInput>>;
  updateMany?: InputMaybe<Array<WalletTransactionUpdateManyWithWhereWithoutSource_UserInput>>;
  upsert?: InputMaybe<Array<WalletTransactionUpsertWithWhereUniqueWithoutSource_UserInput>>;
};

export type WalletTransactionUpdateManyWithoutUserNestedInput = {
  connect?: InputMaybe<Array<WalletTransactionWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<WalletTransactionCreateOrConnectWithoutUserInput>>;
  create?: InputMaybe<Array<WalletTransactionCreateWithoutUserInput>>;
  createMany?: InputMaybe<WalletTransactionCreateManyUserInputEnvelope>;
  delete?: InputMaybe<Array<WalletTransactionWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<WalletTransactionScalarWhereInput>>;
  disconnect?: InputMaybe<Array<WalletTransactionWhereUniqueInput>>;
  set?: InputMaybe<Array<WalletTransactionWhereUniqueInput>>;
  update?: InputMaybe<Array<WalletTransactionUpdateWithWhereUniqueWithoutUserInput>>;
  updateMany?: InputMaybe<Array<WalletTransactionUpdateManyWithWhereWithoutUserInput>>;
  upsert?: InputMaybe<Array<WalletTransactionUpsertWithWhereUniqueWithoutUserInput>>;
};

export type WalletTransactionUpdateWithWhereUniqueWithoutProgramInput = {
  data: WalletTransactionUpdateWithoutProgramInput;
  where: WalletTransactionWhereUniqueInput;
};

export type WalletTransactionUpdateWithWhereUniqueWithoutSource_UserInput = {
  data: WalletTransactionUpdateWithoutSource_UserInput;
  where: WalletTransactionWhereUniqueInput;
};

export type WalletTransactionUpdateWithWhereUniqueWithoutUserInput = {
  data: WalletTransactionUpdateWithoutUserInput;
  where: WalletTransactionWhereUniqueInput;
};

export type WalletTransactionUpdateWithoutProgramInput = {
  amount?: InputMaybe<FloatFieldUpdateOperationsInput>;
  checkout_session_id?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  created_at?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  dispute_id?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  funds_available_at?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  legacy_collection?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  legacy_id?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  net_amount?: InputMaybe<FloatFieldUpdateOperationsInput>;
  original_transaction_id?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payment_intent_id?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payment_type?: InputMaybe<EnumWalletPaymentTypeFieldUpdateOperationsInput>;
  platform_fee?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  source_user?: InputMaybe<UserUpdateOneRequiredWithoutWalletPaymentsNestedInput>;
  status?: InputMaybe<EnumTransactionStatusFieldUpdateOperationsInput>;
  stripe_available_on?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  transfer_error?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  transfer_failed_at?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  transfer_id?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  transfer_status?: InputMaybe<EnumTransferStatusFieldUpdateOperationsInput>;
  transferred_at?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  updated_at?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  user?: InputMaybe<UserUpdateOneRequiredWithoutWalletTransactionsNestedInput>;
};

export type WalletTransactionUpdateWithoutSource_UserInput = {
  amount?: InputMaybe<FloatFieldUpdateOperationsInput>;
  checkout_session_id?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  created_at?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  dispute_id?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  funds_available_at?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  legacy_collection?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  legacy_id?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  net_amount?: InputMaybe<FloatFieldUpdateOperationsInput>;
  original_transaction_id?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payment_intent_id?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payment_type?: InputMaybe<EnumWalletPaymentTypeFieldUpdateOperationsInput>;
  platform_fee?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  program?: InputMaybe<ProgramUpdateOneRequiredWithoutWalletTransactionsNestedInput>;
  status?: InputMaybe<EnumTransactionStatusFieldUpdateOperationsInput>;
  stripe_available_on?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  transfer_error?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  transfer_failed_at?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  transfer_id?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  transfer_status?: InputMaybe<EnumTransferStatusFieldUpdateOperationsInput>;
  transferred_at?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  updated_at?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  user?: InputMaybe<UserUpdateOneRequiredWithoutWalletTransactionsNestedInput>;
};

export type WalletTransactionUpdateWithoutUserInput = {
  amount?: InputMaybe<FloatFieldUpdateOperationsInput>;
  checkout_session_id?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  created_at?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  dispute_id?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  funds_available_at?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  legacy_collection?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  legacy_id?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  net_amount?: InputMaybe<FloatFieldUpdateOperationsInput>;
  original_transaction_id?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payment_intent_id?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payment_type?: InputMaybe<EnumWalletPaymentTypeFieldUpdateOperationsInput>;
  platform_fee?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  program?: InputMaybe<ProgramUpdateOneRequiredWithoutWalletTransactionsNestedInput>;
  source_user?: InputMaybe<UserUpdateOneRequiredWithoutWalletPaymentsNestedInput>;
  status?: InputMaybe<EnumTransactionStatusFieldUpdateOperationsInput>;
  stripe_available_on?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  transfer_error?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  transfer_failed_at?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  transfer_id?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  transfer_status?: InputMaybe<EnumTransferStatusFieldUpdateOperationsInput>;
  transferred_at?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  updated_at?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type WalletTransactionUpsertWithWhereUniqueWithoutProgramInput = {
  create: WalletTransactionCreateWithoutProgramInput;
  update: WalletTransactionUpdateWithoutProgramInput;
  where: WalletTransactionWhereUniqueInput;
};

export type WalletTransactionUpsertWithWhereUniqueWithoutSource_UserInput = {
  create: WalletTransactionCreateWithoutSource_UserInput;
  update: WalletTransactionUpdateWithoutSource_UserInput;
  where: WalletTransactionWhereUniqueInput;
};

export type WalletTransactionUpsertWithWhereUniqueWithoutUserInput = {
  create: WalletTransactionCreateWithoutUserInput;
  update: WalletTransactionUpdateWithoutUserInput;
  where: WalletTransactionWhereUniqueInput;
};

export type WalletTransactionWhereInput = {
  AND?: InputMaybe<Array<WalletTransactionWhereInput>>;
  NOT?: InputMaybe<Array<WalletTransactionWhereInput>>;
  OR?: InputMaybe<Array<WalletTransactionWhereInput>>;
  amount?: InputMaybe<FloatFilter>;
  checkout_session_id?: InputMaybe<StringNullableFilter>;
  created_at?: InputMaybe<DateTimeFilter>;
  description?: InputMaybe<StringNullableFilter>;
  dispute_id?: InputMaybe<StringNullableFilter>;
  funds_available_at?: InputMaybe<DateTimeNullableFilter>;
  id?: InputMaybe<StringFilter>;
  legacy_collection?: InputMaybe<StringNullableFilter>;
  legacy_id?: InputMaybe<StringNullableFilter>;
  net_amount?: InputMaybe<FloatFilter>;
  original_transaction_id?: InputMaybe<StringNullableFilter>;
  payment_intent_id?: InputMaybe<StringNullableFilter>;
  payment_type?: InputMaybe<EnumWalletPaymentTypeFilter>;
  platform_fee?: InputMaybe<FloatNullableFilter>;
  program?: InputMaybe<ProgramRelationFilter>;
  program_id?: InputMaybe<StringFilter>;
  source_user?: InputMaybe<UserRelationFilter>;
  source_user_id?: InputMaybe<StringFilter>;
  status?: InputMaybe<EnumTransactionStatusFilter>;
  stripe_available_on?: InputMaybe<IntNullableFilter>;
  transfer_error?: InputMaybe<StringNullableFilter>;
  transfer_failed_at?: InputMaybe<DateTimeNullableFilter>;
  transfer_id?: InputMaybe<StringNullableFilter>;
  transfer_status?: InputMaybe<EnumTransferStatusFilter>;
  transferred_at?: InputMaybe<DateTimeNullableFilter>;
  updated_at?: InputMaybe<DateTimeFilter>;
  user?: InputMaybe<UserRelationFilter>;
  user_id?: InputMaybe<StringFilter>;
};

export type WalletTransactionWhereUniqueInput = {
  AND?: InputMaybe<Array<WalletTransactionWhereInput>>;
  NOT?: InputMaybe<Array<WalletTransactionWhereInput>>;
  OR?: InputMaybe<Array<WalletTransactionWhereInput>>;
  amount?: InputMaybe<FloatFilter>;
  checkout_session_id?: InputMaybe<StringNullableFilter>;
  created_at?: InputMaybe<DateTimeFilter>;
  description?: InputMaybe<StringNullableFilter>;
  dispute_id?: InputMaybe<StringNullableFilter>;
  funds_available_at?: InputMaybe<DateTimeNullableFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  legacy_collection?: InputMaybe<StringNullableFilter>;
  legacy_id?: InputMaybe<StringNullableFilter>;
  net_amount?: InputMaybe<FloatFilter>;
  original_transaction_id?: InputMaybe<StringNullableFilter>;
  payment_intent_id?: InputMaybe<StringNullableFilter>;
  payment_type?: InputMaybe<EnumWalletPaymentTypeFilter>;
  platform_fee?: InputMaybe<FloatNullableFilter>;
  program?: InputMaybe<ProgramRelationFilter>;
  program_id?: InputMaybe<StringFilter>;
  source_user?: InputMaybe<UserRelationFilter>;
  source_user_id?: InputMaybe<StringFilter>;
  status?: InputMaybe<EnumTransactionStatusFilter>;
  stripe_available_on?: InputMaybe<IntNullableFilter>;
  transfer_error?: InputMaybe<StringNullableFilter>;
  transfer_failed_at?: InputMaybe<DateTimeNullableFilter>;
  transfer_id?: InputMaybe<StringNullableFilter>;
  transfer_status?: InputMaybe<EnumTransferStatusFilter>;
  transferred_at?: InputMaybe<DateTimeNullableFilter>;
  updated_at?: InputMaybe<DateTimeFilter>;
  user?: InputMaybe<UserRelationFilter>;
  user_id?: InputMaybe<StringFilter>;
};

export type WalletWithdrawalAvgAggregate = {
  __typename?: 'WalletWithdrawalAvgAggregate';
  amount?: Maybe<Scalars['Float']['output']>;
  arrival_date?: Maybe<Scalars['Float']['output']>;
};

/** Paginated list of wallet withdrawals */
export type WalletWithdrawalConnection = {
  __typename?: 'WalletWithdrawalConnection';
  /** List of withdrawal edges */
  edges: Array<WalletWithdrawalEdge>;
  /** Pagination information */
  pageInfo: WalletWithdrawalPageInfo;
  /** Total count of withdrawals matching the filter */
  totalCount: Scalars['Int']['output'];
};

export type WalletWithdrawalCountAggregate = {
  __typename?: 'WalletWithdrawalCountAggregate';
  _all: Scalars['Int']['output'];
  amount: Scalars['Int']['output'];
  arrival_date: Scalars['Int']['output'];
  bankAccountId: Scalars['Int']['output'];
  bankAccountLast4: Scalars['Int']['output'];
  bankName: Scalars['Int']['output'];
  created: Scalars['Int']['output'];
  currency: Scalars['Int']['output'];
  description: Scalars['Int']['output'];
  failure_message: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  status: Scalars['Int']['output'];
  stripeConnectId: Scalars['Int']['output'];
  stripeTransferId: Scalars['Int']['output'];
  updated_at: Scalars['Int']['output'];
  user_id: Scalars['Int']['output'];
};

/** Edge containing a wallet withdrawal and its cursor */
export type WalletWithdrawalEdge = {
  __typename?: 'WalletWithdrawalEdge';
  /** Cursor for this item (used for pagination) */
  cursor: Scalars['String']['output'];
  /** The wallet withdrawal */
  node: WalletWithdrawalType;
};

/** Filter options for wallet withdrawals query */
export type WalletWithdrawalFilterInput = {
  /** Filter withdrawals created on or after this date */
  fromDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** Filter by payout status (pending, paid, failed, canceled) */
  status?: InputMaybe<Scalars['String']['input']>;
  /** Filter withdrawals created on or before this date */
  toDate?: InputMaybe<Scalars['DateTime']['input']>;
};

export type WalletWithdrawalMaxAggregate = {
  __typename?: 'WalletWithdrawalMaxAggregate';
  amount?: Maybe<Scalars['Int']['output']>;
  arrival_date?: Maybe<Scalars['Int']['output']>;
  bankAccountId?: Maybe<Scalars['String']['output']>;
  bankAccountLast4?: Maybe<Scalars['String']['output']>;
  bankName?: Maybe<Scalars['String']['output']>;
  created?: Maybe<Scalars['DateTime']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  failure_message?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  status?: Maybe<PayoutStatus>;
  stripeConnectId?: Maybe<Scalars['String']['output']>;
  stripeTransferId?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['DateTime']['output']>;
  user_id?: Maybe<Scalars['String']['output']>;
};

export type WalletWithdrawalMinAggregate = {
  __typename?: 'WalletWithdrawalMinAggregate';
  amount?: Maybe<Scalars['Int']['output']>;
  arrival_date?: Maybe<Scalars['Int']['output']>;
  bankAccountId?: Maybe<Scalars['String']['output']>;
  bankAccountLast4?: Maybe<Scalars['String']['output']>;
  bankName?: Maybe<Scalars['String']['output']>;
  created?: Maybe<Scalars['DateTime']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  failure_message?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  status?: Maybe<PayoutStatus>;
  stripeConnectId?: Maybe<Scalars['String']['output']>;
  stripeTransferId?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['DateTime']['output']>;
  user_id?: Maybe<Scalars['String']['output']>;
};

/** Pagination information for wallet withdrawal list */
export type WalletWithdrawalPageInfo = {
  __typename?: 'WalletWithdrawalPageInfo';
  /** Cursor for the last item in this page */
  endCursor?: Maybe<Scalars['String']['output']>;
  /** Whether there are more results after this page */
  hasNextPage: Scalars['Boolean']['output'];
  /** Whether there are results before this page */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** Cursor for the first item in this page */
  startCursor?: Maybe<Scalars['String']['output']>;
};

export type WalletWithdrawalSumAggregate = {
  __typename?: 'WalletWithdrawalSumAggregate';
  amount?: Maybe<Scalars['Int']['output']>;
  arrival_date?: Maybe<Scalars['Int']['output']>;
};

/** Wallet withdrawal (transfer to Connect account) */
export type WalletWithdrawalType = {
  __typename?: 'WalletWithdrawalType';
  /** Amount in cents */
  amount: Scalars['Int']['output'];
  /** Amount in dollars (computed from cents) */
  amountInDollars: Scalars['Float']['output'];
  /** Unix timestamp when funds will arrive at bank */
  arrival_date?: Maybe<Scalars['Int']['output']>;
  /** Stripe bank account ID (ba_xxx) */
  bankAccountId?: Maybe<Scalars['String']['output']>;
  /** Last 4 digits of bank account */
  bankAccountLast4?: Maybe<Scalars['String']['output']>;
  /** Name of the bank */
  bankName?: Maybe<Scalars['String']['output']>;
  /** When withdrawal was created */
  created: Scalars['DateTime']['output'];
  /** Currency code */
  currency: Scalars['String']['output'];
  /** Human-readable description */
  description?: Maybe<Scalars['String']['output']>;
  /** Unique withdrawal identifier */
  id: Scalars['ID']['output'];
  /** Real-time payout status from Stripe (resolved on-demand) */
  payoutStatus?: Maybe<PayoutStatusType>;
  /** Withdrawal status: pending, completed, failed */
  status: Scalars['String']['output'];
  /** Stripe Connect account ID (acct_xxx) */
  stripeConnectId: Scalars['String']['output'];
  /** Stripe Transfer ID (tr_xxx) */
  stripeTransferId: Scalars['String']['output'];
  /** When withdrawal was last updated */
  updated_at?: Maybe<Scalars['DateTime']['output']>;
  /** User ID who requested the withdrawal */
  user_id: Scalars['String']['output'];
};

export type WebhookEventAvgAggregate = {
  __typename?: 'WebhookEventAvgAggregate';
  retry_count?: Maybe<Scalars['Float']['output']>;
};

export type WebhookEventCountAggregate = {
  __typename?: 'WebhookEventCountAggregate';
  _all: Scalars['Int']['output'];
  completed_at: Scalars['Int']['output'];
  created_at: Scalars['Int']['output'];
  error_message: Scalars['Int']['output'];
  event_data: Scalars['Int']['output'];
  event_id: Scalars['Int']['output'];
  event_type: Scalars['Int']['output'];
  failed_reason: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  job_id: Scalars['Int']['output'];
  last_error_at: Scalars['Int']['output'];
  processed_at: Scalars['Int']['output'];
  processing_status: Scalars['Int']['output'];
  queue_status: Scalars['Int']['output'];
  queued_at: Scalars['Int']['output'];
  related_payout_ids: Scalars['Int']['output'];
  related_transaction_ids: Scalars['Int']['output'];
  retry_count: Scalars['Int']['output'];
  started_at: Scalars['Int']['output'];
};

export type WebhookEventMaxAggregate = {
  __typename?: 'WebhookEventMaxAggregate';
  completed_at?: Maybe<Scalars['DateTime']['output']>;
  created_at?: Maybe<Scalars['DateTime']['output']>;
  error_message?: Maybe<Scalars['String']['output']>;
  event_id?: Maybe<Scalars['String']['output']>;
  event_type?: Maybe<Scalars['String']['output']>;
  failed_reason?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  job_id?: Maybe<Scalars['String']['output']>;
  last_error_at?: Maybe<Scalars['DateTime']['output']>;
  processed_at?: Maybe<Scalars['DateTime']['output']>;
  processing_status?: Maybe<WebhookStatus>;
  queue_status?: Maybe<QueueStatus>;
  queued_at?: Maybe<Scalars['DateTime']['output']>;
  retry_count?: Maybe<Scalars['Int']['output']>;
  started_at?: Maybe<Scalars['DateTime']['output']>;
};

export type WebhookEventMinAggregate = {
  __typename?: 'WebhookEventMinAggregate';
  completed_at?: Maybe<Scalars['DateTime']['output']>;
  created_at?: Maybe<Scalars['DateTime']['output']>;
  error_message?: Maybe<Scalars['String']['output']>;
  event_id?: Maybe<Scalars['String']['output']>;
  event_type?: Maybe<Scalars['String']['output']>;
  failed_reason?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  job_id?: Maybe<Scalars['String']['output']>;
  last_error_at?: Maybe<Scalars['DateTime']['output']>;
  processed_at?: Maybe<Scalars['DateTime']['output']>;
  processing_status?: Maybe<WebhookStatus>;
  queue_status?: Maybe<QueueStatus>;
  queued_at?: Maybe<Scalars['DateTime']['output']>;
  retry_count?: Maybe<Scalars['Int']['output']>;
  started_at?: Maybe<Scalars['DateTime']['output']>;
};

export type WebhookEventSumAggregate = {
  __typename?: 'WebhookEventSumAggregate';
  retry_count?: Maybe<Scalars['Int']['output']>;
};

/** Stripe webhook event record for admin debugging and monitoring */
export type WebhookEventType = {
  __typename?: 'WebhookEventType';
  /** When processing completed (null if still processing) */
  completed_at?: Maybe<Scalars['DateTime']['output']>;
  /** When webhook event was received */
  created_at: Scalars['DateTime']['output'];
  /** Error message if processing failed */
  error_message?: Maybe<Scalars['String']['output']>;
  /** Full Stripe event object - allows replaying if processing failed */
  event_data: Scalars['JSON']['output'];
  /** Stripe event ID (evt_xxx) - unique for idempotency */
  event_id: Scalars['String']['output'];
  /** Event type (e.g., 'payment_intent.succeeded', 'charge.dispute.created') */
  event_type: Scalars['String']['output'];
  /** Detailed failure reason for DLQ analysis */
  failed_reason?: Maybe<Scalars['String']['output']>;
  /** Unique webhook event identifier */
  id: Scalars['ID']['output'];
  /** True if webhook is stuck in processing state for >5 minutes */
  isStuck: Scalars['Boolean']['output'];
  /** BullMQ job ID (typically same as event_id) */
  job_id?: Maybe<Scalars['String']['output']>;
  /** When last error occurred */
  last_error_at?: Maybe<Scalars['DateTime']['output']>;
  /** When BullMQ worker completed processing */
  processed_at?: Maybe<Scalars['DateTime']['output']>;
  /** Processing duration in milliseconds (null if not completed) */
  processingDurationMs?: Maybe<Scalars['Int']['output']>;
  /** Processing state (processing, completed, failed) - legacy field */
  processing_status: WebhookStatus;
  /** BullMQ job status (QUEUED, PROCESSING, COMPLETED, FAILED) */
  queue_status: QueueStatus;
  /** When event was queued to BullMQ */
  queued_at: Scalars['DateTime']['output'];
  /** UserPayout IDs created by this webhook */
  related_payout_ids: Array<Scalars['String']['output']>;
  /** StudentTransaction IDs created by this webhook */
  related_transaction_ids: Array<Scalars['String']['output']>;
  /** Number of retry attempts (BullMQ retries) */
  retry_count: Scalars['Int']['output'];
  /** When processing began */
  started_at: Scalars['DateTime']['output'];
};

/** Webhook processing lifecycle status */
export enum WebhookStatus {
  Completed = 'completed',
  Failed = 'failed',
  Processing = 'processing'
}

export type WidgetsAvgAggregate = {
  __typename?: 'WidgetsAvgAggregate';
  position?: Maybe<Scalars['Float']['output']>;
  tickSize?: Maybe<Scalars['Float']['output']>;
};

export type WidgetsCountAggregate = {
  __typename?: 'WidgetsCountAggregate';
  _all: Scalars['Int']['output'];
  ages: Scalars['Int']['output'];
  aiTier: Scalars['Int']['output'];
  category: Scalars['Int']['output'];
  color: Scalars['Int']['output'];
  comp_type: Scalars['Int']['output'];
  component_name: Scalars['Int']['output'];
  configurableProperties: Scalars['Int']['output'];
  defaultValue: Scalars['Int']['output'];
  dependencies: Scalars['Int']['output'];
  description: Scalars['Int']['output'];
  disabled: Scalars['Int']['output'];
  disabledInput: Scalars['Int']['output'];
  discordEntityType: Scalars['Int']['output'];
  draggable_icon: Scalars['Int']['output'];
  draggable_name: Scalars['Int']['output'];
  exampleConfig: Scalars['Int']['output'];
  groupLabel: Scalars['Int']['output'];
  header: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  isPreset: Scalars['Int']['output'];
  items: Scalars['Int']['output'];
  label: Scalars['Int']['output'];
  max: Scalars['Int']['output'];
  maxDate: Scalars['Int']['output'];
  min: Scalars['Int']['output'];
  minDate: Scalars['Int']['output'];
  mode: Scalars['Int']['output'];
  model: Scalars['Int']['output'];
  multiple: Scalars['Int']['output'];
  name: Scalars['Int']['output'];
  position: Scalars['Int']['output'];
  preset: Scalars['Int']['output'];
  rendererType: Scalars['Int']['output'];
  required: Scalars['Int']['output'];
  roles: Scalars['Int']['output'];
  rules: Scalars['Int']['output'];
  searchInput: Scalars['Int']['output'];
  semantic: Scalars['Int']['output'];
  setup: Scalars['Int']['output'];
  tickSize: Scalars['Int']['output'];
  ticks: Scalars['Int']['output'];
  title: Scalars['Int']['output'];
  type: Scalars['Int']['output'];
  userType: Scalars['Int']['output'];
  value: Scalars['Int']['output'];
  whenToUse: Scalars['Int']['output'];
};

export type WidgetsMaxAggregate = {
  __typename?: 'WidgetsMaxAggregate';
  ages?: Maybe<Scalars['String']['output']>;
  aiTier?: Maybe<Scalars['String']['output']>;
  category?: Maybe<Scalars['String']['output']>;
  color?: Maybe<Scalars['String']['output']>;
  comp_type?: Maybe<Scalars['String']['output']>;
  component_name?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  disabled?: Maybe<Scalars['Boolean']['output']>;
  disabledInput?: Maybe<Scalars['Boolean']['output']>;
  discordEntityType?: Maybe<Scalars['String']['output']>;
  draggable_icon?: Maybe<Scalars['String']['output']>;
  draggable_name?: Maybe<Scalars['String']['output']>;
  groupLabel?: Maybe<Scalars['String']['output']>;
  header?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  isPreset?: Maybe<Scalars['Boolean']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  max?: Maybe<Scalars['String']['output']>;
  maxDate?: Maybe<Scalars['String']['output']>;
  min?: Maybe<Scalars['String']['output']>;
  minDate?: Maybe<Scalars['String']['output']>;
  mode?: Maybe<Scalars['String']['output']>;
  model?: Maybe<Scalars['String']['output']>;
  multiple?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  position?: Maybe<Scalars['Int']['output']>;
  rendererType?: Maybe<Scalars['String']['output']>;
  required?: Maybe<Scalars['Boolean']['output']>;
  searchInput?: Maybe<Scalars['String']['output']>;
  tickSize?: Maybe<Scalars['Int']['output']>;
  ticks?: Maybe<Scalars['Boolean']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  userType?: Maybe<Scalars['String']['output']>;
  whenToUse?: Maybe<Scalars['String']['output']>;
};

export type WidgetsMinAggregate = {
  __typename?: 'WidgetsMinAggregate';
  ages?: Maybe<Scalars['String']['output']>;
  aiTier?: Maybe<Scalars['String']['output']>;
  category?: Maybe<Scalars['String']['output']>;
  color?: Maybe<Scalars['String']['output']>;
  comp_type?: Maybe<Scalars['String']['output']>;
  component_name?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  disabled?: Maybe<Scalars['Boolean']['output']>;
  disabledInput?: Maybe<Scalars['Boolean']['output']>;
  discordEntityType?: Maybe<Scalars['String']['output']>;
  draggable_icon?: Maybe<Scalars['String']['output']>;
  draggable_name?: Maybe<Scalars['String']['output']>;
  groupLabel?: Maybe<Scalars['String']['output']>;
  header?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  isPreset?: Maybe<Scalars['Boolean']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  max?: Maybe<Scalars['String']['output']>;
  maxDate?: Maybe<Scalars['String']['output']>;
  min?: Maybe<Scalars['String']['output']>;
  minDate?: Maybe<Scalars['String']['output']>;
  mode?: Maybe<Scalars['String']['output']>;
  model?: Maybe<Scalars['String']['output']>;
  multiple?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  position?: Maybe<Scalars['Int']['output']>;
  rendererType?: Maybe<Scalars['String']['output']>;
  required?: Maybe<Scalars['Boolean']['output']>;
  searchInput?: Maybe<Scalars['String']['output']>;
  tickSize?: Maybe<Scalars['Int']['output']>;
  ticks?: Maybe<Scalars['Boolean']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  userType?: Maybe<Scalars['String']['output']>;
  whenToUse?: Maybe<Scalars['String']['output']>;
};

export type WidgetsProps = {
  __typename?: 'WidgetsProps';
  airtableRecordId?: Maybe<Scalars['String']['output']>;
  category?: Maybe<Scalars['String']['output']>;
  discordEntityType?: Maybe<Scalars['String']['output']>;
  fields?: Maybe<Array<WidgetsPropsFields>>;
  icon?: Maybe<Scalars['String']['output']>;
  instruction?: Maybe<WidgetsPropsInstruction>;
  isSkippable?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  permissions?: Maybe<Array<WidgetsPropsPermissions>>;
  position?: Maybe<Scalars['Int']['output']>;
  presetFields?: Maybe<Array<WidgetsPropsPresetFields>>;
  preview?: Maybe<Scalars['Boolean']['output']>;
  setupRequired?: Maybe<Scalars['Boolean']['output']>;
  status?: Maybe<Scalars['Boolean']['output']>;
  styling?: Maybe<WidgetsPropsStyling>;
};

export type WidgetsPropsFields = {
  __typename?: 'WidgetsPropsFields';
  action?: Maybe<Scalars['String']['output']>;
  addButtonLabel?: Maybe<Scalars['String']['output']>;
  adk?: Maybe<Scalars['String']['output']>;
  align?: Maybe<Scalars['String']['output']>;
  builderType?: Maybe<Scalars['String']['output']>;
  event?: Maybe<WidgetsPropsFieldsEvent>;
  linkLabel?: Maybe<Scalars['String']['output']>;
  link_type?: Maybe<Scalars['String']['output']>;
  model?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  noSetup?: Maybe<Scalars['Boolean']['output']>;
  position: Scalars['Int']['output'];
  /** Nested objects had no data in the sample dataset to introspect a nested type. */
  preset?: Maybe<Scalars['JSON']['output']>;
  roles?: Maybe<Array<Scalars['String']['output']>>;
  setup?: Maybe<WidgetsPropsFieldsSetup>;
  styling?: Maybe<WidgetsPropsFieldsStyling>;
  target?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  /** Nested objects had no data in the sample dataset to introspect a nested type. */
  value?: Maybe<Scalars['JSON']['output']>;
  videoAskLabel?: Maybe<Scalars['String']['output']>;
  videoAskUrl?: Maybe<Scalars['String']['output']>;
  videoName?: Maybe<Scalars['String']['output']>;
};

export type WidgetsPropsFieldsEvent = {
  __typename?: 'WidgetsPropsFieldsEvent';
  body: Scalars['String']['output'];
  /** Could not determine type: the field only had null or empty values in the sample set. */
  buttons?: Maybe<Scalars['JSON']['output']>;
  component: Scalars['String']['output'];
  title: Scalars['String']['output'];
  trigger: Scalars['String']['output'];
};

export type WidgetsPropsFieldsSetup = {
  __typename?: 'WidgetsPropsFieldsSetup';
  researchLinks?: Maybe<Array<WidgetsPropsFieldsSetupResearchLinks>>;
};

export type WidgetsPropsFieldsSetupResearchLinks = {
  __typename?: 'WidgetsPropsFieldsSetupResearchLinks';
  link: Scalars['String']['output'];
  required: Scalars['Boolean']['output'];
  resource: Scalars['String']['output'];
};

export type WidgetsPropsFieldsStyling = {
  __typename?: 'WidgetsPropsFieldsStyling';
  appendIcon?: Maybe<Scalars['String']['output']>;
  btnLabel?: Maybe<Scalars['String']['output']>;
  class?: Maybe<Scalars['String']['output']>;
  color?: Maybe<Scalars['String']['output']>;
  createAccountLabel?: Maybe<Scalars['String']['output']>;
  dark?: Maybe<Scalars['Boolean']['output']>;
  depressed?: Maybe<Scalars['Boolean']['output']>;
  existingAccountLabel?: Maybe<Scalars['String']['output']>;
  generate_btn_label?: Maybe<Scalars['String']['output']>;
  headerLabel?: Maybe<Scalars['String']['output']>;
  hint?: Maybe<Scalars['String']['output']>;
  icon?: Maybe<Scalars['Boolean']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  meetHeader?: Maybe<Scalars['String']['output']>;
  rounded?: Maybe<Scalars['Boolean']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  videoask_form_id?: Maybe<Scalars['String']['output']>;
  wrapperClass?: Maybe<Scalars['String']['output']>;
  xLarge?: Maybe<Scalars['Boolean']['output']>;
};

export type WidgetsPropsInstruction = {
  __typename?: 'WidgetsPropsInstruction';
  boilerInstructions?: Maybe<Array<Scalars['String']['output']>>;
  discordUrl: Scalars['String']['output'];
  goal: Scalars['String']['output'];
  youtubeUrl: Scalars['String']['output'];
};

export type WidgetsPropsPermissions = {
  __typename?: 'WidgetsPropsPermissions';
  permissions_matrix?: Maybe<Array<Scalars['String']['output']>>;
  roles: Scalars['String']['output'];
};

export type WidgetsPropsPresetFields = {
  __typename?: 'WidgetsPropsPresetFields';
  noSetup: Scalars['Boolean']['output'];
  position: Scalars['Int']['output'];
  /** Nested objects had no data in the sample dataset to introspect a nested type. */
  preset: Scalars['JSON']['output'];
  roles?: Maybe<Array<Scalars['String']['output']>>;
  title: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type WidgetsPropsStyling = {
  __typename?: 'WidgetsPropsStyling';
  borderColor: Scalars['String']['output'];
  disabled?: Maybe<Scalars['Boolean']['output']>;
};

export type WidgetsRadioButtons = {
  __typename?: 'WidgetsRadioButtons';
  label: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type WidgetsStyling = {
  __typename?: 'WidgetsStyling';
  class?: Maybe<Scalars['String']['output']>;
  clearable?: Maybe<Scalars['Boolean']['output']>;
  color?: Maybe<Scalars['String']['output']>;
  cols?: Maybe<Scalars['String']['output']>;
  /** Multiple data types found: String: 50%, Int: 50% out of 2 sampled entries */
  counter?: Maybe<Scalars['JSON']['output']>;
  dark?: Maybe<Scalars['Boolean']['output']>;
  dense?: Maybe<Scalars['Boolean']['output']>;
  hide_details?: Maybe<Scalars['Boolean']['output']>;
  hint?: Maybe<Scalars['String']['output']>;
  itemColor?: Maybe<Scalars['String']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  outlined?: Maybe<Scalars['Boolean']['output']>;
  persistentHint?: Maybe<Scalars['Boolean']['output']>;
  persistentPlaceholder?: Maybe<Scalars['Boolean']['output']>;
  placeholder?: Maybe<Scalars['String']['output']>;
  prependIcon?: Maybe<Scalars['String']['output']>;
  rounded?: Maybe<Scalars['Boolean']['output']>;
  rows?: Maybe<Scalars['String']['output']>;
  small_chips?: Maybe<Scalars['Boolean']['output']>;
};

export type WidgetsSumAggregate = {
  __typename?: 'WidgetsSumAggregate';
  position?: Maybe<Scalars['Int']['output']>;
  tickSize?: Maybe<Scalars['Int']['output']>;
};

/** Input for withdrawing funds from wallet to bank account */
export type WithdrawFundsInput = {
  /** Amount to withdraw in dollars (min: $1, max: $5,000) */
  amount: Scalars['Float']['input'];
  /** Bank account ID to withdraw to (uses default if not provided) */
  bankAccountId?: InputMaybe<Scalars['String']['input']>;
  /** Currency code */
  currency?: Scalars['String']['input'];
  /** Optional description for the withdrawal */
  description?: InputMaybe<Scalars['String']['input']>;
};

/**
 * WorkforceOccupationRow — one occupation row from a workforce-kind GroundingSource.
 * Schema mirrors the CA COE / Lightcast occupational demand format.
 */
export type WorkforceOccupationRow = {
  __typename?: 'WorkforceOccupationRow';
  /** Average annual job openings (replacement + growth) */
  averageAnnualOpenings: Scalars['Int']['output'];
  /** Occupation title, e.g., "Marketing Managers" */
  description: Scalars['String']['output'];
  groundingSource: GroundingSource;
  groundingSourceId: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  /** Jobs in the baseline year of the projection */
  jobsBaseline: Scalars['Int']['output'];
  /** Median annual earnings (USD) */
  medianAnnualEarnings: Scalars['Int']['output'];
  /** Median hourly wage (USD) */
  medianHourlyEarnings: Scalars['Float']['output'];
  /** Fractional change projected over the window (e.g., 0.0348 for +3.48%) */
  pctChangeProjection: Scalars['Float']['output'];
  /** Standard Occupational Classification code, e.g., "11-2021" */
  socCode: Scalars['String']['output'];
  /** BLS typical entry-level education category, e.g., "Bachelor's degree" */
  typicalEntryEducation: Scalars['String']['output'];
};

export type WorkforceOccupationRowAvgAggregate = {
  __typename?: 'WorkforceOccupationRowAvgAggregate';
  averageAnnualOpenings?: Maybe<Scalars['Float']['output']>;
  jobsBaseline?: Maybe<Scalars['Float']['output']>;
  medianAnnualEarnings?: Maybe<Scalars['Float']['output']>;
  medianHourlyEarnings?: Maybe<Scalars['Float']['output']>;
  pctChangeProjection?: Maybe<Scalars['Float']['output']>;
};

export type WorkforceOccupationRowCountAggregate = {
  __typename?: 'WorkforceOccupationRowCountAggregate';
  _all: Scalars['Int']['output'];
  averageAnnualOpenings: Scalars['Int']['output'];
  description: Scalars['Int']['output'];
  groundingSourceId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  jobsBaseline: Scalars['Int']['output'];
  medianAnnualEarnings: Scalars['Int']['output'];
  medianHourlyEarnings: Scalars['Int']['output'];
  pctChangeProjection: Scalars['Int']['output'];
  socCode: Scalars['Int']['output'];
  typicalEntryEducation: Scalars['Int']['output'];
};

export type WorkforceOccupationRowMaxAggregate = {
  __typename?: 'WorkforceOccupationRowMaxAggregate';
  averageAnnualOpenings?: Maybe<Scalars['Int']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  groundingSourceId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  jobsBaseline?: Maybe<Scalars['Int']['output']>;
  medianAnnualEarnings?: Maybe<Scalars['Int']['output']>;
  medianHourlyEarnings?: Maybe<Scalars['Float']['output']>;
  pctChangeProjection?: Maybe<Scalars['Float']['output']>;
  socCode?: Maybe<Scalars['String']['output']>;
  typicalEntryEducation?: Maybe<Scalars['String']['output']>;
};

export type WorkforceOccupationRowMinAggregate = {
  __typename?: 'WorkforceOccupationRowMinAggregate';
  averageAnnualOpenings?: Maybe<Scalars['Int']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  groundingSourceId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  jobsBaseline?: Maybe<Scalars['Int']['output']>;
  medianAnnualEarnings?: Maybe<Scalars['Int']['output']>;
  medianHourlyEarnings?: Maybe<Scalars['Float']['output']>;
  pctChangeProjection?: Maybe<Scalars['Float']['output']>;
  socCode?: Maybe<Scalars['String']['output']>;
  typicalEntryEducation?: Maybe<Scalars['String']['output']>;
};

export type WorkforceOccupationRowSumAggregate = {
  __typename?: 'WorkforceOccupationRowSumAggregate';
  averageAnnualOpenings?: Maybe<Scalars['Int']['output']>;
  jobsBaseline?: Maybe<Scalars['Int']['output']>;
  medianAnnualEarnings?: Maybe<Scalars['Int']['output']>;
  medianHourlyEarnings?: Maybe<Scalars['Float']['output']>;
  pctChangeProjection?: Maybe<Scalars['Float']['output']>;
};

export type WriteBackAnalyticsEventAvgAggregate = {
  __typename?: 'WriteBackAnalyticsEventAvgAggregate';
  aiConfidence?: Maybe<Scalars['Float']['output']>;
  timeToComplete?: Maybe<Scalars['Float']['output']>;
};

export type WriteBackAnalyticsEventCountAggregate = {
  __typename?: 'WriteBackAnalyticsEventCountAggregate';
  _all: Scalars['Int']['output'];
  activityName: Scalars['Int']['output'];
  activityWorkSubType: Scalars['Int']['output'];
  aiConfidence: Scalars['Int']['output'];
  confidenceTier: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  errorMessage: Scalars['Int']['output'];
  eventType: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  inboundMessageId: Scalars['Int']['output'];
  metadata: Scalars['Int']['output'];
  programId: Scalars['Int']['output'];
  studentId: Scalars['Int']['output'];
  threadId: Scalars['Int']['output'];
  timeToComplete: Scalars['Int']['output'];
  triggeredAt: Scalars['Int']['output'];
  updatedAt: Scalars['Int']['output'];
  validationErrors: Scalars['Int']['output'];
};

export type WriteBackAnalyticsEventMaxAggregate = {
  __typename?: 'WriteBackAnalyticsEventMaxAggregate';
  activityName?: Maybe<Scalars['String']['output']>;
  activityWorkSubType?: Maybe<Scalars['String']['output']>;
  aiConfidence?: Maybe<Scalars['Float']['output']>;
  confidenceTier?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  errorMessage?: Maybe<Scalars['String']['output']>;
  eventType?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  inboundMessageId?: Maybe<Scalars['String']['output']>;
  programId?: Maybe<Scalars['String']['output']>;
  studentId?: Maybe<Scalars['String']['output']>;
  threadId?: Maybe<Scalars['String']['output']>;
  timeToComplete?: Maybe<Scalars['Int']['output']>;
  triggeredAt?: Maybe<Scalars['DateTime']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type WriteBackAnalyticsEventMinAggregate = {
  __typename?: 'WriteBackAnalyticsEventMinAggregate';
  activityName?: Maybe<Scalars['String']['output']>;
  activityWorkSubType?: Maybe<Scalars['String']['output']>;
  aiConfidence?: Maybe<Scalars['Float']['output']>;
  confidenceTier?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  errorMessage?: Maybe<Scalars['String']['output']>;
  eventType?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  inboundMessageId?: Maybe<Scalars['String']['output']>;
  programId?: Maybe<Scalars['String']['output']>;
  studentId?: Maybe<Scalars['String']['output']>;
  threadId?: Maybe<Scalars['String']['output']>;
  timeToComplete?: Maybe<Scalars['Int']['output']>;
  triggeredAt?: Maybe<Scalars['DateTime']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type WriteBackAnalyticsEventSumAggregate = {
  __typename?: 'WriteBackAnalyticsEventSumAggregate';
  aiConfidence?: Maybe<Scalars['Float']['output']>;
  timeToComplete?: Maybe<Scalars['Int']['output']>;
};

/** Confidence thresholds for write-back decisions */
export type WriteBackConfidenceThresholds = {
  __typename?: 'WriteBackConfidenceThresholds';
  autoApprove: Scalars['Float']['output'];
  humanDecision: Scalars['Float']['output'];
  recommend: Scalars['Float']['output'];
};

/** Write-back configuration for AI-assisted activity completion (Path B) */
export type WriteBackConfig = {
  __typename?: 'WriteBackConfig';
  activityOverrides?: Maybe<Scalars['JSON']['output']>;
  completionMode: Scalars['String']['output'];
  confidenceThresholds: WriteBackConfidenceThresholds;
  enabled: Scalars['Boolean']['output'];
  feedback?: Maybe<WriteBackFeedback>;
  notifications: WriteBackNotifications;
  safetyLimits: WriteBackSafetyLimits;
};

/** Feedback configuration for three-stage COLLECT_AND_COACH flow */
export type WriteBackFeedback = {
  __typename?: 'WriteBackFeedback';
  enabled: Scalars['Boolean']['output'];
  maxIterations?: Maybe<Scalars['Int']['output']>;
  qualityThreshold?: Maybe<Scalars['Float']['output']>;
};

/** Notification settings for write-back */
export type WriteBackNotifications = {
  __typename?: 'WriteBackNotifications';
  notifyPMOnAutoWrite: Scalars['Boolean']['output'];
  notifyParticipantOnWrite: Scalars['Boolean']['output'];
};

/** Safety limits for write-back operations */
export type WriteBackSafetyLimits = {
  __typename?: 'WriteBackSafetyLimits';
  maxWritesPerParticipantPerDay: Scalars['Int']['output'];
  maxWritesPerProgramPerHour: Scalars['Int']['output'];
};
